
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("eufGV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("jEua6")).default);
$parcel$export(module.exports, "useReportFeatures", () => (parcelRequire("y8WG5")).useReportFeatures);
$parcel$export(module.exports, "useFeatures", () => (parcelRequire("y8WG5")).useFeatures);
$parcel$export(module.exports, "useSettingFeatures", () => (parcelRequire("y8WG5")).useSettingFeatures);
$parcel$export(module.exports, "useCustomReports", () => (parcelRequire("eYYbM")).useCustomReports);
$parcel$export(module.exports, "createReportUrl", () => (parcelRequire("c2JIK")).createReportUrl);
$parcel$export(module.exports, "useLegacySpaClickHandler", () => (parcelRequire("c2JIK")).useLegacySpaClickHandler);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $jEua6 = parcelRequire("jEua6");

var $y8WG5 = parcelRequire("y8WG5");

var $eYYbM = parcelRequire("eYYbM");

var $c2JIK = parcelRequire("c2JIK");

});
parcelRegister("jEua6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0549f96ea7e05719$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $lpwtK = parcelRequire("lpwtK");

var $lGo7j = parcelRequire("lGo7j");

var $7OqB4 = parcelRequire("7OqB4");

var $6jY6G = parcelRequire("6jY6G");

var $b2XdI = parcelRequire("b2XdI");

var $5Srj8 = parcelRequire("5Srj8");

var $jF62O = parcelRequire("jF62O");

var $6dNtI = parcelRequire("6dNtI");

var $buVVR = parcelRequire("buVVR");
const $0549f96ea7e05719$var$useJiraServiceManagementProjectNavigation = (0, $7OqB4.withThrowOnError)((0, $1J3t1.useJiraServiceManagementProjectNavigation));
const $0549f96ea7e05719$var$useThrowProject = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $0549f96ea7e05719$export$1917d191cb487794 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { loading: serviceProjectFeatureLoading } = (0, $b2XdI.default)();
    const [practiceList, loadingPractice] = (0, $jF62O.usePracticeList)();
    const hasPractices = practiceList && practiceList.length > 1;
    const { data: project } = $0549f96ea7e05719$var$useThrowProject();
    const { data: data, loading: loading } = $0549f96ea7e05719$var$useJiraServiceManagementProjectNavigation();
    if (loading || loadingPractice || data == null || // route.group === 'servicedesk' means it's on project navigation, not under settings.
    // Data come back from useServiceProjectFeatures only controls items under "Operations" section on project navigation
    serviceProjectFeatureLoading && route.group === 'servicedesk') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Srj8.NavigationCategoryContainer), {
        projectKey: project ? project.key : '',
        scope: project ? project.key : ''
    }, hasPractices === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6dNtI.MenuPractices), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buVVR.Menu), null)), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).JSM
    }));
};
var $0549f96ea7e05719$export$2e2bcd8739ae039 = $0549f96ea7e05719$export$1917d191cb487794;

});
parcelRegister("fobme", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $4b9be639c0c7f77b$export$adf978edbdfaf080);
const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("7OqB4", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("b2XdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b693b7ac6b5692db$export$2e2bcd8739ae039);

var $6sNnq = parcelRequire("6sNnq");

var $2YP9W = parcelRequire("2YP9W");
const $b693b7ac6b5692db$var$useServiceProjectFeatures = ()=>(0, $2YP9W.useResource)((0, $6sNnq.featuresResource));
var $b693b7ac6b5692db$export$2e2bcd8739ae039 = $b693b7ac6b5692db$var$useServiceProjectFeatures;

});
parcelRegister("6sNnq", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $d0a02e466fb63798$export$16f81cc9da2c6c47);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $d0a02e466fb63798$var$getDataLoader = ()=>(parcelRequire("its7u"));
const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $2M1hQ.createResource)({
    type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $d0a02e466fb63798$var$getDataLoader,
    maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
});

});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';

parcelRegister("its7u", function(module, exports) {

let $d730bf6f328ec7ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d730bf6f328ec7ad$var$load("eNmuD"),
    $d730bf6f328ec7ad$var$load("aOISr")
]).then(()=>parcelRequire('frQmB'));

});



parcelRegister("5Srj8", function(module, exports) {

$parcel$export(module.exports, "QueueListSection", () => $3b5b2eee2cc09f57$export$f9e39ac255344f7b);
$parcel$export(module.exports, "NavigationCategoryContainer", () => $3b5b2eee2cc09f57$export$ea600ea09fe6bbd);
$parcel$export(module.exports, "useSelectedGroupIdByCategory", () => $3b5b2eee2cc09f57$export$9a1583f58d01a77c);
$parcel$export(module.exports, "useSelectedQueueSectionByCategory", () => $3b5b2eee2cc09f57$export$aca7e7401e11cffa);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aBZ4l = parcelRequire("aBZ4l");
var $3b5b2eee2cc09f57$export$f9e39ac255344f7b = /*#__PURE__*/ function(QueueListSection) {
    QueueListSection[QueueListSection["STARRED"] = 0] = "STARRED";
    QueueListSection[QueueListSection["PRIORITY_GROUP"] = 1] = "PRIORITY_GROUP";
    QueueListSection[QueueListSection["ALL_QUEUES"] = 2] = "ALL_QUEUES";
    return QueueListSection;
}({});
const $3b5b2eee2cc09f57$export$e324594224ef24da = {
    updateCurrentCategorySelectedGroup: (projectKey, practice, selectedGroupId)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                ...getState()[practice] ? {
                    [practice]: {
                        ...getState()[practice],
                        selectedGroupId: selectedGroupId
                    }
                } : {
                    [practice]: {
                        selectedGroupId: selectedGroupId
                    }
                }
            });
            (0, $aBZ4l.setQueueGroupsStateInLocalStorage)(projectKey, getState());
        },
    updatePathCategorySelectedQueueSection: (projectKey, practice, selectedQueueSection)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                ...getState()[practice] ? {
                    [practice]: {
                        ...getState()[practice],
                        selectedQueueSection: selectedQueueSection
                    }
                } : {
                    [practice]: {
                        selectedQueueSection: selectedQueueSection
                    }
                }
            });
            (0, $aBZ4l.setQueueGroupsStateInLocalStorage)(projectKey, getState());
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $3b5b2eee2cc09f57$var$initialState = {};
const $3b5b2eee2cc09f57$var$Store = (0, $iXqE5.createStore)({
    name: 'jsm-navigation-categories-store',
    initialState: $3b5b2eee2cc09f57$var$initialState,
    actions: $3b5b2eee2cc09f57$export$e324594224ef24da
});
const $3b5b2eee2cc09f57$export$ea600ea09fe6bbd = (0, $gg7kZ.createContainer)($3b5b2eee2cc09f57$var$Store, {
    onInit: ()=>({ setState: setState }, { projectKey: projectKey })=>{
            const stateFromStorage = (0, $aBZ4l.getQueueGroupsStateFromLocalStorage)(projectKey);
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $3b5b2eee2cc09f57$export$6676162114f1489a = (0, $3sQ5x.createHook)($3b5b2eee2cc09f57$var$Store);
const $3b5b2eee2cc09f57$export$9a1583f58d01a77c = (0, $3sQ5x.createHook)($3b5b2eee2cc09f57$var$Store, {
    selector: (state, category)=>state[category]?.selectedGroupId
});
const $3b5b2eee2cc09f57$export$aca7e7401e11cffa = (0, $3sQ5x.createHook)($3b5b2eee2cc09f57$var$Store, {
    selector: (state, category)=>state[category]?.selectedQueueSection
});

});
parcelRegister("aBZ4l", function(module, exports) {

$parcel$export(module.exports, "getQueueGroupsStateFromLocalStorage", () => $6763d726b8e20795$export$69c85d62a3ce3c00);
$parcel$export(module.exports, "setQueueGroupsStateInLocalStorage", () => $6763d726b8e20795$export$7475d3423fcf9a14);

var $bSSG7 = parcelRequire("bSSG7");
const $6763d726b8e20795$export$72f6692c81a0e6b3 = 'jsm-queue-groups-state';
const $6763d726b8e20795$export$d8474cff104280f3 = 'selected-group-id';
const $6763d726b8e20795$export$69c85d62a3ce3c00 = (projectKey)=>{
    const localStorageProvider = (0, $bSSG7.createLocalStorageProvider)($6763d726b8e20795$export$72f6692c81a0e6b3);
    try {
        const state = localStorageProvider.get(`${$6763d726b8e20795$export$d8474cff104280f3}-${projectKey}`);
        if (state) return JSON.parse(state);
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $6763d726b8e20795$export$7475d3423fcf9a14 = (projectKey, value)=>{
    const localStorageProvider = (0, $bSSG7.createLocalStorageProvider)($6763d726b8e20795$export$72f6692c81a0e6b3);
    try {
        localStorageProvider.set(`${$6763d726b8e20795$export$d8474cff104280f3}-${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};

});


parcelRegister("jF62O", function(module, exports) {

$parcel$export(module.exports, "useCategorizedNavItems", () => $8f1bc4ac72406fd0$export$fec6561bcaa1c55b);
$parcel$export(module.exports, "useCurrentCategorizedNavItems", () => $8f1bc4ac72406fd0$export$f9b7a4e20c09f3ce);
$parcel$export(module.exports, "useCategorizedQueues", () => $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6);
$parcel$export(module.exports, "useFavouriteNavItems", () => $8f1bc4ac72406fd0$export$e27d61833d43b175);
$parcel$export(module.exports, "usePracticeMetadata", () => $8f1bc4ac72406fd0$export$f857eeb50ae9b1b2);
$parcel$export(module.exports, "usePracticeList", () => $8f1bc4ac72406fd0$export$216a9245ead6e18a);
$parcel$export(module.exports, "CategorizedQueuesStore", () => $8f1bc4ac72406fd0$export$5577ca8a6b2fed3c);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $1WlLE = parcelRequire("1WlLE");

var $oCMSG = parcelRequire("oCMSG");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $2lO5M = parcelRequire("2lO5M");
const $8f1bc4ac72406fd0$var$useCategorizedData = (category, dataSelector, customContext)=>{
    const { data: allData, loading: loading, error: error, refresh: refresh } = (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.queuesNavigationItems), customContext);
    const memoizedData = (0, $5uXOq.useMemo)(()=>dataSelector(allData, category), [
        allData,
        category,
        dataSelector
    ]);
    return [
        memoizedData,
        loading,
        error,
        refresh
    ];
};
const $8f1bc4ac72406fd0$export$fec6561bcaa1c55b = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error, refresh] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.navDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods,
        refresh
    ];
};
const $8f1bc4ac72406fd0$export$f9b7a4e20c09f3ce = ()=>{
    const projectKey = (0, $bebaD.useProjectKey)();
    const category = (0, $bebaD.useCurrentCategory)();
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6('', projectKey, category);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$1dc9816387d038aa = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.notFavouriteDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$e27d61833d43b175 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.favouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$528be43f76fe19f7 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.notFavouriteAndCanBeHiddenDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$4c168500ca36ad18 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.cannotBeHiddenAndNotFavouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6 = (baseUrl, projectKey, category = (0, $oCMSG.NO_CATEGORY))=>{
    const [methods] = (0, $2lO5M.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.queuesDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $8f1bc4ac72406fd0$export$f857eeb50ae9b1b2 = (category = (0, $oCMSG.NO_CATEGORY), customContext)=>$8f1bc4ac72406fd0$var$useCategorizedData(category, (0, $fyiDq.practiceMetadataSelector), customContext);
const $8f1bc4ac72406fd0$export$216a9245ead6e18a = (customContext)=>$8f1bc4ac72406fd0$var$useCategorizedData((0, $oCMSG.NO_CATEGORY), (0, $fyiDq.practiceListSelector), customContext);
const $8f1bc4ac72406fd0$export$5577ca8a6b2fed3c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$c4ca47ba8c81dba6(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
const $8f1bc4ac72406fd0$export$aea9dc5735ed30c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $8f1bc4ac72406fd0$export$fec6561bcaa1c55b(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
$8f1bc4ac72406fd0$export$5577ca8a6b2fed3c.defaultProps = {
    category: (0, $oCMSG.NO_CATEGORY)
};
$8f1bc4ac72406fd0$export$aea9dc5735ed30c.defaultProps = {
    category: (0, $oCMSG.NO_CATEGORY)
};

});
parcelRegister("1WlLE", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $c68314f43531feff$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $c68314f43531feff$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResource", () => $c68314f43531feff$export$f6133a181a1ec201);
$parcel$export(module.exports, "issueListSsrResource", () => $c68314f43531feff$export$3d03cbaac8581e65);

var $9XE6b = parcelRequire("9XE6b");

var $jcw0u = parcelRequire("jcw0u");


var $jthxb = parcelRequire("jthxb");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $8w6CZ = parcelRequire("8w6CZ");

var $fRrvi = parcelRequire("fRrvi");

const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("17Fyq"));

const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("5u46E"));

const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("57gkn"));
const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
const $c68314f43531feff$export$4fed8be571897bef = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $c68314f43531feff$var$getDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$1f9ab301771fe42e = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $c68314f43531feff$export$f6133a181a1ec201 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true,
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
});
const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});

});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("jthxb", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $c406e66b8b597668$export$a973ef9e17a326f);
async function $c406e66b8b597668$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("8w6CZ", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $a4c66eaf20e13a4d$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $a4c66eaf20e13a4d$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID", () => $a4c66eaf20e13a4d$export$efa043b0bbc0ab6d);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $a4c66eaf20e13a4d$export$2733615da5b906f0);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $a4c66eaf20e13a4d$export$5a00268156ea5027);
const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $a4c66eaf20e13a4d$export$efa043b0bbc0ab6d = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID';
const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("fRrvi", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $2d01df2d1057a1ad$export$cf2bd2ec601ed920);

var $fn8B5 = parcelRequire("fn8B5");

var $bFU4G = parcelRequire("bFU4G");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $2d01df2d1057a1ad$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsById = async (projectId, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectId=${projectId}`);
};
const $2d01df2d1057a1ad$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    const fetchStartTime = performance.now();
    let data;
    if (projectId) {
        data = await $2d01df2d1057a1ad$var$fetchGroupsById(projectId, cloudId);
        (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroupsByProjectId', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    } else {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $2d01df2d1057a1ad$var$fetchGroupsByKey(projectKey, cloudId);
        (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroups', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category'); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});


parcelRegister("17Fyq", function(module, exports) {

let $0d16adb72e72a0d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0d16adb72e72a0d2$var$load("eNmuD"),
    $0d16adb72e72a0d2$var$load("fYHqp")
]).then(()=>parcelRequire('lini2'));

});

parcelRegister("5u46E", function(module, exports) {

let $3fe2f07d36e8f0eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fe2f07d36e8f0eb$var$load("2mLKW").then(()=>parcelRequire('etJR3'));

});

parcelRegister("57gkn", function(module, exports) {

let $3b9a45894e4111de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b9a45894e4111de$var$load("jmkWj").then(()=>parcelRequire('bmzqI'));

});


parcelRegister("bebaD", function(module, exports) {

$parcel$export(module.exports, "getQueuesForCategory", () => $f538431335917e3a$export$fcf9c653a5f7167a);
$parcel$export(module.exports, "setQueuesForCategory", () => $f538431335917e3a$export$7ca50bfd96f22f76);
$parcel$export(module.exports, "queuesToNavItems", () => $f538431335917e3a$export$e6491f132367997c);
$parcel$export(module.exports, "useProjectKey", () => $f538431335917e3a$export$f87be37f8e8be65);
$parcel$export(module.exports, "useCurrentCategory", () => $f538431335917e3a$export$e42116f2f5c27c35);

var $7uUwQ = parcelRequire("7uUwQ");

var $dd29Z = parcelRequire("dd29Z");

var $1ilU2 = parcelRequire("1ilU2");

var $g5X3G = parcelRequire("g5X3G");

var $doZTA = parcelRequire("doZTA");
const $f538431335917e3a$export$fcf9c653a5f7167a = (data, category)=>(0, $7uUwQ.getIn)(data, [
        category,
        'queues'
    ]);
const $f538431335917e3a$export$7ca50bfd96f22f76 = (data, category, newQueues)=>// @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'CategorizedQueueData': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    (0, $7uUwQ.updateIn)(data || {}, [
        category,
        'queues'
    ], (queues)=>{
        // We only want to update queues if they exist in a category already
        if (queues) return newQueues;
        throw new Error(`${category} does not exist in resource`);
    });
const $f538431335917e3a$export$e6491f132367997c = (queues)=>queues.map(({ id: id, name: name, projectKey: projectKey, count: count, category: category, favourite: favourite, canBeHidden: canBeHidden, shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh, lastRefreshedTime: lastRefreshedTime })=>({
            id: String(id),
            name: name,
            url: `/projects/${projectKey}/${(0, $dd29Z.getQueueFragment)(id, category)}`,
            badgeCount: count,
            starred: favourite,
            canBeHidden: canBeHidden,
            shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh,
            category: category,
            lastRefreshedTime: lastRefreshedTime
        }));
const $f538431335917e3a$export$f87be37f8e8be65 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $g5X3G.toProjectKey)(match.params.projectKey || '');
};
const $f538431335917e3a$export$e42116f2f5c27c35 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $1ilU2.toItsmPractice)(match.params.practiceType);
};

});
parcelRegister("dd29Z", function(module, exports) {

$parcel$export(module.exports, "QUEUE_ROUTES", () => $10cfdb56a53da9cf$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $10cfdb56a53da9cf$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $10cfdb56a53da9cf$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $10cfdb56a53da9cf$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $10cfdb56a53da9cf$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $10cfdb56a53da9cf$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $10cfdb56a53da9cf$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $10cfdb56a53da9cf$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $10cfdb56a53da9cf$export$91152835d12ca65f);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $5viSR = parcelRequire("5viSR");

var $oCMSG = parcelRequire("oCMSG");

var $hzd6p = parcelRequire("hzd6p");
const $10cfdb56a53da9cf$var$LOCATION = 'servicedesk.common.navigation.queues';
let $10cfdb56a53da9cf$var$navigatorPromise;
const $10cfdb56a53da9cf$var$getPushStateNavigator = ()=>{
    if (!$10cfdb56a53da9cf$var$navigatorPromise) $10cfdb56a53da9cf$var$navigatorPromise = (0, $hzd6p.createPushStateNavigator)();
    return $10cfdb56a53da9cf$var$navigatorPromise;
};
const $10cfdb56a53da9cf$export$410a6306dae101ca = {
    [(0, $oCMSG.INCIDENTS)]: 'section/incidents',
    [(0, $oCMSG.CHANGES)]: 'section/changes',
    [(0, $oCMSG.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $oCMSG.PROBLEMS)]: 'section/problems',
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $oCMSG.NO_CATEGORY)]: 'queues'
};
const $10cfdb56a53da9cf$var$fromCategory = (category)=>$10cfdb56a53da9cf$export$410a6306dae101ca[category || (0, $oCMSG.NO_CATEGORY)];
const $10cfdb56a53da9cf$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $5viSR.emitSignal)($10cfdb56a53da9cf$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $kVLXA.Observable).fromPromise($10cfdb56a53da9cf$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $kVLXA.Observable).empty();
    }).catch(()=>(0, $kVLXA.Observable).empty());
};
const $10cfdb56a53da9cf$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $10cfdb56a53da9cf$export$86f6a6d69e87f843 = (queueId, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/edit`;
const $10cfdb56a53da9cf$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $10cfdb56a53da9cf$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $10cfdb56a53da9cf$export$a796bfaff67c9fae = (issueKey)=>`${$10cfdb56a53da9cf$export$954f428fa284c7()}/issue/${issueKey}`;
const $10cfdb56a53da9cf$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $10cfdb56a53da9cf$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("5viSR", function(module, exports) {

$parcel$export(module.exports, "emitSignal", () => $8dc3d00171ca741d$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Cypress tests.
 *
 * This acts as a bridge between the storybook application and cypress for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $8dc3d00171ca741d$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8dc3d00171ca741d$var$registerSignal = (signal, meta)=>{
    window.cySignals.allSignals.push(signal);
    const signalsByName = window.cySignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $8dc3d00171ca741d$var$initCySignals = ()=>{
    window.cySignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $8dc3d00171ca741d$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($8dc3d00171ca741d$var$isProduction()) return;
    if (!window.cySignals) $8dc3d00171ca741d$var$initCySignals();
    $8dc3d00171ca741d$var$registerSignal(signal, meta);
};

});

parcelRegister("hzd6p", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $ddde70bc55609ded$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $ddde70bc55609ded$var$REQUIRE_TIMEOUT = 100;
const $ddde70bc55609ded$var$REQUIRE_RETRIES = 5;
const $ddde70bc55609ded$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $ddde70bc55609ded$var$REQUIRE_TIMEOUT,
        tentatives: $ddde70bc55609ded$var$REQUIRE_RETRIES
    });

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});




parcelRegister("1ilU2", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $27eaa4458d2c6986$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $27eaa4458d2c6986$export$357b94e419749e3d);

var $oCMSG = parcelRequire("oCMSG");
const $27eaa4458d2c6986$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $oCMSG.INCIDENTS;
        case 'changes':
            return 0, $oCMSG.CHANGES;
        case 'service-requests':
            return 0, $oCMSG.SERVICE_REQUEST;
        case 'problems':
            return 0, $oCMSG.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $oCMSG.POST_INCIDENT_REVIEWS;
        default:
            return 0, $oCMSG.NO_CATEGORY;
    }
};
const $27eaa4458d2c6986$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $oCMSG.INCIDENTS:
        case 0, $oCMSG.CHANGES:
        case 0, $oCMSG.SERVICE_REQUEST:
        case 0, $oCMSG.PROBLEMS:
        case 0, $oCMSG.POST_INCIDENT_REVIEWS:
        case 0, $oCMSG.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});


parcelRegister("fyiDq", function(module, exports) {

$parcel$export(module.exports, "queuesDataSelector", () => $1df222051fb5e2fa$export$fe10e38dc2f0e4c8);
$parcel$export(module.exports, "navDataSelector", () => $1df222051fb5e2fa$export$caf8de9cbdbf9102);
$parcel$export(module.exports, "notFavouriteAndCanBeHiddenDataSelector", () => $1df222051fb5e2fa$export$231e113a2e075013);
$parcel$export(module.exports, "notFavouriteDataSelector", () => $1df222051fb5e2fa$export$46aa703ec1a01e);
$parcel$export(module.exports, "cannotBeHiddenAndNotFavouriteDataSelector", () => $1df222051fb5e2fa$export$f28545acfde3f70e);
$parcel$export(module.exports, "favouriteDataSelector", () => $1df222051fb5e2fa$export$fc3fab89f453b08e);
$parcel$export(module.exports, "practiceMetadataSelector", () => $1df222051fb5e2fa$export$b0af22bb6bff9c49);
$parcel$export(module.exports, "isCountLoadingSelector", () => $1df222051fb5e2fa$export$efbcd30acb5e816f);
$parcel$export(module.exports, "hasRequestedCountSelector", () => $1df222051fb5e2fa$export$54e54a1ac5e7098f);
$parcel$export(module.exports, "practiceListSelector", () => $1df222051fb5e2fa$export$61d9fd7be029b514);

var $7uUwQ = parcelRequire("7uUwQ");

var $bebaD = parcelRequire("bebaD");
const $1df222051fb5e2fa$export$fe10e38dc2f0e4c8 = (data, category)=>(0, $bebaD.getQueuesForCategory)(data, category) || null;
const $1df222051fb5e2fa$export$caf8de9cbdbf9102 = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    return queues ? (0, $bebaD.queuesToNavItems)(queues) : null;
};
const $1df222051fb5e2fa$export$231e113a2e075013 = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    const otherQueuesData = queues ? queues.filter((q)=>q.canBeHidden && !q.favourite) : null;
    return otherQueuesData ? (0, $bebaD.queuesToNavItems)(otherQueuesData) : null;
};
const $1df222051fb5e2fa$export$46aa703ec1a01e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const otherQueuesData = queues ? queues.filter((q)=>!q.favourite) : null;
    return otherQueuesData ? (0, $bebaD.queuesToNavItems)(otherQueuesData) : null;
};
const $1df222051fb5e2fa$export$f28545acfde3f70e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    const defaultQueuesData = queues ? queues.filter((q)=>!q.canBeHidden && !q.favourite) : null;
    return defaultQueuesData ? (0, $bebaD.queuesToNavItems)(defaultQueuesData) : null;
};
const $1df222051fb5e2fa$export$fc3fab89f453b08e = (data, category)=>{
    const queues = (0, $bebaD.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const starredQueues = queues ? queues.filter((q)=>q.favourite) : null;
    return starredQueues ? (0, $bebaD.queuesToNavItems)(starredQueues) : null;
};
const $1df222051fb5e2fa$export$b0af22bb6bff9c49 = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? (0, $7uUwQ.dissoc)(practiceData, 'queues') : null;
};
const $1df222051fb5e2fa$export$efbcd30acb5e816f = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.isCountLoading : false;
};
const $1df222051fb5e2fa$export$54e54a1ac5e7098f = (data, category)=>{
    const practiceData = (0, $7uUwQ.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.hasRequestedCount : false;
};
const $1df222051fb5e2fa$export$61d9fd7be029b514 = (data)=>// @ts-expect-error - TS2322 - Type 'string[] | null' is not assignable to type 'Data<ItsmPractice[]>'.
    data ? Object.keys(data) : null;

});

parcelRegister("2lO5M", function(module, exports) {

$parcel$export(module.exports, "useCategorizedActions", () => $ff5cc066d5a13377$export$8632bfeb0b672958);
$parcel$export(module.exports, "default", () => $ff5cc066d5a13377$export$2e2bcd8739ae039);

var $324W5 = parcelRequire("324W5");

var $1WlLE = parcelRequire("1WlLE");

var $a4M45 = parcelRequire("a4M45");
const $ff5cc066d5a13377$export$8632bfeb0b672958 = (baseUrl, projectKey, category, customContext)=>{
    const { update: update } = (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.queuesNavigationItems), customContext);
    const cachedActions = (0, $a4M45.default)(category, update, {
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    return [
        cachedActions
    ];
};
const $ff5cc066d5a13377$var$ActionsProvider = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [actions] = $ff5cc066d5a13377$export$8632bfeb0b672958(baseUrl, projectKey, category);
    return children(actions);
};
var $ff5cc066d5a13377$export$2e2bcd8739ae039 = $ff5cc066d5a13377$var$ActionsProvider;

});
parcelRegister("a4M45", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c8b4db868052f8$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6vsnF = parcelRequire("6vsnF");
const $64c8b4db868052f8$export$36d128238e6b60f5 = {
    currentCacheKey: '',
    // @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'Record<ItsmPractice, ChildrenProps>': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    actionsByCategory: {}
};
const $64c8b4db868052f8$export$8b3bc28eb06c49b6 = {
    // Actions are lazily created for each category of a project.
    // Project key is used as the cache key. Once the cache key has changed
    // the store will be reset
    getActions: (...args)=>({ getState: getState, setState: setState })=>{
            const [category, , { projectKey: projectKey }] = args;
            const { currentCacheKey: currentCacheKey, actionsByCategory: actionsByCategory } = getState();
            const categoryActions = actionsByCategory[category];
            const hasSameKey = projectKey === currentCacheKey;
            if (hasSameKey && Boolean(categoryActions)) return categoryActions;
            const newCategoryActions = (0, $6vsnF.getActions)(...args);
            setState({
                currentCacheKey: projectKey,
                // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '{ "change-management"?: Actions | undefined; "incident-management"?: Actions | undefined; "problem-management"?: Actions | undefined; "service-request"?: Actions | undefined; "post-incident-review"?: Actions | undefined; "no-category"?: Actions | undefined; }' is not assignable to type 'Record<ItsmPractice, ChildrenProps>'.
                actionsByCategory: {
                    ...hasSameKey ? actionsByCategory : {},
                    [category]: newCategoryActions
                }
            });
            return newCategoryActions;
        }
};
const $64c8b4db868052f8$var$Store = (0, $iXqE5.createStore)({
    initialState: $64c8b4db868052f8$export$36d128238e6b60f5,
    actions: $64c8b4db868052f8$export$8b3bc28eb06c49b6,
    name: 'jira-servicedesk-categorized-queues-actions-store'
});
const $64c8b4db868052f8$var$useActionsStore = (0, $3sQ5x.createHook)($64c8b4db868052f8$var$Store, {
    selector: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $64c8b4db868052f8$export$193cb0fec61d3692 = (...args)=>{
    const [, { getActions: getActions }] = $64c8b4db868052f8$var$useActionsStore();
    return getActions(...args);
};
var $64c8b4db868052f8$export$2e2bcd8739ae039 = $64c8b4db868052f8$export$193cb0fec61d3692;

});
parcelRegister("6vsnF", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $62968e378f0259c7$export$fe3955935f564b31);

var $7uUwQ = parcelRequire("7uUwQ");

var $34ck9 = parcelRequire("34ck9");


var $6s1PB = parcelRequire("6s1PB");

var $fZneA = parcelRequire("fZneA");

var $2nYuf = parcelRequire("2nYuf");

var $jHq2C = parcelRequire("jHq2C");

var $90q41 = parcelRequire("90q41");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $czC6V = parcelRequire("czC6V");

var $kTfMz = parcelRequire("kTfMz");
const $62968e378f0259c7$var$getThrottledRefresh = ()=>Number((0, $6s1PB.expVal)('jsm_dynamic_queues_issue_count_refresh_interval', 'value', '120000'));
const $62968e378f0259c7$var$getAnalyticsPayload = (err)=>{
    const wasQueueDeleted = err?.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef);
    const queueConflictOccurred = err?.statusCode === (0, $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f);
    const queueActionNotPermitted = err?.statusCode === (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3);
    return {
        wasQueueDeleted: wasQueueDeleted,
        queueConflictOccurred: queueConflictOccurred,
        queueActionNotPermitted: queueActionNotPermitted,
        isClientFetchError: (0, $fZneA.isClientFetchError)(err)
    };
};
const $62968e378f0259c7$export$fe3955935f564b31 = (category, update, restParams)=>{
    const actions = {
        addItem: (item)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.addItem)(queues, item));
                throw new Error(`Cannot add item because ${category} does not exist in resource`);
            });
        },
        deleteItem: (id)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.deleteItem)(queues, id));
                throw new Error(`Cannot delete item because ${category} does not exist in resource`);
            });
        },
        editItem: (item)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, item));
                throw new Error(`Cannot edit item because ${category} does not exist in resource`);
            });
        },
        moveItem: (from, to)=>{
            if (from !== to) update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItem)(queues, from, to);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category);
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item because ${category} does not exist in resource`);
            });
        },
        moveItemBelow: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItemBelow)(queues, queueId, targetQueueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item below because ${category} does not exist in resource`);
            });
        },
        moveItemAbove: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveItemAbove)(queues, queueId, targetQueueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item above because ${category} does not exist in resource`);
            });
        },
        moveToTop: (queueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kTfMz.moveToTop)(queues, queueId);
                    (0, $jHq2C.setQueues)(baseUrl, projectKey, (0, $bebaD.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item to top because ${category} does not exist in resource`);
            });
        },
        refreshNavItems: (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((analyticsEvent)=>{
            setTimeout(()=>{
                update((data)=>{
                    const isCountLoading = (0, $fyiDq.isCountLoadingSelector)(data, category);
                    if (isCountLoading) return data;
                    if (restParams.projectKey) (0, $czC6V.refreshIssueCountForVisibleAndStarredQueues)(update, {
                        ...restParams,
                        category: category
                    }, analyticsEvent);
                    const updatedData = data ? (0, $7uUwQ.assocIn)(data, [
                        category,
                        'isCountLoading'
                    ], true) : null;
                    return updatedData;
                });
            // Jitter the call randomly between 1 - 5secs in case of multiple tab requests
            }, Math.floor(Math.random() * 5000) + 1000);
        }, $62968e378f0259c7$var$getThrottledRefresh()),
        initialFetchNavItems: (analyticsEvent)=>{
            update((data)=>{
                const isCountLoading = (0, $fyiDq.isCountLoadingSelector)(data, category);
                const hasRequestedCount = (0, $fyiDq.hasRequestedCountSelector)(data, category);
                if (!isCountLoading && !hasRequestedCount) actions.refreshNavItems(analyticsEvent);
                return data;
            });
        },
        refreshIssueCountForItems: (queueIds, analyticsEvent)=>{
            (0, $czC6V.refreshIssueCountForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds, analyticsEvent);
        },
        editItemIssueCount: (id, count)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, {
                    id: Number(id),
                    count: count,
                    lastRefreshedTime: Date.now()
                }));
                // There is no point update the issue-counts for default queue as there is no queues.
                // It might throwing exceptions if we cannot fetch queue categories.
                // Being defensive here for the rollout, if this code throw any errors, it's the same behavior as the below line.
                if (Number(id) === (0, $2nYuf.DEFAULT_QUEUE_ID)) return data;
                throw new Error(`Cannot edit item issue count because ${category} does not exist in resource for queue id ${id}`);
            });
        },
        editItemFavorite: (id, favourite)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItem)(queues, {
                    id: Number(id),
                    favourite: favourite
                }));
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        editVisibilityOfItems: (updatedItems, draggableId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                if (queues) {
                    (0, $90q41.updateQueuesVisibility)(baseUrl, projectKey, updatedItems).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($62968e378f0259c7$var$getAnalyticsPayload(err)));
                    return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.editItems)(queues, [
                        ...updatedItems
                    ]));
                }
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        enableRefreshForQueues: (queueIds)=>{
            (0, $czC6V.enableRefreshForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds);
        },
        enableIssueCountForSelectedQueues: (selectedQueueIds)=>{
            update((data)=>{
                const queues = (0, $bebaD.getQueuesForCategory)(data, category);
                if (queues) return (0, $bebaD.setQueuesForCategory)(data, category, (0, $kTfMz.enableSelectedQueuesVisibility)(selectedQueueIds, queues));
                throw new Error(`Cannot enable issue count for selected queues because ${category} does not exist in resource`);
            });
        }
    };
    return actions;
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("2nYuf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLUMNS", () => $55f991500b621537$export$50c19f60b9c144f7);
$parcel$export(module.exports, "DEFAULT_QUEUE_ID", () => $55f991500b621537$export$e78379cc32bff512);
$parcel$export(module.exports, "FETCH_BATCH_SIZE", () => $55f991500b621537$export$baa236d86cd0d3f5);
$parcel$export(module.exports, "FETCH_SIZE_IN_INITIAL_LOAD", () => $55f991500b621537$export$4ee65d92b7b81b6b);
const $55f991500b621537$export$50c19f60b9c144f7 = [
    'issuetype',
    'issuekey',
    'summary',
    'reporter',
    'assignee',
    'status',
    'created'
];
const $55f991500b621537$export$e78379cc32bff512 = Number.MIN_VALUE;
const $55f991500b621537$export$baa236d86cd0d3f5 = 100;
const $55f991500b621537$export$4ee65d92b7b81b6b = 30;

});

parcelRegister("jHq2C", function(module, exports) {

$parcel$export(module.exports, "setQueues", () => $7a268253f439fbe8$export$51b06787b88b2bf2);

var $eusud = parcelRequire("eusud");

var $2m5JT = parcelRequire("2m5JT");
const $7a268253f439fbe8$var$getQueuesUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues`;
const $7a268253f439fbe8$export$51b06787b88b2bf2 = (baseUrl, projectKey, queues, category)=>(0, $eusud.performPutRequest)($7a268253f439fbe8$var$getQueuesUrl(baseUrl, projectKey), {
        body: JSON.stringify((0, $2m5JT.transformQueues)(queues, category))
    });

});
parcelRegister("2m5JT", function(module, exports) {

$parcel$export(module.exports, "transformQueues", () => $21e5ad652b3de239$export$66ec85c65393edb4);

var $oCMSG = parcelRequire("oCMSG");
const $21e5ad652b3de239$export$66ec85c65393edb4 = (queues, category)=>({
        order: queues.map((queue)=>queue.id),
        id: 'com.atlassian.servicedesk.project-ui:sd-queues-custom',
        inline: true,
        deleted: [],
        ...category && category !== (0, $oCMSG.NO_CATEGORY) ? {
            category: category
        } : undefined
    });

});


parcelRegister("90q41", function(module, exports) {

$parcel$export(module.exports, "updateQueuesVisibility", () => $8ab251897e60612e$export$c0862f2fb17c23c2);

var $eusud = parcelRequire("eusud");
const $8ab251897e60612e$var$getUpdateQueuesVisibilityUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/update-visibility`;
const $8ab251897e60612e$export$c0862f2fb17c23c2 = (baseUrl, projectKey, modified)=>(0, $eusud.performPutRequest)($8ab251897e60612e$var$getUpdateQueuesVisibilityUrl(baseUrl, projectKey), {
        body: JSON.stringify({
            modified: modified
        })
    });

});

parcelRegister("czC6V", function(module, exports) {

$parcel$export(module.exports, "refreshIssueCountForVisibleAndStarredQueues", () => $d32f12b3757f33df$export$aaa6aeca5994daee);
$parcel$export(module.exports, "enableRefreshForQueues", () => $d32f12b3757f33df$export$6b0c14cefee3edf5);
$parcel$export(module.exports, "refreshIssueCountForQueues", () => $d32f12b3757f33df$export$b05e3887bfb123a8);

var $7uUwQ = parcelRequire("7uUwQ");

var $4Xk2W = parcelRequire("4Xk2W");

var $8Rkzz = parcelRequire("8Rkzz");

var $7qDUb = parcelRequire("7qDUb");

var $jcw0u = parcelRequire("jcw0u");

var $bebaD = parcelRequire("bebaD");

var $fyiDq = parcelRequire("fyiDq");

var $l6KG9 = parcelRequire("l6KG9");
const $d32f12b3757f33df$export$defcbd4ba0fd3734 = 5;
const $d32f12b3757f33df$var$RETRY_DELAY_IN_MS = 1000;
const $d32f12b3757f33df$var$fireErrorAnalyticsForRetryFailure = (error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'retryQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $d32f12b3757f33df$export$ef7266a9f6c0de43 = ({ baseUrl: baseUrl, projectKey: projectKey, category: category }, skipHiddenQueues, update, retryCount, analyticsEvent)=>async (queueIds)=>{
        if (queueIds && queueIds.length === 0) return;
        if (retryCount >= $d32f12b3757f33df$export$defcbd4ba0fd3734) {
            (0, $l6KG9.fireManualOperationalAnalytics)({
                source: 'refreshQueueIssueCountAction',
                actionSubject: 'retryIssueCount',
                action: 'limitExceeded',
                attributes: {
                    retryCount: retryCount,
                    maxRetryCount: $d32f12b3757f33df$export$defcbd4ba0fd3734
                }
            });
            return;
        }
        setTimeout(()=>{
            try {
                const newRetryCount = retryCount + 1;
                update((data)=>{
                    const queues = (0, $bebaD.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id));
                    if (queues && queues.length > 0) {
                        const retryCallback = $d32f12b3757f33df$export$ef7266a9f6c0de43({
                            baseUrl: baseUrl,
                            projectKey: projectKey,
                            category: category
                        }, true, update, newRetryCount, analyticsEvent);
                        (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent);
                        (0, $l6KG9.fireManualOperationalAnalytics)({
                            source: 'refreshQueueIssueCountAction',
                            actionSubject: 'retryQueueIssueCount',
                            action: 'triggered',
                            attributes: {
                                retryCount: newRetryCount,
                                maxRetryCount: $d32f12b3757f33df$export$defcbd4ba0fd3734,
                                queuesCount: queues.length
                            }
                        });
                        return data ? (0, $7uUwQ.assocIn)(data, [
                            category,
                            'isCountLoading'
                        ], true) : null;
                    }
                    return data;
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                $d32f12b3757f33df$var$fireErrorAnalyticsForRetryFailure(error);
                throw error;
            }
        }, $d32f12b3757f33df$var$RETRY_DELAY_IN_MS);
    };
const $d32f12b3757f33df$export$aaa6aeca5994daee = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $bebaD.getQueuesForCategory)(data, category);
            const retryCallback = !(0, $fyiDq.hasRequestedCountSelector)(data, category) ? $d32f12b3757f33df$export$ef7266a9f6c0de43({
                baseUrl: baseUrl,
                projectKey: projectKey,
                category: category
            }, true, update, 0, analyticsEvent) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
            if (queues) {
                (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, true, update, retryCallback, analyticsEvent);
                return data ? (0, $7uUwQ.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $l6KG9.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};
const $d32f12b3757f33df$export$6b0c14cefee3edf5 = (update, { projectKey: _, category: category }, queueIds)=>{
    update((data)=>{
        const queues = (0, $bebaD.getQueuesForCategory)(data, category);
        const refreshEnabledQueues = queues?.filter((queue)=>queueIds.includes(queue.id.toString())).map((queue)=>queue.shouldSkipIssueCountRefresh ? {
                ...queue,
                shouldSkipIssueCountRefresh: false,
                count: undefined
            } : queue);
        const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(queues, 'id');
        refreshEnabledQueues?.forEach((queue)=>{
            queuesMap[queue.id] = queue;
        });
        return (0, $bebaD.setQueuesForCategory)(data, category, (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(Object.values(queuesMap), 'order'));
    });
};
const $d32f12b3757f33df$export$b05e3887bfb123a8 = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, queueIds, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $bebaD.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id.toString()));
            if (queues && queues.length > 0) {
                (0, $l6KG9.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, false, update, (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), analyticsEvent);
                return data ? (0, $7uUwQ.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $l6KG9.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};

});
parcelRegister("4Xk2W", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
    $1m3dq(result, key, value);
});
module.exports = $39bc38f0156cacc0$var$keyBy;

});

parcelRegister("l6KG9", function(module, exports) {

$parcel$export(module.exports, "fireManualOperationalAnalytics", () => $fa1880944e28b500$export$a9301d18019c11f9);
$parcel$export(module.exports, "fireErrorAnalyticsForRefreshCountFailure", () => $fa1880944e28b500$export$b5e2038970f91d6c);
$parcel$export(module.exports, "updateIssueCountForQueues", () => $fa1880944e28b500$export$d436cbef77099410);

var $7uUwQ = parcelRequire("7uUwQ");

var $hUobS = parcelRequire("hUobS");

var $4Xk2W = parcelRequire("4Xk2W");

var $7qDUb = parcelRequire("7qDUb");

var $dMEgP = parcelRequire("dMEgP");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $g9E9n = parcelRequire("g9E9n");

var $7ZmbO = parcelRequire("7ZmbO");

var $bebaD = parcelRequire("bebaD");
const $fa1880944e28b500$var$ERROR_DB_TIMEOUT = 'error.db-timeout';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $fa1880944e28b500$var$ERROR_UNKNOWN = 'error.unknown';
const $fa1880944e28b500$export$cf85cf6a45b00808 = {
    FAILED: 'failed',
    SUCCESS: 'success',
    PENDING: 'pending'
};
const $fa1880944e28b500$var$MAX_ISSUECOUNT_THRESHOLD = 1000;
const $fa1880944e28b500$export$a9301d18019c11f9 = (payload)=>(0, $g9E9n.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $fa1880944e28b500$var$filterOutHiddenQueues = (queues)=>queues.filter((q)=>!(q.canBeHidden === undefined ? false : q.canBeHidden) || q.favourite);
const $fa1880944e28b500$var$filterOutBadQueues = (queues)=>queues.filter((q)=>!q.shouldSkipIssueCountRefresh);
const $fa1880944e28b500$var$getIssueCountPerGroup = (issueCounts)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(issueCounts).reduce((curr, queueId)=>{
        const res = curr;
        if (issueCounts[Number(queueId)]) {
            if (issueCounts[Number(queueId)].issueCount || issueCounts[Number(queueId)].issueCount === 0) res[Number(queueId)] = issueCounts[Number(queueId)].issueCount;
        }
        return res;
    }, {});
const $fa1880944e28b500$var$getQueuesPerGroup = (queues, skipHiddenQueues)=>{
    const starredQueues = [];
    const defaultQueues = [];
    let toGroupQueues = queues;
    let hasSkippedQueues = false;
    if (skipHiddenQueues === true) toGroupQueues = $fa1880944e28b500$var$filterOutHiddenQueues(queues);
    toGroupQueues = $fa1880944e28b500$var$filterOutBadQueues(toGroupQueues);
    let queueByGroups = {};
    toGroupQueues.forEach((queue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(queue.count) && queue.count > $fa1880944e28b500$var$MAX_ISSUECOUNT_THRESHOLD) {
            hasSkippedQueues = true;
            return;
        }
        if (queue.favourite) starredQueues.push(queue);
        else defaultQueues.push(queue);
    });
    queueByGroups = {
        starredQueues: starredQueues,
        defaultQueues: defaultQueues
    };
    if (hasSkippedQueues) $fa1880944e28b500$export$a9301d18019c11f9({
        source: 'refreshQueueIssueCountAction',
        actionSubject: 'queueIssueCountRefresh',
        action: 'skipped'
    });
    return queueByGroups;
};
const $fa1880944e28b500$var$getQueuesSortByLastRefreshedTime = (queuesBeforeSort)=>{
    let queuesSortByLastRefreshedTime = [];
    const queuesSortByGroup = [
        ...queuesBeforeSort.starredQueues,
        ...queuesBeforeSort.defaultQueues
    ];
    queuesSortByLastRefreshedTime = (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(queuesSortByGroup, [
        'lastRefreshedTime'
    ]);
    return queuesSortByLastRefreshedTime;
};
const $fa1880944e28b500$export$b5e2038970f91d6c = (error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'refreshQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $fa1880944e28b500$var$isIssueCountAlreadyFetched = (queue)=>queue.count !== undefined;
const $fa1880944e28b500$var$getSkippedQueues = (issueCounts, queuesMap)=>Object.keys(issueCounts).map((id)=>Number(id)).filter((queueId)=>issueCounts[queueId].result === $fa1880944e28b500$export$cf85cf6a45b00808.PENDING && !$fa1880944e28b500$var$isIssueCountAlreadyFetched(queuesMap[queueId]));
const $fa1880944e28b500$var$fetchIssueCountForQueueGroup = async (projectKey, queueIds)=>(0, $eusud.performPostRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/issue-counts/refresh`, {
        body: JSON.stringify(queueIds)
    });
const $fa1880944e28b500$var$getQueueGroupData = (queueIds, issueCounts, queuesMap, batchStartProcessingTime)=>{
    const queueRefreshData = {
        minLastRefreshTimeFromCurrentBatch: Number.MAX_VALUE,
        queueCountChanges: 0
    };
    return queueIds.reduce((changes, queueId)=>{
        if (issueCounts[queueId]) {
            if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) {
                const queue = queuesMap[queueId];
                const currentQueueLastRefreshedTime = queue.lastRefreshedTime !== undefined && queue.lastRefreshedTime !== 0 ? queue.lastRefreshedTime : batchStartProcessingTime;
                const minLastRefreshTimeFromCurrentBatch = Math.min(changes.minLastRefreshTimeFromCurrentBatch, currentQueueLastRefreshedTime);
                const queueCountChanges = queue.count !== issueCounts[queueId].issueCount ? changes.queueCountChanges + 1 : changes.queueCountChanges;
                return {
                    minLastRefreshTimeFromCurrentBatch: minLastRefreshTimeFromCurrentBatch,
                    queueCountChanges: queueCountChanges
                };
            }
        }
        return changes;
    }, queueRefreshData);
};
const $fa1880944e28b500$var$fetchAndUpdateCount = async (baseUrl, projectKey, queueIds, category, analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
update, batchStartProcessingTime, retryCallback)=>{
    if (queueIds.length === 0) return;
    let maxQueuesPerSd = await (0, $7ZmbO.getLimit)((0, $7ZmbO.MAX_QUEUES_PER_SD));
    if (maxQueuesPerSd === null) maxQueuesPerSd = queueIds.length;
    const queueIdsToFetch = queueIds.slice(0, maxQueuesPerSd);
    const startTime = Date.now();
    await $fa1880944e28b500$var$fetchIssueCountForQueueGroup(projectKey, queueIdsToFetch).then(({ issueCounts: issueCounts })=>{
        update((data)=>{
            const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))((0, $bebaD.getQueuesForCategory)(data, category), 'id');
            const skippedQueues = $fa1880944e28b500$var$getSkippedQueues(issueCounts, queuesMap);
            if (skippedQueues.length > 0) retryCallback(skippedQueues);
            const endTime = Date.now();
            let queueCountChanges = 0;
            let minLastRefreshTimeFromCurrentBatch = 0;
            let numberOfBadQueues = 0;
            const queueRefreshData = $fa1880944e28b500$var$getQueueGroupData(queueIds, issueCounts, queuesMap, batchStartProcessingTime);
            queueCountChanges = queueRefreshData.queueCountChanges;
            minLastRefreshTimeFromCurrentBatch = queueRefreshData.minLastRefreshTimeFromCurrentBatch;
            queueIds.forEach((queueId)=>{
                const queue = queuesMap[queueId];
                if (issueCounts[queueId]) {
                    if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) queuesMap[queueId] = {
                        ...queue,
                        count: issueCounts[queueId].issueCount,
                        lastRefreshedTime: endTime,
                        shouldSkipIssueCountRefresh: false
                    };
                    else if (issueCounts[queueId].errorCode === $fa1880944e28b500$var$ERROR_DB_TIMEOUT) {
                        numberOfBadQueues += 1;
                        queuesMap[queueId] = {
                            ...queue,
                            shouldSkipIssueCountRefresh: true
                        };
                    }
                }
            });
            if (analyticsEvent) {
                const issueCountPerGroup = $fa1880944e28b500$var$getIssueCountPerGroup(issueCounts);
                const queueIssueCounts = Object.values(issueCountPerGroup).map((queueCount)=>Number(queueCount));
                const jiraShard = (0, $j8DrX.default)('ajs-shard') || '';
                if (queueIssueCounts.length === 0) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'navigationSession poorPerformanceQueuesCountsInfo', {
                    category: category,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    timeToFetchIssueCount: endTime - startTime,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    jiraShard: jiraShard,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
                else (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'navigationSession queuesCountsInfo', {
                    category: category,
                    queues: queueIssueCounts.length,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    maxIssueCount: Math.max(...queueIssueCounts),
                    timeToFetchIssueCount: endTime - startTime,
                    timeBetweenQueueRefresh: endTime - minLastRefreshTimeFromCurrentBatch,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    noOfQueuesWithUpdatedCount: queueCountChanges,
                    jiraShard: jiraShard,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
            }
            return (0, $bebaD.setQueuesForCategory)(data, category, // Object.values is typed as Mixed[] and makes flow unhappy
            (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))((0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(queuesMap), 'order'));
        });
    }).catch((error)=>{
        $fa1880944e28b500$export$b5e2038970f91d6c(error);
    });
};
const $fa1880944e28b500$var$updateLoadingState = (category, queues, update)=>{
    update((data)=>data ? (0, $7uUwQ.chain)(data).setIn([
            category,
            'hasRequestedCount'
        ], true).setIn([
            category,
            'isCountLoading'
        ], false).value() : null);
};
const $fa1880944e28b500$export$d436cbef77099410 = async (baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent)=>{
    const queuesPerGroup = $fa1880944e28b500$var$getQueuesPerGroup(queues, skipHiddenQueues);
    const queuesSortByLastRefreshedTime = $fa1880944e28b500$var$getQueuesSortByLastRefreshedTime(queuesPerGroup);
    const queueIds = queuesSortByLastRefreshedTime.map((x)=>x.id);
    const batchStartProcessingTime = Date.now();
    try {
        // fetching the result in one call
        await $fa1880944e28b500$var$fetchAndUpdateCount(baseUrl, projectKey, queueIds, category, analyticsEvent, update, batchStartProcessingTime, retryCallback);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $fa1880944e28b500$var$updateLoadingState(category, queues, update);
        $fa1880944e28b500$export$b5e2038970f91d6c(error);
        throw error;
    }
    $fa1880944e28b500$var$updateLoadingState(category, queues, update);
};

});
parcelRegister("hUobS", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $d09a6e5a442af90c$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $d09a6e5a442af90c$var$isNumber(value) {
    return typeof value == 'number' || $fC1Kz(value) && $beQoo(value) == $d09a6e5a442af90c$var$numberTag;
}
module.exports = $d09a6e5a442af90c$var$isNumber;

});

parcelRegister("7ZmbO", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $92269289c1fdd627$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $92269289c1fdd627$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $92269289c1fdd627$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $92269289c1fdd627$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $92269289c1fdd627$export$cb3888a8c43147d2);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $92269289c1fdd627$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $92269289c1fdd627$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $92269289c1fdd627$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $92269289c1fdd627$export$c5d8aa8a650e690f);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
const $92269289c1fdd627$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $92269289c1fdd627$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $92269289c1fdd627$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $92269289c1fdd627$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $92269289c1fdd627$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $92269289c1fdd627$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $92269289c1fdd627$export$5ed1d2ac050e39d = {
    [$92269289c1fdd627$export$dca2c2105b681490]: 30,
    [$92269289c1fdd627$export$a48ac34d39e0fc22]: 30,
    [$92269289c1fdd627$export$2e0ba662d5bb7742]: 300,
    [$92269289c1fdd627$export$eb69982aa3a172b4]: 30,
    [$92269289c1fdd627$export$cb3888a8c43147d2]: 20,
    [$92269289c1fdd627$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $92269289c1fdd627$var$limitCache = {};
const $92269289c1fdd627$export$c419786abd6faaad = (limitProperty)=>{
    delete $92269289c1fdd627$var$limitCache[limitProperty];
};
const $92269289c1fdd627$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$92269289c1fdd627$var$limitCache[limitProperty]) $92269289c1fdd627$var$limitCache[limitProperty] = (0, $7f4tk.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $92269289c1fdd627$export$c419786abd6faaad(limitProperty);
        (0, $2YZCu.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $92269289c1fdd627$var$limitCache[limitProperty];
};
class $92269289c1fdd627$export$9989835030ecd317 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $92269289c1fdd627$export$5ed1d2ac050e39d[limitProperty];
        $92269289c1fdd627$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args), this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $92269289c1fdd627$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92269289c1fdd627$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});



parcelRegister("kTfMz", function(module, exports) {

$parcel$export(module.exports, "addItem", () => $98056c458719acf6$export$fb9705de59d96855);
$parcel$export(module.exports, "deleteItem", () => $98056c458719acf6$export$8d8542dbbc23fe1a);
$parcel$export(module.exports, "editItem", () => $98056c458719acf6$export$60832f4899fbf6a1);
$parcel$export(module.exports, "editItems", () => $98056c458719acf6$export$8c896bccb18e1db1);
$parcel$export(module.exports, "moveItem", () => $98056c458719acf6$export$ec937e64de6c1257);
$parcel$export(module.exports, "moveItemBelow", () => $98056c458719acf6$export$17c7ebc966cf5476);
$parcel$export(module.exports, "moveItemAbove", () => $98056c458719acf6$export$d54386016cadff45);
$parcel$export(module.exports, "moveToTop", () => $98056c458719acf6$export$f2c5cc4c3f787c3e);
$parcel$export(module.exports, "enableSelectedQueuesVisibility", () => $98056c458719acf6$export$ce58537552972d29);

var $fW7cr = parcelRequire("fW7cr");
const $98056c458719acf6$export$fb9705de59d96855 = (source, item)=>[
        ...source,
        item
    ];
const $98056c458719acf6$export$8d8542dbbc23fe1a = (source, id)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: Number(id)
    });
    if (index >= 0) result.splice(index, 1);
    return result;
};
const $98056c458719acf6$export$60832f4899fbf6a1 = (source, updatedItem)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: updatedItem.id
    });
    if (index >= 0) result[index] = {
        ...result[index],
        ...updatedItem
    };
    return result;
};
const $98056c458719acf6$export$8c896bccb18e1db1 = (source, updatedItems)=>{
    const result = source.slice();
    updatedItems.forEach((item)=>{
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: item.id
        });
        if (index >= 0) result[index] = {
            ...result[index],
            ...item
        };
    });
    return result;
};
const $98056c458719acf6$export$ec937e64de6c1257 = (source, from, to)=>{
    const result = source.slice();
    const item = result[from];
    if (from !== to && from >= 0) {
        result.splice(from, 1);
        result.splice(to, 0, item);
    }
    return result.map((page, order)=>({
            ...page,
            order: order
        }));
};
const $98056c458719acf6$export$17c7ebc966cf5476 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex + 1, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $98056c458719acf6$export$d54386016cadff45 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $98056c458719acf6$export$f2c5cc4c3f787c3e = (source, sourceId)=>{
    const result = source.slice();
    if (result.length === 0) return source;
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(result, {
        id: sourceId
    });
    if (index > 0) {
        const sourceQueue = result[index];
        result.splice(index, 1);
        result.splice(0, 0, sourceQueue);
        return result.map((page, order)=>({
                ...page,
                order: order
            }));
    }
    return source;
};
const $98056c458719acf6$export$ce58537552972d29 = (selectedQueueIds, queues)=>queues.map((queue)=>{
        if (selectedQueueIds.some((selectedQueueId)=>selectedQueueId === queue.id)) {
            if (!queue.canBeHidden) return queue;
            return {
                ...queue,
                canBeHidden: false
            };
        }
        if (queue.canBeHidden) return queue;
        return {
            ...queue,
            canBeHidden: true
        };
    });

});
parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});






parcelRegister("6dNtI", function(module, exports) {

$parcel$export(module.exports, "MenuPractices", () => $1a488ccf5b270c95$export$8cf5db42749c99bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck https://atlassian.slack.com/archives/C02785CLSTW/p1658657213150179

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $5LWLA = parcelRequire("5LWLA");

var $dME4E = parcelRequire("dME4E");

var $aZ5rg = parcelRequire("aZ5rg");

var $acknU = parcelRequire("acknU");

var $2ciBJ = parcelRequire("2ciBJ");

var $50Bjx = parcelRequire("50Bjx");

var $9x5pH = parcelRequire("9x5pH");

var $hxCqX = parcelRequire("hxCqX");

var $aVnO1 = parcelRequire("aVnO1");

var $aEHvW = parcelRequire("aEHvW");

var $d1ABl = parcelRequire("d1ABl");

var $lJosW = parcelRequire("lJosW");

var $bB6uF = parcelRequire("bB6uF");

var $ckyDP = parcelRequire("ckyDP");

var $6B8sk = parcelRequire("6B8sk");

var $k2tiP = parcelRequire("k2tiP");

var $7aY9g = parcelRequire("7aY9g");

var $3u0c5 = parcelRequire("3u0c5");

var $7paD5 = parcelRequire("7paD5");

var $imZsD = parcelRequire("imZsD");

var $g2EiV = parcelRequire("g2EiV");
var $9btdk = parcelRequire("9btdk");
var $gjTBi = parcelRequire("gjTBi");
var $gZEU1 = parcelRequire("gZEU1");
var $bWqXX = parcelRequire("bWqXX");

var $dqoiX = parcelRequire("dqoiX");

var $8J6rn = parcelRequire("8J6rn");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $3QTQ5 = parcelRequire("3QTQ5");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $2gP8z = parcelRequire("2gP8z");

var $Uj4ce = parcelRequire("Uj4ce");

var $lpwtK = parcelRequire("lpwtK");

var $juTur = parcelRequire("juTur");

var $jsI7v = parcelRequire("jsI7v");

var $kZj7F = parcelRequire("kZj7F");

var $l468O = parcelRequire("l468O");

var $3SzZi = parcelRequire("3SzZi");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $3tHFY = parcelRequire("3tHFY");

var $hWtQt = parcelRequire("hWtQt");

var $jfqNX = parcelRequire("jfqNX");

var $gZbSF = parcelRequire("gZbSF");

var $6hMYg = parcelRequire("6hMYg");

var $231OU = parcelRequire("231OU");

var $iIGGa = parcelRequire("iIGGa");

var $8zgGo = parcelRequire("8zgGo");

var $dxCvy = parcelRequire("dxCvy");


var $9QGIi = parcelRequire("9QGIi");

var $dtVRS = parcelRequire("dtVRS");

var $16J3A = parcelRequire("16J3A");

var $dd29Z = parcelRequire("dd29Z");

var $htI2Q = parcelRequire("htI2Q");

var $dMRcK = parcelRequire("dMRcK");

var $jF62O = parcelRequire("jF62O");

var $37cK0 = parcelRequire("37cK0");

var $2avq0 = parcelRequire("2avq0");

var $oCMSG = parcelRequire("oCMSG");

var $kVZSN = parcelRequire("kVZSN");

var $koeKL = parcelRequire("koeKL");

var $2YP9W = parcelRequire("2YP9W");

var $aQY3O = parcelRequire("aQY3O");

var $lNhbS = parcelRequire("lNhbS");

var $a88Sz = parcelRequire("a88Sz");

var $e1CQH = parcelRequire("e1CQH");

var $4eEnx = parcelRequire("4eEnx");

var $1rtJs = parcelRequire("1rtJs");

var $ccoXC = parcelRequire("ccoXC");

var $3wBTQ = parcelRequire("3wBTQ");

var $bTR6h = parcelRequire("bTR6h");

var $dYOHi = parcelRequire("dYOHi");

var $80BbW = parcelRequire("80BbW");

var $y8WG5 = parcelRequire("y8WG5");

var $2TRg1 = parcelRequire("2TRg1");

var $hadw2 = parcelRequire("hadw2");
const $1a488ccf5b270c95$var$styles = {
    menuItem: "_btpd1ady _1c06idpf _g718kb7n _3u8ukb7n"
};
const $1a488ccf5b270c95$export$e8026ff3708f95e4 = (0, $7OqB4.withThrowOnError)((0, $y8WG5.useFeatures));
const $1a488ccf5b270c95$export$154ecbb867fd48f0 = (0, $7OqB4.withThrowOnError)((0, $y8WG5.useSettingFeatures));
const $1a488ccf5b270c95$export$a4007dc4843ca7f6 = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $1a488ccf5b270c95$export$1108315bd91bf04b = (0, $7OqB4.withThrowOnError)((0, $gZbSF.useProjectConnectItems));
const $1a488ccf5b270c95$export$3da22ae99edc5982 = (0, $7OqB4.withThrowOnError)((0, $hWtQt.useProjectReportsConnectItems));
const $1a488ccf5b270c95$export$1f8e4b2910733f3 = (0, $7OqB4.withThrowOnError)((0, $jfqNX.useProjectSettingsConnectItems)); /**
                                                                                                      * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4/jsm-project-menu
                                                                                                      */ 
const $1a488ccf5b270c95$export$8cf5db42749c99bc = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [forgeQueueParentStack] = (0, $5uXOq.useState)(()=>[
            (0, $lNhbS.SECTION_ID).QUEUES
        ]);
    const [forgeSettingsParentStack, setForgeSettingsParentStack] = (0, $5uXOq.useState)(()=>[
            (0, $lNhbS.SECTION_ID).SETTINGS
        ]);
    const { data: features } = $1a488ccf5b270c95$export$e8026ff3708f95e4();
    const { data: settingFeatures } = $1a488ccf5b270c95$export$154ecbb867fd48f0();
    const { data: project } = $1a488ccf5b270c95$export$a4007dc4843ca7f6();
    const [practiceList] = (0, $jF62O.usePracticeList)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: projectConnectItems, stack: connectProjectStack } = $1a488ccf5b270c95$export$1108315bd91bf04b();
    const { data: connectReportsItems, stack: connectReportsStack } = $1a488ccf5b270c95$export$3da22ae99edc5982();
    const { data: connectSettingsItems, stack: connectSettingsStack } = $1a488ccf5b270c95$export$1f8e4b2910733f3();
    const { stack: forgeProjectStack } = (0, $231OU.useProjectForgeApps)('forge-spa-project');
    const { stack: forgeProjectServicedeskStack } = (0, $231OU.useProjectForgeApps)('forge-spa-project-servicedesk');
    const { data: forgeSettingsItems, stack: forgeProjectSettingsStack } = (0, $6hMYg.useProjectSettingsForgeAppsForMenu)('project-settings-servicedesk-forge-apps', forgeSettingsParentStack);
    const { stack: forgeQueueStack } = (0, $iIGGa.useServiceDeskQueueForgeApps)('forge-spa-servicedesk-queue', forgeQueueParentStack);
    const ecosystemItems = (0, $5uXOq.useMemo)(()=>({
            forge: forgeSettingsItems,
            connect: connectSettingsItems
        }), [
        connectSettingsItems,
        forgeSettingsItems
    ]);
    const { enabled: isLegacyAutomationEnabled } = (0, $Uj4ce.useNavigationAutomationLegacyEnabledResource)().data || {};
    const [stack, setStack] = (0, $2TRg1.useNestingStack)({
        connectStack: connectProjectStack || connectReportsStack || connectSettingsStack,
        forgeStack: forgeProjectStack || forgeProjectServicedeskStack || forgeProjectSettingsStack || forgeQueueStack,
        knowledgeType: features && features.knowledge.type,
        isLegacyAutomationEnabled: !!isLegacyAutomationEnabled,
        isTeamManagedProject: project?.isSimplified ?? false
    });
    const { data: projectContext } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    const { shouldUseJSM: shouldUseJSM, loading: isOgTenantInfoLoading, error: ogTenantInfoError } = (0, $8J6rn.useOgTenantInfo)();
    const [isLoading, isGettingStatedPageEnabled] = (0, $htI2Q.useIsGettingStartedPageEnabled)();
    const { isInviteTeamSpotlightEnabled: isInviteTeamSpotlightEnabled, loadInviteTeamResource: loadInviteTeamResource, onInviteTeamOnboardingCTAClick: onInviteTeamOnboardingCTAClick } = (0, $9QGIi.useShouldRenderInviteTeamPromptSpotlight)();
    (0, $5uXOq.useEffect)(()=>{
        project?.isSimplified ? // @ts-expect-error - TS2322 - Type '"apps"' is not assignable to type '"settings"'.
        setForgeSettingsParentStack([
            (0, $lNhbS.SECTION_ID).SETTINGS,
            'apps'
        ]) : setForgeSettingsParentStack([
            (0, $lNhbS.SECTION_ID).SETTINGS
        ]);
    }, [
        project?.isSimplified
    ]);
    const feedbackButtonRef = (0, $5uXOq.useRef)(null);
    const onSubmitFeedbackClick = (0, $5uXOq.useCallback)(()=>{
        const additionalFields = [
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            feedbackGroupId: (0, $lNhbS.FEEDBACK_GROUP_ID),
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackContext: additionalFields,
            additionalFields: additionalFields,
            triggerRef: feedbackButtonRef
        });
    }, [
        openFeedbackCollector,
        cloudId
    ]);
    const viewsFeature = (0, $hadw2.useViewsFeature)({
        features: features
    });
    const archivedProjectItems = (0, $5uXOq.useMemo)(()=>{
        if (features?.hasArchivedIssues !== true) return null;
        const archivedIssuesUrl = `/jira/servicedesk/projects/${project.key}/issues/archive`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'archives'
            },
            href: archivedIssuesUrl,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7aY9g))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                appearance: "new"
            }, formatMessage((0, $a88Sz.messages).newLozenge)),
            selectedOn: [
                'archived-issues-directory'
            ],
            testId: "navigation-apps-sidebar-servicedesk.ui.menu-practices.archives-link"
        }, formatMessage((0, $a88Sz.messages).itemArchives)));
    }, [
        features?.hasArchivedIssues,
        project.key,
        formatMessage
    ]);
    if (features == null || project == null || practiceList == null || projectConnectItems == null || isOgTenantInfoLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const urlPath = `/jira/servicedesk/projects/${project.key}`;
    const classicSettingsUrl = `/jira/servicedesk/projects/${project.key}/settings/details`;
    const shouldShowServices = Boolean(settingFeatures?.hasServices);
    const shouldShowOpsGenieAlert = !!features?.opsgenieAlert.enabled && !!features.opsgenieAlert.url;
    const shouldShowOpsGenieOnCall = !!features?.opsgenieOnCall.enabled && !!features.opsgenieOnCall.url;
    const isJSMAlertOnCallEnabled = shouldUseJSM && !ogTenantInfoError;
    const isCustomerSupportManagementEnabled = Boolean(settingFeatures?.hasCustomerSupportManagement);
    const isDeveloperEscalationsEnabled = Boolean(settingFeatures?.hasDeveloperEscalation);
    const isProductsAndEntitlementsEnabled = Boolean(settingFeatures?.hasProductsAndEntitlements);
    const hasNotificationLogs = (0, $4R6GH.fg)('jcs_master_flag') ? !!features.hasNotificationLogs : true;
    const BackMenuItem = {
        href: urlPath,
        // @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
        onClick: (ev)=>ev.preventDefault(),
        title: formatMessage((0, $a88Sz.messages).backToProject)
    };
    const knowledgeInsightsTitle = // Returns true if any Knowledge & Insights elements exist.
    practiceList.includes((0, $oCMSG.CHANGES)) || (0, $3SzZi.shouldRenderNesting)(features.knowledge.enabled && !!features.knowledge.type, // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    stack, 'knowledge') || // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    (0, $3SzZi.shouldRenderNesting)(features.hasReports, stack, (0, $lNhbS.SECTION_ID).REPORTS) ? formatMessage((0, $a88Sz.messages).knowledgeInsights) : undefined;
    const changeCalendar = practiceList.includes((0, $oCMSG.CHANGES)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $16J3A.HOME_ITEMS_IDS).CHANGE_CALENDAR_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'changeCalendar'
        },
        href: `${urlPath}/change-calendar`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $a88Sz.messages).changeCalendar))); /* NOTE: This SpotlightTarget can be used throughout Jira not just within
                       * the current package. They're often used for onboarding or changeboarding
                       * experiences and allow an Atlaskit spotlight to be attached to page elements.
                       * If you need to change this, make sure you check where the target ID is being used
                       * and contact the relevant team as necessary. This Sourcegraph link should help :)
                       * http://go/src/SERVICES_SPOTLIGHT|services-spotlight
                       */ 
    const services = shouldShowServices && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $16J3A.HOME_ITEMS_IDS).SERVICES_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'services'
        },
        href: `${urlPath}/services`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $2avq0.ServicesGlyph),
            label: ""
        }),
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $a88Sz.messages).services)));
    const hasOperationsSectionItems = [
        changeCalendar,
        services,
        shouldShowOpsGenieAlert,
        shouldShowOpsGenieOnCall
    ].some(Boolean);
    const feedback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'feedback'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: onSubmitFeedbackClick,
        ref: feedbackButtonRef
    }, formatMessage((0, $a88Sz.messages).feedback));
    const jsmProjectSummary = ((0, $4R6GH.fg)('jsm-project-summary-beta') ? features.hasProjectSummary : (0, $4R6GH.fg)('jsm-project-summary')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'project-summary'
        },
        href: `${urlPath}/summary`,
        iconBefore: (0, $4R6GH.fg)('jsm_project_summary_milestone_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9x5pH))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50Bjx))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-project-summary'
        ]
    }, formatMessage((0, $a88Sz.messages).itemProjectSummary)));
    const JsmViewsOnboarding = (0, $4R6GH.fg)('jsm_views_of_work_phase_1_onboarding') ? (0, $37cK0.ViewsNavItemOnboarding) : (0, $5uXOq.Fragment);
    const jsmViews = viewsFeature.isEnabled && (0, $4R6GH.fg)('jsm_views_of_work_phase_1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JsmViewsOnboarding, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'views'
        },
        href: viewsFeature.url,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ5rg))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-boards',
            'servicedesk-calendar'
        ]
    }, formatMessage((0, $a88Sz.messages).itemViews)));
    const jsmKanbanBoard = features.jsmBoard?.enabled && !(0, $4R6GH.fg)('jsm_views_of_work_phase_1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $980f7c356a507e07$export$a0a21d9967c1ebe1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'boards'
        },
        href: features.jsmBoard.url,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-boards'
        ]
    }, formatMessage((0, $a88Sz.messages).itemBoards))));
    const jsmCalendar = features.jsmCalendar?.enabled && !(0, $4R6GH.fg)('jsm_views_of_work_phase_1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'calendar'
        },
        href: features.jsmCalendar.url,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-calendar'
        ]
    }, formatMessage((0, $a88Sz.messages).itemCalendars));
    const GettingStartedPageMenuItem = !isLoading && isGettingStatedPageEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'getting-started-page'
        },
        href: `${urlPath}/getting-started`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxCqX))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-getting-started-page'
        ]
    }, formatMessage((0, $a88Sz.messages).gettingStarted));
    const developerEscalations = isDeveloperEscalationsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'developerEscalations'
        },
        href: `${urlPath}/escalations`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2ciBJ))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-customer-service-escalations'
        ]
    }, formatMessage((0, $a88Sz.messages).itemDeveloperEscalations));
    const products = isProductsAndEntitlementsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'products'
        },
        href: `${urlPath}/products`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bB6uF))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-customer-service-products'
        ]
    }, formatMessage((0, $a88Sz.messages).itemProducts));
    const NotificationLogsMenuItem = hasNotificationLogs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'notificationLogs'
        },
        href: `${urlPath}/notification-logs`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aVnO1))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'notification-logs'
        ]
    }, formatMessage((0, $a88Sz.messages).notificationLogs));
    const customersItem = features.hasCustomers && !isCustomerSupportManagementEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'customers'
        },
        href: `${urlPath}/customers`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-customers-v2'
        ]
    }, formatMessage((0, $a88Sz.messages).itemCustomers)); /* Please check for usage of this SpotlightTarget before changing
                * http://go/src/CUSTOMER_CHANNELS_SPOTLIGHT|customer-channels-spotlight
                */ 
    const customerChannelsItem = features.hasCustomerChannels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $16J3A.HOME_ITEMS_IDS).CUSTOMER_CHANNELS_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e1CQH.CustomerChannelsItem), null, formatMessage((0, $a88Sz.messages).itemCustomerChannels)));
    const inviteTeamItem = features.hasSettings && (0, $6s1PB.expValEquals)('jsm_core_invites_experiment', 'cohort', 'experiment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rtJs.InviteTeamItemNew), null, formatMessage((0, $a88Sz.messages).itemAddPeople)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccoXC.InviteTeamItem), {
        loadEntryPointResource: loadInviteTeamResource
    }, formatMessage((0, $a88Sz.messages).itemInviteAgents));
    const teamSupport = projectContext?.isProjectArchived === true ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $a88Sz.messages).directory)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("pre", null), (0, $4R6GH.fg)('jsm_customers_directory_page_for_all') ? features.hasCustomers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4eEnx.CustomerSupportManagementItems), {
        urlPath: urlPath
    }) : isCustomerSupportManagementEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4eEnx.CustomerSupportManagementItems), {
        urlPath: urlPath
    }), products, customerChannelsItem, !(0, $4R6GH.fg)('jsm_customers_directory_page_for_all') && customersItem, stack.length === 0 && isInviteTeamSpotlightEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $980f7c356a507e07$export$460011addfd3fbe1)
    }, inviteTeamItem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dtVRS.InviteUserPrompt), {
        onCTAClick: onInviteTeamOnboardingCTAClick
    })) : inviteTeamItem);
    return(// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string[] | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $lNhbS.MENU_ID_SD_ITSM),
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZEU1.default), {
        label: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2EiV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l468O.ProjectHeader), {
        description: formatMessage((0, $a88Sz.messages).headerDescriptionJsm),
        avatarUrl: project.avatarUrl,
        name: project.name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        stack: stack,
        onChange: setStack,
        isDefaultFocusControl: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $16J3A.HOME_ITEMS_IDS).ALL_ITSM_QUEUES_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, GettingStartedPageMenuItem, jsmProjectSummary, (0, $3SzZi.shouldRenderNesting)(practiceList.includes((0, $oCMSG.NO_CATEGORY)), // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    stack, (0, $lNhbS.SECTION_ID).QUEUES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'queues'
        },
        href: `${urlPath}/${(0, $dd29Z.QUEUE_ROUTES)[0, $oCMSG.NO_CATEGORY]}`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B8sk))), {
            spacing: "spacious",
            label: ""
        }),
        id: (0, $lNhbS.SECTION_ID).QUEUES,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $a88Sz.messages).itemQueuesRetranslate),
        onClick: (ev)=>ev.preventDefault(),
        "data-testid": "navigation-apps-sidebar-servicedesk.ui.menu-practices.nesting-menu-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTR6h.PracticeQueues), {
        practice: (0, $oCMSG.NO_CATEGORY),
        title: formatMessage((0, $kVZSN.default).queues)
    })), jsmViews, jsmKanbanBoard, jsmCalendar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3SzZi.shouldRenderNesting)(practiceList.includes((0, $oCMSG.SERVICE_REQUEST)), // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    stack, (0, $oCMSG.SERVICE_REQUEST)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'service-requests'
        },
        href: `${urlPath}/${(0, $dd29Z.QUEUE_ROUTES)[0, $oCMSG.SERVICE_REQUEST]}`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $2avq0.ServiceRequestsGlyph),
            label: ""
        }),
        id: (0, $oCMSG.SERVICE_REQUEST),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $kVZSN.default).serviceRequests),
        onClick: (ev)=>ev.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTR6h.PracticeQueues), {
        practice: (0, $oCMSG.SERVICE_REQUEST),
        title: formatMessage((0, $kVZSN.default).serviceRequests)
    })), (0, $3SzZi.shouldRenderNesting)(practiceList.includes((0, $oCMSG.INCIDENTS)), // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    stack, (0, $oCMSG.INCIDENTS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'incidents'
        },
        href: `${urlPath}/${(0, $dd29Z.QUEUE_ROUTES)[0, $oCMSG.INCIDENTS]}`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $2avq0.IncidentsGlyph),
            label: ""
        }),
        id: (0, $oCMSG.INCIDENTS),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $kVZSN.default).incidents),
        onClick: (ev)=>ev.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTR6h.PracticeQueues), {
        title: formatMessage((0, $kVZSN.default).incidents),
        practice: (0, $oCMSG.INCIDENTS)
    })), (0, $3SzZi.shouldRenderNesting)(practiceList.includes((0, $oCMSG.PROBLEMS)), // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    stack, (0, $oCMSG.PROBLEMS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'problems'
        },
        href: `${urlPath}/${(0, $dd29Z.QUEUE_ROUTES)[0, $oCMSG.PROBLEMS]}`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $2avq0.ProblemsGlyph),
            label: ""
        }),
        id: (0, $oCMSG.PROBLEMS),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $kVZSN.default).problems),
        onClick: (ev)=>ev.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTR6h.PracticeQueues), {
        practice: (0, $oCMSG.PROBLEMS),
        title: formatMessage((0, $kVZSN.default).problems)
    })), (0, $3SzZi.shouldRenderNesting)(practiceList.includes((0, $oCMSG.CHANGES)), // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    stack, (0, $oCMSG.CHANGES)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'changes'
        },
        href: `${urlPath}/${(0, $dd29Z.QUEUE_ROUTES)[0, $oCMSG.CHANGES]}`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $2avq0.ChangesGlyph),
            label: ""
        }),
        id: (0, $oCMSG.CHANGES),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $kVZSN.default).changes),
        onClick: (ev)=>ev.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTR6h.PracticeQueues), {
        practice: (0, $oCMSG.CHANGES),
        title: formatMessage((0, $kVZSN.default).changes)
    })), (0, $3SzZi.shouldRenderNesting)(practiceList.includes((0, $oCMSG.POST_INCIDENT_REVIEWS)), // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    stack, (0, $oCMSG.POST_INCIDENT_REVIEWS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'post-incident-reviews'
        },
        href: `${urlPath}/${(0, $dd29Z.QUEUE_ROUTES)[0, $oCMSG.POST_INCIDENT_REVIEWS]}`,
        iconBefore: // @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => JSX.Element' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $2avq0.PostIncidentReviewsGlyph),
            label: ""
        }),
        id: (0, $oCMSG.POST_INCIDENT_REVIEWS),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $kVZSN.default).postIncidentReviews),
        onClick: (ev)=>ev.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTR6h.PracticeQueues), {
        practice: (0, $oCMSG.POST_INCIDENT_REVIEWS),
        title: formatMessage((0, $kVZSN.default).postIncidentReviews)
    }))), developerEscalations)), hasOperationsSectionItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $a88Sz.messages).operations)
    }, changeCalendar, services, (shouldShowOpsGenieAlert || shouldShowOpsGenieOnCall) && /* Please check for usage of this SpotlightTarget before changing
             * http://go/src/ALERTS_AND_ON_CALL_SPOTLIGHT|alerts-and-on-call-spotlight
             */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $16J3A.HOME_ITEMS_IDS).ALERTS_AND_ON_CALL_SPOTLIGHT
    }, shouldShowOpsGenieAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'opsgenie-alert'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $dMRcK.AlertsGlyph),
            label: ""
        }),
        href: "/jira/ops/alerts?view=list&query=",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            spacing: "spacious",
            label: ""
        }),
        target: "_blank",
        ...!isJSMAlertOnCallEnabled && {
            href: features.opsgenieAlert.url
        },
        className: (0, $bwpsq.default)([
            $1a488ccf5b270c95$var$styles.menuItem
        ])
    }, formatMessage((0, $a88Sz.messages).alerts), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, formatMessage((0, $a88Sz.messages).linkOpensInNewWindow))), shouldShowOpsGenieOnCall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'opsgenie-on-call'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $aQY3O.OnCallGlyph),
            label: ""
        }),
        href: "/jira/ops/who-is-on-call",
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            spacing: "spacious",
            label: ""
        }),
        target: "_blank",
        ...!isJSMAlertOnCallEnabled && {
            href: `${urlPath}/on-call-schedule`,
            iconAfter: undefined,
            target: undefined
        },
        className: (0, $bwpsq.default)([
            $1a488ccf5b270c95$var$styles.menuItem
        ])
    }, formatMessage((0, $a88Sz.messages).onCall)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: knowledgeInsightsTitle
    }, (0, $3SzZi.shouldRenderNesting)(features.knowledge.enabled && !!features.knowledge.type, // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
    stack, 'knowledge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wBTQ.KnowledgeItem), {
        href: `${urlPath}/knowledge`,
        nestingId: "knowledge",
        overrides: {
            BackMenuItem: BackMenuItem
        },
        stack: stack,
        type: features.knowledge.type
    }), (0, $3SzZi.shouldRenderNesting)(features.hasReports, stack, (0, $lNhbS.SECTION_ID).REPORTS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'reports'
        },
        href: `${urlPath}/reports`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d1ABl))), {
            spacing: "spacious",
            label: ""
        }),
        id: (0, $lNhbS.SECTION_ID).REPORTS,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $a88Sz.messages).itemReports)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dYOHi.Reports), {
        projectKey: project.key,
        connectItems: connectReportsItems
    })), teamSupport, (0, $3SzZi.shouldRenderNesting)(features.hasPIN, stack, (0, $lNhbS.SECTION_ID).ISSUES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.IssuesContextualAnalyticsData), {
        navigatorScope: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'project-issue-navigator'
        },
        href: `/jira/servicedesk/projects/${project.key}/issues`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJosW))), {
            spacing: "spacious",
            label: ""
        }),
        id: (0, $lNhbS.SECTION_ID).ISSUES,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $a88Sz.messages).itemIssues)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsI7v.Issues), {
        projectKey: project.key,
        pinUrl: `/jira/servicedesk/projects/${project.key}/issues/?filter=`
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zgGo.ForgeProjectSection), {
        overrides: {
            BackMenuItem: BackMenuItem
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tHFY.ConnectMenu), {
        hasSeparator: true,
        items: projectConnectItems,
        showIcons: true,
        overrides: {
            BackMenuItem: BackMenuItem
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $a88Sz.messages).shortcuts)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3QTQ5.Shortcuts), {
        addItemLabel: formatMessage((0, $a88Sz.messages).addShortcutLabel),
        canAddItem: features.hasShortcutsAdd,
        canAddLinks: true,
        canAddRepositories: false,
        isSimplifiedProject: project.isSimplified,
        projectKey: project.key,
        projectId: project.id
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, (0, $3SzZi.shouldRenderNesting)(features.hasSettings, stack, (0, $lNhbS.SECTION_ID).SETTINGS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'settings'
        },
        href: classicSettingsUrl,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
            spacing: "spacious",
            label: ""
        }),
        id: (0, $lNhbS.SECTION_ID).SETTINGS,
        overrides: {
            BackMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(BackMenuItem, [
                'onClick'
            ])
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $a88Sz.messages).projectSettingsRetranslate)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80BbW.SettingsClassic), {
        ecosystemItems: ecosystemItems,
        projectId: project.id,
        projectKey: project.key,
        stack: stack
    })), NotificationLogsMenuItem, feedback)), (0, $4R6GH.fg)('ken_2264_archive_menu_itsm_project') ? archivedProjectItems : null))));
};

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("2ciBJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::892203c72b828429279b82b0b7182ba7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $199b22d6246a3269$var$_react = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $199b22d6246a3269$var$_angleBrackets = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("jSlaY")));

var $199b22d6246a3269$var$_code = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("c2JK5")));
function $199b22d6246a3269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "CodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $199b22d6246a3269$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $199b22d6246a3269$var$_react.default.createElement($199b22d6246a3269$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $199b22d6246a3269$var$_code.default
    }, props));
$199b22d6246a3269$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $199b22d6246a3269$var$_default = module.exports.default = $199b22d6246a3269$var$AngleBracketsIcon;

});
parcelRegister("jSlaY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7837c8d7e1becd0$var$_react = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e7837c8d7e1becd0$var$_baseNew = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e7837c8d7e1becd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7837c8d7e1becd0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $e7837c8d7e1becd0$var$_react.default.createElement($e7837c8d7e1becd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$e7837c8d7e1becd0$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $e7837c8d7e1becd0$var$_default = module.exports.default = $e7837c8d7e1becd0$var$AngleBracketsIcon;

});

parcelRegister("c2JK5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c49276b1d591265$var$_react = $8c49276b1d591265$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8c49276b1d591265$var$_angleBrackets = $8c49276b1d591265$var$_interopRequireDefault((parcelRequire("jSlaY")));
function $8c49276b1d591265$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8c49276b1d591265$var$CodeIcon = (props)=>/*#__PURE__*/ $8c49276b1d591265$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
    }, props, {
        newIcon: $8c49276b1d591265$var$_angleBrackets.default
    }));
$8c49276b1d591265$var$CodeIcon.displayName = 'CodeIcon';
var $8c49276b1d591265$var$_default = module.exports.default = $8c49276b1d591265$var$CodeIcon;

});


parcelRegister("hxCqX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4278cede1b75ce1f6bae493dae404a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc5354e02d431713$var$_react = $cc5354e02d431713$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cc5354e02d431713$var$_compass = $cc5354e02d431713$var$_interopRequireDefault((parcelRequire("7ftyG")));

var $cc5354e02d431713$var$_discover = $cc5354e02d431713$var$_interopRequireDefault((parcelRequire("hyEaJ")));
function $cc5354e02d431713$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CompassIcon.
 * This component is CompassIcon, with `UNSAFE_fallbackIcon` set to "DiscoverIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc5354e02d431713$var$CompassIcon = (props)=>/*#__PURE__*/ $cc5354e02d431713$var$_react.default.createElement($cc5354e02d431713$var$_compass.default, Object.assign({
        LEGACY_fallbackIcon: $cc5354e02d431713$var$_discover.default
    }, props));
$cc5354e02d431713$var$CompassIcon.Name = 'CompassIconMigration';
var $cc5354e02d431713$var$_default = module.exports.default = $cc5354e02d431713$var$CompassIcon;

});
parcelRegister("7ftyG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::149b2cd6a95881a63bc7d331a2f52240>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5470dcd3a4786f26$var$_react = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5470dcd3a4786f26$var$_baseNew = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5470dcd3a4786f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5470dcd3a4786f26$var$CompassIcon = (props)=>/*#__PURE__*/ $5470dcd3a4786f26$var$_react.default.createElement($5470dcd3a4786f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m11.78-3.78a.75.75 0 0 1 .155.834l-2 4.5a.75.75 0 0 1-.38.381l-4.5 2a.75.75 0 0 1-.99-.99l2-4.5a.75.75 0 0 1 .38-.38l4.5-2a.75.75 0 0 1 .835.154M6.992 8.051l.955.956-1.72.764zm2.016-.105-.956-.955 1.72-.765z" clip-rule="evenodd"/>`
    }, props));
$5470dcd3a4786f26$var$CompassIcon.displayName = 'CompassIcon';
var $5470dcd3a4786f26$var$_default = module.exports.default = $5470dcd3a4786f26$var$CompassIcon;

});

parcelRegister("hyEaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc84c60139a91f28$var$_react = $cc84c60139a91f28$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc84c60139a91f28$var$_compass = $cc84c60139a91f28$var$_interopRequireDefault((parcelRequire("7ftyG")));
function $cc84c60139a91f28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc84c60139a91f28$var$DiscoverIcon = (props)=>/*#__PURE__*/ $cc84c60139a91f28$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18"/><path d="m10.86 10.186 3.896-1.948c1.11-.555 1.562-.108 1.005 1.006l-1.948 3.896c-.126.251-.426.55-.673.673l-3.897 1.948c-1.11.556-1.561.11-1.004-1.006l1.947-3.896c.126-.25.426-.55.673-.673M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></g></svg>`
    }, props, {
        newIcon: $cc84c60139a91f28$var$_compass.default
    }));
$cc84c60139a91f28$var$DiscoverIcon.displayName = 'DiscoverIcon';
var $cc84c60139a91f28$var$_default = module.exports.default = $cc84c60139a91f28$var$DiscoverIcon;

});


parcelRegister("aVnO1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));

var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f41b19bed4136e0$var$EmailIcon = (props)=>/*#__PURE__*/ $7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
    }, props));
$7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;

});
parcelRegister("eRB05", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ad22b76beceec928$var$_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ad22b76beceec928$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad22b76beceec928$var$EmailIcon = (props)=>/*#__PURE__*/ $ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;

});

parcelRegister("5bEkJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c6d443366bf8cbb$var$EmailIcon = (props)=>/*#__PURE__*/ $3c6d443366bf8cbb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $3c6d443366bf8cbb$var$_email.default
    }));
$3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;

});


parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("d1ABl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11aab62d49f71f052487ab6cf09d42c7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97b7c29ceb1a6bc1$var$_react = $97b7c29ceb1a6bc1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97b7c29ceb1a6bc1$var$_chartBar = $97b7c29ceb1a6bc1$var$_interopRequireDefault((parcelRequire("fDskX")));

var $97b7c29ceb1a6bc1$var$_graphBar = $97b7c29ceb1a6bc1$var$_interopRequireDefault((parcelRequire("iLAWO")));
function $97b7c29ceb1a6bc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartBarIcon.
 * This component is ChartBarIcon, with `UNSAFE_fallbackIcon` set to "GraphBarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97b7c29ceb1a6bc1$var$ChartBarIcon = (props)=>/*#__PURE__*/ $97b7c29ceb1a6bc1$var$_react.default.createElement($97b7c29ceb1a6bc1$var$_chartBar.default, Object.assign({
        LEGACY_fallbackIcon: $97b7c29ceb1a6bc1$var$_graphBar.default
    }, props));
$97b7c29ceb1a6bc1$var$ChartBarIcon.Name = 'ChartBarIconMigration';
var $97b7c29ceb1a6bc1$var$_default = module.exports.default = $97b7c29ceb1a6bc1$var$ChartBarIcon;

});
parcelRegister("fDskX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b6207aa8debd29f4$var$_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>/*#__PURE__*/ $b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;

});

parcelRegister("iLAWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da9946d1fc4faefc$var$_react = $da9946d1fc4faefc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $da9946d1fc4faefc$var$_chartBar = $da9946d1fc4faefc$var$_interopRequireDefault((parcelRequire("fDskX")));
function $da9946d1fc4faefc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $da9946d1fc4faefc$var$GraphBarIcon = (props)=>/*#__PURE__*/ $da9946d1fc4faefc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="4" height="11" x="17" y="5" rx="2"/><rect width="4" height="8" x="11" y="8" rx="2"/><rect width="4" height="5" x="5" y="11" rx="2"/><path fill-rule="nonzero" d="M21 17H4.995C4.448 17 4 16.548 4 15.991V6a1 1 0 1 0-2 0v9.991A3.004 3.004 0 0 0 4.995 19H21a1 1 0 0 0 0-2"/></g></svg>`
    }, props, {
        newIcon: $da9946d1fc4faefc$var$_chartBar.default
    }));
$da9946d1fc4faefc$var$GraphBarIcon.displayName = 'GraphBarIcon';
var $da9946d1fc4faefc$var$_default = module.exports.default = $da9946d1fc4faefc$var$GraphBarIcon;

});


parcelRegister("bB6uF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f496fbd618fe5795b7e6b61ffefa90fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87182fe6ca83cdb6$var$_react = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87182fe6ca83cdb6$var$_tag = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("eKl4L")));

var $87182fe6ca83cdb6$var$_label = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("cL0IW")));
function $87182fe6ca83cdb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TagIcon.
 * This component is TagIcon, with `UNSAFE_fallbackIcon` set to "LabelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87182fe6ca83cdb6$var$TagIcon = (props)=>/*#__PURE__*/ $87182fe6ca83cdb6$var$_react.default.createElement($87182fe6ca83cdb6$var$_tag.default, Object.assign({
        LEGACY_fallbackIcon: $87182fe6ca83cdb6$var$_label.default
    }, props));
$87182fe6ca83cdb6$var$TagIcon.Name = 'TagIconMigration';
var $87182fe6ca83cdb6$var$_default = module.exports.default = $87182fe6ca83cdb6$var$TagIcon;

});
parcelRegister("eKl4L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d3d269e42a209b60a9080b233bea35f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abc5b5ca44dcd9b7$var$_react = $abc5b5ca44dcd9b7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $abc5b5ca44dcd9b7$var$_baseNew = $abc5b5ca44dcd9b7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $abc5b5ca44dcd9b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $abc5b5ca44dcd9b7$var$TagIcon = (props)=>/*#__PURE__*/ $abc5b5ca44dcd9b7$var$_react.default.createElement($abc5b5ca44dcd9b7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.354 1.586A2 2 0 0 1 8.768 1H13a2 2 0 0 1 2 2v4.232a2 2 0 0 1-.586 1.414l-5.75 5.75a2 2 0 0 1-2.828 0l-4.232-4.232a2 2 0 0 1 0-2.828zm1.414.914a.5.5 0 0 0-.354.146l-5.75 5.75a.5.5 0 0 0 0 .708l4.232 4.232a.5.5 0 0 0 .708 0l5.75-5.75a.5.5 0 0 0 .146-.354V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M10 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/>`
    }, props));
$abc5b5ca44dcd9b7$var$TagIcon.displayName = 'TagIcon';
var $abc5b5ca44dcd9b7$var$_default = module.exports.default = $abc5b5ca44dcd9b7$var$TagIcon;

});

parcelRegister("cL0IW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $949a6f91366cfd9f$var$_react = $949a6f91366cfd9f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $949a6f91366cfd9f$var$_tag = $949a6f91366cfd9f$var$_interopRequireDefault((parcelRequire("eKl4L")));
function $949a6f91366cfd9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $949a6f91366cfd9f$var$LabelIcon = (props)=>/*#__PURE__*/ $949a6f91366cfd9f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
    }, props, {
        newIcon: $949a6f91366cfd9f$var$_tag.default
    }));
$949a6f91366cfd9f$var$LabelIcon.displayName = 'LabelIcon';
var $949a6f91366cfd9f$var$_default = module.exports.default = $949a6f91366cfd9f$var$LabelIcon;

});


parcelRegister("6B8sk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82b9f55a530bbe318018956e9ca6b2dc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cdcc1ee30f05f4e$var$_react = $4cdcc1ee30f05f4e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4cdcc1ee30f05f4e$var$_pages = $4cdcc1ee30f05f4e$var$_interopRequireDefault((parcelRequire("6a9Wp")));

var $4cdcc1ee30f05f4e$var$_queues = $4cdcc1ee30f05f4e$var$_interopRequireDefault((parcelRequire("6jKfv")));
function $4cdcc1ee30f05f4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PagesIcon.
 * This component is PagesIcon, with `UNSAFE_fallbackIcon` set to "QueuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cdcc1ee30f05f4e$var$PagesIcon = (props)=>/*#__PURE__*/ $4cdcc1ee30f05f4e$var$_react.default.createElement($4cdcc1ee30f05f4e$var$_pages.default, Object.assign({
        LEGACY_fallbackIcon: $4cdcc1ee30f05f4e$var$_queues.default
    }, props));
$4cdcc1ee30f05f4e$var$PagesIcon.Name = 'PagesIconMigration';
var $4cdcc1ee30f05f4e$var$_default = module.exports.default = $4cdcc1ee30f05f4e$var$PagesIcon;

});
parcelRegister("6a9Wp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47cb635ccdf7d850$var$_react = $47cb635ccdf7d850$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $47cb635ccdf7d850$var$_baseNew = $47cb635ccdf7d850$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $47cb635ccdf7d850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47cb635ccdf7d850$var$PagesIcon = (props)=>/*#__PURE__*/ $47cb635ccdf7d850$var$_react.default.createElement($47cb635ccdf7d850$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$47cb635ccdf7d850$var$PagesIcon.displayName = 'PagesIcon';
var $47cb635ccdf7d850$var$_default = module.exports.default = $47cb635ccdf7d850$var$PagesIcon;

});

parcelRegister("6jKfv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $499864867b6a89d7$var$_react = $499864867b6a89d7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $499864867b6a89d7$var$_pages = $499864867b6a89d7$var$_interopRequireDefault((parcelRequire("6a9Wp")));
function $499864867b6a89d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $499864867b6a89d7$var$QueuesIcon = (props)=>/*#__PURE__*/ $499864867b6a89d7$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M19 5h.006C20.107 5 21 5.895 21 6.994v12.012A1.995 1.995 0 0 1 19.006 21H6.994A1.995 1.995 0 0 1 5 19.006V19h13c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5zm1 3c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 8m0 3c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 11"/></svg>`
    }, props, {
        newIcon: $499864867b6a89d7$var$_pages.default
    }));
$499864867b6a89d7$var$QueuesIcon.displayName = 'QueuesIcon';
var $499864867b6a89d7$var$_default = module.exports.default = $499864867b6a89d7$var$QueuesIcon;

});


parcelRegister("7aY9g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::542b8587e912458cb1fe6aa28ca83d10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53981fc6c9b6b165$var$_react = $53981fc6c9b6b165$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $53981fc6c9b6b165$var$_archiveBox = $53981fc6c9b6b165$var$_interopRequireDefault((parcelRequire("41CZr")));

var $53981fc6c9b6b165$var$_archive = $53981fc6c9b6b165$var$_interopRequireDefault((parcelRequire("jFmxZ")));
function $53981fc6c9b6b165$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArchiveBoxIcon.
 * This component is ArchiveBoxIcon, with `UNSAFE_fallbackIcon` set to "ArchiveIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53981fc6c9b6b165$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $53981fc6c9b6b165$var$_react.default.createElement($53981fc6c9b6b165$var$_archiveBox.default, Object.assign({
        LEGACY_fallbackIcon: $53981fc6c9b6b165$var$_archive.default
    }, props));
$53981fc6c9b6b165$var$ArchiveBoxIcon.Name = 'ArchiveBoxIconMigration';
var $53981fc6c9b6b165$var$_default = module.exports.default = $53981fc6c9b6b165$var$ArchiveBoxIcon;

});
parcelRegister("41CZr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ee5800a86362bd2$var$_react = $2ee5800a86362bd2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ee5800a86362bd2$var$_baseNew = $2ee5800a86362bd2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ee5800a86362bd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ee5800a86362bd2$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $2ee5800a86362bd2$var$_react.default.createElement($2ee5800a86362bd2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$2ee5800a86362bd2$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $2ee5800a86362bd2$var$_default = module.exports.default = $2ee5800a86362bd2$var$ArchiveBoxIcon;

});

parcelRegister("jFmxZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e513560ae499789a$var$_react = $e513560ae499789a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e513560ae499789a$var$_archiveBox = $e513560ae499789a$var$_interopRequireDefault((parcelRequire("41CZr")));
function $e513560ae499789a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e513560ae499789a$var$ArchiveIcon = (props)=>/*#__PURE__*/ $e513560ae499789a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 3H4.85A2 2 0 0 0 3 5v4h1v10.45A1.67 1.67 0 0 0 5.77 21h12.46A1.67 1.67 0 0 0 20 19.45V9h1V5a2 2 0 0 0-2-2m-1 16H6V9h12zm1-12H5V5h14zm-4 7H9v-2h6z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $e513560ae499789a$var$_archiveBox.default
    }));
$e513560ae499789a$var$ArchiveIcon.displayName = 'ArchiveIcon';
var $e513560ae499789a$var$_default = module.exports.default = $e513560ae499789a$var$ArchiveIcon;

});


parcelRegister("g2EiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d4c6f37fa43791$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $f8d4c6f37fa43791$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $f8d4c6f37fa43791$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $f8d4c6f37fa43791$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $f8d4c6f37fa43791$export$2e2bcd8739ae039 = $f8d4c6f37fa43791$var$NavigationHeader;

});

parcelRegister("9btdk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $1598986e4d07c239$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $1598986e4d07c239$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");

var $VSDnB = parcelRequire("VSDnB");

var $6XySk = parcelRequire("6XySk");

var $8UO8z = parcelRequire("8UO8z");

var $9zCCP = parcelRequire("9zCCP");

var $j9VTE = parcelRequire("j9VTE");

var $cfT4M = parcelRequire("cfT4M");
const $1598986e4d07c239$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $1598986e4d07c239$var$nestableNavigationContentStyles = null;
const $1598986e4d07c239$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $1598986e4d07c239$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $1598986e4d07c239$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6XySk.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $9zCCP.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $1598986e4d07c239$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cfT4M.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j9VTE.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UO8z.default), {
                                    title: "",
                                    id: $1598986e4d07c239$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $1598986e4d07c239$export$2e2bcd8739ae039 = $1598986e4d07c239$var$NestableNavigationContent;

});
parcelRegister("6XySk", function(module, exports) {

$parcel$export(module.exports, "default", () => $acf862f964b3fe45$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $d2gYe = parcelRequire("d2gYe");


var $ayWDM = parcelRequire("ayWDM");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $acf862f964b3fe45$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $acf862f964b3fe45$export$2e2bcd8739ae039 = $acf862f964b3fe45$var$GoBackItem;

});
parcelRegister("d2gYe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97d8a03a9ac2bd8e$var$_react = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97d8a03a9ac2bd8e$var$_arrowLeft = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("ctqwA")));

var $97d8a03a9ac2bd8e$var$_arrowLeftCircle = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("g9uZe")));
function $97d8a03a9ac2bd8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97d8a03a9ac2bd8e$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $97d8a03a9ac2bd8e$var$_react.default.createElement($97d8a03a9ac2bd8e$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $97d8a03a9ac2bd8e$var$_arrowLeftCircle.default
    }, props));
$97d8a03a9ac2bd8e$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $97d8a03a9ac2bd8e$var$_default = module.exports.default = $97d8a03a9ac2bd8e$var$ArrowLeftIcon;

});
parcelRegister("ctqwA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $914cc4b222e651e0$var$_react = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $914cc4b222e651e0$var$_baseNew = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $914cc4b222e651e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $914cc4b222e651e0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $914cc4b222e651e0$var$_react.default.createElement($914cc4b222e651e0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$914cc4b222e651e0$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $914cc4b222e651e0$var$_default = module.exports.default = $914cc4b222e651e0$var$ArrowLeftIcon;

});

parcelRegister("g9uZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $bc2585eb44f99538$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $bc2585eb44f99538$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $bc2585eb44f99538$var$_arrowLeft.default
    }));
$bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;

});


var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("ayWDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $860cc941614c9e62$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $jsTfk = parcelRequire("jsTfk");

var $j9VTE = parcelRequire("j9VTE");
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $860cc941614c9e62$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jsTfk.overrideStyleFunction)((0, $jsTfk.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $860cc941614c9e62$export$2e2bcd8739ae039 = $860cc941614c9e62$var$ButtonItem;

});


parcelRegister("8UO8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0599b2a9b08db47e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bh9nY = parcelRequire("bh9nY");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $jsTfk = parcelRequire("jsTfk");

var $ayWDM = parcelRequire("ayWDM");
var $jSfqD = parcelRequire("jSfqD");
var $kzjuk = parcelRequire("kzjuk");

var $9btdk = parcelRequire("9btdk");

var $j9VTE = parcelRequire("j9VTE");

var $9zCCP = parcelRequire("9zCCP");

var $5n9uX = parcelRequire("5n9uX");
const $0599b2a9b08db47e$var$styles = {
    iconContainer: "_1e0c1nu9"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $0599b2a9b08db47e$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $j9VTE.useNestedContext)();
    const mergedStyles = (0, $jsTfk.overrideStyleFunction)((0, $5n9uX.nestingItemStyle), cssFn);
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $9zCCP.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j9VTE.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kzjuk.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $9btdk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "data-right-arrow": true,
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh9nY))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title,
        cssFn: mergedStyles
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        ref: activeParentRef,
        ...componentProps
    });
};
var $0599b2a9b08db47e$export$2e2bcd8739ae039 = $0599b2a9b08db47e$var$NestingItem;

});
parcelRegister("bh9nY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $835890081946c47e$var$_react = $835890081946c47e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $835890081946c47e$var$_arrowRight = $835890081946c47e$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $835890081946c47e$var$_arrowRightCircle = $835890081946c47e$var$_interopRequireDefault((parcelRequire("1zw66")));
function $835890081946c47e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $835890081946c47e$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $835890081946c47e$var$_react.default.createElement($835890081946c47e$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $835890081946c47e$var$_arrowRightCircle.default
    }, props));
$835890081946c47e$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $835890081946c47e$var$_default = module.exports.default = $835890081946c47e$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("1zw66", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1251f532550be707$var$_react = $1251f532550be707$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1251f532550be707$var$_arrowRight = $1251f532550be707$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $1251f532550be707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1251f532550be707$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $1251f532550be707$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $1251f532550be707$var$_arrowRight.default
    }));
$1251f532550be707$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $1251f532550be707$var$_default = module.exports.default = $1251f532550be707$var$ArrowRightCircleIcon;

});


parcelRegister("jSfqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e63733262ea805c$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-overrides */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1aogK = parcelRequire("1aogK");

var $jsTfk = parcelRequire("jsTfk");

var $j9VTE = parcelRequire("j9VTE");
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $0e63733262ea805c$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jsTfk.overrideStyleFunction)((0, $jsTfk.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;

});

parcelRegister("kzjuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf97ddffeccb81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cw1vL = parcelRequire("cw1vL");

var $j9VTE = parcelRequire("j9VTE");
const $dfdf97ddffeccb81$var$outerContainerCSS = null;
const $dfdf97ddffeccb81$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $dfdf97ddffeccb81$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $dfdf97ddffeccb81$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    const scrollbar = (0, $cw1vL.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $dfdf97ddffeccb81$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $dfdf97ddffeccb81$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $dfdf97ddffeccb81$var$containerCSS.basic,
                    showTopScrollIndicator && $dfdf97ddffeccb81$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;

});
parcelRegister("cw1vL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03f8a420074f68d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a03f8a420074f68d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("9zCCP", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $edc749a9b64f215e$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $edc749a9b64f215e$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
const $edc749a9b64f215e$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $9btdk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $edc749a9b64f215e$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});

parcelRegister("5n9uX", function(module, exports) {

$parcel$export(module.exports, "nestingItemStyle", () => $1433420fe651ac2a$export$38e770f85519b259);
const $1433420fe651ac2a$export$4c36b5b1b67ee1e8 = {
    ['&:hover [data-custom-icon]']: {
        display: 'none'
    },
    ['&:active [data-custom-icon]']: {
        display: 'none'
    },
    ['&:focus [data-custom-icon]']: {
        display: 'none'
    },
    ['& [data-custom-icon]']: {
        display: 'inherit'
    },
    ['&:hover [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:active [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:focus [data-right-arrow]']: {
        display: 'inherit'
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $1433420fe651ac2a$var$disabledCSS = {
    ['[data-item-elem-after]']: {
        opacity: 0
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $1433420fe651ac2a$export$38e770f85519b259 = (state)=>{
    return {
        ...state.isDisabled ? $1433420fe651ac2a$var$disabledCSS : $1433420fe651ac2a$export$4c36b5b1b67ee1e8
    };
};

});


parcelRegister("cfT4M", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $0051a7791f96d83a$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Sbj3 = parcelRequire("8Sbj3");
const $0051a7791f96d83a$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("gZEU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2dd47d2fa741f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7LBE = parcelRequire("j7LBE");
const $eb2dd47d2fa741f7$var$sidebarMinWidth = '240px';
const $eb2dd47d2fa741f7$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $eb2dd47d2fa741f7$var$SideNavigation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $eb2dd47d2fa741f7$export$2e2bcd8739ae039 = $eb2dd47d2fa741f7$var$SideNavigation;

});

parcelRegister("dqoiX", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $11827e0613b04108$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $11827e0613b04108$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $11827e0613b04108$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $11827e0613b04108$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $11827e0613b04108$export$88fad6aa294f111c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _kqswstnw",
            __cmplp.className
        ])
    });
});
const $11827e0613b04108$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _kqswstnw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8J6rn", function(module, exports) {

$parcel$export(module.exports, "useOgTenantInfo", () => $31f27587daf0b28f$export$990ea9ff15ca04f7);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $daoB1 = parcelRequire("daoB1");

var $2YP9W = parcelRequire("2YP9W");

var $3H5ry = parcelRequire("3H5ry");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $31f27587daf0b28f$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    // It is important that this ff should stop any new behaviour except for
    // safe hook calls. That's why we only do very minimal stuff here.
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh
    ]);
};
const $31f27587daf0b28f$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $2YP9W.useResource)((0, $bHhiy.getConsolidationStateResource)());
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    $31f27587daf0b28f$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    if (// TODO: Remove this check after the feature flag is removed
    // The refresh is handled in useConsolidationStateResourceRefresh
    // and this one is only for the old behaviour.
    !(0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $3H5ry.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $3H5ry.checkIsConsolidated)(tenantInfoResource.data),
        isOpsAdmin: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') && (0, $3H5ry.checkIsOpsAdmin)(tenantInfoResource.data),
        isTransitioning: (0, $3H5ry.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $3H5ry.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});
parcelRegister("daoB1", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $77add4b5420e5058$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $77add4b5420e5058$export$4d9cadb4042acc1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $51nlc = parcelRequire("51nlc");

var $2gywT = parcelRequire("2gywT");

var $9OXo1 = parcelRequire("9OXo1");
const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $51nlc.createSubscriber)((0, $2gywT.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $77add4b5420e5058$var$selector
});
const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});


parcelRegister("3QTQ5", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $8ff29ea69a98d034$export$b326d77e4b8b7664);

var $5uXOq = parcelRequire("5uXOq");

var $7O7lB = parcelRequire("7O7lB");

var $4Rw2J = parcelRequire("4Rw2J");

var $eWXbg = parcelRequire("eWXbg");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $aWq5G = parcelRequire("aWq5G");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $7UhxN = parcelRequire("7UhxN");

var $k1ALc = parcelRequire("k1ALc");

var $1vBwL = parcelRequire("1vBwL");

var $2RBG9 = parcelRequire("2RBG9");

var $7E0T0 = parcelRequire("7E0T0");

var $kfztd = parcelRequire("kfztd");

var $itmJb = parcelRequire("itmJb");

var $cNJA1 = parcelRequire("cNJA1");

var $dsZRM = parcelRequire("dsZRM");

var $7dRTN = parcelRequire("7dRTN");
const $8ff29ea69a98d034$var$ShortcutsSimplifyNavExperimentInner = ({ children: children })=>{
    const isSimplifyNavExperimentEnabled = (0, $7E0T0.useIsSimplifyNavExperimentEnabled)();
    return isSimplifyNavExperimentEnabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $8ff29ea69a98d034$var$ShortcutsSimplifyNavExperiment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraNavigationAppsSidebarCommon",
        id: "sidebar.shortcuts",
        teamName: "jlove-makkuro",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ff29ea69a98d034$var$ShortcutsSimplifyNavExperimentInner, null, children));
const $8ff29ea69a98d034$export$1e66c1282cda9ed2 = ({ addItemLabel: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
addItemLabel = null, canAddItem: canAddItem, canAddLinks: canAddLinks, canAddRepositories: canAddRepositories, children: children = null, hasPages: hasPages = false, isSimplifiedProject: isSimplifiedProject = false, pagesLink: pagesLink, projectId: projectId, onPagesTabClick: onPagesTabClick, projectKey: projectKey, isBusinessProject: isBusinessProject = false, canShowOtherShortcuts: canShowOtherShortcuts = true })=>{
    const [{ data: rawShortcuts }, actions] = (0, $k1ALc.useShortcutItems)();
    const baseUrl = '';
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const isProjectPagesEnabled = hasPages && !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)();
    const [isModalOpenViaAddView] = (0, $2RBG9.useIsModalOpenViaAddView)();
    const { setIsModalOpenViaAddView: setIsModalOpenViaAddView } = (0, $2RBG9.useSimplifyNavExperimentActions)();
    if (!rawShortcuts || !actions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    // We need this id to focus edit shortcut button after closing edit modal for repo type shortcut, which is legacy
    const EDIT_SHORTCUT_BUTTON_ID_PREFIX = 'navigation-apps-sidebar.shortcuts.edit-shortcut-button-';
    const shortcuts = rawShortcuts.map((s)=>({
            ...s,
            editButtonId: EDIT_SHORTCUT_BUTTON_ID_PREFIX + s.id
        }));
    const urlForSoftwareProjects = isSimplifiedProject ? `/jira/software/projects/${projectKey}/pages` : `/jira/software/c/projects/${projectKey}/pages`;
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const Icon = isBusinessProject ? (0, (/*@__PURE__*/$parcel$interopDefault($4Rw2J))) : (0, (/*@__PURE__*/$parcel$interopDefault($eWXbg)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vBwL.default), {
        // Shortcuts app from nav-next expect the navItemType to be NavigationItem, which is deprecated
        // @ts-expect-error - TS2322 - Type 'BoundActions<State, { readonly addItem: (item: ShortcutItem) => Action<State, void, void | Promise<void>>; readonly deleteItem: (id: string) => Action<State, void, void | Promise<...>>; readonly editItem: (item: ShortcutItem) => Action<...>; readonly editItems: (items: ShortcutItem[]) => Action<...>; readonly update...' is not assignable to type '{ addItem: (arg1: NavigationItem) => any; deleteItem: (arg1: string) => any; editItem: (arg1: NavigationItem) => any; editItems: (arg1: NavigationItem[]) => any; }'.
        methods: actions,
        // @ts-expect-error - TS2322 - Type 'ShortcutItem[]' is not assignable to type 'NavigationItem[]'.
        items: shortcuts,
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectId: projectId,
        isAdmin: isAdmin,
        showPagesSelector: !isSimplifiedProject,
        canAddLinks: canAddLinks,
        canAddRepositories: canAddRepositories,
        pagesLink: pagesLink,
        ...(0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate') && {
            isModalOpenViaAddView: isModalOpenViaAddView,
            setIsModalOpenViaAddView: setIsModalOpenViaAddView
        }
    }, ({ openAddModal: openAddModal, openEditModal: openEditModal, openManagePagesLinkModal: openManagePagesLinkModal, addItemButtonRef: addItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isProjectPagesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsZRM.PagesMenuItem), {
            analytics: {
                itemId: 'pages',
                // @ts-expect-error TS2322 | TS2322 - Type '{ itemId: string; nextgen: boolean; projectId: number; connectionState: DevOpsToolConnectionState | undefined; }' is not assignable to type 'Analytics'. | Type '{ itemId: string; nextgen: boolean; projectId: number; connectionState: DevOpsToolConnectionState | undefined; }' is not assignable to type 'Analytics'.
                nextgen: isSimplifiedProject,
                projectId: projectId
            },
            "aria-labelledby": "navigation-apps-sidebar-common.ui.shortcuts.business-pages-link",
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure, jira/integration/enforce-data-testid-usage
            "data-test-id": "navigation-apps-sidebar-common.ui.shortcuts.business-pages-link",
            href: isBusinessProject ? `/jira/core/projects/${projectKey}/pages` : urlForSoftwareProjects,
            projectId: projectId,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
                label: ""
            }),
            onClick: onPagesTabClick,
            selectedOn: [
                'project-pages'
            ],
            onEditClick: pagesLink?.canEdit ? openManagePagesLinkModal : undefined,
            pagesMenuItemTitle: isBusinessProject ? (0, $7dRTN.messages).pagesItem : undefined
        }), canShowOtherShortcuts && shortcuts.map((shortcut)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWq5G.Shortcut), {
                shortcut: shortcut,
                key: shortcut.id,
                openEditItem: openEditModal
            })), children, canAddItem && ((0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ff29ea69a98d034$var$ShortcutsSimplifyNavExperiment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'shortcuts--add'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7O7lB))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: openAddModal,
            ref: addItemButtonRef,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "navigation-apps-sidebar-common.ui.shortcuts.shortcuts-add-link"
        }, addItemLabel || formatMessage((0, $cNJA1.messages).addItem))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'shortcuts--add'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7O7lB))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: openAddModal,
            ref: addItemButtonRef,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "navigation-apps-sidebar-common.ui.shortcuts.shortcuts-add-link"
        }, addItemLabel || formatMessage((0, $cNJA1.messages).addItem)))));
};
const $8ff29ea69a98d034$export$b326d77e4b8b7664 = ({ children: children = null, ...rest })=>{
    const { data: data, loading: loading } = (0, $7UhxN.useShortcutsData)();
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1ALc.ShortcutsContainer), {
        data: data,
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ff29ea69a98d034$export$1e66c1282cda9ed2, rest, children));
};

});
parcelRegister("7O7lB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c635a2f2e69a7d56a90070d44e636799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5af2e6f3116f409b$var$_react = $5af2e6f3116f409b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5af2e6f3116f409b$var$_shortcut = $5af2e6f3116f409b$var$_interopRequireDefault((parcelRequire("ewWB1")));

var $5af2e6f3116f409b$var$_addItem = $5af2e6f3116f409b$var$_interopRequireDefault((parcelRequire("hcxOp")));
function $5af2e6f3116f409b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShortcutIcon.
 * This component is ShortcutIcon, with `UNSAFE_fallbackIcon` set to "AddItemIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5af2e6f3116f409b$var$ShortcutIcon = (props)=>/*#__PURE__*/ $5af2e6f3116f409b$var$_react.default.createElement($5af2e6f3116f409b$var$_shortcut.default, Object.assign({
        LEGACY_fallbackIcon: $5af2e6f3116f409b$var$_addItem.default
    }, props));
$5af2e6f3116f409b$var$ShortcutIcon.Name = 'ShortcutIconMigration';
var $5af2e6f3116f409b$var$_default = module.exports.default = $5af2e6f3116f409b$var$ShortcutIcon;

});
parcelRegister("ewWB1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d24329325b8e254a68f910248b6c4858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a94181d48cb18184$var$_react = $a94181d48cb18184$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a94181d48cb18184$var$_baseNew = $a94181d48cb18184$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a94181d48cb18184$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shortcut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a94181d48cb18184$var$ShortcutIcon = (props)=>/*#__PURE__*/ $a94181d48cb18184$var$_react.default.createElement($a94181d48cb18184$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.25 2.25V0h1.5v2.25H16v1.5h-2.25V6h-1.5V3.75H10v-1.5zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5H15V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$a94181d48cb18184$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $a94181d48cb18184$var$_default = module.exports.default = $a94181d48cb18184$var$ShortcutIcon;

});

parcelRegister("hcxOp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c85dc900b70593f4$var$_react = $c85dc900b70593f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c85dc900b70593f4$var$_shortcut = $c85dc900b70593f4$var$_interopRequireDefault((parcelRequire("ewWB1")));
function $c85dc900b70593f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c85dc900b70593f4$var$AddItemIcon = (props)=>/*#__PURE__*/ $c85dc900b70593f4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M16.002 3H4.995A1.995 1.995 0 0 0 3 4.995v14.01C3 20.107 3.893 21 4.995 21h14.01A1.995 1.995 0 0 0 21 19.005V7.998 11h-2v8H5V5h8V3z"/><path d="M19 5V3.99A1 1 0 0 0 18 3c-.556 0-1 .444-1 .99V5h-1a1 1 0 0 0 0 2h1v1.01A1 1 0 0 0 18 9c.556 0 1-.444 1-.99V7h1a1 1 0 0 0 0-2z"/></g></svg>`
    }, props, {
        newIcon: $c85dc900b70593f4$var$_shortcut.default
    }));
$c85dc900b70593f4$var$AddItemIcon.displayName = 'AddItemIcon';
var $c85dc900b70593f4$var$_default = module.exports.default = $c85dc900b70593f4$var$AddItemIcon;

});


parcelRegister("4Rw2J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38a4f7c4ef65cc10$var$_react = $38a4f7c4ef65cc10$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $38a4f7c4ef65cc10$var$_file = $38a4f7c4ef65cc10$var$_interopRequireDefault((parcelRequire("1NlXW")));
function $38a4f7c4ef65cc10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38a4f7c4ef65cc10$var$FileIcon = (props)=>/*#__PURE__*/ $38a4f7c4ef65cc10$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/><rect width="8" height="2" x="8" y="12" rx="1"/><rect width="4" height="2" x="8" y="15" rx="1"/></g></svg>`
    }, props, {
        newIcon: $38a4f7c4ef65cc10$var$_file.default
    }));
$38a4f7c4ef65cc10$var$FileIcon.displayName = 'FileIcon';
var $38a4f7c4ef65cc10$var$_default = module.exports.default = $38a4f7c4ef65cc10$var$FileIcon;

});
parcelRegister("1NlXW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14eb6801df53e470$var$_react = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $14eb6801df53e470$var$_baseNew = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $14eb6801df53e470$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14eb6801df53e470$var$FileIcon = (props)=>/*#__PURE__*/ $14eb6801df53e470$var$_react.default.createElement($14eb6801df53e470$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$14eb6801df53e470$var$FileIcon.displayName = 'FileIcon';
var $14eb6801df53e470$var$_default = module.exports.default = $14eb6801df53e470$var$FileIcon;

});


parcelRegister("aWse0", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $6b28e3c9e1c89fbd$export$d82607073b68786);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $koVbs.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("aWq5G", function(module, exports) {

$parcel$export(module.exports, "Shortcut", () => $a8022ab33881936a$export$59451aa6b6270879);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $aWse0 = parcelRequire("aWse0");

var $7eui6 = parcelRequire("7eui6");

var $72RJC = parcelRequire("72RJC");

var $kvHKs = parcelRequire("kvHKs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $9olct = parcelRequire("9olct");
const $a8022ab33881936a$var$styles = {
    emojiWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _p12f1tcg _c71l1tcg",
    emojiPlaceholder: "_11c8nf1z _kdam1apl",
    menuItem: "_btpd1ady _1c06idpf _g718kb7n _3u8ukb7n"
};
const $a8022ab33881936a$export$59451aa6b6270879 = ({ EditButton: EditButton = (0, $7eui6.EditButton), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), SyncButton: SyncButton = (0, $72RJC.SyncButton), openEditItem: openEditItem, shortcut: shortcut, useIntl: // @ts-expect-error - TS2339 - Property 'useIntl' does not exist on type 'ShortcutProps'.
useIntl = (0, $aWse0.useIntlV2) })=>{
    const { before: DefaultIconBefore, canEdit: canEdit, href: href, id: shortcutId, onEditClick: onEditClick, onSyncClick: onSyncClick, shortcutType: shortcutType, showSync: showSync, text: text, editButtonId: editButtonId } = shortcut;
    const { formatMessage: formatMessage } = useIntl();
    let iconBefore = DefaultIconBefore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DefaultIconBefore, null) : null;
    let shortcutText = text || '';
    if (shortcutType === (0, $kvHKs.LINK_TYPE) && shortcutText) {
        const match = shortcutText.match((0, $kvHKs.EMOJI_REGEX));
        if (match) {
            const [emoji] = match;
            const linkText = shortcutText.substr(emoji.length).trim();
            if (linkText) shortcutText = linkText;
            if (emoji) iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                className: (0, $bwpsq.default)([
                    $a8022ab33881936a$var$styles.emojiWrapper
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                className: (0, $bwpsq.default)([
                    $a8022ab33881936a$var$styles.emojiPlaceholder
                ])
            }, emoji));
        }
    }
    const iconAfter = (()=>{
        if (showSync === true && onSyncClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SyncButton, {
            id: shortcutId,
            onClick: onSyncClick,
            label: formatMessage((0, $9olct.messages).sync)
        });
        if (canEdit === true) {
            let onClick = openEditItem; // We do not edit repository shortcuts on our own, instead we allow another plugin doing it.
            // Till the moment that plugin gets initialized we won't be rendering edit icon.
            if (shortcutType === (0, $kvHKs.REPO_TYPE)) {
                if (!onEditClick) return null;
                onClick = onEditClick;
            }
            const ariaLabel = shortcutText !== '' ? formatMessage((0, $9olct.messages).editWithShortcutText, {
                shortcutText: shortcutText
            }) : formatMessage((0, $9olct.messages).edit);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditButton, {
                id: editButtonId,
                shortcutId: shortcutId,
                onClick: onClick,
                label: ariaLabel
            });
        }
        return null;
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        tag: "span",
        content: shortcutText,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: `shortcut--item-${shortcutId}`
        },
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        href: href,
        target: "_blank",
        className: (0, $bwpsq.default)([
            $a8022ab33881936a$var$styles.menuItem
        ])
    }, shortcutText));
};

});
parcelRegister("7eui6", function(module, exports) {

$parcel$export(module.exports, "EditButton", () => $3765b526fab19461$export$a8d3280cb45e38b8);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $4ChK1 = parcelRequire("4ChK1");

var $1ywCO = parcelRequire("1ywCO");
const $3765b526fab19461$export$a8d3280cb45e38b8 = ({ onClick: onClick, shortcutId: shortcutId, id: id, label: label })=>{
    const [isHover, setIsHover] = (0, $5uXOq.useState)(true);
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onButtonClick = (event)=>{
        event.preventDefault();
        onClick(shortcutId, buttonRef);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        "aria-label": label,
        spacing: "none",
        onClick: onButtonClick,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        onFocus: ()=>setIsHover(true),
        onBlur: ()=>setIsHover(false),
        id: id,
        ref: buttonRef
    }, isHover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ywCO))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: ""
    }));
};

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});


parcelRegister("1ywCO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d8183d86255e266d89dc1fd99bbc4dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $122246161208ff48$var$_react = $122246161208ff48$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $122246161208ff48$var$_edit = $122246161208ff48$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $122246161208ff48$var$_editFilled = $122246161208ff48$var$_interopRequireDefault((parcelRequire("avBcG")));
function $122246161208ff48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $122246161208ff48$var$EditIcon = (props)=>/*#__PURE__*/ $122246161208ff48$var$_react.default.createElement($122246161208ff48$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $122246161208ff48$var$_editFilled.default
    }, props));
$122246161208ff48$var$EditIcon.Name = 'EditIconMigration';
var $122246161208ff48$var$_default = module.exports.default = $122246161208ff48$var$EditIcon;

});
parcelRegister("avBcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a69a877f42e31b8$var$_react = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7a69a877f42e31b8$var$_edit = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $7a69a877f42e31b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a69a877f42e31b8$var$EditFilledIcon = (props)=>/*#__PURE__*/ $7a69a877f42e31b8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $7a69a877f42e31b8$var$_edit.default
    }));
$7a69a877f42e31b8$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $7a69a877f42e31b8$var$_default = module.exports.default = $7a69a877f42e31b8$var$EditFilledIcon;

});



parcelRegister("72RJC", function(module, exports) {

$parcel$export(module.exports, "SyncButton", () => $34948fa341d4f6ba$export$3826f2c15cf9a4f4);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $jOrGg = parcelRequire("jOrGg");
const $34948fa341d4f6ba$export$3826f2c15cf9a4f4 = ({ id: id, onClick: onClick, label: label })=>{
    const onButtonClick = (event)=>{
        event.preventDefault();
        onClick(id);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
        LEGACY_size: "small",
        label: label
    }));
};
var $34948fa341d4f6ba$export$2e2bcd8739ae039 = $34948fa341d4f6ba$export$3826f2c15cf9a4f4;

});
parcelRegister("jOrGg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b7deedaffb04632472c93b0c8f5452>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6c828a42ee64c30$var$_react = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6c828a42ee64c30$var$_refresh = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("gPelT")));

var $e6c828a42ee64c30$var$_refresh2 = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("75Jbm")));
function $e6c828a42ee64c30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6c828a42ee64c30$var$RefreshIcon = (props)=>/*#__PURE__*/ $e6c828a42ee64c30$var$_react.default.createElement($e6c828a42ee64c30$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $e6c828a42ee64c30$var$_refresh2.default
    }, props));
$e6c828a42ee64c30$var$RefreshIcon.Name = 'RefreshIconMigration';
var $e6c828a42ee64c30$var$_default = module.exports.default = $e6c828a42ee64c30$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::688997f0a16a41562042ca280fe15628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});

parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});



parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $jSfqD = parcelRequire("jSfqD");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("9olct", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8656b699d75bb3ee$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8656b699d75bb3ee$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    edit: {
        "id": "navigation-apps-shortcuts-sidebar.shortcut.edit",
        "defaultMessage": "Edit shortcut"
    },
    editWithShortcutText: {
        "id": "navigation-apps-shortcuts-sidebar.shortcut.edit-with-shortcut-text",
        "defaultMessage": "Edit shortcut for {shortcutText}"
    },
    sync: {
        "id": "navigation-apps-shortcuts-sidebar.shortcut.sync",
        "defaultMessage": "Sync"
    }
});

});


parcelRegister("7UhxN", function(module, exports) {

$parcel$export(module.exports, "useShortcutsData", () => $799685b63be28a3b$export$47d387d66bf16cb);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iEUaw = parcelRequire("iEUaw");

var $324W5 = parcelRequire("324W5");

var $5hv0u = parcelRequire("5hv0u");

var $89Akw = parcelRequire("89Akw");
const $799685b63be28a3b$var$transformShortcutsMemo = (0, $8QpSo.default)((a, b)=>(0, $89Akw.transformShortcuts)(a, b));
const $799685b63be28a3b$var$emptyData = [];
const $799685b63be28a3b$export$47d387d66bf16cb = (customContext)=>{
    const canEdit = (0, $5hv0u.useCanEditShortcuts)(customContext);
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $iEUaw.staticSidebarShortcutsResource), customContext);
    const items = (0, $5uXOq.useMemo)(()=>data && $799685b63be28a3b$var$transformShortcutsMemo(data, canEdit), [
        data,
        canEdit
    ]); // canEdit should be the same for all shortcuts per person, per project
    return {
        data: items || $799685b63be28a3b$var$emptyData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5hv0u", function(module, exports) {

$parcel$export(module.exports, "useCanEditShortcuts", () => $e888d8394c5baf80$export$cf4f3a9f01fdc8a7);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $dhuBw = parcelRequire("dhuBw");
const $e888d8394c5baf80$export$cf4f3a9f01fdc8a7 = (customContext)=>{
    const { data: data } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    return (0, $5uXOq.useMemo)(()=>data && (0, $dhuBw.getCanEditShortcuts)(data), [
        data
    ]) || false;
};

});
parcelRegister("dhuBw", function(module, exports) {

$parcel$export(module.exports, "getCanEditShortcuts", () => $050e711b4fac24d4$export$c64b03ccce2c3de);
const $050e711b4fac24d4$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS || false;
const $050e711b4fac24d4$export$c64b03ccce2c3de = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraWorkManagementNavData.permissionInfo) : false;
        case 'jira_software':
            return jiraSoftwareNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraSoftwareNavData.permissionInfo) : false;
        case 'jira_service_management':
            return jiraServiceManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraServiceManagementNavData.permissionInfo) : false;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraProductDiscoveryNavData.permissionInfo) : false;
        case null:
            return false;
        default:
            return false;
    }
};

});


parcelRegister("89Akw", function(module, exports) {

$parcel$export(module.exports, "transformShortcuts", () => $c195049077f99f76$export$1fc4378e3ea910d0);
const $c195049077f99f76$var$getShortcutIcon = (type)=>{
    if (type == null || type === 'unknown' || type === 'unsupported') return 'shortcut';
    if (type === 'github') return 'repos';
    return type;
};
const $c195049077f99f76$export$1fc4378e3ea910d0 = (arrayOfShortcuts, canEditOld)=>{
    if (arrayOfShortcuts && Array.isArray(arrayOfShortcuts)) {
        const links = [];
        const repos = [];
        arrayOfShortcuts.forEach((shortcut)=>{
            const shortcutIcon = $c195049077f99f76$var$getShortcutIcon(shortcut.dvcsType);
            const s = {
                id: shortcut.type == null ? `com.atlassian.jira.jira-projects-plugin:project.shortcut.default.link.${shortcut.id}` : `com.atlassian.jira.jira-projects-plugin:${shortcut.type}.${shortcut.id}`,
                name: shortcut.name,
                icon: shortcutIcon,
                url: shortcut.url,
                selected: false,
                section: false,
                separator: false,
                showDot: false,
                hasLandingPage: false,
                canEdit: canEditOld,
                showSync: false,
                canDismiss: false,
                sortable: false,
                target: '_blank'
            };
            shortcut.type === 'source.code.link' ? repos.push(s) : links.push(s);
        });
        return repos.concat(links);
    }
    return [];
};

});


parcelRegister("k1ALc", function(module, exports) {

$parcel$export(module.exports, "ShortcutsContainer", () => $6885b5bf730cd03e$export$df449cf702d8e0fd);
$parcel$export(module.exports, "useShortcutItems", () => $6885b5bf730cd03e$export$2c1990af0fa688a3);

var $5uXOq = parcelRequire("5uXOq");

var $7paD5 = parcelRequire("7paD5");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4bqWq = parcelRequire("4bqWq");
const $6885b5bf730cd03e$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
        spacing: "spacious",
        label: "shortcut"
    });
const $6885b5bf730cd03e$export$fb9705de59d96855 = (item)=>({ setState: setState, getState: getState })=>{
        const { shortcutType: shortcutType } = item;
        const state = getState();
        const index = state.data.map((i)=>i.shortcutType).lastIndexOf(shortcutType);
        const newItem = {
            before: $6885b5bf730cd03e$var$renderShortcutIcon,
            ...item,
            target: '_blank',
            canEdit: true,
            itemType: 'shortcut'
        };
        // Append new item to same shortcuts group
        if (index === -1) // @ts-expect-error - TS2322 - Type 'ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'. | TS2322 - Type '{ target: string; canEdit: boolean; itemType: string; before: React.ComponentType<Record<any, any>> | (() => JSX.Element); href?: string | undefined; icon?: string | undefined; ... 6 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'.
        setState({
            data: [
                ...state.data,
                newItem
            ]
        });
        else setState({
            // @ts-expect-error - TS2322 - Type '(ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; })[]' is not assignable to type 'ShortcutItem[]'.
            data: [
                ...state.data.slice(0, index + 1),
                newItem,
                ...state.data.slice(index + 1)
            ]
        });
    };
const $6885b5bf730cd03e$export$8d8542dbbc23fe1a = (id)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.filter((existingItem)=>existingItem.id !== id);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$60832f4899fbf6a1 = (item)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>existingItem.id !== item.id ? existingItem : item);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$8c896bccb18e1db1 = (items)=>({ setState: setState, getState: getState })=>{
        if (!items.length) return;
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>items.find((item)=>item.id === existingItem.id) || existingItem);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$ed2a7beca2c9674 = (data, loading)=>({ setState: setState, getState: getState })=>{
        const items = (data || []).map((0, $4bqWq.getItemFromLink));
        const state = getState();
        return setState({
            ...state,
            loading: loading,
            data: items,
            oldData: items,
            isLoaded: true
        });
    };
const $6885b5bf730cd03e$export$e324594224ef24da = {
    addItem: $6885b5bf730cd03e$export$fb9705de59d96855,
    deleteItem: $6885b5bf730cd03e$export$8d8542dbbc23fe1a,
    editItem: $6885b5bf730cd03e$export$60832f4899fbf6a1,
    editItems: $6885b5bf730cd03e$export$8c896bccb18e1db1,
    updateContainer: $6885b5bf730cd03e$export$ed2a7beca2c9674
};
const $6885b5bf730cd03e$export$d4c72bab9d6cc13a = {
    data: [],
    oldData: null,
    loading: false,
    isLoaded: false
};
/**
 * Instance
 */ const $6885b5bf730cd03e$var$Store = (0, $iXqE5.createStore)({
    name: 'shortcuts',
    initialState: $6885b5bf730cd03e$export$d4c72bab9d6cc13a,
    actions: $6885b5bf730cd03e$export$e324594224ef24da
});
var $6885b5bf730cd03e$export$2e2bcd8739ae039 = $6885b5bf730cd03e$var$Store;
const $6885b5bf730cd03e$export$df449cf702d8e0fd = (0, $gg7kZ.createContainer)($6885b5bf730cd03e$var$Store, {
    onInit: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        }
});
const $6885b5bf730cd03e$export$2c1990af0fa688a3 = (0, $3sQ5x.createHook)($6885b5bf730cd03e$var$Store);

});
parcelRegister("4bqWq", function(module, exports) {

$parcel$export(module.exports, "getItemFromLink", () => $5f237ed4c010c05c$export$60d4c4ef6da272ad);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ixUGT = parcelRequire("ixUGT");

var $hYfgW = parcelRequire("hYfgW");

var $7Jlas = parcelRequire("7Jlas");

var $17Ngn = parcelRequire("17Ngn");

var $iMzG0 = parcelRequire("iMzG0");
const $5f237ed4c010c05c$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const $5f237ed4c010c05c$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMzG0.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $5f237ed4c010c05c$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $5f237ed4c010c05c$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($7Jlas));
        default:
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($17Ngn));
    }
};
const $5f237ed4c010c05c$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($5f237ed4c010c05c$var$getLinkParts(linkId));
const $5f237ed4c010c05c$export$d37d2882f5261346 = (linkId)=>linkId;
const $5f237ed4c010c05c$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($ixUGT)))($5f237ed4c010c05c$var$getLinkParts(linkId)).join('.');
const $5f237ed4c010c05c$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $5f237ed4c010c05c$export$3cec694c50bc695d(linkId);
    const shortcutType = $5f237ed4c010c05c$export$92a97f8239a551c5(linkId);
    const target = link.target ?? '_blank';
    const Icon = $5f237ed4c010c05c$export$16b26cd5e98d9100(icon);
    return {
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});
parcelRegister("ixUGT", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */ function $d80748aee2c24c33$var$initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? $dM3Z8(array, 0, -1) : [];
}
module.exports = $d80748aee2c24c33$var$initial;

});

parcelRegister("7Jlas", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a0d27d0abcfe15c$var$_react = $5a0d27d0abcfe15c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5a0d27d0abcfe15c$var$_angleBrackets = $5a0d27d0abcfe15c$var$_interopRequireDefault((parcelRequire("jSlaY")));
function $5a0d27d0abcfe15c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5a0d27d0abcfe15c$var$BitbucketReposIcon = (props)=>/*#__PURE__*/ $5a0d27d0abcfe15c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/><path d="M9.23 8.31 6.3 11.26a1.06 1.06 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L8.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.02 1.02 0 0 0-.73-.3c-.27 0-.53.1-.73.31m4.06 0a1.05 1.05 0 0 0 0 1.48L15.5 12l-2.2 2.22a1.05 1.05 0 0 0 0 1.48c.4.41 1.06.41 1.46 0l2.93-2.95a1.05 1.05 0 0 0 0-1.48l-2.93-2.96a1.03 1.03 0 0 0-1.46 0"/></g></svg>`
    }, props, {
        newIcon: $5a0d27d0abcfe15c$var$_angleBrackets.default
    }));
$5a0d27d0abcfe15c$var$BitbucketReposIcon.displayName = 'BitbucketReposIcon';
var $5a0d27d0abcfe15c$var$_default = module.exports.default = $5a0d27d0abcfe15c$var$BitbucketReposIcon;

});

parcelRegister("iMzG0", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $0af9b15279bc8ff1$export$5fc1066e677788d4);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $0af9b15279bc8ff1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $0af9b15279bc8ff1$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $0af9b15279bc8ff1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});



parcelRegister("1vBwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e55df98ec766a24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7paD5 = parcelRequire("7paD5");

var $7T84i = parcelRequire("7T84i");
var $cQZXC = parcelRequire("cQZXC");

var $2YZCu = parcelRequire("2YZCu");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $lfTZh = parcelRequire("lfTZh");

var $g5X3G = parcelRequire("g5X3G");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");


var $lkWkR = parcelRequire("lkWkR");

const $0e55df98ec766a24$export$220dc4f1b8ffa17c = (0, $kxZPA.lazy)(()=>(parcelRequire("jA4Dc")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/add-link-modal/index.tsx"
});

const $0e55df98ec766a24$export$f4f22b2fa38658d6 = (0, $kxZPA.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aiSFl")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/add-item/index.tsx"
});

const $0e55df98ec766a24$export$f525b7ef0c89cbed = (0, $kxZPA.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("2EZdp")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/add-item-v2/index.tsx"
});

const $0e55df98ec766a24$export$234ec8e31562766c = (0, $kxZPA.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aFtLa")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/edit-shortcut-modal/index.tsx"
});

const $0e55df98ec766a24$export$14ff0695ca26505c = (0, $kxZPA.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("67YVY")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/manage-pages-link-modal/index.tsx"
});
const $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY = 500;
const $0e55df98ec766a24$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
        spacing: "spacious",
        label: ""
    });
const $0e55df98ec766a24$var$findRepoShortcuts = (items)=>items.filter((i)=>i.shortcutType === (0, $27f32c1fbb856eaf$export$399c7e6858236b4));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0e55df98ec766a24$var$toItem = (link)=>{
    // We cannot create shortcuts with legacyId as it would exclude them from the list of navigation items -
    // they don't exist in the sidebar config we've fetched before
    const { legacyId: legacyId, ...withoutLegacyId } = (0, $lkWkR.getItemFromLink)(link);
    return {
        ...withoutLegacyId,
        onEditClick: ()=>setTimeout(()=>link.onEditClick()),
        onSyncClick: link.onSyncClick
    };
};
class $0e55df98ec766a24$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isSpa: false,
            isAdmin: false,
            canAddLinks: true,
            canAddRepositories: false,
            showPagesSelector: true,
            items: []
        };
    }
    constructor(props){
        super(props), this.addItemButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.onAddItem = ()=>{
            if (this.props.canAddLinks && !this.state.canAddRepositories) this.onAddLink();
            else if (this.state.canAddRepositories && !this.props.canAddLinks) this.onAddRepository();
            else this.setState({
                addItem: {
                    type: undefined
                }
            });
        }, this.onAddLink = ()=>{
            // if a modal is already open, close it and open the add link modal
            // with a delay to ensure the modal is closed before opening the new one
            if (this.state.addItem) {
                this.setState({
                    addItem: undefined
                });
                // wait for the modal to close before opening the next modal
                setTimeout(()=>{
                    this.setState({
                        addItem: {
                            type: 'link'
                        }
                    });
                }, $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY);
            } else this.setState({
                addItem: {
                    type: 'link'
                }
            });
        }, this.onAddRepository = ()=>{
            this.setState(()=>({
                    addItem: undefined
                }));
            setTimeout(()=>{
                if (typeof this.repositoryApi.add === 'function') this.repositoryApi.add();
                else (0, $2YZCu.default).safeErrorWithoutCustomerData('navigation-next.shortcuts.repository', "Cannot open add repository shortcut modal - the API wan't set up");
            }, $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY);
        }, this.onAddItemCompleted = ({ item: item })=>{
            if (item) this.props.methods.addItem({
                ...item,
                target: '_blank',
                canEdit: true,
                before: $0e55df98ec766a24$var$renderShortcutIcon
            });
            this.setState(()=>{
                return {
                    addItem: undefined
                };
            }, ()=>{
                if (this.addItemButtonRef?.current) this.addItemButtonRef.current.focus();
            });
        }, this.onEditOrDeleteItem = (id, ref)=>{
            if (ref) this.setState({
                editOrDeleteItem: id,
                editShortcutButtonRef: ref
            });
            else this.setState({
                editOrDeleteItem: id
            });
        }, this.openManagePagesLinkModal = ()=>{
            this.setState({
                isPagesModalOpen: true
            });
        }, this.closeManagePagesLinkModal = ()=>{
            this.setState({
                isPagesModalOpen: false
            });
        }, this.onEditOrDeleteItemCompleted = (args)=>{
            const { item: item, deleted: deleted } = args;
            if (item) deleted ? this.props.methods.deleteItem(item.id) : this.props.methods.editItem(item);
            this.setState(()=>{
                return {
                    editOrDeleteItem: undefined,
                    editShortcutButtonRef: undefined
                };
            });
        }, this.setPagesLink = ({ setPagesLink: setPagesLink })=>(isEnabled)=>{
                const { baseUrl: baseUrl, projectKey: projectKey } = this.props;
                return setPagesLink({
                    baseUrl: (0, $g5X3G.toBaseUrl)(baseUrl),
                    projectKey: (0, $g5X3G.toProjectKey)(projectKey),
                    enable: isEnabled
                });
            }, this.repositoryApi = {};
        this.state = {
            canAddRepositories: props.canAddRepositories,
            addItem: undefined,
            editOrDeleteItem: undefined,
            isPagesModalOpen: false,
            editShortcutButtonRef: undefined
        };
        if (props.canAddRepositories) this.initLegacyBridgeAPI();
    }
    componentDidMount() {
        if ((0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate')) this.showModalIfAddShortcutClickedFromAddView();
    }
    componentDidUpdate(prevProps) {
        if ((0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate')) {
            if (this.props.isModalOpenViaAddView !== prevProps.isModalOpenViaAddView) this.showModalIfAddShortcutClickedFromAddView();
        }
    }
    showModalIfAddShortcutClickedFromAddView() {
        if (this.props.isModalOpenViaAddView === true) {
            this.onAddItem();
            this.props.setIsModalOpenViaAddView?.(false);
        }
    }
    initLegacyBridgeAPI() {
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $cQZXC.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $7T84i.loadBridgeStrict)({
                name: 'repository-shortcuts/navigation-next',
                wrmKeys: [
                    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next'
                ]
            })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ?.then((init)=>{
            const { methods: methods, items: items, projectKey: projectKey, projectId: projectId, isAdmin: isAdmin } = this.props;
            this.repositoryApi = init({
                shortcuts: $0e55df98ec766a24$var$findRepoShortcuts(items),
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                onAdd: (item)=>methods.addItem($0e55df98ec766a24$var$toItem(item)),
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                onEdit: (item)=>methods.editItem($0e55df98ec766a24$var$toItem(item)),
                // @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
                onDelete: (id)=>methods.deleteItem((0, $lkWkR.getIdFromLinkId)(id)),
                // @ts-expect-error - TS7006 - Parameter 'itemBulk' implicitly has an 'any' type.
                onBulkEdit: (itemBulk)=>// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                    methods.editItems(itemBulk.map((item)=>$0e55df98ec766a24$var$toItem(item))),
                projectKey: projectKey,
                projectId: projectId,
                isAdmin: isAdmin
            });
        }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ?.catch((e)=>{
            this.setState({
                canAddRepositories: false
            });
            (0, $2YZCu.default).safeErrorWithoutCustomerData('navigation-next.shortcuts.repository', 'There was a problem loading or integrating with repository shortcuts', e);
        });
    }
    render() {
        const { children: children, baseUrl: baseUrl, pagesLink: pagesLink, projectKey: projectKey, items: items, showPagesSelector: showPagesSelector } = this.props;
        const { editOrDeleteItem: editOrDeleteItem, addItem: addItem, isPagesModalOpen: isPagesModalOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
            data: {
                shortcuts: items
            },
            openAddModal: this.onAddItem,
            openEditModal: this.onEditOrDeleteItem,
            openManagePagesLinkModal: pagesLink ? this.openManagePagesLinkModal : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            addItemButtonRef: this.addItemButtonRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "shortcuts-modal",
            packageName: "jiraNavigationShortcuts"
        }, pagesLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
            until: (0, $4R6GH.fg)('nav_prevent_eager_manage_pages_modal') ? isPagesModalOpen === true : isPagesModalOpen != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "manage-pages-link-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$14ff0695ca26505c, {
            config: {
                isPagesLinkEnabled: pagesLink.isEnabled,
                setPagesLink: this.setPagesLink(pagesLink)
            },
            isOpen: isPagesModalOpen,
            onClose: this.closeManagePagesLinkModal
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
            until: addItem != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "add-item-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, pagesLink ? // add shortcut modal
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$f525b7ef0c89cbed, {
            addItem: addItem,
            baseUrl: baseUrl,
            pages: {
                isEnabled: pagesLink.isEnabled,
                setPagesLink: this.setPagesLink(pagesLink)
            },
            projectKey: projectKey,
            onAddItemCompleted: this.onAddItemCompleted,
            onAddLink: this.onAddLink,
            onAddRepo: this.onAddRepository,
            showPagesSelector: showPagesSelector,
            addItemButtonRef: this.addItemButtonRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$f4f22b2fa38658d6, {
            addItem: addItem,
            baseUrl: baseUrl,
            projectKey: projectKey,
            onAddItemCompleted: this.onAddItemCompleted,
            onAddLink: this.onAddLink,
            onAddRepo: this.onAddRepository
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
            until: editOrDeleteItem != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "edit-shortcut-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$234ec8e31562766c, {
            baseUrl: baseUrl,
            projectKey: projectKey,
            editOrDeleteItem: editOrDeleteItem,
            items: items,
            editOrDeleteItemCompleted: this.onEditOrDeleteItemCompleted,
            editButtonRef: this.state.editShortcutButtonRef
        })))));
    }
}

});
const $27f32c1fbb856eaf$export$399c7e6858236b4 = 'source.code.link';
const $27f32c1fbb856eaf$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $27f32c1fbb856eaf$export$3746846b4d8615c3 = 'INVALID_URL';

parcelRegister("lkWkR", function(module, exports) {

$parcel$export(module.exports, "getIdFromLinkId", () => $74dd3faace70a053$export$3cec694c50bc695d);
$parcel$export(module.exports, "getItemFromLink", () => $74dd3faace70a053$export$60d4c4ef6da272ad);

var $5uXOq = parcelRequire("5uXOq");

var $ixUGT = parcelRequire("ixUGT");

var $hYfgW = parcelRequire("hYfgW");

var $7Jlas = parcelRequire("7Jlas");

var $17Ngn = parcelRequire("17Ngn");

var $iMzG0 = parcelRequire("iMzG0");
const $74dd3faace70a053$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $74dd3faace70a053$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMzG0.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $74dd3faace70a053$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $74dd3faace70a053$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($7Jlas));
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($17Ngn));
    }
};
const $74dd3faace70a053$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($74dd3faace70a053$var$getLinkParts(linkId));
const $74dd3faace70a053$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($ixUGT)))($74dd3faace70a053$var$getLinkParts(linkId)).join('.');
const $74dd3faace70a053$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $74dd3faace70a053$export$3cec694c50bc695d(linkId);
    const shortcutType = $74dd3faace70a053$export$92a97f8239a551c5(linkId);
    const target = link.target || '_blank';
    const Icon = $74dd3faace70a053$export$16b26cd5e98d9100(icon);
    return {
        type: 'Item',
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});

parcelRegister("jA4Dc", function(module, exports) {

let $e414f8ca3f5a3ebd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e414f8ca3f5a3ebd$var$load("9aYrW").then(()=>parcelRequire('1KSRk'));

});

parcelRegister("aiSFl", function(module, exports) {

let $7805fd52d29baf3f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7805fd52d29baf3f$var$load("lw2WF").then(()=>parcelRequire('283Hr'));

});

parcelRegister("2EZdp", function(module, exports) {

let $1efecd478bb26902$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1efecd478bb26902$var$load("hVh0q").then(()=>parcelRequire('kSuJt'));

});

parcelRegister("aFtLa", function(module, exports) {

let $7c44d1638e625f20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7c44d1638e625f20$var$load("bpNdl").then(()=>parcelRequire('5h9Nf'));

});

parcelRegister("67YVY", function(module, exports) {

let $4762a9c73f87d768$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4762a9c73f87d768$var$load("lVTe9").then(()=>parcelRequire('bw5U3'));

});


parcelRegister("2RBG9", function(module, exports) {

$parcel$export(module.exports, "useSimplifyNavExperimentActions", () => $4f93da38aa0d50ec$export$dec0900020ea5bc1);
$parcel$export(module.exports, "useIsModalOpenViaAddView", () => $4f93da38aa0d50ec$export$7159774426103694);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $hEThu = parcelRequire("hEThu");
const $4f93da38aa0d50ec$var$initialState = {
    isModalOpenViaAddView: false
};
const $4f93da38aa0d50ec$var$Store = (0, $iXqE5.createStore)({
    initialState: $4f93da38aa0d50ec$var$initialState,
    actions: $hEThu.actions,
    name: 'add-shortcut-modal'
});
const $4f93da38aa0d50ec$export$dec0900020ea5bc1 = (0, $3sQ5x.createActionsHook)($4f93da38aa0d50ec$var$Store);
const $4f93da38aa0d50ec$var$getIsModalOpenViaAddView = (state)=>state.isModalOpenViaAddView;
const $4f93da38aa0d50ec$export$7159774426103694 = (0, $3sQ5x.createHook)($4f93da38aa0d50ec$var$Store, {
    selector: $4f93da38aa0d50ec$var$getIsModalOpenViaAddView
});

});
parcelRegister("hEThu", function(module, exports) {

$parcel$export(module.exports, "actions", () => $2feb5bd35f69b764$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2feb5bd35f69b764$export$e324594224ef24da = {
    setIsModalOpenViaAddView: (isOpen)=>({ setState: setState })=>{
            setState({
                isModalOpenViaAddView: isOpen
            });
        }
};

});


parcelRegister("7E0T0", function(module, exports) {

$parcel$export(module.exports, "useIsSimplifyNavExperimentEnabled", () => $22c277cef5718f50$export$9e64ffaf2b8ea06);

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $dAfqg = parcelRequire("dAfqg");
const $22c277cef5718f50$export$9e64ffaf2b8ea06 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const isJsw = projectContext?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isProjectAdmin = projectContext?.isProjectAdmin;
    const isTmp = !!projectContext?.simplified;
    const isEligible = isJsw && isTmp && isProjectAdmin;
    if (isEligible) return expConfig.get('isEnabled', false);
    return false;
};

});
parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});


parcelRegister("kfztd", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $064393a36b21cb6e$export$18bfef4995ec57b7);

var $aIZdc = parcelRequire("aIZdc");
const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, $aIZdc.isFedRamp)();

});

parcelRegister("cNJA1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5aa04212b12cb992$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5aa04212b12cb992$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    addItem: {
        "id": "navigation-apps-shortcuts-sidebar.add-item",
        "defaultMessage": "Add shortcut"
    }
});

});

parcelRegister("dsZRM", function(module, exports) {

$parcel$export(module.exports, "PagesMenuItem", () => $987860c5961bf9dc$export$134a99f2c72dc6b7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $1ywCO = parcelRequire("1ywCO");

var $3u0c5 = parcelRequire("3u0c5");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lLoy3 = parcelRequire("lLoy3");

var $2MtwW = parcelRequire("2MtwW");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $1z3xg = parcelRequire("1z3xg");

var $b0i2u = parcelRequire("b0i2u");

var $doZTA = parcelRequire("doZTA");


var $4Y8PR = parcelRequire("4Y8PR");

var $gXsf7 = parcelRequire("gXsf7");

var $7dRTN = parcelRequire("7dRTN");
const $987860c5961bf9dc$var$EditIcon = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = (ev)=>{
        ev.preventDefault();
        if (onClick) onClick(ev);
    };
    // this function handle keydown event when user navigate to the edit button and press enter to open the dialog.
    const handleKeyDown = (event)=>{
        if (event.key === 'Enter') handleClick(event);
    };
    const buttonProps = {
        appearance: 'subtle-link',
        spacing: 'none',
        onClick: handleClick,
        onKeyDown: handleKeyDown
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "data-edit-icon": true,
        ...buttonProps,
        "aria-describedby": "navigation-apps-sidebar-common.ui.shortcuts.business-pages-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ywCO))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage((0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? (0, $7dRTN.messages).editProjectPages : (0, $7dRTN.messages).edit)
    }));
};
const $987860c5961bf9dc$var$WrappedPagesMenuItemWithMayBeLozenge = ({ onEditClick: onEditClick, iconAfter: iconAfter, pagesMenuItemTitle: pagesMenuItemTitle, crossJoinNudge: crossJoinNudge = {
    isCrossJoinTeamEligible: false,
    canShowJoinTeamlozenge: false,
    canShowJoinTeamPulse: false
}, projectId: // Extracting here so that it does not end up in the "rest" which would eventually get passed to a normal DOM element and cause React to be unhappy
projectId, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isCrossJoinTeamEligible: isCrossJoinTeamEligible, canShowJoinTeamlozenge: canShowJoinTeamlozenge } = crossJoinNudge;
    if ((0, $4R6GH.fg)('blu-4174-enghealth-13134-page-item-a11y-fix')) {
        const icon = !iconAfter && onEditClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1ywCO))),
            onClick: (e)=>onEditClick(e),
            label: formatMessage((0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? (0, $7dRTN.messages).editProjectPages : (0, $7dRTN.messages).edit),
            appearance: "subtle"
        }) : iconAfter; // In order to ensure that the spacing is correct in the Nav3 sidebar we need to wrap the icon in an element
        // with some padding. This ensures that everything lines up correctly when the menu item is selected.
        const { iconBefore: iconBefore, ...allTheRest } = rest;
        const augmentedIconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingInlineStart: "space.200"
        }, iconBefore);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            iconBefore: augmentedIconBefore,
            ...allTheRest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            id: "navigation-apps-sidebar-common.ui.shortcuts.business-pages-link"
        }, formatMessage(pagesMenuItemTitle || (0, $7dRTN.messages).projectPagesItem)), isCrossJoinTeamEligible && canShowJoinTeamlozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "test-id": "shortcuts.business-pages-lozenge",
            className: (0, $bwpsq.default)([
                "_19bvu2gc"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: "new"
        }, formatMessage((0, $7dRTN.messages).projectPagesLozenge))))), icon);
    }
    const cssFn = isCrossJoinTeamEligible ? (0, $1z3xg.cssFn) : (0, $b0i2u.cssFn);
    const extraProps = !iconAfter && onEditClick ? {
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$EditIcon, {
            onClick: onEditClick
        }),
        cssFn: cssFn
    } : {
        iconAfter: iconAfter
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ...extraProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        id: "shortcuts.business-pages-lozenge"
    }, formatMessage(pagesMenuItemTitle || (0, $7dRTN.messages).projectPagesItem)), isCrossJoinTeamEligible && canShowJoinTeamlozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "test-id": "shortcuts.business-pages-lozenge",
        className: (0, $bwpsq.default)([
            "_19bvu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $7dRTN.messages).projectPagesLozenge))));
};
const $987860c5961bf9dc$var$lozengeStyles = null;
const $987860c5961bf9dc$var$WrappedPagesMenuItem = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $bd24ef8cd2fd388b$export$965e349a75efe8dc)
    }, props.crossJoinNudge && props.crossJoinNudge.isCrossJoinTeamEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Y8PR.ProjectPageMenuItemWithJoinTeamPulse), {
        showPulse: props.crossJoinNudge.canShowJoinTeamPulse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItemWithMayBeLozenge, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItemWithMayBeLozenge, props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MtwW.EngagementSpotlight), {
        engagementId: (0, $bd24ef8cd2fd388b$export$965e349a75efe8dc)
    }));
const $987860c5961bf9dc$var$WrappedPagesMenuItemWithNudge = (props)=>{
    // for a11y purposes, we drill the focussed state down so the nudge can be shown via keyboard controls
    const [isFocussed, setIsFocussed] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "pages-menu-item-end-user-activate-nudge",
        packageName: "jira-navigation-apps-sidebar-common",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItem, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXsf7.EndUserActivateNudgeProvider), {
        isFocussed: isFocussed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItem, {
        ...props,
        onFocus: (e)=>{
            setIsFocussed(true);
            props.onFocus?.(e);
        },
        onBlur: (e)=>{
            setIsFocussed(false);
            props.onBlur?.(e);
        }
    })));
};
const $987860c5961bf9dc$export$134a99f2c72dc6b7 = (props)=>{
    const [{ route: route }] = (0, $doZTA.useRouter)();
    const crossJoinNudge = (0, $lLoy3.useCrossJoinTeamEligible)(props.projectId);
    const extraProps = {
        ...props,
        crossJoinNudge: crossJoinNudge
    }; // don't show the nudge if the user is already on project-pages
    return route.name !== 'project-pages' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItemWithNudge, extraProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItem, extraProps);
};

});
parcelRegister("lLoy3", function(module, exports) {

$parcel$export(module.exports, "useCrossJoinTeamEligible", () => $5b34d0e1b0b740e7$export$c04acf198fab33d6);

var $5uXOq = parcelRequire("5uXOq");

var $iVil7 = parcelRequire("iVil7");

var $e1J1K = parcelRequire("e1J1K");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $9XCQv = parcelRequire("9XCQv");
const $5b34d0e1b0b740e7$export$c04acf198fab33d6 = (projectId)=>{
    const [isCrossJoinTeamEligible, setIsCrossJoinTeamEligible] = (0, $5uXOq.useState)(false);
    const [canShowJoinTeamlozenge, setCanShowJoinTeamLozenge] = (0, $5uXOq.useState)(false);
    const [canShowJoinTeamPulse, setCanShowJoinTeamPulse] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [checkIfSpotlightOrLozengeShown] = (0, $9XCQv.useIsEligibleForSpotlight)();
    const [markAsNotEligible] = (0, $9XCQv.useUserSpotlightProperty)((0, $9XCQv.INELIGIBLE_FOR_CONFLUENCE_ACCESS_ID));
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('cjn_project_pages_gate') || !projectId) return;
        const checkEligibility = async ()=>{
            let ineligibilityReason = '';
            let cohort = 'not-enrolled';
            try {
                const [canShowPulse, canShowlozenge, isIneligibleForAccess] = await checkIfSpotlightOrLozengeShown();
                if (isIneligibleForAccess) ineligibilityReason = 'NOT_ELIGIBLE_FROM_LOCAL_STORE';
                else if (canShowPulse === false) {
                    cohort = 'variation'; // if spotlight is shown before, its safe to consider the user is in variation
                    if (canShowlozenge) {
                        ineligibilityReason = 'SPOTLIGHT_ELIGIBLE';
                        setCanShowJoinTeamLozenge(canShowlozenge);
                    } else ineligibilityReason = 'ALREADY_SHOWN_SPOTLIGHT';
                } else {
                    const alreadyHasAccess = await (0, $iVil7.hasProductAccess)('confluence', cloudId);
                    if (alreadyHasAccess) ineligibilityReason = 'ALREADY_HAVE_ACCESS';
                    else {
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'crossJoinNudgeProjectPages capabilityCheck');
                        const canRequestAccess = await (0, $e1J1K.fetchIsRequestAccessCapable)('confluence', cloudId);
                        if (canRequestAccess) {
                            cohort = (0, $6s1PB.expVal)('cjn_project_pages_on_userid', 'cohort', 'not-enrolled');
                            if (cohort === 'variation') {
                                if (canShowPulse || canShowlozenge) {
                                    ineligibilityReason = 'SPOTLIGHT_ELIGIBLE';
                                    setCanShowJoinTeamPulse(canShowPulse);
                                    setCanShowJoinTeamLozenge(canShowlozenge);
                                }
                            } else ineligibilityReason = 'NOT_ENROLLED_IN_VARIATION';
                        } else ineligibilityReason = 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS';
                    }
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (error instanceof Error && error.message?.includes('status code: 400')) ineligibilityReason = 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS';
                else ineligibilityReason = 'ERROR_EVALUATING_ELIGIBILITY';
                (0, $jcw0u.default)({
                    meta: {
                        id: 'checkCJNEligibility',
                        packageName: 'jiraNavigationAppsShortcutsSidebar'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            const eventDetail = {
                flagKey: 'cjn_project_pages_on_userid',
                cohort: cohort,
                ineligibilityReason: ineligibilityReason
            };
            if ([
                'ALREADY_HAVE_ACCESS',
                'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
            ].includes(ineligibilityReason)) markAsNotEligible();
            if (cohort !== 'not-enrolled') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', eventDetail);
            else if (ineligibilityReason !== 'NOT_ELIGIBLE_FROM_LOCAL_STORE') // we don't need to fire multiple 'feature excluded' event for same user if we find ineligibility in local storage,
            // this will reduce the event volume greatly
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'feature excluded', eventDetail);
            const result = ineligibilityReason === 'SPOTLIGHT_ELIGIBLE';
            setIsCrossJoinTeamEligible(result);
        };
        checkEligibility();
    }, [
        projectId,
        cloudId,
        createAnalyticsEvent,
        checkIfSpotlightOrLozengeShown,
        markAsNotEligible
    ]);
    return {
        isCrossJoinTeamEligible: isCrossJoinTeamEligible,
        canShowJoinTeamlozenge: canShowJoinTeamlozenge,
        canShowJoinTeamPulse: canShowJoinTeamPulse
    };
};

});
parcelRegister("iVil7", function(module, exports) {

$parcel$export(module.exports, "hasProductAccess", () => $543bba9bf251c6d1$export$61073fd69a83a1e3);
$parcel$export(module.exports, "fetchCachedAccessCheck", () => $543bba9bf251c6d1$export$cd2f9bc003d00b45);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $543bba9bf251c6d1$var$URL = '/gateway/api/permissions/permitted';
const $543bba9bf251c6d1$export$61073fd69a83a1e3 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await (0, $7f4tk.default)($543bba9bf251c6d1$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
// Purposefully set this to 7 days as it's unlikely user can be kicked out of Confluence when they already have access
const $543bba9bf251c6d1$var$PERMISSION_CACHE_KEY_EXPIRY_MS = 604800000;
const $543bba9bf251c6d1$var$crossJoinApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('cross-join-nudge-conf-perms-api-cache');
const $543bba9bf251c6d1$export$cd2f9bc003d00b45 = async (createAnalyticsEvent, product, cloudId, touchpoint)=>{
    const cacheKey = `cross.join.${product}.cache.key`;
    let permissionResponse = $543bba9bf251c6d1$var$crossJoinApiCache.get(cacheKey);
    if (permissionResponse === undefined) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheMiss', {
            touchpoint: touchpoint,
            product: product
        });
        try {
            permissionResponse = await $543bba9bf251c6d1$export$61073fd69a83a1e3(product, cloudId);
        } catch (err) {
            // No PII from identity exception so fire operational analytics consistently
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck fetchError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        try {
            $543bba9bf251c6d1$var$crossJoinApiCache.set(cacheKey, permissionResponse, Date.now() + $543bba9bf251c6d1$var$PERMISSION_CACHE_KEY_EXPIRY_MS);
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck setError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                skipSentry: true
            });
            return permissionResponse;
        }
        return permissionResponse;
    }
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheHit', {
        touchpoint: touchpoint,
        product: product
    });
    return permissionResponse;
};

});

parcelRegister("e1J1K", function(module, exports) {

$parcel$export(module.exports, "fetchIsRequestAccessCapable", () => $b1d9429bb117b963$export$c75518284e8dee24);
$parcel$export(module.exports, "fetchCachedIsConfluenceRACapable", () => $b1d9429bb117b963$export$f5767c68446c14cb);
$parcel$export(module.exports, "resetRACapableCache", () => $b1d9429bb117b963$export$5191fc85eb825b4b);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $b1d9429bb117b963$export$c75518284e8dee24 = async (product, cloudId)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    const response = await (0, $7f4tk.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
};
const $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY = 'cross.join.confluence-capabilities.cache.key';
// This is set to 1 day only as capabilties has many more states e.g PENDING_REQUEST_EXISTS, APPROVED_REQUEST_EXISTS etc
// We expect capabilities to change more often than product access
const $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS = 86400000;
const $b1d9429bb117b963$var$crossJoinApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('cross-join-nudge-conf-capabilities-api-cache');
const $b1d9429bb117b963$export$f5767c68446c14cb = async (createAnalyticsEvent, cloudId, touchpoint)=>{
    let isRACapable = $b1d9429bb117b963$var$crossJoinApiCache.get($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
    if (isRACapable === undefined) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheMiss', {
            touchpoint: touchpoint
        });
        try {
            isRACapable = await $b1d9429bb117b963$export$c75518284e8dee24('confluence', cloudId);
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
                touchpoint: touchpoint,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        $b1d9429bb117b963$export$a901680cf5ecfb6c(createAnalyticsEvent, isRACapable, touchpoint);
        return isRACapable;
    }
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheHit', {
        touchpoint: touchpoint
    });
    return isRACapable;
};
const $b1d9429bb117b963$export$a901680cf5ecfb6c = (createAnalyticsEvent, value, touchpoint)=>{
    try {
        $b1d9429bb117b963$var$crossJoinApiCache.set($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY, value, Date.now() + $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS);
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck setError', {
            touchpoint: touchpoint,
            err: err,
            skipSentry: true
        });
    }
};
const $b1d9429bb117b963$export$5191fc85eb825b4b = ()=>{
    $b1d9429bb117b963$var$crossJoinApiCache.remove($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
};

});

parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("9XCQv", function(module, exports) {

$parcel$export(module.exports, "PULSE_MESSAGE_ID", () => $05b5344c171266a0$export$1a5cb28e0beda89f);
$parcel$export(module.exports, "LOZENGE_MESSAGE_ID", () => $05b5344c171266a0$export$a5a1e9d7e5d0c391);
$parcel$export(module.exports, "INELIGIBLE_FOR_CONFLUENCE_ACCESS_ID", () => $05b5344c171266a0$export$810bc8a6202e075e);
$parcel$export(module.exports, "useIsEligibleForSpotlight", () => $05b5344c171266a0$export$eae410af47358d91);
$parcel$export(module.exports, "useUserSpotlightProperty", () => $05b5344c171266a0$export$352e2dad9741678e);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");
const $05b5344c171266a0$export$1a5cb28e0beda89f = 'menu-item-pulse';
const $05b5344c171266a0$export$a5a1e9d7e5d0c391 = 'menu-item-lozenge';
const $05b5344c171266a0$export$810bc8a6202e075e = 'ineligible-for-confluence-access';
const $05b5344c171266a0$var$sessionStorage = (0, $eNf8a.createSessionStorageProvider)('cjn_project_pages_on_userid');
const $05b5344c171266a0$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('cjn_project_pages_on_userid');
const $05b5344c171266a0$export$eae410af47358d91 = ()=>{
    const checkIfSpotlightOrLozengeShown = (0, $5uXOq.useCallback)(()=>{
        const canShowPulse = $05b5344c171266a0$var$canShowProperty($05b5344c171266a0$export$1a5cb28e0beda89f);
        const canShowLozenge = $05b5344c171266a0$var$canShowProperty($05b5344c171266a0$export$a5a1e9d7e5d0c391);
        const isIneligibleForAccess = $05b5344c171266a0$var$hasPropertyInLocalStore($05b5344c171266a0$export$810bc8a6202e075e);
        return [
            canShowPulse,
            canShowLozenge,
            isIneligibleForAccess
        ];
    }, []);
    return [
        checkIfSpotlightOrLozengeShown
    ];
};
const $05b5344c171266a0$var$canShowProperty = (propertyKey)=>!$05b5344c171266a0$var$sessionStorage.get(propertyKey) && !$05b5344c171266a0$var$localStorage.get(propertyKey);
const $05b5344c171266a0$var$hasPropertyInLocalStore = (propertyKey)=>$05b5344c171266a0$var$sessionStorage.get(propertyKey) || $05b5344c171266a0$var$localStorage.get(propertyKey);
const $05b5344c171266a0$export$352e2dad9741678e = (propertyKey)=>{
    const markAsPropertySeen = (0, $5uXOq.useCallback)(()=>{
        $05b5344c171266a0$var$localStorage.set(propertyKey, true);
        $05b5344c171266a0$var$sessionStorage.set(propertyKey, true);
    }, [
        propertyKey
    ]);
    return [
        markAsPropertySeen
    ];
};

});


parcelRegister("2MtwW", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $0e9acf1f50def63d$export$f14689466e4eca7a);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0e9acf1f50def63d$export$f14689466e4eca7a = (0, $axUP7.withNestingOptimisation)(({ engagementId: engagementId })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: engagementId
    });
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $3d7d84f3bc65155e$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4ZIaA = parcelRequire("4ZIaA");
var $c8E4X = parcelRequire("c8E4X");
var $eX4XX = parcelRequire("eX4XX");
var $aKz2G = parcelRequire("aKz2G");
var $aj7M6 = parcelRequire("aj7M6");
var $kUAkd = parcelRequire("kUAkd");
var $3WK4F = parcelRequire("3WK4F");
var $4CWca = parcelRequire("4CWca");
var $9xmqY = parcelRequire("9xmqY");
var $31ERv = parcelRequire("31ERv");
var $cIcFn = parcelRequire("cIcFn");
var $j3yGs = parcelRequire("j3yGs");

var $3HwlS = parcelRequire("3HwlS");

var $2MLVq = parcelRequire("2MLVq");
var $jjRN8 = parcelRequire("jjRN8");
var $hOWCC = parcelRequire("hOWCC");
var $ZlCus = parcelRequire("ZlCus");
var $1EWMr = parcelRequire("1EWMr");
var $kTus1 = parcelRequire("kTus1");
var $fod7Z = parcelRequire("fod7Z");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1EWMr.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WK4F.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjRN8.Banner), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ZIaA.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fod7Z.TopBar), {
        UNSAFE_height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31ERv.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eX4XX.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj7M6.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKz2G.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOWCC.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUAkd.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8E4X.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MLVq.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9xmqY.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZlCus.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CWca.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cIcFn.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $565cb8192fc4e070$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $565cb8192fc4e070$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $565cb8192fc4e070$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $565cb8192fc4e070$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $565cb8192fc4e070$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $565cb8192fc4e070$export$aeff86a16f13529);

});
// dimension vars
const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
const $565cb8192fc4e070$export$be83e7118304b28e = 56;
const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
const $565cb8192fc4e070$export$539e68c09584883a = 240;
const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;


parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});





parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $j9VTE = parcelRequire("j9VTE");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $j9VTE.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});



parcelRegister("1z3xg", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $eb963f2e8b47e0f7$export$d722961e96b459c5);

var $1UikQ = parcelRequire("1UikQ");

var $gwIPs = parcelRequire("gwIPs");

var $ai0LF = parcelRequire("ai0LF");
const $eb963f2e8b47e0f7$export$d722961e96b459c5 = (0, $ai0LF.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
    const newStyle = {
        '[data-edit-icon]': {
            display: 'none'
        },
        '&:hover [data-item-elem-after]': {
            '& > :not([data-edit-icon])': {
                display: 'none'
            },
            '& [data-edit-icon]': {
                display: 'flex'
            }
        },
        height: `${(0, $gwIPs.gridSize) * 5.5}px`
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(currentStyles, newStyle);
});

});
parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $k5uoT = parcelRequire("k5uoT");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $k5uoT.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $k5uoT.layers).navigation(),
    card: (0, $k5uoT.layers).card(),
    dialog: (0, $k5uoT.layers).dialog(),
    navigation: (0, $k5uoT.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $k5uoT.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $k5uoT.layers).navigation() - 1,
    layer: (0, $k5uoT.layers).layer(),
    blanket: (0, $k5uoT.layers).blanket(),
    modal: (0, $k5uoT.layers).modal(),
    flag: (0, $k5uoT.layers).flag(),
    spotlight: (0, $k5uoT.layers).spotlight(),
    tooltip: (0, $k5uoT.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});

parcelRegister("ai0LF", function(module, exports) {

$parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", () => $2bb346e8dcf8bbae$export$3f662b014fa1806e);
function $2bb346e8dcf8bbae$export$3f662b014fa1806e(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
function $2bb346e8dcf8bbae$export$17f32e2573d62daa(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}

});


parcelRegister("b0i2u", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $3474e09f91a13a47$export$d722961e96b459c5);

var $gwIPs = parcelRequire("gwIPs");

var $42iU4 = parcelRequire("42iU4");
const $3474e09f91a13a47$export$d722961e96b459c5 = ()=>({
        ...(0, $42iU4.cssFn)(),
        height: `${(0, $gwIPs.gridSize) * 5.5}px`
    });

});
parcelRegister("42iU4", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $6016163e6eb4da1c$export$d722961e96b459c5);
const $6016163e6eb4da1c$export$d722961e96b459c5 = ()=>({
        // Display button when the menu item is focused
        '[data-item-elem-after]': {
            opacity: 0
        },
        '&:hover [data-item-elem-after], &:focus-within [data-item-elem-after]': {
            opacity: 1
        }
    });

});


const $bd24ef8cd2fd388b$export$965e349a75efe8dc = 'spotlight-sidebar-project-pages';

parcelRegister("4Y8PR", function(module, exports) {

$parcel$export(module.exports, "ProjectPageMenuItemWithJoinTeamPulse", () => $ac3dcb3683e445c1$export$7f5c350080123ae8);

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9XCQv = parcelRequire("9XCQv");
const $ac3dcb3683e445c1$export$7f5c350080123ae8 = ({ children: children, showPulse: showPulse })=>{
    const [markAsSpotlightPulseSeen] = (0, $9XCQv.useUserSpotlightProperty)((0, $9XCQv.PULSE_MESSAGE_ID));
    const [markAsJoinTeamLozengeSeen] = (0, $9XCQv.useUserSpotlightProperty)((0, $9XCQv.LOZENGE_MESSAGE_ID));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const stopPulsing = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'lozenge'
        }), 'crossJoinTeamSidebar');
        markAsJoinTeamLozengeSeen();
    }, [
        markAsJoinTeamLozengeSeen,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        markAsSpotlightPulseSeen(); // mark as seen after first view
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        pulse: showPulse,
        radius: 3,
        onClick: stopPulsing,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure -- PLEASE FIX - ENABLING FLAT LINT CONFIG
        testId: "navigation-apps-sidebar-common.ui.shortcuts.pages-menu-item.cross-join-team-nudge-provider.cross-join-nudge-pulse"
    }, children);
};

});

parcelRegister("gXsf7", function(module, exports) {

$parcel$export(module.exports, "EndUserActivateNudgeProvider", () => $f71cb08805be985b$export$a00e9d2e4877aaa0);

var $5uXOq = parcelRequire("5uXOq");

var $eGLgs = parcelRequire("eGLgs");

var $6i9Dy = parcelRequire("6i9Dy");

var $jvHQd = parcelRequire("jvHQd");


const $f71cb08805be985b$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);
const $f71cb08805be985b$export$a00e9d2e4877aaa0 = ({ children: children, isFocussed: isFocussed })=>{
    const [showSpotlight, markAsSeen] = (0, $jvHQd.useShowProjectPagesSpotlightSeenStatus)((0, $6i9Dy.MESSAGE_ID));
    return showSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $6i9Dy.MESSAGE_ID),
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f71cb08805be985b$var$CoordinationStopProvider, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6i9Dy.EndUserActivateNudge), {
            stop: stop,
            isFocussed: isFocussed,
            markAsSeen: markAsSeen
        }, children))) : children;
};

});
parcelRegister("eGLgs", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $754c27d37ccd1133$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $754c27d37ccd1133$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iZhen = parcelRequire("iZhen");

var $jcYbC = parcelRequire("jcYbC");
var $8Mq6c = parcelRequire("8Mq6c");

var $TTRxY = parcelRequire("TTRxY");

var $ioD1B = parcelRequire("ioD1B");

var $10xFf = parcelRequire("10xFf");

var $4Pf62 = parcelRequire("4Pf62");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $14XJw = parcelRequire("14XJw");

var $7qPn9 = parcelRequire("7qPn9");
const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
class $754c27d37ccd1133$export$580a2294c917898c extends (0, $8Mq6c.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $iZhen.envType).PROD;
            if (env === 'staging') return (0, $iZhen.envType).STAGING;
            return (0, $iZhen.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $10xFf.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $TTRxY.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $4R6GH.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $TTRxY.MessageDeliveryStatus).STARTED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $TTRxY.MessageDeliveryStatus).STOPPED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $TTRxY.MessageDeliveryStatus).STARTED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $TTRxY.MessageDeliveryStatus).STOPPED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcYbC.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});

parcelRegister("6i9Dy", function(module, exports) {

$parcel$export(module.exports, "MESSAGE_ID", () => $cf909fe934837f3e$export$af60a7ae4202be66);
$parcel$export(module.exports, "EndUserActivateNudge", () => $cf909fe934837f3e$export$e44c6e87aab1f81);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fqbGj = parcelRequire("fqbGj");

var $k6T4f = parcelRequire("k6T4f");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5oFIy = parcelRequire("5oFIy");

var $hd2Cc = parcelRequire("hd2Cc");
const $cf909fe934837f3e$export$af60a7ae4202be66 = 'jsw-pp-end-user-activated-confluence_v2';
const $cf909fe934837f3e$var$StyledNudge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...restProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf909fe934837f3e$var$NudgeWrapper, {
        ...restProps,
        ref: ref,
        "data-testid": nudgeTestId
    }, children));
const $cf909fe934837f3e$export$e44c6e87aab1f81 = ({ children: children, isFocussed: isFocussed, stop: stop, markAsSeen: markAsSeen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [dismissed, setDismissed] = (0, $5uXOq.useState)(false);
    const spotlightRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)(); // show the spotlight when focussed (via keyboard)
    (0, $5uXOq.useEffect)(()=>{
        if (isFocussed) spotlightRef.current?.toggleCardVisibility?.(true);
    }, [
        isFocussed,
        spotlightRef
    ]);
    const hideMessage = (0, $5uXOq.useCallback)(()=>{
        setDismissed(true);
        stop?.();
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'endUserActivateProjectPagesSpotlight dismissed', {
            messageId: $cf909fe934837f3e$export$af60a7ae4202be66
        });
    }, [
        createAnalyticsEvent,
        stop
    ]);
    const handleOkClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'endUserActivateProjectPagesSpotlightDismissButton', {
            messageId: $cf909fe934837f3e$export$af60a7ae4202be66
        });
        hideMessage();
    }, [
        createAnalyticsEvent,
        hideMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "endUserActivateProjectPagesSpotlightNudge",
        sourceType: "Screen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            messageId: $cf909fe934837f3e$export$af60a7ae4202be66
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqbGj.NudgeSpotlight), {
        ref: spotlightRef,
        hidden: dismissed,
        setHidden: hideMessage,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "endUserActivateProjectPagesSpotlight",
            sourceType: "Screen"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                messageId: $cf909fe934837f3e$export$af60a7ae4202be66
            }
        }), formatMessage((0, $hd2Cc.default).content)),
        actions: [
            {
                text: formatMessage((0, $hd2Cc.default).primaryActionText),
                onClick: handleOkClick
            }
        ],
        position: "right-end",
        onOutsideClick: hideMessage,
        nudgeTestId: `${$cf909fe934837f3e$export$af60a7ae4202be66}-nudge`,
        cardTestId: `${$cf909fe934837f3e$export$af60a7ae4202be66}-card`,
        showSpotlightCardOnFirstRender: false,
        onShow: markAsSeen,
        nudge: $cf909fe934837f3e$var$StyledNudge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        pulse: !dismissed,
        radius: 3,
        testId: `${$cf909fe934837f3e$export$af60a7ae4202be66}-nudge-pulsing-border`
    }, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf909fe934837f3e$var$NudgeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrv77o _vtwzu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fqbGj", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $8ea39cee960047f1$export$eebbda33f5d4d735);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jC4R5 = parcelRequire("jC4R5");

var $k8nZq = parcelRequire("k8nZq");

var $4oNEb = parcelRequire("4oNEb");

var $cBeZP = parcelRequire("cBeZP");

var $4AhK0 = parcelRequire("4AhK0");

var $4aeUu = parcelRequire("4aeUu");

var $ao4Ml = parcelRequire("ao4Ml");
const $8ea39cee960047f1$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $8ea39cee960047f1$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $4AhK0.default), nudge: Nudge = (0, $jC4R5.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $5uXOq.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $5uXOq.useRef)(null);
    const spotlightCardRef = (0, $5uXOq.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $5uXOq.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $5uXOq.useState)(false);
    const stopBlink = (0, $5uXOq.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $5uXOq.useRef)({
        fn: ()=>{}
    });
    (0, $5uXOq.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $5uXOq.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $5uXOq.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $5uXOq.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $5uXOq.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $5uXOq.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $5uXOq.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $5uXOq.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $cBeZP.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $8ea39cee960047f1$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $5uXOq.useMemo)(()=>Spotlight === (0, $4AhK0.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4aeUu.SpotlightContainer), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $8ea39cee960047f1$export$2e2bcd8739ae039 = $8ea39cee960047f1$export$eebbda33f5d4d735;

});
parcelRegister("jC4R5", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $d88355bc6c5eb74c$export$b7d614104f4a4a7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5XLZB = parcelRequire("5XLZB");
const $d88355bc6c5eb74c$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5XLZB.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));

});
parcelRegister("5XLZB", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $589071e97cffed79$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k5uoT = parcelRequire("k5uoT");

var $VSDnB = parcelRequire("VSDnB");
function $589071e97cffed79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $589071e97cffed79$var$baseShadow = '0 0 0 3px';
const $589071e97cffed79$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P75})`;
const $589071e97cffed79$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $589071e97cffed79$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $589071e97cffed79$var$pulseAnimation = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animation: `pulseKeyframes 3000ms ${$589071e97cffed79$var$easing} infinite`
});
const $589071e97cffed79$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $589071e97cffed79$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $589071e97cffed79$var$pulseAnimation
            ]
        }
    });
const $589071e97cffed79$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $k5uoT.borderRadius)(), pulseColor: pulseColor = $589071e97cffed79$var$basePulseColor, pulseShadowColor: pulseShadowColor = $589071e97cffed79$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(CastTargetContainer, {
        css: [
            $589071e97cffed79$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $VSDnB.fg)('jira_onboarding_experiences_a11y_fixes') && $589071e97cffed79$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $589071e97cffed79$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};

});


parcelRegister("4AhK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b690ab706aa80c88$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");


var $f8Sb3 = parcelRequire("f8Sb3");
function $b690ab706aa80c88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b690ab706aa80c88$var$borderRadius = 3;
const $b690ab706aa80c88$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
    borderRadius: `${$b690ab706aa80c88$var$borderRadius}px`,
    overflow: 'auto'
};
const $b690ab706aa80c88$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $b690ab706aa80c88$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $b690ab706aa80c88$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $829f609a65d26a98$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $829f609a65d26a98$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        }
    });
const $b690ab706aa80c88$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        css: $b690ab706aa80c88$var$actionItemStyles(index),
        ...rest
    });
const $b690ab706aa80c88$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $b690ab706aa80c88$export$b3ae98194e057550 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $5uXOq.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($b690ab706aa80c88$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$b690ab706aa80c88$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$headerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $b690ab706aa80c88$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$actionItemContainerStyles
    }, renderedActions))));
});
var $b690ab706aa80c88$export$2e2bcd8739ae039 = $b690ab706aa80c88$export$b3ae98194e057550;

});

parcelRegister("4aeUu", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $99a240fc01f7ca0b$export$d0f55839b708c0a0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $k8nZq = parcelRequire("k8nZq");
const $99a240fc01f7ca0b$export$474e8ee88cc7cd8f = 200;
const $99a240fc01f7ca0b$export$3d6f334bf7dc4597 = 120;
const $99a240fc01f7ca0b$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$99a240fc01f7ca0b$export$474e8ee88cc7cd8f}ms`
};
const $99a240fc01f7ca0b$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$99a240fc01f7ca0b$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $99a240fc01f7ca0b$var$timeoutDurations = {
    enter: 0,
    exit: $99a240fc01f7ca0b$export$3d6f334bf7dc4597
};
const $99a240fc01f7ca0b$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $99a240fc01f7ca0b$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink,
        children: (state)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...containerStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$99a240fc01f7ca0b$var$defaultTransitionStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$99a240fc01f7ca0b$var$statefulTransitionStyles[state]
                    },
                    ref: ref,
                    "aria-labelledby": ariaLabelledBy,
                    ...rest
                })
            })
    }));

});


parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $cb25w.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("hd2Cc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5cd796d16315ac4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c5cd796d16315ac4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    content: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.end-user-activate-nudge-provider.nudge.content",
        "defaultMessage": "Collaborate on product requirements, documentation, plans, and so much more."
    },
    primaryActionText: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.end-user-activate-nudge-provider.nudge.primary-action-text",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("jvHQd", function(module, exports) {

$parcel$export(module.exports, "useShowProjectPagesSpotlightSeenStatus", () => $fa98bfcce54b89aa$export$d2a473f76f614377);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $90yGq = parcelRequire("90yGq");
const $fa98bfcce54b89aa$export$d2a473f76f614377 = (messageId)=>{
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const propertyKey = `${messageId}.seen`;
    const accountId = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        if (accountId) (0, $89SaW.getUserProperty)(accountId, propertyKey).then(()=>{
            setShowSpotlight(false);
        }).catch((error)=>{
            // If we can't find key, we know user never seen the spotlight
            if (error.statusCode === 404) {
                setShowSpotlight(true);
                return;
            }
            (0, $2YZCu.default).safeErrorWithoutCustomerData('useShowProjectPagesSpotlightSeenStatus', `Error reading data from getUserProperty with property key ${propertyKey}`, error);
        });
        else (0, $2YZCu.default).safeErrorWithoutCustomerData('useShowProjectPagesSpotlightSeenStatus', `Can not read data from getUserProperty with property key ${propertyKey} because accountId is missing`);
    }, [
        accountId,
        propertyKey
    ]);
    const markAsSeen = (0, $5uXOq.useCallback)(()=>{
        if (accountId) (0, $89SaW.setUserProperties)(accountId, propertyKey, 'true').then((res)=>{
            if (res.ok) return;
            res.text().then((errResp)=>{
                throw new (0, $jJZqs.default)(res.status, errResp);
            });
        }).catch((error)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('useShowProjectPagesSpotlightSeenStatus', `Failed to update the value in setUserProperties with property key ${propertyKey}`, error));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData('useShowProjectPagesSpotlightSeenStatus', `Can not set data using setUserProperties with property key ${propertyKey} because accountId is missing`);
    }, [
        accountId,
        propertyKey
    ]);
    return [
        showSpotlight,
        markAsSeen
    ];
};

});
parcelRegister("90yGq", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $903db0de2618ef6c$export$e72033e0f5baa3e);

var $9OXo1 = parcelRequire("9OXo1");
const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});



parcelRegister("7dRTN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $78c30a1a7f0b1479$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $78c30a1a7f0b1479$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectPagesItem: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.project-pages-item",
        "defaultMessage": "Project pages"
    },
    edit: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.edit",
        "defaultMessage": "Edit"
    },
    editProjectPages: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.edit-project-pages",
        "defaultMessage": "Edit project pages"
    },
    pagesItem: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.pages-item",
        "defaultMessage": "Pages"
    },
    projectPagesLozenge: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.project-pages-lozenge",
        "defaultMessage": "Join Team"
    }
});

});



parcelRegister("2gP8z", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $bac5b90628bba66f$export$e29577842f211e22);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $axUP7 = parcelRequire("axUP7");
const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $bac5b90628bba66f$export$e29577842f211e22 = (0, $axUP7.withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);

});

parcelRegister("Uj4ce", function(module, exports) {

$parcel$export(module.exports, "useNavigationAutomationLegacyEnabledResource", () => $c645a2088e7fdbff$export$ca7c07083e4556cd);

var $kJQXA = parcelRequire("kJQXA");

var $2YP9W = parcelRequire("2YP9W");
const $c645a2088e7fdbff$export$ca7c07083e4556cd = ()=>{
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource));
    return {
        data: data,
        loading: loading
    };
};

});

parcelRegister("juTur", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$bc7f6eebc16e6127);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $lpwtK = parcelRequire("lpwtK");

var $3d1up = parcelRequire("3d1up");
const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $3d1up.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $lpwtK.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("3d1up", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $2f6f53381b1f04e0$export$5b5545ed894dc47a);
const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("jsI7v", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $e89a82dba74cf1ac$export$1cb51167b20548a0);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bWqXX = parcelRequire("bWqXX");

var $7CMCs = parcelRequire("7CMCs");

var $iL2Ly = parcelRequire("iL2Ly");

var $6KxGW = parcelRequire("6KxGW");

var $8kM72 = parcelRequire("8kM72");

var $5w5Kh = parcelRequire("5w5Kh");

var $hnmuM = parcelRequire("hnmuM");
const $e89a82dba74cf1ac$export$1cb51167b20548a0 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { data: features } = (0, $8kM72.useDefaultPinFilters)();
    if (features === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5w5Kh.DefaultFilters), {
        pinUrl: pinUrl,
        projectKey: projectKey,
        features: features,
        titleHeaderText: titleHeaderText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jira-navigation-apps-sidebar-common",
        id: "issues.starred-filters-section",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KxGW.StarredFiltersErrorFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerAfter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL2Ly.StarredFiltersContainer), {
        pinUrl: pinUrl,
        projectKey: projectKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnmuM.FiltersFooter), {
        hasFilters: hasFilters
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e89a82dba74cf1ac$var$CompiledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xlv12x7 _1rqn1fxt",
            __cmplp.renderDividerBefore && "_175u1crf",
            __cmplp.renderDividerAfter && "_1we51crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iL2Ly", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersContainer", () => $1ec2742e0426c5a8$export$f5b4503a4a7ca418);

var $59JDz = parcelRequire("59JDz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bWqXX = parcelRequire("bWqXX");

var $VILOn = parcelRequire("VILOn");

var $a3OKn = parcelRequire("a3OKn");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $bATyw = parcelRequire("bATyw");

var $koeKL = parcelRequire("koeKL");

var $2YP9W = parcelRequire("2YP9W");

var $aV2yn = parcelRequire("aV2yn");

var $8Jljs = parcelRequire("8Jljs");
const $1ec2742e0426c5a8$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.;
    const [localStorageData] = (0, $5uXOq.useState)((0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
    const { data: resourceData } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    // get value from localStorage if available, get from the resource if this code runs in SSR
    let isNinGlobalScopeEnrolmentEnabled;
    if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
    const baseHref = (0, $aV2yn.getStarredFilterLink)({
        projectKey: projectKey,
        pinUrl: pinUrl,
        shouldStayProjectScope: isNinGlobalScopeEnrolmentEnabled
    });
    const data = (0, $8Uumt.usePreloadedQuery)((0, $59JDz.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Jljs.StarredFiltersList), {
        baseHref: baseHref,
        jiraQuery: data.jira,
        onFavouritesChanged: onFavouritesChanged
    });
};
const $1ec2742e0426c5a8$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
    const { queryReference: resourceQueryRef } = (0, $ao2h1.useRelayResource)((0, $a3OKn.sidebarProjectIssuesResource));
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $59JDz.default), resourceQueryRef);
    const cloudId = (0, $koeKL.useCloudId)();
    const loadSidebarData = (0, $5uXOq.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        cloudId,
        loadQuery
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!queryReference) loadSidebarData();
    }, [
        loadSidebarData,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "starred-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null)
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ec2742e0426c5a8$export$3be6ba2fb4838e7e, {
        queryReference: queryReference,
        onFavouritesChanged: loadSidebarData,
        pinUrl: pinUrl,
        projectKey: projectKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null));
};

});
parcelRegister("59JDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc7247f574fad09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9654d948e0d21eca1746252fbb0b581>>
 * @relayHash 62d616b47f1dfc22a4c3e97140061306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e
const $6bc7247f574fad09$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditable"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;

});

parcelRegister("VILOn", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $5dc42c779a970b72$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $5dc42c779a970b72$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $5dc42c779a970b72$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $5dc42c779a970b72$export$458eda2352a1e223);

var $bSSG7 = parcelRequire("bSSG7");

var $2YZCu = parcelRequire("2YZCu");
const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, $bSSG7.createLocalStorageProvider)('nin-changeboarding');
const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $5dc42c779a970b72$export$34434fbbe40a8047();
    }
};
const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("a3OKn", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $b491cf2963738bcf$export$be31dd7adcfd2297);

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $6YG83 = parcelRequire("6YG83");
const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $59JDz.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});

parcelRegister("bATyw", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $a818348721ae6866$export$3f6390b4131d761b);

var $2M1hQ = parcelRequire("2M1hQ");

const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("fjGDd"));
const $a818348721ae6866$export$3f6390b4131d761b = (0, $2M1hQ.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $a818348721ae6866$var$getDataLoader
});

});
parcelRegister("fjGDd", function(module, exports) {

let $b269b315f9daed49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b269b315f9daed49$var$load("f9qz1").then(()=>parcelRequire('dIecw'));

});


parcelRegister("aV2yn", function(module, exports) {

$parcel$export(module.exports, "getStarredFilterLink", () => $a754d4f1af7bcc7d$export$7082c02465d0ecd4);
const $a754d4f1af7bcc7d$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
    if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
    // xxx/issues?filter=123 -> xxx/issues
    const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
    return shouldStayProjectScope ? craftedPinUrl : '/issues/';
};

});

parcelRegister("8Jljs", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersList", () => $0208f837fc89d8ec$export$b7f4b26a8737eee0);

var $47bDC = parcelRequire("47bDC");

var $jUReQ = parcelRequire("jUReQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $b2GBS = parcelRequire("b2GBS");

var $kZDjT = parcelRequire("kZDjT");

var $4ABV3 = parcelRequire("4ABV3");
var $0208f837fc89d8ec$var$_StyledSection = /*#__PURE__*/ (0, $47bDC.default)((0, $gjTBi.default)).withConfig({
    componentId: "sc-8ugvpc-0"
})`${(p)=>p._css}`;
const $0208f837fc89d8ec$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $jUReQ.default), jiraQuery);
    (0, $b2GBS.useFavoritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
        // refresh when transitioning from pending to NOT pending
        if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
    });
    const starredFilterEdges = data.favouriteFilters?.edges || [];
    if (!starredFilterEdges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0208f837fc89d8ec$var$_StyledSection, {
        title: formatMessage((0, $4ABV3.messages).newStarredFiltersHeader),
        _css: sectionCustomCss
    }, starredFilterEdges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZDjT.FilterItem), {
            key: edge.node.filterId,
            baseHref: baseHref,
            filter: edge.node,
            customAnalytics: {
                isStarred: true
            }
        }) : null));
};

});
parcelRegister("jUReQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9363fe5268fd6910$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a0ff7cd83606b406c54bd970f933e48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9363fe5268fd6910$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "starredFiltersList_navigationAppsSidebarCommon",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraFilterConnection",
            "kind": "LinkedField",
            "name": "favouriteFilters",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "filterId"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "filterItem_navigationAppsSidebarCommon"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$9363fe5268fd6910$var$node.hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";
var $9363fe5268fd6910$export$2e2bcd8739ae039 = $9363fe5268fd6910$var$node;

});

parcelRegister("b2GBS", function(module, exports) {

$parcel$export(module.exports, "useFavoritesChangeEffect", () => $0fca8b6d7b43f931$export$659f59218fc5dd14);

var $5uXOq = parcelRequire("5uXOq");

var $4f8Oj = parcelRequire("4f8Oj");

var $4041n = parcelRequire("4041n");

var $1XJ20 = parcelRequire("1XJ20");
const $0fca8b6d7b43f931$export$659f59218fc5dd14 = (type, effect)=>{
    const { items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
    const typeItems = items[type];
    const pendingChanges = (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(typeItems, (item)=>item.pending);
    const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
    const previousHasPendingChanges = (0, $1XJ20.usePreviousWithInitial)(hasPendingChanges);
    (0, $5uXOq.useEffect)(()=>{
        effect(hasPendingChanges, previousHasPendingChanges);
    }, [
        effect,
        hasPendingChanges,
        previousHasPendingChanges
    ]);
};

});
parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $iJZ8l.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $1Y49U = parcelRequire("1Y49U");

var $1WQct = parcelRequire("1WQct");

var $k0goX = parcelRequire("k0goX");

var $gbLWS = parcelRequire("gbLWS");

var $89DrR = parcelRequire("89DrR");

var $j5YhT = parcelRequire("j5YhT");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $j5YhT.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $gbLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $k0goX.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $89DrR.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $1WQct.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $1Y49U.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});

parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});


parcelRegister("kZDjT", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $f981c975abc56594$export$3cf161fcd24b6b4f);

var $lE53e = parcelRequire("lE53e");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $k0ZZ2 = parcelRequire("k0ZZ2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f981c975abc56594$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
const $f981c975abc56594$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
    const { filterId: filterId, name: name } = (0, $8Uumt.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $lE53e.default), /* eslint-enable @atlassian/relay/unused-fields */ filter);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            ...customAnalytics || {},
            itemId: `filter-${filterId}`
        }), [
        customAnalytics,
        filterId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        key: filterId,
        analytics: analyticsAttributes,
        selectedOn: $f981c975abc56594$var$selectedOn,
        href: `${baseHref}?filter=${filterId}`
    }, name);
};

});
parcelRegister("lE53e", function(module, exports) {

$parcel$export(module.exports, "default", () => $251d70d9349441ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<331a8e20fbd9d2a81b2d41dfa21f3810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $251d70d9349441ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "filterItem_navigationAppsSidebarCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$251d70d9349441ea$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
var $251d70d9349441ea$export$2e2bcd8739ae039 = $251d70d9349441ea$var$node;

});


parcelRegister("4ABV3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f94c0f775539d45d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f94c0f775539d45d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    newStarredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});



parcelRegister("6KxGW", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersErrorFallback", () => $48c59f757828f109$export$70765d6359132b82);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $92Z2l = parcelRequire("92Z2l");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $b1xML = parcelRequire("b1xML");
const $48c59f757828f109$export$70765d6359132b82 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48c59f757828f109$var$SectionWrapper, {
        // TODO remove SectionWrapper once @atlaskit/section design gets updated
        title: formatMessage((0, $b1xML.default).starredFiltersHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, formatMessage((0, $b1xML.default).errorMessage, {
        link: (linkText)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                spacing: "none",
                onClick: ()=>window.location.reload()
            }, linkText)
    })));
};
// TODO remove SectionWrapper once @atlaskit/section design gets updated
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48c59f757828f109$var$SectionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $gjTBi.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt3i2wt _euf41fxt _1qdg1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("b1xML", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc624d55e9cb181d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dc624d55e9cb181d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
        "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
    },
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});


parcelRegister("8kM72", function(module, exports) {

$parcel$export(module.exports, "useDefaultPinFilters", () => $42363ac07745a31e$export$3c69152f8409a017);

var $5uXOq = parcelRequire("5uXOq");

var $1b36n = parcelRequire("1b36n");

var $2YP9W = parcelRequire("2YP9W");
const $42363ac07745a31e$export$3c69152f8409a017 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $2YP9W.useResource)((0, $1b36n.staticSidebarDefaultPINFiltersResource));
    (0, $5uXOq.useEffect)(()=>{
        if (data == null && error == null && loading === false) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return {
        data: data,
        loading: loading
    };
};

});
parcelRegister("1b36n", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $f0c33588b62c7651$export$d3efe54a881807bf);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $elyZV = parcelRequire("elyZV");
const $f0c33588b62c7651$export$d3efe54a881807bf = (0, $2M1hQ.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $elyZV.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("elyZV", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $88433d457c0f5220$export$268c1bcb44a0ddd3);

var $eusud = parcelRequire("eusud");
const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $eusud.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});



parcelRegister("5w5Kh", function(module, exports) {

$parcel$export(module.exports, "DefaultFilters", () => $68067cb39e642d05$export$5df36bcfaa4d1f9d);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $gjTBi = parcelRequire("gjTBi");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $doZTA = parcelRequire("doZTA");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $irHAa = parcelRequire("irHAa");

var $2q4IS = parcelRequire("2q4IS");
const $68067cb39e642d05$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ match: match, location: location }] = (0, $doZTA.useRouter)();
    // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $ebyGx.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).issuesIssueTermRefresh : (0, $irHAa.messages).issues) : titleHeaderText;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $4OCke.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $4OCke.matchUrlParams)([
        'filter'
    ], false);
    // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query URL param should be ignored unless this is for legacy PIN.
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: title
    }, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).ninLayoutAllIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).ninLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allIssuesIssueTermRefresh : (0, $irHAa.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).myOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).myOpenIssues.selectedOn(jql),
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).myOpenIssuesIssueTermRefresh : (0, $irHAa.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).reportedByMe.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).reportedByMe.selectedOn(jql),
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $irHAa.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).notNinLayoutAllIssues.analytics,
        selectedOn: (0, $2q4IS.itemMap).notNinLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allIssuesIssueTermRefresh : (0, $irHAa.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).allOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allOpenIssuesIssueTermRefresh : (0, $irHAa.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).doneIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).doneIssues.selectedOn(jql),
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).doneIssuesIssueTermRefresh : (0, $irHAa.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).viewedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).viewedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $irHAa.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).createdRecently.analytics,
        selectedOn: (0, $2q4IS.itemMap).createdRecently.selectedOn(jql),
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $irHAa.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).resolvedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).resolvedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $irHAa.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).updatedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).updatedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $irHAa.messages).updatedRecently)));
};

});
parcelRegister("4OCke", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $cf3ce1d2a79b8e17$export$63fdecce99465869);

var $f8l56 = parcelRequire("f8l56");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("irHAa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $87feacba5b057fbf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $87feacba5b057fbf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
        "defaultMessage": "Updated recently"
    },
    issuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-issue-term-refresh",
        "defaultMessage": "Work items and filters"
    },
    issuesFiltersIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters-issue-term-refresh",
        "defaultMessage": "Work items and filters"
    },
    myOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues-issue-term-refresh",
        "defaultMessage": "My open work items"
    },
    allIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues-issue-term-refresh",
        "defaultMessage": "All work items"
    },
    allOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues-issue-term-refresh",
        "defaultMessage": "Open work items"
    },
    doneIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues-issue-term-refresh",
        "defaultMessage": "Done work items"
    }
});

});

parcelRegister("2q4IS", function(module, exports) {

$parcel$export(module.exports, "itemMap", () => $414ee2dbecb9ba58$export$1072457701b9918d);

var $kvHKs = parcelRequire("kvHKs");

var $4OCke = parcelRequire("4OCke");
const $414ee2dbecb9ba58$export$1596c397510d46b1 = (filter, jql)=>{
    // Initial load
    if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
    if (filter != null && filter !== 'allissues') return false;
    if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
    return false;
};
const $414ee2dbecb9ba58$export$1072457701b9918d = {
    ninLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>(...args)=>$414ee2dbecb9ba58$export$1596c397510d46b1(undefined, '') || (!jql ? (0, $4OCke.matchUrlParams)([
                    'filter'
                ], false)(...args) : false)
    },
    myOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    reportedByMe: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    notNinLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    allOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
    },
    doneIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    viewedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    createdRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    resolvedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    updatedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    }
};

});


parcelRegister("hnmuM", function(module, exports) {

$parcel$export(module.exports, "FiltersFooter", () => $ca4a87e5b79a11b5$export$c131ccfc44bcd85c);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fcEY2 = parcelRequire("fcEY2");
const $ca4a87e5b79a11b5$var$analyticsPayload = {
    itemId: 'pin-manage-filters'
};
const $ca4a87e5b79a11b5$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: hasFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: $ca4a87e5b79a11b5$var$analyticsPayload,
        href: "/jira/filters"
    }, formatMessage((0, $fcEY2.messages).viewAllFilters)));
};

});
parcelRegister("fcEY2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $905189d98c72b841$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $905189d98c72b841$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});



parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $1UikQ = parcelRequire("1UikQ");

var $d2gYe = parcelRequire("d2gYe");

var $8UO8z = parcelRequire("8UO8z");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $kZ5sr = parcelRequire("kZ5sr");

var $fpoBX = parcelRequire("fpoBX");

var $ai0LF = parcelRequire("ai0LF");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $2fbfde7c900477f4$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5"
};
const $2fbfde7c900477f4$var$customCssFn = (0, $ai0LF.castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
    const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
    const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
    const newStyle = {
        ...(0, $kZ5sr.cssFn)(currentStateAndStyles),
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            color: activeColor
        },
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus': {
            color: baseColor
        },
        '& [data-item-title]': {
            color: baseColor
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(currentStateAndStyles, newStyle);
});
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $5uXOq.createElement(WrapperComponent, null, /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$2fbfde7c900477f4$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $bwpsq.default)([
                iconSecondaryColor && $2fbfde7c900477f4$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $8UO8z.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            cssFn: customItemCssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
                customItemCssFn,
                $2fbfde7c900477f4$var$customCssFn
            ]) : $2fbfde7c900477f4$var$customCssFn
        }, /*#__PURE__*/ $5uXOq.createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("kZ5sr", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $399c9dca906145c0$export$d722961e96b459c5);

var $1UikQ = parcelRequire("1UikQ");

var $gwIPs = parcelRequire("gwIPs");

var $ai0LF = parcelRequire("ai0LF");
const $399c9dca906145c0$export$d722961e96b459c5 = (0, $ai0LF.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
    const newStyle = {
        '[data-item-elem-after] [data-right-arrow]': {
            display: 'none'
        },
        '&:hover [data-item-elem-after]': {
            '& > :not([data-right-arrow])': {
                display: 'none'
            },
            '& [data-right-arrow]': {
                display: 'flex'
            }
        },
        height: `${(0, $gwIPs.gridSize) * 5.5}px`
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(currentStyles, newStyle);
});

});

parcelRegister("kavsL", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $e059487e30c8155a$export$729f3684d5c2b9b9);
const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});


parcelRegister("l468O", function(module, exports) {

$parcel$export(module.exports, "ProjectHeader", () => $3b1d5cf2181bf590$export$69277e177204bdfd);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $fJoTF = parcelRequire("fJoTF");
const $3b1d5cf2181bf590$export$69277e177204bdfd = ({ Avatar: Avatar = (0, $ujWmd.default), Header: Header = (0, $fJoTF.CustomHeader), avatarUrl: avatarUrl, iconBefore: iconBefore, description: description, name: name })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, {
        description: description,
        iconBefore: iconBefore ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: avatarUrl ? `${avatarUrl}?size=xxlarge` : avatarUrl
        })
    }, name);
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jSfqD = parcelRequire("jSfqD");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_vrjt140y _1cmdleuv _1w901jnk _14n4h2mm _1cg71wug _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_16hg1im0",
            item?.color?.default && "_1w901jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        overrides: {
            Title: {
                // eslint-disable-next-line @atlaskit/design-system/use-heading
                render: (_, { children: title, ...props })=>/*#__PURE__*/ $5uXOq.createElement("h2", props, title)
            }
        }
    }, children);
};

});


parcelRegister("3SzZi", function(module, exports) {

$parcel$export(module.exports, "shouldRenderNesting", () => $956cef61e43b05f1$export$a35baff1c4efd3da);
const $956cef61e43b05f1$export$a35baff1c4efd3da = (condition, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));

});

parcelRegister("3tHFY", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $1b0be5b9936240ae$export$19d0925d424b864a);

var $5uXOq = parcelRequire("5uXOq");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");
const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $au6nA.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("au6nA", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $cb371d7d8e582719$export$79762159776e61da);

var $5uXOq = parcelRequire("5uXOq");

var $kvHKs = parcelRequire("kvHKs");
const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation" | "com.codebarrel.addons.automation.moderate__cb-automation"'.
        return items?.filter((item)=>!(0, $kvHKs.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fh2pW", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8vDvO = parcelRequire("8vDvO");

var $gjTBi = parcelRequire("gjTBi");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $jjUR3 = parcelRequire("jjUR3");

var $hrlU6 = parcelRequire("hrlU6");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $3OGaE = parcelRequire("3OGaE");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");
const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const isDialog = item.styleClass && (0, $hrlU6.isConnectDialogWebItem)(item.styleClass);
    const webItemRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
            spacing: "spacious",
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $5uXOq.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
        else item.url != null && addNew(item.url);
    }, [
        addNew,
        isDialog,
        isNested,
        item.styleClass,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $4OCke.matchUrlExact)(),
        iconBefore: icon,
        href: isDialog ? undefined : item.url,
        onClick: onItemClick,
        ref: webItemRef
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2bd062d7c8c5e44$var$ConnectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUo88", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $89b5b8a4b358ad27$export$93509ff9a62ee022);

var $7RRGT = parcelRequire("7RRGT");
const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $7RRGT.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("jjUR3", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $c499ec49965fe6fe$export$c251e3fda1cce4a3);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
// A single instance for the entire SPA session
const $c499ec49965fe6fe$var$history = {
    unique: []
};
const $c499ec49965fe6fe$export$c251e3fda1cce4a3 = ()=>{
    (0, $gKZoD.di)(window);
    const addNew = (0, $5uXOq.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $c499ec49965fe6fe$var$history.unique.push(historyItem);
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            history: $c499ec49965fe6fe$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $c499ec49965fe6fe$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $c499ec49965fe6fe$var$history.unique.length = 0;
};

});

parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("3hUjN"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("3hUjN", function(module, exports) {

let $264ea540dc548cff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $264ea540dc548cff$var$load("aVR4N").then(()=>parcelRequire('8vJyT'));

});



parcelRegister("eYDk7", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $eea5dc8ebf00d36e$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $eea5dc8ebf00d36e$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $eea5dc8ebf00d36e$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $eea5dc8ebf00d36e$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $eea5dc8ebf00d36e$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $lD23V.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $lD23V.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $gwIPs.gridSize), "px"),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3OGaE", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $09f1bcc415909488$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fJoTF = parcelRequire("fJoTF");
const $09f1bcc415909488$var$overrideStyles = null;
const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJoTF.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $bwpsq.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});



parcelRegister("hWtQt", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $a740427f233367ba$export$a1c75c386c088992);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $a740427f233367ba$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, $5W6pd.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("7tsV0", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $93fa8c16baad19b1$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
        const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("k0iPT", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $c82776b15970ab04$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $c82776b15970ab04$export$c47bf667d3008c53);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $c82776b15970ab04$export$50c2d6bcb0b94b74);
const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
    'classic-business-overview-summary',
    'classic-business-overview-calendar',
    'classic-business-overview-timeline',
    'classic-business-overview-redirect'
]);
const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $c82776b15970ab04$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});


parcelRegister("5W6pd", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $1efacbf40a7b73c8$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $1efacbf40a7b73c8$export$27267b6b6650eaa5);
const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("jfqNX", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $662340ab1e9d2787$export$41a50100db18b578);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $662340ab1e9d2787$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("gZbSF", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $fcf7bc53994ae8f3$export$f23d0c24c77d7608);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("6hMYg", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsForgeApps", () => $2106846b1818d2e6$export$bef2e514007d2f07);
$parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", () => $2106846b1818d2e6$export$b741e3e3cfb39b82);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $2YP9W = parcelRequire("2YP9W");

var $kKdpt = parcelRequire("kKdpt");

var $7Tlti = parcelRequire("7Tlti");
const $2106846b1818d2e6$export$bef2e514007d2f07 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgeProjectSettingsModuleResource));
    const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
        isAdmin,
        isSiteAdmin,
        projectContext?.isProjectAdmin
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectSettingsData ? hasPermissions && projectSettingsData || [] : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error
        }), [
        projectSettingsData,
        accessNarrowedData,
        loading,
        error,
        hasPermissions
    ]);
};
const $2106846b1818d2e6$var$appsProjectTypeRouteMap = {
    tmp: {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        // it's genuinely missing Jira Product Discovery and CUSTOMER_SERVICE_PROJECT support
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: undefined
    },
    cmp: {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software/c',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: undefined
    }
};
const $2106846b1818d2e6$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$2106846b1818d2e6$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};
const $2106846b1818d2e6$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: data, loading: loading, error: error } = $2106846b1818d2e6$export$bef2e514007d2f07();
    const stack = (0, $kKdpt.useForgeItemStack)(data, routeName, parentStack);
    const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
    return (0, $5uXOq.useMemo)(()=>({
            data: data ? data.map((extension)=>({
                    id: extension.id,
                    // @ts-expect-error - TS2345 - Argument of type 'ProjectType | undefined' is not assignable to parameter of type 'ProjectType'.
                    url: $2106846b1818d2e6$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                    name: extension.properties.title,
                    iconUrl: extension.properties.icon,
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    moduleName: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
                    sections: (0, $7Tlti.toSections)(extension)
                })) : null,
            loading: loading,
            error: error,
            stack: stack
        }), [
        data,
        loading,
        error,
        stack,
        projectType,
        projectKey,
        isSimplified
    ]);
};

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("kKdpt", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $dac9c7c54c5ccbb1$export$462f82a278743d46);

var $5uXOq = parcelRequire("5uXOq");

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");

var $7Tlti = parcelRequire("7Tlti");
const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const matchedExtension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $7Tlti.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});
parcelRegister("c70gQ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $b661f1f04cec9385$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $b661f1f04cec9385$export$25abed85383f0fbb);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");
const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $e0AC8.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});

parcelRegister("7Tlti", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $25b31557e9750c03$export$29678d1e04c0e8c4);

var $8QpSo = parcelRequire("8QpSo");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $25b31557e9750c03$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, $8QpSo.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($25b31557e9750c03$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($25b31557e9750c03$var$normalizeSection);
    return [];
});

});



parcelRegister("231OU", function(module, exports) {

$parcel$export(module.exports, "useProjectForgeApps", () => $1a247d2d1d6e7cdf$export$338edd25edcf3648);
$parcel$export(module.exports, "useProjectForgeAppsNav4", () => $1a247d2d1d6e7cdf$export$80e84933a3e2f677);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $324W5 = parcelRequire("324W5");

var $kKdpt = parcelRequire("kKdpt");
const $1a247d2d1d6e7cdf$export$338edd25edcf3648 = (routeName, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $5bkvv.forgeProjectModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $kKdpt.useForgeItemStack)(projectData, routeName);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $1a247d2d1d6e7cdf$export$80e84933a3e2f677 = (projectKey)=>$1a247d2d1d6e7cdf$export$338edd25edcf3648(undefined, projectKey);

});

parcelRegister("iIGGa", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskQueueForgeApps", () => $1febfd879444642e$export$8a2bb837db423089);
$parcel$export(module.exports, "useServiceDeskQueueForgeAppsNav4", () => $1febfd879444642e$export$52b0be0dcb122e71);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $324W5 = parcelRequire("324W5");

var $kKdpt = parcelRequire("kKdpt");
const $1febfd879444642e$export$8a2bb837db423089 = (routeName, parentStack, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $5bkvv.forgeServiceDeskQueueModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const serviceDeskQueueData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $kKdpt.useForgeItemStack)(serviceDeskQueueData, routeName, parentStack);
    return (0, $5uXOq.useMemo)(()=>({
            data: serviceDeskQueueData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        serviceDeskQueueData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $1febfd879444642e$export$52b0be0dcb122e71 = (projectKey)=>$1febfd879444642e$export$8a2bb837db423089(undefined, undefined, projectKey);

});

parcelRegister("8zgGo", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $4cec53abbd9c3c33$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeProjectSection", () => $4cec53abbd9c3c33$export$fb7da191295a7e22);
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $2vSU6 = parcelRequire("2vSU6");

var $1rTGO = parcelRequire("1rTGO");

var $bXK4r = parcelRequire("bXK4r");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $dAfqg = parcelRequire("dAfqg");

var $k51JQ = parcelRequire("k51JQ");

var $7Tlti = parcelRequire("7Tlti");

var $231OU = parcelRequire("231OU");

var $kBPYs = parcelRequire("kBPYs");
// @ts-expect-error - It's genuinely missing Jira Product Discovery.
const $4cec53abbd9c3c33$var$projectTypeRouteMap = {
    [(0, $2vSU6.CORE_PROJECT)]: 'core',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $4cec53abbd9c3c33$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$4cec53abbd9c3c33$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $4cec53abbd9c3c33$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
    const { data: data } = (0, $231OU.useProjectForgeApps)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const filteredForgeAppsData = (0, $5uXOq.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
            overrides.selectedApp
        ] : data || [], [
        data,
        overrides
    ]);
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey, projectType: projectType } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bXK4r.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, $kBPYs.messages).forgeSectionTitle)
    }, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $4cec53abbd9c3c33$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            moduleName: (0, $k2DRb.PROJECT_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true,
            nestedMenuActive: nestedMenuActive,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PROJECT_PAGE_MODULE)
        }
    })));
};

});
parcelRegister("1rTGO", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $abbdb580491d9d09$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $abbdb580491d9d09$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $abbdb580491d9d09$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $abbdb580491d9d09$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $abbdb580491d9d09$export$14e56d7f5d3f917c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $eOGyv = parcelRequire("eOGyv");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $isuse = parcelRequire("isuse");

var $4R6GH = parcelRequire("4R6GH");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $dd7Uh = parcelRequire("dd7Uh");

var $2RhPB = parcelRequire("2RhPB");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");
const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: (0, $6MtPV.createAttributes)(attributes)
    });
const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $dd7Uh.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $eOGyv.useHasForgeAccess)();
    const analyticsAttributes = (0, $4R6GH.fg)('custom_fields_attempt_event_optimization') ? (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]) : (0, $6MtPV.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, (0, $9BrHy.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: fireEvent
    });
};
const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6MtPV.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hBuqR.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $9BrHy.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $k2DRb.CUSTOM_FIELD_MODULE) || extensionModule === (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $k2DRb.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $k2DRb.GLOBAL_PAGE_MODULE),
        (0, $k2DRb.ISSUE_ACTION_MODULE),
        (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
        (0, $k2DRb.ISSUE_CONTEXT_MODULE),
        (0, $k2DRb.ISSUE_GLANCE_MODULE),
        (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
        (0, $k2DRb.ISSUE_PANEL_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.ADMIN_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        (0, $k2DRb.BACKLOG_ACTION_MODULE),
        (0, $k2DRb.BOARD_ACTION_MODULE),
        (0, $k2DRb.SPRINT_ACTION_MODULE),
        (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $5uXOq.useRef)(performance.now());
        const isCustomUI = (0, $3mOWa.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $9BrHy.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        }) : (0, $9BrHy.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $5uXOq.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $5uXOq.useCallback)(()=>{
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $dd7Uh.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("3mOWa", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $e79bbc527e600bd1$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $e79bbc527e600bd1$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $e79bbc527e600bd1$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $e79bbc527e600bd1$export$42b85bc9b386c977);

var $gccSB = parcelRequire("gccSB");
const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $e79bbc527e600bd1$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
    const { resource: resource } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("eOGyv", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);

var $cZpsT = parcelRequire("cZpsT");
const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return !isAnonymous;
};

});
parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});


parcelRegister("isuse", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $1df0619a43ad69d9$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
// eslint-disable-next-line jira/react/no-class-components
class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, $cb25w.default)()($1df0619a43ad69d9$var$MountEventComponent);

});

parcelRegister("dd7Uh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $7d829a81d29f9e72$export$add44f896fb31ba3);

var $hBuqR = parcelRequire("hBuqR");

var $8uOa6 = parcelRequire("8uOa6");
const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("2RhPB", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $3fba0b567cec1fe0$export$5d3b06ab08af139e);

var $3mOWa = parcelRequire("3mOWa");

var $e0AC8 = parcelRequire("e0AC8");
const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $3mOWa.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});

parcelRegister("9BrHy", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $10bc2a9e37d5a5bb$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $10bc2a9e37d5a5bb$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);

var $k2DRb = parcelRequire("k2DRb");

var $6yg2S = parcelRequire("6yg2S");

var $hBuqR = parcelRequire("hBuqR");
const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, $k2DRb.SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hBuqR.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("bXK4r", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $488beba58e0bb189$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $488beba58e0bb189$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $488beba58e0bb189$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $488beba58e0bb189$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("k51JQ", function(module, exports) {

$parcel$export(module.exports, "ForgeSubpagesView", () => $b3f0da209e047dcf$export$9711365f685f75c0);
$parcel$export(module.exports, "ForgeItem", () => $b3f0da209e047dcf$export$26a5287439a1d287);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8vDvO = parcelRequire("8vDvO");

var $gjTBi = parcelRequire("gjTBi");

var $8kVg1 = parcelRequire("8kVg1");

var $fl3Yy = parcelRequire("fl3Yy");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $jv9Yy = parcelRequire("jv9Yy");

var $8iQMc = parcelRequire("8iQMc");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");

var $4R6GH = parcelRequire("4R6GH");
const $b3f0da209e047dcf$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $b3f0da209e047dcf$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeIcon, {
        alt: "",
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
        spacing: "spacious",
        label: ""
    });
const $b3f0da209e047dcf$export$df3259e43d89ee7b = (props)=>{
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    const onClick = ()=>{
        (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
            startTime: performance.now()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        href: url,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        analytics: {
            itemId: itemId,
            itemType: 'forge',
            module: moduleName
        },
        onClick: (0, $4R6GH.fg)('arken-1562_full_page_performance_metric_addition') ? undefined : onClick
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};
const $b3f0da209e047dcf$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, $8iQMc.ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgePageHeader, {
        avatarUrl: iconUrl || '',
        name: name,
        environmentType: environmentType,
        environmentKey: environmentKey,
        nestedMenuActive: nestedMenuActive
    });
const $b3f0da209e047dcf$export$9711365f685f75c0 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
    const selectedOn = (0, $5uXOq.useCallback)((route)=>[
            '',
            '/'
        ].includes(String(route || '').trim()) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, $4OCke.matchPartialUrlPathname)(), []);
    const onClick = ()=>{
        (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
            startTime: performance.now()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeSubpagesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$961eebe0deda9ad3, props), sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
            key: index
        }, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jv9Yy.SectionHeader), null, section.header) : null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
                key: page.route,
                iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                    url: page.icon
                }) : null,
                href: $b3f0da209e047dcf$export$9ffb311b483a1e2b(url, page.route),
                selectedOn: selectedOn(page.route),
                analytics: {
                    itemId: itemId,
                    itemType: 'forge',
                    module: moduleName
                },
                onClick: (0, $4R6GH.fg)('arken-1562_full_page_performance_metric_addition') ? undefined : onClick
            }, page.title)))));
};
const $b3f0da209e047dcf$export$26a5287439a1d287 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const selectedOn = (0, $5uXOq.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
        url
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$df3259e43d89ee7b, props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'subpages'
        },
        id: `${itemId}-subpages`,
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        title: (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey),
        selectedOn: selectedOn,
        onClick: onNestedMenuItemClick,
        // @ts-expect-error - overrides types mismatch
        overrides: overrides
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b3f0da209e047dcf$var$ForgeSubpagesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_14tkpxbi _t3zcv47k _1so41gjq",
            __cmplp.className
        ])
    });
});
const $b3f0da209e047dcf$var$ForgeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fl3Yy", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $730173a4987fa3e4$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $730173a4987fa3e4$export$f9338c21ba7c7334);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $k2DRb = parcelRequire("k2DRb");

var $ousew = parcelRequire("ousew");

var $8Je4V = parcelRequire("8Je4V");
const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $k2DRb.DEVELOPMENT_ENVIRONMENT:
            return (0, $8Je4V.messages).developmentEnvironmentLozenge;
        case 0, $k2DRb.STAGING_ENVIRONMENT:
            return (0, $8Je4V.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), labelKey)) : null;
};
const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("8Je4V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $838ac71f7259b5ef$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $838ac71f7259b5ef$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("jv9Yy", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $c634a42deba697de$export$8adb256d999cd5a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c2V4l = parcelRequire("c2V4l");

var $fpoBX = parcelRequire("fpoBX");
const $c634a42deba697de$var$textColorCssVar = '--section-header-text-color';
const $c634a42deba697de$var$opacityCssVar = '--section-header-opacity';
const $c634a42deba697de$var$colorThemeStyles = null;
const $c634a42deba697de$var$opacityThemeStyles = null;
const $c634a42deba697de$export$8adb256d999cd5a0 = ({ children: children })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement((0, $c2V4l.default), {
        // @ts-expect-error - className is a valid prop
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            [$c634a42deba697de$var$opacityCssVar]: item?.opacity,
            [$c634a42deba697de$var$textColorCssVar]: item?.color?.default
        },
        className: (0, $bwpsq.default)([
            item?.opacity && "_3bezblmq",
            item?.color?.default && "_1w90oa1y"
        ])
    }, children);
};

});
parcelRegister("c2V4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6289355db2eea81d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4mNf3 = parcelRequire("4mNf3");

var $jsTfk = parcelRequire("jsTfk");

var $j9VTE = parcelRequire("j9VTE");
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $6289355db2eea81d$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssFn = (0, $jsTfk.overrideStyleFunction)((0, $jsTfk.sectionHeaderSpacingStyles), props.cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides, @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4mNf3.default), {
        ...props,
        cssFn: cssFn
    });
};
var $6289355db2eea81d$export$2e2bcd8739ae039 = $6289355db2eea81d$var$HeadingItem;

});


parcelRegister("8iQMc", function(module, exports) {

$parcel$export(module.exports, "ForgePageHeader", () => $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $apKqz = parcelRequire("apKqz");

var $fl3Yy = parcelRequire("fl3Yy");

var $fJoTF = parcelRequire("fJoTF");
const $5bbfd34eb4e2a6d6$var$containerNestedStyles = null;
const $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, $ujWmd.default), AddonIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
AddonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($apKqz))), Header: Header = (0, $fJoTF.CustomHeader), EnvironmentLozenge: EnvironmentLozenge = (0, $fl3Yy.EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, nestedMenuActive: nestedMenuActive })=>{
    return /*#__PURE__*/ $5uXOq.createElement(Header, {
        iconBefore: avatarUrl?.length ? /*#__PURE__*/ $5uXOq.createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: `${avatarUrl}?size=xxlarge`
        }) : /*#__PURE__*/ $5uXOq.createElement(AddonIcon, {
            label: "",
            size: "medium"
        }),
        iconAfter: /*#__PURE__*/ $5uXOq.createElement(EnvironmentLozenge, {
            environmentType: environmentType
        }),
        className: (0, $bwpsq.default)([
            nestedMenuActive && "_1yxx183y"
        ])
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});


parcelRegister("kBPYs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3e1e8355c24b18f2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3e1e8355c24b18f2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


const $980f7c356a507e07$export$7216549face95b5a = 'jsmAdoptionNudges';
const $980f7c356a507e07$export$460011addfd3fbe1 = 'jsm-invite-user-prompt';
const $980f7c356a507e07$export$5f0aa5406cf19560 = 'invite-user-in-jsm-during-key-moments';
const $980f7c356a507e07$export$5b974a711cd5598b = 'jsm_projects_with_core_actions_and_no_team_invite';
const $980f7c356a507e07$export$a0a21d9967c1ebe1 = 'jsm-boards-nav-onboarding';
const $980f7c356a507e07$export$ff3f73f9a85c7472 = 'servicedesk-getting-started-page';

parcelRegister("9QGIi", function(module, exports) {

$parcel$export(module.exports, "useShouldRenderInviteTeamPromptSpotlight", () => $d32165725f09ede1$export$62961213f9d7d703);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $jX0pr = parcelRequire("jX0pr");

var $lOkV6 = parcelRequire("lOkV6");

var $9OXo1 = parcelRequire("9OXo1");

const $d32165725f09ede1$export$62961213f9d7d703 = (customContext)=>{
    const [_, { setIsInviteTeamDialogOpen: setIsInviteTeamDialogOpen }] = (0, $lOkV6.useInviteTeamDialog)();
    const { data: data } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)(customContext) || {};
    const { isAdminAgent: isAdminAgent, project: project } = data || {};
    const { id: projectId } = project || {};
    const [ifTraitExists, setIfTraitExists] = (0, $5uXOq.useState)(false);
    const [loadInviteTeamResource, setLoadInviteTeamResource] = (0, $5uXOq.useState)(false);
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { fetch: fetch } = (0, $jX0pr.useSitePersonalization)();
    const onInviteTeamOnboardingCTAClick = ()=>{
        setLoadInviteTeamResource(true);
        // to open "Invite team" modal from the onboarding spotlight
        setIsInviteTeamDialogOpen(true);
    };
    (0, $5uXOq.useEffect)(()=>{
        const performFetch = async ()=>{
            const personalizationData = await fetch({
                cloudId: cloudId
            });
            personalizationData?.find((trait)=>{
                if (typeof trait.value === 'string' && trait.name === (0, $980f7c356a507e07$export$5b974a711cd5598b)) setIfTraitExists(JSON.parse(trait.value).includes(projectId?.toString()));
                return null;
            });
        };
        performFetch();
    }, [
        cloudId,
        fetch,
        projectId,
        setIfTraitExists
    ]);
    return {
        isInviteTeamSpotlightEnabled: isAdminAgent && ifTraitExists,
        loadInviteTeamResource: loadInviteTeamResource,
        onInviteTeamOnboardingCTAClick: onInviteTeamOnboardingCTAClick
    };
};

});
parcelRegister("lOkV6", function(module, exports) {

$parcel$export(module.exports, "useInviteTeamDialog", () => $767126e5f6642684$export$eee7489dc1099feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $bxTIn = parcelRequire("bxTIn");

const $767126e5f6642684$export$d33043ed8e6f4d24 = (0, $51nlc.createSubscriber)((0, $bxTIn.store), {
    displayName: 'ChannelsDialogSubscriber'
});
const $767126e5f6642684$export$eee7489dc1099feb = (0, $3sQ5x.createHook)((0, $bxTIn.store));

});
parcelRegister("bxTIn", function(module, exports) {

$parcel$export(module.exports, "store", () => $49094acaba247235$export$6f57813fe9f31bf9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $2qtHt = parcelRequire("2qtHt");
const $49094acaba247235$export$d4c72bab9d6cc13a = {
    isInviteTeamDialogOpen: false,
    onDialogUpdated: ()=>Promise.resolve(null)
};
const $49094acaba247235$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'jsd-invite-dialog-service',
    initialState: $49094acaba247235$export$d4c72bab9d6cc13a,
    actions: $2qtHt.actions
});

});
parcelRegister("2qtHt", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9121933cd6dabe45$export$e324594224ef24da);
const $9121933cd6dabe45$export$e324594224ef24da = {
    setIsInviteTeamDialogOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isInviteTeamDialogOpen: isOpen
            });
        },
    setOnDialogUpdated: (onDialogUpdated)=>({ setState: setState })=>{
            setState({
                onDialogUpdated: onDialogUpdated
            });
        }
};

});




parcelRegister("dtVRS", function(module, exports) {

$parcel$export(module.exports, "InviteUserPrompt", () => $f82516b61e7be62f$export$4f1c3a78d3985b91);

var $5uXOq = parcelRequire("5uXOq");

var $eGLgs = parcelRequire("eGLgs");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $gPQRI = parcelRequire("gPQRI");

var $1J3t1 = parcelRequire("1J3t1");

var $12hlA = parcelRequire("12hlA");

var $gq0sA = parcelRequire("gq0sA");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $cNd4s = parcelRequire("cNd4s");

var $doZTA = parcelRequire("doZTA");


var $etO06 = parcelRequire("etO06");
const $f82516b61e7be62f$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);
const $f82516b61e7be62f$export$4f1c3a78d3985b91 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onCTAClick: onCTAClick })=>{
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const [spotlightActive, setSpotlightActive] = (0, $5uXOq.useState)(false);
    const [{ data: pageContextData, loading: pageContextLoading }] = (0, $gq0sA.usePageContext)();
    const { loading: sideBarNavLoading } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)();
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    const { projectContext: projectContext } = pageContextData || {};
    const { projectId: projectId, projectName: projectName, projectKey: projectKey } = projectContext || {};
    const { serviceDesk: jsmEdition } = (0, $k9JTq.useAppEditions)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [isInviteTeamDialogOpen, setIsInviteTeamDialogOpen] = (0, $5uXOq.useState)(false);
    const onOpenAddPeopleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsInviteTeamDialogOpen(true);
    }, [
        setIsInviteTeamDialogOpen
    ]);
    const onCloseAddPeopleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsInviteTeamDialogOpen(false);
    }, [
        setIsInviteTeamDialogOpen
    ]);
    const onFinish = (0, $5uXOq.useCallback)((stop)=>()=>{
            setShowSpotlight(false);
            stop && stop();
        }, [
        setShowSpotlight
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const id = setTimeout(()=>{
            setShowSpotlight(true);
        }, 2000);
        return ()=>{
            clearTimeout(id);
        };
    }, []);
    const [{ route: { name: routeName } }] = (0, $doZTA.useRouter)() || [
        {
            route: {
                name: ''
            }
        }
    ];
    const shouldSuppressSpotlightInGettingStarted = routeName === (0, $980f7c356a507e07$export$ff3f73f9a85c7472);
    (0, $5uXOq.useEffect)(()=>{
        if (!pageContextLoading && !isCollapsed && !sideBarNavLoading && !shouldSuppressSpotlightInGettingStarted) setSpotlightActive(true);
    }, [
        isCollapsed,
        pageContextLoading,
        sideBarNavLoading,
        shouldSuppressSpotlightInGettingStarted
    ]);
    const onClick = (0, $6s1PB.expValEquals)('jsm_core_invites_experiment', 'cohort', 'experiment') ? onOpenAddPeopleDialog : onCTAClick;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "contextual-invite-users-prompt",
        packageName: (0, $980f7c356a507e07$export$7216549face95b5a)
    }, spotlightActive && showSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $980f7c356a507e07$export$5f0aa5406cf19560)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f82516b61e7be62f$var$CoordinationStopProvider, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $etO06.default), {
            props: {
                onFinish: onFinish(stop),
                onCTAClick: onClick
            },
            entryPoints: {},
            extraProps: {},
            queries: {}
        }))) : null, isInviteTeamDialogOpen && projectId && (0, $6s1PB.expValEquals)('jsm_core_invites_experiment', 'cohort', 'experiment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12hlA.default), {
        appEdition: jsmEdition,
        cloudId: cloudId,
        isOpen: isInviteTeamDialogOpen,
        onClose: onCloseAddPeopleDialog,
        projectId: projectId,
        jiraProjectKey: projectKey,
        jiraProjectName: projectName,
        isSiteAdmin: isSiteAdmin
    }));
});

});
parcelRegister("12hlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc8c7c74346f034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $0bc8c7c74346f034$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("75k3H")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;

});
parcelRegister("75k3H", function(module, exports) {

let $52888f40ff68f92e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $52888f40ff68f92e$var$load("hPzOn"),
    $52888f40ff68f92e$var$load("cM9em"),
    $52888f40ff68f92e$var$load("fr9NE"),
    $52888f40ff68f92e$var$load("h2MrD"),
    $52888f40ff68f92e$var$load("bYT2S"),
    $52888f40ff68f92e$var$load("6C6tQ")
]).then(()=>parcelRequire('3dNZP'));

});


parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});
parcelRegister("cAofY", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $9c517de0cdc23225$export$5eaaf465969a9171);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("2WfJW"));
const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $2M1hQ.createResource)({
    type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $dK8AG.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $9c517de0cdc23225$var$getDataLoader,
    maxAge: Infinity
});

});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("2WfJW", function(module, exports) {

let $223d3531a11189cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $223d3531a11189cf$var$load("iNITq").then(()=>parcelRequire('g4PUK'));

});




parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

parcelRegister("etO06", function(module, exports) {

$parcel$export(module.exports, "default", () => $c75546e9194468cc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $hDONF = parcelRequire("hDONF");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ehdJY = parcelRequire("ehdJY");

var $4R6GH = parcelRequire("4R6GH");


var $26afe = parcelRequire("26afe");
// TODO implement the spotlight card ui
const $c75546e9194468cc$var$InviteUsersPromptNudge = ({ props: props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onFinish: onFinish, onCTAClick: onCTAClick } = props;
    const nudge = (0, $5uXOq.useMemo)(()=>({
            actions: [
                {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contextualInviteUserPromptButtonInviteTeam');
                        onFinish();
                        onCTAClick();
                    },
                    text: (0, $6s1PB.expValEquals)('jsm_core_invites_experiment', 'cohort', 'experiment') ? formatMessage((0, $26afe.default).addPeopleButton) : formatMessage((0, $26afe.default).inviteButton)
                },
                {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contextualInviteUserPromptButtonDismiss');
                        onFinish();
                    },
                    text: formatMessage((0, $26afe.default).dismissButton),
                    'aria-label': formatMessage((0, $26afe.default).dismissButtonAriaLabel)
                }
            ],
            message: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $26afe.default).descriptionIssueTermRefresh : (0, $26afe.default).description)
        }), [
        formatMessage,
        createAnalyticsEvent,
        onFinish,
        onCTAClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: (0, $980f7c356a507e07$export$7216549face95b5a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: nudge.actions,
        dialogPlacement: "right bottom",
        dialogWidth: 275,
        targetRadius: 3,
        target: (0, $980f7c356a507e07$export$460011addfd3fbe1),
        key: (0, $980f7c356a507e07$export$460011addfd3fbe1),
        heading: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $26afe.default).headingIssueTermRefresh : (0, $26afe.default).heading),
        messageId: "service-management-adoption-nudges.ui.invite-user-prompt.jira-spotlight",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c75546e9194468cc$var$spotlightStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDONF.default), {
        alt: ""
    })), nudge.message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
var $c75546e9194468cc$export$2e2bcd8739ae039 = $c75546e9194468cc$var$InviteUsersPromptNudge;
const $c75546e9194468cc$var$spotlightStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.0',
    transform: 'translateY(-152px)',
    backgroundColor: 'color.background.discovery.bold',
    left: 'space.0',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px'
});

});
parcelRegister("hDONF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5a10430836b2e2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1USYx")))));

var $dCLgq = parcelRequire("dCLgq");

var $fykKx = parcelRequire("fykKx");

var $1USYx = parcelRequire("1USYx");
const $0f5a10430836b2e2$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1USYx)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fykKx))
});
var $0f5a10430836b2e2$export$2e2bcd8739ae039 = $0f5a10430836b2e2$var$Illustration;
// for advanced use only
const $0f5a10430836b2e2$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    337
];

});
parcelRegister("dCLgq", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $191b30bb5e9fa934$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $191b30bb5e9fa934$export$4d00e7be716a0093);

var $5uXOq = parcelRequire("5uXOq");

var $10ozQ = parcelRequire("10ozQ");
function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10ozQ.AsImg), props);
}
function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("10ozQ", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $b5af8835f639f069$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");
// suggested defaults, the consumer is free to override
const $b5af8835f639f069$var$defaultStyles = null;
const $b5af8835f639f069$var$fillStyles = null;
const $b5af8835f639f069$var$autoDarkModeStyles = null;
function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("fykKx", function(module, exports) {
module.exports = new URL("this-is-new-jira-darkmode.80f28371.png", import.meta.url).toString();

});

parcelRegister("1USYx", function(module, exports) {
module.exports = new URL("this-is-new-jira.80f28371.png", import.meta.url).toString();

});


parcelRegister("ehdJY", function(module, exports) {

$parcel$export(module.exports, "JiraSpotlight", () => $61a8dc1ff1116911$export$e209c6be9ab8c4f4);

var $5uXOq = parcelRequire("5uXOq");

var $7gs1W = parcelRequire("7gs1W");

var $10xFf = parcelRequire("10xFf");

var $5NHqU = parcelRequire("5NHqU");
const $61a8dc1ff1116911$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NHqU.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7gs1W.default), rest);
};

});
parcelRegister("5NHqU", function(module, exports) {

$parcel$export(module.exports, "ChoreographerSpotlight", () => $b7d2a49fe3b12822$export$e01943d134357d00);
// eslint-disable-next-line jira/import/no-restricted-import

var $7gs1W = parcelRequire("7gs1W");

var $cSWNW = parcelRequire("cSWNW");
const $b7d2a49fe3b12822$export$e01943d134357d00 = (0, $cSWNW.withChoreographedRender)((0, $7gs1W.default));

});


parcelRegister("26afe", function(module, exports) {

$parcel$export(module.exports, "default", () => $521b9204e9445547$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $521b9204e9445547$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "service-management-adoption-nudges.invite-user-prompt.heading",
        "defaultMessage": "Teams can resolve 46% of customer issues in a day or less!"
    },
    headingIssueTermRefresh: {
        "id": "service-management-adoption-nudges.invite-user-prompt.heading-issue-term-refresh",
        "defaultMessage": "Teams can resolve 46% of customer work items in a day or less!"
    },
    description: {
        "id": "service-management-adoption-nudges.invite-user-prompt.description",
        "defaultMessage": "Invite more team members to resolve issues faster."
    },
    descriptionIssueTermRefresh: {
        "id": "service-management-adoption-nudges.invite-user-prompt.description-issue-term-refresh",
        "defaultMessage": "Invite more team members to resolve work items faster."
    },
    dismissButton: {
        "id": "service-management-adoption-nudges.invite-user-prompt.dismiss-button",
        "defaultMessage": "Dismiss"
    },
    inviteButton: {
        "id": "service-management-adoption-nudges.invite-user-prompt.invite-button",
        "defaultMessage": "Invite agents"
    },
    dismissButtonAriaLabel: {
        "id": "service-management-adoption-nudges.invite-user-prompt.dismiss-button-aria-label",
        "defaultMessage": "Dismiss message"
    },
    addPeopleButton: {
        "id": "service-management-adoption-nudges.invite-user-prompt.add-people-button",
        "defaultMessage": "Add people"
    }
});

});



parcelRegister("16J3A", function(module, exports) {

$parcel$export(module.exports, "REPORTS_IDS", () => $6fb2b1c825061655$export$1f70a76cb421b107);
$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $6fb2b1c825061655$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "PRACTICES_IDS", () => $6fb2b1c825061655$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $6fb2b1c825061655$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $6fb2b1c825061655$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", () => $6fb2b1c825061655$export$e2d46b728fe0a15a);
$parcel$export(module.exports, "SERVICE_DESK", () => $6fb2b1c825061655$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $6fb2b1c825061655$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $6fb2b1c825061655$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $6fb2b1c825061655$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $6fb2b1c825061655$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $6fb2b1c825061655$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $6fb2b1c825061655$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $6fb2b1c825061655$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $6fb2b1c825061655$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $6fb2b1c825061655$export$9a6deaa9c1af559f);
const $6fb2b1c825061655$var$HOME_QUEUES = 'queues';
const $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $6fb2b1c825061655$var$HOME_INCIDENTS = 'incidents';
const $6fb2b1c825061655$var$HOME_CHANGES = 'changes';
const $6fb2b1c825061655$var$HOME_PROBLEMS = 'problems';
const $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $6fb2b1c825061655$var$HOME_CUSTOMERS = 'customers';
const $6fb2b1c825061655$var$HOME_REPORTS = 'reports';
const $6fb2b1c825061655$var$HOME_RAISE_REQUEST = 'raise-request';
const $6fb2b1c825061655$var$HOME_ISSUES = 'issues';
const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $6fb2b1c825061655$var$HOME_INVITE_TEAM = 'invite-team';
const $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $6fb2b1c825061655$var$HOME_SERVICES = 'services';
const $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $6fb2b1c825061655$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $6fb2b1c825061655$export$9afbea2cbd37e16d = {
    QUEUES: $6fb2b1c825061655$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $6fb2b1c825061655$var$HOME_INCIDENTS,
    CHANGES: $6fb2b1c825061655$var$HOME_CHANGES,
    PROBLEMS: $6fb2b1c825061655$var$HOME_PROBLEMS,
    CUSTOMERS: $6fb2b1c825061655$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $6fb2b1c825061655$var$HOME_REPORTS,
    RAISE_REQUEST: $6fb2b1c825061655$var$HOME_RAISE_REQUEST,
    ISSUES: $6fb2b1c825061655$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $6fb2b1c825061655$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK,
    SERVICES: $6fb2b1c825061655$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $6fb2b1c825061655$var$KNOWLEDGE_BASE_IDS = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $6fb2b1c825061655$var$SETTINGS_IDS = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $6fb2b1c825061655$var$QUEUES_IDS = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $6fb2b1c825061655$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $6fb2b1c825061655$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $6fb2b1c825061655$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $6fb2b1c825061655$var$KNOWLEDGE_BASE_IDS,
        SETTINGS: $6fb2b1c825061655$var$SETTINGS_IDS,
        QUEUES: $6fb2b1c825061655$var$QUEUES_IDS,
        REPORTS: $6fb2b1c825061655$export$1f70a76cb421b107
    }
};
const $6fb2b1c825061655$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $6fb2b1c825061655$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $6fb2b1c825061655$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $6fb2b1c825061655$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $6fb2b1c825061655$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $6fb2b1c825061655$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $6fb2b1c825061655$export$707771f2f7e60575 = 'project/service-desk/reports';
const $6fb2b1c825061655$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $6fb2b1c825061655$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $6fb2b1c825061655$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $6fb2b1c825061655$export$d70ba5c124463035 = 'project/service-desk/translations';
const $6fb2b1c825061655$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});

parcelRegister("htI2Q", function(module, exports) {

$parcel$export(module.exports, "useGettingStartedPageStateActions", () => $33645e86b9772f1d$export$8d2572f02ec0aa4c);
$parcel$export(module.exports, "useIsFirstProjectITSM", () => $33645e86b9772f1d$export$852fe39748ba826d);
$parcel$export(module.exports, "useGetNpleDisabledProjectProperty", () => $33645e86b9772f1d$export$24659fa3abfd0100);
$parcel$export(module.exports, "useIsGettingStartedPageEnabled", () => $33645e86b9772f1d$export$a58e406dc976509e);

var $5uXOq = parcelRequire("5uXOq");

var $58GFP = parcelRequire("58GFP");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2NMNM = parcelRequire("2NMNM");

var $O4MMs = parcelRequire("O4MMs");

var $dAfqg = parcelRequire("dAfqg");

var $324W5 = parcelRequire("324W5");

var $lbaDt = parcelRequire("lbaDt");

var $9OXo1 = parcelRequire("9OXo1");

var $3HwlS = parcelRequire("3HwlS");

var $5DnNI = parcelRequire("5DnNI");

var $jULiL = parcelRequire("jULiL");

var $kTQYw = parcelRequire("kTQYw");
const $33645e86b9772f1d$export$8d2572f02ec0aa4c = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const baseUrl = window.location.origin;
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { data: data } = (0, $dAfqg.useProjectContext)() || {};
    const { projectId: projectId } = data || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectIdString = projectId ? projectId.toString() : '';
    return (0, $5uXOq.useMemo)(()=>{
        const actionProps = {
            baseUrl: baseUrl,
            cloudId: cloudId,
            projectId: projectIdString,
            createAnalyticsEvent: createAnalyticsEvent
        };
        return [
            {
                updateLandingPageStateProperties: (0, $kTQYw.updateLandingPageStateProperties)(actionProps),
                getLandingPageState: (0, $kTQYw.getLandingPageState)(actionProps),
                initialiseLandingPageState: (0, $kTQYw.initialiseLandingPageState)(actionProps)
            }
        ];
    }, [
        baseUrl,
        cloudId,
        createAnalyticsEvent,
        projectIdString
    ]);
};
const $33645e86b9772f1d$var$useIsFirstProjectITSMOld = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $dAfqg.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const [isFirstProject, setIsFirstProject] = (0, $5uXOq.useState)(false);
    const [isFirstProjectItsm, setIsFirstProjectItsm] = (0, $5uXOq.useState)(false);
    const [isStateLoading, setStateLoading] = (0, $5uXOq.useState)(true);
    const { error: isFirstProjectError, firstProject: firstProject } = (0, $jULiL.useFirstProjectDetails)();
    (0, $5uXOq.useEffect)(()=>{
        if (currentProjectId && !isFirstProjectError && firstProject) {
            setIsFirstProject(firstProject.projectId === `${currentProjectId}`);
            setIsFirstProjectItsm(firstProject.projectTemplateKey === (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY));
            setStateLoading(false);
        } else if (isFirstProjectError) setStateLoading(false);
    }, [
        currentProjectId,
        firstProject,
        isFirstProjectError,
        setStateLoading
    ]);
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            isLoading: loading || isStateLoading,
            isFirstProject: isFirstProject,
            isFirstProjectItsm: isFirstProjectItsm,
            isFirstProjectError: isFirstProjectError
        }), [
        isFirstProject,
        isFirstProjectItsm,
        isFirstProjectError,
        loading,
        isStateLoading
    ]);
    return memoizedValue;
};
const $33645e86b9772f1d$var$useIsFirstProjectITSMNew = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $dAfqg.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const { data: { error: isFirstProjectError, firstProject: firstProject }, loading: isFirstProjectDetailsLoading } = (0, $jULiL.useFirstProjectDetailsNew)();
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            isLoading: loading || isFirstProjectDetailsLoading,
            isFirstProject: firstProject?.projectId === `${currentProjectId}`,
            isFirstProjectItsm: firstProject?.projectTemplateKey === (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
            isFirstProjectError: isFirstProjectError
        }), [
        loading,
        firstProject,
        isFirstProjectDetailsLoading,
        isFirstProjectError,
        currentProjectId
    ]);
    return memoizedValue;
};
const $33645e86b9772f1d$export$852fe39748ba826d = (inputProjectId)=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('hot-113350-ssr-jsm-project-menu-fix', 'isEnabled', false) ? $33645e86b9772f1d$var$useIsFirstProjectITSMNew(inputProjectId) : $33645e86b9772f1d$var$useIsFirstProjectITSMOld(inputProjectId);
};
const $33645e86b9772f1d$var$useInitialProjectTemplateProjectPropertyKeyWithFF = (projectId, customContext)=>{
    if ((0, $4R6GH.fg)('ssr_nav4_queues_sidebar')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, loading: loading } = (0, $324W5.useResourceWithCustomRouterContext)((0, $lbaDt.requiredFrontendProperties), customContext);
        if (!data) return [
            null,
            loading
        ];
        return [
            data[0, $58GFP.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY],
            loading
        ];
    }
    const { [(0, $58GFP.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)]: initialProjectTemplateOld } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $O4MMs.useProjectProperties)([
        (0, $58GFP.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)
    ], projectId);
    const isLoadingOld = initialProjectTemplateOld === undefined;
    return [
        initialProjectTemplateOld,
        isLoadingOld
    ];
};
const $33645e86b9772f1d$export$da3441212b1c36fb = (projectId, customContext)=>{
    const [initialProjectTemplate, isLoading] = $33645e86b9772f1d$var$useInitialProjectTemplateProjectPropertyKeyWithFF(projectId, customContext);
    const { isLoading: isFirstProjectITSMLoading, isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = $33645e86b9772f1d$export$852fe39748ba826d(projectId);
    const excludedProjectTemplates = isFirstProject && isFirstProjectItsm && (0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') ? (0, $5DnNI.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM) : (0, $5DnNI.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD);
    return (0, $5uXOq.useMemo)(()=>[
            isLoading || isFirstProjectITSMLoading,
            excludedProjectTemplates.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            initialProjectTemplate)
        ], [
        excludedProjectTemplates,
        initialProjectTemplate,
        isFirstProjectITSMLoading,
        isLoading
    ]);
};
const $33645e86b9772f1d$export$24659fa3abfd0100 = (projectKeyOrId)=>{
    const [npleDisabled, setNpleDisabled] = (0, $5uXOq.useState)(projectKeyOrId ? undefined : true);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const getNpleDisabledProjectProperty = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const response = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKeyOrId}/properties/${(0, $5DnNI.DISABLE_NPLE_PROJECT_PROJECT_KEY)}`);
            setNpleDisabled(response.value);
            setIsLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setNpleDisabled(error.statusCode !== 404);
            setIsLoading(false);
            error.statusCode !== 404 && (0, $jcw0u.default)({
                meta: {
                    id: 'getDisableNpleProjectProperty',
                    packageName: (0, $5DnNI.PACKAGE_NAME),
                    teamName: (0, $5DnNI.PACKAGE_TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        projectKeyOrId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (projectKeyOrId) getNpleDisabledProjectProperty();
    }, [
        getNpleDisabledProjectProperty,
        projectKeyOrId
    ]);
    return [
        isLoading,
        npleDisabled
    ];
};
const $33645e86b9772f1d$var$useGetNpleDisabledProjectPropertyWithFF = (projectKey, customContext)=>{
    const [isGetNpleDisabledLoadingOld, npleDisabledOld] = $33645e86b9772f1d$export$24659fa3abfd0100(// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('gsp_production_rollout') && !(0, $4R6GH.fg)('ssr_nav4_queues_sidebar') ? projectKey : undefined);
    const { data: requiredProjectPropertiesDataNew, loading: isGetNpleDisabledLoadingNew } = (0, $324W5.useResourceWithCustomRouterContext)((0, $lbaDt.requiredProjectProperties), customContext);
    const npleDisabledNew = requiredProjectPropertiesDataNew ? requiredProjectPropertiesDataNew[0, $5DnNI.DISABLE_NPLE_PROJECT_PROJECT_KEY] : false;
    const npleDisabled = (0, $4R6GH.fg)('ssr_nav4_queues_sidebar') ? npleDisabledNew : npleDisabledOld;
    const isGetNpleDisabledLoading = (0, $4R6GH.fg)('ssr_nav4_queues_sidebar') ? isGetNpleDisabledLoadingNew : isGetNpleDisabledLoadingOld;
    return [
        npleDisabled,
        isGetNpleDisabledLoading
    ];
};
const $33645e86b9772f1d$export$a58e406dc976509e = (customContext)=>{
    const { data: data, loading: projectContextLoading } = (0, $dAfqg.useProjectContext)(customContext) || {};
    const { simplified: isSimplified = false, isProjectAdmin: isProjectAdmin, projectKey: projectKey, projectId: projectId } = data || {};
    const [isLoading, isExcludedProject] = $33645e86b9772f1d$export$da3441212b1c36fb(projectId?.toString(), customContext);
    const [npleDisabled, isGetNpleDisabledLoading] = $33645e86b9772f1d$var$useGetNpleDisabledProjectPropertyWithFF(projectKey, customContext);
    const isDataLoading = isLoading || projectContextLoading || isGetNpleDisabledLoading && (0, $4R6GH.fg)('gsp_production_rollout');
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)() || {};
    const hasJSMAccess = (0, $4R6GH.fg)('add-product-permission-check-for-nple') ? appPermissions?.hasServiceDeskAccess : true;
    return (0, $5uXOq.useMemo)(()=>[
            isDataLoading,
            !isDataLoading ? hasJSMAccess && isProjectAdmin && !isSimplified && !isExcludedProject && !npleDisabled && (0, $4R6GH.fg)('gsp_production_rollout') : false
        ], [
        isDataLoading,
        isProjectAdmin,
        isSimplified,
        isExcludedProject,
        npleDisabled,
        hasJSMAccess
    ]);
};

});
parcelRegister("58GFP", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $c364c398187f9175$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $c364c398187f9175$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $c364c398187f9175$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $c364c398187f9175$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $c364c398187f9175$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $c364c398187f9175$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $c364c398187f9175$export$a062badd78c9993);
$parcel$export(module.exports, "isJwmTmpTemplateKey", () => $c364c398187f9175$export$aff130309b9a2baf);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $c364c398187f9175$export$278632cc7ed9a312 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $c364c398187f9175$export$594d0d4f5ecbf4c7 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $c364c398187f9175$export$dda85c7a8278e495 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $c364c398187f9175$export$b92c431651f9ee91 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $c364c398187f9175$export$d72d75d9d0e071fc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $c364c398187f9175$export$753322ed1c32ff89 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $c364c398187f9175$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
const $c364c398187f9175$export$a062badd78c9993 = {
    [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
    [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
};
const $c364c398187f9175$export$aff130309b9a2baf = (templateKey)=>{
    return [
        $c364c398187f9175$export$477ca3550da12e43,
        $c364c398187f9175$export$b5ab111fb8825075,
        $c364c398187f9175$export$ebf7af45376deb8b,
        $c364c398187f9175$export$310a9ac5c28d65f6,
        $c364c398187f9175$export$136d17feb2f4285d,
        $c364c398187f9175$export$e288f4758e94a8cc,
        $c364c398187f9175$export$4e9ac1417ba54bba,
        $c364c398187f9175$export$560c9f6765bf9af4,
        $c364c398187f9175$export$14d4c6dbbb62a127,
        $c364c398187f9175$export$1367ee12532c525f,
        $c364c398187f9175$export$278632cc7ed9a312,
        $c364c398187f9175$export$594d0d4f5ecbf4c7,
        $c364c398187f9175$export$dda85c7a8278e495,
        $c364c398187f9175$export$b92c431651f9ee91,
        $c364c398187f9175$export$d72d75d9d0e071fc,
        $c364c398187f9175$export$753322ed1c32ff89
    ].includes(templateKey);
};

});

parcelRegister("O4MMs", function(module, exports) {

$parcel$export(module.exports, "useProjectProperties", () => $eccdf8f1b49d4032$export$58be98885c2d686a);

var $5uXOq = parcelRequire("5uXOq");

var $74ySO = parcelRequire("74ySO");

var $ajpes = parcelRequire("ajpes");

var $4f8Oj = parcelRequire("4f8Oj");

var $lpwtK = parcelRequire("lpwtK");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dYZ0w = parcelRequire("dYZ0w");
const $eccdf8f1b49d4032$export$d4c72bab9d6cc13a = {};
const $eccdf8f1b49d4032$var$Store = (0, $iXqE5.createStore)({
    name: 'project-properties',
    initialState: $eccdf8f1b49d4032$export$d4c72bab9d6cc13a,
    actions: $dYZ0w.actions
});
const $eccdf8f1b49d4032$export$eebf791068e870dd = (0, $3sQ5x.createHook)($eccdf8f1b49d4032$var$Store);
const $eccdf8f1b49d4032$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $lpwtK.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $eccdf8f1b49d4032$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $1XJ20.usePrevious)(propertyKeys);
    (0, $5uXOq.useEffect)(()=>{
        if (projectId === undefined) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(propertyKeys, key)) : {};
};

});
parcelRegister("74ySO", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");

var $hTJwX = parcelRequire("hTJwX");

var $agVdz = parcelRequire("agVdz");

var $kPZpS = parcelRequire("kPZpS");

var $dMEgP = parcelRequire("dMEgP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5263f72d78aeaf9c$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $5263f72d78aeaf9c$var$includes(collection, value, fromIndex, guard) {
    collection = $hTJwX(collection) ? collection : $dMEgP(collection);
    fromIndex = fromIndex && !guard ? $kPZpS(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $5263f72d78aeaf9c$var$nativeMax(length + fromIndex, 0);
    return $agVdz(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $2wwA6(collection, value, fromIndex) > -1;
}
module.exports = $5263f72d78aeaf9c$var$includes;

});
parcelRegister("agVdz", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $8LQ84 = parcelRequire("8LQ84");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $77a7c84c5ee0b808$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $77a7c84c5ee0b808$var$isString(value) {
    return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
}
module.exports = $77a7c84c5ee0b808$var$isString;

});


parcelRegister("dYZ0w", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d36e01b4b5883936$export$e324594224ef24da);

var $9Tr6m = parcelRequire("9Tr6m");
const $d36e01b4b5883936$export$e324594224ef24da = {
    get: $9Tr6m.get
};

});
parcelRegister("9Tr6m", function(module, exports) {

$parcel$export(module.exports, "get", () => $52dc90cc0afc52f4$export$3988ae62b71be9a3);

var $k8IPx = parcelRequire("k8IPx");

var $cjFoH = parcelRequire("cjFoH");

var $66FNL = parcelRequire("66FNL");

var $fUPWG = parcelRequire("fUPWG");
const $52dc90cc0afc52f4$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($66FNL)))(currentProperties));
        missingProperties.length && (0, $fUPWG.default)({
            baseUrl: '',
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        });
    };

});
parcelRegister("k8IPx", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $ea975459f1938a58$var$difference = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true)) : [];
});
module.exports = $ea975459f1938a58$var$difference;

});

parcelRegister("fUPWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $573d8b462e0e2ec6$export$2e2bcd8739ae039);

var $1sYcL = parcelRequire("1sYcL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$573d8b462e0e2ec6$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $1sYcL.get)(baseUrl, {
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};

});
parcelRegister("1sYcL", function(module, exports) {

$parcel$export(module.exports, "get", () => $7fc92c544211ac93$export$3988ae62b71be9a3);

var $lbWm4 = parcelRequire("lbWm4");

var $3T6Xo = parcelRequire("3T6Xo");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $fjcgS = parcelRequire("fjcgS");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
let $7fc92c544211ac93$var$ufoExperiencesMap = {};
const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
    if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, $duUGa.UFOExperience)(key, {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
    });
    return $7fc92c544211ac93$var$ufoExperiencesMap[key];
};
const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
    $7fc92c544211ac93$var$ufoExperiencesMap = {};
};
const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $eusud.performGetRequest)(url);
        if (response === null) (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $7fc92c544211ac93$var$patchProperties(response, 'user');
        $7fc92c544211ac93$var$patchProperties(response, 'instance');
        $7fc92c544211ac93$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return (0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response || {
            user: {},
            instance: {},
            project: {}
        } : response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $fZneA.isClientFetchError)(error) && (0, $jcw0u.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});





parcelRegister("lbaDt", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $3477ceb4f9b98b2e$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $3477ceb4f9b98b2e$export$f620cebb7e8eeeae);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];

const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("cB0XL"));
const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader,
    maxAge: 300000
});

const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("5QIw2"));
const $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS = 86400000;
const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS
});

const $3477ceb4f9b98b2e$var$getFirstProjectDataLoader = ()=>Promise.resolve((parcelRequire("KbkKO")));
const $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS = 43200000;
const $3477ceb4f9b98b2e$export$f620cebb7e8eeeae = (0, $2M1hQ.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: $3477ceb4f9b98b2e$var$getFirstProjectDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS
});

});
parcelRegister("cB0XL", function(module, exports) {

let $92b9aff04352e21b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92b9aff04352e21b$var$load("7aPU6").then(()=>parcelRequire('d4USv'));

});

parcelRegister("5QIw2", function(module, exports) {

let $442456f5c4332281$var$load = (parcelRequire("28QjX"))(4);
module.exports = $442456f5c4332281$var$load("4Lrpj").then(()=>parcelRequire('7UDgf'));

});


parcelRegister("5DnNI", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $52e659885063405d$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $52e659885063405d$export$2b3151a089bc8780);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_CHANNELS_CUSTOMISED", () => $52e659885063405d$export$190fb6b68393ab0a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_REQUEST_TYPES_REVIEWED", () => $52e659885063405d$export$b51e545ada86528a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_QUEUE_CUSTOMISED", () => $52e659885063405d$export$2527ae3f75e929d);
$parcel$export(module.exports, "ERROR_CODE_NOT_FOUND", () => $52e659885063405d$export$7741797ac345bc17);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $52e659885063405d$export$2c16bd1d8b68b11f);
$parcel$export(module.exports, "JSM_DOCUMENTATION_URL", () => $52e659885063405d$export$3b0c21ad7d48c17f);
$parcel$export(module.exports, "ASK_COMMUNITY_URL", () => $52e659885063405d$export$eb3a822ca5964b4c);
$parcel$export(module.exports, "SAMPLE_SPACE_URL", () => $52e659885063405d$export$7d64ff3c41d97984);
$parcel$export(module.exports, "ITSM_OPERATIONS_OVERVIEW_DOCUMENTATION_URL", () => $52e659885063405d$export$9485f2fbd78b0ffb);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD", () => $52e659885063405d$export$eb8426badfb143b);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM", () => $52e659885063405d$export$6e4b80733f1b287d);
$parcel$export(module.exports, "JSM_EXCLUDED_TEMPLATES_FOR_NPLE", () => $52e659885063405d$export$849d996b61162ae5);
$parcel$export(module.exports, "REQUEST_CHANNEL_PORTAL", () => $52e659885063405d$export$84bc97b21fdd244a);
$parcel$export(module.exports, "REQUEST_CHANNEL_CHAT", () => $52e659885063405d$export$a45136678da730c);
$parcel$export(module.exports, "REQUEST_CHANNEL_EMAIL", () => $52e659885063405d$export$4585842137473138);
$parcel$export(module.exports, "REQUEST_TYPES_MAX_ELEMENTS", () => $52e659885063405d$export$4ff5ead961dddcb6);
$parcel$export(module.exports, "ManageQueuesArticleId", () => $52e659885063405d$export$337d9a01cb6ca6b9);
$parcel$export(module.exports, "RequestChannelsArticleId", () => $52e659885063405d$export$14ea17a7011e8003);
$parcel$export(module.exports, "RequestTypesArticleId", () => $52e659885063405d$export$bf7175403ae935b4);
$parcel$export(module.exports, "RequestQueuesArticleId", () => $52e659885063405d$export$f5f272385d51d0c);
$parcel$export(module.exports, "ViewIssueArticleId", () => $52e659885063405d$export$3a62b051817d4794);
$parcel$export(module.exports, "REQUEST_CHANNELS", () => $52e659885063405d$export$66b0ce7a4d805ff);
$parcel$export(module.exports, "REQUEST_TYPES", () => $52e659885063405d$export$b1183955728be615);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD", () => $52e659885063405d$export$56dfbf0bd0f6a594);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD_ITSM", () => $52e659885063405d$export$7153e91b542b7f0a);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD_ITOPS", () => $52e659885063405d$export$2dce1bec124ad97d);
$parcel$export(module.exports, "DEMO_ISSUE_LABEL", () => $52e659885063405d$export$fe4edbd608405ae2);
$parcel$export(module.exports, "DEMO_ISSUE_ERROR_FLAG_ID", () => $52e659885063405d$export$b2f56b9b16e7a5d8);
$parcel$export(module.exports, "DISABLE_NPLE_PROJECT_PROJECT_KEY", () => $52e659885063405d$export$8b55ba9520951f74);
$parcel$export(module.exports, "DISABLE_NPLE_ERROR_FLAG_ID", () => $52e659885063405d$export$8ce85ec44321d12);
$parcel$export(module.exports, "DISABLE_NPLE_SUCCESS_FLAG_ID", () => $52e659885063405d$export$2b5c9784d8cd5f0);
$parcel$export(module.exports, "INCIDENTS", () => $52e659885063405d$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "CHANGES", () => $52e659885063405d$export$8598196f74460271);
$parcel$export(module.exports, "ALERTS", () => $52e659885063405d$export$bc57e9dea1fac017);
$parcel$export(module.exports, "CREATE_A_TEAM", () => $52e659885063405d$export$6ee8a54637c51e7d);
$parcel$export(module.exports, "SELECT_A_TEAM", () => $52e659885063405d$export$c6fd9f8cba84eaaf);
$parcel$export(module.exports, "MUTLI_OPS_TEAMS_OPTIIMISE_OPERATIONS", () => $52e659885063405d$export$c8c3ea29683272dd);
$parcel$export(module.exports, "SINGLE_OPS_TEAMS_OPTIMISE_OPERATIONS", () => $52e659885063405d$export$e3695100db882d1d);
$parcel$export(module.exports, "INTEGRATIONS", () => $52e659885063405d$export$d49fe9e32eb9b9c3);
$parcel$export(module.exports, "ONCALL", () => $52e659885063405d$export$4a57a4a93a9f526);

var $58GFP = parcelRequire("58GFP");
const $52e659885063405d$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPage';
const $52e659885063405d$export$2b3151a089bc8780 = 'itops-mithril';
const $52e659885063405d$export$190fb6b68393ab0a = 'servicedesk-getting-started-page-request-channels-customised';
const $52e659885063405d$export$b51e545ada86528a = 'servicedesk-getting-started-page-request-types-reviewed';
const $52e659885063405d$export$2527ae3f75e929d = 'servicedesk-getting-started-page-queue-customised';
const $52e659885063405d$var$IT_SERVICE_MANAGEMENT_KEY = 'jsm.it-service-management';
const $52e659885063405d$var$NEW_IT_SERVICE_MANAGEMENT_KEY = 'jsm.it-service-management-advanced';
const $52e659885063405d$export$7741797ac345bc17 = 404;
const $52e659885063405d$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/';
const $52e659885063405d$export$3b0c21ad7d48c17f = 'https://support.atlassian.com/jira-service-management-cloud/docs/get-started-with-jira-service-management/';
const $52e659885063405d$export$eb3a822ca5964b4c = 'https://community.atlassian.com/t5/Jira-Service-Management/Welcome-to-Jira-Service-Management/m-p/2690403?utm_source=community&utm_medium=inapp&utm_campaign=P:jira-service-management%7CO:community%7CC:community%7CW:jsmlp%7CH:05/07/2024%7CI:onboarding%7C';
const $52e659885063405d$export$7d64ff3c41d97984 = '/jira/servicedesk/itsm-sample-space';
const $52e659885063405d$export$9485f2fbd78b0ffb = 'https://support.atlassian.com/jira-service-management-cloud/docs/discover-alerting-and-on-call/';
const $52e659885063405d$var$UNKNOWN_PROJECT_TEMPLATE_KEY = '';
const $52e659885063405d$export$eb8426badfb143b = [
    (0, $58GFP.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    (0, $58GFP.JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY),
    $52e659885063405d$var$UNKNOWN_PROJECT_TEMPLATE_KEY
];
const $52e659885063405d$export$6e4b80733f1b287d = [
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    $52e659885063405d$var$UNKNOWN_PROJECT_TEMPLATE_KEY
];
const $52e659885063405d$export$849d996b61162ae5 = [
    $52e659885063405d$var$IT_SERVICE_MANAGEMENT_KEY,
    $52e659885063405d$var$NEW_IT_SERVICE_MANAGEMENT_KEY,
    (0, $58GFP.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    $52e659885063405d$var$UNKNOWN_PROJECT_TEMPLATE_KEY
];
const $52e659885063405d$export$84bc97b21fdd244a = 'Portal';
const $52e659885063405d$export$a45136678da730c = 'Chat';
const $52e659885063405d$export$4585842137473138 = 'Email';
const $52e659885063405d$export$4ff5ead961dddcb6 = 4;
const $52e659885063405d$export$337d9a01cb6ca6b9 = '5b7BuVaVJqmbyCZ2mbMYHD';
const $52e659885063405d$export$14ea17a7011e8003 = '3v4bqtuzeA4dOJq6A4yhiM';
const $52e659885063405d$export$bf7175403ae935b4 = 'eYQImfQnsXgIvrECKaQTF';
const $52e659885063405d$export$f5f272385d51d0c = 'bfeWmUW9tPB6MqlPnOXgF';
const $52e659885063405d$export$3a62b051817d4794 = '102lbF25oEeqn7GG1rXPUA';
const $52e659885063405d$export$66b0ce7a4d805ff = 'RequestChannel';
const $52e659885063405d$export$b1183955728be615 = 'RequestTypes';
const $52e659885063405d$export$5b2e9a43da487c8d = 'InviteTeam';
const $52e659885063405d$export$82cf56f84f36683f = 'ManageQueues';
const $52e659885063405d$export$56dfbf0bd0f6a594 = 'newLandingPageExperienceProd';
const $52e659885063405d$export$7153e91b542b7f0a = 'newLandingPageExperienceProdITSM';
const $52e659885063405d$export$2dce1bec124ad97d = 'newLandingPageExperienceProdITOPS';
const $52e659885063405d$export$fe4edbd608405ae2 = 'onboarding-learn-by-doing-demo-issue';
const $52e659885063405d$export$b2f56b9b16e7a5d8 = 'onboarding-sample-issue-error';
const $52e659885063405d$export$8b55ba9520951f74 = 'npleDisabled';
const $52e659885063405d$export$8ce85ec44321d12 = 'disable-nple-error';
const $52e659885063405d$export$2b5c9784d8cd5f0 = 'disable-nple-success';
const $52e659885063405d$export$a50b49a533b5f7bc = 'incidents';
const $52e659885063405d$export$8598196f74460271 = 'changes';
const $52e659885063405d$export$bc57e9dea1fac017 = 'alerts';
const $52e659885063405d$export$6ee8a54637c51e7d = 'createATeam';
const $52e659885063405d$export$c6fd9f8cba84eaaf = 'selectATeam';
const $52e659885063405d$export$c8c3ea29683272dd = 'optimiseOperationsMultiOps';
const $52e659885063405d$export$e3695100db882d1d = 'optimiseOperationsSingleOps';
const $52e659885063405d$export$d49fe9e32eb9b9c3 = 'integrations';
const $52e659885063405d$export$4a57a4a93a9f526 = 'oncall';

});

parcelRegister("jULiL", function(module, exports) {

$parcel$export(module.exports, "useFirstProjectDetails", () => $2151d2bb13849eac$export$a2dd21ca7232bc34);
$parcel$export(module.exports, "useFirstProjectDetailsNew", () => $2151d2bb13849eac$export$16beb41ec08bf629);

var $5uXOq = parcelRequire("5uXOq");


var $9OXo1 = parcelRequire("9OXo1");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2YP9W = parcelRequire("2YP9W");

var $lbaDt = parcelRequire("lbaDt");

var $KbkKO = parcelRequire("KbkKO");
const $2151d2bb13849eac$var$initialState = {
    error: false,
    firstProject: undefined
};
const $2151d2bb13849eac$var$setError = (error)=>({ setState: setState })=>{
        setState({
            error: error
        });
    };
const $2151d2bb13849eac$var$setFirstProject = (firstProject)=>({ setState: setState })=>{
        setState({
            firstProject: firstProject
        });
    };
const $2151d2bb13849eac$export$e324594224ef24da = {
    setError: $2151d2bb13849eac$var$setError,
    setFirstProject: $2151d2bb13849eac$var$setFirstProject
};
const $2151d2bb13849eac$var$store = (0, $iXqE5.createStore)({
    name: 'getting-started-page-is-first-project',
    initialState: $2151d2bb13849eac$var$initialState,
    actions: $2151d2bb13849eac$export$e324594224ef24da
});
const $2151d2bb13849eac$export$a47f6b1a99a5e57f = (0, $3sQ5x.createHook)($2151d2bb13849eac$var$store);
const $2151d2bb13849eac$export$a2dd21ca7232bc34 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $2151d2bb13849eac$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    (0, $5uXOq.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        (0, $KbkKO.default)().then((response)=>{
            setFirstProjectDetails(response);
        }).catch(()=>{
            setErrorState(true);
        });
    }, [
        hasJsmLicense,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return data;
};
const $2151d2bb13849eac$export$16beb41ec08bf629 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $2151d2bb13849eac$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    const { data: resourceData, error: error, loading: loading } = (0, $2YP9W.useResource)((0, $lbaDt.firstProjectResource));
    (0, $5uXOq.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        if (error) setErrorState(true);
        else if (resourceData) setFirstProjectDetails(resourceData);
    }, [
        hasJsmLicense,
        resourceData,
        error,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return {
        data: data,
        loading: loading
    };
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("KbkKO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $746c95604cc49d58$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $bFU4G = parcelRequire("bFU4G");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $746c95604cc49d58$var$getFirstProject = async ()=>{
    try {
        const fetchStartTime = performance.now();
        const response = await (0, $eusud.performGetRequest)('/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk');
        (0, $bFU4G.addSpanToAll)('fetch', 'rest/servicedesk/latest/xflow/getFirstProject?type=service_desk', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode !== 404) (0, $jcw0u.default)({
            meta: {
                id: 'getFirstProject',
                packageName: '@atlassian/jira-router-resources-service-desk-project-getting-started',
                teamName: 'itops-mithril'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
var // named export does not work with Bifrost templates CI build: 'index.tsx does not export 'then'`. Also, `getDataLoader:` in router works only with default exports
$746c95604cc49d58$export$2e2bcd8739ae039 = $746c95604cc49d58$var$getFirstProject;

});


parcelRegister("kTQYw", function(module, exports) {

$parcel$export(module.exports, "initialiseLandingPageState", () => $123174e2fee8004a$export$afc4bcbfce806408);
$parcel$export(module.exports, "getLandingPageState", () => $123174e2fee8004a$export$43654a89c1df0019);
$parcel$export(module.exports, "updateLandingPageStateProperties", () => $123174e2fee8004a$export$2dede61295d6c46);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $5DnNI = parcelRequire("5DnNI");
const $123174e2fee8004a$export$afc4bcbfce806408 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            await (0, $eusud.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'initialised'
            }), 'jiraServicedeskGettingStartedPage.State initialised');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $5DnNI.PACKAGE_NAME),
                    teamName: (0, $5DnNI.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
const $123174e2fee8004a$export$43654a89c1df0019 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            const response = await (0, $eusud.performGetRequestWithRetry)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'fetched'
            }), 'jiraServicedeskGettingStartedPage.State fetched');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $5DnNI.PACKAGE_NAME),
                    teamName: (0, $5DnNI.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
const $123174e2fee8004a$export$2dede61295d6c46 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async (properties)=>{
        const sectionStateString = JSON.stringify(properties);
        try {
            await (0, $eusud.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page/properties`, {
                body: JSON.stringify({
                    sectionState: sectionStateString
                })
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'Properties',
                action: 'updated'
            }), 'jiraServicedeskGettingStartedPage.Properties updated', {
                property: properties
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'Properties',
                    packageName: (0, $5DnNI.PACKAGE_NAME),
                    teamName: (0, $5DnNI.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});


parcelRegister("dMRcK", function(module, exports) {

$parcel$export(module.exports, "AlertsGlyph", () => $cd26add3f777a385$export$176f750a9e6f975b);

var $5uXOq = parcelRequire("5uXOq");
const $cd26add3f777a385$export$176f750a9e6f975b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C13.104 22 14 21.104 14 20H10C10 21.104 10.896 22 12 22Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 16.9295C18.962 16.9585 18.879 16.9995 18.75 16.9995H5.25C5.121 16.9995 5.038 16.9585 5 16.9295V16.3025C6.347 15.8965 7.341 14.7765 7.517 13.4265L7.521 13.3975L7.523 13.3675L7.964 9.00151C8.203 7.28851 9.933 5.99951 12 5.99951C14.067 5.99951 15.797 7.28851 16.036 9.00151L16.477 13.3675L16.479 13.3975L16.483 13.4265C16.659 14.7765 17.654 15.8965 19 16.3025V16.9295ZM19.728 14.4265C19.051 14.2845 18.547 13.7815 18.467 13.1675L18.022 8.76751C17.707 6.35151 15.622 4.47151 13 4.08251V2.99951C13 2.44751 12.553 1.99951 12 1.99951C11.447 1.99951 11 2.44751 11 2.99951V4.08251C8.378 4.47151 6.293 6.35151 5.978 8.76751L5.533 13.1675C5.453 13.7815 4.949 14.2845 4.272 14.4265C3.527 14.5815 3 15.1735 3 15.8535V17.0005C3 18.1045 4.007 18.9995 5.25 18.9995H18.75C19.993 18.9995 21 18.1045 21 17.0005V15.8535C21 15.1735 20.473 14.5815 19.728 14.4265Z",
        fill: "currentColor"
    }));

});

parcelRegister("37cK0", function(module, exports) {

$parcel$export(module.exports, "ViewsNavItemOnboarding", () => $c718095475a9e150$export$6539c8ff897f7660);

var $5uXOq = parcelRequire("5uXOq");

var $fqbGj = parcelRequire("fqbGj");

var $k6T4f = parcelRequire("k6T4f");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $j9VTE = parcelRequire("j9VTE");

var $k5uoT = parcelRequire("k5uoT");

var $fG5AJ = parcelRequire("fG5AJ");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5QsHM = parcelRequire("5QsHM");

var $gq0sA = parcelRequire("gq0sA");

var $ajlSd = parcelRequire("ajlSd");


var $izo6z = parcelRequire("izo6z");

var $9gGUm = parcelRequire("9gGUm");
const $c718095475a9e150$var$screenName = 'jsmViewsOnboardingSpotlight';
const $c718095475a9e150$var$ChoreographedToggleableSpotlight = (0, $fG5AJ.withChoreographedToggle)(({ isChoreographingStarted: isChoreographingStarted = true, setShouldShowSpotlight: setShouldShowSpotlight, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onDismiss = ()=>{
        setShouldShowSpotlight(false);
    };
    const onReadMore = ()=>{
        onDismiss();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open('https://support.atlassian.com/jira-service-management-cloud/docs/enable-new-views-for-your-service-project/', '_blank', 'noreferrer');
    };
    const renderNudge = ()=>(0, $ajlSd.createOnboardingSpotlight)({
            actions: [
                {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', `${$c718095475a9e150$var$screenName}ReadMore`);
                        onReadMore();
                    },
                    content: formatMessage((0, $9gGUm.default).readMore),
                    appearance: 'subtle'
                },
                {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', `${$c718095475a9e150$var$screenName}Dismiss`);
                        onDismiss();
                    },
                    content: formatMessage((0, $9gGUm.default).ok),
                    appearance: 'primary'
                }
            ],
            contentMessage: formatMessage((0, $9gGUm.default).description),
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $izo6z.MergedViewsIllustration), null),
            headingMessage: formatMessage((0, $9gGUm.default).heading)
        });
    if (!isChoreographingStarted) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: $c718095475a9e150$var$screenName,
        attributes: {
            messageId: (0, $c1ccbc81e9e157ed$export$ee777497d6c75889),
            name: $c718095475a9e150$var$screenName,
            projectId: projectId,
            projectType: projectType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqbGj.NudgeSpotlight), {
        hidden: false,
        setHidden: ()=>{
        /* Handled via onDismissClick */ },
        onOutsideClick: ()=>{
            onDismiss();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'blanket clicked', `${$c718095475a9e150$var$screenName}Dismiss`);
        },
        spotlightCard: renderNudge(),
        concealSpotlightOnReferenceHidden: true,
        position: "right-start",
        zIndex: (0, $k5uoT.layers).dialog()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
}, 'isChoreographingStarted');
const $c718095475a9e150$var$ChoreographedSpotlight = ({ isChoreographingStarted: isChoreographingStarted = true, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c718095475a9e150$var$ChoreographedToggleableSpotlight, {
        ...props,
        isChoreographingStarted: isChoreographingStarted,
        messageId: (0, $c1ccbc81e9e157ed$export$ee777497d6c75889)
    });
};
const $c718095475a9e150$var$Spotlight = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c718095475a9e150$var$ChoreographedSpotlight, props);
const $c718095475a9e150$var$Pulse = ({ children: children, shouldShowPulse: shouldShowPulse, setShouldShowSpotlight: setShouldShowSpotlight, markSpotlightAsSeen: markSpotlightAsSeen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'pulse clicked', `${$c718095475a9e150$var$screenName}Pulse`);
        setShouldShowSpotlight(true);
        markSpotlightAsSeen();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c718095475a9e150$var$pulseContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        pulse: shouldShowPulse,
        radius: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        role: "button",
        "aria-label": formatMessage((0, $9gGUm.default).pulseLabel),
        onClick: onClick,
        xcss: $c718095475a9e150$var$pulseTargetContainerStyles,
        onKeyDown: (e)=>{
            e.key === 'Enter' && onClick();
        },
        tabIndex: 0,
        "data-testId": "servicedesk-views-onboarding.ui.views-nav-item-onboarding.spotlight-trigger"
    }, children)));
};
const $c718095475a9e150$var$ViewsNavItemOnboardingView = ({ children: children })=>{
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: (0, $c1ccbc81e9e157ed$export$ee777497d6c75889),
        isSeenValue: true,
        packageName: $c1ccbc81e9e157ed$export$9345d7360ffe0722,
        teamName: $c1ccbc81e9e157ed$export$9f98a8d796affec6
    });
    const shouldShowPulse = !hasSeenSpotlight;
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowPulse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c718095475a9e150$var$Pulse, {
        setShouldShowSpotlight: setShouldShowSpotlight,
        markSpotlightAsSeen: markSpotlightAsSeen,
        shouldShowPulse: shouldShowPulse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, children)), shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c718095475a9e150$var$Spotlight, {
        setShouldShowSpotlight: setShouldShowSpotlight
    }, children), !shouldShowPulse && !shouldShowSpotlight && children);
};
const $c718095475a9e150$export$6539c8ff897f7660 = ({ children: children })=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!(0, $3HwlS.getWillShowNav4)() && !shouldRender) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jiraServicedeskViewsNavItemOnboarding",
        packageName: (0, $c1ccbc81e9e157ed$export$9345d7360ffe0722),
        teamName: (0, $c1ccbc81e9e157ed$export$9f98a8d796affec6),
        fallback: ()=>children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c718095475a9e150$var$ViewsNavItemOnboardingView, null, children));
};
const $c718095475a9e150$var$pulseContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $c718095475a9e150$var$pulseTargetContainerStyles = (0, $8CUq3.xcss)({
    cursor: 'pointer'
});

});
parcelRegister("5QsHM", function(module, exports) {

$parcel$export(module.exports, "useSeenStatus", () => $36807a4a4f35954c$export$12667e37571b0a02);

var $5uXOq = parcelRequire("5uXOq");


var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");
const $36807a4a4f35954c$var$initialState = {
    isSeen: true,
    isLoading: false,
    error: undefined
};
const $36807a4a4f35954c$export$f7ab30339d40bcd = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $36807a4a4f35954c$export$12667e37571b0a02 = ({ userPropertyKey: userPropertyKey, isSeenValue: isSeenValue, packageName: packageName, teamName: teamName, skipOnboarding: skipOnboarding })=>{
    const [state, setState] = (0, $5uXOq.useState)($36807a4a4f35954c$var$initialState);
    const { atlassianAccountId: accountId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const reportErrorDeps = (0, $5uXOq.useRef)({
        packageName: packageName,
        teamName: teamName
    });
    reportErrorDeps.current = {
        packageName: packageName,
        teamName: teamName
    };
    const reportError = (0, $5uXOq.useCallback)((errorId, error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: errorId,
                ...reportErrorDeps.current
            },
            error: error,
            attributes: {
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (accountId && !$36807a4a4f35954c$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isLoading: true
                }));
            (0, $89SaW.getUserProperty)(accountId, userPropertyKey).catch((error)=>{
                if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) // user property has not been set
                return false;
                throw error;
            }).then((value)=>{
                setState((oldState)=>({
                        ...oldState,
                        isSeen: value === isSeenValue,
                        isLoading: false
                    }));
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.fetchStatus succeeded', {
                    userPropertyKey: userPropertyKey
                });
            }).catch((error)=>{
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.fetchStatus', error);
            });
        }
    }, [
        userPropertyKey,
        accountId,
        isSeenValue,
        reportError,
        createAnalyticsEvent,
        skipOnboarding
    ]);
    const markAsSeen = (0, $5uXOq.useCallback)(()=>{
        if (accountId && !$36807a4a4f35954c$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isSeen: true,
                    isLoading: true
                }));
            (0, $89SaW.setUserProperties)(accountId, userPropertyKey, JSON.stringify(isSeenValue)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $jJZqs.default)(res.status, errResp);
                });
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false
                    }));
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.markAsSeen succeeded', {
                    userPropertyKey: userPropertyKey
                });
                return Promise.resolve();
            }).catch((error)=>{
                // leave `isSeen` as true. we don't want to block the user
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.markAsSeen', error);
            });
        }
    }, [
        accountId,
        userPropertyKey,
        isSeenValue,
        createAnalyticsEvent,
        reportError,
        skipOnboarding
    ]);
    return [
        state,
        {
            markAsSeen: markAsSeen
        }
    ];
};

});

parcelRegister("ajlSd", function(module, exports) {

$parcel$export(module.exports, "createOnboardingSpotlight", () => $208acef035d7cdaa$export$3de3bbc64fe39fe6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $9yOBd = parcelRequire("9yOBd");
var $fVnbM = parcelRequire("fVnbM");

var $5ujeO = parcelRequire("5ujeO");

var $8Bc5A = parcelRequire("8Bc5A");
const $208acef035d7cdaa$var$NudgeHeading = ({ formattedMessage: formattedMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$Title, {
        id: "nudge-spot-light-card-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$CustomHeading, null, formattedMessage));
const $208acef035d7cdaa$var$NudgeAction = ({ appearance: appearance, content: content, onClick: onClick })=>{
    // if appearance is primary, override styles with custom button
    // note CustomThemeButton is advised against and we need a better solution
    // (potentially even going with the blue button). Leaving this code for the experiment
    if (appearance === 'primary') {
        const customTheme = (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: `${"var(--ds-icon-discovery, #8270DB)"}`,
                    minWidth: '84px',
                    margin: `0 ${"var(--ds-space-050, 4px)"}`,
                    color: `${"var(--ds-text-inverse, #FFFFFF)"}`
                },
                spinnerStyles: spinnerStyles
            };
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
            appearance: appearance,
            onClick: onClick,
            theme: customTheme
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: appearance,
        onClick: onClick
    }, content);
};
const $208acef035d7cdaa$var$NudgeActions = ({ actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$Footer, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeAction, {
            key: index,
            ...action
        })));
const $208acef035d7cdaa$export$3de3bbc64fe39fe6 = ({ actions: actions, contentMessage: contentMessage, headingMessage: headingMessage, image: image, width: width = (0, $8Bc5A.DEFAULT_NUDGE_WIDTH), CustomWrapper: CustomWrapper, actionsBeforeElement: actionsBeforeElement })=>{
    const Wrapper = CustomWrapper || $208acef035d7cdaa$var$SpotlightCardWrapper;
    return /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
            image: image,
            heading: headingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeHeading, {
                formattedMessage: headingMessage
            }) : null,
            width: width,
            actionsBeforeElement: actionsBeforeElement
        }, contentMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeActions, {
            actions: actions
        }))));
};
const $208acef035d7cdaa$export$cbbb2ee263b2a558 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ focusLock: focusLock, ...rest }, ref)=>{
    const Spotlight = $208acef035d7cdaa$export$3de3bbc64fe39fe6({
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
        disabled: !focusLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Spotlight, {
        ref: ref
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $208acef035d7cdaa$var$SpotlightCardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_fkwn1bhr _tml11fxt _19yu1fxt",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$CustomHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $5f07ce956337ba8b$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $5f07ce956337ba8b$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $5f07ce956337ba8b$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $5f07ce956337ba8b$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $5f07ce956337ba8b$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $5f07ce956337ba8b$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$8ab0859f5b30b013 = $5f07ce956337ba8b$var$completeDevopsTaskName('welcome-to-your-project-task');
const $5f07ce956337ba8b$export$d1f6d18c6698104c = $5f07ce956337ba8b$var$completeDevopsTaskName('get-to-know-jira-task');
const $5f07ce956337ba8b$export$e6ee159eee7adc1c = $5f07ce956337ba8b$var$completeDevopsTaskName('navigate-your-tools-task');
const $5f07ce956337ba8b$export$dd267ca1e3cd3bad = $5f07ce956337ba8b$var$completeDevopsTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$f14c8bffc35200d3 = $5f07ce956337ba8b$var$completeDevopsTaskName('create-automation-rules-task');
const $5f07ce956337ba8b$export$36cc22c9997d92a = $5f07ce956337ba8b$var$completeDevopsTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$d651cc94a46ff383 = $5f07ce956337ba8b$var$completeDevopsTaskName('find-help-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$8ab0859f5b30b013,
    $5f07ce956337ba8b$export$d1f6d18c6698104c,
    $5f07ce956337ba8b$export$e6ee159eee7adc1c,
    $5f07ce956337ba8b$export$dd267ca1e3cd3bad,
    $5f07ce956337ba8b$export$f14c8bffc35200d3,
    $5f07ce956337ba8b$export$36cc22c9997d92a,
    $5f07ce956337ba8b$export$d651cc94a46ff383,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$a333714599f14a6,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];

});


const $c1ccbc81e9e157ed$export$9345d7360ffe0722 = 'jiraServicedeskViewsOnboarding';
const $c1ccbc81e9e157ed$export$9f98a8d796affec6 = 'jsd-shield';
const $c1ccbc81e9e157ed$export$ee777497d6c75889 = 'jsm-views-nav-onboarding';
const $c1ccbc81e9e157ed$export$4566dcc26de63fd5 = 'jsm-views-meatballs-onboarding';

parcelRegister("izo6z", function(module, exports) {

$parcel$export(module.exports, "MergedViewsIllustration", () => $5bcebe3f3da17cf9$export$36c1669f1868ef98);

var $5uXOq = parcelRequire("5uXOq");

var $jNdI7 = parcelRequire("jNdI7");
const $5bcebe3f3da17cf9$export$36c1669f1868ef98 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jNdI7))),
        alt: "",
        width: "320"
    });

});
parcelRegister("jNdI7", function(module, exports) {
module.exports = new URL("merged-views-illustration.5d9832fd.png", import.meta.url).toString();

});


parcelRegister("9gGUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfff9b7c0b247645$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfff9b7c0b247645$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "servicedesk-views-onboarding.views-nav-item-onboarding.heading",
        "defaultMessage": "Board + Calendar = Views"
    },
    description: {
        "id": "servicedesk-views-onboarding.views-nav-item-onboarding.description",
        "defaultMessage": "Switch between views to see issues in the way that works best for you."
    },
    readMore: {
        "id": "servicedesk-views-onboarding.views-nav-item-onboarding.read-more",
        "defaultMessage": "Read more"
    },
    ok: {
        "id": "servicedesk-views-onboarding.views-nav-item-onboarding.ok",
        "defaultMessage": "OK"
    },
    pulseLabel: {
        "id": "servicedesk-views-onboarding.views-nav-item-onboarding.pulse-label",
        "defaultMessage": "Learn more about views"
    }
});

});


parcelRegister("2avq0", function(module, exports) {

$parcel$export(module.exports, "IncidentsGlyph", () => $eeea82b6a0c8bc7b$export$dccd7347f5424c62);
$parcel$export(module.exports, "ChangesGlyph", () => $eeea82b6a0c8bc7b$export$fdf1495a4a912188);
$parcel$export(module.exports, "ProblemsGlyph", () => $eeea82b6a0c8bc7b$export$7e45df5d5091bdc1);
$parcel$export(module.exports, "ServiceRequestsGlyph", () => $eeea82b6a0c8bc7b$export$aa6aa7c7f5b660eb);
$parcel$export(module.exports, "PostIncidentReviewsGlyph", () => $eeea82b6a0c8bc7b$export$d16eebd02cbe077);
$parcel$export(module.exports, "ServicesGlyph", () => $eeea82b6a0c8bc7b$export$3d11ab79d49f0705);

var $5uXOq = parcelRequire("5uXOq");
const $eeea82b6a0c8bc7b$export$dccd7347f5424c62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8716 5.54947C12.7818 5.38984 12.6499 5.25794 12.4903 5.16815C12.0089 4.89739 11.3992 5.06811 11.1284 5.54947L3.83826 18.5097C3.75407 18.6594 3.70984 18.8283 3.70984 19C3.70984 19.5523 4.15755 20 4.70984 20H19.2901C19.4619 20 19.6307 19.9558 19.7804 19.8716C20.2618 19.6008 20.4325 18.9911 20.1617 18.5097L12.8716 5.54947ZM12 9.09932L16.7254 17.5H7.27461L12 9.09932Z",
        fill: "currentColor"
    }));
const $eeea82b6a0c8bc7b$export$fdf1495a4a912188 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4123 10.1551C12.8378 10.1525 12.3701 9.68475 12.3675 9.11027L12.3598 7.39768L5.63605 14.1215C5.24553 14.512 4.61236 14.512 4.22184 14.1215C3.83132 13.731 3.83132 13.0978 4.22184 12.7073L10.9456 5.98347L9.23304 5.97583C8.65857 5.97326 8.19079 5.50548 8.18823 4.93101C8.18567 4.35654 8.64929 3.89291 9.22376 3.89548L13.3845 3.91404C13.9589 3.9166 14.4267 4.38438 14.4293 4.95886L14.4478 9.11955C14.4504 9.69403 13.9868 10.1577 13.4123 10.1551Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8118 19.0691C15.8093 18.4946 15.3415 18.0269 14.767 18.0243L13.0544 18.0166L19.7782 11.2929C20.1687 10.9023 20.1687 10.2692 19.7782 9.87864C19.3877 9.48812 18.7545 9.48811 18.364 9.87864L11.6402 16.6024L11.6326 14.8898C11.63 14.3154 11.1622 13.8476 10.5877 13.845C10.0133 13.8425 9.54965 14.3061 9.55222 14.8806L9.57078 19.0413C9.57334 19.6157 10.0411 20.0835 10.6156 20.0861L14.7763 20.1046C15.3508 20.1072 15.8144 19.6436 15.8118 19.0691Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
        id: "mask0",
        "mask-type": "alpha",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "7",
        width: "16",
        height: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8118 19.0691C15.8093 18.4946 15.3415 18.0269 14.767 18.0243L13.0544 18.0166L19.7782 11.2929C20.1687 10.9023 20.1687 10.2692 19.7782 9.87864C19.3877 9.48812 18.7545 9.48811 18.364 9.87864L11.6402 16.6024L11.6326 14.8898C11.63 14.3154 11.1622 13.8476 10.5877 13.845C10.0133 13.8425 9.54965 14.3061 9.55222 14.8806L9.57078 19.0413C9.57334 19.6157 10.0411 20.0835 10.6156 20.0861L14.7763 20.1046C15.3508 20.1072 15.8144 19.6436 15.8118 19.0691Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        mask: "url(#mask0)"
    }));
const $eeea82b6a0c8bc7b$export$7e45df5d5091bdc1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM17.3946 8.37281L8.37281 17.3946C9.40883 18.0926 10.6568 18.5 12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 10.6568 18.0926 9.40883 17.3946 8.37281ZM5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C13.3432 5.5 14.5912 5.9074 15.6272 6.60536L6.60536 15.6272C5.9074 14.5912 5.5 13.3432 5.5 12Z",
        fill: "currentColor"
    }));
const $eeea82b6a0c8bc7b$export$aa6aa7c7f5b660eb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4C16.4183 4 20 7.13401 20 11C20 14.866 16.4183 18 12 18C11.2426 18 10.5098 17.9079 9.81538 17.7358L9.48536 17.9384C8.76804 18.3682 7.14214 19.3047 4.60766 20.748L5.41439 17.3256C5.60252 16.5045 5.73944 15.8795 5.82514 15.4509C4.6849 14.2411 4 12.6905 4 11C4 7.13401 7.58172 4 12 4ZM12 6C8.68629 6 6 8.23858 6 11C6 13.7614 8.68629 16 12 16C15.3137 16 18 13.7614 18 11C18 8.23858 15.3137 6 12 6Z",
        fill: "currentColor"
    }));
const $eeea82b6a0c8bc7b$export$d16eebd02cbe077 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon-inverse, #FFFFFF)",
        fillOpacity: ".01",
        d: "M0 0h24v24H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 17H5V7h1V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v-2Zm13-6.995V19H9V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995h-2Z",
        fill: "var(--ds-icon, #44546F)"
    }));
const $eeea82b6a0c8bc7b$export$6be6d2feb174f383 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: "false",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 5h.006C20.107 5 21 5.895 21 6.994v12.012A1.995 1.995 0 0 1 19.006 21H6.994A1.995 1.995 0 0 1 5 19.006V19h13c.555 0 1-.448 1-1V5zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994V5.006zM5 5v10h10V5H5zm1 3c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 8zm0 3c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 11z",
        fill: "currentColor"
    }));
const $eeea82b6a0c8bc7b$export$3d11ab79d49f0705 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 6C20 7.10457 19.1046 8 18 8C16.8954 8 16 7.10457 16 6C16 4.89543 16.8954 4 18 4C19.1046 4 20 4.89543 20 6ZM20 18C20 19.1046 19.1046 20 18 20C16.8954 20 16 19.1046 16 18C16 16.8954 16.8954 16 18 16C19.1046 16 20 16.8954 20 18ZM18 10C20.2091 10 22 8.20914 22 6C22 3.79086 20.2091 2 18 2C15.7909 2 14 3.79086 14 6C14 8.20914 15.7909 10 18 10ZM18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22ZM11.1377 5C10.803 5 10.4904 5.16747 10.3051 5.44617L9.28468 6.98023C8.97881 7.44008 9.10363 8.06082 9.56348 8.36669C10.0233 8.67256 10.6441 8.54774 10.9499 8.08789L11.6736 7H12.5688C13.1211 7 13.5688 6.55228 13.5688 6C13.5688 5.44772 13.1211 5 12.5688 5H11.1377ZM8.90917 11.156C9.21504 10.6962 9.09022 10.0754 8.63037 9.76954C8.17052 9.46367 7.54978 9.5885 7.24391 10.0483L6.49738 11.1707C6.19106 11.377 6.03512 11.7238 6.0583 12.0681C6.03512 12.4124 6.19106 12.7592 6.49738 12.9656L7.24391 14.0879C7.54978 14.5477 8.17052 14.6726 8.63037 14.3667C9.09022 14.0608 9.21504 13.4401 8.90917 12.9802L8.30247 12.0681L8.90917 11.156ZM3 11C2.44772 11 2 11.4477 2 12C2 12.0229 2.00077 12.0456 2.00228 12.0681C2.00077 12.0906 2 12.1133 2 12.1362C2 12.6885 2.44772 13.1362 3 13.1362H5.02808C5.58036 13.1362 6.02808 12.6885 6.02808 12.1362C6.02808 12.1133 6.02731 12.0906 6.02579 12.0681C6.02731 12.0456 6.02808 12.0229 6.02808 12C6.02808 11.4477 5.58036 11 5.02808 11H3ZM10.9499 16.0483C10.6441 15.5885 10.0233 15.4637 9.56348 15.7695C9.10363 16.0754 8.97881 16.6962 9.28468 17.156L10.3051 18.6901C10.4904 18.9688 10.803 19.1362 11.1377 19.1362H12.5688C13.1211 19.1362 13.5688 18.6885 13.5688 18.1362C13.5688 17.5839 13.1211 17.1362 12.5688 17.1362H11.6736L10.9499 16.0483Z",
        fill: "currentColor"
    }));

});

parcelRegister("aQY3O", function(module, exports) {

$parcel$export(module.exports, "OnCallGlyph", () => $16003ebb62b1ef5e$export$d3a20748cdc236d3);

var $5uXOq = parcelRequire("5uXOq");
const $16003ebb62b1ef5e$export$d3a20748cdc236d3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.952 5C7.574 5 7.231 5.271 7.078 5.69C6.362 7.648 6 9.712 6 11.827V11.981C6 14.138 6.36 16.25 7.072 18.256C7.239 18.725 7.584 19 7.967 19H9.416L9.209 16.506H7.562L7.415 15.683C7.192 14.44 7.079 13.195 7.079 11.981V11.827C7.079 10.66 7.183 9.48 7.39 8.32L7.536 7.495H9.209L9.416 5H7.952ZM11.41 18.833C11.507 20 10.586 21 9.415 21H7.967C6.744 21 5.634 20.183 5.203 18.967C4.399 16.703 4 14.366 4 11.981V11.827C4 9.478 4.403 7.182 5.199 5.004C5.643 3.787 6.724 3 7.952 3H9.415C10.586 3 11.507 4 11.41 5.167L11.199 7.704C11.115 8.716 10.269 9.495 9.254 9.495H9.231C9.13 10.271 9.079 11.052 9.079 11.827V11.981C9.079 12.81 9.138 13.656 9.254 14.506C10.269 14.506 11.115 15.285 11.199 16.296L11.41 18.833ZM19.3183 12C19.3183 12.829 18.6463 13.5 17.8183 13.5C16.9903 13.5 16.3183 12.829 16.3183 12C16.3183 11.172 16.9903 10.5 17.8183 10.5C18.6463 10.5 19.3183 11.172 19.3183 12ZM12.8183 13.5C13.6463 13.5 14.3183 12.829 14.3183 12C14.3183 11.172 13.6463 10.5 12.8183 10.5C11.9903 10.5 11.3183 11.172 11.3183 12C11.3183 12.829 11.9903 13.5 12.8183 13.5Z",
        fill: "currentColor"
    }));

});

parcelRegister("lNhbS", function(module, exports) {

$parcel$export(module.exports, "KNOWLEDGE_HUB_TYPE", () => $d26b268980a6ee8c$export$85e95297c026ffe1);
$parcel$export(module.exports, "KNOWLEDGE_HUB_NESTED_TYPE", () => $d26b268980a6ee8c$export$66207e8113b05d87);
$parcel$export(module.exports, "SETTINGS_IDS", () => $d26b268980a6ee8c$export$5fd6685a693e1064);
$parcel$export(module.exports, "NG_COMMUNITY_LINK", () => $d26b268980a6ee8c$export$e789d42e7f93d028);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $d26b268980a6ee8c$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $d26b268980a6ee8c$export$9a6deaa9c1af559f);
$parcel$export(module.exports, "MENU_ID_SD", () => $d26b268980a6ee8c$export$e2d4904f27149ba);
$parcel$export(module.exports, "MENU_ID_SD_ITSM", () => $d26b268980a6ee8c$export$4e823a662d7bce02);
$parcel$export(module.exports, "SECTION_ID", () => $d26b268980a6ee8c$export$501955bd67991a25);
$parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", () => $d26b268980a6ee8c$export$75d31ae45b00712c);
$parcel$export(module.exports, "JIRA_FEDRAMP_MODERATE_AUTOMATION_ADDON_KEY", () => $d26b268980a6ee8c$export$b0b94b45c4873ede);
$parcel$export(module.exports, "PROJECT_SETTINGS_SHIFTER_WEIGHT", () => $d26b268980a6ee8c$export$2929141d456c2576);
$parcel$export(module.exports, "FEEDBACK_GROUP_ID", () => $d26b268980a6ee8c$export$14b33d63628336c2);
$parcel$export(module.exports, "packageName", () => $d26b268980a6ee8c$export$9345d7360ffe0722);
$parcel$export(module.exports, "scimTeamName", () => $d26b268980a6ee8c$export$343beee5e53e6b85);
const $d26b268980a6ee8c$export$b5358afda8ff335e = 'base';
const $d26b268980a6ee8c$export$85e95297c026ffe1 = 'hub';
const $d26b268980a6ee8c$export$66207e8113b05d87 = 'hub-nested';
const $d26b268980a6ee8c$export$5fd6685a693e1064 = {
    DETAILS: 'details',
    PEOPLE: 'people',
    SUMMARY: 'summary',
    VIRTUAL_AGENT: 'virtual-agent',
    DELETE_PROJECT: 'delete-project',
    ISSUE_LAYOUT: 'issue-layout',
    ISSUE_TYPES: 'issue-types',
    ITSM_FEATURES: 'itsm-features',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    DEVTOOLS: 'devtools',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    NOTIFICATION_EMAIL: 'notification-email',
    ISSUE_COLLECTORS: 'issue-collectors',
    PROJECT_CHAT_ADDON: 'sd-project-chat-addon',
    FORMS: 'proforma-forms',
    EXTERNAL_LINKS: 'sd-external-links',
    DATA_CLASSIFICATIONS: 'data-classificatons',
    JOURNEYS: 'journeys'
};
const $d26b268980a6ee8c$export$e789d42e7f93d028 = 'https://community.atlassian.com/t5/Next-gen-Jira-Service-Desk/gp-p/next-gen-jsd';
const $d26b268980a6ee8c$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $d26b268980a6ee8c$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';
const $d26b268980a6ee8c$export$e2d4904f27149ba = 'project/service-desk';
const $d26b268980a6ee8c$export$4e823a662d7bce02 = 'project/service-desk-itsm';
const $d26b268980a6ee8c$export$501955bd67991a25 = {
    ISSUES: 'issues',
    QUEUES: 'queues',
    REPORTS: 'reports',
    INSIGHT: 'insight',
    KNOWLEDGE: 'knowledge',
    SETTINGS: 'settings'
};
const $d26b268980a6ee8c$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
const $d26b268980a6ee8c$export$b0b94b45c4873ede = 'com.codebarrel.addons.automation.moderate';
const $d26b268980a6ee8c$export$2929141d456c2576 = 200;
const $d26b268980a6ee8c$export$14b33d63628336c2 = 'jira-servicedesk-itsm-sidebar-nav';
const $d26b268980a6ee8c$export$9345d7360ffe0722 = 'jiraNavigationAppsSidebarServicedesk';
const $d26b268980a6ee8c$export$343beee5e53e6b85 = 'jsm-banana';

});

parcelRegister("a88Sz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $53aad6d9737fb939$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $53aad6d9737fb939$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    headerDescriptionJsm: {
        "id": "spa-apps-sidebar-servicedesk.common.header-description-jsm",
        "defaultMessage": "Service project"
    },
    gettingStarted: {
        "id": "spa-apps-sidebar-servicedesk.common.getting-started",
        "defaultMessage": "Get started"
    },
    itemQueuesRetranslate: {
        "id": "spa-apps-sidebar-servicedesk.common.item-queues-retranslate",
        "defaultMessage": "Queues"
    },
    itemProjectSummary: {
        "id": "spa-apps-sidebar-servicedesk.common.item-project-summary.non-final",
        "defaultMessage": "Summary"
    },
    itemViews: {
        "id": "spa-apps-sidebar-servicedesk.common.item-views",
        "defaultMessage": "Views"
    },
    itemBoards: {
        "id": "spa-apps-sidebar-servicedesk.common.item-boards",
        "defaultMessage": "Board"
    },
    itemCalendars: {
        "id": "spa-apps-sidebar-servicedesk.common.item-calendars",
        "defaultMessage": "Calendar"
    },
    itemCustomers: {
        "id": "spa-apps-sidebar-servicedesk.common.item-customers",
        "defaultMessage": "Customers"
    },
    itemReports: {
        "id": "spa-apps-sidebar-servicedesk.common.item-reports",
        "defaultMessage": "Reports"
    },
    itemRaiseRequest: {
        "id": "spa-apps-sidebar-servicedesk.common.item-raise-request",
        "defaultMessage": "Raise a request"
    },
    itemCustomerChannels: {
        "id": "spa-apps-sidebar-servicedesk.common.item-customer-channels",
        "defaultMessage": "Channels"
    },
    itemInviteAgents: {
        "id": "spa-apps-sidebar-servicedesk.common.item-invite-agents",
        "defaultMessage": "Invite agents"
    },
    itemAddPeople: {
        "id": "spa-apps-sidebar-servicedesk.common.item-add-people",
        "defaultMessage": "Add people"
    },
    itemInsight: {
        "id": "spa-apps-sidebar-servicedesk.common.item-insight",
        "defaultMessage": "Insight"
    },
    itemCmdbAssets: {
        "id": "spa-apps-sidebar-servicedesk.common.item-cmdb-assets",
        "defaultMessage": "Assets"
    },
    projectSettingsRetranslate: {
        "id": "spa-apps-sidebar-servicedesk.common.project-settings-retranslate",
        "defaultMessage": "Project settings"
    },
    serviceProjectSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.service-project-settings",
        "defaultMessage": "Project settings"
    },
    serviceHubSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.service-hub-settings",
        "defaultMessage": "Service hub settings"
    },
    customerHubSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.customer-hub-settings",
        "defaultMessage": "Customer hub settings"
    },
    itemIssues: {
        "id": "spa-apps-sidebar-servicedesk.common.item-issues",
        "defaultMessage": "Issues and filters"
    },
    backToProject: {
        "id": "spa-apps-sidebar-servicedesk.common.back-to-project",
        "defaultMessage": "Back to project"
    },
    backToServiceProject: {
        "id": "spa-apps-sidebar-servicedesk.common.back-to-service-project",
        "defaultMessage": "Back to service project"
    },
    navigateToIncidents: {
        "id": "spa-apps-sidebar-servicedesk.common.navigate-to-incidents",
        "defaultMessage": "navigate to incident queues"
    },
    learnMore: {
        "id": "spa-apps-sidebar-servicedesk.common.learn-more",
        "defaultMessage": "Learn more"
    },
    learnMoreAriaLabel: {
        "id": "spa-apps-sidebar-servicedesk.common.learn-more-aria-label",
        "defaultMessage": "Learn more about Jira Service Management team-managed projects"
    },
    getHelp: {
        "id": "spa-apps-sidebar-servicedesk.common.get-help",
        "defaultMessage": "Get help"
    },
    feedback: {
        "id": "spa-apps-sidebar-servicedesk.common.feedback",
        "defaultMessage": "Give feedback"
    },
    services: {
        "id": "spa-apps-sidebar-servicedesk.common.services",
        "defaultMessage": "Services"
    },
    directory: {
        "id": "spa-apps-sidebar-servicedesk.common.directory",
        "defaultMessage": "Directory"
    },
    knowledgeInsights: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-insights",
        "defaultMessage": "Knowledge"
    },
    operations: {
        "id": "spa-apps-sidebar-servicedesk.common.operations",
        "defaultMessage": "Operations"
    },
    alerts: {
        "id": "spa-apps-sidebar-servicedesk.common.alerts",
        "defaultMessage": "Alerts"
    },
    linkOpensInNewWindow: {
        "id": "spa-apps-sidebar-servicedesk.common.link-opens-in-new-window",
        "defaultMessage": "Link opens in a new window"
    },
    onCall: {
        "id": "spa-apps-sidebar-servicedesk.common.on-call",
        "defaultMessage": "On-call"
    },
    shortcuts: {
        "id": "spa-apps-sidebar-servicedesk.common.shortcuts",
        "defaultMessage": "Shortcuts"
    },
    addShortcutLabel: {
        "id": "spa-apps-sidebar-servicedesk.common.add-shortcut-label",
        "defaultMessage": "Add shortcut"
    },
    changeCalendar: {
        "id": "spa-apps-sidebar-servicedesk.common.change-calendar",
        "defaultMessage": "Change calendar"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-servicedesk.common.new-lozenge",
        "defaultMessage": "New"
    },
    itemOrganizations: {
        "id": "spa-apps-sidebar-servicedesk.common.item-organizations",
        "defaultMessage": "Organizations"
    },
    itemIndividuals: {
        "id": "spa-apps-sidebar-servicedesk.common.item-individuals",
        "defaultMessage": "Customers"
    },
    itemProducts: {
        "id": "spa-apps-sidebar-servicedesk.common.item-products",
        "defaultMessage": "Products"
    },
    itemDeveloperEscalations: {
        "id": "spa-apps-sidebar-servicedesk.common.item-developer-escalations",
        "defaultMessage": "Developer escalations"
    },
    notificationLogs: {
        "id": "spa-apps-sidebar-servicedesk.common.item-notification-logs",
        "defaultMessage": "Customer notification logs"
    },
    sideBarNavigationTitle: {
        "id": "spa-apps-sidebar-servicedesk.menu.section-with-header.side-bar-navigation-title",
        "defaultMessage": "Menu"
    },
    itemArchives: {
        "id": "spa-apps-sidebar-servicedesk.menu.item-archives",
        "defaultMessage": "Archived issues"
    }
});

});

parcelRegister("e1CQH", function(module, exports) {

$parcel$export(module.exports, "CustomerChannelsItem", () => $d62508f06b7af5da$export$750164883a3dc654);

var $5uXOq = parcelRequire("5uXOq");

var $dZ2wS = parcelRequire("dZ2wS");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7cL8O = parcelRequire("7cL8O");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $7KCWP = parcelRequire("7KCWP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d62508f06b7af5da$var$PopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// PLEASE NOTE: The reason for the suppression of the react/jsx-props-no-spreading rule is that
    //              this is exactly following the example from the official documentation, see
    //              https://atlassian.design/components/popup/examples#customization
    //
    //              Spreading props doesn't appear to break behaviour, and it's been confirmed with
    //              ADS that this is the correct way to do it, see https://atlassian.slack.com/archives/CFJ9DU39U/p1708055215799369
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ...props,
        xcss: $d62508f06b7af5da$var$ChannelDialogWrapperStyles,
        ref: ref
    }));
const $d62508f06b7af5da$var$POPUP_OFFSET = [
    0,
    0
];
const $d62508f06b7af5da$export$750164883a3dc654 = ({ AkPopup: AkPopup = (0, $1I7E8.default), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), children: children, useChannelsDialog: useChannelsDialog = (0, $7cL8O.useChannelsDialog) })=>{
    const [{ isChannelsDialogOpen: isChannelsDialogOpen }, { setIsChannelsDialogOpen: setIsChannelsDialogOpen }] = useChannelsDialog();
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            ...triggerProps,
            analytics: {
                itemId: 'customer-channels'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZ2wS))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: ()=>{
                setIsChannelsDialogOpen(!isChannelsDialogOpen);
            }
        }, children), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        isChannelsDialogOpen,
        setIsChannelsDialogOpen
    ]);
    const Content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7KCWP.CustomerChannelsDialog), null), []);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkPopup, {
        popupComponent: $d62508f06b7af5da$var$PopupComponent,
        trigger: Trigger,
        placement: "right",
        content: Content,
        isOpen: isChannelsDialogOpen,
        offset: $d62508f06b7af5da$var$POPUP_OFFSET,
        onClose: ()=>setIsChannelsDialogOpen(false)
    });
};
const $d62508f06b7af5da$var$ChannelDialogWrapperStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.200',
    color: 'color.text',
    padding: 'space.200',
    zIndex: 'dialog',
    boxShadow: 'elevation.shadow.overlay',
    ':focus': {
        outline: 'none'
    }
});

});
parcelRegister("7cL8O", function(module, exports) {

$parcel$export(module.exports, "ChannelsDialogSubscriber", () => $279832461b2a02cb$export$4978f95e5ebfd7a7);
$parcel$export(module.exports, "useChannelsDialog", () => $279832461b2a02cb$export$e09168e89f1ce804);
// TODO DELOR-321 Move directory inside servicedesk when cleaning up the feature flag
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $eNFVv = parcelRequire("eNFVv");
const $279832461b2a02cb$export$4978f95e5ebfd7a7 = (0, $51nlc.createSubscriber)((0, $eNFVv.default), {
    displayName: 'ChannelsDialogSubscriber'
});
const $279832461b2a02cb$export$e09168e89f1ce804 = (0, $3sQ5x.createHook)((0, $eNFVv.default));

});
parcelRegister("eNFVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $298e94783ae47e27$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $7KzHS = parcelRequire("7KzHS");
const $298e94783ae47e27$var$initialState = {
    isChannelsDialogOpen: false
};
var $298e94783ae47e27$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'channels-jsd',
    initialState: $298e94783ae47e27$var$initialState,
    actions: $7KzHS.actions
});

});
parcelRegister("7KzHS", function(module, exports) {

$parcel$export(module.exports, "actions", () => $faa39622c3dfdf94$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $faa39622c3dfdf94$export$e324594224ef24da = {
    setIsChannelsDialogOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isChannelsDialogOpen: isOpen
            });
        }
};

});



parcelRegister("7KCWP", function(module, exports) {

$parcel$export(module.exports, "CustomerChannelsDialog", () => $ec872d7d0d1029b6$export$66408654f999a009);

var $5uXOq = parcelRequire("5uXOq");

var $dxCvy = parcelRequire("dxCvy");

var $4puvO = parcelRequire("4puvO");

var $hcmXv = parcelRequire("hcmXv");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");

var $dnjeJ = parcelRequire("dnjeJ");

var $y8WG5 = parcelRequire("y8WG5");
const $ec872d7d0d1029b6$export$66408654f999a009 = ()=>{
    (0, $dnjeJ.useUFOComponentExperience)((0, $4puvO.loadChannelsExperience));
    const { data: features } = (0, $y8WG5.useSettingFeatures)();
    const projectContext = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    if (!projectContext || !projectContext.data) return null;
    const { projectId: projectId, projectKey: projectKey, isProjectAdmin: isProjectAdmin, simplified: simplified } = projectContext.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcmXv.ChannelsJsdApp), {
        locale: tenantContext.locale,
        projectId: (0, $g5X3G.toProjectId)(String(projectId)),
        projectKey: projectKey,
        environment: tenantContext.environment || 'prod',
        isProjectAdmin: isProjectAdmin || false,
        isProjectSimplified: simplified,
        isJSMChatInstalled: !!features?.hasChat
    }));
};

});
parcelRegister("4puvO", function(module, exports) {

$parcel$export(module.exports, "loadChannelsExperience", () => $436b00fedc71c776$export$9e3b8cd9c06b297f);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $436b00fedc71c776$export$9e3b8cd9c06b297f = new (0, $duUGa.UFOExperience)('jsm-channels-dialog-load', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("hcmXv", function(module, exports) {

$parcel$export(module.exports, "ChannelsJsdApp", () => $6943236aab9713d5$export$c049c55923712d6a);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $7cL8O = parcelRequire("7cL8O");

var $lf2Au = parcelRequire("lf2Au");

var $b71gk = parcelRequire("b71gk");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");

var $9noxX = parcelRequire("9noxX");

var $4hkgA = parcelRequire("4hkgA");

var $7AWNE = parcelRequire("7AWNE");

var $eoy6A = parcelRequire("eoy6A");

var $lkMgE = parcelRequire("lkMgE");

var $log3e = parcelRequire("log3e");

var $5B5Qw = parcelRequire("5B5Qw");

var $jU73Z = parcelRequire("jU73Z");

var $jjpxd = parcelRequire("jjpxd");

var $5lEpS = parcelRequire("5lEpS");

var $eKGJZ = parcelRequire("eKGJZ");
const $6943236aab9713d5$var$CHANNELS_JSD_APP_ID = 'servicedesk.channels-jsd';
const $6943236aab9713d5$var$channelsAnalyticsAttributes = {
    level: 3,
    parentItemId: 'channels'
};
class $6943236aab9713d5$export$c049c55923712d6a extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.store = (0, $lkMgE.default)((0, $4hkgA.default));
        this.store.dispatch((0, $7AWNE.setAppProps)(this.props));
        this.store.dispatch((0, $eoy6A.fetchChannelsInfo)());
    }
    render() {
        const AnalyticsWrapper = (0, $3HwlS.getWillShowNav4)() ? ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                attributes: $6943236aab9713d5$var$channelsAnalyticsAttributes
            }, children) : (0, $5uXOq.Fragment);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: $6943236aab9713d5$var$CHANNELS_JSD_APP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AnalyticsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7cL8O.ChannelsDialogSubscriber), null, (__, { setIsChannelsDialogOpen: setIsChannelsDialogOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKGJZ.ChannelsJsd), {
                EmailChannel: (0, $jU73Z.EmailChannel),
                WidgetChannel: (0, $5lEpS.WidgetChannel),
                HelpDeskChannel: (0, $jjpxd.HelpCenterChannel),
                ChatChannel: (0, $log3e.ChatChannel),
                CustomerAccessChannel: (0, $5B5Qw.CustomerAccessChannel),
                onSetIsChannelsDialogOpen: setIsChannelsDialogOpen
            })))))));
    }
}
var $6943236aab9713d5$export$2e2bcd8739ae039 = $6943236aab9713d5$export$c049c55923712d6a;

});
parcelRegister("lf2Au", function(module, exports) {

$parcel$export(module.exports, "default", () => $9249f8c63b854f95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $9249f8c63b854f95$var$appStyles = null;
var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyle;

});

parcelRegister("9noxX", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $12b9024f66e7ef57$export$ac31f8f3368d6881);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4DPZY = parcelRequire("4DPZY");

var $8H3A4 = parcelRequire("8H3A4");
const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $5uXOq.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
$12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $8H3A4.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $4DPZY.useContainerContext)
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("4hkgA", function(module, exports) {

$parcel$export(module.exports, "default", () => $263ea9e37088564b$export$2e2bcd8739ae039);
parcelRequire("c66Ur");

var $e1AU2 = parcelRequire("e1AU2");

var $2YZCu = parcelRequire("2YZCu");

var $e81jA = parcelRequire("e81jA");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$263ea9e37088564b$export$2e2bcd8739ae039 = (action$, store)=>(0, $e1AU2.combineEpics)((0, $e81jA.default))(action$, store).catch((error, stream)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('navigation-apps.channels-jsd.ops', 'Unhandled error');
        return stream;
    });

});
parcelRegister("e81jA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b172e7acceb70346$export$2e2bcd8739ae039);
parcelRequire("jFVZ1");
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $3yob0 = parcelRequire("3yob0");

var $eoy6A = parcelRequire("eoy6A");

var $geXrZ = parcelRequire("geXrZ");

var $hNv1J = parcelRequire("hNv1J");
const $b172e7acceb70346$export$103bedf43ba882db = 'servicedesk.channels-jsd.get-channels-data';
const $b172e7acceb70346$var$fetchChannelsInfoEpic = (action$, store)=>action$.ofType((0, $eoy6A.FETCH_CHANNELS_INFO)).switchMap(()=>{
        const state = store.getState();
        const projectId = (0, $geXrZ.getProjectId)(state);
        const fetchChannelsInfo$ = (0, $kVLXA.Observable).fromPromise((0, $3yob0.getChannelsInfo)(projectId)).filter(()=>!(0, $hNv1J.isLoading)(state)).map((channelChannelsInfo)=>(0, $eoy6A.setChannelsInfo)(channelChannelsInfo)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData($b172e7acceb70346$export$103bedf43ba882db, error.message, error);
            return (0, $kVLXA.Observable).of((0, $eoy6A.fetchChannelsInfoFailure)());
        });
        return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $eoy6A.startFetchingChannelsInfo)()), fetchChannelsInfo$);
    });
var $b172e7acceb70346$export$2e2bcd8739ae039 = $b172e7acceb70346$var$fetchChannelsInfoEpic;

});
parcelRegister("3yob0", function(module, exports) {

$parcel$export(module.exports, "getChannelsInfo", () => $eaef85146409857a$export$b590e670e822027b);

var $lnm1a = parcelRequire("lnm1a");
const $eaef85146409857a$export$b590e670e822027b = async (projectId)=>{
    const response = await (0, $lnm1a.getChannelsInfoRest)(projectId);
    return response;
};

});
parcelRegister("lnm1a", function(module, exports) {

$parcel$export(module.exports, "getChannelsInfoRest", () => $3cd5b0165ad1b158$export$8ddcce8cefd2b115);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
const $3cd5b0165ad1b158$export$94df0e59ebebf4a7 = (projectId)=>`/rest/servicedesk/1/channels/project/${projectId}`;
const $3cd5b0165ad1b158$export$8ddcce8cefd2b115 = async (projectId)=>{
    const url = $3cd5b0165ad1b158$export$94df0e59ebebf4a7(projectId);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (response.ok) return response.json();
    throw new (0, $jJZqs.default)(response.status, await response.text());
};

});


parcelRegister("eoy6A", function(module, exports) {

$parcel$export(module.exports, "FETCH_CHANNELS_INFO", () => $772c0b959150dab7$export$7f26b66809e5a023);
$parcel$export(module.exports, "fetchChannelsInfo", () => $772c0b959150dab7$export$39d5ba67288fd23e);
$parcel$export(module.exports, "START_FETCHING_CHANNELS_INFO", () => $772c0b959150dab7$export$3279710c1ed61a9e);
$parcel$export(module.exports, "startFetchingChannelsInfo", () => $772c0b959150dab7$export$f5ff46acf8eac6af);
$parcel$export(module.exports, "FETCH_CHANNELS_INFO_FAILURE", () => $772c0b959150dab7$export$d78dcbaa85e89076);
$parcel$export(module.exports, "fetchChannelsInfoFailure", () => $772c0b959150dab7$export$dabf7696a8f036c4);
$parcel$export(module.exports, "SET_CHANNELS_INFO", () => $772c0b959150dab7$export$67d17920cf43ff01);
$parcel$export(module.exports, "setChannelsInfo", () => $772c0b959150dab7$export$96bf4d6f0bb73592);
const $772c0b959150dab7$export$7f26b66809e5a023 = 'state.actions.app-state.FETCH_CHANNELS_INFO';
const $772c0b959150dab7$export$39d5ba67288fd23e = ()=>({
        type: $772c0b959150dab7$export$7f26b66809e5a023
    });
const $772c0b959150dab7$export$3279710c1ed61a9e = 'state.actions.app-state.START_FETCHING_CHANNELS_INFO';
const $772c0b959150dab7$export$f5ff46acf8eac6af = ()=>({
        type: $772c0b959150dab7$export$3279710c1ed61a9e
    });
const $772c0b959150dab7$export$d78dcbaa85e89076 = 'state.actions.app-state.FETCH_CHANNELS_INFO_FAILURE';
const $772c0b959150dab7$export$dabf7696a8f036c4 = ()=>({
        type: $772c0b959150dab7$export$d78dcbaa85e89076
    });
const $772c0b959150dab7$export$67d17920cf43ff01 = 'state.actions.app-state.SET_CHANNELS_INFO';
const $772c0b959150dab7$export$96bf4d6f0bb73592 = (payload)=>({
        payload: payload,
        type: $772c0b959150dab7$export$67d17920cf43ff01
    });

});

parcelRegister("geXrZ", function(module, exports) {

$parcel$export(module.exports, "getProjectId", () => $65a04fbb797dbf29$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectKey", () => $65a04fbb797dbf29$export$667f2a0f99c75faa);
$parcel$export(module.exports, "isProjectAdmin", () => $65a04fbb797dbf29$export$b23507437e4b06ac);
$parcel$export(module.exports, "isProjectSimplified", () => $65a04fbb797dbf29$export$52c053325a56f3c0);
$parcel$export(module.exports, "isJSMChatInstalled", () => $65a04fbb797dbf29$export$5df019d60d1ab17a);
const $65a04fbb797dbf29$export$876089ea65adc54 = (state)=>state.appProps;
const $65a04fbb797dbf29$export$180605366c04f0cd = (state)=>$65a04fbb797dbf29$export$876089ea65adc54(state).locale;
const $65a04fbb797dbf29$export$89040d072f281f85 = (state)=>$65a04fbb797dbf29$export$876089ea65adc54(state).projectId;
const $65a04fbb797dbf29$export$667f2a0f99c75faa = (state)=>$65a04fbb797dbf29$export$876089ea65adc54(state).projectKey;
const $65a04fbb797dbf29$export$57570b1603cf6adb = (state)=>$65a04fbb797dbf29$export$876089ea65adc54(state).environment;
const $65a04fbb797dbf29$export$b23507437e4b06ac = (state)=>$65a04fbb797dbf29$export$876089ea65adc54(state).isProjectAdmin;
const $65a04fbb797dbf29$export$52c053325a56f3c0 = (state)=>$65a04fbb797dbf29$export$876089ea65adc54(state).isProjectSimplified;
const $65a04fbb797dbf29$export$5df019d60d1ab17a = (state)=>$65a04fbb797dbf29$export$876089ea65adc54(state).isJSMChatInstalled;

});

parcelRegister("hNv1J", function(module, exports) {

$parcel$export(module.exports, "isWidgetEnabled", () => $391896aa574bcfd1$export$f2857eeda2ea245d);
$parcel$export(module.exports, "getCustomerAccess", () => $391896aa574bcfd1$export$e4f45ab82b59a034);
$parcel$export(module.exports, "getServiceDeskEmail", () => $391896aa574bcfd1$export$efe2d92f56bd841d);
$parcel$export(module.exports, "isLoading", () => $391896aa574bcfd1$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isEmailEnabled", () => $391896aa574bcfd1$export$3390953d2c324024);
$parcel$export(module.exports, "getPortalId", () => $391896aa574bcfd1$export$79c9b12a0a57147a);
$parcel$export(module.exports, "isChatEnabled", () => $391896aa574bcfd1$export$afd6e39d6ad8b221);
$parcel$export(module.exports, "getPortalUrl", () => $391896aa574bcfd1$export$8f6fdb27182bf17e);
const $391896aa574bcfd1$export$e5739260e1926e37 = (state)=>state.appState;
const $391896aa574bcfd1$export$f2857eeda2ea245d = (state)=>$391896aa574bcfd1$export$e5739260e1926e37(state).widgetEnabled;
const $391896aa574bcfd1$export$e4f45ab82b59a034 = (state)=>state.appState.customerAccess;
const $391896aa574bcfd1$export$efe2d92f56bd841d = (state)=>$391896aa574bcfd1$export$e5739260e1926e37(state).serviceDeskEmail;
const $391896aa574bcfd1$export$20bb0d907fbbe433 = (state)=>$391896aa574bcfd1$export$e5739260e1926e37(state).isLoading;
const $391896aa574bcfd1$export$3390953d2c324024 = (state)=>!!$391896aa574bcfd1$export$efe2d92f56bd841d(state) && $391896aa574bcfd1$export$efe2d92f56bd841d(state).length > 0;
const $391896aa574bcfd1$export$79c9b12a0a57147a = (state)=>$391896aa574bcfd1$export$e5739260e1926e37(state).portalId;
const $391896aa574bcfd1$export$afd6e39d6ad8b221 = (state)=>$391896aa574bcfd1$export$e5739260e1926e37(state).chatEnabled;
const $391896aa574bcfd1$export$8f6fdb27182bf17e = (state)=>$391896aa574bcfd1$export$e5739260e1926e37(state).portalUrl;

});



parcelRegister("7AWNE", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $705e0a04f5e4ab93$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $705e0a04f5e4ab93$export$cfda7627848a58cd);
const $705e0a04f5e4ab93$export$8aefe701a6f431e0 = 'state.actions.app-props.SET_APP_PROPS';
const $705e0a04f5e4ab93$export$cfda7627848a58cd = (payload)=>({
        type: $705e0a04f5e4ab93$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("lkMgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c2f418d580fb6b$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $2B13L = parcelRequire("2B13L");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$51c2f418d580fb6b$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'channels-jsd',
        rootReducer: $2B13L.default,
        rootEpic: rootEpic
    });

});
parcelRegister("2B13L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3fe19b2cb565009$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $lYxhm = parcelRequire("lYxhm");

var $3Gjhg = parcelRequire("3Gjhg");
const $f3fe19b2cb565009$export$d4c72bab9d6cc13a = {
    appProps: (0, $lYxhm.initialState),
    appState: (0, $3Gjhg.initialState)
};
var $f3fe19b2cb565009$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    appProps: $lYxhm.default,
    appState: $3Gjhg.default
});

});
parcelRegister("lYxhm", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $8e7c4e8ce20ccc75$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $8e7c4e8ce20ccc75$export$2e2bcd8739ae039);

var $lzeFL = parcelRequire("lzeFL");

var $g5X3G = parcelRequire("g5X3G");

var $7AWNE = parcelRequire("7AWNE");
const $8e7c4e8ce20ccc75$export$d4c72bab9d6cc13a = {
    locale: (0, $lzeFL.defaultLocale),
    projectId: (0, $g5X3G.toProjectId)('-1'),
    projectKey: (0, $g5X3G.toProjectKey)(''),
    environment: 'prod',
    isProjectAdmin: false,
    isProjectSimplified: false,
    isJSMChatInstalled: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8e7c4e8ce20ccc75$export$2e2bcd8739ae039 = (state = $8e7c4e8ce20ccc75$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $7AWNE.SET_APP_PROPS:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("3Gjhg", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $874b113808e9684c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $874b113808e9684c$export$2e2bcd8739ae039);

var $h6jnh = parcelRequire("h6jnh");

var $eoy6A = parcelRequire("eoy6A");
const $874b113808e9684c$export$d4c72bab9d6cc13a = {
    widgetEnabled: false,
    serviceDeskEmail: '',
    isLoading: false,
    portalId: 0,
    chatEnabled: false,
    portalUrl: '',
    customerAccess: (0, $h6jnh.CUSTOMER_ACCESS).PUBLIC
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$874b113808e9684c$export$2e2bcd8739ae039 = (state = $874b113808e9684c$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $eoy6A.FETCH_CHANNELS_INFO:
            return {
                ...state
            };
        case 0, $eoy6A.START_FETCHING_CHANNELS_INFO:
            return {
                ...state,
                isLoading: true
            };
        case 0, $eoy6A.FETCH_CHANNELS_INFO_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case 0, $eoy6A.SET_CHANNELS_INFO:
            return {
                ...state,
                isLoading: false,
                widgetEnabled: action.payload.widgetEnabled,
                portalId: action.payload.portalId,
                serviceDeskEmail: action.payload.serviceDeskEmail,
                chatEnabled: action.payload.chatEnabled,
                portalUrl: action.payload.portalUrl,
                customerAccess: action.payload.customerAccess ?? (0, $h6jnh.CUSTOMER_ACCESS).PUBLIC
            };
        default:
            {
                const _exhaustiveCheck = action;
                return {
                    ...state
                };
            }
    }
};

});
parcelRegister("h6jnh", function(module, exports) {

$parcel$export(module.exports, "ACCESS_TYPES", () => $e31367306d6ffd3d$export$6ac93f9e47fc137b);
$parcel$export(module.exports, "PORTAL_ACCESS", () => $e31367306d6ffd3d$export$393a9929126b63d8);
$parcel$export(module.exports, "CUSTOMER_ACCESS", () => $e31367306d6ffd3d$export$1a38bc465284831a);
$parcel$export(module.exports, "SHARE_REQUESTS_ACCESS", () => $e31367306d6ffd3d$export$f8f38f62ce063838);
const $e31367306d6ffd3d$export$6ac93f9e47fc137b = {
    RESTRICTED: 'RESTRICTED',
    PUBLIC: 'PUBLIC',
    ANONYMOUS: 'ANONYMOUS',
    INTERNAL: 'INTERNAL'
};
const $e31367306d6ffd3d$export$393a9929126b63d8 = $e31367306d6ffd3d$export$6ac93f9e47fc137b;
const $e31367306d6ffd3d$export$1a38bc465284831a = $e31367306d6ffd3d$export$6ac93f9e47fc137b;
const $e31367306d6ffd3d$export$f8f38f62ce063838 = {
    AGENT_ONLY: 'AGENT_ONLY',
    EMAIL_ONLY: 'EMAIL_ONLY',
    SEARCH_AUTO_COMPLETE: 'SEARCH_AUTO_COMPLETE'
};

});




parcelRegister("log3e", function(module, exports) {

$parcel$export(module.exports, "ChatChannel", () => $e457db5c2c7dc039$export$e46294d6f22408f);

var $bC2fB = parcelRequire("bC2fB");

var $geXrZ = parcelRequire("geXrZ");

var $hNv1J = parcelRequire("hNv1J");

var $lngB3 = parcelRequire("lngB3");

var $fD3oP = parcelRequire("fD3oP");
const $e457db5c2c7dc039$var$mapStateToProps = (state)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { hostname: hostname } = window.location;
    const projectKey = (0, $geXrZ.getProjectKey)(state);
    const isSimplified = (0, $geXrZ.isProjectSimplified)(state);
    return {
        isAdmin: (0, $geXrZ.isProjectAdmin)(state),
        isEnabled: (0, $hNv1J.isChatEnabled)(state),
        isJSMChatInstalled: (0, $geXrZ.isJSMChatInstalled)(state),
        link: (0, $lngB3.getChatSettingsLink)(hostname, projectKey, isSimplified)
    };
};
const $e457db5c2c7dc039$export$e46294d6f22408f = (0, $bC2fB.connect)($e457db5c2c7dc039$var$mapStateToProps, {})((0, $fD3oP.ChatChannelView));

});
parcelRegister("lngB3", function(module, exports) {

$parcel$export(module.exports, "getChatSettingsLink", () => $063b217a6c7a326a$export$dfe60043eccb4b1c);
const $063b217a6c7a326a$export$dfe60043eccb4b1c = (hostname, projectKey, isSimplified)=>`https://${hostname}/jira/servicedesk/projects/${projectKey}/settings${isSimplified ? '/channels' : ''}/chat?placement=channelsConfigure`;

});

parcelRegister("fD3oP", function(module, exports) {

$parcel$export(module.exports, "ChatChannelView", () => $e641720f298387c4$export$aaabed1389dcea08);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $fVnbM = parcelRequire("fVnbM");

var $82RQj = parcelRequire("82RQj");

var $iQv12 = parcelRequire("iQv12");

var $8RXs9 = parcelRequire("8RXs9");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $aj3l3 = parcelRequire("aj3l3");

var $eRwaR = parcelRequire("eRwaR");

var $7qQMP = parcelRequire("7qQMP");

var $1WFFE = parcelRequire("1WFFE");
const $e641720f298387c4$var$ChatChannelViewComponent = ({ isEnabled: isEnabled, isAdmin: isAdmin, isJSMChatInstalled: isJSMChatInstalled, onClick: onClick, link: link, intl: { formatMessage: formatMessage } })=>{
    const image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.ChannelItemImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7qQMP.ChatIcon), null));
    if (!isJSMChatInstalled) return null;
    const configureButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: link,
        onClick: onClick,
        appearance: "default",
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_channel') ? {
            'aria-label': formatMessage((0, $1WFFE.default).configureLabelDescriptive)
        } : {}
    }, formatMessage((0, $1WFFE.default).configure));
    const lozengeType = isEnabled ? (0, $aj3l3.LOZENGE_TYPES).ON : (0, $aj3l3.LOZENGE_TYPES).OFF;
    const lozengeLabel = formatMessage(isEnabled ? (0, $1WFFE.default).chatConnectedLabel : (0, $1WFFE.default).chatInactiveLabel);
    const isNav4 = (0, $3HwlS.getWillShowNav4)();
    const getChatDescriptionMessage = ()=>{
        return (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $1WFFE.default).chatDescriptionIssueTermRefresh : (0, $1WFFE.default).chatDescription;
    };
    const description = isEnabled ? formatMessage(getChatDescriptionMessage()) : formatMessage(isNav4 ? (0, $1WFFE.default).chatOff : getChatDescriptionMessage());
    const icon = isNav4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($82RQj))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }) : image;
    const label = isNav4 ? formatMessage((0, $1WFFE.default).label) : formatMessage((0, $1WFFE.default).chatLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.BaseChannelItem), {
        button: isAdmin ? configureButton : undefined,
        image: icon,
        label: label,
        description: description,
        channelName: "chat",
        statusLozenge: !isNav4 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj3l3.ChannelStatusLozenge), {
            type: lozengeType,
            label: lozengeLabel
        })
    });
};
const $e641720f298387c4$export$aaabed1389dcea08 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'configureChat'
}), (0, $8RXs9.default))($e641720f298387c4$var$ChatChannelViewComponent);

});
parcelRegister("82RQj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7997b223b163fea361e6870d11885d8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5db846b1e6bcdc52$var$_react = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5db846b1e6bcdc52$var$_baseNew = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5db846b1e6bcdc52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5db846b1e6bcdc52$var$AiChatIcon = (props)=>/*#__PURE__*/ $5db846b1e6bcdc52$var$_react.default.createElement($5db846b1e6bcdc52$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2z" clip-rule="evenodd"/><path fill="currentcolor" d="M6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$5db846b1e6bcdc52$var$AiChatIcon.displayName = 'AiChatIcon';
var $5db846b1e6bcdc52$var$_default = module.exports.default = $5db846b1e6bcdc52$var$AiChatIcon;

});

parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("aj3l3", function(module, exports) {

$parcel$export(module.exports, "LOZENGE_TYPES", () => $51b61d5ca3b3db2b$export$a281685bc76a04e3);
$parcel$export(module.exports, "ChannelStatusLozenge", () => $51b61d5ca3b3db2b$export$b19f18e8d0f28578);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");
const $51b61d5ca3b3db2b$export$a281685bc76a04e3 = {
    ON: 'ON',
    OFF: 'OFF',
    RESTRICTED: 'RESTRICTED'
};
const $51b61d5ca3b3db2b$var$getAppearance = (type)=>{
    switch(type){
        case $51b61d5ca3b3db2b$export$a281685bc76a04e3.ON:
            return 'success';
        case $51b61d5ca3b3db2b$export$a281685bc76a04e3.OFF:
            return 'default';
        case $51b61d5ca3b3db2b$export$a281685bc76a04e3.RESTRICTED:
            return 'removed';
        default:
            return 'default';
    }
};
const $51b61d5ca3b3db2b$export$b19f18e8d0f28578 = ({ label: label, type: type })=>{
    const appearence = $51b61d5ca3b3db2b$var$getAppearance(type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: appearence
    }, label);
};

});

parcelRegister("eRwaR", function(module, exports) {

$parcel$export(module.exports, "BaseChannelItem", () => $d5a98be54790ad8f$export$6e9ca75a956eec88);
$parcel$export(module.exports, "ChannelItemImage", () => $d5a98be54790ad8f$export$fce1039a8a4a6886);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $kTsKx = parcelRequire("kTsKx");
const $d5a98be54790ad8f$export$6e9ca75a956eec88 = (0, $kTsKx.ChannelItemView);
const $d5a98be54790ad8f$export$fce1039a8a4a6886 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1auhp1j": (0, $lD23V.default)(`${4 * (0, $gwIPs.gridSize)}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ifbz3 _1bsbfbz3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kTsKx", function(module, exports) {

$parcel$export(module.exports, "ChannelItemView", () => $76386ff8672466af$export$1a43b778297bdc43);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $7y4Op = parcelRequire("7y4Op");
class $76386ff8672466af$export$d5a8565920c2aa66 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            button: undefined
        };
    }
    render() {
        const { button: button, image: image, label: label, description: description, channelName: channelName, statusLozenge: statusLozenge } = this.props;
        const { isHovered: isHovered } = this.state;
        return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $76386ff8672466af$var$wrapperStyles,
            testId: `servicedesk.channels-jsd.channels.${channelName}`,
            onFocus: this.onHover,
            onBlur: this.onBlur,
            onMouseOver: this.onHover,
            onMouseLeave: this.onBlur,
            ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_channel') ? {} : {
                tabIndex: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $76386ff8672466af$var$iconStyles
        }, image), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $76386ff8672466af$var$descriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $76386ff8672466af$var$labelStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "medium",
            weight: "medium",
            color: "color.text.subtle"
        }, label), channelName === 'help-center' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $76386ff8672466af$var$helpCenterLozengeStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7y4Op.JsmCustomDomainLozenge), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p",
            maxLines: 1,
            size: "small",
            color: "color.text.subtle"
        }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $76386ff8672466af$var$lozengeStyles
        }, (0, $4R6GH.fg)('jsm_aiiy_for_nav_item_channel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            testId: `servicedesk.channels-jsd.channels.${channelName}.button`,
            xcss: [
                $76386ff8672466af$var$buttonStyles,
                !isHovered && (0, $4R6GH.fg)('jsm_aiiy_for_nav_item_channel') ? $76386ff8672466af$var$hiddenStyles : undefined
            ]
        }, button), !isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, statusLozenge)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            testId: `servicedesk.channels-jsd.channels.${channelName}.button`,
            xcss: $76386ff8672466af$var$buttonStyles
        }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, statusLozenge))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76386ff8672466af$var$ChannelItemWrapperNav3, {
            "data-testid": `servicedesk.channels-jsd.channels.${channelName}`,
            onFocus: this.onHover,
            onBlur: this.onBlur,
            onMouseOver: this.onHover,
            onMouseLeave: this.onBlur,
            isHovered: isHovered
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76386ff8672466af$var$ChannelItemImageWrapperNav3, null, image), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76386ff8672466af$var$ChannelItemTextWrapperNav3, null, channelName === 'help-center' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76386ff8672466af$var$ChannelItemLabelWrapperNav3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "xxsmall",
            as: "h4"
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $76386ff8672466af$var$channelItemLozengeWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7y4Op.JsmCustomDomainLozenge), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "xxsmall",
            as: "h4"
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p",
            maxLines: 1
        }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76386ff8672466af$var$ChannelItemButtonWrapperNav3, {
            "data-testid": `servicedesk.channels-jsd.channels.${channelName}.button`,
            isHovered: isHovered
        }, button), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76386ff8672466af$var$StatusLozengeWrapper, {
            isHovered: isHovered
        }, statusLozenge));
    }
    constructor(...args){
        super(...args), this.state = {
            isHovered: false
        }, this.onHover = ()=>{
            this.setState({
                isHovered: true
            });
        }, this.onBlur = ()=>{
            this.setState({
                isHovered: false
            });
        };
    }
}
const $76386ff8672466af$export$1a43b778297bdc43 = $76386ff8672466af$export$d5a8565920c2aa66;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76386ff8672466af$var$ChannelItemImageWrapperNav3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkooahv _1tkeoahv _1ul9oahv _1bah1h6o _4cvr1h6o _19pku2gc _18u0pxbi _2hwxpxbi _otyru2gc _bfhkm7j4 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $76386ff8672466af$var$ChannelItemTextWrapperNav3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi _19pkpxbi _s7n4nkob _1pbyidpf _1bsb4d55",
            __cmplp.className
        ])
    });
});
const $76386ff8672466af$var$channelItemLozengeWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100',
    marginBottom: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76386ff8672466af$var$ChannelItemLabelWrapperNav3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1gjq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $76386ff8672466af$var$ChannelItemButtonWrapperNav3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _4t3ixy5q _19pkpxbi _otyrpxbi _2hwxpxbi _18u01ejb _kqswstnw _1xi2idpf _1pbyzo7u _bfhk11bn _16qs1cd0",
            __cmplp.isHovered ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $76386ff8672466af$var$StatusLozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ahbq1wug _12l2pxbi",
            __cmplp.isHovered ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $76386ff8672466af$var$ChannelItemWrapperNav3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reoewfl _18m9ewfl _1e0c1txw _4cvr1h6o _1bsblti4 _4t3ivbgk _kqswh2mm _19pkidpf _2hwxmgjw _otyridpf _18u0mgjw",
            __cmplp.isHovered ? "_bfhk166n" : "_bfhk1w7a",
            __cmplp.className
        ])
    });
});
const $76386ff8672466af$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    position: 'relative',
    height: '48px',
    marginInline: 'space.negative.100',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral'
    },
    ':focus': {
        backgroundColor: 'color.background.neutral'
    }
});
const $76386ff8672466af$var$labelStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $76386ff8672466af$var$descriptionStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.200'
});
const $76386ff8672466af$var$iconStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    marginInlineStart: 'space.200',
    marginInlineEnd: 'space.100'
});
const $76386ff8672466af$var$buttonStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    height: 'space.400',
    margin: 'space.100',
    marginInlineStart: 'space.300',
    textDecoration: 'none',
    zIndex: 'layer',
    backgroundColor: 'color.background.accent.gray.subtlest'
});
const $76386ff8672466af$var$helpCenterLozengeStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});
const $76386ff8672466af$var$lozengeStyles = (0, $8CUq3.xcss)({
    marginInlineStart: 'auto',
    marginInlineEnd: 'space.200'
});
const $76386ff8672466af$var$hiddenStyles = (0, $8CUq3.xcss)({
    opacity: 0
});

});
parcelRegister("7y4Op", function(module, exports) {

$parcel$export(module.exports, "JsmCustomDomainLozenge", () => $2839eab6d92344f1$export$7ebf83055cf53143);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $ex8CH = parcelRequire("ex8CH");

var $koVbs = parcelRequire("koVbs");

var $c4MSy = parcelRequire("c4MSy");
const $2839eab6d92344f1$var$PERIOD_TO_SHOW_LOZENGE_IN_DAYS = 21;
const $2839eab6d92344f1$export$7ebf83055cf53143 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ showFlagUpdateStartDate: showFlagUpdateStartDate, loading: loading, error: error }, { fetchApplicationProperty: fetchApplicationProperty }] = (0, $ex8CH.useProperties)();
    (0, $5uXOq.useEffect)(()=>{
        fetchApplicationProperty();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const currentTime = Date.now();
    const customDomainUpdatedDate = typeof showFlagUpdateStartDate === 'number' ? new Date(showFlagUpdateStartDate) : null;
    const stopShowLozengeTimestamp = customDomainUpdatedDate && customDomainUpdatedDate.setDate(customDomainUpdatedDate.getDate() + $2839eab6d92344f1$var$PERIOD_TO_SHOW_LOZENGE_IN_DAYS);
    const showLozenge = customDomainUpdatedDate && stopShowLozengeTimestamp ? currentTime < stopShowLozengeTimestamp : false;
    return !error && !loading && showLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $c4MSy.default).helpCenterLozenge)) : null;
};

});
parcelRegister("ex8CH", function(module, exports) {

$parcel$export(module.exports, "NOT_LOADED", () => $4ceccd054bbaa79c$export$256d135b6d6cdabe);
$parcel$export(module.exports, "NO_VALUE", () => $4ceccd054bbaa79c$export$d5a265bcf7e0ecc1);
$parcel$export(module.exports, "useProperties", () => $4ceccd054bbaa79c$export$b003fb77901c7fe3);

var $5uXOq = parcelRequire("5uXOq");

var $bFU4G = parcelRequire("bFU4G");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $9OXo1 = parcelRequire("9OXo1");

const $4ceccd054bbaa79c$export$256d135b6d6cdabe = 'NOT_LOADED';
const $4ceccd054bbaa79c$export$d5a265bcf7e0ecc1 = 'NO_VALUE';
const $4ceccd054bbaa79c$var$EXPECTED_ERROR_STATUS = [
    403,
    404
];
const $4ceccd054bbaa79c$export$b003fb77901c7fe3 = ()=>{
    const currentTime = Date.now();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [showFlagUpdateStartDate, setShowFlagUpdateStartDate] = (0, $5uXOq.useState)($4ceccd054bbaa79c$export$256d135b6d6cdabe);
    const [helpCenterUrls, setHelpcenterUrls] = (0, $5uXOq.useState)(undefined);
    const [customDomainStatus, setCustomDomainStatus] = (0, $5uXOq.useState)(undefined);
    const [userSeenFlagDate, setUserSeenFlagDate] = (0, $5uXOq.useState)($4ceccd054bbaa79c$export$256d135b6d6cdabe);
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleErrorLogging = (0, $5uXOq.useCallback)((operation, e)=>{
        setLoading(false);
        if (e.name === 'FetchError' && !$4ceccd054bbaa79c$var$EXPECTED_ERROR_STATUS.includes(e.statusCode)) {
            (0, $jcw0u.default)({
                meta: {
                    id: operation,
                    packageName: (0, $a714ef406a66d2e3$export$b8b9d90f9e5bd72b),
                    teamName: (0, $a714ef406a66d2e3$export$d57b6b390e78d90f)
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(e);
        }
    }, []);
    const fetchSeenFlagDateProperty = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        if (atlassianAccountId && userSeenFlagDate === $4ceccd054bbaa79c$export$256d135b6d6cdabe) {
            setLoading(true);
            try {
                const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $a714ef406a66d2e3$export$a7741d60828dd6c));
                setLoading(false);
                setUserSeenFlagDate(Number(response));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setUserSeenFlagDate($4ceccd054bbaa79c$export$d5a265bcf7e0ecc1);
                handleErrorLogging((0, $a714ef406a66d2e3$export$9c32917917adce6b), e);
            }
        }
    }, [
        atlassianAccountId,
        handleErrorLogging,
        loading,
        userSeenFlagDate
    ]);
    const updateUserProperty = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        if (atlassianAccountId) {
            setLoading(true);
            try {
                await (0, $89SaW.setUserProperties)(atlassianAccountId, (0, $a714ef406a66d2e3$export$a7741d60828dd6c), currentTime.toString());
                setLoading(false);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                handleErrorLogging((0, $a714ef406a66d2e3$export$622e359c4ee54143), e);
            }
        }
    }, [
        atlassianAccountId,
        currentTime,
        handleErrorLogging,
        loading
    ]);
    const fetchApplicationProperty = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            const fetchStartTime = performance.now();
            const response = await (0, $eusud.performGetRequest)('/rest/servicedesk/1/customdomain');
            (0, $bFU4G.addSpanToAll)('fetch', 'rest/servicedesk/1/customdomain', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            const { startDate: startDate, newUrl: newUrl, oldUrl: oldUrl, status: status } = response;
            setLoading(false);
            setShowFlagUpdateStartDate(startDate);
            setHelpcenterUrls({
                newUrl: newUrl,
                oldUrl: oldUrl
            });
            setCustomDomainStatus(status);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setShowFlagUpdateStartDate($4ceccd054bbaa79c$export$d5a265bcf7e0ecc1);
            handleErrorLogging((0, $a714ef406a66d2e3$export$3fbedbe58601db04), e);
        }
    }, [
        handleErrorLogging,
        loading
    ]);
    const memoisedData = (0, $5uXOq.useMemo)(()=>({
            userSeenFlagDate: userSeenFlagDate,
            showFlagUpdateStartDate: showFlagUpdateStartDate,
            helpCenterUrls: helpCenterUrls,
            customDomainStatus: customDomainStatus,
            loading: loading,
            error: error
        }), [
        userSeenFlagDate,
        showFlagUpdateStartDate,
        loading,
        error,
        helpCenterUrls,
        customDomainStatus
    ]);
    return [
        memoisedData,
        {
            fetchSeenFlagDateProperty: fetchSeenFlagDateProperty,
            updateUserProperty: updateUserProperty,
            fetchApplicationProperty: fetchApplicationProperty
        }
    ];
};

});
const $a714ef406a66d2e3$export$a7741d60828dd6c = 'jsm.custom.domain.flag.seen.date';
const $a714ef406a66d2e3$export$b8b9d90f9e5bd72b = 'jiraHelpCenterCustomDomainChangeBoarding';
const $a714ef406a66d2e3$export$d57b6b390e78d90f = 'jsm-banana';
const $a714ef406a66d2e3$export$9c32917917adce6b = 'fetchUserProperty';
const $a714ef406a66d2e3$export$622e359c4ee54143 = 'updateUserProperty';
const $a714ef406a66d2e3$export$3fbedbe58601db04 = 'getShowFlagDate';


parcelRegister("c4MSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $848679fabb5a27fc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $848679fabb5a27fc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    helpCenterLozenge: {
        "id": "servicedesk.channels-jsd.channels.help-center.jsm-custom-domain-lozenge.help-center-lozenge",
        "defaultMessage": "UPDATED"
    }
});

});




parcelRegister("7qQMP", function(module, exports) {

$parcel$export(module.exports, "ChatIcon", () => $cc68de3a75e2ba71$export$52cd484a7ef4f2b9);

var $5uXOq = parcelRequire("5uXOq");
const $cc68de3a75e2ba71$var$primaryColor = "var(--ds-icon, #44546F)";
const $cc68de3a75e2ba71$var$baseColor = "var(--ds-background-neutral, #091E420F)";
const $cc68de3a75e2ba71$export$52cd484a7ef4f2b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14.2672 24.8747L14.1058 25.0336V24.0883C14.1058 23.1218 13.3223 22.3383 12.3558 22.3383H11.9424H11.933L11.9236 22.3385C8.16922 22.3951 4.98752 19.8399 4.33501 16.3892C4.01162 14.3703 4.61966 12.3077 6.0189 10.7402C7.42398 9.16627 9.4892 8.24873 11.6766 8.25H11.6773H20.9067C23.089 8.25845 25.1455 9.18099 26.5429 10.755L27.4777 9.92516L26.5429 10.755C27.935 12.3232 28.5376 14.3829 28.2122 16.3979C27.56 19.849 24.3781 22.4045 20.6234 22.3479L20.6143 22.3478L20.6052 22.3478C18.2421 22.3465 15.9656 23.2459 14.2789 24.8633L14.273 24.869L14.2672 24.8747Z",
        fill: $cc68de3a75e2ba71$var$baseColor,
        stroke: $cc68de3a75e2ba71$var$primaryColor,
        strokeWidth: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M21.7589 17.2496C20.8103 17.2496 20.0413 16.4829 20.0413 15.5371C20.0413 14.5912 20.8103 13.8245 21.7589 13.8245C22.7075 13.8245 23.4766 14.5912 23.4766 15.5371C23.4766 16.4829 22.7075 17.2496 21.7589 17.2496Z",
        fill: $cc68de3a75e2ba71$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.7824 17.2496C9.83373 17.2496 9.06472 16.4829 9.06472 15.5371C9.06472 14.5912 9.83373 13.8245 10.7824 13.8245C11.731 13.8245 12.5 14.5912 12.5 15.5371C12.5 16.4829 11.731 17.2496 10.7824 17.2496Z",
        fill: $cc68de3a75e2ba71$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.2667 17.2496C15.3181 17.2496 14.5491 16.4829 14.5491 15.5371C14.5491 14.5912 15.3181 13.8245 16.2667 13.8245C17.2154 13.8245 17.9844 14.5912 17.9844 15.5371C17.9844 16.4829 17.2154 17.2496 16.2667 17.2496Z",
        fill: $cc68de3a75e2ba71$var$primaryColor
    }));

});

parcelRegister("1WFFE", function(module, exports) {

$parcel$export(module.exports, "default", () => $04cbc7be44317d32$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04cbc7be44317d32$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    configure: {
        "id": "servicedesk.channels-jsd.channels.chat.configure",
        "defaultMessage": "Configure"
    },
    configureLabelDescriptive: {
        "id": "servicedesk.channels-jsd.channels.chat.configure.label-descriptive",
        "defaultMessage": "Configure chat channel"
    },
    chatLabel: {
        "id": "servicedesk.channels-jsd.channels.chat.chat-label",
        "defaultMessage": "CHAT"
    },
    label: {
        "id": "servicedesk.channels-jsd.channels.chat.label",
        "defaultMessage": "Chat"
    },
    chatDescription: {
        "id": "servicedesk.channels-jsd.channels.chat.chat-description",
        "defaultMessage": "Create issues from chat channels"
    },
    chatDescriptionIssueTermRefresh: {
        "id": "servicedesk.channels-jsd.channels.chat.chat-description-issue-term-refresh",
        "defaultMessage": "Create work items from chat channels"
    },
    chatInactiveLabel: {
        "id": "servicedesk.channels-jsd.channels.chat.chat-inactive-label",
        "defaultMessage": "INACTIVE"
    },
    chatConnectedLabel: {
        "id": "servicedesk.channels-jsd.channels.chat.chat-connected-label",
        "defaultMessage": "CONNECTED"
    },
    chatOff: {
        "id": "servicedesk.channels-jsd.channels.chat.chat-off",
        "defaultMessage": "Off"
    }
});

});



parcelRegister("5B5Qw", function(module, exports) {

$parcel$export(module.exports, "CustomerAccessChannel", () => $3734f220ca515323$export$11811c7574f52fb0);

var $bC2fB = parcelRequire("bC2fB");

var $geXrZ = parcelRequire("geXrZ");

var $hNv1J = parcelRequire("hNv1J");

var $cC6UJ = parcelRequire("cC6UJ");
const $3734f220ca515323$var$getCustomerPermissionsSettingsLink = (projectKey, isSimplified)=>`/jira/servicedesk/projects/${projectKey}/settings${isSimplified ? '/channels' : ''}/customer-permissions`;
const $3734f220ca515323$var$mapStateToProps = (state)=>{
    const projectKey = (0, $geXrZ.getProjectKey)(state);
    const isSimplified = (0, $geXrZ.isProjectSimplified)(state);
    return {
        accessType: (0, $hNv1J.getCustomerAccess)(state),
        isAdmin: (0, $geXrZ.isProjectAdmin)(state),
        link: $3734f220ca515323$var$getCustomerPermissionsSettingsLink(projectKey, isSimplified)
    };
};
const $3734f220ca515323$export$11811c7574f52fb0 = (0, $bC2fB.connect)($3734f220ca515323$var$mapStateToProps, {})((0, $cC6UJ.CustomerAccessChannelView));

});
parcelRegister("cC6UJ", function(module, exports) {

$parcel$export(module.exports, "CustomerAccessChannelView", () => $e38e47adaaad1ae6$export$1213a6670c1ac144);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $fVnbM = parcelRequire("fVnbM");

var $bwyQI = parcelRequire("bwyQI");

var $jHgVl = parcelRequire("jHgVl");

var $iQv12 = parcelRequire("iQv12");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $40RN5 = parcelRequire("40RN5");

var $h6jnh = parcelRequire("h6jnh");

var $e40kZ = parcelRequire("e40kZ");

var $4R6GH = parcelRequire("4R6GH");

var $aj3l3 = parcelRequire("aj3l3");

var $eRwaR = parcelRequire("eRwaR");

var $9Cdjg = parcelRequire("9Cdjg");
const $e38e47adaaad1ae6$var$openImage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.ChannelItemImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e40kZ.OpenIcon), null));
const $e38e47adaaad1ae6$var$restrictedImage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.ChannelItemImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e40kZ.RestrictedIcon), null));
const $e38e47adaaad1ae6$var$openAccessDataOld = {
    lozengeType: (0, $aj3l3.LOZENGE_TYPES).ON,
    lozengeLabel: (0, $40RN5.messages).openLabel,
    image: $e38e47adaaad1ae6$var$openImage,
    description: (0, $9Cdjg.default).openPermissions
};
const $e38e47adaaad1ae6$var$restrictedAccessDataOld = {
    lozengeType: (0, $aj3l3.LOZENGE_TYPES).RESTRICTED,
    lozengeLabel: (0, $40RN5.messages).restrictedLabel,
    image: $e38e47adaaad1ae6$var$restrictedImage,
    description: (0, $9Cdjg.default).restrictedPermissions
};
const $e38e47adaaad1ae6$var$openAccessData = {
    lozengeType: (0, $aj3l3.LOZENGE_TYPES).ON,
    lozengeLabel: (0, $40RN5.messages).openLabel,
    image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHgVl))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    }),
    description: (0, $9Cdjg.default).open
};
const $e38e47adaaad1ae6$var$restrictedAccessData = {
    lozengeType: (0, $aj3l3.LOZENGE_TYPES).RESTRICTED,
    lozengeLabel: (0, $40RN5.messages).restrictedLabel,
    image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    }),
    description: (0, $9Cdjg.default).restricted
};
const $e38e47adaaad1ae6$var$accessTypeMapOld = {
    [(0, $h6jnh.CUSTOMER_ACCESS).PUBLIC]: $e38e47adaaad1ae6$var$openAccessDataOld,
    [(0, $h6jnh.CUSTOMER_ACCESS).INTERNAL]: $e38e47adaaad1ae6$var$openAccessDataOld,
    [(0, $h6jnh.CUSTOMER_ACCESS).ANONYMOUS]: $e38e47adaaad1ae6$var$openAccessDataOld,
    [(0, $h6jnh.CUSTOMER_ACCESS).RESTRICTED]: $e38e47adaaad1ae6$var$restrictedAccessDataOld
};
const $e38e47adaaad1ae6$var$accessTypeMap = {
    [(0, $h6jnh.CUSTOMER_ACCESS).PUBLIC]: $e38e47adaaad1ae6$var$openAccessData,
    [(0, $h6jnh.CUSTOMER_ACCESS).INTERNAL]: $e38e47adaaad1ae6$var$openAccessData,
    [(0, $h6jnh.CUSTOMER_ACCESS).ANONYMOUS]: $e38e47adaaad1ae6$var$openAccessData,
    [(0, $h6jnh.CUSTOMER_ACCESS).RESTRICTED]: $e38e47adaaad1ae6$var$restrictedAccessData
};
const $e38e47adaaad1ae6$var$CustomerAccessChannelViewComponent = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { accessType: accessType, isAdmin: isAdmin, onClick: onClick, link: link } = props;
    const { lozengeType: lozengeType, lozengeLabel: lozengeLabel, image: image, description: description } = (0, $3HwlS.getWillShowNav4)() ? $e38e47adaaad1ae6$var$accessTypeMap[accessType] : $e38e47adaaad1ae6$var$accessTypeMapOld[accessType];
    const configureButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: link,
        onClick: onClick,
        appearance: "default",
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_channel') ? {
            'aria-label': formatMessage((0, $9Cdjg.default).configureLabelDescriptive)
        } : {}
    }, formatMessage((0, $9Cdjg.default).configure));
    const lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj3l3.ChannelStatusLozenge), {
        type: lozengeType,
        label: formatMessage(lozengeLabel).toLocaleUpperCase()
    });
    const label = (0, $3HwlS.getWillShowNav4)() ? formatMessage((0, $9Cdjg.default).itemLabel) : formatMessage((0, $9Cdjg.default).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.BaseChannelItem), {
        button: isAdmin ? configureButton : undefined,
        image: image,
        label: label,
        description: formatMessage(description),
        channelName: "customer-access",
        statusLozenge: lozenge
    });
};
const $e38e47adaaad1ae6$export$1213a6670c1ac144 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'configureCustomerAccess'
}))($e38e47adaaad1ae6$var$CustomerAccessChannelViewComponent);

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("jHgVl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e56f2934baaafa03$var$_react = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e56f2934baaafa03$var$_baseNew = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e56f2934baaafa03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e56f2934baaafa03$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $e56f2934baaafa03$var$_react.default.createElement($e56f2934baaafa03$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$e56f2934baaafa03$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $e56f2934baaafa03$var$_default = module.exports.default = $e56f2934baaafa03$var$LockUnlockedIcon;

});

parcelRegister("40RN5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dc98c551f0f53cb8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $dc98c551f0f53cb8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    openLabel: {
        "id": "servicedesk-customer-permissions.common.open-label",
        "defaultMessage": "Open"
    },
    openDescription: {
        "id": "servicedesk-customer-permissions.common.open-description",
        "defaultMessage": "Anyone can submit requests to this project."
    },
    restrictedLabel: {
        "id": "servicedesk-customer-permissions.common.restricted-label",
        "defaultMessage": "Restricted"
    },
    restrictedDescription: {
        "id": "servicedesk-customer-permissions.common.restricted-description",
        "defaultMessage": "Only people directly invited to this project can submit requests."
    },
    placeholder: {
        "id": "servicedesk-customer-permissions.common.placeholder",
        "defaultMessage": "Choose an access level"
    }
});

});

parcelRegister("e40kZ", function(module, exports) {

$parcel$export(module.exports, "RestrictedIcon", () => $03054768ed531cce$export$fb0d481c8f77ba99);
$parcel$export(module.exports, "OpenIcon", () => $03054768ed531cce$export$1b908f8a0643e3ae);

var $5uXOq = parcelRequire("5uXOq");
const $03054768ed531cce$var$primaryColor = "var(--ds-icon, #44546F)";
const $03054768ed531cce$var$baseColor = "var(--ds-background-neutral, #091E420F)";
const $03054768ed531cce$export$fb0d481c8f77ba99 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "32",
        height: "32",
        fill: $03054768ed531cce$var$baseColor,
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.3787 14.8383C14.0955 14.8383 16.2978 12.6359 16.2978 9.91913C16.2978 7.20237 14.0955 5 11.3787 5C8.66194 5 6.45957 7.20237 6.45957 9.91913C6.45957 12.6359 8.66194 14.8383 11.3787 14.8383Z",
        fill: $03054768ed531cce$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 18.5276C4 17.1687 5.10926 16.0681 6.47064 16.0681H15.969C15.4547 16.5605 15.0457 17.2473 14.9413 18.1672V24.8356C14.9302 25.3213 15.1316 26.0127 15.5436 26.6403C11.2021 27.8022 4 26.9205 4 23.9952V18.5276Z",
        fill: $03054768ed531cce$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M22.4636 22.8543C21.7176 22.8543 21.1128 22.2495 21.1128 21.5035C21.1128 20.7574 21.7176 20.1526 22.4636 20.1526C23.2097 20.1526 23.8145 20.7574 23.8145 21.5035C23.8145 22.2495 23.2097 22.8543 22.4636 22.8543Z",
        fill: $03054768ed531cce$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M22.5 12C24.1832 12 25.5573 13.3098 25.639 14.9558L25.6429 15.1111V16.6667H26.4286C27.257 16.6667 27.9357 17.3012 27.9957 18.1061L28 18.2222V24.4444C28 25.2645 27.359 25.9364 26.5458 25.9957L26.4286 26H18.5714C17.743 26 17.0643 25.3654 17.0043 24.5605L17 24.4444V18.2222C17 17.4022 17.641 16.7303 18.4542 16.6709L18.5714 16.6667H19.3571V15.1111C19.3571 13.445 20.6803 12.0847 22.3431 12.0038L22.5 12ZM26.4286 18.2222H19.5714C19.0191 18.2222 18.5714 18.6699 18.5714 19.2222V24.4444H25.4286C25.9809 24.4444 26.4286 23.9967 26.4286 23.4444V18.2222ZM22.5 13.5556C21.6716 13.5556 20.9929 14.1901 20.9329 14.995L20.9286 15.1111V16.6667H24.0714V15.1111C24.0714 14.3321 23.4929 13.6868 22.7379 13.5733L22.6173 13.5598L22.5 13.5556Z",
        fill: $03054768ed531cce$var$primaryColor
    }));
const $03054768ed531cce$export$1b908f8a0643e3ae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "32",
        height: "32",
        fill: $03054768ed531cce$var$baseColor,
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.3787 14.8383C14.0955 14.8383 16.2978 12.6359 16.2978 9.91913C16.2978 7.20237 14.0955 5 11.3787 5C8.66194 5 6.45957 7.20237 6.45957 9.91913C6.45957 12.6359 8.66194 14.8383 11.3787 14.8383Z",
        fill: $03054768ed531cce$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 18.5276C4 17.1687 5.10926 16.0681 6.47064 16.0681H15.969C15.4547 16.5605 15.0457 17.2473 14.9413 18.1672V24.8356C14.9302 25.3213 15.1316 26.0127 15.5436 26.6403C11.2021 27.8022 4 26.9205 4 23.9952V18.5276Z",
        fill: $03054768ed531cce$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M22.9847 16.8962C24.6782 16.8962 24.9725 16.8942 26.4166 16.8922C27.2501 16.8922 27.933 17.519 27.9934 18.3144L27.9977 18.4291V24.578C27.9977 25.3884 27.3527 26.0524 26.5346 26.111L26.4166 26.1153H18.5108C17.6773 26.1153 16.9944 25.4882 16.934 24.6927L16.9297 24.578V18.4291C16.9297 17.6187 17.5747 16.9548 18.3928 16.8961L18.5108 16.8919H19.3014L20.5436 16.8961C22.4637 16.8919 20.3805 16.8955 22.021 16.8919L22.9847 16.8962ZM26.4166 18.4291H19.5108C18.9586 18.4291 18.5108 18.8768 18.5108 19.4291V24.578H25.4166C25.9689 24.578 26.4166 24.1303 26.4166 23.578V18.4291Z",
        fill: $03054768ed531cce$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M22.4636 22.8543C21.7176 22.8543 21.1128 22.2495 21.1128 21.5035C21.1128 20.7574 21.7176 20.1526 22.4636 20.1526C23.2097 20.1526 23.8145 20.7574 23.8145 21.5035C23.8145 22.2495 23.2097 22.8543 22.4636 22.8543Z",
        fill: $03054768ed531cce$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19.4902 13.8037C19.4906 12.9696 19.8106 12.1697 20.3798 11.5797C20.9489 10.9897 21.7209 10.6579 22.526 10.657C22.9248 10.657 23.3197 10.7384 23.6881 10.8966C24.0566 11.0548 24.3913 11.2866 24.6732 11.5788C24.9551 11.871 25.1787 12.2179 25.3312 12.5997C25.4837 12.9814 25.5621 13.3906 25.5619 13.8037V14.1953H24.0439V13.8037C24.044 13.5971 24.0049 13.3925 23.9286 13.2016C23.8524 13.0106 23.7406 12.8371 23.5997 12.691C23.4587 12.5448 23.2914 12.4288 23.1072 12.3497C22.9229 12.2705 22.7255 12.2297 22.526 12.2296C21.6897 12.2296 21.0081 12.9357 21.0081 13.8037V17.7335H19.4902V13.8037ZM24.0439 14.1953H25.5619C25.5619 14.4038 25.4819 14.6038 25.3396 14.7513C25.1972 14.8987 25.0042 14.9816 24.8029 14.9816C24.6016 14.9816 24.4086 14.8987 24.2662 14.7513C24.1239 14.6038 24.0439 14.4038 24.0439 14.1953Z",
        fill: $03054768ed531cce$var$primaryColor
    }));

});

parcelRegister("9Cdjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86edc5cf8815064$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c86edc5cf8815064$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openPermissions: {
        "id": "servicedesk.channels-jsd.channels.customer-access.open-permissions",
        "defaultMessage": "All customers have access"
    },
    open: {
        "id": "servicedesk.channels-jsd.channels.customer-access.open",
        "defaultMessage": "All customers"
    },
    restrictedPermissions: {
        "id": "servicedesk.channels-jsd.channels.customer-access.restricted-permissions",
        "defaultMessage": "Only invited customers have access "
    },
    restricted: {
        "id": "servicedesk.channels-jsd.channels.customer-access.restricted",
        "defaultMessage": "Only invited customers"
    },
    configure: {
        "id": "servicedesk.channels-jsd.channels.customer-access.configure",
        "defaultMessage": "Configure"
    },
    configureLabelDescriptive: {
        "id": "servicedesk.channels-jsd.channels.customer-access.label-descriptive",
        "defaultMessage": "Configure channel access"
    },
    label: {
        "id": "servicedesk.channels-jsd.channels.customer-access.label",
        "defaultMessage": "CHANNEL ACCESS"
    },
    itemLabel: {
        "id": "servicedesk.channels-jsd.channels.customer-access.item-label",
        "defaultMessage": "Channel access"
    }
});

});



parcelRegister("jU73Z", function(module, exports) {

$parcel$export(module.exports, "EmailChannel", () => $56be9bcdb45afe87$export$c61caba47bfbe16);

var $bC2fB = parcelRequire("bC2fB");

var $geXrZ = parcelRequire("geXrZ");

var $hNv1J = parcelRequire("hNv1J");

var $1Kzgy = parcelRequire("1Kzgy");
const $56be9bcdb45afe87$var$mapStateToProps = (state)=>({
        isAdmin: (0, $geXrZ.isProjectAdmin)(state),
        isEnabled: (0, $hNv1J.isEmailEnabled)(state),
        isProjectSimplified: (0, $geXrZ.isProjectSimplified)(state),
        email: (0, $hNv1J.getServiceDeskEmail)(state),
        projectKey: (0, $geXrZ.getProjectKey)(state),
        baseUrl: ''
    });
const $56be9bcdb45afe87$export$c61caba47bfbe16 = (0, $bC2fB.connect)($56be9bcdb45afe87$var$mapStateToProps, {})((0, $1Kzgy.EmailChannelView));

});
parcelRegister("1Kzgy", function(module, exports) {

$parcel$export(module.exports, "EmailChannelView", () => $d50328f27908ca79$export$231ccb5d527e7644);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $fVnbM = parcelRequire("fVnbM");

var $cYcwl = parcelRequire("cYcwl");

var $eRB05 = parcelRequire("eRB05");

var $3Fq5M = parcelRequire("3Fq5M");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $2vSU6 = parcelRequire("2vSU6");

var $8RXs9 = parcelRequire("8RXs9");

var $3HwlS = parcelRequire("3HwlS");

var $02Psx = parcelRequire("02Psx");

var $4R6GH = parcelRequire("4R6GH");

var $aj3l3 = parcelRequire("aj3l3");

var $eRwaR = parcelRequire("eRwaR");

var $g3vbr = parcelRequire("g3vbr");

var $5gWY4 = parcelRequire("5gWY4");
// eslint-disable-next-line jira/react/no-class-components
class $d50328f27908ca79$var$EmailChannelViewComponent extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            email: ''
        };
    }
    getClassicConfigurationLink() {
        const { projectKey: projectKey } = this.props;
        return `/jira/servicedesk/projects/${projectKey}/settings/email`;
    }
    getConfigurationLink() {
        const { projectKey: projectKey, isProjectSimplified: isProjectSimplified } = this.props;
        return isProjectSimplified ? `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/email` : this.getClassicConfigurationLink();
    }
    render() {
        const { isEnabled: isEnabled, isAdmin: isAdmin, email: email, onClick: onClick, intl: { formatMessage: formatMessage } } = this.props;
        const onCopyClick = (event, analyticsEvent)=>{
            (0, $cYcwl.copyToClipboard)(email);
            this.props.onCopyClick(event, analyticsEvent);
        };
        const configureEmailButton = isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: this.getConfigurationLink(),
            onClick: onClick,
            appearance: "default",
            ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_channel') ? {
                'aria-label': formatMessage((0, $5gWY4.default).configureLabelDescriptive)
            } : {}
        }, formatMessage((0, $5gWY4.default).configure)) : undefined;
        const copyEmailButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            delay: 100,
            content: formatMessage((0, $5gWY4.default).copyEmail)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: onCopyClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
                label: "",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            appearance: "default",
            "aria-label": formatMessage((0, $5gWY4.default).copyEmail)
        }));
        const emailButton = !isAdmin && isEnabled ? copyEmailButton : configureEmailButton;
        const lozengeType = isEnabled ? (0, $aj3l3.LOZENGE_TYPES).ON : (0, $aj3l3.LOZENGE_TYPES).OFF;
        const lozengeLabel = formatMessage(isEnabled ? (0, $5gWY4.default).emailEnabledLabel : (0, $5gWY4.default).emailOffLabel);
        const isNav4 = (0, $3HwlS.getWillShowNav4)();
        const description = isEnabled ? email : formatMessage(isNav4 ? (0, $5gWY4.default).emailOff : (0, $5gWY4.default).channelTurnedOff);
        const icon = isNav4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eRB05))), {
            color: "var(--ds-icon, #44546F)",
            label: ""
        }) : this.image;
        const label = isNav4 ? formatMessage((0, $5gWY4.default).email) : formatMessage((0, $5gWY4.default).emailLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.BaseChannelItem), {
            button: emailButton,
            image: icon,
            label: label,
            description: description,
            channelName: "email",
            statusLozenge: !isNav4 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj3l3.ChannelStatusLozenge), {
                type: lozengeType,
                label: lozengeLabel
            })
        });
    }
    constructor(...args){
        super(...args), this.image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.ChannelItemImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3vbr.default), null));
    }
}
const $d50328f27908ca79$export$231ccb5d527e7644 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'configureEmail',
    onCopyClick: 'copyEmail'
}), (0, $8RXs9.default))($d50328f27908ca79$var$EmailChannelViewComponent);

});
parcelRegister("cYcwl", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", () => $e78f458911acd4e2$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "copyHTMLToClipboard", () => $e78f458911acd4e2$export$8b344d2a6a3e9af3);
$parcel$export(module.exports, "copyHTMLToClipboardPolyfill", () => $e78f458911acd4e2$export$97e18ff8b98c7078);
$parcel$export(module.exports, "getAnalyticsPayload", () => $e78f458911acd4e2$export$4feda93c1c6b2d80);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $2x8Ci = parcelRequire("2x8Ci");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $8AlsS = parcelRequire("8AlsS");
const $e78f458911acd4e2$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $e78f458911acd4e2$var$isIEClipboardApiSupported = ()=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.clipboardData && typeof window.clipboardData.setData === 'function';
const $e78f458911acd4e2$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $e78f458911acd4e2$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($e78f458911acd4e2$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($e78f458911acd4e2$var$isIEClipboardApiSupported()) try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
const $e78f458911acd4e2$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    // @ts-ignore
    if ($e78f458911acd4e2$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        // @ts-ignore
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if (!!document && typeof document === 'object') try {
        // ED-17083 extension copy seems have issue with ClipboardItem API
        // Hence of use of this polyfill
        $e78f458911acd4e2$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
};
const $e78f458911acd4e2$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $2x8Ci.ClipboardItem({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $2x8Ci.write([
        dt
    ]);
};
const $e78f458911acd4e2$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $8AlsS.getNodeSelectionAnalyticsPayload)(selection) || (0, $8AlsS.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $8AlsS.getAllSelectionAnalyticsPayload)(selection) || (0, $8AlsS.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = selectionAnalyticsPayload.attributes?.node;
        const content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $gkwXh.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($e78f458911acd4e2$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).RANGE:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).CELL:
                {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($e78f458911acd4e2$var$isExtensionNode(node)) return {
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $gZGBX.TextSelection) && selection.$cursor) return {
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};

});
parcelRegister("2x8Ci", function(module, exports) {

$parcel$export(module.exports, "ClipboardItem", () => $1d8558ea290058b8$export$3b1380c0957dc8fe);
$parcel$export(module.exports, "write", () => $1d8558ea290058b8$export$68d8715fc104d294);
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $1d8558ea290058b8$var$TEXT_PLAIN = "text/plain";
var $1d8558ea290058b8$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $1d8558ea290058b8$var$debugLogImpl = (s)=>{};
function $1d8558ea290058b8$var$debugLog(s) {
    $1d8558ea290058b8$var$debugLogImpl(s);
}
function $1d8558ea290058b8$export$e014146e87162c32(logFn) {
    $1d8558ea290058b8$var$debugLogImpl = logFn;
}
var $1d8558ea290058b8$var$showWarnings = true;
function $1d8558ea290058b8$export$ba5c9528becaaf25() {
    $1d8558ea290058b8$var$showWarnings = false;
}
function $1d8558ea290058b8$var$shouldShowWarnings() {
    return $1d8558ea290058b8$var$showWarnings;
}
function $1d8558ea290058b8$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $1d8558ea290058b8$var$warn = $1d8558ea290058b8$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $1d8558ea290058b8$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $1d8558ea290058b8$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $1d8558ea290058b8$var$_a, $1d8558ea290058b8$var$_b, $1d8558ea290058b8$var$_c;
var $1d8558ea290058b8$var$promiseConstructorImpl = ($1d8558ea290058b8$var$_c = ($1d8558ea290058b8$var$_a = $1d8558ea290058b8$var$originalWindow) == null ? void 0 : $1d8558ea290058b8$var$_a.Promise) != null ? $1d8558ea290058b8$var$_c : ($1d8558ea290058b8$var$_b = $1d8558ea290058b8$var$originalGlobalThis) == null ? void 0 : $1d8558ea290058b8$var$_b.Promise;
function $1d8558ea290058b8$var$getPromiseConstructor() {
    if (!$1d8558ea290058b8$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $1d8558ea290058b8$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $1d8558ea290058b8$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $1d8558ea290058b8$var$originalNavigatorClipboard = $1d8558ea290058b8$var$originalNavigator == null ? void 0 : $1d8558ea290058b8$var$originalNavigator.clipboard;
var $1d8558ea290058b8$var$_a2;
var $1d8558ea290058b8$var$originalNavigatorClipboardRead = ($1d8558ea290058b8$var$_a2 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.read) == null ? void 0 : $1d8558ea290058b8$var$_a2.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a3;
var $1d8558ea290058b8$var$originalNavigatorClipboardReadText = ($1d8558ea290058b8$var$_a3 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.readText) == null ? void 0 : $1d8558ea290058b8$var$_a3.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a4;
var $1d8558ea290058b8$var$originalNavigatorClipboardWrite = ($1d8558ea290058b8$var$_a4 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.write) == null ? void 0 : $1d8558ea290058b8$var$_a4.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a5;
var $1d8558ea290058b8$var$originalNavigatorClipboardWriteText = ($1d8558ea290058b8$var$_a5 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.writeText) == null ? void 0 : $1d8558ea290058b8$var$_a5.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a6;
var $1d8558ea290058b8$var$originalWindowClipboardItem = ($1d8558ea290058b8$var$_a6 = $1d8558ea290058b8$var$originalWindow) == null ? void 0 : $1d8558ea290058b8$var$_a6.ClipboardItem;
var $1d8558ea290058b8$var$promiseConstructor = $1d8558ea290058b8$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $1d8558ea290058b8$var$ieWindow = $1d8558ea290058b8$var$originalWindow;
function $1d8558ea290058b8$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($1d8558ea290058b8$var$ieWindow == null ? void 0 : $1d8558ea290058b8$var$ieWindow.clipboardData) !== "undefined" && typeof ($1d8558ea290058b8$var$ieWindow == null ? void 0 : $1d8558ea290058b8$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $1d8558ea290058b8$var$writeTextIE(text) {
    if (!$1d8558ea290058b8$var$ieWindow.clipboardData) return false;
    var success = $1d8558ea290058b8$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $1d8558ea290058b8$var$debugLog("writeTextIE worked");
    return success;
}
function $1d8558ea290058b8$var$readTextIE() {
    if (!$1d8558ea290058b8$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $1d8558ea290058b8$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $1d8558ea290058b8$var$copyListener(tracker, data, e) {
    $1d8558ea290058b8$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $1d8558ea290058b8$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $1d8558ea290058b8$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $1d8558ea290058b8$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $1d8558ea290058b8$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $1d8558ea290058b8$var$copyUsingTempSelection(e, data) {
    $1d8558ea290058b8$var$selectionSet(e);
    var success = $1d8558ea290058b8$var$execCopy(data);
    $1d8558ea290058b8$var$selectionClear();
    return success;
}
function $1d8558ea290058b8$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $1d8558ea290058b8$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $1d8558ea290058b8$var$copyTextUsingDOM(str) {
    $1d8558ea290058b8$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $1d8558ea290058b8$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $1d8558ea290058b8$var$selectionSet(span);
    var result = document.execCommand("copy");
    $1d8558ea290058b8$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $1d8558ea290058b8$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $1d8558ea290058b8$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $1d8558ea290058b8$var$writeFallback(stringItem) {
    var hasTextPlain = $1d8558ea290058b8$var$TEXT_PLAIN in stringItem;
    if ($1d8558ea290058b8$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($1d8558ea290058b8$var$writeTextIE(stringItem[$1d8558ea290058b8$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($1d8558ea290058b8$var$execCopy(stringItem)) {
        $1d8558ea290058b8$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $1d8558ea290058b8$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($1d8558ea290058b8$var$copyUsingTempSelection(document.body, stringItem)) {
        $1d8558ea290058b8$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($1d8558ea290058b8$var$copyUsingTempElem(stringItem)) {
        $1d8558ea290058b8$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($1d8558ea290058b8$var$copyTextUsingDOM(stringItem[$1d8558ea290058b8$var$TEXT_PLAIN])) {
        $1d8558ea290058b8$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $1d8558ea290058b8$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $1d8558ea290058b8$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $1d8558ea290058b8$var$voidPromise = $1d8558ea290058b8$var$promiseConstructor.resolve();
var $1d8558ea290058b8$var$truePromiseFn = ()=>$1d8558ea290058b8$var$promiseConstructor.resolve(true);
var $1d8558ea290058b8$var$falsePromise = $1d8558ea290058b8$var$promiseConstructor.resolve(false);
function $1d8558ea290058b8$var$rejectThrownErrors(executor) {
    return new $1d8558ea290058b8$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $1d8558ea290058b8$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$1d8558ea290058b8$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $1d8558ea290058b8$export$bec150f75a9b8f11(s) {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardWriteText) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardWriteText(s).catch($1d8558ea290058b8$var$writeTextStringFallback);
        }
        return $1d8558ea290058b8$var$promiseConstructor.resolve($1d8558ea290058b8$var$writeTextStringFallback(s));
    });
}
function $1d8558ea290058b8$var$writeTextStringFallback(s) {
    if (!$1d8558ea290058b8$var$writeFallback($1d8558ea290058b8$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $1d8558ea290058b8$export$bee0113684d8879b() {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardReadText) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardReadText();
        }
        if ($1d8558ea290058b8$var$seemToBeInIE()) {
            var result = $1d8558ea290058b8$var$readTextIE();
            return $1d8558ea290058b8$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $1d8558ea290058b8$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $1d8558ea290058b8$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $1d8558ea290058b8$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $1d8558ea290058b8$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $1d8558ea290058b8$export$3b1380c0957dc8fe = $1d8558ea290058b8$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $1d8558ea290058b8$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $1d8558ea290058b8$var$blobToString(blob) {
    return new $1d8558ea290058b8$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $1d8558ea290058b8$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $1d8558ea290058b8$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($1d8558ea290058b8$var$originalWindowClipboardItem) resolve(new $1d8558ea290058b8$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $1d8558ea290058b8$var$textToClipboardItem(text) {
    var items = {};
    items[$1d8558ea290058b8$var$TEXT_PLAIN] = $1d8558ea290058b8$var$stringToBlob(text, $1d8558ea290058b8$var$TEXT_PLAIN);
    return new $1d8558ea290058b8$export$3b1380c0957dc8fe(items);
}
function $1d8558ea290058b8$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $1d8558ea290058b8$var$blobToString(text);
    });
}
function $1d8558ea290058b8$var$toStringItem(data) {
    return $1d8558ea290058b8$var$promiseRecordMap(data.types, function(type) {
        return $1d8558ea290058b8$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $1d8558ea290058b8$export$68d8715fc104d294(data) {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardWrite && $1d8558ea290058b8$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $1d8558ea290058b8$var$originalNavigatorClipboardWrite;
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.write()`.");
            return $1d8558ea290058b8$var$promiseConstructor.all(data.map($1d8558ea290058b8$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($1d8558ea290058b8$var$truePromiseFn).catch((e)=>{
                    if (!$1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_PLAIN) && !$1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_HTML)) throw e;
                    return $1d8558ea290058b8$var$falsePromise;
                });
            });
        }
        return $1d8558ea290058b8$var$falsePromise;
    }).then((success)=>{
        if (success) return $1d8558ea290058b8$var$voidPromise;
        var hasTextPlain = $1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_PLAIN);
        if ($1d8558ea290058b8$var$shouldShowWarnings() && !hasTextPlain) $1d8558ea290058b8$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $1d8558ea290058b8$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$1d8558ea290058b8$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $1d8558ea290058b8$export$aafa59e2e03f2942() {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardRead) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.read()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardRead();
        }
        return $1d8558ea290058b8$export$bee0113684d8879b().then((text)=>{
            return [
                $1d8558ea290058b8$var$textToClipboardItem(text)
            ];
        });
    });
}

});

parcelRegister("gZGBX", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $c5f36586ce432e9f$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $c5f36586ce432e9f$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $c5f36586ce432e9f$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $c5f36586ce432e9f$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $c5f36586ce432e9f$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $c5f36586ce432e9f$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $c5f36586ce432e9f$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $c5f36586ce432e9f$export$1692d8b0e89cecc3);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $c5f36586ce432e9f$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $c5f36586ce432e9f$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $kCV8T.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
            if (i == 0) $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $c5f36586ce432e9f$export$c2b25f346d19bcbb($pos) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, 0, 0, 1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $c5f36586ce432e9f$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $c5f36586ce432e9f$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $c5f36586ce432e9f$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $c5f36586ce432e9f$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $c5f36586ce432e9f$var$warnedAboutTextSelection = false;
function $c5f36586ce432e9f$var$checkTextSelection($pos) {
    if (!$c5f36586ce432e9f$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $c5f36586ce432e9f$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $c5f36586ce432e9f$export$c2b25f346d19bcbb extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $c5f36586ce432e9f$var$checkTextSelection($anchor);
        $c5f36586ce432e9f$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $c5f36586ce432e9f$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $kCV8T.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $c5f36586ce432e9f$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $c5f36586ce432e9f$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("text", $c5f36586ce432e9f$export$c2b25f346d19bcbb);
class $c5f36586ce432e9f$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $c5f36586ce432e9f$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $c5f36586ce432e9f$export$e2940151ac854c0b extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
        return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $c5f36586ce432e9f$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$c5f36586ce432e9f$export$e2940151ac854c0b.prototype.visible = false;
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("node", $c5f36586ce432e9f$export$e2940151ac854c0b);
class $c5f36586ce432e9f$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $c5f36586ce432e9f$var$TextBookmark(pos, pos) : new $c5f36586ce432e9f$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(node)) return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
        return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $c5f36586ce432e9f$export$c15d9ba76bdbcd95 extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        if (content == (0, $kCV8T.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $c5f36586ce432e9f$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $c5f36586ce432e9f$var$AllBookmark;
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("all", $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
const $c5f36586ce432e9f$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $c5f36586ce432e9f$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $c5f36586ce432e9f$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $c5f36586ce432e9f$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(child)) return $c5f36586ce432e9f$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $eS2Dn.ReplaceStep) || step instanceof (0, $eS2Dn.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $c5f36586ce432e9f$var$UPDATED_SEL = 1, $c5f36586ce432e9f$var$UPDATED_MARKS = 2, $c5f36586ce432e9f$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $c5f36586ce432e9f$export$febc5573c75cefb0 extends (0, $eS2Dn.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $c5f36586ce432e9f$var$UPDATED_SEL) & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $c5f36586ce432e9f$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $kCV8T.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $kCV8T.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $c5f36586ce432e9f$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_SCROLL) > 0;
    }
}
function $c5f36586ce432e9f$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $c5f36586ce432e9f$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $c5f36586ce432e9f$var$bind(desc.init, self);
        this.apply = $c5f36586ce432e9f$var$bind(desc.apply, self);
    }
}
const $c5f36586ce432e9f$var$baseFields = [
    new $c5f36586ce432e9f$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $c5f36586ce432e9f$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $c5f36586ce432e9f$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $c5f36586ce432e9f$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $c5f36586ce432e9f$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $c5f36586ce432e9f$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $c5f36586ce432e9f$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $c5f36586ce432e9f$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $c5f36586ce432e9f$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $c5f36586ce432e9f$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $c5f36586ce432e9f$var$Configuration(config.schema, config.plugins);
        let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $kCV8T.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $c5f36586ce432e9f$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $c5f36586ce432e9f$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $c5f36586ce432e9f$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $c5f36586ce432e9f$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $c5f36586ce432e9f$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $c5f36586ce432e9f$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $c5f36586ce432e9f$var$keys = Object.create(null);
function $c5f36586ce432e9f$var$createKey(name) {
    if (name in $c5f36586ce432e9f$var$keys) return name + "$" + ++$c5f36586ce432e9f$var$keys[name];
    $c5f36586ce432e9f$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $c5f36586ce432e9f$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $c5f36586ce432e9f$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("kCV8T", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f043ae92c0a873f0$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f043ae92c0a873f0$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f043ae92c0a873f0$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f043ae92c0a873f0$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f043ae92c0a873f0$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f043ae92c0a873f0$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $f043ae92c0a873f0$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f043ae92c0a873f0$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f043ae92c0a873f0$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f043ae92c0a873f0$export$3476b78f8f5a8b72);

var $dHeNB = parcelRequire("dHeNB");
function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f043ae92c0a873f0$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
        if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                return $f043ae92c0a873f0$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
const $f043ae92c0a873f0$var$found = {
    index: 0,
    offset: 0
};
function $f043ae92c0a873f0$var$retIndex(index, offset) {
    $f043ae92c0a873f0$var$found.index = index;
    $f043ae92c0a873f0$var$found.offset = offset;
    return $f043ae92c0a873f0$var$found;
}
function $f043ae92c0a873f0$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
function $f043ae92c0a873f0$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f043ae92c0a873f0$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
    return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
}
function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
        return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f043ae92c0a873f0$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f043ae92c0a873f0$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
}
function $f043ae92c0a873f0$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
        if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
        let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
        return result;
    }
}
class $f043ae92c0a873f0$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f043ae92c0a873f0$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
        $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
class $f043ae92c0a873f0$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f043ae92c0a873f0$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
    let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f043ae92c0a873f0$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
    let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f043ae92c0a873f0$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f043ae92c0a873f0$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $f043ae92c0a873f0$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f043ae92c0a873f0$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f043ae92c0a873f0$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f043ae92c0a873f0$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f043ae92c0a873f0$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f043ae92c0a873f0$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f043ae92c0a873f0$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f043ae92c0a873f0$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $dHeNB.default).from(spec.nodes), instanceSpec.marks = (0, $dHeNB.default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f043ae92c0a873f0$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f043ae92c0a873f0$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f043ae92c0a873f0$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f043ae92c0a873f0$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f043ae92c0a873f0$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
}
class $f043ae92c0a873f0$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f043ae92c0a873f0$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
        let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $f043ae92c0a873f0$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f043ae92c0a873f0$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f043ae92c0a873f0$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f043ae92c0a873f0$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
    }
}
function $f043ae92c0a873f0$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f043ae92c0a873f0$var$doc(options) {
    return options.document || window.document;
}
const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
    let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("dHeNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
    this.content = content;
}
$9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
    constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9f8ac547b0b2e1f8$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
    if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
};
var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;

});


parcelRegister("eS2Dn", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $ad3826e817ebec37$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $ad3826e817ebec37$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $ad3826e817ebec37$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $ad3826e817ebec37$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $ad3826e817ebec37$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $ad3826e817ebec37$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $ad3826e817ebec37$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $ad3826e817ebec37$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $ad3826e817ebec37$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $ad3826e817ebec37$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $ad3826e817ebec37$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $ad3826e817ebec37$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $ad3826e817ebec37$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $ad3826e817ebec37$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $ad3826e817ebec37$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $ad3826e817ebec37$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $ad3826e817ebec37$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $ad3826e817ebec37$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $ad3826e817ebec37$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $ad3826e817ebec37$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $ad3826e817ebec37$export$563a914cafbdc389);

var $kCV8T = parcelRequire("kCV8T");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $ad3826e817ebec37$var$lower16 = 0xffff;
const $ad3826e817ebec37$var$factor16 = Math.pow(2, 16);
function $ad3826e817ebec37$var$makeRecover(index, offset) {
    return index + offset * $ad3826e817ebec37$var$factor16;
}
function $ad3826e817ebec37$var$recoverIndex(value) {
    return value & $ad3826e817ebec37$var$lower16;
}
function $ad3826e817ebec37$var$recoverOffset(value) {
    return (value - (value & $ad3826e817ebec37$var$lower16)) / $ad3826e817ebec37$var$factor16;
}
const $ad3826e817ebec37$var$DEL_BEFORE = 1, $ad3826e817ebec37$var$DEL_AFTER = 2, $ad3826e817ebec37$var$DEL_ACROSS = 4, $ad3826e817ebec37$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $ad3826e817ebec37$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $ad3826e817ebec37$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($ad3826e817ebec37$var$DEL_BEFORE | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($ad3826e817ebec37$var$DEL_AFTER | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $ad3826e817ebec37$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $ad3826e817ebec37$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $ad3826e817ebec37$export$c53d01c3ab9721b3.empty) return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $ad3826e817ebec37$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $ad3826e817ebec37$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $ad3826e817ebec37$var$DEL_AFTER : pos == end ? $ad3826e817ebec37$var$DEL_BEFORE : $ad3826e817ebec37$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $ad3826e817ebec37$var$DEL_SIDE;
                return new $ad3826e817ebec37$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $ad3826e817ebec37$export$c53d01c3ab9721b3.empty : new $ad3826e817ebec37$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $ad3826e817ebec37$export$c53d01c3ab9721b3.empty = new $ad3826e817ebec37$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $ad3826e817ebec37$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $ad3826e817ebec37$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $ad3826e817ebec37$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $ad3826e817ebec37$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $ad3826e817ebec37$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $ad3826e817ebec37$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $ad3826e817ebec37$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $ad3826e817ebec37$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $ad3826e817ebec37$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $ad3826e817ebec37$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $ad3826e817ebec37$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $kCV8T.ReplaceError)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $ad3826e817ebec37$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($ad3826e817ebec37$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $kCV8T.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $ad3826e817ebec37$export$d24ba56b0e3464a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $ad3826e817ebec37$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $ad3826e817ebec37$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("addMark", $ad3826e817ebec37$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $ad3826e817ebec37$export$94150db1311f67a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $ad3826e817ebec37$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $ad3826e817ebec37$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeMark", $ad3826e817ebec37$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $ad3826e817ebec37$export$adefd16c402fee4e extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $ad3826e817ebec37$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("addNodeMark", $ad3826e817ebec37$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $ad3826e817ebec37$export$fdf7d1dc10724da2 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeNodeMark", $ad3826e817ebec37$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $ad3826e817ebec37$export$5c860b2e74034756 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $ad3826e817ebec37$var$contentBetween(doc, this.from, this.to)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $ad3826e817ebec37$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $ad3826e817ebec37$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $ad3826e817ebec37$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $ad3826e817ebec37$export$5c860b2e74034756(json.from, json.to, (0, $kCV8T.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("replace", $ad3826e817ebec37$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $ad3826e817ebec37$export$444ba800d6024a98 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($ad3826e817ebec37$var$contentBetween(doc, this.from, this.gapFrom) || $ad3826e817ebec37$var$contentBetween(doc, this.gapTo, this.to))) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $ad3826e817ebec37$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $ad3826e817ebec37$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $ad3826e817ebec37$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $kCV8T.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("replaceAround", $ad3826e817ebec37$export$444ba800d6024a98);
function $ad3826e817ebec37$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $ad3826e817ebec37$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $ad3826e817ebec37$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $ad3826e817ebec37$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $ad3826e817ebec37$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $kCV8T.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $ad3826e817ebec37$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur, end, (0, $kCV8T.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $kCV8T.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $kCV8T.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $ad3826e817ebec37$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $ad3826e817ebec37$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$ad3826e817ebec37$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $ad3826e817ebec37$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $kCV8T.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $kCV8T.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $kCV8T.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $kCV8T.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $kCV8T.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $ad3826e817ebec37$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $ad3826e817ebec37$var$findWrappingOutside(range, nodeType);
    let inner = around && $ad3826e817ebec37$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($ad3826e817ebec37$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($ad3826e817ebec37$var$withAttrs));
}
function $ad3826e817ebec37$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $ad3826e817ebec37$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $ad3826e817ebec37$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $ad3826e817ebec37$var$wrap(tr, range, wrappers) {
    let content = (0, $kCV8T.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $kCV8T.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, start, end, new (0, $kCV8T.Slice)(content, 0, 0), wrappers.length, true));
}
function $ad3826e817ebec37$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $ad3826e817ebec37$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $ad3826e817ebec37$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $ad3826e817ebec37$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $ad3826e817ebec37$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $ad3826e817ebec37$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $ad3826e817ebec37$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $kCV8T.Fragment).empty, after = (0, $kCV8T.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $kCV8T.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $kCV8T.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(pos, pos, new (0, $kCV8T.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $ad3826e817ebec37$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $ad3826e817ebec37$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $ad3826e817ebec37$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $ad3826e817ebec37$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $ad3826e817ebec37$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $ad3826e817ebec37$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $ad3826e817ebec37$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $ad3826e817ebec37$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $ad3826e817ebec37$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $ad3826e817ebec37$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $kCV8T.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $ad3826e817ebec37$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $ad3826e817ebec37$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $ad3826e817ebec37$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $ad3826e817ebec37$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $kCV8T.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice);
    return new $ad3826e817ebec37$var$Fitter($from, $to, slice).fit();
}
function $ad3826e817ebec37$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $ad3826e817ebec37$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $kCV8T.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $kCV8T.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $kCV8T.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $ad3826e817ebec37$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $ad3826e817ebec37$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $ad3826e817ebec37$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $kCV8T.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $kCV8T.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($ad3826e817ebec37$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, frontierDepth, (0, $kCV8T.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$ad3826e817ebec37$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $ad3826e817ebec37$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $ad3826e817ebec37$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.depth, (0, $kCV8T.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $kCV8T.Fragment).empty, true);
        if (add.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $ad3826e817ebec37$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($ad3826e817ebec37$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $ad3826e817ebec37$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($ad3826e817ebec37$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $ad3826e817ebec37$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $ad3826e817ebec37$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $ad3826e817ebec37$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $kCV8T.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $ad3826e817ebec37$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$ad3826e817ebec37$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $ad3826e817ebec37$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $ad3826e817ebec37$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $ad3826e817ebec37$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $ad3826e817ebec37$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $ad3826e817ebec37$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $kCV8T.Slice)($ad3826e817ebec37$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $ad3826e817ebec37$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($ad3826e817ebec37$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $kCV8T.Fragment).empty, true));
    }
    return fragment;
}
function $ad3826e817ebec37$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $ad3826e817ebec37$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
}
function $ad3826e817ebec37$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $ad3826e817ebec37$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $ad3826e817ebec37$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $ad3826e817ebec37$export$626399c38172f669 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $ad3826e817ebec37$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("attr", $ad3826e817ebec37$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $ad3826e817ebec37$export$f50707b396300ac9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $ad3826e817ebec37$export$f50707b396300ac9(json.attr, json.value);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("docAttr", $ad3826e817ebec37$export$f50707b396300ac9);
/**
@internal
*/ let $ad3826e817ebec37$export$88cc3a1dfce48dd3 = class extends Error {
};
$ad3826e817ebec37$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.constructor = $ad3826e817ebec37$export$88cc3a1dfce48dd3;
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $ad3826e817ebec37$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $ad3826e817ebec37$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $ad3826e817ebec37$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $kCV8T.Slice).empty) {
        let step = $ad3826e817ebec37$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $kCV8T.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $ad3826e817ebec37$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $ad3826e817ebec37$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $ad3826e817ebec37$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $ad3826e817ebec37$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $ad3826e817ebec37$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $ad3826e817ebec37$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $ad3826e817ebec37$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $ad3826e817ebec37$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $ad3826e817ebec37$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $ad3826e817ebec37$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $ad3826e817ebec37$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $kCV8T.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $ad3826e817ebec37$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $ad3826e817ebec37$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $ad3826e817ebec37$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $ad3826e817ebec37$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("gkwXh", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $97c56ca7515fdb59$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $97c56ca7515fdb59$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $97c56ca7515fdb59$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $97c56ca7515fdb59$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $97c56ca7515fdb59$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $97c56ca7515fdb59$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $97c56ca7515fdb59$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
var $97c56ca7515fdb59$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $97c56ca7515fdb59$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_TTI"] = "tti";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
    ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
    ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $97c56ca7515fdb59$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $97c56ca7515fdb59$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $97c56ca7515fdb59$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $97c56ca7515fdb59$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    return ACTION_SUBJECT;
}({});
var $97c56ca7515fdb59$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $97c56ca7515fdb59$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("8AlsS", function(module, exports) {

$parcel$export(module.exports, "getNodeSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$3162c38157c33ee6);
$parcel$export(module.exports, "getAllSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$9f3a063378bdcaa1);
$parcel$export(module.exports, "getCellSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$dcdd07dcad6adb98);
$parcel$export(module.exports, "getRangeSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$bf6883b886d952b0);
$parcel$export(module.exports, "createSelectionClickHandler", () => $09b21fe82b545f9f$export$563f7987ca7936f1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $hHsVB = parcelRequire("hHsVB");

var $gkwXh = parcelRequire("gkwXh");

var $6MkyM = parcelRequire("6MkyM");

var $hPjvp = parcelRequire("hPjvp");

var $5Vvw4 = parcelRequire("5Vvw4");

var $3jyjs = parcelRequire("3jyjs");

var $2xQXF = parcelRequire("2xQXF");

var $fMoO3 = parcelRequire("fMoO3");

var $eAVGd = parcelRequire("eAVGd");

var $k6Y9i = parcelRequire("k6Y9i");
function $09b21fe82b545f9f$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $gZGBX.NodeSelection)) return {
        action: (0, $gkwXh.ACTION).SELECTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $09b21fe82b545f9f$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $gZGBX.AllSelection)) return {
        action: (0, $gkwXh.ACTION).SELECTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
}
function $09b21fe82b545f9f$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $hFEwm.CellSelection)) {
        const rect = (0, $hHsVB.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $gkwXh.ACTION).SELECTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $09b21fe82b545f9f$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $gZGBX.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $gkwXh.ACTION).SELECTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $09b21fe82b545f9f$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $gZGBX.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $09b21fe82b545f9f$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $09b21fe82b545f9f$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}

});
parcelRegister("hFEwm", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $451fe475e5e2c47a$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $6MNnJ = parcelRequire("6MNnJ");

var $uOUlv = parcelRequire("uOUlv");

var $6hQQ3 = parcelRequire("6hQQ3");

var $6e6o8 = parcelRequire("6e6o8");

var $aKDxB = parcelRequire("aKDxB");

var $bQFBc = parcelRequire("bQFBc");
class $451fe475e5e2c47a$export$831cc7e2a83afa94 extends (0, $gZGBX.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $aKDxB.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $6hQQ3.pointsAtCell)($anchorCell) && (0, $6hQQ3.pointsAtCell)($headCell) && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $gZGBX.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $6e6o8.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $6e6o8.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $kCV8T.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
        }
        const sel = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $uOUlv.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $451fe475e5e2c47a$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $6MNnJ.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $gZGBX.Selection).jsonID('cell', $451fe475e5e2c47a$export$831cc7e2a83afa94);

});
parcelRegister("6MNnJ", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $7bc56074adb266b5$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gZGBX = parcelRequire("gZGBX");

var $bQFBc = parcelRequire("bQFBc");
class $7bc56074adb266b5$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $7bc56074adb266b5$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $gZGBX.Selection).fromJSON(doc, data);
        }
        return (0, $gZGBX.Selection).near($headCell, 1);
    }
}

});
parcelRegister("bQFBc", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $e501ca8feab95168$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $e501ca8feab95168$export$debd62b44eb7e281);
function $e501ca8feab95168$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $e501ca8feab95168$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("uOUlv", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $ca500cf7ecedd822$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $ca500cf7ecedd822$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $ca500cf7ecedd822$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $ca500cf7ecedd822$var$readFromCache, $ca500cf7ecedd822$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $ca500cf7ecedd822$var$readFromCache = (key)=>cache.get(key);
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $ca500cf7ecedd822$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $ca500cf7ecedd822$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $ca500cf7ecedd822$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $ca500cf7ecedd822$export$c60fae4049791eae = 140;
class $ca500cf7ecedd822$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $ca500cf7ecedd822$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $ca500cf7ecedd822$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $ca500cf7ecedd822$var$readFromCache(table) || $ca500cf7ecedd822$var$addToCache(table, $ca500cf7ecedd822$var$computeMap(table));
    }
}
// Compute a table map.
function $ca500cf7ecedd822$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $ca500cf7ecedd822$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $ca500cf7ecedd822$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($ca500cf7ecedd822$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $ca500cf7ecedd822$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $ca500cf7ecedd822$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $ca500cf7ecedd822$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $ca500cf7ecedd822$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca500cf7ecedd822$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("6hQQ3", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $6704a47d099ba366$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $6704a47d099ba366$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $6704a47d099ba366$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $6704a47d099ba366$export$172699367bb25225);

var $uOUlv = parcelRequire("uOUlv");
function $6704a47d099ba366$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $6704a47d099ba366$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $6704a47d099ba366$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $6704a47d099ba366$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("6e6o8", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $44eb8577da1c519b$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $44eb8577da1c519b$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $44eb8577da1c519b$export$147ee78a1321ac36);
function $44eb8577da1c519b$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $44eb8577da1c519b$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("aKDxB", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $d20b421410b3cfed$export$a60a444208fd5099);

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");
function $d20b421410b3cfed$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $gZGBX.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});


parcelRegister("hHsVB", function(module, exports) {

$parcel$export(module.exports, "selectedRect", () => $78cade064f4edb3a$export$39ce22e69aa9ed17);

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $22PoI = parcelRequire("22PoI");
function $78cade064f4edb3a$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $22PoI.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $hFEwm.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}

});
parcelRegister("22PoI", function(module, exports) {

$parcel$export(module.exports, "selectionCell", () => $6e0c68deaeecd60c$export$aad75348c8f2d244);

var $6hQQ3 = parcelRequire("6hQQ3");

var $iGxzn = parcelRequire("iGxzn");
function $6e0c68deaeecd60c$export$aad75348c8f2d244(selection) {
    if ((0, $iGxzn.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $iGxzn.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $6hQQ3.cellAround)(selection.$head) || (0, $6hQQ3.cellNear)(selection.$head);
}

});
parcelRegister("iGxzn", function(module, exports) {

$parcel$export(module.exports, "isSelectionType", () => $a99399272acf3f8b$export$626dcc173023aed7);
function $a99399272acf3f8b$export$626dcc173023aed7(selection, type) {
    if (!selection) return false;
    const serialized = selection.toJSON();
    return serialized.type === type;
}

});



parcelRegister("6MkyM", function(module, exports) {

$parcel$export(module.exports, "RelativeSelectionPos", () => $1e3782577a66fd65$export$cb9005d223ae8de7);
var $1e3782577a66fd65$export$cb9005d223ae8de7 = /*#__PURE__*/ function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
    return RelativeSelectionPos;
}({});

});

parcelRegister("hPjvp", function(module, exports) {

$parcel$export(module.exports, "Side", () => $b20495f9cc03905d$export$80a00690bda7f17e);
$parcel$export(module.exports, "JSON_ID", () => $b20495f9cc03905d$export$d9f9f34e18094ffd);
$parcel$export(module.exports, "GapCursorSelection", () => $b20495f9cc03905d$export$7d98c58ca1423246);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $2xQXF = parcelRequire("2xQXF");
var $b20495f9cc03905d$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $b20495f9cc03905d$export$d9f9f34e18094ffd = 'gapcursor';
class $b20495f9cc03905d$export$7d98c58ca1423246 extends (0, $gZGBX.Selection) {
    /**
	 * Construct a GapCursorSelection
	 * @param {ResolvedPos} $pos resolved position
	 * @param {Side} side side where the gap cursor is drawn
	 */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side, this.visible = false;
    }
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $2xQXF.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $2xQXF.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos)) return new $b20495f9cc03905d$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($b20495f9cc03905d$export$7d98c58ca1423246.valid($cur)) return new $b20495f9cc03905d$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($b20495f9cc03905d$export$7d98c58ca1423246.valid($cur)) return new $b20495f9cc03905d$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $b20495f9cc03905d$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos) ? new $b20495f9cc03905d$export$7d98c58ca1423246($pos, this.side) : (0, $gZGBX.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $b20495f9cc03905d$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $kCV8T.Slice).empty;
    }
    getBookmark() {
        return new $b20495f9cc03905d$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $b20495f9cc03905d$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
}
(0, $gZGBX.Selection).jsonID($b20495f9cc03905d$export$d9f9f34e18094ffd, $b20495f9cc03905d$export$7d98c58ca1423246);
class $b20495f9cc03905d$export$afd2c0d75bc9ce6c {
    constructor(pos){
        this.pos = pos;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $b20495f9cc03905d$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos) ? new $b20495f9cc03905d$export$7d98c58ca1423246($pos) : (0, $gZGBX.Selection).near($pos);
    }
}

});
parcelRegister("2xQXF", function(module, exports) {

$parcel$export(module.exports, "isValidTargetNode", () => $2d159bb5ec0bb7a6$export$b485b49b5e1715ef);

var $3jyjs = parcelRequire("3jyjs");
const $2d159bb5ec0bb7a6$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $3jyjs.isIgnored)(node);
};

});
parcelRegister("3jyjs", function(module, exports) {

$parcel$export(module.exports, "isIgnored", () => $48a4afee3b713705$export$ac3f691269cd6d9b);
// we don't show gap cursor for those nodes
const $48a4afee3b713705$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $48a4afee3b713705$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $48a4afee3b713705$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};

});



parcelRegister("5Vvw4", function(module, exports) {

$parcel$export(module.exports, "setSelectionTopLevelBlocks", () => $d7ff16845adf5723$export$1b305efb24649ca5);
$parcel$export(module.exports, "setGapCursorAtPos", () => $d7ff16845adf5723$export$44fdd7840a0a11f2);

var $gZGBX = parcelRequire("gZGBX");

var $hPjvp = parcelRequire("hPjvp");

var $2xQXF = parcelRequire("2xQXF");
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $d7ff16845adf5723$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $hPjvp.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT;
            let position;
            if (side === (0, $hPjvp.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $d7ff16845adf5723$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $d7ff16845adf5723$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $hPjvp.Side).LEFT ? (0, $2xQXF.isValidTargetNode)($pos.nodeAfter) : (0, $2xQXF.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $hPjvp.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $hPjvp.GapCursorSelection)) tr.setSelection((0, $gZGBX.Selection).near($pos));
        else tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $gZGBX.Selection).findFrom($pos, cursorCoords.side === (0, $hPjvp.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $d7ff16845adf5723$export$44fdd7840a0a11f2 = (position, side = (0, $hPjvp.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $hPjvp.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };

});

parcelRegister("fMoO3", function(module, exports) {

$parcel$export(module.exports, "setGapCursorSelection", () => $860240a1613ee906$export$a8946811e8b82dd);

var $hPjvp = parcelRequire("hPjvp");
function $860240a1613ee906$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $hPjvp.GapCursorSelection)(state.doc.resolve(pos), side)));
}

});

parcelRegister("eAVGd", function(module, exports) {

$parcel$export(module.exports, "hideCaretModifier", () => $618a810c9ab6b0dd$export$8adc5edbc4a22166);
$parcel$export(module.exports, "gapCursorStyles", () => $618a810c9ab6b0dd$export$f6b9d90c2745834e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $618a810c9ab6b0dd$var$gapCursorBlink = (0, $f8Sb3.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $618a810c9ab6b0dd$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $618a810c9ab6b0dd$var$gapCursor = '.ProseMirror-gapcursor';
const $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $618a810c9ab6b0dd$var$wrapLeft = '[layout="wrap-left"]';
const $618a810c9ab6b0dd$var$wrapRight = '[layout="wrap-right"]';
const $618a810c9ab6b0dd$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{&.", $618a810c9ab6b0dd$export$8adc5edbc4a22166, "{caret-color:transparent;}", $618a810c9ab6b0dd$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $618a810c9ab6b0dd$var$gapCursorBlink, " step-start infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $618a810c9ab6b0dd$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $618a810c9ab6b0dd$var$gapCursor, "{display:block;border-color:transparent;}}", $618a810c9ab6b0dd$var$gapCursor, $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$gapCursor, $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span ", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "{clear:none;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "{float:left;}", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "::after,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "::after,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+*>*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock, "+", $618a810c9ab6b0dd$var$gapCursor, "+*,", $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+*{margin-top:0;}");

});

parcelRegister("k6Y9i", function(module, exports) {

$parcel$export(module.exports, "isSelectionAtStartOfNode", () => $2aa2babce658057c$export$2543715425b0bf0b);
$parcel$export(module.exports, "isSelectionAtEndOfNode", () => $2aa2babce658057c$export$5762916b8b83bc6d);
$parcel$export(module.exports, "atTheEndOfDoc", () => $2aa2babce658057c$export$4ca816540352da02);
$parcel$export(module.exports, "atTheBeginningOfDoc", () => $2aa2babce658057c$export$e9083e8cbe24bec0);
$parcel$export(module.exports, "atTheEndOfBlock", () => $2aa2babce658057c$export$6f303ca7dac350ae);
$parcel$export(module.exports, "endPositionOfParent", () => $2aa2babce658057c$export$8e09b50c60354750);
$parcel$export(module.exports, "atTheBeginningOfBlock", () => $2aa2babce658057c$export$8351d833af62ae68);
$parcel$export(module.exports, "startPositionOfParent", () => $2aa2babce658057c$export$ced77c72038c89cb);

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $hPjvp = parcelRequire("hPjvp");
const $2aa2babce658057c$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};
const $2aa2babce658057c$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};
function $2aa2babce658057c$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $2aa2babce658057c$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
function $2aa2babce658057c$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return false;
    if (selection instanceof (0, $gZGBX.NodeSelection) && selection.node.isBlock) return true;
    return $2aa2babce658057c$export$8e09b50c60354750($to) === $to.pos + 1;
}
function $2aa2babce658057c$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    const { $from: $from } = selection;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return false;
    if (selection instanceof (0, $gZGBX.NodeSelection) && selection.node.isBlock) return true;
    return $2aa2babce658057c$export$ced77c72038c89cb($from) === $from.pos;
}
function $2aa2babce658057c$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
function $2aa2babce658057c$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}
const $2aa2babce658057c$export$748c2428d313e6d0 = ($anchor, $head)=>{
    const sharedDepth = $anchor.sharedDepth($head.pos) + 1;
    const $from = $anchor.min($head);
    const $to = $anchor.max($head);
    const fromDepth = $from.depth;
    const toDepth = $to.depth;
    let selectionStart;
    let selectionEnd;
    const selectionHasGrandparent = toDepth > 1 && fromDepth > 1;
    const selectionIsAcrossDiffParents = selectionHasGrandparent && !$to.parent.isTextblock && !$to.sameParent($from);
    const selectionIsAcrossTextBlocksWithDiffParents = selectionHasGrandparent && $to.parent.isTextblock && $to.before(toDepth - 1) !== $from.before(fromDepth - 1);
    if (toDepth > fromDepth) {
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = fromDepth ? $from.before() : $from.pos;
            selectionEnd = fromDepth ? $to.after(fromDepth) : $to.after(1);
        }
    } else if (toDepth < fromDepth) {
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = toDepth ? $from.before(toDepth) : $from.before(1);
            selectionEnd = toDepth ? $to.after() : $to.pos;
        }
    } else if (selectionIsAcrossDiffParents || selectionIsAcrossTextBlocksWithDiffParents) {
        // when selection from/to share same depth with different parents, hoist up the selection to the parent of the highest depth in the selection
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = $from.before(fromDepth - 1);
            selectionEnd = $to.after(toDepth - 1);
        }
    } else if (!$from.node().inlineContent) // when selection might be a Node selection, return what was passed in
    return {
        $anchor: $anchor,
        $head: $head
    };
    else {
        selectionStart = fromDepth ? $from.before() : $from.pos;
        selectionEnd = toDepth ? $to.after() : $to.pos;
    }
    const $expandedFrom = $anchor.doc.resolve(selectionStart);
    const $expandedTo = $anchor.doc.resolve(selectionEnd);
    return {
        $anchor: $anchor === $from ? $expandedFrom : $expandedTo,
        $head: $head === $to ? $expandedTo : $expandedFrom
    };
};

});



parcelRegister("3Fq5M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));

var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
function $2ab970d264bef26f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ab970d264bef26f$var$CopyIcon = (props)=>/*#__PURE__*/ $2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
    }, props));
$2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;

});
parcelRegister("8w53e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63353af41c1756be$var$_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $63353af41c1756be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63353af41c1756be$var$CopyIcon = (props)=>/*#__PURE__*/ $63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;

});

parcelRegister("eE13R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa959fe1f5a86e24$var$CopyIcon = (props)=>/*#__PURE__*/ $aa959fe1f5a86e24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $aa959fe1f5a86e24$var$_copy.default
    }));
$aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;

});


parcelRegister("02Psx", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $a59737cd16881573$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $a59737cd16881573$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $a59737cd16881573$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $a59737cd16881573$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $a59737cd16881573$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $a59737cd16881573$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $a59737cd16881573$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $a59737cd16881573$export$dad567762dae162e);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $2X0eJ = parcelRequire("2X0eJ");

var $3XO6n = parcelRequire("3XO6n");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");
const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: (0, $4R6GH.fg)('jcs_project_type_m3') ? 'servicedesk' : 'customerservice',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('urls'), (0, $gl0PU.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${(0, $2X0eJ.serializeBackLink)(backLink)}`;
};
const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $2vSU6.SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${(0, $2X0eJ.serializeBackLink)(backLink)}`;
const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${(0, $2X0eJ.serializeBackLink)(backLink)}`;

});
parcelRegister("2X0eJ", function(module, exports) {

$parcel$export(module.exports, "serializeBackLink", () => $b75ea0cca9bceab1$export$abebef1e474c32c5);
$parcel$export(module.exports, "getHrefWithBackLink", () => $b75ea0cca9bceab1$export$6d7b0d2d046b7fdd);
/**
 * When users complete task in SWIFT settings page, a UI flag shows and says "Go back to X"
 * This object configures the URL and _translated_ link text of the UI flag.
 *
 * If this backlink is not configured then SWIFT uses some default text ("Go to project") or similar.
 * Each project type has its own defaults: configured in Product features
 *
 * See https://hello.atlassian.net/wiki/spaces/JPCE/pages/700125807/SWIFT+backlinks
 */ const $b75ea0cca9bceab1$export$abebef1e474c32c5 = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $b75ea0cca9bceab1$export$6d7b0d2d046b7fdd = (href, title)=>{
    if (!href || !href.length) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname, search: search } = window.location;
    const backlinkData = {
        // url and title are not using encodeURIComponent here because it will be serialized later.
        url: `${pathname}${search}`,
        title: title
    };
    const backlink = $b75ea0cca9bceab1$export$abebef1e474c32c5(backlinkData);
    return `${href}${backlink}`;
};

});

parcelRegister("3XO6n", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $594ec5369f29a734$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $594ec5369f29a734$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $594ec5369f29a734$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $594ec5369f29a734$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $594ec5369f29a734$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $594ec5369f29a734$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $594ec5369f29a734$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $594ec5369f29a734$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $594ec5369f29a734$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $594ec5369f29a734$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $594ec5369f29a734$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $594ec5369f29a734$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $594ec5369f29a734$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $594ec5369f29a734$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_APP_NAME", () => $594ec5369f29a734$export$b36025abb367eace);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $594ec5369f29a734$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $594ec5369f29a734$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $594ec5369f29a734$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $594ec5369f29a734$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $594ec5369f29a734$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $594ec5369f29a734$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $594ec5369f29a734$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $594ec5369f29a734$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $594ec5369f29a734$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $594ec5369f29a734$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $594ec5369f29a734$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $594ec5369f29a734$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $594ec5369f29a734$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $594ec5369f29a734$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $594ec5369f29a734$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $594ec5369f29a734$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $594ec5369f29a734$export$ac655f5b3ff7b929);
// Issue Type Templates

var $lzeFL = parcelRequire("lzeFL");

var $5fc53 = parcelRequire("5fc53");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7qPn9 = parcelRequire("7qPn9");

var $5fc53 = parcelRequire("5fc53");
const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
const $594ec5369f29a734$export$952581bc40160893 = 'custom';
const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
    $594ec5369f29a734$export$9355e489ad16f98e,
    $594ec5369f29a734$export$bcf558c186108044,
    $594ec5369f29a734$export$1ea39a3ae330045,
    $594ec5369f29a734$export$3cb4a99a332e4186
];
const $594ec5369f29a734$export$39cd48613b53ce2f = (0, $5fc53.TEXT_AREA_CF_TYPE);
const $594ec5369f29a734$export$56eae1056efd4899 = (0, $5fc53.DESCRIPTION_TYPE);
const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, $5fc53.ENVIRONMENT_TYPE);
const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
    $594ec5369f29a734$export$56eae1056efd4899,
    $594ec5369f29a734$export$39cd48613b53ce2f,
    $594ec5369f29a734$export$ca61f05d869b2ea3
];
const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $594ec5369f29a734$export$b36025abb367eace = 'Jira Customer Service';
const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
const $594ec5369f29a734$export$d77765147749db6b = 'select';
const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $ldyPw.populateApplicationEditions)(),
        appPermissions: (0, $7qPn9.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        appUpdatesAvailable: null,
        atlassianAccountId: null,
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        cloudId: (0, $g5X3G.toCloudId)(''),
        activationId: (0, $g5X3G.toActivationId)(''),
        cloudName: (0, $g5X3G.toCloudName)(''),
        devopsProjectSignupSource: (0, $g5X3G.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $ef5Xn.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $lzeFL.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false,
            customerService: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false,
        avpWorkspaceId: null
    });

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $81f079589240b9b7$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $81f079589240b9b7$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $81f079589240b9b7$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $81f079589240b9b7$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $81f079589240b9b7$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $81f079589240b9b7$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $81f079589240b9b7$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $81f079589240b9b7$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $81f079589240b9b7$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$1e188101081be3f8 = 'forge/string';
const $81f079589240b9b7$export$caf3b3f20c0589b9 = 'forge/string-list';
const $81f079589240b9b7$export$9bdf08a1276e866c = 'forge/number';
const $81f079589240b9b7$export$996c3d3eb2880229 = 'forge/date';
const $81f079589240b9b7$export$578c5856bf684e2a = 'forge/datetime';
const $81f079589240b9b7$export$38791c0fdd0bcce = 'forge/user';
const $81f079589240b9b7$export$5c209e1debd6c274 = 'forge/user-list';
const $81f079589240b9b7$export$8646fecba9a8be61 = 'forge/group';
const $81f079589240b9b7$export$68b91cd2f2e6b810 = 'forge/group-list';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("gl0PU", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $b5e194c6e2cc34cd$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $b5e194c6e2cc34cd$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("1RLjE", function(module, exports) {

$parcel$export(module.exports, "logError", () => $b0fc9ceb76f86c8e$export$58da9968c3170cb1);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");
const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $jcw0u.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $2YZCu.default).unsafeErrorWithCustomerData(location, message, error);
};

});


parcelRegister("g3vbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb65e672687e1ca$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $ebb65e672687e1ca$var$primaryColor = "var(--ds-icon, #44546F)";
const $ebb65e672687e1ca$var$EmailIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.66667 9.33341V22.6667H25.3333V9.33341H6.66667ZM25.3333 6.66675C26.8 6.66675 28 7.86675 28 9.33341V22.6667C28 24.1334 26.8 25.3334 25.3333 25.3334H6.66667C5.2 25.3334 4 24.1334 4 22.6667V9.33341C4 7.86675 5.2 6.66675 6.66667 6.66675H25.3333Z",
        fill: $ebb65e672687e1ca$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.33067 8.66675H4.16533C4.364 9.25341 4.69733 9.80541 5.16533 10.2734L13.008 18.1147C13.394 18.501 13.8523 18.8075 14.3567 19.0166C14.8612 19.2257 15.4019 19.3333 15.948 19.3333C16.4941 19.3333 17.0348 19.2257 17.5393 19.0166C18.0437 18.8075 18.502 18.501 18.888 18.1147L26.7307 10.2734C27.1973 9.80541 27.5307 9.25341 27.7293 8.66675H24.5653L17.0027 16.2294C16.8641 16.3681 16.6996 16.478 16.5185 16.5531C16.3374 16.6281 16.1433 16.6667 15.9473 16.6667C15.7513 16.6667 15.5572 16.6281 15.3762 16.5531C15.1951 16.478 15.0306 16.3681 14.892 16.2294L7.33067 8.66675Z",
        fill: $ebb65e672687e1ca$var$primaryColor
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ebb65e672687e1ca$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebb65e672687e1ca$var$EmailIcon, null);

});

parcelRegister("5gWY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cfbb40fba906d30$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0cfbb40fba906d30$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    channelTurnedOff: {
        "id": "servicedesk.channels-jsd.channels.email.channel-turned-off",
        "defaultMessage": "Turned off"
    },
    configure: {
        "id": "servicedesk.channels-jsd.channels.email.configure",
        "defaultMessage": "Configure"
    },
    configureLabelDescriptive: {
        "id": "servicedesk.channels-jsd.channels.email.configure.label-descriptive",
        "defaultMessage": "Configure email channel"
    },
    copyEmail: {
        "id": "servicedesk.channels-jsd.channels.email.copy-email",
        "defaultMessage": "Copy email"
    },
    emailLabel: {
        "id": "servicedesk.channels-jsd.channels.email.email-label",
        "defaultMessage": "EMAIL"
    },
    emailOffLabel: {
        "id": "servicedesk.channels-jsd.channels.email.email-off-label",
        "defaultMessage": "OFF"
    },
    email: {
        "id": "servicedesk.channels-jsd.channels.email.email",
        "defaultMessage": "Email"
    },
    emailOff: {
        "id": "servicedesk.channels-jsd.channels.email.email-off",
        "defaultMessage": "Off"
    },
    emailEnabledLabel: {
        "id": "servicedesk.channels-jsd.channels.email.email-enabled-label",
        "defaultMessage": "ENABLED"
    }
});

});



parcelRegister("jjpxd", function(module, exports) {

$parcel$export(module.exports, "HelpCenterChannel", () => $a817181f792fccb2$export$26d5d760acb49e66);

var $bC2fB = parcelRequire("bC2fB");

var $hNv1J = parcelRequire("hNv1J");

var $kpecO = parcelRequire("kpecO");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a817181f792fccb2$var$mapStateToProps = (state)=>({
        link: (0, $hNv1J.getPortalUrl)(state)
    });
const $a817181f792fccb2$export$26d5d760acb49e66 = (0, $bC2fB.connect)($a817181f792fccb2$var$mapStateToProps, {})((0, $kpecO.HelpCenterChannelView));

});
parcelRegister("kpecO", function(module, exports) {

$parcel$export(module.exports, "HelpCenterChannelView", () => $233d88aef6b20fa9$export$e0cd0179873c5b54);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $fVnbM = parcelRequire("fVnbM");

var $9fIhE = parcelRequire("9fIhE");

var $9Xmvg = parcelRequire("9Xmvg");

var $iQv12 = parcelRequire("iQv12");

var $8RXs9 = parcelRequire("8RXs9");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $aj3l3 = parcelRequire("aj3l3");

var $eRwaR = parcelRequire("eRwaR");

var $l7oyI = parcelRequire("l7oyI");

var $6Xy1c = parcelRequire("6Xy1c");
// eslint-disable-next-line jira/react/no-class-components
class $233d88aef6b20fa9$var$HelpCenterChannelViewComponent extends (0, $5uXOq.Component) {
    render() {
        const { link: link, intl: { formatMessage: formatMessage } } = this.props;
        const lozengeType = link ? (0, $aj3l3.LOZENGE_TYPES).ON : (0, $aj3l3.LOZENGE_TYPES).OFF;
        const lozengeLabel = formatMessage(link ? (0, $6Xy1c.default).portalVisibleLabel : (0, $6Xy1c.default).portalHiddenLabel);
        const isNav4 = (0, $3HwlS.getWillShowNav4)();
        const description = isNav4 ? link ?? formatMessage((0, $6Xy1c.default).portalHidden) : link;
        const icon = isNav4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9fIhE))), {
            color: "var(--ds-icon, #44546F)",
            label: ""
        }) : this.image;
        const label = isNav4 ? formatMessage((0, $6Xy1c.default).label) : formatMessage((0, $6Xy1c.default).portalLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.BaseChannelItem), {
            image: icon,
            label: label,
            description: description,
            button: this.button,
            channelName: "help-center",
            statusLozenge: !isNav4 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj3l3.ChannelStatusLozenge), {
                type: lozengeType,
                label: lozengeLabel
            })
        });
    }
    constructor(...args){
        super(...args), this.image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.ChannelItemImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7oyI.HelpCenterIcon), null)), this.button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: this.props.link,
            onClick: this.props.onClick,
            appearance: "default",
            target: "_blank",
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Xmvg))), {
                label: this.props.intl.formatMessage((0, $6Xy1c.default).helpCenterButtonLabel)
            }),
            ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_channel') ? {
                'aria-label': this.props.intl.formatMessage((0, $6Xy1c.default).openButtonLabelDescriptive)
            } : {}
        }, this.props.intl.formatMessage((0, $6Xy1c.default).open));
    }
}
const $233d88aef6b20fa9$export$e0cd0179873c5b54 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'openHelpCenter'
}), (0, $8RXs9.default))($233d88aef6b20fa9$var$HelpCenterChannelViewComponent);

});
parcelRegister("l7oyI", function(module, exports) {

$parcel$export(module.exports, "HelpCenterIcon", () => $8d5b099e99a11a40$export$ccd5d80774b3acdd);

var $5uXOq = parcelRequire("5uXOq");
const $8d5b099e99a11a40$var$primaryColor = "var(--ds-icon, #44546F)";
const $8d5b099e99a11a40$export$ccd5d80774b3acdd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.00001 8.01192C4.00001 6.53192 5.19068 5.33325 6.66001 5.33325H25.34C26.8093 5.33325 28 6.53592 28 8.01192V18.6546C28 20.1346 26.8093 21.3333 25.34 21.3333H6.66001C5.95227 21.3301 5.27471 21.0462 4.77602 20.5441C4.27732 20.0419 3.99824 19.3623 4.00001 18.6546V8.01192ZM6.66668 18.6666H25.3333V7.99992H6.66668V18.6666Z",
        fill: $8d5b099e99a11a40$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.3333 22.6666H18.6667V26.6666H13.3333V22.6666ZM12 27.3333C12 27.1585 12.0686 26.9907 12.191 26.866C12.3134 26.7414 12.48 26.6697 12.6547 26.6666H19.3453C19.5201 26.6697 19.6866 26.7414 19.809 26.866C19.9314 26.9907 20 27.1585 20 27.3333V27.9999H12V27.3333Z",
        fill: $8d5b099e99a11a40$var$primaryColor
    }));

});

parcelRegister("6Xy1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d4bd6de7861075f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0d4bd6de7861075f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    portalLabel: {
        "id": "servicedesk.channels-jsd.channels.help-center.portal-label",
        "defaultMessage": "PORTAL"
    },
    label: {
        "id": "servicedesk.channels-jsd.channels.help-center.label",
        "defaultMessage": "Portal"
    },
    helpCenterButtonLabel: {
        "id": "servicedesk.channels-jsd.channels.help-center.help-center-button-label",
        "defaultMessage": "Open Help Center"
    },
    open: {
        "id": "servicedesk.channels-jsd.channels.help-center.open",
        "defaultMessage": "Open"
    },
    openButtonLabelDescriptive: {
        "id": "servicedesk.channels-jsd.channels.help-center.open.label-descriptive",
        "defaultMessage": "Open portal"
    },
    portalVisibleLabel: {
        "id": "servicedesk.channels-jsd.channels.help-center.portal-visible-label",
        "defaultMessage": "VISIBLE"
    },
    portalHiddenLabel: {
        "id": "servicedesk.channels-jsd.channels.help-center.portal-hidden-label",
        "defaultMessage": "HIDDEN"
    },
    portalHidden: {
        "id": "servicedesk.channels-jsd.channels.help-center.portal-hidden",
        "defaultMessage": "Hidden"
    }
});

});



parcelRegister("5lEpS", function(module, exports) {

$parcel$export(module.exports, "WidgetChannel", () => $895e7d969c1c63da$export$f5e85bc6423bb6e0);

var $bC2fB = parcelRequire("bC2fB");

var $geXrZ = parcelRequire("geXrZ");

var $hNv1J = parcelRequire("hNv1J");

var $8Nh3s = parcelRequire("8Nh3s");

var $2csfQ = parcelRequire("2csfQ");
const $895e7d969c1c63da$var$mapStateToProps = (state)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { hostname: hostname } = window.location;
    const projectKey = (0, $geXrZ.getProjectKey)(state);
    const isSimplified = (0, $geXrZ.isProjectSimplified)(state);
    return {
        isAdmin: (0, $geXrZ.isProjectAdmin)(state),
        isEnabled: (0, $hNv1J.isWidgetEnabled)(state),
        link: isSimplified ? (0, $8Nh3s.getNextGenWidgetSettingsLink)(hostname, projectKey) : (0, $8Nh3s.getWidgetSettingsLink)(projectKey)
    };
};
const $895e7d969c1c63da$export$f5e85bc6423bb6e0 = (0, $bC2fB.connect)($895e7d969c1c63da$var$mapStateToProps, {})((0, $2csfQ.WidgetChannelView));

});
parcelRegister("8Nh3s", function(module, exports) {

$parcel$export(module.exports, "getWidgetSettingsLink", () => $342d0caab2527e2a$export$94779a476996078b);
$parcel$export(module.exports, "getNextGenWidgetSettingsLink", () => $342d0caab2527e2a$export$b4b5f1db72081a14);

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");
const $342d0caab2527e2a$export$94779a476996078b = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/settings/widget`;
const $342d0caab2527e2a$export$b4b5f1db72081a14 = (hostname, projectKey)=>`https://${hostname}${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/widget`;

});

parcelRegister("2csfQ", function(module, exports) {

$parcel$export(module.exports, "WidgetChannelView", () => $080c3f235e951ec4$export$9d6ee23b6d999529);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $fVnbM = parcelRequire("fVnbM");

var $hRf4g = parcelRequire("hRf4g");

var $iQv12 = parcelRequire("iQv12");

var $8RXs9 = parcelRequire("8RXs9");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $aj3l3 = parcelRequire("aj3l3");

var $eRwaR = parcelRequire("eRwaR");

var $g1oXY = parcelRequire("g1oXY");

var $1rXln = parcelRequire("1rXln");
// eslint-disable-next-line jira/react/no-class-components
class $080c3f235e951ec4$var$WidgetChannelViewComponent extends (0, $5uXOq.Component) {
    render() {
        const { isEnabled: isEnabled, isAdmin: isAdmin, onClick: onClick, link: link, intl: { formatMessage: formatMessage } } = this.props;
        const configureButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: link,
            onClick: onClick,
            appearance: "default",
            ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_channel') ? {
                'aria-label': formatMessage((0, $1rXln.default).configureLabelDescriptive)
            } : {}
        }, formatMessage((0, $1rXln.default).configure));
        const lozengeType = isEnabled ? (0, $aj3l3.LOZENGE_TYPES).ON : (0, $aj3l3.LOZENGE_TYPES).OFF;
        const lozengeLabel = formatMessage(isEnabled ? (0, $1rXln.default).widgetOnLabel : (0, $1rXln.default).widgetOffLabel);
        const isNav4 = (0, $3HwlS.getWillShowNav4)();
        const description = isEnabled ? formatMessage(isNav4 ? (0, $1rXln.default).widgetOn : (0, $1rXln.default).channelIsOn) : formatMessage(isNav4 ? (0, $1rXln.default).widgetOff : (0, $1rXln.default).channelTurnedOff);
        const image = isEnabled ? this.enabledImage : this.disabledImage;
        const icon = isNav4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
            color: "var(--ds-icon, #44546F)",
            label: ""
        }) : image;
        const label = isNav4 ? formatMessage((0, $1rXln.default).widget) : formatMessage((0, $1rXln.default).widgetLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.BaseChannelItem), {
            button: isAdmin ? configureButton : undefined,
            image: icon,
            label: label,
            description: description,
            channelName: "widget",
            statusLozenge: !isNav4 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj3l3.ChannelStatusLozenge), {
                type: lozengeType,
                label: lozengeLabel
            })
        });
    }
    constructor(...args){
        super(...args), this.disabledImage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.ChannelItemImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1oXY.WidgetDisabledIcon), null)), this.enabledImage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRwaR.ChannelItemImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1oXY.WidgetEnabledIcon), null));
    }
}
const $080c3f235e951ec4$export$9d6ee23b6d999529 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'configureWidget'
}), (0, $8RXs9.default))($080c3f235e951ec4$var$WidgetChannelViewComponent);

});
parcelRegister("g1oXY", function(module, exports) {

$parcel$export(module.exports, "WidgetDisabledIcon", () => $d1d6ac985b6dd8af$export$9ff90cc4dcf5ebe0);
$parcel$export(module.exports, "WidgetEnabledIcon", () => $d1d6ac985b6dd8af$export$137d705f50a13f9b);

var $5uXOq = parcelRequire("5uXOq");
const $d1d6ac985b6dd8af$var$primaryColor = "var(--ds-icon, #44546F)";
const $d1d6ac985b6dd8af$var$baseColor = "var(--ds-background-neutral, #091E420F)";
const $d1d6ac985b6dd8af$export$9ff90cc4dcf5ebe0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.08696 4H22.2459C22.52 4 22.7914 4.05173 23.0446 4.15224C23.2978 4.25275 23.5278 4.40007 23.7216 4.58579C23.9154 4.7715 24.0691 4.99198 24.174 5.23463C24.2789 5.47728 24.3329 5.73736 24.3329 6V25.893C24.3329 26.4234 24.113 26.9321 23.7216 27.3072C23.3302 27.6823 22.7994 27.893 22.2459 27.893H8.08696C7.53346 27.893 7.00264 27.6823 6.61126 27.3072C6.21988 26.9321 6 26.4234 6 25.893V6C6 5.46957 6.21988 4.96086 6.61126 4.58579C7.00264 4.21071 7.53346 4 8.08696 4V4ZM8.50957 7.094C8.23282 7.094 7.9674 7.19936 7.77171 7.38689C7.57602 7.57443 7.46609 7.82878 7.46609 8.094V8.905C7.46609 9.17022 7.57602 9.42457 7.77171 9.61211C7.9674 9.79964 8.23282 9.905 8.50957 9.905H21.8223C22.099 9.905 22.3644 9.79964 22.5601 9.61211C22.7558 9.42457 22.8657 9.17022 22.8657 8.905V8.095C22.8657 7.82978 22.7558 7.57543 22.5601 7.38789C22.3644 7.20036 22.099 7.095 21.8223 7.095H8.50957V7.094ZM8.50957 11.966C8.23282 11.966 7.9674 12.0714 7.77171 12.2589C7.57602 12.4464 7.46609 12.7008 7.46609 12.966V20.616C7.46609 20.8812 7.57602 21.1356 7.77171 21.3231C7.9674 21.5106 8.23282 21.616 8.50957 21.616H21.8223C22.099 21.616 22.3644 21.5106 22.5601 21.3231C22.7558 21.1356 22.8657 20.8812 22.8657 20.616V12.966C22.8657 12.7008 22.7558 12.4464 22.5601 12.2589C22.3644 12.0714 22.099 11.966 21.8223 11.966H8.50957Z",
        fill: $d1d6ac985b6dd8af$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.9215 23.021H8.50832C7.93202 23.021 7.46484 23.4687 7.46484 24.021V24.481C7.46484 25.0333 7.93202 25.481 8.50832 25.481H11.9215C12.4978 25.481 12.965 25.0333 12.965 24.481V24.021C12.965 23.4687 12.4978 23.021 11.9215 23.021Z",
        fill: $d1d6ac985b6dd8af$var$baseColor
    }));
const $d1d6ac985b6dd8af$export$137d705f50a13f9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_480_33977)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.08696 4H22.2459C22.52 4 22.7914 4.05173 23.0446 4.15224C23.2978 4.25275 23.5278 4.40007 23.7216 4.58579C23.9154 4.7715 24.0691 4.99198 24.174 5.23463C24.2789 5.47728 24.3329 5.73736 24.3329 6V25.893C24.3329 26.4234 24.113 26.9321 23.7216 27.3072C23.3302 27.6823 22.7994 27.893 22.2459 27.893H8.08696C7.53346 27.893 7.00264 27.6823 6.61126 27.3072C6.21988 26.9321 6 26.4234 6 25.893V6C6 5.46957 6.21988 4.96086 6.61126 4.58579C7.00264 4.21071 7.53346 4 8.08696 4V4ZM8.50957 7.094C8.23282 7.094 7.9674 7.19936 7.77171 7.38689C7.57602 7.57443 7.46609 7.82878 7.46609 8.094V8.905C7.46609 9.17022 7.57602 9.42457 7.77171 9.61211C7.9674 9.79964 8.23282 9.905 8.50957 9.905H21.8223C22.099 9.905 22.3644 9.79964 22.5601 9.61211C22.7558 9.42457 22.8657 9.17022 22.8657 8.905V8.095C22.8657 7.82978 22.7558 7.57543 22.5601 7.38789C22.3644 7.20036 22.099 7.095 21.8223 7.095H8.50957V7.094ZM8.50957 11.966C8.23282 11.966 7.9674 12.0714 7.77171 12.2589C7.57602 12.4464 7.46609 12.7008 7.46609 12.966V20.616C7.46609 20.8812 7.57602 21.1356 7.77171 21.3231C7.9674 21.5106 8.23282 21.616 8.50957 21.616H21.8223C22.099 21.616 22.3644 21.5106 22.5601 21.3231C22.7558 21.1356 22.8657 20.8812 22.8657 20.616V12.966C22.8657 12.7008 22.7558 12.4464 22.5601 12.2589C22.3644 12.0714 22.099 11.966 21.8223 11.966H8.50957Z",
        fill: $d1d6ac985b6dd8af$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.9215 23.021H8.50832C7.93202 23.021 7.46484 23.4687 7.46484 24.021V24.481C7.46484 25.0333 7.93202 25.481 8.50832 25.481H11.9215C12.4978 25.481 12.965 25.0333 12.965 24.481V24.021C12.965 23.4687 12.4978 23.021 11.9215 23.021Z",
        fill: $d1d6ac985b6dd8af$var$primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.5229 28C28.6035 28 29.4794 27.1605 29.4794 26.125C29.4794 25.0895 28.6035 24.25 27.5229 24.25C26.4424 24.25 25.5664 25.0895 25.5664 26.125C25.5664 27.1605 26.4424 28 27.5229 28Z",
        fill: $d1d6ac985b6dd8af$var$primaryColor
    })));

});

parcelRegister("1rXln", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cb1aa631747e465$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1cb1aa631747e465$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    channelIsOn: {
        "id": "servicedesk.channels-jsd.channels.widget.channel-is-on",
        "defaultMessage": "Widget is on"
    },
    channelTurnedOff: {
        "id": "servicedesk.channels-jsd.channels.widget.channel-turned-off",
        "defaultMessage": "Turned off"
    },
    configure: {
        "id": "servicedesk.channels-jsd.channels.widget.configure",
        "defaultMessage": "Configure"
    },
    configureLabelDescriptive: {
        "id": "servicedesk.channels-jsd.channels.widget.configure.label-descriptive",
        "defaultMessage": "Configure Widget"
    },
    widgetOnLabel: {
        "id": "servicedesk.channels-jsd.channels.widget.widget-on-label",
        "defaultMessage": "ENABLED"
    },
    widgetOffLabel: {
        "id": "servicedesk.channels-jsd.channels.widget.widget-off-label",
        "defaultMessage": "OFF"
    },
    widgetLabel: {
        "id": "servicedesk.channels-jsd.channels.widget.widget-label",
        "defaultMessage": "WIDGET"
    },
    widgetOn: {
        "id": "servicedesk.channels-jsd.channels.widget.widget-on",
        "defaultMessage": "On"
    },
    widgetOff: {
        "id": "servicedesk.channels-jsd.channels.widget.widget-off",
        "defaultMessage": "Off"
    },
    widget: {
        "id": "servicedesk.channels-jsd.channels.widget.widget",
        "defaultMessage": "Widget"
    }
});

});



parcelRegister("eKGJZ", function(module, exports) {

$parcel$export(module.exports, "ChannelsJsd", () => $41d4c2d8b4db5acb$export$8aa3d96ecc235fde);

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");


var $bC2fB = parcelRequire("bC2fB");

var $hNv1J = parcelRequire("hNv1J");

var $2xLFH = parcelRequire("2xLFH");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $41d4c2d8b4db5acb$var$mapStateToProps = (state)=>({
        isLoading: (0, $hNv1J.isLoading)(state),
        portalId: (0, $hNv1J.getPortalId)(state)
    });
const $41d4c2d8b4db5acb$export$8aa3d96ecc235fde = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSource)('jsdChannels', (0, $4d5e0871c06cee03$export$cae2783c9279926)), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $bC2fB.connect)($41d4c2d8b4db5acb$var$mapStateToProps, {}))((0, $2xLFH.ChannelsJsdView));

});
parcelRegister("2xLFH", function(module, exports) {

$parcel$export(module.exports, "ChannelsJsdView", () => $eadac46fc63f3d7d$export$a584158001189e71);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $561FV = parcelRequire("561FV");

var $fW62l = parcelRequire("fW62l");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $hZHze = parcelRequire("hZHze");

var $8RXs9 = parcelRequire("8RXs9");

var $3HwlS = parcelRequire("3HwlS");

var $ce4pa = parcelRequire("ce4pa");

var $4puvO = parcelRequire("4puvO");

var $3iZ5h = parcelRequire("3iZ5h");

var $jWjSW = parcelRequire("jWjSW");
// eslint-disable-next-line jira/react/no-class-components
class $eadac46fc63f3d7d$var$ChannelsJsdViewComponent extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isLoading: true
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.onPageClick = (event)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(this, 'node.current') && !this.node.current.contains(event.target)) this.props.onSetIsChannelsDialogOpen(false);
        }, this.onKeyPress = (event)=>{
            if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('escape')) this.props.onSetIsChannelsDialogOpen(false);
        };
        this.node = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('click', this.onPageClick);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('keydown', this.onKeyPress, false);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('click', this.onPageClick); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('keydown', this.onKeyPress, false);
    }
    isChannelInfoLoaded() {
        return this.props.portalId !== 0;
    }
    render() {
        const { intl: intl, isLoading: isLoading, EmailChannel: EmailChannel, HelpDeskChannel: HelpDeskChannel, WidgetChannel: WidgetChannel, ChatChannel: ChatChannel, CustomerAccessChannel: CustomerAccessChannel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: (0, $3HwlS.getWillShowNav4)() && $eadac46fc63f3d7d$var$nav4SpinnerStyles,
            ref: this.node
        }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: [
                $eadac46fc63f3d7d$var$spinnerWrapperStyles,
                !(0, $3HwlS.getWillShowNav4)() && $eadac46fc63f3d7d$var$nav3SpinnerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "large"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWjSW.ChannelsTitle), {
            title: intl.formatMessage((0, $3iZ5h.default).title)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EmailChannel, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HelpDeskChannel, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WidgetChannel, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChatChannel, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eadac46fc63f3d7d$var$HorizontalLine, {
            role: "presentation"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomerAccessChannel, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), this.isChannelInfoLoaded() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ce4pa.ExperienceSuccess), {
            experience: (0, $4puvO.loadChannelsExperience)
        })));
    }
}
const $eadac46fc63f3d7d$export$a584158001189e71 = (0, $8RXs9.default)($eadac46fc63f3d7d$var$ChannelsJsdViewComponent);
const $eadac46fc63f3d7d$var$spinnerWrapperStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '296px'
});
const $eadac46fc63f3d7d$var$nav3SpinnerStyles = (0, $8CUq3.xcss)({
    width: '416px'
});
const $eadac46fc63f3d7d$var$nav4SpinnerStyles = (0, $8CUq3.xcss)({
    minWidth: '280px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eadac46fc63f3d7d$var$HorizontalLine = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189et94y _1dqonqa1 _syazmuej _19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fW62l", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $994MI.default)({
    componentName: 'view-tracker'
})((0, $cb25w.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("3iZ5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $be1a2c0ba2a5d120$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $be1a2c0ba2a5d120$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk.channels-jsd.title",
        "defaultMessage": "Channels"
    }
});

});

parcelRegister("jWjSW", function(module, exports) {

$parcel$export(module.exports, "ChannelsTitle", () => $20b3409e864e4e43$export$f2d8e620e4c2645);

var $ig8lP = parcelRequire("ig8lP");
const $20b3409e864e4e43$export$f2d8e620e4c2645 = (0, $ig8lP.ChannelsTitleView);

});
parcelRegister("ig8lP", function(module, exports) {

$parcel$export(module.exports, "ChannelsTitleView", () => $1e632e0c5f2b000d$export$d74df69d5dacaf24);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3HwlS = parcelRequire("3HwlS");
function $1e632e0c5f2b000d$export$d74df69d5dacaf24({ title: title }) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1e632e0c5f2b000d$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e632e0c5f2b000d$var$Text, {
        size: "medium",
        as: "h3"
    }, title);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1e632e0c5f2b000d$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $l1N8i.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $1e632e0c5f2b000d$var$headingStyles = (0, $8CUq3.xcss)({
    margin: 'space.100'
});

});





parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("y8WG5", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $6f07339a74e499dd$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useReportFeatures", () => $6f07339a74e499dd$export$4adaea9828b7ff13);
$parcel$export(module.exports, "useSettingFeatures", () => $6f07339a74e499dd$export$56022a3b83c8ed6a);
$parcel$export(module.exports, "useTMPSettingFeatures", () => $6f07339a74e499dd$export$e8540ab76a479132);

var $5uXOq = parcelRequire("5uXOq");

var $aQGK8 = parcelRequire("aQGK8");

var $1J3t1 = parcelRequire("1J3t1");

var $jIwth = parcelRequire("jIwth");

var $2tT7R = parcelRequire("2tT7R");

var $kFjc6 = parcelRequire("kFjc6");
const $6f07339a74e499dd$export$4a39035bacc4ed76 = (customContext)=>{
    const { data: data, ...rest } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)(customContext);
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $kFjc6.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $6f07339a74e499dd$export$4adaea9828b7ff13 = (customContext)=>{
    const { data: data, ...rest } = (0, $aQGK8.useJiraServiceManagementReportsNavigation)(customContext);
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $kFjc6.extractReportData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $6f07339a74e499dd$export$56022a3b83c8ed6a = (customContext)=>{
    const { data: data, ...rest } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)(customContext);
    const hasActiveSoftwareAccess = (0, $jIwth.useHasActiveSoftwareAccess)();
    const environment = (0, $2tT7R.useEnvironment)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $kFjc6.extractSettingData)(data, {
            hasActiveSoftwareAccess: hasActiveSoftwareAccess,
            environment: environment
        }), [
        data,
        environment,
        hasActiveSoftwareAccess
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $6f07339a74e499dd$export$e8540ab76a479132 = ()=>{
    const { data: data, ...rest } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $kFjc6.extractTMPSettingData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};

});
parcelRegister("aQGK8", function(module, exports) {

$parcel$export(module.exports, "useJiraServiceManagementReportsNavigation", () => $8d8e651293539c9e$export$6d172fb6aa6b6b5b);

var $gS5PF = parcelRequire("gS5PF");

var $324W5 = parcelRequire("324W5");
const $8d8e651293539c9e$export$6d172fb6aa6b6b5b = (customContext)=>(0, $324W5.useResourceWithCustomRouterContext)((0, $gS5PF.staticSidebarJsmReportsResource), customContext);

});
parcelRegister("gS5PF", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $e7e607725980fdf6$export$ec28065a31cce4ce);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $cQGRH = parcelRequire("cQGRH");
const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $cQGRH.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("cQGRH", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $ed2ba0d649a8d8eb$export$c1dd51127051647d);

var $eusud = parcelRequire("eusud");
const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});



parcelRegister("jIwth", function(module, exports) {

$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $c3adde43a433f1b5$export$895f9b38ce00671e);

var $k9JTq = parcelRequire("k9JTq");

var $daoB1 = parcelRequire("daoB1");
const $c3adde43a433f1b5$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $daoB1.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});

parcelRegister("2tT7R", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $6bd66e47d4948917$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $6bd66e47d4948917$export$b0d8f74f433a09c9);

var $9OXo1 = parcelRequire("9OXo1");
const $6bd66e47d4948917$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
};
const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
    const env = $6bd66e47d4948917$export$ea7ed2425832167d();
    return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("kFjc6", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $d21447ab73114105$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractReportData", () => $d21447ab73114105$export$86f3b0e5fff6482e);
$parcel$export(module.exports, "extractSettingData", () => $d21447ab73114105$export$a1d86e289d0f43b7);
$parcel$export(module.exports, "extractTMPSettingData", () => $d21447ab73114105$export$d334c13580163a89);

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");
const $d21447ab73114105$export$9df5fa0a366163d2 = (navData)=>{
    const { project: project, permissionInfo: permissionInfo, isAgent: isAgent, hasCustomerChannels: hasCustomerChannels, knowledgeBaseInfo: knowledgeBaseInfo, raiseRequestInfo: raiseRequestInfo, opsGenieInfo: opsGenieInfo, projectSummaryInfo: projectSummaryInfo, boardInfo: boardInfo, calendarInfo: calendarInfo, hasNotificationLogs: hasNotificationLogs = true, hasHelpCenterSettings: hasHelpCenterSettings = false, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const { isOnCallEnabled: isOnCallEnabled, isAlertEnabled: isAlertEnabled, opsGenieBaseUrl: opsGenieBaseUrl } = opsGenieInfo;
    const isProjectOrJiraAdmin = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const { portalUrl: portalUrl } = raiseRequestInfo;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasQueues: isAgent,
        hasCustomers: isAgent,
        hasCustomerChannels: hasCustomerChannels,
        hasReports: isAgent,
        hasPIN: !isAgent,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        knowledge: {
            enabled: knowledgeBaseInfo.enabled,
            type: knowledgeBaseInfo.enabled ? knowledgeBaseInfo.knowledgeBaseType : null
        },
        raiseRequest: {
            enabled: raiseRequestInfo.enabled,
            url: raiseRequestInfo.enabled ? portalUrl : ''
        },
        opsgenieAlert: {
            enabled: isAlertEnabled,
            url: isAlertEnabled ? `${opsGenieBaseUrl}/alert/list` : ''
        },
        opsgenieOnCall: {
            enabled: isOnCallEnabled,
            url: isOnCallEnabled ? `${opsGenieBaseUrl}/schedule/whoIsOnCall` : ''
        },
        hasProjectSummary: (0, $4R6GH.fg)('jsm-project-summary-beta') ? !!projectSummaryInfo?.enabled : false,
        jsmBoard: {
            enabled: boardInfo.enabled,
            url: `/jira/servicedesk/projects/${project.key}/boards/${boardInfo.board.id}`
        },
        jsmCalendar: {
            enabled: calendarInfo?.enabled ?? false,
            url: `/jira/servicedesk/projects/${project.key}/boards/${boardInfo.board.id}/calendar`
        },
        hasNotificationLogs: (0, $4R6GH.fg)('jcs_master_flag') ? hasNotificationLogs : true,
        hasHelpCenterSettings: (0, $4R6GH.fg)('jcs_master_flag') ? isProjectOrJiraAdmin && hasHelpCenterSettings : false
    };
};
const $d21447ab73114105$export$86f3b0e5fff6482e = (data)=>({
        hasWorkload: true,
        hasSatisfaction: data.hasSatisfactionReport,
        hasRequestsDeflected: data.hasRequestsDeflectedReport,
        hasRequestsResolved: data.hasRequestsResolvedReport,
        hasNewReport: data.hasNewReport,
        hasManageReport: false
    });
const $d21447ab73114105$export$a1d86e289d0f43b7 = (navData, { hasActiveSoftwareAccess: hasActiveSoftwareAccess, environment: environment })=>{
    const { permissionInfo: permissionInfo, settingsInfo: settingsInfo } = navData;
    const { hasChangeManagement: hasChangeManagement = false, hasAddonInstaller: hasAddonInstaller = false, hasIncidentManagement: hasIncidentManagement = false, hasExternalLinks: hasExternalLinks = false, hasProjectAutomation: hasProjectAutomation = false, hasWidgetAddon: hasWidgetAddon = false, hasChat: hasChat = true, hasServices: hasServices = false, hasVersions: hasVersions = true, hasComponents: hasComponents = true, hasCustomerSupportManagement: hasCustomerSupportManagement = false, hasProductsAndEntitlements: hasProductsAndEntitlements = false, hasDeveloperEscalation: hasDeveloperEscalation = false, hasVirtualAgent: hasVirtualAgent = true, hasLanguageSupport: hasLanguageSupport = true, hasRequestTypes: hasRequestTypes = true, hasPortalSettings: hasPortalSettings = true, hasCustomerNotifications: hasCustomerNotifications = true, hasCustomerPermissions: hasCustomerPermissions = true, hasForms: hasForms = true, hasKnowledgeBase: hasKnowledgeBase = true, hasChannelsAndSelfService: hasChannelsAndSelfService = true } = settingsInfo;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrJiraAdmin = isAdmin || isProjectAdmin;
    const hasIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    return {
        hasDetails: isProjectOrJiraAdmin,
        hasPeople: isProjectOrJiraAdmin,
        hasSummary: true,
        hasIssueLayout: isProjectOrJiraAdmin || hasIssueLayoutPermissions,
        hasIssueTypes: isProjectOrJiraAdmin,
        hasJsdChangeManagement: hasChangeManagement,
        hasRequestTypes: (0, $4R6GH.fg)('jcs_master_flag') ? hasRequestTypes : true,
        hasCustomerPermissions: (0, $4R6GH.fg)('jcs_master_flag') ? hasCustomerPermissions : true,
        hasPortalSettings: (0, $4R6GH.fg)('jcs_master_flag') ? hasPortalSettings : true,
        hasCustomerNotifications: (0, $4R6GH.fg)('jcs_master_flag') ? hasCustomerNotifications : true,
        hasAddonInstaller: hasAddonInstaller,
        hasWidgetAddon: hasWidgetAddon && environment === 'prod',
        hasWidgetAddonDev: hasWidgetAddon && environment !== 'prod',
        hasChat: hasChat,
        hasKnowledgeBase: (0, $4R6GH.fg)('jcs_master_flag') ? hasKnowledgeBase : true,
        hasSla: true,
        hasLegacyJSMAutomation: true,
        hasJsdAppDiscovery: true,
        hasJsdIncidentManagement: hasIncidentManagement,
        hasWorkflows: true,
        hasVersions: hasVersions,
        hasComponents: hasComponents,
        hasPermissions: true,
        hasIssueSecurity: true,
        hasNotifications: true,
        hasIssueCollectors: true,
        hasProjectAutomation: hasProjectAutomation,
        hasDevtools: hasActiveSoftwareAccess && isProjectAdmin,
        hasExternalLinks: hasExternalLinks,
        hasServices: hasServices,
        hasCustomerSupportManagement: hasCustomerSupportManagement,
        hasProductsAndEntitlements: hasProductsAndEntitlements,
        hasDeveloperEscalation: hasDeveloperEscalation,
        hasVirtualAgent: (0, $4R6GH.fg)('jcs_master_flag') ? hasVirtualAgent : true,
        hasLanguageSupport: (0, $4R6GH.fg)('jcs_master_flag') ? hasLanguageSupport : true,
        hasForms: (0, $4R6GH.fg)('jcs_master_flag') ? hasForms : true,
        hasFields: isProjectOrJiraAdmin,
        hasChannelsAndSelfService: (0, $4R6GH.fg)('jcs_master_flag') ? hasChannelsAndSelfService : true
    };
};
const $d21447ab73114105$export$d334c13580163a89 = (navData)=>{
    let hasFields = false;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    if (expConfig.get('isEnabled', false)) {
        const { permissionInfo: permissionInfo, hasExplicitFieldAssociationsEnabled: hasExplicitFieldAssociationsEnabled = false } = navData;
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
        const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
        const isProjectOrJiraAdmin = isAdmin || isProjectAdmin;
        hasFields = isProjectOrJiraAdmin && hasExplicitFieldAssociationsEnabled;
    }
    return {
        hasExternalLinks: navData?.settingsInfo?.hasExternalLinks,
        hasChat: navData?.settingsInfo?.hasChat,
        hasFields: hasFields
    };
};

});




parcelRegister("4eEnx", function(module, exports) {

$parcel$export(module.exports, "CustomerSupportManagementItems", () => $49084a6bd16d85da$export$df9ebd1e395a300d);

var $5uXOq = parcelRequire("5uXOq");

var $lSrt8 = parcelRequire("lSrt8");

var $4hqZ5 = parcelRequire("4hqZ5");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $7OqB4 = parcelRequire("7OqB4");

var $y8WG5 = parcelRequire("y8WG5");

var $5QsHM = parcelRequire("5QsHM");

var $lNhbS = parcelRequire("lNhbS");

var $a88Sz = parcelRequire("a88Sz");

var $kIKHM = parcelRequire("kIKHM");
// Do not change this ID, as changing it will cause the spotlight to reappear for customers (Bad UX).
const $49084a6bd16d85da$var$NAVIGATION_NEW_ITEM_ORGANIZATIONS_CHANGEBOARDING_ITEM_KEY = 'navigation-new-item-organizations-changeboarding-seen-status';
const $49084a6bd16d85da$var$useThrowSettingFeatures = (0, $7OqB4.withThrowOnError)((0, $y8WG5.useSettingFeatures));
const $49084a6bd16d85da$export$df9ebd1e395a300d = ({ urlPath: urlPath, isPremiumTenant: // currently not used but can be in the future for premium/non-premium features
// eslint-disable-next-line @typescript-eslint/no-unused-vars
isPremiumTenant })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: settingFeatures } = $49084a6bd16d85da$var$useThrowSettingFeatures();
    const isCustomerSupportManagementEnabled = Boolean(settingFeatures?.hasCustomerSupportManagement);
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: $49084a6bd16d85da$var$NAVIGATION_NEW_ITEM_ORGANIZATIONS_CHANGEBOARDING_ITEM_KEY,
        isSeenValue: true,
        packageName: $lNhbS.packageName,
        teamName: (0, $lNhbS.scimTeamName)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jsm_customers_directory_page_change_boarding') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "organizations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'organizations'
        },
        href: `${urlPath}/organizations`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSrt8))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-organizations',
            'servicedesk-organization-details',
            'servicedesk-organization_v2'
        ]
    }, formatMessage((0, $a88Sz.messages).itemOrganizations))), !hasSeenSpotlight && !isCustomerSupportManagementEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kIKHM.default), {
        onAcknowledge: markSpotlightAsSeen
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'organizations'
        },
        href: `${urlPath}/organizations`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSrt8))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-organizations',
            'servicedesk-organization-details',
            'servicedesk-organization_v2'
        ]
    }, formatMessage((0, $a88Sz.messages).itemOrganizations)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'customers'
        },
        href: `${urlPath}/customers`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-customers-v2'
        ]
    }, formatMessage((0, $a88Sz.messages).itemIndividuals)));
};

});
parcelRegister("lSrt8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c9411407c1f042ec99fb06f89567549>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fed3f2dc0bb9ed52$var$_react = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fed3f2dc0bb9ed52$var$_officeBuilding = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("4bTdk")));

var $fed3f2dc0bb9ed52$var$_officeBuildingFilled = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("e8Dhe")));
function $fed3f2dc0bb9ed52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fed3f2dc0bb9ed52$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $fed3f2dc0bb9ed52$var$_react.default.createElement($fed3f2dc0bb9ed52$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $fed3f2dc0bb9ed52$var$_officeBuildingFilled.default
    }, props));
$fed3f2dc0bb9ed52$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $fed3f2dc0bb9ed52$var$_default = module.exports.default = $fed3f2dc0bb9ed52$var$OfficeBuildingIcon;

});
parcelRegister("4bTdk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30d304d6d8375db3$var$_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $30d304d6d8375db3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;

});

parcelRegister("e8Dhe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4b0479e3879f3a8$var$_react = $a4b0479e3879f3a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a4b0479e3879f3a8$var$_officeBuilding = $a4b0479e3879f3a8$var$_interopRequireDefault((parcelRequire("4bTdk")));
function $a4b0479e3879f3a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon = (props)=>/*#__PURE__*/ $a4b0479e3879f3a8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8z"/><path fill="inherit" d="M6 10h2v2H6zm0 3h2v2H6z"/><path fill="currentcolor" d="M9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/><path fill="inherit" d="M12 7h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/></g></svg>`
    }, props, {
        newIcon: $a4b0479e3879f3a8$var$_officeBuilding.default
    }));
$a4b0479e3879f3a8$var$OfficeBuildingFilledIcon.displayName = 'OfficeBuildingFilledIcon';
var $a4b0479e3879f3a8$var$_default = module.exports.default = $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon;

});


parcelRegister("4hqZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff23a711b4b109cded01cd0a5945034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31ddae7439c341a9$var$_react = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $31ddae7439c341a9$var$_peopleGroup = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("fptva")));

var $31ddae7439c341a9$var$_people = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("h8cgU")));
function $31ddae7439c341a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31ddae7439c341a9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $31ddae7439c341a9$var$_react.default.createElement($31ddae7439c341a9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $31ddae7439c341a9$var$_people.default
    }, props));
$31ddae7439c341a9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $31ddae7439c341a9$var$_default = module.exports.default = $31ddae7439c341a9$var$PeopleGroupIcon;

});

parcelRegister("kIKHM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1aad0bc6e658999$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $lEW6r = parcelRequire("lEW6r");
const $d1aad0bc6e658999$var$NEW_ITEM_ORGANIZATION_NAV_MESSAGE_ID = 'new-item-organization-nav-message';
const $d1aad0bc6e658999$var$ItemOrganizationsSpotlight = ({ onAcknowledge: onAcknowledge })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>onAcknowledge(),
                text: formatMessage((0, $lEW6r.messages).itemOrganizationsSpotlightConfirmButton)
            }
        ],
        heading: formatMessage((0, $lEW6r.messages).itemOrganizationsSpotlightHeading),
        target: "organizations",
        messageType: "engagement",
        messageId: $d1aad0bc6e658999$var$NEW_ITEM_ORGANIZATION_NAV_MESSAGE_ID,
        key: "organizations",
        dialogPlacement: "right bottom",
        scrollPositionBlock: "start",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)"
    }, formatMessage((0, $lEW6r.messages).itemOrganizationsSpotlightBody));
};
var $d1aad0bc6e658999$export$2e2bcd8739ae039 = $d1aad0bc6e658999$var$ItemOrganizationsSpotlight;

});
parcelRegister("lEW6r", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ecf95a3f9bbc8468$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ecf95a3f9bbc8468$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    itemOrganizationsSpotlightHeading: {
        "id": "spa-apps-sidebar-servicedesk.common.ui.customer-support-management-section.item-organizations-spotlight-heading",
        "defaultMessage": "Organizations relocated"
    },
    itemOrganizationsSpotlightBody: {
        "id": "spa-apps-sidebar-servicedesk.common.ui.customer-support-management-section.item-organizations-spotlight-body",
        "defaultMessage": "We've moved organizations from your Customers page."
    },
    itemOrganizationsSpotlightConfirmButton: {
        "id": "spa-apps-sidebar-servicedesk.common.ui.customer-support-management-section.item-organizations-spotlight-confirm-button",
        "defaultMessage": "Got it"
    }
});

});



parcelRegister("1rtJs", function(module, exports) {

$parcel$export(module.exports, "InviteTeamItemNew", () => $f55141158f6da0d7$export$46d2afedbfe2fed8);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3nHDn = parcelRequire("3nHDn");

var $7rViF = parcelRequire("7rViF");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $12hlA = parcelRequire("12hlA");

var $gq0sA = parcelRequire("gq0sA");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $cNd4s = parcelRequire("cNd4s");
const $f55141158f6da0d7$export$46d2afedbfe2fed8 = ({ children: children })=>{
    const [{ data: pageContextData, loading: loading }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext } = pageContextData || {};
    const { projectId: projectId, projectName: projectName, projectKey: projectKey } = projectContext || {};
    const { serviceDesk: jsmEdition } = (0, $k9JTq.useAppEditions)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [isInviteTeamDialogOpen, setIsInviteTeamDialogOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onOpenAddPeopleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsInviteTeamDialogOpen(true);
        (0, $7rViF.fireCoreInvitesInJsmProjectFeatureExposed)(createAnalyticsEvent, (0, $6s1PB.expVal)('jsm_core_invites_experiment', 'cohort', 'not-enrolled'));
    }, [
        setIsInviteTeamDialogOpen,
        createAnalyticsEvent
    ]);
    const onCloseAddPeopleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsInviteTeamDialogOpen(false);
    }, [
        setIsInviteTeamDialogOpen
    ]);
    if (loading) return null;
    return projectId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-navigation-apps-sidebar-servicedesk-core-invites-experience",
        packageName: "jira-navigation-apps-sidebar-servicedesk",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'coreInvitesSideNav'
        },
        onClick: onOpenAddPeopleDialog,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3nHDn))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    }, children), isInviteTeamDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12hlA.default), {
        appEdition: jsmEdition,
        cloudId: cloudId,
        isOpen: isInviteTeamDialogOpen,
        onClose: onCloseAddPeopleDialog,
        projectId: projectId,
        jiraProjectKey: projectKey,
        jiraProjectName: projectName,
        isSiteAdmin: isSiteAdmin
    }));
};

});
parcelRegister("3nHDn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c28ad36bcbed963277bba2e64773578>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27655de63feeadee$var$_react = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $27655de63feeadee$var$_personAdd = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("fvfvk")));

var $27655de63feeadee$var$_inviteTeam = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("ijaND")));
function $27655de63feeadee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAddIcon.
 * This component is PersonAddIcon, with `UNSAFE_fallbackIcon` set to "InviteTeamIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27655de63feeadee$var$PersonAddIcon = (props)=>/*#__PURE__*/ $27655de63feeadee$var$_react.default.createElement($27655de63feeadee$var$_personAdd.default, Object.assign({
        LEGACY_fallbackIcon: $27655de63feeadee$var$_inviteTeam.default
    }, props));
$27655de63feeadee$var$PersonAddIcon.Name = 'PersonAddIconMigration';
var $27655de63feeadee$var$_default = module.exports.default = $27655de63feeadee$var$PersonAddIcon;

});
parcelRegister("fvfvk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b495c71cb30b2c7c$var$_react = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b495c71cb30b2c7c$var$_baseNew = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b495c71cb30b2c7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b495c71cb30b2c7c$var$PersonAddIcon = (props)=>/*#__PURE__*/ $b495c71cb30b2c7c$var$_react.default.createElement($b495c71cb30b2c7c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$b495c71cb30b2c7c$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $b495c71cb30b2c7c$var$_default = module.exports.default = $b495c71cb30b2c7c$var$PersonAddIcon;

});

parcelRegister("ijaND", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d54260e58fec7f9a$var$_react = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d54260e58fec7f9a$var$_personAdd = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("fvfvk")));
function $d54260e58fec7f9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d54260e58fec7f9a$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d54260e58fec7f9a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $d54260e58fec7f9a$var$_personAdd.default
    }));
$d54260e58fec7f9a$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d54260e58fec7f9a$var$_default = module.exports.default = $d54260e58fec7f9a$var$InviteTeamIcon;

});


parcelRegister("7rViF", function(module, exports) {

$parcel$export(module.exports, "fireCoreInvitesInJsmProjectFeatureExposed", () => $19157e19516eca78$export$4ae66d6e56a5cb11);

var $8zOmE = parcelRequire("8zOmE");
const $19157e19516eca78$export$4ae66d6e56a5cb11 = (createAnalyticsEvent, coreInvitesJsmExpValue)=>{
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'jsm_core_invites_experiment',
        cohort: coreInvitesJsmExpValue
    });
};

});


parcelRegister("ccoXC", function(module, exports) {

$parcel$export(module.exports, "InviteTeamItem", () => $3ff8ba3a3539b57e$export$666dcae17d5c3c30);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ijaND = parcelRequire("ijaND");

var $1I7E8 = parcelRequire("1I7E8");

var $eZJjh = parcelRequire("eZJjh");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $bFK4M = parcelRequire("bFK4M");

var $lOkV6 = parcelRequire("lOkV6");

var $gq0sA = parcelRequire("gq0sA");

var $20mDG = parcelRequire("20mDG");

var $fswC9 = parcelRequire("fswC9");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3ff8ba3a3539b57e$var$PopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ff8ba3a3539b57e$var$InviteTeamDialogWrapper, {
        ...props,
        ref: ref
    }));
const $3ff8ba3a3539b57e$var$POPUP_OFFSET = [
    0,
    0
];
const $3ff8ba3a3539b57e$var$entryPointParams = {};
const $3ff8ba3a3539b57e$export$666dcae17d5c3c30 = ({ children: children, InviteTeamIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
InviteTeamIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ijaND))), Popup: Popup = (0, $1I7E8.default), useInviteTeamDialog: useInviteTeamDialog = (0, $lOkV6.useInviteTeamDialog), usePageContext: usePageContext = (0, $gq0sA.usePageContext), loadEntryPointResource: loadEntryPointResource = false })=>{
    const [{ data: pageContextData }] = usePageContext();
    const { serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { userRole: userRole } = serviceDeskContext || {};
    const [{ isInviteTeamDialogOpen: isInviteTeamDialogOpen }, { setOnDialogUpdated: setOnDialogUpdated, setIsInviteTeamDialogOpen: setIsInviteTeamDialogOpen }] = useInviteTeamDialog();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $bFK4M.inviteDialogEntryPoint), $3ff8ba3a3539b57e$var$entryPointParams);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isInviteTeamDialogOpen);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        loadEntryPointResource && entryPointActions.load();
    }, [
        loadEntryPointResource,
        entryPointActions
    ]);
    const PopupTrigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fswC9.InviteTeamDialogTriggerWithRef), {
            ...props,
            InviteTeamIcon: InviteTeamIcon,
            ref: (element)=>{
                triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                props.ref(element);
            },
            isInviteTeamDialogOpen: isInviteTeamDialogOpen,
            setIsInviteTeamDialogOpen: setIsInviteTeamDialogOpen
        }, children), [
        InviteTeamIcon,
        children,
        isInviteTeamDialogOpen,
        setIsInviteTeamDialogOpen,
        triggerRef
    ]);
    const Content = (0, $5uXOq.useCallback)(({ update: onDialogUpdated })=>{
        setOnDialogUpdated(onDialogUpdated);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "async-servicedesk-invite-team-dialog-experience",
            packageName: "jiraServicedeskInviteTeamService",
            runtimeProps: {},
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ff8ba3a3539b57e$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "large"
            }))
        });
    }, [
        setOnDialogUpdated,
        entryPointReferenceSubject
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsInviteTeamDialogOpen(false);
    }, [
        setIsInviteTeamDialogOpen
    ]);
    if (userRole !== (0, $20mDG.USER_JSM_PROJECT_ROLE).AGENT_PROJECT_ADMIN_ROLE) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PopupTrigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Popup, {
        isOpen: isInviteTeamDialogOpen,
        onClose: onClose,
        placement: "right",
        content: Content,
        trigger: PopupTrigger,
        offset: $3ff8ba3a3539b57e$var$POPUP_OFFSET,
        popupComponent: $3ff8ba3a3539b57e$var$PopupComponent
    });
};
const $3ff8ba3a3539b57e$var$backgroundColor = "var(--ds-surface-overlay, #FFFFFF)";
const $3ff8ba3a3539b57e$var$textColor = "var(--ds-text, #172B4D)";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ff8ba3a3539b57e$var$InviteTeamDialogWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71bhr _2rko1l7b _syaz1fxt _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb _1bsb1to9 _1pbyowjs _vchhusvi _16qs1cd0 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $3ff8ba3a3539b57e$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _1tke13lo _qdr01h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $1be876415a945060$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) return null;
    return entryPointReference;
};

});

parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});
parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1tcYS = parcelRequire("1tcYS");

var $bFU4G = parcelRequire("bFU4G");

var $8Ec39 = parcelRequire("8Ec39");

var $cEm1b = parcelRequire("cEm1b");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $1tcYS.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $bFU4G.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $bFU4G.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEm1b.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ec39.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});



parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jp5kW = parcelRequire("jp5kW");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const timer = (0, $5uXOq.useRef)();
    const removeInactiveLoadsIdleCallback = (0, $5uXOq.useRef)(null);
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) {
            // Delay clean up to prioritise render cycle in case
            // prior queries get used again
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            removeInactiveLoadsIdleCallback.current = $d6e83c6db8fa388b$var$callWhenIdle(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
            });
        } else // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $d6e83c6db8fa388b$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $d6e83c6db8fa388b$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const unsub = (0, $5uXOq.useRef)(null);
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($011b3d8d407c2901$var$isReactAsyncJSResourceReference(entryPoint?.root) && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
            if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $011b3d8d407c2901$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("bFK4M", function(module, exports) {

$parcel$export(module.exports, "inviteDialogEntryPoint", () => $dddd8fbf7b96ff6e$export$7afb133c38f2f0b8);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $dddd8fbf7b96ff6e$export$7afb133c38f2f0b8 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("h0zBY")), {
        moduleId: "ee1547d0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("h0zBY", function(module, exports) {

let $c61e0f745a6e9b40$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c61e0f745a6e9b40$var$load("hPzOn"),
    $c61e0f745a6e9b40$var$load("hFtxf")
]).then(()=>parcelRequire('36XMr'));

});


parcelRegister("20mDG", function(module, exports) {

$parcel$export(module.exports, "USER_JSM_PROJECT_ROLE", () => $9a4dc3177f5f851e$export$a9054e41660c4d00);
const $9a4dc3177f5f851e$var$AGENT_ROLE = 'agent';
const $9a4dc3177f5f851e$var$AGENT_PROJECT_ADMIN_ROLE = 'agent-project-admin';
const $9a4dc3177f5f851e$var$JIRA_ROLE = 'jira-user';
const $9a4dc3177f5f851e$export$a9054e41660c4d00 = {
    AGENT_ROLE: $9a4dc3177f5f851e$var$AGENT_ROLE,
    AGENT_PROJECT_ADMIN_ROLE: $9a4dc3177f5f851e$var$AGENT_PROJECT_ADMIN_ROLE,
    JIRA_ROLE: $9a4dc3177f5f851e$var$JIRA_ROLE
};

});

parcelRegister("fswC9", function(module, exports) {

$parcel$export(module.exports, "InviteTeamDialogTriggerWithRef", () => $702881781d29c8de$export$29c59a79e62a22e9);

var $5uXOq = parcelRequire("5uXOq");

var $k0ZZ2 = parcelRequire("k0ZZ2");
const $702881781d29c8de$export$29c59a79e62a22e9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        ...props,
        analytics: {
            itemId: 'invite-team'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.InviteTeamIcon, {
            label: ""
        }),
        isSelected: props.isInviteTeamDialogOpen,
        onClick: ()=>{
            props.setIsInviteTeamDialogOpen(!props.isInviteTeamDialogOpen);
        },
        ref: ref,
        testId: "navigation-apps-sidebar-servicedesk.common.ui.invite-team-item.invite-team-dialog-trigger.menu-item"
    }, props.children));

});


parcelRegister("3wBTQ", function(module, exports) {

$parcel$export(module.exports, "KnowledgeItem", () => $39566683c509d03c$export$5fe179562f470ba6);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8JcnB = parcelRequire("8JcnB");

var $hYRTO = parcelRequire("hYRTO");

var $eZJjh = parcelRequire("eZJjh");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $kZj7F = parcelRequire("kZj7F");

var $3SzZi = parcelRequire("3SzZi");

var $4OCke = parcelRequire("4OCke");

var $b71gk = parcelRequire("b71gk");

var $etiBx = parcelRequire("etiBx");

var $4R6GH = parcelRequire("4R6GH");

var $bzFSU = parcelRequire("bzFSU");

var $koeKL = parcelRequire("koeKL");

var $lNhbS = parcelRequire("lNhbS");

var $jiEb9 = parcelRequire("jiEb9");

var $d82Tb = parcelRequire("d82Tb");
const $39566683c509d03c$export$5fe179562f470ba6 = ({ KnowledgeBaseHubIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
KnowledgeBaseHubIcon = (0, (/*@__PURE__*/$parcel$interopDefault($8JcnB))), KnowledgeHubMenu: KnowledgeHubMenu = (0, $jiEb9.KnowledgeHubMenu), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), NestingMenuItem: NestingMenuItem = (0, $kZj7F.NestingMenuItem), matchPartialUrlPathname: matchPartialUrlPathname = (0, $4OCke.matchPartialUrlPathname), href: href, nestingId: nestingId, overrides: overrides, stack: stack, type: type, useIntl: useIntl = (0, $aWse0.useIntlV2) })=>{
    const { formatMessage: formatMessage } = useIntl();
    if ((0, $3SzZi.shouldRenderNesting)(type === (0, $lNhbS.KNOWLEDGE_HUB_NESTED_TYPE), stack, nestingId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NestingMenuItem, {
        analytics: {
            itemId: 'knowledge-hub-nested'
        },
        href: href,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeBaseHubIcon, {
            label: ""
        }),
        id: nestingId,
        overrides: overrides,
        selectedOn: matchPartialUrlPathname(),
        title: formatMessage((0, $d82Tb.messages).itemKnowledgeBaseHub)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "SideNavigationKnowledge",
        packageName: "jira-navigation-apps-sidebar-servicedesk"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($39566683c509d03c$export$97de9d30d762e044, {
        KnowledgeHubMenu: KnowledgeHubMenu,
        href: href
    })));
    if (type === (0, $lNhbS.KNOWLEDGE_HUB_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'knowledge-hub'
        },
        selectedOn: matchPartialUrlPathname(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeBaseHubIcon, {
            label: ""
        }),
        href: href
    }, formatMessage((0, $d82Tb.messages).itemKnowledgeBase));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'knowledge-base'
        },
        selectedOn: matchPartialUrlPathname(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeBaseHubIcon, {
            label: ""
        }),
        href: href
    }, formatMessage((0, $d82Tb.messages).itemKnowledgeBase));
};
const $39566683c509d03c$export$97de9d30d762e044 = ({ href: href, KnowledgeHubMenu: KnowledgeHubMenu })=>{
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $etiBx.default));
    const cloudId = (0, $koeKL.useCloudId)();
    const container = (0, $bzFSU.useContainerAri)();
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            cloudId: cloudId,
            container: container,
            isEnabled: (0, $4R6GH.fg)('kb-cross-site-enabled') || (0, $4R6GH.fg)('3p-integration-enabled_t5ysh')
        });
    }, [
        loadQuery,
        cloudId,
        container
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "SideNavigationKnowledgeItem",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeHubMenu, {
        basePath: href,
        queryReference: queryReference
    }) : null);
};

});
parcelRegister("8JcnB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65ac210680010c0a$var$_react = $65ac210680010c0a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $65ac210680010c0a$var$_bookWithBookmark = $65ac210680010c0a$var$_interopRequireDefault((parcelRequire("h9rhI")));
function $65ac210680010c0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $65ac210680010c0a$var$BookIcon = (props)=>/*#__PURE__*/ $65ac210680010c0a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 6.002v9.996c0 .546.446 1.002.995 1.002h8.01c.54 0 .995-.449.995-1.002V6.002C17 5.456 16.554 5 16.005 5h-8.01C7.455 5 7 5.449 7 6.002m-2 0A3.005 3.005 0 0 1 7.995 3h8.01A3.003 3.003 0 0 1 19 6.002v9.996A3.005 3.005 0 0 1 16.005 19h-8.01A3.003 3.003 0 0 1 5 15.998z"/><path d="M9 7h6v4H9zm0 6h6v2H9zm1 7.86V20H7v.86L8.5 20zM7 18h3v2H7z"/></g></svg>`
    }, props, {
        newIcon: $65ac210680010c0a$var$_bookWithBookmark.default
    }));
$65ac210680010c0a$var$BookIcon.displayName = 'BookIcon';
var $65ac210680010c0a$var$_default = module.exports.default = $65ac210680010c0a$var$BookIcon;

});
parcelRegister("h9rhI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7c8712306b53637$var$_react = $c7c8712306b53637$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7c8712306b53637$var$_baseNew = $c7c8712306b53637$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c7c8712306b53637$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7c8712306b53637$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $c7c8712306b53637$var$_react.default.createElement($c7c8712306b53637$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$c7c8712306b53637$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $c7c8712306b53637$var$_default = module.exports.default = $c7c8712306b53637$var$BookWithBookmarkIcon;

});


parcelRegister("etiBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c65f1cac8c7ad13a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<83473b882cebebf3a3d271e8a8d1c7fb>>
 * @relayHash e8bdd087745c04953d57f1c1345e6a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a22d0ca655cf4288f757f976fb178eb41f2f12035fd04dc15fd5ee0d49d43033
const $c65f1cac8c7ad13a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "container"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEnabled"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "container",
            "variableName": "container"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "sourceType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSideNavKBTypeCheckerQuery",
            "selections": [
                {
                    "condition": "isEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "KnowledgeBaseQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBase",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "KnowledgeBaseSourceEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edge",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "KnowledgeBaseSource",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v6 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "knowledgeBase.knowledgeBase.edge.node.sourceType"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "knowledgeBase.knowledgeBase.edge"
                                                }
                                            ],
                                            "type": "KnowledgeBaseSources"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSideNavKBTypeCheckerQuery",
            "selections": [
                {
                    "condition": "isEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "KnowledgeBaseQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBase",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeBaseSourceEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "KnowledgeBaseSource",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeBaseSources"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a22d0ca655cf4288f757f976fb178eb41f2f12035fd04dc15fd5ee0d49d43033",
            "metadata": {},
            "name": "mainSideNavKBTypeCheckerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c65f1cac8c7ad13a$var$node.hash = "08ff2357eb14da4040baeb3029f7c34a";
var $c65f1cac8c7ad13a$export$2e2bcd8739ae039 = $c65f1cac8c7ad13a$var$node;

});

parcelRegister("bzFSU", function(module, exports) {

$parcel$export(module.exports, "useContainerAri", () => $0787e19ae54403b2$export$fa482684d80284db);

var $5uXOq = parcelRequire("5uXOq");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $gq0sA = parcelRequire("gq0sA");
const $0787e19ae54403b2$export$fa482684d80284db = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext } = pageContextData || {};
    return (0, $5uXOq.useMemo)(()=>{
        return (0, $dXq4S.createAri)({
            cloudId: cloudId,
            resourceId: projectContext?.projectId?.toString() ?? '',
            resourceType: 'project',
            resourceOwner: 'jira'
        });
    }, [
        cloudId,
        projectContext?.projectId
    ]);
};

});

parcelRegister("jiEb9", function(module, exports) {

$parcel$export(module.exports, "KnowledgeHubMenu", () => $367de3fee9e5a1d9$export$525324bc39d88570);

var $etiBx = parcelRequire("etiBx");

var $5uXOq = parcelRequire("5uXOq");

var $2Zxiy = parcelRequire("2Zxiy");

var $8Uumt = parcelRequire("8Uumt");

var $99M5v = parcelRequire("99M5v");

var $gjTBi = parcelRequire("gjTBi");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $16T6Y = parcelRequire("16T6Y");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $kvQS7 = parcelRequire("kvQS7");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $4OCke = parcelRequire("4OCke");

var $2WqFA = parcelRequire("2WqFA");

var $2NMNM = parcelRequire("2NMNM");

var $lw2HC = parcelRequire("lw2HC");

var $gq0sA = parcelRequire("gq0sA");

var $jt2Om = parcelRequire("jt2Om");

var $d82Tb = parcelRequire("d82Tb");

var $3gVb1 = parcelRequire("3gVb1");
const $367de3fee9e5a1d9$export$525324bc39d88570 = ({ basePath: basePath, queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ data: suggestedTopics, error: error, loading: loading }, { fetchSuggestedTopics: fetchSuggestedTopics }] = (0, $jt2Om.useSuggestedTopics)();
    const [isTopicsFiltered] = (0, $jt2Om.useIsTopicsFiltered)();
    const checkIsTopicsFiltered = (0, $4R6GH.fg)('suggested_topics_eap') ? isTopicsFiltered : true;
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
    const { projectId: projectId } = projectContext || {};
    const analyticsEvent = createAnalyticsEvent({});
    const activationId = tenantContext?.activationId || '';
    const [{ categories: categories, isCategoriesSupported: isCategoriesSupported }, { reorderCategories: onCategoryReorder, fetchCategories: fetchCategories }] = (0, $lw2HC.useCategoriesData)();
    (0, $5uXOq.useEffect)(()=>{
        projectId && fetchCategories(projectId, createAnalyticsEvent({}), activationId);
    }, [
        projectId,
        fetchCategories,
        createAnalyticsEvent,
        activationId
    ]);
    const [, { setCreateCategoryDisplay: openCreateCategory }] = (0, $kvQS7.useKbCreateCategoryActions)();
    const { data: isAdminHubAIEnabled, fetchAIEnablement: fetchAIEnablement } = (0, $2WqFA.default)('jira-servicedesk');
    const showSuggestedTopics = (0, $4R6GH.fg)('suggested_topics_eap') ? !loading && !error && isAdminHubAIEnabled : (0, $4R6GH.fg)('jsm-suggested-articles-in-kb');
    (0, $5uXOq.useEffect)(()=>{
        (0, $4R6GH.fg)('suggested_topics_eap') && fetchAIEnablement();
    }, [
        fetchAIEnablement
    ]);
    (0, $5uXOq.useEffect)(()=>{
        projectId && (0, $4R6GH.fg)('jsm-suggested-articles-in-kb') && fetchSuggestedTopics(projectId, createAnalyticsEvent({}), activationId);
    }, [
        activationId,
        createAnalyticsEvent,
        fetchSuggestedTopics,
        projectId
    ]);
    const knowledgeBaseSourceType = (0, $8Uumt.usePreloadedQuery)((0, $etiBx.default), queryReference);
    const sourceType = knowledgeBaseSourceType?.knowledgeBase?.knowledgeBase?.__typename === 'KnowledgeBaseSources' ? knowledgeBaseSourceType.knowledgeBase.knowledgeBase.edge[0]?.node?.sourceType : null;
    const handleDragEnd = (0, $5uXOq.useCallback)((data)=>{
        const onReorderFailure = ()=>{
            showFlag({
                type: 'error',
                isAutoDismiss: true,
                title: formatMessage((0, $3gVb1.default).reorderFailureTitle),
                description: formatMessage((0, $3gVb1.default).reorderFailureDescription),
                messageId: 'navigation-apps-sidebar-servicedesk.common.ui.knowledge-item.hub-menu.show-flag.error',
                messageType: 'transactional'
            });
        };
        const onReorderMismatch = ()=>{
            showFlag({
                type: 'success',
                isAutoDismiss: true,
                title: formatMessage((0, $3gVb1.default).reorderMismatchTitle),
                description: (0, $3gVb1.default).reorderMismatchDescription.defaultMessage,
                messageId: 'navigation-apps-sidebar-servicedesk.common.ui.knowledge-item.hub-menu.show-flag.success',
                messageType: 'transactional'
            });
        };
        if (data && data.source && data.destination) {
            if (projectId) onCategoryReorder(projectId, data.source.index, data.destination.index, analyticsEvent, activationId, onReorderMismatch, onReorderFailure);
        }
    }, [
        showFlag,
        formatMessage,
        projectId,
        onCategoryReorder,
        analyticsEvent,
        activationId
    ]);
    const renderArticles = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'articles'
            },
            href: `${basePath}/articles`,
            selectedOn: [
                'knowledge-hub-browse-all-articles'
            ]
        }, formatMessage((0, $d82Tb.messages).allArticles));
    }, [
        basePath,
        formatMessage
    ]);
    const renderDrafts = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'drafts'
            },
            href: `${basePath}/drafts`,
            selectedOn: [
                'knowledge-hub-drafts'
            ]
        }, formatMessage((0, $d82Tb.messages).drafts));
    }, [
        basePath,
        formatMessage
    ]);
    const renderSuggestedTopics = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'suggested topics'
            },
            href: `${basePath}/suggested-topics`,
            selectedOn: [
                'knowledge-hub-suggested-topics'
            ]
        }, formatMessage((0, $d82Tb.messages).suggestedTopics), checkIsTopicsFiltered && !error && !loading && suggestedTopics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $367de3fee9e5a1d9$var$BadgeStyles,
            as: "span",
            "data-testId": "navigation-apps-sidebar-servicedesk.common.ui.knowledge-item.hub-menu.suggested-topics-badge"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, suggestedTopics.length)));
    }, [
        basePath,
        checkIsTopicsFiltered,
        error,
        formatMessage,
        loading,
        suggestedTopics.length
    ]);
    const renderCategoriesList = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
            title: formatMessage((0, $d82Tb.messages).categories),
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.DragDropContext), {
            onDragEnd: handleDragEnd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Droppable), {
            droppableId: "categories"
        }, ({ innerRef: droppableRef, droppableProps: droppableProps, placeholder: placeholder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: droppableRef,
                ...droppableProps
            }, categories.map((category, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Draggable), {
                    disableInteractiveElementBlocking: true,
                    key: String(category.id),
                    draggableId: String(category.id),
                    index: index
                }, ({ innerRef: innerRef, dragHandleProps: dragHandleProps, draggableProps: draggableProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
                        analytics: {
                            itemId: `category-${String(category.id)}`
                        },
                        href: `${basePath}/categories/${String(category.id)}`,
                        ref: innerRef,
                        selectedOn: (0, $4OCke.matchUrlPathname)(),
                        ...dragHandleProps,
                        ...draggableProps
                    }, category.name))), placeholder))));
    }, [
        basePath,
        categories,
        formatMessage,
        handleDragEnd
    ]);
    const renderNewCategory = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'new-category'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: ()=>openCreateCategory(true)
        }, formatMessage((0, $d82Tb.messages).newCategory)));
    }, [
        formatMessage,
        openCreateCategory
    ]);
    const allowedSourceTypes = [
        'NATIVE_CONFLUENCE',
        'SERVER_CONFLUENCE'
    ];
    const isDraftsAndCategoriesAllowed = ()=>{
        if ((0, $4R6GH.fg)('kb-cross-site-enabled') || (0, $4R6GH.fg)('3p-integration-enabled_t5ysh')) {
            if (sourceType && allowedSourceTypes.includes(sourceType)) return true;
            return false;
        }
        return true;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $d82Tb.messages).heading))), isDraftsAndCategoriesAllowed() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, renderArticles(), (0, $4R6GH.fg)('jsm-suggested-topics-reorder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showSuggestedTopics && renderSuggestedTopics(), renderDrafts()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderDrafts(), showSuggestedTopics && renderSuggestedTopics())), isCategoriesSupported && categories.length > 0 ? renderCategoriesList() : null, isCategoriesSupported ? renderNewCategory() : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, renderArticles(), showSuggestedTopics && renderSuggestedTopics()));
};
const $367de3fee9e5a1d9$var$BadgeStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.150'
});

});
parcelRegister("2Zxiy", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", () => $22db1ba098eb3017$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $22db1ba098eb3017$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $22db1ba098eb3017$export$423ec2075359570a);

var $5uXOq = parcelRequire("5uXOq");

var $3YMLK = parcelRequire("3YMLK");

var $1AwyE = parcelRequire("1AwyE");

var $gzM5u = parcelRequire("gzM5u");

var $22j3V = parcelRequire("22j3V");
parcelRequire("i6AsN");
var $AuRrZ = parcelRequire("AuRrZ");
var $9bdMd = parcelRequire("9bdMd");

var $3YKxB = parcelRequire("3YKxB");

var $g7psY = parcelRequire("g7psY");

var $i2aN7 = parcelRequire("i2aN7");

var $cs3hJ = parcelRequire("cs3hJ");

var $7qpjg = parcelRequire("7qpjg");

var $3BSY2 = parcelRequire("3BSY2");

var $4iZOV = parcelRequire("4iZOV");

var $7nsd3 = parcelRequire("7nsd3");

var $1DIXK = parcelRequire("1DIXK");
var $22db1ba098eb3017$var$isProduction = true;
var $22db1ba098eb3017$var$spacesAndTabs = /[ \t]{2,}/g;
var $22db1ba098eb3017$var$lineStartWithSpaces = /^[ \t]*/gm;
var $22db1ba098eb3017$var$clean = function clean(value) {
    return value.replace($22db1ba098eb3017$var$spacesAndTabs, ' ').replace($22db1ba098eb3017$var$lineStartWithSpaces, '').trim();
};
var $22db1ba098eb3017$var$getDevMessage = function getDevMessage(message) {
    return $22db1ba098eb3017$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $22db1ba098eb3017$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $22db1ba098eb3017$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $22db1ba098eb3017$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $22db1ba098eb3017$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $22db1ba098eb3017$var$log(type, message) {
    var _console;
    if ($22db1ba098eb3017$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$22db1ba098eb3017$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $22db1ba098eb3017$var$getFormattedMessage(message));
}
var $22db1ba098eb3017$var$warning = $22db1ba098eb3017$var$log.bind(null, 'warn');
var $22db1ba098eb3017$var$error = $22db1ba098eb3017$var$log.bind(null, 'error');
function $22db1ba098eb3017$var$noop() {}
function $22db1ba098eb3017$var$getOptions(shared, fromBinding) {
    return (0, $gzM5u.default)({}, shared, fromBinding);
}
function $22db1ba098eb3017$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $22db1ba098eb3017$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $22db1ba098eb3017$var$isProduction$1 = true;
var $22db1ba098eb3017$var$prefix = 'Invariant failed';
function $22db1ba098eb3017$var$RbdInvariant(message) {
    this.message = message;
}
$22db1ba098eb3017$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $22db1ba098eb3017$var$invariant(condition, message) {
    if (condition) return;
    if ($22db1ba098eb3017$var$isProduction$1) throw new $22db1ba098eb3017$var$RbdInvariant($22db1ba098eb3017$var$prefix);
    else throw new $22db1ba098eb3017$var$RbdInvariant($22db1ba098eb3017$var$prefix + ": " + (message || ''));
}
var $22db1ba098eb3017$var$ErrorBoundary = function(_React$Component) {
    (0, $1AwyE.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $22db1ba098eb3017$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $22db1ba098eb3017$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $22db1ba098eb3017$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $22db1ba098eb3017$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
var $22db1ba098eb3017$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $22db1ba098eb3017$var$position = function position(index) {
    return index + 1;
};
var $22db1ba098eb3017$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $22db1ba098eb3017$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $22db1ba098eb3017$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $22db1ba098eb3017$var$position(source.index);
    var endPosition = $22db1ba098eb3017$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $22db1ba098eb3017$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $22db1ba098eb3017$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $22db1ba098eb3017$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $22db1ba098eb3017$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $22db1ba098eb3017$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $22db1ba098eb3017$var$position(source.index) + "\n";
};
var $22db1ba098eb3017$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $22db1ba098eb3017$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $22db1ba098eb3017$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $22db1ba098eb3017$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $22db1ba098eb3017$var$returnedToStart(result.source) + "\n  ";
};
var $22db1ba098eb3017$var$preset = {
    liftInstruction: $22db1ba098eb3017$var$liftInstruction,
    onDragStart: $22db1ba098eb3017$var$onDragStart,
    onDragUpdate: $22db1ba098eb3017$var$onDragUpdate,
    onDragEnd: $22db1ba098eb3017$var$onDragEnd
};
var $22db1ba098eb3017$var$origin = {
    x: 0,
    y: 0
};
var $22db1ba098eb3017$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $22db1ba098eb3017$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $22db1ba098eb3017$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $22db1ba098eb3017$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $22db1ba098eb3017$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $22db1ba098eb3017$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $22db1ba098eb3017$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $22db1ba098eb3017$var$distance(target, point);
    }));
};
var $22db1ba098eb3017$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $22db1ba098eb3017$var$executeClip = function(frame, subject) {
    var result = (0, $3YKxB.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $22db1ba098eb3017$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $22db1ba098eb3017$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $22db1ba098eb3017$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $22db1ba098eb3017$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $22db1ba098eb3017$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $22db1ba098eb3017$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $gzM5u.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $22db1ba098eb3017$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $22db1ba098eb3017$var$executeClip(frame.pageMarginBox, target);
    return (0, $3YKxB.getRect)(target);
};
var $22db1ba098eb3017$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $22db1ba098eb3017$var$scroll(page.marginBox, frame);
    var increased = $22db1ba098eb3017$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $22db1ba098eb3017$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $22db1ba098eb3017$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $22db1ba098eb3017$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $22db1ba098eb3017$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $22db1ba098eb3017$var$negate(scrollDiff);
    var frame = (0, $gzM5u.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $gzM5u.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $22db1ba098eb3017$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($i2aN7)))(map);
}
function $22db1ba098eb3017$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $22db1ba098eb3017$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $22db1ba098eb3017$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $22db1ba098eb3017$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $22db1ba098eb3017$var$toDroppableMap = (0, $g7psY.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $22db1ba098eb3017$var$toDraggableMap = (0, $g7psY.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $22db1ba098eb3017$var$toDroppableList = (0, $g7psY.default)(function(droppables) {
    return $22db1ba098eb3017$var$values(droppables);
});
var $22db1ba098eb3017$var$toDraggableList = (0, $g7psY.default)(function(draggables) {
    return $22db1ba098eb3017$var$values(draggables);
});
var $22db1ba098eb3017$var$getDraggablesInsideDroppable = (0, $g7psY.default)(function(droppableId, draggables) {
    var result = $22db1ba098eb3017$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $22db1ba098eb3017$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $22db1ba098eb3017$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $22db1ba098eb3017$var$removeDraggableFromList = (0, $g7psY.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $22db1ba098eb3017$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $22db1ba098eb3017$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $gzM5u.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $22db1ba098eb3017$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $22db1ba098eb3017$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $22db1ba098eb3017$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $22db1ba098eb3017$var$noDisplacedBy = {
    point: $22db1ba098eb3017$var$origin,
    value: 0
};
var $22db1ba098eb3017$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $22db1ba098eb3017$var$noImpact = {
    displaced: $22db1ba098eb3017$var$emptyGroups,
    displacedBy: $22db1ba098eb3017$var$noDisplacedBy,
    at: null
};
var $22db1ba098eb3017$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $22db1ba098eb3017$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $22db1ba098eb3017$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $22db1ba098eb3017$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $22db1ba098eb3017$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $22db1ba098eb3017$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $22db1ba098eb3017$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $22db1ba098eb3017$var$origin;
    return $22db1ba098eb3017$var$offsetByPosition(target, displacement);
};
var $22db1ba098eb3017$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $22db1ba098eb3017$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $22db1ba098eb3017$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $22db1ba098eb3017$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $22db1ba098eb3017$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $22db1ba098eb3017$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $22db1ba098eb3017$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame
    }));
};
var $22db1ba098eb3017$var$isTotallyVisible = function isTotallyVisible(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isTotallyVisibleThroughFrame
    }));
};
var $22db1ba098eb3017$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $22db1ba098eb3017$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $22db1ba098eb3017$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $3YKxB.getRect)((0, $3YKxB.expand)(marginBox, expandBy));
}
function $22db1ba098eb3017$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $22db1ba098eb3017$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $22db1ba098eb3017$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $22db1ba098eb3017$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $22db1ba098eb3017$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $22db1ba098eb3017$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $22db1ba098eb3017$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $22db1ba098eb3017$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $22db1ba098eb3017$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $22db1ba098eb3017$var$isHomeOf(draggable, destination);
    if (index == null) return $22db1ba098eb3017$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $22db1ba098eb3017$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $22db1ba098eb3017$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $22db1ba098eb3017$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $22db1ba098eb3017$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $22db1ba098eb3017$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $22db1ba098eb3017$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $22db1ba098eb3017$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $22db1ba098eb3017$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $22db1ba098eb3017$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $22db1ba098eb3017$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $22db1ba098eb3017$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $22db1ba098eb3017$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($22db1ba098eb3017$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $22db1ba098eb3017$var$origin : $22db1ba098eb3017$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $22db1ba098eb3017$var$origin;
};
var $22db1ba098eb3017$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
    !combine && $22db1ba098eb3017$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $22db1ba098eb3017$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $22db1ba098eb3017$var$add(center, displaceBy);
};
var $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $22db1ba098eb3017$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $22db1ba098eb3017$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $22db1ba098eb3017$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $22db1ba098eb3017$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $22db1ba098eb3017$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveInto.contentBox[axis.start] + $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $22db1ba098eb3017$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $22db1ba098eb3017$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($22db1ba098eb3017$var$didStartAfterCritical(closestAfter, afterCritical)) return $22db1ba098eb3017$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $3YKxB.offset)(closest.page, displacedBy.point);
        return $22db1ba098eb3017$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($22db1ba098eb3017$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $3YKxB.offset)(last.page, $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point));
        return $22db1ba098eb3017$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $22db1ba098eb3017$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $22db1ba098eb3017$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $22db1ba098eb3017$var$add(point, frame.scroll.diff.displacement);
};
var $22db1ba098eb3017$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $22db1ba098eb3017$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $22db1ba098eb3017$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $22db1ba098eb3017$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $22db1ba098eb3017$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $22db1ba098eb3017$var$scrollViewport = function(viewport, newScroll) {
    var diff = $22db1ba098eb3017$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $22db1ba098eb3017$var$negate(diff);
    var frame = (0, $3YKxB.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $22db1ba098eb3017$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $22db1ba098eb3017$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $22db1ba098eb3017$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $22db1ba098eb3017$var$scrollViewport(viewport, $22db1ba098eb3017$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $22db1ba098eb3017$var$scrollDroppable(destination, $22db1ba098eb3017$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: $22db1ba098eb3017$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: $22db1ba098eb3017$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $22db1ba098eb3017$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $gzM5u.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $22db1ba098eb3017$var$withViewportDisplacement = function(viewport, point) {
    return $22db1ba098eb3017$var$add(viewport.scroll.diff.displacement, point);
};
var $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $22db1ba098eb3017$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $22db1ba098eb3017$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $22db1ba098eb3017$var$add(draggable.client.borderBox.center, offset);
};
var $22db1ba098eb3017$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $22db1ba098eb3017$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $22db1ba098eb3017$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $22db1ba098eb3017$var$isTotallyVisibleOnAxis(args) : $22db1ba098eb3017$var$isTotallyVisible(args);
};
var $22db1ba098eb3017$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $22db1ba098eb3017$var$isHomeOf(draggable, destination);
    var impact = $22db1ba098eb3017$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $22db1ba098eb3017$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $22db1ba098eb3017$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $22db1ba098eb3017$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $22db1ba098eb3017$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $22db1ba098eb3017$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $22db1ba098eb3017$var$invariant(false);
    return rect;
};
var $22db1ba098eb3017$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $22db1ba098eb3017$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame(viewport.frame)($22db1ba098eb3017$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $22db1ba098eb3017$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $22db1ba098eb3017$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $22db1ba098eb3017$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $22db1ba098eb3017$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $22db1ba098eb3017$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $22db1ba098eb3017$var$getKnownActive(droppable)[axis.crossAxisStart] === $22db1ba098eb3017$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $22db1ba098eb3017$var$isWithin($22db1ba098eb3017$var$getKnownActive(droppable)[axis.start], $22db1ba098eb3017$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $22db1ba098eb3017$var$getKnownActive(a)[axis.start] - $22db1ba098eb3017$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $22db1ba098eb3017$var$closest(pageBorderBoxCenter, $22db1ba098eb3017$var$getCorners($22db1ba098eb3017$var$getKnownActive(a)));
        var second = $22db1ba098eb3017$var$closest(pageBorderBoxCenter, $22db1ba098eb3017$var$getCorners($22db1ba098eb3017$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $22db1ba098eb3017$var$getKnownActive(a)[axis.start] - $22db1ba098eb3017$var$getKnownActive(b)[axis.start];
    })[0];
};
var $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $22db1ba098eb3017$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $22db1ba098eb3017$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $22db1ba098eb3017$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $22db1ba098eb3017$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $22db1ba098eb3017$var$offsetByPosition(original, $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point)) : original;
};
var $22db1ba098eb3017$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $22db1ba098eb3017$var$isTotallyVisible({
            target: $22db1ba098eb3017$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $22db1ba098eb3017$var$distance(pageBorderBoxCenter, $22db1ba098eb3017$var$withDroppableDisplacement(destination, $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $22db1ba098eb3017$var$distance(pageBorderBoxCenter, $22db1ba098eb3017$var$withDroppableDisplacement(destination, $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $22db1ba098eb3017$var$getDisplacedBy = (0, $g7psY.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $22db1ba098eb3017$var$patch(axis.line, displacement)
    };
});
var $22db1ba098eb3017$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $22db1ba098eb3017$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $22db1ba098eb3017$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $22db1ba098eb3017$var$patch(axis.line, needsToGrowBy);
};
var $22db1ba098eb3017$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $gzM5u.default)({}, frame, {
        scroll: (0, $gzM5u.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $22db1ba098eb3017$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$22db1ba098eb3017$var$isHomeOf(draggable, droppable) && $22db1ba098eb3017$var$invariant(false);
    !!droppable.subject.withPlaceholder && $22db1ba098eb3017$var$invariant(false);
    var placeholderSize = $22db1ba098eb3017$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $22db1ba098eb3017$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $gzM5u.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $22db1ba098eb3017$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $22db1ba098eb3017$var$withMaxScroll(frame, maxScroll);
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $gzM5u.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $22db1ba098eb3017$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $22db1ba098eb3017$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $gzM5u.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $22db1ba098eb3017$var$invariant(false);
    var newFrame = $22db1ba098eb3017$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $gzM5u.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $22db1ba098eb3017$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $22db1ba098eb3017$var$emptyGroups,
            displacedBy: $22db1ba098eb3017$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $22db1ba098eb3017$var$isHomeOf(draggable, destination) ? destination : $22db1ba098eb3017$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $22db1ba098eb3017$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $22db1ba098eb3017$var$emptyGroups,
        index: proposedIndex
    });
};
var $22db1ba098eb3017$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $22db1ba098eb3017$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $22db1ba098eb3017$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $22db1ba098eb3017$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $22db1ba098eb3017$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $22db1ba098eb3017$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $22db1ba098eb3017$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $22db1ba098eb3017$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $22db1ba098eb3017$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $22db1ba098eb3017$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $22db1ba098eb3017$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $22db1ba098eb3017$var$isPositionInFrame(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $22db1ba098eb3017$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $22db1ba098eb3017$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $22db1ba098eb3017$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $22db1ba098eb3017$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $22db1ba098eb3017$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$22db1ba098eb3017$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($22db1ba098eb3017$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $22db1ba098eb3017$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $22db1ba098eb3017$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $22db1ba098eb3017$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $3YKxB.getRect)($22db1ba098eb3017$var$offsetByPosition(rect, point));
};
var $22db1ba098eb3017$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $22db1ba098eb3017$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $22db1ba098eb3017$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $22db1ba098eb3017$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $22db1ba098eb3017$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $22db1ba098eb3017$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $22db1ba098eb3017$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $22db1ba098eb3017$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $22db1ba098eb3017$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $22db1ba098eb3017$var$isHomeOf(draggable, destination)
    });
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $22db1ba098eb3017$var$combineThresholdDivisor = 4;
var $22db1ba098eb3017$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $22db1ba098eb3017$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $22db1ba098eb3017$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $22db1ba098eb3017$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $22db1ba098eb3017$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $22db1ba098eb3017$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $22db1ba098eb3017$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $22db1ba098eb3017$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $22db1ba098eb3017$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $22db1ba098eb3017$var$withDroppableScroll(destination, pageBorderBox);
    return $22db1ba098eb3017$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $22db1ba098eb3017$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $22db1ba098eb3017$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $gzM5u.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $22db1ba098eb3017$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $22db1ba098eb3017$var$whatIsDraggedOver(previousImpact);
    var now = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $22db1ba098eb3017$var$removePlaceholder(lastDroppable);
    return $22db1ba098eb3017$var$patchDroppableMap(droppables, updated);
};
var $22db1ba098eb3017$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $22db1ba098eb3017$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($22db1ba098eb3017$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $22db1ba098eb3017$var$addPlaceholder(droppable, draggable, draggables);
    return $22db1ba098eb3017$var$patchDroppableMap(cleaned, patched);
};
var $22db1ba098eb3017$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $22db1ba098eb3017$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $22db1ba098eb3017$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $22db1ba098eb3017$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $22db1ba098eb3017$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $gzM5u.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $22db1ba098eb3017$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $22db1ba098eb3017$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $gzM5u.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $22db1ba098eb3017$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $22db1ba098eb3017$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $22db1ba098eb3017$var$getDraggables$1(last.all, draggables);
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $gzM5u.default)({}, impact, {
        displaced: displaced
    });
};
var $22db1ba098eb3017$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $22db1ba098eb3017$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $22db1ba098eb3017$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $22db1ba098eb3017$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $22db1ba098eb3017$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $22db1ba098eb3017$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $22db1ba098eb3017$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $22db1ba098eb3017$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $22db1ba098eb3017$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $22db1ba098eb3017$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $22db1ba098eb3017$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $22db1ba098eb3017$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $22db1ba098eb3017$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $22db1ba098eb3017$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $22db1ba098eb3017$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $22db1ba098eb3017$var$records = {};
var $22db1ba098eb3017$var$isEnabled = false;
var $22db1ba098eb3017$var$isTimingsEnabled = function isTimingsEnabled() {
    return $22db1ba098eb3017$var$isEnabled;
};
var $22db1ba098eb3017$var$start = function start(key) {
    var now;
};
var $22db1ba098eb3017$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $22db1ba098eb3017$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $3YKxB.offset)(draggable.client, offset$1);
    var page = (0, $3YKxB.withScroll)(client, initialWindowScroll);
    var moved = (0, $gzM5u.default)({}, draggable, {
        placeholder: (0, $gzM5u.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $22db1ba098eb3017$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $22db1ba098eb3017$var$invariant(false);
    return frame;
};
var $22db1ba098eb3017$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $22db1ba098eb3017$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $22db1ba098eb3017$var$add(windowScrollChange, droppableScrollChange);
        var moved = $22db1ba098eb3017$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $22db1ba098eb3017$var$timingsKey = 'Processing dynamic changes';
var $22db1ba098eb3017$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $22db1ba098eb3017$var$start($22db1ba098eb3017$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $22db1ba098eb3017$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $gzM5u.default)({}, state.dimensions.droppables, $22db1ba098eb3017$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $22db1ba098eb3017$var$toDraggableMap($22db1ba098eb3017$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $gzM5u.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $22db1ba098eb3017$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $22db1ba098eb3017$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $22db1ba098eb3017$var$finish($22db1ba098eb3017$var$timingsKey);
    var draggingState = (0, $gzM5u.default)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $gzM5u.default)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $22db1ba098eb3017$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $22db1ba098eb3017$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $22db1ba098eb3017$var$patchDimensionMap(state.dimensions, updated);
    if (!$22db1ba098eb3017$var$isSnapping(state) || isEnabledChanging) return $22db1ba098eb3017$var$update({
        state: state,
        dimensions: dimensions
    });
    return $22db1ba098eb3017$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $22db1ba098eb3017$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $gzM5u.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $22db1ba098eb3017$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $22db1ba098eb3017$var$reducer = function(state, action) {
    if (state === void 0) state = $22db1ba098eb3017$var$idle;
    if (action.type === 'FLUSH') return (0, $gzM5u.default)({}, $22db1ba098eb3017$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $22db1ba098eb3017$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.initial),
                offset: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $22db1ba098eb3017$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $22db1ba098eb3017$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
        var _result = (0, $gzM5u.default)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($22db1ba098eb3017$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $22db1ba098eb3017$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $22db1ba098eb3017$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $22db1ba098eb3017$var$scrollDroppable(target, newScroll);
        return $22db1ba098eb3017$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $22db1ba098eb3017$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $22db1ba098eb3017$var$invariant(false);
        var updated = (0, $gzM5u.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $22db1ba098eb3017$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $22db1ba098eb3017$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $22db1ba098eb3017$var$invariant(false);
        var _updated = (0, $gzM5u.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $22db1ba098eb3017$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        !state.isWindowScrollAllowed && $22db1ba098eb3017$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($22db1ba098eb3017$var$isEqual(state.viewport.scroll.current, _newScroll)) return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        var _viewport = $22db1ba098eb3017$var$scrollViewport(state.viewport, _newScroll);
        if ($22db1ba098eb3017$var$isSnapping(state)) return $22db1ba098eb3017$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $22db1ba098eb3017$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$22db1ba098eb3017$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($22db1ba098eb3017$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $gzM5u.default)({}, state.viewport, {
            scroll: (0, $gzM5u.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $gzM5u.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
        var _result2 = $22db1ba098eb3017$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $22db1ba098eb3017$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $22db1ba098eb3017$var$invariant(false);
        var newState = (0, $gzM5u.default)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $22db1ba098eb3017$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $22db1ba098eb3017$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $22db1ba098eb3017$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $22db1ba098eb3017$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $22db1ba098eb3017$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $22db1ba098eb3017$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $22db1ba098eb3017$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $22db1ba098eb3017$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $22db1ba098eb3017$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $22db1ba098eb3017$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $22db1ba098eb3017$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $22db1ba098eb3017$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $22db1ba098eb3017$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $22db1ba098eb3017$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $22db1ba098eb3017$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $22db1ba098eb3017$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $22db1ba098eb3017$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($22db1ba098eb3017$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                dispatch($22db1ba098eb3017$var$flush());
                dispatch($22db1ba098eb3017$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $22db1ba098eb3017$var$validateDimensions(critical, dimensions);
                dispatch($22db1ba098eb3017$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $22db1ba098eb3017$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $22db1ba098eb3017$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $22db1ba098eb3017$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $22db1ba098eb3017$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $22db1ba098eb3017$var$outOfTheWayTiming = $22db1ba098eb3017$var$timings.outOfTheWay + "s " + $22db1ba098eb3017$var$curves.outOfTheWay;
var $22db1ba098eb3017$var$transitions = {
    fluid: "opacity " + $22db1ba098eb3017$var$outOfTheWayTiming,
    snap: "transform " + $22db1ba098eb3017$var$outOfTheWayTiming + ", opacity " + $22db1ba098eb3017$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $22db1ba098eb3017$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $22db1ba098eb3017$var$outOfTheWayTiming,
    placeholder: "height " + $22db1ba098eb3017$var$outOfTheWayTiming + ", width " + $22db1ba098eb3017$var$outOfTheWayTiming + ", margin " + $22db1ba098eb3017$var$outOfTheWayTiming
};
var $22db1ba098eb3017$var$moveTo = function moveTo(offset) {
    return $22db1ba098eb3017$var$isEqual(offset, $22db1ba098eb3017$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $22db1ba098eb3017$var$transforms = {
    moveTo: $22db1ba098eb3017$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $22db1ba098eb3017$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $22db1ba098eb3017$var$combine.scale.drop + ")";
    }
};
var $22db1ba098eb3017$var$minDropTime = $22db1ba098eb3017$var$timings.minDropTime, $22db1ba098eb3017$var$maxDropTime = $22db1ba098eb3017$var$timings.maxDropTime;
var $22db1ba098eb3017$var$dropTimeRange = $22db1ba098eb3017$var$maxDropTime - $22db1ba098eb3017$var$minDropTime;
var $22db1ba098eb3017$var$maxDropTimeAtDistance = 1500;
var $22db1ba098eb3017$var$cancelDropModifier = 0.6;
var $22db1ba098eb3017$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $22db1ba098eb3017$var$distance(current, destination);
    if (distance$1 <= 0) return $22db1ba098eb3017$var$minDropTime;
    if (distance$1 >= $22db1ba098eb3017$var$maxDropTimeAtDistance) return $22db1ba098eb3017$var$maxDropTime;
    var percentage = distance$1 / $22db1ba098eb3017$var$maxDropTimeAtDistance;
    var duration = $22db1ba098eb3017$var$minDropTime + $22db1ba098eb3017$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $22db1ba098eb3017$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $22db1ba098eb3017$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $22db1ba098eb3017$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $22db1ba098eb3017$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $22db1ba098eb3017$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $22db1ba098eb3017$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $gzM5u.default)({}, lastImpact, {
        displaced: $22db1ba098eb3017$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $22db1ba098eb3017$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($22db1ba098eb3017$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $22db1ba098eb3017$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $22db1ba098eb3017$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $22db1ba098eb3017$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $22db1ba098eb3017$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $22db1ba098eb3017$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$22db1ba098eb3017$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($22db1ba098eb3017$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $22db1ba098eb3017$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($22db1ba098eb3017$var$animateDrop(args));
        };
    };
};
var $22db1ba098eb3017$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $22db1ba098eb3017$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $22db1ba098eb3017$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($22db1ba098eb3017$var$getWindowScroll());
    }
    var scheduled = (0, $7qpjg.default)(updateScroll);
    var binding = $22db1ba098eb3017$var$getWindowScrollBinding(scheduled);
    var unbind = $22db1ba098eb3017$var$noop;
    function isActive() {
        return unbind !== $22db1ba098eb3017$var$noop;
    }
    function start() {
        !!isActive() && $22db1ba098eb3017$var$invariant(false);
        unbind = $22db1ba098eb3017$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $22db1ba098eb3017$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $22db1ba098eb3017$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $22db1ba098eb3017$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $22db1ba098eb3017$var$scrollListener = function(store) {
    var listener = $22db1ba098eb3017$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($22db1ba098eb3017$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $22db1ba098eb3017$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $22db1ba098eb3017$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $22db1ba098eb3017$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $22db1ba098eb3017$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $22db1ba098eb3017$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $22db1ba098eb3017$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $22db1ba098eb3017$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $22db1ba098eb3017$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $22db1ba098eb3017$var$withTimings = function withTimings(key, fn) {
    $22db1ba098eb3017$var$start(key);
    fn();
    $22db1ba098eb3017$var$finish(key);
};
var $22db1ba098eb3017$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $22db1ba098eb3017$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $22db1ba098eb3017$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $22db1ba098eb3017$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $22db1ba098eb3017$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        $22db1ba098eb3017$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        $22db1ba098eb3017$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($22db1ba098eb3017$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        var data = $22db1ba098eb3017$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $22db1ba098eb3017$var$withTimings('onDragStart', function() {
                return $22db1ba098eb3017$var$execute(getResponders().onDragStart, data, announce, $22db1ba098eb3017$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $22db1ba098eb3017$var$tryGetDestination(impact);
        var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var hasCriticalChanged = !$22db1ba098eb3017$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$22db1ba098eb3017$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$22db1ba098eb3017$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $gzM5u.default)({}, $22db1ba098eb3017$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $22db1ba098eb3017$var$withTimings('onDragUpdate', function() {
                return $22db1ba098eb3017$var$execute(getResponders().onDragUpdate, data, announce, $22db1ba098eb3017$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        dragging = null;
        $22db1ba098eb3017$var$withTimings('onDragEnd', function() {
            return $22db1ba098eb3017$var$execute(getResponders().onDragEnd, result, announce, $22db1ba098eb3017$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $gzM5u.default)({}, $22db1ba098eb3017$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $22db1ba098eb3017$var$responders = function(getResponders, announce) {
    var publisher = $22db1ba098eb3017$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $22db1ba098eb3017$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $22db1ba098eb3017$var$invariant(false);
            store.dispatch($22db1ba098eb3017$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $22db1ba098eb3017$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($22db1ba098eb3017$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $22db1ba098eb3017$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $22db1ba098eb3017$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $22db1ba098eb3017$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $22db1ba098eb3017$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $22db1ba098eb3017$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($22db1ba098eb3017$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $22db1ba098eb3017$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($22db1ba098eb3017$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $22db1ba098eb3017$var$composeEnhancers = (0, $22j3V.compose);
var $22db1ba098eb3017$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $22j3V.createStore)($22db1ba098eb3017$var$reducer, $22db1ba098eb3017$var$composeEnhancers((0, $22j3V.applyMiddleware)($22db1ba098eb3017$var$style(styleMarshal), $22db1ba098eb3017$var$dimensionMarshalStopper(dimensionMarshal), $22db1ba098eb3017$var$lift$1(dimensionMarshal), $22db1ba098eb3017$var$drop$1, $22db1ba098eb3017$var$dropAnimationFinish, $22db1ba098eb3017$var$dropAnimationFlushOnScroll, $22db1ba098eb3017$var$pendingDrop, $22db1ba098eb3017$var$autoScroll(autoScroller), $22db1ba098eb3017$var$scrollListener, $22db1ba098eb3017$var$focus(focusMarshal), $22db1ba098eb3017$var$responders(getResponders, announce))));
};
var $22db1ba098eb3017$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $22db1ba098eb3017$var$timingKey = 'Publish collection from DOM';
function $22db1ba098eb3017$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $22db1ba098eb3017$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $22db1ba098eb3017$var$start($22db1ba098eb3017$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($22db1ba098eb3017$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(removals),
                modified: updated
            };
            staging = $22db1ba098eb3017$var$clean$1();
            $22db1ba098eb3017$var$finish($22db1ba098eb3017$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $22db1ba098eb3017$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $22db1ba098eb3017$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $22db1ba098eb3017$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $22db1ba098eb3017$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $22db1ba098eb3017$var$invariant(false);
    return doc;
};
var $22db1ba098eb3017$var$getMaxWindowScroll = function() {
    var doc = $22db1ba098eb3017$var$getDocumentElement();
    var maxScroll = $22db1ba098eb3017$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $22db1ba098eb3017$var$getViewport = function() {
    var scroll = $22db1ba098eb3017$var$getWindowScroll();
    var maxScroll = $22db1ba098eb3017$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $22db1ba098eb3017$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $3YKxB.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $22db1ba098eb3017$var$origin,
                displacement: $22db1ba098eb3017$var$origin
            }
        }
    };
    return viewport;
};
var $22db1ba098eb3017$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $22db1ba098eb3017$var$start(timingKey);
    var viewport = $22db1ba098eb3017$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $22db1ba098eb3017$var$toDraggableMap(draggables),
        droppables: $22db1ba098eb3017$var$toDroppableMap(droppables)
    };
    $22db1ba098eb3017$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $22db1ba098eb3017$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $22db1ba098eb3017$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $22db1ba098eb3017$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $22db1ba098eb3017$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $22db1ba098eb3017$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $22db1ba098eb3017$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $22db1ba098eb3017$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $22db1ba098eb3017$var$getScrollableDroppables = (0, $g7psY.default)(function(droppables) {
    return $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $22db1ba098eb3017$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $22db1ba098eb3017$var$find($22db1ba098eb3017$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $22db1ba098eb3017$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $22db1ba098eb3017$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $22db1ba098eb3017$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $22db1ba098eb3017$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $22db1ba098eb3017$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $22db1ba098eb3017$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $22db1ba098eb3017$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $22db1ba098eb3017$var$minScroll = 1;
var $22db1ba098eb3017$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $22db1ba098eb3017$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $22db1ba098eb3017$var$minScroll;
    var percentageFromMaxScrollValueAt = $22db1ba098eb3017$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $22db1ba098eb3017$var$config.maxPixelScroll * $22db1ba098eb3017$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $22db1ba098eb3017$var$accelerateAt = $22db1ba098eb3017$var$config.durationDampening.accelerateAt;
var $22db1ba098eb3017$var$stopAt = $22db1ba098eb3017$var$config.durationDampening.stopDampeningAt;
var $22db1ba098eb3017$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $22db1ba098eb3017$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($3BSY2)))();
    var runTime = now - startOfRange;
    if (runTime >= $22db1ba098eb3017$var$stopAt) return proposedScroll;
    if (runTime < $22db1ba098eb3017$var$accelerateAt) return $22db1ba098eb3017$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $22db1ba098eb3017$var$getPercentage({
        startOfRange: $22db1ba098eb3017$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $22db1ba098eb3017$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $22db1ba098eb3017$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $22db1ba098eb3017$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($22db1ba098eb3017$var$dampenValueByTime(scroll, dragStartTime), $22db1ba098eb3017$var$minScroll);
};
var $22db1ba098eb3017$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $22db1ba098eb3017$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $22db1ba098eb3017$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $22db1ba098eb3017$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $22db1ba098eb3017$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $22db1ba098eb3017$var$clean$2 = $22db1ba098eb3017$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $22db1ba098eb3017$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $22db1ba098eb3017$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $22db1ba098eb3017$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $22db1ba098eb3017$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $22db1ba098eb3017$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $22db1ba098eb3017$var$clean$2({
        x: x,
        y: y
    });
    if ($22db1ba098eb3017$var$isEqual(required, $22db1ba098eb3017$var$origin)) return null;
    var limited = $22db1ba098eb3017$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $22db1ba098eb3017$var$isEqual(limited, $22db1ba098eb3017$var$origin) ? null : limited;
};
var $22db1ba098eb3017$var$smallestSigned = $22db1ba098eb3017$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $22db1ba098eb3017$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $22db1ba098eb3017$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($22db1ba098eb3017$var$isEqual(overlap, $22db1ba098eb3017$var$origin)) return null;
        return overlap;
    };
}();
var $22db1ba098eb3017$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $22db1ba098eb3017$var$smallestSigned(change);
    var overlap = $22db1ba098eb3017$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $22db1ba098eb3017$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $22db1ba098eb3017$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$22db1ba098eb3017$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $22db1ba098eb3017$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $22db1ba098eb3017$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $22db1ba098eb3017$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$22db1ba098eb3017$var$canScrollDroppable(droppable, change)) return null;
    return $22db1ba098eb3017$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $22db1ba098eb3017$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $22db1ba098eb3017$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $22db1ba098eb3017$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $22db1ba098eb3017$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $22db1ba098eb3017$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $22db1ba098eb3017$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $22db1ba098eb3017$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $22db1ba098eb3017$var$getBestScrollableDroppable({
        center: center,
        destination: $22db1ba098eb3017$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $22db1ba098eb3017$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $22db1ba098eb3017$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $7qpjg.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $7qpjg.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $22db1ba098eb3017$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $22db1ba098eb3017$var$start('starting fluid scroller');
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($3BSY2)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $22db1ba098eb3017$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $22db1ba098eb3017$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $22db1ba098eb3017$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $22db1ba098eb3017$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$22db1ba098eb3017$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $22db1ba098eb3017$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $22db1ba098eb3017$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $22db1ba098eb3017$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$22db1ba098eb3017$var$canScrollWindow(viewport, change)) return change;
        var overlap = $22db1ba098eb3017$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $22db1ba098eb3017$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $22db1ba098eb3017$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
        !destination && $22db1ba098eb3017$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $22db1ba098eb3017$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $22db1ba098eb3017$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $22db1ba098eb3017$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $22db1ba098eb3017$var$prefix$1 = 'data-rbd';
var $22db1ba098eb3017$var$dragHandle = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $22db1ba098eb3017$var$draggable = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $22db1ba098eb3017$var$droppable = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $22db1ba098eb3017$var$scrollContainer = {
    contextId: $22db1ba098eb3017$var$prefix$1 + "-scroll-container-context-id"
};
var $22db1ba098eb3017$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $22db1ba098eb3017$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $22db1ba098eb3017$var$noPointerEvents = 'pointer-events: none;';
var $22db1ba098eb3017$var$getStyles$1 = function(contextId) {
    var getSelector = $22db1ba098eb3017$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($22db1ba098eb3017$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $22db1ba098eb3017$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $22db1ba098eb3017$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($22db1ba098eb3017$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($22db1ba098eb3017$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $22db1ba098eb3017$var$getStyles(rules, 'always'),
        resting: $22db1ba098eb3017$var$getStyles(rules, 'resting'),
        dragging: $22db1ba098eb3017$var$getStyles(rules, 'dragging'),
        dropAnimating: $22db1ba098eb3017$var$getStyles(rules, 'dropAnimating'),
        userCancel: $22db1ba098eb3017$var$getStyles(rules, 'userCancel')
    };
};
var $22db1ba098eb3017$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);
var $22db1ba098eb3017$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $22db1ba098eb3017$var$invariant(false);
    return head;
};
var $22db1ba098eb3017$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $22db1ba098eb3017$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $5uXOq.useRef)(null);
    var dynamicRef = (0, $5uXOq.useRef)(null);
    var setDynamicStyle = (0, $3YMLK.useCallback)((0, $g7psY.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $22db1ba098eb3017$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $3YMLK.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $22db1ba098eb3017$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $22db1ba098eb3017$var$invariant(false);
        var always = $22db1ba098eb3017$var$createStyleEl(nonce);
        var dynamic = $22db1ba098eb3017$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($22db1ba098eb3017$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($22db1ba098eb3017$var$prefix$1 + "-dynamic", contextId);
        $22db1ba098eb3017$var$getHead().appendChild(always);
        $22db1ba098eb3017$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $22db1ba098eb3017$var$invariant(false);
                $22db1ba098eb3017$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $3YMLK.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $3YMLK.useCallback)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $3YMLK.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $3YMLK.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $22db1ba098eb3017$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $22db1ba098eb3017$var$isHtmlElement(el) {
    return el instanceof $22db1ba098eb3017$var$getWindowFromEl(el).HTMLElement;
}
function $22db1ba098eb3017$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $22db1ba098eb3017$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $22db1ba098eb3017$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $22db1ba098eb3017$var$find(possible, function(el) {
        return el.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(handle)) return null;
    return handle;
}
function $22db1ba098eb3017$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $5uXOq.useRef)({});
    var recordRef = (0, $5uXOq.useRef)(null);
    var restoreFocusFrameRef = (0, $5uXOq.useRef)(null);
    var isMountedRef = (0, $5uXOq.useRef)(false);
    var register = (0, $3YMLK.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $3YMLK.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $22db1ba098eb3017$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $3YMLK.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $3YMLK.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $3YMLK.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $3YMLK.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $22db1ba098eb3017$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $22db1ba098eb3017$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $22db1ba098eb3017$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $22db1ba098eb3017$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $22db1ba098eb3017$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $22db1ba098eb3017$var$useRegistry() {
    var registry = (0, $3YMLK.useMemo)($22db1ba098eb3017$var$createRegistry, []);
    (0, $5uXOq.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $22db1ba098eb3017$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $22db1ba098eb3017$var$getBodyElement = function() {
    var body = document.body;
    !body && $22db1ba098eb3017$var$invariant(false);
    return body;
};
var $22db1ba098eb3017$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $22db1ba098eb3017$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $22db1ba098eb3017$var$useAnnouncer(contextId) {
    var id = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV)))(el.style, $22db1ba098eb3017$var$visuallyHidden);
        $22db1ba098eb3017$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $22db1ba098eb3017$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $3YMLK.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $22db1ba098eb3017$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $22db1ba098eb3017$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $5uXOq.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV)))(el.style, {
            display: 'none'
        });
        $22db1ba098eb3017$var$getBodyElement().appendChild(el);
        return function unmount() {
            $22db1ba098eb3017$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $22db1ba098eb3017$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $22db1ba098eb3017$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $22db1ba098eb3017$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $22db1ba098eb3017$var$getVersion = function getVersion(value) {
    var result = $22db1ba098eb3017$var$semver.exec(value);
    !(result != null) && $22db1ba098eb3017$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $22db1ba098eb3017$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $22db1ba098eb3017$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $22db1ba098eb3017$var$getVersion(peerDepValue);
    var actual = $22db1ba098eb3017$var$getVersion(actualValue);
    if ($22db1ba098eb3017$var$isSatisfied(peerDep, actual)) return;
};
var $22db1ba098eb3017$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $22db1ba098eb3017$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $22db1ba098eb3017$var$useDev(useHook) {}
function $22db1ba098eb3017$var$useDevSetupWarning(fn, inputs) {
    $22db1ba098eb3017$var$useDev(function() {
        (0, $5uXOq.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $22db1ba098eb3017$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $22db1ba098eb3017$var$useStartupValidation() {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        $22db1ba098eb3017$var$checkReactVersion($22db1ba098eb3017$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).version);
        $22db1ba098eb3017$var$checkDoctype(document);
    }, []);
}
function $22db1ba098eb3017$var$usePrevious(current) {
    var ref = (0, $5uXOq.useRef)(current);
    (0, $5uXOq.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $22db1ba098eb3017$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $22db1ba098eb3017$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $22db1ba098eb3017$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $22db1ba098eb3017$var$tab = 9;
var $22db1ba098eb3017$var$enter = 13;
var $22db1ba098eb3017$var$escape = 27;
var $22db1ba098eb3017$var$space = 32;
var $22db1ba098eb3017$var$pageUp = 33;
var $22db1ba098eb3017$var$pageDown = 34;
var $22db1ba098eb3017$var$end = 35;
var $22db1ba098eb3017$var$home = 36;
var $22db1ba098eb3017$var$arrowLeft = 37;
var $22db1ba098eb3017$var$arrowUp = 38;
var $22db1ba098eb3017$var$arrowRight = 39;
var $22db1ba098eb3017$var$arrowDown = 40;
var $22db1ba098eb3017$var$_preventedKeys;
var $22db1ba098eb3017$var$preventedKeys = ($22db1ba098eb3017$var$_preventedKeys = {}, $22db1ba098eb3017$var$_preventedKeys[$22db1ba098eb3017$var$enter] = true, $22db1ba098eb3017$var$_preventedKeys[$22db1ba098eb3017$var$tab] = true, $22db1ba098eb3017$var$_preventedKeys);
var $22db1ba098eb3017$var$preventStandardKeyEvents = function(event) {
    if ($22db1ba098eb3017$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $22db1ba098eb3017$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $22db1ba098eb3017$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $22db1ba098eb3017$var$primaryButton = 0;
var $22db1ba098eb3017$var$sloppyClickThreshold = 5;
function $22db1ba098eb3017$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $22db1ba098eb3017$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $22db1ba098eb3017$var$sloppyClickThreshold;
}
var $22db1ba098eb3017$var$idle$1 = {
    type: 'IDLE'
};
function $22db1ba098eb3017$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $22db1ba098eb3017$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $22db1ba098eb3017$var$invariant(false);
                var pending = phase.point;
                if (!$22db1ba098eb3017$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $22db1ba098eb3017$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useMouseSensor(api) {
    var phaseRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$idle$1);
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $22db1ba098eb3017$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $3YMLK.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $22db1ba098eb3017$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $3YMLK.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $3YMLK.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $22db1ba098eb3017$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $3YMLK.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $22db1ba098eb3017$var$_scrollJumpKeys;
function $22db1ba098eb3017$var$noop$1() {}
var $22db1ba098eb3017$var$scrollJumpKeys = ($22db1ba098eb3017$var$_scrollJumpKeys = {}, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$pageDown] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$pageUp] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$home] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$end] = true, $22db1ba098eb3017$var$_scrollJumpKeys);
function $22db1ba098eb3017$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $22db1ba098eb3017$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($22db1ba098eb3017$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $22db1ba098eb3017$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop$1);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $22db1ba098eb3017$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $22db1ba098eb3017$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $22db1ba098eb3017$var$idle$2 = {
    type: 'IDLE'
};
var $22db1ba098eb3017$var$timeForLongPress = 120;
var $22db1ba098eb3017$var$forcePressThreshold = 0.15;
function $22db1ba098eb3017$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $22db1ba098eb3017$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useMouseSensor$1(api) {
    var phaseRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$idle$2);
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop);
    var getPhase = (0, $3YMLK.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $3YMLK.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $3YMLK.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($22db1ba098eb3017$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $3YMLK.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $3YMLK.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getHandleBindings(args), options);
        var unbindWindow = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $3YMLK.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $22db1ba098eb3017$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $3YMLK.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $22db1ba098eb3017$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($22db1ba098eb3017$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $22db1ba098eb3017$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $22db1ba098eb3017$var$useValidateSensorHooks(sensorHooks) {
    $22db1ba098eb3017$var$useDev(function() {
        var previousRef = $22db1ba098eb3017$var$usePrevious(sensorHooks);
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $22db1ba098eb3017$var$invariant(false);
        });
    });
}
var $22db1ba098eb3017$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $22db1ba098eb3017$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($22db1ba098eb3017$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $22db1ba098eb3017$var$isAnInteractiveElement(parent, current.parentElement);
}
function $22db1ba098eb3017$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$22db1ba098eb3017$var$isHtmlElement(target)) return false;
    return $22db1ba098eb3017$var$isAnInteractiveElement(draggable, target);
}
var $22db1ba098eb3017$var$getBorderBoxCenterPosition = function(el) {
    return (0, $3YKxB.getRect)(el.getBoundingClientRect()).center;
};
function $22db1ba098eb3017$var$isElement(el) {
    return el instanceof $22db1ba098eb3017$var$getWindowFromEl(el).Element;
}
var $22db1ba098eb3017$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $22db1ba098eb3017$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $22db1ba098eb3017$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$22db1ba098eb3017$var$supportedMatchesName](selector)) return el;
    return $22db1ba098eb3017$var$closestPonyfill(el.parentElement, selector);
}
function $22db1ba098eb3017$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $22db1ba098eb3017$var$closestPonyfill(el, selector);
}
function $22db1ba098eb3017$var$getSelector(contextId) {
    return "[" + $22db1ba098eb3017$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $22db1ba098eb3017$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$22db1ba098eb3017$var$isElement(target)) return null;
    var selector = $22db1ba098eb3017$var$getSelector(contextId);
    var handle = $22db1ba098eb3017$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(handle)) return null;
    return handle;
}
function $22db1ba098eb3017$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $22db1ba098eb3017$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId);
}
function $22db1ba098eb3017$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $22db1ba098eb3017$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $22db1ba098eb3017$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $22db1ba098eb3017$var$find(possible, function(el) {
        return el.getAttribute($22db1ba098eb3017$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $22db1ba098eb3017$var$preventDefault(event) {
    event.preventDefault();
}
function $22db1ba098eb3017$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $22db1ba098eb3017$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$22db1ba098eb3017$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $22db1ba098eb3017$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $22db1ba098eb3017$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $22db1ba098eb3017$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $22db1ba098eb3017$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $22db1ba098eb3017$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($22db1ba098eb3017$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $22db1ba098eb3017$var$invariant(false);
        }
        store.dispatch($22db1ba098eb3017$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $22db1ba098eb3017$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $22db1ba098eb3017$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($22db1ba098eb3017$var$drop({
                reason: reason
            }));
        }
        return (0, $gzM5u.default)({
            isActive: function isActive() {
                return $22db1ba098eb3017$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $7qpjg.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $22db1ba098eb3017$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $gzM5u.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $22db1ba098eb3017$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $22db1ba098eb3017$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $22db1ba098eb3017$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $22db1ba098eb3017$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $22db1ba098eb3017$var$defaultSensors = [
    $22db1ba098eb3017$var$useMouseSensor,
    $22db1ba098eb3017$var$useKeyboardSensor,
    $22db1ba098eb3017$var$useMouseSensor$1
];
function $22db1ba098eb3017$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $22db1ba098eb3017$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $5uXOq.useState)(function() {
        return $22db1ba098eb3017$var$create();
    })[0];
    var tryAbandonLock = (0, $3YMLK.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $3YMLK.useCallback)(function(draggableId) {
        return $22db1ba098eb3017$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $3YMLK.useCallback)(function(draggableId, forceStop, options) {
        return $22db1ba098eb3017$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $3YMLK.useCallback)(function(event) {
        return $22db1ba098eb3017$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $3YMLK.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $3YMLK.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $3YMLK.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $3YMLK.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $22db1ba098eb3017$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $22db1ba098eb3017$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $22db1ba098eb3017$var$getStore(lazyRef) {
    !lazyRef.current && $22db1ba098eb3017$var$invariant(false);
    return lazyRef.current;
}
function $22db1ba098eb3017$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $5uXOq.useRef)(null);
    $22db1ba098eb3017$var$useStartupValidation();
    var lastPropsRef = $22db1ba098eb3017$var$usePrevious(props);
    var getResponders = (0, $3YMLK.useCallback)(function() {
        return $22db1ba098eb3017$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $22db1ba098eb3017$var$useAnnouncer(contextId);
    var liftInstructionId = $22db1ba098eb3017$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $22db1ba098eb3017$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $3YMLK.useCallback)(function(action) {
        $22db1ba098eb3017$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $3YMLK.useMemo)(function() {
        return (0, $22j3V.bindActionCreators)({
            publishWhileDragging: $22db1ba098eb3017$var$publishWhileDragging,
            updateDroppableScroll: $22db1ba098eb3017$var$updateDroppableScroll,
            updateDroppableIsEnabled: $22db1ba098eb3017$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $22db1ba098eb3017$var$updateDroppableIsCombineEnabled,
            collectionStarting: $22db1ba098eb3017$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $22db1ba098eb3017$var$useRegistry();
    var dimensionMarshal = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createAutoScroller((0, $gzM5u.default)({
            scrollWindow: $22db1ba098eb3017$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $22j3V.bindActionCreators)({
            move: $22db1ba098eb3017$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $22db1ba098eb3017$var$useFocusMarshal(contextId);
    var store = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $3YMLK.useCallback)(function() {
        var current = $22db1ba098eb3017$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($22db1ba098eb3017$var$flush());
    }, []);
    var isDragging = (0, $3YMLK.useCallback)(function() {
        var state = $22db1ba098eb3017$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $3YMLK.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $3YMLK.useCallback)(function(id) {
        return $22db1ba098eb3017$var$canStartDrag($22db1ba098eb3017$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $3YMLK.useCallback)(function() {
        return $22db1ba098eb3017$var$isMovementAllowed($22db1ba098eb3017$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $3YMLK.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $22db1ba098eb3017$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $5uXOq.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9bdMd.default), {
        context: $22db1ba098eb3017$var$StoreContext,
        store: store
    }, props.children));
}
var $22db1ba098eb3017$var$instanceCount = 0;
function $22db1ba098eb3017$export$2bfe52350fc0150d() {
    $22db1ba098eb3017$var$instanceCount = 0;
}
function $22db1ba098eb3017$export$237bd83162c14364(props) {
    var contextId = (0, $3YMLK.useMemo)(function() {
        return "" + $22db1ba098eb3017$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $22db1ba098eb3017$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $22db1ba098eb3017$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $22db1ba098eb3017$var$isScroll = $22db1ba098eb3017$var$isEqual$1('scroll');
var $22db1ba098eb3017$var$isAuto = $22db1ba098eb3017$var$isEqual$1('auto');
var $22db1ba098eb3017$var$isVisible$1 = $22db1ba098eb3017$var$isEqual$1('visible');
var $22db1ba098eb3017$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $22db1ba098eb3017$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $22db1ba098eb3017$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $22db1ba098eb3017$var$isEither(overflow, $22db1ba098eb3017$var$isScroll) || $22db1ba098eb3017$var$isEither(overflow, $22db1ba098eb3017$var$isAuto);
};
var $22db1ba098eb3017$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $22db1ba098eb3017$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $22db1ba098eb3017$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$22db1ba098eb3017$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $22db1ba098eb3017$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $22db1ba098eb3017$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $22db1ba098eb3017$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $22db1ba098eb3017$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $22db1ba098eb3017$var$getEnv = function(start) {
    var closestScrollable = $22db1ba098eb3017$var$getClosestScrollable(start);
    var isFixedOnPage = $22db1ba098eb3017$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $22db1ba098eb3017$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $22db1ba098eb3017$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $22db1ba098eb3017$var$origin,
                    displacement: $22db1ba098eb3017$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $22db1ba098eb3017$var$vertical : $22db1ba098eb3017$var$horizontal;
    var subject = $22db1ba098eb3017$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $22db1ba098eb3017$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $3YKxB.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $3YKxB.expand)(paddingBox, base.border);
    var client = (0, $3YKxB.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $22db1ba098eb3017$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $22db1ba098eb3017$var$getClient(ref, closestScrollable);
    var page = (0, $3YKxB.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $3YKxB.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $3YKxB.withScroll)(frameClient, windowScroll),
            scroll: $22db1ba098eb3017$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $22db1ba098eb3017$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $22db1ba098eb3017$var$immediate = {
    passive: false
};
var $22db1ba098eb3017$var$delayed = {
    passive: true
};
var $22db1ba098eb3017$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $22db1ba098eb3017$var$immediate : $22db1ba098eb3017$var$delayed;
};
function $22db1ba098eb3017$var$useRequiredContext(Context) {
    var result = (0, $5uXOq.useContext)(Context);
    !result && $22db1ba098eb3017$var$invariant(false);
    return result;
}
var $22db1ba098eb3017$var$count = 0;
function $22db1ba098eb3017$var$useUniqueId(prefix) {
    var countRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$count++);
    return prefix + "::" + countRef.current;
}
var $22db1ba098eb3017$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $22db1ba098eb3017$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $5uXOq.useRef)(null);
    var appContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$AppContext);
    var uniqueId = $22db1ba098eb3017$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $22db1ba098eb3017$var$usePrevious(args);
    var descriptor = (0, $3YMLK.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $5uXOq.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $3YMLK.useMemo)(function() {
        return (0, $g7psY.default)(function(x, y) {
            !whileDraggingRef.current && $22db1ba098eb3017$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $22db1ba098eb3017$var$origin;
        return $22db1ba098eb3017$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $3YMLK.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $3YMLK.useMemo)(function() {
        return (0, $7qpjg.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $22db1ba098eb3017$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $3YMLK.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $22db1ba098eb3017$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $22db1ba098eb3017$var$invariant(false);
        var env = $22db1ba098eb3017$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $22db1ba098eb3017$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($22db1ba098eb3017$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $22db1ba098eb3017$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($22db1ba098eb3017$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $22db1ba098eb3017$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $3YMLK.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !closest && $22db1ba098eb3017$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $3YMLK.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $3YMLK.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $22db1ba098eb3017$var$noop$2() {}
var $22db1ba098eb3017$var$empty = {
    width: 0,
    height: 0,
    margin: $22db1ba098eb3017$var$noSpacing
};
var $22db1ba098eb3017$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $22db1ba098eb3017$var$empty;
    if (animate === 'close') return $22db1ba098eb3017$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $22db1ba098eb3017$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $22db1ba098eb3017$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $22db1ba098eb3017$var$transitions.placeholder : null
    };
};
function $22db1ba098eb3017$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $5uXOq.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $3YMLK.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $5uXOq.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $5uXOq.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $22db1ba098eb3017$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $22db1ba098eb3017$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $22db1ba098eb3017$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $3YMLK.useCallback)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $22db1ba098eb3017$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $22db1ba098eb3017$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($22db1ba098eb3017$var$Placeholder);
var $22db1ba098eb3017$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $22db1ba098eb3017$var$checkIsValidInnerRef(el) {
    !(el && $22db1ba098eb3017$var$isHtmlElement(el)) && $22db1ba098eb3017$var$invariant(false);
}
function $22db1ba098eb3017$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $22db1ba098eb3017$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $22db1ba098eb3017$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $22db1ba098eb3017$var$invariant(false);
        !(typeof props.droppableId === 'string') && $22db1ba098eb3017$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$22db1ba098eb3017$var$isBoolean(props.isDropDisabled) && $22db1ba098eb3017$var$invariant(false);
        !$22db1ba098eb3017$var$isBoolean(props.isCombineEnabled) && $22db1ba098eb3017$var$invariant(false);
        !$22db1ba098eb3017$var$isBoolean(props.ignoreContainerClipping) && $22db1ba098eb3017$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $22db1ba098eb3017$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $22db1ba098eb3017$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $22db1ba098eb3017$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $22db1ba098eb3017$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $22db1ba098eb3017$var$invariant(false);
    }
];
function $22db1ba098eb3017$var$useValidation(args) {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$shared);
        if (args.props.mode === 'standard') $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$standard);
        if (args.props.mode === 'virtual') $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$virtual);
    });
}
var $22db1ba098eb3017$var$AnimateInOut = function(_React$PureComponent) {
    (0, $1AwyE.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent);
var $22db1ba098eb3017$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $22db1ba098eb3017$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $22db1ba098eb3017$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $22db1ba098eb3017$var$transitions.snap;
    return $22db1ba098eb3017$var$transitions.fluid;
};
var $22db1ba098eb3017$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $22db1ba098eb3017$var$combine.opacity.drop : $22db1ba098eb3017$var$combine.opacity.combining;
};
var $22db1ba098eb3017$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $22db1ba098eb3017$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $22db1ba098eb3017$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $22db1ba098eb3017$var$transforms.drop(offset, isCombining) : $22db1ba098eb3017$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $22db1ba098eb3017$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $22db1ba098eb3017$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $22db1ba098eb3017$var$zIndexOptions.dropAnimating : $22db1ba098eb3017$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $22db1ba098eb3017$var$getSecondaryStyle(secondary) {
    return {
        transform: $22db1ba098eb3017$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $22db1ba098eb3017$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $22db1ba098eb3017$var$getDraggingStyle(mapped) : $22db1ba098eb3017$var$getSecondaryStyle(mapped);
}
function $22db1ba098eb3017$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $22db1ba098eb3017$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $3YKxB.calculateBox)(borderBox, computedStyles);
    var page = (0, $3YKxB.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $22db1ba098eb3017$var$useDraggablePublisher(args) {
    var uniqueId = $22db1ba098eb3017$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $3YMLK.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $3YMLK.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $3YMLK.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $5uXOq.useRef)(entry);
    var isFirstPublishRef = (0, $5uXOq.useRef)(true);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $22db1ba098eb3017$var$useValidation$1(props, contextId, getRef) {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $22db1ba098eb3017$var$invariant(false);
        !(typeof id === 'string') && $22db1ba098eb3017$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($1DIXK)))(props.index) && $22db1ba098eb3017$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $22db1ba098eb3017$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$22db1ba098eb3017$var$findDragHandle(contextId, id) && $22db1ba098eb3017$var$invariant(false);
    });
}
function $22db1ba098eb3017$var$useClonePropValidation(isClone) {
    $22db1ba098eb3017$var$useDev(function() {
        var initialRef = (0, $5uXOq.useRef)(isClone);
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $22db1ba098eb3017$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $22db1ba098eb3017$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $22db1ba098eb3017$var$Draggable(props) {
    var ref = (0, $5uXOq.useRef)(null);
    var setRef = (0, $3YMLK.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $3YMLK.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $3YMLK.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $22db1ba098eb3017$var$useValidation$1(props, contextId, getRef);
    $22db1ba098eb3017$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $3YMLK.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $22db1ba098eb3017$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $3YMLK.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $22db1ba098eb3017$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $3YMLK.useCallback)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $3YMLK.useMemo)(function() {
        var style = $22db1ba098eb3017$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $3YMLK.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $22db1ba098eb3017$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $22db1ba098eb3017$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $22db1ba098eb3017$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $22db1ba098eb3017$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $22db1ba098eb3017$var$getDraggableSelector() {
    var memoizedOffset = (0, $g7psY.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $g7psY.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $g7psY.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
            var combineWith = $22db1ba098eb3017$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $22db1ba098eb3017$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $22db1ba098eb3017$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $22db1ba098eb3017$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $22db1ba098eb3017$var$combine.opacity.drop : null,
                scale: _combineWith ? $22db1ba098eb3017$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $22db1ba098eb3017$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $22db1ba098eb3017$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $22db1ba098eb3017$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $22db1ba098eb3017$var$getSecondarySnapshot(null)
    }
};
function $22db1ba098eb3017$var$getSecondarySelector() {
    var memoizedOffset = (0, $g7psY.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $g7psY.default)($22db1ba098eb3017$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $g7psY.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($22db1ba098eb3017$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $22db1ba098eb3017$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $22db1ba098eb3017$var$getDraggableSelector();
    var secondarySelector = $22db1ba098eb3017$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $22db1ba098eb3017$var$atRest;
    };
    return selector;
};
var $22db1ba098eb3017$var$mapDispatchToProps = {
    dropAnimationFinished: $22db1ba098eb3017$var$dropAnimationFinished
};
var $22db1ba098eb3017$var$ConnectedDraggable = (0, $AuRrZ.default)($22db1ba098eb3017$var$makeMapStateToProps, $22db1ba098eb3017$var$mapDispatchToProps, null, {
    context: $22db1ba098eb3017$var$StoreContext,
    pure: true,
    areStatePropsEqual: $22db1ba098eb3017$var$isStrictEqual
})($22db1ba098eb3017$var$Draggable);
function $22db1ba098eb3017$var$PrivateDraggable(props) {
    var droppableContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$ConnectedDraggable, props);
}
function $22db1ba098eb3017$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$PrivateDraggable, (0, $gzM5u.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $22db1ba098eb3017$var$Droppable(props) {
    var appContext = (0, $5uXOq.useContext)($22db1ba098eb3017$var$AppContext);
    !appContext && $22db1ba098eb3017$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $5uXOq.useRef)(null);
    var placeholderRef = (0, $5uXOq.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $3YMLK.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $3YMLK.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $3YMLK.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $3YMLK.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $22db1ba098eb3017$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $3YMLK.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $22db1ba098eb3017$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $22db1ba098eb3017$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $3YMLK.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $3YMLK.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $22db1ba098eb3017$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $22db1ba098eb3017$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $22db1ba098eb3017$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $gzM5u.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $g7psY.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $g7psY.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$22db1ba098eb3017$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $22db1ba098eb3017$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$22db1ba098eb3017$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $22db1ba098eb3017$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $22db1ba098eb3017$var$whatIsDraggedOverFromResult(completed.result) === id, $22db1ba098eb3017$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$22db1ba098eb3017$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $22db1ba098eb3017$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $22db1ba098eb3017$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $22db1ba098eb3017$var$updateViewportMaxScroll
};
function $22db1ba098eb3017$var$getBody() {
    !document.body && $22db1ba098eb3017$var$invariant(false);
    return document.body;
}
var $22db1ba098eb3017$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $22db1ba098eb3017$var$getBody
};
var $22db1ba098eb3017$export$423ec2075359570a = (0, $AuRrZ.default)($22db1ba098eb3017$var$makeMapStateToProps$1, $22db1ba098eb3017$var$mapDispatchToProps$1, null, {
    context: $22db1ba098eb3017$var$StoreContext,
    pure: true,
    areStatePropsEqual: $22db1ba098eb3017$var$isStrictEqual
})($22db1ba098eb3017$var$Droppable);
$22db1ba098eb3017$export$423ec2075359570a.defaultProps = $22db1ba098eb3017$var$defaultProps;

});
parcelRegister("1AwyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $128268946ec0acb0$export$2e2bcd8739ae039);

var $gIDtq = parcelRequire("gIDtq");

var $blzS6 = parcelRequire("blzS6");
function $128268946ec0acb0$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($gIDtq)))(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $blzS6.default)(subClass, superClass);
}

});
parcelRegister("gIDtq", function(module, exports) {

module.exports = (parcelRequire("dG4Ay"));

});
parcelRegister("dG4Ay", function(module, exports) {
parcelRequire("bAALv");

var $4KXzV = parcelRequire("4KXzV");
var $9f52c1cdbf61a0ea$require$$Object = $4KXzV.Object;
module.exports = function create(P, D) {
    return $9f52c1cdbf61a0ea$require$$Object.create(P, D);
};

});
parcelRegister("bAALv", function(module, exports) {

var $fNMIk = parcelRequire("fNMIk");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$fNMIk($fNMIk.S, 'Object', {
    create: (parcelRequire("221nn"))
});

});
parcelRegister("fNMIk", function(module, exports) {

var $4tgdI = parcelRequire("4tgdI");

var $4KXzV = parcelRequire("4KXzV");

var $85v89 = parcelRequire("85v89");

var $9TfYC = parcelRequire("9TfYC");

var $8cV4K = parcelRequire("8cV4K");
var $b811382cedb7c9d6$var$PROTOTYPE = 'prototype';
var $b811382cedb7c9d6$var$$export = function(type, name, source) {
    var IS_FORCED = type & $b811382cedb7c9d6$var$$export.F;
    var IS_GLOBAL = type & $b811382cedb7c9d6$var$$export.G;
    var IS_STATIC = type & $b811382cedb7c9d6$var$$export.S;
    var IS_PROTO = type & $b811382cedb7c9d6$var$$export.P;
    var IS_BIND = type & $b811382cedb7c9d6$var$$export.B;
    var IS_WRAP = type & $b811382cedb7c9d6$var$$export.W;
    var exports = IS_GLOBAL ? $4KXzV : $4KXzV[name] || ($4KXzV[name] = {});
    var expProto = exports[$b811382cedb7c9d6$var$PROTOTYPE];
    var target = IS_GLOBAL ? $4tgdI : IS_STATIC ? $4tgdI[name] : ($4tgdI[name] || {})[$b811382cedb7c9d6$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $8cV4K(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $85v89(out, $4tgdI) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$b811382cedb7c9d6$var$PROTOTYPE] = C[$b811382cedb7c9d6$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $85v89(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $b811382cedb7c9d6$var$$export.R && expProto && !expProto[key]) $9TfYC(expProto, key, out);
        }
    }
};
// type bitmap
$b811382cedb7c9d6$var$$export.F = 1; // forced
$b811382cedb7c9d6$var$$export.G = 2; // global
$b811382cedb7c9d6$var$$export.S = 4; // static
$b811382cedb7c9d6$var$$export.P = 8; // proto
$b811382cedb7c9d6$var$$export.B = 16; // bind
$b811382cedb7c9d6$var$$export.W = 32; // wrap
$b811382cedb7c9d6$var$$export.U = 64; // safe
$b811382cedb7c9d6$var$$export.R = 128; // real proto method for `library`
module.exports = $b811382cedb7c9d6$var$$export;

});
parcelRegister("4tgdI", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $341673df947a4fac$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $341673df947a4fac$var$global; // eslint-disable-line no-undef

});

parcelRegister("4KXzV", function(module, exports) {
var $3769ac535e8faf09$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $3769ac535e8faf09$var$core; // eslint-disable-line no-undef

});

parcelRegister("85v89", function(module, exports) {
// optional / simple context binding

var $6fe4N = parcelRequire("6fe4N");
module.exports = function(fn, that, length) {
    $6fe4N(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("6fe4N", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9TfYC", function(module, exports) {

var $2J4Nu = parcelRequire("2J4Nu");

var $azl1x = parcelRequire("azl1x");

module.exports = (parcelRequire("aPbfY")) ? function(object, key, value) {
    return $2J4Nu.f(object, key, $azl1x(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("2J4Nu", function(module, exports) {

$parcel$export(module.exports, "f", () => $1fc38158650d0be0$export$2d1720544b23b823, (v) => $1fc38158650d0be0$export$2d1720544b23b823 = v);
var $1fc38158650d0be0$export$2d1720544b23b823;

var $1J67F = parcelRequire("1J67F");

var $7fdxi = parcelRequire("7fdxi");

var $feF34 = parcelRequire("feF34");
var $1fc38158650d0be0$var$dP = Object.defineProperty;

$1fc38158650d0be0$export$2d1720544b23b823 = (parcelRequire("aPbfY")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $1J67F(O);
    P = $feF34(P, true);
    $1J67F(Attributes);
    if ($7fdxi) try {
        return $1fc38158650d0be0$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("1J67F", function(module, exports) {

var $dxLeJ = parcelRequire("dxLeJ");
module.exports = function(it) {
    if (!$dxLeJ(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("dxLeJ", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("7fdxi", function(module, exports) {



module.exports = !(parcelRequire("aPbfY")) && !(parcelRequire("cKvWG"))(function() {
    return Object.defineProperty((parcelRequire("8IahC"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("aPbfY", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("cKvWG"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("cKvWG", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("8IahC", function(module, exports) {

var $dxLeJ = parcelRequire("dxLeJ");

var $4tgdI = parcelRequire("4tgdI");
var $657a68d5e7e8fca9$require$document = $4tgdI.document;
// typeof document.createElement is 'object' in old IE
var $657a68d5e7e8fca9$var$is = $dxLeJ($657a68d5e7e8fca9$require$document) && $dxLeJ($657a68d5e7e8fca9$require$document.createElement);
module.exports = function(it) {
    return $657a68d5e7e8fca9$var$is ? $657a68d5e7e8fca9$require$document.createElement(it) : {};
};

});


parcelRegister("feF34", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $dxLeJ = parcelRequire("dxLeJ");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$dxLeJ(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("azl1x", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("8cV4K", function(module, exports) {
var $5f9bb7be8775a474$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $5f9bb7be8775a474$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("221nn", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $1J67F = parcelRequire("1J67F");

var $aRCm2 = parcelRequire("aRCm2");

var $8LIl9 = parcelRequire("8LIl9");

var $17acd5ea8a458e2a$var$IE_PROTO = (parcelRequire("fZhMi"))('IE_PROTO');
var $17acd5ea8a458e2a$var$Empty = function() {};
var $17acd5ea8a458e2a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $17acd5ea8a458e2a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("8IahC"))('iframe');
    var i = $8LIl9.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("jcava")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $17acd5ea8a458e2a$var$createDict = iframeDocument.F;
    while(i--)delete $17acd5ea8a458e2a$var$createDict[$17acd5ea8a458e2a$var$PROTOTYPE][$8LIl9[i]];
    return $17acd5ea8a458e2a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $17acd5ea8a458e2a$var$Empty[$17acd5ea8a458e2a$var$PROTOTYPE] = $1J67F(O);
        result = new $17acd5ea8a458e2a$var$Empty();
        $17acd5ea8a458e2a$var$Empty[$17acd5ea8a458e2a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$17acd5ea8a458e2a$var$IE_PROTO] = O;
    } else result = $17acd5ea8a458e2a$var$createDict();
    return Properties === undefined ? result : $aRCm2(result, Properties);
};

});
parcelRegister("aRCm2", function(module, exports) {

var $2J4Nu = parcelRequire("2J4Nu");

var $1J67F = parcelRequire("1J67F");

var $iTod0 = parcelRequire("iTod0");

module.exports = (parcelRequire("aPbfY")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $1J67F(O);
    var keys = $iTod0(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$2J4Nu.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("iTod0", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $vYsY4 = parcelRequire("vYsY4");

var $8LIl9 = parcelRequire("8LIl9");
module.exports = Object.keys || function keys(O) {
    return $vYsY4(O, $8LIl9);
};

});
parcelRegister("vYsY4", function(module, exports) {

var $8cV4K = parcelRequire("8cV4K");

var $ehxEQ = parcelRequire("ehxEQ");

var $0601ccb297d1ed28$var$arrayIndexOf = (parcelRequire("80pUB"))(false);

var $0601ccb297d1ed28$var$IE_PROTO = (parcelRequire("fZhMi"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $ehxEQ(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $0601ccb297d1ed28$var$IE_PROTO) $8cV4K(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8cV4K(O, key = names[i++])) ~$0601ccb297d1ed28$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("ehxEQ", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $45UmF = parcelRequire("45UmF");

var $3BBLi = parcelRequire("3BBLi");
module.exports = function(it) {
    return $45UmF($3BBLi(it));
};

});
parcelRegister("45UmF", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $g8809 = parcelRequire("g8809");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $g8809(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("g8809", function(module, exports) {
var $bbe399a4209a50a6$var$toString = {}.toString;
module.exports = function(it) {
    return $bbe399a4209a50a6$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("3BBLi", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("80pUB", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $ehxEQ = parcelRequire("ehxEQ");

var $fVjkK = parcelRequire("fVjkK");

var $eh5pH = parcelRequire("eh5pH");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $ehxEQ($this);
        var length = $fVjkK(O.length);
        var index = $eh5pH(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("fVjkK", function(module, exports) {
// 7.1.15 ToLength

var $9E260 = parcelRequire("9E260");
var $b97b2d25065ac7b9$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $b97b2d25065ac7b9$var$min($9E260(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("9E260", function(module, exports) {
// 7.1.4 ToInteger
var $705979a7eeb2722c$var$ceil = Math.ceil;
var $705979a7eeb2722c$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $705979a7eeb2722c$var$floor : $705979a7eeb2722c$var$ceil)(it);
};

});


parcelRegister("eh5pH", function(module, exports) {

var $9E260 = parcelRequire("9E260");
var $a646da372e065330$var$max = Math.max;
var $a646da372e065330$var$min = Math.min;
module.exports = function(index, length) {
    index = $9E260(index);
    return index < 0 ? $a646da372e065330$var$max(index + length, 0) : $a646da372e065330$var$min(index, length);
};

});


parcelRegister("fZhMi", function(module, exports) {

var $ba3a57d696ea3f5e$var$shared = (parcelRequire("51eCU"))('keys');

var $6oFvJ = parcelRequire("6oFvJ");
module.exports = function(key) {
    return $ba3a57d696ea3f5e$var$shared[key] || ($ba3a57d696ea3f5e$var$shared[key] = $6oFvJ(key));
};

});
parcelRegister("51eCU", function(module, exports) {

var $4KXzV = parcelRequire("4KXzV");

var $4tgdI = parcelRequire("4tgdI");
var $3a78644a27e09ff7$var$SHARED = '__core-js_shared__';
var $3a78644a27e09ff7$var$store = $4tgdI[$3a78644a27e09ff7$var$SHARED] || ($4tgdI[$3a78644a27e09ff7$var$SHARED] = {});

(module.exports = function(key, value) {
    return $3a78644a27e09ff7$var$store[key] || ($3a78644a27e09ff7$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $4KXzV.version,
    mode: (parcelRequire("fQqAk")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("fQqAk", function(module, exports) {
module.exports = true;

});


parcelRegister("6oFvJ", function(module, exports) {
var $4a852f27f31a7144$var$id = 0;
var $4a852f27f31a7144$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$4a852f27f31a7144$var$id + $4a852f27f31a7144$var$px).toString(36));
};

});



parcelRegister("8LIl9", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("jcava", function(module, exports) {

var $4tgdI = parcelRequire("4tgdI");
var $df9748b6b5115090$require$document = $4tgdI.document;
module.exports = $df9748b6b5115090$require$document && $df9748b6b5115090$require$document.documentElement;

});





parcelRegister("blzS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0221c40d50c91a18$export$2e2bcd8739ae039);

var $XfZ8C = parcelRequire("XfZ8C");
function $0221c40d50c91a18$export$2e2bcd8739ae039(o, p) {
    $0221c40d50c91a18$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($XfZ8C))) ? (0, (/*@__PURE__*/$parcel$interopDefault($XfZ8C))).bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0221c40d50c91a18$export$2e2bcd8739ae039(o, p);
}

});
parcelRegister("XfZ8C", function(module, exports) {

module.exports = (parcelRequire("54tg9"));

});
parcelRegister("54tg9", function(module, exports) {
parcelRequire("lLIVa");

module.exports = (parcelRequire("4KXzV")).Object.setPrototypeOf;

});
parcelRegister("lLIVa", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S, 'Object', {
    setPrototypeOf: (parcelRequire("j14FP")).set
});

});
parcelRegister("j14FP", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $dxLeJ = parcelRequire("dxLeJ");

var $1J67F = parcelRequire("1J67F");
var $dd81bc62c5518cb8$var$check = function(O, proto) {
    $1J67F(O);
    if (!$dxLeJ(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("85v89"))(Function.call, (parcelRequire("fZ4ki")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $dd81bc62c5518cb8$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $dd81bc62c5518cb8$var$check
};

});
parcelRegister("fZ4ki", function(module, exports) {

$parcel$export(module.exports, "f", () => $ba2fe8a7b47b04c8$export$2d1720544b23b823, (v) => $ba2fe8a7b47b04c8$export$2d1720544b23b823 = v);
var $ba2fe8a7b47b04c8$export$2d1720544b23b823;

var $1paSc = parcelRequire("1paSc");

var $azl1x = parcelRequire("azl1x");

var $ehxEQ = parcelRequire("ehxEQ");

var $feF34 = parcelRequire("feF34");

var $8cV4K = parcelRequire("8cV4K");

var $7fdxi = parcelRequire("7fdxi");
var $ba2fe8a7b47b04c8$var$gOPD = Object.getOwnPropertyDescriptor;

$ba2fe8a7b47b04c8$export$2d1720544b23b823 = (parcelRequire("aPbfY")) ? $ba2fe8a7b47b04c8$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $ehxEQ(O);
    P = $feF34(P, true);
    if ($7fdxi) try {
        return $ba2fe8a7b47b04c8$var$gOPD(O, P);
    } catch (e) {}
    if ($8cV4K(O, P)) return $azl1x(!$1paSc.f.call(O, P), O[P]);
};

});
parcelRegister("1paSc", function(module, exports) {

$parcel$export(module.exports, "f", () => $10608f6e292983ab$export$2d1720544b23b823, (v) => $10608f6e292983ab$export$2d1720544b23b823 = v);
var $10608f6e292983ab$export$2d1720544b23b823;
$10608f6e292983ab$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});








parcelRegister("gzM5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $c115376b03ce6805$export$2e2bcd8739ae039);

var $4iZOV = parcelRequire("4iZOV");
function $c115376b03ce6805$export$2e2bcd8739ae039() {
    $c115376b03ce6805$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV))) ? (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV))).bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c115376b03ce6805$export$2e2bcd8739ae039.apply(this, arguments);
}

});
parcelRegister("4iZOV", function(module, exports) {

module.exports = (parcelRequire("jSAle"));

});
parcelRegister("jSAle", function(module, exports) {
parcelRequire("gGoAI");

module.exports = (parcelRequire("4KXzV")).Object.assign;

});
parcelRegister("gGoAI", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S + $fNMIk.F, 'Object', {
    assign: (parcelRequire("f40xK"))
});

});
parcelRegister("f40xK", function(module, exports) {
'use strict';

var $aPbfY = parcelRequire("aPbfY");

var $iTod0 = parcelRequire("iTod0");

var $8SJ8c = parcelRequire("8SJ8c");

var $1paSc = parcelRequire("1paSc");

var $llAOy = parcelRequire("llAOy");

var $45UmF = parcelRequire("45UmF");
var $af77a69d8871d271$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$af77a69d8871d271$var$$assign || (parcelRequire("cKvWG"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $af77a69d8871d271$var$$assign({}, A)[S] != 7 || Object.keys($af77a69d8871d271$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $llAOy(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $8SJ8c.f;
    var isEnum = $1paSc.f;
    while(aLen > index){
        var S = $45UmF(arguments[index++]);
        var keys = getSymbols ? $iTod0(S).concat(getSymbols(S)) : $iTod0(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$aPbfY || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $af77a69d8871d271$var$$assign;

});
parcelRegister("8SJ8c", function(module, exports) {

$parcel$export(module.exports, "f", () => $67765ffbebba3db3$export$2d1720544b23b823, (v) => $67765ffbebba3db3$export$2d1720544b23b823 = v);
var $67765ffbebba3db3$export$2d1720544b23b823;
$67765ffbebba3db3$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("llAOy", function(module, exports) {
// 7.1.13 ToObject(argument)

var $3BBLi = parcelRequire("3BBLi");
module.exports = function(it) {
    return Object($3BBLi(it));
};

});






parcelRegister("22j3V", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $17ba8e0cb3c50187$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $17ba8e0cb3c50187$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $17ba8e0cb3c50187$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $17ba8e0cb3c50187$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $17ba8e0cb3c50187$export$9ff26e0402cc7b7);

var $d56Hw = parcelRequire("d56Hw");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $17ba8e0cb3c50187$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $17ba8e0cb3c50187$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $17ba8e0cb3c50187$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $17ba8e0cb3c50187$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $17ba8e0cb3c50187$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $17ba8e0cb3c50187$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $17ba8e0cb3c50187$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $17ba8e0cb3c50187$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $17ba8e0cb3c50187$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($17ba8e0cb3c50187$var$isDate(val)) return 'date';
    if ($17ba8e0cb3c50187$var$isError(val)) return 'error';
    var constructorName = $17ba8e0cb3c50187$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $17ba8e0cb3c50187$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $17ba8e0cb3c50187$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $17ba8e0cb3c50187$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $17ba8e0cb3c50187$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $17ba8e0cb3c50187$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(1));
        return enhancer($17ba8e0cb3c50187$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$17ba8e0cb3c50187$var$isPlainObject(action)) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$17ba8e0cb3c50187$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $17ba8e0cb3c50187$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$17ba8e0cb3c50187$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $17ba8e0cb3c50187$export$8928921ea2d3b126 = $17ba8e0cb3c50187$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $17ba8e0cb3c50187$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $17ba8e0cb3c50187$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $17ba8e0cb3c50187$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$17ba8e0cb3c50187$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $17ba8e0cb3c50187$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $17ba8e0cb3c50187$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $17ba8e0cb3c50187$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $17ba8e0cb3c50187$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $17ba8e0cb3c50187$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $17ba8e0cb3c50187$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $17ba8e0cb3c50187$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $17ba8e0cb3c50187$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $17ba8e0cb3c50187$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $17ba8e0cb3c50187$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $17ba8e0cb3c50187$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $17ba8e0cb3c50187$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d56Hw.default)((0, $d56Hw.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("d56Hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9860f0a512598bc6$export$2e2bcd8739ae039);

var $eHiP8 = parcelRequire("eHiP8");
function $9860f0a512598bc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9860f0a512598bc6$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9860f0a512598bc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9860f0a512598bc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});


parcelRegister("i6AsN", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("AuRrZ")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("9bdMd")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("616sH")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("6S8MB")).useSelector);
parcelRequire("dDvQ8");
parcelRequire("8mhVE");
var $7nsd3 = parcelRequire("7nsd3");

var $297cv = parcelRequire("297cv");
// with standard React renderers (ReactDOM, React Native)
(0, $297cv.setBatch)((0, $7nsd3.unstable_batchedUpdates));

});
parcelRegister("dDvQ8", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("9bdMd")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("AuRrZ")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("616sH")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("6S8MB")).useSelector);

var $9bdMd = parcelRequire("9bdMd");

var $evQWN = parcelRequire("evQWN");

var $eZhPT = parcelRequire("eZhPT");

var $AuRrZ = parcelRequire("AuRrZ");

var $616sH = parcelRequire("616sH");

var $6S8MB = parcelRequire("6S8MB");

var $5sekt = parcelRequire("5sekt");

var $ggTLx = parcelRequire("ggTLx");

});
parcelRegister("9bdMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aefd3e4140316d1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $eZhPT = parcelRequire("eZhPT");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");
function $6aefd3e4140316d1$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $5uXOq.useMemo)(function() {
        var subscription = (0, $arhzp.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $5uXOq.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $eZhPT.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $6aefd3e4140316d1$export$2e2bcd8739ae039 = $6aefd3e4140316d1$var$Provider;

});
parcelRegister("eZhPT", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $ae9499069f1e06d6$export$cc80c08dc91f1c00);

var $5uXOq = parcelRequire("5uXOq");
var $ae9499069f1e06d6$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $ae9499069f1e06d6$export$2e2bcd8739ae039 = $ae9499069f1e06d6$export$cc80c08dc91f1c00;

});

parcelRegister("arhzp", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $799a0e0be31b1662$export$d567d2b9af322f8f);

var $297cv = parcelRequire("297cv");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $799a0e0be31b1662$var$createListenerCollection() {
    var batch = (0, $297cv.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $799a0e0be31b1662$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $799a0e0be31b1662$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $799a0e0be31b1662$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $799a0e0be31b1662$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $799a0e0be31b1662$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("297cv", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $190201f2d37d6502$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $190201f2d37d6502$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $190201f2d37d6502$var$defaultNoopBatch(callback) {
    callback();
}
var $190201f2d37d6502$var$batch = $190201f2d37d6502$var$defaultNoopBatch; // Allow injecting another batching function later
var $190201f2d37d6502$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $190201f2d37d6502$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $190201f2d37d6502$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $190201f2d37d6502$var$batch;
};

});


parcelRegister("gneWW", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $beba64068692f8ee$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $beba64068692f8ee$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);

});


parcelRegister("evQWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90d08332793f660$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $dY8Js = parcelRequire("dY8Js");

var $5uXOq = parcelRequire("5uXOq");

var $bCzx0 = parcelRequire("bCzx0");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");

var $eZhPT = parcelRequire("eZhPT");
var $a90d08332793f660$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $a90d08332793f660$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $a90d08332793f660$var$EMPTY_ARRAY = [];
var $a90d08332793f660$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $a90d08332793f660$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $a90d08332793f660$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $a90d08332793f660$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $a90d08332793f660$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $a90d08332793f660$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $a90d08332793f660$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $eZhPT.ReactReduxContext) : _ref2$context, connectOptions = (0, $ddEsc.default)(_ref2, $a90d08332793f660$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $bS32t.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $5uXOq.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $5uXOq.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $ddEsc.default)(props, $a90d08332793f660$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $5uXOq.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $bCzx0.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $5uXOq.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $5uXOq.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $5uXOq.useMemo)(function() {
                if (!shouldHandleStateChanges) return $a90d08332793f660$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $arhzp.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $5uXOq.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $bS32t.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $5uXOq.useReducer)($a90d08332793f660$var$storeStateUpdatesReducer, $a90d08332793f660$var$EMPTY_ARRAY, $a90d08332793f660$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $5uXOq.useRef)();
            var lastWrapperProps = (0, $5uXOq.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $5uXOq.useRef)();
            var renderIsScheduled = (0, $5uXOq.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs($a90d08332793f660$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs($a90d08332793f660$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $5uXOq.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, (0, $bS32t.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $5uXOq.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Connect, (0, $bS32t.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("bCzx0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dJaa4"));

});
parcelRegister("dJaa4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $9fe75c2c5f477da2$export$a7c73072b1a182ae, (v) => $9fe75c2c5f477da2$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9fe75c2c5f477da2$export$9f27bc3417b4524d, (v) => $9fe75c2c5f477da2$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9fe75c2c5f477da2$export$db77ccec0bb4ccac, (v) => $9fe75c2c5f477da2$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9fe75c2c5f477da2$export$8392c0c9d3dcbd35, (v) => $9fe75c2c5f477da2$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9fe75c2c5f477da2$export$ffb0004e005737fa, (v) => $9fe75c2c5f477da2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9fe75c2c5f477da2$export$b624eff549462981, (v) => $9fe75c2c5f477da2$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9fe75c2c5f477da2$export$7897aa7841a5380c, (v) => $9fe75c2c5f477da2$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9fe75c2c5f477da2$export$602eac185826482c, (v) => $9fe75c2c5f477da2$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9fe75c2c5f477da2$export$e2c29f18771995cb, (v) => $9fe75c2c5f477da2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9fe75c2c5f477da2$export$5f8d39834fd61797, (v) => $9fe75c2c5f477da2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9fe75c2c5f477da2$export$74bf444e3cd11ea5, (v) => $9fe75c2c5f477da2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9fe75c2c5f477da2$export$92387174baf9b227, (v) => $9fe75c2c5f477da2$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9fe75c2c5f477da2$export$ec112efeb987d9c6, (v) => $9fe75c2c5f477da2$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9fe75c2c5f477da2$export$b706b080d889d2c9, (v) => $9fe75c2c5f477da2$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9fe75c2c5f477da2$export$5be5a87408f70ddc, (v) => $9fe75c2c5f477da2$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9fe75c2c5f477da2$export$45a5e7f76e0caa8d, (v) => $9fe75c2c5f477da2$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9fe75c2c5f477da2$export$455c2e768291efa6, (v) => $9fe75c2c5f477da2$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9fe75c2c5f477da2$export$9522e17588c12572, (v) => $9fe75c2c5f477da2$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9fe75c2c5f477da2$export$2110ac352bb060b9, (v) => $9fe75c2c5f477da2$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9fe75c2c5f477da2$export$56885ab8b9c456ab, (v) => $9fe75c2c5f477da2$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9fe75c2c5f477da2$export$d927fcb6adf8f9de, (v) => $9fe75c2c5f477da2$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9fe75c2c5f477da2$export$b82d16f27459e05a, (v) => $9fe75c2c5f477da2$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9fe75c2c5f477da2$export$522c17b4f5e123e8, (v) => $9fe75c2c5f477da2$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9fe75c2c5f477da2$export$1aabd8a0274ecfd6, (v) => $9fe75c2c5f477da2$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9fe75c2c5f477da2$export$9b621391a187a31a, (v) => $9fe75c2c5f477da2$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9fe75c2c5f477da2$export$f5bbd400c2f4426f, (v) => $9fe75c2c5f477da2$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9fe75c2c5f477da2$export$a7c73072b1a182ae;
var $9fe75c2c5f477da2$export$9f27bc3417b4524d;
var $9fe75c2c5f477da2$export$db77ccec0bb4ccac;
var $9fe75c2c5f477da2$export$8392c0c9d3dcbd35;
var $9fe75c2c5f477da2$export$ffb0004e005737fa;
var $9fe75c2c5f477da2$export$b624eff549462981;
var $9fe75c2c5f477da2$export$7897aa7841a5380c;
var $9fe75c2c5f477da2$export$602eac185826482c;
var $9fe75c2c5f477da2$export$e2c29f18771995cb;
var $9fe75c2c5f477da2$export$5f8d39834fd61797;
var $9fe75c2c5f477da2$export$74bf444e3cd11ea5;
var $9fe75c2c5f477da2$export$92387174baf9b227;
var $9fe75c2c5f477da2$export$ec112efeb987d9c6;
var $9fe75c2c5f477da2$export$b706b080d889d2c9;
var $9fe75c2c5f477da2$export$5be5a87408f70ddc;
var $9fe75c2c5f477da2$export$45a5e7f76e0caa8d;
var $9fe75c2c5f477da2$export$455c2e768291efa6;
var $9fe75c2c5f477da2$export$9522e17588c12572;
var $9fe75c2c5f477da2$export$2110ac352bb060b9;
var $9fe75c2c5f477da2$export$56885ab8b9c456ab;
var $9fe75c2c5f477da2$export$d927fcb6adf8f9de;
var $9fe75c2c5f477da2$export$b82d16f27459e05a;
var $9fe75c2c5f477da2$export$522c17b4f5e123e8;
var $9fe75c2c5f477da2$export$1aabd8a0274ecfd6;
var $9fe75c2c5f477da2$export$9b621391a187a31a;
var $9fe75c2c5f477da2$export$f5bbd400c2f4426f;
'use strict';
var $9fe75c2c5f477da2$var$b = 60103, $9fe75c2c5f477da2$var$c = 60106, $9fe75c2c5f477da2$var$d = 60107, $9fe75c2c5f477da2$var$e = 60108, $9fe75c2c5f477da2$var$f = 60114, $9fe75c2c5f477da2$var$g = 60109, $9fe75c2c5f477da2$var$h = 60110, $9fe75c2c5f477da2$var$k = 60112, $9fe75c2c5f477da2$var$l = 60113, $9fe75c2c5f477da2$var$m = 60120, $9fe75c2c5f477da2$var$n = 60115, $9fe75c2c5f477da2$var$p = 60116, $9fe75c2c5f477da2$var$q = 60121, $9fe75c2c5f477da2$var$r = 60122, $9fe75c2c5f477da2$var$u = 60117, $9fe75c2c5f477da2$var$v = 60129, $9fe75c2c5f477da2$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $9fe75c2c5f477da2$var$x = Symbol.for;
    $9fe75c2c5f477da2$var$b = $9fe75c2c5f477da2$var$x("react.element");
    $9fe75c2c5f477da2$var$c = $9fe75c2c5f477da2$var$x("react.portal");
    $9fe75c2c5f477da2$var$d = $9fe75c2c5f477da2$var$x("react.fragment");
    $9fe75c2c5f477da2$var$e = $9fe75c2c5f477da2$var$x("react.strict_mode");
    $9fe75c2c5f477da2$var$f = $9fe75c2c5f477da2$var$x("react.profiler");
    $9fe75c2c5f477da2$var$g = $9fe75c2c5f477da2$var$x("react.provider");
    $9fe75c2c5f477da2$var$h = $9fe75c2c5f477da2$var$x("react.context");
    $9fe75c2c5f477da2$var$k = $9fe75c2c5f477da2$var$x("react.forward_ref");
    $9fe75c2c5f477da2$var$l = $9fe75c2c5f477da2$var$x("react.suspense");
    $9fe75c2c5f477da2$var$m = $9fe75c2c5f477da2$var$x("react.suspense_list");
    $9fe75c2c5f477da2$var$n = $9fe75c2c5f477da2$var$x("react.memo");
    $9fe75c2c5f477da2$var$p = $9fe75c2c5f477da2$var$x("react.lazy");
    $9fe75c2c5f477da2$var$q = $9fe75c2c5f477da2$var$x("react.block");
    $9fe75c2c5f477da2$var$r = $9fe75c2c5f477da2$var$x("react.server.block");
    $9fe75c2c5f477da2$var$u = $9fe75c2c5f477da2$var$x("react.fundamental");
    $9fe75c2c5f477da2$var$v = $9fe75c2c5f477da2$var$x("react.debug_trace_mode");
    $9fe75c2c5f477da2$var$w = $9fe75c2c5f477da2$var$x("react.legacy_hidden");
}
function $9fe75c2c5f477da2$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $9fe75c2c5f477da2$var$b:
                switch(a = a.type, a){
                    case $9fe75c2c5f477da2$var$d:
                    case $9fe75c2c5f477da2$var$f:
                    case $9fe75c2c5f477da2$var$e:
                    case $9fe75c2c5f477da2$var$l:
                    case $9fe75c2c5f477da2$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9fe75c2c5f477da2$var$h:
                            case $9fe75c2c5f477da2$var$k:
                            case $9fe75c2c5f477da2$var$p:
                            case $9fe75c2c5f477da2$var$n:
                            case $9fe75c2c5f477da2$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $9fe75c2c5f477da2$var$c:
                return t;
        }
    }
}
var $9fe75c2c5f477da2$var$z = $9fe75c2c5f477da2$var$g, $9fe75c2c5f477da2$var$A = $9fe75c2c5f477da2$var$b, $9fe75c2c5f477da2$var$B = $9fe75c2c5f477da2$var$k, $9fe75c2c5f477da2$var$C = $9fe75c2c5f477da2$var$d, $9fe75c2c5f477da2$var$D = $9fe75c2c5f477da2$var$p, $9fe75c2c5f477da2$var$E = $9fe75c2c5f477da2$var$n, $9fe75c2c5f477da2$var$F = $9fe75c2c5f477da2$var$c, $9fe75c2c5f477da2$var$G = $9fe75c2c5f477da2$var$f, $9fe75c2c5f477da2$var$H = $9fe75c2c5f477da2$var$e, $9fe75c2c5f477da2$var$I = $9fe75c2c5f477da2$var$l;
$9fe75c2c5f477da2$export$a7c73072b1a182ae = $9fe75c2c5f477da2$var$h;
$9fe75c2c5f477da2$export$9f27bc3417b4524d = $9fe75c2c5f477da2$var$z;
$9fe75c2c5f477da2$export$db77ccec0bb4ccac = $9fe75c2c5f477da2$var$A;
$9fe75c2c5f477da2$export$8392c0c9d3dcbd35 = $9fe75c2c5f477da2$var$B;
$9fe75c2c5f477da2$export$ffb0004e005737fa = $9fe75c2c5f477da2$var$C;
$9fe75c2c5f477da2$export$b624eff549462981 = $9fe75c2c5f477da2$var$D;
$9fe75c2c5f477da2$export$7897aa7841a5380c = $9fe75c2c5f477da2$var$E;
$9fe75c2c5f477da2$export$602eac185826482c = $9fe75c2c5f477da2$var$F;
$9fe75c2c5f477da2$export$e2c29f18771995cb = $9fe75c2c5f477da2$var$G;
$9fe75c2c5f477da2$export$5f8d39834fd61797 = $9fe75c2c5f477da2$var$H;
$9fe75c2c5f477da2$export$74bf444e3cd11ea5 = $9fe75c2c5f477da2$var$I;
$9fe75c2c5f477da2$export$92387174baf9b227 = function() {
    return !1;
};
$9fe75c2c5f477da2$export$ec112efeb987d9c6 = function() {
    return !1;
};
$9fe75c2c5f477da2$export$b706b080d889d2c9 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$h;
};
$9fe75c2c5f477da2$export$5be5a87408f70ddc = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$g;
};
$9fe75c2c5f477da2$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9fe75c2c5f477da2$var$b;
};
$9fe75c2c5f477da2$export$455c2e768291efa6 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$k;
};
$9fe75c2c5f477da2$export$9522e17588c12572 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$d;
};
$9fe75c2c5f477da2$export$2110ac352bb060b9 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$p;
};
$9fe75c2c5f477da2$export$56885ab8b9c456ab = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$n;
};
$9fe75c2c5f477da2$export$d927fcb6adf8f9de = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$c;
};
$9fe75c2c5f477da2$export$b82d16f27459e05a = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$f;
};
$9fe75c2c5f477da2$export$522c17b4f5e123e8 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$e;
};
$9fe75c2c5f477da2$export$1aabd8a0274ecfd6 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$l;
};
$9fe75c2c5f477da2$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9fe75c2c5f477da2$var$d || a === $9fe75c2c5f477da2$var$f || a === $9fe75c2c5f477da2$var$v || a === $9fe75c2c5f477da2$var$e || a === $9fe75c2c5f477da2$var$l || a === $9fe75c2c5f477da2$var$m || a === $9fe75c2c5f477da2$var$w || "object" === typeof a && null !== a && (a.$$typeof === $9fe75c2c5f477da2$var$p || a.$$typeof === $9fe75c2c5f477da2$var$n || a.$$typeof === $9fe75c2c5f477da2$var$g || a.$$typeof === $9fe75c2c5f477da2$var$h || a.$$typeof === $9fe75c2c5f477da2$var$k || a.$$typeof === $9fe75c2c5f477da2$var$u || a.$$typeof === $9fe75c2c5f477da2$var$q || a[0] === $9fe75c2c5f477da2$var$r) ? !0 : !1;
};
$9fe75c2c5f477da2$export$f5bbd400c2f4426f = $9fe75c2c5f477da2$var$y;

});



parcelRegister("AuRrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $06db4d47a421a2eb$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $evQWN = parcelRequire("evQWN");

var $ggTLx = parcelRequire("ggTLx");

var $aRR2I = parcelRequire("aRR2I");

var $li0D7 = parcelRequire("li0D7");

var $3zSL8 = parcelRequire("3zSL8");

var $aQWN9 = parcelRequire("aQWN9");
var $06db4d47a421a2eb$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $06db4d47a421a2eb$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $06db4d47a421a2eb$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $06db4d47a421a2eb$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $evQWN.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $li0D7.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $aRR2I.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $3zSL8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $aQWN9.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $06db4d47a421a2eb$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $ggTLx.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $ggTLx.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $ggTLx.default) : _ref3$areMergedPropsE, extraOptions = (0, $ddEsc.default)(_ref3, $06db4d47a421a2eb$var$_excluded);
        var initMapStateToProps = $06db4d47a421a2eb$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $06db4d47a421a2eb$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $06db4d47a421a2eb$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $bS32t.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $06db4d47a421a2eb$export$2e2bcd8739ae039 = /*#__PURE__*/ $06db4d47a421a2eb$export$9f9feb656dec1fc4();

});
parcelRegister("ggTLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8965e05453892e$export$2e2bcd8739ae039);
function $bd8965e05453892e$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $bd8965e05453892e$export$2e2bcd8739ae039(objA, objB) {
    if ($bd8965e05453892e$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$bd8965e05453892e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("aRR2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e97ffd151087114$export$2e2bcd8739ae039);

var $a37gJ = parcelRequire("a37gJ");

var $8EqLJ = parcelRequire("8EqLJ");
function $7e97ffd151087114$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $8EqLJ.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $7e97ffd151087114$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $8EqLJ.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $7e97ffd151087114$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $8EqLJ.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $a37gJ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $7e97ffd151087114$export$2e2bcd8739ae039 = [
    $7e97ffd151087114$export$a9f27b4b187c1166,
    $7e97ffd151087114$export$ba20d1a7aa0c4a90,
    $7e97ffd151087114$export$94a6e55709d4d961
];

});
parcelRegister("a37gJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $750fd2a673ba963c$export$2e2bcd8739ae039);
function $750fd2a673ba963c$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("8EqLJ", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $64c6d2e3c8e9f263$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $64c6d2e3c8e9f263$export$8d46c7f53c8c602f);
parcelRequire("1prLO");
function $64c6d2e3c8e9f263$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $64c6d2e3c8e9f263$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $64c6d2e3c8e9f263$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $64c6d2e3c8e9f263$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $64c6d2e3c8e9f263$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("1prLO", function(module, exports) {

var $im3MO = parcelRequire("im3MO");

var $kb4xC = parcelRequire("kb4xC");
function $106daad597fc23e6$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $im3MO.default)(value)) (0, $kb4xC.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("im3MO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cd37f6759c7272$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $d5cd37f6759c7272$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("kb4xC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb085b81b2733980$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $eb085b81b2733980$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("li0D7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7fbc484b4e9d2ee$export$2e2bcd8739ae039);

var $8EqLJ = parcelRequire("8EqLJ");
function $f7fbc484b4e9d2ee$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $8EqLJ.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $f7fbc484b4e9d2ee$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $8EqLJ.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $f7fbc484b4e9d2ee$export$2e2bcd8739ae039 = [
    $f7fbc484b4e9d2ee$export$23fc470827b14aa,
    $f7fbc484b4e9d2ee$export$514bc8c1a53c1d66
];

});

parcelRegister("3zSL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $29af1e0b3bc3959e$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");
parcelRequire("1prLO");
function $29af1e0b3bc3959e$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $bS32t.default)({}, ownProps, stateProps, dispatchProps);
}
function $29af1e0b3bc3959e$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $29af1e0b3bc3959e$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $29af1e0b3bc3959e$export$5b105939c84b5234(mergeProps) : undefined;
}
function $29af1e0b3bc3959e$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $29af1e0b3bc3959e$export$691c327fc30bc857;
    } : undefined;
}
var $29af1e0b3bc3959e$export$2e2bcd8739ae039 = [
    $29af1e0b3bc3959e$export$d61b680184bc3f00,
    $29af1e0b3bc3959e$export$a13ba70ef50dda6d
];

});

parcelRegister("aQWN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6c5d8bc061ff2f$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");
parcelRequire("8XVVW");
var $7e6c5d8bc061ff2f$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $7e6c5d8bc061ff2f$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $7e6c5d8bc061ff2f$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $7e6c5d8bc061ff2f$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $ddEsc.default)(_ref2, $7e6c5d8bc061ff2f$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $7e6c5d8bc061ff2f$export$d20c0c2ca6eb2b6f : $7e6c5d8bc061ff2f$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("8XVVW", function(module, exports) {

var $kb4xC = parcelRequire("kb4xC");
function $6870c5d2f9dd91da$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $kb4xC.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $6870c5d2f9dd91da$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $6870c5d2f9dd91da$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $6870c5d2f9dd91da$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $6870c5d2f9dd91da$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("616sH", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4617d947d89cb783$export$8ad76b76a4c905f8);

var $eZhPT = parcelRequire("eZhPT");

var $5sekt = parcelRequire("5sekt");
function $4617d947d89cb783$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useStore = context === (0, $eZhPT.ReactReduxContext) ? (0, $5sekt.useStore) : (0, $5sekt.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4617d947d89cb783$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4617d947d89cb783$export$bc9b55530897c558();

});
parcelRegister("5sekt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $3f8aaec7bfa91a5f$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $3f8aaec7bfa91a5f$export$6ccbb43953eebf8);

var $5uXOq = parcelRequire("5uXOq");

var $eZhPT = parcelRequire("eZhPT");

var $i2tgo = parcelRequire("i2tgo");
function $3f8aaec7bfa91a5f$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useReduxContext = context === (0, $eZhPT.ReactReduxContext) ? (0, $i2tgo.useReduxContext) : function() {
        return (0, $5uXOq.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $3f8aaec7bfa91a5f$export$6ccbb43953eebf8 = /*#__PURE__*/ $3f8aaec7bfa91a5f$export$671dba69185d0304();

});
parcelRegister("i2tgo", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $d21f1d0198d74b68$export$c1275ca9a6fd3ec5);

var $5uXOq = parcelRequire("5uXOq");

var $eZhPT = parcelRequire("eZhPT");
function $d21f1d0198d74b68$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $5uXOq.useContext)((0, $eZhPT.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("6S8MB", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $500e9950191b49f8$export$2105062e25df4afe);

var $5uXOq = parcelRequire("5uXOq");

var $i2tgo = parcelRequire("i2tgo");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");

var $eZhPT = parcelRequire("eZhPT");
var $500e9950191b49f8$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $500e9950191b49f8$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $5uXOq.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $5uXOq.useMemo)(function() {
        return (0, $arhzp.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $5uXOq.useRef)();
    var latestSelector = (0, $5uXOq.useRef)();
    var latestStoreState = (0, $5uXOq.useRef)();
    var latestSelectedState = (0, $5uXOq.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $500e9950191b49f8$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useReduxContext = context === (0, $eZhPT.ReactReduxContext) ? (0, $i2tgo.useReduxContext) : function() {
        return (0, $5uXOq.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $500e9950191b49f8$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $500e9950191b49f8$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $5uXOq.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $500e9950191b49f8$export$2105062e25df4afe = /*#__PURE__*/ $500e9950191b49f8$export$2b53f90d2bd1cbfb();

});


parcelRegister("8mhVE", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("7nsd3")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $7nsd3 = parcelRequire("7nsd3");

});


parcelRegister("3YKxB", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $2e5b13c1f6ee9f8a$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $2e5b13c1f6ee9f8a$export$34928e660d2a8702);

var $3joPi = parcelRequire("3joPi");
var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $2e5b13c1f6ee9f8a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
    var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $3joPi.default)(false);
    return result;
};
var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
    return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
};
var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
    };
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("g7psY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bbc10ddfc67bca56$export$2e2bcd8739ae039);
var $bbc10ddfc67bca56$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $bbc10ddfc67bca56$var$isEqual(first, second) {
    if (first === second) return true;
    if ($bbc10ddfc67bca56$var$safeIsNaN(first) && $bbc10ddfc67bca56$var$safeIsNaN(second)) return true;
    return false;
}
function $bbc10ddfc67bca56$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$bbc10ddfc67bca56$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $bbc10ddfc67bca56$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $bbc10ddfc67bca56$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $bbc10ddfc67bca56$export$2e2bcd8739ae039 = $bbc10ddfc67bca56$var$memoizeOne;

});

parcelRegister("i2aN7", function(module, exports) {

module.exports = (parcelRequire("jptOl"));

});
parcelRegister("jptOl", function(module, exports) {
parcelRequire("a0Ixs");

module.exports = (parcelRequire("4KXzV")).Object.values;

});
parcelRegister("a0Ixs", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $fNMIk = parcelRequire("fNMIk");

var $749c73ef0828bdd4$var$$values = (parcelRequire("kQXku"))(false);
$fNMIk($fNMIk.S, 'Object', {
    values: function values(it) {
        return $749c73ef0828bdd4$var$$values(it);
    }
});

});
parcelRegister("kQXku", function(module, exports) {

var $aPbfY = parcelRequire("aPbfY");

var $iTod0 = parcelRequire("iTod0");

var $ehxEQ = parcelRequire("ehxEQ");

var $1paSc = parcelRequire("1paSc");
var $f2e6af8f0a9cbb36$require$isEnum = $1paSc.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $ehxEQ(it);
        var keys = $iTod0(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$aPbfY || $f2e6af8f0a9cbb36$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});




parcelRegister("cs3hJ", function(module, exports) {

module.exports = (parcelRequire("gtqo2"));

});
parcelRegister("gtqo2", function(module, exports) {
parcelRequire("jgnqd");

module.exports = (parcelRequire("4KXzV")).Object.keys;

});
parcelRegister("jgnqd", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $llAOy = parcelRequire("llAOy");

var $iTod0 = parcelRequire("iTod0");

(parcelRequire("4BA40"))('keys', function() {
    return function keys(it) {
        return $iTod0($llAOy(it));
    };
});

});
parcelRegister("4BA40", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $fNMIk = parcelRequire("fNMIk");

var $4KXzV = parcelRequire("4KXzV");

var $cKvWG = parcelRequire("cKvWG");
module.exports = function(KEY, exec) {
    var fn = ($4KXzV.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $fNMIk($fNMIk.S + $fNMIk.F * $cKvWG(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("7qpjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $567e981b5ef77433$export$2e2bcd8739ae039);
var $567e981b5ef77433$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $567e981b5ef77433$export$2e2bcd8739ae039 = $567e981b5ef77433$var$rafSchd;

});

parcelRegister("3BSY2", function(module, exports) {

module.exports = (parcelRequire("4JOv4"));

});
parcelRegister("4JOv4", function(module, exports) {
parcelRequire("ixUy6");

module.exports = (parcelRequire("4KXzV")).Date.now;

});
parcelRegister("ixUy6", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $fNMIk = parcelRequire("fNMIk");
$fNMIk($fNMIk.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});



parcelRegister("1DIXK", function(module, exports) {

module.exports = (parcelRequire("izccK"));

});
parcelRegister("izccK", function(module, exports) {
parcelRequire("bwyHq");

module.exports = (parcelRequire("4KXzV")).Number.isInteger;

});
parcelRegister("bwyHq", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S, 'Number', {
    isInteger: (parcelRequire("dFLKl"))
});

});
parcelRegister("dFLKl", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $dxLeJ = parcelRequire("dxLeJ");
var $9f4424297502c7e8$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$dxLeJ(it) && isFinite(it) && $9f4424297502c7e8$var$floor(it) === it;
};

});





parcelRegister("99M5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aaa418e9a366cd8$var$_react = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6aaa418e9a366cd8$var$_add = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $6aaa418e9a366cd8$var$_add2 = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("7ymNM")));
function $6aaa418e9a366cd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aaa418e9a366cd8$var$AddIcon = (props)=>/*#__PURE__*/ $6aaa418e9a366cd8$var$_react.default.createElement($6aaa418e9a366cd8$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $6aaa418e9a366cd8$var$_add2.default
    }, props));
$6aaa418e9a366cd8$var$AddIcon.Name = 'AddIconMigration';
var $6aaa418e9a366cd8$var$_default = module.exports.default = $6aaa418e9a366cd8$var$AddIcon;

});
parcelRegister("7ymNM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
function $57fd655943aa23fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57fd655943aa23fe$var$AddIcon = (props)=>/*#__PURE__*/ $57fd655943aa23fe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $57fd655943aa23fe$var$_add.default
    }));
$57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;

});


parcelRegister("kvQS7", function(module, exports) {

$parcel$export(module.exports, "useKbCreateCategoryActions", () => $fefcd82701364dc4$export$719df9e736f08a9);
$parcel$export(module.exports, "KbCreateCategorySubscriber", () => $fefcd82701364dc4$export$2b9cf8c256011b51);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $fefcd82701364dc4$export$d4c72bab9d6cc13a = {
    isOpen: false
};
const $fefcd82701364dc4$var$setCreateCategoryDisplay = (isOpen)=>({ setState: setState })=>{
        setState({
            isOpen: isOpen
        });
    };
const $fefcd82701364dc4$export$e324594224ef24da = {
    setCreateCategoryDisplay: $fefcd82701364dc4$var$setCreateCategoryDisplay
};
const $fefcd82701364dc4$var$Store = (0, $iXqE5.createStore)({
    name: 'kb-create-category',
    initialState: $fefcd82701364dc4$export$d4c72bab9d6cc13a,
    actions: $fefcd82701364dc4$export$e324594224ef24da
});
const $fefcd82701364dc4$export$719df9e736f08a9 = (0, $3sQ5x.createHook)($fefcd82701364dc4$var$Store, {
    selector: null
});
const $fefcd82701364dc4$export$2b9cf8c256011b51 = (0, $51nlc.createSubscriber)($fefcd82701364dc4$var$Store);

});

parcelRegister("2WqFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bf020f3f366501$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $29jfS = parcelRequire("29jfS");
const $18bf020f3f366501$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $29jfS.fetchAiEnablement)(jiraProduct, version);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $18bf020f3f366501$export$2e2bcd8739ae039 = $18bf020f3f366501$var$useIsAdminHubAIEnabled;

});
parcelRegister("29jfS", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $f8e2a461a4c2e420$export$ad4105850d0ce824);

var $7f4tk = parcelRequire("7f4tk");
const $f8e2a461a4c2e420$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $f8e2a461a4c2e420$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $f8e2a461a4c2e420$export$2171a423b572256a(jiraProduct, version);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("lw2HC", function(module, exports) {

$parcel$export(module.exports, "initialCreateCategoryData", () => $ba746da67c53f4b3$export$4947e9942a5d137c);
$parcel$export(module.exports, "KnowledgeCommonSubscriber", () => $ba746da67c53f4b3$export$d226f0c95b79366b);
$parcel$export(module.exports, "UserCapabilitiesSubscriber", () => $ba746da67c53f4b3$export$42b7b5df8c1dee52);
$parcel$export(module.exports, "useFlagData", () => $ba746da67c53f4b3$export$a9ac4a6dcb7104bf);
$parcel$export(module.exports, "useGetCategory", () => $ba746da67c53f4b3$export$3fa52226f8fff61e);
$parcel$export(module.exports, "useDraftShareId", () => $ba746da67c53f4b3$export$2602997fd4d9b312);
$parcel$export(module.exports, "useArticleId", () => $ba746da67c53f4b3$export$a5eb46485735066a);
$parcel$export(module.exports, "useIsFetchingDraftDetails", () => $ba746da67c53f4b3$export$428db75bed41f9d);
$parcel$export(module.exports, "useRedirectionData", () => $ba746da67c53f4b3$export$e30071c464cba7f9);
$parcel$export(module.exports, "useUserCapabilities", () => $ba746da67c53f4b3$export$7ae10e817e068c57);
$parcel$export(module.exports, "useIsPermittedSpaces", () => $ba746da67c53f4b3$export$60270d772f1f3c76);
$parcel$export(module.exports, "useCategoriesData", () => $ba746da67c53f4b3$export$56b47c5ebac10997);
$parcel$export(module.exports, "useCreateCategoryData", () => $ba746da67c53f4b3$export$1e7300097c003415);
$parcel$export(module.exports, "useSuggestedTopics", () => $ba746da67c53f4b3$export$2328a37d3e371b67);
$parcel$export(module.exports, "usePageNumber", () => $ba746da67c53f4b3$export$1571508029b597f4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $kz5Uo = parcelRequire("kz5Uo");

var $cSB1I = parcelRequire("cSB1I");
const $ba746da67c53f4b3$export$61e797cf03b496e1 = {
    hasConfluenceLicense: false,
    articleUserCapabilities: {
        canCreateArticle: false
    },
    spaceUserCapabilities: {
        editableSpaces: [],
        readableSpaces: []
    }
};
const $ba746da67c53f4b3$export$4947e9942a5d137c = {
    isSubmitting: false,
    formValues: {
        name: '',
        description: ''
    },
    error: {
        formError: undefined,
        fieldErrors: undefined
    },
    createdCategory: null
};
const $ba746da67c53f4b3$export$d4c72bab9d6cc13a = {
    draftShareId: '',
    articleId: '',
    published: false,
    closed: false,
    deleted: false,
    redirectionData: {
        onPublishRedirectUrl: '',
        onCloseRedirectUrl: ''
    },
    isFetchingDraftDetails: false,
    spacesPermitted: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    permittedSpaces: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    userCapabilities: {
        isLoading: false,
        error: null,
        data: {
            ...$ba746da67c53f4b3$export$61e797cf03b496e1
        }
    },
    linkedSpaces: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    showConfluenceCreatePageError: false,
    categoriesData: {
        isLoading: true,
        categories: [],
        isCategoriesSupported: false,
        error: null
    },
    createCategoryData: {
        ...$ba746da67c53f4b3$export$4947e9942a5d137c
    },
    spaceKey: '',
    flags: [],
    topics: {
        data: [],
        loading: false,
        error: null
    },
    page: 1
};
const $ba746da67c53f4b3$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $ba746da67c53f4b3$export$d4c72bab9d6cc13a,
    actions: $kz5Uo.actions,
    name: 'KnowledgeCommonStore'
});
const $ba746da67c53f4b3$export$d226f0c95b79366b = (0, $51nlc.createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9);
const $ba746da67c53f4b3$export$42b7b5df8c1dee52 = (0, $51nlc.createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    displayName: 'UserCapabilitiesSubscriber',
    selector: (0, $cSB1I.getUserCapabilities)
});
const $ba746da67c53f4b3$export$a3c47cea95d8bbd1 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCommonFlags)
});
const $ba746da67c53f4b3$export$a9ac4a6dcb7104bf = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getKnowledgeCommonFlags)
});
const $ba746da67c53f4b3$export$3fa52226f8fff61e = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCategory)
});
const $ba746da67c53f4b3$export$2602997fd4d9b312 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getDraftShareId)
});
const $ba746da67c53f4b3$export$a5eb46485735066a = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getArticleId)
});
const $ba746da67c53f4b3$export$428db75bed41f9d = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getIsFetchingDraftDetails)
});
const $ba746da67c53f4b3$export$e30071c464cba7f9 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getRedirectionData)
});
const $ba746da67c53f4b3$export$7ae10e817e068c57 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getUserCapabilities)
});
const $ba746da67c53f4b3$export$60270d772f1f3c76 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getPermittedSpaces)
});
const $ba746da67c53f4b3$export$40685b8df387d08 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getLinkedSpaces)
});
const $ba746da67c53f4b3$export$56b47c5ebac10997 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCategoriesData)
});
const $ba746da67c53f4b3$export$1e7300097c003415 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCreateCategoryData)
});
const $ba746da67c53f4b3$export$2328a37d3e371b67 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getSuggestedTopics)
});
const $ba746da67c53f4b3$export$1571508029b597f4 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getPageNumber)
});

});
parcelRegister("kz5Uo", function(module, exports) {

$parcel$export(module.exports, "actions", () => $78ea76781fae4c5f$export$e324594224ef24da);

var $lx7EO = parcelRequire("lx7EO");

var $heXZI = parcelRequire("heXZI");

var $dsFMC = parcelRequire("dsFMC");

var $aInVL = parcelRequire("aInVL");

var $3twc2 = parcelRequire("3twc2");

var $klUDT = parcelRequire("klUDT");

var $2tTYZ = parcelRequire("2tTYZ");

var $ik7FP = parcelRequire("ik7FP");

var $dAXEk = parcelRequire("dAXEk");

var $fMz1O = parcelRequire("fMz1O");

var $dIiIO = parcelRequire("dIiIO");

var $gpe3Z = parcelRequire("gpe3Z");

var $1TU0Q = parcelRequire("1TU0Q");

var $jIuZj = parcelRequire("jIuZj");

var $eP4xZ = parcelRequire("eP4xZ");

var $8QyFO = parcelRequire("8QyFO");

var $6ThCP = parcelRequire("6ThCP");

var $1VmcQ = parcelRequire("1VmcQ");
const $78ea76781fae4c5f$export$e324594224ef24da = {
    setRedirectionData: $1TU0Q.setRedirectionData,
    resetRedirectionData: $1TU0Q.resetRedirectionData,
    publishSuccess: $aInVL.publishSuccess,
    savedSuccess: $3twc2.savedSuccess,
    fetchDraftAndNavigateToEditor: $ik7FP.fetchDraftAndNavigateToEditor,
    navigateCreateDraftRoute: $gpe3Z.navigateCreateDraftRoute,
    fetchCreateArticlePermission: $2tTYZ.fetchCreateArticlePermission,
    fetchLinkedSpaces: $dAXEk.fetchLinkedSpaces,
    resetDraftArticleData: $8QyFO.resetDraftArticleData,
    articleDeleteSuccess: $lx7EO.articleDeleteSuccess,
    fetchUserCapabilities: $dIiIO.fetchUserCapabilities,
    fetchCategories: $klUDT.fetchCategories,
    reorderCategories: $eP4xZ.reorderCategories,
    createCategory: $heXZI.createCategory,
    handleFormInputChange: $heXZI.handleFormInputChange,
    resetCreatedCategory: $heXZI.resetCreatedCategory,
    updateCategorySuccess: $1VmcQ.updateCategorySuccess,
    deleteCategorySuccess: $dsFMC.deleteCategorySuccess,
    removeCommonFlag: $jIuZj.removeCommonFlag,
    fetchSuggestedTopics: $fMz1O.fetchSuggestedTopics,
    setPagination: $6ThCP.setPagination
};

});
parcelRegister("lx7EO", function(module, exports) {

$parcel$export(module.exports, "articleDeleteSuccess", () => $cfa855108534d4c5$export$7e6f4a244457270c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cfa855108534d4c5$export$7e6f4a244457270c = (articleId)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            deleted: true,
            articleId: articleId
        });
    };

});

parcelRegister("heXZI", function(module, exports) {

$parcel$export(module.exports, "createCategory", () => $015500bcb6a585cb$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "handleFormInputChange", () => $015500bcb6a585cb$export$8e52c4bd9075cb96);
$parcel$export(module.exports, "resetCreatedCategory", () => $015500bcb6a585cb$export$98485bfbe8c8269a);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $fPjip = parcelRequire("fPjip");


var $j8qrr = parcelRequire("j8qrr");

var $lw2HC = parcelRequire("lw2HC");
const $015500bcb6a585cb$export$7ce9dbcc6d544b1 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
        const { formValues: formValues } = {
            ...getState().createCategoryData
        };
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                isSubmitting: true
            }
        });
        try {
            const category = await (0, $j8qrr.createCategory)(projectId, formValues, activationId);
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...getState().categoriesData.categories,
                        category
                    ]
                },
                createCategoryData: {
                    ...(0, $lw2HC.initialCreateCategoryData),
                    createdCategory: category
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'categoryCreate success');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const { fieldErrors: fieldErrors, formError: formError } = (0, $fPjip.toErrors)(error);
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    isSubmitting: false,
                    error: {
                        formError: formError,
                        fieldErrors: fieldErrors
                    }
                }
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'categoryCreate',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };
const $015500bcb6a585cb$export$8e52c4bd9075cb96 = (field, value)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                formValues: {
                    ...getState().createCategoryData.formValues,
                    [field]: value
                }
            }
        });
    };
const $015500bcb6a585cb$export$98485bfbe8c8269a = ()=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                createdCategory: null
            }
        });
    };

});
parcelRegister("fPjip", function(module, exports) {

$parcel$export(module.exports, "toErrors", () => $fdef67eb1eab7980$export$b0ccdd1765e7cb42);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $i2U8h = parcelRequire("i2U8h");

var $guSo6 = parcelRequire("guSo6");
// Ideally JSD Apollo would have i18n in their error messages, however in the absence of that
// we do a conversion here.
const $fdef67eb1eab7980$var$errorKeyToMessage = {
    'jsd.apollo.error.limit.exceeded': (0, $i2U8h.default).categoriesLimitExceeded,
    'jsd.apollo.error.project.permission.no.view.project.permission': (0, $i2U8h.default).categoriesNoPermission,
    'jsd.apollo.field.error.category.name.cannot.be.blank': (0, $i2U8h.default).categoriesNameFieldBlank,
    'jsd.apollo.field.error.category.exceeded.name.length': (0, $i2U8h.default).categoriesNameFieldTooLong,
    'jsd.apollo.field.error.category.description.cannot.be.blank': (0, $i2U8h.default).categoriesDescriptionFieldBlank,
    'jsd.apollo.field.error.category.exceeded.description.length': (0, $i2U8h.default).categoriesDescriptionFieldTooLong
};
const $fdef67eb1eab7980$export$b0ccdd1765e7cb42 = (errorResponse)=>{
    const fieldErrorsResponse = errorResponse.fieldErrors || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldErrors = Object.keys(fieldErrorsResponse).reduce((acc, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [field]: {
                message: // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
                $fdef67eb1eab7980$var$errorKeyToMessage[fieldErrorsResponse[field].errorKey] || (0, $i2U8h.default).categoriesGenericMessage
            }
        }), {});
    const formError = errorResponse.errorKey ? {
        message: // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
        $fdef67eb1eab7980$var$errorKeyToMessage[errorResponse.errorKey] || (0, $i2U8h.default).categoriesGenericMessage
    } : undefined;
    return {
        formError: formError,
        fieldErrors: fieldErrors
    };
};
const $fdef67eb1eab7980$export$7ce9dbcc6d544b1 = (projectId, activationId, payload)=>(0, $guSo6.createCategory)(projectId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw({
            nativeError: errorResponse,
            formattedError: $fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)
        }));
const $fdef67eb1eab7980$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload)=>(0, $guSo6.updateCategory)(projectId, categoryId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw($fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)));

});
parcelRegister("i2U8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed327d012ea36dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6ed327d012ea36dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    categoriesGenericMessage: {
        "id": "servicedesk-knowledge-services.categories-generic-message",
        "defaultMessage": "We couldn't create the category. Wait a moment, then try again."
    },
    categoriesNoPermission: {
        "id": "servicedesk-knowledge-services.categories-no-permission",
        "defaultMessage": "You'll need to be an agent to create a category. Ask an admin to check your permissions."
    },
    categoriesLimitExceeded: {
        "id": "servicedesk-knowledge-services.categories-limit-exceeded",
        "defaultMessage": "You have exceeded the maximum number of categories for this project. The maximum number of categories per project is 30."
    },
    categoriesNameFieldBlank: {
        "id": "servicedesk-knowledge-services.categories-name-field-blank",
        "defaultMessage": "Name cannot be blank"
    },
    categoriesDescriptionFieldBlank: {
        "id": "servicedesk-knowledge-services.categories-description-field-blank",
        "defaultMessage": "Description cannot be blank"
    },
    categoriesNameFieldTooLong: {
        "id": "servicedesk-knowledge-services.categories-name-field-too-long",
        "defaultMessage": "Name cannot be longer than 100 characters"
    },
    categoriesDescriptionFieldTooLong: {
        "id": "servicedesk-knowledge-services.categories-description-field-too-long",
        "defaultMessage": "Description cannot be longer than 150 characters"
    }
});

});

parcelRegister("guSo6", function(module, exports) {

$parcel$export(module.exports, "listCategories", () => $61a0664d6d43d351$export$db54be5b1772ef4b);
$parcel$export(module.exports, "createCategory", () => $61a0664d6d43d351$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "updateCategory", () => $61a0664d6d43d351$export$daaacb0271870c9);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $5OrSA = parcelRequire("5OrSA");

var $2Lj35 = parcelRequire("2Lj35");

const $61a0664d6d43d351$export$db54be5b1772ef4b = (projectId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`);
};
const $61a0664d6d43d351$export$c0a90379dccf4f2f = (projectId, categoryId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category/`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}${(0, $2Lj35.categoryGuidToString)(categoryId)}`, {
        method: 'DELETE'
    });
};
const $61a0664d6d43d351$export$7ce9dbcc6d544b1 = (projectId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`, {
        method: 'POST',
        body: JSON.stringify(payload)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $61a0664d6d43d351$export$ce3ba7bb235ce057 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    let body = {
        articleId: articleId,
        featured: isFeatured
    };
    // @ts-expect-error - TS2322 - Type '{ spaceKey: string; articleId: string; featured: boolean | undefined; }' is not assignable to type '{ articleId: string; featured: boolean | undefined; }'.
    body = {
        ...body,
        spaceKey: spaceKey
    };
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/article`, {
        method: 'POST',
        body: JSON.stringify(body)
    });
};
const $61a0664d6d43d351$export$b6002acecf935894 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/spaceKey/${spaceKey}/article/${articleId}`, {
        method: 'DELETE'
    });
const $61a0664d6d43d351$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
const $61a0664d6d43d351$export$b9f575b5360cf530 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    let body = {
        featured: isFeatured
    };
    // @ts-expect-error - TS2322 - Type '{ spaceKey: string; featured: boolean; }' is not assignable to type '{ featured: boolean; }'.
    body = {
        ...body,
        spaceKey: spaceKey
    };
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/article/${articleId}`, {
        method: 'PUT',
        body: JSON.stringify(body)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $61a0664d6d43d351$export$e90b3dc42a0ddf96 = ({ projectId: projectId, categories: categories, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/order`, {
        method: 'PUT',
        body: JSON.stringify(categories)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));

});
parcelRegister("5OrSA", function(module, exports) {

$parcel$export(module.exports, "fetchJson$", () => $f90c86f7d1f72b9b$export$2ba52855e389d39e);
$parcel$export(module.exports, "fetchText$", () => $f90c86f7d1f72b9b$export$64ab95a52860b608);
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $561FV = parcelRequire("561FV");

var $kVLXA = parcelRequire("kVLXA");

var $487fd = parcelRequire("487fd");

var $7f4tk = parcelRequire("7f4tk");

var $7zmUm = parcelRequire("7zmUm");
const $f90c86f7d1f72b9b$var$buildErrorResponse = (message, statusCode, traceId)=>({
        response: {
            errors: [
                {
                    errorMessage: message
                }
            ],
            reasonKey: 'generic.error',
            reasonCode: `${statusCode}`
        },
        statusCode: statusCode,
        traceId: traceId
    });
const $f90c86f7d1f72b9b$var$toAnError = (error)=>{
    const traceId = error.traceId;
    try {
        // ServiceDesk REST errors be usually be in the form of a JSON
        // object (e.g., AnError).  We'll try to parse it.
        const response = JSON.parse(error.message);
        // Normalize the shape of "simple" JSON error responses containing
        // message and status-code, as used in e.g., standard Jira
        // unauthorized response.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(response, 'message') && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(response, 'status-code')) return $f90c86f7d1f72b9b$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
        return {
            response: response,
            statusCode: error.statusCode,
            traceId: traceId
        };
    } catch (e) {
        // Message didn't parse as JSON; assume it's a plain ol' string, and
        // we'll produce an AnError-like object with it.
        return $f90c86f7d1f72b9b$var$buildErrorResponse(error.message, error.statusCode, traceId);
    }
};
const $f90c86f7d1f72b9b$export$6d71b655afe1638d = (url, opts)=>(0, $7f4tk.default)(url, opts).catch((error)=>Promise.reject($f90c86f7d1f72b9b$var$toAnError(error)));
const $f90c86f7d1f72b9b$export$2ba52855e389d39e = (url, opts)=>(0, $487fd.default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
const $f90c86f7d1f72b9b$export$64ab95a52860b608 = (url, opts)=>(0, $7zmUm.default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});

parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});


parcelRegister("2Lj35", function(module, exports) {

$parcel$export(module.exports, "categoryGuidToString", () => $6a4fff955a10b2dc$export$43162cfd3260b2fe);
$parcel$export(module.exports, "toCategoryGuid", () => $6a4fff955a10b2dc$export$be5c80c4ad1faf99);
const $6a4fff955a10b2dc$export$804bcd2704a6d077 = (appLinkId)=>appLinkId;
const $6a4fff955a10b2dc$export$43162cfd3260b2fe = (guid)=>guid;
const $6a4fff955a10b2dc$export$be5c80c4ad1faf99 = (guid)=>guid;

});

const $45c806b56a43da0e$export$8ce6d23ffa1a190a = '/jsd-apollo';
const $45c806b56a43da0e$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';



const $d7e8e0de2b5415e5$export$d42203c46ecda0b5 = 'ncs';
const $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c = 'JSM';
const $d7e8e0de2b5415e5$export$a40257481ddef37e = 'atlassianAccount';
const $d7e8e0de2b5415e5$export$d57b6b390e78d90f = 'jsm-nebula';
const $d7e8e0de2b5415e5$export$85314a8fbb8155e1 = 'MONTHLY';
const $d7e8e0de2b5415e5$export$d1eb58f682ad65ad = 'ANNUAL';
const $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4 = 'INACTIVE';

parcelRegister("j8qrr", function(module, exports) {

$parcel$export(module.exports, "createCategory", () => $50b96e14ac428fad$export$7ce9dbcc6d544b1);

var $7f4tk = parcelRequire("7f4tk");

const $50b96e14ac428fad$export$f0b37505cff627e3 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
const $50b96e14ac428fad$export$7ce9dbcc6d544b1 = (projectId, payload, activationId)=>{
    const url = $50b96e14ac428fad$export$f0b37505cff627e3(projectId, activationId);
    return (0, $7f4tk.default)(url, {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("dsFMC", function(module, exports) {

$parcel$export(module.exports, "deleteCategorySuccess", () => $3c95377777bb5342$export$aa2eaa46022bd60b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3c95377777bb5342$export$aa2eaa46022bd60b = (categoryId)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: [
                    ...getState().categoriesData.categories.filter((category)=>category.id !== categoryId)
                ]
            }
        });
    };

});

parcelRegister("aInVL", function(module, exports) {

$parcel$export(module.exports, "publishSuccess", () => $7490ef4194dfdc47$export$a435a3808fe5155f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $7490ef4194dfdc47$export$a435a3808fe5155f = ({ articleId: articleId, draftShareId: draftShareId, spaceKey: spaceKey })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            published: true,
            articleId: articleId,
            draftShareId: draftShareId,
            spaceKey: spaceKey
        });
    };

});

parcelRegister("3twc2", function(module, exports) {

$parcel$export(module.exports, "savedSuccess", () => $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f = ({ articleId: articleId, draftShareId: draftShareId })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            closed: true,
            articleId: articleId,
            draftShareId: draftShareId
        });
    };

});

parcelRegister("klUDT", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $1022d05f23af34ff$export$416ec9f5729de215);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $1d66W = parcelRequire("1d66W");
const $1022d05f23af34ff$export$416ec9f5729de215 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...getState(),
            categoriesData: {
                ...initialState.categoriesData,
                isLoading: true
            }
        });
        try {
            const { categories: categories, categoriesSupported: categoriesSupported } = await (0, $1d66W.fetchCategories)(projectId, activationId);
            setState({
                ...getState(),
                categoriesData: {
                    categories: categories,
                    isCategoriesSupported: categoriesSupported,
                    isLoading: false,
                    error: null
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                categoriesData: {
                    ...initialState.categoriesData,
                    isLoading: false,
                    error: error
                }
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'onFetchCategoriesFailure',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("1d66W", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $b7d9de4ee333d2ce$export$416ec9f5729de215);

var $7f4tk = parcelRequire("7f4tk");

const $b7d9de4ee333d2ce$export$5cf4b2ebebe43941 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
const $b7d9de4ee333d2ce$export$416ec9f5729de215 = (projectId, activationId)=>{
    const url = $b7d9de4ee333d2ce$export$5cf4b2ebebe43941(projectId, activationId);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("2tTYZ", function(module, exports) {

$parcel$export(module.exports, "fetchCreateArticlePermission", () => $ac71c34762d51de0$export$c5bf032e1fb1ad18);

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $5ukFp = parcelRequire("5ukFp");
const $ac71c34762d51de0$var$EVENT_NAME = 'createPermissionsForSpace';
const $ac71c34762d51de0$export$c5bf032e1fb1ad18 = ({ cloudId: cloudId, spaceKeys: spaceKeys, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...initialState,
            spacesPermitted: {
                ...initialState.spacesPermitted,
                isLoading: true
            }
        });
        try {
            const { promotedSpaces: promotedSpaces } = await (0, $5ukFp.getCreatePermissionsForSpace)(cloudId, spaceKeys);
            const permittedSpaces = promotedSpaces.spaces.map(// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'text' implicitly has an 'any' type.
            ({ id: id, text: text })=>({
                    spaceKey: id,
                    spaceName: text
                }));
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: false,
                    data: permittedSpaces,
                    totalSize: promotedSpaces.spaces.length
                }
            });
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${$ac71c34762d51de0$var$EVENT_NAME} succedded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: false,
                    error: error
                }
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'createSpacePermissions', 'knowledgeCommon');
        }
    };

});
parcelRegister("cVUDi", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsEvents", () => $9d8927ca77b8220f$export$b84e314c48e09c44);
$parcel$export(module.exports, "getPageOnDelete", () => $9d8927ca77b8220f$export$99689dbe56145ad5);
$parcel$export(module.exports, "fireCustomErrorAnalytics", () => $9d8927ca77b8220f$export$3d13cbe76aeaf5e8);
$parcel$export(module.exports, "getViewArticleUrl", () => $9d8927ca77b8220f$export$4b1de73aa951498c);
$parcel$export(module.exports, "getJcsViewArticleUrl", () => $9d8927ca77b8220f$export$adfe9025f8369589);
$parcel$export(module.exports, "getAllDraftsUrl", () => $9d8927ca77b8220f$export$939c0821a1193768);
$parcel$export(module.exports, "getAllArticlesUrl", () => $9d8927ca77b8220f$export$240e98bbb8304c52);
$parcel$export(module.exports, "getAllJcsArticlesUrl", () => $9d8927ca77b8220f$export$35dca3e17444a3e5);
$parcel$export(module.exports, "getFlag", () => $9d8927ca77b8220f$export$a19b74191e00c5e);
$parcel$export(module.exports, "getCommonFlagData", () => $9d8927ca77b8220f$export$f44d45dc3db56277);
$parcel$export(module.exports, "filterSupportedBillingPeriod", () => $9d8927ca77b8220f$export$9f13ed259dc4b1bf);
$parcel$export(module.exports, "formatTrialEndDate", () => $9d8927ca77b8220f$export$da56c66ce2766e02);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");


var $fyKAM = parcelRequire("fyKAM");

const $9d8927ca77b8220f$var$TEAM_NAME = 'jsm-nebula';
const $9d8927ca77b8220f$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $9d8927ca77b8220f$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $9d8927ca77b8220f$export$53ee51427129200c = (statusCode)=>$9d8927ca77b8220f$export$1a5a4674dd906e7e(statusCode) || $9d8927ca77b8220f$export$d31fd506ce75fa65(statusCode);
const $9d8927ca77b8220f$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    if (error && typeof error.statusCode === 'number') {
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
        const { statusCode: statusCode } = error;
        const lowPriorityError = statusCode >= 400 && statusCode < 500;
        const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
        const transformedError = error instanceof (0, $jJZqs.default) ? error : new (0, $jJZqs.default)(statusCode);
        const errorObj = {
            error: transformedError,
            meta: {
                id: errorMetaId,
                packageName: packageName,
                teamName: $9d8927ca77b8220f$var$TEAM_NAME
            },
            ...attributes && {
                attributes: attributes
            }
        };
        (0, $jcw0u.default)(errorObj);
    } else (0, $jcw0u.default)({
        // Note there should not be a case of circular object for error , if there is it will be handled by fireErrorAnalytics
        error: error instanceof Error ? error : new Error(JSON.stringify(error)),
        meta: {
            id: `${id}__JS_ERROR`,
            packageName: packageName,
            teamName: $9d8927ca77b8220f$var$TEAM_NAME
        },
        ...attributes && {
            attributes: attributes
        }
    });
};
const $9d8927ca77b8220f$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
    const lastPage = Math.ceil(updateDataSize / perPage);
    return currentPage > lastPage ? lastPage : currentPage;
};
const $9d8927ca77b8220f$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
    if (error && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    typeof error.statusCode === 'number' && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    !$9d8927ca77b8220f$export$53ee51427129200c(error.statusCode)) event && (0, $8zOmE.fireOperationalAnalytics)(event, id);
    $9d8927ca77b8220f$export$b84e314c48e09c44(error, id, packageName, attributes);
};
const $9d8927ca77b8220f$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
const $9d8927ca77b8220f$export$adfe9025f8369589 = (projectKey, contentId, spaceKey, helpCenterId)=>`/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles/${contentId}?spaceKey=${spaceKey}`;
const $9d8927ca77b8220f$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
const $9d8927ca77b8220f$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
const $9d8927ca77b8220f$export$35dca3e17444a3e5 = (projectKey, helpCenterId)=>`/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles`;
const $9d8927ca77b8220f$export$a19b74191e00c5e = (title, description, flagType)=>({
        title: title,
        description: description,
        id: (0, $fyKAM.generateNanoId)(),
        flagType: flagType
    });
const $9d8927ca77b8220f$export$a6125e21263de883 = (state)=>{
    const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
    const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
    const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
    const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
    const isArticleDeleted = Boolean(articleId && deleted);
    return {
        isDraftPublished: isDraftPublished,
        isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
        isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
        isArticleDeleted: isArticleDeleted
    };
};
const $9d8927ca77b8220f$export$f44d45dc3db56277 = (state, messages)=>{
    let flag = {
        id: '',
        title: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        description: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
    };
    const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
    // if confluence get content api fails
    if (showConfluenceCreatePageError) {
        flag = {
            id: 'draftErrorFlag',
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            title: messages.confluenceCreatePageFailureTitle,
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            description: messages.confluenceCreatePageFailureDescription,
            type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
        };
        return flag;
    }
    const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $9d8927ca77b8220f$export$a6125e21263de883(state);
    // case when new article is published --> Article View
    if (isDraftPublished) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when draft is saved with unpublished changes --> Browse All Articles Page
    if (isDraftSavedWithUnpublishedChanges) flag = {
        id: 'draftSavedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'string | MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessSavedFlagDescription || '',
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when older article is saved with unpublished changes --> Article View
    if (isArticleSavedWithUnpublishedChanges) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleSuccessSavedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when article is deleted --> Browse All Articles Page
    if (isArticleDeleted) flag = {
        id: 'articleDeletedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleDeletedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleDeletedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    return flag;
};
const $9d8927ca77b8220f$export$9f13ed259dc4b1bf = (billingPeriod)=>{
    if (billingPeriod === (0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1)) return 0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1;
    if (billingPeriod === (0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad)) return 0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad;
    return 0, $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4;
};
const $9d8927ca77b8220f$export$da56c66ce2766e02 = (trialEndDate)=>{
    if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
    return null;
};

});
const $3026c2757a468eb7$export$516433e8a6db7503 = 'SUCCESS';
const $3026c2757a468eb7$export$a0a5e05447abb018 = 'WARNING';
const $3026c2757a468eb7$export$f215947b3d76a6b7 = 'ERROR';
const $3026c2757a468eb7$export$21bdd502a5302e06 = 'INFO';

parcelRegister("fyKAM", function(module, exports) {

$parcel$export(module.exports, "generateNanoId", () => $ef446b866ecb6566$export$a4f5444a5996c185);

var $9J4h7 = parcelRequire("9J4h7");
const $ef446b866ecb6566$export$a4f5444a5996c185 = ()=>(0, $9J4h7.nanoid)(12);
const $ef446b866ecb6566$export$e73c8bd0f20705a = ()=>(0, $9J4h7.nanoid)();

});
parcelRegister("9J4h7", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $714ba1f43c1bc4b0$export$ac4959f4f1338dfc);

let $714ba1f43c1bc4b0$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $714ba1f43c1bc4b0$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $714ba1f43c1bc4b0$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$714ba1f43c1bc4b0$export$a5cee9e955a615e5(alphabet, size, $714ba1f43c1bc4b0$export$4385e60b38654f68);
let $714ba1f43c1bc4b0$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size));
    while(size--)id += (0, $11cc6b8f5f8db98c$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};

});
const $11cc6b8f5f8db98c$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';




parcelRegister("5ukFp", function(module, exports) {

$parcel$export(module.exports, "getCreatePermissionsForSpace", () => $4d7a1d82dc21430a$export$a4d40fb662e5fd46);
$parcel$export(module.exports, "getLinkedSpaces", () => $4d7a1d82dc21430a$export$b764c9ef97480a8e);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
const $4d7a1d82dc21430a$export$a4d40fb662e5fd46 = (cloudId, spaceKeys)=>{
    const queryString = (0, $ebyGx.stringify)({
        promotedSpaceKey: spaceKeys,
        promotedSpacesLimit: spaceKeys.length,
        otherSpacesLimit: 0
    });
    return (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/spaces?${queryString}`);
};
const $4d7a1d82dc21430a$export$b764c9ef97480a8e = (projectKey)=>(0, $7f4tk.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/kb`);

});


parcelRegister("ik7FP", function(module, exports) {

$parcel$export(module.exports, "fetchDraftAndNavigateToEditor", () => $76ec8efa1f92f234$export$e8292dc9536b9de8);

var $dTS1V = parcelRequire("dTS1V");

var $8zOmE = parcelRequire("8zOmE");


var $cVUDi = parcelRequire("cVUDi");

var $gpe3Z = parcelRequire("gpe3Z");

var $1TU0Q = parcelRequire("1TU0Q");
const $76ec8efa1f92f234$var$EVENT_NAME = 'createNewConfluencePage';
const $76ec8efa1f92f234$export$e8292dc9536b9de8 = ({ spaceKey: spaceKey, routerActions: routerActions, projectKey: projectKey, projectId: projectId, onCloseRedirectUrl: onCloseRedirectUrl = '', onPublishRedirectUrl: onPublishRedirectUrl = '', analyticsEvent: analyticsEvent, topicId: topicId, topicName: topicName, bodyText: bodyText, isJcs: isJcs, helpCenterId: helpCenterId })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        try {
            setState({
                ...getState(),
                isFetchingDraftDetails: true
            });
            const bodyADFText = (content)=>{
                return {
                    atlas_doc_format: {
                        value: JSON.stringify(JSON.parse(content)),
                        representation: 'atlas_doc_format'
                    }
                };
            };
            const createContentParams = {
                spaceKey: spaceKey,
                parentProductContentContainerId: String(projectId),
                parentProduct: (0, $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c),
                title: topicName,
                body: bodyText ? bodyADFText(bodyText) : undefined
            };
            const { contentId: contentId, draftShareId: draftShareId } = await (0, $dTS1V.createContent)(createContentParams);
            setState({
                ...getState(),
                articleId: contentId,
                draftShareId: draftShareId,
                isFetchingDraftDetails: false
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${$76ec8efa1f92f234$var$EVENT_NAME} succedded`, {
                topicId: topicId,
                articleId: contentId
            });
            dispatch((0, $1TU0Q.setRedirectionData)({
                onCloseRedirectUrl: onCloseRedirectUrl,
                onPublishRedirectUrl: onPublishRedirectUrl
            }));
            dispatch((0, $gpe3Z.navigateCreateDraftRoute)({
                routerActions: routerActions,
                projectKey: projectKey,
                topicId: topicId,
                selectedSpaceKey: spaceKey,
                isJcs: isJcs,
                helpCenterId: helpCenterId
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                isFetchingDraftDetails: false,
                showConfluenceCreatePageError: true
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, $76ec8efa1f92f234$var$EVENT_NAME, 'knowledgeCommon');
        }
    };

});
parcelRegister("dTS1V", function(module, exports) {

$parcel$export(module.exports, "createContent", () => $2144a235c2b8fe30$export$41c7a4cacf5bab80);
/**
 * This function would be used by Embedding product to create Confluence Content. Content created by this function will be tagged with "embedded" flag.
 * At the moment we only support creating a blank page and does not support cross domain request (Parent Product must be in same domain as Confluence)
 * To enable unlicensed user to create a page, parentProduct & parentProductContentContainerId are required.
 */ 
var $eeFBS = parcelRequire("eeFBS");
const $2144a235c2b8fe30$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
    'parentProduct',
    'parentProductContentContainerId',
    'spaceKey'
];
const $2144a235c2b8fe30$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
const $2144a235c2b8fe30$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
    const payload = {
        type: 'page',
        status: 'draft',
        metadata: {
            properties: {
                editor: {
                    value: 'v2'
                }
            },
            frontend: {
                embedded: true
            }
        },
        space: {
            key: spaceKey
        },
        title: title,
        body: body
    };
    if (parentPageId) payload.ancestors = [
        {
            id: parentPageId
        }
    ];
    const baseurl = domain ? `https://${domain}` : domain;
    const unlicensedAccessHeader = $2144a235c2b8fe30$var$getUnlicensedAccessHeader({
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    });
    let response;
    try {
        response = await fetch(`${baseurl}/wiki/rest/api/content`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                credentials: 'include',
                ...unlicensedAccessHeader
            },
            body: JSON.stringify(payload)
        });
    } catch (e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
        // Promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side else resolve
        throw new Error(`Network failure ${e}`);
    }
    const responseJson = await response.json();
    if (!response.ok) throw new (0, $eeFBS.CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
    return {
        draftShareId: $2144a235c2b8fe30$var$getDraftShareId(responseJson),
        spaceKey: responseJson?.space?.key,
        contentId: responseJson?.id,
        status: responseJson?.status,
        subType: responseJson?.subType
    };
};
const $2144a235c2b8fe30$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
const $2144a235c2b8fe30$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
    const headerValue = {
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    };
    const isValidHeader = $2144a235c2b8fe30$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
    return isValidHeader ? {
        [$2144a235c2b8fe30$export$4de094b68e927f31]: JSON.stringify(headerValue)
    } : undefined;
};

});
parcelRegister("eeFBS", function(module, exports) {

$parcel$export(module.exports, "CreateError", () => $5ee25365aafd3194$export$91ee1703d5a5ab8b);
class $5ee25365aafd3194$export$91ee1703d5a5ab8b extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("gpe3Z", function(module, exports) {

$parcel$export(module.exports, "navigateCreateDraftRoute", () => $4f804a011e2794bb$export$4e7c7ad076f5f5fc);

var $4R6GH = parcelRequire("4R6GH");

var $6udl5 = parcelRequire("6udl5");
const $4f804a011e2794bb$export$4e7c7ad076f5f5fc = ({ routerActions: routerActions, projectKey: projectKey, selectedSpaceKey: selectedSpaceKey, topicId: topicId, isJcs: isJcs, helpCenterId: helpCenterId })=>async ({ getState: getState })=>{
        const { articleId: articleId, draftShareId: draftShareId } = {
            ...getState()
        };
        const EDIT_DRAFT_ROUTE = isJcs && (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $6udl5.getJcsDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId, topicId, helpCenterId) : (0, $6udl5.getDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId, topicId);
        routerActions.push(EDIT_DRAFT_ROUTE);
    };

});
parcelRegister("6udl5", function(module, exports) {

$parcel$export(module.exports, "getDraftEditUrl", () => $ed1cffe35d42c3de$export$5e8433ae3ce7c696);
$parcel$export(module.exports, "getJcsDraftEditUrl", () => $ed1cffe35d42c3de$export$cc7720c915c05b63);
$parcel$export(module.exports, "isDraftCreatedWithNCS", () => $ed1cffe35d42c3de$export$fc0fa1dc4749f854);
$parcel$export(module.exports, "findCategory", () => $ed1cffe35d42c3de$export$93e9d221203aed67);

const $ed1cffe35d42c3de$export$5e8433ae3ce7c696 = (projectKey, selectedSpaceKey, articleId, draftShareId, topicId)=>{
    let draftEditUrl = `/jira/servicedesk/projects/${projectKey}/knowledge/space/${selectedSpaceKey}/articles/${articleId}/edit?draftShareId=${draftShareId}`;
    if (topicId) draftEditUrl += `&topicId=${topicId}`;
    return draftEditUrl;
};
const $ed1cffe35d42c3de$export$cc7720c915c05b63 = (projectKey, selectedSpaceKey, articleId, draftShareId, topicId, helpCenterId)=>{
    let draftEditUrl = `/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles/${articleId}/space/${selectedSpaceKey}/edit?draftShareId=${draftShareId}`;
    if (topicId) draftEditUrl += `&topicId=${topicId}`;
    return draftEditUrl;
};
const $ed1cffe35d42c3de$export$fc0fa1dc4749f854 = (collabService)=>collabService === (0, $d7e8e0de2b5415e5$export$d42203c46ecda0b5);
const $ed1cffe35d42c3de$export$93e9d221203aed67 = (categoriesData, categoryId)=>{
    if (categoriesData.categories) return categoriesData.categories.find((category)=>category.id === categoryId);
    return undefined;
};

});


parcelRegister("1TU0Q", function(module, exports) {

$parcel$export(module.exports, "setRedirectionData", () => $35239289cee1669b$export$c026d4a8850c302d);
$parcel$export(module.exports, "resetRedirectionData", () => $35239289cee1669b$export$7c6d6762f8b5b4db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $35239289cee1669b$export$c026d4a8850c302d = (redirectionData)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            redirectionData: redirectionData
        });
    };
const $35239289cee1669b$export$7c6d6762f8b5b4db = ()=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            redirectionData: {
                onPublishRedirectUrl: '',
                onCloseRedirectUrl: ''
            }
        });
    };

});


parcelRegister("dAXEk", function(module, exports) {

$parcel$export(module.exports, "fetchLinkedSpaces", () => $1976703425aa0479$export$1999596e4ea30c16);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ukFp = parcelRequire("5ukFp");
const $1976703425aa0479$export$1999596e4ea30c16 = (projectKey)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...initialState,
            linkedSpaces: {
                ...initialState.linkedSpaces,
                isLoading: true
            }
        });
        try {
            const response = await (0, $5ukFp.getLinkedSpaces)(projectKey);
            const linkedSpaces = response.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
                    spaceKey: spaceKey,
                    spaceName: spaceName
                }));
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: false,
                    data: linkedSpaces,
                    totalSize: linkedSpaces.length
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: false,
                    error: error
                }
            });
        }
    };

});

parcelRegister("fMz1O", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestedTopics", () => $6568c1fa79c58aad$export$c5eac5039f8d8a0);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $l5XOm = parcelRequire("l5XOm");
const $6568c1fa79c58aad$export$c5eac5039f8d8a0 = (projectId, analyticsEvent, activationId)=>async ({ getState: getState, setState: setState })=>{
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: true,
                    error: null
                }
            });
            const response = projectId && await (0, $l5XOm.fetchSuggestedTopics)(projectId, activationId) || null;
            setState({
                ...getState(),
                topics: {
                    data: response && response?.topics || [],
                    loading: false,
                    error: null
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'fetchTopics succeeded', {
                projectId: projectId,
                noOfTopics: response?.topics.length
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                topics: {
                    data: [],
                    loading: false,
                    error: error
                }
            });
        }
    };

});
parcelRegister("l5XOm", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestedTopics", () => $e690efbbdbde2892$export$c5eac5039f8d8a0);

var $eusud = parcelRequire("eusud");
const $e690efbbdbde2892$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $e690efbbdbde2892$var$getSuggestedTopicsUrl = (projectId, activationId)=>`${$e690efbbdbde2892$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics`;
const $e690efbbdbde2892$export$c5eac5039f8d8a0 = (projectId, activationId)=>{
    const url = $e690efbbdbde2892$var$getSuggestedTopicsUrl(projectId, activationId);
    return (0, $eusud.performGetRequest)(url, {
        method: 'GET'
    });
};

});


parcelRegister("dIiIO", function(module, exports) {

$parcel$export(module.exports, "fetchUserCapabilities", () => $c701340a34445280$export$d1eac56717011ed4);

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $8FVnr = parcelRequire("8FVnr");
const $c701340a34445280$var$EVENT_NAME = 'fetchUserCapabilities';
const $c701340a34445280$export$d1eac56717011ed4 = (projectId, activationId, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...getState(),
            userCapabilities: {
                ...initialState.userCapabilities,
                isLoading: true
            }
        });
        try {
            const data = await (0, $8FVnr.fetchUserCapabilities)(projectId, activationId);
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: false,
                    data: data,
                    error: null
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${$c701340a34445280$var$EVENT_NAME} succeeded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: false,
                    error: error
                }
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, `${$c701340a34445280$var$EVENT_NAME} failed`, 'knowledgeCommon');
        }
    };

});
parcelRegister("8FVnr", function(module, exports) {

$parcel$export(module.exports, "fetchUserCapabilities", () => $11ef201d32e47a4e$export$d1eac56717011ed4);

var $7f4tk = parcelRequire("7f4tk");

const $11ef201d32e47a4e$export$d1eac56717011ed4 = (projectId, activationId)=>{
    const url = `${(0, $45c806b56a43da0e$export$f224912d4ec4705e)}/${activationId}/api/project/${projectId}/user/capabilities`;
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("jIuZj", function(module, exports) {

$parcel$export(module.exports, "removeCommonFlag", () => $3807c62af5ab354f$export$a2af96a4f99f3900);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3807c62af5ab354f$export$a2af96a4f99f3900 = (flagId)=>async ({ getState: getState, setState: setState })=>{
        const { flags: currentFlags } = getState();
        const flags = currentFlags.filter(({ id: id })=>id !== flagId);
        setState({
            ...getState(),
            flags: flags
        });
    };

});

parcelRegister("eP4xZ", function(module, exports) {

$parcel$export(module.exports, "reorderCategories", () => $d1c7d54ec7e0876f$export$32f957e287d37daa);

var $ajpes = parcelRequire("ajpes");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $261Bl = parcelRequire("261Bl");

var $1wnS6 = parcelRequire("1wnS6");
const $d1c7d54ec7e0876f$export$cde74ed295a2b838 = (categories, fromIndex, toIndex)=>{
    const newCategories = [
        ...categories
    ];
    const movedItem = newCategories.splice(fromIndex, 1)[0];
    if (movedItem !== undefined) newCategories.splice(toIndex, 0, movedItem);
    return newCategories;
};
const $d1c7d54ec7e0876f$export$32f957e287d37daa = (projectId, fromIndex, toIndex, analyticsEvent, activationId, onReorderMismatch, onReorderFailure)=>async ({ setState: setState, getState: getState })=>{
        const categoryToBeMovedId = getState().categoriesData.categories[fromIndex].id;
        const initiallyOrderedCategories = [
            ...getState().categoriesData.categories
        ];
        const newlyOrderedCategories = $d1c7d54ec7e0876f$export$cde74ed295a2b838(getState().categoriesData.categories, fromIndex, toIndex);
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: newlyOrderedCategories
            }
        });
        try {
            const { categories: categories } = await (0, $1wnS6.orderCategories)({
                projectId: projectId,
                activationId: activationId,
                categories: [
                    {
                        categoryId: categoryToBeMovedId,
                        order: toIndex
                    }
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'category reordered', {
                id: (0, $261Bl.categoryGuidToString)(categoryToBeMovedId)
            });
            const expectedCategoryIdOrder = newlyOrderedCategories.map((category)=>category.id);
            const actualCategoryIdOrder = categories.map((categoryResult)=>categoryResult.id);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(expectedCategoryIdOrder, actualCategoryIdOrder)) {
                // Something about the category information in apollo is different to our store
                // e.g. another user has reordered categories, added a category, deleted a category
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: categories
                    }
                });
                onReorderMismatch();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'reorderCategories',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...initiallyOrderedCategories
                    ]
                }
            });
            onReorderFailure();
        }
    };

});
parcelRegister("261Bl", function(module, exports) {

$parcel$export(module.exports, "categoryGuidToString", () => $21d0c574129f0705$export$43162cfd3260b2fe);
$parcel$export(module.exports, "toCategoryGuid", () => $21d0c574129f0705$export$be5c80c4ad1faf99);
const $21d0c574129f0705$export$43162cfd3260b2fe = (guid)=>guid;
const $21d0c574129f0705$export$be5c80c4ad1faf99 = (guid)=>guid;

});

parcelRegister("1wnS6", function(module, exports) {

$parcel$export(module.exports, "orderCategories", () => $56b61b6811b7fda7$export$e90b3dc42a0ddf96);

var $7f4tk = parcelRequire("7f4tk");

const $56b61b6811b7fda7$export$e90b3dc42a0ddf96 = ({ projectId: projectId, activationId: activationId, categories: categories, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/category/order`;
    return (0, $7f4tk.default)(url, {
        method: 'PUT',
        body: JSON.stringify(categories)
    });
};

});


parcelRegister("8QyFO", function(module, exports) {

$parcel$export(module.exports, "resetDraftArticleData", () => $c895191ddea664b2$export$e4dbf2710e8c685d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $c895191ddea664b2$export$e4dbf2710e8c685d = (resetDelete)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            draftShareId: '',
            closed: false,
            published: false,
            showConfluenceCreatePageError: false,
            spaceKey: '',
            ...resetDelete && {
                deleted: false,
                articleId: ''
            }
        });
    };

});

parcelRegister("6ThCP", function(module, exports) {

$parcel$export(module.exports, "setPagination", () => $373ed0b89949e59d$export$347aea62317e2398);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $373ed0b89949e59d$export$347aea62317e2398 = (currentPage)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            page: currentPage
        });
    };

});

parcelRegister("1VmcQ", function(module, exports) {

$parcel$export(module.exports, "updateCategorySuccess", () => $10ef8418d41dbca6$export$7d46e556893bba77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $10ef8418d41dbca6$export$7d46e556893bba77 = (updatedCategory)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: getState().categoriesData.categories.map((category)=>category.id === updatedCategory.id ? updatedCategory : category)
            }
        });
    };

});


parcelRegister("cSB1I", function(module, exports) {

$parcel$export(module.exports, "getDraftShareId", () => $b10361f0e26ced23$export$f31b9480a5e4fdcf);
$parcel$export(module.exports, "getArticleId", () => $b10361f0e26ced23$export$2d21c0faccc1d33f);
$parcel$export(module.exports, "getIsFetchingDraftDetails", () => $b10361f0e26ced23$export$19d926b900e1c065);
$parcel$export(module.exports, "getRedirectionData", () => $b10361f0e26ced23$export$fdde4bb390e025db);
$parcel$export(module.exports, "getPermittedSpaces", () => $b10361f0e26ced23$export$4a419b2d3bb6a3fc);
$parcel$export(module.exports, "getLinkedSpaces", () => $b10361f0e26ced23$export$b764c9ef97480a8e);
$parcel$export(module.exports, "getUserCapabilities", () => $b10361f0e26ced23$export$f7db3ef62579b328);
$parcel$export(module.exports, "getCategoriesData", () => $b10361f0e26ced23$export$b416461ac52d8504);
$parcel$export(module.exports, "getCreateCategoryData", () => $b10361f0e26ced23$export$e0cf4a4b69bbc694);
$parcel$export(module.exports, "getCategory", () => $b10361f0e26ced23$export$410364bbb673ddbc);
$parcel$export(module.exports, "getCommonFlags", () => $b10361f0e26ced23$export$b94d9d28300025a9);
$parcel$export(module.exports, "getKnowledgeCommonFlags", () => $b10361f0e26ced23$export$1a5b9662b382779c);
$parcel$export(module.exports, "getSuggestedTopics", () => $b10361f0e26ced23$export$d95ddf26dc427cbd);
$parcel$export(module.exports, "getPageNumber", () => $b10361f0e26ced23$export$c173ad1c1111eb41);

var $cVUDi = parcelRequire("cVUDi");

var $6udl5 = parcelRequire("6udl5");
const $b10361f0e26ced23$export$c9cab98530df1a79 = ({ published: published })=>published;
const $b10361f0e26ced23$export$f31b9480a5e4fdcf = ({ draftShareId: draftShareId })=>draftShareId;
const $b10361f0e26ced23$export$2d21c0faccc1d33f = ({ articleId: articleId })=>articleId;
const $b10361f0e26ced23$export$19d926b900e1c065 = ({ isFetchingDraftDetails: isFetchingDraftDetails })=>isFetchingDraftDetails;
const $b10361f0e26ced23$export$fdde4bb390e025db = (state)=>state.redirectionData;
const $b10361f0e26ced23$export$4a419b2d3bb6a3fc = (state)=>state.spacesPermitted;
const $b10361f0e26ced23$export$b764c9ef97480a8e = (state)=>state.linkedSpaces;
const $b10361f0e26ced23$export$f7db3ef62579b328 = (state)=>state.userCapabilities;
const $b10361f0e26ced23$export$b416461ac52d8504 = (state)=>state.categoriesData;
const $b10361f0e26ced23$export$e0cf4a4b69bbc694 = (state)=>state.createCategoryData;
const $b10361f0e26ced23$export$410364bbb673ddbc = (state, categoryId)=>(0, $6udl5.findCategory)(state.categoriesData, categoryId);
const $b10361f0e26ced23$export$b94d9d28300025a9 = ({ flags: flags })=>flags;
const $b10361f0e26ced23$export$1a5b9662b382779c = (state, messages)=>(0, $cVUDi.getCommonFlagData)({
        ...state
    }, messages);
const $b10361f0e26ced23$export$d95ddf26dc427cbd = (state)=>state.topics;
const $b10361f0e26ced23$export$c173ad1c1111eb41 = (state)=>state.page;

});


parcelRegister("jt2Om", function(module, exports) {

$parcel$export(module.exports, "KnowledgeHubSuggestedTopicsContainer", () => $1d031c60f9a78428$export$545055c3c05f3a42);
$parcel$export(module.exports, "useSuggestedTopics", () => $1d031c60f9a78428$export$2328a37d3e371b67);
$parcel$export(module.exports, "usePageNumber", () => $1d031c60f9a78428$export$1571508029b597f4);
$parcel$export(module.exports, "useIsTopicsFiltered", () => $1d031c60f9a78428$export$28f5b681fa8cfbe1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6P8yK = parcelRequire("6P8yK");

var $7jhAC = parcelRequire("7jhAC");
const $1d031c60f9a78428$var$initialState = {
    topics: {
        data: [],
        loading: false,
        error: null
    },
    isFiltered: true,
    page: 1
};
const $1d031c60f9a78428$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $1d031c60f9a78428$var$initialState,
    actions: $6P8yK.actions,
    name: 'KnowledgeHubSuggestedTopicsStore'
});
const $1d031c60f9a78428$export$545055c3c05f3a42 = (0, $gg7kZ.createContainer)($1d031c60f9a78428$export$6f57813fe9f31bf9, {
    displayName: 'KnowledgeHubSuggestedTopicsContainer'
});
const $1d031c60f9a78428$export$2328a37d3e371b67 = (0, $3sQ5x.createHook)($1d031c60f9a78428$export$6f57813fe9f31bf9, {
    selector: (0, $7jhAC.getSuggestedTopics)
});
const $1d031c60f9a78428$export$1571508029b597f4 = (0, $3sQ5x.createHook)($1d031c60f9a78428$export$6f57813fe9f31bf9, {
    selector: (0, $7jhAC.getPageNumber)
});
const $1d031c60f9a78428$export$28f5b681fa8cfbe1 = (0, $3sQ5x.createHook)($1d031c60f9a78428$export$6f57813fe9f31bf9, {
    selector: (0, $7jhAC.getIsTopicsFiltered)
});

});
parcelRegister("6P8yK", function(module, exports) {

$parcel$export(module.exports, "actions", () => $aadbb2d774b6da4d$export$e324594224ef24da);

var $aYzm1 = parcelRequire("aYzm1");

var $lxHDZ = parcelRequire("lxHDZ");

var $kB9Pd = parcelRequire("kB9Pd");

var $darVv = parcelRequire("darVv");

var $kcnCn = parcelRequire("kcnCn");

var $37eCw = parcelRequire("37eCw");
const $aadbb2d774b6da4d$export$e324594224ef24da = {
    fetchSuggestedTopics: $lxHDZ.fetchSuggestedTopics,
    setPagination: $kB9Pd.setPagination,
    dismissTopic: $aYzm1.dismissTopic,
    filterTopics: $darVv.filterTopics,
    fetchAiDraftPreviewContent: $kcnCn.fetchAiDraftPreviewContent,
    triggerArticleGenerationForTopics: $37eCw.triggerArticleGenerationForTopics
};

});
parcelRegister("aYzm1", function(module, exports) {

$parcel$export(module.exports, "dismissTopic", () => $6aef7796d3942834$export$8c9ab121673c8912);

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $9ku00 = parcelRequire("9ku00");

var $cVUDi = parcelRequire("cVUDi");

var $7NiEh = parcelRequire("7NiEh");


var $jYjsH = parcelRequire("jYjsH");

var $jzsp1 = parcelRequire("jzsp1");
const $6aef7796d3942834$export$8c9ab121673c8912 = (topicId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, locale: locale, activationId: activationId } = props;
        const currentTopics = getState().topics.data;
        const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
        const formatMessage = (0, $9ku00.createFormatMessage)(locale);
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: true,
                    error: null
                }
            });
            projectId && await (0, $7NiEh.deleteTopic)(projectId, topicId, activationId);
            const updatedTopics = (0, $jYjsH.removeTopic)(currentTopics, topicId);
            const page = (0, $cVUDi.getPageOnDelete)(getState().page, updatedTopics.length, (0, $abd8c4ced6efb751$export$5631491ed07b4a08));
            setState({
                ...getState(),
                topics: {
                    data: updatedTopics,
                    loading: false,
                    error: null
                },
                page: page
            });
            showFlag({
                type: 'success',
                title: formatMessage((0, $jzsp1.default).dismissTopicSuccessTitle),
                isAutoDismiss: true,
                messageId: 'servicedesk-knowledge-performance.controllers.store.actions.dismiss-topic.show-flag.success',
                messageType: 'transactional'
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'dismissTopic succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: false,
                    error: error
                }
            });
            showFlag({
                type: 'error',
                title: formatMessage((0, $jzsp1.default).dismissTopicErrorTitle),
                description: formatMessage((0, $jzsp1.default).dismissTopicErrorDescription),
                isAutoDismiss: true,
                messageId: 'servicedesk-knowledge-performance.controllers.store.actions.dismiss-topic.show-flag.error',
                messageType: 'transactional'
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'dismissTopic',
                    packageName: (0, $abd8c4ced6efb751$export$b8b9d90f9e5bd72b),
                    teamName: (0, $abd8c4ced6efb751$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("9ku00", function(module, exports) {

$parcel$export(module.exports, "createFormatMessage", () => $9f1cf6b9497450fa$export$5eaf6c4755708cf2);

var $gJBT6 = parcelRequire("gJBT6");

var $5OX1e = parcelRequire("5OX1e");

var $gdR6R = parcelRequire("gdR6R");

const $9f1cf6b9497450fa$export$5eaf6c4755708cf2 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((locale)=>{
    // TODO: providing locale to IntlProvider is nothing to do with translation. We can completely remove language, not providing any locale
    // TODO: React-intl just reads whatever given to messages object, regardless of locale. REMOVE THIS
    // IntlProvider cannot deal with locale w/ country code. Needs language-only.
    const language = (0, $5OX1e.default)(locale);
    // disable flow for unresolved externals module
    // disable eslint for both unresolved module
    // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
    const messages = (parcelRequire("hWnRN"));
    const intl = (0, $gdR6R.getIntl)({
        locale: language,
        messages: messages
    });
    return intl.formatMessage;
});

});
parcelRegister("5OX1e", function(module, exports) {

$parcel$export(module.exports, "default", () => $90859c0b844c53f2$export$2e2bcd8739ae039);
// en_US => en
// DO NOT USE IT ANYMORE!!
// DO NOT USE IT ANYMORE!!
//
// After the feature flag(https://app.launchdarkly.com/jira/staging/features/use.bcp47.locale.format/targeting) is cleaned-up, this will be removed.
// The reason why it is deprecated is that we are providing locale to ReactIntlProvider as a locale prop after applying
// this function. This is wrong because we are passing only language part ignoring the region variance.
// The consequence is react-intl's format functions such as formatDate will format date into MM-DD-YYYY, instead of DD-MM-YYYY
// in case of en-gb. The similar things could happen in any other language variances.
// On 2. Feb. 2021, it is confirmed that this function is only used to provide locale for IntlProvider component
// Under the feature flag, it is replaced with getBCPLocale function that replaces _ to - to be BCP47 web standard locale format
//
// DO NOT USE IT ANYMORE!!
// DO NOT USE IT ANYMORE!!
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $90859c0b844c53f2$export$2e2bcd8739ae039 = (locale)=>locale ? locale.substring(0, locale.indexOf('_')) : '';

});

parcelRegister("gdR6R", function(module, exports) {

$parcel$export(module.exports, "getIntl", () => $13657aeb20f9eb7b$export$51771ec7613ad564);

var $i5FdW = parcelRequire("i5FdW");
var $hTtGr = parcelRequire("hTtGr");
const $13657aeb20f9eb7b$var$cache = (0, $hTtGr.createIntlCache)();
const $13657aeb20f9eb7b$export$51771ec7613ad564 = (config)=>(0, $i5FdW.createIntl)(config, $13657aeb20f9eb7b$var$cache);

});


parcelRegister("7NiEh", function(module, exports) {

$parcel$export(module.exports, "deleteTopic", () => $4cb4440bb86988d3$export$abca5685670e035c);

var $eusud = parcelRequire("eusud");
const $4cb4440bb86988d3$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $4cb4440bb86988d3$export$abca5685670e035c = (projectId, topicId, activationId)=>{
    return (0, $eusud.performDeleteRequest)(`${$4cb4440bb86988d3$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}`);
};

});

const $abd8c4ced6efb751$export$d57b6b390e78d90f = 'jsm-nebula';
const $abd8c4ced6efb751$export$5631491ed07b4a08 = 10;
const $abd8c4ced6efb751$export$b8b9d90f9e5bd72b = '@atlassian/jira-servicedesk-knowledge-performance';

parcelRegister("jYjsH", function(module, exports) {

$parcel$export(module.exports, "removeTopic", () => $6dbc6572d3c8e5cd$export$fcbc6597dc84c9da);
const $6dbc6572d3c8e5cd$export$fcbc6597dc84c9da = (topics, topicId)=>topics.filter((topic)=>topic.topicId !== topicId);

});

parcelRegister("jzsp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $81af2f7f87378eff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81af2f7f87378eff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dismissTopicSuccessTitle: {
        "id": "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-success-title",
        "defaultMessage": "Removed the suggested topic"
    },
    dismissTopicErrorTitle: {
        "id": "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-error-title",
        "defaultMessage": "We couldn\u2019t remove the topic"
    },
    dismissTopicErrorDescription: {
        "id": "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-error-description",
        "defaultMessage": "Something went wrong. Try again or refresh the page"
    }
});

});


parcelRegister("lxHDZ", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestedTopics", () => $8fbd080ac6c5f063$export$c5eac5039f8d8a0);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $gR30t = parcelRequire("gR30t");
const $8fbd080ac6c5f063$export$c5eac5039f8d8a0 = (projectId, analyticsEvent, activationId)=>async ({ getState: getState, setState: setState })=>{
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: true,
                    error: null
                }
            });
            const response = await (0, $gR30t.fetchSuggestedTopics)(projectId, activationId);
            setState({
                ...getState(),
                topics: {
                    data: response.topics,
                    loading: false,
                    error: null
                },
                isFiltered: response.isFiltered
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'fetchTopics succeeded', {
                projectId: projectId,
                noOfTopics: response.topics.length,
                isFiltered: response.isFiltered
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $abd8c4ced6efb751$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                topics: {
                    data: [],
                    loading: false,
                    error: error
                }
            });
        }
    };

});
parcelRegister("gR30t", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestedTopics", () => $174ece0599b03ab6$export$c5eac5039f8d8a0);

var $eusud = parcelRequire("eusud");
const $174ece0599b03ab6$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $174ece0599b03ab6$var$getSuggestedTopicsUrl = (projectId, activationId)=>`${$174ece0599b03ab6$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics`;
const $174ece0599b03ab6$export$c5eac5039f8d8a0 = (projectId, activationId)=>{
    const url = $174ece0599b03ab6$var$getSuggestedTopicsUrl(projectId, activationId);
    return (0, $eusud.performGetRequest)(url);
};

});


parcelRegister("kB9Pd", function(module, exports) {

$parcel$export(module.exports, "setPagination", () => $e1673f08c327d3a0$export$347aea62317e2398);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e1673f08c327d3a0$export$347aea62317e2398 = (currentPage)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            page: currentPage
        });
    };

});

parcelRegister("darVv", function(module, exports) {

$parcel$export(module.exports, "filterTopics", () => $73d3afbda33b8b5a$export$e3aee287777fa471);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $VyHPe = parcelRequire("VyHPe");
const $73d3afbda33b8b5a$export$e3aee287777fa471 = (projectId, analyticsEvent, activationId)=>async ()=>{
        try {
            await (0, $VyHPe.filterTopics)(projectId, activationId);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'filterTopics succeeded', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'filterTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $abd8c4ced6efb751$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("VyHPe", function(module, exports) {

$parcel$export(module.exports, "filterTopics", () => $aa11c5bce8bb7d0d$export$e3aee287777fa471);

var $eusud = parcelRequire("eusud");
const $aa11c5bce8bb7d0d$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $aa11c5bce8bb7d0d$var$getFilterTopicsUrl = (projectId, activationId)=>`${$aa11c5bce8bb7d0d$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics/refine`;
const $aa11c5bce8bb7d0d$export$e3aee287777fa471 = (projectId, activationId)=>{
    const url = $aa11c5bce8bb7d0d$var$getFilterTopicsUrl(projectId, activationId);
    return (0, $eusud.performPostRequest)(url);
};

});


parcelRegister("kcnCn", function(module, exports) {

$parcel$export(module.exports, "fetchAiDraftPreviewContent", () => $79768d00557669f0$export$518af6df5154b1b1);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $a28Hx = parcelRequire("a28Hx");
const $79768d00557669f0$export$518af6df5154b1b1 = (topicId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId } = props;
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: null,
                                loading: true,
                                error: null
                            }
                        } : topic)
                }
            });
            const response = projectId && await (0, $a28Hx.fetchAiDraftPreviewContent)(projectId, activationId, topicId) || null;
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: response && response?.content || null,
                                loading: false,
                                error: null
                            }
                        } : topic)
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiDraftPreviewContent succeeded', {
                projectId: projectId,
                topicId: topicId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchAiDraftPreviewContent',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: null,
                                loading: false,
                                error: error
                            }
                        } : topic)
                }
            });
        }
    };

});
parcelRegister("a28Hx", function(module, exports) {

$parcel$export(module.exports, "fetchAiDraftPreviewContent", () => $2d46a2ee5c1862bd$export$518af6df5154b1b1);

var $eusud = parcelRequire("eusud");
const $2d46a2ee5c1862bd$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $2d46a2ee5c1862bd$var$getAiDraftPreviewContentUrl = (projectId, activationId, topicId, contentFormat)=>`${$2d46a2ee5c1862bd$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}/draft-article?contentFormat=${contentFormat}`;
const $2d46a2ee5c1862bd$export$518af6df5154b1b1 = (projectId, activationId, topicId)=>{
    const contentFormat = 'text/adf';
    const url = $2d46a2ee5c1862bd$var$getAiDraftPreviewContentUrl(projectId, activationId, topicId, contentFormat);
    return (0, $eusud.performGetRequest)(url);
};

});


parcelRegister("37eCw", function(module, exports) {

$parcel$export(module.exports, "triggerArticleGenerationForTopics", () => $a76f4479331d5392$export$7bd57fc6c7a6dd3d);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $cywfH = parcelRequire("cywfH");
const $a76f4479331d5392$export$7bd57fc6c7a6dd3d = (projectId, analyticsEvent, activationId)=>async ()=>{
        try {
            await (0, $cywfH.fetchArticleGenerationForTopics)(projectId, activationId);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'triggerArticleGenerationForTopics succeeded', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'triggerArticleGenerationForTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $abd8c4ced6efb751$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("cywfH", function(module, exports) {

$parcel$export(module.exports, "fetchArticleGenerationForTopics", () => $ebf54415eb8574c5$export$5d2d7bed782963e7);

var $eusud = parcelRequire("eusud");
const $ebf54415eb8574c5$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $ebf54415eb8574c5$export$fd5c5783cdaa5a5f = (projectId, activationId)=>`${$ebf54415eb8574c5$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics/draft-article/generate`;
const $ebf54415eb8574c5$export$5d2d7bed782963e7 = (projectId, activationId)=>{
    const url = $ebf54415eb8574c5$export$fd5c5783cdaa5a5f(projectId, activationId);
    return (0, $eusud.performPostRequest)(url);
};

});



parcelRegister("7jhAC", function(module, exports) {

$parcel$export(module.exports, "getSuggestedTopics", () => $e5e06d33ac402047$export$d95ddf26dc427cbd);
$parcel$export(module.exports, "getPageNumber", () => $e5e06d33ac402047$export$c173ad1c1111eb41);
$parcel$export(module.exports, "getIsTopicsFiltered", () => $e5e06d33ac402047$export$3e7f4e40e35adad4);
const $e5e06d33ac402047$export$d95ddf26dc427cbd = (state)=>state.topics;
const $e5e06d33ac402047$export$c173ad1c1111eb41 = (state)=>state.page;
const $e5e06d33ac402047$export$3e7f4e40e35adad4 = (state)=>state.isFiltered;

});


parcelRegister("d82Tb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52a5efeefe5e73ca$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $52a5efeefe5e73ca$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    itemKnowledgeBase: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.item-knowledge-base",
        "defaultMessage": "Knowledge base"
    },
    itemKnowledgeBaseHub: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.item-knowledge-base-hub",
        "defaultMessage": "Knowledge base"
    },
    allArticles: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.all-articles",
        "defaultMessage": "Articles"
    },
    drafts: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.drafts",
        "defaultMessage": "Drafts"
    },
    heading: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.heading",
        "defaultMessage": "Knowledge base"
    },
    categories: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.categories",
        "defaultMessage": "Categories"
    },
    newCategory: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.new-category",
        "defaultMessage": "New category"
    },
    suggestedTopics: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.suggested-topics",
        "defaultMessage": "Suggested topics"
    }
});

});

parcelRegister("3gVb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0641e9dda06d3ef$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a0641e9dda06d3ef$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reorderFailureTitle: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.hub-menu.reorder-failure-title",
        "defaultMessage": "We couldn't reorder your categories"
    },
    reorderFailureDescription: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.hub-menu.reorder-failure-description",
        "defaultMessage": "Please try again later."
    },
    reorderMismatchTitle: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.hub-menu.reorder-mismatch-title",
        "defaultMessage": "Successfully reordered categories"
    },
    reorderMismatchDescription: {
        "id": "spa-apps-sidebar-servicedesk.common.knowledge-item.hub-menu.reorder-mismatch-description",
        "defaultMessage": "Somebody else has also reordered the categories recently. Double check your category ordering."
    }
});

});



parcelRegister("bTR6h", function(module, exports) {

$parcel$export(module.exports, "PracticeQueues", () => $512e7ff5c9d1d184$export$9720502a768ac6d4);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");

var $gjTBi = parcelRequire("gjTBi");

var $8J6rn = parcelRequire("8J6rn");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gP8z = parcelRequire("2gP8z");

var $3OGaE = parcelRequire("3OGaE");

var $lpwtK = parcelRequire("lpwtK");

var $3tHFY = parcelRequire("3tHFY");

var $cR56S = parcelRequire("cR56S");

var $2bUNF = parcelRequire("2bUNF");

var $2NMNM = parcelRequire("2NMNM");

var $16J3A = parcelRequire("16J3A");

var $dd29Z = parcelRequire("dd29Z");

var $5MhuD = parcelRequire("5MhuD");

var $5Srj8 = parcelRequire("5Srj8");

var $emIzB = parcelRequire("emIzB");

var $g0Gtc = parcelRequire("g0Gtc");

var $jF62O = parcelRequire("jF62O");

var $oCMSG = parcelRequire("oCMSG");

var $cSD7y = parcelRequire("cSD7y");

var $gRCL3 = parcelRequire("gRCL3");

var $iPLM4 = parcelRequire("iPLM4");

var $8WEWU = parcelRequire("8WEWU");

var $gKDnb = parcelRequire("gKDnb");

var $fanN2 = parcelRequire("fanN2");

var $9WOdt = parcelRequire("9WOdt");

var $8uJQJ = parcelRequire("8uJQJ");

var $FYTTo = parcelRequire("FYTTo");

var $1JOZC = parcelRequire("1JOZC");

var $lD3YF = parcelRequire("lD3YF");
// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
const $512e7ff5c9d1d184$var$updateConnectUrl = (item)=>({
        ...item,
        url: item.url?.replace('/projects/', '/jira/servicedesk/projects/'),
        items: item.items?.map($512e7ff5c9d1d184$var$updateConnectUrl)
    });
/**
 * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4
 */ const $512e7ff5c9d1d184$var$SectionsWithQueueGroups = ({ currentCategory: currentCategory, projectKey: projectKey, onRefreshGroup: onRefreshGroup, selectedGroupId: selectedGroupId, onGroupChange: onGroupChange, canManageQueues: canManageQueues, renderSpotlight: renderSpotlight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: currentCategory === (0, $oCMSG.CHANGES) ? (0, $16J3A.PRACTICES_IDS).CHANGES_QUEUE_ITEMS_SPOTLIGHT : (0, $16J3A.PRACTICES_IDS).INCIDENTS_QUEUE_ITEMS_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lD3YF.StarredSection), {
        practice: currentCategory
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JOZC.QueueGroupsSection), {
        projectKey: projectKey,
        currentCategory: currentCategory,
        onGroupDataRefresh: onRefreshGroup,
        currentCategorySelectedGroupId: selectedGroupId,
        onGroupChange: onGroupChange,
        canManageQueues: canManageQueues
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WEWU.default), {
        practice: currentCategory
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lD3YF.StarredSection), {
        practice: currentCategory
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JOZC.QueueGroupsSection), {
        projectKey: projectKey,
        currentCategory: currentCategory,
        onGroupDataRefresh: onRefreshGroup,
        currentCategorySelectedGroupId: selectedGroupId,
        onGroupChange: onGroupChange,
        canManageQueues: canManageQueues
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WEWU.default), {
        practice: currentCategory
    })));
const $512e7ff5c9d1d184$var$PracticeQueuesError = ({ title: title, onRefresh: onRefresh })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.100"
    }, formatMessage((0, $FYTTo.messages).fetchQueuesError, {
        button: (buttonLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                spacing: "none",
                appearance: "link",
                onClick: onRefresh
            }, buttonLabel)
    })));
};
/**
 * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4
 */ const $512e7ff5c9d1d184$var$PracticeQueuesInternal = ({ practice: practice, title: title })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project, loading: projectLoading, error: projectError } = (0, $lpwtK.useProject)();
    const { data: connectItems } = (0, $cR56S.useProjectQueuesConnectItems)();
    const currentCategory = practice || (0, $oCMSG.NO_CATEGORY);
    const [queues, queuesLoading, queuesError, methods, refreshQueues] = (0, $jF62O.useCategorizedNavItems)('', project ? project.key : '', currentCategory);
    const [metadata] = (0, $jF62O.usePracticeMetadata)(practice);
    const features = (0, $iPLM4.useQueueFeatures)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(project?.key);
    const queuesContextTemp = (0, $4R6GH.fg)('add-custom-context-to-nav3-group-fetch-calls') ? queueCustomContext : undefined;
    const [groups, groupLoading, groupFetchingError, refresh] = (0, $emIzB.usePriorityGroups)(currentCategory, queuesContextTemp);
    const [currentCategorySelectedGroupId, navigationCategoryActions] = (0, $5Srj8.useSelectedGroupIdByCategory)(currentCategory);
    (0, $gRCL3.useOnFavoritesChanged)(project?.key || '', practice || (0, $oCMSG.NO_CATEGORY), queues, methods.editItemFavorite, methods.refreshIssueCountForItems);
    const isCountDataRequired = Boolean(metadata && !metadata.hasRequestedCount);
    const selectFirstGroupAsDefault = (0, $5uXOq.useCallback)(()=>{
        navigationCategoryActions.updateCurrentCategorySelectedGroup(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
        project?.key, currentCategory, groups[0].id);
        methods.enableIssueCountForSelectedQueues(groups[0].queues);
    }, [
        currentCategory,
        groups,
        methods,
        navigationCategoryActions,
        project?.key
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldUpdateIssueCounts = groupLoading || queuesLoading || projectLoading || groupFetchingError || queuesError || projectError;
        if (shouldUpdateIssueCounts) return undefined;
        if (groups.length === 0) return methods.enableIssueCountForSelectedQueues([]);
        if (currentCategorySelectedGroupId === undefined) return selectFirstGroupAsDefault();
        const selectedGroup = groups.find((group)=>group.id === currentCategorySelectedGroupId);
        if (selectedGroup) return methods.enableIssueCountForSelectedQueues(selectedGroup.queues);
        return selectFirstGroupAsDefault();
    }, [
        currentCategorySelectedGroupId,
        groups,
        groupFetchingError,
        groupLoading,
        methods,
        selectFirstGroupAsDefault,
        queuesError,
        projectError,
        queuesLoading,
        projectLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isCountDataRequired) {
            const event = createAnalyticsEvent({
                action: 'mounted'
            });
            methods.initialFetchNavItems(event);
        }
    }, [
        createAnalyticsEvent,
        isCountDataRequired,
        methods
    ]);
    // fix connect links to new urls
    const queuesConnectItems = (0, $5uXOq.useMemo)(()=>connectItems?.map($512e7ff5c9d1d184$var$updateConnectUrl), [
        connectItems
    ]);
    const renderSpotlight = // @ts-expect-error - TS2345 - Argument of type 'ItsmPractice | undefined' is not assignable to parameter of type '"change-management" | "incident-management"'.
    features.canMoveQueues && [
        (0, $oCMSG.CHANGES),
        (0, $oCMSG.INCIDENTS)
    ].includes(practice) && !false;
    const showOpsgenieIncidentsMenuItem = practice === (0, $oCMSG.INCIDENTS) && !shouldUseJSM;
    const onGroupChange = (0, $5uXOq.useCallback)((groupId, selectedQueueIds)=>{
        if (project?.key) navigationCategoryActions.updateCurrentCategorySelectedGroup(project?.key, currentCategory, groupId);
        methods.enableIssueCountForSelectedQueues(selectedQueueIds);
        methods.refreshIssueCountForItems(selectedQueueIds.map((queueId)=>queueId.toString()));
    }, [
        currentCategory,
        methods,
        navigationCategoryActions,
        project?.key
    ]);
    if (projectError || queuesError) {
        if (!(0, $4R6GH.fg)('update_viewqueuesnav_instrumentation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($512e7ff5c9d1d184$var$PracticeQueuesError, {
            title: title,
            onRefresh: refreshQueues
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: "failed-fetching-initial-data",
            failureEventAttributes: {
                errorName: queuesError?.name || projectError?.name,
                errorMessage: queuesError?.message || projectError?.message,
                errorStack: queuesError?.stack || projectError?.stack
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($512e7ff5c9d1d184$var$PracticeQueuesError, {
            title: title,
            onRefresh: refreshQueues
        }));
    }
    return(// DESK-5408 remove this QueuesExperienceTracker
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKDnb.QueuesExperienceTracker), {
        experience: "viewQueuesNav"
    }, [
        (0, $oCMSG.CHANGES),
        (0, $oCMSG.INCIDENTS)
    ].includes(practice) ? /* NOTE: These SpotlightTargets can be used throughout Jira not just within
       * the current package. They're often used for onboarding or changeboarding
       * experiences and allow an Atlaskit spotlight to be attached to page elements.
       * If you need to change this, make sure you check where the target ID is being used
       * and contact the relevant team as necessary. This Sourcegraph link should help :)
       * http://go/src/_QUEUE_.*_SPOTLIGHT|-queue-.*-spotlight
       */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: practice === (0, $oCMSG.CHANGES) ? (0, $16J3A.PRACTICES_IDS).CHANGES_QUEUE_TITLE_SPOTLIGHT : (0, $16J3A.PRACTICES_IDS).INCIDENTS_QUEUE_TITLE_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($512e7ff5c9d1d184$var$SectionsWithQueueGroups, {
        currentCategory: currentCategory,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        projectKey: project?.key,
        onRefreshGroup: refresh,
        selectedGroupId: currentCategorySelectedGroupId || '',
        onGroupChange: onGroupChange,
        canManageQueues: features.canManageQueues,
        renderSpotlight: renderSpotlight
    }), showOpsgenieIncidentsMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WOdt.GotoOpsgenieMenuItem), null), (!practice || practice === (0, $oCMSG.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tHFY.ConnectMenu), {
        items: queuesConnectItems,
        showIcons: false,
        overrides: {
            BackMenuItem: {
                href: `/jira/servicedesk/projects/${project?.key}/${(0, $dd29Z.QUEUE_ROUTES)[practice || (0, $oCMSG.NO_CATEGORY)]}/`,
                onClick: (ev)=>ev.preventDefault(),
                title: title
            }
        }
    }), features.canManageQueues === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uJQJ.ManageQueuesItem), {
        practice: practice || (0, $oCMSG.NO_CATEGORY)
    }, formatMessage((0, $FYTTo.messages).itemQueueSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fanN2.GiveFeedbackItem), null)), features.canManageQueues !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fanN2.GiveFeedbackItem), null)), (!practice || practice === (0, $oCMSG.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bUNF.default), null)));
};
const $512e7ff5c9d1d184$var$PracticeQueuesWithExperienceTracker = ({ practice: practice, title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKDnb.QueuesExperienceTracker), {
        experience: "viewQueuesNavExtended"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($512e7ff5c9d1d184$var$PracticeQueuesInternal, {
        practice: practice,
        title: title
    }));
};
const $512e7ff5c9d1d184$export$9720502a768ac6d4 = (0, $cSD7y.componentWithFG)('update_viewqueuesnav_instrumentation', $512e7ff5c9d1d184$var$PracticeQueuesWithExperienceTracker, $512e7ff5c9d1d184$var$PracticeQueuesInternal);

});
parcelRegister("cR56S", function(module, exports) {

$parcel$export(module.exports, "useProjectQueuesConnectItems", () => $3a899b88eb826b5c$export$50fe6ea577457a75);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $3a899b88eb826b5c$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $3a899b88eb826b5c$export$50fe6ea577457a75 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading } = (0, $1J3t1.useJSMProjectConnectQueuesNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $3a899b88eb826b5c$var$findItemAndStackMemo(items, route.name, location, [
            'queues'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("2bUNF", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $233bf08156102065$export$ed6342e0e28465a6);
$parcel$export(module.exports, "default", () => $233bf08156102065$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $1rTGO = parcelRequire("1rTGO");

var $LoDvw = parcelRequire("LoDvw");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $dAfqg = parcelRequire("dAfqg");

var $k51JQ = parcelRequire("k51JQ");

var $7Tlti = parcelRequire("7Tlti");

var $iIGGa = parcelRequire("iIGGa");

var $Mw97N = parcelRequire("Mw97N");
const $233bf08156102065$export$ed6342e0e28465a6 = (extension, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};
const $233bf08156102065$export$a133aa9cc8b5e080 = ()=>{
    const { data: data } = (0, $iIGGa.useServiceDeskQueueForgeApps)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $Mw97N.messages).forgeSectionTitle)
    }, data.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $233bf08156102065$export$ed6342e0e28465a6(extension, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            moduleName: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
        }
    }));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$233bf08156102065$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LoDvw.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($233bf08156102065$export$a133aa9cc8b5e080, null));

});
parcelRegister("LoDvw", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $d68c1b1fe01b723d$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $d68c1b1fe01b723d$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $d68c1b1fe01b723d$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $d68c1b1fe01b723d$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("Mw97N", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0a930757ccc9f8ec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0a930757ccc9f8ec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.servicedesk-queue.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("5MhuD", function(module, exports) {

$parcel$export(module.exports, "useQueueCustomRouterContext", () => $04b895fed4cbd829$export$f7c5cd815dd083e4);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");
const $04b895fed4cbd829$export$f7c5cd815dd083e4 = (projectKey)=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $5uXOq.useMemo)(()=>projectKey ? {
            matchParams: {
                ...match.params,
                projectKey: projectKey
            }
        } : undefined, [
        match.params,
        projectKey
    ]);
};

});

parcelRegister("emIzB", function(module, exports) {

$parcel$export(module.exports, "usePriorityGroupsActions", () => $da86e17b74592a56$export$aceb895c0a1bdb9);
$parcel$export(module.exports, "usePriorityGroupData", () => $da86e17b74592a56$export$e41417e5a9e40e44);
$parcel$export(module.exports, "usePriorityGroups", () => $da86e17b74592a56$export$9ad7fd5c13dc6dbb);
$parcel$export(module.exports, "useCategorizedGroupsNavItems", () => $da86e17b74592a56$export$7ddc2fd096cdc650);
$parcel$export(module.exports, "useNormalizedPriorityGroups", () => $da86e17b74592a56$export$c2e9f9150500e785);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $dAfqg = parcelRequire("dAfqg");

var $324W5 = parcelRequire("324W5");

var $1WlLE = parcelRequire("1WlLE");

var $koeKL = parcelRequire("koeKL");

var $2YP9W = parcelRequire("2YP9W");

var $bebaD = parcelRequire("bebaD");

var $jF62O = parcelRequire("jF62O");

var $bHygi = parcelRequire("bHygi");
const $da86e17b74592a56$var$updateGroup = (updatedGroup, groups)=>groups.map((g)=>g.id === updatedGroup.id ? {
            ...g,
            name: updatedGroup.name,
            version: updatedGroup.version,
            queues: updatedGroup.queueIds
        } : g);
const $da86e17b74592a56$var$deleteGroup = (id, groups)=>groups.filter((group)=>group.id !== id);
const $da86e17b74592a56$var$updateQueueGroups = (updatedGroups, groups)=>groups.map((group)=>{
        const matchedGroup = updatedGroups?.find((updatedGroup)=>updatedGroup.group.id === group.id);
        if (matchedGroup === undefined) return group;
        return {
            ...group,
            id: matchedGroup.group.id,
            name: matchedGroup.group.name,
            queues: matchedGroup.group.queueIds,
            version: matchedGroup.group.version
        };
    });
const $da86e17b74592a56$var$addQueueToGroupByGroupName = (queueId, updatedGroup, groups)=>groups.map((g)=>updatedGroup.includes(g.name) && !g.queues.includes(queueId) ? {
            ...g,
            queues: [
                ...g.queues,
                queueId
            ]
        } : g);
const $da86e17b74592a56$var$removeQueueFromGroupsByGroupName = (queueId, updatedGroup, groups)=>groups.map((g)=>updatedGroup.includes(g.name) ? {
            ...g,
            queues: g.queues.filter((q)=>q !== queueId)
        } : g);
const $da86e17b74592a56$var$createActions = (update, category, projectId, cloudId)=>({
        updateQueuesInGroup: (id, name, version, newQueues)=>(0, $bHygi.updateGroup)({
                cloudId: cloudId,
                id: id,
                name: name,
                version: version,
                queueIds: newQueues
            }).then((updatedGroup)=>{
                update((data)=>({
                        ...data,
                        [category]: $da86e17b74592a56$var$updateGroup(updatedGroup, data[category])
                    }));
            }),
        renameGroup: (id, newName, version, queues)=>(0, $bHygi.updateGroup)({
                cloudId: cloudId,
                id: id,
                name: newName,
                version: version,
                queueIds: queues
            }).then((updatedGroup)=>{
                update((data)=>({
                        ...data,
                        [category]: $da86e17b74592a56$var$updateGroup(updatedGroup, data[category])
                    }));
            }),
        createGroup: (name)=>(0, $bHygi.createGroup)({
                name: name,
                category: category,
                projectId: projectId,
                cloudId: cloudId,
                queueIds: []
            }).then((createdGroup)=>{
                update((data)=>{
                    const groups = data[category] || [];
                    return {
                        ...data,
                        [category]: [
                            ...groups,
                            {
                                ...createdGroup,
                                queues: createdGroup.queueIds
                            }
                        ]
                    };
                });
            }),
        deleteGroup: (id)=>(0, $bHygi.deleteGroup)({
                cloudId: cloudId,
                id: id
            }).then(()=>{
                update((data)=>({
                        ...data,
                        [category]: $da86e17b74592a56$var$deleteGroup(id, data[category])
                    }));
            }),
        addQueueToGroupByGroupName: (queueId, toUpdateGroups)=>{
            if (toUpdateGroups.length === 0) return;
            update((data)=>({
                    ...data,
                    [category]: $da86e17b74592a56$var$addQueueToGroupByGroupName(queueId, toUpdateGroups, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    data[category])
                }));
        },
        removeQueueFromGroupsByGroupName: (queueId, toUpdateGroups)=>{
            if (toUpdateGroups.length === 0) return;
            update((data)=>({
                    ...data,
                    [category]: $da86e17b74592a56$var$removeQueueFromGroupsByGroupName(queueId, toUpdateGroups, data[category])
                }));
        },
        updateQueueGroupsByGroupId: (queueId, toUpdateGroups)=>(0, $bHygi.updateQueueGroupsByGroupId)({
                cloudId: cloudId,
                projectId: projectId,
                category: category,
                queueId: queueId,
                groupIds: toUpdateGroups
            }).then((updatedGroups)=>{
                update((data)=>({
                        ...data,
                        [category]: $da86e17b74592a56$var$updateQueueGroups(updatedGroups.results, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        data[category])
                    }));
            })
    });
const $da86e17b74592a56$var$fetchPriorityGroupByProjectId = ()=>(0, $4R6GH.fg)('jsm_flash_priority_group_api_optimisation') && !(0, $3HwlS.getWillShowNav4)();
const $da86e17b74592a56$export$aceb895c0a1bdb9 = ()=>{
    const category = (0, $bebaD.useCurrentCategory)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    let update;
    if ($da86e17b74592a56$var$fetchPriorityGroupByProjectId()) // eslint-disable-next-line react-hooks/rules-of-hooks
    update = (0, $2YP9W.useResource)((0, $1WlLE.priorityGroupByProjectIdResource)).update;
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    update = (0, $2YP9W.useResource)((0, $1WlLE.priorityGroupResource)).update;
    const projectId = projectContext?.projectId;
    return (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>$da86e17b74592a56$var$createActions(update, category, projectId?.toString(), cloudId), [
        category,
        cloudId,
        projectId,
        update
    ]);
};
const $da86e17b74592a56$export$e41417e5a9e40e44 = (customContext)=>$da86e17b74592a56$var$fetchPriorityGroupByProjectId() ? (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.priorityGroupByProjectIdResource), customContext) : (0, $324W5.useResourceWithCustomRouterContext)((0, $1WlLE.priorityGroupResource), customContext);
const $da86e17b74592a56$export$9ad7fd5c13dc6dbb = (category, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = $da86e17b74592a56$export$e41417e5a9e40e44(customContext);
    const categorizedGroups = (0, $5uXOq.useMemo)(()=>(data && data[category]) ?? [], [
        category,
        data
    ]);
    return [
        categorizedGroups,
        loading,
        error,
        refresh
    ];
};
const $da86e17b74592a56$export$7ddc2fd096cdc650 = (projectKey, category, customContext)=>{
    const [groups, groupLoading, groupError] = $da86e17b74592a56$export$9ad7fd5c13dc6dbb(category, customContext);
    const [navItems, loading, queueError] = (0, $jF62O.useCategorizedNavItems)('', projectKey, category, customContext);
    return (0, $5uXOq.useMemo)(()=>{
        const isLoading = loading || groupLoading;
        if (isLoading || queueError || groupError) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            [],
            isLoading,
            groupError,
            queueError
        ];
        const normalizedGroups = groups.map((group)=>({
                group: group,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues.map((queueId)=>navItems?.find((item)=>Number.parseInt(item.id, 10) === queueId)).filter((item)=>!!item)
            }));
        return [
            normalizedGroups,
            isLoading,
            groupError,
            queueError
        ];
    }, [
        groupError,
        groupLoading,
        groups,
        loading,
        navItems,
        queueError
    ]);
};
const $da86e17b74592a56$export$c2e9f9150500e785 = ()=>{
    const projectKey = (0, $bebaD.useProjectKey)();
    const category = (0, $bebaD.useCurrentCategory)();
    const [groups, groupLoading] = $da86e17b74592a56$export$9ad7fd5c13dc6dbb(category);
    const [navItems, loading, error] = (0, $jF62O.useCategorizedQueues)('', projectKey, category);
    return (0, $5uXOq.useMemo)(()=>{
        const isLoading = loading || groupLoading;
        if (isLoading || error) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            [],
            isLoading,
            error
        ];
        const normalizedGroups = groups.map((group)=>({
                group: group,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues.map((queueId)=>navItems?.find((item)=>item.id === queueId)).filter((queue)=>!!queue)
            }));
        return [
            normalizedGroups,
            isLoading,
            error
        ];
    }, [
        error,
        groupLoading,
        groups,
        loading,
        navItems
    ]);
};

});
parcelRegister("bHygi", function(module, exports) {

$parcel$export(module.exports, "createGroup", () => $a7a86b8cce8a7c4d$export$856f728536d122cb);
$parcel$export(module.exports, "updateGroup", () => $a7a86b8cce8a7c4d$export$7266cde9e95c4de8);
$parcel$export(module.exports, "deleteGroup", () => $a7a86b8cce8a7c4d$export$ae2679b329fc10b6);
$parcel$export(module.exports, "updateQueueGroupsByGroupId", () => $a7a86b8cce8a7c4d$export$bdf88b9d006a8a43);

var $eusud = parcelRequire("eusud");
const $a7a86b8cce8a7c4d$export$856f728536d122cb = ({ cloudId: cloudId, projectId: projectId, category: category, name: name, queueIds: queueIds })=>{
    const createGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group`;
    const payload = {
        projectId: projectId,
        category: category,
        name: name,
        queueIds: queueIds
    };
    return (0, $eusud.performPostRequest)(createGroupUrl, {
        body: JSON.stringify(payload)
    });
};
const $a7a86b8cce8a7c4d$export$7266cde9e95c4de8 = ({ cloudId: cloudId, id: id, version: version, name: name, queueIds: queueIds })=>{
    const updateGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/${id}`;
    const payload = {
        version: version,
        name: name,
        queueIds: queueIds
    };
    return (0, $eusud.performPutRequest)(updateGroupUrl, {
        body: JSON.stringify(payload)
    });
};
const $a7a86b8cce8a7c4d$export$ae2679b329fc10b6 = ({ cloudId: cloudId, id: id })=>{
    const deleteGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/${id}`;
    return (0, $eusud.performDeleteRequest)(deleteGroupUrl);
};
const $a7a86b8cce8a7c4d$export$bdf88b9d006a8a43 = ({ cloudId: cloudId, projectId: projectId, category: category, queueId: queueId, groupIds: groupIds })=>{
    const batchUpdateQueueGroupsUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/batch/update-queue-groups/${projectId}/${category}`;
    const payload = {
        projectId: projectId,
        category: category,
        queueId: queueId,
        groupIds: groupIds
    };
    return (0, $eusud.performPutRequest)(batchUpdateQueueGroupsUrl, {
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("gRCL3", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $115382004ebb0828$export$ddf44c597e03063d);

var $5uXOq = parcelRequire("5uXOq");

var $1sWm7 = parcelRequire("1sWm7");

var $dMEgP = parcelRequire("dMEgP");

var $eXQym = parcelRequire("eXQym");

var $4041n = parcelRequire("4041n");
const $115382004ebb0828$var$updateQueueUsingCallback = (queues, queueItemChanges, editItemFavoriteCallback, refreshIssueCountForItemsCallback)=>{
    if (queues) {
        const itemsToRefresh = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(queues, {
                id: id
            });
            if (queue && queue.starred !== value) {
                const isHiddenQueueStarred = queue.canBeHidden === true && value === true;
                editItemFavoriteCallback(id, value);
                if (isHiddenQueueStarred) itemsToRefresh.push(id);
            }
        });
        if (itemsToRefresh && itemsToRefresh.length > 0) refreshIssueCountForItemsCallback(itemsToRefresh);
    }
};
const $115382004ebb0828$export$ddf44c597e03063d = (projectKey, category, queues, editItemFavoriteCallback, refreshIssueCountForItemsCallback)=>{
    const { items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const queueItemChanges = items[0, $eXQym.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $5uXOq.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        $115382004ebb0828$var$updateQueueUsingCallback(queues, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        queueItemChanges, editItemFavoriteCallback, refreshIssueCountForItemsCallback);
    }
};

});
parcelRegister("1sWm7", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $fW7cr = parcelRequire("fW7cr");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
module.exports = $1115ac3ae60cc7bc$var$find;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});



parcelRegister("iPLM4", function(module, exports) {

$parcel$export(module.exports, "useQueueFeatures", () => $4293f886a9a9579f$export$abd834ff12646a2a);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $gq0sA = parcelRequire("gq0sA");
const $4293f886a9a9579f$export$abd834ff12646a2a = ()=>{
    const [{ data: pageContextData, error: pageContextError }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
    const canMoveQueues = !pageContextError ? projectContext?.isAdmin || tenantContext?.isSiteAdmin : false;
    const canManageQueues = !pageContextError ? projectContext && projectContext.isAdmin : false;
    const { data: data } = (0, $1J3t1.useJiraServiceManagementProjectNavigation)();
    const hasNewQueueItemV4Nav = (0, $5uXOq.useMemo)(()=>data && data.isAdminAgent, [
        data
    ]);
    return {
        canMoveQueues: Boolean(canMoveQueues),
        hasNewQueueItem: Boolean(hasNewQueueItemV4Nav),
        canManageQueues: Boolean(canManageQueues)
    };
};

});

parcelRegister("8WEWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf9a2354a406d761$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c8Oei = parcelRequire("c8Oei");

var $hWZau = parcelRequire("hWZau");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");

var $cSD7y = parcelRequire("cSD7y");

var $koVbs = parcelRequire("koVbs");

var $lpwtK = parcelRequire("lpwtK");

var $5Srj8 = parcelRequire("5Srj8");

var $emIzB = parcelRequire("emIzB");

var $jF62O = parcelRequire("jF62O");

var $4R6GH = parcelRequire("4R6GH");

var $eGsEn = parcelRequire("eGsEn");

var $fekw4 = parcelRequire("fekw4");

var $6eLdp = parcelRequire("6eLdp");
const $cf9a2354a406d761$var$AllQueueButton = ({ expanded: expanded, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf9a2354a406d761$var$CollapsibleSectionContainer, {
        "aria-expanded": expanded,
        onClick: onClick,
        type: "button"
    }, expanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-text, #172B4D)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-text, #172B4D)"
    }), (0, $4R6GH.fg)('fix_jsm_queue_insertbefore_error') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span"
    }, formatMessage((0, $6eLdp.messages).allQueues)) : formatMessage((0, $6eLdp.messages).allQueues));
};
const $cf9a2354a406d761$var$AllQueuesSection = ({ practice: practice })=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const projectKey = project?.key || '';
    const projectId = project?.id.toString() || '';
    const [allQueues] = (0, $jF62O.useCategorizedNavItems)('', projectKey, practice);
    const [groups] = (0, $emIzB.useCategorizedGroupsNavItems)(projectKey, practice);
    const [pathCategorySelectedSection] = (0, $5Srj8.useSelectedQueueSectionByCategory)(practice);
    const isAllQueuesSelected = pathCategorySelectedSection === (0, $5Srj8.QueueListSection).ALL_QUEUES;
    const [expandHiddenSection, setExpandHiddenSection] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const stateFromLocalStorage = (0, $fekw4.getAllQueuesStateFromLocalStorage)(projectId);
        setExpandHiddenSection(stateFromLocalStorage === undefined ? isAllQueuesSelected : stateFromLocalStorage);
    }, [
        groups.length,
        isAllQueuesSelected,
        projectId
    ]);
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Keep the focus when using space or enter key.
        e.stopPropagation();
        setExpandHiddenSection(!expandHiddenSection);
        (0, $fekw4.setAllQueuesStateInLocalStorage)(projectId, !expandHiddenSection);
    }, [
        expandHiddenSection,
        projectId
    ]);
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf9a2354a406d761$var$AllQueueButton, {
        expanded: expandHiddenSection,
        onClick: handleClick
    }), expandHiddenSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGsEn.QueueList), {
        queues: allQueues,
        section: (0, $5Srj8.QueueListSection).ALL_QUEUES
    }));
};
var $cf9a2354a406d761$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $cf9a2354a406d761$var$AllQueuesSection;
const $cf9a2354a406d761$var$CollapsibleSectionContainerLegacy = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81o8v _1e0c1txw _4cvr1h6o _80omtlke _19pkpxbi _otyru2gc _bfhk18uv _1bsb1osq _1p1dangw _k48pmoej _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf9a2354a406d761$var$CollapsibleSectionContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c8dcr7 _1e0c1txw _4cvr1h6o _80omtlke _19pkpxbi _otyru2gc _bfhk18uv _1bsb1osq _k48pmoej _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $cf9a2354a406d761$var$CollapsibleSectionContainer = (0, $cSD7y.componentWithFG)('queue-groups-nav3-minor-ui-updates', $cf9a2354a406d761$var$CollapsibleSectionContainerNew, $cf9a2354a406d761$var$CollapsibleSectionContainerLegacy);

});
parcelRegister("eGsEn", function(module, exports) {

$parcel$export(module.exports, "QueueList", () => $85d4744792c9e744$export$6b278a59f65cf1eb);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fW7cr = parcelRequire("fW7cr");

var $2Zxiy = parcelRequire("2Zxiy");

var $lpwtK = parcelRequire("lpwtK");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4ZEcj = parcelRequire("4ZEcj");

var $jF62O = parcelRequire("jF62O");

var $3kZFO = parcelRequire("3kZFO");
const $85d4744792c9e744$export$6b278a59f65cf1eb = ({ QueueItem: QueueItem = (0, $3kZFO.QueueItem), queues: queues, section: section })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, queues.map((queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(QueueItem, {
            key: queue.id,
            queue: queue,
            section: section
        })));
const $85d4744792c9e744$export$dcd39fa083a1ad8a = ({ DragDropContext: DragDropContext = (0, $2Zxiy.DragDropContext), Droppable: Droppable = (0, $2Zxiy.Droppable), Draggable: Draggable = (0, $2Zxiy.Draggable), QueueItem: QueueItem = (0, $3kZFO.QueueItem), onDragEnd: onDragEnd, queues: queues })=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
    const onDragStart = (0, $5uXOq.useCallback)(()=>{
        setIsDragging(true);
    }, []);
    const onDragEndInternal = (0, $5uXOq.useCallback)((result, provided)=>{
        setIsDragging(false);
        onDragEnd(result, provided);
    }, [
        onDragEnd
    ]);
    const renderQueueItems = (0, $5uXOq.useCallback)((droppableProps, placeholder)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, queues.map((queue, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Draggable, {
                disableInteractiveElementBlocking: true,
                key: queue.id,
                draggableId: queue.id,
                index: index
            }, ({ innerRef: innerRef, dragHandleProps: dragHandleProps, draggableProps: draggableProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(QueueItem, {
                    // @ts-expect-error - TS2322 - Type '{ style?: DraggingStyle | NotDraggingStyle | undefined; 'data-rbd-draggable-context-id': string; 'data-rbd-draggable-id': string; onTransitionEnd?: TransitionEventHandler<...> | undefined; ... 8 more ...; queue: QueueNavItem; }' is not assignable to type 'IntrinsicAttributes & QueueItemProps & { children?: ReactNode; }'.
                    ref: innerRef,
                    queue: queue,
                    ...dragHandleProps,
                    ...draggableProps
                }))), placeholder), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        queues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DragDropContext, {
        onDragStart: onDragStart,
        onDragEnd: onDragEndInternal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Droppable, {
        droppableId: "queues"
    }, ({ innerRef: droppableRef, droppableProps: droppableProps, placeholder: placeholder }, { isDraggingOver: isDraggingOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85d4744792c9e744$export$f598c65f623cbfc3, {
            isDragging: isDragging,
            isDraggingOver: isDraggingOver,
            ref: droppableRef,
            ...droppableProps
        }, renderQueueItems(droppableProps, placeholder))));
};
const $85d4744792c9e744$export$35a9dd94efab5e06 = ({ practice: practice, queues: queues, ...rest })=>{
    // TODO This baseUrl has a dependency o@atlassian/jira-servicedesk-queues-categorized-store
    // The above items need to be updated prior to complete baseUrl removal from this file.
    const baseUrl = '';
    const { data: project } = (0, $lpwtK.useProject)();
    const projectKey = project ? project.key : '';
    const [allQueues, , , methods] = (0, $jF62O.useCategorizedNavItems)(baseUrl, projectKey, practice);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleDragEnd = (0, $5uXOq.useCallback)((data)=>{
        const destinationIndex = data.destination?.index;
        if (data && data.source && destinationIndex !== undefined && allQueues && queues) {
            const fromIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(allQueues, {
                id: data.draggableId
            });
            const sourceIndexQueue = queues[destinationIndex];
            const toIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(allQueues, {
                id: sourceIndexQueue.id
            });
            methods.moveItem(fromIndex, toIndex);
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragged',
                actionSubject: 'navigationItem'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                itemId: `queue-${sourceIndexQueue.id}`,
                itemType: 'queue'
            });
        }
    }, [
        allQueues,
        createAnalyticsEvent,
        methods,
        queues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85d4744792c9e744$export$dcd39fa083a1ad8a, {
        ...rest,
        queues: queues,
        onDragEnd: handleDragEnd
    });
};
const $85d4744792c9e744$export$f598c65f623cbfc3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $4ZEcj.DragAndDropQueuesContainerBorderCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0v77o _2hwxv77o",
            !__cmplp.isDragging && "_bfhkn7od",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ZEcj", function(module, exports) {

$parcel$export(module.exports, "DragAndDropQueuesContainerBorderCompiled", () => $c8aaf7793e5d1e13$export$ab4215b191859a7b);
/* styles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c8aaf7793e5d1e13$export$6746fe0d9c9fab54 = 12;
const $c8aaf7793e5d1e13$export$ab4215b191859a7b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDropDisabled: isDropDisabled, isDragging: isDragging, isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _vchhusvi",
            __cmplp.isDropDisabled && "_19itex4c _bfhkqbzx",
            !__cmplp.isDropDisabled && !__cmplp.isDragging && "_19itex4c _bfhkqbzx",
            !__cmplp.isDropDisabled && __cmplp.isDragging && __cmplp.isDraggingOver && "_19it1on9 _bfhki1yw",
            !__cmplp.isDropDisabled && __cmplp.isDragging && !__cmplp.isDraggingOver && "_19it1on9 _bfhkfg4m",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3kZFO", function(module, exports) {

$parcel$export(module.exports, "QueueItem", () => $825105589241f090$export$1b63de307530e1bc);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hUobS = parcelRequire("hUobS");

var $1sXeC = parcelRequire("1sXeC");

var $16T6Y = parcelRequire("16T6Y");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $1p96B = parcelRequire("1p96B");

var $5MhuD = parcelRequire("5MhuD");

var $5Srj8 = parcelRequire("5Srj8");

var $emIzB = parcelRequire("emIzB");

var $oCMSG = parcelRequire("oCMSG");

var $1ilU2 = parcelRequire("1ilU2");

var $DVljb = parcelRequire("DVljb");

var $bmKPg = parcelRequire("bmKPg");
var $doZTA = parcelRequire("doZTA");

var $8OR0k = parcelRequire("8OR0k");

var $lGnt6 = parcelRequire("lGnt6");

var $fmDJR = parcelRequire("fmDJR");

var $34dgN = parcelRequire("34dgN");
const $825105589241f090$var$MAX_BADGE_COUNT = 999;
const $825105589241f090$export$1b710b78e8672f80 = (pathCategorySelectedSection, currentQueueInSection)=>(currentLocation, itemLocation)=>{
        const pathNameMatches = currentLocation.pathname === itemLocation.pathname || currentLocation.pathname.substring(0, currentLocation.pathname.lastIndexOf('/')) === itemLocation.pathname;
        const isSectionMatched = pathCategorySelectedSection === currentQueueInSection;
        if (!(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return pathNameMatches && isSectionMatched;
        const pathNameMatchesNew = currentLocation.pathname === itemLocation.pathname || currentLocation.pathname.substring(0, currentLocation.pathname.lastIndexOf('/')) === itemLocation.pathname || currentLocation.pathname.substring(0, currentLocation.pathname.lastIndexOf('/board/')) === itemLocation.pathname || currentLocation.pathname.substring(0, currentLocation.pathname.lastIndexOf('/calendar/')) === itemLocation.pathname || currentLocation.pathname.substring(0, currentLocation.pathname.lastIndexOf('/edit/')) === itemLocation.pathname;
        return pathNameMatchesNew && isSectionMatched;
    };
const $825105589241f090$export$1b63de307530e1bc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ Badge: Badge = (0, $16T6Y.default), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), queue: queue, section: section, ...rest }, ref)=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const [queueId] = (0, $bmKPg.usePathParam)('queueId');
    const [practice] = (0, $bmKPg.usePathParam)('practiceType');
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const pathCategory = (0, $1ilU2.toItsmPractice)(practice);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [pathCategorySelectedSection, { updatePathCategorySelectedQueueSection: updatePathCategorySelectedQueueSection }] = (0, $5Srj8.useSelectedQueueSectionByCategory)(pathCategory);
    const href = `/jira/servicedesk${queue.url}`;
    const isSelected = route != null && queueId === queue.id && location.pathname.startsWith(href);
    const locale = (0, $DVljb.useLocale)();
    const queueCategory = queue.category || (0, $oCMSG.NO_CATEGORY);
    const queueCustomContext = (0, $5MhuD.useQueueCustomRouterContext)(projectKey);
    const queuesContextTemp = (0, $4R6GH.fg)('add-custom-context-to-nav3-group-fetch-calls') ? queueCustomContext : undefined;
    const [priorityGroups] = (0, $emIzB.usePriorityGroups)(queueCategory, queuesContextTemp);
    const [selectedGroupId] = (0, $5Srj8.useSelectedGroupIdByCategory)(queueCategory);
    const [lastSelectedSection] = (0, $5Srj8.useSelectedQueueSectionByCategory)(queueCategory);
    const actualSelectedSection = (0, $5uXOq.useMemo)(()=>{
        if (isSelected) return (0, $34dgN.calculateSelectedSection)(queue, priorityGroups, lastSelectedSection, section, selectedGroupId);
        return lastSelectedSection;
    }, [
        isSelected,
        lastSelectedSection,
        priorityGroups,
        queue,
        section,
        selectedGroupId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isSelected && actualSelectedSection === section && actualSelectedSection !== pathCategorySelectedSection) updatePathCategorySelectedQueueSection(projectKey || '', queueCategory, section);
    }, [
        actualSelectedSection,
        isSelected,
        pathCategory,
        pathCategorySelectedSection,
        projectKey,
        queue,
        queueCategory,
        section,
        updatePathCategorySelectedQueueSection
    ]);
    const getFormattedRelativeLastRefreshedTime = (0, $5uXOq.useCallback)(()=>{
        if (queue.badgeCount === undefined) return formatMessage((0, $lGnt6.tooltipMessages).loadingIssueCountTooltip);
        const lastRefreshedTime = queue.lastRefreshedTime === 0 || queue.lastRefreshedTime === undefined ? Date.now() : queue.lastRefreshedTime;
        return formatMessage((0, $lGnt6.tooltipMessages).showLastRefreshedTimeTooltip, {
            lastUpdate: (0, $1p96B.formatDistanceStrictWithLocale)(lastRefreshedTime, Date.now(), locale, true)
        });
    }, [
        formatMessage,
        locale,
        queue.badgeCount,
        queue.lastRefreshedTime
    ]);
    const shouldShowBadge = (0, $5uXOq.useCallback)(()=>{
        if (section !== (0, $5Srj8.QueueListSection).ALL_QUEUES) return true;
        return isSelected && pathCategorySelectedSection === section;
    }, [
        isSelected,
        pathCategorySelectedSection,
        section
    ]);
    const issueCountBadge = shouldShowBadge() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ()=>getFormattedRelativeLastRefreshedTime()
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-is-queue-issue-count-badge": true,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Badge, {
            max: $825105589241f090$var$MAX_BADGE_COUNT
        }, (0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(queue.badgeCount) ? (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(queue.badgeCount) : '-')));
    const starButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmDJR.StarButton), {
        isStarred: queue.starred,
        queueId: queue.id
    });
    const starrableBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-is-star-queue-button": true
    }, starButton), issueCountBadge);
    const issueCountErrorBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-is-star-queue-button": true
    }, starButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8OR0k.default), {
        queue: queue
    }));
    const shouldShowIssueCountError = (0, $5uXOq.useCallback)(()=>{
        return queue.shouldSkipIssueCountRefresh && shouldShowBadge();
    }, [
        queue.shouldSkipIssueCountRefresh,
        shouldShowBadge
    ]);
    const notificationBadge = shouldShowIssueCountError() ? issueCountErrorBadge : starrableBadge;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($825105589241f090$export$75d003fa8b0d90ff, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        ref: ref,
        analytics: {
            itemId: `queue-${queue.id}`,
            itemType: 'queue',
            sidebarSection: (0, $5Srj8.QueueListSection)[section]
        },
        href: href,
        selectedOn: $825105589241f090$export$1b710b78e8672f80(actualSelectedSection, section),
        onClick: ()=>updatePathCategorySelectedQueueSection(projectKey || '', queue.category || (0, $oCMSG.NO_CATEGORY), section),
        iconAfter: notificationBadge,
        "aria-label": queue.name,
        ...rest
    }, queue.name));
});
const $825105589241f090$export$75d003fa8b0d90ff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1g2tn7od _1t0sn7od _9llvn7od _zvirn7od _gabin7od _12s0n7od _wbv8n7od _l0ton7od _whtcglyw _12wg1b66 _jl6u1ule _7rxv1ule",
            __cmplp.className
        ])
    });
});

});
parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("8OR0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $651aa550b9345c98$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");

var $ggICg = parcelRequire("ggICg");

var $gb7Oz = parcelRequire("gb7Oz");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");

var $lpwtK = parcelRequire("lpwtK");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $jF62O = parcelRequire("jF62O");

var $itmJb = parcelRequire("itmJb");

var $8IA2f = parcelRequire("8IA2f");
const $651aa550b9345c98$export$9facd8d31b938a25 = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const projectContext = (0, $dAfqg.useProjectContext)();
    const isProjectAdmin = isAdmin || projectContext?.data?.isProjectAdmin || false;
    return {
        isProjectAdmin: isProjectAdmin
    };
};
const $651aa550b9345c98$var$learnMoreUrl = 'https://community.atlassian.com/t5/Jira-Service-Management-articles/Managing-queues-at-scale-in-Jira-Service-Management/ba-p/2102021';
const $651aa550b9345c98$export$ca8e59510a286136 = ({ queue: queue })=>{
    const [showDialog, setShowDialog] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const [, , , methods] = (0, $jF62O.useCategorizedNavItems)('', project ? project.key : '', queue.category);
    const onReload = (0, $5uXOq.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'ReloadBadQueueButton');
        methods.enableRefreshForQueues([
            queue.id
        ]);
        methods.refreshIssueCountForItems([
            queue.id
        ]);
    }, [
        methods,
        queue.id,
        createAnalyticsEvent
    ]);
    const onEditQueue = (0, $5uXOq.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        setShowDialog(false);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'EditQueueFromIssueCountErrorDialog'
        }), {
            meta: {
                id: 'ViewEditQueueFromIssueCountErrorDialog',
                packageName: 'jiraNavigationAppsSidebarServicedesk',
                teamName: 'jsd-shield'
            },
            canBeHidden: queue.canBeHidden,
            isStarred: queue.starred
        });
    }, [
        setShowDialog,
        queue.canBeHidden,
        queue.starred,
        createAnalyticsEvent
    ]);
    const onLearnMoreClick = (0, $5uXOq.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        setShowDialog(false);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'BadQueueLearnMoreButton');
    }, [
        createAnalyticsEvent
    ]);
    const learnMoreButton = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
            target: "_blank",
            onClick: onLearnMoreClick,
            href: $651aa550b9345c98$var$learnMoreUrl
        }, formatMessage((0, $8IA2f.messages).learnMoreButtonLabel)), [
        formatMessage,
        onLearnMoreClick
    ]);
    const reloadButton = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            onClick: onReload
        }, formatMessage((0, $8IA2f.messages).reloadButtonLabel)), [
        onReload,
        formatMessage
    ]);
    const editQueueButton = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
            testId: "navigation-apps-sidebar-servicedesk.common.ui.practice-queues.queue-list.queue-item.issue-count-error-message.edit-queue-button",
            href: `${queue.url}/edit`,
            onClick: onEditQueue,
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg)))
        }, formatMessage((0, $8IA2f.messages).editQueueButtonLabel)), [
        queue.url,
        onEditQueue,
        formatMessage
    ]);
    const { isProjectAdmin: isProjectAdmin } = $651aa550b9345c98$export$9facd8d31b938a25();
    const userActionButton = isProjectAdmin ? editQueueButton : reloadButton;
    const agentMessage = queue.starred ? (0, $8IA2f.messages).issueCountErrorMessageAgentStarred : (0, $8IA2f.messages).issueCountErrorMessageAgentNotStarred;
    const contentMessage = isProjectAdmin ? (0, $8IA2f.messages).issueCountErrorMessageAdmin : agentMessage;
    const content = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            weight: "bold"
        }, formatMessage((0, $8IA2f.messages).issueCountErrorMessageHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, formatMessage(contentMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.100"
        }, learnMoreButton, userActionButton)), [
        contentMessage,
        formatMessage,
        learnMoreButton,
        userActionButton
    ]);
    const onIssueCountErrorButtonClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2315 - Type 'Mouse Event' is not generic.
    (e)=>{
        e.stopPropagation(); // prevent underlying queue button from being pressed
        e.preventDefault();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'IssueCountErrorButton');
        setShowDialog(!showDialog);
    }, [
        showDialog,
        setShowDialog,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        onClose: ()=>{
            setShowDialog(false);
        },
        content: content,
        isOpen: showDialog,
        messageId: "navigation-apps-sidebar-servicedesk.common.ui.practice-queues.queue-list.queue-item.issue-count-error-message.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        onClick: onIssueCountErrorButtonClick,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gb7Oz))),
        label: formatMessage((0, $8IA2f.messages).learnMoreButtonLabel),
        testId: "navigation-apps-sidebar-servicedesk.common.ui.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-button"
    }));
};
var $651aa550b9345c98$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $651aa550b9345c98$export$ca8e59510a286136;
const $651aa550b9345c98$var$InlineDialogContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _p12f3xl8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $651aa550b9345c98$var$InlineDialogHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $651aa550b9345c98$var$InlineDialogButtons = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0xmi2 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $651aa550b9345c98$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _14hp1tcg _jq8g1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $651aa550b9345c98$export$7ed12d2a5241e393 = {
    InlineDialogContainer: $651aa550b9345c98$var$InlineDialogContainer,
    InlineDialogHeader: $651aa550b9345c98$var$InlineDialogHeader,
    InlineDialogButtons: $651aa550b9345c98$var$InlineDialogButtons,
    ButtonWrapper: $651aa550b9345c98$var$ButtonWrapper
};

});
parcelRegister("gb7Oz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77723dece3c67bedf7bcbbec84e5d004>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc73bc3d72b7857d$var$_react = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc73bc3d72b7857d$var$_warning = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("34Rrn")));

var $bc73bc3d72b7857d$var$_warning2 = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("hD8l9")));
function $bc73bc3d72b7857d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc73bc3d72b7857d$var$WarningIcon = (props)=>/*#__PURE__*/ $bc73bc3d72b7857d$var$_react.default.createElement($bc73bc3d72b7857d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $bc73bc3d72b7857d$var$_warning2.default
    }, props));
$bc73bc3d72b7857d$var$WarningIcon.Name = 'WarningIconMigration';
var $bc73bc3d72b7857d$var$_default = module.exports.default = $bc73bc3d72b7857d$var$WarningIcon;

});
parcelRegister("hD8l9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd5c8c5b40614fc0$var$_react = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cd5c8c5b40614fc0$var$_warning = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("34Rrn")));
function $cd5c8c5b40614fc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cd5c8c5b40614fc0$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $cd5c8c5b40614fc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $cd5c8c5b40614fc0$var$_warning.default
    }));
$cd5c8c5b40614fc0$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $cd5c8c5b40614fc0$var$_default = module.exports.default = $cd5c8c5b40614fc0$var$EditorWarningIcon;

});


parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("8IA2f", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b5fae75f3cd0d1b9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b5fae75f3cd0d1b9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueCountErrorMessageHeader: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-header",
        "defaultMessage": "We can't show the number of issues"
    },
    issueCountErrorMessageLabel: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-label",
        "defaultMessage": "Show queue issue count error details"
    },
    issueCountErrorMessageAdmin: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-admin",
        "defaultMessage": "There seems to be a problem with the queue's filters. Edit the queue and try again."
    },
    issueCountErrorMessageAgentStarred: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-agent-starred",
        "defaultMessage": "There seems to be a problem with the queue's filters. Contact your admins to edit this queue or remove it from Starred."
    },
    issueCountErrorMessageAgentNotStarred: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-agent-not-starred",
        "defaultMessage": "There seems to be a problem with the queue's filters. Contact your admins to edit this queue."
    },
    learnMoreButtonLabel: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.issue-count-error-message.learn-more-button-label",
        "defaultMessage": "Learn more"
    },
    reloadButtonLabel: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.issue-count-error-message.reload-button-label",
        "defaultMessage": "Reload"
    },
    editQueueButtonLabel: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.issue-count-error-message.edit-queue-button-label",
        "defaultMessage": "Edit queue"
    }
});

});


parcelRegister("lGnt6", function(module, exports) {

$parcel$export(module.exports, "tooltipMessages", () => $31c9d25e5f1182bd$export$4713da6aa4410043);

var $7VHMR = parcelRequire("7VHMR");
const $31c9d25e5f1182bd$export$4713da6aa4410043 = (0, $7VHMR.defineMessages)({
    loadingIssueCountTooltip: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.loading-issue-count-tooltip",
        "defaultMessage": "Loading the number of issues"
    },
    showLastRefreshedTimeTooltip: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queue-list.queue-item.show-last-refreshed-time-tooltip",
        "defaultMessage": "Last updated {lastUpdate}"
    }
});

});

parcelRegister("fmDJR", function(module, exports) {

$parcel$export(module.exports, "StarButton", () => $2d4a2f63cfde964e$export$b4b5678234ca6d4d);

var $5uXOq = parcelRequire("5uXOq");

var $hcObS = parcelRequire("hcObS");

var $eXQym = parcelRequire("eXQym");

var $4041n = parcelRequire("4041n");
const $2d4a2f63cfde964e$export$b4b5678234ca6d4d = ({ isStarred: isStarred, queueId: queueId })=>{
    const { changeFavorite: changeFavorite } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        isFavorite: isStarred,
        pending: false,
        isSmall: true,
        onClick: (analyticsEvent)=>{
            changeFavorite({
                id: queueId,
                value: !isStarred,
                type: (0, $eXQym.QUEUES_ITEM_TYPE)
            }, analyticsEvent);
        }
    });
};

});
parcelRegister("hcObS", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $0a68425ce3fc2fa8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dm1qi = parcelRequire("dm1qi");

var $dAf5R = parcelRequire("dAf5R");

var $5oTeF = parcelRequire("5oTeF");

var $bH1hf = parcelRequire("bH1hf");

var $7FtaJ = parcelRequire("7FtaJ");

var $1Cvrw = parcelRequire("1Cvrw");

var $fNobW = parcelRequire("fNobW");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $7XYc4 = parcelRequire("7XYc4");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $6fQ6A = parcelRequire("6fQ6A");
const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $0a68425ce3fc2fa8$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
            "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bH1hf))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5oTeF))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($7FtaJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($1Cvrw)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))) : (0, (/*@__PURE__*/$parcel$interopDefault($dAf5R)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6fQ6A.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6fQ6A.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $az4zD.injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
const $0a68425ce3fc2fa8$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$db65185b5889c83 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("6fQ6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc2ec5d9a72db1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});



parcelRegister("34dgN", function(module, exports) {

$parcel$export(module.exports, "calculateSelectedSection", () => $8470a0fc39b8da47$export$b70190c48788c872);

var $5Srj8 = parcelRequire("5Srj8");
const $8470a0fc39b8da47$export$b70190c48788c872 = (queue, priorityGroups, lastSelectedSection, currentSection, selectedGroupId)=>{
    if (currentSection === lastSelectedSection) return currentSection;
    const isStarred = queue.starred;
    const selectedPriorityGroup = priorityGroups.find((group)=>group.id === selectedGroupId);
    const isQueueInSelectedGroup = selectedPriorityGroup?.queues.some((queueInGroup)=>queueInGroup.toString(10) === queue.id);
    if (lastSelectedSection === (0, $5Srj8.QueueListSection).STARRED && !queue.starred) return isQueueInSelectedGroup ? (0, $5Srj8.QueueListSection).PRIORITY_GROUP : (0, $5Srj8.QueueListSection).ALL_QUEUES;
    if (lastSelectedSection === (0, $5Srj8.QueueListSection).PRIORITY_GROUP && !isQueueInSelectedGroup) return isStarred ? (0, $5Srj8.QueueListSection).STARRED : (0, $5Srj8.QueueListSection).ALL_QUEUES;
    if (lastSelectedSection === undefined) {
        if (isStarred) return (0, $5Srj8.QueueListSection).STARRED;
        if (isQueueInSelectedGroup) return (0, $5Srj8.QueueListSection).PRIORITY_GROUP;
        return (0, $5Srj8.QueueListSection).ALL_QUEUES;
    }
    return lastSelectedSection;
};

});



parcelRegister("fekw4", function(module, exports) {

$parcel$export(module.exports, "getAllQueuesStateFromLocalStorage", () => $9c564d70f91925f7$export$b0f4873c9d10d2a8);
$parcel$export(module.exports, "setAllQueuesStateInLocalStorage", () => $9c564d70f91925f7$export$9e900548c9d21399);

var $bSSG7 = parcelRequire("bSSG7");
const $9c564d70f91925f7$export$72f6692c81a0e6b3 = 'jsm-all-queues-state';
const $9c564d70f91925f7$export$d8474cff104280f3 = 'is-open';
const $9c564d70f91925f7$export$b0f4873c9d10d2a8 = (projectId)=>{
    const localStorageProvider = (0, $bSSG7.createLocalStorageProvider)($9c564d70f91925f7$export$72f6692c81a0e6b3);
    try {
        const result = localStorageProvider.get(`${$9c564d70f91925f7$export$d8474cff104280f3}-${projectId}`);
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $9c564d70f91925f7$export$9e900548c9d21399 = (projectId, value)=>{
    const localStorageProvider = (0, $bSSG7.createLocalStorageProvider)($9c564d70f91925f7$export$72f6692c81a0e6b3);
    try {
        localStorageProvider.set(`${$9c564d70f91925f7$export$d8474cff104280f3}-${projectId}`, value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
    // do nothing
    }
};

});

parcelRegister("6eLdp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $830b6aaa148680b5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $830b6aaa148680b5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    allQueues: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.all-queues-section.all-queues",
        "defaultMessage": "All queues"
    }
});

});


parcelRegister("gKDnb", function(module, exports) {

$parcel$export(module.exports, "QueuesExperienceTracker", () => $9de972be35f35118$export$68c534d50bf4d3ae);

var $5uXOq = parcelRequire("5uXOq");

var $aD4Nm = parcelRequire("aD4Nm");

var $2i4sA = parcelRequire("2i4sA");

var $8WmEI = parcelRequire("8WmEI");

var $01Rn4 = parcelRequire("01Rn4");

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $9OXo1 = parcelRequire("9OXo1");
const $9de972be35f35118$export$68c534d50bf4d3ae = ({ children: children, experience: experience })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appEditions: appEditions } = tenantContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        application: (0, $efvDm.JIRA_SERVICE_DESK),
        edition: appEditions.serviceDesk,
        // DESK-5408 can hardcode "viewQueuesNav" as the value for experience here
        experience: (0, $4R6GH.fg)('update_viewqueuesnav_instrumentation') ? experience : 'viewQueuesNav',
        analyticsSource: "queuesNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
        location: "queues-nav-render-error"
    }, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WmEI.default), {
            handler: (error)=>{
                if ((0, $4R6GH.fg)('adding-more-data-for-viewqueue-and-viewnav-event')) onExperienceFailure(undefined, {
                    errorMessage: error?.message,
                    errorName: error?.name
                });
                else onExperienceFailure();
            },
            isRethrowEnabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
            op: onExperienceSuccess
        })))));
};

});
parcelRegister("2i4sA", function(module, exports) {

$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $c08cc6207a190361$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $c08cc6207a190361$export$e0241c84ce5db240);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $jNwWT = parcelRequire("jNwWT");

var $aD4Nm = parcelRequire("aD4Nm");

var $ehKaJ = parcelRequire("ehKaJ");
const $c08cc6207a190361$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehKaJ.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$c08cc6207a190361$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $c08cc6207a190361$export$2e2bcd8739ae039 = $c08cc6207a190361$export$a5efa46877be148f;
const $c08cc6207a190361$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNwWT.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehKaJ.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$c08cc6207a190361$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("ehKaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a267f2f54170b1c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");


var $jNwWT = parcelRequire("jNwWT");
class $a267f2f54170b1c1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props), this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        }, this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        }, this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name,
                ...this.props?.additionalAttributes
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $hh0bW.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNwWT.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
parcelRegister("hh0bW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c8a1e19e7613048$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");
const $6c8a1e19e7613048$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6c8a1e19e7613048$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6c8a1e19e7613048$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $6c8a1e19e7613048$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $6c8a1e19e7613048$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            ...location ? {
                reason: location
            } : {},
            ...field ? {
                field: field
            } : {},
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $6c8a1e19e7613048$var$transformApplication(application),
            edition: $6c8a1e19e7613048$var$transformEdition(edition),
            ...!false && (0, $4R6GH.fg)('chronos-add-shard-data-to-operational-metrics') ? {
                shard: (0, $j8DrX.default)('ajs-shard') || '',
                region: (0, $j8DrX.default)('ajs-region') || ''
            } : {}
        }
    });
var /**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c8a1e19e7613048$export$2e2bcd8739ae039 = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6c8a1e19e7613048$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};

});

const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("8WmEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fcaf1a018ca6020$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $1fcaf1a018ca6020$var$OnCatch extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            arg: undefined,
            isRethrowEnabled: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const { handler: handler, isRethrowEnabled: isRethrowEnabled, arg: arg } = this.props;
        handler(error, errorInfo, arg);
        if (isRethrowEnabled) throw error;
    }
    render() {
        return this.props.children;
    }
}
var $1fcaf1a018ca6020$export$2e2bcd8739ae039 = $1fcaf1a018ca6020$var$OnCatch;

});

parcelRegister("01Rn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b7c410527eddaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line jira/react/no-class-components
class $32b7c410527eddaf$var$OpTrigger extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $32b7c410527eddaf$export$2e2bcd8739ae039 = $32b7c410527eddaf$var$OpTrigger;

});


parcelRegister("fanN2", function(module, exports) {

$parcel$export(module.exports, "GiveFeedbackItem", () => $25f01a7417d05feb$export$6fef3e7edab221f0);

var $5uXOq = parcelRequire("5uXOq");

var $aEHvW = parcelRequire("aEHvW");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lNhbS = parcelRequire("lNhbS");

var $4Opyo = parcelRequire("4Opyo");
const $25f01a7417d05feb$export$6fef3e7edab221f0 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const feedbackButtonRef = (0, $5uXOq.useRef)(null);
    const onSubmitFeedbackClick = (0, $5uXOq.useCallback)(()=>{
        openFeedbackCollector({
            feedbackGroupId: (0, $lNhbS.FEEDBACK_GROUP_ID),
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            additionalFields: [
                {
                    id: (0, $7iULw.EntryKeys).JSM_QUEUES_SIDE_BAR,
                    value: 'true'
                }
            ],
            triggerRef: feedbackButtonRef
        });
    }, [
        openFeedbackCollector,
        feedbackButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'feedback'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: onSubmitFeedbackClick,
        ref: feedbackButtonRef
    }, formatMessage((0, $4Opyo.messages).giveFeedback));
};

});
parcelRegister("4Opyo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $67ce803567e9d3ce$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $67ce803567e9d3ce$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    giveFeedback: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.give-feedback-item.give-feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("9WOdt", function(module, exports) {

$parcel$export(module.exports, "GotoOpsgenieMenuItem", () => $2f5553e202d72f12$export$858a841effb0f4a5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7paD5 = parcelRequire("7paD5");

var $3bDjY = parcelRequire("3bDjY");

var $cfGFW = parcelRequire("cfGFW");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $8zOmE = parcelRequire("8zOmE");

var $kwGW2 = parcelRequire("kwGW2");

var $73bsk = parcelRequire("73bsk");
const $2f5553e202d72f12$var$defaultOpsgenieInstanceUrl = 'https://www.opsgenie.com';
const $2f5553e202d72f12$var$onClick = ()=>{
    (0, $cfGFW.getOpsgenieInstanceUrl)().then((instanceUrl)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(`${instanceUrl !== null ? instanceUrl : $2f5553e202d72f12$var$defaultOpsgenieInstanceUrl}/incident/list`, '_blank'));
};
const $2f5553e202d72f12$var$analyticsDetail = {
    itemId: 'gotoOpsgenie'
};
const $2f5553e202d72f12$export$858a841effb0f4a5 = ()=>{
    const [hasOpsgenieAccount] = (0, $kwGW2.useHasCurrentUserOpsgenieAccount)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ShortcutIconComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            LEGACY_size: "small",
            label: ""
        }), []);
    if (hasOpsgenieAccount !== true) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f5553e202d72f12$export$b33066c493600138, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $73bsk.messages).itemGotoOpsgenieItemTooltip),
        onShow: (event)=>(0, $8zOmE.fireUIAnalytics)(event, 'opegenieIncidentsLinkTooltip')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: $2f5553e202d72f12$var$analyticsDetail,
        onClick: $2f5553e202d72f12$var$onClick,
        iconAfter: ShortcutIconComponent
    }, formatMessage((0, $73bsk.messages).itemGotoOpsgenie))));
};
const $2f5553e202d72f12$export$b33066c493600138 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8yu7o _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cfGFW", function(module, exports) {

$parcel$export(module.exports, "getOpsgenieInstanceUrl", () => $eec1c41c4553bdb4$export$3df9099b7ceb6eef);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");

var $koeKL = parcelRequire("koeKL");

const $eec1c41c4553bdb4$export$256b0e8bff582010 = (cloudId)=>`/gateway/api/xflow/${cloudId}/license-information`;
const $eec1c41c4553bdb4$export$a573b79a27d213cc = async (cloudId)=>(0, $eusud.performGetRequest)($eec1c41c4553bdb4$export$256b0e8bff582010(cloudId));
const $eec1c41c4553bdb4$export$6167ce6dfa704e2e = (applicationUrl)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentInstanceName = window.location.hostname.replace(/(\.jira(-dev)?)?\.com$|(\.atlassian)?\.net$/, '');
    if (applicationUrl && currentInstanceName && applicationUrl.includes(currentInstanceName)) return applicationUrl;
    return null;
};
const $eec1c41c4553bdb4$export$15270500324d66e1 = ()=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: true,
        data: null,
        error: null
    });
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        const fetchInstanceData = async ()=>{
            setState({
                loading: true,
                data: null,
                error: null
            });
            try {
                const licenseInformation = await $eec1c41c4553bdb4$export$a573b79a27d213cc(cloudId);
                setState({
                    loading: false,
                    data: licenseInformation,
                    error: null
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $2YZCu.default).safeWarnWithoutCustomerData('growth.cross-flow.utils', 'There was an error fetching license information', err);
                setState({
                    loading: false,
                    data: null,
                    error: err
                });
            }
        };
        fetchInstanceData();
    }, [
        cloudId
    ]);
    return state;
};
const $eec1c41c4553bdb4$export$7a94de949b646b48 = (productKey)=>{
    const { loading: loading, data: data, error: error } = $eec1c41c4553bdb4$export$15270500324d66e1();
    const isActive = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, [
        'products',
        productKey,
        'state'
    ], null) === (0, $65d944bc0e15c52b$export$2b35adb71b3f6143);
    return {
        loading: loading,
        isActive: isActive,
        error: error
    };
};
const $eec1c41c4553bdb4$export$3df9099b7ceb6eef = async ()=>{
    try {
        const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        const licenses = await $eec1c41c4553bdb4$export$a573b79a27d213cc(cloudId);
        if (licenses && licenses.products && licenses.products.opsgenie && licenses.products.opsgenie.applicationUrl) return $eec1c41c4553bdb4$export$6167ce6dfa704e2e(licenses.products.opsgenie.applicationUrl);
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('growth.megaphone.touchpoint.experiment', 'There was an error fetching license information', error);
        return null;
    }
};

});
const $65d944bc0e15c52b$export$2b35adb71b3f6143 = 'ACTIVE';


parcelRegister("kwGW2", function(module, exports) {

$parcel$export(module.exports, "useHasCurrentUserOpsgenieAccount", () => $079abf3bceaf14ad$export$340013ec995e6863);

var $5uXOq = parcelRequire("5uXOq");

var $cYlk7 = parcelRequire("cYlk7");

var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8ONu3 = parcelRequire("8ONu3");

var $3drwY = parcelRequire("3drwY");
const $079abf3bceaf14ad$export$d4c72bab9d6cc13a = {
    data: {
        hasOpsgenieAccount: undefined
    },
    isLoading: false,
    error: undefined
};
const $079abf3bceaf14ad$export$152a899769dcec7a = (0, $iXqE5.createStore)({
    name: 'hasOpsgenieAccount',
    initialState: $079abf3bceaf14ad$export$d4c72bab9d6cc13a,
    actions: (0, $3drwY.actions)
});
const $079abf3bceaf14ad$export$1370c8074eb7b15c = (0, $3sQ5x.createHook)($079abf3bceaf14ad$export$152a899769dcec7a);
const $079abf3bceaf14ad$export$340013ec995e6863 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [state, { fetchHasOpgenieAccount: fetchHasOpgenieAccount }] = $079abf3bceaf14ad$export$1370c8074eb7b15c();
    const userId = (0, $cYlk7.useCurrentUser)().data.user.accountId;
    const { baseUrl: baseUrl, cloudId: cloudId, isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    (0, $5uXOq.useEffect)(()=>{
        fetchHasOpgenieAccount({
            baseUrl: baseUrl,
            cloudId: cloudId,
            userId: userId,
            isAnonymousUser: isAnonymous,
            analyticsEvent: createAnalyticsEvent({}),
            packageName: (0, $8ONu3.PACKAGE_NAME)
        });
    }, [
        fetchHasOpgenieAccount,
        baseUrl,
        cloudId,
        userId,
        isAnonymous,
        createAnalyticsEvent
    ]);
    return [
        state.data.hasOpsgenieAccount,
        {}
    ];
};

});
parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $iXqE5.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $gg7kZ.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $3sQ5x.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $8QpSo = parcelRequire("8QpSo");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $6Z846 = parcelRequire("6Z846");
const $d22d4c6d892f61f1$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $d22d4c6d892f61f1$var$fetchDataNew = (0, $8QpSo.default)($d22d4c6d892f61f1$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $6Z846.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $6Z846.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-iv-llc-unnecessary-api'), $d22d4c6d892f61f1$var$fetchDataNew, $d22d4c6d892f61f1$export$5e5a6664039ed1cc);

});




parcelRegister("8ONu3", function(module, exports) {

$parcel$export(module.exports, "MODAL_WIDTH", () => $1de3054ab3ca0a0a$export$3d931b64f46140b3);
$parcel$export(module.exports, "PACKAGE_NAME", () => $1de3054ab3ca0a0a$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PRIORITIES", () => $1de3054ab3ca0a0a$export$19868e2467c966ad);
$parcel$export(module.exports, "OG_PRIORITY_MAP", () => $1de3054ab3ca0a0a$export$b589c96cf5816a9a);
$parcel$export(module.exports, "priorityColor", () => $1de3054ab3ca0a0a$export$1d50193093c58ff5);

var $dFDBy = parcelRequire("dFDBy");
const $1de3054ab3ca0a0a$export$3d931b64f46140b3 = 1100;
const $1de3054ab3ca0a0a$export$89b184e16097a22c = 520;
const $1de3054ab3ca0a0a$export$b8b9d90f9e5bd72b = '@atlassian/jira-servicedesk-incident-management-common';
const $1de3054ab3ca0a0a$var$P1 = 'P1';
const $1de3054ab3ca0a0a$var$P2 = 'P2';
const $1de3054ab3ca0a0a$var$P3 = 'P3';
const $1de3054ab3ca0a0a$var$P4 = 'P4';
const $1de3054ab3ca0a0a$var$P5 = 'P5';
const $1de3054ab3ca0a0a$export$19868e2467c966ad = {
    P1: $1de3054ab3ca0a0a$var$P1,
    P2: $1de3054ab3ca0a0a$var$P2,
    P3: $1de3054ab3ca0a0a$var$P3,
    P4: $1de3054ab3ca0a0a$var$P4,
    P5: $1de3054ab3ca0a0a$var$P5
};
const $1de3054ab3ca0a0a$var$PRIORITY_COLORS = {
    [$1de3054ab3ca0a0a$var$P1]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [$1de3054ab3ca0a0a$var$P2]: "var(--ds-background-accent-red-subtle, #F87168)",
    [$1de3054ab3ca0a0a$var$P3]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [$1de3054ab3ca0a0a$var$P4]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [$1de3054ab3ca0a0a$var$P5]: "var(--ds-background-accent-green-bolder, #1F845A)"
};
const $1de3054ab3ca0a0a$var$PRIORITY_COLORS_CONSOLIDATION = {
    [$1de3054ab3ca0a0a$var$P1]: "var(--ds-background-danger-bold, #C9372C)",
    [$1de3054ab3ca0a0a$var$P2]: "var(--ds-background-accent-red-subtle, #F87168)",
    [$1de3054ab3ca0a0a$var$P3]: "var(--ds-background-accent-orange-subtle, #FEA362)",
    [$1de3054ab3ca0a0a$var$P4]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [$1de3054ab3ca0a0a$var$P5]: "var(--ds-background-accent-green-bolder, #1F845A)"
};
const $1de3054ab3ca0a0a$export$b589c96cf5816a9a = [
    {
        value: $1de3054ab3ca0a0a$export$19868e2467c966ad.P1,
        label: (0, $dFDBy.default).criticalAlertPriority
    },
    {
        value: $1de3054ab3ca0a0a$export$19868e2467c966ad.P2,
        label: (0, $dFDBy.default).highAlertPriority
    },
    {
        value: $1de3054ab3ca0a0a$export$19868e2467c966ad.P3,
        label: (0, $dFDBy.default).moderateAlertPriority
    },
    {
        value: $1de3054ab3ca0a0a$export$19868e2467c966ad.P4,
        label: (0, $dFDBy.default).lowAlertPriority
    },
    {
        value: $1de3054ab3ca0a0a$export$19868e2467c966ad.P5,
        label: (0, $dFDBy.default).informationalAlertPriority
    }
];
const $1de3054ab3ca0a0a$export$1d50193093c58ff5 = (p, consolidated = false)=>consolidated ? $1de3054ab3ca0a0a$var$PRIORITY_COLORS_CONSOLIDATION[p] : $1de3054ab3ca0a0a$var$PRIORITY_COLORS[p];

});
parcelRegister("dFDBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce0661008e6335$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d6ce0661008e6335$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    criticalAlertPriority: {
        "id": "servicedesk-incident-management-common.critical-alert-priority",
        "defaultMessage": "Critical"
    },
    highAlertPriority: {
        "id": "servicedesk-incident-management-common.high-alert-priority",
        "defaultMessage": "High"
    },
    moderateAlertPriority: {
        "id": "servicedesk-incident-management-common.moderate-alert-priority",
        "defaultMessage": "Moderate"
    },
    lowAlertPriority: {
        "id": "servicedesk-incident-management-common.low-alert-priority",
        "defaultMessage": "Low"
    },
    informationalAlertPriority: {
        "id": "servicedesk-incident-management-common.informational-alert-priority",
        "defaultMessage": "Informational"
    }
});

});


parcelRegister("3drwY", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c506940474c5ad6f$export$e324594224ef24da);

var $aCCYo = parcelRequire("aCCYo");
const $c506940474c5ad6f$export$e324594224ef24da = {
    fetchHasOpgenieAccount: $aCCYo.fetchHasOpgenieAccount
};

});
parcelRegister("aCCYo", function(module, exports) {

$parcel$export(module.exports, "fetchHasOpgenieAccount", () => $38f299aa87ce9cdb$export$4260d7dd363de357);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
const $38f299aa87ce9cdb$var$isValidFetchState = ({ data: { hasOpsgenieAccount: hasOpsgenieAccount }, isLoading: isLoading, error: error })=>hasOpsgenieAccount === undefined && !isLoading && error === undefined;
const $38f299aa87ce9cdb$export$4260d7dd363de357 = ({ baseUrl: baseUrl, cloudId: cloudId, userId: userId, isAnonymousUser: isAnonymousUser, analyticsEvent: analyticsEvent, packageName: packageName })=>async ({ getState: getState, setState: setState })=>{
        if (!$38f299aa87ce9cdb$var$isValidFetchState(getState())) return;
        if (isAnonymousUser) {
            setState({
                data: {
                    hasOpsgenieAccount: false
                },
                isLoading: false,
                error: undefined
            });
            return;
        }
        if (userId == null) return;
        setState({
            isLoading: true,
            error: undefined
        });
        try {
            const response = await (0, $eusud.performGetRequest)(`${baseUrl || ''}/gateway/api/jsd/escalator/${cloudId}/api/user-rights/has-opsgenie-access?accountId=${userId}`);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'fetchHasOpgenieAccount succeeded');
            setState({
                data: {
                    hasOpsgenieAccount: response
                },
                isLoading: false,
                error: undefined
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'fetchHasOpgenieAccount',
                    packageName: packageName
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("73bsk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e34963895bf6e810$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e34963895bf6e810$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    itemGotoOpsgenie: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.goto-opsgenie.item-goto-opsgenie",
        "defaultMessage": "Opsgenie incidents"
    },
    itemGotoOpsgenieItemTooltip: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.goto-opsgenie.item-goto-opsgenie-item-tooltip",
        "defaultMessage": "View the incidents in your connected Opsgenie account."
    }
});

});


parcelRegister("8uJQJ", function(module, exports) {

$parcel$export(module.exports, "ManageQueuesItem", () => $6e8868e8fb6b86ab$export$379cd307e34f4932);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $h6N0Y = parcelRequire("h6N0Y");

var $3u0c5 = parcelRequire("3u0c5");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $f5TWP = parcelRequire("f5TWP");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $4OCke = parcelRequire("4OCke");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dd29Z = parcelRequire("dd29Z");

var $htI2Q = parcelRequire("htI2Q");

var $cwSew = parcelRequire("cwSew");

var $ieDtd = parcelRequire("ieDtd");


var $7MLWx = parcelRequire("7MLWx");
const $6e8868e8fb6b86ab$export$379cd307e34f4932 = ({ children: children, practice: practice })=>{
    const [, { showManageQueuesDialog: showManageQueuesDialogFromHook }] = (0, $cwSew.useManageQueuesDialog)();
    const [isManageQueuesDialogVisible] = (0, $cwSew.useIsManageQueuesDialogVisible)();
    const [, setShowPulse] = (0, $5uXOq.useState)(true);
    const { data: project } = (0, $lpwtK.useProject)();
    const projectKey = project ? project.key : '';
    const [isLoading, isGettingStartedPageEnabled] = (0, $htI2Q.useIsGettingStartedPageEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [referrer, setReferrer] = (0, $ieDtd.useQueryParam)((0, $4ed82c2938dc3a98$export$a74074a8f4372ab0));
    const showManageQueuesDialog = (0, $5uXOq.useCallback)(()=>{
        if (!isManageQueuesDialogVisible) {
            showManageQueuesDialogFromHook();
            setShowPulse(false);
            setReferrer(undefined);
        }
    }, [
        isManageQueuesDialogVisible,
        setReferrer,
        showManageQueuesDialogFromHook
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const isReferrerValue = referrer === (0, $4ed82c2938dc3a98$export$dfbb42178a057cd2);
        if (isReferrerValue && !isLoading && isGettingStartedPageEnabled) showManageQueuesDialog();
    }, [
        isGettingStartedPageEnabled,
        isLoading,
        isManageQueuesDialogVisible,
        referrer,
        showManageQueuesDialog
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // We need to make sure queue settings menu item is rendered before trigger event
        // that will cause queue settings Engagement Platform message to be displayed,
        // otherwise the message will be displayed in the wrong position.
        setTimeout(()=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'queueSettings rendered', {
                meta: {
                    packageName: 'jiraNavigationAppsSidebarServicedesk',
                    teamName: 'jsd-shield'
                }
            });
        }, 1500);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $4ed82c2938dc3a98$export$f2d6a162e9c17811)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'manage page'
        },
        href: `/jira/servicedesk/projects/${projectKey}/${(0, $dd29Z.QUEUE_ROUTES)[practice]}/queue-settings`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h6N0Y))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $7MLWx.default).itemManageQueuesNewLozenge))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: (0, $4ed82c2938dc3a98$export$f2d6a162e9c17811)
    }));
};

});
parcelRegister("h6N0Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a96776728836c727b5d4d4945e79e50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c749047eae6bc5c9$var$_react = $c749047eae6bc5c9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c749047eae6bc5c9$var$_settings = $c749047eae6bc5c9$var$_interopRequireDefault((parcelRequire("epOG5")));

var $c749047eae6bc5c9$var$_settings2 = $c749047eae6bc5c9$var$_interopRequireDefault((parcelRequire("ik2d8")));
function $c749047eae6bc5c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SettingsIcon.
 * This component is SettingsIcon, with `UNSAFE_fallbackIcon` set to "EditorSettingsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c749047eae6bc5c9$var$SettingsIcon = (props)=>/*#__PURE__*/ $c749047eae6bc5c9$var$_react.default.createElement($c749047eae6bc5c9$var$_settings.default, Object.assign({
        LEGACY_fallbackIcon: $c749047eae6bc5c9$var$_settings2.default
    }, props));
$c749047eae6bc5c9$var$SettingsIcon.Name = 'SettingsIconMigration';
var $c749047eae6bc5c9$var$_default = module.exports.default = $c749047eae6bc5c9$var$SettingsIcon;

});
parcelRegister("ik2d8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d56bcf4208f0775d$var$_react = $d56bcf4208f0775d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d56bcf4208f0775d$var$_settings = $d56bcf4208f0775d$var$_interopRequireDefault((parcelRequire("epOG5")));
function $d56bcf4208f0775d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d56bcf4208f0775d$var$EditorSettingsIcon = (props)=>/*#__PURE__*/ $d56bcf4208f0775d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.64 1.64 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.2 7.2 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.38.38 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.9.9 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.38.38 0 0 0 .134.506 7.2 7.2 0 0 0 1.697.721.38.38 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.2 7.2 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.9.9 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153q.367-.683.585-1.443a.385.385 0 0 0-.252-.461"/></svg>`
    }, props, {
        newIcon: $d56bcf4208f0775d$var$_settings.default
    }));
$d56bcf4208f0775d$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var $d56bcf4208f0775d$var$_default = module.exports.default = $d56bcf4208f0775d$var$EditorSettingsIcon;

});


parcelRegister("cwSew", function(module, exports) {

$parcel$export(module.exports, "useIsManageQueuesDialogVisible", () => $136d708cc4170ed7$export$ec2ad858a7dae904);
$parcel$export(module.exports, "useManageQueuesDialog", () => $136d708cc4170ed7$export$957e9d434fe9441b);

var $oCMSG = parcelRequire("oCMSG");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $136d708cc4170ed7$var$actions = {
    showManageQueuesDialog: ()=>({ setState: setState })=>{
            setState({
                manageQueuesDialogStatus: (0, $1e10f2ec7db4ba8f$export$dda6912361cddac9)
            });
        },
    hideManageQueuesDialog: ()=>({ setState: setState })=>{
            setState({
                manageQueuesDialogStatus: (0, $1e10f2ec7db4ba8f$export$d2f7b3f0efb6e208),
                filterQueuesSearchQuery: ''
            });
        },
    setFilterQueuesSearchQuery: (query)=>({ setState: setState })=>{
            setState({
                filterQueuesSearchQuery: query
            });
        },
    setRendered: (projectKey, category)=>({ setState: setState })=>{
            setState({
                renderedInProject: projectKey,
                renderedInCategory: category
            });
        }
};
const $136d708cc4170ed7$var$initialState = {
    manageQueuesDialogStatus: (0, $1e10f2ec7db4ba8f$export$d2f7b3f0efb6e208),
    filterQueuesSearchQuery: '',
    renderedInProject: '',
    renderedInCategory: (0, $oCMSG.NO_CATEGORY)
};
const $136d708cc4170ed7$var$Store = (0, $iXqE5.createStore)({
    name: 'manage-queues-jsm',
    initialState: $136d708cc4170ed7$var$initialState,
    actions: $136d708cc4170ed7$var$actions
});
const $136d708cc4170ed7$var$getIsDialogVisible = (state)=>state.manageQueuesDialogStatus === (0, $1e10f2ec7db4ba8f$export$dda6912361cddac9);
const $136d708cc4170ed7$export$ec2ad858a7dae904 = (0, $3sQ5x.createHook)($136d708cc4170ed7$var$Store, {
    selector: $136d708cc4170ed7$var$getIsDialogVisible
});
const $136d708cc4170ed7$export$957e9d434fe9441b = (0, $3sQ5x.createHook)($136d708cc4170ed7$var$Store);

});
const $1e10f2ec7db4ba8f$export$d2f7b3f0efb6e208 = 'HIDDEN';
const $1e10f2ec7db4ba8f$export$dda6912361cddac9 = 'VISIBLE';


const $4ed82c2938dc3a98$export$a74074a8f4372ab0 = 'referrer';
const $4ed82c2938dc3a98$export$dfbb42178a057cd2 = 'gettingStartedPage';
const $4ed82c2938dc3a98$export$f2d6a162e9c17811 = 'curate-priority-groups-for-your-teams';

parcelRegister("7MLWx", function(module, exports) {

$parcel$export(module.exports, "default", () => $887121e32a96c489$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $887121e32a96c489$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    itemManageQueuesNewLozenge: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.manage-queues-item.item-manage-queues-new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("FYTTo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7b1ab95fad6e2eec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7b1ab95fad6e2eec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    itemNewQueue: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.item-new-queue",
        "defaultMessage": "New queue"
    },
    itemQueueSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.item-queue-settings",
        "defaultMessage": "Queue settings"
    },
    addons: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.addons",
        "defaultMessage": "Add-ons"
    },
    fetchQueuesError: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.fetch-queues-error",
        "defaultMessage": "We're unable to load queues data, <button>try again.</button>"
    },
    queuesGroupErrorHeading: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queues-group-error-heading",
        "defaultMessage": "Queue Groups"
    },
    queuesGroupErrorBody: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.queues-group-error-body",
        "defaultMessage": "We're unable to load queue groups data, <button>try again.</button>"
    }
});

});

parcelRegister("1JOZC", function(module, exports) {

$parcel$export(module.exports, "QueueGroupsSection", () => $8b1d8c586b7cd965$export$95e0028b61fb2a1a);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");

var $gjTBi = parcelRequire("gjTBi");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $kxZPA = parcelRequire("kxZPA");

var $FYTTo = parcelRequire("FYTTo");

const $8b1d8c586b7cd965$export$1f09c1703a7e1be9 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2QYsA")), {
    ssr: true,
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/common/ui/practice-queues/queue-groups/main.tsx"
});
const $8b1d8c586b7cd965$export$95e0028b61fb2a1a = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const reload = (0, $5uXOq.useCallback)(()=>window.location.reload(), []);
    const Fallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
            title: formatMessage((0, $FYTTo.messages).queuesGroupErrorHeading)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            padding: "space.100"
        }, formatMessage((0, $FYTTo.messages).queuesGroupErrorBody, {
            button: (buttonLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    spacing: "none",
                    appearance: "link",
                    onClick: reload
                }, buttonLabel)
        }))), [
        formatMessage,
        reload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        render: Fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b1d8c586b7cd965$export$1f09c1703a7e1be9, props));
};

});
parcelRegister("2QYsA", function(module, exports) {

let $213f5636c42a595f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $213f5636c42a595f$var$load("bMjxe").then(()=>parcelRequire('iOLc4'));

});


parcelRegister("lD3YF", function(module, exports) {

$parcel$export(module.exports, "StarredSection", () => $d05da7c3578474fd$export$e5f8d87968088916);

var $5uXOq = parcelRequire("5uXOq");

var $7i3ao = parcelRequire("7i3ao");

var $imZsD = parcelRequire("imZsD");
var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $gjTBi = parcelRequire("gjTBi");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $lpwtK = parcelRequire("lpwtK");

var $16J3A = parcelRequire("16J3A");

var $isS7L = parcelRequire("isS7L");

var $5Srj8 = parcelRequire("5Srj8");

var $jF62O = parcelRequire("jF62O");

var $eGsEn = parcelRequire("eGsEn");

var $4mghT = parcelRequire("4mghT");

var $fO6Rf = parcelRequire("fO6Rf");
const $d05da7c3578474fd$export$e5f8d87968088916 = ({ practice: practice })=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectKey = project ? project.key : '';
    const [queues] = (0, $jF62O.useFavouriteNavItems)('', projectKey, practice);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const [showPulse, setShowPulse] = (0, $5uXOq.useState)(true);
    const hasNoStarredQueues = queues?.every((queue)=>!queue.starred);
    const onClose = ()=>setIsSpotlightActive(false);
    const emptyStarredOnClick = (0, $5uXOq.useCallback)(()=>{
        if (showPulse) {
            setShowPulse(false);
            setIsSpotlightActive(true);
        }
    }, [
        showPulse
    ]);
    const emptyStarredContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        as: "span",
        xcss: $d05da7c3578474fd$var$emptyStarredContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4mghT.messages).emptyStarredSectionMessage));
    const starredSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", (0, $7i3ao.useResizingHeight)(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $4mghT.messages).starredHeader)
    }, queues && queues.length !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGsEn.QueueList), {
        queues: queues,
        section: (0, $5Srj8.QueueListSection).STARRED
    }) : emptyStarredContainer));
    let spotlightPulseContainer;
    if (showPulse) spotlightPulseContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "navigation-apps-sidebar-servicedesk.common.ui.practice-queues.starred-section.starred-queues",
        as: "span",
        role: "button",
        onClick: emptyStarredOnClick,
        xcss: $d05da7c3578474fd$var$pulseContainerWithPulseStyles,
        onKeyDown: (e)=>{
            e.key === 'Enter' && emptyStarredOnClick();
        },
        tabIndex: 0
    }, starredSection);
    else spotlightPulseContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, starredSection);
    return hasNoStarredQueues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isS7L.CoordinationClientWithFallback), {
        messageId: (0, $16J3A.STARRED_QUEUE_SPOTLIGHT),
        messageType: "engagement",
        fallback: starredSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "starred-queues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        pulse: showPulse,
        radius: 3
    }, spotlightPulseContainer)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fO6Rf.default), {
        onClose: onClose
    })))) : starredSection;
};
const $d05da7c3578474fd$var$emptyStarredContainerStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    paddingInlineStart: 'space.100'
});
const $d05da7c3578474fd$var$pulseContainerWithPulseStyles = (0, $8CUq3.xcss)({
    cursor: 'pointer'
});

});
parcelRegister("7i3ao", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $5f7cf4464a63f574$export$da99457d6430d83);
$parcel$export(module.exports, "ResizingHeight", () => $5f7cf4464a63f574$export$204d7b6d1491a2d3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");


var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $5Otrq = parcelRequire("5Otrq");
const $5f7cf4464a63f574$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $lObw7.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $eba99f58997c09b3$export$c07234257a03d5e9) } = {})=>{
    const prevDimensions = (0, $5uXOq.useRef)();
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $bh8Xz.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    (0, $5Otrq.useSnapshotBeforeUpdate)(()=>{
        if ((0, $dWt6p.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $fsENI.useLayoutEffect)(()=>{
        if ((0, $dWt6p.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $5f7cf4464a63f574$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $5f7cf4464a63f574$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children(resizing)
    });
};

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("3GP8X", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $19cc13cbd0e78f53$export$ff879f35a69d56b7);

var $5uXOq = parcelRequire("5uXOq");
const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $5uXOq.useRef)(null);
    const setRef = (0, $5uXOq.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("5Otrq", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $80940ec2167ac037$export$9e95200239cd148b);

var $5uXOq = parcelRequire("5uXOq");

var $fsENI = parcelRequire("fsENI");
const $80940ec2167ac037$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $5uXOq.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $fsENI.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("isS7L", function(module, exports) {

$parcel$export(module.exports, "CoordinationClientWithFallback", () => $4acb928649cf6393$export$ca3cd60062d9aab7);

var $5uXOq = parcelRequire("5uXOq");

var $ioD1B = parcelRequire("ioD1B");

var $4Pf62 = parcelRequire("4Pf62");

var $eGLgs = parcelRequire("eGLgs");

var $14XJw = parcelRequire("14XJw");
const $4acb928649cf6393$var$STARGATE_URL = '/gateway/api';
const $4acb928649cf6393$export$ca3cd60062d9aab7 = ({ messageId: messageId, messageType: messageType, fallback: fallback, children: children })=>{
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const [coordinationClient] = (0, $5uXOq.useState)(new (0, $eGLgs.CoordinationClient)(cloudId, $4acb928649cf6393$var$STARGATE_URL, false, orgId, messageType));
    const [didMessageStart, setDidMessageStart] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        coordinationClient.start(messageId).then(setDidMessageStart);
    }, [
        coordinationClient,
        messageId
    ]);
    switch(didMessageStart){
        case true:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                isChoreographed: coordinationClient.enableChoreographer
            }, children);
        case false:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallback);
        default:
            return null;
    }
};

});

parcelRegister("4mghT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5a42856957a73542$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5a42856957a73542$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    emptyStarredSectionMessage: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.empty-starred-section-message",
        "defaultMessage": "Select the star icon next to your queues to add them here."
    },
    starredHeader: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.starred-header",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("fO6Rf", function(module, exports) {

$parcel$export(module.exports, "default", () => $356cc5116722c25b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGLgs = parcelRequire("eGLgs");

var $16J3A = parcelRequire("16J3A");

var $dqDIG = parcelRequire("dqDIG");
const $356cc5116722c25b$var$StarredQueueOnboarding = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $16J3A.STARRED_QUEUE_SPOTLIGHT),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqDIG.StarredSectionSpotlight), {
        onClose: onClose
    }));
var $356cc5116722c25b$export$2e2bcd8739ae039 = $356cc5116722c25b$var$StarredQueueOnboarding;

});
parcelRegister("dqDIG", function(module, exports) {

$parcel$export(module.exports, "StarredSectionSpotlight", () => $e319a564d90cfa9f$export$60ef2680ccb1317b);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $dZDma = parcelRequire("dZDma");
const $e319a564d90cfa9f$export$60ef2680ccb1317b = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClose = ()=>{
        props.stop && props.stop();
        props.onClose();
    };
    const fieldI18nValues = {
        starred: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "strong"
        }, formatMessage((0, $dZDma.messages).starred))
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: onClose,
                text: formatMessage((0, $dZDma.messages).actionText)
            }
        ],
        dialogPlacement: "right top",
        heading: formatMessage((0, $dZDma.messages).title),
        target: "starred-queues",
        targetRadius: 3,
        messageId: "navigation-apps-sidebar-servicedesk.common.ui.practice-queues.starred-section.onboarding.spotlight.jira-spotlight.starred-queues",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $dZDma.messages).description,
        values: fieldI18nValues
    })));
};
$e319a564d90cfa9f$export$60ef2680ccb1317b.defaultProps = {
    stop: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};

});
parcelRegister("dZDma", function(module, exports) {

$parcel$export(module.exports, "messages", () => $69553dc155a4c07f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $69553dc155a4c07f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.onboarding.spotlight.starred",
        "defaultMessage": "Starred"
    },
    title: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.onboarding.spotlight.title",
        "defaultMessage": "Personalized for you"
    },
    description: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.onboarding.spotlight.description",
        "defaultMessage": "Handpick your favorite queues and access them quickly from {starred}."
    },
    actionText: {
        "id": "spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.onboarding.spotlight.action-text",
        "defaultMessage": "Got it"
    }
});

});





parcelRegister("dYOHi", function(module, exports) {

$parcel$export(module.exports, "Reports", () => $0a0baeafc48d119a$export$883262dc952d8f59);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $4Pf62 = parcelRequire("4Pf62");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $4OCke = parcelRequire("4OCke");

var $3tHFY = parcelRequire("3tHFY");

var $hqBSi = parcelRequire("hqBSi");

var $y8WG5 = parcelRequire("y8WG5");

var $c2JIK = parcelRequire("c2JIK");

var $dkLc2 = parcelRequire("dkLc2");

var $e00Lm = parcelRequire("e00Lm");

var $iVtjZ = parcelRequire("iVtjZ");
const $0a0baeafc48d119a$export$883262dc952d8f59 = ({ ConnectMenu: ConnectMenu = (0, $3tHFY.ConnectMenu), JsdReports: JsdReports = (0, $dkLc2.JsdReports), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), ReportActions: ReportActions = (0, $iVtjZ.ReportActions), Section: Section = (0, $gjTBi.default), SkeletonItem: SkeletonItem = (0, $bWqXX.default), TitleHeader: TitleHeader = (0, $3OGaE.TitleHeader), connectItems: connectItems, matchUrlPathname: matchUrlPathname = (0, $4OCke.matchUrlPathname), projectKey: projectKey, useIntl: useIntl = (0, $aWse0.useIntlV2), useReportFeatures: useReportFeatures = (0, $y8WG5.useReportFeatures) })=>{
    const { data: features } = useReportFeatures();
    const { formatMessage: formatMessage } = useIntl();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const shouldShowAtlassianAnalytics = licensedProducts && licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).ATLASSIAN_ANALYTICS];
    if (features == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    const BackMenuItem = {
        href: (0, $c2JIK.createReportUrl)(projectKey, ''),
        title: formatMessage((0, $e00Lm.default).reports)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleHeader, null, formatMessage((0, $e00Lm.default).reports)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $e00Lm.default).defaultReports)
    }, features.hasWorkload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'workload'
        },
        href: (0, $c2JIK.createReportUrl)(projectKey, '/workload'),
        selectedOn: matchUrlPathname()
    }, formatMessage((0, $e00Lm.default).workload)), features.hasSatisfaction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'all-rating'
        },
        href: (0, $c2JIK.createReportUrl)(projectKey, '/all-rating'),
        selectedOn: matchUrlPathname()
    }, formatMessage((0, $e00Lm.default).satisfaction)), features.hasRequestsDeflected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'kb-requests-deflected'
        },
        href: (0, $c2JIK.createReportUrl)(projectKey, '/kb-requests-deflected'),
        selectedOn: matchUrlPathname()
    }, formatMessage((0, $e00Lm.default).requestsDeflected)), features.hasRequestsResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'kb-requests-resolved'
        },
        href: (0, $c2JIK.createReportUrl)(projectKey, '/kb-requests-resolved'),
        selectedOn: matchUrlPathname()
    }, formatMessage((0, $e00Lm.default).requestsResolved)), shouldShowAtlassianAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'atlassian-analytics'
        },
        href: (0, $c2JIK.createReportUrl)(projectKey, '/atlassian-analytics'),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: "new"
        }, formatMessage((0, $e00Lm.default).newLozenge)),
        selectedOn: matchUrlPathname()
    }, formatMessage((0, $e00Lm.default).itemAtlassianAnalytics))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JsdReports, {
        title: formatMessage((0, $e00Lm.default).custom)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ReportActions, {
        features: features,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConnectMenu, {
        items: connectItems,
        overrides: {
            BackMenuItem: BackMenuItem
        }
    }));
};

});
parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("c2JIK", function(module, exports) {

$parcel$export(module.exports, "createReportUrl", () => $ff6ef038ac5edc5a$export$58ea1e106226fd1e);
$parcel$export(module.exports, "useLegacySpaClickHandler", () => $ff6ef038ac5edc5a$export$688261d7167cb6e9);

var $5uXOq = parcelRequire("5uXOq");

var $6BZYo = parcelRequire("6BZYo");
const $ff6ef038ac5edc5a$export$58ea1e106226fd1e = (projectKey, reportType)=>`${__SPA__ ? '/jira/servicedesk' : ''}/projects/${projectKey}/reports${reportType}`;
const $ff6ef038ac5edc5a$export$688261d7167cb6e9 = ()=>{
    const pushStateNavigatorRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $6BZYo.loadBridge)({
            name: 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator',
            shouldLogError: false
        }).then((result)=>{
            pushStateNavigatorRef.current = result;
        }).catch(()=>{
        // silently dies when the required module is not available in this context
        });
    });
    return (0, $5uXOq.useCallback)((e)=>{
        const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & Element) | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & Element) | (EventTarget & HTMLAnchorElement)'.
        typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
        const openInNewTab = // @ts-expect-error - TS2339 - Property 'metaKey' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'ctrlKey' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'.
        e.metaKey === true || e.ctrlKey === true || e.button != null && e.button === 1;
        if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
        if (pushStateNavigatorRef.current) {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            const willNavigate = pushStateNavigatorRef.current.navigate(href);
            if (willNavigate) e.preventDefault();
        }
    }, []);
};

});

parcelRegister("dkLc2", function(module, exports) {

$parcel$export(module.exports, "JsdReports", () => $5841d164f080d64c$export$515c19e76e3f7648);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $aQ7Be = parcelRequire("aQ7Be");

var $eYYbM = parcelRequire("eYYbM");
const $5841d164f080d64c$export$515c19e76e3f7648 = ({ MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $gjTBi.default), matchUrlPathname: matchUrlPathname = (0, $4OCke.matchUrlPathname), title: title, useCustomReport: useCustomReport = (0, $eYYbM.useCustomReports), useReportsNavApi: useReportsNavApi = (0, $aQ7Be.useReportsNavApi) })=>{
    const { data: initialCustomReportsFromSidebarConfig } = useCustomReport();
    const [{ data: { customReports: customReports } }, actions] = useReportsNavApi();
    // on mount, we need to use custom reports data from sidebar nav to populate the dedicated jsd report store
    (0, $5uXOq.useEffect)(()=>{
        if (initialCustomReportsFromSidebarConfig) actions.setItems({
            customReports: initialCustomReportsFromSidebarConfig
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: title
    }, customReports.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: item.id
            },
            key: item.id,
            href: __SPA__ ? item.url.replace(/^\/projects/, '/jira/servicedesk/projects') : item.url,
            selectedOn: matchUrlPathname()
        }, item.name)));
};

});
parcelRegister("aQ7Be", function(module, exports) {

$parcel$export(module.exports, "useReportsNavApi", () => $5ca1c4b48b13ceea$export$df7adaf97937c0bd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dtC25 = parcelRequire("dtC25");
const $5ca1c4b48b13ceea$export$d4c72bab9d6cc13a = {
    data: {
        customReports: []
    }
};
const $5ca1c4b48b13ceea$var$Store = (0, $iXqE5.createStore)({
    name: 'reports-nav-jsd',
    initialState: $5ca1c4b48b13ceea$export$d4c72bab9d6cc13a,
    actions: $dtC25.default
});
const $5ca1c4b48b13ceea$export$df7adaf97937c0bd = (0, $3sQ5x.createHook)($5ca1c4b48b13ceea$var$Store);
var $5ca1c4b48b13ceea$export$2e2bcd8739ae039 = $5ca1c4b48b13ceea$var$Store;

});
parcelRegister("dtC25", function(module, exports) {

$parcel$export(module.exports, "default", () => $423ec8381340528c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $423ec8381340528c$var$addItem = (item)=>({ setState: setState, getState: getState })=>{
        const { data: originalState } = getState();
        const customReports = [
            ...originalState.customReports,
            item
        ];
        setState({
            data: {
                ...originalState,
                customReports: customReports
            }
        });
    };
const $423ec8381340528c$var$deleteItem = (id)=>({ setState: setState, getState: getState })=>{
        const { data: originalState } = getState();
        setState({
            data: {
                ...originalState,
                customReports: originalState.customReports.filter((existingItem)=>String(existingItem.id) !== id)
            }
        });
    };
const $423ec8381340528c$var$editItem = (item)=>({ setState: setState, getState: getState })=>{
        const { data: originalState } = getState();
        setState({
            data: {
                ...originalState,
                customReports: originalState.customReports.map((existingItem)=>existingItem.id !== item.id ? existingItem : item)
            }
        });
    };
const $423ec8381340528c$var$setItems = ({ customReports: customReports })=>({ setState: setState })=>setState({
            data: {
                customReports: customReports
            }
        });
const $423ec8381340528c$var$actions = {
    addItem: $423ec8381340528c$var$addItem,
    deleteItem: $423ec8381340528c$var$deleteItem,
    editItem: $423ec8381340528c$var$editItem,
    setItems: $423ec8381340528c$var$setItems
};
var $423ec8381340528c$export$2e2bcd8739ae039 = $423ec8381340528c$var$actions;

});


parcelRegister("eYYbM", function(module, exports) {

$parcel$export(module.exports, "useCustomReports", () => $fe826eecf5ba2b29$export$40ce6c46d343d75f);

var $5uXOq = parcelRequire("5uXOq");

var $aQGK8 = parcelRequire("aQGK8");

var $01b4Y = parcelRequire("01b4Y");
const $fe826eecf5ba2b29$export$40ce6c46d343d75f = ()=>{
    const { data: data, loading: loading } = (0, $aQGK8.useJiraServiceManagementReportsNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $01b4Y.getCustomReports)(data), [
        data
    ]);
    return {
        data: extractedData,
        loading: loading
    };
};

});
parcelRegister("01b4Y", function(module, exports) {

$parcel$export(module.exports, "getCustomReports", () => $834e3ba61dbfadb5$export$a8c10e0a09026b31);
const $834e3ba61dbfadb5$export$a8c10e0a09026b31 = (data)=>{
    const customReports = data.customReports?.map((report)=>({
            id: `com.atlassian.servicedesk:reports-nav-${report.id}`,
            name: report.name,
            url: report.url
        }));
    return customReports || [];
};

});



parcelRegister("e00Lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ce3ff044028f42$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a0ce3ff044028f42$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reports: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.reports",
        "defaultMessage": "Reports"
    },
    workload: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.workload",
        "defaultMessage": "Workload"
    },
    slaGoals: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.sla-goals",
        "defaultMessage": "SLA goals"
    },
    satisfaction: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.satisfaction",
        "defaultMessage": "Satisfaction"
    },
    team: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.team",
        "defaultMessage": "Team"
    },
    defaultReports: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.default-reports",
        "defaultMessage": "Default"
    },
    requestsDeflected: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.requests-deflected",
        "defaultMessage": "Requests deflected"
    },
    requestsResolved: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.requests-resolved",
        "defaultMessage": "Requests resolved"
    },
    knowledgeBase: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.knowledge-base",
        "defaultMessage": "Knowledge base"
    },
    newReport: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.new-report",
        "defaultMessage": "New report"
    },
    manageReports: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.manage-reports",
        "defaultMessage": "Manage Reports"
    },
    custom: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.custom",
        "defaultMessage": "Custom"
    },
    addons: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.addons",
        "defaultMessage": "Add-ons"
    },
    itemAtlassianAnalytics: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.item-atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-servicedesk.common.reports.new-lozenge",
        "defaultMessage": "New"
    }
});

});

parcelRegister("iVtjZ", function(module, exports) {

$parcel$export(module.exports, "ReportActions", () => $1e68495439cdc0d0$export$bcb57565a364b52a);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $c2JIK = parcelRequire("c2JIK");

var $e00Lm = parcelRequire("e00Lm");
const $1e68495439cdc0d0$export$bcb57565a364b52a = ({ MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $gjTBi.default), features: features, matchUrlPathname: matchUrlPathname = (0, $4OCke.matchUrlPathname), projectKey: projectKey, useIntl: useIntl = (0, $aWse0.useIntlV2) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const { hasManageReport: hasManageReport, hasNewReport: hasNewReport } = features;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, hasNewReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'custom-new'
        },
        href: (0, $c2JIK.createReportUrl)(projectKey, '/custom/new'),
        selectedOn: matchUrlPathname()
    }, formatMessage((0, $e00Lm.default).newReport)), hasManageReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'custom-manage'
        },
        href: (0, $c2JIK.createReportUrl)(projectKey, '/custom/manage'),
        selectedOn: matchUrlPathname()
    }, formatMessage((0, $e00Lm.default).manageReports)));
};

});


parcelRegister("80BbW", function(module, exports) {

$parcel$export(module.exports, "SettingsClassic", () => $5da90ac53f11b17d$export$50e48492ea706380);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5on2Q = parcelRequire("5on2Q");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ldyPw = parcelRequire("ldyPw");

var $xc3fY = parcelRequire("xc3fY");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $1F3us = parcelRequire("1F3us");

var $lpwtK = parcelRequire("lpwtK");

var $kZj7F = parcelRequire("kZj7F");

var $3SzZi = parcelRequire("3SzZi");

var $4OCke = parcelRequire("4OCke");

var $6jY6G = parcelRequire("6jY6G");

var $2NMNM = parcelRequire("2NMNM");

var $8FvgP = parcelRequire("8FvgP");

var $eSH1I = parcelRequire("eSH1I");

var $20mDG = parcelRequire("20mDG");

var $daoB1 = parcelRequire("daoB1");

var $k9JTq = parcelRequire("k9JTq");

var $6EZeH = parcelRequire("6EZeH");

var $e1N3q = parcelRequire("e1N3q");

var $y8WG5 = parcelRequire("y8WG5");

var $lNhbS = parcelRequire("lNhbS");

var $c2JIK = parcelRequire("c2JIK");

var $hOzYR = parcelRequire("hOzYR");

var $68cWF = parcelRequire("68cWF");

var $haRgi = parcelRequire("haRgi");

var $79NZh = parcelRequire("79NZh");

var $kuGxV = parcelRequire("kuGxV");

var $4uiNQ = parcelRequire("4uiNQ");

var $8bszo = parcelRequire("8bszo");

var $ldKWY = parcelRequire("ldKWY");

var $bTE3y = parcelRequire("bTE3y");

var $8gYcW = parcelRequire("8gYcW");

var $arClt = parcelRequire("arClt");
const $5da90ac53f11b17d$var$calculateRequestManagementActive = (path)=>/jira\/servicedesk\/projects\/.+\/settings\/request-types/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/forms/.test(path) || /plugins\/servlet\/project-config\/.+\/workflows/.test(path) || /plugins\/servlet\/project-config\/.+\/slas/.test(path) || /plugins\/servlet\/project-config\/.+\/feedback-settings/.test(path) || /plugins\/servlet\/project-config\/.+\/issuetypes/.test(path) || /plugins\/servlet\/project-config\/.+\/issuelayout/.test(path) || /plugins\/servlet\/project-config\/.+\/fields/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/screens/.test(path);
const $5da90ac53f11b17d$var$calculateAccessActive = (path)=>/plugins\/servlet\/project-config\/.+\/people/.test(path) || /plugins\/servlet\/project-config\/.+\/permissions/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/customer-permissions/.test(path) || /plugins\/servlet\/project-config\/.+\/issue-security/.test(path);
const $5da90ac53f11b17d$var$calculateChannelsActive = (path)=>/jira\/servicedesk\/projects\/.+\/settings\/portal-settings/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/email/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/chat\?placement=projectSettings/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/confluence-kb/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/virtual-agent/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/external-links/.test(path) || /secure\/(.+)Collector/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/widget/.test(path);
const $5da90ac53f11b17d$var$calculateNotificationsActive = (path)=>/jira\/servicedesk\/projects\/.+\/settings\/customer-notifications/.test(path) || /plugins\/servlet\/project-config\/.+\/notifications/.test(path);
const $5da90ac53f11b17d$var$calculateIntegrationsActive = (path)=>/secure\/ConfigureDevStatus\.jspa\?projectKey=.+/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/apps/.test(path);
const $5da90ac53f11b17d$var$calculateOperationsActive = (path)=>/jira\/servicedesk\/projects\/.+\/settings\/change-management/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/incident-management/.test(path); /**
                                                                                                                                                                                                               * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4/project-settings/jsm-cmp-project-settings
                                                                                                                                                                                                               */ 
const $5da90ac53f11b17d$export$50e48492ea706380 = ({ ecosystemItems: ecosystemItems, projectId: projectId, projectKey: projectKey, stack: stack })=>{
    const { data: features } = (0, $y8WG5.useSettingFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const appPermissions = (0, $daoB1.useApplicationPermissions)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const handleLegacySPAClick = (0, $c2JIK.useLegacySpaClickHandler)();
    const [{ data: translations }, { fetchTranslationSummaries: fetchTranslationSummaries }] = (0, $eSH1I.useTranslationSummaries)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { userRole: userRole } = (0, $1F3us.useServiceDeskContextResource)().data || {};
    const hasDlpEnabled = (0, $6EZeH.useDlpEntitlement)();
    const [accessActive] = (0, $5uXOq.useState)($5da90ac53f11b17d$var$calculateAccessActive(route.path));
    const [requestManagementActive] = (0, $5uXOq.useState)($5da90ac53f11b17d$var$calculateRequestManagementActive(route.path));
    const [channelsActive] = (0, $5uXOq.useState)($5da90ac53f11b17d$var$calculateChannelsActive(route.path));
    const [notificationsActive] = (0, $5uXOq.useState)($5da90ac53f11b17d$var$calculateNotificationsActive(route.path));
    const [operationsActive] = (0, $5uXOq.useState)($5da90ac53f11b17d$var$calculateOperationsActive(route.path));
    const [integrationsActive] = (0, $5uXOq.useState)($5da90ac53f11b17d$var$calculateIntegrationsActive(route.path));
    const getSpaUrlForClassicSettings = (subroute, optionalParams)=>`/jira/servicedesk/projects/${projectKey}/settings/${subroute}${optionalParams || ''}`;
    (0, $5uXOq.useEffect)(()=>{
        if (project && userRole === (0, $20mDG.USER_JSM_PROJECT_ROLE).AGENT_PROJECT_ADMIN_ROLE) fetchTranslationSummaries(project.id, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        fetchTranslationSummaries,
        project,
        userRole
    ]);
    if (features == null || projectId == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    const overrides = {
        BackMenuItem: {
            href: classicSettingsUrl,
            // @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
            onClick: (ev)=>ev.preventDefault(),
            title: formatMessage((0, $ldKWY.default).itemBack)
        }
    };
    const shouldShowOperations = features.hasJsdChangeManagement || features.hasJsdIncidentManagement;
    const shouldShowNotifications = features.hasNotifications || features.hasCustomerNotifications;
    const hasVersionsOrComponents = features.hasVersions || features.hasComponents;
    const hasPremiumServiceDeskLicense = appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $ldKWY.default).settings)), features.hasDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).DETAILS
        },
        href: getSpaUrlForClassicSettings('details'),
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).details)), features.hasSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).SUMMARY
        },
        href: `/plugins/servlet/project-config/${projectKey}/summary`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).ITSM_FEATURES
        },
        href: getSpaUrlForClassicSettings('itsm-features'),
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).itsmFeatures)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'access-group'
        },
        menuItemLabel: formatMessage((0, $ldKWY.default).accessGroup),
        forceExpand: accessActive,
        submenuId: "access-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79NZh.AccessMenu), {
        projectKey: projectKey,
        features: features,
        onHandleLegacySPAClick: handleLegacySPAClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'requests-group'
        },
        menuItemLabel: formatMessage((0, $ldKWY.default).requestsManagementGroup),
        forceExpand: requestManagementActive,
        submenuId: "requests-group-settings"
    }, (0, $3SzZi.shouldRenderNesting)(features.hasRequestTypes, stack, (0, $lNhbS.SERVICE_DESK_LEGACY_TICKET_TYPES)) && (stack.length > 1 && stack[1] === (0, $lNhbS.SERVICE_DESK_LEGACY_TICKET_TYPES) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5da90ac53f11b17d$var$RequestTypesWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $arClt.TicketTypesItem), {
        projectKey: projectKey,
        nestingId: (0, $lNhbS.SERVICE_DESK_LEGACY_TICKET_TYPES)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $arClt.TicketTypesItem), {
        projectKey: projectKey,
        nestingId: (0, $lNhbS.SERVICE_DESK_LEGACY_TICKET_TYPES)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8gYcW.RequestsManagementMenu), {
        projectKey: projectKey,
        features: features,
        onHandleLegacySPAClick: handleLegacySPAClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $68cWF.Automation), {
        overrides: overrides,
        projectKey: projectKey,
        isSimplified: false,
        hasJiraAutomation: features.hasProjectAutomation
    }), // Config checker should only be used when the user is a JSD agent admin.
    userRole === (0, $20mDG.USER_JSM_PROJECT_ROLE).AGENT_PROJECT_ADMIN_ROLE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FvgP.default), {
        projectKey: projectKey
    }) : null, route && !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOzYR.AsyncAutomationChangeboarding), {
        isLegacyAutomation: route.name === 'legacy-jsd-jira-automation'
    }), (0, $4R6GH.fg)('jsm-journey-builder') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e1N3q.JourneyNavItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).JOURNEYS
        },
        href: getSpaUrlForClassicSettings('journeys'),
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).journeysNonFinal))), hasPremiumServiceDeskLicense && (0, $4R6GH.fg)('playbooks-in-jsm') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PLAYBOOKS
        },
        href: getSpaUrlForClassicSettings('playbooks'),
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).playbooks), (0, $4R6GH.fg)('phantom-3037-playbooks-admin-navigation-spotlight') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $5da90ac53f11b17d$var$lozengeTagStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $ldKWY.default).playbooksNewLozenge)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'channels-group'
        },
        menuItemLabel: formatMessage((0, $ldKWY.default).channelsGroup),
        forceExpand: channelsActive,
        submenuId: "channels-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kuGxV.ChannelsMenu), {
        projectKey: projectKey,
        features: features,
        onHandleLegacySPAClick: handleLegacySPAClick
    })), shouldShowOperations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'operations-group'
        },
        menuItemLabel: formatMessage((0, $ldKWY.default).operationsGroup),
        forceExpand: operationsActive,
        submenuId: "operations-group-settings"
    }, features.hasJsdChangeManagement && appPermissions.hasServiceDeskAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).JSD_CHANGE_MANAGEMENT
        },
        href: getSpaUrlForClassicSettings('change-management'),
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).jsdChangeManagement)), features.hasJsdIncidentManagement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).JSD_INCIDENT_MANAGEMENT
        },
        href: getSpaUrlForClassicSettings('incident-management'),
        onClick: handleLegacySPAClick,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).jsdIncidentManagement))), shouldShowNotifications && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'notifications-group'
        },
        menuItemLabel: formatMessage((0, $ldKWY.default).notificationsGroup),
        forceExpand: notificationsActive,
        submenuId: "notifications-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTE3y.NotificationsMenu), {
        projectKey: projectKey,
        features: features,
        onHandleLegacySPAClick: handleLegacySPAClick
    })), (!(0, $4R6GH.fg)('jcs_master_flag') || features.hasLanguageSupport) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'language-support'
        },
        href: getSpaUrlForClassicSettings('language'),
        iconAfter: translations.isLanguageSupportHighlighted ? // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5on2Q))), {
            primaryColor: "var(--ds-icon-warning, #E56910)",
            label: ""
        }) : null,
        id: "languageSupport",
        overrides: overrides,
        shifter: {
            groupTitle: formatMessage((0, $ldKWY.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        },
        title: formatMessage((0, $ldKWY.default).languageSupport),
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bszo.Language), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'integrations-group'
        },
        menuItemLabel: formatMessage((0, $ldKWY.default).integrationsGroup),
        forceExpand: integrationsActive,
        submenuId: "integrations-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uiNQ.IntegrationsMenu), {
        ecosystemItems: ecosystemItems,
        projectKey: projectKey,
        features: features,
        onHandleLegacySPAClick: handleLegacySPAClick
    })), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).DATA_CLASSIFICATIONS
        },
        href: `/plugins/servlet/project-config/${projectKey}/data-classifications`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).dataClassificationsNonFinal)), hasVersionsOrComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, features.hasVersions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).VERSIONS
        },
        href: `/plugins/servlet/project-config/${projectKey}/administer-versions`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).versions)), features.hasComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).COMPONENTS
        },
        href: `/plugins/servlet/project-config/${projectKey}/administer-components`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $ldKWY.default).components))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haRgi.default), null));
};
// Padding inconsistencies happen in L2 RT panel and it comes from ExpandableMenuItem used in new Nav3
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $5da90ac53f11b17d$var$RequestTypesWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_9n9o1b66 _1nx0126e _kltq1b66 _1oz01b66 _5yz1idpf",
            __cmplp.className
        ])
    });
});
const $5da90ac53f11b17d$var$lozengeTagStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("5on2Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ed111e655fee284$var$_react = $3ed111e655fee284$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $3ed111e655fee284$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ed111e655fee284$var$HipchatMediaAttachmentCountIcon = (props)=>/*#__PURE__*/ $3ed111e655fee284$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="5" fill="currentcolor" fill-rule="evenodd"/></svg>`
    }, props));
$3ed111e655fee284$var$HipchatMediaAttachmentCountIcon.displayName = 'HipchatMediaAttachmentCountIcon';
var $3ed111e655fee284$var$_default = module.exports.default = $3ed111e655fee284$var$HipchatMediaAttachmentCountIcon;

});

parcelRegister("xc3fY", function(module, exports) {

$parcel$export(module.exports, "ExpandableSubmenuItem", () => $dec8d2ea50472f86$export$16ba9a3b96f3ac6d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $fXJBp = parcelRequire("fXJBp");

var $k0ZZ2 = parcelRequire("k0ZZ2");
const $dec8d2ea50472f86$var$defaultExpandMenuState = {
    submenuActive: false,
    expanded: false
};
const $dec8d2ea50472f86$export$e5a6b8291f2460bc = ()=>{
    const getExpandableState = (submenuId)=>{
        const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
        let parsedCookieData = null;
        try {
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            parsedCookieData = JSON.parse(cookieData);
        } catch  {
            // Rather than throw an error - just set the default state
            parsedCookieData = $dec8d2ea50472f86$var$defaultExpandMenuState;
        }
        return parsedCookieData;
    };
    const setExpandedState = (submenuId, newExpandedState)=>{
        if (submenuId != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
    };
    return {
        getExpandableState: getExpandableState,
        setExpandedState: setExpandedState
    };
};
const $dec8d2ea50472f86$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $dec8d2ea50472f86$export$e5a6b8291f2460bc();
    const [subMenuActive, setSubMenuActive] = (0, $5uXOq.useState)(false);
    const [currentCookieData] = (0, $5uXOq.useState)(getExpandableState(submenuId));
    const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
    const [expanded, setExpanded] = (0, $5uXOq.useState)(forceExpand);
    const expandableMenuItemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (currentCookieData?.expanded) {
            setExpanded(currentCookieData.expanded);
            setSubMenuActive(currentCookieData.submenuActive);
        }
    }, [
        currentCookieData
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (submenuId != null) setExpandedState(submenuId, {
            submenuActive: false,
            expanded: !expanded
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
            expandMenuId: analytics?.itemId,
            expanded: !expanded
        });
        setExpanded(!expanded);
        requestAnimationFrame(()=>{
            expandableMenuItemRef?.current?.focus();
        });
    }, [
        analytics,
        createAnalyticsEvent,
        expanded,
        setExpandedState,
        submenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuWrapper, {
        isExpanded: subMenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: analytics,
        href: href,
        useButtonLink: useButtonLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXJBp.ExpandButton), {
            id: expandButtonId,
            label: expandButtonLabel,
            isActive: true,
            isExpanded: expanded,
            size: "medium"
        }), iconBefore),
        onClick: onClick,
        "data-test-id": testId,
        ref: expandableMenuItemRef,
        tabIndex: -1
    }, menuItemLabel), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper, {
        noListStyle: noListStyle
    }, children));
};
// Buttons inside the Expandable Menu indicate sub-expandable menus,
// these are styled differently that top level expandable menu items so the aligment look ok
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dec8d2ea50472f86$var$ExpandableSubmenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
            __cmplp.isExpanded && "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fXJBp", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $a3120c1c485e5e18$export$5663c8f5aeb8c1c4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $dC5iT = parcelRequire("dC5iT");

var $dCm1o = parcelRequire("dCm1o");
const $a3120c1c485e5e18$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
tabIndex = null })=>{
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const ChevronOld = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))) : (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R)));
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($hORKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0)));
    const onKeydown = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        // Space bar or enter (Button A11y rules) triggers click of expand button
        if ([
            13,
            32
        ].includes(event.keyCode)) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const chevronElement = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.075",
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronIcon, {
        testId: `sidebar.expand-button.container-${id}`,
        color: "var(--ds-icon, #44546F)",
        label: label
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronOld, {
        testId: `sidebar.expand-button.container-${id}`,
        primaryColor: "var(--ds-icon, #44546F)",
        label: label,
        size: size
    });
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isActive) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3120c1c485e5e18$var$Container, {
        role: "button",
        "aria-expanded": isExpanded,
        onClick: onClick,
        onKeyDown: onKeydown,
        isVisible: isVisible,
        removeCaret: removeCaret,
        size: size,
        tabIndex: tabIndex
    }, chevronElement);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3120c1c485e5e18$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _kqswh2mm _4t3i1osq _bfhk18uv _80omtlke _1spjglyw _1ejjufon _19lvkb7n",
            __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1F3us", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContextResource", () => $87857d345fb001b8$export$190facf1092470d4);

var $cAofY = parcelRequire("cAofY");

var $2YP9W = parcelRequire("2YP9W");
const $87857d345fb001b8$export$190facf1092470d4 = ()=>{
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $cAofY.serviceDeskContextResource));
    return {
        data: data,
        loading: loading
    };
};

});

parcelRegister("8FvgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $10d70ccbba4b7673$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $10d70ccbba4b7673$var$LazyAfterPaintConfigurationChecker = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("jWM9V")), {
    moduleId: "./src/packages/servicedesk/configuration-checker/src/ui/index.tsx"
});
const $10d70ccbba4b7673$var$AsyncConfigurationChecker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-async-configuration-checker",
        fallback: "unmount",
        packageName: "jira-servicedesk-configuration-checker",
        teamName: "jsd-shield"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "servicedesk-configuration-checker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10d70ccbba4b7673$var$LazyAfterPaintConfigurationChecker, props)));
var $10d70ccbba4b7673$export$2e2bcd8739ae039 = $10d70ccbba4b7673$var$AsyncConfigurationChecker;

});
parcelRegister("jWM9V", function(module, exports) {

let $e858ca7848a3cf41$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e858ca7848a3cf41$var$load("9XZfv").then(()=>parcelRequire('b1YRL'));

});


parcelRegister("eSH1I", function(module, exports) {

$parcel$export(module.exports, "TranslationSummariesSubscriber", () => $406e4161d9b7b332$export$aeb4d1191eb11e1);
$parcel$export(module.exports, "useTranslationSummaries", () => $406e4161d9b7b332$export$87ca645cd1503c82);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $74Pmw = parcelRequire("74Pmw");

var $blvRu = parcelRequire("blvRu");
const $406e4161d9b7b332$var$initialState = {
    loading: false,
    error: undefined,
    data: {
        languageTranslationSummaries: []
    },
    isDataInitialised: false
};
const $406e4161d9b7b332$var$Store = (0, $iXqE5.createStore)({
    initialState: $406e4161d9b7b332$var$initialState,
    actions: $74Pmw.actions
});
const $406e4161d9b7b332$export$aeb4d1191eb11e1 = (0, $51nlc.createSubscriber)($406e4161d9b7b332$var$Store, {
    selector: (0, $blvRu.translationSummariesSelector)
});
const $406e4161d9b7b332$export$87ca645cd1503c82 = (0, $3sQ5x.createHook)($406e4161d9b7b332$var$Store, {
    selector: (0, $blvRu.translationSummariesSelector)
});

});
parcelRegister("74Pmw", function(module, exports) {

$parcel$export(module.exports, "actions", () => $75aa155ce55d214b$export$e324594224ef24da);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
const $75aa155ce55d214b$var$fetchTranslationSummaries = (projectId, analyticsEvent, isForceSearch = false)=>async ({ setState: setState, getState: getState })=>{
        const { loading: loading, isDataInitialised: isDataInitialised } = getState();
        if (!isForceSearch && (loading || isDataInitialised)) return;
        setState({
            loading: true
        });
        try {
            const { languageTranslationSummaries: languageTranslationSummaries } = await (0, $7f4tk.default)(`/rest/servicedesk/lingo-integration/1/manage-language/${projectId}/translation-summaries`);
            setState({
                data: {
                    languageTranslationSummaries: languageTranslationSummaries
                },
                loading: false,
                isDataInitialised: true
            });
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'translationSummaries fetched', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error,
                loading: false
            });
            (0, $2YZCu.default).safeErrorWithoutCustomerData('servicedesk.languages.services.translation-summaries', error.message, error);
            (0, $jcw0u.trackFetchErrors)({
                error: error,
                id: 'services.translation-summaries.fetch',
                packageName: 'jiraServicedeskLanguages',
                logToSentry: !(0, $jJZqs.isValidationError)(error)
            });
        }
    };
const $75aa155ce55d214b$export$e324594224ef24da = {
    fetchTranslationSummaries: $75aa155ce55d214b$var$fetchTranslationSummaries
};

});

parcelRegister("blvRu", function(module, exports) {

$parcel$export(module.exports, "translationSummariesSelector", () => $33d704d5d24ef165$export$dcd204091dae6f77);
const $33d704d5d24ef165$var$getIsLanguagesEmptyState = (state)=>state.data.languageTranslationSummaries.length === 0;
const $33d704d5d24ef165$var$getIsLanguageSupportHighlighted = (state)=>state.data.languageTranslationSummaries.some(({ flaggedSections: flaggedSections })=>flaggedSections > 0);
const $33d704d5d24ef165$export$dcd204091dae6f77 = (state)=>{
    const { data: data, ...other } = state;
    return {
        ...other,
        data: {
            ...data,
            isLanguagesEmptyState: $33d704d5d24ef165$var$getIsLanguagesEmptyState(state),
            isLanguageSupportHighlighted: $33d704d5d24ef165$var$getIsLanguageSupportHighlighted(state)
        }
    };
};

});


parcelRegister("6EZeH", function(module, exports) {

$parcel$export(module.exports, "useDlpEntitlement", () => $c4c8661954b324b0$export$4472465702535e7);

var $9OXo1 = parcelRequire("9OXo1");
const $c4c8661954b324b0$export$4472465702535e7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.hasDlpEnabled || false;
};

});

parcelRegister("e1N3q", function(module, exports) {

$parcel$export(module.exports, "JourneyNavItemWrapper", () => $cf8e1fbaeb9e8ff1$export$3306a585fffa14e0);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9noxX = parcelRequire("9noxX");
const $cf8e1fbaeb9e8ff1$var$FireViewedEvent = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'menuItem viewed', 'journeysNav');
    }, [
        createAnalyticsEvent
    ]);
    return null;
};
const $cf8e1fbaeb9e8ff1$export$3306a585fffa14e0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf8e1fbaeb9e8ff1$var$FireViewedEvent, null));
};

});

parcelRegister("hOzYR", function(module, exports) {

$parcel$export(module.exports, "AsyncAutomationChangeboarding", () => $a9e4e03d79ce10e2$export$3cef31efd817ae4);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

/**
 * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4/project-settings
 */ const $a9e4e03d79ce10e2$var$RLLAsyncAutomationChangeboarding = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("duweA")).then((exportedModule)=>exportedModule.AutomationChangeboarding), {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/common/ui/automation-changeboarding/main.tsx"
});
const $a9e4e03d79ce10e2$export$3cef31efd817ae4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-automation-changeboarding",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9e4e03d79ce10e2$var$RLLAsyncAutomationChangeboarding, props));

});
parcelRegister("duweA", function(module, exports) {

let $0288e36e85470efa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0288e36e85470efa$var$load("4ApOX").then(()=>parcelRequire('gMMAR'));

});


parcelRegister("68cWF", function(module, exports) {

$parcel$export(module.exports, "Automation", () => $a2fb9030fcd82c69$export$132a1e91790bf469);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $Uj4ce = parcelRequire("Uj4ce");

var $kZj7F = parcelRequire("kZj7F");

var $lNhbS = parcelRequire("lNhbS");

var $oEVO5 = parcelRequire("oEVO5");

var $c2JIK = parcelRequire("c2JIK");

var $lhFiJ = parcelRequire("lhFiJ");
const $a2fb9030fcd82c69$export$132a1e91790bf469 = ({ overrides: overrides, shifter: shifter, projectKey: projectKey, isSimplified: isSimplified, hasJiraAutomation: hasJiraAutomation })=>{
    const { enabled: isLegacyAutomationEnabled } = (0, $Uj4ce.useNavigationAutomationLegacyEnabledResource)().data || {};
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleLegacySPAClick = (0, $c2JIK.useLegacySpaClickHandler)();
    const automationPaths = (0, $oEVO5.getAutomationPaths)({
        projectKey: projectKey,
        isSimplified: isSimplified
    });
    if (!isLegacyAutomationEnabled && !hasJiraAutomation) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isLegacyAutomationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: (0, $lNhbS.SERVICE_DESK_AUTOMATION_SUB_NAV),
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).AUTOMATION_SUB_NAV
        },
        title: formatMessage((0, $lhFiJ.default).automation),
        href: hasJiraAutomation ? automationPaths.jira : automationPaths.serviceDesk,
        overrides: overrides,
        shifter: shifter,
        selectedOn: (0, $oEVO5.isAutomationSubNavSelected)(automationPaths),
        onClick: hasJiraAutomation && isSimplified || __SPA__ ? undefined : handleLegacySPAClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $lhFiJ.default).automation)
    }, hasJiraAutomation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).JIRA_AUTOMATION
        },
        href: automationPaths.jira,
        onClick: isSimplified ? undefined : handleLegacySPAClick,
        selectedOn: (0, $oEVO5.isJiraAutomationSelected)(automationPaths)
    }, formatMessage((0, $lhFiJ.default).jiraAutomation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).AUTOMATION
        },
        selectedOn: (0, $oEVO5.isServiceDeskAutomationSelected)(automationPaths),
        href: automationPaths.serviceDesk,
        onClick: __SPA__ ? undefined : handleLegacySPAClick
    }, formatMessage((0, $lhFiJ.default).legacyAutomation)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).JIRA_AUTOMATION
        },
        href: hasJiraAutomation ? automationPaths.jira : automationPaths.serviceDesk,
        onClick: isSimplified ? undefined : handleLegacySPAClick,
        selectedOn: hasJiraAutomation ? (0, $oEVO5.isJiraAutomationSelected)(automationPaths) : (0, $oEVO5.isServiceDeskAutomationSelected)(automationPaths)
    }, formatMessage((0, $lhFiJ.default).jiraAutomation)));
};

});
parcelRegister("oEVO5", function(module, exports) {

$parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", () => $1466434297c2c448$export$75d31ae45b00712c);
$parcel$export(module.exports, "JIRA_FEDRAMP_MODERATE_AUTOMATION_ADDON_KEY", () => $1466434297c2c448$export$b0b94b45c4873ede);
$parcel$export(module.exports, "getAutomationPaths", () => $1466434297c2c448$export$c0e4da031d0fddbf);
$parcel$export(module.exports, "isJiraAutomationSelected", () => $1466434297c2c448$export$a80df7f8c5b6e790);
$parcel$export(module.exports, "isServiceDeskAutomationSelected", () => $1466434297c2c448$export$6f34362afef50bf4);
$parcel$export(module.exports, "isAutomationSubNavSelected", () => $1466434297c2c448$export$d856d80610cafe0f);

var $gOS29 = parcelRequire("gOS29");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $g5X3G = parcelRequire("g5X3G");
const $1466434297c2c448$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
const $1466434297c2c448$export$b0b94b45c4873ede = 'com.codebarrel.addons.automation.moderate';
const $1466434297c2c448$export$c0e4da031d0fddbf = ({ projectKey: projectKey, isSimplified: isSimplified })=>{
    const nextGenSettingsBaseUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey);
    return {
        serviceDesk: `${nextGenSettingsBaseUrl}/automation`,
        jira: (0, $gOS29.getBaseAutomationUrl)({
            projectType: (0, $2vSU6.SERVICE_DESK_PROJECT),
            projectKey: (0, $g5X3G.toProjectKey)(projectKey),
            isSimplified: isSimplified
        })
    };
};
const $1466434297c2c448$export$a80df7f8c5b6e790 = (automationPaths)=>({ pathname: pathname })=>automationPaths.jira.includes(pathname);
const $1466434297c2c448$export$6f34362afef50bf4 = (automationPaths)=>({ pathname: pathname })=>pathname.includes(automationPaths.serviceDesk);
const $1466434297c2c448$export$d856d80610cafe0f = (automationPaths)=>(currentLocation)=>$1466434297c2c448$export$a80df7f8c5b6e790(automationPaths)(currentLocation) || $1466434297c2c448$export$6f34362afef50bf4(automationPaths)(currentLocation);

});
parcelRegister("gOS29", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $b61a7afc01657dc2$export$8e479e490e1e69bc);
const $b61a7afc01657dc2$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});


parcelRegister("lhFiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $731b5273918862e5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $731b5273918862e5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jiraAutomation: {
        "id": "spa-apps-sidebar-servicedesk.common.automation.jira-automation",
        "defaultMessage": "Automation"
    },
    legacyAutomation: {
        "id": "spa-apps-sidebar-servicedesk.common.automation.legacy-automation",
        "defaultMessage": "Legacy automation"
    },
    automation: {
        "id": "spa-apps-sidebar-servicedesk.common.automation.automation",
        "defaultMessage": "Automation"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-servicedesk.common.automation.new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("haRgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c09b226514a0178$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $jhmo0 = parcelRequire("jhmo0");
var $8CUq3 = parcelRequire("8CUq3");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $ehdJY = parcelRequire("ehdJY");

var $gnIHG = parcelRequire("gnIHG");
const $4c09b226514a0178$var$TARGET = 'JSM Project settings Nav3';
const $4c09b226514a0178$var$MESSAGE_ID = 'jsm-simplified-project-settings-nav3';
const $4c09b226514a0178$var$Nudge = ({ stop: stop })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const targetNode = (0, $5uXOq.useRef)(globalThis.document?.querySelector('[data-testid="ContextualNavigation-resize-children-wrapper"]'));
    const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'jsmProjectSettingsNav3Changeboarding dismissed');
        stop?.();
        setIsSpotlightActive(false);
    }, [
        stop
    ]);
    const LEARN_MORE_LINK = 'https://community.atlassian.com/t5/Jira-Service-Management-articles/Updated-project-settings-navigation-in-Jira-Service-Management/ba-p/2829019';
    if (!isSpotlightActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "JSMProjectSettingsNav3Changeboarding",
        sourceType: "Screen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: onClick,
                text: formatMessage((0, $gnIHG.default).ok)
            }
        ],
        heading: formatMessage((0, $gnIHG.default).title),
        targetNode: targetNode.current ?? undefined,
        key: $4c09b226514a0178$var$TARGET,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogWidth: 300,
        dialogPlacement: "left middle",
        messageId: "navigation-apps-sidebar-servicedesk.common.ui.settings-changeboarding.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $gnIHG.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: LEARN_MORE_LINK,
        target: "_blank",
        xcss: $4c09b226514a0178$var$anchorStyles
    }, formatMessage((0, $gnIHG.default).readMoreLink)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $4c09b226514a0178$var$ProjectSettingsChangeBoarding = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: $4c09b226514a0178$var$MESSAGE_ID,
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c09b226514a0178$var$Nudge, null));
var $4c09b226514a0178$export$2e2bcd8739ae039 = $4c09b226514a0178$var$ProjectSettingsChangeBoarding;
const $4c09b226514a0178$var$anchorStyles = (0, $8CUq3.xcss)({
    color: 'color.text.inverse',
    textDecoration: 'underline',
    borderStyle: 'none',
    ':link': {
        color: 'color.text.inverse'
    },
    ':hover': {
        textDecoration: 'none',
        color: 'color.text.inverse'
    },
    ':active': {
        color: 'color.text.inverse'
    },
    ':visited': {
        color: 'color.text.inverse'
    },
    ':visited:active': {
        color: 'color.text.inverse'
    }
});

});
parcelRegister("gnIHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb76158208ccdce7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb76158208ccdce7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-changeboarding.title",
        "defaultMessage": "Improved navigation"
    },
    description: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-changeboarding.description",
        "defaultMessage": "Quickly find your project\u2019s settings with the help of clear labels and the grouping of related items."
    },
    readMoreLink: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-changeboarding.read-more-link",
        "defaultMessage": "Read more about this change"
    },
    ok: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-changeboarding.ok",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("79NZh", function(module, exports) {

$parcel$export(module.exports, "AccessMenu", () => $44cbef7ab019527e$export$ad4989badaf2c553);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $lNhbS = parcelRequire("lNhbS");

var $5b1vi = parcelRequire("5b1vi");

var $kDyc8 = parcelRequire("kDyc8");
const $44cbef7ab019527e$export$ad4989badaf2c553 = ({ projectKey: projectKey, features: features, onHandleLegacySPAClick: onHandleLegacySPAClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (features == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, features.hasPeople && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PEOPLE
        },
        href: `/plugins/servlet/project-config/${projectKey}/people`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $kDyc8.default).peopleAndAccess)), features.hasPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PERMISSIONS
        },
        href: `/plugins/servlet/project-config/${projectKey}/permissions`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $kDyc8.default).projectPermissions)), features.hasCustomerPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).CUSTOMER_PERMISSIONS
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('customer-permissions', projectKey),
        onClick: __SPA__ ? undefined : onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $kDyc8.default).customerPermissions)), features.hasIssueSecurity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).ISSUE_SECURITY
        },
        href: `/plugins/servlet/project-config/${projectKey}/issuesecurity`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $kDyc8.default).issueSecurity)));
};

});
parcelRegister("5b1vi", function(module, exports) {

$parcel$export(module.exports, "getSpaUrlForClassicSettings", () => $4eb9034dcdb31fef$export$7420914670673d5c);
const $4eb9034dcdb31fef$export$7420914670673d5c = (subroute, projectKey, optionalParams)=>`/jira/servicedesk/projects/${projectKey}/settings/${subroute}${optionalParams || ''}`;

});

parcelRegister("kDyc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3c9681c4770379$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c3c9681c4770379$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    peopleAndAccess: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.access.people-and-access",
        "defaultMessage": "People and access"
    },
    projectPermissions: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.access.project-permissions",
        "defaultMessage": "Project permissions"
    },
    customerPermissions: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.access.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    issueSecurity: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.access.issue-security",
        "defaultMessage": "Issue security"
    }
});

});


parcelRegister("kuGxV", function(module, exports) {

$parcel$export(module.exports, "ChannelsMenu", () => $b7964079c9122624$export$2304c1a84e67d4f4);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $aIZdc = parcelRequire("aIZdc");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2MtwW = parcelRequire("2MtwW");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $2gP8z = parcelRequire("2gP8z");

var $4OCke = parcelRequire("4OCke");

var $lNhbS = parcelRequire("lNhbS");

var $5b1vi = parcelRequire("5b1vi");

var $fVpM0 = parcelRequire("fVpM0");

var $cfK1T = parcelRequire("cfK1T");

var $5IwO3 = parcelRequire("5IwO3");
const $b7964079c9122624$export$2304c1a84e67d4f4 = ({ projectKey: projectKey, features: features, onHandleLegacySPAClick: onHandleLegacySPAClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    const BackMenuOverrides = {
        BackMenuItem: {
            href: classicSettingsUrl,
            onClick: (ev)=>ev.preventDefault(),
            title: formatMessage((0, $5IwO3.default).itemBack)
        }
    };
    if (features == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, features.hasPortalSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PORTAL_SETTINGS
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('portal-settings', projectKey),
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $5IwO3.default).portalSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: "spotlight-nav-servicedesk/sd-project-sidebar-email-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).EMAIL_REQUESTS
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('email', projectKey),
        onClick: __SPA__ ? undefined : onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $5IwO3.default).emailRequests)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MtwW.EngagementSpotlight), {
        engagementId: "spotlight-nav-servicedesk/sd-project-sidebar-email-settings"
    })), features.hasChat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PROJECT_CHAT_ADDON
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('chat', projectKey, '?placement=projectSettings'),
        onClick: __SPA__ ? undefined : onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $5IwO3.default).chat)), features.hasAddonInstaller && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PROJECT_WIDGET_ADDON_INSTALLER
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('widget', projectKey),
        onClick: onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $5IwO3.default).widget)), features.hasWidgetAddon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PROJECT_WIDGET_ADDON
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('widget', projectKey),
        onClick: __SPA__ ? undefined : onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $5IwO3.default).widget)), features.hasWidgetAddonDev && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PROJECT_WIDGET_ADDON
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('widget', projectKey),
        onClick: __SPA__ ? undefined : onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $5IwO3.default).widget)), features.hasKnowledgeBase && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).KNOWLEDGE_BASE
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('confluence-kb', projectKey),
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $5IwO3.default).knowledgeBase)), (!(0, $4R6GH.fg)('jcs_master_flag') || features.hasVirtualAgent) && !(0, $aIZdc.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "virtualAgent",
        packageName: "jiraNavigationAppsSidebarServicedesk",
        teamName: "navigation",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfK1T.VirtualAgentMenuItem), {
                projectKey: projectKey
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVpM0.VirtualAgent), {
        projectKey: projectKey,
        overrides: BackMenuOverrides,
        shifter: {
            groupTitle: formatMessage((0, $5IwO3.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        }
    })), (!(0, $4R6GH.fg)('jcs_master_flag') || features.hasExternalLinks) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).EXTERNAL_LINKS
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('external-links', projectKey),
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $5IwO3.default).externalResources)), features.hasIssueCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).ISSUE_COLLECTORS
        },
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        href: `/secure/ViewCollectors!default.jspa?projectKey=${projectKey}`,
        selectedOn: (currentLocation)=>Boolean(currentLocation.pathname.match(/secure\/(.+)Collector/))
    }, formatMessage((0, $5IwO3.default).issueCollectors)));
};

});
parcelRegister("fVpM0", function(module, exports) {

$parcel$export(module.exports, "VirtualAgent", () => $35f0efe4d167e5d8$export$7fa1bd0aea291233);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $2cxgG = parcelRequire("2cxgG");

var $cfK1T = parcelRequire("cfK1T");
const $35f0efe4d167e5d8$export$7fa1bd0aea291233 = ({ projectKey: projectKey, overrides: overrides, shifter: shifter })=>{
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $2cxgG.virtualAgentOnboardingResource));
    if (queryReference == null) // Some JSM settings pages don't have the VA onboarding resource defined in their resources list (mostly legacy pages)
    // For these pages, we'll just show the menu item (no nested nav) regardless of if they have a VA
    // In FLUX-8640 we'll change this to use an entry point so we can load in our FE & data async
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfK1T.VirtualAgentMenuItem), {
        projectKey: projectKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "virtual-agent-sidebar-item",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfK1T.VirtualAgentMenuItem), {
            projectKey: projectKey
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfK1T.VirtualAgentSidebar), {
        projectKey: projectKey,
        overrides: overrides,
        shifter: shifter,
        queryReference: queryReference
    }));
};

});
parcelRegister("2cxgG", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $e9d51fb7135f5412$export$d39827c053fda3aa);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $2j6fy = parcelRequire("2j6fy");
const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, $ao2h1.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $2j6fy.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("2j6fy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b605658e5ce20d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8391836c727c96074b367b5cee339a0d>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

var $7oHmH = parcelRequire("7oHmH");
const $45b605658e5ce20d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;

});
parcelRegister("7oHmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0ef421b1798a33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("cfK1T", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentMenuItem", () => $b1acb2b8fae4410c$export$393b2c5a9a9bc3da);
$parcel$export(module.exports, "VirtualAgentSidebar", () => $b1acb2b8fae4410c$export$f56cd039cb4cc4df);

var $73xmr = parcelRequire("73xmr");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3u0c5 = parcelRequire("3u0c5");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $c2JIK = parcelRequire("c2JIK");

var $cjx33 = parcelRequire("cjx33");

var $866UJ = parcelRequire("866UJ");
const $b1acb2b8fae4410c$export$393b2c5a9a9bc3da = ({ projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleLegacySPAClick = (0, $c2JIK.useLegacySpaClickHandler)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        onClick: __SPA__ ? undefined : handleLegacySPAClick,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: "new"
        }, formatMessage((0, $cjx33.default).virtualAgentLozengeText))
    }, formatMessage((0, $cjx33.default).virtualServiceAgent));
};
const $b1acb2b8fae4410c$export$f56cd039cb4cc4df = ({ projectKey: projectKey, overrides: overrides, queryReference: queryReference, shifter: shifter })=>{
    const data = (0, $8Uumt.usePreloadedQuery)((0, $73xmr.default), queryReference);
    const isAiEnabledInAdminHub = (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent') ? !!data.virtualAgent?.virtualAgentEntitlements?.isAiEnabledInAdminHub : true;
    const isSiteEntitledToUseVa = !!data.virtualAgent?.virtualAgentEntitlements?.isVirtualAgentAvailable && isAiEnabledInAdminHub;
    const showFullVANav = isSiteEntitledToUseVa || data.jira.jiraProjectByKey.virtualAgentConfiguration?.__typename === 'VirtualAgentConfiguration';
    // If VA is not created, do not show nested nav
    if (!showFullVANav || !data.virtualAgent?.virtualAgentEntitlements) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1acb2b8fae4410c$export$393b2c5a9a9bc3da, {
        projectKey: projectKey
    });
    // Otherwise, show nested nav
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $866UJ.VirtualAgentNestedNav), {
        projectKey: projectKey,
        overrides: overrides,
        shifter: shifter,
        virtualAgentFeaturesRef: data.virtualAgent.virtualAgentEntitlements,
        virtualAgentConfigurationRef: data.jira.jiraProjectByKey?.virtualAgentConfiguration ?? null
    });
};

});
parcelRegister("73xmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2faee7f8fca7da98$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b6a5a341a914fe51a650af383283e3c4>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

var $7oHmH = parcelRequire("7oHmH");

var $eiowN = parcelRequire("eiowN");
const $2faee7f8fca7da98$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "checkForAiEnabledFF"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v3 /*: any*/ 
    ], v7 = [
        {
            "kind": "ScalarField",
            "name": "isAiEnabledInAdminHub"
        }
    ], v8 = {
        "condition": "checkForAiEnabledFF",
        "kind": "Condition",
        "passingValue": true,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "isVirtualAgentAvailable"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = [
        v10 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainVirtualAgentSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "virtualAgentConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentConfigurationRef"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef"
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "mainVirtualAgentSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v11 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v11 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
            "metadata": {},
            "name": "mainVirtualAgentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
            }
        }
    };
}();
$2faee7f8fca7da98$var$node.hash = "cfd46162843f2acc60da5ab6493725c3";
(0, $eiowN.PreloadableQueryRegistry).set($2faee7f8fca7da98$var$node.params.id, $2faee7f8fca7da98$var$node);
var $2faee7f8fca7da98$export$2e2bcd8739ae039 = $2faee7f8fca7da98$var$node;

});

parcelRegister("cjx33", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab22211d14855740$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ab22211d14855740$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    virtualServiceAgent: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.virtual-service-agent",
        "defaultMessage": "Virtual service agent"
    },
    virtualAgentLozengeText: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.virtual-agent-lozenge-text",
        "defaultMessage": "New"
    }
});

});

parcelRegister("866UJ", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentNestedNav", () => $24c05dc15e3659f0$export$aab0bc902d0a5e77);

var $llHkE = parcelRequire("llHkE");

var $aIoAk = parcelRequire("aIoAk");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7paD5 = parcelRequire("7paD5");

var $3u0c5 = parcelRequire("3u0c5");

var $kgoHi = parcelRequire("kgoHi");

var $c2V4l = parcelRequire("c2V4l");
var $gjTBi = parcelRequire("gjTBi");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");

var $dFOAR = parcelRequire("dFOAR");

var $impi5 = parcelRequire("impi5");

var $eu0Gv = parcelRequire("eu0Gv");

var $55NVm = parcelRequire("55NVm");
const $24c05dc15e3659f0$export$aab0bc902d0a5e77 = ({ projectKey: projectKey, overrides: overrides, shifter: shifter, virtualAgentFeaturesRef: virtualAgentFeaturesRef, virtualAgentConfigurationRef: virtualAgentConfigurationRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const virtualAgentFeatures = (0, $8Uumt.useFragment)((0, $aIoAk.default), virtualAgentFeaturesRef);
    const virtualAgentConfiguration = (0, $8Uumt.useFragment)((0, $llHkE.default), virtualAgentConfigurationRef);
    const isVirtualAgentConfigured = virtualAgentConfiguration?.__typename === 'VirtualAgentConfiguration';
    const [{ data: serviceDeskContext }] = (0, $dFOAR.useServiceDeskContext)();
    const testModeUrl = serviceDeskContext && `${serviceDeskContext.portalUrl}/conversation?isTestConversation=true`;
    const isSiteEntitledToUseVa = (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent') ? virtualAgentFeatures?.isVirtualAgentAvailable && virtualAgentFeatures?.isAiEnabledInAdminHub : virtualAgentFeatures?.isVirtualAgentAvailable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: "virtualagent",
        analytics: {
            itemId: 'virtualagent'
        },
        title: formatMessage((0, $eu0Gv.default).virtualServiceAgent),
        href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent/${isSiteEntitledToUseVa ? 'intents' : 'settings'}`,
        selectedOn: (0, $55NVm.matchVirtualAgentPathname)(),
        overrides: overrides,
        shifter: shifter,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: "new"
        }, formatMessage((0, $eu0Gv.default).virtualAgentLozengeText))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2V4l.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $eu0Gv.default).virtualServiceAgent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $eu0Gv.default).virtualAgentLozengeText)))), isSiteEntitledToUseVa && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jsm_va_enable_performance_page') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent/performance`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, formatMessage((0, $eu0Gv.default).performance)), (0, $4R6GH.fg)('jsm_va_enable_ai_answers_page') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent/ai-answers`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, formatMessage((0, $eu0Gv.default).aiAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent/intents`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, formatMessage((0, $eu0Gv.default).intents)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent/standard-flows`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, formatMessage((0, $eu0Gv.default).standardFlows)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent/conversations`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, formatMessage((0, $eu0Gv.default).conversations))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent/settings`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, formatMessage((0, $eu0Gv.default).settings)), isSiteEntitledToUseVa && testModeUrl && ((0, $4R6GH.fg)('jsm_portal_test_mode_requires_va_configured') ? isVirtualAgentConfigured : true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        href: testModeUrl,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            spacing: "spacious",
            label: ""
        }),
        target: "_blank"
    }, formatMessage((0, $eu0Gv.default).test))), (0, $4R6GH.fg)('jsm-virtual-agent-feedback-collector') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $impi5.FeedbackMenuItem), null)));
};

});
parcelRegister("llHkE", function(module, exports) {

$parcel$export(module.exports, "default", () => $04c1fd1ae5a8d3fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d484eb4320b0c009c7c2f298a754bed1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $04c1fd1ae5a8d3fd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentConfigurationRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "VirtualAgentConfiguration"
};
$04c1fd1ae5a8d3fd$var$node.hash = "3916f1bba674a6d4d9f8a29f030688b1";
var $04c1fd1ae5a8d3fd$export$2e2bcd8739ae039 = $04c1fd1ae5a8d3fd$var$node;

});

parcelRegister("aIoAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bb1195a51bfae47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc3304e691871b808aacde54ee4f85ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9bb1195a51bfae47$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isVirtualAgentAvailable"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isAiEnabledInAdminHub"
                }
            ]
        }
    ],
    "type": "VirtualAgentFeatures"
};
$9bb1195a51bfae47$var$node.hash = "ee71e92c7b841f7b1594c4636880f22d";
var $9bb1195a51bfae47$export$2e2bcd8739ae039 = $9bb1195a51bfae47$var$node;

});

parcelRegister("impi5", function(module, exports) {

$parcel$export(module.exports, "FeedbackMenuItem", () => $e32de889eb1c8fbc$export$83f53de30aa402ca);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $aEHvW = parcelRequire("aEHvW");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $iIvm8 = parcelRequire("iIvm8");
const $e32de889eb1c8fbc$var$FeedbackTitleDetails = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $iIvm8.default).feedbackTitleDetails)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $iIvm8.default).feedbackTitleDetailsContactSupport, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                spacing: "none",
                target: "_blank",
                rel: "noopener noreferrer",
                href: "https://support.atlassian.com/contact"
            }, chunks)
    })));
};
const $e32de889eb1c8fbc$export$83f53de30aa402ca = ()=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const feedbackButtonRef = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>openFeedbackCollector({
                feedbackGroupId: 'jira-servicedesk-project-settings-virtual-agent',
                entrypointId: (0, $7iULw.ENTRY_POINT_ID_JSM_VIRTUAL_AGENT),
                triggerRef: feedbackButtonRef,
                feedbackTitle: formatMessage((0, $iIvm8.default).feedbackTitleV2),
                feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e32de889eb1c8fbc$var$FeedbackTitleDetails, null)
            }),
        ref: feedbackButtonRef
    }, formatMessage((0, $iIvm8.default).feedbackMenuItem));
};

});
parcelRegister("iIvm8", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb816aa4ee4869f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb816aa4ee4869f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedbackMenuItem: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.feedback-menu-item.feedback-menu-item",
        "defaultMessage": "Give feedback"
    },
    feedbackTitleV2: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.feedback-menu-item.feedback-title-v-2",
        "defaultMessage": "Give feedback for the virtual service agent"
    },
    feedbackTitleDetails: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.feedback-menu-item.feedback-title-details",
        "defaultMessage": "Share your thoughts on how we can improve this experience."
    },
    feedbackTitleDetailsContactSupport: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.feedback-menu-item.feedback-title-details-contact-support",
        "defaultMessage": "If you\u2019re having technical issues, <link>contact Support</link>."
    }
});

});


parcelRegister("eu0Gv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab15f340c38825fb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ab15f340c38825fb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    virtualServiceAgent: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.virtual-service-agent",
        "defaultMessage": "Virtual service agent"
    },
    intents: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.intents",
        "defaultMessage": "Intents"
    },
    standardFlows: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.standard-flows",
        "defaultMessage": "Standard flows"
    },
    conversations: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.conversations",
        "defaultMessage": "Conversations"
    },
    settings: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.settings",
        "defaultMessage": "Settings"
    },
    test: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.test",
        "defaultMessage": "Test"
    },
    virtualAgentLozengeText: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.virtual-agent-lozenge-text",
        "defaultMessage": "New"
    },
    title: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.title",
        "defaultMessage": "Virtual service agent"
    },
    aiAnswers: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.ai-answers",
        "defaultMessage": "AI answers"
    },
    performance: {
        "id": "spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.performance",
        "defaultMessage": "Performance"
    }
});

});

parcelRegister("55NVm", function(module, exports) {

$parcel$export(module.exports, "matchVirtualAgentPathname", () => $ab02b553d2afb057$export$d2bf6e7ed357f5cd);
const $ab02b553d2afb057$export$d2bf6e7ed357f5cd = ()=>(currentLocation, _)=>currentLocation.pathname.includes('settings/virtual-agent');

});




parcelRegister("5IwO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff1ad9c4cfa9cea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ff1ad9c4cfa9cea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    portalSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.portal-settings",
        "defaultMessage": "Portal"
    },
    emailRequests: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.email-requests",
        "defaultMessage": "Email"
    },
    chat: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.chat",
        "defaultMessage": "Chat"
    },
    widget: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.widget",
        "defaultMessage": "Widget"
    },
    knowledgeBase: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.knowledge-base",
        "defaultMessage": "Knowledge base"
    },
    itemBack: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.item-back",
        "defaultMessage": "Back to project settings"
    },
    title: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.title",
        "defaultMessage": "Project settings"
    },
    externalResources: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.external-resources",
        "defaultMessage": "External resources"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels.issue-collectors",
        "defaultMessage": "Issue collectors"
    }
});

});


parcelRegister("4uiNQ", function(module, exports) {

$parcel$export(module.exports, "IntegrationsMenu", () => $d5f2587760ea6a20$export$99c306b2506109fd);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $k2DRb = parcelRequire("k2DRb");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $5xslo = parcelRequire("5xslo");

var $lNhbS = parcelRequire("lNhbS");

var $5b1vi = parcelRequire("5b1vi");

var $kQ2Pn = parcelRequire("kQ2Pn");
const $d5f2587760ea6a20$export$99c306b2506109fd = ({ projectKey: projectKey, features: features, onHandleLegacySPAClick: onHandleLegacySPAClick, ecosystemItems: ecosystemItems })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    const EcoSystemOverrides = {
        BackMenuItem: {
            href: classicSettingsUrl,
            onClick: (ev)=>ev.preventDefault(),
            title: formatMessage((0, $kQ2Pn.default).itemBack)
        }
    };
    if (features == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5xslo.default), {
        items: ecosystemItems,
        overrides: EcoSystemOverrides,
        forgeModule: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        hasSeparator: true,
        nestedMenuActive: false
    }), features.hasDevtools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'devtools'
        },
        href: `/secure/ConfigureDevStatus.jspa?projectKey=${projectKey}`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $kQ2Pn.default).devtools)), features.hasJsdAppDiscovery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).JSD_APP_DISCOVERY
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('apps', projectKey),
        onClick: __SPA__ ? undefined : onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $kQ2Pn.default).jsdAppDiscovery)));
};

});
parcelRegister("5xslo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f574dcd99762a8d6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");

var $k51JQ = parcelRequire("k51JQ");
const $f574dcd99762a8d6$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
    const forgeItems = (0, $5uXOq.useMemo)(()=>items.forge || [], [
        items.forge
    ]);
    const connectItems = (0, $au6nA.useFilteredItems)(items.connect, shouldFilter);
    const sortedItems = (0, $5uXOq.useMemo)(()=>[
            ...forgeItems.map((item)=>({
                    type: 'forge',
                    item: item
                })),
            ...connectItems.map((item)=>({
                    type: 'connect',
                    item: item
                }))
        ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
        connectItems,
        forgeItems
    ]);
    if (!sortedItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
        if (type === 'forge') {
            // @ts-expect-error - TS2322 - Type 'ConnectDataItem | ForgeItemProps' is not assignable to type 'ForgeProjectSettingsItem'.
            const forgeItem = item;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
                key: forgeItem.id,
                ...forgeItem,
                overrides: overrides,
                showIcon: showIcons,
                nestedMenuActive: nestedMenuActive
            });
        }
        const connectItem = item;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: connectItem,
            key: connectItem.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        });
    }), forgeItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), null) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f574dcd99762a8d6$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: forgeModule,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f574dcd99762a8d6$export$66569e9b4a285b16, restProps));

});

parcelRegister("kQ2Pn", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d560a09e09d44f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $89d560a09e09d44f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsdAppDiscovery: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.integrations.jsd-app-discovery",
        "defaultMessage": "Explore apps"
    },
    devtools: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.integrations.devtools",
        "defaultMessage": "Development tools"
    },
    itemBack: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.integrations.item-back",
        "defaultMessage": "Back to project settings"
    }
});

});


parcelRegister("8bszo", function(module, exports) {

$parcel$export(module.exports, "Language", () => $be0c63a334a1ada4$export$ce4fe1c9e6520c1a);

var $5uXOq = parcelRequire("5uXOq");

var $5on2Q = parcelRequire("5on2Q");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $iwDvi = parcelRequire("iwDvi");

var $3OGaE = parcelRequire("3OGaE");

var $lpwtK = parcelRequire("lpwtK");

var $kZj7F = parcelRequire("kZj7F");

var $2NMNM = parcelRequire("2NMNM");

var $1e8Ij = parcelRequire("1e8Ij");

var $eSH1I = parcelRequire("eSH1I");

var $ldKWY = parcelRequire("ldKWY");
const $be0c63a334a1ada4$export$ce4fe1c9e6520c1a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const [enabledLanguages, { fetchLanguages: fetchLanguages }] = (0, $1e8Ij.useEnabledLanguages)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ data: translations }] = (0, $eSH1I.useTranslationSummaries)();
    (0, $5uXOq.useEffect)(()=>{
        if (project) {
            const analyticsEvent = createAnalyticsEvent({});
            fetchLanguages(project.id, analyticsEvent);
        }
    }, [
        createAnalyticsEvent,
        fetchLanguages,
        project
    ]);
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const baseSettingsUrl = `/jira/servicedesk/projects/${project.key}/settings`;
    const BackMenuItem = {
        href: `${baseSettingsUrl}/language`,
        title: formatMessage((0, $ldKWY.default).itemBack)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $ldKWY.default).languageSupport)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, enabledLanguages?.filter((language)=>language.state !== 'unused').map((language)=>{
        const summary = translations?.languageTranslationSummaries?.find((v)=>v.key === language.key);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
            analytics: {
                itemId: language.key
            },
            iconAfter: summary?.flaggedSections ? // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5on2Q))), {
                primaryColor: "var(--ds-icon-warning, #E56910)",
                label: ""
            }) : null,
            id: language.key,
            key: language.key,
            title: language.label,
            href: `${baseSettingsUrl}/language/${language.key}`,
            overrides: {
                BackMenuItem: BackMenuItem
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwDvi.SidebarTranslations), null));
    })));
};

});
parcelRegister("iwDvi", function(module, exports) {

$parcel$export(module.exports, "SidebarTranslations", () => $645aeea5cf787aa1$export$b13ab2ba4399deee);

var $5uXOq = parcelRequire("5uXOq");

var $5on2Q = parcelRequire("5on2Q");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $lpwtK = parcelRequire("lpwtK");

var $4OCke = parcelRequire("4OCke");

var $cPUYN = parcelRequire("cPUYN");

var $lI8d8 = parcelRequire("lI8d8");
const $645aeea5cf787aa1$var$makePanelUrl = ({ projectKey: projectKey, languageKey: languageKey, panelId: panelId })=>`/jira/servicedesk/projects/${projectKey}/settings/language/${languageKey}/${panelId}`;
const $645aeea5cf787aa1$export$b13ab2ba4399deee = ({ ChangeIndicator: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
ChangeIndicator = (0, (/*@__PURE__*/$parcel$interopDefault($5on2Q))), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $gjTBi.default), SkeletonItem: SkeletonItem = (0, $bWqXX.default), TitleHeader: TitleHeader = (0, $3OGaE.TitleHeader) })=>{
    const { translationTabsWithPanelIds: translationTabsWithPanelIds, selectedLanguage: selectedLanguage, currentLanguage: currentLanguage, translationPanelMap: translationPanelMap } = (0, $cPUYN.useTranslationStoreState)();
    const { data: project } = (0, $lpwtK.useProject)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (currentLanguage == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    if (!project || !translationPanelMap) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleHeader, null, formatMessage((0, $lI8d8.default).title, {
        language: selectedLanguage?.label
    })), translationTabsWithPanelIds.filter((tTab)=>tTab.translationPanelIds.length > 0).map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
            key: tab.name,
            title: tab.name
        }, tab.translationPanelIds.map((panelId)=>{
            const panel = translationPanelMap[panelId];
            const { id: id, isFlagged: isFlagged } = panel;
            const panelUrl = $645aeea5cf787aa1$var$makePanelUrl({
                projectKey: project.key,
                languageKey: currentLanguage,
                panelId: id
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                analytics: {
                    itemId: id
                },
                iconAfter: isFlagged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChangeIndicator, {
                    primaryColor: "var(--ds-icon-warning, #E56910)",
                    label: formatMessage((0, $lI8d8.default).changeIndicatorLabel)
                }) : null,
                key: id,
                selectedOn: (0, $4OCke.matchUrlPathname)(),
                href: panelUrl
            }, panel.displayName);
        }))));
};

});
parcelRegister("cPUYN", function(module, exports) {

$parcel$export(module.exports, "useTranslationController", () => $c9507f38cb61b917$export$4af4ca8c6826f1ca);
$parcel$export(module.exports, "useFlaggedTranslationCount", () => $c9507f38cb61b917$export$53764565621eeace);
$parcel$export(module.exports, "useFormDirty", () => $c9507f38cb61b917$export$e6e4d80a6984157f);
$parcel$export(module.exports, "useTranslationGroups", () => $c9507f38cb61b917$export$d90e845a2766fd29);
$parcel$export(module.exports, "useTranslationStoreState", () => $c9507f38cb61b917$export$5f2c801ba636475e);
$parcel$export(module.exports, "useFieldState", () => $c9507f38cb61b917$export$4e8d6353e50062e7);
$parcel$export(module.exports, "useSelectedPanel", () => $c9507f38cb61b917$export$f68a41d0aec02a54);
$parcel$export(module.exports, "useManageTranslationsActions", () => $c9507f38cb61b917$export$4f40724c94207e54);

var $5uXOq = parcelRequire("5uXOq");

var $fq71H = parcelRequire("fq71H");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $k7tsS = parcelRequire("k7tsS");

var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $bBUqz = parcelRequire("bBUqz");

var $dpIMy = parcelRequire("dpIMy");
const $c9507f38cb61b917$export$5dc802f1ff7a22ad = (0, $bBUqz.actions);
const $c9507f38cb61b917$var$initialState = {
    currentLanguage: '',
    loading: false,
    error: null,
    selectedPanelId: null,
    translationPanelMap: null,
    cachedOriginalApiFieldsMap: null,
    translationTabsWithPanelIds: [],
    selectedLanguage: null,
    defaultLanguage: null,
    oldApiFieldsMap: null
};
const $c9507f38cb61b917$var$store = (0, $iXqE5.createStore)({
    initialState: $c9507f38cb61b917$var$initialState,
    actions: $bBUqz.actions
});
const $c9507f38cb61b917$var$getFlaggedTranslationCount = (state)=>{
    const { translationPanelMap: translationPanelMap } = state;
    if (translationPanelMap === null) return 0;
    const translationPanels = state.translationTabsWithPanelIds?.flatMap((tabs)=>tabs.translationPanelIds);
    return translationPanels?.filter((panel)=>translationPanelMap[panel].isFlagged).length || 0;
};
const $c9507f38cb61b917$export$23c12649559fe423 = ()=>{
    const { data: translationsForLanguage, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $k7tsS.languageTranslationsResource));
    return {
        data: translationsForLanguage,
        loading: loading,
        error: error,
        refresh: refresh
    };
};
const $c9507f38cb61b917$export$4af4ca8c6826f1ca = ({ canInitializeStore: canInitializeStore = false })=>{
    const [hookState, hookActions] = $c9507f38cb61b917$export$45390a0199f8bbc();
    const { data: translationsForLanguage, loading: loading, error: error, refresh: refresh } = $c9507f38cb61b917$export$23c12649559fe423();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (canInitializeStore && !loading && (error || translationsForLanguage)) {
            const translations = translationsForLanguage || null;
            if (translations) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'translations fetched');
            const e = error ? new Error(error.message) : null;
            hookActions.initialize(translations, e, loading);
        }
    }, [
        loading,
        error,
        translationsForLanguage,
        hookActions,
        canInitializeStore,
        createAnalyticsEvent
    ]);
    return [
        hookState,
        hookActions,
        error,
        loading,
        refresh
    ];
};
const $c9507f38cb61b917$export$53764565621eeace = (0, $3sQ5x.createStateHook)($c9507f38cb61b917$var$store, {
    selector: $c9507f38cb61b917$var$getFlaggedTranslationCount
});
const $c9507f38cb61b917$export$e6e4d80a6984157f = (0, $3sQ5x.createStateHook)($c9507f38cb61b917$var$store, {
    selector: (state)=>{
        const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = state;
        if (translationPanelMap === null || selectedPanelId === null) return false;
        (0, $fq71H.addBreadcrumb)({
            level: 'debug',
            data: {
                translationPanelMap: translationPanelMap,
                selectedPanelId: selectedPanelId
            }
        });
        return translationPanelMap[selectedPanelId].isDirty;
    }
});
const $c9507f38cb61b917$export$d90e845a2766fd29 = (0, $3sQ5x.createStateHook)($c9507f38cb61b917$var$store, {
    selector: (state)=>({
            currentLanguage: state.currentLanguage,
            translationGroups: (0, $dpIMy.getTranslationGroups)(state)
        })
});
const $c9507f38cb61b917$export$5f2c801ba636475e = (0, $3sQ5x.createStateHook)($c9507f38cb61b917$var$store, {
    selector: (state)=>state
});
const $c9507f38cb61b917$export$4e8d6353e50062e7 = (translationFieldId)=>{
    const translationPanel = $c9507f38cb61b917$export$f68a41d0aec02a54();
    if (!translationPanel) return null;
    const fieldState = translationPanel.translationGroups.flatMap((group)=>group.translationFields).find((field)=>field.logicalId === translationFieldId);
    if (!fieldState) return null;
    return fieldState;
};
const $c9507f38cb61b917$export$f68a41d0aec02a54 = ()=>{
    const [hookState, hookActions] = $c9507f38cb61b917$export$45390a0199f8bbc();
    const [routerState] = (0, $doZTA.useRouter)();
    const { sidebarItemKey: sidebarItemKey, languageKey: languageKey, projectKey: projectKey } = routerState?.match?.params || {};
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    if (hookState.loading) return null;
    if (!hookState.selectedLanguage) return null;
    const { translationPanelMap: translationPanelMap } = hookState;
    if (!hookState.translationTabsWithPanelIds) return null;
    const allTranslationPanelIds = hookState.translationTabsWithPanelIds.flatMap((translationTab)=>translationTab.translationPanelIds);
    if (!translationPanelMap) return null;
    if (!sidebarItemKey) {
        const flaggedPanelId = allTranslationPanelIds.find((translationPanelId)=>translationPanelMap[translationPanelId].isFlagged);
        const selectPanelId = flaggedPanelId || allTranslationPanelIds[0];
        const baseSettingsUrl = `/jira/servicedesk/projects/${projectKey}/settings/language/${languageKey}/${selectPanelId}`;
        replace(baseSettingsUrl);
        return null;
    }
    if (hookState.selectedPanelId && hookState.selectedPanelId === sidebarItemKey) return translationPanelMap[hookState.selectedPanelId];
    const selectedPanelId = translationPanelMap[sidebarItemKey] ? sidebarItemKey : allTranslationPanelIds[0];
    const selectedPanel = translationPanelMap[selectedPanelId];
    hookActions.setSelectedPanelId(selectedPanelId);
    return selectedPanel;
};
const $c9507f38cb61b917$export$4f40724c94207e54 = (0, $3sQ5x.createActionsHook)($c9507f38cb61b917$var$store);
const $c9507f38cb61b917$export$45390a0199f8bbc = (0, $3sQ5x.createHook)($c9507f38cb61b917$var$store);

});
parcelRegister("k7tsS", function(module, exports) {

$parcel$export(module.exports, "languageTranslationsResource", () => $ffad7a39054feef3$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $ffad7a39054feef3$export$c460156a7e6b85b2);

var $2M1hQ = parcelRequire("2M1hQ");
const $ffad7a39054feef3$export$9f529be3aeae01ea = 'JSM Language Translations';
const $ffad7a39054feef3$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $ffad7a39054feef3$export$f51887e33895eab9 = (0, $2M1hQ.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$ffad7a39054feef3$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("8cPk6")),
    maxAge: Infinity
});

const $ffad7a39054feef3$export$c460156a7e6b85b2 = (0, $2M1hQ.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$ffad7a39054feef3$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("cjHww")),
    maxAge: Infinity
});

});
parcelRegister("8cPk6", function(module, exports) {

let $5f97417493ba58fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f97417493ba58fe$var$load("4BYvo").then(()=>parcelRequire('3m5cp'));

});

parcelRegister("cjHww", function(module, exports) {

let $8f7905411a0d9277$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8f7905411a0d9277$var$load("hn2iP").then(()=>parcelRequire('49aS0'));

});


parcelRegister("bBUqz", function(module, exports) {

$parcel$export(module.exports, "actions", () => $93635a2e4a77b9a9$export$e324594224ef24da);

var $LpImS = parcelRequire("LpImS");
const $93635a2e4a77b9a9$export$aeddc78ea054d95a = (panel)=>{
    if (panel.entityId) return `${panel.providerUrlKey}-${panel.entityId}`;
    return panel.providerUrlKey;
};
const $93635a2e4a77b9a9$var$getFormattedPanelData = (translationPanel)=>{
    const panelId = $93635a2e4a77b9a9$export$aeddc78ea054d95a(translationPanel);
    let isPanelFlagged = false;
    const groups = translationPanel.translationGroups.map((group)=>{
        const { translationFields: translationFields } = group;
        const fields = translationFields.map((translationField)=>{
            if (translationField.translationState !== 'up_to_date') isPanelFlagged = true;
            return {
                ...translationField,
                changeType: 'unchanged',
                isAlwaysUpToDate: false
            };
        });
        return {
            ...group,
            translationFields: fields
        };
    });
    return {
        ...translationPanel,
        translationGroups: groups,
        id: panelId,
        isDirty: false,
        isFlagged: isPanelFlagged
    };
};
const $93635a2e4a77b9a9$export$9b06d01613fd55c7 = ({ isFieldChanged: isFieldChanged, isAlwaysUptoDate: isAlwaysUptoDate, originalApiFieldTranslationState: originalApiFieldTranslationState })=>{
    if (isFieldChanged) return 'changed';
    if (isAlwaysUptoDate && originalApiFieldTranslationState === 'outdated') return 'confirmed';
    return 'unchanged';
};
const $93635a2e4a77b9a9$export$2e23de592fa0281 = ({ isFieldChanged: isFieldChanged, isAlwaysUptoDate: isAlwaysUptoDate, originalApiFieldTranslationState: originalApiFieldTranslationState, fieldContent: fieldContent })=>{
    if (!fieldContent) return 'missing';
    if (originalApiFieldTranslationState === 'outdated' && !isFieldChanged && !isAlwaysUptoDate) return 'outdated';
    return 'up_to_date';
};
const $93635a2e4a77b9a9$export$1a8acf56aa100e3 = ({ cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap, field: field, fieldContent: fieldContent, currentLanguage: currentLanguage })=>{
    const cachedOriginalApiField = cachedOriginalApiFieldsMap?.[field.logicalId];
    // if field is changed before then the original api values will be in cachedOriginalApiField
    const originalApiField = cachedOriginalApiField || field;
    const originalApiFieldContent = originalApiField.translationContentMap[currentLanguage];
    const isFieldChanged = fieldContent !== originalApiFieldContent;
    const isAlwaysUptoDate = originalApiField.translationState === 'up_to_date' || field.isAlwaysUpToDate;
    const updatedTranslationState = $93635a2e4a77b9a9$export$2e23de592fa0281({
        isFieldChanged: isFieldChanged,
        isAlwaysUptoDate: isAlwaysUptoDate,
        originalApiFieldTranslationState: originalApiField.translationState,
        fieldContent: fieldContent
    });
    const updatedChangeType = $93635a2e4a77b9a9$export$9b06d01613fd55c7({
        isFieldChanged: isFieldChanged,
        isAlwaysUptoDate: isAlwaysUptoDate,
        originalApiFieldTranslationState: originalApiField.translationState
    });
    const isFieldDirty = updatedChangeType === 'changed' || updatedChangeType === 'confirmed';
    return {
        isFieldDirty: isFieldDirty,
        updatedTranslationState: updatedTranslationState,
        updatedChangeType: updatedChangeType
    };
};
const $93635a2e4a77b9a9$var$getFormattedData = (translationsData)=>{
    const translationPanelMap = {};
    const { defaultLanguage: defaultLanguage, selectedLanguage: selectedLanguage } = translationsData;
    const translationTabsWithPanelIds = translationsData.translationTabs.map((translationTab)=>{
        const { translationPanels: translationPanels, key: key, name: name } = translationTab;
        const translationPanelIds = translationPanels.map((translationPanel)=>{
            const panel = $93635a2e4a77b9a9$var$getFormattedPanelData(translationPanel);
            translationPanelMap[panel.id] = panel;
            return panel.id;
        });
        return {
            key: key,
            name: name,
            translationPanelIds: translationPanelIds
        };
    });
    return {
        translationPanelMap: translationPanelMap,
        translationTabsWithPanelIds: translationTabsWithPanelIds,
        selectedLanguage: selectedLanguage,
        defaultLanguage: defaultLanguage
    };
};
const $93635a2e4a77b9a9$export$e324594224ef24da = {
    initialize: (translationsData, error, loading)=>({ setState: setState, getState: getState })=>{
            if (loading) return;
            if (!translationsData) return;
            const { translationTabsWithPanelIds: translationTabsWithPanelIds, translationPanelMap: translationPanelMap, defaultLanguage: defaultLanguage, selectedLanguage: selectedLanguage } = $93635a2e4a77b9a9$var$getFormattedData(translationsData);
            setState({
                ...getState(),
                currentLanguage: translationsData?.selectedLanguage.key,
                loading: loading,
                error: error,
                translationPanelMap: translationPanelMap,
                translationTabsWithPanelIds: translationTabsWithPanelIds,
                selectedLanguage: selectedLanguage,
                defaultLanguage: defaultLanguage
            });
        },
    resetSelectedLanguage: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                selectedLanguage: null
            });
        },
    updateFields: ({ fieldLogicalId: fieldLogicalId, fieldContent: fieldContent })=>({ getState: getState, dispatch: dispatch })=>{
            const { currentLanguage: currentLanguage, cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap, selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const selectedPanel = translationPanelMap[selectedPanelId];
            let updatedPanelFlaggedStatus = false;
            let isDirty = false;
            const updatedTranslationGroups = selectedPanel.translationGroups.map((translationGroup)=>({
                    ...translationGroup,
                    translationFields: translationGroup.translationFields.map((field)=>{
                        // field currently getting updated
                        if (field.logicalId === fieldLogicalId) {
                            const cachedOriginalApiField = cachedOriginalApiFieldsMap?.[field.logicalId];
                            const { updatedChangeType: updatedChangeType, updatedTranslationState: updatedTranslationState, isFieldDirty: isFieldDirty } = $93635a2e4a77b9a9$export$1a8acf56aa100e3({
                                cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap,
                                field: field,
                                currentLanguage: currentLanguage,
                                fieldContent: fieldContent
                            });
                            if (updatedTranslationState !== 'up_to_date') updatedPanelFlaggedStatus = true;
                            isDirty = isDirty || isFieldDirty;
                            // save the field in cachedOriginalApiFieldMap if it is not present
                            if (!cachedOriginalApiField) dispatch($93635a2e4a77b9a9$export$e324594224ef24da.setOriginalApiFieldCache(field));
                            return {
                                ...field,
                                changeType: updatedChangeType,
                                translationState: updatedTranslationState,
                                translationContentMap: {
                                    ...field.translationContentMap,
                                    [currentLanguage]: fieldContent
                                }
                            };
                        }
                        if (field.translationState !== 'up_to_date') updatedPanelFlaggedStatus = true;
                        const { changeType: changeType } = field;
                        const isFieldDirty = changeType === 'changed' || changeType === 'confirmed';
                        isDirty = isDirty || isFieldDirty;
                        return field;
                    })
                }));
            const updatedSelectedPanel = {
                ...selectedPanel,
                isDirty: isDirty,
                isFlagged: updatedPanelFlaggedStatus,
                translationGroups: updatedTranslationGroups
            };
            dispatch($93635a2e4a77b9a9$export$e324594224ef24da.updateSelectedPanelData(selectedPanelId, updatedSelectedPanel));
        },
    discardChanges: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap, selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const selectedPanel = translationPanelMap[selectedPanelId];
            let updatedPanelFlaggedStatus = false;
            const updatedTranslationGroups = selectedPanel.translationGroups.map((translationGroups)=>({
                    ...translationGroups,
                    translationFields: translationGroups.translationFields.map((field)=>{
                        // take the cachedOriginalApiFieldsMap data if present for the field
                        const originalField = cachedOriginalApiFieldsMap?.[field.logicalId] || field;
                        if (originalField.translationState !== 'up_to_date') updatedPanelFlaggedStatus = true;
                        return {
                            ...originalField,
                            changeType: 'unchanged',
                            isAlwaysUpToDate: false,
                            translationContentMap: {
                                ...originalField.translationContentMap
                            }
                        };
                    })
                }));
            const updatedSelectedPanel = {
                ...selectedPanel,
                isDirty: false,
                translationGroups: updatedTranslationGroups,
                isFlagged: updatedPanelFlaggedStatus
            };
            dispatch($93635a2e4a77b9a9$export$e324594224ef24da.updateSelectedPanelData(selectedPanelId, updatedSelectedPanel));
            dispatch($93635a2e4a77b9a9$export$e324594224ef24da.resetOriginalApiFieldCache());
        },
    setSelectedPanelId: (selectedPanelId)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                selectedPanelId: selectedPanelId
            });
        },
    confirmTranslation: ({ fieldLogicalId: fieldLogicalId })=>({ getState: getState, dispatch: dispatch })=>{
            const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap, cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const selectedPanel = translationPanelMap[selectedPanelId];
            let isPanelFlaggedStatusUpdated = false;
            const updatedTranslationGroups = selectedPanel.translationGroups.map((translationGroup)=>({
                    ...translationGroup,
                    translationFields: translationGroup.translationFields.map((field)=>{
                        // field currently getting updated
                        if (field.logicalId === fieldLogicalId) {
                            const cachedOriginalApiField = cachedOriginalApiFieldsMap?.[field.logicalId];
                            if (!cachedOriginalApiField) dispatch($93635a2e4a77b9a9$export$e324594224ef24da.setOriginalApiFieldCache(field));
                            return {
                                ...field,
                                isAlwaysUpToDate: true,
                                translationState: 'up_to_date',
                                changeType: 'confirmed'
                            };
                        }
                        if (field.translationState !== 'up_to_date') isPanelFlaggedStatusUpdated = true;
                        return field;
                    })
                }));
            const updatedSelectedPanel = {
                ...selectedPanel,
                isDirty: true,
                isFlagged: isPanelFlaggedStatusUpdated,
                translationGroups: updatedTranslationGroups
            };
            dispatch($93635a2e4a77b9a9$export$e324594224ef24da.updateSelectedPanelData(selectedPanelId, updatedSelectedPanel));
        },
    setOriginalApiFieldCache: (field)=>({ getState: getState, setState: setState })=>{
            const { cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap } = getState();
            const updatedCachedOriginalApiFieldsMap = {
                ...cachedOriginalApiFieldsMap,
                [field.logicalId]: {
                    ...field,
                    translationContentMap: {
                        ...field.translationContentMap
                    }
                }
            };
            setState({
                ...getState(),
                cachedOriginalApiFieldsMap: updatedCachedOriginalApiFieldsMap
            });
        },
    updateSelectedPanelData: (selectedPanelId, updatedSelectedPanel)=>({ getState: getState, setState: setState })=>{
            const { translationPanelMap: translationPanelMap } = getState();
            setState({
                ...getState(),
                translationPanelMap: {
                    ...translationPanelMap,
                    [selectedPanelId]: updatedSelectedPanel
                }
            });
        },
    resetOriginalApiFieldCache: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                cachedOriginalApiFieldsMap: null
            });
        },
    onFooterSaveInitiated: ()=>({ getState: getState, setState: setState })=>{
            const { cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap, selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = getState();
            if (selectedPanelId === null || translationPanelMap === null) return;
            const oldApiFieldsMap = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(cachedOriginalApiFieldsMap);
            const selectedPanel = translationPanelMap[selectedPanelId];
            const panelDataReset = $93635a2e4a77b9a9$var$getFormattedPanelData(selectedPanel);
            setState({
                oldApiFieldsMap: oldApiFieldsMap,
                cachedOriginalApiFieldsMap: null,
                translationPanelMap: {
                    ...translationPanelMap,
                    [selectedPanelId]: panelDataReset
                }
            });
        },
    onFooterSaveFailure: ()=>({ getState: getState, setState: setState })=>{
            const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap, currentLanguage: currentLanguage, oldApiFieldsMap: oldApiFieldsMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const cachedOriginalApiFieldsMap = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(oldApiFieldsMap);
            const selectedPanel = translationPanelMap[selectedPanelId];
            let isPanelFlagged = false;
            let isDirty = false;
            const updatedTranslationGroups = selectedPanel.translationGroups.map((translationGroup)=>({
                    ...translationGroup,
                    translationFields: translationGroup.translationFields.map((field)=>{
                        const fieldContent = field.translationContentMap[currentLanguage];
                        const { updatedChangeType: updatedChangeType, updatedTranslationState: updatedTranslationState, isFieldDirty: isFieldDirty } = $93635a2e4a77b9a9$export$1a8acf56aa100e3({
                            cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap,
                            field: field,
                            currentLanguage: currentLanguage,
                            fieldContent: fieldContent
                        });
                        if (updatedTranslationState !== 'up_to_date') isPanelFlagged = true;
                        isDirty = isDirty || isFieldDirty;
                        return {
                            ...field,
                            changeType: updatedChangeType,
                            translationState: updatedTranslationState
                        };
                    })
                }));
            const updatedSelectedPanel = {
                ...selectedPanel,
                isDirty: isDirty,
                isFlagged: isPanelFlagged,
                translationGroups: updatedTranslationGroups
            };
            setState({
                cachedOriginalApiFieldsMap: cachedOriginalApiFieldsMap,
                oldApiFieldsMap: null,
                translationPanelMap: {
                    ...translationPanelMap,
                    [selectedPanelId]: updatedSelectedPanel
                }
            });
        },
    onFooterSaveSuccess: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                oldApiFieldsMap: null
            });
        },
    resetStoreAfterSave: ()=>({ getState: getState, setState: setState })=>{
            const { selectedPanelId: selectedPanelId, translationPanelMap: translationPanelMap } = getState();
            if (translationPanelMap === null || selectedPanelId === null) return;
            const selectedPanel = translationPanelMap[selectedPanelId];
            const panelDataReset = $93635a2e4a77b9a9$var$getFormattedPanelData(selectedPanel);
            setState({
                ...getState(),
                cachedOriginalApiFieldsMap: null,
                translationPanelMap: {
                    ...translationPanelMap,
                    [selectedPanelId]: panelDataReset
                }
            });
        }
};

});

parcelRegister("dpIMy", function(module, exports) {

$parcel$export(module.exports, "getTranslationGroups", () => $8240b13da26d4da7$export$be95f96d7716b005);
const $8240b13da26d4da7$export$be95f96d7716b005 = (state)=>{
    const { translationTabsWithPanelIds: translationTabsWithPanelIds, translationPanelMap: translationPanelMap } = state;
    if (translationPanelMap == null) return [];
    const translationGroups = translationTabsWithPanelIds.filter((group)=>group.translationPanelIds.length > 0).map(({ name: name, key: key, translationPanelIds: translationPanelIds })=>{
        const panels = translationPanelIds.map((panelId)=>translationPanelMap[panelId]);
        return {
            name: name,
            key: key,
            panels: panels
        };
    });
    return translationGroups;
};

});


parcelRegister("lI8d8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8cf929097e6fde1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c8cf929097e6fde1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "language-settings.sidebar-translations.title",
        "defaultMessage": "{language} translations"
    },
    changeIndicatorLabel: {
        "id": "language-settings.sidebar-translations.change-indicator-label",
        "defaultMessage": "Translations missing"
    }
});

});


parcelRegister("1e8Ij", function(module, exports) {

$parcel$export(module.exports, "EnabledLanguagesSubscriber", () => $3b9d33b5b21ca492$export$7213c8152d9f4fb9);
$parcel$export(module.exports, "useLanguages", () => $3b9d33b5b21ca492$export$38be4353f99148d);
$parcel$export(module.exports, "useEnabledLanguages", () => $3b9d33b5b21ca492$export$6bf456ac4b57e1e);
$parcel$export(module.exports, "useDisabledLanguages", () => $3b9d33b5b21ca492$export$a5e6f5e02526192c);
$parcel$export(module.exports, "useActiveLanguages", () => $3b9d33b5b21ca492$export$2ad4cb2f7292728b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $61F73 = parcelRequire("61F73");

var $963mH = parcelRequire("963mH");

var $7FZHZ = parcelRequire("7FZHZ");
const $3b9d33b5b21ca492$var$initialState = {
    loading: false,
    currentOperation: {
        type: (0, $7FZHZ.LANGUAGE_OPERATIONS).NO_OP,
        updatedLanguages: [],
        addedLanguages: [],
        languageLabel: '',
        analytics: undefined
    },
    error: undefined,
    data: {
        languages: [],
        projectDefaultLanguage: {
            key: '',
            label: ''
        },
        shouldAskUserToConfirmLanguages: false
    }
};
const $3b9d33b5b21ca492$var$Store = (0, $iXqE5.createStore)({
    initialState: $3b9d33b5b21ca492$var$initialState,
    actions: $61F73.actions,
    name: 'Languages'
});
const $3b9d33b5b21ca492$export$7213c8152d9f4fb9 = (0, $51nlc.createSubscriber)($3b9d33b5b21ca492$var$Store, {
    selector: (0, $963mH.getUsedLanguages)
});
const $3b9d33b5b21ca492$export$38be4353f99148d = (0, $3sQ5x.createHook)($3b9d33b5b21ca492$var$Store);
const $3b9d33b5b21ca492$export$6bf456ac4b57e1e = (0, $3sQ5x.createHook)($3b9d33b5b21ca492$var$Store, {
    selector: (0, $963mH.getUsedLanguages)
});
const $3b9d33b5b21ca492$export$a5e6f5e02526192c = (0, $3sQ5x.createHook)($3b9d33b5b21ca492$var$Store, {
    selector: (0, $963mH.getUnusedLanguages)
});
const $3b9d33b5b21ca492$export$2ad4cb2f7292728b = (0, $3sQ5x.createHook)($3b9d33b5b21ca492$var$Store, {
    selector: (0, $963mH.getActiveLanguages)
});

});
parcelRegister("61F73", function(module, exports) {

$parcel$export(module.exports, "actions", () => $aa48dd0fea7572e9$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $7FZHZ = parcelRequire("7FZHZ");
const $aa48dd0fea7572e9$var$getDefaultLanguageLabel = (languages, languageKey)=>{
    const language = languages.find((l)=>l.key === languageKey);
    return language ? language.label : '';
};
const $aa48dd0fea7572e9$var$fetchLanguages = (projectId, analyticsEvent)=>async ({ setState: setState })=>{
        setState({
            loading: true
        });
        try {
            const { languages: languages, projectDefaultLanguageKey: key, shouldAskUserToConfirmLanguages: shouldAskUserToConfirmLanguages } = await (0, $7f4tk.default)(`/rest/servicedesk/lingo-integration/1/manage-language/${projectId}`);
            setState({
                data: {
                    languages: languages,
                    projectDefaultLanguage: {
                        key: key,
                        label: $aa48dd0fea7572e9$var$getDefaultLanguageLabel(languages, key)
                    },
                    shouldAskUserToConfirmLanguages: shouldAskUserToConfirmLanguages
                },
                loading: false
            });
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'languages fetched', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error,
                loading: false
            });
            (0, $jcw0u.trackFetchErrors)({
                id: 'services.languages.fetch',
                packageName: 'jiraServicedeskLanguages',
                error: error
            });
        }
    };
const $aa48dd0fea7572e9$var$getUpdatePayload = (defaultLanguageKey, updatedLanguages)=>{
    const defaultLanguage = {
        languageTag: defaultLanguageKey,
        enabled: true
    };
    return [
        defaultLanguage,
        ...updatedLanguages.filter((l)=>l.state !== 'unused').filter((l)=>l.key !== defaultLanguageKey).map((l)=>({
                languageTag: l.key,
                enabled: l.state === 'active'
            }))
    ];
};
// A generic function to call the update languages endpoint.
// This is used by all operations: adding, removing, toggling availability and setting default.
const $aa48dd0fea7572e9$var$updateLanguages = // @ts-expect-error - TS2304 - Cannot find name 'SetState'.
(setState)=>async ({ projectId: projectId, updatedLanguages: updatedLanguages, defaultLanguageKey: defaultLanguageKey, analytics: analytics })=>{
        setState({
            loading: true
        });
        try {
            const { languages: languages, projectDefaultLanguageKey: key, shouldAskUserToConfirmLanguages: shouldAskUserToConfirmLanguages } = await (0, $eusud.performPostRequest)(`/rest/servicedesk/lingo-integration/1/manage-language/${projectId}`, {
                body: JSON.stringify({
                    projectDefaultLanguageKey: defaultLanguageKey,
                    languages: $aa48dd0fea7572e9$var$getUpdatePayload(defaultLanguageKey, updatedLanguages)
                })
            });
            setState({
                error: undefined,
                data: {
                    languages: languages,
                    projectDefaultLanguage: {
                        key: key,
                        label: $aa48dd0fea7572e9$var$getDefaultLanguageLabel(languages, key)
                    },
                    shouldAskUserToConfirmLanguages: shouldAskUserToConfirmLanguages
                },
                loading: false
            });
            if (analytics) (0, $8zOmE.fireOperationalAnalytics)(analytics.event, 'languages updated', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error,
                loading: false
            });
            (0, $jcw0u.trackFetchErrors)({
                id: 'services.languages.update',
                packageName: 'jiraServicedeskLanguages',
                error: error
            });
        }
    };
const $aa48dd0fea7572e9$var$clearLanguageOperation = ()=>async ({ setState: setState })=>{
        setState({
            currentOperation: {
                type: (0, $7FZHZ.LANGUAGE_OPERATIONS).NO_OP,
                updatedLanguages: [],
                addedLanguages: [],
                languageLabel: '',
                analytics: undefined
            }
        });
    };
const $aa48dd0fea7572e9$var$setDefaultLanguage = (params)=>async ({ setState: setState })=>{
        await $aa48dd0fea7572e9$var$updateLanguages(setState)(params);
        const { analytics: analytics, updatedLanguages: updatedLanguages, addedLanguages: addedLanguages } = params;
        setState({
            currentOperation: {
                type: (0, $7FZHZ.LANGUAGE_OPERATIONS).SET_DEFAULT_LANGUAGE,
                updatedLanguages: updatedLanguages,
                addedLanguages: addedLanguages,
                languageLabel: '',
                analytics: analytics
            }
        });
    };
const $aa48dd0fea7572e9$var$addLanguages = (params)=>async ({ setState: setState })=>{
        await $aa48dd0fea7572e9$var$updateLanguages(setState)(params);
        const { analytics: analytics, updatedLanguages: updatedLanguages, addedLanguages: addedLanguages } = params;
        setState({
            currentOperation: {
                type: (0, $7FZHZ.LANGUAGE_OPERATIONS).ADD_LANGUAGE,
                updatedLanguages: updatedLanguages,
                addedLanguages: addedLanguages,
                languageLabel: '',
                analytics: analytics
            }
        });
    };
const $aa48dd0fea7572e9$var$removeLanguage = ({ languageLabel: languageLabel, ...params })=>async ({ setState: setState })=>{
        await $aa48dd0fea7572e9$var$updateLanguages(setState)(params);
        const { analytics: analytics, updatedLanguages: updatedLanguages, addedLanguages: addedLanguages } = params;
        setState({
            currentOperation: {
                type: (0, $7FZHZ.LANGUAGE_OPERATIONS).REMOVE_LANGUAGE,
                updatedLanguages: updatedLanguages,
                addedLanguages: addedLanguages,
                languageLabel: languageLabel,
                analytics: analytics
            }
        });
    };
const $aa48dd0fea7572e9$var$setAvailableLanguage = ({ languageLabel: languageLabel, ...params })=>async ({ setState: setState })=>{
        await $aa48dd0fea7572e9$var$updateLanguages(setState)(params);
        const { analytics: analytics, updatedLanguages: updatedLanguages, addedLanguages: addedLanguages } = params;
        setState({
            currentOperation: {
                type: (0, $7FZHZ.LANGUAGE_OPERATIONS).SET_AVAILABLE,
                updatedLanguages: updatedLanguages,
                addedLanguages: addedLanguages,
                languageLabel: languageLabel,
                analytics: analytics
            }
        });
    };
const $aa48dd0fea7572e9$var$setUnavailableLanguage = ({ languageLabel: languageLabel, ...params })=>async ({ setState: setState })=>{
        await $aa48dd0fea7572e9$var$updateLanguages(setState)(params);
        const { analytics: analytics, updatedLanguages: updatedLanguages, addedLanguages: addedLanguages } = params;
        setState({
            currentOperation: {
                type: (0, $7FZHZ.LANGUAGE_OPERATIONS).SET_UNAVAILABLE,
                updatedLanguages: updatedLanguages,
                addedLanguages: addedLanguages,
                languageLabel: languageLabel,
                analytics: analytics
            }
        });
    };
const $aa48dd0fea7572e9$export$e324594224ef24da = {
    fetchLanguages: $aa48dd0fea7572e9$var$fetchLanguages,
    clearLanguageOperation: $aa48dd0fea7572e9$var$clearLanguageOperation,
    addLanguages: $aa48dd0fea7572e9$var$addLanguages,
    removeLanguage: $aa48dd0fea7572e9$var$removeLanguage,
    setAvailableLanguage: $aa48dd0fea7572e9$var$setAvailableLanguage,
    setUnavailableLanguage: $aa48dd0fea7572e9$var$setUnavailableLanguage,
    setDefaultLanguage: $aa48dd0fea7572e9$var$setDefaultLanguage
};

});
parcelRegister("7FZHZ", function(module, exports) {

$parcel$export(module.exports, "LANGUAGE_OPERATIONS", () => $94e88221edab9f04$export$e5f5168ee0c64f5a);
const $94e88221edab9f04$export$e5f5168ee0c64f5a = {
    NO_OP: 'NO_OP',
    ADD_LANGUAGE: 'ADD_LANGUAGE',
    REMOVE_LANGUAGE: 'REMOVE_LANGUAGE',
    SET_AVAILABLE: 'SET_AVAILABLE',
    SET_UNAVAILABLE: 'SET_UNAVAILABLE',
    SET_DEFAULT_LANGUAGE: 'SET_DEFAULT_LANGUAGE'
};

});


parcelRegister("963mH", function(module, exports) {

$parcel$export(module.exports, "getUsedLanguages", () => $9f89ae534ccee58d$export$3628275452a6073a);
$parcel$export(module.exports, "getUnusedLanguages", () => $9f89ae534ccee58d$export$56e4e857fa63069d);
$parcel$export(module.exports, "getActiveLanguages", () => $9f89ae534ccee58d$export$7a28b13bef8866d3);
const $9f89ae534ccee58d$var$withoutProjectDefaultLanguage = (languages, projectDefaultLanguageKey)=>languages.filter((l)=>l.key !== projectDefaultLanguageKey);
const $9f89ae534ccee58d$var$isLanguageUsed = (language)=>language.state !== 'unused';
const $9f89ae534ccee58d$var$isLanguageNotUsed = (language)=>!$9f89ae534ccee58d$var$isLanguageUsed(language);
const $9f89ae534ccee58d$var$isLanguageActive = (language)=>language.state === 'active';
const $9f89ae534ccee58d$export$3628275452a6073a = (state)=>$9f89ae534ccee58d$var$withoutProjectDefaultLanguage(state.data.languages, state.data.projectDefaultLanguage.key).filter($9f89ae534ccee58d$var$isLanguageUsed);
const $9f89ae534ccee58d$export$56e4e857fa63069d = (state)=>$9f89ae534ccee58d$var$withoutProjectDefaultLanguage(state.data.languages, state.data.projectDefaultLanguage.key).filter($9f89ae534ccee58d$var$isLanguageNotUsed);
const $9f89ae534ccee58d$export$7a28b13bef8866d3 = (state)=>state.data.languages.filter($9f89ae534ccee58d$var$isLanguageActive);

});


parcelRegister("ldKWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0606ff916c36da54$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0606ff916c36da54$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.settings",
        "defaultMessage": "Project settings"
    },
    details: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.details",
        "defaultMessage": "Details"
    },
    people: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.people",
        "defaultMessage": "People"
    },
    itsmFeatures: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.itsm-features",
        "defaultMessage": "Features"
    },
    summary: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.summary",
        "defaultMessage": "Summary"
    },
    deleteProject: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.delete-project",
        "defaultMessage": "Delete project"
    },
    issueTypes: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.issue-types",
        "defaultMessage": "Issue types"
    },
    issueLayout: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.issue-layout",
        "defaultMessage": "Issue layout"
    },
    workflows: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.workflows",
        "defaultMessage": "Workflows"
    },
    screens: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.screens",
        "defaultMessage": "Screens"
    },
    fields: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.fields",
        "defaultMessage": "Fields"
    },
    versions: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.versions",
        "defaultMessage": "Versions"
    },
    components: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.components",
        "defaultMessage": "Components"
    },
    permissions: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.permissions",
        "defaultMessage": "Permissions"
    },
    issueSecurity: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.issue-security",
        "defaultMessage": "Issue security"
    },
    notifications: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.notifications",
        "defaultMessage": "Notifications"
    },
    projectAutomation: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.project-automation",
        "defaultMessage": "Project Automation"
    },
    hipChat: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.hip-chat",
        "defaultMessage": "HipChat integration"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    features: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.features",
        "defaultMessage": "Features"
    },
    requestTypes: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.request-types",
        "defaultMessage": "Request types"
    },
    workCategories: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.work-categories",
        "defaultMessage": "Work categories"
    },
    customerPermissions: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    languageSupport: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.language-support",
        "defaultMessage": "Language support"
    },
    portalSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.portal-settings",
        "defaultMessage": "Portal settings"
    },
    emailRequests: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.email-requests",
        "defaultMessage": "Email requests"
    },
    customerNotifications: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.widget",
        "defaultMessage": "Widget"
    },
    satisfactionSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.satisfaction-settings",
        "defaultMessage": "Satisfaction settings"
    },
    knowledgeBase: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.knowledge-base",
        "defaultMessage": "Knowledge base"
    },
    sla: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.sla",
        "defaultMessage": "SLAs"
    },
    automation: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.automation",
        "defaultMessage": "Automation"
    },
    playbooks: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.playbooks",
        "defaultMessage": "Playbooks"
    },
    playbooksNewLozenge: {
        "id": "navigation-apps-sidebar-nav4-jsm-cmp-project-settings.playbooks.new-lozenge-label",
        "defaultMessage": "NEW"
    },
    journeysNonFinal: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.journeys",
        "defaultMessage": "Journeys"
    },
    devtools: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.devtools",
        "defaultMessage": "Development tools"
    },
    jsdAppDiscovery: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.jsd-app-discovery",
        "defaultMessage": "Apps"
    },
    jsdIncidentManagement: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.jsd-incident-management",
        "defaultMessage": "Incident management"
    },
    jsdChangeManagement: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.jsd-change-management",
        "defaultMessage": "Change management"
    },
    title: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.title",
        "defaultMessage": "Project settings"
    },
    itemBack: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.item-back",
        "defaultMessage": "Back to project settings"
    },
    goToSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.go-to-settings",
        "defaultMessage": "Back to settings"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
    'practice_change-management': {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.indicen-dfd",
        "defaultMessage": "Changes"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
    'practice_incident-management': {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.practice-incident-management",
        "defaultMessage": "Incidents"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
    'practice_post-incident-review': {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.practice-post-incident-review",
        "defaultMessage": "Post-incident reviews"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
    'practice_developer-escalation': {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.practice-developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
    'practice_problem-management': {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.practice-problem-management",
        "defaultMessage": "Problems"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
    'practice_service-request': {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.practice-service-request",
        "defaultMessage": "Service requests"
    },
    chat: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.chat",
        "defaultMessage": "Chat"
    },
    unassigned: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.unassigned",
        "defaultMessage": "Unassigned"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.new-lozenge",
        "defaultMessage": "New"
    },
    forms: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.forms",
        "defaultMessage": "Forms"
    },
    externalLinks: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.external-links",
        "defaultMessage": "External resources"
    },
    dataClassificationsNonFinal: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.data-classifications-non-final",
        "defaultMessage": "Data classification"
    },
    accessGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.access-group",
        "defaultMessage": "Access"
    },
    requestsManagementGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management-group",
        "defaultMessage": "Request management"
    },
    channelsGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.channels-group",
        "defaultMessage": "Channels & self service"
    },
    notificationsGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.notifications-group",
        "defaultMessage": "Notifications"
    },
    integrationsGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.integrations-group",
        "defaultMessage": "Apps"
    },
    operationsGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.operations-group",
        "defaultMessage": "Operations"
    }
});

});


parcelRegister("bTE3y", function(module, exports) {

$parcel$export(module.exports, "NotificationsMenu", () => $21aa1846b18a80e7$export$b08a5e252ace2ba);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $lNhbS = parcelRequire("lNhbS");

var $5b1vi = parcelRequire("5b1vi");

var $60r7z = parcelRequire("60r7z");
const $21aa1846b18a80e7$export$b08a5e252ace2ba = ({ projectKey: projectKey, features: features, onHandleLegacySPAClick: onHandleLegacySPAClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (features == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const NOTIFICATIONS_ROUTE_NAMES = [
        'project-settings-servicedesk-notifications',
        'legacy-project-settings-notifications',
        'project-settings-servicedesk-notifications-notification-email'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, features.hasNotifications && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).NOTIFICATIONS
        },
        href: `/plugins/servlet/project-config/${projectKey}/notifications`,
        selectedOn: NOTIFICATIONS_ROUTE_NAMES,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $60r7z.default).agentNotifications)), features.hasCustomerNotifications && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).CUSTOMER_NOTIFICATIONS
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('customer-notifications', projectKey),
        onClick: __SPA__ ? undefined : onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $60r7z.default).customerNotifications)));
};

});
parcelRegister("60r7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e31f6fc17a288d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $18e31f6fc17a288d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    agentNotifications: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.notifications.agent-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.notifications.customer-notifications",
        "defaultMessage": "Customer notifications"
    }
});

});


parcelRegister("8gYcW", function(module, exports) {

$parcel$export(module.exports, "RequestsManagementMenu", () => $be85adc6c23cd7f4$export$30079c5ff257de7f);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $jEJ7g = parcelRequire("jEJ7g");

var $lpwtK = parcelRequire("lpwtK");

var $itmJb = parcelRequire("itmJb");

var $lNhbS = parcelRequire("lNhbS");

var $5b1vi = parcelRequire("5b1vi");

var $hwltN = parcelRequire("hwltN");
const $be85adc6c23cd7f4$export$30079c5ff257de7f = ({ projectKey: projectKey, features: features, onHandleLegacySPAClick: onHandleLegacySPAClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { data: project } = (0, $lpwtK.useProject)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(project?.type);
    if (features == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (!(0, $4R6GH.fg)('jcs_master_flag') || features.hasForms) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).FORMS
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('forms', projectKey),
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $hwltN.default).forms)), features.hasWorkflows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).WORKFLOWS
        },
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        href: !isAdmin ? `/jira/servicedesk/projects/${projectKey}/settings/workflows` : `/plugins/servlet/project-config/${projectKey}/workflows`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $hwltN.default).workflows))), features.hasSla && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).SLAS
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('sla', projectKey),
        onClick: __SPA__ ? undefined : onHandleLegacySPAClick,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $hwltN.default).sla)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).SATISFACTION_SETTINGS
        },
        href: (0, $5b1vi.getSpaUrlForClassicSettings)('feedback-settings', projectKey),
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $hwltN.default).customerSatisfaction)), features.hasIssueTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).ISSUE_TYPES
        },
        href: `/plugins/servlet/project-config/${projectKey}/issuetypes`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $hwltN.default).issueTypes)), isJCS && features.hasIssueLayout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).ISSUE_LAYOUT
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${projectKey}/issuelayout`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $hwltN.default).issueLayout)), features.hasFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).FIELDS
        },
        href: `/plugins/servlet/project-config/${projectKey}/fields`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $hwltN.default).fields)), features.hasWorkflows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).SCREENS
        },
        href: `/plugins/servlet/project-config/${projectKey}/screens`,
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)()
    }, formatMessage((0, $hwltN.default).screens)));
};

});
parcelRegister("jEJ7g", function(module, exports) {

$parcel$export(module.exports, "useAsyncIsJCS", () => $db67bf04078e8532$export$3894a8f24b665478);
$parcel$export(module.exports, "isJCSProjectType", () => $db67bf04078e8532$export$25e1541dd4631818);
$parcel$export(module.exports, "useIsJCSProjectType", () => $db67bf04078e8532$export$b78b0f34fdacd97a);
$parcel$export(module.exports, "isJCSTemplate", () => $db67bf04078e8532$export$afee907b7a66ef2b);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $O4MMs = parcelRequire("O4MMs");

var $2vSU6 = parcelRequire("2vSU6");
const $db67bf04078e8532$var$useIsJCSProjectTypeFallback = (projectType, isAsync)=>{
    const isJCS = $db67bf04078e8532$export$3894a8f24b665478();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return isAsync ? isJCS : Boolean(isJCS);
};
const $db67bf04078e8532$export$25e1541dd4631818 = (projectType)=>projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && (0, $4R6GH.fg)('jcs_project_type_m3');
const $db67bf04078e8532$export$4b74a6f22da4a0d2 = (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || $db67bf04078e8532$export$25e1541dd4631818(projectType);
const $db67bf04078e8532$export$b78b0f34fdacd97a = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_project_type_m3'), $db67bf04078e8532$export$25e1541dd4631818, $db67bf04078e8532$var$useIsJCSProjectTypeFallback);
//
//  M2 helpers, deprecated
// ---------------------
const $db67bf04078e8532$var$useIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $O4MMs.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};
const $db67bf04078e8532$export$927b5354181b3adf = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$useIsJCSUnderFF, ()=>false);
// Undefined can be used to check if project properties has been resolved or not
const $db67bf04078e8532$var$useAsyncIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $O4MMs.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
};
const $db67bf04078e8532$export$3894a8f24b665478 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$useAsyncIsJCSUnderFF, ()=>false);
const $db67bf04078e8532$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
const $db67bf04078e8532$var$isJCSTemplateFallback = (template)=>false;
const $db67bf04078e8532$export$afee907b7a66ef2b = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$isJCSTemplateUnderFF, $db67bf04078e8532$var$isJCSTemplateFallback);

});

parcelRegister("hwltN", function(module, exports) {

$parcel$export(module.exports, "default", () => $92289d94efce8cfb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $92289d94efce8cfb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    workflows: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.workflows",
        "defaultMessage": "Workflows"
    },
    screens: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.screens",
        "defaultMessage": "Screens"
    },
    fields: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.fields",
        "defaultMessage": "Fields"
    },
    issueTypes: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.issue-types",
        "defaultMessage": "Issue types"
    },
    issueLayout: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.issue-layout",
        "defaultMessage": "Issue layout"
    },
    requestTypes: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.request-types",
        "defaultMessage": "Request types"
    },
    forms: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.forms",
        "defaultMessage": "Forms"
    },
    sla: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.sla",
        "defaultMessage": "SLAs"
    },
    customerSatisfaction: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.customer-satisfaction",
        "defaultMessage": "Customer satisfaction"
    }
});

});


parcelRegister("arClt", function(module, exports) {

$parcel$export(module.exports, "TicketTypesItem", () => $8232c60cb5bd0509$export$ad435b141df29313);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $xc3fY = parcelRequire("xc3fY");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $eUvlM = parcelRequire("eUvlM");

var $16J3A = parcelRequire("16J3A");

var $f5dul = parcelRequire("f5dul");

var $ee0rS = parcelRequire("ee0rS");

var $doZTA = parcelRequire("doZTA");

var $lNhbS = parcelRequire("lNhbS");

var $c2JIK = parcelRequire("c2JIK");

var $ldKWY = parcelRequire("ldKWY");
const $8232c60cb5bd0509$var$requestTypesGroupWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.150'
});
const $8232c60cb5bd0509$var$requestTypesWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $8232c60cb5bd0509$var$StyledSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $8232c60cb5bd0509$export$ad435b141df29313 = ({ nestingId: nestingId, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const enabledPracticeData = (0, $eUvlM.useWorkCategoriesAllSupportedWithForceRefreshOnMount)();
    const handleLegacySPAClick = (0, $c2JIK.useLegacySpaClickHandler)();
    const enabledPractices = enabledPracticeData.data || [];
    const [{ location: location }] = (0, $doZTA.useRouter)();
    return enabledPractices.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8232c60cb5bd0509$var$requestTypesGroupWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).TICKET_TYPES
        },
        menuItemLabel: formatMessage((0, $ldKWY.default).requestTypes),
        submenuId: nestingId,
        forceExpand: location.pathname.startsWith(`/jira/servicedesk/projects/${projectKey}/settings/request-types/`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5dul.default), {
        id: (0, $16J3A.REQUEST_TYPE_PRACTICE_NAV_ONBOARDING).PRACTICE_NAV_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8232c60cb5bd0509$var$requestTypesWrapperStyles
    }, enabledPractices.filter(Boolean).map((practice)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            onClick: handleLegacySPAClick,
            key: practice,
            analytics: {
                itemId: `sd-ticket-types-${(0, $ee0rS.toShortFormItsmPractice)(practice)}`
            },
            href: `/jira/servicedesk/projects/${projectKey}/settings/request-types/category/${(0, $ee0rS.toShortFormItsmPractice)(practice)}`,
            selectedOn: (0, $4OCke.matchPartialUrlPathname)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8232c60cb5bd0509$var$StyledSpan, null, formatMessage((0, $ldKWY.default)[`practice_${practice}`])))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5dul.default), {
        id: (0, $16J3A.REQUEST_TYPE_PRACTICE_NAV_ONBOARDING).UNASSIGNED_NAV_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8232c60cb5bd0509$var$requestTypesWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        onClick: __SPA__ ? undefined : handleLegacySPAClick,
        analytics: {
            itemId: 'sd-ticket-types-unassigned'
        },
        href: `/jira/servicedesk/projects/${projectKey}/settings/request-types/unassigned`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8232c60cb5bd0509$var$StyledSpan, null, formatMessage((0, $ldKWY.default).unassigned))))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).TICKET_TYPES
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        href: `/jira/servicedesk/projects/${projectKey}/settings/request-types`,
        onClick: handleLegacySPAClick
    }, formatMessage((0, $ldKWY.default).requestTypes));
};

});
parcelRegister("eUvlM", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $9479f477b801290f$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $9479f477b801290f$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $9479f477b801290f$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $9479f477b801290f$export$4d46346ef0bdc6b9);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $oCMSG = parcelRequire("oCMSG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("4Wb3o"));
const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
const $9479f477b801290f$export$2ae319305481e7de = (0, $2M1hQ.createResource)({
    type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $9479f477b801290f$var$getDataLoader,
    maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
});
const $9479f477b801290f$var$queuesOrder = [
    ...(0, $oCMSG.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $9479f477b801290f$var$workCategoryOrder = [
    ...$9479f477b801290f$var$queuesOrder,
    (0, $oCMSG.DEVELOPER_ESCALATION)
];
const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("4Wb3o", function(module, exports) {

let $39852742b1504c54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39852742b1504c54$var$load("jhLKO").then(()=>parcelRequire('8khb6'));

});


parcelRegister("f5dul", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a767177a3817e54$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hchBL = parcelRequire("hchBL");
/**
 * @deprecated This component is deprecated as part of JIG-1315 due to the top level
 * SpotlightManager in Jira Frontend. Atlaskit SpotlightTarget is now usable in
 * Jira Frontend in place of GlobalSpotlightTarget.
 * Please use import { SpotlightTarget } from '@atlaskit/onboarding' instead.
 * NOTE: GlobalSpotlightTarget may also cause OOM errors while using redux-devtools
 * due to the component's usage of global refs to attach spotlights to targets
 */ const $4a767177a3817e54$var$GlobalSpotlightTargetDeprecated = (props)=>{
    const { id: id, children: children, TargetComponent: TargetComponent } = props;
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        register(id, ref);
    }, [
        register,
        id
    ]);
    const targetProps = {
        ref: onRef,
        'data-testid': `ref-spotlight-target-${props.id}`
    };
    return TargetComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TargetComponent, targetProps, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a767177a3817e54$var$InheritDisplay, targetProps, children);
};
var $4a767177a3817e54$export$2e2bcd8739ae039 = $4a767177a3817e54$var$GlobalSpotlightTargetDeprecated;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a767177a3817e54$var$InheritDisplay = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1kw7 _2lx21kw7 _4cvr1kw7 _1bah1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hchBL", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $b03364e48d8512c5$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $b03364e48d8512c5$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $b03364e48d8512c5$export$6b4b878b04fd3017);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b03364e48d8512c5$var$store = (0, $iXqE5.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $b03364e48d8512c5$export$4beaa3baa53198e4 = (0, $gg7kZ.createContainer)($b03364e48d8512c5$var$store);
const $b03364e48d8512c5$var$useGlobalRefStateSelector = (0, $3sQ5x.createStateHook)($b03364e48d8512c5$var$store, {
    selector: (state, key)=>state[key]
});
const $b03364e48d8512c5$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $b03364e48d8512c5$var$useGlobalRefStateSelector(key)
    ];
const $b03364e48d8512c5$export$3c6c6911d09d7d8a = (0, $3sQ5x.createHook)($b03364e48d8512c5$var$store, {
    selector: null
});
const $b03364e48d8512c5$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $b03364e48d8512c5$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});


parcelRegister("ee0rS", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $3a8490f36704bba6$export$db58a56259f511a2);

var $oCMSG = parcelRequire("oCMSG");
const $3a8490f36704bba6$var$longToShortConversionMap = {
    [(0, $oCMSG.CHANGES)]: (0, $oCMSG.SHORT_FORM_CHANGES),
    [(0, $oCMSG.INCIDENTS)]: (0, $oCMSG.SHORT_FORM_INCIDENTS),
    [(0, $oCMSG.PROBLEMS)]: (0, $oCMSG.SHORT_FORM_PROBLEMS),
    [(0, $oCMSG.SERVICE_REQUEST)]: (0, $oCMSG.SHORT_FORM_SERVICE_REQUEST),
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: (0, $oCMSG.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $oCMSG.DEVELOPER_ESCALATION)]: (0, $oCMSG.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $3a8490f36704bba6$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $3a8490f36704bba6$var$longToShortConversionMap;
}
const $3a8490f36704bba6$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($3a8490f36704bba6$var$isLongForm(workCategoryKey)) return $3a8490f36704bba6$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});



parcelRegister("2TRg1", function(module, exports) {

$parcel$export(module.exports, "useNestingStack", () => $d8682805e2f5e5e1$export$15c44bbc3b4a50e0);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $doZTA = parcelRequire("doZTA");

var $lNhbS = parcelRequire("lNhbS");

var $6km9q = parcelRequire("6km9q");
const $d8682805e2f5e5e1$export$15c44bbc3b4a50e0 = ({ connectStack: connectStack, forgeStack: forgeStack, knowledgeType: knowledgeType, isLegacyAutomationEnabled: isLegacyAutomationEnabled, isTeamManagedProject: isTeamManagedProject })=>{
    const [currentRouterState] = (0, $doZTA.useRouter)();
    const previousRouterState = (0, $6jY6G.usePreviousRouterState)();
    const forcedRootStack = (0, $5uXOq.useRef)({
        enabled: true,
        queueId: undefined
    });
    const lastStackRef = (0, $5uXOq.useRef)([]);
    const knowledgeNest = knowledgeType === (0, $lNhbS.KNOWLEDGE_HUB_NESTED_TYPE);
    const [stack, setStack] = (0, $5uXOq.useState)(()=>(0, $6km9q.calculateStack)({
            connectStack: connectStack,
            forgeStack: forgeStack,
            currentRouterState: currentRouterState,
            forceRootStack: true,
            knowledgeNest: knowledgeNest,
            previousState: previousRouterState,
            isLegacyAutomationEnabled: isLegacyAutomationEnabled,
            isTeamManagedProject: isTeamManagedProject,
            lastStackRef: lastStackRef
        }));
    const { projectKey: projectKey } = currentRouterState.match.params;
    // Reset to the initial behaviour when the servicedesk project key changes
    (0, $5uXOq.useEffect)(()=>{
        forcedRootStack.current = {
            enabled: true,
            queueId: undefined
        };
    }, [
        projectKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // We do not need to do anything if the forced root stack is disabled
        if (!forcedRootStack.current.enabled) return;
        const { action: action, match: match, route: route } = currentRouterState;
        const { queueId: queueId } = match.params;
        // Set the initial queueId on the forced root stack, if it has not been set yet
        if (forcedRootStack.current.queueId == null && queueId != null) forcedRootStack.current.queueId = queueId;
        // Disable the forced root stack, when:
        // the user moves to another queue
        const hasChangedQueue = forcedRootStack.current.queueId != null && forcedRootStack.current.queueId !== queueId;
        const isNavigatingToTheSamePageAgain = action === 'PUSH' && !route.isRedirect;
        const isNavigatingFromGettingStartedPage = (0, $4R6GH.fg)('gsp_production_rollout') && route.name === 'servicedesk-getting-started-page';
        if (hasChangedQueue || isNavigatingToTheSamePageAgain || isNavigatingFromGettingStartedPage) forcedRootStack.current.enabled = false;
    }, [
        currentRouterState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const forceRootStack = forcedRootStack.current.enabled;
        const nextStack = (0, $6km9q.calculateStack)({
            connectStack: connectStack,
            forgeStack: forgeStack,
            currentRouterState: currentRouterState,
            forceRootStack: forceRootStack,
            knowledgeNest: knowledgeNest,
            previousState: previousRouterState,
            isLegacyAutomationEnabled: isLegacyAutomationEnabled,
            isTeamManagedProject: isTeamManagedProject,
            lastStackRef: lastStackRef
        });
        setStack(nextStack);
    }, [
        connectStack,
        forgeStack,
        currentRouterState,
        isLegacyAutomationEnabled,
        isTeamManagedProject,
        knowledgeNest,
        previousRouterState
    ]);
    /*
        Making an exception for settings page.
        When clicking Back menu item in settings page we don't want to re-calculate the stack;
		therefore, no transition happens, and will let the page redirect load happen to the root page.
    */ if (lastStackRef.current.includes('settings') && stack.length === 0) return [
        lastStackRef.current,
        setStack
    ];
    if (String(stack) !== String(lastStackRef)) lastStackRef.current = stack;
    return [
        stack,
        setStack
    ];
};

});
parcelRegister("6km9q", function(module, exports) {

$parcel$export(module.exports, "calculateStack", () => $5eba550c8f520274$export$b753dc61ba067fb);

var $k0iPT = parcelRequire("k0iPT");

var $4R6GH = parcelRequire("4R6GH");

var $dd29Z = parcelRequire("dd29Z");

var $oCMSG = parcelRequire("oCMSG");

var $lNhbS = parcelRequire("lNhbS");
const $5eba550c8f520274$var$REPLACE = 'REPLACE';
const $5eba550c8f520274$var$shouldForceRootStack = (state)=>{
    const { route: route, action: action } = state || {};
    // If we explicitly load on :projectKey/sections/:practiceType we want to load the nest
    const isLoadOnSectionRedirect = action !== $5eba550c8f520274$var$REPLACE && route?.name === 'servicedesk-practice-landing';
    // When landing on these routes we don't want it to force reloading the stack regardless of isRedirect = true
    const isLandingPageRedirectRoute = [
        'project-settings-servicedesk-classic-apps',
        'project-settings-servicedesk-virtualagent'
    ].includes(route?.name || '');
    return route?.isRedirect && !isLoadOnSectionRedirect && !isLandingPageRedirectRoute;
};
const $5eba550c8f520274$export$b753dc61ba067fb = ({ connectStack: connectStack, forgeStack: forgeStack, currentRouterState: currentRouterState, forceRootStack: forceRootStack, knowledgeNest: knowledgeNest, previousState: previousState, isLegacyAutomationEnabled: isLegacyAutomationEnabled, lastStackRef: lastStackRef })=>{
    const { match: match, route: route } = currentRouterState;
    if (!route) return [];
    if (forceRootStack && ($5eba550c8f520274$var$shouldForceRootStack(previousState) || $5eba550c8f520274$var$shouldForceRootStack(currentRouterState))) return [];
    if ([
        'servicedesk-practice-custom-and-issue',
        'servicedesk-practice-edit',
        'servicedesk-practice-issue',
        'servicedesk-practice-landing',
        'servicedesk-practice-new',
        'servicedesk-practice-manage-view',
        'servicedesk-queues-addon',
        'servicedesk-queues-custom-view',
        'servicedesk-queues-edit',
        'servicedesk-queues-issue',
        'servicedesk-queues-landing',
        'servicedesk-queues-new',
        'servicedesk-queues-manage-view',
        'servicedesk-queues-custom-issue-detail',
        ...(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? [
            'servicedesk-queues-custom-board',
            'servicedesk-queues-custom-calendar',
            'servicedesk-queues-practice-custom-board',
            'servicedesk-queues-practice-custom-calendar',
            'servicedesk-queues-views-config',
            'servicedesk-practice-views-config'
        ] : []
    ].filter(Boolean).includes(route.name)) {
        const practice = (0, $oCMSG.WORK_CATEGORIES_QUEUE_SUPPORTED).find((v)=>match.url.includes(`/${(0, $dd29Z.QUEUE_ROUTES)[v]}`)) || 'queues';
        return [
            practice
        ];
    }
    if ([
        'knowledge-hub-all-articles',
        'knowledge-hub-article-in-category',
        'knowledge-hub-browse-all-articles',
        'knowledge-hub-browse-view-article',
        'knowledge-hub-category',
        'knowledge-hub-category-page',
        'knowledge-hub-landing',
        'knowledge-hub-search',
        'knowledge-hub-setup',
        'knowledge-hub-drafts',
        'knowledge-hub-browse-all-categories',
        'knowledge-hub-suggested-topics'
    ].includes(route.name) && knowledgeNest) return [
        'knowledge'
    ];
    if ([
        'servicedesk-reports',
        'servicedesk-atlassian-analytics',
        'servicedesk-reports-workload',
        'servicedesk-reports-satisfaction-time-scale-issue',
        'servicedesk-reports-satisfaction-time-scale',
        'servicedesk-reports-satisfaction',
        'servicedesk-kb-requests-reports-time-scale-issue',
        'servicedesk-kb-requests-reports-time-scale',
        'servicedesk-kb-requests-reports',
        'servicedesk-reports-custom-edit',
        'servicedesk-reports-custom-create',
        'servicedesk-reports-custom-time-scale-issue',
        'servicedesk-reports-custom-time-scale',
        'servicedesk-reports-custom',
        'servicedesk-reports-type'
    ].includes(route.name)) return [
        'reports'
    ];
    if ([
        'servicedesk-issues'
    ].includes(route.name)) return [
        'issues'
    ];
    if (isLegacyAutomationEnabled) {
        if ([
            'legacy-jsd-jira-automation',
            'project-settings-automation',
            'project-settings-servicedesk-jira-automation'
        ].includes(route.name) || route.name.includes('project-settings-servicedesk-automation')) return [
            'settings',
            (0, $lNhbS.SERVICE_DESK_AUTOMATION_SUB_NAV)
        ];
    }
    // SERVICE_DESK_LEGACY_TICKET_TYPES - is a "Request types" menu panel
    const isOnSpaRequestTypePage = route.name === 'project-settings-servicedesk-itsm-ticket-types-config' || route.name === 'project-settings-servicedesk-itsm-ticket-type-fields';
    if (route.name === 'project-settings-servicedesk-unassigned-ticket-types-config' || route.name === 'project-settings-servicedesk-unassigned-ticket-type-fields') return [
        'settings'
    ];
    if (isOnSpaRequestTypePage) return [
        'settings'
    ];
    if (route.name === 'project-settings-servicedesk-notifications-notification-email') return [
        'settings'
    ];
    // should be handled above the generic PROJECT_SETTINGS_SERVICEDESK logic
    if ([
        'forge-spa-project',
        'forge-spa-project-servicedesk',
        'forge-spa-servicedesk-queue',
        'project-settings-servicedesk-forge-apps'
    ].includes(route.name) && forgeStack) return forgeStack;
    // generic JSM Project Settings / PROJECT_SETTINGS_SERVICEDESK logic
    if (route.name.includes('project-settings-servicedesk') || route.name.includes('legacy-jsd-settings')) {
        const [view] = route.name.replace('project-settings-servicedesk-', '').replace('legacy-jsd-settings-', '').split('-');
        switch(view){
            case 'channels':
            case 'issuetypes':
            case 'apps':
                return [
                    'settings'
                ];
            case 'notifications':
                return [
                    'settings'
                ];
            case 'language':
                if (match?.params?.languageKey != null) return [
                    'settings',
                    'languageSupport',
                    match.params.languageKey
                ];
                return [
                    'settings',
                    'languageSupport'
                ];
            case 'virtualagent':
                return [
                    'settings',
                    'virtualagent'
                ];
            default:
                return [
                    'settings'
                ];
        }
    }
    if ([
        'legacy-project-settings-edit',
        'legacy-project-settings-config',
        'project-settings-classic-data-classifications',
        'legacy-project-settings-fields',
        'legacy-project-settings-issue-layout',
        (0, $4R6GH.fg)('jcs_master_flag') && 'project-settings-classic-issue-layout',
        'legacy-project-settings-issue-security',
        'legacy-project-settings-issue-types',
        'legacy-project-settings-notifications',
        'legacy-project-settings-opsgenie',
        'legacy-project-settings-permissions',
        'legacy-project-settings-screens',
        'legacy-project-settings-summary',
        'legacy-project-settings-workflows',
        'legacy-project-settings-delete',
        'legacy-project-settings-collectors',
        'legacy-project-settings-dev',
        'legacy-project-settings-people',
        'project-settings-versions',
        'project-settings-components',
        'project-settings-automation',
        'legacy-jsd-settings-fallback',
        'legacy-jsd-widgets',
        'servicedesk-sla-settings',
        (0, $4R6GH.fg)('playbooks-in-jsm') && 'project-settings-playbooks-edit',
        (0, $4R6GH.fg)('playbooks-in-jsm') && 'project-settings-playbooks-list'
    ].includes(route.name)) return [
        'settings'
    ];
    if ((0, $k0iPT.CONNECT_ROUTES_SET).has(route.name) && connectStack) return connectStack;
    if ([
        'issue-navigator'
    ].includes(route.name)) return [
        'issues'
    ];
    /*
        When navigating to the products or customers page, we don't need to
        retain lastStack to previous value, see the exception in ../index
        for the settings page. When navigating from the feature page settings
        to the products or customers page, the navbar stays on the settings.
        This sets the lastStack to an empty array to update the navbar.
    */ if ([
        'servicedesk-customer-service-products',
        'servicedesk-customers-v2'
    ].includes(route.name)) {
        // eslint-disable-next-line no-param-reassign
        lastStackRef.current = [];
        return [];
    }
    return [];
};

});


parcelRegister("hadw2", function(module, exports) {

$parcel$export(module.exports, "useViewsFeature", () => $b1f44c73795db9e5$export$d6cb0e5ae10a36bb);

var $4R6GH = parcelRequire("4R6GH");
const $b1f44c73795db9e5$export$d6cb0e5ae10a36bb = ({ features: features })=>{
    if (!(0, $4R6GH.fg)('jsm_views_of_work_phase_1')) return {
        isEnabled: false,
        url: ''
    };
    const isBoardEnabled = !!features?.jsmBoard?.enabled;
    const boardUrl = features?.jsmBoard?.url ?? '';
    const isCalendarEnabled = !!features?.jsmCalendar?.enabled;
    const calendarUrl = features?.jsmCalendar?.url ?? '';
    const isEnabled = isBoardEnabled && !!boardUrl || isCalendarEnabled && !!calendarUrl;
    if (!isEnabled) return {
        isEnabled: false,
        url: ''
    };
    return {
        isEnabled: true,
        url: isBoardEnabled ? boardUrl : calendarUrl
    };
};

});


parcelRegister("buVVR", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $5e36b02795dbb5e5$export$d9b273488cd8ce6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $5LWLA = parcelRequire("5LWLA");

var $7aY9g = parcelRequire("7aY9g");

var $dME4E = parcelRequire("dME4E");

var $aZ5rg = parcelRequire("aZ5rg");

var $acknU = parcelRequire("acknU");

var $2ciBJ = parcelRequire("2ciBJ");

var $50Bjx = parcelRequire("50Bjx");

var $9x5pH = parcelRequire("9x5pH");

var $hxCqX = parcelRequire("hxCqX");

var $aVnO1 = parcelRequire("aVnO1");

var $aEHvW = parcelRequire("aEHvW");

var $d1ABl = parcelRequire("d1ABl");

var $fc7bc = parcelRequire("fc7bc");

var $lJosW = parcelRequire("lJosW");

var $bB6uF = parcelRequire("bB6uF");

var $ckyDP = parcelRequire("ckyDP");

var $6B8sk = parcelRequire("6B8sk");

var $k2tiP = parcelRequire("k2tiP");

var $7paD5 = parcelRequire("7paD5");

var $3u0c5 = parcelRequire("3u0c5");

var $imZsD = parcelRequire("imZsD");

var $4PB4I = parcelRequire("4PB4I");
var $g2EiV = parcelRequire("g2EiV");
var $9btdk = parcelRequire("9btdk");
var $gjTBi = parcelRequire("gjTBi");
var $gZEU1 = parcelRequire("gZEU1");
var $bWqXX = parcelRequire("bWqXX");

var $dqoiX = parcelRequire("dqoiX");

var $8J6rn = parcelRequire("8J6rn");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $3QTQ5 = parcelRequire("3QTQ5");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $crQHm = parcelRequire("crQHm");

var $2gP8z = parcelRequire("2gP8z");

var $Uj4ce = parcelRequire("Uj4ce");

var $lpwtK = parcelRequire("lpwtK");

var $juTur = parcelRequire("juTur");

var $jsI7v = parcelRequire("jsI7v");

var $kZj7F = parcelRequire("kZj7F");

var $l468O = parcelRequire("l468O");

var $3SzZi = parcelRequire("3SzZi");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $3tHFY = parcelRequire("3tHFY");

var $hWtQt = parcelRequire("hWtQt");

var $jfqNX = parcelRequire("jfqNX");

var $gZbSF = parcelRequire("gZbSF");

var $6hMYg = parcelRequire("6hMYg");

var $231OU = parcelRequire("231OU");

var $iIGGa = parcelRequire("iIGGa");

var $8zgGo = parcelRequire("8zgGo");

var $j9iVo = parcelRequire("j9iVo");

var $dxCvy = parcelRequire("dxCvy");


var $9QGIi = parcelRequire("9QGIi");

var $dtVRS = parcelRequire("dtVRS");

var $htI2Q = parcelRequire("htI2Q");

var $dMRcK = parcelRequire("dMRcK");

var $37cK0 = parcelRequire("37cK0");

var $2avq0 = parcelRequire("2avq0");

var $koeKL = parcelRequire("koeKL");

var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");

var $aQY3O = parcelRequire("aQY3O");

var $lNhbS = parcelRequire("lNhbS");

var $a88Sz = parcelRequire("a88Sz");

var $e1CQH = parcelRequire("e1CQH");

var $4eEnx = parcelRequire("4eEnx");

var $1rtJs = parcelRequire("1rtJs");

var $ccoXC = parcelRequire("ccoXC");

var $3wBTQ = parcelRequire("3wBTQ");

var $bTR6h = parcelRequire("bTR6h");

var $dYOHi = parcelRequire("dYOHi");

var $80BbW = parcelRequire("80BbW");

var $812cH = parcelRequire("812cH");

var $y8WG5 = parcelRequire("y8WG5");

var $fN4XF = parcelRequire("fN4XF");

var $2TRg1 = parcelRequire("2TRg1");

var $hadw2 = parcelRequire("hadw2");

var $2EZB0 = parcelRequire("2EZB0");
const $5e36b02795dbb5e5$var$styles = {
    menuItem: "_btpd1ady _1c06idpf _g718kb7n _3u8ukb7n"
};
const $5e36b02795dbb5e5$export$e8026ff3708f95e4 = (0, $7OqB4.withThrowOnError)((0, $y8WG5.useFeatures));
const $5e36b02795dbb5e5$export$154ecbb867fd48f0 = (0, $7OqB4.withThrowOnError)((0, $y8WG5.useSettingFeatures));
const $5e36b02795dbb5e5$export$a4007dc4843ca7f6 = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $5e36b02795dbb5e5$export$1108315bd91bf04b = (0, $7OqB4.withThrowOnError)((0, $gZbSF.useProjectConnectItems));
const $5e36b02795dbb5e5$export$3da22ae99edc5982 = (0, $7OqB4.withThrowOnError)((0, $hWtQt.useProjectReportsConnectItems));
const $5e36b02795dbb5e5$export$1f8e4b2910733f3 = (0, $7OqB4.withThrowOnError)((0, $jfqNX.useProjectSettingsConnectItems)); /**
                                                                                                      * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4/jsm-project-menu
                                                                                                      */ 
const $5e36b02795dbb5e5$export$d9b273488cd8ce6f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [forgeQueueParentStack] = (0, $5uXOq.useState)(()=>[
            (0, $lNhbS.SECTION_ID).QUEUES
        ]);
    const [forgeSettingsParentStack, setForgeSettingsParentStack] = (0, $5uXOq.useState)(()=>[
            (0, $lNhbS.SECTION_ID).SETTINGS
        ]);
    const isPremiumTenant = (0, $fN4XF.useIsPremiumTenant)();
    const { data: features } = $5e36b02795dbb5e5$export$e8026ff3708f95e4();
    const { data: settingFeatures } = $5e36b02795dbb5e5$export$154ecbb867fd48f0();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const { data: project } = $5e36b02795dbb5e5$export$a4007dc4843ca7f6();
    const { data: projectConnectItems, stack: connectProjectStack } = $5e36b02795dbb5e5$export$1108315bd91bf04b();
    const { data: connectReportsItems, stack: connectReportsStack } = $5e36b02795dbb5e5$export$3da22ae99edc5982();
    const { data: connectSettingsItems, stack: connectSettingsStack } = $5e36b02795dbb5e5$export$1f8e4b2910733f3();
    const { data: forgeSettingsItems, stack: forgeProjectSettingsStack } = (0, $6hMYg.useProjectSettingsForgeAppsForMenu)('project-settings-servicedesk-forge-apps', forgeSettingsParentStack);
    const { stack: forgeProjectStack } = (0, $231OU.useProjectForgeApps)('forge-spa-project');
    const { stack: forgeProjectServicedeskStack } = (0, $231OU.useProjectForgeApps)('forge-spa-project-servicedesk');
    const { stack: forgeQueueStack } = (0, $iIGGa.useServiceDeskQueueForgeApps)('forge-spa-servicedesk-queue', forgeQueueParentStack);
    const ecosystemItems = (0, $5uXOq.useMemo)(()=>({
            forge: forgeSettingsItems,
            connect: connectSettingsItems
        }), [
        connectSettingsItems,
        forgeSettingsItems
    ]);
    const { enabled: isLegacyAutomationEnabled } = (0, $Uj4ce.useNavigationAutomationLegacyEnabledResource)().data || {};
    const [stack, setStack] = (0, $2TRg1.useNestingStack)({
        connectStack: connectProjectStack || connectReportsStack || connectSettingsStack,
        forgeStack: forgeProjectStack || forgeProjectServicedeskStack || forgeProjectSettingsStack || forgeQueueStack,
        knowledgeType: features && features.knowledge.type,
        isLegacyAutomationEnabled: !!isLegacyAutomationEnabled,
        isTeamManagedProject: project?.isSimplified ?? false
    });
    const { data: projectContext } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    const { shouldUseJSM: shouldUseJSM, loading: isOgTenantInfoLoading, error: ogTenantInfoError } = (0, $8J6rn.useOgTenantInfo)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ route: route }] = (0, $doZTA.useRouter)();
    const [isLoading, isGettingStatedPageEnabled] = (0, $htI2Q.useIsGettingStartedPageEnabled)();
    const { isInviteTeamSpotlightEnabled: isInviteTeamSpotlightEnabled, loadInviteTeamResource: loadInviteTeamResource, onInviteTeamOnboardingCTAClick: onInviteTeamOnboardingCTAClick } = (0, $9QGIi.useShouldRenderInviteTeamPromptSpotlight)();
    (0, $5uXOq.useEffect)(()=>{
        project?.isSimplified ? setForgeSettingsParentStack([
            (0, $lNhbS.SECTION_ID).SETTINGS,
            'apps'
        ]) : setForgeSettingsParentStack([
            (0, $lNhbS.SECTION_ID).SETTINGS
        ]);
    }, [
        project?.isSimplified
    ]);
    const feedbackButtonRef = (0, $5uXOq.useRef)(null);
    const onSubmitFeedbackClick = (0, $5uXOq.useCallback)(()=>{
        const additionalFields = [
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            feedbackGroupId: 'jira-servicedesk-classic',
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackContext: additionalFields,
            additionalFields: additionalFields,
            triggerRef: feedbackButtonRef
        });
    }, [
        openFeedbackCollector,
        cloudId
    ]);
    const viewsFeature = (0, $hadw2.useViewsFeature)({
        features: features
    });
    if (features == null || project == null || projectConnectItems == null || isOgTenantInfoLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const urlPath = `/jira/servicedesk/projects/${project.key}`;
    const classicSettingsUrl = `/jira/servicedesk/projects/${project.key}/settings/details`;
    const BackMenuItem = {
        href: urlPath,
        onClick: (ev)=>ev.preventDefault(),
        title: formatMessage(project.isSimplified ? (0, $a88Sz.messages).backToServiceProject : (0, $a88Sz.messages).backToProject)
    };
    const knowledgeInsightsTitle = // Returns true if any Knowledge & Insights elements exist.
    (0, $3SzZi.shouldRenderNesting)(features.knowledge.enabled && !!features.knowledge.type, stack, (0, $lNhbS.SECTION_ID).KNOWLEDGE) || (0, $3SzZi.shouldRenderNesting)(features.hasReports, stack, (0, $lNhbS.SECTION_ID).REPORTS) ? formatMessage((0, $a88Sz.messages).knowledgeInsights) : undefined;
    const isServicesEnabled = Boolean(settingFeatures?.hasServices);
    const isJSMAlertOnCallEnabled = shouldUseJSM && !ogTenantInfoError;
    const isAlertsEnabled = features.opsgenieAlert.enabled && !!features.opsgenieAlert.url;
    const isOncallEnabled = features.opsgenieOnCall.enabled && !!features.opsgenieOnCall.url;
    const hasOperationsSectionItems = isServicesEnabled || isAlertsEnabled || isOncallEnabled;
    const isCustomerSupportManagementEnabled = Boolean(settingFeatures?.hasCustomerSupportManagement);
    const isDeveloperEscalationsEnabled = Boolean(settingFeatures?.hasDeveloperEscalation);
    const isProductsAndEntitlementsEnabled = Boolean(settingFeatures?.hasProductsAndEntitlements);
    const hasNotificationLogs = (0, $4R6GH.fg)('jcs_master_flag') ? !!features.hasNotificationLogs : true;
    const SettingsMenuItem = (0, $3SzZi.shouldRenderNesting)(features.hasSettings, stack, (0, $lNhbS.SECTION_ID).SETTINGS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: (0, $lNhbS.SECTION_ID).SETTINGS,
        analytics: {
            itemId: 'settings'
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        href: project.isSimplified ? `${urlPath}/settings` : classicSettingsUrl,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
            spacing: "spacious",
            label: ""
        }),
        overrides: {
            BackMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(BackMenuItem, [
                'onClick'
            ])
        },
        "data-testId": "navigation-apps-sidebar-servicedesk.ui.menu.project-settings",
        title: formatMessage(project.isSimplified ? (0, $a88Sz.messages).serviceProjectSettings : (0, $a88Sz.messages).projectSettingsRetranslate)
    }, project.isSimplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $812cH.SettingsNextgen), {
        stack: stack
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80BbW.SettingsClassic), {
        ecosystemItems: ecosystemItems,
        projectId: project.id,
        projectKey: project.key,
        stack: stack
    }));
    const HelpCenterSettingsMenuItem = features?.hasHelpCenterSettings && (0, $4R6GH.fg)('jcs_master_flag') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'helpCenterSettings'
        },
        href: `/jira/helpcenter/projects/${project.key}/settings`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $a88Sz.messages).customerHubSettings : (0, $a88Sz.messages).serviceHubSettings));
    const NotificationLogsMenuItem = hasNotificationLogs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'notificationLogs'
        },
        href: `${urlPath}/notification-logs`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aVnO1))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'notification-logs'
        ]
    }, formatMessage((0, $a88Sz.messages).notificationLogs));
    const FeedbackMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'feedback'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: onSubmitFeedbackClick,
        ref: feedbackButtonRef
    }, formatMessage((0, $a88Sz.messages).feedback));
    const ShortcutsMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3QTQ5.Shortcuts), {
        canAddItem: features.hasShortcutsAdd,
        canAddLinks: true,
        canAddRepositories: false,
        isSimplifiedProject: project.isSimplified,
        projectKey: project.key,
        projectId: project.id
    });
    const KnowledgeMenuItem = (0, $3SzZi.shouldRenderNesting)(features.knowledge.enabled && !!features.knowledge.type, stack, (0, $lNhbS.SECTION_ID).KNOWLEDGE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wBTQ.KnowledgeItem), {
        href: `${urlPath}/knowledge`,
        nestingId: (0, $lNhbS.SECTION_ID).KNOWLEDGE,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        stack: stack,
        type: features.knowledge.type
    });
    const ReportsMenuItem = (0, $3SzZi.shouldRenderNesting)(features.hasReports, stack, (0, $lNhbS.SECTION_ID).REPORTS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'reports'
        },
        href: `${urlPath}/reports`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d1ABl))), {
            spacing: "spacious",
            label: ""
        }),
        id: (0, $lNhbS.SECTION_ID).REPORTS,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $a88Sz.messages).itemReports)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dYOHi.Reports), {
        projectKey: project.key,
        connectItems: connectReportsItems
    }));
    const CustomerChannelsMenuItem = features.hasCustomerChannels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e1CQH.CustomerChannelsItem), null, formatMessage((0, $a88Sz.messages).itemCustomerChannels));
    const jsmProjectSummary = ((0, $4R6GH.fg)('jsm-project-summary-beta') ? features.hasProjectSummary : (0, $4R6GH.fg)('jsm-project-summary')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'project-summary'
        },
        href: `${urlPath}/summary`,
        iconBefore: (0, $4R6GH.fg)('jsm_project_summary_milestone_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9x5pH))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50Bjx))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-project-summary'
        ]
    }, formatMessage((0, $a88Sz.messages).itemProjectSummary));
    const JsmViewsOnboarding = (0, $4R6GH.fg)('jsm_views_of_work_phase_1_onboarding') ? (0, $37cK0.ViewsNavItemOnboarding) : (0, $5uXOq.Fragment);
    const jsmViews = viewsFeature.isEnabled && (0, $4R6GH.fg)('jsm_views_of_work_phase_1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JsmViewsOnboarding, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'views'
        },
        href: viewsFeature.url,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ5rg))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-boards',
            'servicedesk-calendar'
        ]
    }, formatMessage((0, $a88Sz.messages).itemViews)));
    const jsmKanbanBoard = features.jsmBoard?.enabled && !(0, $4R6GH.fg)('jsm_views_of_work_phase_1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $980f7c356a507e07$export$a0a21d9967c1ebe1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'boards'
        },
        href: features.jsmBoard.url,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-boards'
        ]
    }, formatMessage((0, $a88Sz.messages).itemBoards))));
    const jsmCalendar = features.jsmCalendar?.enabled && !(0, $4R6GH.fg)('jsm_views_of_work_phase_1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'calendar'
        },
        href: features.jsmCalendar.url,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-calendar'
        ]
    }, formatMessage((0, $a88Sz.messages).itemCalendars));
    const GettingStartedPageMenuItem = !isLoading && isGettingStatedPageEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'getting-started-page'
        },
        href: `${urlPath}/getting-started`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxCqX))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-getting-started-page'
        ]
    }, formatMessage((0, $a88Sz.messages).gettingStarted));
    const developerEscalations = isDeveloperEscalationsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'developerEscalations'
        },
        href: `${urlPath}/escalations`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2ciBJ))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-customer-service-escalations'
        ]
    }, formatMessage((0, $a88Sz.messages).itemDeveloperEscalations));
    const products = isProductsAndEntitlementsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'products'
        },
        href: `${urlPath}/products`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bB6uF))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-customer-service-products'
        ]
    }, formatMessage((0, $a88Sz.messages).itemProducts));
    const CustomersMenuItem = features.hasCustomers && !isCustomerSupportManagementEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'customers'
        },
        href: `${urlPath}/customers`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: [
            'servicedesk-customers-v2'
        ]
    }, formatMessage((0, $a88Sz.messages).itemCustomers));
    const footer = (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4PB4I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EZB0.Footer), {
            isSimplified: project.isSimplified
        })))();
    const inviteTeamItem = features.hasSettings && (0, $6s1PB.expValEquals)('jsm_core_invites_experiment', 'cohort', 'experiment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rtJs.InviteTeamItemNew), null, formatMessage((0, $a88Sz.messages).itemAddPeople)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccoXC.InviteTeamItem), {
        loadEntryPointResource: loadInviteTeamResource
    }, formatMessage((0, $a88Sz.messages).itemInviteAgents));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $lNhbS.MENU_ID_SD),
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j9iVo.ConnectAppsContainer), {
        onError: undefined,
        scope: project.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZEU1.default), {
        label: "",
        isServer: false,
        isSSRPlaceholderEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && route?.name === 'servicedesk-issues' || route.name === 'issue' && (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nav_for_iv')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2EiV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l468O.ProjectHeader), {
        description: formatMessage((0, $a88Sz.messages).headerDescriptionJsm),
        avatarUrl: project.avatarUrl,
        name: project.name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $crQHm.SectionWithHeader), {
        title: formatMessage((0, $a88Sz.messages).sideBarNavigationTitle),
        headingLevel: 2,
        screenReaderTextHeading: true
    }, GettingStartedPageMenuItem, jsmProjectSummary, (0, $3SzZi.shouldRenderNesting)(features.hasQueues, stack, (0, $lNhbS.SECTION_ID).QUEUES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'queues'
        },
        href: `${urlPath}/queues`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B8sk))), {
            spacing: "spacious",
            label: ""
        }),
        id: (0, $lNhbS.SECTION_ID).QUEUES,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $a88Sz.messages).itemQueuesRetranslate),
        onClick: (ev)=>ev.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTR6h.PracticeQueues), {
        title: formatMessage((0, $a88Sz.messages).itemQueuesRetranslate)
    })), jsmViews, jsmKanbanBoard, jsmCalendar, developerEscalations, features.raiseRequest.enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'raise-request'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc7bc))), {
            spacing: "spacious",
            label: ""
        }),
        href: features.raiseRequest.url,
        target: "_blank"
    }, formatMessage((0, $a88Sz.messages).itemRaiseRequest)), hasOperationsSectionItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $a88Sz.messages).operations)
    }, isServicesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'services'
        },
        href: `${urlPath}/services`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $2avq0.ServicesGlyph),
            label: ""
        }),
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $a88Sz.messages).services)), isAlertsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'opsgenie-alert'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $dMRcK.AlertsGlyph),
            label: ""
        }),
        href: "/jira/ops/alerts?view=list&query=",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            spacing: "spacious",
            label: ""
        }),
        target: "_blank",
        ...!isJSMAlertOnCallEnabled && {
            href: features.opsgenieAlert.url
        },
        className: (0, $bwpsq.default)([
            $5e36b02795dbb5e5$var$styles.menuItem
        ])
    }, formatMessage((0, $a88Sz.messages).alerts), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, formatMessage((0, $a88Sz.messages).linkOpensInNewWindow))), isOncallEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'opsgenie-on-call'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $aQY3O.OnCallGlyph),
            label: ""
        }),
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            spacing: "spacious",
            label: ""
        }),
        target: "_blank",
        href: "/jira/ops/who-is-on-call",
        ...!isJSMAlertOnCallEnabled && {
            href: `${urlPath}/on-call-schedule`,
            iconAfter: undefined,
            target: undefined
        },
        className: (0, $bwpsq.default)([
            $5e36b02795dbb5e5$var$styles.menuItem
        ])
    }, formatMessage((0, $a88Sz.messages).onCall))), (0, $3SzZi.shouldRenderNesting)(features.hasPIN, stack, (0, $lNhbS.SECTION_ID).ISSUES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.IssuesContextualAnalyticsData), {
        navigatorScope: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'project-issue-navigator'
        },
        href: `/jira/servicedesk/projects/${project.key}/issues`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJosW))), {
            spacing: "spacious",
            label: ""
        }),
        id: (0, $lNhbS.SECTION_ID).ISSUES,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        title: formatMessage((0, $a88Sz.messages).itemIssues)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsI7v.Issues), {
        projectKey: project.key,
        pinUrl: `/jira/servicedesk/projects/${project.key}/issues/?filter=`
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zgGo.ForgeProjectSection), {
        overrides: {
            BackMenuItem: BackMenuItem
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tHFY.ConnectMenu), {
        items: projectConnectItems,
        showIcons: true,
        overrides: {
            BackMenuItem: BackMenuItem
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $crQHm.SectionWithHeader), {
        title: knowledgeInsightsTitle,
        headingLevel: 3
    }, KnowledgeMenuItem, ReportsMenuItem), projectContext?.isProjectArchived === true ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $crQHm.SectionWithHeader), {
        title: formatMessage((0, $a88Sz.messages).directory),
        headingLevel: 3
    }, (0, $4R6GH.fg)('jsm_customers_directory_page_for_all') ? features.hasCustomers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4eEnx.CustomerSupportManagementItems), {
        urlPath: urlPath,
        isPremiumTenant: isPremiumTenant
    }) : isCustomerSupportManagementEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4eEnx.CustomerSupportManagementItems), {
        urlPath: urlPath,
        isPremiumTenant: isPremiumTenant
    }), products, CustomerChannelsMenuItem, stack.length === 0 && isInviteTeamSpotlightEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: (0, $980f7c356a507e07$export$460011addfd3fbe1)
    }, inviteTeamItem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dtVRS.InviteUserPrompt), {
        onCTAClick: onInviteTeamOnboardingCTAClick
    })) : inviteTeamItem, !(0, $4R6GH.fg)('jsm_customers_directory_page_for_all') && CustomersMenuItem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $crQHm.SectionWithHeader), {
        title: formatMessage((0, $a88Sz.messages).shortcuts),
        headingLevel: 3
    }, ShortcutsMenuItem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, HelpCenterSettingsMenuItem, SettingsMenuItem, NotificationLogsMenuItem, !project.isSimplified && FeedbackMenuItem), ((0, $4R6GH.fg)('archived_issues_in_nav4_sidebar') ? features?.hasArchivedIssues === true : true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'archives'
        },
        href: `/jira/servicedesk/projects/${project.key}/issues/archive`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7aY9g))), {
            spacing: "spacious",
            label: ""
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: "new"
        }, formatMessage((0, $a88Sz.messages).newLozenge)),
        selectedOn: [
            'archived-issues-directory'
        ],
        testId: "navigation-apps-sidebar-servicedesk.ui.menu.archives-link"
    }, formatMessage((0, $a88Sz.messages).itemArchives))))), footer)));
};

});
parcelRegister("fc7bc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8829fbe18d9ef0b7a6c5c1521961961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0fd8bbb021d7458$var$_react = $b0fd8bbb021d7458$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b0fd8bbb021d7458$var$_plusSquare = $b0fd8bbb021d7458$var$_interopRequireDefault((parcelRequire("9ZmJp")));

var $b0fd8bbb021d7458$var$_issueRaise = $b0fd8bbb021d7458$var$_interopRequireDefault((parcelRequire("xTErF")));
function $b0fd8bbb021d7458$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PlusSquareIcon.
 * This component is PlusSquareIcon, with `UNSAFE_fallbackIcon` set to "IssueRaiseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: 'New feature' Jira issue status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0fd8bbb021d7458$var$PlusSquareIcon = (props)=>/*#__PURE__*/ $b0fd8bbb021d7458$var$_react.default.createElement($b0fd8bbb021d7458$var$_plusSquare.default, Object.assign({
        LEGACY_fallbackIcon: $b0fd8bbb021d7458$var$_issueRaise.default
    }, props));
$b0fd8bbb021d7458$var$PlusSquareIcon.Name = 'PlusSquareIconMigration';
var $b0fd8bbb021d7458$var$_default = module.exports.default = $b0fd8bbb021d7458$var$PlusSquareIcon;

});
parcelRegister("9ZmJp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fafc1f0f653bb65291af28a11fe92957>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $745b7185accee483$var$_react = $745b7185accee483$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $745b7185accee483$var$_baseNew = $745b7185accee483$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $745b7185accee483$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlusSquare".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: 'New feature' Jira issue status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $745b7185accee483$var$PlusSquareIcon = (props)=>/*#__PURE__*/ $745b7185accee483$var$_react.default.createElement($745b7185accee483$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm4.25 6.25V12h1.5V8.75H12v-1.5H8.75V4h-1.5v3.25H4v1.5z" clip-rule="evenodd"/>`
    }, props));
$745b7185accee483$var$PlusSquareIcon.displayName = 'PlusSquareIcon';
var $745b7185accee483$var$_default = module.exports.default = $745b7185accee483$var$PlusSquareIcon;

});

parcelRegister("xTErF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $065e40612cdf7822$var$_react = $065e40612cdf7822$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $065e40612cdf7822$var$_plusSquare = $065e40612cdf7822$var$_interopRequireDefault((parcelRequire("9ZmJp")));
function $065e40612cdf7822$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $065e40612cdf7822$var$IssueRaiseIcon = (props)=>/*#__PURE__*/ $065e40612cdf7822$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="11" y="9" rx="1"/><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><rect width="6" height="2" x="9" y="11" rx="1"/></g></svg>`
    }, props, {
        newIcon: $065e40612cdf7822$var$_plusSquare.default
    }));
$065e40612cdf7822$var$IssueRaiseIcon.displayName = 'IssueRaiseIcon';
var $065e40612cdf7822$var$_default = module.exports.default = $065e40612cdf7822$var$IssueRaiseIcon;

});


parcelRegister("4PB4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $1889ca1dd837c218$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $1889ca1dd837c218$var$styles = {
    navigationFooter: "_kqswh2mm"
};
/**
 * __Navigation footer__
 *
 * Allows for customisation of the footer.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $1889ca1dd837c218$var$NavigationFooter = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        padding: "space.100",
        paddingBlockEnd: "space.200",
        xcss: $1889ca1dd837c218$var$styles.navigationFooter,
        children: children
    });
};
var $1889ca1dd837c218$export$2e2bcd8739ae039 = $1889ca1dd837c218$var$NavigationFooter;

});

parcelRegister("crQHm", function(module, exports) {

$parcel$export(module.exports, "SectionWithHeader", () => $ddc0068d6f66fc4e$export$215625322bdbb2eb);

var $5uXOq = parcelRequire("5uXOq");

var $c2V4l = parcelRequire("c2V4l");
var $gjTBi = parcelRequire("gjTBi");

var $dqoiX = parcelRequire("dqoiX");
const $ddc0068d6f66fc4e$export$215625322bdbb2eb = ({ title: title, headingLevel: headingLevel, headingItemProps: headingItemProps, sectionProps: sectionProps, children: children, screenReaderTextHeading: screenReaderTextHeading })=>{
    const commonHeadingItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2V4l.default), {
        headingLevel: headingLevel,
        ...headingItemProps
    }, title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), sectionProps, title && (screenReaderTextHeading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, commonHeadingItem) : commonHeadingItem), children);
};

});

parcelRegister("j9iVo", function(module, exports) {

$parcel$export(module.exports, "ConnectAppsSubscriber", () => $1d2a37fb0b2cedf7$export$2646f920b0e2e4de);
$parcel$export(module.exports, "useConnectApps", () => $1d2a37fb0b2cedf7$export$4864478dcab77643);
$parcel$export(module.exports, "ConnectAppsContainer", () => $1d2a37fb0b2cedf7$export$ac845603c8c91acd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $7YSUx = parcelRequire("7YSUx");

const $1d2a37fb0b2cedf7$export$2646f920b0e2e4de = (0, $51nlc.createSubscriber)((0, $7YSUx.default), {
    displayName: 'ConnectAppsSubscriber'
});
const $1d2a37fb0b2cedf7$export$4864478dcab77643 = (0, $3sQ5x.createHook)((0, $7YSUx.default));
const $1d2a37fb0b2cedf7$export$ac845603c8c91acd = (0, $gg7kZ.createContainer)((0, $7YSUx.default));

});
parcelRegister("7YSUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bdb3f5fb2a260df$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $76t3Y = parcelRequire("76t3Y");
const $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a = {
    data: null,
    loading: false,
    error: null,
    hasFirstError: false
};
var $3bdb3f5fb2a260df$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'connect-apps',
    initialState: $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a,
    actions: $76t3Y.actions
});

});
parcelRegister("76t3Y", function(module, exports) {

$parcel$export(module.exports, "actions", () => $183a508abf4e51e7$export$e324594224ef24da);

var $8VvCU = parcelRequire("8VvCU");
const $183a508abf4e51e7$export$e324594224ef24da = {
    fetch: $8VvCU.default
};

});
parcelRegister("8VvCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b005bb27151e101$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $2FYaA = parcelRequire("2FYaA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3b005bb27151e101$export$2e2bcd8739ae039 = (projectKey)=>async ({ setState: setState, getState: getState }, { onError: onError })=>{
        const currentState = getState();
        if (!projectKey || currentState.loading) return;
        setState({
            loading: true,
            error: null
        });
        try {
            const data = await (0, $2FYaA.default)(projectKey);
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { hasFirstError: hasFirstError, data: data } = getState();
            // It's the first error if it does not already have a first error and there is no data currently in state
            const isFirstError = !hasFirstError && data === null;
            setState({
                error: err,
                loading: false,
                hasFirstError: hasFirstError || isFirstError
            });
            if (onError) onError(isFirstError);
        }
    };

});
parcelRegister("2FYaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $27cd0e7e45645bce$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $lVlV8 = parcelRequire("lVlV8");
const $27cd0e7e45645bce$export$43bc37ac3360968f = (projectKey)=>`/rest/internal/2/connectprojectconfig/${projectKey}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$27cd0e7e45645bce$export$2e2bcd8739ae039 = (projectKey)=>{
    const fetchPromise = (0, $koFzm.famaCatchAndLogFetchError)((0, $7f4tk.default)($27cd0e7e45645bce$export$43bc37ac3360968f(projectKey)), (0, $lVlV8.PACKAGE_NAME), (0, $gl0PU.toErrorId)('getConnectApps'), (0, $gl0PU.toErrorMessage)('Failed to fetch connect apps for a project'));
    return fetchPromise.then((response)=>response.map((app)=>{
            // Server returns JSON as a string inside JSON as a string inside JSON as a string because reasons.
            // Let's parse it here
            const options = JSON.parse(app.iframe.options);
            const myApp = {
                title: app.title,
                id: options.uniqueKey,
                connectIframeProps: {
                    addon_key: app.iframe.addonKey,
                    key: app.iframe.moduleKey,
                    url: options.url,
                    options: {
                        ...options,
                        productContext: JSON.parse(options.productCtx),
                        structuredContext: JSON.parse(options.structuredContext),
                        user: {
                            uid: options.uid,
                            ukey: options.ukey,
                            timeZone: options.timeZone
                        }
                    }
                }
            };
            return myApp;
        }));
};

});
parcelRegister("koFzm", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $eb8b95f475174133$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $eb8b95f475174133$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $1RLjE = parcelRequire("1RLjE");
const $eb8b95f475174133$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $eb8b95f475174133$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $jJZqs.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $jJZqs.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $eb8b95f475174133$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData($eb8b95f475174133$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $eb8b95f475174133$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $eb8b95f475174133$var$getStatusCodeGroup(error);
        (0, $1RLjE.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $eb8b95f475174133$export$2e2bcd8739ae039 = $eb8b95f475174133$var$catchAndLogFetchError;

});

parcelRegister("lVlV8", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $418c76e16c63cf92$export$d76071d5de2774fc);
$parcel$export(module.exports, "PACKAGE_NAME", () => $418c76e16c63cf92$export$b8b9d90f9e5bd72b);

var $3XO6n = parcelRequire("3XO6n");
const $418c76e16c63cf92$export$d76071d5de2774fc = 'project-settings/connect-apps';
const $418c76e16c63cf92$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectSettingsAppsConnectApps');

});






parcelRegister("812cH", function(module, exports) {

$parcel$export(module.exports, "SettingsNextgen", () => $d693134a67731a99$export$945536a75ac9c0fb);

var $5uXOq = parcelRequire("5uXOq");

var $5on2Q = parcelRequire("5on2Q");

var $gjTBi = parcelRequire("gjTBi");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ldyPw = parcelRequire("ldyPw");

var $xc3fY = parcelRequire("xc3fY");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $1F3us = parcelRequire("1F3us");

var $lpwtK = parcelRequire("lpwtK");

var $kZj7F = parcelRequire("kZj7F");

var $lGo7j = parcelRequire("lGo7j");

var $3SzZi = parcelRequire("3SzZi");

var $6hMYg = parcelRequire("6hMYg");

var $6jY6G = parcelRequire("6jY6G");

var $k9JTq = parcelRequire("k9JTq");

var $2NMNM = parcelRequire("2NMNM");

var $02Psx = parcelRequire("02Psx");

var $j9iVo = parcelRequire("j9iVo");

var $fkAkD = parcelRequire("fkAkD");

var $eSH1I = parcelRequire("eSH1I");

var $20mDG = parcelRequire("20mDG");

var $iaiNb = parcelRequire("iaiNb");

var $6EZeH = parcelRequire("6EZeH");

var $9OXo1 = parcelRequire("9OXo1");

var $4OCke = parcelRequire("4OCke");

var $e1N3q = parcelRequire("e1N3q");

var $y8WG5 = parcelRequire("y8WG5");

var $lNhbS = parcelRequire("lNhbS");

var $oEVO5 = parcelRequire("oEVO5");

var $hHWvI = parcelRequire("hHWvI");

var $hOzYR = parcelRequire("hOzYR");

var $68cWF = parcelRequire("68cWF");

var $haRgi = parcelRequire("haRgi");

var $hRqBV = parcelRequire("hRqBV");

var $98hQ0 = parcelRequire("98hQ0");

var $l5jSb = parcelRequire("l5jSb");

var $8uoEG = parcelRequire("8uoEG");

var $dHXIb = parcelRequire("dHXIb");

var $dVJa0 = parcelRequire("dVJa0");

var $j6F3H = parcelRequire("j6F3H");
const $d693134a67731a99$var$hasJiraAutomationConnectApp = (connectAppsData)=>{
    if ((0, $4R6GH.fg)('wolf-86_exclude_legacy_automation_navigation_fedm')) return (connectAppsData || []).some(({ connectIframeProps: connectIframeProps })=>connectIframeProps ? connectIframeProps.addon_key === (0, $oEVO5.JIRA_AUTOMATION_ADDON_KEY) || connectIframeProps.addon_key === (0, $oEVO5.JIRA_FEDRAMP_MODERATE_AUTOMATION_ADDON_KEY) : false);
    return (connectAppsData || []).some(({ connectIframeProps: connectIframeProps })=>connectIframeProps ? connectIframeProps.addon_key === (0, $oEVO5.JIRA_AUTOMATION_ADDON_KEY) : false);
};
const $d693134a67731a99$export$f4bd54079e635a9d = ({ stack: stack })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const appEditions = (0, $k9JTq.useAppEditions)();
    const hasDlpEnabled = (0, $6EZeH.useDlpEntitlement)();
    const [{ data: translations }, { fetchTranslationSummaries: fetchTranslationSummaries }] = (0, $eSH1I.useTranslationSummaries)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ data: connectAppsData }, { fetch: fetchConnectApps }] = (0, $j9iVo.useConnectApps)();
    const { userRole: userRole } = (0, $1F3us.useServiceDeskContextResource)().data || {};
    const { data: forgeSettingsItems } = (0, $6hMYg.useProjectSettingsForgeAppsForMenu)();
    const { data: features } = (0, $y8WG5.useTMPSettingFeatures)();
    const calculateAccessActive = ({ path: path })=>/jira\/servicedesk\/projects\/.+\/settings\/customer-permissions/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/access/.test(path);
    const [accessActive] = (0, $5uXOq.useState)(calculateAccessActive(route));
    const calculateRequestManagementActive = ({ path: path })=>/jira\/servicedesk\/projects\/.+\/settings\/forms/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/sla/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/feedback-settings/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/issuetypes\/.+/.test(path);
    const [requestManagementActive] = (0, $5uXOq.useState)(calculateRequestManagementActive(route));
    const calculateChannelsActive = ({ path: path })=>/jira\/servicedesk\/projects\/.+\/settings\/channels\/portal-settings/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/email/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/widget/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/chat/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/confluence-kb/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/virtual-agent/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/external-links/.test(path);
    const [channelsActive] = (0, $5uXOq.useState)(calculateChannelsActive(route));
    const calculateNotificationsActive = ({ path: path })=>/jira\/servicedesk\/projects\/.+\/settings\/customer-notifications/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/internal-notifications/.test(path) || /jira\/servicedesk\/projects\/.+\/settings\/notification-email/.test(path);
    const [notificationsActive] = (0, $5uXOq.useState)(calculateNotificationsActive(route));
    const calculateIntegrationsActive = ({ path: path })=>/jira\/servicedesk\/projects\/.+\/settings\/apps\/.+/.test(path);
    const [integrationsActive] = (0, $5uXOq.useState)(calculateIntegrationsActive(route));
    (0, $5uXOq.useEffect)(()=>{
        if (project && userRole === (0, $20mDG.USER_JSM_PROJECT_ROLE).AGENT_PROJECT_ADMIN_ROLE) fetchTranslationSummaries(project.id, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        fetchTranslationSummaries,
        project,
        userRole
    ]);
    // to remove on isAppControlsEnabled() cleanup
    (0, $5uXOq.useEffect)(()=>{
        if (project && !connectAppsData) fetchConnectApps(project.key);
    }, [
        connectAppsData,
        fetchConnectApps,
        project
    ]);
    // This flag is for the case that when JSD is suspended/deactivated, only Details should be shown.
    const { hasServiceDeskAccess: hasJSD } = appPermissions;
    const hasPremiumServiceDeskLicense = appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION);
    const serviceDeskConnectApps = (0, $hHWvI.filterServiceDeskConnectApps)(connectAppsData);
    const ecosystemApps = (0, $5uXOq.useMemo)(()=>({
            forge: forgeSettingsItems,
            connect: serviceDeskConnectApps
        }), [
        serviceDeskConnectApps,
        forgeSettingsItems
    ]);
    if (project == null || features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), null);
    const { key: projectKey } = project;
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), project.key);
    const BackMenuItem = {
        href: baseSettingsUrl,
        title: formatMessage((0, $dHXIb.default).goToSettings)
    };
    const productFeatures = (0, $fkAkD.getServiceDeskFeatures)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaiNb.IssueTypesNavigationItemsFetcher), {
        projectId: project.id,
        productFeatures: productFeatures
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $dHXIb.default).projectSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: [
            'project-settings-servicedesk-details'
        ],
        href: `${baseSettingsUrl}/details`,
        "data-testId": "navigation-apps-sidebar-servicedesk-common.ui.menu.settings-nextgen.details"
    }, formatMessage((0, $dHXIb.default).details)), hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'itsm-features'
        },
        selectedOn: [
            'project-settings-servicedesk-itsm-features'
        ],
        href: `${baseSettingsUrl}/itsm-features`,
        shifter: {
            groupTitle: formatMessage((0, $dHXIb.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        }
    }, formatMessage((0, $dHXIb.default).itsmFeatures)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'access-group'
        },
        menuItemLabel: formatMessage((0, $dHXIb.default).accessGroup),
        forceExpand: accessActive,
        submenuId: "access-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hRqBV.AccessMenu), {
        projectKey: projectKey,
        features: features
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'requests-group'
        },
        menuItemLabel: formatMessage((0, $dHXIb.default).requestsManagementGroup),
        forceExpand: requestManagementActive,
        submenuId: "requests-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6F3H.RequestsManagementMenu), {
        projectKey: projectKey
    })), hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'channels-group'
        },
        menuItemLabel: formatMessage((0, $dHXIb.default).channelsGroup),
        forceExpand: channelsActive,
        submenuId: "channels-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98hQ0.Channels), {
        projectKey: projectKey,
        features: features
    })), hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'notifications-group'
        },
        menuItemLabel: formatMessage((0, $dHXIb.default).notificationsGroup),
        forceExpand: notificationsActive,
        submenuId: "notifications-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVJa0.Notifications), {
        projectKey: projectKey
    })), (0, $3SzZi.shouldRenderNesting)(hasJSD, stack, 'languageSupport') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'language-support'
        },
        href: `${baseSettingsUrl}/language`,
        iconAfter: translations.isLanguageSupportHighlighted ? // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5on2Q))), {
            primaryColor: "var(--ds-icon-warning, #E56910)",
            label: ""
        }) : null,
        id: "languageSupport",
        overrides: {
            BackMenuItem: BackMenuItem
        },
        shifter: {
            groupTitle: formatMessage((0, $dHXIb.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        },
        title: formatMessage((0, $dHXIb.default).languageSupport)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uoEG.Language), null)), hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $68cWF.Automation), {
        overrides: {
            BackMenuItem: BackMenuItem
        },
        shifter: {
            groupTitle: formatMessage((0, $dHXIb.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        },
        projectKey: projectKey,
        isSimplified: true,
        hasJiraAutomation: $d693134a67731a99$var$hasJiraAutomationConnectApp(connectAppsData)
    }), hasPremiumServiceDeskLicense && (0, $4R6GH.fg)('playbooks-in-jsm') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).PLAYBOOKS
        },
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        href: `${baseSettingsUrl}/playbooks`,
        shifter: {
            groupTitle: formatMessage((0, $dHXIb.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        }
    }, formatMessage((0, $dHXIb.default).playbooks))), (0, $4R6GH.fg)('jsm-journey-builder') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e1N3q.JourneyNavItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: (0, $lNhbS.SETTINGS_IDS).JOURNEYS
        },
        href: `${baseSettingsUrl}/journeys`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, formatMessage((0, $dHXIb.default).journeysNonFinal))), hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'integrations-group'
        },
        menuItemLabel: formatMessage((0, $dHXIb.default).integrationsGroup),
        forceExpand: integrationsActive,
        submenuId: "integrations-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5jSb.EcosystemAppsMenu), {
        apps: ecosystemApps
    })), route && !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOzYR.AsyncAutomationChangeboarding), {
        isLegacyAutomation: route.name.includes('project-settings-servicedesk-automation')
    }), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'data-classifications'
        },
        selectedOn: [
            'project-settings-servicedesk-data-classifications'
        ],
        href: `${baseSettingsUrl}/data-classifications`
    }, formatMessage((0, $dHXIb.default).dataClassificationsNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haRgi.default), null));
};
const $d693134a67731a99$export$945536a75ac9c0fb = ({ stack: stack })=>{
    const { data: project } = (0, $lpwtK.useProject)();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d693134a67731a99$export$f4bd54079e635a9d, {
        stack: stack
    });
};

});
parcelRegister("fkAkD", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskFeatures", () => $5da8358b54cce8ab$export$11569a8b7fd625e5);

var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $in90R = parcelRequire("in90R");

var $5fc53 = parcelRequire("5fc53");

var $3XO6n = parcelRequire("3XO6n");

var $02Psx = parcelRequire("02Psx");

var $6wesA = parcelRequire("6wesA");

var $ghCiF = parcelRequire("ghCiF");

var $2teXs = parcelRequire("2teXs");

var $7E1yI = parcelRequire("7E1yI");

var $5Aioa = parcelRequire("5Aioa");

var $2Ic5U = parcelRequire("2Ic5U");

var $hPw0Z = parcelRequire("hPw0Z");

var $gIb2d = parcelRequire("gIb2d");

var $jFgQY = parcelRequire("jFgQY");

var $6ozDP = parcelRequire("6ozDP");

var $719NN = parcelRequire("719NN");

var $2tk6O = parcelRequire("2tk6O");

var $kEraB = parcelRequire("kEraB");

var $ayl8e = parcelRequire("ayl8e");

var $kp2EN = parcelRequire("kp2EN");

var $fbE1k = parcelRequire("fbE1k");

var $3p4Fj = parcelRequire("3p4Fj");

var $iaUQo = parcelRequire("iaUQo");

var $8k5eK = parcelRequire("8k5eK");

var $cgGpC = parcelRequire("cgGpC");

var $9LMsC = parcelRequire("9LMsC");

var $dXdGS = parcelRequire("dXdGS");

var $fCJv5 = parcelRequire("fCJv5");

var $cgvPO = parcelRequire("cgvPO");

var $2IXkL = parcelRequire("2IXkL");

var $hQIjR = parcelRequire("hQIjR");

var $4R6GH = parcelRequire("4R6GH");

var $ghck8 = parcelRequire("ghck8");

var $7Ertg = parcelRequire("7Ertg");

var $b3HO0 = parcelRequire("b3HO0");

var $EcXxh = parcelRequire("EcXxh");

var $l0vRU = parcelRequire("l0vRU");

var $hwF9S = parcelRequire("hwF9S");

var $fyLyr = parcelRequire("fyLyr");

var $bDbDt = parcelRequire("bDbDt");

var $if5xq = parcelRequire("if5xq");

var $gurvk = parcelRequire("gurvk");
const $5da8358b54cce8ab$var$fieldsDocumentationUrl = 'https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Customize+an+issue%27s+fields+in+next-gen+projects';
const $5da8358b54cce8ab$var$fieldsDocumentationInProductHelpArticleId = '5xtQIjEWw12ExbUuX2Wk7h';
const $5da8358b54cce8ab$var$portalDocumentationInProductHelpArticleId = '4S9HZghmTHRR7tUGV44eiV';
const $5da8358b54cce8ab$var$getServiceDeskRequestCategory = ()=>({
        name: (0, $7Ertg.getRequestFieldCategoryId)(),
        displayName: (0, $b3HO0.fieldCategories).alwaysShowTitleRequestForm,
        emptyStateText: (0, $b3HO0.fieldCategories).primaryEmptyMessage,
        categoryEmptyState: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Aioa.default), {
                emptyStateText: (0, $b3HO0.fieldCategories).primaryEmptyMessage,
                ...props
            }),
        whatIsThis: {
            buttonLabel: (0, $b3HO0.fieldCategories).whatIsThis,
            content: (0, $b3HO0.fieldCategories).whatArePrimaryFieldsForInProductHelp,
            linkToDocumentationText: (0, $b3HO0.fieldCategories).linkToInProductHelpTextPortal,
            linkToInProductHelpArticleId: $5da8358b54cce8ab$var$portalDocumentationInProductHelpArticleId
        },
        allowRequiredField: true,
        allowFieldAliasEditing: true,
        allowFieldAlias: true,
        allowedLayoutItems: []
    });
const $5da8358b54cce8ab$var$getServiceDeskEmailRequestCategory = ()=>({
        name: (0, $7Ertg.getRequestFieldCategoryId)(),
        displayName: (0, $b3HO0.fieldCategories).emailFieldsTitle,
        emptyStateText: (0, $b3HO0.fieldCategories).primaryEmptyMessage,
        whatIsThis: {
            buttonLabel: (0, $b3HO0.fieldCategories).whatIsThis,
            content: (0, $b3HO0.fieldCategories).whatAreEmailFields,
            linkToDocumentationText: (0, $b3HO0.fieldCategories).linkToDocumentationText
        },
        allowRequiredField: false,
        allowFieldAlias: true,
        allowFieldAliasEditing: false,
        allowedLayoutItems: [
            (0, $2teXs.allowFieldLayoutItem)((0, $5fc53.SUMMARY_TYPE)),
            (0, $2teXs.allowFieldLayoutItem)((0, $3XO6n.DESCRIPTION_FIELD_TYPE)),
            (0, $2teXs.allowFieldLayoutItem)((0, $5fc53.ATTACHMENT_TYPE))
        ],
        // Since this field category is only used for the Email Request type it will only override properties in the
        // `summary`, `description` and `attachment` fields in Email Request Types
        overriddenFields: [
            {
                key: 'summary',
                required: true,
                category: (0, $7Ertg.getRequestFieldCategoryId)(),
                // @ts-expect-error - TS2739 - Type '{ canModifyRequired: false; categoriesWhitelist: string[]; editable: false; removable: false; canAssociateInSettings: true; }' is missing the following properties from type 'Readonly<Readonly<{ editable: boolean; removable: boolean; categoriesWhitelist: string[]; canAssociateInSettings: boolean; deletable: boolean; }> & { canModifyOptions: boolean; canModifyDefaultValue: boolean; canModifyPropertyConfiguration: boolean; canModifyRequired: boolean; }>': deletable, canModifyOptions, canModifyDefaultValue, canModifyPropertyConfiguration
                operations: {
                    canModifyRequired: false,
                    categoriesWhitelist: [
                        (0, $7Ertg.getRequestFieldCategoryId)()
                    ],
                    editable: false,
                    removable: false,
                    canAssociateInSettings: true
                },
                sortable: false
            },
            {
                key: 'description',
                required: false,
                category: (0, $7Ertg.getRequestFieldCategoryId)(),
                // @ts-expect-error - TS2739 - Type '{ canModifyRequired: false; categoriesWhitelist: string[]; editable: false; removable: false; canAssociateInSettings: true; }' is missing the following properties from type 'Readonly<Readonly<{ editable: boolean; removable: boolean; categoriesWhitelist: string[]; canAssociateInSettings: boolean; deletable: boolean; }> & { canModifyOptions: boolean; canModifyDefaultValue: boolean; canModifyPropertyConfiguration: boolean; canModifyRequired: boolean; }>': deletable, canModifyOptions, canModifyDefaultValue, canModifyPropertyConfiguration
                operations: {
                    canModifyRequired: false,
                    categoriesWhitelist: [
                        (0, $7Ertg.getRequestFieldCategoryId)()
                    ],
                    editable: false,
                    removable: false,
                    canAssociateInSettings: true
                },
                sortable: false
            },
            {
                key: 'attachment',
                required: false,
                category: (0, $7Ertg.getRequestFieldCategoryId)(),
                // @ts-expect-error - TS2739 - Type '{ canModifyRequired: false; categoriesWhitelist: string[]; editable: false; removable: false; canAssociateInSettings: true; }' is missing the following properties from type 'Readonly<Readonly<{ editable: boolean; removable: boolean; categoriesWhitelist: string[]; canAssociateInSettings: boolean; deletable: boolean; }> & { canModifyOptions: boolean; canModifyDefaultValue: boolean; canModifyPropertyConfiguration: boolean; canModifyRequired: boolean; }>': deletable, canModifyOptions, canModifyDefaultValue, canModifyPropertyConfiguration
                operations: {
                    canModifyRequired: false,
                    categoriesWhitelist: [
                        (0, $7Ertg.getRequestFieldCategoryId)()
                    ],
                    editable: false,
                    removable: false,
                    canAssociateInSettings: true
                },
                sortable: false
            }
        ]
    });
// This category gives support to multi line fields in JSD
// They are visible in bento but are not in the sidebar or visible to help seekers so they require a new category
// https://hello.atlassian.net/wiki/spaces/VPORT/pages/582718933/JSD+SWIFT+spec+-+Multi-line+field+and+Buckets
const $5da8358b54cce8ab$var$getServiceDeskMultiLineCategory = ()=>({
        name: (0, $in90R.toFieldCategory)('content'),
        displayName: (0, $b3HO0.fieldCategories).descriptionTitle,
        emptyStateText: (0, $b3HO0.fieldCategories).descriptionEmptyTitle,
        categoryEmptyState: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Aioa.default), {
                emptyStateText: (0, $b3HO0.fieldCategories).descriptionEmptyTitle,
                ...props
            }),
        whatIsThis: {
            buttonLabel: (0, $b3HO0.fieldCategories).whatIsThis,
            content: (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $b3HO0.fieldCategories).whatAreDescriptionFieldsForInProductHelpIssueTermRefresh : (0, $b3HO0.fieldCategories).whatAreDescriptionFieldsForInProductHelp,
            linkToDocumentationText: (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $b3HO0.fieldCategories).linkToInProductHelpTextIssueTermRefresh : (0, $b3HO0.fieldCategories).linkToInProductHelpText,
            linkToInProductHelpArticleId: $5da8358b54cce8ab$var$fieldsDocumentationInProductHelpArticleId
        },
        allowRequiredField: false,
        allowFieldAliasEditing: false,
        allowFieldAlias: true,
        allowedLayoutItems: [
            (0, $2teXs.allowFieldLayoutItem)((0, $3XO6n.TEXT_AREA_CF_TYPE))
        ]
    });
const $5da8358b54cce8ab$var$getServiceDeskPrimaryCategory = ()=>({
        name: (0, $in90R.toFieldCategory)('primary'),
        displayName: (0, $b3HO0.fieldCategories).primaryTitle,
        emptyStateText: (0, $b3HO0.fieldCategories).secondaryEmptyMessage,
        categoryEmptyState: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Aioa.default), {
                emptyStateText: (0, $b3HO0.fieldCategories).secondaryEmptyMessage,
                ...props
            }),
        whatIsThis: {
            buttonLabel: (0, $b3HO0.fieldCategories).whatIsThis,
            content: (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $b3HO0.fieldCategories).whatAreSecondaryFieldsWithDividerForInProductHelpIssueTermRefresh : (0, $b3HO0.fieldCategories).whatAreSecondaryFieldsWithDividerForInProductHelp,
            linkToDocumentationText: (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $b3HO0.fieldCategories).linkToInProductHelpTextIssueTermRefresh : (0, $b3HO0.fieldCategories).linkToInProductHelpText,
            linkToInProductHelpArticleId: $5da8358b54cce8ab$var$fieldsDocumentationInProductHelpArticleId
        },
        renderBeforeItems: (0, $719NN.default),
        allowRequiredField: false,
        allowFieldAliasEditing: false,
        allowFieldAlias: false,
        allowedLayoutItems: []
    });
const $5da8358b54cce8ab$var$getServiceDeskSecondaryCategory = ()=>({
        name: (0, $in90R.toFieldCategory)('secondary'),
        displayName: (0, $b3HO0.fieldCategories).hideWhenEmptyFields,
        dividerText: (0, $b3HO0.fieldCategories).showMoreDividerText,
        emptyStateText: (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $b3HO0.fieldCategories).hideFieldsBelowCategoryEmptyMessageWithDraggableDividerIssueTermRefresh : (0, $b3HO0.fieldCategories).hideFieldsBelowCategoryEmptyMessageWithDraggableDivider,
        categoryEmptyState: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Aioa.default), {
                emptyStateText: (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $b3HO0.fieldCategories).hideFieldsBelowCategoryEmptyMessageWithDraggableDividerIssueTermRefresh : (0, $b3HO0.fieldCategories).hideFieldsBelowCategoryEmptyMessageWithDraggableDivider,
                ...props
            }),
        allowRequiredField: false,
        allowFieldAliasEditing: false,
        allowFieldAlias: false,
        allowedLayoutItems: []
    });
const $5da8358b54cce8ab$var$getServiceDeskFieldCategories = ()=>[
        $5da8358b54cce8ab$var$getServiceDeskRequestCategory(),
        $5da8358b54cce8ab$var$getServiceDeskMultiLineCategory(),
        $5da8358b54cce8ab$var$getServiceDeskPrimaryCategory(),
        $5da8358b54cce8ab$var$getServiceDeskSecondaryCategory()
    ];
const $5da8358b54cce8ab$var$getServiceDeskEmailedRequestTypeFieldCategories = ()=>[
        $5da8358b54cce8ab$var$getServiceDeskEmailRequestCategory(),
        $5da8358b54cce8ab$var$getServiceDeskMultiLineCategory(),
        $5da8358b54cce8ab$var$getServiceDeskPrimaryCategory(),
        $5da8358b54cce8ab$var$getServiceDeskSecondaryCategory()
    ];
function $5da8358b54cce8ab$var$getApprovalFieldWarning(associatedField, intl) {
    if (associatedField.type === (0, $5fc53.APPROVERS_LIST_CF_TYPE)) {
        // When the admin configures an approval where the approvers are set by the customer -
        // an approver list field is added to SWIFT in the customer portal bucket.
        // Approver fields are special people fields used for storing approvers.
        const approvalConfig = associatedField.configuration ? associatedField.configuration['jsd.field.approval.config'] : undefined;
        if (approvalConfig !== undefined && approvalConfig !== null && typeof approvalConfig === 'object') {
            // @ts-expect-error - TS2339 - Property 'statusName' does not exist on type '{}'.
            const { statusName: statusName } = approvalConfig;
            // We always expect statusName to be available as a human readable string, if it's not we want to throw an error
            // here as a clear signal that something has gone wrong.
            if (Boolean(statusName) === false || typeof statusName !== 'string') throw new Error('Expected approvalConfig.statusName to be a valid human readable string from the backend, instead got undefined or an object');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                key: `approver-list-information-for-${String(statusName)}`
            }, intl.formatMessage((0, $b3HO0.fieldWarnings).approversListInformation, {
                approvalStatus: statusName
            }));
        }
    }
    return null;
}
const $5da8358b54cce8ab$var$fieldValidatorIncludingConfiguration = (0, $iaUQo.composeValidators)([
    (0, $fbE1k.nameMustBeNotEmpty),
    (0, $ghck8.fieldAliasDescriptionMustBeShortEnough),
    (0, $kp2EN.fieldDefaultValueValidator),
    (0, $3p4Fj.optionsMustBeUniquePerParent)
]);
const $5da8358b54cce8ab$var$breadcrumbConfig = {
    getHref: (0, $02Psx.getNextgenSettingsIssueTypesUrl),
    message: (0, $cgvPO.navigationMessages).issueTypesLink,
    type: 'issue-type'
};
const $5da8358b54cce8ab$var$getFieldTooltipContent = ({ associatedField: field, fieldCreator: fieldCreator, isRequirabilityDisplayed: isRequirabilityDisplayed, isEditable: isEditable, isAppField: isAppField })=>{
    const messageFlags = (0, $jFgQY.getMessageFlags)({
        uneditable: !isEditable,
        unrequirable: isRequirabilityDisplayed && !field.operations.canModifyRequired,
        unsortable: field.sortable !== undefined && field.sortable === false,
        unremovable: !field.operations.removable
    });
    if (!messageFlags) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIb2d.FieldTooltipContent), {
        ...messageFlags,
        isAppField: isAppField,
        fieldCreator: fieldCreator
    });
};
const $5da8358b54cce8ab$var$stopPropagation = (e)=>e.stopPropagation();
const $5da8358b54cce8ab$var$DiscoveryInfoIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5da8358b54cce8ab$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        color: "var(--ds-icon-discovery, #8270DB)",
        label: "",
        spacing: "spacious"
    }));
const $5da8358b54cce8ab$export$badfb6855668830d = ({ associatedField: associatedField, intl: intl })=>{
    const approvalFieldWarning = $5da8358b54cce8ab$var$getApprovalFieldWarning(associatedField, intl);
    if (approvalFieldWarning != null) return {
        longText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.InfoMessageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.InfoMessageNotDraggable), {
            onMouseDown: $5da8358b54cce8ab$var$stopPropagation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            appearance: "discovery",
            icon: $5da8358b54cce8ab$var$DiscoveryInfoIcon
        }, approvalFieldWarning)))
    };
    return undefined;
};
const $5da8358b54cce8ab$export$d60e8083fdfb3def = ({ associatedField: associatedField, layoutOwners: layoutOwners, intl: intl })=>{
    const restrictions = // there could be no restrictions for scoped fields
    // because such fields will be automatically linked with the issuetype on association
    associatedField.global && (0, $fCJv5.getRestrictions)(associatedField.availability, layoutOwners, associatedField.custom);
    if (restrictions) return {
        icon: {
            type: 'warning',
            label: (0, $dXdGS.messages).restrictedFieldIconLabel
        },
        longText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9LMsC.RestrictedFieldWarnings), {
            intl: intl,
            fieldKey: associatedField.key,
            hiddenInContext: restrictions.hiddenInContext,
            hiddenInConfigurationsWithIssueTypes: restrictions.hiddenInConfigurationsWithIssueTypes,
            HiddenInContextComponent: (0, $bDbDt.HiddenInContextWarning)
        })
    };
    return undefined;
};
const $5da8358b54cce8ab$var$getFieldCard = (fieldType)=>{
    switch(fieldType){
        /**
     * Environment field has turned off default value because it's not supported in JSM CMP.
     * But this code is JSM TMP. Perhaps it should be enabled again?
     * See https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/commits/0733055f2d2f4734349a99f0c1fa0318455c507b#src/packages/project-settings/issue-type-page-product-features/src/common/utils/service-desk/index.js
     */ case 0, $3XO6n.ENVIRONMENT_FIELD_TYPE:
            return {
                isExpandable: ()=>false,
                ConfigurationComponent: ()=>null
            };
        case 0, $3XO6n.TEXT_AREA_CF_TYPE:
        case 0, $3XO6n.DESCRIPTION_FIELD_TYPE:
            return {
                isExpandable: (operations)=>operations.canModifyDefaultValue,
                ConfigurationComponent: (0, $hQIjR.MultilineFieldConfiguration)
            };
        default:
            return (0, $2Ic5U.getFieldCard)(fieldType);
    }
};
const $5da8358b54cce8ab$export$11569a8b7fd625e5 = (store, bottomControlsIsDirty, bottomControlsIsSaving, bottomControlsDiscardChanges, createAnalyticsEvent)=>({
        fieldAlias: true,
        issueTypeHierarchy: (0, $7Ertg.doesJsmTmpSupportIssueTypeHierarchy)(),
        issueTypeHelpText: true,
        allowRequiringFields: true,
        addNewFieldsToBottom: true,
        workflowEditor: true,
        issueRestriction: false,
        fieldCategoryConfiguration: $5da8358b54cce8ab$var$getServiceDeskFieldCategories(),
        issueTypeTemplates: [],
        addIssueTypeMessages: $b3HO0.addIssueTypeMessages,
        deleteFieldMessages: $b3HO0.deleteFieldMessages,
        navigationMessages: $cgvPO.navigationMessages,
        editIssueTypeMessages: (0, $4R6GH.fg)('itsm-issue-renaming') ? {
            ...(0, $cgvPO.editIssueTypeMessages),
            ...(0, $cgvPO.editIssueTypeMessagesIssueTermRefresh)
        } : (0, $cgvPO.editIssueTypeMessages),
        fieldsEditorMessages: $cgvPO.fieldsEditorMessages,
        requiredFieldMessages: (0, $4R6GH.fg)('itsm-issue-renaming') ? {
            ...(0, $cgvPO.requiredFieldMessages),
            ...(0, $cgvPO.requiredFieldMessagesIssueTermRefresh)
        } : (0, $cgvPO.requiredFieldMessages),
        fieldsDocumentationUrl: $5da8358b54cce8ab$var$fieldsDocumentationUrl,
        getActiveFieldHeaderInfo: (0, $kEraB.mergeGetActiveFieldHeaderInfo)((0, $ayl8e.requiredFieldActiveFieldHeaderInfo), $5da8358b54cce8ab$export$badfb6855668830d, $5da8358b54cce8ab$export$d60e8083fdfb3def, (0, $cgGpC.ecosystemAppFieldWarning)),
        BottomProductControl: (0, $gurvk.ViewButtonWrapper),
        saveChangesService: store ? (0, $l0vRU.saveChangesServiceWithProformaContext)(store, createAnalyticsEvent) : (0, $l0vRU.saveChangesService),
        AvailableLayoutItemsSidebar: (0, $if5xq.JsmTmpSidebar),
        fetchAvailableItemsService: (0, $ghCiF.fetchAvailableLayoutItems)('ISSUE_VIEW'),
        fetchMoreAvailableItemsService: (0, $ghCiF.fetchMoreAvailableLayoutItems)('ISSUE_VIEW'),
        fetchLayoutConfiguration: (0, $EcXxh.fetchLayoutConfiguration)($5da8358b54cce8ab$var$getServiceDeskFieldCategories(), $5da8358b54cce8ab$var$getServiceDeskEmailedRequestTypeFieldCategories()),
        ConfirmBeforeSave: (0, $2IXkL.DuplicateFormLinkedFieldsWarningDialogWithErrorBoundary),
        MainContent: $hwF9S.MainContent,
        MainHeader: $fyLyr.MainHeader,
        Scrollable: $2tk6O.Scrollable,
        Footer: (0, $2tk6O.NonShrinkableFooter),
        getFieldCard: $5da8358b54cce8ab$var$getFieldCard,
        validateField: $5da8358b54cce8ab$var$fieldValidatorIncludingConfiguration,
        getFieldTooltipContent: $5da8358b54cce8ab$var$getFieldTooltipContent,
        validateIssueType: ({ issueDataState: issueDataState, existingIssueTypeNames: existingIssueTypeNames })=>(0, $8k5eK.validateIssueType)({}, {}, issueDataState.name.value, existingIssueTypeNames, issueDataState.helptext.value, issueDataState.description.value),
        validateIssueDataCards: ()=>[],
        issueLayoutBreadcrumbConfig: $5da8358b54cce8ab$var$breadcrumbConfig,
        issueLayoutType: 'customer',
        metricsConfig: {
            pageLoad: {
                key: 'project-settings.issue-type.jsm-tmp'
            }
        },
        feedbackCollectorConfig: {
            feedbackGroupId: 'project-settings.issue-type',
            source: 'jsm-tmp-request-type-config'
        },
        getScreenId: ()=>undefined,
        SidebarContainer: // TMP projects don’t use screens
        $6ozDP.SidebarContainer,
        swiftVersionForAnalytics: (0, $6wesA.SWIFT_VERSION_M2),
        FieldToolbarNoAction: $7E1yI.FieldToolbarNoAction,
        bottomControlsIsDirty: bottomControlsIsDirty,
        bottomControlsIsSaving: bottomControlsIsSaving,
        bottomControlsDiscardChanges: bottomControlsDiscardChanges
    });
const $5da8358b54cce8ab$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    width: '24px'
});

});
parcelRegister("in90R", function(module, exports) {

$parcel$export(module.exports, "toFieldCategory", () => $651dc689c7916a22$export$eb5d5579b98ad89e);
const $651dc689c7916a22$export$eb5d5579b98ad89e = (c)=>c;

});

parcelRegister("6wesA", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $a553a914b9b6f7c9$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "INACTIVE_LIST", () => $a553a914b9b6f7c9$export$d7fec05af6b928f7);
$parcel$export(module.exports, "FIELD_TYPE_LIST", () => $a553a914b9b6f7c9$export$de26d0d1ef96d0ed);
$parcel$export(module.exports, "DELETE_DROPPABLE_ID", () => $a553a914b9b6f7c9$export$a155cb9d82798d65);
$parcel$export(module.exports, "IGNORE_CLICK_OUTSIDE_CLASS_NAME", () => $a553a914b9b6f7c9$export$8191ccc97ff9885c);
$parcel$export(module.exports, "DO_NOT_ANIMATE_WIDTH", () => $a553a914b9b6f7c9$export$c77ecc59e9e91e60);
$parcel$export(module.exports, "JSD_FIELD_HELPTEXT", () => $a553a914b9b6f7c9$export$663476c4863d5014);
$parcel$export(module.exports, "FORGE_FIELD_TYPE", () => $a553a914b9b6f7c9$export$b1bef6d04e96121a);
$parcel$export(module.exports, "FORGE_FIELD_COLLECTION", () => $a553a914b9b6f7c9$export$991edf9ddbb20d59);
$parcel$export(module.exports, "ID_REQUEST_OWNER_PROPERTY_KEY", () => $a553a914b9b6f7c9$export$9be9f574874c9a2f);
$parcel$export(module.exports, "NAME_REQUEST_OWNER_PROPERTY_KEY", () => $a553a914b9b6f7c9$export$b320c6b352dcb101);
$parcel$export(module.exports, "SUGGESTED_GROUP", () => $a553a914b9b6f7c9$export$e66b34cc29932bbf);
$parcel$export(module.exports, "ASSETS_GROUP", () => $a553a914b9b6f7c9$export$c87c7df18254969e);
$parcel$export(module.exports, "DATES_GROUP", () => $a553a914b9b6f7c9$export$fa8c310a8ac47d47);
$parcel$export(module.exports, "LABELS_GROUP", () => $a553a914b9b6f7c9$export$5b2dd1b457037e13);
$parcel$export(module.exports, "NUMBER_GROUP", () => $a553a914b9b6f7c9$export$2c2f344ca2ba1c03);
$parcel$export(module.exports, "PEOPLE_GROUP", () => $a553a914b9b6f7c9$export$1441c9d524a8c0f2);
$parcel$export(module.exports, "SELECT_GROUP", () => $a553a914b9b6f7c9$export$d3e4788fc90e5f8f);
$parcel$export(module.exports, "SYSTEM_GROUP", () => $a553a914b9b6f7c9$export$724e0d23ac7e9b03);
$parcel$export(module.exports, "TEXT_GROUP", () => $a553a914b9b6f7c9$export$bd76d204d15f4c6a);
$parcel$export(module.exports, "VERSION_GROUP", () => $a553a914b9b6f7c9$export$33d3fa5e989ba460);
$parcel$export(module.exports, "ADVANCED_GROUP", () => $a553a914b9b6f7c9$export$c58a10f3e3456974);
$parcel$export(module.exports, "OTHER_GROUP", () => $a553a914b9b6f7c9$export$591e195d295fd27e);
$parcel$export(module.exports, "RESTRICTED_GROUP", () => $a553a914b9b6f7c9$export$14785d7afcf55619);
$parcel$export(module.exports, "AI_SUGGESTED_GROUP", () => $a553a914b9b6f7c9$export$df593ebd3e7c9c2d);
$parcel$export(module.exports, "INIT", () => $a553a914b9b6f7c9$export$d788bc089976c004);
$parcel$export(module.exports, "LOADING", () => $a553a914b9b6f7c9$export$26d55645375ca9a);
$parcel$export(module.exports, "SUCCESS", () => $a553a914b9b6f7c9$export$638cc6e36b2a737a);
$parcel$export(module.exports, "FAILURE", () => $a553a914b9b6f7c9$export$5b1e245d5eac107);
$parcel$export(module.exports, "classicFieldTypesMap", () => $a553a914b9b6f7c9$export$369c1f8ac37104ce);
$parcel$export(module.exports, "ngFieldTypesMap", () => $a553a914b9b6f7c9$export$b361664c16c2ea91);
$parcel$export(module.exports, "SWIFT_VERSION_M2", () => $a553a914b9b6f7c9$export$527472231e0f6045);
$parcel$export(module.exports, "JSD_IS_EMAIL_REQUEST_TYPE", () => $a553a914b9b6f7c9$export$97806a3c861a8076);

var $5fc53 = parcelRequire("5fc53");

var $3XO6n = parcelRequire("3XO6n");
const $a553a914b9b6f7c9$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectSettingsAppsIssueTypePageProductFeatures');
const $a553a914b9b6f7c9$export$d7fec05af6b928f7 = 'inactive-list';
const $a553a914b9b6f7c9$export$de26d0d1ef96d0ed = 'field-type-list';
const $a553a914b9b6f7c9$export$a155cb9d82798d65 = 'delete-droppable-id';
const $a553a914b9b6f7c9$export$8191ccc97ff9885c = '9|.^=*D(riA_=lUv787iQ7hwW5HIz=}t/OdJy%q';
const $a553a914b9b6f7c9$export$c77ecc59e9e91e60 = 'DO_NOT_ANIMATE_WIDTH';
const $a553a914b9b6f7c9$export$663476c4863d5014 = 'jsd.field.helpText';
const $a553a914b9b6f7c9$export$b1bef6d04e96121a = 'forge.field.type';
const $a553a914b9b6f7c9$export$991edf9ddbb20d59 = 'forge.field.collection';
const $a553a914b9b6f7c9$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
const $a553a914b9b6f7c9$export$9be9f574874c9a2f = 'jsm.issue.type.id';
const $a553a914b9b6f7c9$export$b320c6b352dcb101 = 'jsm.issue.type.name';
const $a553a914b9b6f7c9$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
const $a553a914b9b6f7c9$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
const $a553a914b9b6f7c9$export$e66b34cc29932bbf = 'suggestedGroup';
const $a553a914b9b6f7c9$export$c87c7df18254969e = 'assetsGroup';
const $a553a914b9b6f7c9$export$fa8c310a8ac47d47 = 'datesGroup';
const $a553a914b9b6f7c9$export$5b2dd1b457037e13 = 'labelsGroup';
const $a553a914b9b6f7c9$export$2c2f344ca2ba1c03 = 'numberGroup';
const $a553a914b9b6f7c9$export$1441c9d524a8c0f2 = 'peopleGroup';
const $a553a914b9b6f7c9$export$d3e4788fc90e5f8f = 'selectGroup';
const $a553a914b9b6f7c9$export$724e0d23ac7e9b03 = 'systemGroup';
const $a553a914b9b6f7c9$export$bd76d204d15f4c6a = 'textGroup';
const $a553a914b9b6f7c9$export$33d3fa5e989ba460 = 'versionGroup';
const $a553a914b9b6f7c9$export$c58a10f3e3456974 = 'advancedGroup';
const $a553a914b9b6f7c9$export$591e195d295fd27e = 'otherGroup';
const $a553a914b9b6f7c9$export$14785d7afcf55619 = 'restrictedGroup';
const $a553a914b9b6f7c9$export$df593ebd3e7c9c2d = 'aiSuggestedGroup';
const $a553a914b9b6f7c9$export$d788bc089976c004 = 'INIT';
const $a553a914b9b6f7c9$export$26d55645375ca9a = 'LOADING';
const $a553a914b9b6f7c9$export$638cc6e36b2a737a = 'SUCCESS';
const $a553a914b9b6f7c9$export$5b1e245d5eac107 = 'FAILURE';
const $a553a914b9b6f7c9$export$369c1f8ac37104ce = {
    assetspicker: $a553a914b9b6f7c9$export$c58a10f3e3456974,
    date: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
    datetime: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
    labelpicker: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
    number: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
    multiuserpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
    userpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
    checkbox: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    radio: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    cascadingselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    multiselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    select: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    attachment: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
    textarea: $a553a914b9b6f7c9$export$bd76d204d15f4c6a
};
const $a553a914b9b6f7c9$export$b361664c16c2ea91 = {
    [(0, $5fc53.ASSETS_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
    [(0, $5fc53.DATE_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
    [(0, $5fc53.DATETIME_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
    [(0, $5fc53.LABELS_CF_TYPE)]: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
    [(0, $5fc53.NUMBER_CF_TYPE)]: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
    people: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    [(0, $5fc53.SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    [(0, $5fc53.ATTACHMENT_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.TEXT_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
    text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
    [(0, $5fc53.VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
    [(0, $5fc53.SUMMARY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.DESCRIPTION_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.LABELS_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.PEOPLE_CF_TYPE)]: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
    [(0, $5fc53.PRIORITY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.DUE_DATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.REPORTER_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.ASSIGNEE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03
};
const $a553a914b9b6f7c9$export$8e333612d4b83b0e = 'M1';
const $a553a914b9b6f7c9$export$527472231e0f6045 = 'M2';
const $a553a914b9b6f7c9$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';

});

parcelRegister("ghCiF", function(module, exports) {

$parcel$export(module.exports, "fetchMoreAvailableLayoutItems", () => $91adcf6df998392e$export$e04b6dd1d04cce69);
$parcel$export(module.exports, "fetchAvailableLayoutItems", () => $91adcf6df998392e$export$385f842c67e18d76);

var $92ECu = parcelRequire("92ECu");

var $iBOrg = parcelRequire("iBOrg");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $g5X3G = parcelRequire("g5X3G");

var $6wesA = parcelRequire("6wesA");

var $3WKp7 = parcelRequire("3WKp7");

var $c2EaK = parcelRequire("c2EaK");
const $91adcf6df998392e$var$availableItems = (0, $92ECu.gqlTagGira)`
query AvailableIssueLayoutItems(
    $projectId: Long!,
    $extraDefinerId: Long!,
    $layoutType: IssueLayoutType!,
    $pageSize: Int!,
    $queryString: String!,
    $fieldPropertyKeys: [String!]!,
    $after: String,
    $includeRestrictedItems: Boolean = true,
    $includeSystemItems: Boolean = true,
    $includeTextItems: Boolean = true,
    $includeLabelsItems: Boolean = true,
    $includePeopleItems: Boolean = true,
    $includeDateItems: Boolean = true,
    $includeSelectItems: Boolean = true,
    $includeNumberItems: Boolean = true,
    $includeOtherItems: Boolean = true,
    $includeAdvancedItems: Boolean = true,
    $includeSuggestedItems: Boolean = true,
) {
  issueLayoutConfiguration(issueLayoutKey: {projectId: $projectId, extraDefinerId: $extraDefinerId}, type: $layoutType) {
    ... on QueryError {
      message
    }
    ... on JiraIssueLayoutConfigurationResult {
      metadata {
        __typename
        availableItems {
          restrictedFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeRestrictedItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          suggestedFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeSuggestedItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          systemAndAppFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeSystemItems)  {
            ...SystemAvailableLayoutItemsGroup
          }
          textFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeTextItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          labelsFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeLabelsItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          peopleFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includePeopleItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          dateFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeDateItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          selectFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeSelectItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          numberFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeNumberItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          otherFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeOtherItems) {
            ...CustomAvailableLayoutItemsGroup
          }
          advancedFields(first: $pageSize, queryString: $queryString, after: $after) @include(if: $includeAdvancedItems) {
            ...CustomAvailableLayoutItemsGroup
          }
        }
      }
    }
  }
}

${(0, $3WKp7.AvailableLayoutItemGroupsFragments)}
`;
const $91adcf6df998392e$var$includeEverything = {
    includeRestrictedItems: true,
    includeSystemItems: true,
    includeTextItems: true,
    includeLabelsItems: true,
    includePeopleItems: true,
    includeDateItems: true,
    includeSelectItems: true,
    includeNumberItems: true,
    includeSuggestedItems: true,
    includeOtherItems: true,
    includeAdvancedItems: true
};
const $91adcf6df998392e$var$includeNothing = {
    includeRestrictedItems: false,
    includeSystemItems: false,
    includeTextItems: false,
    includeLabelsItems: false,
    includePeopleItems: false,
    includeDateItems: false,
    includeSelectItems: false,
    includeNumberItems: false,
    includeSuggestedItems: false,
    includeOtherItems: false,
    includeAdvancedItems: false
};
const $91adcf6df998392e$var$includesByGroup = {
    [(0, $6wesA.DATES_GROUP)]: 'includeDateItems',
    [(0, $6wesA.LABELS_GROUP)]: 'includeLabelsItems',
    [(0, $6wesA.NUMBER_GROUP)]: 'includeNumberItems',
    [(0, $6wesA.PEOPLE_GROUP)]: 'includePeopleItems',
    [(0, $6wesA.SELECT_GROUP)]: 'includeSelectItems',
    [(0, $6wesA.SYSTEM_GROUP)]: 'includeSystemItems',
    [(0, $6wesA.TEXT_GROUP)]: 'includeTextItems',
    [(0, $6wesA.SUGGESTED_GROUP)]: 'includeSuggestedItems',
    [(0, $6wesA.OTHER_GROUP)]: 'includeOtherItems',
    [(0, $6wesA.ADVANCED_GROUP)]: 'includeAdvancedItems',
    [(0, $6wesA.ASSETS_GROUP)]: 'includeAdvancedItems',
    [(0, $6wesA.VERSION_GROUP)]: 'includeAdvancedItems',
    [(0, $6wesA.AI_SUGGESTED_GROUP)]: 'includeAdvancedItems',
    [(0, $6wesA.RESTRICTED_GROUP)]: 'includeRestrictedItems'
};
const $91adcf6df998392e$var$fetchAvailableLayoutItemsInternal = (projectContext, extraDefinerId, layoutType, pageSize, queryString, includes, after)=>{
    const client = (0, $iBOrg.getClient)((0, $g5X3G.toBaseUrl)('')); // in cloud, baseUrl is always empty string
    const { projectId: projectId } = projectContext;
    return client.query({
        query: $91adcf6df998392e$var$availableItems,
        variables: {
            projectId: projectId,
            extraDefinerId: extraDefinerId,
            layoutType: layoutType,
            pageSize: pageSize,
            queryString: queryString,
            fieldPropertyKeys: [],
            after: after,
            ...includes
        }
    });
};
const $91adcf6df998392e$export$e04b6dd1d04cce69 = (layoutType)=>({ projectContext: projectContext, extraDefinerId: extraDefinerId, pageSize: pageSize, group: group, queryString: queryString, after: after })=>{
        const includes = {
            ...$91adcf6df998392e$var$includeNothing
        };
        if (!$91adcf6df998392e$var$includesByGroup[group]) throw new Error(`Unknown layout items group: ${group}`);
        includes[$91adcf6df998392e$var$includesByGroup[group]] = true;
        return (0, $koFzm.famaCatchAndLogFetchError)($91adcf6df998392e$var$fetchAvailableLayoutItemsInternal(projectContext, extraDefinerId, layoutType, pageSize, queryString, includes, after), (0, $6wesA.PACKAGE_NAME), (0, $gl0PU.toErrorId)('fetchMoreAvailableLayoutItems'), (0, $gl0PU.toErrorMessage)('Failed to fetch more available layout items in SWIFT')).then(({ data: data })=>{
            const issueLayoutConfiguration = data?.issueLayoutConfiguration;
            if (!issueLayoutConfiguration || issueLayoutConfiguration.__typename === 'QueryError' || !issueLayoutConfiguration.metadata || // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"JiraIssueLayoutMetadata"' and '"QueryError"' have no overlap.
            issueLayoutConfiguration.metadata.__typename === 'QueryError') throw new Error('Failed to fetch more available layout items');
            return (0, $c2EaK.transformAvailableLayoutItemGroups)(issueLayoutConfiguration.metadata.availableItems || {});
        });
    };
const $91adcf6df998392e$export$385f842c67e18d76 = (layoutType)=>({ projectContext: projectContext, extraDefinerId: extraDefinerId, pageSize: pageSize, queryString: queryString })=>(0, $koFzm.famaCatchAndLogFetchError)($91adcf6df998392e$var$fetchAvailableLayoutItemsInternal(projectContext, extraDefinerId, layoutType, pageSize, queryString, $91adcf6df998392e$var$includeEverything), (0, $6wesA.PACKAGE_NAME), (0, $gl0PU.toErrorId)('fetchAvailableLayoutItems'), (0, $gl0PU.toErrorMessage)('Failed to fetch available layout items in SWIFT')).then(({ data: data })=>{
            const issueLayoutConfiguration = data?.issueLayoutConfiguration;
            if (!issueLayoutConfiguration || issueLayoutConfiguration.__typename === 'QueryError' || !issueLayoutConfiguration.metadata || // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"JiraIssueLayoutMetadata"' and '"QueryError"' have no overlap.
            issueLayoutConfiguration.metadata.__typename === 'QueryError') throw new Error('Failed to fetch available layout items');
            return (0, $c2EaK.transformAvailableLayoutItemGroups)(issueLayoutConfiguration.metadata.availableItems || {});
        });

});
parcelRegister("92ECu", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $9387aa2a419a55f9$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $9387aa2a419a55f9$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $9387aa2a419a55f9$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("iBOrg", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $3d6ab2890da8f9df$export$6bb76d6eba7e258c);

var $7f4tk = parcelRequire("7f4tk");

var $fqpdr = parcelRequire("fqpdr");
const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $7f4tk.default)((0, $fqpdr.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $3d6ab2890da8f9df$var$client;
const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
    return $3d6ab2890da8f9df$var$client;
};

});
parcelRegister("fqpdr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $3789cf83eed10ddd$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $3789cf83eed10ddd$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $3789cf83eed10ddd$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $3789cf83eed10ddd$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $3789cf83eed10ddd$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $96nmc = parcelRequire("96nmc");

var $EJMEI = parcelRequire("EJMEI");

var $8TkIN = parcelRequire("8TkIN");

var $e2Vt6 = parcelRequire("e2Vt6");

var $92ECu = parcelRequire("92ECu");

var $6QL4r = parcelRequire("6QL4r");

var $5Pqa3 = parcelRequire("5Pqa3");

var $b1RJj = parcelRequire("b1RJj");

var $1HCMp = parcelRequire("1HCMp");

var $8JI9I = parcelRequire("8JI9I");

var $kNriQ = parcelRequire("kNriQ");

var $cRP2d = parcelRequire("cRP2d");
const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $3789cf83eed10ddd$var$getURLFromWindow = ()=>new URL(window.location.href);
const $3789cf83eed10ddd$var$viewIssueQuery = (url = $3789cf83eed10ddd$var$getURLFromWindow())=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $EJMEI.default)({
        maxResults: (0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD)),
        hydrateData: false,
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cRP2d.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $92ECu.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $e2Vt6.getEcosystemQuery)()}
        ${(0, $8TkIN.getContentPanelsQuery)()}
        ${(0, $e2Vt6.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $5Pqa3.getContainersByTypeQuery)()}
        ${(0, $kNriQ.getRemoteLinksQuery)()}
    }
`;
const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $3789cf83eed10ddd$export$222ae9aca08830f0 = (url)=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, $b1RJj.default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery(url)}
        ${(0, $6QL4r.getJiraSettingsQuery)()}
        ${(0, $1HCMp.default)()}
        ${(0, $8JI9I.default)()}
    }

`;
const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
        query: $3789cf83eed10ddd$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("EJMEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ae9b8d951a6992$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, hydrateData: hydrateData = true, url: url })=>{
    const commentPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
    if ((0, $4R6GH.fg)('jira_comments_agg_pagination')) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
    if (!hydrateData) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
            startIndex
        }
    `;
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
                eventOccurredAt
                jsdIncidentActivityViewHidden
            }
            totalCount
            startIndex
        }
    `;
};

});
parcelRegister("6tI1D", function(module, exports) {

$parcel$export(module.exports, "PermalinkType", () => $ac458c74e4b12b29$export$b18d061fc042df1a);
$parcel$export(module.exports, "COMMENTS", () => $ac458c74e4b12b29$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $ac458c74e4b12b29$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $ac458c74e4b12b29$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $ac458c74e4b12b29$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $ac458c74e4b12b29$export$87557f913748dcff);

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");
const $ac458c74e4b12b29$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
    (0, $gKZoD.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
};
const $ac458c74e4b12b29$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("8TkIN", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $09fdc8c72c341092$export$e6f14eac549b679d);
const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("e2Vt6", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $1771eed42c62eeca$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $1771eed42c62eeca$export$92c9a3dc7076af51);
const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("6QL4r", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $10470e592ba8e782$export$191f50c0f86b85ec);
const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("5Pqa3", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $85e2f5a62f1697d1$export$63131b2831854cc);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $85e2f5a62f1697d1$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$63131b2831854cc = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $85e2f5a62f1697d1$export$842411c0b98baa9c, $85e2f5a62f1697d1$export$e30f32dd3fd26efd);

});

parcelRegister("b1RJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $42429f0fa15c54ae$export$2e2bcd8739ae039);

var $9wuCE = parcelRequire("9wuCE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $9wuCE.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("9wuCE", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $ebb491dcc11e8362$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;

});


parcelRegister("1HCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea17df757c74c46$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("8JI9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2232e63ddd04bbb1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("kNriQ", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $e19ca26272d1dd4d$export$6bbc6b72b0b57f25);

var $4R6GH = parcelRequire("4R6GH");
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $e19ca26272d1dd4d$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$e19ca26272d1dd4d$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $e19ca26272d1dd4d$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
        ${$e19ca26272d1dd4d$var$getWebLinksFragment()}
        ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>(0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $e19ca26272d1dd4d$var$getRemoteLinksQueryNew() : $e19ca26272d1dd4d$var$getRemoteLinksQueryOld();

});

parcelRegister("cRP2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $354b7c85b873ab44$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.WORKLOG), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});



parcelRegister("3WKp7", function(module, exports) {

$parcel$export(module.exports, "FieldItemFragment", () => $47a25d5dad89d0aa$export$7a8299307dd70f67);
$parcel$export(module.exports, "JiraIssueLayoutUsageInfoFragment", () => $47a25d5dad89d0aa$export$2df7e5e5b510d80c);
$parcel$export(module.exports, "JiraIssueLayoutItemContainerFragment", () => $47a25d5dad89d0aa$export$2e6cf11fbee65585);
$parcel$export(module.exports, "AvailableLayoutItemGroupsFragments", () => $47a25d5dad89d0aa$export$88127a7d77bb2842);
$parcel$export(module.exports, "JiraIssueLayoutItemConfigurationFragment", () => $47a25d5dad89d0aa$export$9c69ad57ca0c312f);

var $6s1PB = parcelRequire("6s1PB");

var $92ECu = parcelRequire("92ECu");
const $47a25d5dad89d0aa$var$getFieldItemOptionsFragment = ()=>(0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) ? (0, $92ECu.gqlTagGira)`fragment FieldItemOptionsFragment on JiraIssueLayoutFieldOption {
			value
			id
			externalUuid
			parentId
			color { colorKey }
		}` : (0, $92ECu.gqlTagGira)`fragment FieldItemOptionsFragment on JiraIssueLayoutFieldOption {
		value
		id
		externalUuid
		parentId
	}`;
const $47a25d5dad89d0aa$export$243b1114ee1aaa9d = $47a25d5dad89d0aa$var$getFieldItemOptionsFragment();
const $47a25d5dad89d0aa$export$db655e3235c16464 = (0, $92ECu.gqlTagGira)`
fragment FieldItemProviderFragment on JiraIssueLayoutFieldProvider {
  key
  name
}
`;
const $47a25d5dad89d0aa$export$959738a16ad20163 = (0, $92ECu.gqlTagGira)`
fragment FieldItemOperationsFragment on JiraIssueLayoutFieldOperations {
  editable
  canModifyRequired
  canModifyOptions
  canModifyDefaultValue
  canModifyPropertyConfiguration
  removable
  deletable
  canAssociateInSettings
  categoriesWhitelist
}
`;
const $47a25d5dad89d0aa$export$1e2040112d5fe3c1 = (0, $92ECu.gqlTagGira)`
fragment FieldItemBaseFragment on JiraIssueLayoutFieldItemConfiguration {
  fieldItemId
  key
  name
  type
  custom
  global
  description
  configuration
  required
  externalUuid
  defaultValue
  options {
    ...FieldItemOptionsFragment
  }
  operations {
    ...FieldItemOperationsFragment
  }
  provider {
    ...FieldItemProviderFragment
  }
  availability {
    isHiddenIn {
      __typename
      ... on JiraIssueLayoutFieldConfigurationHiddenInGlobal {
        fieldConfigs {
          id
          configName
        }
      }
      ... on JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner {
        layoutOwnerId
        fieldConfigs {
          id
          configName
        }
      }
    }
    context {
      layoutOwnerIds
      id
    }
    displayConditions
    isHiddenByAppAccessRules
  }
}
`;
const $47a25d5dad89d0aa$export$7a8299307dd70f67 = (0, $92ECu.gqlTagGira)`
  ${$47a25d5dad89d0aa$export$959738a16ad20163}
  ${$47a25d5dad89d0aa$export$db655e3235c16464}
  ${$47a25d5dad89d0aa$export$1e2040112d5fe3c1}
  ${$47a25d5dad89d0aa$export$243b1114ee1aaa9d}
  fragment FieldItemFragment on JiraIssueLayoutFieldItemConfiguration {
    ...FieldItemBaseFragment
    properties(keys: $fieldPropertyKeys)
  }
`;
const $47a25d5dad89d0aa$export$b58ac802871cb8d8 = (0, $92ECu.gqlTagGira)`
fragment PanelItemFragment on JiraIssueLayoutPanelItemConfiguration {
  panelItemId
  name
  operations {
      editable
      removable
      categoriesWhitelist
      canAssociateInSettings
      deletable
  }
}`;
const $47a25d5dad89d0aa$export$2fbbe8981497f51d = (0, $92ECu.gqlTagGira)`
fragment JiraIssueLayoutOwnerFragment on JiraIssueLayoutOwner {
  __typename
  ... on JiraIssueLayoutIssueTypeOwner {
    id
    name
    description
    avatarId
    iconUrl
  }
  ... on JiraIssueLayoutRequestTypeOwner {
    id
    externalUuid
    name
    description
    avatarId
    iconUrl
    instructions
    restrictionStatus
    properties(keys: $requestOwnerPropertyKeys)
  }
}
`;
const $47a25d5dad89d0aa$export$2df7e5e5b510d80c = (0, $92ECu.gqlTagGira)`
${$47a25d5dad89d0aa$export$2fbbe8981497f51d}
fragment JiraIssueLayoutUsageInfo on JiraIssueLayoutUsageInfoConnection {
  edges {
    currentProject
    node {
      avatarId
      projectId
      projectKey
      projectName
      layoutOwners {
        ... JiraIssueLayoutOwnerFragment
      }
    }
  }
}
`;
const $47a25d5dad89d0aa$export$cdd943e8cf7f993f = (0, $92ECu.gqlTagGira)`
  fragment JiraIssueLayoutActiveFieldItemFragment on JiraIssueItemFieldItem {
    __typename
    fieldItemId
    containerPosition
  }
`;
const $47a25d5dad89d0aa$export$8a95c49fd973f993 = (0, $92ECu.gqlTagGira)`
  fragment JiraIssueLayoutActivePanelItemFragment on JiraIssueItemPanelItem {
  __typename
    panelItemId
  }
`;
const $47a25d5dad89d0aa$export$34ba8c4fbd93e088 = (0, $92ECu.gqlTagGira)`
  ${$47a25d5dad89d0aa$export$cdd943e8cf7f993f}
  fragment JiraIssueLayoutTabContainerFragment on JiraIssueItemTabContainer {
      __typename
      tabContainerId
      name
      items {
        nodes {
          ...JiraIssueLayoutActiveFieldItemFragment
        }
        totalCount
      }
  }
`;
const $47a25d5dad89d0aa$export$2e6cf11fbee65585 = (0, $92ECu.gqlTagGira)`
${$47a25d5dad89d0aa$export$8a95c49fd973f993}
${$47a25d5dad89d0aa$export$34ba8c4fbd93e088}
fragment JiraIssueLayoutItemContainerFragment on JiraIssueItemContainer {
  containerType
  items {
    nodes {
      __typename
      ... JiraIssueLayoutActiveFieldItemFragment,
      ... JiraIssueLayoutActivePanelItemFragment,
      ... JiraIssueLayoutTabContainerFragment,
    }
  }
}
`;
const $47a25d5dad89d0aa$export$88127a7d77bb2842 = (0, $92ECu.gqlTagGira)`
${$47a25d5dad89d0aa$export$b58ac802871cb8d8}
${$47a25d5dad89d0aa$export$7a8299307dd70f67}

fragment SystemAvailableLayoutItemsGroup on JiraIssueLayoutFieldPanelItemConfigurationResult {
  items {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
          node {
              __typename
              ...FieldItemFragment
              ...PanelItemFragment
          }
      }
  }
}
fragment CustomAvailableLayoutItemsGroup on JiraIssueLayoutFieldItemConfigurationResult {
  items {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
          node {
              __typename
              ...FieldItemFragment
          }
      }
  }
}
`;
const $47a25d5dad89d0aa$export$9c69ad57ca0c312f = (0, $92ECu.gqlTagGira)`
fragment JiraIssueLayoutItemConfigurationFragment on JiraIssueLayoutItemConfigurationResult {
  items {
    nodes {
      __typename
      ...FieldItemFragment
      ...PanelItemFragment
    }
  }
}
`;

});

parcelRegister("c2EaK", function(module, exports) {

$parcel$export(module.exports, "transformAvailableLayoutItemGroups", () => $64f355b9fa1d8b47$export$efd912f70b85802f);

var $6wesA = parcelRequire("6wesA");

var $fXJQQ = parcelRequire("fXJQQ");

var $eZEPm = parcelRequire("eZEPm");
const $64f355b9fa1d8b47$export$14f383ff620889b1 = (groupId, { items: { pageInfo: pageInfo, totalCount: totalCount, edges: edges } })=>{
    const items = (0, $fXJQQ.transformBaseLayoutItems)(edges.map(({ node: node })=>node), (0, $eZEPm.default));
    const hasNextPage = pageInfo?.hasNextPage || false;
    const endCursor = pageInfo?.endCursor || null;
    return {
        groupId: groupId,
        totalCount: totalCount || 0,
        hasNextPage: hasNextPage,
        endCursor: endCursor,
        items: items
    };
};
const $64f355b9fa1d8b47$export$efd912f70b85802f = (gqlGroups)=>{
    const { systemAndAppFields: systemAndAppFields, textFields: textFields, labelsFields: labelsFields, peopleFields: peopleFields, dateFields: dateFields, selectFields: selectFields, numberFields: numberFields, otherFields: otherFields, advancedFields: advancedFields, suggestedFields: suggestedFields, restrictedFields: restrictedFields } = gqlGroups;
    const result = [];
    if (systemAndAppFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.SYSTEM_GROUP), systemAndAppFields));
    if (textFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.TEXT_GROUP), textFields));
    if (suggestedFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.SUGGESTED_GROUP), suggestedFields));
    if (dateFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.DATES_GROUP), dateFields));
    if (labelsFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.LABELS_GROUP), labelsFields));
    if (numberFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.NUMBER_GROUP), numberFields));
    if (peopleFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.PEOPLE_GROUP), peopleFields));
    if (selectFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.SELECT_GROUP), selectFields));
    if (otherFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.OTHER_GROUP), otherFields));
    if (advancedFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.ADVANCED_GROUP), advancedFields));
    if (restrictedFields) result.push($64f355b9fa1d8b47$export$14f383ff620889b1((0, $6wesA.RESTRICTED_GROUP), restrictedFields));
    return result;
};

});
parcelRegister("fXJQQ", function(module, exports) {

$parcel$export(module.exports, "transformBaseLayoutItems", () => $065e01e123385e65$export$1b820dd083dd11e7);

var $2teXs = parcelRequire("2teXs");
const $065e01e123385e65$var$fieldToLayoutItem = (field)=>({
        key: (0, $2teXs.toLayoutItemKey)((0, $2teXs.FIELD_LAYOUT_ITEM_TYPE), field.key),
        layoutItemType: (0, $2teXs.FIELD_LAYOUT_ITEM_TYPE),
        data: field,
        operations: field.operations,
        category: null
    });
const $065e01e123385e65$var$panelToLayoutItem = (panel)=>({
        key: (0, $2teXs.toLayoutItemKey)((0, $2teXs.PANEL_LAYOUT_ITEM_TYPE), panel.key),
        layoutItemType: (0, $2teXs.PANEL_LAYOUT_ITEM_TYPE),
        data: panel,
        operations: panel.operations,
        category: null
    });
const $065e01e123385e65$export$1b820dd083dd11e7 = (layoutItemNodes, transformers)=>layoutItemNodes.reduce((accum, node)=>{
        let layoutItem;
        switch(node.__typename){
            case 'JiraIssueLayoutFieldItemConfiguration':
                {
                    const field = transformers.field(node, transformers);
                    layoutItem = $065e01e123385e65$var$fieldToLayoutItem(field);
                    break;
                }
            case 'JiraIssueLayoutPanelItemConfiguration':
                {
                    const panel = transformers.panel(node, transformers);
                    layoutItem = $065e01e123385e65$var$panelToLayoutItem(panel);
                    break;
                }
            default:
                // We ignore all non-base layout items (i.e. items we don't want to render in the sidebar).
                return accum;
        }
        return accum.concat([
            layoutItem
        ]);
    }, []);

});
parcelRegister("2teXs", function(module, exports) {

$parcel$export(module.exports, "toFieldType", () => $d7d2336983f9d243$export$42a45ca5a89c0224);
$parcel$export(module.exports, "PANEL_LAYOUT_ITEM_TYPE", () => $d7d2336983f9d243$export$14a822b4b8728ff);
$parcel$export(module.exports, "FIELD_LAYOUT_ITEM_TYPE", () => $d7d2336983f9d243$export$57d657a79733c8ff);
$parcel$export(module.exports, "allowFieldLayoutItem", () => $d7d2336983f9d243$export$1616501503fc215f);
$parcel$export(module.exports, "toLayoutItemKey", () => $d7d2336983f9d243$export$d751f7a27494922b);

var $5fc53 = parcelRequire("5fc53");

var $5fc53 = parcelRequire("5fc53");
var $3XO6n = parcelRequire("3XO6n");
const $d7d2336983f9d243$var$fieldTypesMap = {
    [(0, $5fc53.SUMMARY_TYPE)]: (0, $5fc53.SUMMARY_TYPE),
    [(0, $3XO6n.DESCRIPTION_FIELD_TYPE)]: (0, $3XO6n.DESCRIPTION_FIELD_TYPE),
    [(0, $5fc53.ATTACHMENT_TYPE)]: (0, $5fc53.ATTACHMENT_TYPE),
    [(0, $5fc53.NUMBER_CF_TYPE)]: (0, $5fc53.NUMBER_CF_TYPE),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
    [(0, $5fc53.URL_CF_TYPE)]: (0, $5fc53.URL_CF_TYPE),
    [(0, $5fc53.TEXT_CF_TYPE)]: (0, $5fc53.TEXT_CF_TYPE),
    [(0, $3XO6n.TEXT_AREA_CF_TYPE)]: (0, $3XO6n.TEXT_AREA_CF_TYPE),
    [(0, $5fc53.LABELS_CF_TYPE)]: (0, $5fc53.LABELS_CF_TYPE),
    [(0, $5fc53.DATE_CF_TYPE)]: (0, $5fc53.DATE_CF_TYPE),
    [(0, $5fc53.DATETIME_CF_TYPE)]: (0, $5fc53.DATETIME_CF_TYPE),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    [(0, $5fc53.SELECT_CF_TYPE)]: (0, $5fc53.SELECT_CF_TYPE),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: (0, $5fc53.MULTI_VERSION_CF_TYPE),
    [(0, $5fc53.VERSION_CF_TYPE)]: (0, $5fc53.VERSION_CF_TYPE),
    [(0, $5fc53.GROUP_CF_TYPE)]: (0, $5fc53.GROUP_CF_TYPE),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: (0, $5fc53.MULTI_GROUP_CF_TYPE),
    [(0, $5fc53.USER_CF_TYPE)]: (0, $5fc53.USER_CF_TYPE),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: (0, $5fc53.MULTI_USER_CF_TYPE),
    [(0, $5fc53.FLAGGED_CF_TYPE)]: (0, $5fc53.FLAGGED_CF_TYPE),
    [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
    [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
    [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
    [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
    [(0, $5fc53.ASSETS_CF_TYPE)]: (0, $5fc53.ASSETS_CF_TYPE),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: (0, $5fc53.PEOPLE_CF_TYPE),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: (0, $5fc53.CASCADING_SELECT_CF_TYPE),
    [(0, $3XO6n.ENVIRONMENT_FIELD_TYPE)]: (0, $3XO6n.ENVIRONMENT_FIELD_TYPE),
    [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: (0, $5fc53.ENTITLEMENT_CF_TYPE),
    [(0, $5fc53.ORGANIZATION_CF_TYPE)]: (0, $5fc53.ORGANIZATION_CF_TYPE),
    [(0, $5fc53.REPORTER_TYPE)]: (0, $5fc53.REPORTER_TYPE)
};
const $d7d2336983f9d243$export$42a45ca5a89c0224 = (strFieldType)=>{
    const fieldType = $d7d2336983f9d243$var$fieldTypesMap[strFieldType];
    if (!fieldType) throw new Error(`Failed to convert string to FieldType. Invalid field type: ${strFieldType}`);
    return fieldType;
};
const $d7d2336983f9d243$export$14a822b4b8728ff = 'PANEL';
const $d7d2336983f9d243$export$57d657a79733c8ff = 'FIELD';
const $d7d2336983f9d243$export$1616501503fc215f = (type)=>`${$d7d2336983f9d243$export$57d657a79733c8ff}:${type}`;
const $d7d2336983f9d243$export$ad2e30fb97b657d9 = (panelId)=>`${$d7d2336983f9d243$export$14a822b4b8728ff}:${panelId}`;
const $d7d2336983f9d243$export$d751f7a27494922b = (layoutItemType, dataKey)=>`${layoutItemType}.${dataKey}`;

});


parcelRegister("eZEPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f000901522116110$export$2e2bcd8739ae039);

var $jCzZZ = parcelRequire("jCzZZ");

var $ovaMM = parcelRequire("ovaMM");

var $fXJQQ = parcelRequire("fXJQQ");

var $l6Vth = parcelRequire("l6Vth");

var $cYpXY = parcelRequire("cYpXY");

var $3PVf3 = parcelRequire("3PVf3");

var $409yl = parcelRequire("409yl");

var $dEj6Z = parcelRequire("dEj6Z");
const $f000901522116110$var$transformers = {
    activeLayoutItem: (0, $jCzZZ.toActiveLayoutItem),
    field: (0, $3PVf3.transformField),
    fieldOperations: (0, $cYpXY.transformFieldOperations),
    panel: (0, $409yl.transformPanel),
    tabs: (0, $dEj6Z.transformTabs),
    category: (0, $l6Vth.transformCategory),
    activeLayoutItems: (0, $ovaMM.transformActiveLayoutItems),
    baseLayoutItems: (0, $fXJQQ.transformBaseLayoutItems)
};
var $f000901522116110$export$2e2bcd8739ae039 = $f000901522116110$var$transformers;

});
parcelRegister("jCzZZ", function(module, exports) {

$parcel$export(module.exports, "toActiveLayoutItem", () => $11d66ce5b893bd26$export$a3b4207708fef480);

var $6wesA = parcelRequire("6wesA");

var $2teXs = parcelRequire("2teXs");

var $aUDnU = parcelRequire("aUDnU");

var $4Y9LX = parcelRequire("4Y9LX");
const $11d66ce5b893bd26$export$c6c6863447265be7 = (alternateNameOrDescription)=>{
    if (alternateNameOrDescription === '') return undefined;
    return alternateNameOrDescription;
};
const $11d66ce5b893bd26$var$toField = (graphqlField, containerType, transformers)=>{
    const field = transformers.field(graphqlField, transformers);
    const { properties: properties, options: options, required: required, defaultValue: defaultValue } = graphqlField;
    const normalizedOptions = (0, $4Y9LX.normalizeOptions)(field.type, options);
    const associatedField = {
        ...field,
        category: transformers.category(containerType),
        required: required,
        options: normalizedOptions,
        alternateDescription: properties ? $11d66ce5b893bd26$export$c6c6863447265be7(properties[0, $6wesA.JSD_FIELD_HELPTEXT]) : undefined,
        defaultValue: (0, $aUDnU.normalizeDefaultValue)(field.type, defaultValue, normalizedOptions),
        configuration: field.configuration ? {
            ...field.configuration,
            // needed as otherwise `inactiveFieldLozenge` gives a type error because it is `mixed`
            // we don't expect the server to return lozenge data as it's internationalized messages
            // https://atlassian.slack.com/archives/C0271N53BB4/p1633999472180600?thread_ts=1633919728.133600&cid=C0271N53BB4
            inactiveFieldLozenge: undefined
        } : field.configuration
    };
    return {
        key: (0, $2teXs.toLayoutItemKey)((0, $2teXs.FIELD_LAYOUT_ITEM_TYPE), associatedField.key),
        layoutItemType: (0, $2teXs.FIELD_LAYOUT_ITEM_TYPE),
        data: associatedField,
        operations: field.operations,
        category: associatedField.category
    };
};
const $11d66ce5b893bd26$var$toPanel = (graphqlPanel, containerType, transformers)=>{
    const panel = transformers.panel(graphqlPanel, transformers);
    const category = transformers.category(containerType);
    return {
        key: (0, $2teXs.toLayoutItemKey)((0, $2teXs.PANEL_LAYOUT_ITEM_TYPE), panel.key),
        layoutItemType: (0, $2teXs.PANEL_LAYOUT_ITEM_TYPE),
        data: panel,
        operations: panel.operations,
        category: category
    };
};
const $11d66ce5b893bd26$export$a3b4207708fef480 = (graphqlItem, containerType, transformers)=>{
    switch(graphqlItem.__typename){
        case 'JiraIssueLayoutFieldItemConfiguration':
            return $11d66ce5b893bd26$var$toField(graphqlItem, containerType, transformers);
        case 'JiraIssueLayoutPanelItemConfiguration':
            return $11d66ce5b893bd26$var$toPanel(graphqlItem, containerType, transformers);
        default:
            return null;
    }
};

});
parcelRegister("aUDnU", function(module, exports) {

$parcel$export(module.exports, "normalizeDefaultValue", () => $9507c154fe021365$export$4f16ba0d07769755);

var $2EudM = parcelRequire("2EudM");
const $9507c154fe021365$var$mapOptimisticId = (o)=>{
    if (o != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    typeof o.value === 'string' && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    typeof o.id === 'number' && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    !Number.isNaN(o.id)) // optimisticId is used for rendering options, DnD, etc... We map the option id to ensure this method remains idempotent.
    return {
        ...o,
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        optimisticId: o.id.toString()
    };
    return o;
};
const $9507c154fe021365$var$mapDefaultValueFromOptions = (defaultValue, options)=>{
    let matchingOption;
    // We need to copy the externalUuid from the options to the default value as existing default values currently do not have uuids
    // This will be able to be removed once there are external uuids on all existing default values
    if (defaultValue != null && typeof defaultValue === 'object' && // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'object'.
    typeof defaultValue.id === 'number') // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'object'.
    matchingOption = options.find((option)=>option.id === defaultValue.id);
    return {
        // @ts-expect-error - Spread types may only be created from object types.
        ...$9507c154fe021365$var$mapOptimisticId(defaultValue),
        externalUuid: matchingOption?.externalUuid,
        parentId: matchingOption?.parentId,
        parentExternalUuid: matchingOption?.parentExternalUuid
    };
};
const $9507c154fe021365$export$4f16ba0d07769755 = (fieldType, defaultValue, options)=>{
    // GraphQL API (GET) will return empty default values as null, while the REST API (PUT) will return undefined.
    // We return undefined values as null to ensure we can reliably compare empty default values.
    if (defaultValue === undefined || defaultValue === null) return undefined;
    if (!(0, $2EudM.doesFieldTypeSupportOptions)(fieldType)) return defaultValue;
    // Ensure default values for field types which support options correctly map optimisticId. When an option is
    // selected as the default value on the UI it will have an optimisticId, so we must ensure default values from the
    // server also have this property or else dirty field checks will fail.
    if (options === undefined) {
        if (Array.isArray(defaultValue)) return defaultValue.map((value)=>$9507c154fe021365$var$mapOptimisticId(value));
        return $9507c154fe021365$var$mapOptimisticId(defaultValue);
    }
    if (Array.isArray(defaultValue)) return defaultValue.map((value)=>$9507c154fe021365$var$mapDefaultValueFromOptions(value, options));
    return $9507c154fe021365$var$mapDefaultValueFromOptions(defaultValue, options);
};

});
parcelRegister("2EudM", function(module, exports) {

$parcel$export(module.exports, "doesFieldTypeSupportOptions", () => $c62ae0cbb3df30bc$export$74e747afb28d949d);

var $5fc53 = parcelRequire("5fc53");

var $3XO6n = parcelRequire("3XO6n");
const $c62ae0cbb3df30bc$export$74e747afb28d949d = (fieldType)=>[
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $3XO6n.CASCADINGSELECT_FIELD_TYPE),
        (0, $3XO6n.RADIO_FIELD_TYPE),
        (0, $3XO6n.SELECT_FIELD_TYPE),
        (0, $3XO6n.CHECKBOX_FIELD_TYPE),
        (0, $3XO6n.MULTISELECT_FIELD_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE)
    ].includes(fieldType);

});


parcelRegister("4Y9LX", function(module, exports) {

$parcel$export(module.exports, "normalizeOptions", () => $3c71e9845af3b3ae$export$eb806c0b85b62f7a);

var $7Jxgt = parcelRequire("7Jxgt");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");

var $g5X3G = parcelRequire("g5X3G");

var $6wesA = parcelRequire("6wesA");

var $2EudM = parcelRequire("2EudM");
const $3c71e9845af3b3ae$var$printShape = (option)=>{
    if (option == null || typeof option !== 'object') return `${typeof option}`;
    // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'object'. | TS2339 - Property 'value' does not exist on type 'object'.
    return `{ id: ${typeof option.id}, value: ${typeof option.value} }`;
};
// Some field options do not have a defined `externalUuid` e.g. JSM CMP cascading select.
// We 'repair' the options by adding a uuid where it is missing.
// This ensures that the options are linked correctly.
const $3c71e9845af3b3ae$var$repairMissingUuids = (arr)=>arr.map((opt)=>{
        if (opt != null && typeof opt === 'object') return {
            ...opt,
            externalUuid: // @ts-expect-error - TS2339 - Property 'externalUuid' does not exist on type 'object'. | TS2339 - Property 'externalUuid' does not exist on type 'object'. | TS2339 - Property 'externalUuid' does not exist on type 'object'.
            opt.externalUuid != null && opt.externalUuid !== '' ? opt.externalUuid : (0, $7Jxgt.v4)()
        };
        return opt;
    });
const $3c71e9845af3b3ae$var$getUuidsMap = (arr)=>arr.reduce((map, opt)=>{
        if (opt != null && typeof opt === 'object' && // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'object'.
        typeof opt.id === 'number' && // @ts-expect-error - TS2339 - Property 'externalUuid' does not exist on type 'object'.
        typeof opt.externalUuid === 'string') {
            // @ts-expect-error - TS2339 - Property 'id' does not exist on type '{}'.
            const { id: id } = opt;
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...map,
                // @ts-expect-error - TS2339 - Property 'externalUuid' does not exist on type 'object'.
                [id]: (0, $g5X3G.toOptionUuid)(opt.externalUuid) || null
            };
        }
        return map;
    }, {});
const $3c71e9845af3b3ae$export$eb806c0b85b62f7a = (fieldType, arr)=>{
    if (!(0, $2EudM.doesFieldTypeSupportOptions)(fieldType)) return undefined;
    if (!Array.isArray(arr)) return [];
    const options = [];
    const repairedArr = $3c71e9845af3b3ae$var$repairMissingUuids(arr);
    const uuidsMap = $3c71e9845af3b3ae$var$getUuidsMap(repairedArr);
    repairedArr.forEach((o)=>{
        if (o != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        typeof o.value === 'string' && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        typeof o.id === 'number' && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        !Number.isNaN(o.id)) {
            let externalUuid;
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            if (typeof o.externalUuid === 'string') // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            externalUuid = (0, $g5X3G.toOptionUuid)(o.externalUuid);
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS2571 - Object is of type 'unknown'.
            const parentId = typeof o.parentId === 'number' ? o.parentId : null;
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'unknown'.
            const { value: value, color: color, colour: colour } = o;
            // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'unknown'.
            const { id: id } = o;
            // optimisticId is used for rendering options, DnD, etc... We map the option id to ensure this method
            // remains idempotent
            const optimisticId = id.toString();
            options.push({
                value: value,
                id: id,
                optimisticId: optimisticId,
                externalUuid: externalUuid,
                parentId: parentId,
                colour: color?.colorKey || colour,
                parentExternalUuid: parentId != null && uuidsMap[parentId] ? uuidsMap[parentId] : null
            });
        } else {
            (0, $1RLjE.logError)((0, $6wesA.PACKAGE_NAME), (0, $gl0PU.toErrorId)('fieldsNormalizer.invalidOption'), (0, $gl0PU.toErrorMessage)(`Option not defined or option has no "value" or no "id": ${$3c71e9845af3b3ae$var$printShape(o)}`));
            throw new Error('Option not defined or option has no "value" or no "id". (issue-type-page.services.issue-type.normalizer)');
        }
    });
    return options;
};

});


parcelRegister("ovaMM", function(module, exports) {

$parcel$export(module.exports, "createLayoutItemsIndex", () => $754eb26fcca068ea$export$7bcdeed98221acf2);
$parcel$export(module.exports, "transformActiveLayoutItems", () => $754eb26fcca068ea$export$754f64f8ca043bac);
/**
 * It may happen that a field or layout item is referenced but the actual data never arrives.
 * In case a customer adds a field to Field screen tab, then deletes it,
 * the tab will still remember the field reference even though the entity is gone.
 *
 * We should filter such references away.
 */ const $754eb26fcca068ea$var$getMatchingNode = (nodeMap, containerItemId)=>nodeMap.get(containerItemId);
const $754eb26fcca068ea$export$7bcdeed98221acf2 = (nodes)=>{
    const fieldsById = new Map();
    const panelsById = new Map();
    for(let i = 0; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.__typename === 'JiraIssueLayoutFieldItemConfiguration') fieldsById.set(node.fieldItemId, node);
        if (node.__typename === 'JiraIssueLayoutPanelItemConfiguration') panelsById.set(node.panelItemId, node);
    }
    return {
        fieldsById: fieldsById,
        panelsById: panelsById
    };
};
const $754eb26fcca068ea$export$754f64f8ca043bac = (containers, fieldsById, panelsById, transformers)=>{
    // Flatten and sort all our container nodes by their container position
    const containerNodesWithContainerType = containers// TODO MCD-2079 Update schema types so containers does not allow nullish items
    .filter(Boolean).reduce((accum, container)=>{
        if (!container || !container.containerType || !container.items || !container.items.nodes) throw new Error('Failed to load initial data. No containers for active layout items');
        const { containerType: containerType, items: { nodes: nodes } } = container;
        const nodesWithCategory = nodes// TODO MCD-2079 Update schema types so containers does not allow nullish items
        .filter(Boolean).map((node)=>({
                containerType: containerType,
                node: node,
                containerPosition: node?.__typename === 'JiraIssueItemFieldItem' ? node.containerPosition : undefined
            }));
        return accum.concat(nodesWithCategory);
    }, [])// Sort the flattened list by container position. Currently only fields have this data so if it's undefined for
    // either item then retain the original sort order.
    // TODO This logic exists purely for JSM CMP to support merging data from multiple containers into a single
    //  category in the UI. Ideally this logic should live in JSM transformer code (or better yet abolish category merging).
    .sort(({ containerPosition: a }, { containerPosition: b })=>a === undefined || b === undefined ? 0 : a - b);
    return containerNodesWithContainerType.flatMap((containerNodeWithContainerType)=>{
        const { containerType: containerType, node: node } = containerNodeWithContainerType;
        switch(node.__typename){
            case 'JiraIssueItemFieldItem':
                {
                    const matchingNode = $754eb26fcca068ea$var$getMatchingNode(fieldsById, node.fieldItemId);
                    if (!matchingNode) return null;
                    return transformers.activeLayoutItem(matchingNode, containerType, transformers);
                }
            case 'JiraIssueItemPanelItem':
                {
                    const matchingNode = $754eb26fcca068ea$var$getMatchingNode(panelsById, node.panelItemId);
                    if (!matchingNode) return null;
                    return transformers.activeLayoutItem(matchingNode, containerType, transformers);
                }
            case 'JiraIssueItemTabContainer':
                // Screen tabs cannot have panels in them; only fields.
                if (node.items == null || node.items.nodes == null) return null;
                return node.items.nodes.filter(Boolean).map(({ fieldItemId: fieldItemId })=>$754eb26fcca068ea$var$getMatchingNode(fieldsById, fieldItemId)).filter(Boolean).map((matchingNode)=>transformers.activeLayoutItem(matchingNode, containerType, transformers));
            default:
                // We ignore all unsupported layout items as we expect them to be mapped separately, e.g. tabs.
                return null;
        }
    }).filter(Boolean);
};

});

parcelRegister("l6Vth", function(module, exports) {

$parcel$export(module.exports, "transformCategory", () => $427dedaa8a5e219e$export$364bf3353be1fa6d);

var $in90R = parcelRequire("in90R");
const $427dedaa8a5e219e$export$364bf3353be1fa6d = (containerType)=>(0, $in90R.toFieldCategory)(containerType.toLowerCase());

});

parcelRegister("cYpXY", function(module, exports) {

$parcel$export(module.exports, "transformFieldOperations", () => $c50a2d230f6e76a3$export$937bfa4b23d5e7bf);
$parcel$export(module.exports, "transformFieldOperationsAdapter", () => $c50a2d230f6e76a3$export$b13ca4908b83d782);
const $c50a2d230f6e76a3$export$937bfa4b23d5e7bf = (operations, transformers)=>{
    const { editable: editable, canModifyRequired: canModifyRequired, canModifyOptions: canModifyOptions, canModifyDefaultValue: canModifyDefaultValue, canModifyPropertyConfiguration: canModifyPropertyConfiguration, removable: removable, deletable: deletable, canAssociateInSettings: canAssociateInSettings, categoriesWhitelist: categoriesWhitelist } = operations || {};
    const cleanCategoriesWhitelist = categoriesWhitelist.reduce((categoryAccum, categoryWhitelist)=>{
        if (categoryWhitelist === undefined || categoryWhitelist === null) return categoryAccum;
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...categoryAccum,
            transformers.category(categoryWhitelist)
        ];
    }, []);
    return {
        editable: editable,
        canModifyRequired: canModifyRequired,
        canModifyOptions: canModifyOptions,
        canModifyDefaultValue: canModifyDefaultValue,
        canModifyPropertyConfiguration: canModifyPropertyConfiguration,
        removable: removable,
        deletable: deletable,
        canAssociateInSettings: canAssociateInSettings,
        categoriesWhitelist: cleanCategoriesWhitelist
    };
};
const $c50a2d230f6e76a3$export$b13ca4908b83d782 = (operations, transformers)=>{
    if (!operations) throw new Error('Failed to load initial data. No field operations');
    return transformers.fieldOperations(operations, transformers);
};

});

parcelRegister("3PVf3", function(module, exports) {

$parcel$export(module.exports, "transformField", () => $e148b94d39d75d12$export$fbce423ada1f57a0);

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");

var $cYpXY = parcelRequire("cYpXY");

var $4Y9LX = parcelRequire("4Y9LX");
/**
 * Transform field provider data from GraphQL into a SWIFT compatible {@link FieldProvider} object.
 */ const $e148b94d39d75d12$var$transformProvider = (provider)=>{
    const { key: providerKey, name: providerName } = provider || {
        key: '',
        name: ''
    };
    return {
        key: providerKey,
        name: providerName
    };
};
const $e148b94d39d75d12$var$transformIsHiddenIn = (isHiddenIn)=>{
    if (isHiddenIn == null) return null;
    const hiddenIn = [];
    const transformFieldConfig = ({ id: id, configName: name })=>({
            id: id,
            name: name
        });
    for (const configuration of isHiddenIn){
        if (configuration.__typename === 'JiraIssueLayoutFieldConfigurationHiddenInGlobal') {
            const { fieldConfigs: fieldConfigs } = configuration;
            hiddenIn.push({
                fieldConfigs: (fieldConfigs || []).map(transformFieldConfig)
            });
        }
        if (configuration.__typename === 'JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner') {
            const { fieldConfigs: fieldConfigs, layoutOwnerId: layoutOwnerId } = configuration;
            hiddenIn.push({
                layoutOwnerId: layoutOwnerId,
                fieldConfigs: (fieldConfigs || []).map(transformFieldConfig)
            });
        }
    }
    return hiddenIn;
};
const $e148b94d39d75d12$var$transformContext = (context)=>{
    if (context == null) return null;
    const transformedContext = {
        id: context.id,
        issueTypeIds: context.layoutOwnerIds
    };
    return transformedContext;
};
const $e148b94d39d75d12$var$transformDisplayConditions = (displayConditions)=>{
    if (displayConditions == null) return null;
    const keys = Object.keys(displayConditions);
    const simpleProjectDisplayConditionList = [
        'projectKey',
        'projectType',
        'projectId',
        'projectName'
    ];
    const transformedDisplayConditions = {
        ...displayConditions,
        // for single issue type and project conditions we can evaluate whether the field is hidden
        // on frontend side and provide admins more specific information about field visibility
        isSimpleIssueTypeDisplayCondition: keys.length === 1 && keys[0] === 'issueType',
        isSimpleProjectDisplayCondition: keys.length === 1 && simpleProjectDisplayConditionList.includes(keys[0])
    };
    return transformedDisplayConditions;
};
const $e148b94d39d75d12$var$transformAvailability = (availability)=>{
    if (availability == null) return null;
    const hiddenIn = $e148b94d39d75d12$var$transformIsHiddenIn(availability.isHiddenIn);
    const context = $e148b94d39d75d12$var$transformContext(availability.context);
    const displayConditions = $e148b94d39d75d12$var$transformDisplayConditions(availability.displayConditions);
    const { isHiddenByAppAccessRules: isHiddenByAppAccessRules } = availability;
    return {
        hiddenIn: hiddenIn,
        context: context,
        displayConditions: displayConditions,
        isHiddenByAppAccessRules: isHiddenByAppAccessRules
    };
};
const $e148b94d39d75d12$export$fbce423ada1f57a0 = (field, transformers)=>{
    const { name: name, key: key, externalUuid: externalUuid, type: type, custom: custom, global: global, description: description, options: options, operations: operations, provider: provider, availability: availability, configuration: configuration, properties: properties } = field;
    return {
        name: name,
        key: key,
        externalUuid: (0, $g5X3G.toFieldUuid)(externalUuid || ''),
        type: type,
        custom: custom,
        global: global,
        description: description || '',
        options: (0, $4Y9LX.normalizeOptions)(type, options),
        operations: (0, $cYpXY.transformFieldOperationsAdapter)(operations, transformers),
        provider: $e148b94d39d75d12$var$transformProvider(provider),
        ...(0, $4R6GH.fg)('forge_custom_fields_on_jsm_portal_create') ? {
            properties: properties
        } : {},
        availability: $e148b94d39d75d12$var$transformAvailability(availability),
        configuration: configuration
    };
};

});

parcelRegister("409yl", function(module, exports) {

$parcel$export(module.exports, "transformPanel", () => $0731b2503fdd0428$export$60d1c3eaec086df6);

var $in90R = parcelRequire("in90R");
const $0731b2503fdd0428$var$defaultPanelOperations = {
    editable: false,
    removable: false,
    categoriesWhitelist: [],
    canAssociateInSettings: true,
    deletable: false
};
const $0731b2503fdd0428$export$60d1c3eaec086df6 = (panel)=>{
    const { panelItemId: panelItemId, name: name, operations: { __typename: __typename, categoriesWhitelist: categoriesWhitelist, ...cleanOperations } } = panel;
    return {
        // TODO MCD-2079 We need a proper key that we can use on the FE to distinguish between panel types
        key: panelItemId,
        name: name,
        operations: {
            ...$0731b2503fdd0428$var$defaultPanelOperations,
            ...cleanOperations,
            categoriesWhitelist: categoriesWhitelist.map((0, $in90R.toFieldCategory))
        }
    };
};

});

parcelRegister("dEj6Z", function(module, exports) {

$parcel$export(module.exports, "transformTabs", () => $81685509aae11edd$export$f758e80fe860c5b8);

var $2teXs = parcelRequire("2teXs");
const $81685509aae11edd$export$f758e80fe860c5b8 = (containers, fieldsById, transformers)=>{
    const accumulator = {};
    return containers.reduce((accum, container)=>{
        const { containerType: containerType, items: items } = container;
        if (!containerType || !items || !items.nodes) throw new Error('Failed to load initial data. No containers for tabs.');
        const tabsInContainer = items.nodes.map((node)=>{
            if (node && node.__typename === 'JiraIssueItemTabContainer' && node.name != null && node.items != null && node.items.nodes != null) {
                const { tabContainerId: tabContainerId, name: name } = node;
                const layoutItems = node.items.nodes// TODO MCD-2079 Update schema types so nodes does not allow nullish items
                .filter(Boolean).map((fieldNode)=>{
                    // TODO: Need to understand & update logic code to fix this issue, e.g. checking null and return a default value
                    const matchingFieldItem = fieldsById.get(fieldNode.fieldItemId);
                    if (matchingFieldItem) return {
                        // The API only allows to put fields in tabs so we can hardcode this one
                        layoutItemType: (0, $2teXs.FIELD_LAYOUT_ITEM_TYPE),
                        layoutItemKey: (0, $2teXs.toLayoutItemKey)((0, $2teXs.FIELD_LAYOUT_ITEM_TYPE), matchingFieldItem.key)
                    };
                    // Ignore tab nodes which don't have a matching field item. We don't expect this to happen
                    // but if it does we probably don't want to crash the app.
                    return null;
                }).filter(Boolean);
                return {
                    tabContainerId: tabContainerId,
                    name: name,
                    layoutItems: layoutItems
                };
            }
            return null;
        }).filter(Boolean);
        if (tabsInContainer.length === 0) /*
			 * This part is important.
			 * From SWIFT point of view, there is a difference between "There is <empty list> of tabs" and "There is <null> of tabs"
			 * because they mean different things:
			 * - Empty list of tabs means that there are no tabs at the moment _but there could be_.
			 *         This makes SWIFT render tab UI (in M2 it will have "Add a tab" button) and ignore the root layout items completely.
			 * - "null" tabs means that the category has no tabs feature.
			 *         This makes SWIFT ignore the tabs, and render "root" layout items, as if there were no tabs at all.
			 */ return accum;
        // Extract category name from container type
        const category = transformers.category(containerType);
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accum,
            [String(category)]: tabsInContainer
        };
    }, accumulator);
};

});




parcelRegister("7E1yI", function(module, exports) {

$parcel$export(module.exports, "FieldToolbarNoAction", () => $79f21f879421c47e$export$6dbc1805e389b650);

var $5uXOq = parcelRequire("5uXOq");

var $jvpJu = parcelRequire("jvpJu");
const $79f21f879421c47e$export$6dbc1805e389b650 = ({ fieldCreator: fieldCreator, issueTypeName: issueTypeName, intl: { formatMessage: formatMessage }, messages: messages, isAppField: isAppField })=>{
    const descriptionMessage = isAppField ? messages.noActionFieldToolbarDescriptionAppField : messages.noActionFieldToolbarDescription;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvpJu.default), {
        dropHighlight: false,
        header: formatMessage(messages.noActionFieldToolbarHeader),
        description: formatMessage(descriptionMessage, {
            fieldCreator: fieldCreator,
            issueTypeName: issueTypeName
        })
    });
};

});
parcelRegister("jvpJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $96adc268e809499c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gwIPs = parcelRequire("gwIPs");

var $hPw0Z = parcelRequire("hPw0Z");

var $fVP4X = parcelRequire("fVP4X");
/*
 * View without the Drag&Drop decorators is in separate component to enable easy testing
 */ const $96adc268e809499c$var$FieldToolbarOverlay = (props)=>{
    const { header: header, description: description, isDraggingOver: isDraggingOver, dropHighlight: dropHighlight } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($96adc268e809499c$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($96adc268e809499c$export$40f4eb1b1236c803, {
        isDraggingOver: isDraggingOver,
        dropHighlight: dropHighlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($96adc268e809499c$export$fead96407cda089b, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($96adc268e809499c$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($96adc268e809499c$var$Column, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($96adc268e809499c$var$ImgWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVP4X.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h5", null, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($96adc268e809499c$var$Description, null, description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($96adc268e809499c$var$MarginBottom, null)));
};
$96adc268e809499c$var$FieldToolbarOverlay.defaultProps = {
    isDraggingOver: false,
    dropHighlight: true
};
const $96adc268e809499c$var$marginMax = 10 * (0, $gwIPs.gridSize);
const $96adc268e809499c$var$dropzoneBorderColor = "var(--ds-border-brand, #0C66E4)";
const $96adc268e809499c$var$dropzoneBackgroundColor = "var(--ds-background-selected, #E9F2FF)";
const $96adc268e809499c$var$dropzoneBackgroundHoverColor = "var(--ds-background-selected-hovered, #CCE0FF)";
const $96adc268e809499c$var$transitionSpeed = '0.3s';
var $96adc268e809499c$export$2e2bcd8739ae039 /*
                                     * CSS does not have max-margin so we have to fake it with flexbox grow elements
                                     */  = $96adc268e809499c$var$FieldToolbarOverlay;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96adc268e809499c$var$MarginBottom = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12itq89-0"
})({
    flexGrow: 1
});
/*
 * Content must be display: block so that the content height is computed properly.
 *
 * !! CAREFUL HERE !!
 *
 * ^^^^^^^^^^^^^^^^^^
 *
 * As this is somehow brittle and introducing overflow or display or position property breaks the vertical shrinking.
 * Always make sure to see the storybooks after changing this!
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96adc268e809499c$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $96adc268e809499c$var$Column = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _y3gn1h6o _1bah1h6o _2lx21bp4 _19pku2gc _2hwx1wug _otyru2gc _18u01wug _ca0qidpf _u5f3pxbi _n3tdidpf _19bvpxbi _1reo15vq",
            __cmplp.className
        ])
    });
});
const $96adc268e809499c$var$ImgWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i68cl",
            __cmplp.className
        ])
    });
});
const $96adc268e809499c$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $96adc268e809499c$var$CoverAllOfParent = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12itq89-1"
})({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
});
const $96adc268e809499c$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $47bDC.default)($96adc268e809499c$var$CoverAllOfParent).withConfig({
    componentId: "sc-12itq89-2"
})({
    zIndex: 0
});
const $96adc268e809499c$export$fead96407cda089b = /*#__PURE__*/ (0, $47bDC.default)($96adc268e809499c$var$MarginBottom).withConfig({
    componentId: "sc-12itq89-3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${$96adc268e809499c$var$marginMax}px`
});
// FIXME: convert-props-syntax doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $96adc268e809499c$var$dropzoneMixin = /*#__PURE__*/ (0, $47bDC.css)`border-width:2px;border-style:dashed;border-radius:${(0, $hPw0Z.fieldBorderRadius)};border-color:${$96adc268e809499c$var$dropzoneBorderColor};transition:border-color ${$96adc268e809499c$var$transitionSpeed},background-color ${$96adc268e809499c$var$transitionSpeed};background-color:${(props)=>props.isDraggingOver ? $96adc268e809499c$var$dropzoneBackgroundHoverColor : $96adc268e809499c$var$dropzoneBackgroundColor};`;
const $96adc268e809499c$export$40f4eb1b1236c803 = /*#__PURE__*/ (0, $47bDC.default)($96adc268e809499c$var$CoverAllOfParent).withConfig({
    componentId: "sc-12itq89-4"
})({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-subtle, #44546F)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.dropHighlight ? // FIXME: type error in object syntax passing result of `css` to `css`
    // WORKAROUND: just return `dropzoneMixin` without `css()`
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)`${$96adc268e809499c$var$dropzoneMixin};` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    }));
const $96adc268e809499c$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hPw0Z", function(module, exports) {

$parcel$export(module.exports, "fieldBorderRadius", () => $2b2da31fd709e8e9$export$15e9f67cce6dc5d3);
$parcel$export(module.exports, "cardHeight", () => $2b2da31fd709e8e9$export$49f4a98b6a099a3d);
$parcel$export(module.exports, "cardBodyPadding", () => $2b2da31fd709e8e9$export$5d96e258b2d2244);
$parcel$export(module.exports, "Margin", () => $2b2da31fd709e8e9$export$e717bcf55e1dfb40);
$parcel$export(module.exports, "FieldHeaderContainer", () => $2b2da31fd709e8e9$export$54616bd4295662a1);
$parcel$export(module.exports, "LozengeContainer", () => $2b2da31fd709e8e9$export$d5aa9dc8584e2976);
$parcel$export(module.exports, "FieldContentAnimation", () => $2b2da31fd709e8e9$export$7bb1463b5f54a09e);
$parcel$export(module.exports, "IconContainer", () => $2b2da31fd709e8e9$export$8f314e512d92575f);
$parcel$export(module.exports, "FieldStatusIconContainer", () => $2b2da31fd709e8e9$export$b83c5a9f1d0abe35);
$parcel$export(module.exports, "Form", () => $2b2da31fd709e8e9$export$a7fed597f4b8afd8);
$parcel$export(module.exports, "ErrorMessageLabel", () => $2b2da31fd709e8e9$export$3141257108f2e56a);
$parcel$export(module.exports, "InfoMessageWrapper", () => $2b2da31fd709e8e9$export$97173cdcc119e274);
$parcel$export(module.exports, "InfoMessageNotDraggable", () => $2b2da31fd709e8e9$export$1980a4e5fdf12c1d);
$parcel$export(module.exports, "Footer", () => $2b2da31fd709e8e9$export$a06f1c675e846f6f);
$parcel$export(module.exports, "AkFieldWrapper", () => $2b2da31fd709e8e9$export$12ed92aa8287efd8);
$parcel$export(module.exports, "PullRight", () => $2b2da31fd709e8e9$export$bf037e71be93ba07);
$parcel$export(module.exports, "ChevronContainer", () => $2b2da31fd709e8e9$export$f25bd028f55b3d30);
$parcel$export(module.exports, "HiddenSubmitInput", () => $2b2da31fd709e8e9$export$9e49b67bb461e0fb);
$parcel$export(module.exports, "Elevation", () => $2b2da31fd709e8e9$export$58bfb4f6ec5aa58d);
$parcel$export(module.exports, "FieldConfigurationDefaultValue", () => $2b2da31fd709e8e9$export$7f5c7b83403d9260);
$parcel$export(module.exports, "CheckboxFieldConfigurationDefaultValue", () => $2b2da31fd709e8e9$export$bdb5806e572f48a3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $2QzwR = parcelRequire("2QzwR");

var $gwIPs = parcelRequire("gwIPs");

var $dq3xR = parcelRequire("dq3xR");

var $2tk6O = parcelRequire("2tk6O");
const $2b2da31fd709e8e9$export$15e9f67cce6dc5d3 = '3px';
const $2b2da31fd709e8e9$var$FIELD_ANIMATION_DURATION = 250;
const $2b2da31fd709e8e9$var$placeholderColor = "var(--ds-text-subtlest, #626F86)";
const $2b2da31fd709e8e9$var$padding = (0, $gwIPs.gridSize);
const $2b2da31fd709e8e9$export$507197e0ca3872c2 = (0, $gwIPs.gridSize) * 2;
const $2b2da31fd709e8e9$var$border = (0, $gwIPs.gridSize) / 4;
const $2b2da31fd709e8e9$var$elementHeight = (0, $gwIPs.gridSize) * 3;
const $2b2da31fd709e8e9$var$animationDuration = `${$2b2da31fd709e8e9$var$FIELD_ANIMATION_DURATION}ms`;
const $2b2da31fd709e8e9$var$animationParams = `${$2b2da31fd709e8e9$var$animationDuration} cubic-bezier(0.15, 1, 0.3, 1)`;
const $2b2da31fd709e8e9$export$49f4a98b6a099a3d = 2 * $2b2da31fd709e8e9$var$padding + 2 * $2b2da31fd709e8e9$var$border + $2b2da31fd709e8e9$var$elementHeight;
const $2b2da31fd709e8e9$export$6d949f1cb5d9ba43 = $2b2da31fd709e8e9$var$elementHeight + (0, $gwIPs.gridSize); // MC-806
const $2b2da31fd709e8e9$export$5d96e258b2d2244 = 5 * (0, $gwIPs.gridSize); /* Margins!
                                              * Must be:
                                              * + bottom because if it's up + bottom then different margin collapsing rules apply for Draggables and placeholders
                                              *
                                              * If you change these make sure that D&D still works. Moving items between lists, reordering, and aborting the drag
                                              * should not cause visible jumps, all should animate back to its please seamlessly.
                                              */ 
const $2b2da31fd709e8e9$export$9f1a27e99c71fcf9 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-0"
})({
    marginBottom: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        marginBottom: 0
    }
});
const $2b2da31fd709e8e9$export$e717bcf55e1dfb40 = ({ innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        ref: innerRef,
        ...rest,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _otyr1b66 _19pkidpf _dxh9idpf"
        ])
    }, children);
const $2b2da31fd709e8e9$var$hoverMixin = `
    &:hover {
        background-color: ${"var(--ds-background-input-hovered, #F7F8F9)"};
    }
`;
const $2b2da31fd709e8e9$var$shrinks = `
    min-width: 0;
    flex-shrink: 1;
    overflow-x: hidden;
    overflow-y: hidden;
    text-overflow: ellipsis;
`; /* stylelint-disable no-descending-specificity */ 
const $2b2da31fd709e8e9$export$54616bd4295662a1 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-1"
})({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${$2b2da31fd709e8e9$var$padding}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `${$2b2da31fd709e8e9$var$border}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginRight: `${$2b2da31fd709e8e9$var$padding}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > *:last-child,[data-isEditable][data-testid="project-settings-apps-issue-type-page.field-item-navigation-dropdown-menu.dropdown-menu--trigger"]': {
        marginRight: 0
    }
}); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$d5aa9dc8584e2976 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-2"
})({
    marginLeft: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        verticalAlign: "'text-bottom !important'"
    }
}); // `& > :first-child` - when not expanded, we should not display the child elements
const $2b2da31fd709e8e9$export$7bb1463b5f54a09e = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-3"
})((props)=>({
        transition: `height ${$2b2da31fd709e8e9$var$animationParams}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.isExpanded ? `${props.height}px` : '0px',
        /* We only want to hide overflow during height animation, otherwise popups inside field configuration will also be
     hidden (e.g. select dropdowns) */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        overflow: props.isAnimating ? 'hidden' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& > div > :first-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            paddingTop: props.isExpanded ? `${$2b2da31fd709e8e9$export$507197e0ca3872c2 - $2b2da31fd709e8e9$var$padding}px` : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginTop: props.isExpanded ? undefined : 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& > div > :first-child:last-child': {
            marginTop: 0
        }
    })); /* stylelint-enable no-descending-specificity */ 
const $2b2da31fd709e8e9$export$8f314e512d92575f = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-114epgy-4"
})({
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$2b2da31fd709e8e9$var$elementHeight}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$2b2da31fd709e8e9$var$elementHeight}px`,
    borderRadius: $2b2da31fd709e8e9$export$15e9f67cce6dc5d3,
    textAlign: 'center',
    flexShrink: 0
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$b83c5a9f1d0abe35 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _18u0u2gc _syazwdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$a7fed597f4b8afd8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $2b2da31fd709e8e9$export$3141257108f2e56a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-5"
})`padding-right:${$2b2da31fd709e8e9$export$6d949f1cb5d9ba43}px;padding-left:${$2b2da31fd709e8e9$export$6d949f1cb5d9ba43 + (0, $gwIPs.gridSize)}px;margin-bottom:${$2b2da31fd709e8e9$export$507197e0ca3872c2}px;> ${(0, $dq3xR.InlineErrorMessageWrapper)}{margin-top:0;}`; // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$97173cdcc119e274 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-6"
})({
    padding: `0 ${"var(--ds-space-500, 40px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBottom: `${$2b2da31fd709e8e9$export$507197e0ca3872c2}px`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$1980a4e5fdf12c1d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80om1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-7"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${$2b2da31fd709e8e9$var$padding}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`,
    display: 'flex',
    justifyContent: 'space-between'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$2b2da31fd709e8e9$var$shrinks); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$12ed92aa8287efd8 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-8"
})({
    cursor: 'text',
    flexGrow: 1,
    maxWidth: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& label > div': {
        paddingTop: 0
    },
    /* The Field component from @atlaskit/form has a built-in margin-top which conflicts with our existing */ /* spacing. We could adopt this spacing everywhere but there are some components which don't use Field */ /* (e.g. LabelsPicker), so overriding the Field component margin here is the path of least resistance. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> div': {
        marginTop: 0
    }
}); /* stylelint-disable no-descending-specificity */ 
const $2b2da31fd709e8e9$export$bf037e71be93ba07 = /*#__PURE__*/ (0, $47bDC.default).section.withConfig({
    componentId: "sc-114epgy-9"
})`display:flex;flex-wrap:nowrap;flex-direction:row;justify-content:flex-end;flex:1 1 auto;min-width:0;align-items:center;& > *{margin-left:${"var(--ds-space-100, 8px)"};margin-right:${"var(--ds-space-100, 8px)"};${$2b2da31fd709e8e9$var$shrinks};}& > *:last-child{margin-right:0;}`;
const $2b2da31fd709e8e9$export$f25bd028f55b3d30 = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-114epgy-10"
})((props)=>({
        cursor: 'pointer',
        display: 'flex',
        height: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${$2b2da31fd709e8e9$var$elementHeight}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: `${3 * (0, $gwIPs.gridSize)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button > span': {
            transition: `transform ${$2b2da31fd709e8e9$var$animationParams}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: props.isOpen ? 'rotate(90deg)' : undefined
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$9e49b67bb461e0fb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $2b2da31fd709e8e9$var$elevationCollapsed = /*#__PURE__*/ (0, $47bDC.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    maxHeight: '0 !important',
    overflow: 'hidden',
    padding: 0,
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    marginBottom: `${-(0, $gwIPs.gridSize) / 2}px`
}); // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $2b2da31fd709e8e9$var$sortableMixin = /*#__PURE__*/ (0, $47bDC.css)`${(props)=>props.isOpen ? '' : $2b2da31fd709e8e9$var$hoverMixin};${(props)=>{
    if (props.isDragging) return 0, $2QzwR.draggingMixin;
    return 0, $2tk6O.layoutItemNotDraggingMixin;
}};`;
const $2b2da31fd709e8e9$var$unsortableHoverMixin = /*#__PURE__*/ (0, $47bDC.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: "var(--ds-background-input-hovered, #F7F8F9)"
    }
}); // FIXME: type error passing result of `css` to `css`
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $2b2da31fd709e8e9$var$clickableMixin = /*#__PURE__*/ (0, $47bDC.css)`${$2b2da31fd709e8e9$var$unsortableHoverMixin};cursor:pointer;`;
const $2b2da31fd709e8e9$var$unsortableOrLockedMixin = /*#__PURE__*/ (0, $47bDC.css)({
    borderWidth: '1px',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderColor: `${"var(--ds-shadow-overflow-perimeter, #091e421f)"}`
}); // FIXME: type error passing result of `css` to `css`
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $2b2da31fd709e8e9$var$unsortableMixin = /*#__PURE__*/ (0, $47bDC.css)`${$2b2da31fd709e8e9$var$unsortableOrLockedMixin} ${(props)=>props.isOpen ? '' : $2b2da31fd709e8e9$var$clickableMixin};`; // FIXME: type error passing result of `css` to `css`
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $2b2da31fd709e8e9$var$lockedMixin = /*#__PURE__*/ (0, $47bDC.css)`${$2b2da31fd709e8e9$var$unsortableOrLockedMixin} cursor:not-allowed;`;
const $2b2da31fd709e8e9$export$58bfb4f6ec5aa58d = /*#__PURE__*/ (0, $47bDC.default)($2b2da31fd709e8e9$export$9f1a27e99c71fcf9).withConfig({
    componentId: "sc-114epgy-11"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: $2b2da31fd709e8e9$export$15e9f67cce6dc5d3,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isHighlighted ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "var(--ds-background-discovery-hovered, #DFD8FD)" : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "var(--ds-background-input, #FFFFFF)",
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `max-height ${$2b2da31fd709e8e9$var$animationParams}, padding ${$2b2da31fd709e8e9$var$animationParams}, margin ${$2b2da31fd709e8e9$var$animationParams}, opacity ${$2b2da31fd709e8e9$var$animationParams}, box-shadow ${$2b2da31fd709e8e9$var$animationParams}, background-color ${0, $2tk6O.LAYOUT_ITEM_HIGHLIGHTED_TRANSITION_PARAMS}`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.sortable ? $2b2da31fd709e8e9$var$sortableMixin : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>!props.sortable && props.isExpandable ? $2b2da31fd709e8e9$var$unsortableMixin : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>!props.sortable && !props.isExpandable ? $2b2da31fd709e8e9$var$lockedMixin : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isOpen ? '' : 'overflow: hidden;', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.deleteAnimation ? $2b2da31fd709e8e9$var$elevationCollapsed : '', {
    '&:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px ${"var(--ds-background-selected, #E9F2FF)"}`,
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    input: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-webkit-input-placeholder': {
            /* WebKit, Blink, Edge */ color: $2b2da31fd709e8e9$var$placeholderColor
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-moz-placeholder': {
            /* Mozilla Firefox 19+ */ color: $2b2da31fd709e8e9$var$placeholderColor,
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-ms-input-placeholder': {
            /* Microsoft Edge */ color: $2b2da31fd709e8e9$var$placeholderColor
        }
    }
});
const $2b2da31fd709e8e9$export$c1638c4c027acf2d = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-12"
})({
    /* Double ampersand to override an AK style with higher specificity */ /* https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& [data-ds--text-field--input]': {
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$2b2da31fd709e8e9$var$elementHeight}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-ds--text-field--container]': {
        border: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)"
    }
}); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2b2da31fd709e8e9$export$7f5c7b83403d9260 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114epgy-13"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingRight: `${$2b2da31fd709e8e9$export$5d96e258b2d2244}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: `${$2b2da31fd709e8e9$export$5d96e258b2d2244}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBottom: `${$2b2da31fd709e8e9$export$507197e0ca3872c2}px`,
    display: 'flex',
    flex: 1,
    flexDirection: 'row'
}); // This component has slightly less left-padding so that the checkboxes are left aligned with content above/below
const $2b2da31fd709e8e9$export$bdb5806e572f48a3 = /*#__PURE__*/ (0, $47bDC.default)($2b2da31fd709e8e9$export$7f5c7b83403d9260).withConfig({
    componentId: "sc-114epgy-14"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: `${$2b2da31fd709e8e9$export$5d96e258b2d2244 - 5}px`
});

});
parcelRegister("2QzwR", function(module, exports) {

$parcel$export(module.exports, "notDraggingMixin", () => $4be1cec804401cdb$export$9c40a8c3db24eb04);
$parcel$export(module.exports, "draggingMixin", () => $4be1cec804401cdb$export$5caff591ca542600);


var $gwIPs = parcelRequire("gwIPs");
const $4be1cec804401cdb$export$9c40a8c3db24eb04 = `
    z-index: 100;
    box-shadow: 0 1px 1px ${(0, $829f609a65d26a98$exports).N50A}, 0 0 1px ${(0, $829f609a65d26a98$exports).N60A};
`;
const $4be1cec804401cdb$export$5caff591ca542600 = `
    z-index: 300;
    box-shadow: 0 ${(0, $gwIPs.gridSize)}px ${(0, $gwIPs.gridSize) * 2}px ${-(0, $gwIPs.gridSize) / 2}px ${(0, $829f609a65d26a98$exports).N50A}, 0 0 1px ${(0, $829f609a65d26a98$exports).N60A};
`;

});

parcelRegister("dq3xR", function(module, exports) {

$parcel$export(module.exports, "InlineErrorMessageWrapper", () => $ff6844c103be280d$export$dd2d398699d3d5a1);
$parcel$export(module.exports, "default", () => $ff6844c103be280d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $dD7Zc = parcelRequire("dD7Zc");
const $ff6844c103be280d$var$InlineErrorMessage = ({ message: message, id: id, role: role })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff6844c103be280d$export$dd2d398699d3d5a1, {
        id: id,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff6844c103be280d$var$AlignedIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-text-accent-orange-bolder, #702E00)",
        LEGACY_size: "small",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, message));
var $ff6844c103be280d$export$2e2bcd8739ae039 // eslint-disable-next-line  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $ff6844c103be280d$var$InlineErrorMessage;
const $ff6844c103be280d$export$dd2d398699d3d5a1 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "hbddbn-0"
})`font:${"var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-200, 16px)"};color:${"var(--ds-text-danger, #AE2E24)"};display:flex;word-wrap:break-word;> * + *{margin-left:${"var(--ds-space-050, 4px)"};min-width:0;flex-basis:100%;}`;
// The error icon has 2px padding inside it's viewbox. We need to subtract that padding so the icon aligns correctly.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff6844c103be280d$var$AlignedIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1o9zidpf _18u01i6y",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2tk6O", function(module, exports) {

$parcel$export(module.exports, "Scrollable", () => $d745c3dc453f5632$export$fcc7818a78919c8c);
$parcel$export(module.exports, "NonShrinkableHeader", () => $d745c3dc453f5632$export$986ee592c39285c6);
$parcel$export(module.exports, "NonShrinkableFooter", () => $d745c3dc453f5632$export$1dd816b1c8c0d522);
$parcel$export(module.exports, "Column", () => $d745c3dc453f5632$export$816b5d811295e6bc);
$parcel$export(module.exports, "LAYOUT_ITEM_HIGHLIGHTED_TRANSITION_PARAMS", () => $d745c3dc453f5632$export$a8e820b7c58588a7);
$parcel$export(module.exports, "elevatedLayoutItemShadowMixin", () => $d745c3dc453f5632$export$4e9a23e49e7aad57);
$parcel$export(module.exports, "layoutItemNotDraggingMixin", () => $d745c3dc453f5632$export$35908094fb97c156);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $2QzwR = parcelRequire("2QzwR");

var $gwIPs = parcelRequire("gwIPs");
const $d745c3dc453f5632$var$scrollShadowHiderMixin = /*#__PURE__*/ (0, $47bDC.css)({
    content: "''",
    display: 'block',
    height: '2px',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    zIndex: 2,
    /* When scrollbars are visible it causes the scrollable element to shift left which means it no longer covers the
     scrollShadowMixin. We use a negative margin here to increase the width of the shadow hider to ensure the shadow
     remains hidden. This must not exceed the padding of CenteredContent to prevent overflow-x issues.  */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    margin: `0 ${-(0, $gwIPs.contentHorizontalSpacing) / 2}px`
});
const $d745c3dc453f5632$export$fcc7818a78919c8c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-9mca5c-0"
})`display:flex;flex-direction:column;height:100%;&::before{${$d745c3dc453f5632$var$scrollShadowHiderMixin};flex-shrink:0;}&::after{${$d745c3dc453f5632$var$scrollShadowHiderMixin};flex-shrink:0;margin-top:auto;}`;
const $d745c3dc453f5632$export$20d13abddb65f398 = /*#__PURE__*/ (0, $47bDC.css)({
    content: "''",
    display: 'block',
    height: '2px',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    zIndex: 1
});
const $d745c3dc453f5632$var$NonShrinkable = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-9mca5c-1"
})({
    flexShrink: 0,
    flexGrow: 0
});
const $d745c3dc453f5632$export$986ee592c39285c6 = // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $47bDC.default)($d745c3dc453f5632$var$NonShrinkable).withConfig({
    componentId: "sc-9mca5c-2"
})`&::after{${$d745c3dc453f5632$export$20d13abddb65f398};margin-bottom:${"var(--ds-space-negative-025, -2px)"};}`;
const $d745c3dc453f5632$export$1dd816b1c8c0d522 = // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $47bDC.default)($d745c3dc453f5632$var$NonShrinkable).withConfig({
    componentId: "sc-9mca5c-3"
})`&::before{${$d745c3dc453f5632$export$20d13abddb65f398};margin-top:${"var(--ds-space-negative-025, -2px)"};}`;
const $d745c3dc453f5632$export$816b5d811295e6bc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _v5ynidpf",
            __cmplp.className
        ])
    });
});
const $d745c3dc453f5632$export$a8e820b7c58588a7 = '250ms cubic-bezier(0.15, 1, 0.3, 1)'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $d745c3dc453f5632$export$4e9a23e49e7aad57 = /*#__PURE__*/ (0, $47bDC.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    boxShadow: `${"var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"}, ${"var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"}`
});
const $d745c3dc453f5632$export$35908094fb97c156 = /*#__PURE__*/ (0, $47bDC.css)`${(0, $2QzwR.notDraggingMixin)} ${$d745c3dc453f5632$export$4e9a23e49e7aad57}`;

});


parcelRegister("fVP4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1588b5b139fbc8f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $1588b5b139fbc8f7$var$NoActionSvg = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "107px",
        height: "109px",
        viewBox: "0 0 107 109",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "96",
        height: "96",
        rx: "48"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("filter", {
        x: "-6.2%",
        y: "-4.2%",
        width: "116.7%",
        height: "116.7%",
        filterUnits: "objectBoundingBox",
        id: "filter-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feOffset", {
        dx: "2",
        dy: "4",
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feGaussianBlur", {
        stdDeviation: "2",
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.035   0 0 0 0 0.118   0 0 0 0 0.259  0 0 0 0.129999995 0",
        type: "matrix",
        in: "shadowBlurOuter1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        x1: "50%",
        y1: "0.992398649%",
        x2: "50%",
        y2: "100%",
        id: "linearGradient-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "var(--ds-icon-disabled, #091E424F)",
        offset: "0%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "var(--ds-icon-accent-gray, #758195)",
        offset: "100%"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        id: "no-action",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        id: "Group",
        transform: "translate(6.000000, 4.000000)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
        id: "mask-2",
        fill: "var(--ds-background-input, #FFFFFF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
        href: "#path-1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        id: "Rectangle-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
        fill: "var(--ds-background-neutral, #091E420F)",
        fillOpacity: "1",
        filter: "url(#filter-3)",
        href: "#path-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
        fill: "var(--ds-background-input, #FFFFFF)",
        fillRule: "evenodd",
        href: "#path-1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M28.0923219,42.8104916 C27.5886589,44.6209386 27.3194444,46.5290301 27.3194444,48.5 C27.3194444,60.1976978 36.8023022,69.6805556 48.5,69.6805556 C54.425212,69.6805556 59.7821609,67.2475325 63.6262937,63.3260397 L28.0923219,42.8104916 Z M32.5155044,34.6030496 L68.5321691,55.3972807 C69.2764477,53.2351963 69.6805556,50.9147904 69.6805556,48.5 C69.6805556,36.8023022 60.1976978,27.3194444 48.5,27.3194444 C42.1198903,27.3194444 36.3986478,30.1403901 32.5155044,34.6030496 Z M48.5,79 C31.6553151,79 18,65.3446849 18,48.5 C18,31.6553151 31.6553151,18 48.5,18 C65.3446849,18 79,31.6553151 79,48.5 C79,65.3446849 65.3446849,79 48.5,79 Z",
        id: "Combined-Shape",
        fill: "url(#linearGradient-4)"
    }))));
var $1588b5b139fbc8f7$export$2e2bcd8739ae039 = $1588b5b139fbc8f7$var$NoActionSvg;

});



parcelRegister("5Aioa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2185e4e17bcb8346$export$2e2bcd8739ae039);

var $8RXs9 = parcelRequire("8RXs9");

var $6irLC = parcelRequire("6irLC");

var $2185e4e17bcb8346$export$2e2bcd8739ae039 = (0, $8RXs9.default)((0, $6irLC.default));

});
parcelRegister("6irLC", function(module, exports) {

$parcel$export(module.exports, "EmptyStateMessage", () => $ba4e90d82d5afca0$export$11e5ba4f4669e663);
$parcel$export(module.exports, "default", () => $ba4e90d82d5afca0$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Jgku = parcelRequire("1Jgku");
const $ba4e90d82d5afca0$export$11e5ba4f4669e663 = ({ message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba4e90d82d5afca0$var$Wrapper, {
        "data-testid": "project-settings-apps-issue-type-page-product-features.common.ui.empty-state.empty-state-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba4e90d82d5afca0$var$ImageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Jgku.UpdatedEmptyImg), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba4e90d82d5afca0$var$Text, null, message));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ba4e90d82d5afca0$export$2e2bcd8739ae039 = ({ emptyStateText: emptyStateText, intl: intl, issueTypeName: issueTypeName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba4e90d82d5afca0$export$11e5ba4f4669e663, {
        message: intl.formatMessage(emptyStateText, {
            issueTypeName: issueTypeName
        })
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba4e90d82d5afca0$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _4cvr1h6o _p12fdgin _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _y3gn1h6o _4t3i1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $ba4e90d82d5afca0$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $ba4e90d82d5afca0$var$ImageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgx0z",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1Jgku", function(module, exports) {

$parcel$export(module.exports, "UpdatedEmptyImg", () => $718bd7b79f2e4f1f$export$37cdcaed3454078a);

var $5uXOq = parcelRequire("5uXOq");
const $718bd7b79f2e4f1f$export$37cdcaed3454078a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 262 99"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M139 36h119c1.7 0 3 1.3 3 3v21c0 1.7-1.3 3-3 3H139c-1.7 0-3-1.3-3-3V39c0-1.7 1.3-3 3-3zM4 1h119c1.7 0 3 1.3 3 3v91c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3z",
        fill: "var(--ds-background-input, #FFFFFF)",
        stroke: "var(--ds-border-accent-gray, #758195)",
        strokeLinecap: "round",
        strokeDasharray: "2,4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M139 1h119c1.7 0 3 1.3 3 3v21c0 1.7-1.3 3-3 3H139c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3zm0 70h119c1.7 0 3 1.3 3 3v21c0 1.7-1.3 3-3 3H139c-1.7 0-3-1.3-3-3V74c0-1.7 1.3-3 3-3z",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M59,18c-1.7,0-3,1.3-3,3v21c0,1.7,1.3,3,3,3h119c1.7,0,3-1.3,3-3V21c0-1.7-1.3-3-3-3H59z",
        fillRule: "evenodd",
        fill: "var(--ds-background-input, #FFFFFF)",
        stroke: "var(--ds-border-accent-gray, #758195)",
        strokeWidth: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M171.8 36.5c-.2.1-.3.4-.2.7l2.2 3.9c.1.2.4.3.7.2.2-.1.3-.4.2-.7l-2-3.5 3.5-2c.2-.1.3-.4.2-.7-.1-.2-.4-.3-.7-.2l-3.9 2.3zm15.7 15.4c-.4-4.1-1.3-7.2-3.6-9.7-2.3-2.4-5.9-4.2-11.8-5.8l-.3 1c5.8 1.6 9.2 3.2 11.3 5.5 2.1 2.2 2.9 5 3.3 9.1l1.1-.1z",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: ".5"
    }));

});



parcelRegister("2Ic5U", function(module, exports) {

$parcel$export(module.exports, "getFieldCard", () => $aa491fb2f6d0806d$export$3b78a16f09e0e98b);

var $5fc53 = parcelRequire("5fc53");

var $5fc53 = parcelRequire("5fc53");
var $3XO6n = parcelRequire("3XO6n");

var $2Tx3l = parcelRequire("2Tx3l");

var $9ddWo = parcelRequire("9ddWo");

var $gX3J2 = parcelRequire("gX3J2");

var $7xtmF = parcelRequire("7xtmF");

var $5PsvH = parcelRequire("5PsvH");

var $bs61j = parcelRequire("bs61j");

var $e5ine = parcelRequire("e5ine");

var $c1NYE = parcelRequire("c1NYE");

var $kLERN = parcelRequire("kLERN");

var $hlPgl = parcelRequire("hlPgl");

var $jzVPY = parcelRequire("jzVPY");

var $b0eNp = parcelRequire("b0eNp");

var $9mOHc = parcelRequire("9mOHc");

var $irjUF = parcelRequire("irjUF");

var $3pEwq = parcelRequire("3pEwq");

var $kesxN = parcelRequire("kesxN");

var $fygmF = parcelRequire("fygmF");

var $jh9BI = parcelRequire("jh9BI");

var $37Jh8 = parcelRequire("37Jh8");

var $bBCi8 = parcelRequire("bBCi8");

var $kWQog = parcelRequire("kWQog");

var $28HmG = parcelRequire("28HmG");

var $5Udqs = parcelRequire("5Udqs");

var $htPg0 = parcelRequire("htPg0");

var $lyeB5 = parcelRequire("lyeB5");

var $eaZQn = parcelRequire("eaZQn");

var $2Rl74 = parcelRequire("2Rl74");

var $61Iqi = parcelRequire("61Iqi");
const $aa491fb2f6d0806d$var$unsupportedFieldCard = {
    isExpandable: ()=>false
};
const $aa491fb2f6d0806d$export$3b78a16f09e0e98b = (fieldType)=>{
    switch(fieldType){
        case 0, $5fc53.APPROVALS_CF_TYPE:
            return {
                isFieldDescriptionApplicable: false,
                ConfigurationComponent: (0, $2Tx3l.ApprovalsFieldConfiguration),
                isExpandable: (0, $2Tx3l.isExpandable)
            };
        case 0, $5fc53.PEOPLE_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $37Jh8.PeopleFieldConfiguration),
                isExpandable: (0, $jh9BI.isExpandable)
            };
        case 0, $5fc53.SELECT_CF_TYPE:
        case 0, $5fc53.RADIO_BUTTONS_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $hlPgl.DropdownFieldConfiguration),
                isExpandable: (0, $kLERN.isExpandable)
            };
        case 0, $5fc53.CASCADING_SELECT_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $7xtmF.CascadingDropdown),
                isExpandable: (0, $gX3J2.isExpandable)
            };
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $bs61j.CheckboxFieldConfiguration),
                isExpandable: (0, $5PsvH.isExpandable)
            };
        case 0, $5fc53.PRIORITY_TYPE:
            return {
                isFieldDescriptionApplicable: false,
                isExpandable: (0, $bBCi8.isExpandable),
                ConfigurationComponent: (0, $kWQog.PriorityFieldConfiguration)
            };
        case 0, $5fc53.TEXT_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $lyeB5.TextFieldConfiguration),
                isExpandable: (0, $htPg0.isExpandable)
            };
        case 0, $3XO6n.TEXT_AREA_CF_TYPE:
        case 0, $3XO6n.DESCRIPTION_FIELD_TYPE:
        case 0, $3XO6n.ENVIRONMENT_FIELD_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $3pEwq.MultilineFieldConfiguration),
                isExpandable: (0, $3pEwq.isExpandable)
            };
        case 0, $5fc53.LABELS_TYPE:
        case 0, $5fc53.LABELS_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $irjUF.LabelsFieldConfiguration),
                isExpandable: (0, $9mOHc.isExpandable)
            };
        /**
		 * Date CF does not support default values because of a bug that we found in 2019
		 * where roadmaps code was having "issues with their Start Date field".
		 * The details have been lost over the years, and it's entirely possible
		 * that we can re-enable support for this default today.
		 *
		 * Also backend will actively refuse to set a default value for date fields
		 * so make sure to fix that before re-enabling Date default values for JSW TMP here.
		 *
		 * We however do offer several "Default value" components for use with Date and Datetime so feel free to use these
		 * - just make sure that the saving actually works.
		 *
		 * See https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/15347/overview
		 */ case 0, $5fc53.DATE_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: ()=>null,
                isExpandable: ()=>false
            };
        case 0, $5fc53.DATETIME_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $e5ine.CurrentDateTimeDefaultValue),
                isExpandable: (0, $c1NYE.isExpandable)
            };
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
            // The story points CF is simply an extension of the number CF type, just uniquely named
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $fygmF.NumberFieldConfiguration),
                isExpandable: (0, $kesxN.isExpandable)
            };
        case 0, $5fc53.ASSETS_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $9ddWo.AssetTypeFieldConfiguration),
                isExpandable: (0, $9ddWo.isExpandable)
            };
        case 0, $5fc53.GROUP_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $b0eNp.SingleGroupFieldConfiguration),
                isExpandable: (0, $jzVPY.isExpandable)
            };
        case 0, $5fc53.MULTI_GROUP_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $b0eNp.MultiGroupFieldConfiguration),
                isExpandable: (0, $jzVPY.isExpandable)
            };
        case 0, $5fc53.VERSION_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $61Iqi.VersionFieldConfiguration),
                isExpandable: (0, $eaZQn.isExpandable)
            };
        case 0, $5fc53.MULTI_VERSION_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $2Rl74.MultiVersionFieldConfiguration),
                isExpandable: (0, $eaZQn.isExpandable)
            };
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return {
                isFieldDescriptionApplicable: true,
                ConfigurationComponent: (0, $5Udqs.default),
                isExpandable: (0, $28HmG.isExpandable)
            };
        default:
            return $aa491fb2f6d0806d$var$unsupportedFieldCard;
    }
};

});
parcelRegister("2Tx3l", function(module, exports) {

$parcel$export(module.exports, "ApprovalsFieldConfiguration", () => $cb421cd346b2a3bf$export$a067fe1399953060);
$parcel$export(module.exports, "isExpandable", () => $cb421cd346b2a3bf$export$6e0f0a958dc8ef91);

var $5uXOq = parcelRequire("5uXOq");

var $i6Kvk = parcelRequire("i6Kvk");
const $cb421cd346b2a3bf$export$a067fe1399953060 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6Kvk.ApprovalsData), {
        configuration: props.field.configuration
    });
const $cb421cd346b2a3bf$export$6e0f0a958dc8ef91 = ()=>true;

});
parcelRegister("i6Kvk", function(module, exports) {

$parcel$export(module.exports, "ApprovalsData", () => $972e5191037b6790$export$c1f3a1727e51a604);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $gyekB = parcelRequire("gyekB");

var $b46LP = parcelRequire("b46LP");

var $hPsbp = parcelRequire("hPsbp");

var $6cobl = parcelRequire("6cobl");
const $972e5191037b6790$export$c1f3a1727e51a604 = (props)=>{
    const intl = (0, $koVbs.default)();
    const { configuration: configuration } = props;
    const rawData = configuration ? configuration['jsd.field.approval.all.configs'] : undefined;
    if (rawData === undefined || rawData === null || !Array.isArray(rawData)) return null;
    const steps = rawData.map((rawDataItem, index)=>{
        const approvalStepData = (0, $6cobl.getApprovalStepData)(rawDataItem);
        if (approvalStepData == null) return null;
        const { statusId: statusId, customFieldName: customFieldName, statusName: statusName, defaultApproverIds: defaultApproverIds } = approvalStepData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gyekB.ApprovalStep), {
            key: statusId + index,
            approverListFieldName: customFieldName,
            numberOfApprovers: approvalStepData.numberOfApprovers,
            whoChoosesApprovers: approvalStepData.whoChoosesApprovers,
            approvalStatus: statusName,
            defaultApprovers: defaultApproverIds
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $972e5191037b6790$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b46LP.ApprovalsStepBundle), {
        approvalSteps: steps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, intl.formatMessage((0, $hPsbp.default).portalNotice)));
};
const $972e5191037b6790$var$containerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.500',
    paddingRight: 'space.500',
    marginBottom: 'space.300'
});

});
parcelRegister("gyekB", function(module, exports) {

$parcel$export(module.exports, "ApprovalStep", () => $1a814816de72018d$export$fb0b0ebcd2805776);

var $5uXOq = parcelRequire("5uXOq");

var $fO66d = parcelRequire("fO66d");

var $fLC2r = parcelRequire("fLC2r");
const $1a814816de72018d$export$fb0b0ebcd2805776 = (props)=>{
    const [{ cachedApprovers: cachedApprovers }, { fetchApprovers: fetchApprovers }] = (0, $fO66d.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLC2r.ApprovalStepView), {
        ...props,
        cachedApprovers: cachedApprovers,
        onFetchApprovers: fetchApprovers
    });
};

});
parcelRegister("fO66d", function(module, exports) {

$parcel$export(module.exports, "getCachedApproversForIds", () => $1745257b073653dc$export$aa427b3c9c58168f);
$parcel$export(module.exports, "default", () => $1745257b073653dc$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $1F6Ez = parcelRequire("1F6Ez");
const $1745257b073653dc$var$initialState = {
    isLoading: false,
    cachedApprovers: [],
    error: undefined
};
const $1745257b073653dc$var$fetchUsers = (query)=>(0, $7f4tk.default)(`/rest/api/3/user/bulk?${query}`);
const $1745257b073653dc$export$3361e9be8093ddcc = (fetchedUsers)=>fetchedUsers.filter(Boolean).map((0, $1F6Ez.fetchedUserToApprover));
const $1745257b073653dc$var$fetchApprovers = (userIds)=>async ({ getState: getState, setState: setState })=>{
        setState({
            isLoading: true
        });
        if (userIds.length === 0) {
            setState({
                isLoading: false
            });
            return;
        }
        try {
            const { values: users } = await $1745257b073653dc$var$fetchUsers((0, $ebyGx.stringify)({
                accountId: userIds
            }));
            const approvers = $1745257b073653dc$export$3361e9be8093ddcc(users);
            const { cachedApprovers: cachedApprovers } = getState();
            setState({
                isLoading: false,
                cachedApprovers: Array.from(new Set([
                    ...cachedApprovers,
                    ...approvers
                ]))
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.trackFetchErrors)({
                error: error,
                id: 'fetchApprovers',
                packageName: 'jiraWorkflowApprovals',
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                isLoading: false,
                error: error
            });
        }
    };
const $1745257b073653dc$var$updateCachedApprovers = (approversToCache)=>({ getState: getState, setState: setState })=>{
        const { cachedApprovers: cachedApprovers } = getState();
        setState({
            cachedApprovers: Array.from(new Set([
                ...approversToCache,
                ...cachedApprovers
            ]))
        });
    };
const $1745257b073653dc$export$aa427b3c9c58168f = (accountIds, cachedApprovers)=>accountIds.map((id)=>cachedApprovers.find((cachedApprover)=>cachedApprover.accountId === id)).filter(Boolean);
const $1745257b073653dc$export$e324594224ef24da = {
    fetchApprovers: $1745257b073653dc$var$fetchApprovers,
    updateCachedApprovers: $1745257b073653dc$var$updateCachedApprovers
};
const $1745257b073653dc$var$Store = (0, $iXqE5.createStore)({
    initialState: $1745257b073653dc$var$initialState,
    actions: $1745257b073653dc$export$e324594224ef24da,
    name: 'approvals-approver-service'
});
const $1745257b073653dc$var$useApproverService = (0, $3sQ5x.createHook)($1745257b073653dc$var$Store);
var $1745257b073653dc$export$2e2bcd8739ae039 = $1745257b073653dc$var$useApproverService;

});
parcelRegister("1F6Ez", function(module, exports) {

$parcel$export(module.exports, "fetchedUserToApprover", () => $473f069d2506446a$export$fa876a600f899dbf);
$parcel$export(module.exports, "approverToPeopleFieldUser", () => $473f069d2506446a$export$efb5e350d4d27481);
$parcel$export(module.exports, "peopleFieldUserToApprover", () => $473f069d2506446a$export$6908507f068d3a28);
$parcel$export(module.exports, "approverToDefaultApprover", () => $473f069d2506446a$export$f32940652d04a268);
$parcel$export(module.exports, "defaultApproverToApprover", () => $473f069d2506446a$export$f202ab6adb509193);

var $g5X3G = parcelRequire("g5X3G");
const $473f069d2506446a$export$fa876a600f899dbf = (fetchedUser)=>({
        name: fetchedUser.displayName,
        avatarUrl: fetchedUser.avatarUrls['48x48'],
        accountId: (0, $g5X3G.toAccountId)(fetchedUser.accountId),
        type: 'user'
    });
const $473f069d2506446a$export$efb5e350d4d27481 = (approver)=>({
        id: approver.accountId.toString(),
        name: approver.name || '',
        type: approver.type,
        fixed: false,
        avatarUrl: approver.avatarUrl || ''
    });
const $473f069d2506446a$export$6908507f068d3a28 = (peopleFieldUser)=>({
        name: peopleFieldUser.name,
        avatarUrl: peopleFieldUser.avatarUrl,
        accountId: (0, $g5X3G.toAccountId)(peopleFieldUser.id),
        type: peopleFieldUser.type === 'user' ? 'user' : 'team'
    });
const $473f069d2506446a$export$f32940652d04a268 = (approver)=>({
        id: approver.accountId,
        type: approver.type
    });
const $473f069d2506446a$export$f202ab6adb509193 = (defaultApprover)=>({
        accountId: defaultApprover.id,
        type: defaultApprover.type
    });

});


parcelRegister("fLC2r", function(module, exports) {

$parcel$export(module.exports, "ApprovalStepView", () => $d8bd83d5b1ddefc5$export$283560c35f8b6b8c);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7sUFC = parcelRequire("7sUFC");
var $ujWmd = parcelRequire("ujWmd");

var $jnhNB = parcelRequire("jnhNB");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $77MkV = parcelRequire("77MkV");
const $d8bd83d5b1ddefc5$var$getApprovalInfoMessage = (length)=>{
    if (length > 1) return (0, $77MkV.default).approvalStepInformationWithDefaults;
    if (length === 1) return (0, $77MkV.default).approvalStepInformationWithDefaultsSingular;
    return (0, $77MkV.default).approvalStepInformationNoDefaults;
};
const $d8bd83d5b1ddefc5$export$283560c35f8b6b8c = (props)=>{
    const { defaultApprovers: defaultApprovers, approvalStatus: approvalStatus, whoChoosesApprovers: whoChoosesApprovers, numberOfApprovers: numberOfApprovers, approverListFieldName: approverListFieldName, cachedApprovers: cachedApprovers, onFetchApprovers: onFetchApprovers, tooltipDelay: tooltipDelay, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (onFetchApprovers !== undefined && defaultApprovers.length > 0) onFetchApprovers(defaultApprovers);
    }, [
        onFetchApprovers,
        defaultApprovers
    ]);
    const enrichedDefaultApprovers = defaultApprovers.map((approver)=>cachedApprovers.find((ca)=>ca.accountId === approver)).filter(Boolean);
    const approvalStepInformationMessage = $d8bd83d5b1ddefc5$var$getApprovalInfoMessage(defaultApprovers.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8bd83d5b1ddefc5$var$ApprovalStepCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $77MkV.default).approvalStepHeading, {
        approvalStatus: approvalStatus
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8bd83d5b1ddefc5$var$ApprovalStepInformation, null, formatMessage(approvalStepInformationMessage, {
        whoChoosesApprovers: whoChoosesApprovers,
        numberOfApprovers: numberOfApprovers,
        approverListFieldName: approverListFieldName,
        approvalStatus: approvalStatus
    })), enrichedDefaultApprovers.length === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sUFC.default), {
        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: enrichedDefaultApprovers[0].name || '',
            position: "bottom",
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            src: enrichedDefaultApprovers[0].avatarUrl,
            testId: testId
        })),
        key: enrichedDefaultApprovers[0].accountId,
        primaryText: enrichedDefaultApprovers[0].name
    }), enrichedDefaultApprovers.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
        appearance: "stack",
        data: enrichedDefaultApprovers.map((approver)=>({
                name: approver.name || '',
                src: approver.avatarUrl,
                appearance: 'circle',
                size: 'medium',
                enableTooltip: true
            }))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d8bd83d5b1ddefc5$var$ApprovalStepCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189eyh40 _vchhusvi _bfhk1vck _16qsxya4 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d8bd83d5b1ddefc5$var$ApprovalStepInformation = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7sUFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fee6a3655f9d2d5$export$2e2bcd8739ae039);
/* avatar-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $dS3PR = parcelRequire("dS3PR");

var $kyyq3 = parcelRequire("kyyq3");
const $0fee6a3655f9d2d5$var$bgColorCssVar = '--avatar-item-bg-color';
const $0fee6a3655f9d2d5$var$styles = {
    root: "_2rko1l7b _12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1txw _vchhusvi _1bsb1osq _4cvr1h6o _bfhk1g13 _syaz1kw7 _1wyb1kw7 _zg8l4jg8 _k48pi7a9 _vwz4kb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i51b66 _1q511b66 _y4ti1b66 _bozg1b66 _y3gn1e5h",
    rootDisabled: "_80om13gf _tzy41e4z _lcxvglyw",
    rootInteractive: "_nt751r31 _49pcglyw _1hvw1o36 _858u194a _9oik18uv _1bnxglyw _jf4cnqa1 _irr314ae _d0altlke _1di61l7b",
    avatarItem: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _vwz419ii _bozgu2gc",
    baseText: "_1e0c1ule _syaz1fxt",
    truncation: "_1reo15vq _1bto1l2s _o5721q9c",
    secondaryTextLegacy: "_syaz131l _1wyb181o"
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $0fee6a3655f9d2d5$var$AvatarItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const Container = (0, $kyyq3.getCustomElement)(isDisabled, href, onClick);
    const isInteractive = Boolean(onClick || href);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Container, {
        style: {
            [$0fee6a3655f9d2d5$var$bgColorCssVar]: backgroundColor
        },
        ref: ref,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        disabled: isDisabled,
        "data-testid": testId ? `${testId}--itemInner` : undefined,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $bwpsq.default)([
            $0fee6a3655f9d2d5$var$styles.root,
            isInteractive && $0fee6a3655f9d2d5$var$styles.rootInteractive,
            isDisabled && $0fee6a3655f9d2d5$var$styles.rootDisabled
        ]),
        children: [
            avatar,
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $0fee6a3655f9d2d5$var$styles.avatarItem
                ]),
                children: (0, $VSDnB.fg)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            maxLines: isTruncationDisabled ? undefined : 1,
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            color: "color.text.subtlest",
                            maxLines: isTruncationDisabled ? undefined : 1,
                            size: "UNSAFE_small",
                            children: secondaryText
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: (0, $bwpsq.default)([
                                $0fee6a3655f9d2d5$var$styles.baseText,
                                !isTruncationDisabled && $0fee6a3655f9d2d5$var$styles.truncation
                            ]),
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: (0, $bwpsq.default)([
                                $0fee6a3655f9d2d5$var$styles.baseText,
                                $0fee6a3655f9d2d5$var$styles.secondaryTextLegacy,
                                !isTruncationDisabled && $0fee6a3655f9d2d5$var$styles.truncation
                            ]),
                            children: secondaryText
                        })
                    ]
                })
            })
        ]
    });
});
$0fee6a3655f9d2d5$var$AvatarItem.displayName = 'AvatarItem';
var $0fee6a3655f9d2d5$export$2e2bcd8739ae039 = $0fee6a3655f9d2d5$var$AvatarItem;

});

parcelRegister("77MkV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd7344cead8dcdd3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd7344cead8dcdd3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    approvalStepHeading: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.approval-step.approval-step-heading",
        "defaultMessage": "Approval for \"{approvalStatus}\" status"
    },
    approvalStepInformationNoDefaults: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.approval-step.approval-step-information-no-defaults",
        "defaultMessage": "{whoChoosesApprovers} must add {numberOfApprovers, plural, one {# approver} other {# approvers}} to the \"{approverListFieldName}\" field"
    },
    approvalStepInformationWithDefaults: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.approval-step.approval-step-information-with-defaults",
        "defaultMessage": "{numberOfApprovers} of the following people must approve: "
    },
    approvalStepInformationWithDefaultsSingular: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.approval-step.approval-step-information-with-defaults-singular",
        "defaultMessage": "This person must approve: "
    }
});

});



parcelRegister("b46LP", function(module, exports) {

$parcel$export(module.exports, "ApprovalsStepBundle", () => $3a445c05afeb0d12$export$1ac96849db3d7381);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
function $3a445c05afeb0d12$export$1ac96849db3d7381(props) {
    const { approvalSteps: approvalSteps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a445c05afeb0d12$var$ApprovalStepsList, null, approvalSteps.map((approvalStep, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a445c05afeb0d12$var$ApprovalStepItem, {
            key: index
        }, approvalStep)));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a445c05afeb0d12$var$ApprovalStepsList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $3a445c05afeb0d12$var$ApprovalStepItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hPsbp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b3a5ccb50897d9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6b3a5ccb50897d9a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    portalNotice: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.portal-notice",
        "defaultMessage": "Approval information will be shown on the portal."
    }
});

});

parcelRegister("6cobl", function(module, exports) {

$parcel$export(module.exports, "getApprovalStepData", () => $4a85ab3615d23ab0$export$c716c42b9ea3f4da);

var $7c0in = parcelRequire("7c0in");

const $4a85ab3615d23ab0$export$4d53970231c909b3 = (conditionType, conditionValue, defaultApproversCount)=>{
    if (conditionType === 'number') return Number(conditionValue);
    if (defaultApproversCount > 0) return defaultApproversCount;
    return 1;
};
const $4a85ab3615d23ab0$export$4ecf6e1ca6b3046c = (serviceDeskFieldCategory, defaultApproversCount)=>{
    if (serviceDeskFieldCategory === 'request') return 0, $d52952b284e6425f$export$1d0cc9f143bfe9fc;
    if (defaultApproversCount > 0) return 0, $d52952b284e6425f$export$770485fbd4daa4a1;
    return 0, $d52952b284e6425f$export$2094f21f9500691a;
};
const $4a85ab3615d23ab0$var$transformDefaultApprover = (acc, unknownApprover)=>{
    if (!unknownApprover || typeof unknownApprover !== 'object') return acc;
    if ((0, $7c0in.hasProp)(unknownApprover, 'id') && typeof unknownApprover.id === 'string' && (0, $7c0in.hasProp)(unknownApprover, 'type') && typeof unknownApprover.type === 'string') {
        const approver = {
            id: unknownApprover.id,
            type: unknownApprover.type
        };
        acc.push(approver);
    }
    return acc;
};
const $4a85ab3615d23ab0$export$69cfd08ebfe5da8f = (unknownData)=>{
    if (!unknownData || typeof unknownData !== 'object') return null;
    const approvalStepData = {
        statusId: '',
        customFieldName: '',
        conditionType: '',
        conditionValue: '',
        defaultApprovers: [],
        serviceDeskFieldCategory: '',
        statusName: ''
    };
    if ((0, $7c0in.hasProp)(unknownData, 'statusId') && typeof unknownData.statusId === 'string') approvalStepData.statusId = unknownData.statusId;
    if ((0, $7c0in.hasProp)(unknownData, 'conditionType') && typeof unknownData.conditionType === 'string') approvalStepData.conditionType = unknownData.conditionType;
    if ((0, $7c0in.hasProp)(unknownData, 'conditionValue') && typeof unknownData.conditionValue === 'string') approvalStepData.conditionValue = unknownData.conditionValue;
    if ((0, $7c0in.hasProp)(unknownData, 'defaultApprovers') && Array.isArray(unknownData.defaultApprovers)) {
        const defaultApprovers = unknownData.defaultApprovers.reduce($4a85ab3615d23ab0$var$transformDefaultApprover, []);
        approvalStepData.defaultApprovers = defaultApprovers;
    }
    if ((0, $7c0in.hasProp)(unknownData, 'serviceDeskFieldCategory') && typeof unknownData.serviceDeskFieldCategory === 'string') approvalStepData.serviceDeskFieldCategory = unknownData.serviceDeskFieldCategory;
    if ((0, $7c0in.hasProp)(unknownData, 'statusName') && typeof unknownData.statusName === 'string') approvalStepData.statusName = unknownData.statusName;
    if ((0, $7c0in.hasProp)(unknownData, 'customFieldName') && typeof unknownData.customFieldName === 'string') approvalStepData.customFieldName = unknownData.customFieldName;
    return approvalStepData;
};
const $4a85ab3615d23ab0$export$c716c42b9ea3f4da = (rawDataItem)=>{
    const approvalStepData = $4a85ab3615d23ab0$export$69cfd08ebfe5da8f(rawDataItem);
    if (approvalStepData == null) return null;
    const { statusId: statusId, customFieldName: customFieldName, conditionType: conditionType, conditionValue: conditionValue, defaultApprovers: defaultApprovers, serviceDeskFieldCategory: serviceDeskFieldCategory, statusName: statusName } = approvalStepData;
    const numberOfApprovers = $4a85ab3615d23ab0$export$4d53970231c909b3(conditionType, conditionValue, defaultApprovers.length);
    const whoChoosesApprovers = $4a85ab3615d23ab0$export$4ecf6e1ca6b3046c(serviceDeskFieldCategory, defaultApprovers.length);
    const defaultApproverIds = defaultApprovers.map(({ id: id })=>id);
    return {
        statusId: statusId,
        customFieldName: customFieldName,
        statusName: statusName,
        numberOfApprovers: numberOfApprovers,
        whoChoosesApprovers: whoChoosesApprovers,
        defaultApproverIds: defaultApproverIds
    };
};

});
const $d52952b284e6425f$export$770485fbd4daa4a1 = 'Project Admin';
const $d52952b284e6425f$export$1d0cc9f143bfe9fc = 'Customer';
const $d52952b284e6425f$export$2094f21f9500691a = 'Agent';




parcelRegister("9ddWo", function(module, exports) {

$parcel$export(module.exports, "AssetTypeFieldConfiguration", () => $f80a767af9f4d8a0$export$19e8f384fd12e9ca);
$parcel$export(module.exports, "isExpandable", () => $f80a767af9f4d8a0$export$6e0f0a958dc8ef91);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $h0AAx = parcelRequire("h0AAx");

var $8GdKU = parcelRequire("8GdKU");
const $f80a767af9f4d8a0$var$AssetTypeFieldConfigurationWithHook = (props)=>{
    const [{ assetTypes: assetTypes, error: error }] = (0, $h0AAx.useAssetTypes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GdKU.AssetTypeFieldConfiguration), {
        ...props,
        assetTypes: assetTypes,
        assetFetchError: error
    });
};
const $f80a767af9f4d8a0$export$19e8f384fd12e9ca = (0, $8oe80.default)('assetsFieldConfiguration', {
    onChange: 'updated'
})($f80a767af9f4d8a0$var$AssetTypeFieldConfigurationWithHook);
const $f80a767af9f4d8a0$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyPropertyConfiguration;

});
parcelRegister("h0AAx", function(module, exports) {

$parcel$export(module.exports, "AssetTypesContainer", () => $a26011ab2cd81489$export$d65654680e6e119d);
$parcel$export(module.exports, "useAssetTypes", () => $a26011ab2cd81489$export$403e665fef3ed7d0);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $dKS9k = parcelRequire("dKS9k");

var $9n23k = parcelRequire("9n23k");

var $fjy0D = parcelRequire("fjy0D");
const $a26011ab2cd81489$export$6dd3ac779b1ce9b1 = (0, $51nlc.createSubscriber)((0, $9n23k.default), {
    displayName: 'AssetTypesSubscriber'
});
const $a26011ab2cd81489$var$AssetTypesContainerWithoutAnalytics = (0, $gg7kZ.createContainer)((0, $9n23k.default), {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($dKS9k.default({}))
});
const $a26011ab2cd81489$var$fireAnalyticsEvent = (analyticsEvent, fetchingState, error)=>{
    if (fetchingState === (0, $fjy0D.FetchingStates).FAILED) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'fetchAssetTypes Failed', {
        error: error
    });
    else (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'fetchAssetTypes Succeeded');
};
const $a26011ab2cd81489$export$d65654680e6e119d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a26011ab2cd81489$var$AssetTypesContainerWithoutAnalytics, {
        baseUrl: props.baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a26011ab2cd81489$export$6dd3ac779b1ce9b1, null, ({ fetchingState: fetchingState, error: error })=>fetchingState !== (0, $fjy0D.FetchingStates).INIT && fetchingState !== (0, $fjy0D.FetchingStates).LOADING ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
            // eslint-disable-next-line jira/react-no-inline-function-prop
            onMount: (analyticsEvent)=>$a26011ab2cd81489$var$fireAnalyticsEvent(analyticsEvent, fetchingState, error)
        }) : null), props.children);
const $a26011ab2cd81489$export$403e665fef3ed7d0 = (0, $3sQ5x.createHook)((0, $9n23k.default));

});
parcelRegister("dKS9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $10c78f420d21d7e2$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");

var $fjy0D = parcelRequire("fjy0D");
const $10c78f420d21d7e2$var$DEFAULT_ASSET_TYPES_LIMIT = 50;
// Get asset types by recursively and consecutively requesting each page
// until last page has been requested and then return asset types
// @ts-expect-error - TS7023 - 'getAssetTypes' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const $10c78f420d21d7e2$var$getAssetTypes = async ({ baseUrl: baseUrl = '', assetTypes: assetTypes = [], isLastPage: isLastPage = false, start: start = 0, limit: limit = $10c78f420d21d7e2$var$DEFAULT_ASSET_TYPES_LIMIT })=>{
    if (isLastPage) return assetTypes;
    const data = await (0, $7f4tk.default)(`${baseUrl}/rest/assetapi/asset/type?${(0, $ebyGx.stringify)({
        start: start,
        limit: limit
    })}`);
    return $10c78f420d21d7e2$var$getAssetTypes({
        baseUrl: baseUrl,
        assetTypes: [
            ...assetTypes,
            ...data.values
        ],
        isLastPage: data.isLastPage,
        start: start + limit,
        limit: limit
    });
};
const $10c78f420d21d7e2$var$getAssetTypesAction = ({ forceRefetch: forceRefetch = false, start: start = 0, limit: limit = $10c78f420d21d7e2$var$DEFAULT_ASSET_TYPES_LIMIT })=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
        const currentState = getState();
        if (currentState.fetchingState === (0, $fjy0D.FetchingStates).LOADED && !forceRefetch || currentState.fetchingState === (0, $fjy0D.FetchingStates).LOADING) return;
        try {
            setState({
                fetchingState: (0, $fjy0D.FetchingStates).LOADING
            });
            const assetTypes = await $10c78f420d21d7e2$var$getAssetTypes({
                baseUrl: baseUrl,
                start: start,
                limit: limit
            });
            setState({
                assetTypes: assetTypes,
                error: undefined,
                fetchingState: (0, $fjy0D.FetchingStates).LOADED
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error,
                fetchingState: (0, $fjy0D.FetchingStates).FAILED
            });
        }
    };
var $10c78f420d21d7e2$export$2e2bcd8739ae039 = $10c78f420d21d7e2$var$getAssetTypesAction;

});
parcelRegister("fjy0D", function(module, exports) {

$parcel$export(module.exports, "FetchingStates", () => $72b327922b896320$export$2976dc18278704fd);
const $72b327922b896320$export$2976dc18278704fd = Object.freeze({
    INIT: Symbol('init'),
    LOADING: Symbol('loading'),
    LOADED: Symbol('loaded'),
    FAILED: Symbol('failed')
});

});


parcelRegister("9n23k", function(module, exports) {

$parcel$export(module.exports, "default", () => $53ca544fe54eba4b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $chgjq = parcelRequire("chgjq");

var $fjy0D = parcelRequire("fjy0D");
const $53ca544fe54eba4b$export$d4c72bab9d6cc13a = {
    fetchingState: (0, $fjy0D.FetchingStates).INIT,
    error: undefined,
    assetTypes: []
};
var $53ca544fe54eba4b$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'asset-types',
    initialState: $53ca544fe54eba4b$export$d4c72bab9d6cc13a,
    actions: $chgjq
});

});
parcelRegister("chgjq", function(module, exports) {

$parcel$export(module.exports, "fetch", () => (parcelRequire("dKS9k")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $dKS9k = parcelRequire("dKS9k");

});



parcelRegister("8GdKU", function(module, exports) {

$parcel$export(module.exports, "AssetTypeFieldConfiguration", () => $7bb17db7e03ad4fc$export$19e8f384fd12e9ca);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $16dzj = parcelRequire("16dzj");

var $7O4UO = parcelRequire("7O4UO");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $94bNw = parcelRequire("94bNw");

var $3bDjY = parcelRequire("3bDjY");

var $hZHze = parcelRequire("hZHze");

var $koVbs = parcelRequire("koVbs");

var $dlgLJ = parcelRequire("dlgLJ");

var $hPw0Z = parcelRequire("hPw0Z");

var $ignom = parcelRequire("ignom");
const $7bb17db7e03ad4fc$export$9c4866ea320965d6 = (field)=>!!field.configuration && !!field.configuration.assetTypes;
const $7bb17db7e03ad4fc$export$9ad035bc1392ec6c = (field)=>{
    if (!field || !field.configuration || !field.configuration.assetTypes) return [];
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'AssetType[]'.
    return field.configuration.assetTypes;
};
const $7bb17db7e03ad4fc$export$286d827aa91c9925 = (selectedAssetTypes, assetTypes)=>selectedAssetTypes.filter((selectedAssetType)=>assetTypes.find((assetType)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(assetType, selectedAssetType)));
const $7bb17db7e03ad4fc$export$37b3cc07a70f65dc = (field, selectedAssetTypes)=>!$7bb17db7e03ad4fc$export$9c4866ea320965d6(field) && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(selectedAssetTypes) || $7bb17db7e03ad4fc$export$9c4866ea320965d6(field) && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($16dzj)))($7bb17db7e03ad4fc$export$9ad035bc1392ec6c(field), selectedAssetTypes));
const $7bb17db7e03ad4fc$export$19e8f384fd12e9ca = ({ field: field, onUpdate: onUpdate, assetTypes: assetTypes, assetFetchError: assetFetchError, tooltipDelay: tooltipDelay, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [selectedAssetTypes, setSelectedAssetTypes] = (0, $5uXOq.useState)($7bb17db7e03ad4fc$export$9ad035bc1392ec6c(field));
    (0, $5uXOq.useEffect)(()=>{
        if ($7bb17db7e03ad4fc$export$37b3cc07a70f65dc(field, selectedAssetTypes)) onUpdate({
            ...field,
            configuration: {
                ...field.configuration,
                assetTypes: selectedAssetTypes
            }
        });
    });
    const isModifyPropertyConfigurationDisabled = !field.operations.canModifyPropertyConfiguration;
    const hasAssetTypesOrError = ()=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(assetTypes) || !!assetFetchError;
    const getNoOptionsMessage = ()=>formatMessage((0, $ignom.default).noAssetTypes);
    const getOptionValue = (assetType)=>`${assetType.origin.appKey}/${assetType.origin.originId}`;
    const getOptionLabel = (assetType)=>assetType.label.value;
    const onChange = (changedSelectedAssetTypes)=>{
        // Adding null check due to https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7451
        setSelectedAssetTypes(changedSelectedAssetTypes || []);
    };
    // Removes the out of sync selected asset types that are no longer returned from the saffron service
    const removeOutOfSyncAssetTypesFromConfiguration = ()=>{
        const selectedAssetTypesStillInSync = $7bb17db7e03ad4fc$export$286d827aa91c9925(selectedAssetTypes, assetTypes);
        if (!assetFetchError && selectedAssetTypesStillInSync.length !== selectedAssetTypes.length) setSelectedAssetTypes(selectedAssetTypesStillInSync);
    };
    const render = ()=>{
        removeOutOfSyncAssetTypesFromConfiguration();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $7bb17db7e03ad4fc$var$assetsDefaultValueStyledStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: `${field.key}-default-value`,
            label: formatMessage((0, $ignom.default).assetTypesLabel)
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: isModifyPropertyConfigurationDisabled ? formatMessage((0, $ignom.default).assetTypesDisabledTooltip) : null,
                delay: tooltipDelay
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlgLJ.default), {
                testId: testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94bNw.default), {
                inputId: fieldProps.id,
                placeholder: formatMessage((0, $ignom.default).assetTypesPlaceholder),
                noOptionsMessage: getNoOptionsMessage,
                // @ts-expect-error - CheckboxSelect does not allow specifying generics so we cannot type this
                getOptionValue: getOptionValue,
                // @ts-expect-error - CheckboxSelect does not allow specifying generics so we cannot type this
                getOptionLabel: getOptionLabel,
                // @ts-expect-error - CheckboxSelect does not allow specifying generics so we cannot type this
                onChange: onChange,
                // @ts-expect-error - CheckboxSelect does not allow specifying generics so we cannot type this
                value: selectedAssetTypes,
                isDisabled: isModifyPropertyConfigurationDisabled,
                // @ts-expect-error - CheckboxSelect does not allow specifying generics so we cannot type this
                options: assetTypes
            }))))));
    };
    return hasAssetTypesOrError() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), {
        key: field.key
    }), render()) : null;
};
const $7bb17db7e03ad4fc$var$assetsDefaultValueStyledStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.500',
    paddingLeft: 'space.500',
    marginBottom: 'space.200'
});

});
parcelRegister("16dzj", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $g7i7g = parcelRequire("g7i7g");

var $7txx8 = parcelRequire("7txx8");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $0cd0e06461d5e057$var$xor = $g7i7g(function(arrays) {
    return $7txx8($2GdQn(arrays, $f3SOL));
});
module.exports = $0cd0e06461d5e057$var$xor;

});
parcelRegister("7txx8", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $7CoLY = parcelRequire("7CoLY");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $7CoLY(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $7CoLY($ekcP3(result, 1), iteratee, comparator);
}
module.exports = $571540db172adafd$var$baseXor;

});


parcelRegister("7O4UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e20204ce79b642c$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $dRN65 = parcelRequire("dRN65");

var $efXp3 = parcelRequire("efXp3");

var $2x3Cb = parcelRequire("2x3Cb");

var $kxqHl = parcelRequire("kxqHl");

var $6cAn5 = parcelRequire("6cAn5");
const $7e20204ce79b642c$var$fieldWrapperStyles = null;
function $7e20204ce79b642c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7e20204ce79b642c$var$isFunction(x) {
    return typeof x === 'function';
}
function $7e20204ce79b642c$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $efXp3.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $9KnKW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2x3Cb.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kxqHl.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("dRN65", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $706cd4dbd4574fd7$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $706cd4dbd4574fd7$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("efXp3", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $987e2ff089e89967$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $987e2ff089e89967$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $987e2ff089e89967$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $987e2ff089e89967$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $987e2ff089e89967$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = null;
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("kxqHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55ac25356e81a33$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d55ac25356e81a33$var$requiredIndicatorStyles = null;
function $d55ac25356e81a33$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("94bNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf832c571222d72$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $itpgN = parcelRequire("itpgN");
const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $ebf832c571222d72$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
var $ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;

});
parcelRegister("7K5PP", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $c2d344e1481a2d3b$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, $3c98u.default)((0, $eAthk.default));
const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
const $c2d344e1481a2d3b$var$Select = (0, $994MI.default)({
    componentName: 'select',
    packageName: $c2d344e1481a2d3b$var$packageName,
    packageVersion: $c2d344e1481a2d3b$var$packageVersion
})((0, $cb25w.default)({
    onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $c2d344e1481a2d3b$var$packageName,
            packageVersion: $c2d344e1481a2d3b$var$packageVersion
        }
    })
})($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;

});
parcelRegister("eAthk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0cf20527a3a891$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("iaInK")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $9uJ4X = parcelRequire("9uJ4X");
const $6d0cf20527a3a891$var$AsyncSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $iaInK.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $9uJ4X.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;

});
parcelRegister("2QhWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e863683b34816f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2Z7Iz = parcelRequire("2Z7Iz");

var $VSDnB = parcelRequire("VSDnB");

var $eEtcC = parcelRequire("eEtcC");

var $bChGW = parcelRequire("bChGW");

var $jtVgE = parcelRequire("jtVgE");
var $9cRAr = parcelRequire("9cRAr");
var $galqx = parcelRequire("galqx");

var $7uagk = parcelRequire("7uagk");

var $81i5b = parcelRequire("81i5b");

var $aA8TC = parcelRequire("aA8TC");

var $5JAlL = parcelRequire("5JAlL");

var $7VXAu = parcelRequire("7VXAu");

var $gyjU7 = parcelRequire("gyjU7");
const $d8e863683b34816f$export$9c21a3269931e1e6 = {
    // aria-live is by default with the live region so we don't need it
    // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
    'aria-live': (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $gyjU7.isTouchCapable)(),
    captureMenuScroll: !(0, $gyjU7.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5JAlL.createFilter)(),
    formatGroupLabel: (0, $eEtcC.formatGroupLabel),
    getOptionLabel: (0, $eEtcC.getOptionLabel),
    getOptionValue: (0, $eEtcC.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $eEtcC.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $gyjU7.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
    const label = $d8e863683b34816f$var$getOptionLabel(props, option);
    const value = $d8e863683b34816f$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $gyjU7.notNullish));
}
function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
    return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
}
function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
    return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
}
function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $d8e863683b34816f$var$instanceId = 1;
class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isVoiceOver = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && (0, $2Z7Iz.isAppleDevice)(), // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $gyjU7.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $gyjU7.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $gyjU7.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $gyjU7.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $gyjU7.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $gyjU7.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $d8e863683b34816f$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $d8e863683b34816f$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $7VXAu.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $bChGW.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $gyjU7.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $VSDnB.fg)('platform_dst_layer_observer_select')) return;
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
        this.state.selectValue = (0, $gyjU7.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $gyjU7.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $gyjU7.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription(action) {
        const descriptionProp = this.props['aria-describedby'] || this.props['descriptionId'];
        const { isMulti: isMulti } = this.props;
        const { selectValue: selectValue } = this.state;
        const defaultDescription = selectValue.length ? this.getElementId('live-region') : this.getElementId('placeholder');
        if (!isMulti && selectValue.length && action !== 'initial-input-focus') return;
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            return {
                'aria-describedby': descriptionProp ? [
                    descriptionProp,
                    defaultDescription,
                    multiMessage
                ].join(' ') : [
                    defaultDescription,
                    multiMessage
                ].join(' ')
            };
        } else return {
            'aria-describedby': descriptionProp ? [
                descriptionProp,
                defaultDescription
            ].join(' ') : defaultDescription
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-describedby': this.props['aria-describedby'] || descriptionId,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription(ariaSelection?.action)
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtVgE.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $gyjU7.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $5uXOq.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $5uXOq.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    'data-testid': `${testId}-select--multivalue-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled && (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : isDisabled,
                'aria-describedby': (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? headingId : undefined,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $5uXOq.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const calculateListboxLabel = ()=>{
            // First in name calculation, overwrites aria-label
            if (labelId) return {
                'aria-labelledby': labelId
            };
            // Second in name calcuation, overwrites everything else except aria-labelledby
            if (label) return {
                'aria-label': label
            };
            // Fallback if no label or labelId is provided, might catch label via <label for> otherwise
            // will most likely not have an accessible name
            return {
                'aria-labelledby': this.inputRef?.id || this.getElementId('input')
            };
        };
        const menuElement = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aA8TC.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galqx.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    'aria-multiselectable': (this.isVoiceOver || !commonProps.isMulti) && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox when ff is on
                                    ...(0, $VSDnB.fg)('design_system_select-a11y-improvement') && calculateListboxLabel()
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $2OMIu.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9cRAr.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $81i5b.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isVoiceOver
        });
    }
    renderMultiselectMessage() {
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: ", multiple selections available,"
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $2OMIu.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7uagk.NotifyOpenLayerObserver), {
                    isOpen: (0, $VSDnB.fg)('platform_dst_layer_observer_select') && this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("2Z7Iz", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $f979f269481b61c7$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $f979f269481b61c7$export$e1865c3bedcd822b);
function $f979f269481b61c7$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $f979f269481b61c7$var$isIPhone() {
    return $f979f269481b61c7$var$testPlatform(/^iPhone/i);
}
function $f979f269481b61c7$var$isMac() {
    return $f979f269481b61c7$var$testPlatform(/^Mac/i);
}
function $f979f269481b61c7$var$isIPad() {
    return $f979f269481b61c7$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $f979f269481b61c7$var$isMac() && navigator.maxTouchPoints > 1;
}
function $f979f269481b61c7$var$isIOS() {
    return $f979f269481b61c7$var$isIPhone() || $f979f269481b61c7$var$isIPad();
}
function $f979f269481b61c7$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $f979f269481b61c7$export$e1865c3bedcd822b() {
    return $f979f269481b61c7$var$isMac() || $f979f269481b61c7$var$isIOS();
}

});

parcelRegister("eEtcC", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $1a3d0f2eb875e1af$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $1a3d0f2eb875e1af$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $1a3d0f2eb875e1af$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $1a3d0f2eb875e1af$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("bChGW", function(module, exports) {

$parcel$export(module.exports, "components", () => $ea75c1778b4e3ad2$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $ea75c1778b4e3ad2$export$71abc632aa29e6fe);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $95iuW.ClearIndicator),
    Control: (0, $eZFhY.default),
    DropdownIndicator: (0, $95iuW.DropdownIndicator),
    Group: (0, $i48X9.default),
    GroupHeading: (0, $i48X9.GroupHeading),
    IndicatorsContainer: (0, $h1QWG.IndicatorsContainer),
    Input: (0, $dS5G5.default),
    LoadingIndicator: (0, $95iuW.LoadingIndicator),
    Menu: (0, $aA8TC.default),
    MenuList: (0, $aA8TC.MenuList),
    MenuPortal: (0, $aA8TC.MenuPortal),
    LoadingMessage: (0, $aA8TC.LoadingMessage),
    NoOptionsMessage: (0, $aA8TC.NoOptionsMessage),
    MultiValue: (0, $hqcPo.default),
    MultiValueContainer: (0, $hqcPo.MultiValueContainer),
    MultiValueLabel: (0, $hqcPo.MultiValueLabel),
    MultiValueRemove: (0, $hqcPo.MultiValueRemove),
    Option: (0, $8l2RA.default),
    Placeholder: (0, $kKm82.default),
    SelectContainer: (0, $h1QWG.SelectContainer),
    SingleValue: (0, $hpcbi.default),
    ValueContainer: (0, $h1QWG.ValueContainer)
};
const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
        ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("h1QWG", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $78186faf13ea75d3$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $78186faf13ea75d3$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $78186faf13ea75d3$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $78186faf13ea75d3$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $78186faf13ea75d3$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $78186faf13ea75d3$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $gyjU7 = parcelRequire("gyjU7");
const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        position: 'relative',
        font: (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        pointerEvents: 'all',
        cursor: isDisabled ? 'not-allowed' : undefined,
        [`${(0, $h9kUS.media).above.xs}`]: {
            font: (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : undefined
        }
    });
const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
    });
const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0,
        paddingRight: "var(--ds-space-050, 4px)"
    });
const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("gyjU7", function(module, exports) {

$parcel$export(module.exports, "noop", () => $109d3f9af5469308$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $109d3f9af5469308$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $109d3f9af5469308$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $109d3f9af5469308$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $109d3f9af5469308$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $109d3f9af5469308$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $109d3f9af5469308$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $109d3f9af5469308$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $109d3f9af5469308$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $109d3f9af5469308$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $109d3f9af5469308$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $109d3f9af5469308$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $109d3f9af5469308$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $109d3f9af5469308$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $109d3f9af5469308$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $109d3f9af5469308$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $109d3f9af5469308$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $109d3f9af5469308$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $109d3f9af5469308$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $109d3f9af5469308$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $109d3f9af5469308$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $109d3f9af5469308$export$4213b25a1c4e877);
const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
    if ($109d3f9af5469308$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $109d3f9af5469308$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $109d3f9af5469308$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
    const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
        $109d3f9af5469308$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $109d3f9af5469308$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $109d3f9af5469308$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $109d3f9af5469308$var$passiveOptionAccessed = false;
const $109d3f9af5469308$var$options = {
    get passive () {
        return $109d3f9af5469308$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
}
const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $109d3f9af5469308$var$isArray(arg) {
    return Array.isArray(arg);
}
function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("eZFhY", function(module, exports) {

$parcel$export(module.exports, "css", () => $728816cb4150b6bc$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $728816cb4150b6bc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
    let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
    let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    if (isDisabled) {
        backgroundColor = "var(--ds-background-disabled, #091E4208)";
        borderColor = "var(--ds-background-disabled, #091E4208)";
    }
    if (isInvalid) {
        borderColor = "var(--ds-border-danger, #E2483D)";
        borderColorHover = "var(--ds-border-danger, #E2483D)";
    }
    const transitionDuration = '200ms';
    if (appearance === 'subtle') {
        borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
        backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
        backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    }
    if (appearance === 'none') {
        borderColor = 'transparent';
        backgroundColor = 'transparent';
        backgroundColorHover = 'transparent';
        borderColorHover = 'transparent';
    }
    return {
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        // Turn pointer events off when disabled - this makes it so hover etc don't work.
        pointerEvents: isDisabled ? 'none' : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
        '&:focus-within': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
        },
        minHeight: isCompact ? 32 : 40,
        padding: 0,
        transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
        '::-webkit-scrollbar': {
            height: 8,
            width: 8
        },
        '::-webkit-scrollbar-corner': {
            display: 'none'
        },
        ':hover': {
            '::-webkit-scrollbar-thumb': {
                // scrollbars occur only if the user passes in a custom component with overflow: scroll
                backgroundColor: 'rgba(0,0,0,0.2)'
            },
            cursor: 'pointer',
            backgroundColor: backgroundColorHover,
            borderColor: borderColorHover
        },
        '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.4)'
        }
    };
};
const $728816cb4150b6bc$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $gyjU7.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;

});

parcelRegister("i48X9", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $902e86f4b4fe337b$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $902e86f4b4fe337b$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $902e86f4b4fe337b$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $902e86f4b4fe337b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $902e86f4b4fe337b$export$b6794329c1460634 = ({})=>({
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-100, 8px)"
    });
const $902e86f4b4fe337b$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({})=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        marginBottom: '0.25em',
        paddingLeft: "var(--ds-space-150, 12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtle, #44546F)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textTransform: 'none'
    });
const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;

});

parcelRegister("95iuW", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $13f090f36c42825d$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $13f090f36c42825d$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $13f090f36c42825d$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $13f090f36c42825d$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $13f090f36c42825d$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $13f090f36c42825d$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $c8Oei = parcelRequire("c8Oei");

var $cQz2U = parcelRequire("cQz2U");

var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $gyjU7 = parcelRequire("gyjU7");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $13f090f36c42825d$var$iconContainerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $13f090f36c42825d$var$dropdownWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.075'
});
const $13f090f36c42825d$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
        as: "span",
        xcss: $13f090f36c42825d$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
};
const $13f090f36c42825d$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: "var(--ds-text-subtlest, #626F86)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear' } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
        xcss: $13f090f36c42825d$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
};
const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isCompact: isCompact })=>({
        label: 'loadingIndicator',
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
    });
const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), {
        size: "small"
    }));
};

});
parcelRegister("cQz2U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7da2857c3151a92889bed61f5baa1334>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));

var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
function $95a586bfe482ffec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
    }, props));
$95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;

});
parcelRegister("47etd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23b3104937a360e799abf4f0ea698b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ff30a5d9a7d32b6$var$_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;

});

parcelRegister("673MF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
function $473654f205f53fc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $473654f205f53fc4$var$SelectClearIcon = (props)=>/*#__PURE__*/ $473654f205f53fc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $473654f205f53fc4$var$_crossCircle.default
    }));
$473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;

});



parcelRegister("dS5G5", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $1c949ac6f5985b40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $1c949ac6f5985b40$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value })=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$1c949ac6f5985b40$var$containerStyle,
        margin: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingTop: "var(--ds-space-025, 2px)",
        color: "var(--ds-text, #172B4D)"
    });
const $1c949ac6f5985b40$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $1c949ac6f5985b40$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$1c949ac6f5985b40$var$spacingStyle
    }
};
const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$1c949ac6f5985b40$var$spacingStyle
    });
const $1c949ac6f5985b40$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $1c949ac6f5985b40$var$inputStyle(isHidden),
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;

});

parcelRegister("aA8TC", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $1fde8cb844828ae2$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $1fde8cb844828ae2$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $1fde8cb844828ae2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $1fde8cb844828ae2$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $1fde8cb844828ae2$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $1fde8cb844828ae2$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $1fde8cb844828ae2$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $1fde8cb844828ae2$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $1fde8cb844828ae2$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $1fde8cb844828ae2$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $gyjU7 = parcelRequire("gyjU7");
function $1fde8cb844828ae2$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $VSDnB.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $1fde8cb844828ae2$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement })=>({
        label: 'menu',
        [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        borderRadius: "var(--ds-border-radius, 4px)",
        marginBottom: "var(--ds-space-100, 8px)",
        marginTop: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-overlay, white)",
        boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
    });
const $1fde8cb844828ae2$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $1fde8cb844828ae2$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $1fde8cb844828ae2$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)"
    });
const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $1fde8cb844828ae2$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, children));
};
const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, children));
};
const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $gyjU7.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("g9RrE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $bc36f1aefc070984$export$deee3a793edee05f);

var $gSfPF = parcelRequire("gSfPF");
var $cVo0M = parcelRequire("cVo0M");

var $cVo0M = parcelRequire("cVo0M");

var $f8LYQ = parcelRequire("f8LYQ");
function $bc36f1aefc070984$var$getCssDimensions(element) {
    const css = (0, $f8LYQ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f8LYQ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cVo0M.round)(width) !== offsetWidth || (0, $cVo0M.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bc36f1aefc070984$var$unwrapElement(element) {
    return !(0, $f8LYQ.isElement)(element) ? element.contextElement : element;
}
function $bc36f1aefc070984$var$getScale(element) {
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    if (!(0, $f8LYQ.isHTMLElement)(domElement)) return (0, $cVo0M.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cVo0M.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cVo0M.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bc36f1aefc070984$var$noOffsets = /*#__PURE__*/ (0, $cVo0M.createCoords)(0);
function $bc36f1aefc070984$var$getVisualOffsets(element) {
    const win = (0, $f8LYQ.getWindow)(element);
    if (!(0, $f8LYQ.isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $f8LYQ.getWindow)(element)) return false;
    return isFixed;
}
function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    let scale = (0, $cVo0M.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f8LYQ.isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
        } else scale = $bc36f1aefc070984$var$getScale(element);
    }
    const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, $cVo0M.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $f8LYQ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $f8LYQ.isElement)(offsetParent) ? (0, $f8LYQ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f8LYQ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f8LYQ.getWindow)(currentIFrame);
            currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        }
    }
    return (0, $cVo0M.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f8LYQ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, $f8LYQ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $f8LYQ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cVo0M.createCoords)(1);
    const offsets = (0, $cVo0M.createCoords)(0);
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if ((0, $f8LYQ.isHTMLElement)(offsetParent)) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
            scale = $bc36f1aefc070984$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, $cVo0M.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bc36f1aefc070984$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bc36f1aefc070984$var$getDocumentRect(element) {
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const scroll = (0, $f8LYQ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cVo0M.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cVo0M.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $f8LYQ.getComputedStyle)(body).direction === 'rtl') x += (0, $cVo0M.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
    const win = (0, $f8LYQ.getWindow)(element);
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $f8LYQ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $f8LYQ.isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, $cVo0M.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, $f8LYQ.getDocumentElement)(element));
    else if ((0, $f8LYQ.isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cVo0M.rectToClientRect)(rect);
}
function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $f8LYQ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $f8LYQ.isElement)(parentNode) || (0, $f8LYQ.isLastTraversableNode)(parentNode)) return false;
    return (0, $f8LYQ.getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f8LYQ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $f8LYQ.isElement)(el) && (0, $f8LYQ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $f8LYQ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f8LYQ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f8LYQ.isElement)(currentNode) && !(0, $f8LYQ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $f8LYQ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $f8LYQ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $f8LYQ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $f8LYQ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bc36f1aefc070984$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f8LYQ.isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cVo0M.max)(rect.top, accRect.top);
        accRect.right = (0, $cVo0M.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cVo0M.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cVo0M.max)(rect.left, accRect.left);
        return accRect;
    }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bc36f1aefc070984$var$getDimensions(element) {
    const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cVo0M.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, $cVo0M.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bc36f1aefc070984$var$isStaticPositioned(element) {
    return (0, $f8LYQ.getComputedStyle)(element).position === 'static';
}
function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f8LYQ.isHTMLElement)(element) || (0, $f8LYQ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f8LYQ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
    const win = (0, $f8LYQ.getWindow)(element);
    if ((0, $f8LYQ.isTopLayer)(element)) return win;
    if (!(0, $f8LYQ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $f8LYQ.getParentNode)(element);
        while(svgOffsetParent && !(0, $f8LYQ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $f8LYQ.isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f8LYQ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f8LYQ.isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f8LYQ.isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, $f8LYQ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $f8LYQ.getContainingBlock)(element) || win;
}
const $bc36f1aefc070984$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bc36f1aefc070984$var$isRTL(element) {
    return (0, $f8LYQ.getComputedStyle)(element).direction === 'rtl';
}
const $bc36f1aefc070984$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f8LYQ.getDocumentElement,
    getClippingRect: $bc36f1aefc070984$var$getClippingRect,
    getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
    getElementRects: $bc36f1aefc070984$var$getElementRects,
    getClientRects: $bc36f1aefc070984$var$getClientRects,
    getDimensions: $bc36f1aefc070984$var$getDimensions,
    getScale: $bc36f1aefc070984$var$getScale,
    isElement: $f8LYQ.isElement,
    isRTL: $bc36f1aefc070984$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bc36f1aefc070984$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $f8LYQ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cVo0M.floor)(top);
        const insetRight = (0, $cVo0M.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cVo0M.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cVo0M.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cVo0M.max)(0, (0, $cVo0M.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f8LYQ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $f8LYQ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, $gSfPF.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bc36f1aefc070984$export$cc800923e997bb8 = (0, $gSfPF.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, $gSfPF.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bc36f1aefc070984$export$fba63a578e423eb = (0, $gSfPF.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, $gSfPF.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bc36f1aefc070984$export$346677f925de839c = (0, $gSfPF.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bc36f1aefc070984$export$fe8985bb6374093c = (0, $gSfPF.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, $gSfPF.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, $gSfPF.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, $gSfPF.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bc36f1aefc070984$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $gSfPF.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("gSfPF", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $c48df878d8118962$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $c48df878d8118962$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $c48df878d8118962$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $c48df878d8118962$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $c48df878d8118962$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $c48df878d8118962$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $c48df878d8118962$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $c48df878d8118962$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $c48df878d8118962$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $c48df878d8118962$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $c48df878d8118962$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("cVo0M")).rectToClientRect);

var $cVo0M = parcelRequire("cVo0M");
function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cVo0M.getSideAxis)(placement);
    const alignmentAxis = (0, $cVo0M.getAlignmentAxis)(placement);
    const alignLength = (0, $cVo0M.getAxisLength)(alignmentAxis);
    const side = (0, $cVo0M.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cVo0M.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state);
    const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cVo0M.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cVo0M.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cVo0M.getAlignmentAxis)(placement);
            const length = (0, $cVo0M.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cVo0M.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cVo0M.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cVo0M.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cVo0M.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cVo0M.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cVo0M.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cVo0M.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cVo0M.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cVo0M.placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cVo0M.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cVo0M.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cVo0M.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cVo0M.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cVo0M.getSide)(placement);
            const initialSideAxis = (0, $cVo0M.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cVo0M.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cVo0M.getOppositePlacement)(initialPlacement)
            ] : (0, $cVo0M.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cVo0M.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cVo0M.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cVo0M.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
    return (0, $cVo0M.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c48df878d8118962$var$getBoundingRect(rects) {
    const minX = (0, $cVo0M.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cVo0M.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cVo0M.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cVo0M.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c48df878d8118962$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cVo0M.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cVo0M.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cVo0M.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cVo0M.getSide)(placement) === 'left';
                    const maxRight = (0, $cVo0M.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cVo0M.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c48df878d8118962$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cVo0M.getSide)(placement);
    const alignment = (0, $cVo0M.getAlignment)(placement);
    const isVertical = (0, $cVo0M.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cVo0M.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c48df878d8118962$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cVo0M.getSideAxis)((0, $cVo0M.getSide)(placement));
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cVo0M.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cVo0M.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cVo0M.getSideAxis)(placement);
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cVo0M.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cVo0M.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c48df878d8118962$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cVo0M.getSide)(placement);
            const alignment = (0, $cVo0M.getAlignment)(placement);
            const isYAxis = (0, $cVo0M.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cVo0M.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cVo0M.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cVo0M.max)(overflow.left, 0);
                const xMax = (0, $cVo0M.max)(overflow.right, 0);
                const yMin = (0, $cVo0M.max)(overflow.top, 0);
                const yMax = (0, $cVo0M.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cVo0M.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cVo0M.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cVo0M", function(module, exports) {

$parcel$export(module.exports, "sides", () => $968d6f1d7e429938$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $968d6f1d7e429938$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $968d6f1d7e429938$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $968d6f1d7e429938$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $968d6f1d7e429938$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $968d6f1d7e429938$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $968d6f1d7e429938$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $968d6f1d7e429938$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $968d6f1d7e429938$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $968d6f1d7e429938$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $968d6f1d7e429938$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $968d6f1d7e429938$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $968d6f1d7e429938$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $968d6f1d7e429938$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $968d6f1d7e429938$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $968d6f1d7e429938$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $968d6f1d7e429938$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $968d6f1d7e429938$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $968d6f1d7e429938$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $968d6f1d7e429938$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $968d6f1d7e429938$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $968d6f1d7e429938$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $968d6f1d7e429938$export$803cd8101b6c182b = /*#__PURE__*/ $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $968d6f1d7e429938$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $968d6f1d7e429938$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
    return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
}
function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
    return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
}
function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
    const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
    const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
    return [
        $968d6f1d7e429938$export$2b182c584985588b(placement),
        oppositePlacement,
        $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
    ];
}
function $968d6f1d7e429938$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
}
function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
    }
    return list;
}
function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
}
function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("f8LYQ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $b05cd24baa7455b6$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $b05cd24baa7455b6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $b05cd24baa7455b6$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $b05cd24baa7455b6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b05cd24baa7455b6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $b05cd24baa7455b6$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $b05cd24baa7455b6$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $b05cd24baa7455b6$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $b05cd24baa7455b6$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $b05cd24baa7455b6$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $b05cd24baa7455b6$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $b05cd24baa7455b6$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $b05cd24baa7455b6$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $b05cd24baa7455b6$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $b05cd24baa7455b6$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $b05cd24baa7455b6$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $b05cd24baa7455b6$export$7bf1f8740e3e34af);
function $b05cd24baa7455b6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b05cd24baa7455b6$export$651544f548703224(node) {
    if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b05cd24baa7455b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
}
function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
}
function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
    if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b05cd24baa7455b6$export$651544f548703224(element));
}
function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
    const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b05cd24baa7455b6$export$940d8225183e1404(element) {
    let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
    while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b05cd24baa7455b6$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b05cd24baa7455b6$export$651544f548703224(node));
}
function $b05cd24baa7455b6$export$3735103072e4a80(element) {
    return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
    if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
    if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b05cd24baa7455b6$export$e495491855dc5418(node);
    return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
    const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
    if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
}
function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = (0, $5uXOq.useLayoutEffect);

});


parcelRegister("hqcPo", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $20933ad7b05a0c37$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $20933ad7b05a0c37$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $20933ad7b05a0c37$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $20933ad7b05a0c37$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $20933ad7b05a0c37$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $20933ad7b05a0c37$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $673MF = parcelRequire("673MF");

var $bjGSs = parcelRequire("bjGSs");

var $VSDnB = parcelRequire("VSDnB");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $gyjU7 = parcelRequire("gyjU7");
function $20933ad7b05a0c37$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $20933ad7b05a0c37$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused })=>{
    let backgroundColor;
    let color;
    if (isDisabled) {
        // Use the basic neutral background so it is slightly separate from the
        // field's background
        backgroundColor = "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text-disabled, #091E424F)";
    } else if (isFocused) {
        backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
    } else {
        backgroundColor = (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text, hsl(0, 0%, 20%))";
    }
    return {
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        margin: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        backgroundColor: backgroundColor,
        boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
        maxWidth: '100%',
        '@media screen and (-ms-high-contrast: active)': {
            border: isFocused ? '1px solid transparent' : 'none'
        },
        color: color,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            borderRadius: "var(--ds-border-radius-100, 4px)",
            // Hardcode this color for visual refresh as there is no token color yet
            borderColor: '#B7B9BE',
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            backgroundColor: "var(--ds-background-input, #FFFFFF)"
        }
    };
};
const $20933ad7b05a0c37$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '85%',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        padding: "var(--ds-space-025, 2px)",
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
        paddingLeft: "var(--ds-space-075, 6px)",
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "var(--ds-space-050, 4px)"
        }
    });
const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
        alignItems: 'center',
        display: 'flex',
        backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
        fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-025, 2px)",
        borderRadius: '0px 2px 2px 0px',
        // DSP-6470 we should style like Tag once we have the :has selector
        ':hover': {
            backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
            fill: "var(--ds-text-danger, #000)"
        },
        ':active': {
            backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
            fill: "var(--ds-text-danger, #000)"
        },
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            appearance: 'none',
            borderRadius: "var(--ds-border-radius, 4px)",
            color: "var(--ds-text, #172B4D)",
            padding: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            ':focus-visible': {
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            ':hover': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            }
        }
    });
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $20933ad7b05a0c37$var$MultiValueGeneric = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$var$MultiValueGeneric;
const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$var$MultiValueGeneric;
const $20933ad7b05a0c37$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $20933ad7b05a0c37$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $20933ad7b05a0c37$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.025'
});
const $20933ad7b05a0c37$var$renderIcon = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
        label: "",
        color: "currentColor"
    });
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
        xcss: $20933ad7b05a0c37$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
        label: "",
        color: "currentColor"
    }));
    return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($673MF))), {
        label: "",
        primaryColor: "transparent",
        size: "small",
        secondaryColor: "inherit"
    }));
};
function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, innerProps: innerProps }) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $20933ad7b05a0c37$var$disabledStyles : $20933ad7b05a0c37$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, $20933ad7b05a0c37$var$renderIcon())));
}
const $20933ad7b05a0c37$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            role: 'button',
            tabIndex: -1,
            'aria-label': `${ariaLabel || 'option'}, remove`,
            ...removeProps
        },
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;

});

parcelRegister("8l2RA", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $6e6d67a90b457dc1$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $6e6d67a90b457dc1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    let color = "var(--ds-text, #172B4D)";
    if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
    else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
    let boxShadow;
    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
    else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
    const cursor = isDisabled ? 'not-allowed' : 'default';
    return {
        label: 'option',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        backgroundColor: backgroundColor,
        color: color,
        cursor: cursor,
        boxShadow: boxShadow,
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
        }
    };
};
const $6e6d67a90b457dc1$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;

});

parcelRegister("kKm82", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $889d652a9d0dc097$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $889d652a9d0dc097$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
    });
const $889d652a9d0dc097$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;

});

parcelRegister("hpcbi", function(module, exports) {

$parcel$export(module.exports, "css", () => $aff94346c62a222f$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $aff94346c62a222f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled })=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
    });
const $aff94346c62a222f$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;

});


parcelRegister("jtVgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe53037961824c2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $afe53037961824c2$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $afe53037961824c2$var$dummyInputStyles
    });
}

});

parcelRegister("9cRAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a388fa48a9e96271$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $eGmKJ = parcelRequire("eGmKJ");
function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a388fa48a9e96271$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $a388fa48a9e96271$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;

});

parcelRegister("galqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15a49c0b3452f71$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $59IMp = parcelRequire("59IMp");

var $3jzRI = parcelRequire("3jzRI");
function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e15a49c0b3452f71$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $59IMp.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $3jzRI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onClick: $e15a49c0b3452f71$var$blurSelectInput,
        css: $e15a49c0b3452f71$var$styles
    }), children(targetRef));
}

});
parcelRegister("59IMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c08116303d9e3a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
const $96c08116303d9e3a$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $gyjU7.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("3jzRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $840302f0f43020c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $840302f0f43020c5$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $840302f0f43020c5$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $840302f0f43020c5$var$preventTouchMove(e) {
    e.preventDefault();
}
function $840302f0f43020c5$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $840302f0f43020c5$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $840302f0f43020c5$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $840302f0f43020c5$var$activeScrollLocks = 0;
const $840302f0f43020c5$var$listenerOptions = {
    capture: false,
    passive: false
};
function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $840302f0f43020c5$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("7uagk", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $7a4261c0e93bff6e$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $7a4261c0e93bff6e$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("81i5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ccfcdca5695e58$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $dQlbw = parcelRequire("dQlbw");

var $bEd7d = parcelRequire("bEd7d");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), !(0, $VSDnB.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance)));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bEd7d.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bEd7d.default), {
        "aria-live": ariaLive,
        "aria-atomic": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
        "aria-relevant": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
        role: (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? 'status' : 'log'
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;

});
parcelRegister("dQlbw", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $d3258ad64818881e$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $VSDnB = parcelRequire("VSDnB");
const $d3258ad64818881e$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || !(0, $VSDnB.fg)('design_system_select-a11y-improvement') ? `option ${label}, deselected` : ''; // TODO: this should be handled on backspace|delete if no value, but doing it here first
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return label.length && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || !(0, $VSDnB.fg)('design_system_select-a11y-improvement') ? `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.` : '';
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        // No longer needed after fg('design_system_select-a11y-improvement') is cleaned up
        if (context === 'menu' && !(0, $VSDnB.fg)('design_system_select-a11y-improvement')) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ' not selected'}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("bEd7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc43afa82d3c33b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $7cc43afa82d3c33b$var$styles = {
    name: "jvmzbk-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;user-select:none;white-space:nowrap"
};
const $7cc43afa82d3c33b$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $7cc43afa82d3c33b$var$styles,
        ...props
    });
var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;

});


parcelRegister("5JAlL", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $bXu2O = parcelRequire("bXu2O");
const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $bXu2O.stripDiacritics));
const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $bXu2O.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("bXu2O", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $df93339199dda18e$export$b5bee4b27048330b);
const $df93339199dda18e$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $df93339199dda18e$var$diacriticToBase = {};
for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
    let diacritic = $df93339199dda18e$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
    return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
};

});


parcelRegister("7VXAu", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $11d0fd648d1f51c0$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $11d0fd648d1f51c0$export$e618dc39ac9ad607);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
    clearIndicator: (0, $95iuW.clearIndicatorCSS),
    container: (0, $h1QWG.containerCSS),
    control: (0, $eZFhY.css),
    dropdownIndicator: (0, $95iuW.dropdownIndicatorCSS),
    group: (0, $i48X9.groupCSS),
    groupHeading: (0, $i48X9.groupHeadingCSS),
    indicatorsContainer: (0, $h1QWG.indicatorsContainerCSS),
    input: (0, $dS5G5.inputCSS),
    loadingIndicator: (0, $95iuW.loadingIndicatorCSS),
    loadingMessage: (0, $aA8TC.loadingMessageCSS),
    menu: (0, $aA8TC.menuCSS),
    menuList: (0, $aA8TC.menuListCSS),
    menuPortal: (0, $aA8TC.menuPortalCSS),
    multiValue: (0, $hqcPo.multiValueCSS),
    multiValueLabel: (0, $hqcPo.multiValueLabelCSS),
    multiValueRemove: (0, $hqcPo.multiValueRemoveCSS),
    noOptionsMessage: (0, $aA8TC.noOptionsMessageCSS),
    option: (0, $8l2RA.optionCSS),
    placeholder: (0, $kKm82.placeholderCSS),
    singleValue: (0, $hpcbi.css),
    valueContainer: (0, $h1QWG.valueContainerCSS)
};
function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("iaInK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e85c90096c52fe4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $5uXOq.useRef)(undefined);
    const mounted = (0, $5uXOq.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5uXOq.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $gyjU7.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("9uJ4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b6d9d338d10de1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("3c98u", function(module, exports) {

$parcel$export(module.exports, "default", () => $628a0199069e875a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $1DATb = parcelRequire("1DATb");
function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'assertive',
            ariaLiveMessages: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            //TO DO: Still need live region for PopupSelect because of the menu being open by default
            (0, $1DATb.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $1DATb.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("1DATb", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $a998ee34d66f3da7$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $a998ee34d66f3da7$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $a998ee34d66f3da7$export$8ee33f304118fce4);

var $VSDnB = parcelRequire("VSDnB");
function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    if (focused.label && groupData?.label && (0, $VSDnB.fg)('design_system_select-a11y-improvement')) return `${focused.label}, ${groupData?.label}`;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("itpgN", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $f5875245cd0ad0c1$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $f5875245cd0ad0c1$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6aY6N = parcelRequire("6aY6N");

var $iQHJo = parcelRequire("iQHJo");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
const $f5875245cd0ad0c1$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $f5875245cd0ad0c1$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $f5875245cd0ad0c1$var$baseIconStyles = null;
const $f5875245cd0ad0c1$var$baseOptionStyles = null;
// eslint-disable-next-line @repo/internal/react/no-class-components
const $f5875245cd0ad0c1$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $5uXOq.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $f5875245cd0ad0c1$var$optionStyles.default,
            isFocused && $f5875245cd0ad0c1$var$optionStyles.focused,
            isDisabled && $f5875245cd0ad0c1$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $f5875245cd0ad0c1$var$iconStyles.inherit : $f5875245cd0ad0c1$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    label: "",
                    primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/platform/no-preconditioning
        (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($6aY6N))),
        ...props
    });
const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/platform/no-preconditioning
        (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($iQHJo))),
        ...props
    });

});
parcelRegister("6aY6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
function $47f24d9003b82760$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47f24d9003b82760$var$CheckboxIcon = (props)=>/*#__PURE__*/ $47f24d9003b82760$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $47f24d9003b82760$var$_checkboxChecked.default
    }));
$47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;

});
parcelRegister("aoKYM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79209663d32c0c44$var$_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79209663d32c0c44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;

});


parcelRegister("iQHJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db8f016a0af5fda9$var$RadioIcon = (props)=>/*#__PURE__*/ $db8f016a0af5fda9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $db8f016a0af5fda9$var$_radioChecked.default
    }));
$db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;

});
parcelRegister("kqGQn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f37934c6709a990262261073c8d0052>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $edf7783e719984ba$var$_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $edf7783e719984ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;

});




parcelRegister("dlgLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e099e320aca8301$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $3e099e320aca8301$var$TestIdWrapper = ({ testId: testId, children: children })=>{
    if (testId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId
    }, children);
    return children;
};
var $3e099e320aca8301$export$2e2bcd8739ae039 = $3e099e320aca8301$var$TestIdWrapper;

});

parcelRegister("ignom", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ddf8796d37f8acf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ddf8796d37f8acf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assetTypesLabel: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.assets.asset-types-label",
        "defaultMessage": "Asset types"
    },
    assetTypesPlaceholder: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.assets.asset-types-placeholder",
        "defaultMessage": "Any type"
    },
    assetTypesDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.assets.asset-types-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t edit this field\u2019s asset types"
    },
    noAssetTypes: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.assets.no-asset-types",
        "defaultMessage": "No asset types"
    }
});

});



parcelRegister("gX3J2", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $6b65484a204f18ef$export$6e0f0a958dc8ef91);

const $6b65484a204f18ef$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyOptions || operations.canModifyDefaultValue;

});

parcelRegister("7xtmF", function(module, exports) {

$parcel$export(module.exports, "CascadingDropdown", () => $92fe010008145f5a$export$24252a0c62dc3678);

var $5uXOq = parcelRequire("5uXOq");

var $8dBBB = parcelRequire("8dBBB");

var $8G7jD = parcelRequire("8G7jD");

var $gvyUb = parcelRequire("gvyUb");

var $6rA66 = parcelRequire("6rA66");
const $92fe010008145f5a$export$1b4ddbf43e95b989 = (field)=>{
    const { defaultValue: defaultValue, options: options } = field;
    if (options == null) return field;
    const refined = (0, $8G7jD.refineDefaultValue)(defaultValue);
    if (refined.length === 0) return field;
    return {
        ...field,
        defaultValue: options.find((0, $8G7jD.isDefaultOption)(refined))
    };
};
const $92fe010008145f5a$export$24252a0c62dc3678 = (props)=>{
    const onFieldUpdate = (field)=>{
        const { onUpdate: onUpdate } = props;
        onUpdate($92fe010008145f5a$export$1b4ddbf43e95b989(field));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dBBB.CascadingFieldOptions), {
        ...props,
        label: (0, $6rA66.default).optionsHeader,
        onUpdate: onFieldUpdate,
        DefaultValueControlRight: (0, $gvyUb.DefaultValueControlRight)
    });
};

});
parcelRegister("8dBBB", function(module, exports) {

$parcel$export(module.exports, "CascadingFieldOptions", () => $5387f058c4ebfd20$export$1c3d224dcf005e67);

var $5uXOq = parcelRequire("5uXOq");

var $3ZT8o = parcelRequire("3ZT8o");

var $7Jxgt = parcelRequire("7Jxgt");

var $3XO6n = parcelRequire("3XO6n");

var $g5X3G = parcelRequire("g5X3G");

var $kqJFH = parcelRequire("kqJFH");

var $e2ztK = parcelRequire("e2ztK");
const $5387f058c4ebfd20$export$1c3d224dcf005e67 = (props)=>{
    const [lastAddedOptimisticId, setLastAddedOptimisticId] = (0, $5uXOq.useState)(null);
    const optionsModified = (options)=>{
        const { field: field, onUpdate: onUpdate } = props;
        onUpdate({
            ...field,
            options: options
        });
    };
    const onEditOption = (option, newValue)=>{
        const { field: { options: options } } = props;
        if (options == null) return;
        const newOptions = options.map((o)=>{
            if (o === option) return {
                ...o,
                value: newValue
            };
            return o;
        });
        optionsModified(newOptions);
    };
    const onRemoveOption = (option)=>{
        const { field: { options: options } } = props;
        if (options == null || options.length === 1) // There must be at least one option so do not allow deleting the last one
        return;
        optionsModified(options.filter((o)=>o !== option && o.parentExternalUuid !== option.externalUuid));
    };
    const onAddOption = (parentId)=>{
        const { field: field, field: { options: options = [] }, limits: limits } = props;
        // Prevent adding a new option when the add button is disabled and the enter key is pressed
        if (!(0, $e2ztK.canAddNewOptions)(field, limits)) return;
        const parent = parentId === 'root' ? null : options.find((option)=>option.externalUuid === parentId);
        if (parent === undefined) return;
        const peerOptions = (0, $e2ztK.groupCascadingSelectFieldOptions)(options)[parentId] || [];
        const last = peerOptions[peerOptions.length - 1];
        // Do not add another empty option if there is one already
        if (last && last.value === '') return;
        const optionExternalUuid = (0, $g5X3G.toOptionUuid)((0, $7Jxgt.v4)());
        const optimisticId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))((0, $3XO6n.NEW_FIELD_OPTION_PREFIX));
        const newOptions = [
            ...options,
            // Prefix optimisticId to avoid collision with options returned from the API
            {
                value: '',
                id: null,
                optimisticId: optimisticId,
                externalUuid: optionExternalUuid,
                parentId: parent ? parent.id : undefined,
                parentExternalUuid: parent ? parent.externalUuid : undefined
            }
        ];
        setLastAddedOptimisticId(optimisticId);
        optionsModified(newOptions);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqJFH.RootOptionsList), {
        ...props,
        onAddOption: onAddOption,
        onEditOption: onEditOption,
        onRemoveOption: onRemoveOption,
        lastAddedOptimisticId: lastAddedOptimisticId,
        optionsByParent: (0, $e2ztK.groupCascadingSelectFieldOptions)(props.field.options)
    });
};

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("kqJFH", function(module, exports) {

$parcel$export(module.exports, "RootOptionsList", () => $efc2f387ea1e529c$export$90a594d39c9e5a2b);

var $5uXOq = parcelRequire("5uXOq");

var $2vwkj = parcelRequire("2vwkj");
const $efc2f387ea1e529c$export$90a594d39c9e5a2b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2vwkj.CascadingFieldOptionsList), {
        ...props,
        parentId: "root"
    });

});
parcelRegister("2vwkj", function(module, exports) {

$parcel$export(module.exports, "CascadingFieldOptionsList", () => $87d0c60bb2363e5f$export$b301dee464ce4711);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2Zxiy = parcelRequire("2Zxiy");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $faod6 = parcelRequire("faod6");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $koVbs = parcelRequire("koVbs");

var $5o4rc = parcelRequire("5o4rc");


var $8G7jD = parcelRequire("8G7jD");

var $l6Iz9 = parcelRequire("l6Iz9");

var $e2ztK = parcelRequire("e2ztK");

var $8CNiY = parcelRequire("8CNiY");
const $87d0c60bb2363e5f$var$getTranslatedErrorFor = (option, fieldErrors, intl)=>{
    const error = fieldErrors.find((err)=>err.position === (0, $d2e37636a1b0be7f$export$cc69bd2d2695dc1d) && err.positionId != null && err.positionId.optionOptimisticId === option.optimisticId);
    if (!error) return undefined;
    return intl.formatMessage(error.messageDescriptor, error.values);
};
const $87d0c60bb2363e5f$var$getAddButtonTooltip = (field, limits, intl)=>{
    if (!field.operations.canModifyOptions) return intl.formatMessage((0, $8CNiY.default).addButtonDisabledNoModify);
    if ((0, $8G7jD.isOptionsPerFieldLimitReached)(field, limits)) return intl.formatMessage((0, $8CNiY.default).addButtonDisabledMaxOptions, {
        maxOptions: limits.optionsPerField
    });
    return null;
};
const $87d0c60bb2363e5f$export$b301dee464ce4711 = (props)=>{
    const onAddOption = ()=>{
        props.onAddOption(props.parentId);
    };
    const intl = (0, $koVbs.default)();
    const { field: field, fieldErrors: fieldErrors, optionsByParent: optionsByParent, label: label, DefaultValueControlLeft: DefaultValueControlLeft, DefaultValueControlRight: DefaultValueControlRight, parentId: parentId, onRemoveOption: onRemoveOption, onEditOption: onEditOption, lastAddedOptimisticId: lastAddedOptimisticId, onUpdate: onUpdate, limits: limits, tooltipDelay: tooltipDelay } = props;
    const options = optionsByParent[parentId] || [];
    const isTopLevel = parentId === 'root';
    const isAddDisabled = !(0, $e2ztK.canAddNewOptions)(field, limits); // There must be at least 1 option at the top level
    const canDeleteOptions = !isTopLevel || options.length > 1;
    const preselectedOptions = (0, $8G7jD.refineDefaultValue)(field.defaultValue); // Droppable only rerenders when drag-and-drop information changes.
    // Options are not drag and drop information, they come from us,
    // so we need to use a different function every time DropdownOptions renders,
    // to trigger a prop change (therefore rerender) of Droppable.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $87d0c60bb2363e5f$var$dropdownOptionsStyledStyles
    }, isTopLevel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, intl.formatMessage(label)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Droppable), {
        droppableId: (0, $5o4rc.toDroppableId)(field.key, parentId),
        type: isTopLevel ? (0, $5o4rc.PARENT_OPTION_DRAGGABLE_TYPE) : (0, $5o4rc.CHILD_OPTION_DRAGGABLE_TYPE)
    }, ({ innerRef: innerRef, droppableProps: droppableProps, placeholder: placeholder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87d0c60bb2363e5f$var$List, {
            ref: innerRef,
            ...droppableProps
        }, options.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6Iz9.Option), {
                key: option.optimisticId,
                placeholder: intl.formatMessage((0, $8CNiY.default).optionPlaceholder, {
                    index: index + 1
                }),
                option: option,
                field: field,
                autoFocus: option.optimisticId === lastAddedOptimisticId,
                onRemove: onRemoveOption,
                onEnterKey: onAddOption,
                onEdit: onEditOption,
                onUpdate: onUpdate,
                isDeletable: canDeleteOptions,
                isDefault: (0, $8G7jD.isDefaultOption)(preselectedOptions)(option),
                DefaultValueControlLeft: DefaultValueControlLeft,
                DefaultValueControlRight: DefaultValueControlRight,
                translatedError: $87d0c60bb2363e5f$var$getTranslatedErrorFor(option, fieldErrors, intl),
                index: index,
                tooltipDelay: tooltipDelay
            }, isTopLevel && option.externalUuid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87d0c60bb2363e5f$export$b301dee464ce4711, {
                ...props,
                parentId: option.externalUuid
            }) : null)), placeholder, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: $87d0c60bb2363e5f$var$getAddButtonTooltip(field, limits, intl),
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
            isDisabled: isAddDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            isDisabled: isAddDisabled,
            appearance: "subtle" // label is not needed on this icon because there is button text
            ,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
                label: ""
            }),
            onClick: onAddOption
        }, intl.formatMessage(isTopLevel ? (0, $8CNiY.default).addNewParentOption : (0, $8CNiY.default).addNewChildOption)))))));
};
const $87d0c60bb2363e5f$var$dropdownOptionsStyledStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.500',
    paddingLeft: 'space.500',
    marginBottom: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87d0c60bb2363e5f$var$List = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2mzuglyw _19bvze3t _19pk1b66 _2hwxze3t _otyrze3t _18u0ze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jQtKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbfcf6b8255255f$export$2e2bcd8739ae039);

var $47bDC = parcelRequire("47bDC");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbfcf6b8255255f$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $47bDC.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$4dbfcf6b8255255f$export$2e2bcd8739ae039 = $4dbfcf6b8255255f$var$DisabledButtonWithTooltip;

});

parcelRegister("5o4rc", function(module, exports) {

$parcel$export(module.exports, "OPTION_DRAGGABLE_TYPE", () => $5c03be808bafcf3a$export$8a348951a9fc2b04);
$parcel$export(module.exports, "PARENT_OPTION_DRAGGABLE_TYPE", () => $5c03be808bafcf3a$export$cbeb109fa0c391ce);
$parcel$export(module.exports, "CHILD_OPTION_DRAGGABLE_TYPE", () => $5c03be808bafcf3a$export$d055a8f0d9da03ed);
$parcel$export(module.exports, "toDroppableId", () => $5c03be808bafcf3a$export$5fd969ec1e564b39);
$parcel$export(module.exports, "parseDroppableId", () => $5c03be808bafcf3a$export$dd98c25bb9f41a34);
$parcel$export(module.exports, "toDraggableId", () => $5c03be808bafcf3a$export$88fa4c94b552df6e);
$parcel$export(module.exports, "toId", () => $5c03be808bafcf3a$export$2eb5b510ed7bb259);
const $5c03be808bafcf3a$export$8a348951a9fc2b04 = 'field.option';
const $5c03be808bafcf3a$export$cbeb109fa0c391ce = 'field.option.parent';
const $5c03be808bafcf3a$export$d055a8f0d9da03ed = 'field.option.child';
const $5c03be808bafcf3a$var$OPTION_DRAGGABLE_PREFIX = 'field.option';
const $5c03be808bafcf3a$export$5fd969ec1e564b39 = (fieldKey, parentId)=>`${fieldKey}#${parentId}`;
const $5c03be808bafcf3a$export$dd98c25bb9f41a34 = (droppableId)=>{
    const [fieldKey, parentOptionId] = droppableId.split('#');
    return {
        fieldKey: fieldKey,
        parentOptionId: parentOptionId || ''
    };
};
const $5c03be808bafcf3a$export$88fa4c94b552df6e = (id)=>`${$5c03be808bafcf3a$var$OPTION_DRAGGABLE_PREFIX}-${id}`;
const $5c03be808bafcf3a$export$2eb5b510ed7bb259 = (draggableId)=>draggableId.startsWith($5c03be808bafcf3a$var$OPTION_DRAGGABLE_PREFIX) ? draggableId.slice($5c03be808bafcf3a$var$OPTION_DRAGGABLE_PREFIX.length + 1) : null;

});

const $d2e37636a1b0be7f$export$9375b5f6fd0a43c1 = 'issue-type-name-input';
const $d2e37636a1b0be7f$export$cb807c52d310479f = 'issue-type-help-text-input';
const $d2e37636a1b0be7f$export$b3eded1439af86ec = 'issue-type-description-input';
const $d2e37636a1b0be7f$export$46836eb4ff11521d = 'field-name-input';
const $d2e37636a1b0be7f$export$cc69bd2d2695dc1d = 'field-options';
const $d2e37636a1b0be7f$export$fa640bba89c0678c = 'field-default-value-input';
const $d2e37636a1b0be7f$export$79e928bf2e38d2f4 = 'field-description-input';
const $d2e37636a1b0be7f$export$9248857307f14dc5 = 'inactive-layout-item';
const $d2e37636a1b0be7f$export$f94572acf95fe16 = 'issueTypeNameValidator';
const $d2e37636a1b0be7f$export$d12a5e85a72705c1 = 'issueTypeHelpTextValidator';
const $d2e37636a1b0be7f$export$66a5f2695bdd185c = 'issueTypeDescriptionValidator';

parcelRegister("8G7jD", function(module, exports) {

$parcel$export(module.exports, "refineDefaultValue", () => $1e1213e8febaff16$export$7ed87108605c2);
$parcel$export(module.exports, "isDefaultOption", () => $1e1213e8febaff16$export$e73019f09357ae98);
$parcel$export(module.exports, "isOptionsPerFieldLimitReached", () => $1e1213e8febaff16$export$de82ffaa4a3a61d6);
$parcel$export(module.exports, "FieldOptions", () => $1e1213e8febaff16$export$3feb8dd00bcf2932);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3ZT8o = parcelRequire("3ZT8o");

var $2Zxiy = parcelRequire("2Zxiy");

var $7Jxgt = parcelRequire("7Jxgt");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $faod6 = parcelRequire("faod6");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $koVbs = parcelRequire("koVbs");

var $3XO6n = parcelRequire("3XO6n");

var $5o4rc = parcelRequire("5o4rc");

var $g5X3G = parcelRequire("g5X3G");

var $6s1PB = parcelRequire("6s1PB");

var $ek97b = parcelRequire("ek97b");

var $5fc53 = parcelRequire("5fc53");

var $1XJ20 = parcelRequire("1XJ20");

var $4R6GH = parcelRequire("4R6GH");


var $4VCVr = parcelRequire("4VCVr");
const $1e1213e8febaff16$var$getTranslatedErrorFor = (option, fieldErrors, intl)=>{
    const error = fieldErrors.find((err)=>err.position === (0, $d2e37636a1b0be7f$export$cc69bd2d2695dc1d) && err.positionId != null && err.positionId.optionOptimisticId === option.optimisticId);
    if (!error) return undefined;
    return intl.formatMessage(error.messageDescriptor, error.values);
};
const $1e1213e8febaff16$export$488ceaf1342ab2be = (defaultValue)=>{
    if (defaultValue == null || typeof defaultValue !== 'object' || !('id' in defaultValue) || defaultValue.id !== null && typeof defaultValue.id !== 'number') return null;
    let optimisticId;
    if ('optimisticId' in defaultValue && typeof defaultValue.optimisticId === 'string') optimisticId = defaultValue.optimisticId;
    else if (defaultValue.id !== null) optimisticId = defaultValue.id.toString();
    else // This scenario will never occur as whenever id is null optimisticId will exist. However we return null here to prevent flow errors.
    return null;
    let externalUuid;
    if ('externalUuid' in defaultValue && typeof defaultValue.externalUuid === 'string') externalUuid = (0, $g5X3G.toOptionUuid)(defaultValue.externalUuid);
    let value;
    if ('value' in defaultValue) value = String(defaultValue.value);
    else value = '';
    return {
        id: defaultValue.id,
        optimisticId: optimisticId,
        value: value,
        externalUuid: externalUuid
    };
};
const $1e1213e8febaff16$export$7ed87108605c2 = (defaultValue)=>{
    let maybeOptions; /*
                                                       * This file handles both radios and checkboxes.
                                                       * Radios can only have one preselected option so the `defaultValue` will be always an object.
                                                       * Checkboxes can have multiple so the `defaultValue` is always an array (even when only one is preselected).
                                                       * Or null.
                                                       */ 
    if (Array.isArray(defaultValue)) maybeOptions = defaultValue.map($1e1213e8febaff16$export$488ceaf1342ab2be);
    else maybeOptions = [
        $1e1213e8febaff16$export$488ceaf1342ab2be(defaultValue)
    ];
    return maybeOptions.filter(Boolean);
};
const $1e1213e8febaff16$export$e73019f09357ae98 = (defaultValue)=>(option)=>defaultValue.some((defaultOption)=>defaultOption.id === null ? defaultOption.optimisticId === option.optimisticId : defaultOption.id === option.id);
const $1e1213e8febaff16$export$de82ffaa4a3a61d6 = (field, limits)=>{
    const limit = limits.optionsPerField;
    const { options: options } = field;
    return limit !== null && limit > 0 && options !== undefined && options.length >= limit;
};
const $1e1213e8febaff16$var$getAddButtonTooltip = (field, limits, intl)=>{
    if (!field.operations.canModifyOptions) return intl.formatMessage((0, $4VCVr.default).addButtonDisabledNoModify);
    if ($1e1213e8febaff16$export$de82ffaa4a3a61d6(field, limits)) return intl.formatMessage((0, $4VCVr.default).addButtonDisabledMaxOptions, {
        maxOptions: limits.optionsPerField
    });
    return null;
};
function $1e1213e8febaff16$var$canAddNewOptions(field, limits) {
    return field.operations.canModifyOptions && !$1e1213e8febaff16$export$de82ffaa4a3a61d6(field, limits);
}
const $1e1213e8febaff16$export$3feb8dd00bcf2932 = (props)=>{
    const optionsModified = (options)=>{
        const { field: field, onUpdate: onUpdate } = props;
        onUpdate({
            ...field,
            options: options
        });
    };
    const prevOptionsCount = (0, $1XJ20.usePrevious)(props.field?.options?.length || 0);
    const onEditOption = (option, newValue)=>{
        const { field: { options: options = [] } } = props;
        const newOptions = options.map((o)=>{
            if (o === option) return {
                ...o,
                value: newValue
            };
            return o;
        });
        optionsModified(newOptions);
    };
    const onSaveColor = (option, newColor)=>{
        const { field: { options: options = [] } } = props;
        const newOptions = options.map((o)=>{
            if (o === option) return {
                ...o,
                colour: newColor
            };
            return o;
        });
        optionsModified(newOptions);
    };
    const onRemoveOption = (option)=>{
        const { field: { options: options = [] } } = props;
        if (options.length === 1) // There must be at least one option so do not allow deleting the last one
        return;
        optionsModified(options.filter((o)=>o !== option));
    };
    const onAddOption = ()=>{
        const { field: field, field: { options: options = [] }, limits: limits } = props; // Prevent adding a new option when the add button is disabled and the enter key is pressed
        if (!$1e1213e8febaff16$var$canAddNewOptions(field, limits)) return;
        const last = options[options.length - 1]; // Do not add another empty option if there is one already
        if (last && last.value === '') return;
        const optionExternalUuid = (0, $g5X3G.toOptionUuid)((0, $7Jxgt.v4)());
        optionsModified([
            ...options,
            // Prefix optimisticId to avoid collision with options returned from the API
            {
                value: '',
                id: null,
                optimisticId: (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))((0, $3XO6n.NEW_FIELD_OPTION_PREFIX)),
                externalUuid: optionExternalUuid,
                ...field.type === (0, $5fc53.SELECT_CF_TYPE) && (0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) ? {
                    colour: (0, $ek97b.getRandomColor)()
                } : {}
            }
        ]);
    };
    const { field: field, fieldErrors: fieldErrors, field: { options: options = [] }, label: label, DefaultValueControlLeft: DefaultValueControlLeft, DefaultValueControlRight: DefaultValueControlRight, OptionComponent: OptionComponent, limits: limits, onUpdate: onUpdate, autofocus: autofocus = true } = props;
    const isAddButtonDisabled = !$1e1213e8febaff16$var$canAddNewOptions(field, limits);
    const intl = (0, $koVbs.default)();
    const preselectedOptions = $1e1213e8febaff16$export$7ed87108605c2(field.defaultValue); // There must be at least 1 option
    const canDeleteOptions = options.length > 1; // Droppable only rerenders when drag-and-drop information changes.
    // Options are not drag and drop information, they come from us,
    // so we need to use a different function every time DropdownOptions renders,
    // to trigger a prop change (therefore rerender) of Droppable.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1e1213e8febaff16$var$dropdownOptionsStyledStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1e1213e8febaff16$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, intl.formatMessage(label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Droppable), {
        droppableId: field.key,
        type: (0, $5o4rc.OPTION_DRAGGABLE_TYPE)
    }, ({ innerRef: innerRef, droppableProps: droppableProps, placeholder: placeholder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e1213e8febaff16$var$List, {
            ref: innerRef,
            ...droppableProps
        }, options.map((option, index)=>{
            // only the last option should has autoFocus=true,
            // and if there is only 1 option we should disable autoFocus,
            // otherwise it will compete with field name input when we create a new field
            const isLastOption = index > 0 && index === options.length - 1;
            const isNewOptionCreated = prevOptionsCount != null ? options.length > prevOptionsCount : false;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OptionComponent, {
                key: option.optimisticId,
                placeholder: intl.formatMessage((0, $4VCVr.default).optionPlaceholder, {
                    index: index + 1
                }),
                option: option,
                field: field,
                autoFocus: !autofocus && (0, $4R6GH.fg)('field-options-bounce-autofocus-fix') ? isNewOptionCreated && isLastOption : isLastOption,
                onRemove: onRemoveOption,
                onEnterKey: onAddOption,
                onUpdate: onUpdate,
                onEdit: onEditOption,
                onSaveColor: onSaveColor,
                isDeletable: canDeleteOptions,
                isDefault: $1e1213e8febaff16$export$e73019f09357ae98(preselectedOptions)(option),
                DefaultValueControlLeft: DefaultValueControlLeft,
                DefaultValueControlRight: DefaultValueControlRight,
                translatedError: $1e1213e8febaff16$var$getTranslatedErrorFor(option, fieldErrors, intl),
                index: index
            });
        }), placeholder)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: $1e1213e8febaff16$var$getAddButtonTooltip(field, limits, intl),
        delay: props?.tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
        isDisabled: isAddButtonDisabled,
        "data-testid": props?.testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        isDisabled: isAddButtonDisabled,
        appearance: "subtle" // label is not needed on this icon because there is button text
        ,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
            label: ""
        }),
        onClick: onAddOption
    }, intl.formatMessage((0, $4VCVr.default).addNewOption)))));
};
const $1e1213e8febaff16$var$dropdownOptionsStyledStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.500',
    paddingLeft: 'space.500',
    marginBottom: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1e1213e8febaff16$var$List = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2mzuglyw _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
            __cmplp.className
        ])
    });
});
const $1e1213e8febaff16$var$headerStyles = (0, $8CUq3.xcss)({
    paddingBottom: 'space.050'
});

});
parcelRegister("ek97b", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $c5f14892c9125c93$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $c5f14892c9125c93$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $c5f14892c9125c93$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $c5f14892c9125c93$export$49fce7fdcf55f26d);

var $1L3S5 = parcelRequire("1L3S5");
const $c5f14892c9125c93$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length);
    return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
};
const $c5f14892c9125c93$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $1L3S5.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $c5f14892c9125c93$export$9eff62e8ee2aaa2c = (colorName)=>(0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $c5f14892c9125c93$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $1L3S5.GREY_META;
    return (0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $1L3S5.GREY_META);
};
const $c5f14892c9125c93$export$4ef6b7574883e63d = ()=>(0, $1L3S5.OPTION_COLOR_THEMES).map((item)=>item.name);

});
parcelRegister("1L3S5", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $0d4a83e59182b411$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $0d4a83e59182b411$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $0d4a83e59182b411$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $0d4a83e59182b411$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $0d4a83e59182b411$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $0d4a83e59182b411$export$7c14120abebd4749);

var $9GtPC = parcelRequire("9GtPC");
const $0d4a83e59182b411$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLightest
};
const $0d4a83e59182b411$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLighter
};
const $0d4a83e59182b411$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).grey
};
const $0d4a83e59182b411$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarker
};
const $0d4a83e59182b411$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarkest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLightest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLighter
};
const $0d4a83e59182b411$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purple
};
const $0d4a83e59182b411$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarker
};
const $0d4a83e59182b411$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarkest
};
const $0d4a83e59182b411$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLightest
};
const $0d4a83e59182b411$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLighter
};
const $0d4a83e59182b411$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blue
};
const $0d4a83e59182b411$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarker
};
const $0d4a83e59182b411$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarkest
};
const $0d4a83e59182b411$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLightest
};
const $0d4a83e59182b411$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLighter
};
const $0d4a83e59182b411$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).teal
};
const $0d4a83e59182b411$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarker
};
const $0d4a83e59182b411$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarkest
};
const $0d4a83e59182b411$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLightest
};
const $0d4a83e59182b411$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLighter
};
const $0d4a83e59182b411$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).green
};
const $0d4a83e59182b411$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarker
};
const $0d4a83e59182b411$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarkest
};
const $0d4a83e59182b411$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLightest
};
const $0d4a83e59182b411$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLighter
};
const $0d4a83e59182b411$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).lime
};
const $0d4a83e59182b411$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarker
};
const $0d4a83e59182b411$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarkest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLightest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLighter
};
const $0d4a83e59182b411$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellow
};
const $0d4a83e59182b411$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarker
};
const $0d4a83e59182b411$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarkest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLightest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLighter
};
const $0d4a83e59182b411$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orange
};
const $0d4a83e59182b411$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarker
};
const $0d4a83e59182b411$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarkest
};
const $0d4a83e59182b411$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLightest
};
const $0d4a83e59182b411$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLighter
};
const $0d4a83e59182b411$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).red
};
const $0d4a83e59182b411$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarker
};
const $0d4a83e59182b411$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarkest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLightest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLighter
};
const $0d4a83e59182b411$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magenta
};
const $0d4a83e59182b411$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarker
};
const $0d4a83e59182b411$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarkest
};
const $0d4a83e59182b411$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $0d4a83e59182b411$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $0d4a83e59182b411$export$7f42563469df7e01 = [
    $0d4a83e59182b411$var$GREY_LIGHTEST_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTEST_META,
    $0d4a83e59182b411$var$BLUE_LIGHTEST_META,
    $0d4a83e59182b411$var$TEAL_LIGHTEST_META,
    $0d4a83e59182b411$var$GREEN_LIGHTEST_META,
    $0d4a83e59182b411$var$LIME_LIGHTEST_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTEST_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTEST_META,
    $0d4a83e59182b411$var$RED_LIGHTEST_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META,
    $0d4a83e59182b411$var$GREY_LIGHTER_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTER_META,
    $0d4a83e59182b411$var$BLUE_LIGHTER_META,
    $0d4a83e59182b411$var$TEAL_LIGHTER_META,
    $0d4a83e59182b411$var$GREEN_LIGHTER_META,
    $0d4a83e59182b411$var$LIME_LIGHTER_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTER_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTER_META,
    $0d4a83e59182b411$var$RED_LIGHTER_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTER_META,
    $0d4a83e59182b411$export$11b75436f568ab00,
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$BLUE_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$LIME_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$7c314e2461a7241b,
    $0d4a83e59182b411$var$BLUE_DARKER_META,
    $0d4a83e59182b411$export$6daaa1cc3f46f41,
    $0d4a83e59182b411$var$GREEN_DARKER_META,
    $0d4a83e59182b411$var$LIME_DARKER_META,
    $0d4a83e59182b411$var$YELLOW_DARKER_META,
    $0d4a83e59182b411$var$ORANGE_DARKER_META,
    $0d4a83e59182b411$var$RED_DARKER_META,
    $0d4a83e59182b411$var$MAGENTA_DARKER_META,
    $0d4a83e59182b411$var$GREY_DARKEST_META,
    $0d4a83e59182b411$var$PURPLE_DARKEST_META,
    $0d4a83e59182b411$export$69c4eac71b813fba,
    $0d4a83e59182b411$var$TEAL_DARKEST_META,
    $0d4a83e59182b411$var$GREEN_DARKEST_META,
    $0d4a83e59182b411$var$LIME_DARKEST_META,
    $0d4a83e59182b411$var$YELLOW_DARKEST_META,
    $0d4a83e59182b411$var$ORANGE_DARKEST_META,
    $0d4a83e59182b411$var$RED_DARKEST_META,
    $0d4a83e59182b411$var$MAGENTA_DARKEST_META
];
const $0d4a83e59182b411$export$2c649adf8351b065 = [
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$11b75436f568ab00
];
const $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$0d4a83e59182b411$export$2c649adf8351b065.forEach((option)=>{
    $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $0d4a83e59182b411$export$7c14120abebd4749 = {};
$0d4a83e59182b411$export$7f42563469df7e01.forEach((option)=>{
    $0d4a83e59182b411$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("9GtPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8610941b4777e2f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8610941b4777e2f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});



parcelRegister("4VCVr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdd265b5a786ed2a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cdd265b5a786ed2a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addNewOption: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.add-new-option",
        "defaultMessage": "Add option"
    },
    newOption: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.new-option",
        "defaultMessage": "Option 1"
    },
    addButtonDisabledMaxOptions: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.add-button-disabled-max-options",
        "defaultMessage": "You can't add more than {maxOptions} field options"
    },
    addButtonDisabledNoModify: {
        "id": "issue-type-page.field-associated.field-configuration.field-options.add-button-disabled-no-modify",
        "defaultMessage": "You can\u2019t add an option"
    },
    optionPlaceholder: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.option-placeholder",
        "defaultMessage": "Option {index}"
    },
    errorKeyDuplicate: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.error-key-duplicate",
        "defaultMessage": "Already exists. Try something else."
    },
    errorKeyEmpty: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.error-key-empty",
        "defaultMessage": "Give the option a name."
    },
    errorKeyInvalid: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.error-key-invalid",
        "defaultMessage": "Add some options for people to choose from."
    }
});

});


parcelRegister("l6Iz9", function(module, exports) {

$parcel$export(module.exports, "Option", () => $d0560fafc8ee59f2$export$36d18380658d5d20);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2Zxiy = parcelRequire("2Zxiy");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $5LWLA = parcelRequire("5LWLA");

var $2jwCH = parcelRequire("2jwCH");

var $dD7Zc = parcelRequire("dD7Zc");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $koVbs = parcelRequire("koVbs");

var $5o4rc = parcelRequire("5o4rc");

var $1oOvL = parcelRequire("1oOvL");

var $lfaxC = parcelRequire("lfaxC");
const $d0560fafc8ee59f2$var$DragHandle = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("title", null, "drag-handle"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
        fill: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.3333333,18 C9.59695367,18 9,17.4030463 9,16.6666667 C9,15.930287 9.59695367,15.3333333 10.3333333,15.3333333 C11.069713,15.3333333 11.6666667,15.930287 11.6666667,16.6666667 C11.6666667,17.4030463 11.069713,18 10.3333333,18 Z M10.3333333,13.3333333 C9.59695367,13.3333333 9,12.7363797 9,12 C9,11.2636203 9.59695367,10.6666667 10.3333333,10.6666667 C11.069713,10.6666667 11.6666667,11.2636203 11.6666667,12 C11.6666667,12.7363797 11.069713,13.3333333 10.3333333,13.3333333 Z M10.3333333,8.66666667 C9.59695367,8.66666667 9,8.069713 9,7.33333333 C9,6.59695367 9.59695367,6 10.3333333,6 C11.069713,6 11.6666667,6.59695367 11.6666667,7.33333333 C11.6666667,8.069713 11.069713,8.66666667 10.3333333,8.66666667 Z M14.3333333,18 C13.5969537,18 13,17.4030463 13,16.6666667 C13,15.930287 13.5969537,15.3333333 14.3333333,15.3333333 C15.069713,15.3333333 15.6666667,15.930287 15.6666667,16.6666667 C15.6666667,17.4030463 15.069713,18 14.3333333,18 Z M14.3333333,13.3333333 C13.5969537,13.3333333 13,12.7363797 13,12 C13,11.2636203 13.5969537,10.6666667 14.3333333,10.6666667 C15.069713,10.6666667 15.6666667,11.2636203 15.6666667,12 C15.6666667,12.7363797 15.069713,13.3333333 14.3333333,13.3333333 Z M14.3333333,8.66666667 C13.5969537,8.66666667 13,8.069713 13,7.33333333 C13,6.59695367 13.5969537,6 14.3333333,6 C15.069713,6 15.6666667,6.59695367 15.6666667,7.33333333 C15.6666667,8.069713 15.069713,8.66666667 14.3333333,8.66666667 Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.3333333,18 C9.59695367,18 9,17.4030463 9,16.6666667 C9,15.930287 9.59695367,15.3333333 10.3333333,15.3333333 C11.069713,15.3333333 11.6666667,15.930287 11.6666667,16.6666667 C11.6666667,17.4030463 11.069713,18 10.3333333,18 Z M10.3333333,13.3333333 C9.59695367,13.3333333 9,12.7363797 9,12 C9,11.2636203 9.59695367,10.6666667 10.3333333,10.6666667 C11.069713,10.6666667 11.6666667,11.2636203 11.6666667,12 C11.6666667,12.7363797 11.069713,13.3333333 10.3333333,13.3333333 Z M10.3333333,8.66666667 C9.59695367,8.66666667 9,8.069713 9,7.33333333 C9,6.59695367 9.59695367,6 10.3333333,6 C11.069713,6 11.6666667,6.59695367 11.6666667,7.33333333 C11.6666667,8.069713 11.069713,8.66666667 10.3333333,8.66666667 Z M14.3333333,18 C13.5969537,18 13,17.4030463 13,16.6666667 C13,15.930287 13.5969537,15.3333333 14.3333333,15.3333333 C15.069713,15.3333333 15.6666667,15.930287 15.6666667,16.6666667 C15.6666667,17.4030463 15.069713,18 14.3333333,18 Z M14.3333333,13.3333333 C13.5969537,13.3333333 13,12.7363797 13,12 C13,11.2636203 13.5969537,10.6666667 14.3333333,10.6666667 C15.069713,10.6666667 15.6666667,11.2636203 15.6666667,12 C15.6666667,12.7363797 15.069713,13.3333333 14.3333333,13.3333333 Z M14.3333333,8.66666667 C13.5969537,8.66666667 13,8.069713 13,7.33333333 C13,6.59695367 13.5969537,6 14.3333333,6 C15.069713,6 15.6666667,6.59695367 15.6666667,7.33333333 C15.6666667,8.069713 15.069713,8.66666667 14.3333333,8.66666667 Z",
        fill: "var(--ds-icon, #44546F)"
    })));
const $d0560fafc8ee59f2$export$36d18380658d5d20 = (props)=>{
    const intl = (0, $koVbs.default)(); /*
                                      * Only show validation error when user has touched this field
                                      * so that we avoid screaming in red when user has just only created the option.
                                      */ 
    const [touched, setTouched] = (0, $5uXOq.useState)(false);
    const [focused, setFocused] = (0, $5uXOq.useState)(false);
    const [hovered, setHovered] = (0, $5uXOq.useState)(false);
    const [removeEmptyOptionTimeout, setEmptyOptionTimeout] = (0, $5uXOq.useState)(undefined);
    const onTouch = ()=>{
        setTouched(true);
    };
    const onRemove = ()=>{
        props.onRemove(props.option);
    };
    const onBlur = ()=>{
        setFocused(false);
        onTouch();
        if (props.isDeletable && props.option.value === '') setEmptyOptionTimeout(setTimeout(onRemove));
    };
    const onFocus = ()=>{
        setFocused(true);
        clearTimeout(removeEmptyOptionTimeout);
    };
    const onMouseEnter = ()=>setHovered(true);
    const onMouseLeave = ()=>setHovered(false);
    const onChange = (e)=>{
        onTouch();
        props.onEdit(props.option, e.currentTarget.value);
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            props.onEnterKey();
        }
    };
    const getIsInvalid = ()=>{
        const { option: option, translatedError: translatedError } = props; // Only show validation error when user has touched this field
        // so that we avoid screaming in red when user has just only created the option.
        // In case the option is already saved on the server and is invalid, make the error display immediately.
        // That prevent the case when collapsed field card shows error icon, but there is no error inside!
        // This should in theory never happen - but it does anyway because we keep adding new validation rules,
        // but never retrospectively check the data.
        return (touched || option.id !== null) && translatedError != null && translatedError.length > 0;
    };
    const renderDefaultValueControl = (DefaultValueControlComponent)=>{
        if (DefaultValueControlComponent == null) return null;
        const { field: field, field: { operations: { canModifyOptions: canModifyOptions } }, option: option, isDefault: isDefault, onUpdate: onUpdate } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.AlignedOptionControl), {
            isDisabled: !canModifyOptions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DefaultValueControlComponent, {
            option: option,
            field: field,
            isSelected: isDefault,
            isOptionFocused: focused,
            isOptionHovered: hovered,
            onFieldUpdated: onUpdate
        }));
    };
    const { index: index, option: option, placeholder: placeholder, autoFocus: autoFocus, translatedError: translatedError, isDeletable: isDeletable, DefaultValueControlLeft: DefaultValueControlLeft, DefaultValueControlRight: DefaultValueControlRight, children: children, field: { operations: { canModifyOptions: canModifyOptions } }, tooltipDelay: tooltipDelay } = props;
    const isInvalid = getIsInvalid();
    const removeOptionLabel = intl.formatMessage((0, $lfaxC.default).removeOption);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Draggable), {
        isDragDisabled: !canModifyOptions,
        draggableId: (0, $5o4rc.toDraggableId)(option.optimisticId),
        index: index
    }, (dragProvided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d0560fafc8ee59f2$var$MarginWithOutline, {
            invalid: isInvalid,
            isDragging: snapshot.isDragging,
            ref: dragProvided.innerRef,
            ...dragProvided.draggableProps,
            onFocus: onFocus,
            onBlur: onBlur,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d0560fafc8ee59f2$var$Item, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: !canModifyOptions ? intl.formatMessage((0, $lfaxC.default).disabledSortHandleTooltip) : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.AlignedOptionControl), {
            ...dragProvided.dragHandleProps,
            isDisabled: !canModifyOptions,
            tabIndex: !canModifyOptions ? -1 : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: $d0560fafc8ee59f2$var$DragHandle,
            label: ""
        }))), renderDefaultValueControl(DefaultValueControlLeft), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.OptionControlGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.Row), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.Input), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: !canModifyOptions ? intl.formatMessage((0, $lfaxC.default).disabledInputTooltip) : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            name: "select-custom-field-option",
            value: option.value,
            placeholder: placeholder,
            maxLength: 255,
            autoFocus: autoFocus,
            onChange: onChange,
            onKeyDown: onKeyDown,
            isDisabled: !canModifyOptions,
            appearance: "none"
        }))), renderDefaultValueControl(DefaultValueControlRight), isDeletable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.AlignedOptionControl), {
            isDisabled: !canModifyOptions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: intl.formatMessage(!canModifyOptions ? (0, $lfaxC.default).disabledRemoveButtonTooltip : (0, $lfaxC.default).removeOption),
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
            isDisabled: !canModifyOptions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            shouldFitContainer: true,
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
                spacing: "spacious" // This does not need a11y message because there is aria-label on the button element
                ,
                label: ""
            }),
            "aria-label": removeOptionLabel,
            onClick: onRemove,
            isDisabled: !canModifyOptions
        })))) : null), isInvalid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "xxsmall",
            as: "div"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            color: "var(--ds-text-accent-orange-bolder, #702E00)",
            LEGACY_size: "small",
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, translatedError))) : null)), children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0560fafc8ee59f2$var$MarginWithOutline = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { invalid: invalid, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189eyh40 _1dqonqa1 _otyr1b66 _bfhk1j9a _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _irr31d5g",
            __cmplp.invalid ? "_1h6d1bqt" : "_1h6d1elr",
            __cmplp.invalid ? "_16qsbimv" : __cmplp.isDragging ? "_16qs1gmf" : "_16qs1g1g",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0560fafc8ee59f2$var$Item = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _1e0c1txw _4cvr1y6m _1grg18uv _w2as18uv _n9z4u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});
parcelRegister("2C7j9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $1e74cc92a54dd799$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $1e74cc92a54dd799$var$_close.default
    }));
$1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;

});


parcelRegister("kY99m", function(module, exports) {

$parcel$export(module.exports, "default", () => $509076ff0c6afa78$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $509076ff0c6afa78$var$containerMedia = {
    invalid: "_srjtgir2",
    disabled: "_6up518qt"
};
const $509076ff0c6afa78$var$inputMediaDisabled = null;
const $509076ff0c6afa78$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $509076ff0c6afa78$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $509076ff0c6afa78$var$invalidStyle = null;
const $509076ff0c6afa78$var$focusWithinStyle = {
    standard: "_ochr1p6i _195er01l _bqhtq049",
    subtle: "_ochr1p6i _195er01l _bqhtq049",
    none: "_ochr3acm _195e18uv _bqhtnruj"
};
const $509076ff0c6afa78$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $509076ff0c6afa78$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _srjtgir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _srjtgir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _srjtgir2"
};
const $509076ff0c6afa78$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $509076ff0c6afa78$var$getMaxWidth = (width)=>!width ? `100%` : width in $509076ff0c6afa78$var$widthMap ? `${$509076ff0c6afa78$var$widthMap[width]}px` : `${+width}px`;
const $509076ff0c6afa78$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $509076ff0c6afa78$var$containerStyles = null;
const $509076ff0c6afa78$var$inputDisabledStyle = null;
const $509076ff0c6afa78$var$inputCompactStyleWithFg = null;
const $509076ff0c6afa78$var$inputCompactStyle = null;
const $509076ff0c6afa78$var$inputMonospacedStyle = null;
const $509076ff0c6afa78$var$inputFontStyleWithFG = null;
const $509076ff0c6afa78$var$inputStyleMonospacedWithFg = null;
const $509076ff0c6afa78$var$inputStyleNotDataCompactWithFG = null;
const $509076ff0c6afa78$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $509076ff0c6afa78$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$509076ff0c6afa78$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $509076ff0c6afa78$var$getContainerTextBgAndBorderColor[appearance],
            $509076ff0c6afa78$var$containerStyleAppearance[appearance],
            !isDisabled && $509076ff0c6afa78$var$focusWithinStyle[appearance],
            !isDisabled && $509076ff0c6afa78$var$hoverStyle[appearance],
            isDisabled && $509076ff0c6afa78$var$containerMedia.disabled,
            isDisabled && $509076ff0c6afa78$var$disabledStyle[appearance],
            isInvalid && $509076ff0c6afa78$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _10j7r01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;

});

parcelRegister("1oOvL", function(module, exports) {

$parcel$export(module.exports, "Option", () => $b697ef545b535cfb$export$36d18380658d5d20);
$parcel$export(module.exports, "AlignedOptionControl", () => $b697ef545b535cfb$export$2ee32f2c93bc06ed);
$parcel$export(module.exports, "OptionControlGroup", () => $b697ef545b535cfb$export$e994f3ba48fc21df);
$parcel$export(module.exports, "Row", () => $b697ef545b535cfb$export$b59bdbef9ce70de2);
$parcel$export(module.exports, "ErrorMessage", () => $b697ef545b535cfb$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "Input", () => $b697ef545b535cfb$export$f5b8910cec6cf069);
$parcel$export(module.exports, "DefaultValueLabel", () => $b697ef545b535cfb$export$e50bd17af031688d);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2Zxiy = parcelRequire("2Zxiy");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $5LWLA = parcelRequire("5LWLA");

var $2jwCH = parcelRequire("2jwCH");

var $dD7Zc = parcelRequire("dD7Zc");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $77pYH = parcelRequire("77pYH");

var $5o4rc = parcelRequire("5o4rc");

var $6SlHX = parcelRequire("6SlHX");

var $gdr0Q = parcelRequire("gdr0Q");
const $b697ef545b535cfb$var$DragHandle = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
        fill: "var(--ds-surface-raised, #FFFFFF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.3333333,18 C9.59695367,18 9,17.4030463 9,16.6666667 C9,15.930287 9.59695367,15.3333333 10.3333333,15.3333333 C11.069713,15.3333333 11.6666667,15.930287 11.6666667,16.6666667 C11.6666667,17.4030463 11.069713,18 10.3333333,18 Z M10.3333333,13.3333333 C9.59695367,13.3333333 9,12.7363797 9,12 C9,11.2636203 9.59695367,10.6666667 10.3333333,10.6666667 C11.069713,10.6666667 11.6666667,11.2636203 11.6666667,12 C11.6666667,12.7363797 11.069713,13.3333333 10.3333333,13.3333333 Z M10.3333333,8.66666667 C9.59695367,8.66666667 9,8.069713 9,7.33333333 C9,6.59695367 9.59695367,6 10.3333333,6 C11.069713,6 11.6666667,6.59695367 11.6666667,7.33333333 C11.6666667,8.069713 11.069713,8.66666667 10.3333333,8.66666667 Z M14.3333333,18 C13.5969537,18 13,17.4030463 13,16.6666667 C13,15.930287 13.5969537,15.3333333 14.3333333,15.3333333 C15.069713,15.3333333 15.6666667,15.930287 15.6666667,16.6666667 C15.6666667,17.4030463 15.069713,18 14.3333333,18 Z M14.3333333,13.3333333 C13.5969537,13.3333333 13,12.7363797 13,12 C13,11.2636203 13.5969537,10.6666667 14.3333333,10.6666667 C15.069713,10.6666667 15.6666667,11.2636203 15.6666667,12 C15.6666667,12.7363797 15.069713,13.3333333 14.3333333,13.3333333 Z M14.3333333,8.66666667 C13.5969537,8.66666667 13,8.069713 13,7.33333333 C13,6.59695367 13.5969537,6 14.3333333,6 C15.069713,6 15.6666667,6.59695367 15.6666667,7.33333333 C15.6666667,8.069713 15.069713,8.66666667 14.3333333,8.66666667 Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.3333333,18 C9.59695367,18 9,17.4030463 9,16.6666667 C9,15.930287 9.59695367,15.3333333 10.3333333,15.3333333 C11.069713,15.3333333 11.6666667,15.930287 11.6666667,16.6666667 C11.6666667,17.4030463 11.069713,18 10.3333333,18 Z M10.3333333,13.3333333 C9.59695367,13.3333333 9,12.7363797 9,12 C9,11.2636203 9.59695367,10.6666667 10.3333333,10.6666667 C11.069713,10.6666667 11.6666667,11.2636203 11.6666667,12 C11.6666667,12.7363797 11.069713,13.3333333 10.3333333,13.3333333 Z M10.3333333,8.66666667 C9.59695367,8.66666667 9,8.069713 9,7.33333333 C9,6.59695367 9.59695367,6 10.3333333,6 C11.069713,6 11.6666667,6.59695367 11.6666667,7.33333333 C11.6666667,8.069713 11.069713,8.66666667 10.3333333,8.66666667 Z M14.3333333,18 C13.5969537,18 13,17.4030463 13,16.6666667 C13,15.930287 13.5969537,15.3333333 14.3333333,15.3333333 C15.069713,15.3333333 15.6666667,15.930287 15.6666667,16.6666667 C15.6666667,17.4030463 15.069713,18 14.3333333,18 Z M14.3333333,13.3333333 C13.5969537,13.3333333 13,12.7363797 13,12 C13,11.2636203 13.5969537,10.6666667 14.3333333,10.6666667 C15.069713,10.6666667 15.6666667,11.2636203 15.6666667,12 C15.6666667,12.7363797 15.069713,13.3333333 14.3333333,13.3333333 Z M14.3333333,8.66666667 C13.5969537,8.66666667 13,8.069713 13,7.33333333 C13,6.59695367 13.5969537,6 14.3333333,6 C15.069713,6 15.6666667,6.59695367 15.6666667,7.33333333 C15.6666667,8.069713 15.069713,8.66666667 14.3333333,8.66666667 Z",
        fill: "var(--ds-icon, #44546F)"
    })));
const $b697ef545b535cfb$export$36d18380658d5d20 = (props)=>{
    const intl = (0, $koVbs.default)(); /*
                                      * Only show validation error when user has touched this field
                                      * so that we avoid screaming in red when user has just only created the option.
                                      */ 
    const [touched, setTouched] = (0, $5uXOq.useState)(false);
    const [focused, setFocused] = (0, $5uXOq.useState)(false);
    const [hovered, setHovered] = (0, $5uXOq.useState)(false);
    const [removeEmptyOptionTimeout, setEmptyOptionTimeout] = (0, $5uXOq.useState)(undefined);
    const onTouch = ()=>{
        setTouched(true);
    };
    const onRemove = ()=>{
        props.onRemove(props.option);
    };
    const onBlur = ()=>{
        setFocused(false);
        onTouch();
        if (props.isDeletable && props.option.value === '') setEmptyOptionTimeout(setTimeout(onRemove));
    };
    const onFocus = ()=>{
        setFocused(true);
        clearTimeout(removeEmptyOptionTimeout);
    };
    const onMouseEnter = ()=>setHovered(true);
    const onMouseLeave = ()=>setHovered(false);
    const onChange = (e)=>{
        onTouch();
        props.onEdit(props.option, e.currentTarget.value);
    };
    const onSave = (data)=>{
        onTouch();
        props.onSaveColor(props.option, data.color);
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            props.onEnterKey();
        }
    };
    const isInvalid = ()=>{
        const { option: option, translatedError: translatedError } = props; // Only show validation error when user has touched this field
        // so that we avoid screaming in red when user has just only created the option.
        // In case the option is already saved on the server and is invalid, make the error display immediately.
        // That prevent the case when collapsed field card shows error icon, but there is no error inside!
        // This should in theory never happen - but it does anyway because we keep adding new validation rules,
        // but never retrospectively check the data.
        return (touched || option.id !== null) && translatedError != null && translatedError.length > 0;
    };
    const renderDefaultValueControl = (DefaultValueControlComponent)=>{
        if (DefaultValueControlComponent == null) return null;
        const { field: field, field: { operations: { canModifyOptions: canModifyOptions } }, option: option, isDefault: isDefault, onUpdate: onUpdate } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$export$2ee32f2c93bc06ed, {
            isDisabled: !canModifyOptions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DefaultValueControlComponent, {
            option: option,
            field: field,
            isSelected: isDefault,
            isOptionFocused: focused,
            isOptionHovered: hovered,
            onFieldUpdated: onUpdate
        }));
    };
    const { index: index, option: option, placeholder: placeholder, autoFocus: autoFocus, translatedError: translatedError, isDeletable: isDeletable, field: { type: fieldType, operations: { canModifyOptions: canModifyOptions } }, DefaultValueControlLeft: DefaultValueControlLeft, DefaultValueControlRight: DefaultValueControlRight } = props;
    const renderTextField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: canModifyOptions ? null : intl.formatMessage((0, $gdr0Q.default).disabledInputTooltip),
            delay: props?.tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            name: "select-custom-field-option",
            value: option.value,
            placeholder: placeholder,
            maxLength: 255,
            autoFocus: autoFocus,
            onChange: onChange,
            onKeyDown: onKeyDown,
            isDisabled: !canModifyOptions,
            appearance: "none",
            testId: props?.testId && `${props?.testId}.text-field.test-id-wrapper`
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Draggable), {
        draggableId: (0, $5o4rc.toDraggableId)(option.optimisticId),
        index: index,
        isDragDisabled: !canModifyOptions
    }, (dragProvided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$var$Margin, {
            ref: dragProvided.innerRef,
            ...dragProvided.draggableProps,
            onFocus: onFocus,
            onBlur: onBlur,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$var$Item, {
            invalid: isInvalid(),
            isDragging: snapshot.isDragging
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: canModifyOptions ? null : intl.formatMessage((0, $gdr0Q.default).disabledSortHandleTooltip),
            delay: props?.tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$export$2ee32f2c93bc06ed, {
            ...dragProvided.dragHandleProps,
            isDisabled: !canModifyOptions,
            tabIndex: !canModifyOptions ? -1 : 0,
            "data-testid": props?.testId && `${props?.testId}.default.test-id-wrapper`,
            role: "button",
            "aria-roledescription": intl.formatMessage((0, $gdr0Q.default).draggableItemRole)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: $b697ef545b535cfb$var$DragHandle,
            label: ""
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$export$e994f3ba48fc21df, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$export$b59bdbef9ce70de2, null, renderDefaultValueControl(DefaultValueControlLeft), (0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$export$2ee32f2c93bc06ed, {
            isDisabled: !canModifyOptions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $77pYH.ColorIndicator), {
            canModifyOptions: canModifyOptions,
            fieldType: fieldType,
            color: option.colour
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$var$InputCentred, null, renderTextField()), renderDefaultValueControl(DefaultValueControlRight), (0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$export$2ee32f2c93bc06ed, {
            isDisabled: !canModifyOptions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6SlHX.OptionColorPicker), {
            canModifyOptions: canModifyOptions,
            fieldType: fieldType,
            option: option,
            onSave: onSave
        })), isDeletable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$export$2ee32f2c93bc06ed, {
            isDisabled: !canModifyOptions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: intl.formatMessage(canModifyOptions ? (0, $gdr0Q.default).removeOption : (0, $gdr0Q.default).disabledRemoveButtonTooltip),
            delay: props?.tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
            isDisabled: !canModifyOptions,
            "data-testid": props?.testId && `${props?.testId}.button.test-id-wrapper`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            shouldFitContainer: true,
            appearance: "subtle" // This does not need a11y message because there is aria-label on the button element
            ,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
                spacing: "spacious",
                label: ""
            }),
            "aria-label": intl.formatMessage((0, $gdr0Q.default).removeOption),
            onClick: onRemove,
            isDisabled: !canModifyOptions
        })))) : null), isInvalid() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "xxsmall",
            as: "div"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697ef545b535cfb$export$915e9e7bd4f0f96d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            color: "var(--ds-text-accent-orange-bolder, #702E00)",
            LEGACY_size: "small",
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, translatedError))) : null))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b697ef545b535cfb$var$InputCentred = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _9m3z1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b697ef545b535cfb$var$Margin = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1b66 _2mzuglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b697ef545b535cfb$var$Item = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { invalid: invalid, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189eyh40 _1dqonqa1 _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _bfhk1j9a _irr31d5g",
            __cmplp.invalid ? "_1h6d1bqt" : "_1h6d1elr",
            __cmplp.invalid ? "_16qsbimv" : "_16qs1g1g",
            __cmplp.isDragging ? "_1pbyowjs" : "_1pby1wug",
            __cmplp.isDragging && "_16qs1b10",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b697ef545b535cfb$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b697ef545b535cfb$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b697ef545b535cfb$export$2ee32f2c93bc06ed = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _1e0c1txw _4cvr1h6o",
            __cmplp.isDisabled && "_80om13gf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b697ef545b535cfb$export$e994f3ba48fc21df = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b697ef545b535cfb$export$915e9e7bd4f0f96d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _syaz1tmw _1bsb1osq _19pkidpf _2hwx1b66 _otyru2gc _18u0u2gc _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b697ef545b535cfb$export$e50bd17af031688d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _2hwxutpp",
            __cmplp.isDisabled ? "_80om13gf" : "_80om1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("77pYH", function(module, exports) {

$parcel$export(module.exports, "ColorIndicator", () => $f69d253a0d132731$export$d9d9ccbf5da84ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $bUSNl = parcelRequire("bUSNl");

var $ek97b = parcelRequire("ek97b");
const $f69d253a0d132731$export$d9d9ccbf5da84ba4 = /*#__PURE__*/ (0, $5uXOq.memo)(({ canModifyOptions: canModifyOptions, fieldType: fieldType, color: color })=>{
    const { backgroundColor: backgroundColor, messageLabel: messageLabel } = (0, $ek97b.getColorMetadata)(color);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ content: sidebarContent }] = (0, $bUSNl.useSidebar)();
    if (sidebarContent || !canModifyOptions || fieldType !== 'com.atlassian.jira.plugin.system.customfieldtypes:select') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(messageLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: backgroundColor
        },
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _189e1bk5 _1dqonqa1 _1bsbpxbi _4t3ipxbi"
        ])
    }));
});
const $f69d253a0d132731$var$styledColorBox = null;

});
parcelRegister("bUSNl", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $39fc2da09b28cabf$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $39fc2da09b28cabf$export$54c70f22f548bff8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hE5wF = parcelRequire("hE5wF");

var $3hGWp = parcelRequire("3hGWp");

var $dCm1o = parcelRequire("dCm1o");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $jnA4H = parcelRequire("jnA4H");
const $39fc2da09b28cabf$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD = 360;
const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH = 435;
const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
        (0, $hE5wF.SELECTED_ISSUE_PARAM),
        (0, $hE5wF.SELECTED_COMMENT_PARAM)
    ];
const $39fc2da09b28cabf$export$f4c7df452942956a = ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH : $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD;
const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $39fc2da09b28cabf$export$f4c7df452942956a());
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $jnA4H.localStorage).set($39fc2da09b28cabf$export$86880b4b2e1a2384, newWidth);
    };
const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        });
    };
const $39fc2da09b28cabf$var$actions = {
    setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
    setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
    setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
    closeSidebar: $39fc2da09b28cabf$var$closeSidebar
};
const $39fc2da09b28cabf$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $jnA4H.localStorage).get($39fc2da09b28cabf$export$86880b4b2e1a2384) || $39fc2da09b28cabf$export$f4c7df452942956a(),
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    actions: $39fc2da09b28cabf$var$actions,
    name: 'JWMSidebarStore'
});
const $39fc2da09b28cabf$var$useHook = (0, $3sQ5x.createHook)($39fc2da09b28cabf$var$Store);
const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
    const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("hE5wF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $bfd6cbe4770149b5$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $bfd6cbe4770149b5$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $bfd6cbe4770149b5$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $bfd6cbe4770149b5$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $bfd6cbe4770149b5$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $bfd6cbe4770149b5$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $bfd6cbe4770149b5$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $bfd6cbe4770149b5$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $bfd6cbe4770149b5$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $bfd6cbe4770149b5$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $bfd6cbe4770149b5$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $bfd6cbe4770149b5$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$c72ea455b368cdd9);
$parcel$export(module.exports, "UNASSIGNED_USER_ID", () => $bfd6cbe4770149b5$export$12e572fd459c10dc);

const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
const $bfd6cbe4770149b5$export$12e572fd459c10dc = 'unassigned';

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("3hGWp", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $doZTA.useRouter)();
    const queryParamsRef = (0, $5uXOq.useRef)({});
    const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

parcelRegister("jnA4H", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $301038d04a64b539$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $301038d04a64b539$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_business_common');

});



parcelRegister("6SlHX", function(module, exports) {

$parcel$export(module.exports, "OptionColorPicker", () => $63ebad358e9de753$export$c8c081d14f073605);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $5nRKm = parcelRequire("5nRKm");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $d0Alb = parcelRequire("d0Alb");

var $jgJNO = parcelRequire("jgJNO");

var $bUSNl = parcelRequire("bUSNl");

var $kmov5 = parcelRequire("kmov5");
const $63ebad358e9de753$var$PopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ $5uXOq.createElement("div", {
        ...props,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1pby1nn1"
        ])
    }));
const $63ebad358e9de753$export$c8c081d14f073605 = ({ canModifyOptions: canModifyOptions, fieldType: fieldType, option: option, onSave: onSave })=>{
    const [isColorPickerOpen, setIsColorPickerOpen] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const [{ content: sidebarContent }] = (0, $bUSNl.useSidebar)();
    if (!canModifyOptions || fieldType !== 'com.atlassian.jira.plugin.system.customfieldtypes:select') return null;
    if (sidebarContent || !(0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false)) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $jgJNO.JiraPopup), {
        isOpen: isColorPickerOpen,
        onClose: ()=>setIsColorPickerOpen(false),
        placement: "bottom-start",
        messageId: "project-settings-apps-issue-type-page-product-features.common.ui.field-active.field-configuration.field-options.option.color-picker.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        popupComponent: $63ebad358e9de753$var$PopupContainer,
        content: ()=>/*#__PURE__*/ $5uXOq.createElement((0, $d0Alb.ColorPickerForm), {
                onCancel: ()=>setIsColorPickerOpen(!isColorPickerOpen),
                onSubmit: (data)=>{
                    setIsColorPickerOpen(!isColorPickerOpen);
                    onSave(data);
                },
                initialData: {
                    name: option.value,
                    color: option.colour ?? ''
                },
                type: "edit",
                projectType: "software",
                colorPaletteVariant: "new",
                colorCardVariant: "outline",
                editLabel: false,
                showCancelButton: false
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
                ...triggerProps,
                label: intl.formatMessage((0, $kmov5.default).colorPickerNonFinal),
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
                onClick: ()=>setIsColorPickerOpen(!isColorPickerOpen)
            })
    });
};
const $63ebad358e9de753$var$popupContainerStyles = null;

});
parcelRegister("d0Alb", function(module, exports) {

$parcel$export(module.exports, "ColorPickerForm", () => $0d623d360a292ffb$export$c6b29cee0bdef08a);

var $5uXOq = parcelRequire("5uXOq");

var $iKhOS = parcelRequire("iKhOS");

var $eCeGD = parcelRequire("eCeGD");

var $qfj8c = parcelRequire("qfj8c");

var $l1N8i = parcelRequire("l1N8i");

var $hWZau = parcelRequire("hWZau");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9jL2Q = parcelRequire("9jL2Q");

var $alO8U = parcelRequire("alO8U");

var $lpRLe = parcelRequire("lpRLe");

var $b6qPx = parcelRequire("b6qPx");

var $1L3S5 = parcelRequire("1L3S5");
const $0d623d360a292ffb$export$c6b29cee0bdef08a = /*#__PURE__*/ (0, $5uXOq.memo)(({ onCancel: onCancel, onSubmit: onSubmit, initialData: initialData, type: type, projectType: projectType = 'software', colorPaletteVariant: colorPaletteVariant = 'old', colorCardVariant: colorCardVariant = 'fill', editLabel: editLabel = true, showCancelButton: showCancelButton = true, availableOptions: availableOptions, onInputBlur: onInputBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { color: color, name: name } = initialData;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [currentColor, setCurrentColor] = (0, $5uXOq.useState)(!color ? (0, $1L3S5.GREY_META).name : color);
    const [currentName, setCurrentName] = (0, $5uXOq.useState)(name);
    const [isInputDirty, setIsInputDirty] = (0, $5uXOq.useState)(false);
    const inputElement = (0, $5uXOq.useRef)(null);
    const analyticsEventName = projectType === 'business' ? 'CategoryForm' : 'OptionColorPickerForm';
    const analyticsEventPrefix = projectType === 'business' ? 'category' : 'option';
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${analyticsEventName} viewed`, {
            purpose: type
        });
    }, [
        createAnalyticsEvent,
        type,
        analyticsEventName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (inputElement.current) // This ensures that the input element is focused after the component is rendered
        (0, (/*@__PURE__*/$parcel$interopDefault($iKhOS)))(()=>inputElement?.current?.focus());
    }, []);
    const isUpdatedOptionNameDuplicate = (0, $5uXOq.useCallback)(()=>{
        // If the current name is the same as the original name, it's not a duplicate.
        if (currentName === name) return false;
        // Check if the current name exists in the available options.
        return availableOptions?.includes(currentName) ?? false;
    }, [
        currentName,
        name,
        availableOptions
    ]);
    const isUpdatedOptionNameEmpty = (0, $5uXOq.useCallback)(()=>{
        return !currentName || currentName.trim() === '';
    }, [
        currentName
    ]);
    const isOptionNameInvalid = (0, $5uXOq.useCallback)(()=>isInputDirty && (isUpdatedOptionNameEmpty() || isUpdatedOptionNameDuplicate()), [
        isUpdatedOptionNameEmpty,
        isInputDirty,
        isUpdatedOptionNameDuplicate
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)(()=>{
        if (isOptionNameInvalid()) return;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', type === (0, $b6qPx.COLOR_PICKER_STATE).EDIT ? `${analyticsEventPrefix}FormSave` : `${analyticsEventPrefix}FormAdd`);
        onSubmit && onSubmit({
            name: currentName,
            color: currentColor
        });
    }, [
        createAnalyticsEvent,
        analyticsEventPrefix,
        onSubmit,
        currentName,
        currentColor,
        type,
        isOptionNameInvalid
    ]);
    const handleCancel = (0, $5uXOq.useCallback)(()=>{
        onCancel();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', `${analyticsEventPrefix}FormCancel`);
    }, [
        onCancel,
        createAnalyticsEvent,
        analyticsEventPrefix
    ]);
    const handleKeyDownEvent = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) handleCancel();
        if (event.key === 'Enter' || event.keyCode === 13) {
            handleSubmit();
            event.preventDefault();
        }
    }, [
        handleCancel,
        handleSubmit
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            window.addEventListener('keydown', handleKeyDownEvent, true);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDownEvent, true);
            };
        }
    }, [
        handleKeyDownEvent
    ]);
    const getInvalidOptionNameErrorMessage = ()=>{
        if (isUpdatedOptionNameEmpty()) return formatMessage((0, $alO8U.default).errorMessageBlankOptionName);
        if (isUpdatedOptionNameDuplicate()) return formatMessage((0, $alO8U.default).errorMessageDuplicateOptionName);
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onClick: ()=>inputElement?.current?.focus(),
        xcss: [
            $0d623d360a292ffb$var$formStyles,
            colorPaletteVariant === 'new' && $0d623d360a292ffb$var$maxWidthStyles
        ],
        backgroundColor: "elevation.surface.overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: [
            $0d623d360a292ffb$var$previewStyles,
            $0d623d360a292ffb$var$wrapperStyles
        ],
        testId: "option-color-picker.preview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h4",
        size: "small"
    }, type === (0, $b6qPx.COLOR_PICKER_STATE).EDIT ? formatMessage((0, $alO8U.default).editOptionTitle) : formatMessage((0, $alO8U.default).newOptionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        label: "",
        color: "var(--ds-icon-subtle, #626F86)",
        spacing: "spacious"
    }), currentName !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
        name: currentName,
        color: currentColor
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0d623d360a292ffb$var$formContentStyles
    }, editLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0d623d360a292ffb$var$fieldWrapperStyles,
            $0d623d360a292ffb$var$wrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        "aria-label": formatMessage((0, $alO8U.default).optionNameLabel),
        autoComplete: "off",
        autoFocus: true,
        ref: inputElement,
        value: currentName,
        onBlur: (e)=>{
            if (!isInputDirty) setIsInputDirty(true);
            onInputBlur?.(e);
        },
        placeholder: formatMessage((0, $alO8U.default).optionNamePlaceholder),
        onChange: (e)=>{
            if (!isInputDirty) setIsInputDirty(true);
            setCurrentName(e.currentTarget.value);
        }
    }), isOptionNameInvalid() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, getInvalidOptionNameErrorMessage())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0d623d360a292ffb$var$fieldWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9jL2Q.ColorPickerMenu), {
        onChangeColor: (newColor)=>{
            setCurrentColor(newColor);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'color clicked', `${analyticsEventPrefix}FormColorPicker`, {
                color: newColor
            });
        },
        color: currentColor,
        colorPaletteVariant: colorPaletteVariant,
        colorCardVariant: colorCardVariant
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $0d623d360a292ffb$var$buttonContainerStyles,
        gap: "space.100",
        justifyContent: "end"
    }, showCancelButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        spacing: "compact",
        testId: "option-color-picker.cancel-button",
        onClick: handleCancel
    }, formatMessage((0, $alO8U.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        spacing: "compact",
        testId: "option-color-picker.submit-button",
        onClick: handleSubmit
    }, type === (0, $b6qPx.COLOR_PICKER_STATE).EDIT ? `${formatMessage((0, $alO8U.default).saveButton)} \u{23CE}` : formatMessage((0, $alO8U.default).addButton)))));
});
const $0d623d360a292ffb$var$formStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    display: 'block',
    padding: 'space.200',
    width: 'fit-content'
});
const $0d623d360a292ffb$var$maxWidthStyles = (0, $8CUq3.xcss)({
    maxWidth: '356px'
});
const $0d623d360a292ffb$var$previewStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    maxWidth: '350px'
});
const $0d623d360a292ffb$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $0d623d360a292ffb$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.050'
});
const $0d623d360a292ffb$var$fieldWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.150'
});
const $0d623d360a292ffb$var$formContentStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("iKhOS", function(module, exports) {

var $1gef8 = parcelRequire("1gef8");

var $g7i7g = parcelRequire("g7i7g");
/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */ var $da5a5877d5d6860c$var$defer = $g7i7g(function(func, args) {
    return $1gef8(func, 1, args);
});
module.exports = $da5a5877d5d6860c$var$defer;

});
parcelRegister("1gef8", function(module, exports) {
/** Error message constants. */ var $0eb25573bf32f124$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */ function $0eb25573bf32f124$var$baseDelay(func, wait, args) {
    if (typeof func != 'function') throw new TypeError($0eb25573bf32f124$var$FUNC_ERROR_TEXT);
    return setTimeout(function() {
        func.apply(undefined, args);
    }, wait);
}
module.exports = $0eb25573bf32f124$var$baseDelay;

});


parcelRegister("qfj8c", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $b2d5b368fed948c9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $b2d5b368fed948c9$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $b2d5b368fed948c9$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $g4M8x = parcelRequire("g4M8x");

var $dRN65 = parcelRequire("dRN65");
const $b2d5b368fed948c9$var$messageStyles = null;
const $b2d5b368fed948c9$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $b2d5b368fed948c9$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $b2d5b368fed948c9$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $b2d5b368fed948c9$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4M8x))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $b2d5b368fed948c9$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("059q9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));

var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>/*#__PURE__*/ $00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
    }, props));
$00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;

});
parcelRegister("hAZqC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccf572dfbabebdf7$var$_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>/*#__PURE__*/ $ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;

});


parcelRegister("g4M8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));

var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb425bfe72dc5677$var$SuccessIcon = (props)=>/*#__PURE__*/ $bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
    }, props));
$bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;

});
parcelRegister("hs3k8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0347594f5084a834$var$_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0347594f5084a834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0347594f5084a834$var$SuccessIcon = (props)=>/*#__PURE__*/ $0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;

});

parcelRegister("kJ541", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $f16bf031974cd311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $f16bf031974cd311$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $f16bf031974cd311$var$_success.default
    }));
$f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;

});



parcelRegister("9jL2Q", function(module, exports) {

$parcel$export(module.exports, "ColorPickerMenu", () => $4871f580bea1e373$export$4f039f014adbb6f0);

var $5uXOq = parcelRequire("5uXOq");

var $lGTQx = parcelRequire("lGTQx");
var $3zNHM = parcelRequire("3zNHM");

var $koVbs = parcelRequire("koVbs");

var $1L3S5 = parcelRequire("1L3S5");

var $ek97b = parcelRequire("ek97b");
const $4871f580bea1e373$export$4f039f014adbb6f0 = ({ color: color, onChangeColor: onChangeColor, colorPaletteVariant: colorPaletteVariant = 'old', colorCardVariant: colorCardVariant = 'fill' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const colorPalette = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).map(({ backgroundColor: backgroundColor, messageLabel: messageLabel })=>({
            label: formatMessage(messageLabel),
            value: backgroundColor
        }));
    const colorPaletteOld = (0, $1L3S5.OPTION_COLOR_THEMES).map(({ backgroundColor: backgroundColor, messageLabel: messageLabel })=>({
            label: formatMessage(messageLabel),
            value: backgroundColor
        }));
    const handleChangeColor = (0, $5uXOq.useCallback)((_, newColor)=>{
        onChangeColor((0, $ek97b.getColorNameFromValue)(newColor));
    }, [
        onChangeColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGTQx.default), {
        cols: colorPaletteVariant === 'old' ? colorPaletteOld.length / 5 : colorPalette.length,
        palette: colorPaletteVariant === 'old' ? colorPaletteOld : colorPalette,
        selectedColor: (0, $ek97b.getValueFromColorName)(color),
        onChange: handleChangeColor,
        mode: (0, $3zNHM.Compact),
        checkMarkColor: color.includes('LIGHT') ? (0, $1L3S5.CHECK_MARK_COLOR_LIGHT) : (0, $1L3S5.CHECK_MARK_COLOR_DARK),
        autoFocus: false,
        isFocusLockEnabled: false,
        isInsideMenu: false,
        variant: colorCardVariant
    });
};

});
parcelRegister("lGTQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e30770a4da4328$export$2e2bcd8739ae039);
/* ColorPaletteMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kD00A = parcelRequire("kD00A");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $l0sd0 = parcelRequire("l0sd0");

var $5dAp2 = parcelRequire("5dAp2");

const $c5e30770a4da4328$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $kD00A.Mode).Standard, initialFocusRef: initialFocusRef, variant: variant = 'fill' })=>{
    const { options: options, value: selectedValue } = (0, $5dAp2.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
    const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
    const createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local"
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
    const handleChange = (event, value)=>{
        onChange(event, value, changeAnalyticsCaller());
    };
    (0, $5uXOq.useEffect)(()=>{
        colorCardRefs[focusedIndex]?.focus();
    }, [
        focusedIndex,
        colorCardRefs
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const numItems = options.length;
        switch(event.key){
            case 0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8:
            case 0, $8fa07a9626e5ffeb$export$695331c89a36efd6:
                setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                break;
            case 0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2:
            case 0, $8fa07a9626e5ffeb$export$842fd6cf65a6b80c:
                setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                break;
            case 0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b:
                if (isFocusLockEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    setFocusedIndex(selectedColorIndex);
                }
                break;
            default:
                break;
        }
    }, [
        isFocusLockEnabled,
        selectedColorIndex,
        setFocusedIndex,
        options
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-label": fullLabel,
        role: isInsideMenu ? 'menu' : 'radiogroup',
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $5dAp2.getWidth)(cols, mode)}px`
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _bfhk1bhr",
            mode === (0, $kD00A.Mode).Standard && "_2rkosqtm _16qs1akw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
                mode === (0, $kD00A.Mode).Compact && "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
            ]),
            children: options.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0sd0.default), {
                        type: (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963),
                        label: label,
                        value: value,
                        checkMarkColor: checkMarkColor,
                        isOption: true,
                        selected: value === selectedValue.value,
                        onClick: handleChange,
                        ref: (ref)=>{
                            colorCardRefs[index] = ref;
                        },
                        autoFocus: autoFocus,
                        initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                        isInsideMenu: isInsideMenu,
                        onKeyDown: handleKeyDown,
                        variant: variant
                    })
                }, value))
        })
    });
};
var $c5e30770a4da4328$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'color-picker',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
})((0, $cb25w.default)()($c5e30770a4da4328$export$4bbfe93c6a14e8e6));
const $c5e30770a4da4328$var$colorCardWrapperStyles = null;
const $c5e30770a4da4328$var$colorPaletteContainerStyles = null;
const $c5e30770a4da4328$var$colorPaletteContainerCompactStyles = null;
const $c5e30770a4da4328$var$colorPaletteMenuStyles = null;
const $c5e30770a4da4328$var$colorPaletteMenuStandardStyles = null;

});
parcelRegister("kD00A", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $e25de60b37efd75a$export$9484bbecc3c49a2e);
var $e25de60b37efd75a$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
    return Mode;
}({});

});

parcelRegister("l0sd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d681a23420d49946$export$2e2bcd8739ae039);
/* ColorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eJbwP = parcelRequire("eJbwP");

var $3bDjY = parcelRequire("3bDjY");



var $bWn3s = parcelRequire("bWn3s");
const $d681a23420d49946$var$ColorCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, componentRef)=>{
    const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $829f609a65d26a98$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown, variant: variant = 'fill' } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const isInitialFocus = (0, $5uXOq.useRef)(true);
    const isColorPaletteMenu = type === (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963);
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(event, value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $8fa07a9626e5ffeb$export$8152f929a25a0ff4) || event.key === (0, $8fa07a9626e5ffeb$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onClick(event, value);
        }
        if (isColorPaletteMenu) onKeyDown?.(event);
        else if (event.key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [
        isColorPaletteMenu,
        isTabbing,
        value,
        onClick,
        onKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
            focus: ()=>{
                if (isColorPaletteMenu) {
                    if (isInitialFocus.current) {
                        autoFocus && !initialFocusRef && ref.current?.focus();
                        isInitialFocus.current = false;
                    } else ref.current?.focus();
                }
            }
        }), [
        autoFocus,
        isColorPaletteMenu,
        initialFocusRef
    ]);
    const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
    const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
    const ariaChecked = isColorPaletteMenu ? selected : undefined;
    const ariaLabel = isColorPaletteMenu ? label : undefined;
    const isOutlineVariant = variant === 'outline';
    const newCheckmarkColor = isOutlineVariant ? "var(--ds-icon, #44546F)" : checkMarkColor;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        children: (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown,
                className: (0, $bwpsq.default)([
                    "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _1bsbzwfg _4t3izwfg _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && "_858uvmul _4cvxvmul",
                    focused && (isColorPaletteMenu || !isTabbing) && "_1h6dvmul"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    , {
                        style: isOutlineVariant ? {
                            borderColor: value || 'grey'
                        } : {
                            backgroundColor: value || 'transparent'
                        },
                        className: (0, $bwpsq.default)([
                            "_2rkosqtm _1bsb1tcg _4t3i1tcg _16qs16qq",
                            isOutlineVariant && "_189e1bk5 _1dqonqa1 _16qsglyw"
                        ]),
                        children: selected && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
                            color: newCheckmarkColor,
                            label: "",
                            spacing: "spacious",
                            LEGACY_margin: "1px"
                        })
                    })
                })
            });
        }
    });
});
var $d681a23420d49946$export$2e2bcd8739ae039 = $d681a23420d49946$var$ColorCard;
const $d681a23420d49946$var$colorCardOptionTabbingStyles = null;
const $d681a23420d49946$var$colorCardOptionFocusedStyles = null;
const $d681a23420d49946$var$sharedColorContainerStyles = null;
const $d681a23420d49946$var$colorCardWrapperStyles = null;
const $d681a23420d49946$var$colorCardContentStyles = null;
const $d681a23420d49946$var$colorCardContentStylesOutline = null;

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


const $8fa07a9626e5ffeb$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $8fa07a9626e5ffeb$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac = 32;
const $8fa07a9626e5ffeb$export$e51a3576c045c8d5 = ' ';
const $8fa07a9626e5ffeb$export$8152f929a25a0ff4 = 'Enter';
const $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $8fa07a9626e5ffeb$export$1734a06b2397c2a8 = 'ArrowDown';
const $8fa07a9626e5ffeb$export$842fd6cf65a6b80c = 'ArrowLeft';
const $8fa07a9626e5ffeb$export$695331c89a36efd6 = 'ArrowRight';
const $8fa07a9626e5ffeb$export$10f6869ed0a7d75b = 'Tab';
const $8fa07a9626e5ffeb$export$929c2026f4dd54a2 = 'Escape';


parcelRegister("5dAp2", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $38874a93fb14a10d$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $38874a93fb14a10d$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $k5uoT = parcelRequire("k5uoT");


var $8QpSo = parcelRequire("8QpSo");

var $kD00A = parcelRequire("kD00A");
const $38874a93fb14a10d$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac) + (0, $k5uoT.gridSize)() / 2);
    return mode === (0, $kD00A.Mode).Standard ? width + (0, $k5uoT.gridSize)() : width;
};
const $38874a93fb14a10d$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});


parcelRegister("3zNHM", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $06f62cb25bd09d8d$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $06f62cb25bd09d8d$export$2e2bcd8739ae039);

var $3PpqK = parcelRequire("3PpqK");

var $kD00A = parcelRequire("kD00A");

var $lGTQx = parcelRequire("lGTQx");
const { Compact: $06f62cb25bd09d8d$export$6479582a9c9e50ce, Standard: $06f62cb25bd09d8d$export$d5a1f56087d42b19 } = (0, $kD00A.Mode);
var $06f62cb25bd09d8d$export$2e2bcd8739ae039 = (0, $3PpqK.default);

});
parcelRegister("3PpqK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f994db29f75e4622$export$2e2bcd8739ae039);
/* ColorPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $b9dFI = parcelRequire("b9dFI");

var $1ErJq = parcelRequire("1ErJq");

var $jKrb6 = parcelRequire("jKrb6");


var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $5dAp2 = parcelRequire("5dAp2");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $7oXeG = parcelRequire("7oXeG");
const $f994db29f75e4622$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $f994db29f75e4622$var$packageName = "platform-pkg";
const $f994db29f75e4622$var$packageVersion = "0.0.0-use.local";
class $f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $f994db29f75e4622$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl, variant: variant = 'fill' } = this.props;
        const { options: options, value: value } = (0, $5dAp2.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9dFI.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: ref,
                    className: (0, $bwpsq.default)([
                        "_1e0c1o8l"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ErJq.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId,
                        variant: variant
                    })
                }),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            label: fullLabel,
            value: value,
            components: $jKrb6,
            onChange: this.onChangeSelect,
            searchThreshold: Number.MAX_VALUE,
            //@ts-ignore react-select unsupported props
            cols: cols,
            checkMarkColor: checkMarkColor,
            variant: variant,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown,
            ...(0, $VSDnB.fg)('one_event_rules_them_all_fg') && {
                onMenuOpen: this.props.onMenuOpen
            }
        });
    }
    constructor(...args){
        super(...args), this.createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit'), this.state = {
            isTabbing: false
        }, this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $f994db29f75e4622$var$packageName,
                    packageVersion: $f994db29f75e4622$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        }, this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        }, this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        }, this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2) || key === (0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === (0, $8fa07a9626e5ffeb$export$929c2026f4dd54a2)) e.stopPropagation();
        }, this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $7oXeG.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $f994db29f75e4622$export$2fcf66ed38ff3cf5 = (0, $8RXs9.default)($f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase);
var $f994db29f75e4622$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'color-picker',
    packageName: $f994db29f75e4622$var$packageName,
    packageVersion: $f994db29f75e4622$var$packageVersion
})((0, $cb25w.default)()($f994db29f75e4622$export$2fcf66ed38ff3cf5));
const $f994db29f75e4622$var$colorCardWrapperStyles = null;

});
parcelRegister("b9dFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $768d8504b373d7ff$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $5n5w4 = parcelRequire("5n5w4");
var $283js = parcelRequire("283js");
var $iGDLS = parcelRequire("iGDLS");

var $4wJSY = parcelRequire("4wJSY");

var $2Z7Iz = parcelRequire("2Z7Iz");

var $9KnKW = parcelRequire("9KnKW");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");


var $7K5PP = parcelRequire("7K5PP");

var $1DATb = parcelRequire("1DATb");

var $hT6ku = parcelRequire("hT6ku");

var $9DWu0 = parcelRequire("9DWu0");
/**
 * Are we rendering on the client or server?
 */ const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $768d8504b373d7ff$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $768d8504b373d7ff$var$defaultPopperProps = {
    modifiers: $768d8504b373d7ff$var$modifiers,
    placement: 'bottom-start'
};
const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$768d8504b373d7ff$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $hT6ku.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5n5w4.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iGDLS.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9DWu0.NotifyOpenLayerObserver), {
                    isOpen: (0, $VSDnB.fg)('platform_dst_layer_observer_select') && this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $hT6ku.defaultComponents),
            mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $hT6ku.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) // I might want to use a comma instead of a period here, when the feature flag is removed.
                    ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? `${optionName}, (${optionIndex + 1} of ${totalLength})` : `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? '' : ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $1DATb.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $1DATb.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $1DATb.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    // Safari still does not announce the first option when menu is opened, so forcing a change to the input label
                    // will include the first option in the initial announcement.
                    if (!(0, $VSDnB.fg)('design_system_select-a11y-improvement') || (0, $2Z7Iz.isSafari)() && (0, $VSDnB.fg)('design_system_select-a11y-improvement')) updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $283js.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hT6ku.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                                    label: providedAriaLabel,
                                    // TODO: Popup Select does not work well with active-descendant
                                    "aria-live": (0, $2Z7Iz.isAppleDevice)() && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                                    (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? 'assertive' // only needed on Apple products
                                     : undefined,
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                    styles: (0, $7VXAu.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId,
                                    ariaLiveMessages: {
                                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                                        onFocus: onReactSelectFocus,
                                        ...props.ariaLiveMessages // priority to use user handlers if provided
                                    }
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $VSDnB.fg)('platform_dst_layer_observer_select')) return;
            this.close();
        };
    }
}

});
parcelRegister("5n5w4", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $3e93612641040812$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $3e93612641040812$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $3e93612641040812$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("283js", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $18cee5f949ac4034$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");

var $fNOWl = parcelRequire("fNOWl");
var $18cee5f949ac4034$var$NOOP = function NOOP() {
    return void 0;
};
var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $eclLw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fNOWl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
            update: update || $18cee5f949ac4034$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $eclLw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("eclLw", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $a56311d537d20f47$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $a56311d537d20f47$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $a56311d537d20f47$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $a56311d537d20f47$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $a56311d537d20f47$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("fNOWl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b812f23d0bbb9e85$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Pv9O = parcelRequire("8Pv9O");

var $lHrkK = parcelRequire("lHrkK");

var $eclLw = parcelRequire("eclLw");
var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $8Pv9O.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("8Pv9O", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $66db415bc009fd50$export$8f7491d57c8f97a9);

var $dsn8Y = parcelRequire("dsn8Y");

var $4TVC8 = parcelRequire("4TVC8");

var $j8nKB = parcelRequire("j8nKB");

var $baic6 = parcelRequire("baic6");

var $1AoLg = parcelRequire("1AoLg");

var $gy4Xr = parcelRequire("gy4Xr");

var $3dDWl = parcelRequire("3dDWl");

var $1DdSC = parcelRequire("1DdSC");

var $gzAfz = parcelRequire("gzAfz");

var $6iLAT = parcelRequire("6iLAT");


var $66db415bc009fd50$export$d34966752335dd47 = [
    (0, $4TVC8.default),
    (0, $j8nKB.default),
    (0, $baic6.default),
    (0, $1AoLg.default),
    (0, $gy4Xr.default),
    (0, $3dDWl.default),
    (0, $1DdSC.default),
    (0, $gzAfz.default),
    (0, $6iLAT.default)
];
var $66db415bc009fd50$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $dsn8Y.popperGenerator)({
    defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("dsn8Y", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $9cbfd7bdb6a4f3f1$export$ed5e13716264f202);

var $gvlia = parcelRequire("gvlia");

var $jkGDj = parcelRequire("jkGDj");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $kcmIg = parcelRequire("kcmIg");

var $a8clb = parcelRequire("a8clb");

var $i9xH7 = parcelRequire("i9xH7");


var $gmkfg = parcelRequire("gmkfg");
var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $9cbfd7bdb6a4f3f1$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gmkfg.isElement)(reference) ? (0, $2r6BH.default)(reference) : reference.contextElement ? (0, $2r6BH.default)(reference.contextElement) : [],
                    popper: (0, $2r6BH.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $kcmIg.default)((0, $i9xH7.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gvlia.default)(reference, (0, $gbHJy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $jkGDj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $a8clb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gvlia", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0400ebb908e52cb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $9FFjG = parcelRequire("9FFjG");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");

var $imzt5 = parcelRequire("imzt5");

var $eVELE = parcelRequire("eVELE");

var $c6EdA = parcelRequire("c6EdA");

var $90xPK = parcelRequire("90xPK");
function $c0400ebb908e52cb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $90xPK.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $90xPK.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gmkfg.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gmkfg.isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
    var documentElement = (0, $eVELE.default)(offsetParent);
    var rect = (0, $g2O7Z.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f5IBt.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c6EdA.default)(documentElement)) scroll = (0, $9FFjG.default)(offsetParent);
        if ((0, $gmkfg.isHTMLElement)(offsetParent)) {
            offsets = (0, $g2O7Z.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $imzt5.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("g2O7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae3b796a534b2cf$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");

var $90xPK = parcelRequire("90xPK");

var $1Prpe = parcelRequire("1Prpe");

var $d8bsQ = parcelRequire("d8bsQ");
function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gmkfg.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $90xPK.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $90xPK.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gmkfg.isElement)(element) ? (0, $1Prpe.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d8bsQ.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gmkfg", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $be8e67adfa808002$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $be8e67adfa808002$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $be8e67adfa808002$export$af51f0f06c0f328a);

var $1Prpe = parcelRequire("1Prpe");
function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1Prpe.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1Prpe.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1Prpe.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("1Prpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $154fd01b154b825f$export$2e2bcd8739ae039);
function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("90xPK", function(module, exports) {

$parcel$export(module.exports, "max", () => $68ee5bce69e9df7e$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $68ee5bce69e9df7e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $68ee5bce69e9df7e$export$2077e0241d6afd3c);
var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d8bsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f4ea48bb7f7060$export$2e2bcd8739ae039);

var $j5Xhq = parcelRequire("j5Xhq");
function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j5Xhq.default)());
}

});
parcelRegister("j5Xhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6c77c242bcf4cf$export$2e2bcd8739ae039);
function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9FFjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a7fdf85bb2e8b8$export$2e2bcd8739ae039);

var $8YTLN = parcelRequire("8YTLN");

var $1Prpe = parcelRequire("1Prpe");

var $gmkfg = parcelRequire("gmkfg");

var $i1ad3 = parcelRequire("i1ad3");
function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
    if (node === (0, $1Prpe.default)(node) || !(0, $gmkfg.isHTMLElement)(node)) return (0, $8YTLN.default)(node);
    else return (0, $i1ad3.default)(node);
}

});
parcelRegister("8YTLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $689f300ec0defb42$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
    var win = (0, $1Prpe.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("i1ad3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e03d69dfb9832f$export$2e2bcd8739ae039);
function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("f5IBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc9ebf0aa1487e4$export$2e2bcd8739ae039);
function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("imzt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e5cb506db8cdcb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $eVELE = parcelRequire("eVELE");

var $8YTLN = parcelRequire("8YTLN");
function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $g2O7Z.default)((0, $eVELE.default)(element)).left + (0, $8YTLN.default)(element).scrollLeft;
}

});
parcelRegister("eVELE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade6032ba4b824fe$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gmkfg.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("c6EdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d053e13cecc73ee$export$2e2bcd8739ae039);

var $1ix2F = parcelRequire("1ix2F");
function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1ix2F.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("1ix2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f211a5db2cb1d1b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
    return (0, $1Prpe.default)(element).getComputedStyle(element);
}

});



parcelRegister("jkGDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e130f49f6e9ebcb4$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");
function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $g2O7Z.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("2r6BH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c633a6ac170841a$export$2e2bcd8739ae039);

var $k82dT = parcelRequire("k82dT");

var $eTUzl = parcelRequire("eTUzl");

var $1Prpe = parcelRequire("1Prpe");

var $c6EdA = parcelRequire("c6EdA");
function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $k82dT.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1Prpe.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c6EdA.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, $eTUzl.default)(target)));
}

});
parcelRegister("k82dT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7647704a508683$export$2e2bcd8739ae039);

var $eTUzl = parcelRequire("eTUzl");

var $c6EdA = parcelRequire("c6EdA");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
function $ea7647704a508683$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $f5IBt.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gmkfg.isHTMLElement)(node) && (0, $c6EdA.default)(node)) return node;
    return $ea7647704a508683$export$2e2bcd8739ae039((0, $eTUzl.default)(node));
}

});
parcelRegister("eTUzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad921528f26834dd$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $eVELE = parcelRequire("eVELE");

var $gmkfg = parcelRequire("gmkfg");
function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
    if ((0, $f5IBt.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gmkfg.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eVELE.default)(element) // fallback
    );
}

});



parcelRegister("gbHJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f9908a1e4106f$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $f5IBt = parcelRequire("f5IBt");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $6hs9X = parcelRequire("6hs9X");

var $eTUzl = parcelRequire("eTUzl");

var $j5Xhq = parcelRequire("j5Xhq");
function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
    if (!(0, $gmkfg.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1ix2F.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $bc8f9908a1e4106f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j5Xhq.default)());
    var isIE = /Trident/i.test((0, $j5Xhq.default)());
    if (isIE && (0, $gmkfg.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1ix2F.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $eTUzl.default)(element);
    if ((0, $gmkfg.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gmkfg.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $f5IBt.default)(currentNode)) < 0){
        var css = (0, $1ix2F.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
    var window = (0, $1Prpe.default)(element);
    var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6hs9X.default)(offsetParent) && (0, $1ix2F.default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $f5IBt.default)(offsetParent) === 'html' || (0, $f5IBt.default)(offsetParent) === 'body' && (0, $1ix2F.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
}

});
parcelRegister("6hs9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $492a2c861940c94d$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");
function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $f5IBt.default)(element)) >= 0;
}

});


parcelRegister("kcmIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb468bf0752088cc$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");
function $eb468bf0752088cc$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $eb468bf0752088cc$var$order(modifiers); // order based on phase
    return (0, $kJPed.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("kJPed", function(module, exports) {

$parcel$export(module.exports, "top", () => $f18fbf7b212a7c8e$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f18fbf7b212a7c8e$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f18fbf7b212a7c8e$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f18fbf7b212a7c8e$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f18fbf7b212a7c8e$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f18fbf7b212a7c8e$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f18fbf7b212a7c8e$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f18fbf7b212a7c8e$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $f18fbf7b212a7c8e$export$d087d3878fdf71d5);
var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
    $f18fbf7b212a7c8e$export$1e95b668f3b82d,
    $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
    $f18fbf7b212a7c8e$export$79ffe56a765070d2,
    $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
];
var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []);
var $f18fbf7b212a7c8e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
    $f18fbf7b212a7c8e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
    $f18fbf7b212a7c8e$export$421679a7c3d56e,
    $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
    $f18fbf7b212a7c8e$export$6964f6c886723980,
    $f18fbf7b212a7c8e$export$c65e99957a05207c,
    $f18fbf7b212a7c8e$export$f22da7240b7add18,
    $f18fbf7b212a7c8e$export$bab79516f2d662fe,
    $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
    $f18fbf7b212a7c8e$export$68d8715fc104d294,
    $f18fbf7b212a7c8e$export$70a6e5159acce2e6
];

});


parcelRegister("a8clb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7604395822cc5d61$export$2e2bcd8739ae039);
function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("i9xH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3733441fcf2e882$export$2e2bcd8739ae039);
function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("4TVC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3918fd6b815bcf57$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
var $3918fd6b815bcf57$var$passive = {
    passive: true
};
function $3918fd6b815bcf57$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1Prpe.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3918fd6b815bcf57$var$effect,
    data: {}
};

});

parcelRegister("j8nKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee1300a39219bb5$export$2e2bcd8739ae039);

var $dJ0Jl = parcelRequire("dJ0Jl");
function $dee1300a39219bb5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dJ0Jl.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dee1300a39219bb5$var$popperOffsets,
    data: {}
};

});
parcelRegister("dJ0Jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe00b5c334118ac$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $9GF9F = parcelRequire("9GF9F");

var $kJPed = parcelRequire("kJPed");
function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $QXpw1.default)(placement) : null;
    var variation = placement ? (0, $cGRJ4.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $kJPed.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $kJPed.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $kJPed.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $kJPed.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9GF9F.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $kJPed.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $kJPed.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("QXpw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f2f123ac4a9fdf$export$2e2bcd8739ae039);

function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("cGRJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d315208040ceed$export$2e2bcd8739ae039);
function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9GF9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d7f5cda4210aa3$export$2e2bcd8739ae039);
function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("baic6", function(module, exports) {

$parcel$export(module.exports, "default", () => $820ebddbe0682e4f$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $gbHJy = parcelRequire("gbHJy");

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $90xPK = parcelRequire("90xPK");
var $820ebddbe0682e4f$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $90xPK.round)(x * dpr) / dpr || 0,
        y: (0, $90xPK.round)(y * dpr) / dpr || 0
    };
}
function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $kJPed.left);
    var sideY = (0, $kJPed.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $gbHJy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1Prpe.default)(popper)) {
            offsetParent = (0, $eVELE.default)(popper);
            if ((0, $1ix2F.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $kJPed.top) || (placement === (0, $kJPed.left) || placement === (0, $kJPed.right)) && variation === (0, $kJPed.end)) {
            sideY = (0, $kJPed.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $kJPed.left) || (placement === (0, $kJPed.top) || placement === (0, $kJPed.bottom)) && variation === (0, $kJPed.end)) {
            sideX = (0, $kJPed.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $820ebddbe0682e4f$var$unsetSides);
    var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1Prpe.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $820ebddbe0682e4f$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $QXpw1.default)(state.placement),
        variation: (0, $cGRJ4.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $820ebddbe0682e4f$var$computeStyles,
    data: {}
};

});

parcelRegister("1AoLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $127c5c56b9511f5f$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
// and applies them to the HTMLElements such as popper and arrow
function $127c5c56b9511f5f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $127c5c56b9511f5f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $127c5c56b9511f5f$var$applyStyles,
    effect: $127c5c56b9511f5f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("gy4Xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c3aad300d72ee1$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $kJPed = parcelRequire("kJPed");
function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $QXpw1.default)(placement);
    var invertDistance = [
        (0, $kJPed.left),
        (0, $kJPed.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c0c3aad300d72ee1$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $kJPed.placements).reduce(function(acc, placement) {
        acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $c0c3aad300d72ee1$var$offset
};

});

parcelRegister("3dDWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $258191447a7022df$export$2e2bcd8739ae039);

var $jwSgb = parcelRequire("jwSgb");

var $QXpw1 = parcelRequire("QXpw1");

var $4tIVJ = parcelRequire("4tIVJ");

var $kgkit = parcelRequire("kgkit");

var $cqF2x = parcelRequire("cqF2x");

var $kJPed = parcelRequire("kJPed");

var $cGRJ4 = parcelRequire("cGRJ4");
function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
    if ((0, $QXpw1.default)(placement) === (0, $kJPed.auto)) return [];
    var oppositePlacement = (0, $jwSgb.default)(placement);
    return [
        (0, $4tIVJ.default)(placement),
        oppositePlacement,
        (0, $4tIVJ.default)(oppositePlacement)
    ];
}
function $258191447a7022df$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $QXpw1.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jwSgb.default)(preferredPlacement)
    ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $QXpw1.default)(placement) === (0, $kJPed.auto) ? (0, $cqF2x.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $QXpw1.default)(placement);
        var isStartVariation = (0, $cGRJ4.default)(placement) === (0, $kJPed.start);
        var isVertical = [
            (0, $kJPed.top),
            (0, $kJPed.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $kJPed.right) : (0, $kJPed.left) : isStartVariation ? (0, $kJPed.bottom) : (0, $kJPed.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var altVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $258191447a7022df$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $258191447a7022df$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jwSgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37b1862c86f39c4$export$2e2bcd8739ae039);
var $e37b1862c86f39c4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e37b1862c86f39c4$var$hash[matched];
    });
}

});

parcelRegister("4tIVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $342cb90cb2622617$export$2e2bcd8739ae039);
var $342cb90cb2622617$var$hash = {
    start: 'end',
    end: 'start'
};
function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $342cb90cb2622617$var$hash[matched];
    });
}

});

parcelRegister("kgkit", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec050bcf5e349283$export$2e2bcd8739ae039);

var $dknpr = parcelRequire("dknpr");

var $eVELE = parcelRequire("eVELE");

var $g2O7Z = parcelRequire("g2O7Z");

var $dJ0Jl = parcelRequire("dJ0Jl");

var $h8W1z = parcelRequire("h8W1z");

var $kJPed = parcelRequire("kJPed");

var $gmkfg = parcelRequire("gmkfg");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");
function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $kJPed.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $kJPed.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $kJPed.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
    var altContext = elementContext === (0, $kJPed.popper) ? (0, $kJPed.reference) : (0, $kJPed.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dknpr.default)((0, $gmkfg.isElement)(element) ? element : element.contextElement || (0, $eVELE.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $g2O7Z.default)(state.elements.reference);
    var popperOffsets = (0, $dJ0Jl.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $h8W1z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $kJPed.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $kJPed.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $kJPed.right),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $kJPed.top),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("dknpr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3f4d3932acb3b2$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $3V2hG = parcelRequire("3V2hG");

var $9NXD7 = parcelRequire("9NXD7");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $g2O7Z = parcelRequire("g2O7Z");

var $eTUzl = parcelRequire("eTUzl");

var $j6yPg = parcelRequire("j6yPg");

var $f5IBt = parcelRequire("f5IBt");

var $h8W1z = parcelRequire("h8W1z");

var $90xPK = parcelRequire("90xPK");
function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $g2O7Z.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $kJPed.viewport) ? (0, $h8W1z.default)((0, $3V2hG.default)(element, strategy)) : (0, $gmkfg.isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $h8W1z.default)((0, $9NXD7.default)((0, $eVELE.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9b3f4d3932acb3b2$var$getClippingParents(element) {
    var clippingParents = (0, $2r6BH.default)((0, $eTUzl.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1ix2F.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gmkfg.isHTMLElement)(element) ? (0, $gbHJy.default)(element) : element;
    if (!(0, $gmkfg.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gmkfg.isElement)(clippingParent) && (0, $j6yPg.default)(clippingParent, clipperElement) && (0, $f5IBt.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $90xPK.max)(rect.top, accRect.top);
        accRect.right = (0, $90xPK.min)(rect.right, accRect.right);
        accRect.bottom = (0, $90xPK.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $90xPK.max)(rect.left, accRect.left);
        return accRect;
    }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3V2hG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da877912142c34b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $imzt5 = parcelRequire("imzt5");

var $d8bsQ = parcelRequire("d8bsQ");
function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1Prpe.default)(element);
    var html = (0, $eVELE.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d8bsQ.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $imzt5.default)(element),
        y: y
    };
}

});

parcelRegister("9NXD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7236f1f1532b7fe8$export$2e2bcd8739ae039);

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $imzt5 = parcelRequire("imzt5");

var $8YTLN = parcelRequire("8YTLN");

var $90xPK = parcelRequire("90xPK");
function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eVELE.default)(element);
    var winScroll = (0, $8YTLN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $90xPK.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $90xPK.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $imzt5.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1ix2F.default)(body || html).direction === 'rtl') x += (0, $90xPK.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("j6yPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $de89978be23479c4$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gmkfg.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("h8W1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b0316bb2f8fd97$export$2e2bcd8739ae039);
function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("gIXWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cf410c4fe133f4$export$2e2bcd8739ae039);

var $1ANH0 = parcelRequire("1ANH0");
function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1ANH0.default)(), paddingObject);
}

});
parcelRegister("1ANH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $128fb32b18b92ffa$export$2e2bcd8739ae039);
function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("50KfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cqF2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c7bf65fbdbec33$export$2e2bcd8739ae039);

var $cGRJ4 = parcelRequire("cGRJ4");

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");

var $QXpw1 = parcelRequire("QXpw1");
function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $kJPed.placements) : _options$allowedAutoP;
    var variation = (0, $cGRJ4.default)(placement);
    var placements = variation ? flipVariations ? (0, $kJPed.variationPlacements) : (0, $kJPed.variationPlacements).filter(function(placement) {
        return (0, $cGRJ4.default)(placement) === variation;
    }) : (0, $kJPed.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $QXpw1.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("1DdSC", function(module, exports) {

$parcel$export(module.exports, "default", () => $13043339457d5bc5$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $QXpw1 = parcelRequire("QXpw1");

var $9GF9F = parcelRequire("9GF9F");

var $dNtrn = parcelRequire("dNtrn");

var $4WpIh = parcelRequire("4WpIh");

var $jkGDj = parcelRequire("jkGDj");

var $gbHJy = parcelRequire("gbHJy");

var $kgkit = parcelRequire("kgkit");

var $cGRJ4 = parcelRequire("cGRJ4");

var $1ANH0 = parcelRequire("1ANH0");

var $90xPK = parcelRequire("90xPK");
function $13043339457d5bc5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $kgkit.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var variation = (0, $cGRJ4.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9GF9F.default)(basePlacement);
    var altAxis = (0, $dNtrn.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
        var altSide = mainAxis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $kJPed.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $kJPed.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $jkGDj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1ANH0.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4WpIh.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $gbHJy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4WpIh.within)(tether ? (0, $90xPK.min)(min, tetherMin) : min, offset, tether ? (0, $90xPK.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $kJPed.top) : (0, $kJPed.left);
        var _altSide = mainAxis === 'x' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $kJPed.top),
            (0, $kJPed.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4WpIh.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $4WpIh.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $13043339457d5bc5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $13043339457d5bc5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("dNtrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("4WpIh", function(module, exports) {

$parcel$export(module.exports, "within", () => $3990864f59117d05$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $3990864f59117d05$export$86c8af6d3ef0b4a);

var $90xPK = parcelRequire("90xPK");
function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
    return (0, $90xPK.max)(min, (0, $90xPK.min)(value, max));
}
function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("gzAfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10c08bd5e0ed9fb$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $jkGDj = parcelRequire("jkGDj");

var $j6yPg = parcelRequire("j6yPg");

var $gbHJy = parcelRequire("gbHJy");

var $9GF9F = parcelRequire("9GF9F");

var $4WpIh = parcelRequire("4WpIh");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");

var $kJPed = parcelRequire("kJPed");
var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
};
function $c10c08bd5e0ed9fb$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var axis = (0, $9GF9F.default)(basePlacement);
    var isVertical = [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $jkGDj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
    var maxProp = axis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $gbHJy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4WpIh.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c10c08bd5e0ed9fb$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $j6yPg.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c10c08bd5e0ed9fb$var$arrow,
    effect: $c10c08bd5e0ed9fb$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("6iLAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $496957b0c691a0ed$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");
function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $kJPed.top),
        (0, $kJPed.right),
        (0, $kJPed.bottom),
        (0, $kJPed.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $496957b0c691a0ed$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $kgkit.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $kgkit.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $496957b0c691a0ed$var$hide
};

});




parcelRegister("iGDLS", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $d9aafffd117cbcc1$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");
function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $eclLw.setRef)(innerRef, node);
        (0, $eclLw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $eclLw.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $eclLw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("hT6ku", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $3f79b132df1e01ff$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $3f79b132df1e01ff$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $3f79b132df1e01ff$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gMMNe = parcelRequire("gMMNe");

var $bChGW = parcelRequire("bChGW");

var $jldZL = parcelRequire("jldZL");
const $3f79b132df1e01ff$var$menuDialogStyles = null;
const $3f79b132df1e01ff$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $3f79b132df1e01ff$var$dropdownStyles = null;
const $3f79b132df1e01ff$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gMMNe))), {
            color: "currentColor",
            label: ""
        })
    });
const $3f79b132df1e01ff$var$controlStyles = null;
const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $3f79b132df1e01ff$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ClearIndicator, {
        ...props
    });
const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).MultiValueRemove, {
        ...props
    });
const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
    Control: $3f79b132df1e01ff$var$Control,
    DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
    Menu: $3f79b132df1e01ff$var$Menu,
    ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
    MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
};

});
parcelRegister("gMMNe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd994b90fa78030d2d1c292998636115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));

var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c386fa4cb21167b0$var$SearchIcon = (props)=>/*#__PURE__*/ $c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
    }, props));
$c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;

});
parcelRegister("77ZoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $5308cfd5e45a5605$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $5308cfd5e45a5605$var$_search.default
    }));
$5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;

});



parcelRegister("9DWu0", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $072287da151cf77b$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $072287da151cf77b$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});


parcelRegister("1ErJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $609735830782207d$export$2e2bcd8739ae039);
/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $VSDnB = parcelRequire("VSDnB");
const $609735830782207d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id, variant: variant = 'fill' })=>{
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        /**
     * The 'platform_dst_layer_observer_select' feature flag updates `PopupSelect` to close itself when
     * the internal Select's `onMenuClose` prop is called.
     *
     * By moving focus to the trigger element after the select menu is open, it causes the select
     * menu to think it is being closed, and call its `onMenuClose` prop.
     *
     * This results in the PopupSelect instantly closing when the user clicks to open it.
     */ if (!(0, $VSDnB.fg)('platform_dst_layer_observer_select')) event.currentTarget.focus();
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const isOutlineVariant = variant === 'outline';
    const colorCardStyles = isOutlineVariant ? {
        borderColor: value || 'grey'
    } : {
        backgroundColor: value || 'transparent'
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id,
            className: (0, $bwpsq.default)([
                "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                swatchSize === 'small' ? "_1bsb1tcg _4t3i1tcg _154i1i6y" : "_1bsbzwfg _4t3izwfg",
                "_nt751r31 _gk8x1r31 _49pcglyw _24ueglyw _1hvw1o36 _b4yv1o36 _858u1l4g _rslm1l4g _4cvxtxrc",
                expanded && !(0, $VSDnB.fg)('platform-design-system-dsp-20821-color-pickr-focus') && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1l4g"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: colorCardStyles,
                    className: (0, $bwpsq.default)([
                        isOutlineVariant ? "_2rkosqtm _189e1bk5 _1dqonqa1" : "_2rkosqtm _16qs16qq",
                        swatchSize === 'small' ? "_1bsb7vkz _4t3i7vkz" : "_1bsb1tcg _4t3i1tcg"
                    ])
                })
            })
        })
    });
};
var $609735830782207d$export$2e2bcd8739ae039 = $609735830782207d$var$ColorCard;
const $609735830782207d$var$sharedColorContainerStyles = null;
const $609735830782207d$var$smallColorContainerSize = null;
const $609735830782207d$var$defaultColorContainerSize = null;
const $609735830782207d$var$colorCardButtonStyles = null;
const $609735830782207d$var$colorCardButtonFocusedStyles = null;
const $609735830782207d$var$colorCardWrapperStyles = null;
const $609735830782207d$var$colorCardContentStyles = null;
const $609735830782207d$var$colorCardContentStylesOutline = null;
const $609735830782207d$var$smallColorCardContentSize = null;
const $609735830782207d$var$defaultColorCardContentSize = null;

});

parcelRegister("jKrb6", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $b794a85d007e2dce$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $b794a85d007e2dce$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $b794a85d007e2dce$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $b794a85d007e2dce$export$84712d0562a614b8);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l0sd0 = parcelRequire("l0sd0");

var $5dAp2 = parcelRequire("5dAp2");


var $koVbs = parcelRequire("koVbs");

var $7oXeG = parcelRequire("7oXeG");
const $b794a85d007e2dce$export$d4c4e98c5044dc8 = (props)=>{
    const { //@ts-ignore react-select unsupported props
    selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "group",
        "aria-label": formatMessage((0, $7oXeG.default).menuListAriaLabel),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $5dAp2.getWidth)(cols) : undefined
        },
        //@ts-ignore react-select unsupported props
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ]),
        children: children
    });
};
const $b794a85d007e2dce$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, //@ts-ignore react-select unsupported props
    selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing, variant: variant }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        role: "radio",
        "aria-checked": isSelected,
        "aria-selected": undefined,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0sd0.default), {
            type: (0, $8fa07a9626e5ffeb$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing,
            variant: variant
        })
    });
};
const $b794a85d007e2dce$export$ec98719d3db7f2e4 = ()=>null;
const $b794a85d007e2dce$export$84712d0562a614b8 = ()=>null;
const $b794a85d007e2dce$var$colorCardWrapperStyles = null;
const $b794a85d007e2dce$var$colorPaletteContainerStyles = null;

});
parcelRegister("7oXeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42a6da5a6d06680$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d42a6da5a6d06680$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    },
    menuListAriaLabel: {
        id: 'jira.color-picker.src.menu-list-aria-label',
        defaultMessage: 'Color picker list',
        description: 'This text is used as aria-label text for the listbox element in color picker component'
    }
});

});





parcelRegister("alO8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a9d4ce00e6c963$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $73a9d4ce00e6c963$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    optionNameLabel: {
        "id": "business-categories.option-form.option-name-label",
        "defaultMessage": "Option name"
    },
    optionNamePlaceholder: {
        "id": "business-categories.option-form.option-name-placeholder",
        "defaultMessage": "New option"
    },
    cancelButton: {
        "id": "business-categories.option-form.cancel-button",
        "defaultMessage": "Cancel"
    },
    saveButton: {
        "id": "business-categories.option-form.save-button",
        "defaultMessage": "Save"
    },
    addButton: {
        "id": "business-categories.option-form.add-button",
        "defaultMessage": "Add"
    },
    errorMessageBlankOptionName: {
        "id": "business-categories.option-form.error-message-blank-option-name",
        "defaultMessage": "Option name cannot be blank"
    },
    errorMessageDuplicateOptionName: {
        "id": "business-categories.option-form.error-message-duplicate-option-name",
        "defaultMessage": "Option name cannot be duplicate"
    },
    editOptionTitle: {
        "id": "business-categories.option-form.edit-option-title",
        "defaultMessage": "Edit option"
    },
    newOptionTitle: {
        "id": "business-categories.option-form.new-option-title",
        "defaultMessage": "New option"
    }
});

});

parcelRegister("lpRLe", function(module, exports) {

$parcel$export(module.exports, "OptionTag", () => $7e21718d85b37a90$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ek97b = parcelRequire("ek97b");
const $7e21718d85b37a90$export$5991b62d89f5cc = /*#__PURE__*/ (0, $5uXOq.memo)(({ name: name, color: color, isInteractive: isInteractive = true })=>{
    const { backgroundColor: tagColor } = (0, $ek97b.getColorMetadata)(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $7e21718d85b37a90$var$tagWrapperStyles,
            isInteractive && $7e21718d85b37a90$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e21718d85b37a90$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
});
const $7e21718d85b37a90$var$tagWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $7e21718d85b37a90$var$interactiveStyles = (0, $8CUq3.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e21718d85b37a90$var$StyledTagBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $7e21718d85b37a90$var$StyledTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7e21718d85b37a90$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $lD23V.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko5n0m _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b6qPx", function(module, exports) {

$parcel$export(module.exports, "COLOR_PICKER_STATE", () => $540b63ed208053a5$export$25f706c9042c43eb);
const $540b63ed208053a5$export$25f706c9042c43eb = {
    IDLE: undefined,
    EDIT: 'edit',
    CREATE: 'create'
};

});


parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), rest);
};

});
parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $1I7E8 = parcelRequire("1I7E8");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $1I7E8.Popup), 'isOpen', 'content');

});


parcelRegister("kmov5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cfb5bdd7619126$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e6cfb5bdd7619126$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    colorPickerNonFinal: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.option.color-picker-non-final",
        "defaultMessage": "Color Picker"
    }
});

});


parcelRegister("gdr0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $04ef66b0a43cb646$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04ef66b0a43cb646$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeOption: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.option.remove-option",
        "defaultMessage": "Remove option"
    },
    disabledInputTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.field-options.option.disabled-input-tooltip",
        "defaultMessage": "You can\u2019t change this option"
    },
    disabledSortHandleTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.field-options.option.disabled-sort-handle-tooltip",
        "defaultMessage": "You can\u2019t reorder the options"
    },
    disabledRemoveButtonTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.field-options.option.disabled-remove-button-tooltip",
        "defaultMessage": "You can\u2019t remove this option"
    },
    draggableItemRole: {
        "id": "issue-type-page.field-associated.field-configuration.field-options.option.draggable-item-role",
        "defaultMessage": "Draggable item"
    }
});

});


parcelRegister("lfaxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee8ca3908c96615$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7ee8ca3908c96615$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeOption: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.option.remove-option",
        "defaultMessage": "Remove option"
    },
    disabledInputTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.option.disabled-input-tooltip",
        "defaultMessage": "You can\u2019t change this option"
    },
    disabledSortHandleTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.option.disabled-sort-handle-tooltip",
        "defaultMessage": "You can\u2019t reorder the options"
    },
    disabledRemoveButtonTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.option.disabled-remove-button-tooltip",
        "defaultMessage": "You can\u2019t remove this option"
    }
});

});


parcelRegister("e2ztK", function(module, exports) {

$parcel$export(module.exports, "groupCascadingSelectFieldOptions", () => $f805782034de18f5$export$8687a72798e75d57);
$parcel$export(module.exports, "canAddNewOptions", () => $f805782034de18f5$export$870826d9312246ac);

var $gJBT6 = parcelRequire("gJBT6");

var $8G7jD = parcelRequire("8G7jD");
const $f805782034de18f5$export$8687a72798e75d57 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((options)=>{
    if (!Array.isArray(options)) throw new Error('Expecting options array but options is not an array. (issue-type-page.field-options.dropdown-options)');
    return options.reduce((grouped, option)=>{
        const parentExternalUuid = option.parentExternalUuid || 'root';
        // eslint-disable-next-line no-param-reassign
        grouped[parentExternalUuid] = [
            ...grouped[parentExternalUuid] || [],
            option
        ];
        return grouped;
    }, {});
});
function $f805782034de18f5$export$870826d9312246ac(field, limits) {
    return field.operations.canModifyOptions && !(0, $8G7jD.isOptionsPerFieldLimitReached)(field, limits);
}

});

parcelRegister("8CNiY", function(module, exports) {

$parcel$export(module.exports, "default", () => $384c79f881ebd55c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $384c79f881ebd55c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addNewChildOption: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.options-list.add-new-child-option",
        "defaultMessage": "Add child option"
    },
    addNewParentOption: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.options-list.add-new-parent-option",
        "defaultMessage": "Add parent option"
    },
    newOption: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.options-list.new-option",
        "defaultMessage": "Option 1"
    },
    optionPlaceholder: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.options-list.option-placeholder",
        "defaultMessage": "Option {index}"
    },
    addButtonDisabledMaxOptions: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.add-button-disabled-max-options",
        "defaultMessage": "You can't add more than {maxOptions} field options"
    },
    addButtonDisabledNoModify: {
        "id": "issue-type-page.field-associated.field-configuration.field-options.add-button-disabled-no-modify",
        "defaultMessage": "You can\u2019t add an option"
    }
});

});




parcelRegister("gvyUb", function(module, exports) {

$parcel$export(module.exports, "DefaultValueControlRight", () => $e81a9f1fe7f18dce$export$b33f97c2d49b270a);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $1oOvL = parcelRequire("1oOvL");

var $8RcZz = parcelRequire("8RcZz");
const $e81a9f1fe7f18dce$var$onDefaultValueChange = (field, onFieldUpdated, defaultValue)=>()=>{
        onFieldUpdated({
            ...field,
            defaultValue: defaultValue
        });
    };
const $e81a9f1fe7f18dce$export$b33f97c2d49b270a = ({ field: field, field: { operations: { canModifyDefaultValue: canModifyDefaultValue } }, option: option, isSelected: isSelected, isOptionHovered: isOptionHovered, isOptionFocused: isOptionFocused, onFieldUpdated: onFieldUpdated, tooltipDelay: tooltipDelay, testId: testId })=>{
    const intl = (0, $koVbs.default)();
    const interactingWithOption = isOptionHovered || isOptionFocused; // If isModifyDefaultValueDisabled is true then we never show the button to change default value.
    // Otherwise, we show the button in a hidden state, and make it visible when the option is hovered or focused.
    const changeDefaultValueFragment = !canModifyDefaultValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e81a9f1fe7f18dce$var$Wrapper, {
        isActive: interactingWithOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        isDisabled: !canModifyDefaultValue,
        onClick: $e81a9f1fe7f18dce$var$onDefaultValueChange(field, onFieldUpdated, isSelected ? undefined : option)
    }, intl.formatMessage(isSelected ? (0, $8RcZz.default).clearDefault : (0, $8RcZz.default).setAsDefault)));
    // We only show the label if the option is selected AND the change default value button is not visible.
    const defaultLabelFragment = !isSelected || canModifyDefaultValue && interactingWithOption ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: !canModifyDefaultValue ? intl.formatMessage((0, $8RcZz.default).disabledDefaultTooltip) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.DefaultValueLabel), {
        isDisabled: !canModifyDefaultValue,
        "data-testid": testId
    }, intl.formatMessage((0, $8RcZz.default).default)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, changeDefaultValueFragment, defaultLabelFragment);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e81a9f1fe7f18dce$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1i5z15vq _f7sg15vq _qhhk1cib _v3my1wug",
            __cmplp.isActive ? "_1nq3pfqs" : "_1nq3stnw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8RcZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba99211df0c0d93$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ba99211df0c0d93$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    default: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-dropdown.default-value.default",
        "defaultMessage": "Default"
    },
    disabledDefaultTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-dropdown.default-value.disabled-default-tooltip",
        "defaultMessage": "You can\u2019t clear the default option"
    },
    setAsDefault: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-dropdown.default-value.set-as-default",
        "defaultMessage": "Set as default"
    },
    clearDefault: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-dropdown.default-value.clear-default",
        "defaultMessage": "Clear default"
    }
});

});


parcelRegister("6rA66", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f205e75a7a21439$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5f205e75a7a21439$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    optionsHeader: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-dropdown.options-header",
        "defaultMessage": "Options"
    }
});

});


parcelRegister("5PsvH", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $a35acc73feca5a87$export$6e0f0a958dc8ef91);

const $a35acc73feca5a87$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyOptions || operations.canModifyDefaultValue;

});

parcelRegister("bs61j", function(module, exports) {

$parcel$export(module.exports, "CheckboxFieldConfiguration", () => $f39b64efb7ad57fd$export$19db74eae5eb0906);

var $5uXOq = parcelRequire("5uXOq");

var $7ynmL = parcelRequire("7ynmL");

var $8G7jD = parcelRequire("8G7jD");

var $fwQnS = parcelRequire("fwQnS");

var $dVWDu = parcelRequire("dVWDu");
const $f39b64efb7ad57fd$export$10ebcd1401efa104 = (onUpdate)=>(field)=>{
        const { defaultValue: defaultValue, options: options } = field;
        if (options == null) {
            onUpdate(field);
            return;
        }
        const refined = (0, $8G7jD.refineDefaultValue)(defaultValue);
        if (refined.length === 0) {
            onUpdate(field);
            return;
        }
        const updatedDefaultOptions = options.filter((0, $8G7jD.isDefaultOption)(refined));
        onUpdate({
            ...field,
            defaultValue: updatedDefaultOptions.length ? updatedDefaultOptions : undefined
        });
    };
const $f39b64efb7ad57fd$export$19db74eae5eb0906 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ynmL.FieldOptions), {
        ...props,
        label: (0, $dVWDu.default).optionsLabel,
        onUpdate: $f39b64efb7ad57fd$export$10ebcd1401efa104(props.onUpdate),
        DefaultValueControlLeft: (0, $fwQnS.DefaultValueControlLeft),
        DefaultValueControlRight: (0, $fwQnS.DefaultValueControlRight)
    });

});
parcelRegister("7ynmL", function(module, exports) {

$parcel$export(module.exports, "FieldOptions", () => $87728ea4af59badd$export$3feb8dd00bcf2932);

var $5uXOq = parcelRequire("5uXOq");

var $1oOvL = parcelRequire("1oOvL");

var $8G7jD = parcelRequire("8G7jD");
const $87728ea4af59badd$export$3feb8dd00bcf2932 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8G7jD.FieldOptions), {
        ...props,
        OptionComponent: (0, $1oOvL.Option)
    });

});

parcelRegister("fwQnS", function(module, exports) {

$parcel$export(module.exports, "DefaultValueControlLeft", () => $254bc430940ff69a$export$461aa733afc31e20);
$parcel$export(module.exports, "DefaultValueControlRight", () => $254bc430940ff69a$export$b33f97c2d49b270a);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $1oOvL = parcelRequire("1oOvL");

var $idQxE = parcelRequire("idQxE");
const $254bc430940ff69a$var$isOptionsEqual = (maybeOption, option)=>{
    if (!maybeOption || typeof maybeOption !== 'object') return false;
    // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'object'.
    return typeof maybeOption.id === 'number' ? // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'object'.
    option.id === maybeOption.id : // @ts-expect-error - TS2339 - Property 'optimisticId' does not exist on type 'object'.
    option.optimisticId === maybeOption.optimisticId;
};
const $254bc430940ff69a$var$remove = (defaultValue, option)=>{
    if (!Array.isArray(defaultValue)) return defaultValue;
    const result = defaultValue.filter((item)=>!$254bc430940ff69a$var$isOptionsEqual(item, option));
    return result.length > 0 ? result : undefined;
};
const $254bc430940ff69a$var$add = (defaultValue, option)=>Array.isArray(defaultValue) ? [
        ...defaultValue,
        option
    ] : [
        option
    ];
const $254bc430940ff69a$var$onDefaultValueChange = (field, onFieldUpdated, option, isRemoving)=>()=>{
        onFieldUpdated({
            ...field,
            defaultValue: isRemoving ? $254bc430940ff69a$var$remove(field.defaultValue, option) : $254bc430940ff69a$var$add(field.defaultValue, option)
        });
    };
const $254bc430940ff69a$export$461aa733afc31e20 = ({ field: field, option: option, isSelected: isSelected, onFieldUpdated: onFieldUpdated, field: { operations: { canModifyDefaultValue: canModifyDefaultValue } }, tooltipDelay: tooltipDelay })=>{
    let tooltipMessage = isSelected ? (0, $idQxE.default).tooltipUncheck : (0, $idQxE.default).tooltipCheck;
    if (!canModifyDefaultValue) tooltipMessage = isSelected ? (0, $idQxE.default).disabledTooltipUncheck : (0, $idQxE.default).disabledTooltipCheck;
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: intl.formatMessage(tooltipMessage),
        position: "bottom",
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        label: "",
        onChange: $254bc430940ff69a$var$onDefaultValueChange(field, onFieldUpdated, option, isSelected),
        name: "default",
        value: "default",
        isChecked: isSelected,
        isDisabled: !canModifyDefaultValue,
        "aria-label": intl.formatMessage((0, $idQxE.default).checkboxLabel, {
            option: option.value
        })
    }));
};
const $254bc430940ff69a$export$b33f97c2d49b270a = ({ isSelected: isSelected, field: { operations: { canModifyDefaultValue: canModifyDefaultValue } }, tooltipDelay: tooltipDelay, testId: testId })=>{
    const intl = (0, $koVbs.default)();
    if (!isSelected) return null;
    let tooltipMessage = isSelected ? (0, $idQxE.default).tooltipUncheck : (0, $idQxE.default).tooltipCheck;
    if (!canModifyDefaultValue) tooltipMessage = isSelected ? (0, $idQxE.default).disabledTooltipUncheck : (0, $idQxE.default).disabledTooltipCheck;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: intl.formatMessage(tooltipMessage),
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.DefaultValueLabel), {
        isDisabled: !canModifyDefaultValue,
        "data-testid": testId
    }, intl.formatMessage((0, $idQxE.default).default)));
};

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = null; /**
                              * __Checkbox__
                              *
                              * A checkbox an input control that allows a user to select one or more options from a number of choices.
                              *
                              * - [Examples](https://atlassian.design/components/checkbox/examples)
                              * - [Code](https://atlassian.design/components/checkbox/code)
                              * - [Usage](https://atlassian.design/components/checkbox/usage)
                              */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt",
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("idQxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dff76b4436f04ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0dff76b4436f04ec$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    default: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.checkboxes.default-value.default",
        "defaultMessage": "Preselected"
    },
    disabledTooltipCheck: {
        "id": "issue-type-page.field-associated.field-configuration.checkboxes.default-value.disabled-tooltip-check",
        "defaultMessage": "You can\u2019t preselect this option"
    },
    disabledTooltipUncheck: {
        "id": "issue-type-page.field-associated.field-configuration.checkboxes.default-value.disabled-tooltip-uncheck",
        "defaultMessage": "You can\u2019t clear this preselection"
    },
    tooltipCheck: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.checkboxes.default-value.tooltip-check",
        "defaultMessage": "Preselect"
    },
    tooltipUncheck: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.checkboxes.default-value.tooltip-uncheck",
        "defaultMessage": "Clear preselection"
    },
    checkboxLabel: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.checkboxes.default-value.checkbox-label",
        "defaultMessage": "Checkbox for option {option}"
    }
});

});


parcelRegister("dVWDu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c81b0d8d24ae1a52$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c81b0d8d24ae1a52$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    optionsLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.checkboxes.options-label",
        "defaultMessage": "Options"
    }
});

});


parcelRegister("e5ine", function(module, exports) {

$parcel$export(module.exports, "CurrentDateTimeDefaultValue", () => $58d70b9f73c36b6a$export$67ef7508ff63547d);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hPw0Z = parcelRequire("hPw0Z");

var $elP3b = parcelRequire("elP3b");
const $58d70b9f73c36b6a$var$onDefaultValueChange = (field, onUpdate)=>(e)=>onUpdate({
            ...field,
            defaultValue: !e.target.checked ? // We need to do this to correctly indicate empty state, another solution is polluting field logic
            null : {
                useCurrentTime: e.target.checked
            }
        });
const $58d70b9f73c36b6a$var$refineDefaultValue = (defaultValue)=>defaultValue && typeof defaultValue === 'object' && 'useCurrentTime' in defaultValue && typeof defaultValue.useCurrentTime === 'boolean' ? defaultValue.useCurrentTime : false;
const $58d70b9f73c36b6a$export$67ef7508ff63547d = ({ field: field, onUpdate: onUpdate, tooltipDelay: tooltipDelay })=>{
    const intl = (0, $koVbs.default)();
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const useCurrentTime = $58d70b9f73c36b6a$var$refineDefaultValue(field.defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.CheckboxFieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isModifyDefaultValueDisabled ? intl.formatMessage((0, $elP3b.default).datetimeDefaultValueDisabledTooltip) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: useCurrentTime,
        isDisabled: isModifyDefaultValueDisabled,
        label: intl.formatMessage((0, $elP3b.default).datetimeDefaultValueLabel),
        onChange: $58d70b9f73c36b6a$var$onDefaultValueChange(field, onUpdate)
    })));
};

});
parcelRegister("elP3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3eec74fa23d2057$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b3eec74fa23d2057$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    datetimeDefaultValueLabel: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.datetime.default-value.datetime-default-value-label",
        "defaultMessage": "Set to current time by default"
    },
    datetimeDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.datetime.default-value.datetime-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default time"
    }
});

});


parcelRegister("c1NYE", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $6e69b7d2e3358d42$export$6e0f0a958dc8ef91);

const $6e69b7d2e3358d42$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});

parcelRegister("kLERN", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $18372e32cfeb71ab$export$6e0f0a958dc8ef91);

const $18372e32cfeb71ab$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyOptions || operations.canModifyDefaultValue;

});

parcelRegister("hlPgl", function(module, exports) {

$parcel$export(module.exports, "DropdownFieldConfiguration", () => $c6d1fee272c16b10$export$e112f403b4c2bc0c);

var $5uXOq = parcelRequire("5uXOq");

var $7ynmL = parcelRequire("7ynmL");

var $8G7jD = parcelRequire("8G7jD");

var $2JP50 = parcelRequire("2JP50");

var $2XK1w = parcelRequire("2XK1w");
const $c6d1fee272c16b10$var$onFieldUpdate = (onUpdate)=>(field)=>{
        const { defaultValue: defaultValue, options: options } = field;
        if (options == null) return onUpdate(field);
        const refined = (0, $8G7jD.refineDefaultValue)(defaultValue);
        if (refined.length === 0) return onUpdate(field);
        return onUpdate({
            ...field,
            defaultValue: options.find((0, $8G7jD.isDefaultOption)(refined))
        });
    };
const $c6d1fee272c16b10$export$e112f403b4c2bc0c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ynmL.FieldOptions), {
        ...props,
        label: (0, $2XK1w.default).optionsLabel,
        onUpdate: $c6d1fee272c16b10$var$onFieldUpdate(props.onUpdate),
        DefaultValueControlRight: (0, $2JP50.DefaultValueControlRight)
    });

});
parcelRegister("2JP50", function(module, exports) {

$parcel$export(module.exports, "DefaultValueControlRight", () => $1b329729e590366f$export$b33f97c2d49b270a);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $1oOvL = parcelRequire("1oOvL");

var $aY1kr = parcelRequire("aY1kr");
const $1b329729e590366f$var$onDefaultValueChange = (field, onFieldUpdated, defaultValue)=>()=>{
        onFieldUpdated({
            ...field,
            defaultValue: defaultValue
        });
    };
const $1b329729e590366f$export$b33f97c2d49b270a = ({ field: field, option: option, isSelected: isSelected, isOptionHovered: isOptionHovered, isOptionFocused: isOptionFocused, onFieldUpdated: onFieldUpdated, tooltipDelay: tooltipDelay, testId: testId })=>{
    const interactingWithOption = isOptionHovered || isOptionFocused;
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const intl = (0, $koVbs.default)(); // If isModifyDefaultValueDisabled is true then we never show the button to change default value. Otherwise we
    // show the button in a hidden state, and make it visible when the option is hovered or focused.
    const changeDefaultValueFragment = isModifyDefaultValueDisabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1b329729e590366f$var$Wrapper, {
        isActive: interactingWithOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        isDisabled: isModifyDefaultValueDisabled,
        onClick: $1b329729e590366f$var$onDefaultValueChange(field, onFieldUpdated, isSelected ? undefined : option)
    }, intl.formatMessage(isSelected ? (0, $aY1kr.default).clearDefault : (0, $aY1kr.default).setAsDefault))); // We only show the label if the option is selected AND the change default value button is not visible.
    const defaultLabelFragment = !isSelected || !isModifyDefaultValueDisabled && interactingWithOption ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isModifyDefaultValueDisabled ? intl.formatMessage((0, $aY1kr.default).disabledDefaultTooltip) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oOvL.DefaultValueLabel), {
        isDisabled: isModifyDefaultValueDisabled,
        "data-testid": testId
    }, intl.formatMessage((0, $aY1kr.default).default)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, changeDefaultValueFragment, defaultLabelFragment);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b329729e590366f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1i5z15vq _f7sg15vq _qhhk1cib _v3my1wug",
            __cmplp.isActive ? "_1nq3pfqs" : "_1nq3stnw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aY1kr", function(module, exports) {

$parcel$export(module.exports, "default", () => $381d0861e2165258$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $381d0861e2165258$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    default: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.dropdown.default-value.default",
        "defaultMessage": "Default"
    },
    disabledDefaultTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.dropdown.default-value.disabled-default-tooltip",
        "defaultMessage": "You can\u2019t clear the default option"
    },
    setAsDefault: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.dropdown.default-value.set-as-default",
        "defaultMessage": "Set as default"
    },
    clearDefault: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.dropdown.default-value.clear-default",
        "defaultMessage": "Clear default"
    }
});

});


parcelRegister("2XK1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $99281dd53a63d2cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $99281dd53a63d2cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    optionsLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.dropdown.options-label",
        "defaultMessage": "Options"
    }
});

});


parcelRegister("jzVPY", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $a714be01f9211851$export$6e0f0a958dc8ef91);

const $a714be01f9211851$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});

parcelRegister("b0eNp", function(module, exports) {

$parcel$export(module.exports, "SingleGroupFieldConfiguration", () => $02ee1cd7771b0bd5$export$bdfe8ecf24145f5d);
$parcel$export(module.exports, "MultiGroupFieldConfiguration", () => $02ee1cd7771b0bd5$export$e5e537a9170228ed);

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $arYvt = parcelRequire("arYvt");

var $5fnvk = parcelRequire("5fnvk");

var $dlgLJ = parcelRequire("dlgLJ");

var $hPw0Z = parcelRequire("hPw0Z");

var $eax6A = parcelRequire("eax6A");
const $02ee1cd7771b0bd5$export$2538345533ff0a1a = (field, onUpdate)=>(updatedValue)=>{
        if (Array.isArray(updatedValue)) {
            const groups = updatedValue.map((0, $arYvt.transformUserPickerOptionToGroup));
            return onUpdate({
                ...field,
                defaultValue: groups.length === 0 ? null : groups
            });
        }
        return onUpdate({
            ...field,
            defaultValue: updatedValue ? [
                (0, $arYvt.transformUserPickerOptionToGroup)(updatedValue)
            ] : null
        });
    };
const $02ee1cd7771b0bd5$var$toGroup = (defaultValue)=>{
    if (defaultValue === null || typeof defaultValue !== 'object' || !('groupId' in defaultValue) || typeof defaultValue.groupId !== 'string' || !('name' in defaultValue) || typeof defaultValue.name !== 'string') return null;
    return {
        groupId: defaultValue.groupId,
        name: defaultValue.name,
        type: 'group'
    };
};
const $02ee1cd7771b0bd5$var$refineDefaultValue = (defaultValue)=>Array.isArray(defaultValue) ? defaultValue.map($02ee1cd7771b0bd5$var$toGroup).filter(Boolean).map((0, $arYvt.transformGroupToUserOption)) : [];
const $02ee1cd7771b0bd5$var$GroupFieldConfiguration = ({ field: field, onUpdate: onUpdate, isMulti: isMulti, tooltipDelay: tooltipDelay, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const multiGroupDefaultValueLabel = (0, $eax6A.default).multiGroupDefaultValueLabelNew;
    const groupDefaultValueLabel = (0, $eax6A.default).groupDefaultValueLabelNew;
    const defaultLabel = isMulti === true ? multiGroupDefaultValueLabel : groupDefaultValueLabel;
    const placeholder = isMulti === true ? (0, $eax6A.default).multiGroupPlaceholder : (0, $eax6A.default).groupPlaceholder;
    const disabledTooltipMessage = isMulti === true ? (0, $eax6A.default).multiGroupDefaultValueDisabledTooltip : (0, $eax6A.default).groupDefaultValueDisabledTooltip;
    const defaultValue = $02ee1cd7771b0bd5$var$refineDefaultValue(field.defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: `${field.key}-default-value`,
        label: formatMessage(defaultLabel)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isModifyDefaultValueDisabled ? formatMessage(disabledTooltipMessage) : null,
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlgLJ.default), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fnvk.default), {
            autoCompleteUrl: "/rest/api/3/groups/picker?query=",
            // fieldId is optional and used by the underlying UserPicker component in analytics
            // attributes and as a key in SSR. The "field" here means an input element (as in
            // textfield/field in a form). It can be any unique string we want, however we
            // are choosing not to provide it here in case "field" is mistaken as a Jira field
            // at some point in the future (since there may not be a field ID yet for new fields)
            fieldId: null,
            width: "100%",
            isMulti: isMulti,
            isDisabled: isModifyDefaultValueDisabled,
            placeholder: formatMessage(placeholder),
            value: defaultValue,
            onChange: $02ee1cd7771b0bd5$export$2538345533ff0a1a(field, onUpdate)
        }))))));
};
const $02ee1cd7771b0bd5$export$bdfe8ecf24145f5d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02ee1cd7771b0bd5$var$GroupFieldConfiguration, {
        ...props,
        isMulti: false
    });
const $02ee1cd7771b0bd5$export$e5e537a9170228ed = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02ee1cd7771b0bd5$var$GroupFieldConfiguration, {
        ...props,
        isMulti: true
    });

});
parcelRegister("arYvt", function(module, exports) {

$parcel$export(module.exports, "transformGroupToUserOption", () => $70d728bf86d0ecee$export$f9f97cb0418e400f);
$parcel$export(module.exports, "transformUserPickerOptionToGroup", () => $70d728bf86d0ecee$export$7727449e04185a4c);
$parcel$export(module.exports, "transformGroupToName", () => $70d728bf86d0ecee$export$c76efe48b8ca8203);
$parcel$export(module.exports, "transformGroupsToNames", () => $70d728bf86d0ecee$export$285022bf9288513e);
$parcel$export(module.exports, "appendTypePropertyToGroupOptions", () => $70d728bf86d0ecee$export$705009f1a414da46);
const $70d728bf86d0ecee$export$f9f97cb0418e400f = (group)=>({
        id: group.name,
        name: group.name,
        type: 'group'
    });
const $70d728bf86d0ecee$export$7727449e04185a4c = (userOption)=>({
        groupId: userOption.id,
        name: userOption.name,
        type: 'group'
    });
const $70d728bf86d0ecee$export$c76efe48b8ca8203 = (group)=>({
        name: group.name
    });
const $70d728bf86d0ecee$export$285022bf9288513e = (groups)=>groups.map((group)=>$70d728bf86d0ecee$export$c76efe48b8ca8203(group));
const $70d728bf86d0ecee$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
            ...group,
            type: 'group'
        }));

});

parcelRegister("5fnvk", function(module, exports) {

$parcel$export(module.exports, "default", () => $81263082e0845513$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $cr0SA = parcelRequire("cr0SA");

var $koVbs = parcelRequire("koVbs");

var $arYvt = parcelRequire("arYvt");

var $hSBXu = parcelRequire("hSBXu");

var $lGKF5 = parcelRequire("lGKF5");

var $3PgDR = parcelRequire("3PgDR");
const $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $81263082e0845513$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: // @ts-expect-error - TS2339 - Property 'searchDebounceTimeout' does not exist on type 'Props'.
searchDebounceTimeout = $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const previousQuery = (0, $5uXOq.useRef)('');
    const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, $hSBXu.default)(autoCompleteUrl || '');
    const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(false);
    const getUserPickerControlStyle = (0, $5uXOq.useCallback)((styles)=>{
        if (isInvalid === true) return {
            ...styles,
            ...(0, $3PgDR.invalidStateStyle)
        };
        return styles;
    }, [
        isInvalid
    ]);
    const handleSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            setIsDropdownVisible(!!query);
            // if query has changed, get groups
            if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
            previousQuery.current = query || '';
        }, searchDebounceTimeout), [
        fetchGroups,
        previousQuery,
        searchDebounceTimeout
    ]);
    const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsDropdownVisible(true);
        onFocus?.(sessionId);
        if (!groups || !groups.length) fetchGroups();
    }, [
        fetchGroups,
        groups,
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsDropdownVisible(false);
        onBlur?.(sessionId);
        previousQuery.current = '';
    }, [
        onBlur,
        previousQuery
    ]);
    const handleOnChange = (updatedValue)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(updatedValue);
    };
    const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, $arYvt.transformGroupToUserOption)(group));
    const onClear = ()=>{
        onChange(null);
    };
    const closeMenuOnScroll = (e)=>{
        if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const getIsClearable = ()=>isClearable ? Boolean(value) : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        ariaLabelledBy: fieldProps['aria-labelledby'],
        fieldId: fieldId,
        width: width,
        autoFocus: autoFocus,
        isLoading: loading,
        options: getOptions(),
        value: value,
        onFocus: handleOnFocus,
        onClear: onClear,
        isMulti: isMulti,
        isDisabled: isDisabled,
        isClearable: getIsClearable(),
        onBlur: handleOnBlur,
        onInputChange: handleSearch,
        onChange: handleOnChange,
        placeholder: placeholder,
        addMoreMessage: formatMessage((0, $lGKF5.default).addMoreGroupsPrompt),
        UNSAFE_hasDraggableParentComponent: true,
        closeMenuOnScroll: closeMenuOnScroll,
        open: isDropdownVisible,
        menuPosition: menuPosition,
        styles: {
            control: getUserPickerControlStyle,
            ...groupPickerStyles
        }
    });
};
var $81263082e0845513$export$2e2bcd8739ae039 = $81263082e0845513$var$GroupPicker;

});
parcelRegister("cr0SA", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $ee13645786fb45b4$export$83e0c73b09b3a9cd);

var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $jZA09 = parcelRequire("jZA09");

var $5uXOq = parcelRequire("5uXOq");

var $d3gzD = parcelRequire("d3gzD");

var $2wgOn = parcelRequire("2wgOn");

var $dyegP = parcelRequire("dyegP");

var $fuG1P = parcelRequire("fuG1P");

var $hcX3V = parcelRequire("hcX3V");

var $hrO1B = parcelRequire("hrO1B");

var $2vFqP = parcelRequire("2vFqP");

var $pk97C = parcelRequire("pk97C");

var $7Jxgt = parcelRequire("7Jxgt");

var $VSDnB = parcelRequire("VSDnB");
class $ee13645786fb45b4$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $7Jxgt.v4)();
        const experienceForId = (0, $pk97C.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
            (0, $jZA09.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $pk97C.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
            (0, $jZA09.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false, showClearIndicator: showClearIndicator = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $iOwNT.default) : (0, $7K5PP.default);
        const creatableProps = suggestEmailsForDomain ? (0, $hcX3V.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $fuG1P.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $pk97C.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrO1B.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vFqP.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3gzD.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $2wgOn.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                        (0, $VSDnB.fg)('platform-component-visual-refresh') && (0, $VSDnB.fg)('visual-refresh-user-picker')),
                        components: (0, $dyegP.getComponents)(isMulti, anchor, showClearIndicator && (0, $VSDnB.fg)('user-picker-show-clear-indicator')),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $ee13645786fb45b4$export$83e0c73b09b3a9cd = (0, $cb25w.default)()($ee13645786fb45b4$export$164f4d95e5d7e2f5);

});
parcelRegister("iOwNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $59b6485f0cb008dd$export$2e2bcd8739ae039);

var $9OU1i = parcelRequire("9OU1i");

var $3c98u = parcelRequire("3c98u");
const $59b6485f0cb008dd$var$CreatableSelect = (0, $3c98u.default)((0, $9OU1i.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;

});
parcelRegister("9OU1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29f1caecd9c7d5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("2HH7Y")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $b29f1caecd9c7d5a$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $9uJ4X.default)(props);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;

});
parcelRegister("2HH7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $994aeb783b6f955a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eEtcC = parcelRequire("eEtcC");

var $gyjU7 = parcelRequire("gyjU7");
const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $994aeb783b6f955a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $eEtcC.getOptionValue), getOptionLabel: getOptionLabel = (0, $eEtcC.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $gyjU7.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gyjU7.valueTernary)(isMulti, [
                    ...(0, $gyjU7.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("d3gzD", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $d045e9522a427a64$export$b4ff48c8d43b18c3);

var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $jZA09 = parcelRequire("jZA09");

var $lFKmC = parcelRequire("lFKmC");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $7Jxgt = parcelRequire("7Jxgt");

var $fUmMr = parcelRequire("fUmMr");

var $78Gdn = parcelRequire("78Gdn");

var $8fG8p = parcelRequire("8fG8p");

var $3smIt = parcelRequire("3smIt");

var $pk97C = parcelRequire("pk97C");
const $d045e9522a427a64$var$loadingMessage = ()=>null;
const $d045e9522a427a64$var$classNamePrefix = 'fabric-user-picker';
class $d045e9522a427a64$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $8fG8p.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $3smIt.optionToSelectableOptions)(nextProps.value);
        else if ((0, $3smIt.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $3smIt.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $3smIt.callCallback)(onChange, (0, $3smIt.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $3smIt.callCallback)(onSelection, (0, $3smIt.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $fUmMr.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $fUmMr.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $3smIt.callCallback)(onClear);
                    this.fireEvent((0, $fUmMr.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $fUmMr.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $fUmMr.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $78Gdn.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $fUmMr.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $3smIt.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $jZA09.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $3smIt.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $3smIt.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $3smIt.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $3smIt.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $3smIt.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $3smIt.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $3smIt.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $3smIt.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $fUmMr.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $fUmMr.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $fUmMr.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $3smIt.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return filteredOptions.slice(0, maxOptions);
            }
            return options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $pk97C.userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $fUmMr.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $fUmMr.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $jZA09.UFOExperienceState).STARTED.id,
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": (0, $VSDnB.fg)('pass-aria-describedby-to-baseuserpicker') ? ariaDescribedBy : undefined,
            "aria-label": ariaLabel,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $d045e9522a427a64$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).placeholder
            }),
            addMoreMessage: addMoreMessage,
            classNamePrefix: $d045e9522a427a64$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $d045e9522a427a64$export$d099ade7b4f4d2a4 = (0, $cb25w.default)()($d045e9522a427a64$export$b4ff48c8d43b18c3);

});
parcelRegister("fUmMr", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $e345c0b18a65d683$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $e345c0b18a65d683$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $e345c0b18a65d683$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $e345c0b18a65d683$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $e345c0b18a65d683$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $e345c0b18a65d683$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $e345c0b18a65d683$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $e345c0b18a65d683$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $e345c0b18a65d683$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $e345c0b18a65d683$export$f541f04954b0c11e);

var $gB4mS = parcelRequire("gB4mS");

var $7Jxgt = parcelRequire("7Jxgt");

var $3smIt = parcelRequire("3smIt");
const $e345c0b18a65d683$var$packageName = "platform-pkg";
const $e345c0b18a65d683$var$packageVersion = "0.0.0-use.local";
const $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $e345c0b18a65d683$export$c0d84948cecf78d8 = ()=>({
        id: (0, $7Jxgt.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $e345c0b18a65d683$export$53eef0dcd9611650 = (0, $gB4mS.default)('fabric-elements');
const $e345c0b18a65d683$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $e345c0b18a65d683$var$packageName,
            packageVersion: $e345c0b18a65d683$var$packageVersion,
            ...attributes
        }
    });
const $e345c0b18a65d683$var$checkValidId = (id)=>{
    return $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $e345c0b18a65d683$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $e345c0b18a65d683$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $3smIt.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $3smIt.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $e345c0b18a65d683$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$e345c0b18a65d683$var$optionData2Analytics(data));
    }
    return [];
};
const $e345c0b18a65d683$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $e345c0b18a65d683$var$sessionId(session),
        pickerType: $e345c0b18a65d683$var$pickerType(props),
        journeyId: journeyId
    });
const $e345c0b18a65d683$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'focused', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $e345c0b18a65d683$var$buildValueForAnalytics(state.value)
    });
const $e345c0b18a65d683$export$7b5800e732182efb = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $e345c0b18a65d683$var$values(state)
    });
const $e345c0b18a65d683$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $e345c0b18a65d683$var$sessionId(session),
        journeyId: journeyId,
        value: $e345c0b18a65d683$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $e345c0b18a65d683$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        queryLength: $e345c0b18a65d683$var$queryLength(args[0]),
        spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(args[0]),
        upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
        downKeyCount: $e345c0b18a65d683$var$downKeyCount(session)
    });
const $e345c0b18a65d683$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $e345c0b18a65d683$var$createEvent('ui', $e345c0b18a65d683$var$selectEventType(session), 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        position: $e345c0b18a65d683$var$position(state, args[0]),
        queryLength: $e345c0b18a65d683$var$queryLength(state),
        spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(state),
        upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
        downKeyCount: $e345c0b18a65d683$var$downKeyCount(session),
        result: $e345c0b18a65d683$var$result(args[0]),
        numberOfResults: $e345c0b18a65d683$var$numberOfResults(state)
    });
};
const $e345c0b18a65d683$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $e345c0b18a65d683$var$results(state);
    return $e345c0b18a65d683$var$createEvent('operational', 'searched', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        durationSinceInputChange: $e345c0b18a65d683$var$durationSinceInputChange(session),
        queryLength: $e345c0b18a65d683$var$queryLength(state),
        isLoading: $e345c0b18a65d683$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $e345c0b18a65d683$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$e345c0b18a65d683$var$createEvent('operational', 'failed', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $e345c0b18a65d683$export$f541f04954b0c11e = (sources, accountId)=>$e345c0b18a65d683$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $e345c0b18a65d683$var$checkValidId(accountId) ? accountId : null
    });
function $e345c0b18a65d683$var$queryLength(state) {
    return state.inputValue.length;
}
function $e345c0b18a65d683$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $e345c0b18a65d683$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $e345c0b18a65d683$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $e345c0b18a65d683$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $e345c0b18a65d683$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $e345c0b18a65d683$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $e345c0b18a65d683$var$sessionId(session) {
    return session && session.id;
}
function $e345c0b18a65d683$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $e345c0b18a65d683$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $e345c0b18a65d683$var$result(option) {
    return option ? $e345c0b18a65d683$var$optionData2Analytics(option.data) : null;
}
function $e345c0b18a65d683$var$results(state) {
    return (state.options || []).map($e345c0b18a65d683$var$optionData2Analytics);
}
function $e345c0b18a65d683$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $e345c0b18a65d683$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$e345c0b18a65d683$var$optionData2Analytics(option.data)) : [
        $e345c0b18a65d683$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $e345c0b18a65d683$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("3smIt", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $02015d62698c11ec$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $02015d62698c11ec$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $02015d62698c11ec$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $02015d62698c11ec$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $02015d62698c11ec$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $02015d62698c11ec$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $02015d62698c11ec$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $02015d62698c11ec$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $02015d62698c11ec$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $02015d62698c11ec$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $02015d62698c11ec$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $02015d62698c11ec$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $02015d62698c11ec$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $02015d62698c11ec$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $02015d62698c11ec$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $02015d62698c11ec$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $02015d62698c11ec$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $02015d62698c11ec$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $02015d62698c11ec$export$5419897287f5f1c7);

var $8QpSo = parcelRequire("8QpSo");


var $b9dFI = parcelRequire("b9dFI");
const $02015d62698c11ec$export$f6058dbcb5980cb = (option)=>option.type === (0, $f93312f7d4958f08$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $02015d62698c11ec$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f93312f7d4958f08$export$8436e53e45ffe15b);
const $02015d62698c11ec$export$f8c4277cb588611f = (option)=>option.type === (0, $f93312f7d4958f08$export$26bc40b960693765);
const $02015d62698c11ec$export$d7976824e9f55785 = (option)=>option.type === (0, $f93312f7d4958f08$export$d460f747b73abb10);
const $02015d62698c11ec$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f93312f7d4958f08$export$6662b3461398ef8c);
const $02015d62698c11ec$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f93312f7d4958f08$export$eafd0979afa5b224);
const $02015d62698c11ec$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $02015d62698c11ec$var$isOptionData = (option)=>option.name !== undefined;
const $02015d62698c11ec$export$3f993c492bd6c728 = (option)=>{
    if ($02015d62698c11ec$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $02015d62698c11ec$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $02015d62698c11ec$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $02015d62698c11ec$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((options)=>options.map($02015d62698c11ec$export$3f993c492bd6c728));
const $02015d62698c11ec$export$e6fda14a194bcbcc = (0, $8QpSo.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($02015d62698c11ec$export$3f993c492bd6c728);
    return $02015d62698c11ec$export$3f993c492bd6c728(defaultValue);
});
const $02015d62698c11ec$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $02015d62698c11ec$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $02015d62698c11ec$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $02015d62698c11ec$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $02015d62698c11ec$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $02015d62698c11ec$export$b4f8f1f54acec99b = (optionData)=>{
    if ($02015d62698c11ec$export$2e44165f1da65304(optionData) || $02015d62698c11ec$export$f8c4277cb588611f(optionData) || $02015d62698c11ec$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $02015d62698c11ec$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $b9dFI.default);
const $02015d62698c11ec$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $02015d62698c11ec$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';



parcelRegister("78Gdn", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $2e9cc1cdc768945e$export$da86c38211c1c0a8);
function $2e9cc1cdc768945e$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("8fG8p", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7b21650c04984462$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7b21650c04984462$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("pk97C", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $06ebadcdd7d5e231$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $06ebadcdd7d5e231$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $06ebadcdd7d5e231$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
var $jZA09 = parcelRequire("jZA09");
const $06ebadcdd7d5e231$export$b49757166e1acfc2 = new (0, $cBycP.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
});
const $06ebadcdd7d5e231$export$135a264e0da507ae = new (0, $cBycP.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $7Zbvr.ExperienceTypes).Operation,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
});
class $06ebadcdd7d5e231$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        const instance = $06ebadcdd7d5e231$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $jZA09.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("cBycP", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);

var $dCAsn = parcelRequire("dCAsn");

var $boHLC = parcelRequire("boHLC");
class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $boHLC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dCAsn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});



parcelRegister("2wgOn", function(module, exports) {

$parcel$export(module.exports, "BORDER_PADDING", () => $01bdbab7be42e070$export$59c188914e58c94b);
$parcel$export(module.exports, "getStyles", () => $01bdbab7be42e070$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $01bdbab7be42e070$export$4e983f376ad8a3af);


var $8QpSo = parcelRequire("8QpSo");

var $7VXAu = parcelRequire("7VXAu");
const $01bdbab7be42e070$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $01bdbab7be42e070$export$53937c04f7dfc2ae = 6;
const $01bdbab7be42e070$export$2c62ba763e976c54 = 39;
const $01bdbab7be42e070$export$ffd58b7f6f099a57 = (0, $8QpSo.default)((width, isMulti, isCompact, overrideStyles, isInvalid, isVisualRefresh, isPopupStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $829f609a65d26a98$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                paddingLeft: isMulti ? $01bdbab7be42e070$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$01bdbab7be42e070$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $7VXAu.mergeStyles)(styles, overrideStyles) : styles;
});
const $01bdbab7be42e070$export$4e983f376ad8a3af = (0, $8QpSo.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$01bdbab7be42e070$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, false, isVisualRefresh, true)
    }));

});

parcelRegister("dyegP", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $27e51ea041192381$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $27e51ea041192381$export$19205fd341a6bb08);

var $8QpSo = parcelRequire("8QpSo");

var $dqbw8 = parcelRequire("dqbw8");

var $8Y8Qe = parcelRequire("8Y8Qe");

var $fIpmY = parcelRequire("fIpmY");

var $3QONt = parcelRequire("3QONt");

var $6Kkci = parcelRequire("6Kkci");

var $OxpB4 = parcelRequire("OxpB4");

var $ee8bl = parcelRequire("ee8bl");

var $h3ej5 = parcelRequire("h3ej5");

var $6Ks8i = parcelRequire("6Ks8i");

var $lYehz = parcelRequire("lYehz");
const $27e51ea041192381$export$4e811121b221213b = (0, $8QpSo.default)((multi, anchor, showClearIndicator)=>{
    if (anchor) return {
        Control: anchor,
        Option: $3QONt.Option
    };
    else return {
        MultiValue: $8Y8Qe.MultiValue,
        DropdownIndicator: null,
        SingleValue: $6Kkci.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $dqbw8.ClearIndicator) : null,
        Option: $3QONt.Option,
        ValueContainer: multi ? (0, $fIpmY.MultiValueContainer) : (0, $ee8bl.SingleValueContainer),
        Input: $OxpB4.Input,
        Menu: $lYehz.Menu
    };
});
const $27e51ea041192381$export$19205fd341a6bb08 = (0, $8QpSo.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $6Kkci.SingleValue,
        ClearIndicator: $dqbw8.ClearIndicator,
        Option: $3QONt.Option,
        ValueContainer: (0, $ee8bl.SingleValueContainer),
        Input: (0, $h3ej5.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $6Ks8i.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("dqbw8", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $11bf495008933d24$export$ecf9cf59142dd54a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

const $11bf495008933d24$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7elIv")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $11bf495008933d24$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            }
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($11bf495008933d24$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("7elIv", function(module, exports) {

let $543aafb7cb171c62$var$load = (parcelRequire("28QjX"))(4);
module.exports = $543aafb7cb171c62$var$load("lOT8O").then(()=>parcelRequire('8hfZh'));

});


parcelRegister("8Y8Qe", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $65368b71d1856c3a$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dW8NE = parcelRequire("dW8NE");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $4hqZ5 = parcelRequire("4hqZ5");

var $fuhQD = parcelRequire("fuhQD");

var $VSDnB = parcelRequire("VSDnB");
function $65368b71d1856c3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65368b71d1856c3a$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $65368b71d1856c3a$var$groupTagContainer = (0, $8CUq3.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $65368b71d1856c3a$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $65368b71d1856c3a$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $3smIt.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dW8NE.AddOptionAvatar), {
                isLozenge: true
            });
            if ((0, $3smIt.isGroup)(data)) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $65368b71d1856c3a$var$groupTagContainer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: "multi",
                src: (0, $3smIt.getAvatarUrl)(data),
                type: (0, $3smIt.isTeam)(data) && (0, $VSDnB.fg)('verified-team-in-user-picker') ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $3smIt.isTeam)(data) && data.verified && (0, $VSDnB.fg)('verified-team-in-user-picker')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fuhQD.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $65368b71d1856c3a$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $65368b71d1856c3a$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("dW8NE", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $f3236d5a67f7ff1f$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $aVnO1 = parcelRequire("aVnO1");


var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("5uXOq");
const $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $f3236d5a67f7ff1f$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aVnO1))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    })));
};

});

parcelRegister("5pJx4", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $50cd04ab4dcbd6e5$export$44d81a88129649da);

var $2OMIu = parcelRequire("2OMIu");

var $ujWmd = parcelRequire("ujWmd");

var $fwSAz = parcelRequire("fwSAz");

var $5uXOq = parcelRequire("5uXOq");

var $3smIt = parcelRequire("3smIt");
class $50cd04ab4dcbd6e5$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $3smIt.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            ...props
        });
    }
}

});

parcelRegister("fuhQD", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $a137cc376204c926$export$d7949f68d31e5edd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gqGjQ = parcelRequire("gqGjQ");

var $fGmbh = parcelRequire("fGmbh");

var $3bDjY = parcelRequire("3bDjY");

var $27dJz = parcelRequire("27dJz");
const $a137cc376204c926$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $27dJz.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "aria-hidden": "true",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $fGmbh.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $fGmbh.default)
    });
};

});
parcelRegister("gqGjQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08303db08bddd05336395b40b61b967a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf5fe6b7538334be$var$_react = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bf5fe6b7538334be$var$_baseNew = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bf5fe6b7538334be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf5fe6b7538334be$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $bf5fe6b7538334be$var$_react.default.createElement($bf5fe6b7538334be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.225.95c-.697.54-.87 1.52-.4 2.266l.827 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$bf5fe6b7538334be$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $bf5fe6b7538334be$var$_default = module.exports.default = $bf5fe6b7538334be$var$StatusVerifiedIcon;

});

parcelRegister("fGmbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bd2ad2ea16bb95$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
    });
var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;

});

parcelRegister("27dJz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $952fb45ddff9712a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $952fb45ddff9712a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("fIpmY", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $0a44bca42d442dd9$export$cf9cf2a30a59265c);

var $2OMIu = parcelRequire("2OMIu");

var $bChGW = parcelRequire("bChGW");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $ousew = parcelRequire("ousew");

var $8fG8p = parcelRequire("8fG8p");

var $3smIt = parcelRequire("3smIt");

var $jNYXM = parcelRequire("jNYXM");
class $0a44bca42d442dd9$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, $3smIt.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNYXM.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ValueContainer, {
                ...props,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("jNYXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4661c12157fe2c0e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $4661c12157fe2c0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $4661c12157fe2c0e$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $4661c12157fe2c0e$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $4661c12157fe2c0e$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $4661c12157fe2c0e$export$2e2bcd8739ae039 = $4661c12157fe2c0e$var$ValueContainerWrapper;

});


parcelRegister("3QONt", function(module, exports) {

$parcel$export(module.exports, "Option", () => $99bbff5d4b124ec0$export$36d18380658d5d20);

var $2OMIu = parcelRequire("2OMIu");

var $dC5iT = parcelRequire("dC5iT");

var $bChGW = parcelRequire("bChGW");

var $3bDjY = parcelRequire("3bDjY");

var $5uXOq = parcelRequire("5uXOq");

var $7SChb = parcelRequire("7SChb");

var $IMPHa = parcelRequire("IMPHa");

var $8QliZ = parcelRequire("8QliZ");

var $jC9IK = parcelRequire("jC9IK");

var $3SqqV = parcelRequire("3SqqV");

var $f4ndh = parcelRequire("f4ndh");

var $3smIt = parcelRequire("3smIt");

var $M0UM1 = parcelRequire("M0UM1");
const $99bbff5d4b124ec0$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SChb.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $99bbff5d4b124ec0$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $3smIt.isExternalUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IMPHa.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $3smIt.isUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SChb.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $3smIt.isEmail)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SqqV.default), {
        email: data,
        emailValidity: (0, $M0UM1.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $3smIt.isTeam)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8QliZ.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $3smIt.isGroup)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jC9IK.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $3smIt.isCustom)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4ndh.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $99bbff5d4b124ec0$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                ...tooltipProps,
                children: $99bbff5d4b124ec0$var$dataOption(props)
            })
    });
    return $99bbff5d4b124ec0$var$dataOption(props);
};
const $99bbff5d4b124ec0$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $99bbff5d4b124ec0$var$defaultOption(props),
            children: $99bbff5d4b124ec0$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("7SChb", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $f97ab606ddc0972b$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $bfXHv = parcelRequire("bfXHv");

var $1Y8bw = parcelRequire("1Y8bw");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $VSDnB = parcelRequire("VSDnB");
class $f97ab606ddc0972b$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bfXHv.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1Y8bw.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $3smIt.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1Y8bw.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-component-visual-refresh') && (0, $VSDnB.fg)('visual-refresh-user-picker') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("bfXHv", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $9d51fec62de0f8e9$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $9d51fec62de0f8e9$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3u0c5 = parcelRequire("3u0c5");

var $3smIt = parcelRequire("3smIt");
function $9d51fec62de0f8e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $9d51fec62de0f8e9$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7elIv")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $9d51fec62de0f8e9$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $9d51fec62de0f8e9$var$optionWrapper = {
    name: "yyrqoa",
    styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $9d51fec62de0f8e9$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $9d51fec62de0f8e9$var$additionalInfo = {
    name: "tjo4qw",
    styles: "float:right"
};
const $9d51fec62de0f8e9$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $9d51fec62de0f8e9$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $3smIt.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3u0c5.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9d51fec62de0f8e9$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3u0c5.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3u0c5.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $9d51fec62de0f8e9$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$optionWrapper
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("1Y8bw", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("IMPHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $244ad38dc6a6e0e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $244ad38dc6a6e0e3$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("c67Gh")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $244ad38dc6a6e0e3$export$2e2bcd8739ae039 = $244ad38dc6a6e0e3$var$AsyncExternalUserOption;

});
parcelRegister("c67Gh", function(module, exports) {

let $8cec00dee12aa67b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8cec00dee12aa67b$var$load("h2MrD"),
    $8cec00dee12aa67b$var$load("bYT2S"),
    $8cec00dee12aa67b$var$load("7GjMk")
]).then(()=>parcelRequire('358Ik'));

});


parcelRegister("8QliZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e55a6473b89765e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $6e55a6473b89765e$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("hjiUy")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $6e55a6473b89765e$export$2e2bcd8739ae039 = $6e55a6473b89765e$var$AsyncTeamOption;

});
parcelRegister("hjiUy", function(module, exports) {

let $c9a2e15b000df154$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c9a2e15b000df154$var$load("bmRp3").then(()=>parcelRequire('8Pt0F'));

});


parcelRegister("jC9IK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d883d47691bcfd0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $d883d47691bcfd0f$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("2iZEv")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $d883d47691bcfd0f$export$2e2bcd8739ae039 = $d883d47691bcfd0f$var$AsyncGroupOption;

});
parcelRegister("2iZEv", function(module, exports) {

let $1add160f190a04b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1add160f190a04b2$var$load("mdJEp").then(()=>parcelRequire('ctysX'));

});


parcelRegister("3SqqV", function(module, exports) {

$parcel$export(module.exports, "default", () => $120c09dc4c3dec5f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $120c09dc4c3dec5f$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("hi3HZ")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $120c09dc4c3dec5f$export$2e2bcd8739ae039 = $120c09dc4c3dec5f$var$AsyncEmailOption;

});
parcelRegister("hi3HZ", function(module, exports) {

let $c966fe843ed40d8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c966fe843ed40d8b$var$load("AE9nS").then(()=>parcelRequire('4CChz'));

});


parcelRegister("f4ndh", function(module, exports) {

$parcel$export(module.exports, "default", () => $57cc7ffb924c0e65$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $57cc7ffb924c0e65$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("3Optk")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $57cc7ffb924c0e65$export$2e2bcd8739ae039 = $57cc7ffb924c0e65$var$AsyncCustomOption;

});
parcelRegister("3Optk", function(module, exports) {

let $2c69ccd9c550a6f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2c69ccd9c550a6f7$var$load("lQtwe").then(()=>parcelRequire('iphiD'));

});


parcelRegister("M0UM1", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $8e40db00ccd032ac$export$371e338370561054);
const $8e40db00ccd032ac$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $8e40db00ccd032ac$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $8e40db00ccd032ac$export$371e338370561054 = (inputText)=>{
    if (inputText.match($8e40db00ccd032ac$var$validRegex)) return 'VALID';
    if (inputText.match($8e40db00ccd032ac$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("6Kkci", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $667e1159563155af$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $fuhQD = parcelRequire("fuhQD");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");
const $667e1159563155af$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $667e1159563155af$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $3smIt.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fuhQD.VerifiedTeamIcon), {});
    return null;
};
const $667e1159563155af$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
            xcss: $667e1159563155af$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5pJx4.SizeableAvatar), {
                    src: (0, $3smIt.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $3smIt.isTeam)(data) && (0, $VSDnB.fg)('verified-team-in-user-picker') ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $667e1159563155af$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $667e1159563155af$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $667e1159563155af$var$styles.avatarItemText,
                            children: (0, $VSDnB.fg)('verified-team-in-user-picker') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)($667e1159563155af$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            }) : label
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("OxpB4", function(module, exports) {

$parcel$export(module.exports, "Input", () => $98c53988263e2c5c$export$f5b8910cec6cf069);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
class $98c53988263e2c5c$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
	 * Overrides the default behaviour of react-select lib
	 *
	 * The getter is a workaround for original behaviour of the react-select lib.
	 * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
	 * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
	 * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
	 */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("ee8bl", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $bd8914f05f01f9cc$export$afa5f855316c6a48);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $5pJx4 = parcelRequire("5pJx4");

var $2wgOn = parcelRequire("2wgOn");

var $jNYXM = parcelRequire("jNYXM");
function $bd8914f05f01f9cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bd8914f05f01f9cc$var$placeholderIconContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $2wgOn.BORDER_PADDING),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    gridArea: '1/1/2/2'
});
const $bd8914f05f01f9cc$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
var $bd8914f05f01f9cc$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
class $bd8914f05f01f9cc$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jNYXM.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).ValueContainer, valueContainerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $bd8914f05f01f9cc$var$placeholderIconContainer
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $bd8914f05f01f9cc$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: $bd8914f05f01f9cc$var$_ref,
                onMouseDown: this.onValueContainerClick
            }, children) : children;
        };
    }
}

});

parcelRegister("h3ej5", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $be92b88945d06137$export$d8edbfd510a7db82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $OxpB4 = parcelRequire("OxpB4");
class $be92b88945d06137$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OxpB4.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("6Ks8i", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");

const $77b9c0d4ebdf44c2$var$controlWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $77b9c0d4ebdf44c2$var$labelStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $77b9c0d4ebdf44c2$var$controlWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $77b9c0d4ebdf44c2$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Control, this.props));
    }
}

});

parcelRegister("lYehz", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $9f291598157d275c$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");
const $9f291598157d275c$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $9f291598157d275c$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $9f291598157d275c$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("fuG1P", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $3865687a924ab788$export$36f97d8afa97203d);

var $8QpSo = parcelRequire("8QpSo");


var $M0UM1 = parcelRequire("M0UM1");

var $3smIt = parcelRequire("3smIt");
const $3865687a924ab788$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $3865687a924ab788$var$isValidNewOption = (isValidEmail = (0, $M0UM1.isValidEmail))=>(inputValue)=>inputValue && $3865687a924ab788$var$validOption.includes(isValidEmail(inputValue));
const $3865687a924ab788$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $f93312f7d4958f08$export$6662b3461398ef8c)
        }
    });
const $3865687a924ab788$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $3865687a924ab788$var$isOptionDisabled = (isValidEmail = (0, $M0UM1.isValidEmail))=>(option)=>{
        if ((0, $3smIt.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $3865687a924ab788$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $3865687a924ab788$var$isValidNewOption(isValidEmail),
        getNewOptionData: $3865687a924ab788$var$getNewOptionData,
        formatCreateLabel: $3865687a924ab788$var$formatCreateLabel,
        isOptionDisabled: $3865687a924ab788$var$isOptionDisabled(isValidEmail)
    };
}
const $3865687a924ab788$export$36f97d8afa97203d = (0, $8QpSo.default)($3865687a924ab788$var$creatableProps);

});

parcelRegister("hcX3V", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $fd587de6edc26aae$export$34b9dd2dd6a225e5);

var $8QpSo = parcelRequire("8QpSo");


var $M0UM1 = parcelRequire("M0UM1");

var $3smIt = parcelRequire("3smIt");
const $fd587de6edc26aae$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $fd587de6edc26aae$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $fd587de6edc26aae$var$getNewOptionData = (isValidEmail = (0, $M0UM1.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $fd587de6edc26aae$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $f93312f7d4958f08$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $fd587de6edc26aae$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $fd587de6edc26aae$var$isOptionDisabled = (isValidEmail = (0, $M0UM1.isValidEmail))=>(option)=>{
        if ((0, $3smIt.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $fd587de6edc26aae$export$34b9dd2dd6a225e5 = (0, $8QpSo.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $fd587de6edc26aae$var$isValidNewOption,
        getNewOptionData: $fd587de6edc26aae$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $fd587de6edc26aae$var$formatCreateLabel,
        isOptionDisabled: $fd587de6edc26aae$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("hrO1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce4a8fbf6631c4e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $55C8M = parcelRequire("55C8M");
const $9ce4a8fbf6631c4e$var$EMPTY = {};
const $9ce4a8fbf6631c4e$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($9ce4a8fbf6631c4e$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($9ce4a8fbf6631c4e$var$EMPTY);
        (0, $55C8M.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $9ce4a8fbf6631c4e$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $koVbs.default)();
    const { children: children } = props;
    const messages = $9ce4a8fbf6631c4e$var$useI18n(intl.locale);
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $9ce4a8fbf6631c4e$export$2e2bcd8739ae039 = $9ce4a8fbf6631c4e$var$MessagesIntlProvider;

});
parcelRegister("55C8M", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $0d1c237fd5360db1$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $0d1c237fd5360db1$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("5gHa5")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("232D6")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("3s3HE")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5FFMI")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("kzjwE")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("1spZB")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("aZwQ4")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("bm7gp")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("avlTx")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("QUFqI")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("fEnD9")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("i2R2c")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("6K931")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("jDtKH")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("2NxMX")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("28SFl")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("eit1B")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("3MLuD")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("eWKdr")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("jFwIQ")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("45ti2")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("2UXKK")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("fPRYC")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("b16Mo")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("lkGaj")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("hGM5P")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("87Yuh")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("k5ygj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("cBeqY")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("3qbxF")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $0d1c237fd5360db1$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5FFMI")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("5gHa5", function(module, exports) {

let $3d5fed694663596d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3d5fed694663596d$var$load("5lpPT").then(()=>parcelRequire('gXZJY'));

});

parcelRegister("232D6", function(module, exports) {

let $17dde6c59379bf82$var$load = (parcelRequire("28QjX"))(4);
module.exports = $17dde6c59379bf82$var$load("kfO0l").then(()=>parcelRequire('4a4Fm'));

});

parcelRegister("3s3HE", function(module, exports) {

let $2836dbf48d6dd32c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2836dbf48d6dd32c$var$load("e7FWi").then(()=>parcelRequire('l8jlf'));

});

parcelRegister("5FFMI", function(module, exports) {

let $421131acf685b465$var$load = (parcelRequire("28QjX"))(4);
module.exports = $421131acf685b465$var$load("auLKS").then(()=>parcelRequire('8JpVG'));

});

parcelRegister("kzjwE", function(module, exports) {

let $ef9638ee0b8db062$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef9638ee0b8db062$var$load("3W1ZK").then(()=>parcelRequire('e3biM'));

});

parcelRegister("1spZB", function(module, exports) {

let $10fc918b33c8642b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10fc918b33c8642b$var$load("Tlspk").then(()=>parcelRequire('dnuc7'));

});

parcelRegister("aZwQ4", function(module, exports) {

let $800912f979636baf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $800912f979636baf$var$load("5X8ey").then(()=>parcelRequire('l3vqz'));

});

parcelRegister("bm7gp", function(module, exports) {

let $8447622df2787a7b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8447622df2787a7b$var$load("bmWXN").then(()=>parcelRequire('4oZES'));

});

parcelRegister("avlTx", function(module, exports) {

let $7a5dc87cc02cfe1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a5dc87cc02cfe1a$var$load("bI4uf").then(()=>parcelRequire('2WBzr'));

});

parcelRegister("QUFqI", function(module, exports) {

let $09f0d05fc002f322$var$load = (parcelRequire("28QjX"))(4);
module.exports = $09f0d05fc002f322$var$load("2H83s").then(()=>parcelRequire('bfZBm'));

});

parcelRegister("fEnD9", function(module, exports) {

let $b64cebfb3920a64e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b64cebfb3920a64e$var$load("lUuxE").then(()=>parcelRequire('1tcJ6'));

});

parcelRegister("i2R2c", function(module, exports) {

let $d2318d772208b23f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d2318d772208b23f$var$load("eN4os").then(()=>parcelRequire('4duqz'));

});

parcelRegister("6K931", function(module, exports) {

let $4e8e0e9ffe7e74d3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e8e0e9ffe7e74d3$var$load("gvuTb").then(()=>parcelRequire('dizwu'));

});

parcelRegister("jDtKH", function(module, exports) {

let $e4b8bd0475b14552$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e4b8bd0475b14552$var$load("2Li3C").then(()=>parcelRequire('9N5CX'));

});

parcelRegister("2NxMX", function(module, exports) {

let $209a5e178ce28904$var$load = (parcelRequire("28QjX"))(4);
module.exports = $209a5e178ce28904$var$load("bh153").then(()=>parcelRequire('aZBlm'));

});

parcelRegister("28SFl", function(module, exports) {

let $18f6bba379cb9421$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18f6bba379cb9421$var$load("gdZbx").then(()=>parcelRequire('fGwOM'));

});

parcelRegister("eit1B", function(module, exports) {

let $a68942e073098a20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a68942e073098a20$var$load("aMnvr").then(()=>parcelRequire('NLRKB'));

});

parcelRegister("3MLuD", function(module, exports) {

let $2c1ab1f1111bad1d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2c1ab1f1111bad1d$var$load("b7E7V").then(()=>parcelRequire('cHWkp'));

});

parcelRegister("eWKdr", function(module, exports) {

let $ae1a54f37bf19f56$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae1a54f37bf19f56$var$load("bCfU6").then(()=>parcelRequire('d6RJ6'));

});

parcelRegister("jFwIQ", function(module, exports) {

let $e51b3a9c06f8041e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e51b3a9c06f8041e$var$load("5b76P").then(()=>parcelRequire('bPIQC'));

});

parcelRegister("45ti2", function(module, exports) {

let $2f9e596f77f13622$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f9e596f77f13622$var$load("4Qca8").then(()=>parcelRequire('foWaf'));

});

parcelRegister("2UXKK", function(module, exports) {

let $21ff2975c3be4bc6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $21ff2975c3be4bc6$var$load("8ExDS").then(()=>parcelRequire('d41ym'));

});

parcelRegister("fPRYC", function(module, exports) {

let $b8757d1153dc9316$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b8757d1153dc9316$var$load("57IRb").then(()=>parcelRequire('77rKe'));

});

parcelRegister("b16Mo", function(module, exports) {

let $80550bf81e9e6910$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80550bf81e9e6910$var$load("6iyhv").then(()=>parcelRequire('lwY85'));

});

parcelRegister("lkGaj", function(module, exports) {

let $f87c2c64defa5267$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f87c2c64defa5267$var$load("6FMDk").then(()=>parcelRequire('j3ZnO'));

});

parcelRegister("hGM5P", function(module, exports) {

let $ce0baa3299850a7b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ce0baa3299850a7b$var$load("6583j").then(()=>parcelRequire('I9Pmk'));

});

parcelRegister("87Yuh", function(module, exports) {

let $5eade5b4e3b97c91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5eade5b4e3b97c91$var$load("hdz1o").then(()=>parcelRequire('h4y14'));

});

parcelRegister("k5ygj", function(module, exports) {

let $e9feda02fe93a3b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e9feda02fe93a3b3$var$load("jefTP").then(()=>parcelRequire('6gWmN'));

});

parcelRegister("cBeqY", function(module, exports) {

let $92c4230e814d3f5a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92c4230e814d3f5a$var$load("j2uQo").then(()=>parcelRequire('haTkv'));

});

parcelRegister("3qbxF", function(module, exports) {

let $27dcc0c907d95fd7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27dcc0c907d95fd7$var$load("afbbf").then(()=>parcelRequire('lbgbB'));

});



parcelRegister("2vFqP", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $4629e0617f660bbc$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $4629e0617f660bbc$export$c6c0c1a2bac363f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $4629e0617f660bbc$var$ExusUserSourceContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $4629e0617f660bbc$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4629e0617f660bbc$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $4629e0617f660bbc$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($4629e0617f660bbc$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const abortController = (0, $5uXOq.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("hSBXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9613200b5cbe8cb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");

var $arYvt = parcelRequire("arYvt");
const $b9613200b5cbe8cb$var$useGroupsQuery = (autoCompleteUrl)=>{
    const [groups, setGroups] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchGroups = (0, $5uXOq.useCallback)(async (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        try {
            const response = await (0, $eusud.performGetRequest)(groupsFetchUrl);
            let groupsWithType = [];
            if (query === currentQuery.current) {
                if (response && response.groups) {
                    groupsWithType = (0, $arYvt.appendTypePropertyToGroupOptions)(response.groups);
                    setGroups(groupsWithType);
                } else setGroups([]);
            }
            return groupsWithType;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (query === currentQuery.current) setError(err);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
            return err;
        } finally{
            setLoading(false);
        }
    }, [
        autoCompleteUrl,
        error
    ]);
    return {
        groups: groups,
        error: error,
        loading: loading,
        fetchGroups: fetchGroups
    };
};
var $b9613200b5cbe8cb$export$2e2bcd8739ae039 = $b9613200b5cbe8cb$var$useGroupsQuery;

});

parcelRegister("lGKF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d585cea41a3a80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82d585cea41a3a80$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addMoreGroupsPrompt: {
        "id": "issue-field-group-picker.edit.add-more-groups-prompt",
        "defaultMessage": "add more groups..."
    }
});

});

parcelRegister("3PgDR", function(module, exports) {

$parcel$export(module.exports, "invalidStateStyle", () => $2e61feb10eb63767$export$f204658c943efb85);
const $2e61feb10eb63767$export$f204658c943efb85 = {
    borderColor: "var(--ds-border-danger, #E2483D)"
};

});


parcelRegister("eax6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b78e8cda305038$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c7b78e8cda305038$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupDefaultValueLabelNew: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.group-picker.group-default-value-label-new",
        "defaultMessage": "Default group"
    },
    multiGroupDefaultValueLabelNew: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.group-picker.multi-group-default-value-label-new",
        "defaultMessage": "Default groups"
    },
    groupPlaceholder: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.group-picker.group-placeholder",
        "defaultMessage": "Choose a group"
    },
    multiGroupPlaceholder: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.group-picker.multi-group-placeholder",
        "defaultMessage": "Choose groups"
    },
    groupDefaultValueDisabledTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.group-picker.group-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default group"
    },
    multiGroupDefaultValueDisabledTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.group-picker.multi-group-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default group"
    }
});

});


parcelRegister("9mOHc", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $dd9a4592c41fa792$export$6e0f0a958dc8ef91);

const $dd9a4592c41fa792$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});

parcelRegister("irjUF", function(module, exports) {

$parcel$export(module.exports, "LabelsFieldConfiguration", () => $f3aca0a9af811539$export$cd14e3d000036cef);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4uKU0 = parcelRequire("4uKU0");

var $dq3xR = parcelRequire("dq3xR");

var $jfx3N = parcelRequire("jfx3N");


var $dlgLJ = parcelRequire("dlgLJ");

var $hPw0Z = parcelRequire("hPw0Z");

var $kVdZa = parcelRequire("kVdZa");
const $f3aca0a9af811539$var$onDefaultValueChange = (field, onUpdate)=>(labels)=>onUpdate({
            ...field,
            defaultValue: labels.length === 0 ? null : labels.join(',')
        });
const $f3aca0a9af811539$export$274e56f32b3baedc = (labelsString)=>{
    if (labelsString === null) return [];
    return labelsString.trim().split(/[\s,]+/).filter((label)=>label.length > 0);
};
const $f3aca0a9af811539$var$getCustomFieldId = (fieldName)=>{
    const found = fieldName.match('customfield_');
    if (found && found.length > 0) return fieldName.replace('customfield_', '');
    return undefined;
};
function $f3aca0a9af811539$var$isRelevantError(e) {
    return e.position === (0, $d2e37636a1b0be7f$export$fa640bba89c0678c);
}
function $f3aca0a9af811539$var$getFilteredErrors(errors) {
    return errors.filter($f3aca0a9af811539$var$isRelevantError);
}
const $f3aca0a9af811539$var$DefaultValueErrors = ({ filteredErrors: filteredErrors })=>{
    const intl = (0, $koVbs.default)();
    if (filteredErrors.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredErrors.map((e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dq3xR.default), {
            key: e.messageDescriptor.id,
            message: intl.formatMessage(e.messageDescriptor, e.values)
        })));
};
function $f3aca0a9af811539$var$refineDefaultValue(defaultValue) {
    return $f3aca0a9af811539$export$274e56f32b3baedc(typeof defaultValue === 'string' ? defaultValue : null);
}
const $f3aca0a9af811539$export$cd14e3d000036cef = ({ field: field, onUpdate: onUpdate, fieldErrors: fieldErrors, tooltipDelay: tooltipDelay, testId: testId })=>{
    const intl = (0, $koVbs.default)();
    // @ts-expect-error LabelsPicker wants IntlShapeV2
    const intlV2 = intl;
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const filteredErrors = $f3aca0a9af811539$var$getFilteredErrors(fieldErrors);
    const isInvalid = filteredErrors.length > 0;
    const defaultValue = $f3aca0a9af811539$var$refineDefaultValue(field.defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), {
        onKeyDown: (0, $jfx3N.preventFormSubmitOnEnter)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isModifyDefaultValueDisabled ? intl.formatMessage((0, $kVdZa.default).labelsDefaultValueDisabledTooltip) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlgLJ.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uKU0.LabelsPicker), {
        value: defaultValue,
        noPortal: true,
        baseUrl: "",
        customFieldId: $f3aca0a9af811539$var$getCustomFieldId(field.key),
        isDisabled: isModifyDefaultValueDisabled,
        isRequired: false,
        label: intl.formatMessage((0, $kVdZa.default).labelsDefaultValueLabel),
        placeholder: intl.formatMessage((0, $kVdZa.default).labelsDefaultValuePickerPlaceholder),
        // @ts-expect-error - TS2769 - No overload matches this call.
        onChange: $f3aca0a9af811539$var$onDefaultValueChange(field, onUpdate),
        intl: intlV2,
        enableAnimation: false,
        isInvalid: isInvalid,
        ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
            isColored: true
        } : {}
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f3aca0a9af811539$var$DefaultValueErrors, {
        filteredErrors: filteredErrors
    })));
};

});
parcelRegister("4uKU0", function(module, exports) {

$parcel$export(module.exports, "LabelsPicker", () => $a4a446ed1d7799a7$export$ae3263cd7b2aef77);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $chc6P = parcelRequire("chc6P");

var $7O4UO = parcelRequire("7O4UO");

var $iOwNT = parcelRequire("iOwNT");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $7ldcY = parcelRequire("7ldcY");

var $lpRLe = parcelRequire("lpRLe");

var $ek97b = parcelRequire("ek97b");

var $dCm1o = parcelRequire("dCm1o");

var $2UfaH = parcelRequire("2UfaH");

var $4NMMS = parcelRequire("4NMMS");
const $a4a446ed1d7799a7$var$DEBOUNCE_TIME = 500;
const $a4a446ed1d7799a7$export$c072126708d93f04 = (selectedOptions)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(selectedOptions, (str)=>str.trim().split(/[\s,]+/)).filter((label)=>label.length > 0);
class $a4a446ed1d7799a7$export$ae3263cd7b2aef77 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isInvalid: false,
            noPortal: false,
            autoFocus: false
        };
    }
    componentDidMount() {
        this.setState({
            isLoading: true
        });
        this.fetchOptions();
    }
    componentDidUpdate(prevProps) {
        // automatically refetch options when these props change
        if (prevProps.baseUrl !== this.props.baseUrl || prevProps.customFieldId !== this.props.customFieldId) {
            this.setState({
                isLoading: true
            });
            this.fetchOptions();
        }
    }
    onChange(selectedOption, analyticsEvent) {
        const labels = selectedOption.map((option)=>option.label);
        this.setState({
            labels: labels
        });
        this.props.onChange($a4a446ed1d7799a7$export$c072126708d93f04(labels), analyticsEvent);
    }
    fetchOptions(search = '') {
        (0, $4NMMS.labelsService)(this.props.baseUrl, search, this.props.customFieldId).then((result)=>{
            this.setState({
                isLoading: false,
                options: [
                    ...this.props.initialOptions || [],
                    ...result
                ]
            });
            return result;
        }).catch((err)=>{
            if (err.message === (0, $4NMMS.validationErrorMessage)) this.setState({
                errorType: 'validation',
                isLoading: false,
                options: []
            });
            else this.setState({
                errorType: 'general',
                isLoading: false,
                options: []
            });
        });
    }
    render() {
        const { label: label, isRequired: isRequired, value: value, noPortal: noPortal, intl: { formatMessage: formatMessage }, isInvalid: isInvalid, isColored: isColored, isDefaultValidationState: isDefaultValidationState, ...rest } = this.props;
        const { labels: labels, errorType: errorType, options: options, isLoading: isLoading } = this.state;
        const pickerValues = (value || labels).map((lab)=>({
                label: lab,
                value: lab
            }));
        const isInlineDialogOpen = this.props.noOptionsErrorMessage ? Boolean(errorType === 'validation') : Boolean(errorType);
        const validationState = !isDefaultValidationState && (isInvalid || errorType) ? 'error' : 'default';
        const selectStyles = {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).modal
                })
        };
        const labelsValueStyles = {
            multiValue: (base, { data: data })=>{
                const { backgroundColor: backgroundColor } = (0, $ek97b.getColorMetadata)((0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(data.label));
                return {
                    ...base,
                    border: `1px solid ${backgroundColor}`,
                    '& > div > div > div': {
                        paddingLeft: 0,
                        paddingRight: 0
                    },
                    ...!(0, $dCm1o.isVisualRefreshEnabled)() ? {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        backgroundColor: 'transparent',
                        '& > div': {
                            paddingLeft: "var(--ds-space-050, 4px)",
                            paddingRight: 0,
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                    } : {}
                };
            },
            multiValueLabel: (base)=>({
                    ...base,
                    '& > div > div': {
                        borderColor: 'transparent'
                    }
                })
        };
        const labelsRemoveIconStyles = {
            multiValueRemove: (base)=>({
                    ...base,
                    '& > div > span > svg': {
                        transform: 'scale(1.5)',
                        fill: 'none'
                    },
                    '& > div > span > svg > g > path': {
                        d: 'path("m 2 10 l 4 -4 m 4 -4 L 6 6 m 0 0 L 2 2 m 4 4 l 4 4")',
                        transform: 'translate(5px, 6px)',
                        stroke: "var(--ds-text, #172B4D)",
                        strokeWidth: '1.5'
                    }
                })
        };
        const styles = ()=>{
            if (isColored) {
                if (!(0, $dCm1o.isVisualRefreshEnabled)()) return {
                    ...selectStyles,
                    ...labelsValueStyles,
                    ...labelsRemoveIconStyles
                };
                return {
                    ...selectStyles,
                    ...labelsValueStyles
                };
            }
            return selectStyles;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "platform-ui-pickers-label",
            label: label,
            isRequired: isRequired
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
                content: errorType === 'validation' ? formatMessage((0, $2UfaH.default).validationError) : formatMessage((0, $2UfaH.default).fetchError),
                isOpen: isInlineDialogOpen,
                placement: "right",
                messageId: "label-picker.inline-dialog",
                messageType: "transactional"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOwNT.default), {
                ...rest,
                inputId: fieldProps.id,
                isClearable: false,
                defaultOptions: true,
                autoFocus: !!this.props.autoFocus,
                // @ts-expect-error - TS2322 - Type '(selection: LabelOption[] | LabelOption | null, actionMeta: {    action: string;}, analyticsEvent?: any) => void' is not assignable to type '(value: unknown, action: ActionMeta<unknown>) => void'.
                onChange: this.onSelected,
                noOptionsMessage: this.noOptionsMessage,
                loadingMessage: this.loadingMessage,
                validationState: validationState,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                menuPortalTarget: noPortal ? null : document.body,
                value: pickerValues,
                onCreateOption: this.onCreateOption,
                formatCreateLabel: this.formatCreateLabel,
                ...isColored ? {
                    formatOptionLabel: this.formatOptionLabel
                } : {},
                allowCreateWhileLoading: true,
                isMulti: true,
                options: options,
                onInputChange: this.onInputChange,
                isLoading: isLoading,
                // @ts-expect-error - ts2322 -  Type 'ClearIndicatorProps<unknown, boolean, GroupBase<unknown>>' is not assignable to type 'ClearIndicatorProps<LabelOption, true, GroupBase<LabelOption>>'.
                styles: styles()
            }))));
    }
    constructor(...args){
        super(...args), this.state = {
            labels: [],
            options: [],
            errorType: undefined,
            isLoading: false
        }, this.loadingMessage = ()=>this.props.intl.formatMessage((0, $2UfaH.default).loading), this.noOptionsMessage = ()=>{
            const { errorType: errorType } = this.state;
            const { intl: { formatMessage: formatMessage }, noOptionsErrorMessage: noOptionsErrorMessage } = this.props;
            const message = errorType === 'general' && noOptionsErrorMessage ? noOptionsErrorMessage : formatMessage((0, $2UfaH.default).noOptions);
            return message;
        }, this.onSelected = (selection, actionMeta, analyticsEvent)=>{
            if (Array.isArray(selection)) this.onChange(selection, analyticsEvent);
            else selection && selection.value ? this.onChange([
                selection
            ], analyticsEvent) : this.onChange([], analyticsEvent);
        }, this.onCreateOption = (value)=>{
            const labels = this.props.value || this.state.labels;
            const newLabels = [
                ...labels,
                value
            ];
            this.setState({
                labels: newLabels
            });
            this.props.onChange($a4a446ed1d7799a7$export$c072126708d93f04(newLabels));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((filter)=>{
            this.fetchOptions(filter);
        }, $a4a446ed1d7799a7$var$DEBOUNCE_TIME), this.formatCreateLabel = (value)=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return `${value} (${formatMessage((0, $2UfaH.default).new)})`;
        }, this.onInputChange = (value)=>{
            this.setState({
                isLoading: true,
                errorType: undefined
            });
            this.debouncedLoadOptions(value);
        }, this.formatOptionLabel = (option)=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const optionLabel = option.label;
            const createNewLabelString = `(${formatMessage((0, $2UfaH.default).new)})`;
            if (typeof optionLabel === 'string' && optionLabel.endsWith(createNewLabelString)) {
                const optionLabelWithoutNewLabel = optionLabel.slice(0, -createNewLabelString.length).trim();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
                    name: optionLabel,
                    color: (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(optionLabelWithoutNewLabel)
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
                name: optionLabel,
                color: (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(optionLabel)
            });
        };
    }
}
var $a4a446ed1d7799a7$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($a4a446ed1d7799a7$export$ae3263cd7b2aef77);

});
parcelRegister("chc6P", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), 1);
}
module.exports = $8f007734a6a4d9ac$var$flatMap;

});
parcelRegister("80afZ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $5d3647a04b83e8d6$var$map(collection, iteratee) {
    var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
    return func(collection, $bxDef(iteratee, 3));
}
module.exports = $5d3647a04b83e8d6$var$map;

});


parcelRegister("7ldcY", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a80529ae8ec44f02);

var $gJBT6 = parcelRequire("gJBT6");

var $1L3S5 = parcelRequire("1L3S5");

var $fzY6y = parcelRequire("fzY6y");

var $96pcJ = parcelRequire("96pcJ");
const $7fa3a87d53177c9e$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $1L3S5.GREY_META).name;
};
const $7fa3a87d53177c9e$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $1L3S5.GREY_META).tagColor;
};
const $7fa3a87d53177c9e$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$97056d4b28203ee9);
const $7fa3a87d53177c9e$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$a3f5334e7a13e57a);

});
parcelRegister("fzY6y", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $899e3507d4080274$export$e352defce701b36e);

const $899e3507d4080274$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $37d3405989cb4520$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $37d3405989cb4520$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $37d3405989cb4520$export$d15e38bcd75fda7c = 256;
const $37d3405989cb4520$export$e143f4b09221a374 = 1000000007;


parcelRegister("96pcJ", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $9ffc042ff38af51a$export$cb0dffe2d2ae675a);

var $1L3S5 = parcelRequire("1L3S5");
const $9ffc042ff38af51a$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("2UfaH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be6a988c6de559e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7be6a988c6de559e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fetchError: {
        "id": "label-picker.error",
        "defaultMessage": "Couldn\u2019t find labels. Try again."
    },
    validationError: {
        "id": "label-picker.validation-error",
        "defaultMessage": "Labels can\u2019t have spaces or be more than 255 characters."
    },
    new: {
        "id": "label-picker.new",
        "defaultMessage": "new"
    },
    noOptions: {
        "id": "label-picker.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "label-picker.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("4NMMS", function(module, exports) {

$parcel$export(module.exports, "validationErrorMessage", () => $e01fae3ad16dc9a0$export$9abc43a57b1d16e9);
$parcel$export(module.exports, "labelsService", () => $e01fae3ad16dc9a0$export$8796a7b82dd022aa);

var $iCcqO = parcelRequire("iCcqO");
const $e01fae3ad16dc9a0$export$9abc43a57b1d16e9 = 'labels validation failed. must not contain spaces or be more than 255 characters';
const $e01fae3ad16dc9a0$var$transformLabels = (response)=>{
    // @ts-expect-error - TS2339 - Property 'errorMessages' does not exist on type 'SuggestedLabelsResponse'.
    if (response.suggestions || !response.errorMessages) return response.suggestions.map((suggestion)=>({
            label: suggestion.label,
            value: suggestion.label
        }));
    throw new Error($e01fae3ad16dc9a0$export$9abc43a57b1d16e9);
};
const $e01fae3ad16dc9a0$export$8796a7b82dd022aa = (baseUrl, query, customFieldId)=>(0, $iCcqO.get)(baseUrl, {
        query: query,
        customFieldId: customFieldId
    }).then($e01fae3ad16dc9a0$var$transformLabels);

});
parcelRegister("iCcqO", function(module, exports) {

$parcel$export(module.exports, "get", () => $247d8cea10a0f83d$export$3988ae62b71be9a3);

var $80afZ = parcelRequire("80afZ");

var $7f4tk = parcelRequire("7f4tk");
const $247d8cea10a0f83d$var$toPathQuery = (value, key)=>{
    if (value === '') return `${encodeURIComponent(key)}=`;
    return value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : undefined;
};
const $247d8cea10a0f83d$var$serialize = (obj)=>// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))(obj, (value, key)=>$247d8cea10a0f83d$var$toPathQuery(value, key)).filter((val)=>val !== undefined).join('&');
const $247d8cea10a0f83d$export$a5b7a8c3b1c6e775 = (baseUrl, params)=>`/rest/api/1.0/labels/suggest?${$247d8cea10a0f83d$var$serialize(params)}`;
const $247d8cea10a0f83d$export$3988ae62b71be9a3 = (baseUrl, params)=>(0, $7f4tk.default)($247d8cea10a0f83d$export$a5b7a8c3b1c6e775(baseUrl, params));

});



parcelRegister("jfx3N", function(module, exports) {

$parcel$export(module.exports, "preventFormSubmitOnEnter", () => $a3983ffd5309ea45$export$79e632c3f4159673);
const $a3983ffd5309ea45$export$79e632c3f4159673 = (e)=>{
    if (e.key === 'Enter') e.preventDefault();
};

});

parcelRegister("kVdZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $98dc6e46f4138e21$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98dc6e46f4138e21$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    labelsDefaultValueLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.labels.labels-default-value-label",
        "defaultMessage": "Default labels"
    },
    labelsDefaultValuePickerPlaceholder: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.labels.labels-default-value-picker-placeholder",
        "defaultMessage": "Select labels"
    },
    labelsDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.labels.labels-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default labels"
    }
});

});


parcelRegister("3pEwq", function(module, exports) {

$parcel$export(module.exports, "MultilineFieldConfiguration", () => $99ee3806bd51338b$export$9f96b65d3821e64);
$parcel$export(module.exports, "isExpandable", () => $99ee3806bd51338b$export$6e0f0a958dc8ef91);

var $5uXOq = parcelRequire("5uXOq");

var $hXRXz = parcelRequire("hXRXz");

var $4R6GH = parcelRequire("4R6GH");

var $4b46h = parcelRequire("4b46h");

var $8wTCc = parcelRequire("8wTCc");

var $3sl8c = parcelRequire("3sl8c");
function $99ee3806bd51338b$var$getProjectMentionProvider(projectKey) {
    return Promise.resolve(new (0, $8wTCc.default)('', projectKey, null));
}
const $99ee3806bd51338b$export$9f96b65d3821e64 = (props)=>{
    const mentionProvider = (0, $5uXOq.useRef)($99ee3806bd51338b$var$getProjectMentionProvider(props.projectKey));
    const emojiProvider = (0, $5uXOq.useRef)((0, $hXRXz.getEmojiProvider)() ?? undefined);
    const getTaskAndDecisionProvider = ()=>{
        if ((0, $4R6GH.fg)('jira_issue_config_fields_task_and_decision_gate')) return Promise.resolve(new (0, $4b46h.TaskAndDecisionProvider)());
        return undefined;
    };
    const taskAndDecisionProvider = (0, $5uXOq.useRef)(getTaskAndDecisionProvider());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sl8c.MultilineView), {
        ...props,
        mentionProvider: mentionProvider.current,
        emojiProvider: emojiProvider.current,
        taskDecisionProvider: taskAndDecisionProvider.current
    });
};
const $99ee3806bd51338b$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});
parcelRegister("hXRXz", function(module, exports) {

$parcel$export(module.exports, "getEmojiProvider", () => $8599af293a85f3b3$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", () => $8599af293a85f3b3$export$f9c5a1e85ff0cb72);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", () => $8599af293a85f3b3$export$7cda0fc535c2710f);
$parcel$export(module.exports, "fetchEmojiProvider", () => $8599af293a85f3b3$export$12c2b0bd175ad5c1);

var $3Uu1D = parcelRequire("3Uu1D");

var $9CGZY = parcelRequire("9CGZY");
const $8599af293a85f3b3$var$baseProviders = (serviceBaseUrl)=>[
        {
            url: `${serviceBaseUrl}/emoji/standard`
        },
        {
            url: `${serviceBaseUrl}/emoji/atlassian`
        }
    ];
const $8599af293a85f3b3$export$8210f5f78c0bcf27 = ()=>(0, $9CGZY.getServiceProvider)((0, $9CGZY.EMOJI_SERVICEID), (serviceBaseUrl)=>{
        const emojiResource = new (0, $3Uu1D.default)({
            providers: $8599af293a85f3b3$var$baseProviders(serviceBaseUrl)
        });
        return emojiResource.getEmojiProvider();
    });
const $8599af293a85f3b3$export$f9c5a1e85ff0cb72 = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $9CGZY.getServiceProvider)((0, $9CGZY.EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $3Uu1D.default)({
            providers: providers,
            allowUpload: true,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $8599af293a85f3b3$export$7cda0fc535c2710f = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $9CGZY.getServiceProvider)((0, $9CGZY.EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $3Uu1D.default)({
            providers: providers,
            allowUpload: false,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $8599af293a85f3b3$export$12c2b0bd175ad5c1 = async (emojiProviderPromise)=>{
    (await emojiProviderPromise)?.fetchEmojiProvider();
};

});
parcelRegister("3Uu1D", function(module, exports) {

$parcel$export(module.exports, "supportsUploadFeature", () => $b4e19b4b20da22f1$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $b4e19b4b20da22f1$export$2e2bcd8739ae039);

var $dS9cn = parcelRequire("dS9cn");

var $kin1Z = parcelRequire("kin1Z");

var $b8sgr = parcelRequire("b8sgr");

var $5B9Cy = parcelRequire("5B9Cy");

var $d9blH = parcelRequire("d9blH");

var $9AR2K = parcelRequire("9AR2K");

var $f2M1N = parcelRequire("f2M1N");

var $WeQTx = parcelRequire("WeQTx");

var $62WHo = parcelRequire("62WHo");

var $d2UcN = parcelRequire("d2UcN");

var $cf5vr = parcelRequire("cf5vr");
const $b4e19b4b20da22f1$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $b4e19b4b20da22f1$export$b5efafc6dd611ec5 extends (0, $dS9cn.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        this.emojiProviderConfig = config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $d9blH.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
	 * Get the emoji provider from Emoji Resource
	 * @returns Promise<EmojiProvider>
	 */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $b8sgr.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $d2UcN.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $kin1Z.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $d2UcN.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $f2M1N.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $d2UcN.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $d2UcN.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $b8sgr.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $f2M1N.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $9AR2K.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $9AR2K.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $9AR2K.ProviderTypes).ATLASSIAN;
        return (0, $9AR2K.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $WeQTx.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $62WHo.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $5B9Cy.isPromise)(done)) return done.then(()=>{
                    (0, $b8sgr.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $b8sgr.default)('Failed to prime siteEmojiResource');
                });
                else (0, $b8sgr.default)('Already primed siteEmojiResource');
            } else (0, $b8sgr.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $5B9Cy.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $kin1Z.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
	 *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
	 */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $5B9Cy.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $5B9Cy.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $5B9Cy.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $d2UcN.ufoExperiences)['emoji-searched'].start();
        (0, $d2UcN.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: query?.length || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $d2UcN.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: options?.source || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
	 * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
	 * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
	 * for the purposes of tracking the frequency of use.
	 *
	 * @param emoji The full description of the emoji to record usage for.
	 */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $5B9Cy.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $dS9cn.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $d9blH.default)('localStorage')) try {
            window.localStorage.setItem((0, $kin1Z.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $b4e19b4b20da22f1$export$2e2bcd8739ae039 extends $b4e19b4b20da22f1$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 12000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $cf5vr.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("kin1Z", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $1c1f8a5ed290c232$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $1c1f8a5ed290c232$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $1c1f8a5ed290c232$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $1c1f8a5ed290c232$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $1c1f8a5ed290c232$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $1c1f8a5ed290c232$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $1c1f8a5ed290c232$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $1c1f8a5ed290c232$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $1c1f8a5ed290c232$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $1c1f8a5ed290c232$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $1c1f8a5ed290c232$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $1c1f8a5ed290c232$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $1c1f8a5ed290c232$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $1c1f8a5ed290c232$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $1c1f8a5ed290c232$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $1c1f8a5ed290c232$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $1c1f8a5ed290c232$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $1c1f8a5ed290c232$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $1c1f8a5ed290c232$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $1c1f8a5ed290c232$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $1c1f8a5ed290c232$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $1c1f8a5ed290c232$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $1c1f8a5ed290c232$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $1c1f8a5ed290c232$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $1c1f8a5ed290c232$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $1c1f8a5ed290c232$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $1c1f8a5ed290c232$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $1c1f8a5ed290c232$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $1c1f8a5ed290c232$export$66cabad5e268b05e);
const $1c1f8a5ed290c232$export$5e4e3d1c3e43156a = 'CUSTOM';
const $1c1f8a5ed290c232$export$78ccdc4be403c468 = 'FREQUENT';
const $1c1f8a5ed290c232$export$2c4b04c3aacdf1b3 = 'SITE';
const $1c1f8a5ed290c232$export$1b0258512be88334 = 'SEARCH';
const $1c1f8a5ed290c232$export$42b510423367f354 = 'USER_CUSTOM';
const $1c1f8a5ed290c232$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $1c1f8a5ed290c232$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $1c1f8a5ed290c232$export$8ac325bfd32359b0 = 'data:';
const $1c1f8a5ed290c232$export$a330961542edfe6f = 'delete-emoji';
const $1c1f8a5ed290c232$export$1a817f1886276c6d = 100000;
const $1c1f8a5ed290c232$export$3f99ac31dc0406db = 20;
const $1c1f8a5ed290c232$export$d171dc12fee2b1da = 350;
const $1c1f8a5ed290c232$export$c10ac8125a260041 = 80;
const $1c1f8a5ed290c232$export$5248fb9e0cccc41f = 'medium';
const $1c1f8a5ed290c232$export$94f75d625e7801d3 = 260;
const $1c1f8a5ed290c232$export$7ed599d166d65aea = 295;
const $1c1f8a5ed290c232$export$7722b8e9522021df = $1c1f8a5ed290c232$export$7ed599d166d65aea - 58; // picker height - actions height
const $1c1f8a5ed290c232$export$e218e5cb105a0e22 = 54;
const $1c1f8a5ed290c232$export$e67f617938b111f1 = $1c1f8a5ed290c232$export$7ed599d166d65aea + $1c1f8a5ed290c232$export$e218e5cb105a0e22;
const $1c1f8a5ed290c232$export$e394a0c530ae5631 = 'fabric.emoji';
const $1c1f8a5ed290c232$export$79ee4ef84c545f8f = `${$1c1f8a5ed290c232$export$e394a0c530ae5631}.selectedTone`;
const $1c1f8a5ed290c232$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $1c1f8a5ed290c232$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $1c1f8a5ed290c232$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $1c1f8a5ed290c232$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $1c1f8a5ed290c232$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $1c1f8a5ed290c232$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $1c1f8a5ed290c232$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $1c1f8a5ed290c232$export$4f0ee90b28d6efc5 = 0;
const $1c1f8a5ed290c232$export$9f7de4293d27f3aa = 50;
const $1c1f8a5ed290c232$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $1c1f8a5ed290c232$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $1c1f8a5ed290c232$export$2829f3ec323f8ec0 = 8;
const $1c1f8a5ed290c232$export$ce3a0e7d2d7d6ba2 = 5;
const $1c1f8a5ed290c232$export$858e8dc100a97278 = 150;
const $1c1f8a5ed290c232$export$83aab2ae64548423 = 20;
const $1c1f8a5ed290c232$export$66cabad5e268b05e = 100;

});

parcelRegister("b8sgr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b76154abb8f2c59$export$2e2bcd8739ae039);
let $1b76154abb8f2c59$var$debugEnabled = false;
let $1b76154abb8f2c59$var$stacktracesEnabled = false;
function $1b76154abb8f2c59$export$748ada60eaf985cc(enable) {
    $1b76154abb8f2c59$var$debugEnabled = enable;
}
function $1b76154abb8f2c59$export$4f7017086af31c25(enable) {
    $1b76154abb8f2c59$var$stacktracesEnabled = enable;
}
function $1b76154abb8f2c59$export$2a858f450a2f66d() {
    if ($1b76154abb8f2c59$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b76154abb8f2c59$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b76154abb8f2c59$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("5B9Cy", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $fb1b6c003b1856ef$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $fb1b6c003b1856ef$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $fb1b6c003b1856ef$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $fb1b6c003b1856ef$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $fb1b6c003b1856ef$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $fb1b6c003b1856ef$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $fb1b6c003b1856ef$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $fb1b6c003b1856ef$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $fb1b6c003b1856ef$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $fb1b6c003b1856ef$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $fb1b6c003b1856ef$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $fb1b6c003b1856ef$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $fb1b6c003b1856ef$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $fb1b6c003b1856ef$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $fb1b6c003b1856ef$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $fb1b6c003b1856ef$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $fb1b6c003b1856ef$export$4bcbf61cb6832a8e);

var $aSE1r = parcelRequire("aSE1r");

var $kin1Z = parcelRequire("kin1Z");
const $fb1b6c003b1856ef$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $fb1b6c003b1856ef$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $fb1b6c003b1856ef$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $fb1b6c003b1856ef$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $fb1b6c003b1856ef$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $fb1b6c003b1856ef$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $fb1b6c003b1856ef$export$a7e82c67204c73a1 = (emoji)=>$fb1b6c003b1856ef$export$979133dc1df141c6(emoji.representation);
const $fb1b6c003b1856ef$export$7720a4954d6f75f8 = (rep)=>$fb1b6c003b1856ef$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $kin1Z.dataURLPrefix)) === 0;
const $fb1b6c003b1856ef$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $kin1Z.customCategory) && $fb1b6c003b1856ef$export$7720a4954d6f75f8(emoji.representation);
const $fb1b6c003b1856ef$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $fb1b6c003b1856ef$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $fb1b6c003b1856ef$export$dddfba07c16c94d2 = (key)=>key in (0, $aSE1r.messages);
const $fb1b6c003b1856ef$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $fb1b6c003b1856ef$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $fb1b6c003b1856ef$export$8d7d3de6b5b305d1(emoji);
};
const $fb1b6c003b1856ef$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $fb1b6c003b1856ef$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($fb1b6c003b1856ef$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $fb1b6c003b1856ef$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $fb1b6c003b1856ef$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $fb1b6c003b1856ef$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$fb1b6c003b1856ef$export$979133dc1df141c6(mediaRepresentation) && !$fb1b6c003b1856ef$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $fb1b6c003b1856ef$export$979133dc1df141c6(mediaRepresentation) ? $fb1b6c003b1856ef$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $fb1b6c003b1856ef$export$979133dc1df141c6(mediaAltRepresentation) ? $fb1b6c003b1856ef$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $fb1b6c003b1856ef$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $fb1b6c003b1856ef$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $fb1b6c003b1856ef$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("aSE1r", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11d87ef7c2048740$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $11d87ef7c2048740$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    /*
	searchResultsStatus: {
		id: 'fabric.emoji.search.status',
		defaultMessage: 'Found {count} emojis',
		description: 'search results status for screenreader to read out',
	},
	 */ searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("d9blH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0506955bcee8f359$export$2e2bcd8739ae039);
function $0506955bcee8f359$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("9AR2K", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $d0b081d2572cc7bf$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $d0b081d2572cc7bf$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $d0b081d2572cc7bf$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $d0b081d2572cc7bf$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $d0b081d2572cc7bf$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $d0b081d2572cc7bf$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $d0b081d2572cc7bf$export$482549d945a3723);
var $d0b081d2572cc7bf$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $d0b081d2572cc7bf$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $d0b081d2572cc7bf$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $d0b081d2572cc7bf$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $d0b081d2572cc7bf$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $d0b081d2572cc7bf$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $d0b081d2572cc7bf$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("f2M1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8439b55200f22364$export$2e2bcd8739ae039);

var $0Bueq = parcelRequire("0Bueq");
class $8439b55200f22364$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
	 * Returns a promise with an array of Emoji from all providers.
	 */ loadEmoji() {
        const emojisPromise = (0, $0Bueq.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $0Bueq.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("0Bueq", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $9b95bf1aff58b644$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $9b95bf1aff58b644$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $9b95bf1aff58b644$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $9b95bf1aff58b644$export$b7e9058f156d8d19);

var $dS9cn = parcelRequire("dS9cn");

var $5B9Cy = parcelRequire("5B9Cy");

var $b8sgr = parcelRequire("b8sgr");
const $9b95bf1aff58b644$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $9b95bf1aff58b644$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $9b95bf1aff58b644$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $dS9cn.utils).requestService(serviceConfig, requestOptions);
};
const $9b95bf1aff58b644$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $9b95bf1aff58b644$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $9b95bf1aff58b644$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$9b95bf1aff58b644$var$calculateScale($9b95bf1aff58b644$export$d39ce20a37bba061).altScale];
};
const $9b95bf1aff58b644$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $9b95bf1aff58b644$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $5B9Cy.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $5B9Cy.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($9b95bf1aff58b644$export$db05e6ae1fd416af(imagePath, meta)) return (0, $5B9Cy.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $b8sgr.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $9b95bf1aff58b644$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $9b95bf1aff58b644$export$55077db3efc820aa($9b95bf1aff58b644$export$4a0301d636367e1d(altReps), meta);
};
const $9b95bf1aff58b644$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $9b95bf1aff58b644$export$55077db3efc820aa(representation, meta),
            altRepresentation: $9b95bf1aff58b644$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $9b95bf1aff58b644$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $9b95bf1aff58b644$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $9b95bf1aff58b644$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $9b95bf1aff58b644$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $5B9Cy.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $9b95bf1aff58b644$var$getHeight = (fitToHeight)=>$9b95bf1aff58b644$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $9b95bf1aff58b644$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $9b95bf1aff58b644$var$getHeight(fitToHeight) > emoji.representation.height);

});


parcelRegister("WeQTx", function(module, exports) {

$parcel$export(module.exports, "getEmojiVariation", () => $1d50887d5f60ae61$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $1d50887d5f60ae61$export$2e2bcd8739ae039);

var $lH7AH = parcelRequire("lH7AH");

var $kin1Z = parcelRequire("kin1Z");

var $5B9Cy = parcelRequire("5B9Cy");

var $9AR2K = parcelRequire("9AR2K");

var $9aDRG = parcelRequire("9aDRG");

var $fjHZk = parcelRequire("fjHZk");

var $8Ov1g = parcelRequire("8Ov1g");

var $VSDnB = parcelRequire("VSDnB");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $1d50887d5f60ae61$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $9aDRG.tokenizerRegex).lastIndex = 0;
        while((match = (0, $9aDRG.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $1d50887d5f60ae61$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $5B9Cy.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$1d50887d5f60ae61$var$addAllVariants(variation, fnKey, map));
    }
};
const $1d50887d5f60ae61$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $1d50887d5f60ae61$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $1d50887d5f60ae61$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $5B9Cy.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $1d50887d5f60ae61$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $1d50887d5f60ae61$export$2e2bcd8739ae039 {
    static{
        this.defaultEmojiWeight = 1000000;
    }
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
	 * Returns all available (and searchable) emoji in some default order.
	 */ all() {
        const options = {
            sort: (0, $9AR2K.SearchSort).None
        };
        return this.search('', options);
    }
    /**
	 * Text search of emoji shortName and name field for suitable matches.
	 *
	 * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
	 *
	 * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
	 * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
	 * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
	 */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $1d50887d5f60ae61$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
	 * Returns all emoji with matching shortName
	 */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
	 * Returns the first matching emoji matching the shortName, or null if none found.
	 */ findByShortName(shortName) {
        return $1d50887d5f60ae61$var$findByKey(this.shortNameMap, shortName);
    }
    /**
	 * Returns the first matching emoji matching the id, or null if none found.
	 */ findById(id) {
        return $1d50887d5f60ae61$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $kin1Z.frequentCategory)) return this.getFrequentlyUsed();
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
	 * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
	 * there are none.
	 *
	 * @param options optional settings to be applied to the set of frequently used emoji
	 */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
	 * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
	 * in sorting, etc).
	 *
	 * @param emoji the emoji that was just used
	 */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $kin1Z.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $kin1Z.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $1d50887d5f60ae61$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $9AR2K.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $9AR2K.SearchSort).Default) comparator = (0, $fjHZk.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $9AR2K.SearchSort).UsageFrequency) comparator = (0, $fjHZk.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $1d50887d5f60ae61$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $8Ov1g.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $VSDnB.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
	 * Optimisation to initialise all map member variables in single loop over emojis
	 */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(emoji.category);
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $kin1Z.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $kin1Z.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $lH7AH.Search)('id');
        this.fullSearch.tokenizer = new $1d50887d5f60ae61$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $lH7AH.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $1d50887d5f60ae61$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $1d50887d5f60ae61$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $1d50887d5f60ae61$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $1d50887d5f60ae61$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = (0, $5B9Cy.getCategoryId)(emoji);
        if ((0, $kin1Z.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
}

});
parcelRegister("lH7AH", function(module, exports) {

$parcel$export(module.exports, "UnorderedSearchIndex", () => $fcb38080bd8576e6$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $fcb38080bd8576e6$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $fcb38080bd8576e6$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $fcb38080bd8576e6$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $fcb38080bd8576e6$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $fcb38080bd8576e6$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $fcb38080bd8576e6$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $fcb38080bd8576e6$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $fcb38080bd8576e6$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $fcb38080bd8576e6$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $fcb38080bd8576e6$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $fcb38080bd8576e6$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $fcb38080bd8576e6$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($fcb38080bd8576e6$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $fcb38080bd8576e6$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $fcb38080bd8576e6$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$fcb38080bd8576e6$export$eeaf491a400e882a.constructor = false;
$fcb38080bd8576e6$export$eeaf491a400e882a.hasOwnProperty = false;
$fcb38080bd8576e6$export$eeaf491a400e882a.isPrototypeOf = false;
$fcb38080bd8576e6$export$eeaf491a400e882a.propertyIsEnumerable = false;
$fcb38080bd8576e6$export$eeaf491a400e882a.toLocaleString = false;
$fcb38080bd8576e6$export$eeaf491a400e882a.toString = false;
$fcb38080bd8576e6$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $fcb38080bd8576e6$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$fcb38080bd8576e6$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $fcb38080bd8576e6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fcb38080bd8576e6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fcb38080bd8576e6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcb38080bd8576e6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $fcb38080bd8576e6$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $fcb38080bd8576e6$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $fcb38080bd8576e6$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $fcb38080bd8576e6$export$147e8ac43c84713a();
        this._tokenizer = new $fcb38080bd8576e6$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    } /**
   * Adds searchable documents to the index. Documents will automatically be indexed for search.
   * @param document
   */ ;
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    } /**
   * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
   *
   * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
   */ ;
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    } /**
   * Search all documents for ones matching the specified query text.
   * @param query
   * @returns {Array<Object>}
   */ ;
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    } /**
   * @param documents
   * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
   * @private
   */ ;
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $fcb38080bd8576e6$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $fcb38080bd8576e6$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $fcb38080bd8576e6$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $fcb38080bd8576e6$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $fcb38080bd8576e6$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $fcb38080bd8576e6$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    } /**
   * @param text to wrap
   * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
   * @private
   */ ;
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("9aDRG", function(module, exports) {

$parcel$export(module.exports, "tokenizerRegex", () => $646a79216f1b7bf8$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $646a79216f1b7bf8$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("fjHZk", function(module, exports) {

$parcel$export(module.exports, "createSearchEmojiComparator", () => $60550181d33ca139$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $60550181d33ca139$export$1bd055808eeccb4e);

var $kin1Z = parcelRequire("kin1Z");

var $5B9Cy = parcelRequire("5B9Cy");
function $60550181d33ca139$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $60550181d33ca139$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $60550181d33ca139$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $60550181d33ca139$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $60550181d33ca139$export$587c775915dc4869(textQuery, 'shortName'), new $60550181d33ca139$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($60550181d33ca139$export$165e96ceead77edd.Instance, $60550181d33ca139$export$30ce221e1adf48c1.Instance);
    const comparator = new $60550181d33ca139$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $60550181d33ca139$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $60550181d33ca139$export$a8052d0852821684(new $60550181d33ca139$export$55e24837a4bf653(orderedIds), new $60550181d33ca139$export$a7f7a0b04013a8a8(), $60550181d33ca139$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $60550181d33ca139$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $60550181d33ca139$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $60550181d33ca139$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $60550181d33ca139$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $60550181d33ca139$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $60550181d33ca139$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
	 * Get the ordinal representing the position of this emoji.
	 *
	 * @param id the id of the emoji
	 */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $5B9Cy.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $kin1Z.MAX_ORDINAL;
    }
}
class $60550181d33ca139$export$587c775915dc4869 {
    /**
	 * @param query the query to match
	 * @param propertyToCompare the property of EmojiDescription to check for query within
	 */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $kin1Z.MAX_ORDINAL);
        return score === -1 ? (0, $kin1Z.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $60550181d33ca139$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $kin1Z.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $kin1Z.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $60550181d33ca139$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("8Ov1g", function(module, exports) {

$parcel$export(module.exports, "UsageFrequencyTracker", () => $03e35e6585a0c1a4$export$3f86810331c44209);

var $5B9Cy = parcelRequire("5B9Cy");

var $kin1Z = parcelRequire("kin1Z");

var $2FvtQ = parcelRequire("2FvtQ");

var $fWsKa = parcelRequire("fWsKa");

var $d9blH = parcelRequire("d9blH");
class $03e35e6585a0c1a4$export$3f86810331c44209 {
    static{
        this.queueOptions = {
            storage: (0, $d9blH.default)('localStorage') ? window.localStorage : undefined,
            storagePrefix: (0, $kin1Z.localStoragePrefix),
            maxDuplicates: 25,
            minUniqueItems: 5
        };
    }
    constructor(useStorageIfPossible = true){
        const options = $03e35e6585a0c1a4$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $fWsKa.default)(queueOptions);
        } else this.queue = new (0, $2FvtQ.default)(options);
        this.gateway = new $03e35e6585a0c1a4$export$a0e1fa6601cae894(10);
    }
    /**
	 * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
	 * count on getOrder() reflecting this usage immediately.
	 *
	 * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
	 */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $5B9Cy.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
	 * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
	 * are no usages then an empty array will be returned.
	 */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
	 * Exposed for testing only. Clear any recorded usage.
	 */ clear() {
        this.queue.clear();
    }
}
class $03e35e6585a0c1a4$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
	 * Run the supplied function if the count of already submitted work allows it. Drop the work
	 * if it's not allowed to run.
	 *
	 * Will return true if the function has been submitted or false if it was not submitted.
	 */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("2FvtQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e862ce217e71f514$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $e862ce217e71f514$export$2e2bcd8739ae039 {
    /**
	 * Construct a new DuplicateLimitedQueue.
	 *
	 * @param options the options for this queue.
	 */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
	 * @param item the item to add to the queue.
	 */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items in the queue, ordered by how often they are duplicated. The items with the
	 * most duplicates come first in the returned Array.
	 *
	 * If there are no items in the queue then an empty Array will be returned.
	 */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue.
	 */ clear() {
        this.createEmptyState();
    }
    /**
	 * A more efficient mechanism for adding multiple items. Ordering is only performed once all
	 * the items have been added.
	 *
	 * @param items the items to be enqueued, which happens in their presented order.
	 */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items currently stored in the queue.
	 */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
	 * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
	 * performed by this enqueuing. You must trigger that manually if required.
	 *
	 * @param item the item to be queued
	 */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
	 * Get an array of items from the queue ordered by how often they are duplicated in the queue.
	 */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
	 * Walk the list of items and remove the first occurrence of the matching item.
	 *
	 * @param item the item to be removed.
	 */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
	 * Remove the first item from the queue and update the itemCountMap accordingly.
	 * @return the item add the front of the queue or undefined if the queue is empty
	 */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
	 * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
	 * @param item the item to be added to the queue
	 */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("fWsKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6962a764dc80122$export$2e2bcd8739ae039);

var $2FvtQ = parcelRequire("2FvtQ");

var $b8sgr = parcelRequire("b8sgr");
class $e6962a764dc80122$export$2e2bcd8739ae039 extends (0, $2FvtQ.default) {
    static{
        this.storageKey = 'lastUsed';
    }
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$e6962a764dc80122$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
	 * Enqueue the supplied item and also persist the new contents of the queue to storage.
	 *
	 * @param item the item to be enqueued
	 */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
	 */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
	 * Initialise the queue contents from the configured Storage. If there is no data found in
	 * storage then the queue will have no items added. Likewise, a failure to read or parse stored
	 * data will be swallowed and no items are added to the queue.
	 */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $b8sgr.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
	 * Save the current items in the queue, overwriting any previously stored queue.
	 * Any failure in saving will be silently ignored with the likely outcome that any previous
	 * saved items will remain unchanged in storage.
	 */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $b8sgr.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});



parcelRegister("62WHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f7f47d6423aa49d$export$2e2bcd8739ae039);

var $dS9cn = parcelRequire("dS9cn");

var $cEHh7 = parcelRequire("cEHh7");

var $5B9Cy = parcelRequire("5B9Cy");

var $0l85J = parcelRequire("0l85J");

var $0Bueq = parcelRequire("0Bueq");

var $ijzU9 = parcelRequire("ijzU9");

var $b8sgr = parcelRequire("b8sgr");
const $9f7f47d6423aa49d$export$6f3a08dea02a7b2b = 0.95;
class $9f7f47d6423aa49d$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $5B9Cy.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $0Bueq.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $5B9Cy.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $5B9Cy.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $ijzU9.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $0l85J.default)(this.tokenManager);
    }
    /**
	 * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
	 */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $5B9Cy.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $5B9Cy.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
	 * Will load media emoji, returning a new EmojiDescription if, for example,
	 * the URL has changed.
	 */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $5B9Cy.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $5B9Cy.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $b8sgr.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $cEHh7.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $9f7f47d6423aa49d$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing' || state.status === 'processed') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $b8sgr.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
	 * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
	 * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
	 * completes with failure then the Promise will resolve to false.
	 */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $0Bueq.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $0Bueq.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $b8sgr.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
	 * Calls to site-scoped EmojiResource to delete emoji
	 * @param emoji media emoji to delete
	 * @returns Promise.resolve() if success and Promise.reject() for failure
	 */ deleteEmoji(emoji) {
        if (!(0, $5B9Cy.isMediaEmoji)(emoji) && !(0, $5B9Cy.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("cEHh7", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $2a03c62fd3cc05ea$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $2a03c62fd3cc05ea$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $2a03c62fd3cc05ea$export$8b3e87ea56c3a345);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9z04W = parcelRequire("9z04W");
const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $2a03c62fd3cc05ea$export$f92e83e86b03c398 = new Map();
const $2a03c62fd3cc05ea$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $9z04W.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $2a03c62fd3cc05ea$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $9z04W.MediaClient)(mediaClientConfig);
        $2a03c62fd3cc05ea$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>$2a03c62fd3cc05ea$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};
const $2a03c62fd3cc05ea$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("9z04W", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $a9f77c891230da5c$export$fba8b4ca6d386aec);

var $7n9mn = parcelRequire("7n9mn");
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");

var $1FyHg = parcelRequire("1FyHg");

var $iKPaV = parcelRequire("iKPaV");

var $5eAc2 = parcelRequire("5eAc2");
parcelRequire("8HaZs");
var $fN64m = parcelRequire("fN64m");

class $a9f77c891230da5c$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $fN64m.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $1FyHg.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $gPrGh.ChunkHashAlgorithm).Sha256 : (0, $gPrGh.ChunkHashAlgorithm).Sha1,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $iKPaV.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
        this.stargate = new (0, $5eAc2.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("2Gajd"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("LmkUS", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("6a8j4")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("hQvj4")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("hQvj4")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("gPrGh")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $6a8j4 = parcelRequire("6a8j4");

var $hQvj4 = parcelRequire("hQvj4");

var $gPrGh = parcelRequire("gPrGh");

});
parcelRegister("6a8j4", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $dc598dfdde7cc536$export$8cef61637918b288);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $dc598dfdde7cc536$export$8cef61637918b288 = {
    streams: new (0, $iwKVT.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $7n9mn.EventEmitter2)()
};

});
parcelRegister("iwKVT", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("hQvj4", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $449c85d7d5bc4f1f$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $449c85d7d5bc4f1f$export$17f6055767a8d96a);
function $449c85d7d5bc4f1f$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $449c85d7d5bc4f1f$export$17f6055767a8d96a = (auth)=>{
    if ($449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("gPrGh", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $506f1dfda055692a$export$d3e73a50cc549c2e);
var $506f1dfda055692a$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("1FyHg", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $5d0b8a2b8f8558c8$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $5d0b8a2b8f8558c8$export$20f9315304dd6726);
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");
var $hQvj4 = parcelRequire("hQvj4");

var $7E56q = parcelRequire("7E56q");

var $7LFAu = parcelRequire("7LFAu");

var $1As4I = parcelRequire("1As4I");
var $hzvnk = parcelRequire("hzvnk");

var $ale1y = parcelRequire("ale1y");

var $eeVEv = parcelRequire("eeVEv");

var $5cMkQ = parcelRequire("5cMkQ");

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $5d0b8a2b8f8558c8$var$MEDIA_API_REGION = 'media-api-region';
const $5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $5d0b8a2b8f8558c8$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $7E56q.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $7E56q.MAX_RESOLUTION),
            height: (0, $7E56q.MAX_RESOLUTION)
        } : {}
    };
};
const $5d0b8a2b8f8558c8$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $5d0b8a2b8f8558c8$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $VSDnB.fg)('platform_media_cdn_delivery')) {
        if ((0, $h2NC7.isCommercial)()) result += '/cdn';
    }
    return result;
};
class $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $5cMkQ.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $5cMkQ.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $gPrGh.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $5d0b8a2b8f8558c8$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
        return (0, $eeVEv.mapToMediaCdnUrl)((0, $ale1y.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $ale1y.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
        return (0, $eeVEv.mapToMediaCdnUrl)((0, $ale1y.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $7LFAu.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $7E56q.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $ale1y.createUrl)((0, $eeVEv.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $5d0b8a2b8f8558c8$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $ale1y.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $ale1y.defaultShouldRetryError)(err) || (0, $1As4I.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $hQvj4.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $ale1y.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $eeVEv.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $hzvnk.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $hzvnk.request)(url, {
            method: 'HEAD',
            traceContext: (0, $ale1y.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $5d0b8a2b8f8558c8$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $5d0b8a2b8f8558c8$export$c8b741e18397852a = ()=>{
    return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT);
};
const $5d0b8a2b8f8558c8$export$20f9315304dd6726 = ()=>{
    return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION);
};

});
parcelRegister("7E56q", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $7a454a77a18dd963$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $7a454a77a18dd963$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $7a454a77a18dd963$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $7a454a77a18dd963$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $7a454a77a18dd963$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $7a454a77a18dd963$export$f14f521f3d306044);

var $749LC = parcelRequire("749LC");
const $7a454a77a18dd963$export$860a16125e30000b = 'recents';
const $7a454a77a18dd963$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $7a454a77a18dd963$export$6e70f30e392bc53f = 4096;
const $7a454a77a18dd963$export$c1abb8bab1e615cd = 5 * (0, $749LC.DATA_UNIT).MB;
const $7a454a77a18dd963$export$3d5157f0def70e54 = 1000;
const $7a454a77a18dd963$export$f14f521f3d306044 = 2 * (0, $749LC.DATA_UNIT).TB;

});
parcelRegister("749LC", function(module, exports) {

$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $330ebd66cbfb5bbe$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $330ebd66cbfb5bbe$export$76cfea4c354af843);
const $330ebd66cbfb5bbe$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $330ebd66cbfb5bbe$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $330ebd66cbfb5bbe$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("7LFAu", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $cc56e843db2c0cea$export$1cc24defa44e7f84);

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $cc56e843db2c0cea$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $h2NC7.isCommercial)() && (0, $VSDnB.fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("h2NC7", function(module, exports) {

$parcel$export(module.exports, "isCommercial", () => $bc3c8a168b66c7db$export$df69ff6733e73e50);
function $bc3c8a168b66c7db$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});


parcelRegister("1As4I", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $a9b96946563d0d09$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $a9b96946563d0d09$export$3717b1ffef4428ea);

var $gFZHi = parcelRequire("gFZHi");
class $a9b96946563d0d09$export$43ee7d0e4f429743 extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $a9b96946563d0d09$export$3717b1ffef4428ea(err) {
    return err instanceof $a9b96946563d0d09$export$43ee7d0e4f429743;
}

});
parcelRegister("gFZHi", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $fd6342ef86e499fe$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $fd6342ef86e499fe$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $fd6342ef86e499fe$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $fd6342ef86e499fe$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $fd6342ef86e499fe$export$c2b89b9a32286816);

var $loYHr = parcelRequire("loYHr");
class $fd6342ef86e499fe$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fd6342ef86e499fe$export$e574d1724215079f extends $fd6342ef86e499fe$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $fd6342ef86e499fe$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $fd6342ef86e499fe$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $fd6342ef86e499fe$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $fd6342ef86e499fe$export$e574d1724215079f(error?.reason || 'unknown-reason', error.metadata, error.innerError);
};
const $fd6342ef86e499fe$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("loYHr", function(module, exports) {

$parcel$export(module.exports, "getMediaClientErrorReason", () => $8608a1f56c9594c2$export$c15d72765ee2baa4);
function $8608a1f56c9594c2$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $8608a1f56c9594c2$export$c15d72765ee2baa4(err) {
    return $8608a1f56c9594c2$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("hzvnk", function(module, exports) {

$parcel$export(module.exports, "request", () => $ac16e0b7f5d65450$export$b5fe3f66a567bec0);

var $1As4I = parcelRequire("1As4I");

var $ale1y = parcelRequire("ale1y");
async function $ac16e0b7f5d65450$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $ale1y.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $ale1y.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $ale1y.createProcessFetchResponse)(metadata));
    return (0, $ale1y.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("ale1y", function(module, exports) {

$parcel$export(module.exports, "extendTraceContext", () => $96f7b73b7943f312$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $96f7b73b7943f312$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $96f7b73b7943f312$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $96f7b73b7943f312$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $96f7b73b7943f312$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $96f7b73b7943f312$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $96f7b73b7943f312$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $96f7b73b7943f312$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $96f7b73b7943f312$export$6e2e477edb7d6032);
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");

var $27T0s = parcelRequire("27T0s");

var $3JV6R = parcelRequire("3JV6R");

var $1As4I = parcelRequire("1As4I");
const $96f7b73b7943f312$var$getStatusCode = (error)=>(0, $1As4I.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $96f7b73b7943f312$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $96f7b73b7943f312$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $96f7b73b7943f312$export$bc96a6a479480590(error) {
    const statusCode = error && $96f7b73b7943f312$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $96f7b73b7943f312$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $27T0s.getRandomHex)(8)
    } : undefined;
const $96f7b73b7943f312$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $96f7b73b7943f312$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$96f7b73b7943f312$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$96f7b73b7943f312$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $96f7b73b7943f312$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $96f7b73b7943f312$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $3JV6R.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $96f7b73b7943f312$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$96f7b73b7943f312$export$eaf4479116d2f925(auth),
        ...$96f7b73b7943f312$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $96f7b73b7943f312$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $1As4I.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $96f7b73b7943f312$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $1As4I.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $96f7b73b7943f312$export$fee2242cbb339663 = (err)=>{
    const statusCode = $96f7b73b7943f312$var$getStatusCode(err);
    return $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $96f7b73b7943f312$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $96f7b73b7943f312$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $1As4I.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $96f7b73b7943f312$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$96f7b73b7943f312$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $96f7b73b7943f312$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $96f7b73b7943f312$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($96f7b73b7943f312$export$de0b576cf7ce4a53(err)) throw new (0, $1As4I.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $1As4I.isRequestError)(lastError)) throw $96f7b73b7943f312$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $1As4I.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $96f7b73b7943f312$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $96f7b73b7943f312$export$6397609af718d008(statusCode);
    return new (0, $1As4I.RequestError)(reason, {
        ...metadata,
        ...$96f7b73b7943f312$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $96f7b73b7943f312$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $96f7b73b7943f312$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("27T0s", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $5713248736bc73bb$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $5713248736bc73bb$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $5713248736bc73bb$export$456b25e3a9b4a843);
const $5713248736bc73bb$export$fce6876652108ab = (value)=>value === undefined;
const $5713248736bc73bb$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $5713248736bc73bb$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $5713248736bc73bb$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $5713248736bc73bb$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $5713248736bc73bb$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $5713248736bc73bb$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
    }
    else randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("3JV6R", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $30be3f63a223d0a0$export$6833b130611df767);
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");
function $30be3f63a223d0a0$export$6833b130611df767(auth) {
    if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("eeVEv", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $ac061c5da59ee1d7$export$fb88a576cf28364d);

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $ac061c5da59ee1d7$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $ac061c5da59ee1d7$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!(0, $h2NC7.isCommercial)() || tokenLength > $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $VSDnB.fg)('platform_media_cdn_delivery') && (0, $VSDnB.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $ac061c5da59ee1d7$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("5cMkQ", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $c6441b149d7d138c$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $c6441b149d7d138c$export$5211e1371264aec3);

var $ciNTb = parcelRequire("ciNTb");

var $irn0C = parcelRequire("irn0C");
const $c6441b149d7d138c$export$560085fe411c0660 = 10000;
const $c6441b149d7d138c$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $c6441b149d7d138c$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $irn0C.rejectTimeout)(authProviderTimeout, new (0, $ciNTb.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $ciNTb.MediaStoreError)) throw err;
        throw new (0, $ciNTb.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $ciNTb.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $c6441b149d7d138c$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $ciNTb.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("ciNTb", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $63300db0f534a20c$export$b78480bd311630bc);

var $gFZHi = parcelRequire("gFZHi");
class $63300db0f534a20c$export$b78480bd311630bc extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $63300db0f534a20c$export$8d2a9b675b2ce37a(err) {
    return err instanceof $63300db0f534a20c$export$b78480bd311630bc;
}

});

parcelRegister("irn0C", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $974e005d07aa0732$export$cf2d2a1124beacb2);
const $974e005d07aa0732$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $974e005d07aa0732$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("iKPaV", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $acdec836078e8c40$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("gpU3c")).FileFetcherError);

var $aZdZn = parcelRequire("aZdZn");

var $cVFxd = parcelRequire("cVFxd");

var $bXrHm = parcelRequire("bXrHm");
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");

var $txcJN = parcelRequire("txcJN");

var $1FyHg = parcelRequire("1FyHg");

var $1Pp1U = parcelRequire("1Pp1U");

var $749LC = parcelRequire("749LC");

var $gpU3c = parcelRequire("gpU3c");

var $i57HF = parcelRequire("i57HF");

var $hkwMq = parcelRequire("hkwMq");

var $bfb59 = parcelRequire("bfb59");

var $7E56q = parcelRequire("7E56q");

var $6CZ6k = parcelRequire("6CZ6k");

var $7p3Ot = parcelRequire("7p3Ot");

var $lVahM = parcelRequire("lVahM");

var $dhdZw = parcelRequire("dhdZw");

var $gayAy = parcelRequire("gayAy");

var $j1BIJ = parcelRequire("j1BIJ");
var $lYDAe = parcelRequire("lYDAe");

var $29M1K = parcelRequire("29M1K");

var $2Mh8o = parcelRequire("2Mh8o");

var $jzW7G = parcelRequire("jzW7G");

var $gR4o6 = parcelRequire("gR4o6");

var $dJ905 = parcelRequire("dJ905");

var $9KWg9 = parcelRequire("9KWg9");
parcelRequire("8HaZs");
var $fN64m = parcelRequire("fN64m");

var $kFeQ4 = parcelRequire("kFeQ4");

var $ale1y = parcelRequire("ale1y");

var $gFZHi = parcelRequire("gFZHi");
const $acdec836078e8c40$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $acdec836078e8c40$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $acdec836078e8c40$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $fN64m.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $gFZHi.isCommonMediaClientError)(error)) return (0, $gFZHi.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $gFZHi.CommonMediaClientError)(error);
                return (0, $gFZHi.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $gFZHi.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $gFZHi.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $2Mh8o.createMediaSubject)();
            const poll = new (0, $dJ905.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $749LC.isNotFoundMediaItemDetails)(response)) throw new (0, $gpU3c.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $9KWg9.isEmptyFile)(response)) throw new (0, $gpU3c.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $1Pp1U.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $gayAy.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $lVahM.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.dataloader = (0, $7p3Ot.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $kFeQ4.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(id)) {
            const subject = (0, $2Mh8o.createMediaSubject)();
            const err = new (0, $gpU3c.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $j1BIJ.fromObservable)(subject);
        }
        if (forceRefresh) (0, $hkwMq.getFileStreamsCache)().remove(id);
        return (0, $j1BIJ.fromObservable)((0, $hkwMq.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $lYDAe.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $2Mh8o.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $hkwMq.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $29M1K.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $2Mh8o.createMediaSubject)();
        (0, $hkwMq.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $aZdZn.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $cVFxd.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $dhdZw.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $i57HF.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $j1BIJ.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $txcJN.downloadUrl)(url, {
            name: name
        });
        (0, $bfb59.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $7E56q.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $ale1y.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $1FyHg.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $hQvj4.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $hkwMq.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($acdec836078e8c40$var$isCopySourceFileWithToken(source) && $acdec836078e8c40$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $jzW7G.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $1Pp1U.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $2Mh8o.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $1Pp1U.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $1Pp1U.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $gR4o6.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $dhdZw.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $dhdZw.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $1Pp1U.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $1Pp1U.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $1Pp1U.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $hkwMq.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $2Mh8o.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("txcJN", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $4c4bd5defea17306$export$8a96edb1c96563f4);
const $4c4bd5defea17306$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("1Pp1U", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $8f64b07ac8c4c4df$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $8f64b07ac8c4c4df$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $8f64b07ac8c4c4df$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $8f64b07ac8c4c4df$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $8f64b07ac8c4c4df$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $8f64b07ac8c4c4df$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $8f64b07ac8c4c4df$export$8f33148a37b0c72f);
$parcel$export(module.exports, "isImageRepresentationReady", () => $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $8f64b07ac8c4c4df$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $8f64b07ac8c4c4df$export$ea3730792e8bebfb);
const $8f64b07ac8c4c4df$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $8f64b07ac8c4c4df$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $8f64b07ac8c4c4df$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $8f64b07ac8c4c4df$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $8f64b07ac8c4c4df$export$92dd692b31e42e64 = (fileState)=>!$8f64b07ac8c4c4df$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $8f64b07ac8c4c4df$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $8f64b07ac8c4c4df$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $8f64b07ac8c4c4df$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $8f64b07ac8c4c4df$export$ea3730792e8bebfb = (id, item)=>{
    return $8f64b07ac8c4c4df$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("gpU3c", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $5a4b48edf9ec6627$export$e3e60f0dab8641de);

var $gFZHi = parcelRequire("gFZHi");
class $5a4b48edf9ec6627$export$e3e60f0dab8641de extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $5a4b48edf9ec6627$export$5c3435f75ce0ce70(err) {
    return err instanceof $5a4b48edf9ec6627$export$e3e60f0dab8641de;
}

});

parcelRegister("i57HF", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $8cd2ca9b1610ac88$export$a5575dbeeffdad98);

var $fEpeZ = parcelRequire("fEpeZ");

var $gI62y = parcelRequire("gI62y");

var $ib0Rz = parcelRequire("ib0Rz");

var $f6rzU = parcelRequire("f6rzU");

var $20Dmg = parcelRequire("20Dmg");

var $7E56q = parcelRequire("7E56q");

var $empHz = parcelRequire("empHz");
const $8cd2ca9b1610ac88$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $f6rzU.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $8cd2ca9b1610ac88$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $8cd2ca9b1610ac88$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $8cd2ca9b1610ac88$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $8cd2ca9b1610ac88$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $8cd2ca9b1610ac88$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $7E56q.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $empHz.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $empHz.fileSizeError)) callbacks?.onUploadFinish(new (0, $20Dmg.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $fEpeZ.chunkinator)(content, {
        hashingFunction: (blob)=>$8cd2ca9b1610ac88$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $8cd2ca9b1610ac88$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $7E56q.PROCESSING_BATCH_SIZE),
        processingFunction: $8cd2ca9b1610ac88$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $gI62y.from)(deferredUploadId).pipe((0, $ib0Rz.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $ib0Rz.concatMap)(()=>(0, $gI62y.from)($8cd2ca9b1610ac88$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $8cd2ca9b1610ac88$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("fEpeZ", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $2c9b70a291565367$export$9ab6bef3838698f8);

var $j7Dz8 = parcelRequire("j7Dz8");

var $ib0Rz = parcelRequire("ib0Rz");

var $9RLLl = parcelRequire("9RLLl");

var $bXPjr = parcelRequire("bXPjr");

var $dglPr = parcelRequire("dglPr");

var $kDczJ = parcelRequire("kDczJ");

var $4Vmg1 = parcelRequire("4Vmg1");

var $6SPPN = parcelRequire("6SPPN");

var $RsgFX = parcelRequire("RsgFX");

var $gI62y = parcelRequire("gI62y");
const $2c9b70a291565367$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $bXPjr.fromPromise)((0, $RsgFX.fetchBlob)(file)).pipe((0, $ib0Rz.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $dglPr.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $kDczJ.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $4Vmg1.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $j7Dz8.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $6SPPN.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $ib0Rz.concatMap)((batchedChunks)=>{
            return (0, $gI62y.from)(batchedChunks);
        }), (0, $9RLLl.bufferCount)(totalChunks));
    }));
const $2c9b70a291565367$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $2c9b70a291565367$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("dglPr", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $f0508944ab60c7e6$export$5b92d769f2f57509);

var $eTa7E = parcelRequire("eTa7E");

var $cVFxd = parcelRequire("cVFxd");
const $f0508944ab60c7e6$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $eTa7E.range)(0, totalChunks).pipe((0, $cVFxd.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("kDczJ", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $3a9c605917062ecc$export$d5f5a550a38ec367);

var $RsgFX = parcelRequire("RsgFX");
const $3a9c605917062ecc$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $3a9c605917062ecc$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $RsgFX.asyncMap)($3a9c605917062ecc$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("RsgFX", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $32ba0ece4537a1a3$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $32ba0ece4537a1a3$export$707ee4c4c95d39e3);

var $kVLXA = parcelRequire("kVLXA");

var $80gxR = parcelRequire("80gxR");
async function $32ba0ece4537a1a3$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $32ba0ece4537a1a3$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $32ba0ece4537a1a3$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $kVLXA.Observable)((sub)=>{
            notifiers.push($32ba0ece4537a1a3$var$notify(project(value), sub, onReady));
        });
};
const $32ba0ece4537a1a3$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $80gxR.mergeMap)($32ba0ece4537a1a3$var$mapper(project), concurrent);

});


parcelRegister("4Vmg1", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $a4f565ebdd47f0f4$export$94ce0f3fcf999415);

var $RsgFX = parcelRequire("RsgFX");
const $a4f565ebdd47f0f4$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $RsgFX.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("6SPPN", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $389997e3e47b2450$export$2f21790600302ed);

var $9RLLl = parcelRequire("9RLLl");

var $ib0Rz = parcelRequire("ib0Rz");
const $389997e3e47b2450$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $9RLLl.bufferCount)(options.batchSize)).pipe((0, $ib0Rz.concatMap)(process));
};

});


parcelRegister("f6rzU", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $8249c54a4574cd31$export$14b114effbc08b6b);
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");
let $8249c54a4574cd31$var$hasher = null;
let $8249c54a4574cd31$var$sha256Hasher = null;
const $8249c54a4574cd31$export$b7d263e6bc26b29a = ()=>$8249c54a4574cd31$var$hasher = null;



const $8249c54a4574cd31$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $gPrGh.ChunkHashAlgorithm).Sha256) {
        if (!$8249c54a4574cd31$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("jxiky"));
            $8249c54a4574cd31$var$sha256Hasher = new SimpleHasher();
        }
        return $8249c54a4574cd31$var$sha256Hasher;
    } else if (!$8249c54a4574cd31$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("cm58L"));
        $8249c54a4574cd31$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("dV64f"));
        $8249c54a4574cd31$var$hasher = new SimpleHasher();
    }
    return $8249c54a4574cd31$var$hasher;
};

});
parcelRegister("jxiky", function(module, exports) {

let $e38f51719a1cb6a4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e38f51719a1cb6a4$var$load("istkm").then(()=>parcelRequire('kXp7T'));

});

parcelRegister("cm58L", function(module, exports) {

let $8feb86df4270b390$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8feb86df4270b390$var$load("cM9em"),
    $8feb86df4270b390$var$load("fr9NE"),
    $8feb86df4270b390$var$load("l0S2x")
]).then(()=>parcelRequire('3Gx8H'));

});

parcelRegister("dV64f", function(module, exports) {

let $a2254e17d9791368$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a2254e17d9791368$var$load("cM9em"),
    $a2254e17d9791368$var$load("fr9NE"),
    $a2254e17d9791368$var$load("iIdh2")
]).then(()=>parcelRequire('e4mxx'));

});


parcelRegister("20Dmg", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $5ee433d2b5ace7bb$export$515240c3f059c807);

var $gFZHi = parcelRequire("gFZHi");
class $5ee433d2b5ace7bb$export$515240c3f059c807 extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $5ee433d2b5ace7bb$export$80ee180172bc336(err) {
    return err instanceof $5ee433d2b5ace7bb$export$515240c3f059c807;
}

});

parcelRegister("empHz", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $247cdc788c0fb235$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $247cdc788c0fb235$export$71f452e02035c1e2);

var $749LC = parcelRequire("749LC");

var $7E56q = parcelRequire("7E56q");
const $247cdc788c0fb235$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $247cdc788c0fb235$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $7E56q.MAX_UPLOAD_FILE_SIZE)) throw new Error($247cdc788c0fb235$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $749LC.DATA_UNIT).GB) return 5 * (0, $749LC.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $749LC.DATA_UNIT).GB && fileSize <= 50 * (0, $749LC.DATA_UNIT).GB) return 50 * (0, $749LC.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $749LC.DATA_UNIT).GB && fileSize <= 0.95 * (0, $749LC.DATA_UNIT).TB) return 100 * (0, $749LC.DATA_UNIT).MB;
    return 210 * (0, $749LC.DATA_UNIT).MB;
};

});


parcelRegister("hkwMq", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $451397184147c26f$export$f2f061938c1e6810);
class $451397184147c26f$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $451397184147c26f$var$streamCache;

const $451397184147c26f$export$f2f061938c1e6810 = ()=>{
    if (!$451397184147c26f$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("6a8j4")).mediaState;
        $451397184147c26f$var$streamCache = new $451397184147c26f$export$4293896e79732236(mediaState.streams);
    }
    return $451397184147c26f$var$streamCache;
};

});

parcelRegister("bfb59", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $22065e01bf236cb8$export$68d003d3105952ad);
parcelRequire("LmkUS");
var $6a8j4 = parcelRequire("6a8j4");
const $22065e01bf236cb8$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $6a8j4.mediaState).eventEmitter) return (0, $6a8j4.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("6CZ6k", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5k7LC = parcelRequire("5k7LC");
var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $4d35b0145f276bfe$var$_byteToHex = [];
for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
function $4d35b0145f276bfe$var$unparse(buf, offset) {
    var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
    else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("7p3Ot", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $40dc831f91888cf8$export$ae188fee39529b82);

var $hhZW9 = parcelRequire("hhZW9");

var $27T0s = parcelRequire("27T0s");
const $40dc831f91888cf8$export$b79d95ee17a87a = 100;
const $40dc831f91888cf8$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $40dc831f91888cf8$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $40dc831f91888cf8$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $40dc831f91888cf8$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $40dc831f91888cf8$var$makeCacheKey(id, collection);
        if ($40dc831f91888cf8$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($40dc831f91888cf8$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $40dc831f91888cf8$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $27T0s.getRandomHex)(8),
                spanId: (0, $27T0s.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $40dc831f91888cf8$export$71cd2e8f8162d47b(keys, items);
    };
}
function $40dc831f91888cf8$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))($40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $40dc831f91888cf8$export$b79d95ee17a87a
    });
}

});
parcelRegister("hhZW9", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $c964119340a5ebe3$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
        this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $c964119340a5ebe3$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
    if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
    $c964119340a5ebe3$var$resolvedPromise.then(function() {
        $6cAn5.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $c964119340a5ebe3$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $c964119340a5ebe3$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $c964119340a5ebe3$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $c964119340a5ebe3$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $c964119340a5ebe3$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $c964119340a5ebe3$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $c964119340a5ebe3$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $c964119340a5ebe3$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $c964119340a5ebe3$var$DataLoader;

});


parcelRegister("lVahM", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $748ba0ab0f854341$export$ac3214931ffd82af);

var $jzW7G = parcelRequire("jzW7G");
const $748ba0ab0f854341$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $jzW7G.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("jzW7G", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $08d056d70136c4e2$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser);

var $92ewp = parcelRequire("92ewp");

var $8GKRF = parcelRequire("8GKRF");

var $lF4MN = parcelRequire("lF4MN");
const $08d056d70136c4e2$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $92ewp.isArchive)(mimeType)) return 'archive';
    if ((0, $8GKRF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $8GKRF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $8GKRF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $8GKRF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("92ewp", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $addf45fda6198a62$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $addf45fda6198a62$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("8GKRF", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $3af4ecf7d6cb882c$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $3af4ecf7d6cb882c$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$55ca6cdaf6093034 = (mimeType)=>$3af4ecf7d6cb882c$export$74325e3c843a9555(mimeType) || $3af4ecf7d6cb882c$export$c021f2623a75015f(mimeType) || $3af4ecf7d6cb882c$export$ff36075ea755a717(mimeType) || $3af4ecf7d6cb882c$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("lF4MN", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $8b8147e427110cee$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $8b8147e427110cee$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $8b8147e427110cee$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $8b8147e427110cee$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $8b8147e427110cee$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $8b8147e427110cee$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$548d9148a80556a3 = (mimeType)=>$8b8147e427110cee$export$e9a065a80f76311e(mimeType) || $8b8147e427110cee$export$86baad7a89d908e9(mimeType) || $8b8147e427110cee$export$8cba23825d020bbb(mimeType) || $8b8147e427110cee$export$9c2b4de5fdca2ce3(mimeType) || $8b8147e427110cee$export$94e1479e01d2af53(mimeType);

});



parcelRegister("dhdZw", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $c0fce003746ff4f7$export$89097c0ec1e0dee1);

var $1Pp1U = parcelRequire("1Pp1U");
const $c0fce003746ff4f7$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $1Pp1U.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("gayAy", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $0fff1104576a2bb3$export$ed17558b11b88056);
const $0fff1104576a2bb3$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("j1BIJ", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $6582fd60bc4bbd36$export$4b2432e2d8723823);

var $2Mh8o = parcelRequire("2Mh8o");
function $6582fd60bc4bbd36$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $6582fd60bc4bbd36$export$8659d1f07d151381(item) {
    return $6582fd60bc4bbd36$export$4b2432e2d8723823((0, $2Mh8o.createMediaSubject)(item));
}

});
parcelRegister("2Mh8o", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $c9b8fad0d34272f1$export$bc76d51553fa5e35);

var $dZ0DN = parcelRequire("dZ0DN");
function $c9b8fad0d34272f1$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $dZ0DN.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("lYDAe", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $44429e0ad2a9ded6$export$4dbaaf6c79705e6c);

var $aZdZn = parcelRequire("aZdZn");
const $44429e0ad2a9ded6$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aZdZn.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("29M1K", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $c92d9e8096a99b5b$export$71797c284d89a3e1);

var $8IWWt = parcelRequire("8IWWt");

var $5CbXO = parcelRequire("5CbXO");
const $c92d9e8096a99b5b$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $8IWWt.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $5CbXO.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("8IWWt", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $094f7e5912c5e863$export$a1c3205f28a20414);
const $094f7e5912c5e863$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("5CbXO", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $3629651e482443d2$export$62aabd5ff85d0451);
const $3629651e482443d2$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("gR4o6", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $81fca2ad541e7785$export$2ccdd6f9a9eba6a);

var $8GKRF = parcelRequire("8GKRF");
var $lF4MN = parcelRequire("lF4MN");

var $5CbXO = parcelRequire("5CbXO");
async function $81fca2ad541e7785$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $lF4MN.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $5CbXO.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("dJ905", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $a9b60fcbc1595cd8$export$4c54d536f8e37dc2);

var $j8kdR = parcelRequire("j8kdR");
const $a9b60fcbc1595cd8$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $a9b60fcbc1595cd8$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$a9b60fcbc1595cd8$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $j8kdR.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $j8kdR.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("j8kdR", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $ba72cde1b79a6066$export$c3748c310e92340a);

var $gFZHi = parcelRequire("gFZHi");
class $ba72cde1b79a6066$export$c3748c310e92340a extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $ba72cde1b79a6066$export$541e3e52eea6fece(err) {
    return err instanceof $ba72cde1b79a6066$export$c3748c310e92340a;
}

});


parcelRegister("9KWg9", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $6625df65da5f0486$export$728192ce8dd94659);
const $6625df65da5f0486$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $6625df65da5f0486$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $6625df65da5f0486$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("8HaZs", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("fN64m")).mediaStore);

var $fN64m = parcelRequire("fN64m");

});
parcelRegister("fN64m", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $df71566ec1e8fa2a$export$5785580dea19518d);

var $bIv98 = parcelRequire("bIv98");

var $70n8Q = parcelRequire("70n8Q");

var $ee7sp = parcelRequire("ee7sp");
const $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools = (0, $ee7sp.createStore)()((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
        files: {}
    }))));
const $df71566ec1e8fa2a$var$mediaStoreWithDevtools = (0, $ee7sp.createStore)()((0, $bIv98.devtools)((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
        files: {}
    })))));
const $df71566ec1e8fa2a$export$5785580dea19518d = $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools;
const $df71566ec1e8fa2a$export$503459913a0dc356 = (initialStore)=>{
    return (0, $ee7sp.createStore)()((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("bIv98", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $887bf6c78f4461c3$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $887bf6c78f4461c3$export$5c593627aef9f076);
var $887bf6c78f4461c3$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $887bf6c78f4461c3$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $887bf6c78f4461c3$export$4feba8a1bc8e9afd = $887bf6c78f4461c3$var$reduxImpl;
const $887bf6c78f4461c3$var$trackedConnections = /* @__PURE__ */ new Map();
const $887bf6c78f4461c3$var$getTrackedConnectionState = (name)=>{
    const api = $887bf6c78f4461c3$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $887bf6c78f4461c3$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $887bf6c78f4461c3$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $887bf6c78f4461c3$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $887bf6c78f4461c3$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $887bf6c78f4461c3$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$887bf6c78f4461c3$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $887bf6c78f4461c3$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $887bf6c78f4461c3$export$6922d3b3a607469e = $887bf6c78f4461c3$var$devtoolsImpl;
const $887bf6c78f4461c3$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $887bf6c78f4461c3$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $887bf6c78f4461c3$export$5c593627aef9f076 = $887bf6c78f4461c3$var$subscribeWithSelectorImpl;
const $887bf6c78f4461c3$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $887bf6c78f4461c3$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $887bf6c78f4461c3$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $887bf6c78f4461c3$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $887bf6c78f4461c3$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $887bf6c78f4461c3$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $887bf6c78f4461c3$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $887bf6c78f4461c3$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $887bf6c78f4461c3$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $887bf6c78f4461c3$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $887bf6c78f4461c3$var$oldImpl(config, baseOptions);
    }
    return $887bf6c78f4461c3$var$newImpl(config, baseOptions);
};
const $887bf6c78f4461c3$export$9a6132153fba2e0 = $887bf6c78f4461c3$var$persistImpl;

});

parcelRegister("70n8Q", function(module, exports) {

$parcel$export(module.exports, "immer", () => $519a7bf2c276fd5a$export$428de7ec69ac95c);

var $86xFr = parcelRequire("86xFr");
const $519a7bf2c276fd5a$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $86xFr.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $519a7bf2c276fd5a$export$428de7ec69ac95c = $519a7bf2c276fd5a$var$immerImpl;

});
parcelRegister("86xFr", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $5e68ffea5fb572cb$export$2e2bcd8739ae039 = fn;

});


parcelRegister("ee7sp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $a5b82856cfbd137f$export$f51a9068ac82ea43);
var $a5b82856cfbd137f$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $a5b82856cfbd137f$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $a5b82856cfbd137f$export$f51a9068ac82ea43 = (createState)=>createState ? $a5b82856cfbd137f$var$createStoreImpl(createState) : $a5b82856cfbd137f$var$createStoreImpl;
var $a5b82856cfbd137f$export$2e2bcd8739ae039 = (createState)=>{
    if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $a5b82856cfbd137f$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("kFeQ4", function(module, exports) {

$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $22ef2bf89bf2366d$export$57945b6819e39246);

var $hhZW9 = parcelRequire("hhZW9");

var $27T0s = parcelRequire("27T0s");
const $22ef2bf89bf2366d$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $22ef2bf89bf2366d$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $27T0s.getRandomHex)(8),
                spanId: (0, $27T0s.getRandomHex)(8)
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $22ef2bf89bf2366d$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))($22ef2bf89bf2366d$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $22ef2bf89bf2366d$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("5eAc2", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $0084b28d1d44d0da$export$c66ca190f89caaac);
class $0084b28d1d44d0da$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("2Gajd", function(module, exports) {

let $1f37802c9f1d2be8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f37802c9f1d2be8$var$load("ais1M").then(()=>parcelRequire('piTsY'));

});



parcelRegister("0l85J", function(module, exports) {

$parcel$export(module.exports, "default", () => $468763407d64700f$export$2e2bcd8739ae039);

var $5B9Cy = parcelRequire("5B9Cy");

var $aEbo8 = parcelRequire("aEbo8");

var $b8sgr = parcelRequire("b8sgr");

var $iwKVT = parcelRequire("iwKVT");
const $468763407d64700f$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $468763407d64700f$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $468763407d64700f$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $b8sgr.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $5B9Cy.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($468763407d64700f$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $468763407d64700f$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $468763407d64700f$var$maxImageSize = 10000;
class $468763407d64700f$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $b8sgr.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $iwKVT.LRUMap)($468763407d64700f$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $5B9Cy.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $5B9Cy.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $5B9Cy.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $468763407d64700f$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $b8sgr.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $468763407d64700f$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $b8sgr.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $aEbo8.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $5B9Cy.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $5B9Cy.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $5B9Cy.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $468763407d64700f$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $468763407d64700f$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $468763407d64700f$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("aEbo8", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bf8241dae2d3e6$export$2e2bcd8739ae039);

var $gQ3yg = parcelRequire("gQ3yg");
const $12bf8241dae2d3e6$var$defaultConcurrentDownloadLimit = 16;
const $12bf8241dae2d3e6$var$backoffMaxDelayInMillis = 600;
const $12bf8241dae2d3e6$var$defaultMaxRetriesOnNotFound = 2;
class $12bf8241dae2d3e6$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $12bf8241dae2d3e6$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $12bf8241dae2d3e6$var$defaultMaxRetriesOnNotFound) {
        return (0, $gQ3yg.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($12bf8241dae2d3e6$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("gQ3yg", function(module, exports) {

$parcel$export(module.exports, "getNaturalImageSize", () => $0ad0cc252faa2438$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $0ad0cc252faa2438$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $0ad0cc252faa2438$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $0ad0cc252faa2438$export$f8e7886bc155c2e6);
const $0ad0cc252faa2438$var$maxEmojiSizeInBytes = 1048576;
const $0ad0cc252faa2438$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $0ad0cc252faa2438$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $0ad0cc252faa2438$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $0ad0cc252faa2438$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $0ad0cc252faa2438$var$isWebpSupported;
const $0ad0cc252faa2438$export$c5a964eb84c7fca8 = ()=>{
    if ($0ad0cc252faa2438$var$isWebpSupported !== undefined) return Promise.resolve($0ad0cc252faa2438$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $0ad0cc252faa2438$var$isWebpSupported = img.height === 2;
            resolve($0ad0cc252faa2438$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $0ad0cc252faa2438$export$f8e7886bc155c2e6 = ()=>$0ad0cc252faa2438$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("ijzU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $237e13119c8cb0fd$export$2e2bcd8739ae039);

var $dS9cn = parcelRequire("dS9cn");
const $237e13119c8cb0fd$export$866c20c059277b6 = 30;
class $237e13119c8cb0fd$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $237e13119c8cb0fd$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});


parcelRegister("d2UcN", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $350e11372b641899$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $350e11372b641899$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $350e11372b641899$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $350e11372b641899$export$1466212a1606133);

var $9AR2K = parcelRequire("9AR2K");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
var $boHLC = parcelRequire("boHLC");

var $bHWpv = parcelRequire("bHWpv");
const $350e11372b641899$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $7Zbvr.ExperienceTypes).Load,
        performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $350e11372b641899$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $7Zbvr.ExperienceTypes).Experience,
        performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
    };
};
const $350e11372b641899$var$customEmojiTimings = [
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $9AR2K.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $9AR2K.UfoEmojiTimings).METADATA_START,
        endMark: (0, $9AR2K.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $9AR2K.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $9AR2K.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $9AR2K.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $9AR2K.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $9AR2K.UfoEmojiTimings).ONLOAD_END
    }
];
const $350e11372b641899$export$615f888019c45765 = {
    'emoji-rendered': new (0, $cBycP.ConcurrentExperience)((0, $9AR2K.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $9AR2K.UfoComponentName).EMOJI
        },
        type: (0, $7Zbvr.ExperienceTypes).Operation,
        performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).Custom,
        timings: $350e11372b641899$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $cBycP.ConcurrentExperience)((0, $9AR2K.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $350e11372b641899$var$createRenderExperience((0, $9AR2K.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $boHLC.UFOExperience)((0, $9AR2K.UfoExperienceName).EMOJI_PICKER_OPENED, $350e11372b641899$var$createRenderExperience((0, $9AR2K.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $boHLC.UFOExperience)((0, $9AR2K.UfoExperienceName).EMOJI_SELECTION_RECORDED, $350e11372b641899$var$createInlineExperience((0, $9AR2K.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $boHLC.UFOExperience)((0, $9AR2K.UfoExperienceName).EMOJI_UPLOADED, $350e11372b641899$var$createInlineExperience((0, $9AR2K.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $boHLC.UFOExperience)((0, $9AR2K.UfoExperienceName).EMOJI_SEARCHED, $350e11372b641899$var$createInlineExperience((0, $9AR2K.UfoComponentName).EMOJI_PICKER))
};
const $350e11372b641899$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $bHWpv.withSampling)($350e11372b641899$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $350e11372b641899$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $350e11372b641899$export$1466212a1606133 = (providerType)=>{
    return (0, $bHWpv.withSampling)($350e11372b641899$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("bHWpv", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $8c8d9cbeece0ed73$export$dc2f0946255b3f89);
const $8c8d9cbeece0ed73$export$c7c4959fece2f3ec = {};
const $8c8d9cbeece0ed73$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($8c8d9cbeece0ed73$export$c7c4959fece2f3ec))delete $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[prop];
};
const $8c8d9cbeece0ed73$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $8c8d9cbeece0ed73$var$hasSampledFromStart = (experience)=>{
    if (!$8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $8c8d9cbeece0ed73$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id]) $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $8c8d9cbeece0ed73$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("cf5vr", function(module, exports) {

$parcel$export(module.exports, "promiseWithTimeout", () => $aa7d0d375a38202a$export$a9cd205a244d9f54);
function $aa7d0d375a38202a$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});


parcelRegister("9CGZY", function(module, exports) {

$parcel$export(module.exports, "EMOJI_SERVICEID", () => $2d9090d159781c68$export$f3c4ed49c0fff3de);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", () => $2d9090d159781c68$export$f8b39b441e3e8eb2);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", () => $2d9090d159781c68$export$2cdcb9248b6d4704);
$parcel$export(module.exports, "getServiceProvider", () => $2d9090d159781c68$export$a4c27db78169052e);
$parcel$export(module.exports, "default", () => $2d9090d159781c68$export$2e2bcd8739ae039);

var $j8DrX = parcelRequire("j8DrX");
const $2d9090d159781c68$var$providersRepository = {};
const $2d9090d159781c68$export$f3c4ed49c0fff3de = 'emoji';
const $2d9090d159781c68$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
const $2d9090d159781c68$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
const $2d9090d159781c68$var$getServiceBaseUrl = (serviceId)=>{
    if (serviceId === $2d9090d159781c68$export$f8b39b441e3e8eb2 || serviceId === $2d9090d159781c68$export$2cdcb9248b6d4704) return (0, $j8DrX.default)('ajs-fabric-emoji-url');
    return (0, $j8DrX.default)(`ajs-fabric-${serviceId}-url`);
};
const $2d9090d159781c68$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
    try {
        let serviceProvider = $2d9090d159781c68$var$providersRepository[serviceId];
        if (serviceProvider === undefined) {
            const serviceBaseUrl = $2d9090d159781c68$var$getServiceBaseUrl(serviceId);
            if (serviceBaseUrl) {
                serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                $2d9090d159781c68$var$providersRepository[serviceId] = serviceProvider;
            }
        }
        return serviceProvider;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $2d9090d159781c68$export$59790759c19337ec = ()=>{
    Object.keys($2d9090d159781c68$var$providersRepository).forEach((key)=>{
        delete $2d9090d159781c68$var$providersRepository[key];
    });
};
var $2d9090d159781c68$export$2e2bcd8739ae039 = $2d9090d159781c68$var$getServiceBaseUrl;

});


parcelRegister("4b46h", function(module, exports) {

$parcel$export(module.exports, "TaskAndDecisionProvider", () => $617649e4094f37c7$export$61b19530746739cc);
class $617649e4094f37c7$export$61b19530746739cc {
    constructor(toggleTaskCallback){
        this.toggleTaskCallback = toggleTaskCallback;
        this._toggleTaskCallback = toggleTaskCallback;
    }
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) this._toggleTaskCallback(objectKey, state);
        return Promise.resolve(state);
    }
    subscribe(_objectKey, _handler) {
    // do nothing
    }
    unsubscribe(_objectKey, _handler) {
    // do nothing
    }
    notifyRecentUpdates(_updateContext) {
    // do nothing
    }
    unsubscribeRecentUpdates(_id) {
    // do nothing
    }
}

});

parcelRegister("8wTCc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d322a9f93244712b$export$2e2bcd8739ae039);

var $92lWB = parcelRequire("92lWB");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $6wesA = parcelRequire("6wesA");
class $d322a9f93244712b$export$2e2bcd8739ae039 extends (0, $92lWB.ProjectMentionProvider) {
    // Instrument the fetch call, so we can report on any errors
    fetchMentions(url) {
        return (0, $koFzm.famaCatchAndLogFetchError)(super.fetchMentions(url), (0, $6wesA.PACKAGE_NAME), (0, $gl0PU.toErrorId)('getMentions'), (0, $gl0PU.toErrorMessage)('Failed to fetch mentions for multiline field configuration'));
    }
}

});
parcelRegister("92lWB", function(module, exports) {

$parcel$export(module.exports, "ProjectMentionProvider", () => $e29d82157b4dfb7f$export$40976f7091c70c78);

var $ebyGx = parcelRequire("ebyGx");

var $gVfsM = parcelRequire("gVfsM");
class $e29d82157b4dfb7f$export$40976f7091c70c78 extends (0, $gVfsM.AbstractMentionProvider) {
    constructor(baseUrl, projectKey, projectType){
        super(baseUrl, projectType), this.getQueryString = (query)=>(0, $ebyGx.stringify)({
                query: query,
                projectKey: this.projectKey,
                maxResults: 10
            }), this.getUrl = (queryString)=>`${this.baseUrl}/rest/api/2/user/viewissue/search?${queryString}`, this.shouldHighlightMention = (mention)=>mention.id === this.projectKey;
        this.projectKey = projectKey;
    }
}

});
parcelRegister("gVfsM", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionProvider", () => $b8e30b1d7a2c4e16$export$1503942bd70a06a4);

var $lFKmC = parcelRequire("lFKmC");

var $hGgHi = parcelRequire("hGgHi");

var $3mm6g = parcelRequire("3mm6g");

var $4Pf62 = parcelRequire("4Pf62");

var $7f4tk = parcelRequire("7f4tk");

var $ecbCU = parcelRequire("ecbCU");

var $4QRz9 = parcelRequire("4QRz9");
const $b8e30b1d7a2c4e16$var$MENTION_DEBOUNCE_MS = 150;
class $b8e30b1d7a2c4e16$export$1503942bd70a06a4 extends (0, $3mm6g.AbstractMentionResource) {
    constructor(baseUrl, projectType, createAnalyticsEvent){
        super(), this.debouncedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            return this.search(query, contextIdentifier).then((mentionResult)=>{
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) {
                    this.lastSearchTime = currentSearchTime;
                    this._notifyListeners(mentionResult, {
                        duration: Date.now() - currentSearchTime
                    });
                }
                this._notifyAllResultsListeners(mentionResult);
            }).catch((e)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(query) && query.length > 0) this.activeSearches.delete(query);
                this._notifyErrorListeners(e);
            });
        }, $b8e30b1d7a2c4e16$var$MENTION_DEBOUNCE_MS);
        this.baseUrl = baseUrl;
        this.lastSearchTime = 0;
        this.activeSearches = new Set();
        this.productName = (0, $4QRz9.subProductFromProjectType)(projectType);
        this.userRole = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin ? 'admin' : 'basic';
        this.onInviteItemClick = ()=>{
            (0, $ecbCU.triggerOpenDrawer)(createAnalyticsEvent ?? null, {
                inviteFlow: 'mention'
            });
        };
        this.shouldEnableInvite = true;
        this.isEligibleXProductUserInvite = false;
        this.inviteXProductUser = ()=>Promise.resolve();
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    filter(query, contextIdentifier) {
        return this.debouncedFilter(query, contextIdentifier);
    }
    search(query, context) {
        const queryString = this.getQueryString(query, context);
        const url = this.getUrl(queryString);
        this.activeSearches.add(query);
        return this.fetchMentions(url).then((users)=>users.map((user)=>({
                    name: user.displayName,
                    mentionName: user.displayName,
                    nickname: user.displayName,
                    id: user.accountId,
                    avatarUrl: user.avatarUrls['48x48']
                }))).then((mentions)=>({
                query: query,
                mentions: mentions
            }));
    }
    // Allow concrete subclasses to override this method so fetch calls can be instrumented
    fetchMentions(url) {
        return (0, $7f4tk.default)(url);
    }
}

});
parcelRegister("3mm6g", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $9565842f98e50876$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $9565842f98e50876$export$ae1fce5f69858ef3);

var $dS9cn = parcelRequire("dS9cn");

var $cqJWb = parcelRequire("cqJWb");

var $6Ctoj = parcelRequire("6Ctoj");

var $4kfbr = parcelRequire("4kfbr");

var $lFKmC = parcelRequire("lFKmC");
const $9565842f98e50876$var$MAX_QUERY_ITEMS = 100;
const $9565842f98e50876$var$MAX_NOTIFIED_ITEMS = 20;
const $9565842f98e50876$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $9565842f98e50876$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $9565842f98e50876$export$8576ba1ed2760927 extends $9565842f98e50876$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $6Ctoj.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $6Ctoj.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $9565842f98e50876$export$5a4331e3e1c43553 extends $9565842f98e50876$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $6Ctoj.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $cqJWb.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $9565842f98e50876$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dS9cn.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).INITIAL_STATE, (0, $cqJWb.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).INITIAL_STATE, (0, $cqJWb.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $9565842f98e50876$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dS9cn.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).SEARCH, (0, $cqJWb.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).SEARCH, (0, $cqJWb.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $cqJWb.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $cqJWb.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $9565842f98e50876$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $9565842f98e50876$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $9565842f98e50876$export$2e2bcd8739ae039 = $9565842f98e50876$export$5a4331e3e1c43553;

});
parcelRegister("cqJWb", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $90ca79fb430b6e09$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $90ca79fb430b6e09$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $90ca79fb430b6e09$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $90ca79fb430b6e09$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $90ca79fb430b6e09$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $90ca79fb430b6e09$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $90ca79fb430b6e09$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $90ca79fb430b6e09$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $90ca79fb430b6e09$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $90ca79fb430b6e09$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $90ca79fb430b6e09$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $90ca79fb430b6e09$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $90ca79fb430b6e09$export$4369c812aac99591);
var $90ca79fb430b6e09$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $90ca79fb430b6e09$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $90ca79fb430b6e09$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $90ca79fb430b6e09$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $90ca79fb430b6e09$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $90ca79fb430b6e09$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $90ca79fb430b6e09$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $90ca79fb430b6e09$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $90ca79fb430b6e09$export$81124e6148ca5db0[0];
}
function $90ca79fb430b6e09$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[1];
}
function $90ca79fb430b6e09$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[2];
}
function $90ca79fb430b6e09$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[3];
}
function $90ca79fb430b6e09$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $90ca79fb430b6e09$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("6Ctoj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e109bd73548e92fc$export$2e2bcd8739ae039);
let $e109bd73548e92fc$var$debugEnabled = false;
let $e109bd73548e92fc$var$stacktracesEnabled = false;
function $e109bd73548e92fc$export$748ada60eaf985cc(enable) {
    $e109bd73548e92fc$var$debugEnabled = enable;
}
function $e109bd73548e92fc$export$4f7017086af31c25(enable) {
    $e109bd73548e92fc$var$stacktracesEnabled = enable;
}
function $e109bd73548e92fc$export$2a858f450a2f66d() {
    if ($e109bd73548e92fc$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $e109bd73548e92fc$export$2e2bcd8739ae039(msg, ...args) {
    if ($e109bd73548e92fc$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("4kfbr", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $f8976e2813fe24b2$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $f8976e2813fe24b2$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $f8976e2813fe24b2$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $f8976e2813fe24b2$export$91b2fa6a0fe06408);



var $cqJWb = parcelRequire("cqJWb");
const $f8976e2813fe24b2$var$packageName = "platform-pkg";
const $f8976e2813fe24b2$var$packageVersion = "0.0.0-use.local";
const $f8976e2813fe24b2$export$245097525aef1262 = 'sli';
const $f8976e2813fe24b2$export$c724588856bbfbcf = 'smart';
const $f8976e2813fe24b2$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            attributes: {
                packageName: $f8976e2813fe24b2$var$packageName,
                packageVersion: $f8976e2813fe24b2$var$packageVersion,
                componentName: (0, $cqJWb.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $cqJWb.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        return event;
    };
const $f8976e2813fe24b2$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $f8976e2813fe24b2$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        attributes: {
            packageName: $f8976e2813fe24b2$var$packageName,
            packageVersion: $f8976e2813fe24b2$var$packageVersion,
            componentName: (0, $cqJWb.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $f8976e2813fe24b2$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $f8976e2813fe24b2$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $cqJWb.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $094ce2d9636497d7$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("ecbCU", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleDrawer", () => $6f07668563b12d68$export$48fb2d80745c5e67);
$parcel$export(module.exports, "triggerOpenDrawer", () => $6f07668563b12d68$export$b7dab610045052db);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $2fX5x = parcelRequire("2fX5x");
const $6f07668563b12d68$var$CONTROLLER_NAME = 'invite-people-drawer';
const $6f07668563b12d68$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $6f07668563b12d68$var$Store = (0, $iXqE5.createStore)({
    name: $6f07668563b12d68$var$CONTROLLER_NAME,
    initialState: $6f07668563b12d68$var$initialState,
    actions: {
        openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl })=>({ setState: setState })=>{
                (0, $2fX5x.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                (0, $2fX5x.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl
                });
            },
        closeDrawer: ()=>({ setState: setState })=>setState($6f07668563b12d68$var$initialState)
    }
});
const $6f07668563b12d68$export$48fb2d80745c5e67 = (0, $3sQ5x.createHook)($6f07668563b12d68$var$Store);
const $6f07668563b12d68$export$ac7fed664b4735b5 = (0, $gg7kZ.createContainer)($6f07668563b12d68$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $6f07668563b12d68$export$4358742cbaf4a6d4 = (0, $51nlc.createSubscriber)($6f07668563b12d68$var$Store, {
    displayName: 'InvitePeopleDrawerSubscriber',
    selector: (state)=>state.isOpen
});
const $6f07668563b12d68$export$b7dab610045052db = (createAnalyticsEvent, contextConfig)=>{
    (0, $bKpgX.defaultRegistry).getStore($6f07668563b12d68$var$Store)?.actions.openDrawer(createAnalyticsEvent, contextConfig);
};

});
parcelRegister("2fX5x", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $b69ddc7a728288ef$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $b69ddc7a728288ef$export$6815765da918b983);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $b69ddc7a728288ef$export$21b810258e82d438);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $8zOmE = parcelRequire("8zOmE");
var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");

var $d3xqi = parcelRequire("d3xqi");
const $b69ddc7a728288ef$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $5uXOq.useRef)((0, $fjcgS.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $lhVtI.getEvent)(analyticsEvent)));
        }
    };
};
const $b69ddc7a728288ef$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $b69ddc7a728288ef$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $fjcgS.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $b69ddc7a728288ef$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $d3xqi.getSourceByInviteFlow)(inviteFlow)
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $b69ddc7a728288ef$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        source: source != null && source !== '' ? source : 'unknown'
    };
    $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("d3xqi", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $1b54655f5f68975f$export$c35cd18e9d0123e3);
const $1b54655f5f68975f$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



parcelRegister("4QRz9", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $e6c9433376b7f0e7$export$246e1e2a5c86a633);

var $2vSU6 = parcelRequire("2vSU6");
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $e6c9433376b7f0e7$var$SERVICEDESK_APPLICATION_ROLE = 'jira-servicedesk';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $e6c9433376b7f0e7$var$SOFTWARE_APPLICATION_ROLE = 'jira-software';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $e6c9433376b7f0e7$var$CORE_APPLICATION_ROLE = 'jira-core';
const $e6c9433376b7f0e7$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'Jira Service Management';
        default:
            return 'Jira';
    }
};

});




parcelRegister("3sl8c", function(module, exports) {

$parcel$export(module.exports, "MultilineView", () => $65924ee233ee5fb6$export$7039582fab82240f);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7O4UO = parcelRequire("7O4UO");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $3XO6n = parcelRequire("3XO6n");

var $dq3xR = parcelRequire("dq3xR");


var $hPw0Z = parcelRequire("hPw0Z");

var $funxe = parcelRequire("funxe");

var $kSR59 = parcelRequire("kSR59");

var $6IyET = parcelRequire("6IyET");
function $65924ee233ee5fb6$var$isRelevantError(e) {
    return e.position === (0, $d2e37636a1b0be7f$export$fa640bba89c0678c);
}
function $65924ee233ee5fb6$var$getFilteredErrors(errors) {
    return errors.filter($65924ee233ee5fb6$var$isRelevantError);
}
const $65924ee233ee5fb6$var$DefaultValueErrors = ({ filteredErrors: filteredErrors })=>{
    const intl = (0, $koVbs.default)();
    if (filteredErrors.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("section", null, filteredErrors.map((e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dq3xR.default), {
            key: e.messageDescriptor.id,
            message: intl.formatMessage(e.messageDescriptor, e.values)
        })));
};
const $65924ee233ee5fb6$var$getDefaultLabel = (field)=>{
    switch(field.type){
        case 0, $3XO6n.DESCRIPTION_FIELD_TYPE:
            return (0, $kSR59.default).textDefaultDescriptionLabel;
        case 0, $3XO6n.ENVIRONMENT_FIELD_TYPE:
            return (0, $kSR59.default).environmentDefaultValueLabel;
        default:
            return (0, $kSR59.default).textDefaultValueLabel;
    }
};
const $65924ee233ee5fb6$var$getDisabledTooltipMessage = (field)=>{
    switch(field.type){
        case 0, $3XO6n.DESCRIPTION_FIELD_TYPE:
            return (0, $kSR59.default).descriptionDefaultValueDisabledTooltip;
        case 0, $3XO6n.ENVIRONMENT_FIELD_TYPE:
            return (0, $kSR59.default).environmentDefaultValueDisabledTooltip;
        default:
            return (0, $kSR59.default).textDefaultValueDisabledTooltip;
    }
};
function $65924ee233ee5fb6$var$refineDefaultValue(defaultValue) {
    /*
   * ADFs have many more properties in them but type: string is the only one that is required.
   * I wish there was some utility method to do this but as of now there isn't any.
   * I checked adf-utils and adf-schema but none export functions like this.
   *
   * (adf-utils has a validator but that one accepts `ADFEntity`.)
   */ if (typeof defaultValue === 'object' && defaultValue != null && 'type' in defaultValue && typeof defaultValue.type === 'string') return {
        ...defaultValue,
        type: defaultValue.type
    };
    return undefined;
}
const $65924ee233ee5fb6$export$7039582fab82240f = ({ field: field, onUpdate: onUpdate, fieldErrors: fieldErrors, testId: testId, tooltipDelay: tooltipDelay, ...rest })=>{
    const intl = (0, $koVbs.default)();
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const onEditorUpdate = (0, $5uXOq.useCallback)((adf)=>{
        if ((0, $6IyET.isAdfEmpty)(adf)) onUpdate({
            ...field,
            defaultValue: null
        });
        else onUpdate({
            ...field,
            defaultValue: adf
        });
    }, [
        field,
        onUpdate
    ]);
    const filteredErrors = $65924ee233ee5fb6$var$getFilteredErrors(fieldErrors);
    const isValid = filteredErrors.length === 0;
    const defaultValue = $65924ee233ee5fb6$var$refineDefaultValue(field.defaultValue);
    const editorProps = {
        ...rest,
        onUpdate: onEditorUpdate,
        disabled: isModifyDefaultValueDisabled,
        defaultValue: defaultValue
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65924ee233ee5fb6$var$DefaultValueStyled, null, !isValid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65924ee233ee5fb6$var$DefaultValueErrors, {
        filteredErrors: filteredErrors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: `${field.key}-default-value`,
        label: intl.formatMessage($65924ee233ee5fb6$var$getDefaultLabel(field))
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isModifyDefaultValueDisabled ? intl.formatMessage($65924ee233ee5fb6$var$getDisabledTooltipMessage(field)) : null,
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $funxe.AsyncEditor), editorProps))))));
};
/*
 * react-beautiful-dnd overrides the cursor to grab, but there is a contenteditable div from
 * atlaskit/editor that has text selection instead of grabbing. So let's override the cursor here too.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $65924ee233ee5fb6$var$DefaultValueStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f31jfw _19bv1jfw _otyrpxbi _1acl1kdv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("funxe", function(module, exports) {

$parcel$export(module.exports, "AsyncEditor", () => $022f9f4fbf9d6cd0$export$f2d99141810bab01);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $kxZPA = parcelRequire("kxZPA");

var $6wesA = parcelRequire("6wesA");

var $lvsgf = parcelRequire("lvsgf");

var $jMLuu = parcelRequire("jMLuu");

var $3Pqh1 = parcelRequire("3Pqh1");

var $etNH9 = parcelRequire("etNH9");
const $022f9f4fbf9d6cd0$var$ERROR_ID = 'importEditor';
const $022f9f4fbf9d6cd0$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($022f9f4fbf9d6cd0$var$Skeleton, {
        width: "44%",
        height: "42px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($022f9f4fbf9d6cd0$var$Spacer, {
        height: "22px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($022f9f4fbf9d6cd0$var$Skeleton, {
        width: "90%",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($022f9f4fbf9d6cd0$var$Spacer, {
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($022f9f4fbf9d6cd0$var$Skeleton, {
        width: "63%",
        height: "14px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($022f9f4fbf9d6cd0$var$Spacer, {
        height: "24px"
    }));
const $022f9f4fbf9d6cd0$export$65db35c377fab04b = ()=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $022f9f4fbf9d6cd0$var$errorWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error"
    }, intl.formatMessage((0, $3Pqh1.default).editorFailedToLoad)));
};
const $022f9f4fbf9d6cd0$var$renderAsyncEditor = ({ EditorContext: EditorContext, WithEditorActions: WithEditorActions, Editor: Editor, props: props, scrollableElement: scrollableElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvsgf.Consumer), null, (onRecalculateAnimatorHeight)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $etNH9.AsyncEditorView), {
            EditorContext: EditorContext,
            WithEditorActions: WithEditorActions,
            Editor: Editor,
            onRecalculateAnimatorHeight: onRecalculateAnimatorHeight,
            scrollableElement: scrollableElement,
            ...props
        }));

const $022f9f4fbf9d6cd0$var$importEditorCore = ()=>(0, $koFzm.famaCatchAndLogFetchError)((parcelRequire("l5g3R")), (0, $6wesA.PACKAGE_NAME), (0, $gl0PU.toErrorId)($022f9f4fbf9d6cd0$var$ERROR_ID), (0, $gl0PU.toErrorMessage)('Failed to async load the Atlaskit editor for multiline configuration')); // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $022f9f4fbf9d6cd0$var$LazyEditorRenderer = (0, $kxZPA.lazy)(()=>$022f9f4fbf9d6cd0$var$importEditorCore().then(({ EditorContext: EditorContext, WithEditorActions: WithEditorActions, Editor: Editor })=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMLuu.ScrollableParentConsumer), null, (scrollableParent)=>$022f9f4fbf9d6cd0$var$renderAsyncEditor({
                    EditorContext: // @ts-expect-error - TS2322 - Type 'typeof LegacyEditorContext' is not assignable to type 'ComponentType<{ children: ReactNode; }>'.
                    EditorContext,
                    WithEditorActions: WithEditorActions,
                    Editor: Editor,
                    props: props,
                    scrollableElement: scrollableParent.current
                }))), {});
const $022f9f4fbf9d6cd0$export$f2d99141810bab01 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $022f9f4fbf9d6cd0$var$ERROR_ID,
        packageName: (0, $6wesA.PACKAGE_NAME),
        teamName: "morphinecake",
        fallback: $022f9f4fbf9d6cd0$export$65db35c377fab04b
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-editor",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($022f9f4fbf9d6cd0$export$7db30d367db7d20a, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($022f9f4fbf9d6cd0$var$LazyEditorRenderer, props)));
const $022f9f4fbf9d6cd0$var$shimmer = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $022f9f4fbf9d6cd0$var$Skeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkov77o _5sag9cwz _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhkm7j4 _1itkabhq _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $022f9f4fbf9d6cd0$var$Spacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $022f9f4fbf9d6cd0$var$errorWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("lvsgf", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $4d70ebc4058c43ff$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $4d70ebc4058c43ff$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $4d70ebc4058c43ff$var$defaultValue = ()=>{};
const { Provider: $4d70ebc4058c43ff$export$2881499e37b75b9a, Consumer: $4d70ebc4058c43ff$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $5uXOq.createContext)($4d70ebc4058c43ff$var$defaultValue);

});

parcelRegister("jMLuu", function(module, exports) {

$parcel$export(module.exports, "ScrollableParentConsumer", () => $ad5def34d3b1d9b7$export$7fd688005791a385);

var $5uXOq = parcelRequire("5uXOq");
const $ad5def34d3b1d9b7$var$ScrollableParentContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    current: null
});
const $ad5def34d3b1d9b7$export$e0ee735e5b20e2dc = ({ children: children })=>{
    const scrollableParent = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad5def34d3b1d9b7$var$ScrollableParentContext.Provider, {
        value: scrollableParent
    }, children(scrollableParent));
};
const $ad5def34d3b1d9b7$export$7fd688005791a385 = $ad5def34d3b1d9b7$var$ScrollableParentContext.Consumer;

});

parcelRegister("3Pqh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd12a973f38297ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dd12a973f38297ec$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editorFailedToLoad: {
        "id": "project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-failed-to-load",
        "defaultMessage": "We couldn\u2019t load the editor. Save your changes, refresh, and try again."
    },
    editorContextErrorTitle: {
        "id": "project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-context-error-title",
        "defaultMessage": "We couldn't save your changes"
    },
    editorContextErrorMessageToRefreshPage: {
        "id": "project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-context-error-message-to-refresh-page",
        "defaultMessage": "Refresh the page and try again."
    },
    editorContextErrorMessageToReloadEditor: {
        "id": "project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-context-error-message-to-reload-editor",
        "defaultMessage": "Reload the editor and try again."
    },
    editorContextErrorAction: {
        "id": "project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-context-error-action",
        "defaultMessage": "Try again"
    }
});

});

parcelRegister("etNH9", function(module, exports) {

$parcel$export(module.exports, "AsyncEditorView", () => $2566eb4373fcc98b$export$74ce8bb86db204fe);

var $5uXOq = parcelRequire("5uXOq");

var $l1C1k = parcelRequire("l1C1k");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $6wesA = parcelRequire("6wesA");

var $4SBL6 = parcelRequire("4SBL6");

var $3Pqh1 = parcelRequire("3Pqh1");
const $2566eb4373fcc98b$export$fb8d7f40caaeea67 = ({ errorCount: errorCount, onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2566eb4373fcc98b$var$errorWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        actions: errorCount <= 2 ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: "reload-editor-error-action",
                onClick: onRetry
            }, formatMessage((0, $3Pqh1.default).editorContextErrorAction))
        ] : [],
        title: formatMessage((0, $3Pqh1.default).editorContextErrorTitle)
    }, errorCount <= 2 ? formatMessage((0, $3Pqh1.default).editorContextErrorMessageToReloadEditor) : formatMessage((0, $3Pqh1.default).editorContextErrorMessageToRefreshPage)));
};
const $2566eb4373fcc98b$var$onDefaultValueChange = (actions, onUpdate)=>()=>{
        actions.getValue().then((value)=>{
            if (!value) return;
            const doc = (0, $l1C1k.traverse)(value, {
                mention: (node)=>{
                    // Omit accessLevel as documents from the API do not include this property, and we need dirty checks to be correct
                    // @ts-expect-error - TS2339 - Property 'accessLevel' does not exist on type '{ [name: string]: any; } | undefined'.
                    const { accessLevel: accessLevel, ...attrs } = node.attrs;
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    return {
                        ...node,
                        attrs: attrs
                    };
                }
            });
            if (onUpdate && doc) onUpdate(doc);
        });
    };
const $2566eb4373fcc98b$export$74ce8bb86db204fe = (props)=>{
    const { EditorContext: EditorContext, WithEditorActions: WithEditorActions } = props;
    const popupMountElement = (0, $5uXOq.useRef)(null);
    const [errorCount, setErrorCount] = (0, $5uXOq.useState)(0);
    const [resetCaughtError, setResetCaughtError] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        // Ensure the height animator has been recalculated so the async editor doesn't overflow the container
        props.onRecalculateAnimatorHeight();
        const { body: body } = document;
        if (body !== null) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            popupMountElement.current = document.createElement('div');
            popupMountElement.current.setAttribute('class', (0, $6wesA.IGNORE_CLICK_OUTSIDE_CLASS_NAME));
            body.appendChild(popupMountElement.current);
        }
        return function componentWillUnmount() {
            if (body !== null && popupMountElement.current != null) body.removeChild(popupMountElement.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderEditor = (actions)=>{
        const { onUpdate: onUpdate, Editor: Editor, scrollableElement: scrollableElement, taskDecisionProvider: taskDecisionProvider, onRecalculateAnimatorHeight: onRecalculateAnimatorHeight, ...editorProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Editor, {
            allowPanel: true,
            allowRule: true,
            appearance: "comment",
            ...editorProps,
            ...taskDecisionProvider && (0, $6s1PB.expValEquals)('jira_issue_config_fields_task_and_decision_support', 'isTasksAndDecisionsEnabled', true) && {
                allowTasksAndDecisions: true,
                taskDecisionProvider: taskDecisionProvider
            },
            onChange: $2566eb4373fcc98b$var$onDefaultValueChange(actions, onUpdate),
            allowAnalyticsGASV3: true,
            ...scrollableElement ? {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                popupsMountPoint: popupMountElement.current || document.body || undefined,
                popupsScrollableElement: scrollableElement
            } : null,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true
            }
        });
    };
    const onError = ()=>{
        setErrorCount(errorCount + 1);
        setResetCaughtError(undefined);
    };
    const renderAsyncEditor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditorContext, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithEditorActions, {
            render: renderEditor
        }));
    const renderAsyncEditorWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "editorContext",
            packageName: (0, $4SBL6.PACKAGE_NAME),
            teamName: "morphinecake",
            fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2566eb4373fcc98b$export$fb8d7f40caaeea67, {
                    errorCount: errorCount,
                    onRetry: ()=>setResetCaughtError(error)
                }),
            onError: onError,
            resetCaughtError: resetCaughtError
        }, renderAsyncEditor());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderAsyncEditorWithErrorBoundary());
};
const $2566eb4373fcc98b$var$errorWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");
var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");
const $2e844da07d79ea04$var$styles = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor),
            children: children
        });
        if (onClick) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});

parcelRegister("4SBL6", function(module, exports) {

$parcel$export(module.exports, "ExcludeFromMonitoringError", () => $6ce89ea2d3f5d58c$export$d76cd245e4bd3245);
$parcel$export(module.exports, "SHOW_NO_MESSAGE", () => $6ce89ea2d3f5d58c$export$2fc3d17eb4ad73eb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $6ce89ea2d3f5d58c$export$b8b9d90f9e5bd72b);

var $3XO6n = parcelRequire("3XO6n");
class $6ce89ea2d3f5d58c$export$d76cd245e4bd3245 extends Error {
}
const $6ce89ea2d3f5d58c$export$2fc3d17eb4ad73eb = null;
const $6ce89ea2d3f5d58c$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectSettingsAppsIssueTypePage');

});


parcelRegister("l5g3R", function(module, exports) {

let $f596860fdcad58ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f596860fdcad58ab$var$load("dsiAd"),
    $f596860fdcad58ab$var$load("cM9em"),
    $f596860fdcad58ab$var$load("fr9NE"),
    $f596860fdcad58ab$var$load("h2MrD"),
    $f596860fdcad58ab$var$load("bYT2S"),
    $f596860fdcad58ab$var$load("3RQ7G")
]).then(()=>parcelRequire('85eSI'));

});


parcelRegister("kSR59", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ba4a9eb4ffbe72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c3ba4a9eb4ffbe72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textDefaultValueLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.text-default-value-label",
        "defaultMessage": "Default text"
    },
    textDefaultDescriptionLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.text-default-description-label",
        "defaultMessage": "Default description"
    },
    environmentDefaultValueLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.environment-default-value-label",
        "defaultMessage": "Default environment"
    },
    textDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.multiline.text-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default text"
    },
    descriptionDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.multiline.description-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default description"
    },
    environmentDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.multiline.environment-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default environment"
    },
    defaultValueTooLongErrorDescription: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-description",
        "defaultMessage": "Your description is too long."
    },
    defaultValueTooLongErrorValue: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-value",
        "defaultMessage": "Your text is too long."
    }
});

});

parcelRegister("6IyET", function(module, exports) {

$parcel$export(module.exports, "isAdfEmpty", () => $083aed1dcf817c95$export$186b9eba0e17d2d1);

var $l1C1k = parcelRequire("l1C1k");
const $083aed1dcf817c95$var$isEmptyParagraph = (node)=>Boolean(node.type === 'paragraph' && node.content && node.content.length === 0);
const $083aed1dcf817c95$export$186b9eba0e17d2d1 = (adf)=>{
    if (adf.content == null) return true;
    const firstNode = adf.content[0];
    if (firstNode == null) return true;
    return adf.content.length === 1 && $083aed1dcf817c95$var$isEmptyParagraph(firstNode);
};
const $083aed1dcf817c95$export$c383e63d7f976624 = (adf)=>(0, $l1C1k.traverse)(adf, {
        mention: (node)=>{
            // Omit accessLevel as documents from the API do not include this property and we need dirty checks to be correct
            // @ts-expect-error - TS2339 - Property 'accessLevel' does not exist on type '{ [name: string]: any; } | undefined'.
            const { accessLevel: accessLevel, ...attrs } = node.attrs;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...node,
                attrs: attrs
            };
        }
    });

});



parcelRegister("kesxN", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $7dae0fe80251a1c2$export$6e0f0a958dc8ef91);

const $7dae0fe80251a1c2$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});

parcelRegister("fygmF", function(module, exports) {

$parcel$export(module.exports, "NumberFieldConfiguration", () => $b91e58a4b690e658$export$34f1216751b463c7);

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $dq3xR = parcelRequire("dq3xR");


var $hPw0Z = parcelRequire("hPw0Z");

var $e62PX = parcelRequire("e62PX");
const $b91e58a4b690e658$var$onDefaultValueChange = (field, onUpdate)=>(e)=>onUpdate({
            ...field,
            defaultValue: e.target.value === '' ? null : e.target.value
        });
function $b91e58a4b690e658$var$isRelevantError(e) {
    return e.position === (0, $d2e37636a1b0be7f$export$fa640bba89c0678c);
}
function $b91e58a4b690e658$var$getFilteredErrors(errors) {
    return errors.filter($b91e58a4b690e658$var$isRelevantError);
}
const $b91e58a4b690e658$var$DefaultValueErrors = ({ filteredErrors: filteredErrors, inputId: inputId })=>{
    const intl = (0, $koVbs.default)();
    if (filteredErrors.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: inputId
    }, filteredErrors.map((e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dq3xR.default), {
            key: e.messageDescriptor.id,
            message: intl.formatMessage(e.messageDescriptor, e.values)
        })));
};
function $b91e58a4b690e658$var$refineDefaultValue(defaultValue) {
    return typeof defaultValue === 'string' ? defaultValue : '';
}
const $b91e58a4b690e658$export$34f1216751b463c7 = ({ field: field, onUpdate: onUpdate, fieldErrors: fieldErrors, tooltipDelay: tooltipDelay, testId: testId })=>{
    const intl = (0, $koVbs.default)();
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const defaultValue = $b91e58a4b690e658$var$refineDefaultValue(field.defaultValue);
    const inputId = `${field.key}-default-value`;
    const filteredErrors = $b91e58a4b690e658$var$getFilteredErrors(fieldErrors);
    const isInvalid = filteredErrors.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: `${field.key}-default-value`,
        label: intl.formatMessage((0, $e62PX.default).numberDefaultValueLabel)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isModifyDefaultValueDisabled ? intl.formatMessage((0, $e62PX.default).numberDefaultValueDisabledTooltip) : null,
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            ...fieldProps,
            isDisabled: isModifyDefaultValueDisabled,
            type: "number",
            value: defaultValue,
            placeholder: intl.formatMessage((0, $e62PX.default).numberDefaultValuePlaceholder),
            onChange: $b91e58a4b690e658$var$onDefaultValueChange(field, onUpdate),
            isInvalid: isInvalid,
            "aria-invalid": isInvalid,
            testId: testId
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b91e58a4b690e658$var$DefaultValueErrors, {
        filteredErrors: filteredErrors,
        inputId: inputId
    })));
};

});
parcelRegister("e62PX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d336b540d17413$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e8d336b540d17413$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    numberDefaultValueLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.number.number-default-value-label",
        "defaultMessage": "Default number"
    },
    numberDefaultValuePlaceholder: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.number.number-default-value-placeholder",
        "defaultMessage": "Enter a default value"
    },
    numberDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.number.number-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default number"
    }
});

});


parcelRegister("jh9BI", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $d698b7ab96917979$export$6e0f0a958dc8ef91);

const $d698b7ab96917979$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue || operations.canModifyPropertyConfiguration;

});

parcelRegister("37Jh8", function(module, exports) {

$parcel$export(module.exports, "PeopleFieldConfiguration", () => $1f27f327b1cc0ddc$export$a20fe656d4c8f8dc);

var $5uXOq = parcelRequire("5uXOq");

var $3NMrl = parcelRequire("3NMrl");

var $8QpSo = parcelRequire("8QpSo");

var $7O4UO = parcelRequire("7O4UO");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $jfx3N = parcelRequire("jfx3N");

var $TZT0a = parcelRequire("TZT0a");

var $8QY5G = parcelRequire("8QY5G");

var $dlgLJ = parcelRequire("dlgLJ");

var $hPw0Z = parcelRequire("hPw0Z");

var $eUYCV = parcelRequire("eUYCV");

var $ck4b3 = parcelRequire("ck4b3");
// Pick only properties returned by the people field which are returned from the server.
const $1f27f327b1cc0ddc$var$normaliseDefaultValue = (defaultValue)=>defaultValue ? (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(defaultValue, [
        'id',
        'name',
        'avatarUrl'
    ]) : defaultValue;
const $1f27f327b1cc0ddc$var$onDefaultValueChange = (0, $8QpSo.default)((field, onUpdate)=>(defaultValue)=>{
        if (Array.isArray(defaultValue)) return onUpdate({
            ...field,
            defaultValue: defaultValue.length === 0 ? null : defaultValue.map($1f27f327b1cc0ddc$var$normaliseDefaultValue)
        });
        return onUpdate({
            ...field,
            defaultValue: $1f27f327b1cc0ddc$var$normaliseDefaultValue(defaultValue)
        });
    });
const $1f27f327b1cc0ddc$var$refineUser = (data)=>{
    if (!data || typeof data !== 'object') return null;
    if ('id' in data && 'name' in data && 'avatarUrl' in data) return {
        id: String(data.id),
        name: String(data.name),
        type: 'user',
        fixed: false,
        avatarUrl: String(data.avatarUrl) || ''
    };
    return null;
};
const $1f27f327b1cc0ddc$var$refineDefaultValue = (0, $8QpSo.default)((defaultValue)=>Array.isArray(defaultValue) ? defaultValue.map($1f27f327b1cc0ddc$var$refineUser).filter(Boolean) : []);
const $1f27f327b1cc0ddc$export$a20fe656d4c8f8dc = ({ field: field, onUpdate: onUpdate, projectKey: projectKey, tooltipDelay: tooltipDelay, testId: testId })=>{
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const intl = (0, $koVbs.default)();
    const placeholder = (0, $8QY5G.isPeopleFieldInMultiMode)(field) ? (0, $eUYCV.default).defaultValuePlaceholderMulti : (0, $eUYCV.default).defaultValuePlaceholderSingle;
    const { defaultValueLabelMulti: defaultValueLabelMulti, defaultValueLabelSingle: defaultValueLabelSingle } = (0, $eUYCV.default);
    const defaultLabel = (0, $8QY5G.isPeopleFieldInMultiMode)(field) ? defaultValueLabelMulti : defaultValueLabelSingle;
    const disabledTooltipMessage = (0, $8QY5G.isPeopleFieldInMultiMode)(field) ? (0, $eUYCV.default).defaultValueMultiDisabledTooltip : (0, $eUYCV.default).defaultValueSingleDisabledTooltip;
    const listOfUsers = $1f27f327b1cc0ddc$var$refineDefaultValue(field.defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), {
        onKeyDown: (0, $jfx3N.preventFormSubmitOnEnter)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: `${field.key}-default-value`,
        label: intl.formatMessage(defaultLabel)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isModifyDefaultValueDisabled ? intl.formatMessage(disabledTooltipMessage) : null,
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlgLJ.default), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TZT0a.default), {
            inputId: fieldProps.id,
            baseUrl: "",
            isMulti: (0, $8QY5G.isPeopleFieldInMultiMode)(field),
            isDisabled: isModifyDefaultValueDisabled,
            appearance: "normal",
            placeholder: intl.formatMessage(placeholder),
            usePortalForDropdown: false,
            // @ts-expect-error - TS2322 - Type 'User[]' is not assignable to type 'undefined'. This is because of defaultProps inside PeopleField.
            value: listOfUsers,
            onChange: $1f27f327b1cc0ddc$var$onDefaultValueChange(field, onUpdate),
            projectKey: projectKey,
            "data-": true
        })))))), (0, $8QY5G.isPeopleFieldModal)(field) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ck4b3.Mode), {
        field: field,
        onUpdate: onUpdate
    }));
};

});
parcelRegister("3NMrl", function(module, exports) {

var $i2e26 = parcelRequire("i2e26");

var $9SRAA = parcelRequire("9SRAA");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
    return object == null ? {} : $i2e26(object, paths);
});
module.exports = $2c4b85df1af41471$var$pick;

});
parcelRegister("i2e26", function(module, exports) {

var $4gaCO = parcelRequire("4gaCO");

var $fh9gH = parcelRequire("fh9gH");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $d2134c8f0f8064b1$var$basePick(object, paths) {
    return $4gaCO(object, paths, function(value, path) {
        return $fh9gH(object, path);
    });
}
module.exports = $d2134c8f0f8064b1$var$basePick;

});


parcelRegister("TZT0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $f15d28aebe480fcb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $47bDC = parcelRequire("47bDC");

var $lFKmC = parcelRequire("lFKmC");

var $bU3PY = parcelRequire("bU3PY");

var $cr0SA = parcelRequire("cr0SA");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $4IseO = parcelRequire("4IseO");

var $b74cc = parcelRequire("b74cc");
const $f15d28aebe480fcb$var$DropdownPortal = ({ innerRef: innerRef, isOpen: isOpen })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f15d28aebe480fcb$var$DropdownWrapper, {
        isOpen: isOpen,
        innerRef: innerRef
    }), // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body);
    return null;
};
class $f15d28aebe480fcb$export$60af7cb065ef1e98 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isInvalid: false,
            isInputDisabled: false,
            appearance: 'normal',
            placeholder: '',
            value: undefined,
            minQueryLength: 1,
            autoFocus: false,
            invalidMessage: '',
            usePortalForDropdown: true
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.isInputDisabled && state.isOpen) return {
            isOpen: false
        };
        return null;
    }
    constructor(props){
        super(props), this.onChange = (value)=>{
            this.setState({
                isOpen: false
            });
            if (value && !Array.isArray(value)) this.props.onChange([
                value
            ]);
            else this.props.onChange(value || []);
        }, this.onDropdownPortalRefChange = (ref)=>{
            if (!this.dropdownPortalRef && ref) this.setState({
                isDropdownPortalReady: true
            });
            this.dropdownPortalRef = ref;
        }, this.onQueryChange = (query)=>{
            const { minQueryLength: minQueryLength } = this.props;
            if (query === undefined || query === '' || query.length < minQueryLength) {
                this.setState({
                    isLoading: false,
                    query: query,
                    options: []
                });
                return;
            }
            this.setState({
                query: query,
                isLoading: true
            }, ()=>this.updateOptions(query));
        }, this.onBlur = ()=>this.setState({
                isOpen: false
            }), // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.getNoOptionsMessage = ()=>{
            const { query: query } = this.state;
            const { minQueryLength: minQueryLength, intl: { formatMessage: formatMessage } } = this.props;
            const queryLength = query == null ? 0 : query.length;
            return formatMessage(queryLength < minQueryLength ? (0, $b74cc.default).startTyping : (0, $b74cc.default).empty);
        }, this.updateOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            this.fetchOptions(query).then((options)=>{
                if (query !== this.state.query) return;
                this.setState({
                    options: options,
                    isOpen: true,
                    isLoading: false
                });
            }).catch(()=>{
                if (query === this.state.query) this.setState({
                    isLoading: false
                });
            });
        }, 300), this.cache = {}, this.dropdownPortalRef = null;
        this.state = {
            query: '',
            options: [],
            isLoading: false,
            isDropdownPortalReady: false,
            // right now this is the only way to simulate 'autoFocus' behaviour for UserPicker
            isOpen: props.autoFocus
        };
    }
    getValue() {
        const { isMulti: isMulti, value: value } = this.props;
        if (isMulti || !value) return value;
        return value.length ? value[0] : null;
    }
    fetchOptions(query = '') {
        if (this.cache[query]) return Promise.resolve(this.cache[query]);
        const fetch = async ()=>{
            const response = await (0, $4IseO.default)(this.props.projectKey, this.props.issueKey, query);
            this.cache[query] = response;
            return response;
        };
        return fetch();
    }
    renderUserPicker() {
        const { isLoading: isLoading, options: options, isOpen: isOpen, isDropdownPortalReady: isDropdownPortalReady } = this.state;
        const { isMulti: isMulti, usePortalForDropdown: usePortalForDropdown, appearance: appearance, placeholder: placeholder, isDisabled: isDisabled, isInvalid: isInvalid, invalidMessage: invalidMessage, isInputDisabled: isInputDisabled, inputId: inputId } = this.props;
        const { dropdownPortalRef: dropdownPortalRef } = this;
        if (usePortalForDropdown && !isDropdownPortalReady) // we should wait for dropdown wrapper
        // otherwise the first mount can look weird
        return null;
        const userPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
            width: "100%",
            isLoading: isLoading,
            options: options,
            addMoreMessage: "",
            onBlur: this.onBlur,
            isClearable: true,
            onInputChange: this.onQueryChange,
            open: !isInputDisabled && isOpen,
            // This needs to be passed as a function due to a bug in the component
            // https://product-fabric.atlassian.net/browse/FS-4023
            noOptionsMessage: this.getNoOptionsMessage,
            menuPortalTarget: dropdownPortalRef || undefined,
            isMulti: isMulti,
            disableInput: isInputDisabled,
            appearance: appearance,
            placeholder: placeholder,
            // @ts-expect-error - TS2322 - Type 'User | readonly User[] | null | undefined' is not assignable to type 'Value'.
            value: this.getValue(),
            onChange: this.onChange,
            isDisabled: isDisabled,
            fieldId: "people-field",
            inputId: inputId,
            UNSAFE_hasDraggableParentComponent: true,
            ariaLabel: placeholder
        });
        if (!isInvalid) return userPicker;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            isOpen: true,
            content: invalidMessage,
            placement: "right",
            messageId: "project-settings-apps-people-field.inline-dialog",
            messageType: "transactional"
        }, userPicker, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f15d28aebe480fcb$var$WarningIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            spacing: "spacious",
            label: "warning"
        })));
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const { usePortalForDropdown: usePortalForDropdown } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.renderUserPicker(), usePortalForDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f15d28aebe480fcb$var$DropdownPortal, {
            isOpen: isOpen,
            innerRef: this.onDropdownPortalRefChange
        }) : null);
    }
}
// @ts-expect-error - TS2322 - Type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to type 'ComponentType<PeopleFieldPropsWithDefault>'. | TS2345 - Argument of type 'typeof PeopleField' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
const $f15d28aebe480fcb$var$WithIntl = (0, $az4zD.injectIntlV2)($f15d28aebe480fcb$export$60af7cb065ef1e98);
var $f15d28aebe480fcb$export$2e2bcd8739ae039 = $f15d28aebe480fcb$var$WithIntl;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f15d28aebe480fcb$var$DropdownWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-15ma8sh-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $gwIPs.layers).modal,
        overflow: 'visible',
        position: 'absolute',
        left: 0,
        top: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isOpen ? undefined : 'none'
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f15d28aebe480fcb$var$WarningIcon = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-15ma8sh-1"
})({
    zIndex: 1,
    position: 'absolute',
    right: "var(--ds-space-050, 4px)",
    bottom: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-warning, #A54800)"
});

});
parcelRegister("4IseO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e33d7475f8dcf58$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2e33d7475f8dcf58$var$toItem = (user)=>({
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        id: user.accountId,
        name: user.displayName,
        byline: user.emailAddress,
        type: 'user',
        fixed: false
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2e33d7475f8dcf58$var$transform = (value)=>value ? $2e33d7475f8dcf58$var$toItem(value) : null;
const $2e33d7475f8dcf58$var$getUrl = (projectKey, issueKey, query)=>`/rest/api/3/user/recommend?${new URLSearchParams({
        context: 'People',
        ...projectKey && {
            project: projectKey
        },
        ...issueKey && {
            issueKey: issueKey
        },
        query: query
    })}`;
const $2e33d7475f8dcf58$var$searchUser = async (projectKey, issueKey, query)=>{
    const response = await (0, $7f4tk.default)($2e33d7475f8dcf58$var$getUrl(projectKey, issueKey, query));
    return response.map($2e33d7475f8dcf58$var$transform);
};
var $2e33d7475f8dcf58$export$2e2bcd8739ae039 = $2e33d7475f8dcf58$var$searchUser;

});

parcelRegister("b74cc", function(module, exports) {

$parcel$export(module.exports, "default", () => $219a9e04d8ada4b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $219a9e04d8ada4b2$var$messages = (0, $7VHMR.defineMessages)({
    startTyping: {
        "id": "project-settings-apps.people-field.start-typing",
        "defaultMessage": "Start typing"
    },
    empty: {
        "id": "project-settings-apps.people-field.empty",
        "defaultMessage": "No options"
    }
});
var $219a9e04d8ada4b2$export$2e2bcd8739ae039 = $219a9e04d8ada4b2$var$messages;

});


parcelRegister("8QY5G", function(module, exports) {

$parcel$export(module.exports, "isPeopleFieldInMultiMode", () => $7b4dac0fef47c5ff$export$122ac1ff8a98efde);
$parcel$export(module.exports, "isPeopleFieldModal", () => $7b4dac0fef47c5ff$export$fc097351afecba75);

var $5fc53 = parcelRequire("5fc53");

var $3XO6n = parcelRequire("3XO6n");

var $gifeQ = parcelRequire("gifeQ");

var $4R6GH = parcelRequire("4R6GH");

var $3KfKa = parcelRequire("3KfKa");
const $7b4dac0fef47c5ff$export$122ac1ff8a98efde = (field)=>{
    if ((0, $4R6GH.fg)('forge_custom_fields_on_jsm_portal_create')) {
        if ((0, $gifeQ.isForgeCustomField)(field.type) && field.properties) {
            const simplifiedForgeFieldType = (0, $3KfKa.transformToSimplifiedForgeFieldType)(field.properties);
            return simplifiedForgeFieldType === (0, $5fc53.FORGE_USER_LIST_TYPE);
        }
    }
    switch(field.type){
        case 0, $3XO6n.USERPICKER_FIELD_TYPE:
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
            return false;
        case 0, $3XO6n.MULTIUSERPICKER_FIELD_TYPE:
        case 0, $5fc53.MULTI_USER_CF_TYPE:
        case 0, $5fc53.RESPONDERS_CF_TYPE:
            return true;
        default:
            return field.configuration && typeof field.configuration === 'object' ? field.configuration.isMulti !== false : true;
    }
};
const $7b4dac0fef47c5ff$export$fc097351afecba75 = (field)=>field.type === (0, $5fc53.PEOPLE_CF_TYPE);

});
parcelRegister("gifeQ", function(module, exports) {

$parcel$export(module.exports, "isForgeCustomField", () => $89f92c26c7f930da$export$78cf1b56a8dede1f);
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $89f92c26c7f930da$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $89f92c26c7f930da$export$2b6a9cc67d548886);
$parcel$export(module.exports, "focusFormButton", () => $89f92c26c7f930da$export$f1a0ef98758e7a8a);
$parcel$export(module.exports, "isBuiltInJiraFieldRender", () => $89f92c26c7f930da$export$2909711775a2c267);

var $k2DRb = parcelRequire("k2DRb");

var $3eEiw = parcelRequire("3eEiw");
const $89f92c26c7f930da$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, $k2DRb.LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, $k2DRb.FORGE_FIELD_TYPE_PREFIX)));
const $89f92c26c7f930da$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, $k2DRb.LEGACY_FORGE_FIELD_TYPE_PREFIX));
const $89f92c26c7f930da$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, $k2DRb.PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
const $89f92c26c7f930da$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$89f92c26c7f930da$export$78cf1b56a8dede1f(field.fieldType));
const $89f92c26c7f930da$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
    if (button != null) button.focus();
};
function $89f92c26c7f930da$export$2909711775a2c267(extension, entryPoint, experience) {
    const edit = extension.properties?.edit;
    const view = 'view' in extension.properties ? extension.properties.view : undefined;
    const entry = entryPoint === 'edit' ? edit : view;
    let supportedExperience = false;
    if (entryPoint === 'edit') supportedExperience = edit && 'experience' in edit && edit.experience && (0, $3eEiw.isCustomFieldEditRenderContext)(experience) ? edit.experience.includes(experience) : false;
    else supportedExperience = view && 'experience' in view && view.experience && (0, $3eEiw.isCustomFieldViewRenderContext)(experience) ? view.experience.includes(experience) : false;
    const hasRenderFunction = entry && 'function' in entry;
    const hasSupportedResource = entry && 'resource' in entry && supportedExperience;
    const render = entry && 'render' in entry ? entry.render : null;
    return entryPoint === 'view' ? !hasRenderFunction && !(hasSupportedResource && render === 'native') : !hasRenderFunction && !hasSupportedResource;
}

});
parcelRegister("3eEiw", function(module, exports) {

$parcel$export(module.exports, "isCustomFieldEditRenderContext", () => $99ea418430558080$export$b562ffa4bbc21d4f);
$parcel$export(module.exports, "isCustomFieldViewRenderContext", () => $99ea418430558080$export$36376c9ff94a7fbd);
function $99ea418430558080$export$b562ffa4bbc21d4f(context) {
    return context === 'issue-view' || context === 'issue-create' || context === 'issue-transition';
}
function $99ea418430558080$export$36376c9ff94a7fbd(context) {
    return context === 'issue-view';
}

});


parcelRegister("3KfKa", function(module, exports) {

$parcel$export(module.exports, "transformToSimplifiedForgeFieldType", () => $2e4b8a5877ccdf3f$export$84342037188d77e6);

var $6wesA = parcelRequire("6wesA");
const $2e4b8a5877ccdf3f$export$84342037188d77e6 = (properties)=>{
    const forgeType = properties?.[0, $6wesA.FORGE_FIELD_TYPE];
    const forgeCollection = properties?.[0, $6wesA.FORGE_FIELD_COLLECTION];
    if (!forgeType) return null;
    if (forgeCollection && forgeCollection !== 'none') return `forge/${forgeType}-${forgeCollection}`;
    return `forge/${forgeType}`;
};

});


parcelRegister("eUYCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2835db0ce29194c9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2835db0ce29194c9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultValueLabelMulti: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.people.default-value-label-multi",
        "defaultMessage": "Default users"
    },
    defaultValueLabelSingle: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.people.default-value-label-single",
        "defaultMessage": "Default user"
    },
    defaultValuePlaceholderMulti: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.people.default-value-placeholder-multi",
        "defaultMessage": "Choose users"
    },
    defaultValuePlaceholderSingle: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.people.default-value-placeholder-single",
        "defaultMessage": "Choose a user"
    },
    defaultValueSingleDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.people.default-value-single-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default user"
    },
    defaultValueMultiDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.people.default-value-multi-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default users"
    }
});

});

parcelRegister("ck4b3", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $c68ee9bfdebcd0f4$export$9484bbecc3c49a2e);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8QY5G = parcelRequire("8QY5G");

var $hPw0Z = parcelRequire("hPw0Z");

var $2ADyv = parcelRequire("2ADyv");
const $c68ee9bfdebcd0f4$export$9484bbecc3c49a2e = ({ field: field, onUpdate: onUpdate, tooltipDelay: tooltipDelay, testId: testId })=>{
    const intl = (0, $koVbs.default)();
    const isModifyPropertyConfigurationDisabled = !field.operations.canModifyPropertyConfiguration;
    const onChange = ()=>{
        let { defaultValue: defaultValue } = field;
        const isMulti = !(0, $8QY5G.isPeopleFieldInMultiMode)(field);
        if (!isMulti && Array.isArray(defaultValue) && defaultValue.length > 1) defaultValue = [];
        onUpdate({
            ...field,
            defaultValue: defaultValue,
            configuration: {
                isMulti: isMulti
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.CheckboxFieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isModifyPropertyConfigurationDisabled ? intl.formatMessage((0, $2ADyv.default).singleModeDisabledTooltip) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: !(0, $8QY5G.isPeopleFieldInMultiMode)(field),
        isDisabled: isModifyPropertyConfigurationDisabled,
        label: intl.formatMessage((0, $2ADyv.default).singleModeLabel),
        onChange: onChange,
        testId: testId
    })));
};

});
parcelRegister("2ADyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4a5a4cbc27c91f2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f4a5a4cbc27c91f2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    singleModeLabel: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.people.mode.single-mode-label",
        "defaultMessage": "Restrict to a single user"
    },
    singleModeDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.people.mode.single-mode-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this restriction"
    }
});

});



parcelRegister("bBCi8", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $1ace9c2ad7b9cfb3$export$6e0f0a958dc8ef91);

const $1ace9c2ad7b9cfb3$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});

parcelRegister("kWQog", function(module, exports) {

$parcel$export(module.exports, "PriorityFieldConfiguration", () => $e18c2bc0dfe332ab$export$66ff1d1647374436);

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $Re1Cc = parcelRequire("Re1Cc");

var $hPw0Z = parcelRequire("hPw0Z");

var $cD6PZ = parcelRequire("cD6PZ");
const $e18c2bc0dfe332ab$var$onDefaultValueChange = (field, onUpdate)=>(defaultValue)=>onUpdate({
            ...field,
            defaultValue: !defaultValue ? null : defaultValue
        });
const $e18c2bc0dfe332ab$var$refineDefaultValue = (defaultValue)=>typeof defaultValue === 'string' ? defaultValue : undefined;
const $e18c2bc0dfe332ab$export$66ff1d1647374436 = ({ field: field, projectId: projectId, onUpdate: onUpdate, tooltipDelay: tooltipDelay, testId: testId })=>{
    const intl = (0, $koVbs.default)();
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isModifyDefaultValueDisabled ? intl.formatMessage((0, $cD6PZ.default).priorityDefaultValueDisabledTooltip) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: `${field.key}-default-value`,
        label: intl.formatMessage((0, $cD6PZ.default).priorityDefaultValueLabel),
        testId: testId
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Re1Cc.PriorityPicker), {
            inputId: fieldProps.id,
            label: undefined,
            baseUrl: "",
            isClearableWithCrossIcon: true,
            noPortal: true,
            // @ts-expect-error intl2 vs intl5
            intl: intl,
            value: $e18c2bc0dfe332ab$var$refineDefaultValue(field.defaultValue),
            isDisabled: isModifyDefaultValueDisabled,
            isRequired: false,
            projectIdOrKey: projectId,
            onChange: $e18c2bc0dfe332ab$var$onDefaultValueChange(field, onUpdate)
        })))));
};

});
parcelRegister("Re1Cc", function(module, exports) {

$parcel$export(module.exports, "PriorityPicker", () => $93e46b0a7bb00556$export$d06c49888f60e0f5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $eZJjh = parcelRequire("eZJjh");

var $4U4qk = parcelRequire("4U4qk");

var $az4zD = parcelRequire("az4zD");

var $jZQ8T = parcelRequire("jZQ8T");

var $kj79L = parcelRequire("kj79L");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $93e46b0a7bb00556$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93e46b0a7bb00556$var$OptionWrapper, null, option.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93e46b0a7bb00556$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: option.iconUrl,
        size: "xsmall",
        borderColor: "transparent"
    })) : null, option.label);
const $93e46b0a7bb00556$var$LoadingMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93e46b0a7bb00556$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })); // eslint-disable-next-line jira/react/no-class-components
class $93e46b0a7bb00556$export$d06c49888f60e0f5 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            noPortal: false,
            autoFocus: false
        };
    }
    render() {
        const { inputId: inputId, label: label, isRequired: isRequired, isDisabled: isDisabled, intl: { formatMessage: formatMessage }, value: value, isClearableWithCrossIcon: isClearableWithCrossIcon, noPortal: noPortal } = this.props;
        const { isLoading: isLoading, options: options } = this.state; // If we want to deselect value we need to set it to null
        // See more on this thread:
        // https://stackoverflow.com/questions/50412843/how-to-programmatically-clear-reset-react-select-v2/50417171
        const currentSelection = // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'never'.
        options.find((option)=>option.value === value) || null; // if field is disabled we should pass isSearchable=true, because in current version of react-select there is a bug:
        // when isDisabled=true and isSearchable=false user will be able to focus field (using tab key)
        // https://github.com/JedWatson/react-select/pull/3163
        const isSearchable = isDisabled;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.default), {
            inputId: inputId,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            noPortal: noPortal,
            label: label,
            autoFocus: !!this.props.autoFocus,
            placeholder: formatMessage((0, $jZQ8T.default).placeholder),
            isRequired: isRequired,
            isDisabled: isDisabled,
            isLoading: isLoading,
            value: currentSelection,
            errorMessage: formatMessage((0, $jZQ8T.default).error),
            options: this.renderOptions,
            onSelected: this.onSelected,
            formatOptionLabel: $93e46b0a7bb00556$var$formatOptionLabel,
            components: {
                LoadingMessage: $93e46b0a7bb00556$var$LoadingMessage
            },
            isSearchable: isSearchable,
            hasDraggableParentComponent: true
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isLoading: true,
            options: []
        }, this.onSelected = (selectedOption)=>// selectedOption.value is only available when use picks concrete value
            // this callback is also called when user clears a value and in such a case selectedOption is null
            this.props.onChange(selectedOption ? selectedOption.value : selectedOption), this.renderOptions = ()=>{
            const promise = (0, $kj79L.requestProjectPriorityList)(this.props.projectIdOrKey);
            promise.then((data)=>this.setState({
                    options: data
                }));
            return promise;
        };
    }
}
var $93e46b0a7bb00556$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($93e46b0a7bb00556$export$d06c49888f60e0f5);
const $93e46b0a7bb00556$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93e46b0a7bb00556$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93e46b0a7bb00556$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1tkeckbl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4U4qk", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $0d1a93ba35d548ba$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $0d1a93ba35d548ba$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $0d1a93ba35d548ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1ZftP = parcelRequire("1ZftP");
var $94bNw = parcelRequire("94bNw");
var $bChGW = parcelRequire("bChGW");
var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $VgvL1 = parcelRequire("VgvL1");

var $fVAPR = parcelRequire("fVAPR");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $e239o = parcelRequire("e239o");
const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #626F86)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: '',
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $e239o.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, props));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $0d1a93ba35d548ba$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $1ZftP.default) : (0, $iOwNT.default);
        if (isAsync) return 0, $VgvL1.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $94bNw.default) : (0, $7K5PP.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $e239o.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>formatMessage((0, $e239o.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $e239o.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...(0, $4R6GH.fg)('jira_apply_prop_stylings_to_base_picker') ? this.props.styles : undefined,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
const $0d1a93ba35d548ba$var$PickerWithIntl = (0, $az4zD.injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
};
$0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
var $0d1a93ba35d548ba$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0d1a93ba35d548ba$var$DefaultPicker;
const $0d1a93ba35d548ba$var$StyledValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, $8CUq3.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
});

});
parcelRegister("1ZftP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe39b95a8bd43db$export$2e2bcd8739ae039);

var $isgat = parcelRequire("isgat");

var $3c98u = parcelRequire("3c98u");
const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, $3c98u.default)((0, $isgat.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;

});
parcelRegister("isgat", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce0d05b9e97e68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iaInK.default)(props);
    const creatableProps = (0, $9uJ4X.default)(stateManagerProps);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;

});


parcelRegister("VgvL1", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $462c399840da3e1c$export$ee664e5add893f9);

var $d7FF4 = parcelRequire("d7FF4");

var $8oe80 = parcelRequire("8oe80");
const $462c399840da3e1c$export$ee664e5add893f9 = (0, $8oe80.default)('select', {
    onChange: 'changed'
})((0, $d7FF4.default));

});
parcelRegister("d7FF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4d84cf4438daea$export$2e2bcd8739ae039);

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $ac4d84cf4438daea$var$AsyncSelect = (0, $3c98u.default)((0, $eAthk.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;

});


parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$labelStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $97462970d1593b07$var$requiredIndicatorStyle = null;

});

parcelRegister("e239o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6849afedcc0fa8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("jZQ8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $940c43d8cefebfbe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $940c43d8cefebfbe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "priority-picker.error",
        "defaultMessage": "We couldn't find your priorities. Refresh and try again."
    },
    placeholder: {
        "id": "priority-picker.placeholder",
        "defaultMessage": "Select a value"
    }
});

});

parcelRegister("kj79L", function(module, exports) {

$parcel$export(module.exports, "requestProjectPriorityList", () => $bb0e8afd8968cecc$export$7ec04be0f570e104);

var $jWPzN = parcelRequire("jWPzN");
const $bb0e8afd8968cecc$var$transformPriority = (data)=>data.map((priority)=>({
            value: priority.id,
            label: priority.name,
            iconUrl: priority.iconUrl
        }));
const $bb0e8afd8968cecc$var$cachedResult = {};
const $bb0e8afd8968cecc$var$resetCache = ()=>{
    Object.keys($bb0e8afd8968cecc$var$cachedResult).forEach((key)=>{
        delete $bb0e8afd8968cecc$var$cachedResult[key];
    });
};
const $bb0e8afd8968cecc$export$7ec04be0f570e104 = (projectId)=>$bb0e8afd8968cecc$var$cachedResult[projectId] ? Promise.resolve($bb0e8afd8968cecc$var$cachedResult[projectId]) : (0, $jWPzN.getPriorityListForProject)(projectId).then(({ values: values })=>$bb0e8afd8968cecc$var$transformPriority(values)).then((result)=>{
        $bb0e8afd8968cecc$var$cachedResult[projectId] = result;
        return result;
    });
const $bb0e8afd8968cecc$export$7ae0a48a98786dec = {
    resetCache: $bb0e8afd8968cecc$var$resetCache
};

});
parcelRegister("jWPzN", function(module, exports) {

$parcel$export(module.exports, "getPriorityListForProject", () => $357a275c48df64d7$export$3d245b74f531b564);

var $7f4tk = parcelRequire("7f4tk");
const $357a275c48df64d7$export$8a3ee67d12e43828 = (baseUrl)=>`${baseUrl}/rest/api/2/priority`;
const $357a275c48df64d7$export$5d3cc7c220945bda = (baseUrl, _projectIdOrKey = '')=>(0, $7f4tk.default)($357a275c48df64d7$export$8a3ee67d12e43828(baseUrl));
const $357a275c48df64d7$export$4159899b2a5c63f2 = '/rest/api/3/priority/search';
const $357a275c48df64d7$export$3d245b74f531b564 = (projectId)=>(0, $7f4tk.default)(`${$357a275c48df64d7$export$4159899b2a5c63f2}?projectId=${projectId}`);

});



parcelRegister("cD6PZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $edf061dbc69e700e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $edf061dbc69e700e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityDefaultValueLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.priority.priority-default-value-label",
        "defaultMessage": "Default priority"
    },
    priorityDefaultValueDisabledTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.priority.priority-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default priority"
    }
});

});


parcelRegister("28HmG", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $08e48d915f530f14$export$6e0f0a958dc8ef91);

var $5Udqs = parcelRequire("5Udqs");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$08e48d915f530f14$export$2e2bcd8739ae039 = (0, $5Udqs.default);
const $08e48d915f530f14$export$d7aa59daa107287a = {
    isExpandable: (operations)=>operations.canModifyDefaultValue
};
const $08e48d915f530f14$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});
parcelRegister("5Udqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4554c0be010f936$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $fs8YG = parcelRequire("fs8YG");

var $hPw0Z = parcelRequire("hPw0Z");

var $211RG = parcelRequire("211RG");
const $a4554c0be010f936$var$onDefaultValueChange = (field, onUpdate)=>(defaultValue)=>onUpdate({
            ...field,
            defaultValue: defaultValue == null || defaultValue === '' ? null : defaultValue
        });
const $a4554c0be010f936$var$ProjectPickerFieldConfiguration = ({ field: field, onUpdate: onUpdate, tooltipDelay: tooltipDelay, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const cachedProject = (0, $5uXOq.useRef)();
    const handleChange = (0, $5uXOq.useCallback)((project)=>{
        // This callback fired on mount with an undefined project when no default value is provided. This check
        // prevents the onDefaultValueChange handler being fired unnecessarily when both values are nullish.
        const isNullishValue = project?.value == null && field.defaultValue == null;
        if (!isNullishValue && project?.value !== field.defaultValue) $a4554c0be010f936$var$onDefaultValueChange(field, onUpdate)(project && project.value);
        cachedProject.current = project;
    }, [
        field,
        onUpdate
    ]);
    const selectedProject = (0, $5uXOq.useMemo)(()=>cachedProject.current !== undefined && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        field.defaultValue === cachedProject.current.value ? {
            value: field.defaultValue,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            name: cachedProject.current.name,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            avatarUrl: cachedProject.current.avatarUrl
        } : {
            value: field.defaultValue,
            name: '',
            avatarUrl: ''
        }, [
        field
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: isModifyDefaultValueDisabled ? formatMessage((0, $211RG.default).projectDefaultValueDisabledTooltip) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: `${field.key}-default-value`,
        label: formatMessage((0, $211RG.default).projectDefaultValueLabel),
        testId: testId
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fs8YG.default), {
            inputId: fieldProps.id,
            baseUrl: "",
            // @ts-expect-error - Type '{ value: unknown; name: any; avatarUrl: any; }' is not assignable to type 'Project'.
            selectedProject: selectedProject,
            width: "100%",
            requireBrowsePermission: true,
            isDisabled: isModifyDefaultValueDisabled,
            // @ts-expect-error - Type '(project: PickedProject) => void' is not assignable to type '(arg1: Project | undefined, args_1: UIAnalyticsEvent) => void'.
            onChange: handleChange
        })))));
};
var $a4554c0be010f936$export$2e2bcd8739ae039 = $a4554c0be010f936$var$ProjectPickerFieldConfiguration;

});
parcelRegister("fs8YG", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f47b7198869b8c$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $59ECx = parcelRequire("59ECx");
var $90f47b7198869b8c$export$2e2bcd8739ae039 = (0, $8oe80.default)('ProjectPicker', {
    onChange: 'changed'
})((0, $59ECx.default));

});
parcelRegister("59ECx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af03db95f8cb63b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $4USKh = parcelRequire("4USKh");

var $az4zD = parcelRequire("az4zD");

var $5gPNV = parcelRequire("5gPNV");

var $2oK1T = parcelRequire("2oK1T");
class $1af03db95f8cb63b$export$a4519235a2ef9605 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            detailed: false,
            width: '200px',
            requireBrowsePermission: false,
            label: undefined,
            inputId: undefined,
            projectType: undefined
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedProject: this.props.selectedProject,
            projects: [],
            prevSelectedProject: this.props.selectedProject
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedProject: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (project)=>{
            const { avatarUrl: avatarUrl, name: name } = project;
            const avatar = this.props.renderAvatar ? this.props.renderAvatar(avatarUrl) : avatarUrl;
            return {
                avatar: avatar,
                label: name
            };
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = async (filter)=>{
            const projects = await (0, $5gPNV.requestProjects)(this.props.baseUrl, filter, {
                detailed: this.props.detailed,
                requireBrowsePermission: this.props.requireBrowsePermission,
                projectType: this.props.projectType
            });
            this.setState({
                projects: projects
            });
            return projects;
        };
        this.projectPickerId = `project-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentProjectId = props.selectedProject && props.selectedProject.value;
        const prevProjectId = state.prevSelectedProject && state.prevSelectedProject.value;
        if (currentProjectId !== prevProjectId) return {
            ...state,
            selectedProject: props.selectedProject,
            prevSelectedProject: props.selectedProject
        };
        return null;
    }
    componentDidMount() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    componentDidUpdate() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    fetchProject(selectedProject) {
        const { baseUrl: baseUrl } = this.props;
        const projectValue = selectedProject.value;
        // @ts-expect-error - TS7006 - Parameter 'newProject' implicitly has an 'any' type.
        const updateSelectedProject = (newProject)=>{
            const currentProject = this.state.selectedProject;
            const currentProjectValue = currentProject && currentProject.value;
            // Update the state only in case the project wasn't changed
            if (currentProjectValue === projectValue) {
                this.setState({
                    selectedProject: newProject
                });
                this.props.onChange(newProject);
            }
        };
        return (0, $5gPNV.requestProject)(baseUrl, projectValue).then((project)=>updateSelectedProject(project)).catch(()=>updateSelectedProject(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, selectedProject: selectedProject, onChange: onChange, ...props } = this.props;
        const { selectedProject: project, projects: projects } = this.state;
        // the selected option needs to have same object reference to be correctly announced by screen readers
        const selectedOptionWithObjectReference = projects?.find((projectInList)=>projectInList.value === project?.value);
        const selectedOption = selectedOptionWithObjectReference || (project && project.name ? project : null);
        return(// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $2oK1T.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.projectPickerId : this.props.inputId,
            errorMessage: formatMessage((0, $2oK1T.default).error),
            placeholder: this.props.placeholder || formatMessage((0, $2oK1T.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedOption,
            showFocusedAvatar: true
        }));
    }
}
var $1af03db95f8cb63b$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($1af03db95f8cb63b$export$a4519235a2ef9605);

});
parcelRegister("4USKh", function(module, exports) {

$parcel$export(module.exports, "PickerWithAvatar", () => $63c33924209c0872$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $63c33924209c0872$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $8oe80 = parcelRequire("8oe80");

var $4U4qk = parcelRequire("4U4qk");

var $9M5Oz = parcelRequire("9M5Oz");
const $63c33924209c0872$export$e6b8a87858f7afd1 = (0, $9M5Oz.default);
const $63c33924209c0872$export$3d409af828769e2e = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $9M5Oz.default));
const $63c33924209c0872$export$d8d9f25d80d89b16 = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $4U4qk.default));

});
parcelRegister("9M5Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae2cb265c5b0a53f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $kgoHi = parcelRequire("kgoHi");

var $4U4qk = parcelRequire("4U4qk");
class $ae2cb265c5b0a53f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae2cb265c5b0a53f$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ae2cb265c5b0a53f$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5gPNV", function(module, exports) {

$parcel$export(module.exports, "requestProjects", () => $cc6820a29e56f420$export$fd47004f2da106d6);
$parcel$export(module.exports, "requestProject", () => $cc6820a29e56f420$export$5fc96122a11240fa);

var $4SXEu = parcelRequire("4SXEu");

var $9V0kk = parcelRequire("9V0kk");
const $cc6820a29e56f420$export$fd47004f2da106d6 = (baseUrl, filter, { detailed: detailed, requireBrowsePermission: requireBrowsePermission, maxResults: maxResults, projectType: projectType })=>(0, $4SXEu.getProjects)(baseUrl, filter, detailed, requireBrowsePermission, maxResults, projectType).then((0, $9V0kk.transformProjects));
const $cc6820a29e56f420$export$5fc96122a11240fa = (baseUrl, projectId)=>(0, $4SXEu.getProject)(baseUrl, projectId).then((0, $9V0kk.transformProject));

});
parcelRegister("4SXEu", function(module, exports) {

$parcel$export(module.exports, "getProjects", () => $7b7f1e9303cf186f$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProject", () => $7b7f1e9303cf186f$export$637b60a42bb03f06);

var $7f4tk = parcelRequire("7f4tk");
const $7b7f1e9303cf186f$var$MAX_PROJECTS = 5;
const $7b7f1e9303cf186f$var$VALID_PROJECT_TYPES = [
    'business',
    'service_desk',
    'software'
];
const $7b7f1e9303cf186f$export$897983d170945c20 = (baseUrl)=>`${baseUrl}/rest/api/2/project/search`;
const $7b7f1e9303cf186f$export$40e632ede9793c84 = (baseUrl)=>`${baseUrl}/rest/api/2/project`;
const $7b7f1e9303cf186f$export$3675f59ca23820db = (baseUrl, filter, detailed, requireBrowsePermission, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('orderBy', 'NAME');
    urlSearchParams.set('startAt', '0');
    urlSearchParams.set('query', filter);
    urlSearchParams.set('maxResults', maxResults.toString());
    if (detailed) urlSearchParams.set('expand', 'lead,issueTypes');
    if (requireBrowsePermission) urlSearchParams.set('action', 'browse');
    if ($7b7f1e9303cf186f$var$VALID_PROJECT_TYPES.includes(projectType)) urlSearchParams.set('typeKey', projectType);
    const urlParams = `?${urlSearchParams.toString()}`;
    return `${$7b7f1e9303cf186f$export$897983d170945c20(baseUrl)}${urlParams}`;
};
const $7b7f1e9303cf186f$export$42f2db4bad372151 = (baseUrl, projectId)=>`${$7b7f1e9303cf186f$export$40e632ede9793c84(baseUrl)}/${encodeURIComponent(projectId)}`;
const $7b7f1e9303cf186f$export$b00a271f69f3d728 = (baseUrl, filter = '', detailed = false, requireBrowsePermission = false, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>(0, $7f4tk.default)($7b7f1e9303cf186f$export$3675f59ca23820db(baseUrl, filter, detailed, requireBrowsePermission, maxResults, projectType));
const $7b7f1e9303cf186f$export$637b60a42bb03f06 = (baseUrl, projectId = '')=>(0, $7f4tk.default)($7b7f1e9303cf186f$export$42f2db4bad372151(baseUrl, projectId));

});

parcelRegister("9V0kk", function(module, exports) {

$parcel$export(module.exports, "transformProject", () => $6541540d335a62b4$export$e179869ce707f546);
$parcel$export(module.exports, "transformProjects", () => $6541540d335a62b4$export$227473965d2e27db);
const $6541540d335a62b4$var$transformLead = (leadResponse)=>leadResponse && {
        key: leadResponse.key,
        name: leadResponse.name,
        displayName: leadResponse.displayName,
        avatarUrl: leadResponse.avatarUrls['24x24']
    };
const $6541540d335a62b4$var$transformIssueTypes = (types)=>types.map((t)=>({
            id: t.id,
            name: t.name,
            description: t.description,
            iconUrl: t.iconUrl,
            subtask: t.subtask
        }));
const $6541540d335a62b4$var$transformDetails = (restResponse)=>({
        id: restResponse.id,
        key: restResponse.key,
        lead: $6541540d335a62b4$var$transformLead(restResponse.lead),
        issueTypes: restResponse.issueTypes ? $6541540d335a62b4$var$transformIssueTypes(restResponse.issueTypes) : [],
        projectTypeKey: restResponse.projectTypeKey,
        simplified: restResponse.simplified
    });
const $6541540d335a62b4$export$e179869ce707f546 = (restResponse)=>restResponse && {
        value: restResponse.id,
        name: restResponse.name,
        label: restResponse.name,
        avatarUrl: restResponse.avatarUrls['24x24'],
        details: $6541540d335a62b4$var$transformDetails(restResponse)
    };
const $6541540d335a62b4$export$227473965d2e27db = (restResponse)=>restResponse && restResponse.values && restResponse.values.map($6541540d335a62b4$export$e179869ce707f546);

});


parcelRegister("2oK1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2fad71e32e9ef5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a2fad71e32e9ef5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "project-picker.error",
        "defaultMessage": "We couldn't retrieve projects"
    },
    placeholder: {
        "id": "project-picker.placeholder",
        "defaultMessage": "Project"
    },
    labelText: {
        "id": "project-picker.label-text",
        "defaultMessage": "Project"
    }
});

});



parcelRegister("211RG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4371c702b3b9fad$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c4371c702b3b9fad$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectDefaultValueLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.project-picker.project-default-value-label",
        "defaultMessage": "Default project"
    },
    projectDefaultValueDisabledTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.project-picker.project-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default project"
    }
});

});



parcelRegister("htPg0", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $a8505f6df7f66597$export$6e0f0a958dc8ef91);

const $a8505f6df7f66597$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});

parcelRegister("lyeB5", function(module, exports) {

$parcel$export(module.exports, "TextFieldConfiguration", () => $26bc8a60fb7d6335$export$7dae42ccec2c99de);

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $dq3xR = parcelRequire("dq3xR");


var $hPw0Z = parcelRequire("hPw0Z");

var $gOsNl = parcelRequire("gOsNl");
const $26bc8a60fb7d6335$var$onDefaultValueChange = (field, onUpdate)=>(e)=>{
        onUpdate({
            ...field,
            defaultValue: e.target.value === '' ? null : e.target.value
        });
    };
function $26bc8a60fb7d6335$var$isRelevantError(e) {
    return e.position === (0, $d2e37636a1b0be7f$export$fa640bba89c0678c);
}
function $26bc8a60fb7d6335$var$getFilteredErrors(errors) {
    return errors.filter($26bc8a60fb7d6335$var$isRelevantError);
}
const $26bc8a60fb7d6335$var$DefaultValueErrors = ({ filteredErrors: filteredErrors, inputId: inputId })=>{
    const intl = (0, $koVbs.default)();
    if (filteredErrors.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: inputId
    }, filteredErrors.map((e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dq3xR.default), {
            key: e.messageDescriptor.id,
            message: intl.formatMessage(e.messageDescriptor, e.values)
        })));
};
function $26bc8a60fb7d6335$var$refineDefaultValue(defaultValue) {
    return typeof defaultValue === 'string' ? defaultValue : '';
}
const $26bc8a60fb7d6335$export$7dae42ccec2c99de = ({ field: field, fieldErrors: fieldErrors, onUpdate: onUpdate, tooltipDelay: tooltipDelay, testId: testId })=>{
    const intl = (0, $koVbs.default)();
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const defaultValue = $26bc8a60fb7d6335$var$refineDefaultValue(field.defaultValue);
    const inputId = `${field.key}-default-value`;
    const filteredErrors = $26bc8a60fb7d6335$var$getFilteredErrors(fieldErrors);
    const isInvalid = filteredErrors.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: `${field.key}-default-value`,
        label: intl.formatMessage((0, $gOsNl.default).textDefaultTextLabel)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isModifyDefaultValueDisabled ? intl.formatMessage((0, $gOsNl.default).textDefaultValueDisabledTooltip) : null,
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            ...fieldProps,
            isDisabled: isModifyDefaultValueDisabled,
            placeholder: intl.formatMessage((0, $gOsNl.default).textDefaultValuePlaceholder),
            value: defaultValue,
            onChange: $26bc8a60fb7d6335$var$onDefaultValueChange(field, onUpdate),
            isInvalid: isInvalid,
            "aria-invalid": isInvalid,
            testId: testId
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26bc8a60fb7d6335$var$DefaultValueErrors, {
        filteredErrors: filteredErrors,
        inputId: inputId
    })));
};

});
parcelRegister("gOsNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $335d350156c772e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $335d350156c772e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textDefaultTextLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.text.text-default-text-label",
        "defaultMessage": "Default text"
    },
    textDefaultValuePlaceholder: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.text.text-default-value-placeholder",
        "defaultMessage": "Enter default text"
    },
    textDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.text.text-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default text"
    },
    defaultValueTooLongErrorText: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.text.default-value-too-long-error-text",
        "defaultMessage": "Text fields can't have more than {MAX_ALLOWED_TEXT_LENGTH} characters."
    }
});

});


parcelRegister("eaZQn", function(module, exports) {

$parcel$export(module.exports, "isExpandable", () => $aea9df602007b8f5$export$6e0f0a958dc8ef91);


const $aea9df602007b8f5$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});

parcelRegister("2Rl74", function(module, exports) {

$parcel$export(module.exports, "MultiVersionFieldConfiguration", () => $28f648db1f23c82e$export$62b2f17b0efc093b);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $3VU8B = parcelRequire("3VU8B");

var $dlgLJ = parcelRequire("dlgLJ");

var $hPw0Z = parcelRequire("hPw0Z");

var $04HsQ = parcelRequire("04HsQ");

var $klvI9 = parcelRequire("klvI9");
const $28f648db1f23c82e$var$onDefaultValueChange = (field, onUpdate)=>(updatedValue)=>onUpdate({
            ...field,
            defaultValue: updatedValue.length === 0 ? null : updatedValue
        });
const $28f648db1f23c82e$var$toListOfVersions = (defaultValue)=>Array.isArray(defaultValue) ? defaultValue.map((0, $04HsQ.refineDefaultValue)).filter(Boolean) : [];
const $28f648db1f23c82e$export$62b2f17b0efc093b = ({ field: field, onUpdate: onUpdate, projectKey: projectKey, tooltipDelay: tooltipDelay, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const currentValue = $28f648db1f23c82e$var$toListOfVersions(field.defaultValue);
    const defaultLabel = (0, $klvI9.default).multiVersionDefaultValueLabelNew;
    const placeholder = (0, $klvI9.default).multiVersionPlaceholder;
    const disabledTooltipMessage = (0, $klvI9.default).multiVersionDefaultValueDisabledTooltip;
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isModifyDefaultValueDisabled ? formatMessage(disabledTooltipMessage) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlgLJ.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3VU8B.default), {
        value: currentValue,
        label: formatMessage(defaultLabel),
        placeholder: formatMessage(placeholder),
        projectKey: projectKey,
        onSelected: $28f648db1f23c82e$var$onDefaultValueChange(field, onUpdate),
        isDisabled: isModifyDefaultValueDisabled,
        // This picker is intended for selecting default values
        // therefore it's meant for future issues where archived versions do not make sense.
        // If this was a search page or reports page then we would include archived versions too.
        excludeArchivedVersions: true,
        // this is used to prevent the menu from remaining
        // open when a user clicks through to another field
        noPortal: true,
        isClearableWithCrossIcon: true
    })))));
};

});
parcelRegister("3VU8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f1843c8e32eaf37$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $iQv12 = parcelRequire("iQv12");

var $4U4qk = parcelRequire("4U4qk");

var $az4zD = parcelRequire("az4zD");

var $bcrAM = parcelRequire("bcrAM");

var $5wI4U = parcelRequire("5wI4U");

var $kVzJJ = parcelRequire("kVzJJ");
class $7f1843c8e32eaf37$export$cf62270384b7743e extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearableWithCrossIcon: false,
            baseUrl: '',
            noPortal: false,
            value: undefined,
            label: '',
            placeholder: undefined,
            ignore: [],
            versionStatuses: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getVersionIdsToIgnore() {
        const { value: value, ignore: ignore } = this.props;
        if (value) return [
            ...value.map((v)=>v.id),
            ...ignore
        ];
        return ignore;
    }
    getPlaceholder() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return this.props.placeholder === undefined ? formatMessage((0, $kVzJJ.default).placeholder) : this.props.placeholder;
    }
    getValue() {
        const { value: value } = this.props;
        if (value === null || value === undefined) return value;
        return value.map((0, $5wI4U.transformVersion));
    }
    render() {
        const { label: label, isRequired: isRequired, isDisabled: isDisabled, intl: intl, noPortal: noPortal, isClearableWithCrossIcon: isClearableWithCrossIcon } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.Picker), {
            isMulti: true,
            value: this.getValue(),
            label: label,
            placeholder: this.getPlaceholder(),
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $kVzJJ.default).error),
            onMultiSelected: this.onMultiSelected,
            options: this.onFetchOptions,
            noPortal: noPortal,
            intl: intl
        });
    }
    constructor(...args){
        super(...args), this.onMultiSelected = (selectedOptions, analyticsEvent)=>this.props.onSelected(selectedOptions.map((o)=>({
                    id: o.value,
                    name: o.label
                })), analyticsEvent), this.onFetchOptions = (filter)=>(0, $bcrAM.requestVersions)(this.props.baseUrl, this.props.projectKey, filter, this.props.versionStatuses, this.getVersionIdsToIgnore(), this.props.excludeArchivedVersions);
    }
}
var $7f1843c8e32eaf37$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $iQv12.default)({
    onSelected: 'versionPicker'
})($7f1843c8e32eaf37$export$cf62270384b7743e));

});
parcelRegister("bcrAM", function(module, exports) {

$parcel$export(module.exports, "requestVersions", () => $5693781e34d2d219$export$aadfb092a4919504);

var $fosv1 = parcelRequire("fosv1");

var $5wI4U = parcelRequire("5wI4U");
const $5693781e34d2d219$export$aadfb092a4919504 = async (baseUrl, projectKey, filter, versionStatuses, ignore, excludeArchivedVersions = false)=>{
    const pageVersions = await (0, $fosv1.requestVersions)(baseUrl, projectKey, filter, versionStatuses, ignore);
    return (0, $5wI4U.transformVersions)(pageVersions.values, ignore, excludeArchivedVersions);
};

});
parcelRegister("fosv1", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $8ee5477fd3092e8b$export$f6b2881bc1090cea);
$parcel$export(module.exports, "requestVersions", () => $8ee5477fd3092e8b$export$aadfb092a4919504);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
const $8ee5477fd3092e8b$export$f6b2881bc1090cea = 5;
const $8ee5477fd3092e8b$export$b702ac644ba114c = (baseUrl, projectKey)=>`${baseUrl}/rest/api/2/project/${projectKey}/version`;
const $8ee5477fd3092e8b$export$10181c3ba572bfce = (filter, versionStatuses, ignore)=>(0, $ebyGx.stringify)({
        startAt: 0,
        query: filter,
        maxResults: $8ee5477fd3092e8b$export$f6b2881bc1090cea + ignore.length,
        orderBy: '+NAME',
        status: versionStatuses.join(',')
    });
const $8ee5477fd3092e8b$export$8395ad088d65e586 = (baseUrl, projectKey, filter, versionStatuses, ignore)=>`${$8ee5477fd3092e8b$export$b702ac644ba114c(baseUrl, projectKey)}?${$8ee5477fd3092e8b$export$10181c3ba572bfce(filter, versionStatuses, ignore)}`;
const $8ee5477fd3092e8b$export$aadfb092a4919504 = async (baseUrl, projectKey, filter, versionStatuses, ignore)=>(0, $7f4tk.default)($8ee5477fd3092e8b$export$8395ad088d65e586(baseUrl, projectKey, filter, versionStatuses, ignore));

});

parcelRegister("5wI4U", function(module, exports) {

$parcel$export(module.exports, "transformVersion", () => $9ac4e1645e42431e$export$390ab7123357e756);
$parcel$export(module.exports, "transformVersions", () => $9ac4e1645e42431e$export$8bc7a3929156b65e);

var $fosv1 = parcelRequire("fosv1");
const $9ac4e1645e42431e$export$390ab7123357e756 = (component)=>({
        value: component.id,
        label: component.name
    });
const $9ac4e1645e42431e$export$8bc7a3929156b65e = (data, ignore, excludeArchivedVersions)=>data.filter((value)=>!ignore.includes(value.id) && (!excludeArchivedVersions || !value.archived)).map($9ac4e1645e42431e$export$390ab7123357e756).slice(0, (0, $fosv1.MAX_RESULTS));

});


parcelRegister("kVzJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc1b839fbdef43a1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cc1b839fbdef43a1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "version-picker.error",
        "defaultMessage": "We couldn't retrieve versions"
    },
    placeholder: {
        "id": "version-picker.placeholder",
        "defaultMessage": "Select version"
    }
});

});


parcelRegister("04HsQ", function(module, exports) {

$parcel$export(module.exports, "refineDefaultValue", () => $0ce10a8c6cc27401$export$7ed87108605c2);
const $0ce10a8c6cc27401$export$7ed87108605c2 = (defaultValue)=>{
    if (defaultValue !== null && typeof defaultValue === 'object' && 'id' in defaultValue && 'name' in defaultValue && (typeof defaultValue.id === 'string' || typeof defaultValue.id === 'number') && typeof defaultValue.name === 'string') return {
        id: `${defaultValue.id}`,
        name: defaultValue.name
    };
    return null;
};

});

parcelRegister("klvI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fcc050976afed0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $61fcc050976afed0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    multiVersionDefaultValueLabelNew: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.versions.multi.multi-version-default-value-label-new",
        "defaultMessage": "Default versions"
    },
    multiVersionPlaceholder: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.versions.multi.multi-version-placeholder",
        "defaultMessage": "Choose versions"
    },
    multiVersionDefaultValueDisabledTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.versions.multi.multi-version-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default versions"
    }
});

});


parcelRegister("61Iqi", function(module, exports) {

$parcel$export(module.exports, "VersionFieldConfiguration", () => $b8ac9ed1fe64f47e$export$904a2462e4757d29);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $7ZIA5 = parcelRequire("7ZIA5");

var $dlgLJ = parcelRequire("dlgLJ");

var $hPw0Z = parcelRequire("hPw0Z");

var $04HsQ = parcelRequire("04HsQ");

var $8UXoH = parcelRequire("8UXoH");
const $b8ac9ed1fe64f47e$var$onDefaultValueChange = (field, onUpdate)=>(updatedValue)=>onUpdate({
            ...field,
            defaultValue: updatedValue ?? null
        });
const $b8ac9ed1fe64f47e$export$904a2462e4757d29 = ({ field: field, onUpdate: onUpdate, projectKey: projectKey, tooltipDelay: tooltipDelay, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const currentValue = (0, $04HsQ.refineDefaultValue)(field.defaultValue);
    const defaultLabel = (0, $8UXoH.default).versionDefaultValueLabelNew;
    const placeholder = (0, $8UXoH.default).versionPlaceholder;
    const disabledTooltipMessage = (0, $8UXoH.default).versionDefaultValueDisabledTooltip;
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.FieldConfigurationDefaultValue), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isModifyDefaultValueDisabled ? formatMessage(disabledTooltipMessage) : null,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlgLJ.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ZIA5.default), {
        value: currentValue,
        label: formatMessage(defaultLabel),
        placeholder: formatMessage(placeholder),
        projectKey: projectKey,
        onSelected: $b8ac9ed1fe64f47e$var$onDefaultValueChange(field, onUpdate),
        isDisabled: isModifyDefaultValueDisabled,
        // this is used to prevent the menu from remaining
        // open when a user clicks through to another field
        noPortal: true,
        isClearableWithCrossIcon: true
    })))));
};

});
parcelRegister("7ZIA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6639293982f702ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $iQv12 = parcelRequire("iQv12");

var $4U4qk = parcelRequire("4U4qk");

var $az4zD = parcelRequire("az4zD");

var $bcrAM = parcelRequire("bcrAM");

var $5wI4U = parcelRequire("5wI4U");

var $kVzJJ = parcelRequire("kVzJJ");
class $6639293982f702ce$export$c7c815960e157d78 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearableWithCrossIcon: false,
            baseUrl: '',
            noPortal: false,
            value: undefined,
            label: '',
            placeholder: undefined,
            ignore: [],
            versionStatuses: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getVersionIdsToIgnore() {
        const { value: value, ignore: ignore } = this.props;
        if (value) return [
            value.id,
            ...ignore
        ];
        return ignore;
    }
    getPlaceholder() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return this.props.placeholder === undefined ? formatMessage((0, $kVzJJ.default).placeholder) : this.props.placeholder;
    }
    getValue() {
        const { value: value } = this.props;
        if (value === null || value === undefined) return value;
        return (0, $5wI4U.transformVersion)(value);
    }
    render() {
        const { label: label, isRequired: isRequired, isDisabled: isDisabled, intl: intl, noPortal: noPortal, isClearableWithCrossIcon: isClearableWithCrossIcon } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.Picker), {
            value: this.getValue(),
            label: label,
            placeholder: this.getPlaceholder(),
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $kVzJJ.default).error),
            onSelected: this.onSelected,
            options: this.onFetchOptions,
            noPortal: noPortal,
            intl: intl
        });
    }
    constructor(...args){
        super(...args), this.onSelected = (selectedOption, analyticsEvent)=>selectedOption ? this.props.onSelected({
                id: selectedOption.value,
                name: selectedOption.label
            }, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent), this.onFetchOptions = (filter)=>(0, $bcrAM.requestVersions)(this.props.baseUrl, this.props.projectKey, filter, this.props.versionStatuses, this.getVersionIdsToIgnore());
    }
}
var $6639293982f702ce$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $iQv12.default)({
    onSelected: 'versionPicker'
})($6639293982f702ce$export$c7c815960e157d78));

});

parcelRegister("8UXoH", function(module, exports) {

$parcel$export(module.exports, "default", () => $10179559ce66ddb7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10179559ce66ddb7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    versionDefaultValueLabelNew: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.versions.single.version-default-value-label-new",
        "defaultMessage": "Default version"
    },
    versionPlaceholder: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.versions.single.version-placeholder",
        "defaultMessage": "Choose a version"
    },
    versionDefaultValueDisabledTooltip: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.versions.single.version-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default version"
    }
});

});



parcelRegister("gIb2d", function(module, exports) {

$parcel$export(module.exports, "FieldTooltipContent", () => $ce48fc5f4b4c7eb5$export$73daa61329af8a4);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $4PsJ3 = parcelRequire("4PsJ3");
const $ce48fc5f4b4c7eb5$export$73daa61329af8a4 = ({ isAppField: isAppField, fieldCreator: fieldCreator, uneditable: uneditable, unrequirable: unrequirable, unsortable: unsortable, unremovable: unremovable })=>{
    const intl = (0, $koVbs.default)();
    const baseMessage = isAppField ? (0, $4PsJ3.messages).baseAppField : (0, $4PsJ3.messages).base;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, intl.formatMessage(baseMessage, {
        fieldCreator: fieldCreator
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce48fc5f4b4c7eb5$var$ContentList, null, uneditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        key: "edit"
    }, intl.formatMessage((0, $4PsJ3.messages).edit)), unrequirable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        key: "require"
    }, intl.formatMessage((0, $4PsJ3.messages).require)), unremovable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        key: "remove"
    }, intl.formatMessage((0, $4PsJ3.messages).remove)), unsortable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        key: "sort"
    }, intl.formatMessage((0, $4PsJ3.messages).sort))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce48fc5f4b4c7eb5$var$ContentList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt81vji _19pku2gc _19bv1b66 _n3td1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4PsJ3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $01da5606db78e99c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $01da5606db78e99c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    base: {
        "id": "project-settings-apps.issue-type-page.field.field-tooltip.base",
        "defaultMessage": "{fieldCreator} created this field. You can't:"
    },
    baseAppField: {
        "id": "project-settings-apps.issue-type-page.field.field-tooltip.base-app-field",
        "defaultMessage": "The {fieldCreator} app created this field. You can't:"
    },
    edit: {
        "id": "project-settings-apps.issue-type-page.field.field-tooltip.edit",
        "defaultMessage": "edit its name"
    },
    require: {
        "id": "project-settings-apps.issue-type-page.field.field-tooltip.require",
        "defaultMessage": "change if it's required"
    },
    remove: {
        "id": "project-settings-apps.issue-type-page.field.field-tooltip.remove",
        "defaultMessage": "remove it"
    },
    sort: {
        "id": "project-settings-apps.issue-type-page.field.field-tooltip.sort",
        "defaultMessage": "reorder it"
    }
});

});


parcelRegister("jFgQY", function(module, exports) {

$parcel$export(module.exports, "getMessageFlags", () => $e7b2eff1ca570b72$export$8054880a6111622);
const $e7b2eff1ca570b72$export$8054880a6111622 = ({ uneditable: uneditable, unrequirable: unrequirable, unsortable: unsortable, unremovable: unremovable })=>{
    const hasContent = [
        uneditable,
        unrequirable,
        unsortable,
        unremovable
    ].some(Boolean);
    if (!hasContent) return null;
    return {
        uneditable: uneditable,
        unrequirable: unrequirable,
        unsortable: unsortable,
        unremovable: unremovable
    };
};

});

parcelRegister("6ozDP", function(module, exports) {

$parcel$export(module.exports, "SidebarContainer", () => $ffc197e702d0c8ba$export$f39f3f768bc98e3d);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $iqLcb = parcelRequire("iqLcb");
const $ffc197e702d0c8ba$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ffc197e702d0c8ba$var$SidebarWrapper, null, children);
const $ffc197e702d0c8ba$var$getSidebarWidth = ()=>360;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ffc197e702d0c8ba$var$SidebarWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-16o9u3h-0"
})({
    boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)",
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: `-${$ffc197e702d0c8ba$var$getSidebarWidth()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    right: `-${$ffc197e702d0c8ba$var$getSidebarWidth()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: `calc(${(0, $iqLcb.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} + ${(0, $iqLcb.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)})`,
    transition: 'right 300ms cubic-bezier(0.2, 0, 0, 1) 0s',
    /* This is needed so Fields stay on top of TopBarWrapper while dragging */ zIndex: 12
});

});

parcelRegister("719NN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80cf50b9813c645$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $5LWLA = parcelRequire("5LWLA");

var $aWse0 = parcelRequire("aWse0");

var $9mwQ0 = parcelRequire("9mwQ0");
const $f80cf50b9813c645$var$arrowRightGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $f80cf50b9813c645$var$StatusFieldOld = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    // we need an extra `div` wrapper here to deal with 100% width that comes from the parent element with display: flex
    // the status field should have auto width based on it's content
    // we can't use fixed width, because in different languages the field name can require different width
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f80cf50b9813c645$var$StatusFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: $f80cf50b9813c645$var$arrowRightGlyph,
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, formatMessage((0, $9mwQ0.default).statusFieldName))));
};
/**
 * The decision point of the StatusField component.
 * It renders the old implementation of the StatusField component.
 * In future implementation, this can be used to create the newer implementation of the StatusField component.
 * Hence this is being left as is.
 *
 * @returns {JSX.Element} StatusField component that switches between the old and new implementation
 */ const $f80cf50b9813c645$var$StatusField = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f80cf50b9813c645$var$StatusFieldOld, null);
};
var $f80cf50b9813c645$export$2e2bcd8739ae039 = $f80cf50b9813c645$var$StatusField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f80cf50b9813c645$var$StatusFieldWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-9tmxc8-0"
})({
    display: 'inline flex',
    alignItems: 'center',
    gap: "var(--ds-space-100, 8px)",
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    marginBottom: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-100, 8px)",
    paddingRight: "var(--ds-space-200, 16px)",
    boxSizing: 'border-box',
    borderRadius: '3px',
    backgroundColor: "var(--ds-border-inverse, #FFFFFF)"
});

});
parcelRegister("9mwQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d697539c08aba58$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8d697539c08aba58$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    statusFieldName: {
        "id": "project-settings-apps-issue-type-page-product-features.common.status-field.status-field-name",
        "defaultMessage": "Status"
    },
    required: {
        "id": "project-settings-apps-issue-type-page-product-features.common.status-field.required",
        "defaultMessage": "Required"
    }
});

});


parcelRegister("kEraB", function(module, exports) {

$parcel$export(module.exports, "mergeGetActiveFieldHeaderInfo", () => $b6f760679d3d817e$export$abb245cf25107153);

var $8QpSo = parcelRequire("8QpSo");
const $b6f760679d3d817e$var$levelToNumber = (level)=>{
    switch(level){
        case 'error':
            return 3;
        case 'warning':
            return 2;
        case 'info':
            return 1;
        default:
            return 0;
    }
};
const $b6f760679d3d817e$export$ba2acf54460cf61 = (x, y)=>{
    if ($b6f760679d3d817e$var$levelToNumber(x) < $b6f760679d3d817e$var$levelToNumber(y)) return 1;
    if ($b6f760679d3d817e$var$levelToNumber(x) > $b6f760679d3d817e$var$levelToNumber(y)) return -1;
    return 0;
};
function $b6f760679d3d817e$var$paramsEqual([params1], [params2]) {
    // We don't compare intl on purpose because we do not care about equality of that
    // - the intl instance can change as much as it likes, and it will not affect our memoizer.
    return params1.associatedField === params2.associatedField && params1.isRequirabilityDisplayed === params2.isRequirabilityDisplayed && params1.layoutOwners === params2.layoutOwners;
}
/**
 * This must be a function because the reducer uses the longText array as a writeable array
 * therefore we need new instances of it for every run.
 * The whole function is memoized on the top level.
 */ const $b6f760679d3d817e$var$initialValue = ()=>({
        longText: []
    });
function $b6f760679d3d817e$var$reducer(mostImportantLevel) {
    return (acc, curr)=>{
        if (curr == null) return acc;
        if (Array.isArray(curr.longText)) acc.longText.splice(acc.longText.length, 0, ...curr.longText);
        else if (curr.longText != null) acc.longText.push(curr.longText);
        if (acc.icon == null && acc.shortText == null && acc.midText == null && curr.icon?.type === mostImportantLevel) {
            acc.icon = curr.icon;
            acc.shortText = curr.shortText;
            acc.midText = curr.midText;
        }
        return acc;
    };
}
function $b6f760679d3d817e$var$getMostImportantLevel(notEmptyResults) {
    return notEmptyResults.map((i)=>i.icon?.type).sort($b6f760679d3d817e$export$ba2acf54460cf61).shift();
}
const $b6f760679d3d817e$export$abb245cf25107153 = (...getters)=>(0, $8QpSo.default)((params)=>{
        const results = getters.map((getter)=>getter(params));
        const notEmptyResults = results.filter(Boolean);
        if (notEmptyResults.length === 0) return $b6f760679d3d817e$var$initialValue();
        if (notEmptyResults.length === 1) return notEmptyResults[0];
        const mostImportantLevel = $b6f760679d3d817e$var$getMostImportantLevel(notEmptyResults);
        return notEmptyResults.reduce($b6f760679d3d817e$var$reducer(mostImportantLevel), $b6f760679d3d817e$var$initialValue());
    }, $b6f760679d3d817e$var$paramsEqual);

});

parcelRegister("ayl8e", function(module, exports) {

$parcel$export(module.exports, "requiredFieldActiveFieldHeaderInfo", () => $c6c1017c604ac919$export$ede6baa78a3551ef);

var $etcZ7 = parcelRequire("etcZ7");
const $c6c1017c604ac919$export$ede6baa78a3551ef = ({ associatedField: associatedField, isRequirabilityDisplayed: isRequirabilityDisplayed })=>{
    if (isRequirabilityDisplayed && associatedField.required) return {
        shortText: (0, $etcZ7.messages).required
    };
    return undefined;
};

});
parcelRegister("etcZ7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d2bcca9409698099$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d2bcca9409698099$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    required: {
        "id": "jsd.project-settings-apps.issue-type-page.field.required",
        "defaultMessage": "Required"
    }
});

});


parcelRegister("kp2EN", function(module, exports) {

$parcel$export(module.exports, "fieldDefaultValueValidator", () => $23d92331903bfbef$export$39469bea8bf1ddd8);

var $iaUQo = parcelRequire("iaUQo");

var $4a0qc = parcelRequire("4a0qc");

var $1FRHQ = parcelRequire("1FRHQ");

var $hDWv6 = parcelRequire("hDWv6");
const $23d92331903bfbef$var$validators = (0, $iaUQo.composeValidators)([
    (0, $1FRHQ.validateNumberFieldDefaultValue),
    (0, $hDWv6.validateTextFieldDefaultValue),
    (0, $4a0qc.validateMultilineFieldDefaultValue)
]);
const $23d92331903bfbef$export$39469bea8bf1ddd8 = (input)=>$23d92331903bfbef$var$validators(input);

});
parcelRegister("iaUQo", function(module, exports) {

$parcel$export(module.exports, "composeValidators", () => $386367554dfe9f20$export$e7f08dfbe506511b);
const $386367554dfe9f20$export$e7f08dfbe506511b = (validators)=>(validationInput)=>validators.flatMap((validator)=>validator(validationInput));

});

parcelRegister("4a0qc", function(module, exports) {

$parcel$export(module.exports, "validateMultilineFieldDefaultValue", () => $72442e29d93d6c8c$export$8b7075d97be36f86);

var $1QOns = parcelRequire("1QOns");

var $3XO6n = parcelRequire("3XO6n");


var $hDWv6 = parcelRequire("hDWv6");

var $ialm7 = parcelRequire("ialm7");

var $fS4Tb = parcelRequire("fS4Tb");
const $72442e29d93d6c8c$var$valid = [];
const $72442e29d93d6c8c$export$4d473d0ca0869dae = 32767;
const $72442e29d93d6c8c$var$tooLongDescriptionField = [
    {
        position: (0, $d2e37636a1b0be7f$export$fa640bba89c0678c),
        messageDescriptor: (0, $fS4Tb.messages).defaultValueTooLongErrorDescription,
        values: {
            MAX_ALLOWED_TEXT_LENGTH: $hDWv6.MAX_ALLOWED_TEXT_LENGTH
        }
    }
];
const $72442e29d93d6c8c$var$tooLongOtherFields = [
    {
        position: (0, $d2e37636a1b0be7f$export$fa640bba89c0678c),
        messageDescriptor: (0, $fS4Tb.messages).defaultValueTooLongErrorValue,
        values: {
            MAX_ALLOWED_TEXT_LENGTH: $hDWv6.MAX_ALLOWED_TEXT_LENGTH
        }
    }
];
const $72442e29d93d6c8c$var$supportedFieldTypes = [
    (0, $3XO6n.DESCRIPTION_FIELD_TYPE),
    (0, $3XO6n.TEXT_AREA_CF_TYPE),
    (0, $3XO6n.ENVIRONMENT_FIELD_TYPE)
];
const $72442e29d93d6c8c$export$8b7075d97be36f86 = ({ field: field, isValidationForced: isValidationForced })=>{
    if (!(0, $ialm7.hasDefaultValueProperty)(field)) return $72442e29d93d6c8c$var$valid;
    const { defaultValue: defaultValue, type: type } = field;
    if (!$72442e29d93d6c8c$var$supportedFieldTypes.includes(type) || !(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(defaultValue)) return $72442e29d93d6c8c$var$valid;
    if (!isValidationForced) // The JSON.stringify call below can take quite a long time.
    // So we don't want it to run on every keystroke!
    // This will delay the validation until it's forced which the platform code
    // does when it needs to, usually on save.
    return $72442e29d93d6c8c$var$valid;
    const value = JSON.stringify(defaultValue);
    if (value && value.length > $72442e29d93d6c8c$export$4d473d0ca0869dae) {
        if (type === (0, $3XO6n.DESCRIPTION_FIELD_TYPE)) // Description system field has its own special error message
        return $72442e29d93d6c8c$var$tooLongDescriptionField;
        return $72442e29d93d6c8c$var$tooLongOtherFields;
    }
    return $72442e29d93d6c8c$var$valid;
};

});
parcelRegister("hDWv6", function(module, exports) {

$parcel$export(module.exports, "MAX_ALLOWED_TEXT_LENGTH", () => $361bcef7e9c9372d$export$7f6f97bfadbc017f);
$parcel$export(module.exports, "validateTextFieldDefaultValue", () => $361bcef7e9c9372d$export$eadb2cd7fdec2afb);

var $5fc53 = parcelRequire("5fc53");


var $ialm7 = parcelRequire("ialm7");

var $32nAm = parcelRequire("32nAm");
const $361bcef7e9c9372d$var$valid = [];
const $361bcef7e9c9372d$export$7f6f97bfadbc017f = 255;
const $361bcef7e9c9372d$var$tooLongError = [
    {
        position: (0, $d2e37636a1b0be7f$export$fa640bba89c0678c),
        messageDescriptor: (0, $32nAm.messages).defaultValueTooLongErrorText,
        values: {
            MAX_ALLOWED_TEXT_LENGTH: $361bcef7e9c9372d$export$7f6f97bfadbc017f
        }
    }
];
const $361bcef7e9c9372d$var$supportedFieldTypes = [
    (0, $5fc53.TEXT_CF_TYPE)
];
const $361bcef7e9c9372d$export$eadb2cd7fdec2afb = ({ field: field })=>{
    if (!(0, $ialm7.hasDefaultValueProperty)(field)) return $361bcef7e9c9372d$var$valid;
    const { defaultValue: defaultValue, type: type } = field;
    if (!$361bcef7e9c9372d$var$supportedFieldTypes.includes(type) || !defaultValue || typeof defaultValue !== 'string') return $361bcef7e9c9372d$var$valid;
    if (defaultValue.length > $361bcef7e9c9372d$export$7f6f97bfadbc017f) return $361bcef7e9c9372d$var$tooLongError;
    return $361bcef7e9c9372d$var$valid;
};

});
parcelRegister("ialm7", function(module, exports) {

$parcel$export(module.exports, "hasDefaultValueProperty", () => $bb13378ed7e91426$export$9dd5471262d5eeef);
const $bb13378ed7e91426$export$9dd5471262d5eeef = (field)=>Object.prototype.hasOwnProperty.call(field, 'defaultValue');

});

parcelRegister("32nAm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $62d24750a7e983aa$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $62d24750a7e983aa$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    defaultValueTooLongErrorText: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.text.default-value-too-long-error-text",
        "defaultMessage": "Text fields can't have more than {MAX_ALLOWED_TEXT_LENGTH} characters."
    }
});

});


parcelRegister("fS4Tb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c891f6a12fba737b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $c891f6a12fba737b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    defaultValueTooLongErrorDescription: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-description",
        "defaultMessage": "Your description is too long."
    },
    defaultValueTooLongErrorValue: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-value",
        "defaultMessage": "Your text is too long."
    }
});

});


parcelRegister("1FRHQ", function(module, exports) {

$parcel$export(module.exports, "validateNumberFieldDefaultValue", () => $0bdc0d6d298320a9$export$7ffc50ad09e85a97);

var $5fc53 = parcelRequire("5fc53");


var $ialm7 = parcelRequire("ialm7");

var $fmAdJ = parcelRequire("fmAdJ");
const $0bdc0d6d298320a9$var$valid = [];
const $0bdc0d6d298320a9$export$31f4869ea40dcc9f = 100000000000000;
const $0bdc0d6d298320a9$var$tooBigError = [
    {
        position: (0, $d2e37636a1b0be7f$export$fa640bba89c0678c),
        messageDescriptor: (0, $fmAdJ.messages).defaultValueTooLargeErrorNumber,
        values: {
            MAX_ALLOWED_NUMBER: $0bdc0d6d298320a9$export$31f4869ea40dcc9f
        }
    }
];
const $0bdc0d6d298320a9$var$supportedFieldTypes = [
    (0, $5fc53.NUMBER_CF_TYPE),
    (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)
];
const $0bdc0d6d298320a9$export$7ffc50ad09e85a97 = ({ field: field })=>{
    if (!(0, $ialm7.hasDefaultValueProperty)(field)) return $0bdc0d6d298320a9$var$valid;
    const { defaultValue: defaultValue, type: type } = field;
    if (!$0bdc0d6d298320a9$var$supportedFieldTypes.includes(type) || !defaultValue || typeof defaultValue !== 'string') return $0bdc0d6d298320a9$var$valid;
    if (Number(defaultValue) > $0bdc0d6d298320a9$export$31f4869ea40dcc9f) return $0bdc0d6d298320a9$var$tooBigError;
    return $0bdc0d6d298320a9$var$valid;
};

});
parcelRegister("fmAdJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9346cbe75b168621$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9346cbe75b168621$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    defaultValueTooLargeErrorNumber: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.number.default-value-too-large-error-number",
        "defaultMessage": "Can\u2019t be larger than {MAX_ALLOWED_NUMBER}."
    }
});

});



parcelRegister("fbE1k", function(module, exports) {

$parcel$export(module.exports, "nameMustBeNotEmpty", () => $cb5d7f574a53e50b$export$cdc2c702a40e18cc);
$parcel$export(module.exports, "descriptionMustNotBeLongerThan", () => $cb5d7f574a53e50b$export$571bba3113689e1c);


var $i7vU8 = parcelRequire("i7vU8");
const $cb5d7f574a53e50b$var$valid = [];
const $cb5d7f574a53e50b$var$errorFieldEmptyName = [
    {
        position: (0, $d2e37636a1b0be7f$export$46836eb4ff11521d),
        messageDescriptor: (0, $i7vU8.messages).errorFieldEmptyName
    }
];
const $cb5d7f574a53e50b$export$cdc2c702a40e18cc = ({ field: field, isValidationForced: isValidationForced })=>{
    if (!isValidationForced) // User may want to return to this field later, or they could be in the middle of typing
    return $cb5d7f574a53e50b$var$valid;
    if (field.name === '') return $cb5d7f574a53e50b$var$errorFieldEmptyName;
    return $cb5d7f574a53e50b$var$valid;
};
const $cb5d7f574a53e50b$export$571bba3113689e1c = (maximumDescriptionLength)=>{
    const errorFieldDescriptionTooLong = [
        {
            position: (0, $d2e37636a1b0be7f$export$79e928bf2e38d2f4),
            messageDescriptor: (0, $i7vU8.messages).errorFieldDescriptionTooLong,
            values: {
                maxCharacters: maximumDescriptionLength
            }
        }
    ];
    return ({ field: field })=>{
        // Our types say that field.description is never null/undefined, but Sentry reports that in prod it sometimes is
        if (field.description != null && field.description.length > maximumDescriptionLength) return errorFieldDescriptionTooLong;
        return $cb5d7f574a53e50b$var$valid;
    };
};

});
parcelRegister("i7vU8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $49095919538c8bd5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $49095919538c8bd5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorFieldEmptyName: {
        "id": "project-settings-apps.issue-type-page.fields.field.error-field-empty-name",
        "defaultMessage": "Give the field a name"
    },
    errorFieldDescriptionTooLong: {
        "id": "project-settings-apps.issue-type-page.fields.field.error-field-description-too-long",
        "defaultMessage": "Description can't exceed {maxCharacters} characters"
    }
});

});


parcelRegister("3p4Fj", function(module, exports) {

$parcel$export(module.exports, "optionsMustBeUniquePerParent", () => $db62eaf3ae102a0f$export$17bc4e52c4a498);

var $5fc53 = parcelRequire("5fc53");


var $c74Ue = parcelRequire("c74Ue");
const $db62eaf3ae102a0f$var$valid = [];
const $db62eaf3ae102a0f$var$fieldsThatSupportOptions = [
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.CASCADING_SELECT_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.RADIO_BUTTONS_CF_TYPE)
];
const $db62eaf3ae102a0f$var$doesFieldTypeSupportOptions = (fieldType)=>$db62eaf3ae102a0f$var$fieldsThatSupportOptions.includes(fieldType);
const $db62eaf3ae102a0f$var$checkForDuplicatedOptionsPerParentExternalUuid = (options)=>{
    // `seenValuesMap` is a map of parentExternalUuids (can be null) -> a set of seen values
    // a null parentExternalUuid represents top level options
    const seenValuesMap = new Map();
    const checkValue = (parentExternalUuid, value)=>Boolean(seenValuesMap.get(parentExternalUuid)?.has(value));
    const rememberValue = (parentExternalUuid, value)=>{
        let seenValuesForParent = seenValuesMap.get(parentExternalUuid);
        if (!seenValuesForParent) {
            seenValuesForParent = new Set();
            seenValuesMap.set(parentExternalUuid, seenValuesForParent);
        }
        seenValuesForParent.add(value);
    };
    const errors = [];
    options.forEach((option)=>{
        const { parentExternalUuid: parentExternalUuid, value: value } = option;
        if (checkValue(parentExternalUuid ?? null, value)) errors.push({
            position: (0, $d2e37636a1b0be7f$export$cc69bd2d2695dc1d),
            messageDescriptor: (0, $c74Ue.messages).errorKeyDuplicate,
            positionId: {
                optionOptimisticId: option.optimisticId
            }
        });
        else rememberValue(parentExternalUuid ?? null, value);
    });
    return errors;
};
const $db62eaf3ae102a0f$export$17bc4e52c4a498 = ({ field: field })=>{
    if (!$db62eaf3ae102a0f$var$doesFieldTypeSupportOptions(field.type)) return $db62eaf3ae102a0f$var$valid;
    if (!field.operations.canModifyOptions) return $db62eaf3ae102a0f$var$valid;
    if (field.options == null) /*
		 * TMP SWIFT used to require that all option-fields must have at least one option,
		 * but the global settings page doesn't do that, and it allows having zero options.
		 * So let's do the same here.
		 */ return $db62eaf3ae102a0f$var$valid;
    return $db62eaf3ae102a0f$var$checkForDuplicatedOptionsPerParentExternalUuid(field.options);
};

});
parcelRegister("c74Ue", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a00d43b1455b68b5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a00d43b1455b68b5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorKeyDuplicate: {
        "id": "project-settings-apps.issue-type-page.field.field-configuration.field-with-options.error-key-duplicate",
        "defaultMessage": "Already exists. Try something else."
    }
});

});


parcelRegister("8k5eK", function(module, exports) {

$parcel$export(module.exports, "validateIssueTypeName", () => $7b56a6c4bf3cf3f6$export$231c767d8c47ed1f);
$parcel$export(module.exports, "validateIssueTypeHelpText", () => $7b56a6c4bf3cf3f6$export$58c79713ea64172a);
$parcel$export(module.exports, "validateIssueTypeDescription", () => $7b56a6c4bf3cf3f6$export$870d9557dddbf332);
$parcel$export(module.exports, "validateIssueType", () => $7b56a6c4bf3cf3f6$export$e1a877d27540ccef);

var $8QpSo = parcelRequire("8QpSo");



var $efDZw = parcelRequire("efDZw");
const $7b56a6c4bf3cf3f6$var$nameNormalizer = (str)=>str.toLocaleLowerCase().trim();
const $7b56a6c4bf3cf3f6$export$231c767d8c47ed1f = (0, $8QpSo.default)((issueTypeName, existingIssueTypeNames, validationMessages)=>{
    const normalized = $7b56a6c4bf3cf3f6$var$nameNormalizer(issueTypeName);
    const usedNames = existingIssueTypeNames.map($7b56a6c4bf3cf3f6$var$nameNormalizer);
    const errors = [];
    if (normalized.length < (0, $41355360bde8f3a7$export$59c43d1aa2ab554a)) errors.push({
        position: (0, $d2e37636a1b0be7f$export$9375b5f6fd0a43c1),
        messageDescriptor: validationMessages.errorMessageIssueTypeNameTooShort ?? (0, $efDZw.default).errorMessageIssueTypeNameTooShort
    });
    if (normalized.length > (0, $41355360bde8f3a7$export$ba4f899e906791a3)) errors.push({
        position: (0, $d2e37636a1b0be7f$export$9375b5f6fd0a43c1),
        messageDescriptor: validationMessages.errorMessageIssueTypeNameTooLong ?? (0, $efDZw.default).errorMessageIssueTypeNameTooLong,
        values: {
            maximumNameLength: (0, $41355360bde8f3a7$export$ba4f899e906791a3)
        }
    });
    if (usedNames.includes(normalized)) errors.push({
        position: (0, $d2e37636a1b0be7f$export$9375b5f6fd0a43c1),
        messageDescriptor: validationMessages.errorMessageIssueTypeNameAlreadyExists ?? (0, $efDZw.default).errorMessageIssueTypeNameAlreadyExists
    });
    return errors;
});
const $7b56a6c4bf3cf3f6$export$58c79713ea64172a = (issueTypeHelpText, validationMessages)=>{
    if (issueTypeHelpText.length > (0, $41355360bde8f3a7$export$6de8a702547c6056)) return [
        {
            position: (0, $d2e37636a1b0be7f$export$cb807c52d310479f),
            messageDescriptor: validationMessages.errorMessageIssueTypeHelpTextTooLong ?? (0, $efDZw.default).errorMessageIssueTypeHelpTextTooLong,
            values: {
                maximumHelpTextLength: (0, $41355360bde8f3a7$export$6de8a702547c6056)
            }
        }
    ];
    return [];
};
const $7b56a6c4bf3cf3f6$export$870d9557dddbf332 = (0, $8QpSo.default)((issueTypeDescription, validationMessages)=>{
    if (issueTypeDescription.length > (0, $41355360bde8f3a7$export$1d10d725ce934626)) return [
        {
            position: (0, $d2e37636a1b0be7f$export$b3eded1439af86ec),
            messageDescriptor: validationMessages.errorMessageIssueTypeDescriptionTooLong ?? (0, $efDZw.default).errorMessageDescriptionTooLong,
            values: {
                maximumDescriptionLength: (0, $41355360bde8f3a7$export$1d10d725ce934626)
            }
        }
    ];
    return [];
});
const $7b56a6c4bf3cf3f6$var$getIssueTypeValidators = (0, $8QpSo.default)((overrideValidators)=>({
        [(0, $d2e37636a1b0be7f$export$f94572acf95fe16)]: overrideValidators[0, $d2e37636a1b0be7f$export$f94572acf95fe16] ?? $7b56a6c4bf3cf3f6$export$231c767d8c47ed1f,
        [(0, $d2e37636a1b0be7f$export$d12a5e85a72705c1)]: overrideValidators[0, $d2e37636a1b0be7f$export$d12a5e85a72705c1] ?? $7b56a6c4bf3cf3f6$export$58c79713ea64172a,
        [(0, $d2e37636a1b0be7f$export$66a5f2695bdd185c)]: overrideValidators[0, $d2e37636a1b0be7f$export$66a5f2695bdd185c] ?? $7b56a6c4bf3cf3f6$export$870d9557dddbf332
    }));
const $7b56a6c4bf3cf3f6$export$e1a877d27540ccef = (0, $8QpSo.default)((validationMessages, overrideValidators, issueTypeName, existingIssueTypeNames, issueTypeHelpText, issueTypeDescription)=>{
    const validators = $7b56a6c4bf3cf3f6$var$getIssueTypeValidators(overrideValidators);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(validators).reduce((errors, validatorKey)=>{
        switch(validatorKey){
            case 0, $d2e37636a1b0be7f$export$f94572acf95fe16:
                return [
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...errors,
                    ...validators[0, $d2e37636a1b0be7f$export$f94572acf95fe16](issueTypeName ?? '', existingIssueTypeNames, validationMessages)
                ];
            case 0, $d2e37636a1b0be7f$export$d12a5e85a72705c1:
                return [
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...errors,
                    ...validators[0, $d2e37636a1b0be7f$export$d12a5e85a72705c1](issueTypeHelpText ?? '', validationMessages)
                ];
            case 0, $d2e37636a1b0be7f$export$66a5f2695bdd185c:
                return [
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...errors,
                    ...validators[0, $d2e37636a1b0be7f$export$66a5f2695bdd185c](issueTypeDescription ?? '', validationMessages)
                ];
            default:
                return errors;
        }
    }, []);
});

});
const $41355360bde8f3a7$export$59c43d1aa2ab554a = 1;
const $41355360bde8f3a7$export$ba4f899e906791a3 = 60;
const $41355360bde8f3a7$export$1d10d725ce934626 = 255;
const $41355360bde8f3a7$export$6de8a702547c6056 = 1000;

parcelRegister("efDZw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78afbc755c89245$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f78afbc755c89245$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessageIssueTypeNameTooShort: {
        "id": "project-settings-apps.issue-type-page.main-header.name-inline-input.too-short-error-name",
        "defaultMessage": "Add a name."
    },
    errorMessageIssueTypeNameAlreadyExists: {
        "id": "project-settings-apps.issue-type-page.main-header.name-inline-input.already-exists-error-name",
        "defaultMessage": "Already exists. Try a different name."
    },
    errorMessageIssueTypeNameTooLong: {
        "id": "project-settings-apps.issue-type-page.main-header.name-inline-input.too-long-error-name",
        "defaultMessage": "Name can't exceed {maximumNameLength} characters"
    },
    errorMessageIssueTypeHelpTextTooLong: {
        "id": "project-settings-apps.issue-type-page.main-header.help-text-inline-input.too-long-error-name",
        "defaultMessage": "Help text can't exceed {maximumHelpTextLength} characters"
    },
    errorMessageDescriptionTooLong: {
        "id": "project-settings-apps.issue-type-page.main-header.description-inline-input.too-long-error-name",
        "defaultMessage": "Description can't exceed {maximumDescriptionLength} characters"
    }
});

});


parcelRegister("cgGpC", function(module, exports) {

$parcel$export(module.exports, "ecosystemAppFieldWarning", () => $7d59f21aac6cb387$export$5754b43664e83b8c);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $92Z2l = parcelRequire("92Z2l");

var $4R6GH = parcelRequire("4R6GH");

var $hPw0Z = parcelRequire("hPw0Z");

var $gZupC = parcelRequire("gZupC");

var $55lVQ = parcelRequire("55lVQ");
const $7d59f21aac6cb387$var$HiddenInAccessNarrowingWarnings = ({ intl: intl, appName: appName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, intl.formatMessage((0, $gZupC.messages).hiddenInAccessNarrowing, {
        appName: appName
    }));
const $7d59f21aac6cb387$var$HiddenInForgeDisplayCondiditionWarnings = ({ intl: intl, forgeDisplayConditions: { appName: appName, issueTypeDisplayConditionRestrictions: issueTypeDisplayConditionRestrictions, projectDisplayConditionRestrictions: projectDisplayConditionRestrictions } })=>{
    if (issueTypeDisplayConditionRestrictions?.isHiddenInDisplayConditions && issueTypeDisplayConditionRestrictions.filteredIssueTypes.length !== 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, issueTypeDisplayConditionRestrictions.areAllIssueTypesFiltered ? intl.formatMessage((0, $gZupC.messages).hiddenInForgeDisplayConditionsStrict, {
        appName: appName
    }) : intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gZupC.messages).hiddenInForgeDisplayConditionsWithIssueTypesIssueTermRefresh : (0, $gZupC.messages).hiddenInForgeDisplayConditionsWithIssueTypes, {
        appName: appName,
        issueTypesCount: issueTypeDisplayConditionRestrictions.filteredIssueTypes.length,
        issueTypes: issueTypeDisplayConditionRestrictions.filteredIssueTypes.map((issueType)=>`"${issueType}"`).join(', ')
    }));
    if (projectDisplayConditionRestrictions?.isHiddenInDisplayConditions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, intl.formatMessage((0, $gZupC.messages).hiddenInForgeDisplayConditionsStrict, {
        appName: appName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, intl.formatMessage((0, $gZupC.messages).hiddenInForgeDisplayConditions, {
        appName: appName
    }));
};
const $7d59f21aac6cb387$export$9b01708c5bfb12d = ({ intl: intl, forgeDisplayConditions: forgeDisplayConditions, accessNarrowedApp: accessNarrowedApp })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7d59f21aac6cb387$var$RestrictedFieldDetails, null, accessNarrowedApp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7d59f21aac6cb387$var$HiddenInAccessNarrowingWarnings, {
        intl: intl,
        appName: accessNarrowedApp
    }), forgeDisplayConditions?.shouldDisplayWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7d59f21aac6cb387$var$HiddenInForgeDisplayCondiditionWarnings, {
        intl: intl,
        forgeDisplayConditions: forgeDisplayConditions
    }));
const $7d59f21aac6cb387$export$5754b43664e83b8c = ({ associatedField: associatedField, layoutOwners: layoutOwners, intl: intl, projectContext: projectContext })=>{
    const { forgeDisplayConditionsRestrictions: forgeDisplayConditionsRestrictions, accessNarrowingRestrictedApp: accessNarrowingRestrictedApp } = (0, $55lVQ.getEcosystemAppsRestrictions)(associatedField.availability, layoutOwners, projectContext, associatedField.provider);
    if (forgeDisplayConditionsRestrictions?.shouldDisplayWarning || accessNarrowingRestrictedApp) return {
        icon: {
            type: 'warning',
            label: (0, $gZupC.messages).restrictedEcosystemAppFieldIconLabel
        },
        longText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7d59f21aac6cb387$export$9b01708c5bfb12d, {
            intl: intl,
            forgeDisplayConditions: forgeDisplayConditionsRestrictions,
            accessNarrowedApp: accessNarrowingRestrictedApp
        })
    };
    return undefined;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7d59f21aac6cb387$var$RestrictedFieldDetails = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hPw0Z.FieldConfigurationDefaultValue), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _cttgpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gZupC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e2a8bfbeaeda53e5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e2a8bfbeaeda53e5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    hiddenInForgeDisplayConditionsStrict: {
        "id": "project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-forge-display-conditions-strict",
        "defaultMessage": "This field isn\u2019t visible because \"{appName}\" hid it. Go to the app\u2019s configuration to change this."
    },
    hiddenInForgeDisplayConditionsWithIssueTypes: {
        "id": "project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-forge-display-conditions-with-issue-types",
        "defaultMessage": "This field isn\u2019t visible on issue {issueTypesCount, plural, one {type} other {types}}: {issueTypes} because \"{appName}\" hid it. Go to the app\u2019s configuration to change this."
    },
    hiddenInForgeDisplayConditions: {
        "id": "project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-forge-display-conditions",
        "defaultMessage": "This field may be hidden by \"{appName}\". Check the app\u2019s configuration to learn more."
    },
    hiddenInAccessNarrowing: {
        "id": "project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-access-narrowing",
        "defaultMessage": "This field belongs to an app \"{appName}\" that is blocked by your organization admin in this project through a data security policy."
    },
    restrictedEcosystemAppFieldIconLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.restricted-ecosystem-app-field-icon-label",
        "defaultMessage": "This app field is restricted"
    },
    hiddenInForgeDisplayConditionsWithIssueTypesIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.ecosystem.restricted-forge-field-warnings.hidden-in-forge-display-conditions-with-issue-types-issue-term-refresh",
        "defaultMessage": "This field isn\u2019t visible on work {issueTypesCount, plural, one {type} other {types}}: {issueTypes} because \"{appName}\" hid it. Go to the app\u2019s configuration to change this."
    }
});

});

parcelRegister("55lVQ", function(module, exports) {

$parcel$export(module.exports, "getEcosystemAppsRestrictions", () => $1136bf7bd4237bd8$export$47cfa35332cf6399);

const $1136bf7bd4237bd8$var$getProjectDisplayConditionRestrictions = (displayConditions, projectContext)=>{
    const isHiddenInDisplayConditions = Object.entries(projectContext).some(([key, value])=>{
        if (displayConditions[key]) {
            if (Array.isArray(displayConditions[key])) {
                if (!displayConditions[key].includes(value)) return true;
            } else if (displayConditions[key] !== value) return true;
        }
        return false;
    });
    return {
        isHiddenInDisplayConditions: isHiddenInDisplayConditions
    };
};
const $1136bf7bd4237bd8$var$getIssueTypeDisplayConditionRestrictions = (displayConditions, layoutOwners)=>{
    let isHiddenInDisplayConditions = false;
    const issueLayoutOwnersIssueTypeList = layoutOwners.filter((owner)=>owner.type === (0, $231503f5cdbec9c4$export$48834e33dc47483));
    const filteredIssueTypes = issueLayoutOwnersIssueTypeList.filter((owner)=>Array.isArray(displayConditions.issueType) ? !displayConditions.issueType.includes(owner.data.name) : owner.data.name !== displayConditions.issueType).map((issueType)=>issueType.data.name);
    if (filteredIssueTypes.length || issueLayoutOwnersIssueTypeList.length === 0) isHiddenInDisplayConditions = true;
    const areAllIssueTypesFiltered = filteredIssueTypes.length === issueLayoutOwnersIssueTypeList.length;
    return {
        isHiddenInDisplayConditions: isHiddenInDisplayConditions,
        filteredIssueTypes: filteredIssueTypes,
        areAllIssueTypesFiltered: areAllIssueTypesFiltered
    };
};
const $1136bf7bd4237bd8$export$b9615ef6fb6d6889 = (availability, layoutOwners, projectContext, provider)=>{
    if (!availability || !availability.displayConditions || !provider) return null;
    const { displayConditions: displayConditions } = availability;
    let issueTypeDisplayConditionRestrictions = null;
    let projectDisplayConditionRestrictions = null;
    let shouldDisplayWarning = true;
    if (displayConditions.isSimpleIssueTypeDisplayCondition) {
        issueTypeDisplayConditionRestrictions = $1136bf7bd4237bd8$var$getIssueTypeDisplayConditionRestrictions(displayConditions, layoutOwners);
        if (!issueTypeDisplayConditionRestrictions.isHiddenInDisplayConditions) shouldDisplayWarning = false;
    } else if (displayConditions.isSimpleProjectDisplayCondition) {
        projectDisplayConditionRestrictions = $1136bf7bd4237bd8$var$getProjectDisplayConditionRestrictions(displayConditions, projectContext);
        if (!projectDisplayConditionRestrictions.isHiddenInDisplayConditions) shouldDisplayWarning = false;
    }
    return {
        shouldDisplayWarning: shouldDisplayWarning,
        issueTypeDisplayConditionRestrictions: issueTypeDisplayConditionRestrictions,
        projectDisplayConditionRestrictions: projectDisplayConditionRestrictions,
        appName: provider.name
    };
};
const $1136bf7bd4237bd8$export$792dd838c74ab467 = (availability, provider)=>{
    if (!availability || !availability.isHiddenByAppAccessRules || !provider) return null;
    return provider.name;
};
const $1136bf7bd4237bd8$export$47cfa35332cf6399 = (availability, layoutOwners, projectContext, provider)=>{
    const forgeDisplayConditionsRestrictions = $1136bf7bd4237bd8$export$b9615ef6fb6d6889(availability, layoutOwners, projectContext, provider);
    const accessNarrowingRestrictedApp = $1136bf7bd4237bd8$export$792dd838c74ab467(availability, provider);
    return {
        forgeDisplayConditionsRestrictions: forgeDisplayConditionsRestrictions,
        accessNarrowingRestrictedApp: accessNarrowingRestrictedApp
    };
};

});
const $231503f5cdbec9c4$export$48834e33dc47483 = 'ISSUE_TYPE';
const $231503f5cdbec9c4$export$3bfbaac56381682c = 'REQUEST_TYPE';



parcelRegister("9LMsC", function(module, exports) {

$parcel$export(module.exports, "RestrictedFieldWarnings", () => $a7ca5aa1a127df18$export$b422267875f185);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $92Z2l = parcelRequire("92Z2l");

var $4R6GH = parcelRequire("4R6GH");

var $itmJb = parcelRequire("itmJb");

var $hPw0Z = parcelRequire("hPw0Z");

var $lN1S8 = parcelRequire("lN1S8");


var $dXdGS = parcelRequire("dXdGS");
const $a7ca5aa1a127df18$var$HiddenInContextWarning = ({ context: context, customFieldId: customFieldId, intl: intl, showGoToContextLink: showGoToContextLink })=>{
    if (!showGoToContextLink && (0, $4R6GH.fg)('dagc-53-hide-go-to-context-link-for-da')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).contextNotAppliedNonGlobalAdminIssueTermRefresh : (0, $dXdGS.messages).contextNotAppliedNonGlobalAdmin));
    const link = context === (0, $d60d1919cda17ec9$export$ddfe3e20c145601) ? `/secure/admin/ConfigureCustomField!default.jspa?customFieldId=${customFieldId}` : `/secure/admin/ManageConfigurationScheme!default.jspa?customFieldId=${customFieldId}&fieldConfigSchemeId=${context.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).contextNotAppliedIssueTermRefresh : (0, $dXdGS.messages).contextNotApplied, {
        a: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
                href: link
            }, message)
    }));
};
const $a7ca5aa1a127df18$export$34a59ccc133a806 = ({ intl: intl, hiddenInConfigurationWithIssueTypes: hiddenInConfigurationWithIssueTypes, showGoToFieldConfigurationLink: showGoToFieldConfigurationLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hiddenInConfigurationWithIssueTypes.map((e, i)=>{
        const { fieldConfigId: fieldConfigId, fieldConfigName: fieldConfigName, fieldConfigIssueTypes: fieldConfigIssueTypes, isDefaultFieldConfig: isDefaultFieldConfig } = e;
        const associatedIssueTypesCount = fieldConfigIssueTypes.length;
        if (!showGoToFieldConfigurationLink && (0, $4R6GH.fg)('dagc-157-hide-go-to-field-configuration-link-da')) {
            if (isDefaultFieldConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
                key: fieldConfigId + i,
                appearance: "warning"
            }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).hiddenInConfigurationForNIssueTypesNonGlobalAdminIssueTermRefresh : (0, $dXdGS.messages).hiddenInConfigurationForNIssueTypesNonGlobalAdmin, {
                associatedIssueTypesCount: associatedIssueTypesCount
            }));
            if (associatedIssueTypesCount === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
                key: fieldConfigId + i,
                appearance: "warning"
            }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).hiddenInConfigurationForSingleIssueTypeNonGlobalAdminIssueTermRefresh : (0, $dXdGS.messages).hiddenInConfigurationForSingleIssueTypeNonGlobalAdmin, {
                issueTypeName: fieldConfigIssueTypes[0]
            }));
            if (associatedIssueTypesCount === 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
                key: fieldConfigId + i,
                appearance: "warning"
            }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).hiddenInConfigurationForTwoIssueTypesNonGlobalAdminIssueTermRefresh : (0, $dXdGS.messages).hiddenInConfigurationForTwoIssueTypesNonGlobalAdmin, {
                issueTypeName1: fieldConfigIssueTypes[0],
                issueTypeName2: fieldConfigIssueTypes[1]
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
                key: fieldConfigId + i,
                appearance: "warning"
            }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).hiddenInConfigurationForNIssueTypesNonGlobalAdminIssueTermRefresh : (0, $dXdGS.messages).hiddenInConfigurationForNIssueTypesNonGlobalAdmin, {
                associatedIssueTypesCount: associatedIssueTypesCount
            }));
        }
        if (isDefaultFieldConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            key: fieldConfigId + i,
            appearance: "warning"
        }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).hiddenInConfigurationForNIssueTypesIssueTermRefresh : (0, $dXdGS.messages).hiddenInConfigurationForNIssueTypes, {
            associatedIssueTypesCount: associatedIssueTypesCount,
            fieldConfigName: fieldConfigName,
            a: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
                    href: `/secure/admin/ConfigureFieldLayout!default.jspa?id=${fieldConfigId}`
                }, message)
        }));
        if (associatedIssueTypesCount === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            key: fieldConfigId + i,
            appearance: "warning"
        }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).hiddenInConfigurationForSingleIssueTypeIssueTermRefresh : (0, $dXdGS.messages).hiddenInConfigurationForSingleIssueType, {
            issueTypeName: fieldConfigIssueTypes[0],
            fieldConfigName: fieldConfigName,
            a: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
                    href: `/secure/admin/ConfigureFieldLayout!default.jspa?id=${fieldConfigId}`
                }, message)
        }));
        if (associatedIssueTypesCount === 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            key: fieldConfigId + i,
            appearance: "warning"
        }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).hiddenInConfigurationForTwoIssueTypesIssueTermRefresh : (0, $dXdGS.messages).hiddenInConfigurationForTwoIssueTypes, {
            issueTypeName1: fieldConfigIssueTypes[0],
            issueTypeName2: fieldConfigIssueTypes[1],
            fieldConfigName: fieldConfigName,
            a: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
                    href: `/secure/admin/ConfigureFieldLayout!default.jspa?id=${fieldConfigId}`
                }, message)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            key: fieldConfigId + i,
            appearance: "warning"
        }, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXdGS.messages).hiddenInConfigurationForNIssueTypesIssueTermRefresh : (0, $dXdGS.messages).hiddenInConfigurationForNIssueTypes, {
            associatedIssueTypesCount: associatedIssueTypesCount,
            fieldConfigName: fieldConfigName,
            a: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
                    href: `/secure/admin/ConfigureFieldLayout!default.jspa?id=${fieldConfigId}`
                }, message)
        }));
    }));
const $a7ca5aa1a127df18$export$b422267875f185 = ({ hiddenInContext: hiddenInContext, hiddenInConfigurationsWithIssueTypes: hiddenInConfigurationsWithIssueTypes, fieldKey: fieldKey, intl: intl, HiddenInContextComponent: HiddenInContextComponentFromProps })=>{
    const customFieldId = fieldKey.split('_')[1];
    const isGlobalAdmin = (0, $itmJb.useIsAdmin)();
    const HiddenInContextWarningToBeUsed = HiddenInContextComponentFromProps || $a7ca5aa1a127df18$var$HiddenInContextWarning;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7ca5aa1a127df18$export$f58776bc2f0f440f, null, hiddenInContext !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HiddenInContextWarningToBeUsed, {
        context: hiddenInContext,
        customFieldId: customFieldId,
        intl: intl,
        showGoToContextLink: isGlobalAdmin
    }), hiddenInConfigurationsWithIssueTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7ca5aa1a127df18$export$34a59ccc133a806, {
        hiddenInConfigurationWithIssueTypes: hiddenInConfigurationsWithIssueTypes,
        intl: intl,
        showGoToFieldConfigurationLink: isGlobalAdmin
    }));
};
const $a7ca5aa1a127df18$export$f58776bc2f0f440f = /*#__PURE__*/ (0, $47bDC.default)((0, $hPw0Z.FieldConfigurationDefaultValue)).withConfig({
    componentId: "oslnby-0"
})({
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '> *:not(:last-child)': {
        marginBottom: "var(--ds-space-200, 16px)"
    }
});

});
parcelRegister("lN1S8", function(module, exports) {

$parcel$export(module.exports, "NewTabLink", () => $037a1c331285abb7$export$342b9ba2cf2f8e22);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $7paD5 = parcelRequire("7paD5");

var $koVbs = parcelRequire("koVbs");

var $ienZ5 = parcelRequire("ienZ5");
const $037a1c331285abb7$export$342b9ba2cf2f8e22 = ({ href: href, children: children, onClick: onClick, onAuxClick: onAuxClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        target: "_blank",
        href: href,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($037a1c331285abb7$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            label: formatMessage((0, $ienZ5.messages).newTabIconDescription),
            LEGACY_size: "small"
        })),
        onClick: onClick,
        onAuxClick: onAuxClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($037a1c331285abb7$var$ButtonText, null, children));
};
const $037a1c331285abb7$var$fontWeight400 = /*#__PURE__*/ (0, $47bDC.css)({
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
// FIXME: type error in object syntax passing result of `css` to `styled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $037a1c331285abb7$var$ButtonText = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1fafiq5-0"
})({
    marginRight: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$037a1c331285abb7$var$fontWeight400);
// FIXME: type error in object syntax passing result of `css` to `styled
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $037a1c331285abb7$var$IconWrapper = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1fafiq5-1"
})`${$037a1c331285abb7$var$fontWeight400}`;

});
parcelRegister("ienZ5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dbda82c2bd5f4f8e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $dbda82c2bd5f4f8e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    newTabIconDescription: {
        "id": "project-settings-apps-issue-type-page-product-features.common.new-tab-link.new-tab-icon-description",
        "defaultMessage": "This link will be opened in a new tab"
    }
});

});


const $d60d1919cda17ec9$export$ddfe3e20c145601 = 'NO_CONTEXT';

parcelRegister("dXdGS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3a3791aad65a0cde$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3a3791aad65a0cde$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    hiddenInConfiguration: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration",
        "defaultMessage": "This field is hidden in the field configuration, and you can't see it in the issue view. <a>Go to \"{configName}\"</a> to change this."
    },
    contextNotApplied: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied",
        "defaultMessage": "You can't see this field in the issue view as the context is not applied to this project. <a>Go to context</a> to choose applicable context."
    },
    contextNotAppliedNonGlobalAdmin: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-non-global-admin",
        "defaultMessage": "You can't see this field in the issue view as the context is not applied to this project."
    },
    contextNotAppliedV2: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-v2",
        "defaultMessage": "You  can't see this field in the issue view as the context is not applied to this project. <a>Go to context</a> to choose applicable context or create a new one."
    },
    restrictedFieldIconLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.restricted-field-icon-label",
        "defaultMessage": "This field is restricted"
    },
    hiddenInConfigurationForSingleIssueTypeNonGlobalAdmin: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-single-issue-type-non-global-admin",
        "defaultMessage": "This field is hidden for the \u201C{issueTypeName}\u201D issue type, and you can\u2019t see it in the issue view."
    },
    hiddenInConfigurationForTwoIssueTypesNonGlobalAdmin: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-two-issue-types-non-global-admin",
        "defaultMessage": "This field is hidden for the \u201C{issueTypeName1}\u201D and \u201C{issueTypeName2}\u201D issue types, and you can\u2019t see it in the issue view."
    },
    hiddenInConfigurationForNIssueTypesNonGlobalAdmin: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-n-issue-types-non-global-admin",
        "defaultMessage": "This field is hidden for {associatedIssueTypesCount, plural, one {# issue type} other {# issue types}}, and you can\u2019t see it in the issue view."
    },
    hiddenInConfigurationForSingleIssueType: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-single-issue-type",
        "defaultMessage": "This field is hidden for the \u201C{issueTypeName}\u201D issue type, and you can\u2019t see it in the issue view. <a>Go to \u201C{fieldConfigName}\u201D</a> to change this."
    },
    hiddenInConfigurationForTwoIssueTypes: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-two-issue-types",
        "defaultMessage": "This field is hidden for the \u201C{issueTypeName1}\u201D and \u201C{issueTypeName2}\u201D issue types, and you can\u2019t see it in the issue view. <a>Go to \u201C{fieldConfigName}\u201D</a> to change this."
    },
    hiddenInConfigurationForNIssueTypes: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-n-issue-types",
        "defaultMessage": "This field is hidden for {associatedIssueTypesCount, plural, one {# issue type} other {# issue types}}, and you can\u2019t see it in the issue view. <a>Go to \u201C{fieldConfigName}\u201D</a> to change this."
    },
    hiddenInConfigurationIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-issue-term-refresh",
        "defaultMessage": "This field is hidden in the field configuration, and you can't see it in the work item. <a>Go to \"{configName}\"</a> to change this.\""
    },
    contextNotAppliedIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-issue-term-refresh",
        "defaultMessage": "You can't see this field in the work item as the context is not applied to this project. <a>Go to context</a> to choose applicable context."
    },
    contextNotAppliedNonGlobalAdminIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-non-global-admin-issue-term-refresh",
        "defaultMessage": "You can't see this field in the work item as the context is not applied to this project."
    },
    contextNotAppliedV2IssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-v2-issue-term-refresh",
        "defaultMessage": "You can't see this field in the work item as the context is not applied to this project. <a>Go to context</a> to choose applicable context or create a new one."
    },
    hiddenInConfigurationForSingleIssueTypeNonGlobalAdminIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-single-issue-type-non-global-admin-issue-term-refresh",
        "defaultMessage": "This field is hidden for the \u201C{issueTypeName}\u201D work type, and you can\u2019t see it in the work item."
    },
    hiddenInConfigurationForTwoIssueTypesNonGlobalAdminIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-two-issue-types-non-global-admin-issue-term-refresh",
        "defaultMessage": "This field is hidden for the \u201C{issueTypeName1}\u201D and \u201C{issueTypeName2}\u201D work types, and you can\u2019t see it in the work item."
    },
    hiddenInConfigurationForNIssueTypesNonGlobalAdminIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-n-issue-types-non-global-admin-issue-term-refresh",
        "defaultMessage": "This field is hidden for {associatedIssueTypesCount, plural, one {# work type} other {# work types}}, and you can\u2019t see it in the work item."
    },
    hiddenInConfigurationForSingleIssueTypeIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-single-issue-type-issue-term-refresh",
        "defaultMessage": "This field is hidden for the \u201C{issueTypeName}\u201D work type, and you can\u2019t see it in the work item. <a>Go to \u201C{fieldConfigName}\u201D</a> to change this."
    },
    hiddenInConfigurationForTwoIssueTypesIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-two-issue-types-issue-term-refresh",
        "defaultMessage": "This field is hidden for \u201C{issueTypeName1}\u201D and \u201C{issueTypeName2}\u201D work types, and you can\u2019t see it in the work item. <a>Go to \u201C{fieldConfigName}\u201D</a> to change this."
    },
    hiddenInConfigurationForNIssueTypesIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-n-issue-types-issue-term-refresh",
        "defaultMessage": "This field is hidden for {associatedIssueTypesCount, plural, one {# work type} other {# work types}}, and you can\u2019t see it in the work item. <a>Go to \u201C{fieldConfigName}\u201D</a> to change this."
    }
});

});


parcelRegister("fCJv5", function(module, exports) {

$parcel$export(module.exports, "getRestrictions", () => $f5f75988d4b8ccf9$export$f0e4e46afde5636b);

const $f5f75988d4b8ccf9$export$153235ce4ce7c971 = (context, layoutOwners, isCustomField)=>{
    if (!isCustomField) return null;
    if (context === null) return 0, $d60d1919cda17ec9$export$ddfe3e20c145601;
    const { issueTypeIds: issueTypeIds } = context;
    if (!issueTypeIds.length) return null;
    const currentIssueTypeIds = layoutOwners.map(({ data: data })=>data.id.toString());
    const isAvailable = issueTypeIds.some((issueTypeId)=>currentIssueTypeIds.includes(issueTypeId));
    return isAvailable ? null : context;
};
const $f5f75988d4b8ccf9$export$ec13f79ec71096d = (hiddenIn, layoutOwners)=>{
    if (!hiddenIn?.length) return null;
    const layoutOwnersMap = {};
    const hiddenInConfigurationsMap = {};
    for(let i = 0; i < layoutOwners.length; i += 1)layoutOwnersMap[layoutOwners[i].data.id.toString()] = layoutOwners[i].data.name;
    const defaultHiddenIn = hiddenIn.find((e)=>!e.layoutOwnerId);
    const defaultFieldConfigs = defaultHiddenIn ? defaultHiddenIn.fieldConfigs : undefined;
    /**
	 * Actually represents the field config scheme that users have set for all unmapped
	 * issue types.
	 */ const defaultFieldConfigId = !defaultFieldConfigs || defaultFieldConfigs.length === 0 ? undefined : defaultFieldConfigs[0].id;
    for(let i = 0; i < hiddenIn.length; i += 1){
        const currentLayoutOwnerId = hiddenIn[i].layoutOwnerId;
        const currentFieldConfigs = hiddenIn[i].fieldConfigs;
        /**
		 * If the currentLayoutOwnerId is not undefined (means it is not mapped to the global
		 * "default scheme") and we cannot find it in our layoutOwners, this means that
		 * this field is being hidden in a different screen.
		 */ if (currentLayoutOwnerId !== undefined && !(currentLayoutOwnerId in layoutOwnersMap)) continue;
        /**
		 * If configuration layoutOwnerId is undefined, this issuetype is unmapped and has
		 * been mapped to the "default field configuration scheme" set by the user. They are undefined
		 * because unmapped issue types are not associated with any field config, hence we don't
		 * have their data. To represent these unknown issue types we will set them as 'unknown'
		 * so we can still have a count for our UI.
		 */ const issueTypeName = currentLayoutOwnerId === undefined ? 'unknown' : layoutOwnersMap[currentLayoutOwnerId];
        for(let j = 0; j < currentFieldConfigs.length; j += 1){
            const currentFieldConfig = currentFieldConfigs[j];
            const isDefaultFieldConfig = currentFieldConfig.id === defaultFieldConfigId;
            /**
			 * For the "default" scheme, if issues types are also associated with the same scheme by the user,
			 * this issue type will exist in both hiddenInGlobal and hiddenInIssueType and hence double counted,
			 * to avoid this we only count when issue types are hiddenInGlobal.
			 */ if (isDefaultFieldConfig && issueTypeName !== 'unknown') continue;
            if (hiddenInConfigurationsMap[currentFieldConfig.id]) hiddenInConfigurationsMap[currentFieldConfig.id].fieldConfigIssueTypes.push(issueTypeName);
            else hiddenInConfigurationsMap[currentFieldConfig.id] = {
                fieldConfigId: currentFieldConfig.id,
                fieldConfigName: currentFieldConfig.name,
                fieldConfigIssueTypes: [
                    issueTypeName
                ],
                isDefaultFieldConfig: isDefaultFieldConfig
            };
        }
    }
    return Object.values(hiddenInConfigurationsMap);
};
const $f5f75988d4b8ccf9$export$f0e4e46afde5636b = (availability, layoutOwners, isCustomField)=>{
    if (availability == null) return null;
    const { hiddenIn: hiddenIn, context: context } = availability;
    const hiddenInContext = $f5f75988d4b8ccf9$export$153235ce4ce7c971(context, layoutOwners, isCustomField);
    const hiddenInConfigurationsWithIssueTypes = $f5f75988d4b8ccf9$export$ec13f79ec71096d(hiddenIn, layoutOwners);
    if (!hiddenInContext && !hiddenInConfigurationsWithIssueTypes) return null;
    return {
        hiddenInContext: hiddenInContext,
        hiddenInConfigurationsWithIssueTypes: hiddenInConfigurationsWithIssueTypes
    };
};

});

parcelRegister("cgvPO", function(module, exports) {

$parcel$export(module.exports, "fieldCategories", () => $5d229afd45148a64$export$2a5221b3ba8fb353);
$parcel$export(module.exports, "fieldsEditorMessages", () => $5d229afd45148a64$export$1b7853e811c285a1);
$parcel$export(module.exports, "requiredFieldMessages", () => $5d229afd45148a64$export$7b42bfe28285b876);
$parcel$export(module.exports, "requiredFieldMessagesIssueTermRefresh", () => $5d229afd45148a64$export$cc48a1bae7f15a48);
$parcel$export(module.exports, "editIssueTypeMessages", () => $5d229afd45148a64$export$fd75237eeae3fd62);
$parcel$export(module.exports, "editIssueTypeMessagesIssueTermRefresh", () => $5d229afd45148a64$export$d350ffacad6aac67);
$parcel$export(module.exports, "hiddenFieldMessages", () => $5d229afd45148a64$export$36abd7b26d7389fa);
$parcel$export(module.exports, "viewButton", () => $5d229afd45148a64$export$3935ea323ccbd199);
$parcel$export(module.exports, "navigationMessages", () => $5d229afd45148a64$export$4e13269a777b3240);

var $7VHMR = parcelRequire("7VHMR");
const $5d229afd45148a64$export$2a5221b3ba8fb353 = (0, $7VHMR.defineMessages)({
    alwaysShowTitleRequestForm: {
        "id": "project-settings.product-features.service-desk.always-show-title-request-form",
        "defaultMessage": "Customer request form"
    },
    whatArePrimaryFieldsForInProductHelp: {
        "id": "project-settings.product-features.service-desk.what-are-primary-fields-for-in-product-help-with-forms-enabled-request-form",
        "defaultMessage": "Fields and forms added to the request form are filled out by customers when they raise a request from the portal.{br}{br}{learnMoreLink}."
    },
    whatIsThis: {
        "id": "project-settings.product-features.service-desk.what-is-this",
        "defaultMessage": "What\u2019s this?"
    },
    linkToInProductHelpTextPortal: {
        "id": "project-settings.product-features.service-desk.link-to-in-product-help-text-portal",
        "defaultMessage": "Learn more about the portal"
    },
    primaryEmptyMessage: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.primary-empty-message",
        "defaultMessage": "Drag and drop your fields here"
    }
});
const $5d229afd45148a64$export$1b7853e811c285a1 = (0, $7VHMR.defineMessages)({
    sidebarHelperText: {
        "id": "jsd.project-settings-apps.issue-type-page.fields.fields-editor.helper-text",
        "defaultMessage": "Drag and drop these fields to the left area to customize this request type."
    },
    noActionFieldToolbarHeader: {
        "id": "jsd.project-settings-apps.issue-type-page.fields.droppable-list.field-toolbar-no-action.header",
        "defaultMessage": "You can't remove this field"
    },
    noActionFieldToolbarDescription: {
        "id": "jsd.project-settings-apps.issue-type-page.fields.droppable-list.field-toolbar-no-action.message",
        "defaultMessage": "{fieldCreator} created this field. You can't remove it from \u201C{issueTypeName}\u201D requests."
    },
    noActionFieldToolbarDescriptionAppField: {
        "id": "jsd.project-settings-apps.issue-type-page.fields.droppable-list.field-toolbar-no-action-app-field.message",
        "defaultMessage": "The {fieldCreator} app created this field. You can't remove it from \u201C{issueTypeName}\u201D requests."
    },
    inactiveFieldsEmptyMessage: {
        "id": "jsd.project-settings-apps.issue-type-page.fields.droppable-list.inactive-field-list.empty-message",
        "defaultMessage": "Drag unneeded fields here to remove them from your \u201C{issueTypeName}\u201D requests. Fields in this list are available to use later or on other request types."
    },
    // error state; project-settings-apps/issue-type-page/view/view.js
    errorMessageTitle: {
        "id": "jsd.project-settings.project-settings-spa.issue-types-page.error-message-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorMessage: {
        "id": "jsd.project-settings.project-settings-spa.issue-types-page.error-message",
        "defaultMessage": "We couldn't load this request type. Try refreshing the page."
    },
    refreshButton: {
        "id": "jsd.project-settings.project-settings-spa.issue-types-page.refresh-button",
        "defaultMessage": "Try again"
    },
    sharedFieldInfoMessage: {
        "id": "project-settings-apps.issue-type-page.field.info-used-in-other-request-type",
        "defaultMessage": "Other request types use this field."
    },
    sharedFieldDialogMessage: {
        "id": "project-settings-apps.issue-type-page.field.dialog-used-in-other-request-type",
        "defaultMessage": "Some changes you make also affect these request types:"
    },
    sharedFieldLinkToDocumentationText: {
        "id": "project-settings-apps.issue-type-page.field.link-to-documentation-text-used-in-other-request-type",
        "defaultMessage": "Learn more"
    },
    removeDropzoneHeader: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.remove-dropzone-header",
        "defaultMessage": "Drop here to remove field from request form"
    },
    removeDropzoneDescription: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.remove-dropzone-description",
        "defaultMessage": "Fields in this panel won\u2019t appear in the portal for this request type."
    }
});
const $5d229afd45148a64$export$7b42bfe28285b876 = (0, $7VHMR.defineMessages)({
    required: {
        "id": "jsd.project-settings-apps.issue-type-page.field.required",
        "defaultMessage": "Required"
    },
    requiredDisabledAndCheckedTooltip: {
        "id": "jsd.project-settings-apps.issue-type-page.field.required-disabled-and-checked-tooltip",
        "defaultMessage": "{fieldCreator} created and requires this field."
    },
    requiredDisabledAndUncheckedTooltip: {
        "id": "jsd.project-settings-apps.issue-type-page.field.required-disabled-and-unchecked-tooltip",
        "defaultMessage": "{fieldCreator} created this field. You can\u2019t make it required."
    },
    requiredDisabledInAllCategoriesTooltip: {
        "id": "jsd.project-settings-apps.issue-type-page.field.required-disabled-in-all-categories-tooltip",
        "defaultMessage": "You can't make fields on \"{issueType}\" requests required."
    },
    requiredDisabledInCategoryTooltip: {
        "id": "jsd.project-settings-apps.issue-type-page.field.required-disabled-in-category-tooltip",
        "defaultMessage": "Required fields can't be hidden. To make this field required, drag it into the \"{goodList}\" section above."
    },
    requiredTooltip: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.required-tooltip",
        "defaultMessage": "If checked, this field must be filled out when raising a request or creating an issue"
    }
});
const $5d229afd45148a64$export$cc48a1bae7f15a48 = (0, $7VHMR.defineMessages)({
    requiredTooltip: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.required-tooltip-issue-term-refresh",
        "defaultMessage": "If checked, this field must be filled out when raising a request or creating a work item"
    }
});
const $5d229afd45148a64$export$fd75237eeae3fd62 = (0, $7VHMR.defineMessages)({
    backToProject: {
        "id": "jsd.project-settings.project-settings-spa.flags.back-to-project-jsm",
        "defaultMessage": "Back to service project"
    },
    backToRequestTypes: {
        "id": "jsd.project-settings.project-settings-spa.flags.back-to-request-types",
        "defaultMessage": "Back to request types"
    },
    editIssueTypeFailureTitle: {
        "id": "jsd.project-settings.project-settings-spa.flags.edit-issue-type-failure-title-v2",
        "defaultMessage": "We couldn\u2019t save your changes"
    },
    editIssueTypeFailureDescription: {
        "id": "jsd.project-settings.project-settings-spa.flags.edit-issue-type-failure-description-v2",
        "defaultMessage": "We couldn\u2019t update the \u201C{descriptionName}\u201D issue type. Refresh and try again."
    },
    descriptionLabel: {
        "id": "jsd.project-settings-apps.issue-type-page.main-header.description-inline-input.label",
        "defaultMessage": "Description"
    },
    editDescriptionButtonLabel: {
        "id": "jsd.project-settings-apps.issue-type-page.main-header.description-inline-input.edit-description-button-label",
        "defaultMessage": "Edit description"
    },
    descriptionPlaceholder: {
        "id": "jsd.project-settings-apps.issue-type-page.main-header.description-inline-input.placeholder",
        "defaultMessage": "Let people know when to use this request type"
    },
    avatarAlt: {
        "id": "jsd.project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-alt",
        "defaultMessage": "Request type icon"
    },
    editAvatar: {
        "id": "jsd.project-settings-apps.issue-type-page.main-header.avatar-icon.edit-avatar",
        "defaultMessage": "Edit request type icon"
    },
    editIssueTypeSuccessTitle: {
        "id": "jsd.project-settings.project-settings-spa.flags.edit-issue-type-success-title-new",
        "defaultMessage": "Request type updated"
    },
    editIssueTypeSuccessDescription: {
        "id": "jsd.project-settings.project-settings-spa.flags.edit-issue-type-success-description-new",
        "defaultMessage": "\u201C{descriptionName}\u201D has been successfully updated."
    },
    avatarAccessibleAlt: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.avatar-accessible-alt",
        "defaultMessage": "Change request type icon"
    },
    avatarAriaLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.avatar-aria-label",
        "defaultMessage": "Change request type icon - {issueType}"
    },
    editNameButtonLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.edit-name-button-label",
        "defaultMessage": "Edit request type name"
    },
    editNameInputLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.edit-name-input-label",
        "defaultMessage": "Request type name"
    }
});
const $5d229afd45148a64$export$d350ffacad6aac67 = (0, $7VHMR.defineMessages)({
    editIssueTypeFailureDescription: {
        "id": "jsd.project-settings.project-settings-spa.flags.edit-issue-type-failure-description-v2-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t update the \u201C{descriptionName}\u201D work type. Refresh and try again."
    }
});
const $5d229afd45148a64$export$36abd7b26d7389fa = (0, $7VHMR.defineMessages)({
    hidden: {
        "id": "project-settings-apps-issue-type-page-product-features.common.utils.service-desk-classic.hidden",
        "defaultMessage": "Hidden"
    }
});
const $5d229afd45148a64$export$f8f15bb7669a4b01 = (0, $7VHMR.defineMessages)({
    // duplicated in `src/packages/project-settings/issue-type-page-product-features/src/common/utils/service-desk/messages.js`
    preview: {
        "id": "project-settings-apps.issue-type-page.sticky-bottom-controls.preview",
        "defaultMessage": "Preview"
    }
});
const $5d229afd45148a64$export$3935ea323ccbd199 = (0, $7VHMR.defineMessages)({
    view: {
        "id": "project-settings-apps.issue-type-page.sticky-bottom-controls.view",
        "defaultMessage": "View"
    },
    viewInPortal: {
        "id": "project-settings-apps.issue-type-page.sticky-bottom-controls.viewInPortal",
        "defaultMessage": "View in Portal"
    },
    viewDisabledTooltip: {
        "id": "project-settings-apps.issue-type-page.sticky-bottom-controls.viewdiabled",
        "defaultMessage": "Request type can\u2019t be viewed until changes are saved or discarded"
    }
});
const $5d229afd45148a64$export$b4272695756d635a = (0, $7VHMR.defineMessages)({
    learnMore: {
        "id": "project-settings-apps.issue-type-page-product-features.common.utils.service-desk-classic.learnMore",
        "defaultMessage": "Learn more about linking form fields and Jira Fields."
    },
    description: {
        "id": "project-settings-apps.issue-type-page-product-features.common.utils.service-desk-classic.message",
        "defaultMessage": "This Jira field is linked to a form field below. It won't appear in some places in the portal."
    }
});
const $5d229afd45148a64$export$4e13269a777b3240 = (0, $7VHMR.defineMessages)({
    issueTypesLink: {
        "id": "jsd.project-settings.project-settings-spa.view-v2.nav-views.issue-types",
        "defaultMessage": "Request types"
    },
    addIssueTypeDisabledTooltip: {
        "id": "jsd.project-settings.project-settings-spa.view-v2.nav-views.add-issue-type-disabled-tooltip",
        "defaultMessage": "You can't add more than {limit} request types"
    }
});

});

parcelRegister("2IXkL", function(module, exports) {

$parcel$export(module.exports, "DuplicateFormLinkedFieldsWarningDialogWithErrorBoundary", () => $88a733a595532226$export$d6105922e02c5938);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $7NYq5 = parcelRequire("7NYq5");

var $8zOmE = parcelRequire("8zOmE");

var $dAfqg = parcelRequire("dAfqg");

var $koeKL = parcelRequire("koeKL");

var $bnK2X = parcelRequire("bnK2X");

var $9Yw1p = parcelRequire("9Yw1p");

var $lQAYg = parcelRequire("lQAYg");

var $9m75u = parcelRequire("9m75u");

var $69CKn = parcelRequire("69CKn");
const $88a733a595532226$export$5d5c3caf980d617e = (props)=>{
    const { isOpen: isOpen, onConfirm: onConfirm, activeLayoutItems: activeLayoutItems } = props;
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const store = (0, $5uXOq.useContext)((0, $9Yw1p.ProformaStoreContext));
    const state = store?.getState();
    const duplicateJiraFieldsInForm = state && activeLayoutItems ? (0, $lQAYg.getDuplicateJiraFields)(state, activeLayoutItems) : [];
    const hasDuplicateJiraFields = duplicateJiraFieldsInForm.length > 0;
    const formId = state ? (0, $lQAYg.getProformaFormId)(state) : undefined;
    const formName = state ? (0, $lQAYg.getProformaFormName)(state) : undefined;
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && !hasDuplicateJiraFields) onConfirm(undefined);
    }, [
        isOpen,
        onConfirm,
        hasDuplicateJiraFields
    ]);
    if (hasDuplicateJiraFields && formId && projectContext?.projectId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88a733a595532226$export$db8f026974e4d3ff, {
        ...props,
        formName: formName,
        formId: formId,
        projectId: projectContext.projectId,
        duplicateJiraFieldsInForm: duplicateJiraFieldsInForm
    });
    return null;
};
const $88a733a595532226$export$db8f026974e4d3ff = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const [isRemovingFields, setIsRemovingFields] = (0, $5uXOq.useState)(false);
    const { isOpen: isOpen, onCancel: onCancel, onConfirm: onConfirm, formName: formName, duplicateJiraFieldsInForm: duplicateJiraFieldsInForm = [], formId: formId, projectId: projectId } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const hasDuplicateJiraFields = duplicateJiraFieldsInForm.length > 0;
    const removeFields = (0, $5uXOq.useCallback)(async ()=>{
        try {
            await (0, $69CKn.removeLinkedFields)(cloudId, projectId, formId, duplicateJiraFieldsInForm.map((field)=>field.key));
            onConfirm(); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'removeDuplicateLinkedFieldsFromFormError',
                    packageName: (0, $bnK2X.PACKAGE_NAME),
                    teamName: (0, $bnK2X.TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            showFlag({
                id: 'project-settings.issue-type-page-product-features-jsm-common.ui.duplicate-form-linked-fields-warning-dialogerror-removing-duplicate-form-fields',
                type: 'error',
                title: formatMessage((0, $9m75u.default).errorRemovingDuplicateFormFields),
                description: formatMessage((0, $9m75u.default).errorRemovingDuplicateFormFieldsDescription),
                isAutoDismiss: true,
                messageId: 'project-settings-product-features-jsm-common.ui.duplicate-form-linked-fields-warning-dialog.show-flag.error',
                messageType: 'transactional'
            });
        } finally{
            setIsRemovingFields(false);
        }
    }, [
        cloudId,
        projectId,
        formId,
        duplicateJiraFieldsInForm,
        onConfirm,
        showFlag,
        formatMessage
    ]);
    const handleConfirm = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'removeFieldDuplicateFormLinkedFieldsWarningDialog', {
            duplicateJiraFieldsInFormCount: duplicateJiraFieldsInForm?.length
        });
        setIsRemovingFields(true);
        removeFields();
    }, [
        duplicateJiraFieldsInForm,
        removeFields
    ]);
    const handleCancel = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelDuplicateFormLinkedFieldsWarningDialog', {
            duplicateJiraFieldsInFormCount: duplicateJiraFieldsInForm?.length
        });
        onCancel();
    }, [
        duplicateJiraFieldsInForm,
        onCancel
    ]);
    if (duplicateJiraFieldsInForm.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        onClose: onCancel,
        messageId: "project-settings-product-features-jsm-common.ui.duplicate-form-linked-fields-warning-dialog.modal",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $9m75u.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, formatMessage((0, $9m75u.default).singleDuplicateDescription, {
        formField: duplicateJiraFieldsInForm[0].name,
        formName: formName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, formatMessage((0, $9m75u.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: "warning",
        onClick: handleConfirm,
        isLoading: isRemovingFields
    }, formatMessage((0, $9m75u.default).removeField)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && hasDuplicateJiraFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "project-settings-product-features-jsm-common.ui.duplicate-form-linked-fields-warning-dialog.modal.1",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $9m75u.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, duplicateJiraFieldsInForm.length <= 5 ? // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $9m75u.default).multipleDuplicatesDescription, {
        formName: formName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        className: (0, $bwpsq.default)([
            "_19bvxy5q _ca0q1b66"
        ])
    }, duplicateJiraFieldsInForm.map((formField)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: formField.name
        }, formField.name)))) : // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $9m75u.default).genericDuplicatesDescription, {
        formName: formName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, formatMessage((0, $9m75u.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: "warning",
        onClick: handleConfirm,
        isLoading: isRemovingFields
    }, formatMessage((0, $9m75u.default).removeFields)))));
};
const $88a733a595532226$export$d6105922e02c5938 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "duplicate-dialog",
        packageName: "jiraProjectSettingsProductFeaturesJsmCommon",
        teamName: "jsm-request-intake",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88a733a595532226$export$5d5c3caf980d617e, props));
const $88a733a595532226$var$listStyle = null;

});
parcelRegister("bnK2X", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $c9fa1c246c7bedb1$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $c9fa1c246c7bedb1$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ASSOCIATED_SCREEN_ID_REQUEST_OWNER_PROPERTY_KEY", () => $c9fa1c246c7bedb1$export$aefba859678f04a);
$parcel$export(module.exports, "FFC_M2_SPOTLIGHT_ID", () => $c9fa1c246c7bedb1$export$fb570af2aa7f7e26);
$parcel$export(module.exports, "FFC_M2_SPOTLIGHT_TARGET_ID", () => $c9fa1c246c7bedb1$export$bac6a9b50366532);
$parcel$export(module.exports, "FFC_M2_DOCUMENTATION_LINK", () => $c9fa1c246c7bedb1$export$d2a3d5eaa8e34beb);
$parcel$export(module.exports, "FFC_M2_SPOTLIGHT_USER_PROPERTY_KEY", () => $c9fa1c246c7bedb1$export$5e31c79aa9a74b51);
$parcel$export(module.exports, "FFC_M2_SPOLIGHT_SCREEN_NAME", () => $c9fa1c246c7bedb1$export$72b77fae6ef978f5);
$parcel$export(module.exports, "PRODUCT_HELP_ARTICLE_ID", () => $c9fa1c246c7bedb1$export$cc1d0371f6b79374);
$parcel$export(module.exports, "PRODUCT_HELP_LINK", () => $c9fa1c246c7bedb1$export$a5aa255636ac0bc8);
$parcel$export(module.exports, "ARTICLE_ID", () => $c9fa1c246c7bedb1$export$7147685613ef9998);
$parcel$export(module.exports, "PRODUCT_HELP_IPH_LINK_ID", () => $c9fa1c246c7bedb1$export$e13db079b04d4616);
$parcel$export(module.exports, "LayoutType", () => $c9fa1c246c7bedb1$export$584b2eead59b451d);
$parcel$export(module.exports, "LayoutTypeUser", () => $c9fa1c246c7bedb1$export$30d45acf1cdc221);
$parcel$export(module.exports, "JSD_FIELD_ALIAS", () => $c9fa1c246c7bedb1$export$ffd77ce47de6d72c);
$parcel$export(module.exports, "JSD_FIELD_HELPTEXT", () => $c9fa1c246c7bedb1$export$663476c4863d5014);
$parcel$export(module.exports, "JSD_FIELD_APPROVAL_CONFIG", () => $c9fa1c246c7bedb1$export$dc7a7283bd7cd216);
$parcel$export(module.exports, "JSD_FIELD_APPROVAL_ALL_CONFIGS", () => $c9fa1c246c7bedb1$export$79bc253bc6964b1);
$parcel$export(module.exports, "REQUEST_FORM_LOZENGE_COMPONENT_ID", () => $c9fa1c246c7bedb1$export$8f1058d90a2cbec9);
$parcel$export(module.exports, "ISSUE_VIEW_LOZENGE_COMPONENT_ID", () => $c9fa1c246c7bedb1$export$5aff063111e4cfaa);

var $3XO6n = parcelRequire("3XO6n");
const $c9fa1c246c7bedb1$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectSettingsAppsIssueTypePageJsmCommon');
const $c9fa1c246c7bedb1$export$d57b6b390e78d90f = 'jsd-shield';
const $c9fa1c246c7bedb1$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
const $c9fa1c246c7bedb1$export$fb570af2aa7f7e26 = 'ffc-m2-changeboarding-spotlight';
const $c9fa1c246c7bedb1$export$bac6a9b50366532 = 'ffc-m2-changeboarding-spotlight-target';
const $c9fa1c246c7bedb1$export$d2a3d5eaa8e34beb = 'https://support.atlassian.com/jira-service-management-cloud/docs/customize-the-fields-of-a-request-type/';
const $c9fa1c246c7bedb1$export$5e31c79aa9a74b51 = 'jsm-ffc-m2-changeboarding-notification-flag-seen-status';
const $c9fa1c246c7bedb1$export$72b77fae6ef978f5 = 'jsmFfcM2ChangeboardingSpotlight';
const $c9fa1c246c7bedb1$export$cc1d0371f6b79374 = '6I42ggwGORmP84atFaD3hS';
const $c9fa1c246c7bedb1$export$a5aa255636ac0bc8 = 'https://support.atlassian.com/jira-cloud-administration/docs/configure-a-custom-field/#Troubleshoot-issue-configuration-and-context';
const $c9fa1c246c7bedb1$export$7147685613ef9998 = '6xVM2KuVxM8FhqDJ9Wdpii';
const $c9fa1c246c7bedb1$export$e13db079b04d4616 = 'c29tZSBoYXNoIGZvciByZWFjdC1pbnRsIGtleQ==.no-translate';
var $c9fa1c246c7bedb1$export$584b2eead59b451d = /*#__PURE__*/ function(LayoutType) {
    LayoutType["RequestForm"] = "REQUEST_FORM";
    LayoutType["IssueView"] = "ISSUE_VIEW";
    return LayoutType;
}({});
const $c9fa1c246c7bedb1$export$30d45acf1cdc221 = {
    Customer: 'customer',
    Agent: 'agent'
};
const $c9fa1c246c7bedb1$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $c9fa1c246c7bedb1$export$663476c4863d5014 = 'jsd.field.helpText';
const $c9fa1c246c7bedb1$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $c9fa1c246c7bedb1$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';
const $c9fa1c246c7bedb1$export$75a820a987934f50 = 'jsm-fvh-changeboarding-tour-seen-status';
const $c9fa1c246c7bedb1$export$475bf79f94380b57 = 'jsmFvhChangeboardingTour';
const $c9fa1c246c7bedb1$export$431248a22f318dc = {
    SIDEBAR: 'jsm-fvh-changeboarding-tour-spotlight-target-sidebar',
    MAIN_AREA: 'jsm-fvh-changeboarding-tour-spotlight-target-main-area'
};
const $c9fa1c246c7bedb1$export$f6a16b474f31933e = {
    INTRO_SPOTLIGHT: 'introSpotlight',
    SIDEBAR_SPOTLIGHT: 'sidebarSpotlight',
    MAIN_AREA_SPOTLIGHT: 'mainAreaSpotlight'
};
const $c9fa1c246c7bedb1$export$8f1058d90a2cbec9 = 'request-form-sidebar-lozenge';
const $c9fa1c246c7bedb1$export$5aff063111e4cfaa = 'issue-view-sidebar-lozenge';

});

parcelRegister("9Yw1p", function(module, exports) {

$parcel$export(module.exports, "ProformaStoreContext", () => $c1a306f8b5d282b7$export$85144c1217fa15a9);
$parcel$export(module.exports, "ProformaReqConfigProvider", () => $c1a306f8b5d282b7$export$45f1bde7028f5ea3);

var $5uXOq = parcelRequire("5uXOq");

var $iwJFl = parcelRequire("iwJFl");

var $kqnEs = parcelRequire("kqnEs");
const $c1a306f8b5d282b7$export$85144c1217fa15a9 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c1a306f8b5d282b7$export$45f1bde7028f5ea3 = (props)=>{
    const { cloudId: cloudId, extraDefinerId: extraDefinerId, projectId: projectId, projectType: projectType, store: store, children: children } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (extraDefinerId) {
            store.dispatch((0, $kqnEs.syncProformaFormStart)());
            (0, $iwJFl.fetchProformaReqTypeConfig)({
                cloudId: cloudId,
                projectId: projectId,
                requestTypeId: extraDefinerId
            }).then((response)=>{
                if (response !== null) store.dispatch((0, $kqnEs.fetchProformaReqTypeConfigSuccess)(response));
                store.dispatch((0, $kqnEs.setReqTypeContext)({
                    cloudId: cloudId,
                    extraDefinerId: extraDefinerId,
                    projectId: projectId,
                    projectType: projectType
                }));
                store.dispatch((0, $kqnEs.syncProformaFormSuccess)());
            });
        }
    }, [
        cloudId,
        extraDefinerId,
        projectId,
        projectType,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1a306f8b5d282b7$export$85144c1217fa15a9.Provider, {
        value: store
    }, children);
};

});
parcelRegister("iwJFl", function(module, exports) {

$parcel$export(module.exports, "fetchProformaReqTypeConfig", () => $64b5045637af4d9c$export$5f7d881992e08a6a);

var $66FNL = parcelRequire("66FNL");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");


var $cDUV0 = parcelRequire("cDUV0");
const $64b5045637af4d9c$var$transform = (proformaRTFormDataResponse)=>{
    const { formId: formId, formName: formName, fields: fields, newIssueRequestTypeIds: newIssueRequestTypeIds, newIssueIssueTypeIds: newIssueIssueTypeIds, restrictionStatus: restrictionStatus } = proformaRTFormDataResponse;
    const proformaReqTypeConfig = {
        formId: formId,
        formName: formName,
        linkedFieldsKey: (0, (/*@__PURE__*/$parcel$interopDefault($66FNL)))(fields),
        markedForRemoval: false,
        usedAsIssueForm: newIssueIssueTypeIds.length > 0 || newIssueRequestTypeIds.length > 0,
        restrictionStatus: (0, $4R6GH.fg)('granular_permissions_on_forms_m1') ? restrictionStatus : undefined
    };
    return {
        ...proformaReqTypeConfig,
        linkedFields: proformaRTFormDataResponse.fields
    };
};
const $64b5045637af4d9c$var$sendErrorAnalyticsEvent = (projectId, requestTypeId, error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'fetchProformaReqTypeForm',
            packageName: $26bfa12f59001b80$export$9345d7360ffe0722,
            teamName: $26bfa12f59001b80$export$9f98a8d796affec6
        },
        error: error,
        attributes: {
            projectId: projectId,
            requestTypeId: requestTypeId
        }
    });
};
const $64b5045637af4d9c$export$5f7d881992e08a6a = async ({ cloudId: cloudId, projectId: projectId, requestTypeId: requestTypeId })=>{
    try {
        const proformaRTFormDataResponse = await (0, $cDUV0.fetchProformaReqTypeFormData)({
            cloudId: cloudId,
            projectId: projectId,
            requestTypeId: requestTypeId
        });
        if (proformaRTFormDataResponse) return $64b5045637af4d9c$var$transform(proformaRTFormDataResponse);
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $64b5045637af4d9c$var$sendErrorAnalyticsEvent(projectId, requestTypeId, error);
        return null;
    }
};

});
const $26bfa12f59001b80$export$9345d7360ffe0722 = 'jiraProformaRequestTypeConfig';
const $26bfa12f59001b80$export$9f98a8d796affec6 = 'jsm-request-intake';

parcelRegister("cDUV0", function(module, exports) {

$parcel$export(module.exports, "fetchProformaReqTypeFormData", () => $c28bec7e01c36e0e$export$8a208a304fd928ac);

var $eusud = parcelRequire("eusud");
const $c28bec7e01c36e0e$export$8a208a304fd928ac = async ({ cloudId: cloudId, projectId: projectId, requestTypeId: requestTypeId })=>(0, $eusud.performGetRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/3/project/${projectId}/requesttype/${requestTypeId}/form/data`);

});


parcelRegister("kqnEs", function(module, exports) {

$parcel$export(module.exports, "addProformaFormOptimistically", () => $d9e155c4958588d7$export$92723633135bc176);
$parcel$export(module.exports, "discardProformaChanges", () => $d9e155c4958588d7$export$f0338098ae75560b);
$parcel$export(module.exports, "fetchProformaReqTypeConfigSuccess", () => $d9e155c4958588d7$export$33dd954834c75b3e);
$parcel$export(module.exports, "markProformaReqTypeFormForRemoval", () => $d9e155c4958588d7$export$10fe0482cd9f9b0d);
$parcel$export(module.exports, "removeProformaReqTypeFormSuccess", () => $d9e155c4958588d7$export$87acc517c5b8fb58);
$parcel$export(module.exports, "saveChangesStart", () => $d9e155c4958588d7$export$bb66978fdef2a565);
$parcel$export(module.exports, "saveChangesSuccess", () => $d9e155c4958588d7$export$9fbc7befd24c842);
$parcel$export(module.exports, "setReqTypeContext", () => $d9e155c4958588d7$export$3b6e5e8a94b27860);
$parcel$export(module.exports, "syncProformaFormStart", () => $d9e155c4958588d7$export$87601c8a61831f6c);
$parcel$export(module.exports, "syncProformaFormSuccess", () => $d9e155c4958588d7$export$759a5ffdfafba016);

const $d9e155c4958588d7$export$92723633135bc176 = (payload)=>({
        type: (0, $27d381fdbbe4d942$export$b13847c075f1f336),
        payload: payload
    });
const $d9e155c4958588d7$export$f0338098ae75560b = ()=>({
        type: (0, $27d381fdbbe4d942$export$960a73cf9aff4772)
    });
const $d9e155c4958588d7$export$33dd954834c75b3e = (payload)=>({
        type: (0, $27d381fdbbe4d942$export$e76ddc452bc79447),
        payload: payload
    });
const $d9e155c4958588d7$export$10fe0482cd9f9b0d = (payload)=>({
        type: (0, $27d381fdbbe4d942$export$5d02181a95c4d61b),
        payload: payload
    });
const $d9e155c4958588d7$export$87acc517c5b8fb58 = ()=>({
        type: (0, $27d381fdbbe4d942$export$58d514c90ac401fb)
    });
const $d9e155c4958588d7$export$bb66978fdef2a565 = ()=>({
        type: (0, $27d381fdbbe4d942$export$e268b48925b605c8)
    });
const $d9e155c4958588d7$export$9fbc7befd24c842 = ()=>({
        type: (0, $27d381fdbbe4d942$export$e0976c4ed9c93b89)
    });
const $d9e155c4958588d7$export$3b6e5e8a94b27860 = (payload)=>({
        type: (0, $27d381fdbbe4d942$export$af30b95313dc376),
        payload: payload
    });
const $d9e155c4958588d7$export$87601c8a61831f6c = ()=>({
        type: (0, $27d381fdbbe4d942$export$5b57ec88a545636f)
    });
const $d9e155c4958588d7$export$759a5ffdfafba016 = ()=>({
        type: (0, $27d381fdbbe4d942$export$ea67efafec91b00d)
    });

});
const $27d381fdbbe4d942$export$b13847c075f1f336 = 'ADD_PROFORMA_FORM_OPTIMISTICALLY';
const $27d381fdbbe4d942$export$960a73cf9aff4772 = 'DISCARD_PROFORMA_CHANGES';
const $27d381fdbbe4d942$export$e76ddc452bc79447 = 'FETCH_PROFORMA_REQ_TYPE_CONFIG_SUCCESS';
const $27d381fdbbe4d942$export$5d02181a95c4d61b = 'MARK_PROFORMA_REQ_TYPE_FORM_FOR_REMOVAL';
const $27d381fdbbe4d942$export$58d514c90ac401fb = 'REMOVE_PROFORMA_REQ_TYPE_FORM_SUCCESS';
const $27d381fdbbe4d942$export$e268b48925b605c8 = 'SAVE_CHANGES_START';
const $27d381fdbbe4d942$export$e0976c4ed9c93b89 = 'SAVE_CHANGES_SUCCESS';
const $27d381fdbbe4d942$export$af30b95313dc376 = 'SET_REQ_TYPE_CONTEXT';
const $27d381fdbbe4d942$export$5b57ec88a545636f = 'SYNC_PROFORMA_FORM_START';
const $27d381fdbbe4d942$export$ea67efafec91b00d = 'SYNC_PROFORMA_FORM_SUCCESS';



parcelRegister("lQAYg", function(module, exports) {

$parcel$export(module.exports, "getCloudId", () => $286ff116f85f1821$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getProjectId", () => $286ff116f85f1821$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectType", () => $286ff116f85f1821$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProformaFormName", () => $286ff116f85f1821$export$2378c46fe51b0756);
$parcel$export(module.exports, "getProformaFormId", () => $286ff116f85f1821$export$651b7206aa88a8e1);
$parcel$export(module.exports, "getProformaRequestTypeFormCardConfig", () => $286ff116f85f1821$export$ce5e16c304cd1fc7);
$parcel$export(module.exports, "isProformaReqTypeConfigDirty", () => $286ff116f85f1821$export$a6b1ad70ba784c7c);
$parcel$export(module.exports, "proformaReqTypeFormRemovalRequest", () => $286ff116f85f1821$export$d9d3f2e428ab1d66);
$parcel$export(module.exports, "proformaReqTypeFormAddRequest", () => $286ff116f85f1821$export$86cb75de9e6afc4f);
$parcel$export(module.exports, "isProformaReqTypeConfigSaving", () => $286ff116f85f1821$export$c9ba0b7f9f090f1d);
$parcel$export(module.exports, "isProformaReqTypeConfigLoading", () => $286ff116f85f1821$export$58767e401a5e49d);
$parcel$export(module.exports, "getDuplicateJiraFields", () => $286ff116f85f1821$export$789a89dc05106c47);

var $dGvGJ = parcelRequire("dGvGJ");

var $4R6GH = parcelRequire("4R6GH");
const $286ff116f85f1821$export$889551054d108850 = (state)=>state.proformaReqTypeConfig;
const $286ff116f85f1821$export$fdd2c0ba94025c3c = (state)=>state.context.cloudId;
const $286ff116f85f1821$export$987d304aca82b827 = (state)=>state.context.extraDefinerId;
const $286ff116f85f1821$export$89040d072f281f85 = (state)=>state.context.projectId;
const $286ff116f85f1821$export$3dd0da95519c1a33 = (state)=>state.context.projectType;
const $286ff116f85f1821$export$7461ab41be90a095 = (state)=>state.proformaReqTypeConfig.associatedForm?.markedForRemoval ?? false;
const $286ff116f85f1821$export$2378c46fe51b0756 = (0, $dGvGJ.createSelector)($286ff116f85f1821$export$889551054d108850, $286ff116f85f1821$export$7461ab41be90a095, (proformaReqTypeConfig, isAssociatedFormMarkedForRemoval)=>{
    const optimisticFormFormName = proformaReqTypeConfig.optimisticNewForm?.formName;
    const associatedProformaFormName = isAssociatedFormMarkedForRemoval ? undefined : proformaReqTypeConfig.associatedForm?.formName;
    return associatedProformaFormName || optimisticFormFormName;
});
const $286ff116f85f1821$export$651b7206aa88a8e1 = (0, $dGvGJ.createSelector)($286ff116f85f1821$export$889551054d108850, $286ff116f85f1821$export$7461ab41be90a095, (proformaReqTypeConfig, isAssociatedFormMarkedForRemoval)=>{
    const optimisticFormFormId = proformaReqTypeConfig.optimisticNewForm?.formId;
    const associatedProformaFormId = isAssociatedFormMarkedForRemoval ? undefined : proformaReqTypeConfig.associatedForm?.formId;
    return associatedProformaFormId || optimisticFormFormId;
});
const $286ff116f85f1821$export$fbf3152bdbf370ea = (0, $dGvGJ.createSelector)($286ff116f85f1821$export$889551054d108850, $286ff116f85f1821$export$7461ab41be90a095, (proformaReqTypeConfig, isAssociatedFormMarkedForRemoval)=>{
    const optimisticFormLinkedFields = proformaReqTypeConfig.optimisticNewForm?.linkedFields ? Object.keys(proformaReqTypeConfig.optimisticNewForm.linkedFields) : undefined;
    const associatedProformaLinkedFields = isAssociatedFormMarkedForRemoval ? undefined : proformaReqTypeConfig.associatedForm?.linkedFieldsKey;
    return associatedProformaLinkedFields || optimisticFormLinkedFields;
});
const $286ff116f85f1821$export$fa97189d614526f8 = (0, $dGvGJ.createSelector)($286ff116f85f1821$export$889551054d108850, $286ff116f85f1821$export$7461ab41be90a095, (proformaReqTypeConfig, isAssociatedFormMarkedForRemoval)=>{
    const optimisticFormUsedAsIssueForm = proformaReqTypeConfig.optimisticNewForm?.usedAsIssueForm;
    const associatedFormUsedAsIssueForm = isAssociatedFormMarkedForRemoval ? undefined : proformaReqTypeConfig.associatedForm?.usedAsIssueForm;
    return optimisticFormUsedAsIssueForm !== undefined && optimisticFormUsedAsIssueForm || associatedFormUsedAsIssueForm !== undefined && associatedFormUsedAsIssueForm;
});
const $286ff116f85f1821$export$ce5e16c304cd1fc7 = (0, $dGvGJ.createSelector)($286ff116f85f1821$export$889551054d108850, $286ff116f85f1821$export$89040d072f281f85, $286ff116f85f1821$export$987d304aca82b827, (proformaReqTypeConfig, projectId, extraDefinerId)=>{
    const hasRequestTypeId = extraDefinerId !== null;
    if (!proformaReqTypeConfig) return undefined;
    const isAssociatedFormMarkedForRemoval = proformaReqTypeConfig.associatedForm?.markedForRemoval;
    if (hasRequestTypeId) {
        /**
			 * For 2 cases, we want to return optimisticNewForm:
			 * 1. If RTC page has associatedForm, user removed and selected optimistic form
			 *  - in this case, proformaReqTypeConfig.associatedForm?.markedForRemoval will be true
			 * 2. If RTC page has no associatedForm, and user selected new form using Empty state add form component
			 *
			 */ const form = proformaReqTypeConfig?.optimisticNewForm ?? (!isAssociatedFormMarkedForRemoval ? proformaReqTypeConfig?.associatedForm : undefined);
        if (form) return {
            formId: form.formId,
            formName: form.formName,
            linkedFields: 'linkedFields' in form ? form.linkedFields : undefined,
            isOptimistic: !!proformaReqTypeConfig?.optimisticNewForm,
            requestTypeId: extraDefinerId,
            projectId: projectId,
            restrictionStatus: (0, $4R6GH.fg)('granular_permissions_on_forms_m1') ? form.restrictionStatus : undefined
        };
    }
    return undefined;
});
const $286ff116f85f1821$export$a6b1ad70ba784c7c = (0, $dGvGJ.createSelector)($286ff116f85f1821$export$889551054d108850, (proformaReqTypeConfig)=>proformaReqTypeConfig.optimisticNewForm && true || proformaReqTypeConfig.associatedForm?.markedForRemoval || false);
const $286ff116f85f1821$export$d9d3f2e428ab1d66 = (0, $dGvGJ.createSelector)($286ff116f85f1821$export$fdd2c0ba94025c3c, $286ff116f85f1821$export$89040d072f281f85, $286ff116f85f1821$export$987d304aca82b827, $286ff116f85f1821$export$889551054d108850, (cloudId, projectId, extraDefinerId, proformaReqTypeConfig)=>{
    const formId = proformaReqTypeConfig.associatedForm?.formId;
    const formName = proformaReqTypeConfig.associatedForm?.formName;
    const markedForRemoval = proformaReqTypeConfig.associatedForm?.markedForRemoval;
    if (extraDefinerId !== null && formId && markedForRemoval) return {
        cloudId: cloudId,
        projectId: projectId,
        requestTypeId: extraDefinerId,
        formId: formId,
        formName: formName
    };
    return undefined;
});
const $286ff116f85f1821$export$86cb75de9e6afc4f = (0, $dGvGJ.createSelector)($286ff116f85f1821$export$fdd2c0ba94025c3c, $286ff116f85f1821$export$89040d072f281f85, $286ff116f85f1821$export$987d304aca82b827, $286ff116f85f1821$export$889551054d108850, $286ff116f85f1821$export$2378c46fe51b0756, (cloudId, projectId, extraDefinerId, proformaReqTypeConfig, formName)=>{
    const formId = proformaReqTypeConfig.optimisticNewForm?.formId;
    if (extraDefinerId !== null && formId) return {
        cloudId: cloudId,
        projectId: projectId,
        requestTypeId: extraDefinerId,
        formId: formId,
        formName: formName
    };
    return undefined;
});
const $286ff116f85f1821$export$c9ba0b7f9f090f1d = (state)=>state.isSaving;
const $286ff116f85f1821$export$58767e401a5e49d = (state)=>state.isLoading;
const $286ff116f85f1821$export$789a89dc05106c47 = (state, requestTypeLayoutItems)=>{
    const linkedJiraFieldsInForm = $286ff116f85f1821$export$fbf3152bdbf370ea(state);
    if ($286ff116f85f1821$export$fa97189d614526f8(state)) return [];
    if (!linkedJiraFieldsInForm) return [];
    const requestTypeJiraFields = requestTypeLayoutItems.map((jiraField)=>({
            name: jiraField.data.name,
            key: jiraField.data.key
        }));
    const duplicateJiraFieldsInForm = requestTypeJiraFields.filter((field)=>linkedJiraFieldsInForm.includes(field.key) && field.key !== 'summary');
    return duplicateJiraFieldsInForm;
};

});

parcelRegister("9m75u", function(module, exports) {

$parcel$export(module.exports, "default", () => $b293aadb3a9362a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b293aadb3a9362a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    singleDuplicateDescription: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.single-duplicate-description",
        "defaultMessage": "To avoid duplicate fields appearing twice, the \u2018{formField}\u2018 linked Jira field will be removed from the \u2018{formName}\u2019 form. This also affects any other request types using this form."
    },
    multipleDuplicatesDescription: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.multiple-duplicates-description",
        "defaultMessage": "To avoid duplicate fields appearing twice, the following linked Jira fields will be removed from the \u2018{formName}\u2019 form. This also affects any other request types using this form."
    },
    genericDuplicatesDescription: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.generic-duplicates-description",
        "defaultMessage": "To avoid fields appearing twice, some linked Jira fields will be removed from the \u2018{formName}\u2019 form. This also affects any other request types using this form."
    },
    title: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.title",
        "defaultMessage": "Linked Jira fields will be removed from the attached form"
    },
    cancel: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.cancel",
        "defaultMessage": "Cancel"
    },
    removeField: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.remove-field",
        "defaultMessage": "Remove field"
    },
    removeFields: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.remove-fields",
        "defaultMessage": "Remove fields"
    },
    errorRemovingDuplicateFormFields: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.error-removing-duplicate-form-fields",
        "defaultMessage": "We couldn\u2019t remove duplicate fields"
    },
    errorRemovingDuplicateFormFieldsDescription: {
        "id": "project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.error-removing-duplicate-form-fields-description",
        "defaultMessage": "Try again"
    }
});

});

parcelRegister("69CKn", function(module, exports) {

$parcel$export(module.exports, "removeLinkedFields", () => $f3d88b5d8fdea1bc$export$1279e5d36f39431d);

var $eusud = parcelRequire("eusud");
const $f3d88b5d8fdea1bc$export$830c804e8d921bba = async (cloudId, projectId, formId)=>(0, $eusud.performGetRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/2/projects/${projectId}/forms/${formId}`);
const $f3d88b5d8fdea1bc$export$3855fd213a39a375 = async (cloudId, projectId, formId, form)=>(0, $eusud.performPutRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/2/projects/${projectId}/forms/${formId}`, {
        body: JSON.stringify(form)
    });
const $f3d88b5d8fdea1bc$export$1279e5d36f39431d = async (cloudId, projectId, formId, duplicateJiraFieldsInForm)=>{
    const form = await $f3d88b5d8fdea1bc$export$830c804e8d921bba(cloudId, projectId, formId);
    const updatedForm = $f3d88b5d8fdea1bc$export$c454e95017cb5e34(form, duplicateJiraFieldsInForm);
    await $f3d88b5d8fdea1bc$export$3855fd213a39a375(cloudId, projectId, formId, updatedForm);
};
const $f3d88b5d8fdea1bc$export$c454e95017cb5e34 = (form, duplicateJiraFieldsInForm)=>{
    const updatedQuestions = Object.keys(form.design.questions).reduce((acc, questionKey)=>{
        const question = form.design.questions[questionKey];
        if (question.jiraField && duplicateJiraFieldsInForm.includes(question.jiraField)) acc[questionKey] = {
            ...question,
            jiraField: undefined
        };
        else acc[questionKey] = question;
        return acc;
    }, {});
    return {
        ...form,
        design: {
            ...form.design,
            questions: {
                ...updatedQuestions
            }
        }
    };
};

});


parcelRegister("hQIjR", function(module, exports) {

$parcel$export(module.exports, "MultilineFieldConfiguration", () => $304503119b942f2d$export$9f96b65d3821e64);

var $5uXOq = parcelRequire("5uXOq");

var $hXRXz = parcelRequire("hXRXz");

var $6TUCc = parcelRequire("6TUCc");
const $304503119b942f2d$export$9f96b65d3821e64 = (props)=>{
    const emojiProvider = (0, $5uXOq.useRef)((0, $hXRXz.getEmojiProvider)() ?? undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6TUCc.MultilineView), {
        ...props,
        mentionProvider: undefined,
        emojiProvider: emojiProvider.current
    });
};
const $304503119b942f2d$export$6e0f0a958dc8ef91 = (operations)=>operations.canModifyDefaultValue;

});
parcelRegister("6TUCc", function(module, exports) {

$parcel$export(module.exports, "MultilineView", () => $51d5b53b8e55695b$export$7039582fab82240f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7O4UO = parcelRequire("7O4UO");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $3XO6n = parcelRequire("3XO6n");

var $dq3xR = parcelRequire("dq3xR");

var $hPw0Z = parcelRequire("hPw0Z");


var $7ovNu = parcelRequire("7ovNu");

var $j2UsO = parcelRequire("j2UsO");

var $2SHDE = parcelRequire("2SHDE");
function $51d5b53b8e55695b$var$isRelevantError(e) {
    return e.position === (0, $d2e37636a1b0be7f$export$fa640bba89c0678c);
}
function $51d5b53b8e55695b$var$getFilteredErrors(errors) {
    return errors.filter($51d5b53b8e55695b$var$isRelevantError);
}
const $51d5b53b8e55695b$var$DefaultValueErrors = ({ filteredErrors: filteredErrors })=>{
    const intl = (0, $koVbs.default)();
    if (filteredErrors.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("section", null, filteredErrors.map((e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dq3xR.default), {
            key: e.messageDescriptor.id,
            message: intl.formatMessage(e.messageDescriptor, e.values)
        })));
};
const $51d5b53b8e55695b$var$getDefaultLabel = (field)=>{
    switch(field.type){
        case 0, $3XO6n.DESCRIPTION_FIELD_TYPE:
            return (0, $j2UsO.default).textDefaultDescriptionLabel;
        case 0, $3XO6n.ENVIRONMENT_FIELD_TYPE:
            return (0, $j2UsO.default).environmentDefaultValueLabel;
        default:
            return (0, $j2UsO.default).textDefaultValueLabel;
    }
};
const $51d5b53b8e55695b$var$getDisabledTooltipMessage = (field)=>{
    switch(field.type){
        case 0, $3XO6n.DESCRIPTION_FIELD_TYPE:
            return (0, $j2UsO.default).descriptionDefaultValueDisabledTooltip;
        case 0, $3XO6n.ENVIRONMENT_FIELD_TYPE:
            return (0, $j2UsO.default).environmentDefaultValueDisabledTooltip;
        default:
            return (0, $j2UsO.default).textDefaultValueDisabledTooltip;
    }
};
function $51d5b53b8e55695b$var$refineDefaultValue(defaultValue) {
    /*
   * ADFs have many more properties in them but type: string is the only one that is required.
   * I wish there was some utility method to do this but as of now there isn't any.
   * I checked adf-utils and adf-schema but none export functions like this.
   *
   * (adf-utils has a validator but that one accepts `ADFEntity`.)
   */ if (typeof defaultValue === 'object' && defaultValue != null && 'type' in defaultValue && typeof defaultValue.type === 'string') return {
        ...defaultValue,
        type: defaultValue.type
    };
    return undefined;
}
const $51d5b53b8e55695b$export$7039582fab82240f = ({ field: field, onUpdate: onUpdate, fieldErrors: fieldErrors, testId: testId, tooltipDelay: tooltipDelay, ...rest })=>{
    const intl = (0, $koVbs.default)();
    const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
    const onEditorUpdate = (0, $5uXOq.useCallback)((adf)=>{
        if ((0, $2SHDE.isAdfEmpty)(adf)) onUpdate({
            ...field,
            defaultValue: null
        });
        else onUpdate({
            ...field,
            defaultValue: adf
        });
    }, [
        field,
        onUpdate
    ]);
    const filteredErrors = $51d5b53b8e55695b$var$getFilteredErrors(fieldErrors);
    const isValid = filteredErrors.length === 0;
    const defaultValue = $51d5b53b8e55695b$var$refineDefaultValue(field.defaultValue);
    const editorProps = {
        ...rest,
        onUpdate: onEditorUpdate,
        disabled: isModifyDefaultValueDisabled,
        defaultValue: defaultValue,
        mentionProvider: undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51d5b53b8e55695b$var$DefaultValueStyled, null, !isValid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51d5b53b8e55695b$var$DefaultValueErrors, {
        filteredErrors: filteredErrors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.AkFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: `${field.key}-default-value`,
        label: intl.formatMessage($51d5b53b8e55695b$var$getDefaultLabel(field))
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isModifyDefaultValueDisabled ? intl.formatMessage($51d5b53b8e55695b$var$getDisabledTooltipMessage(field)) : null,
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ovNu.AsyncEditor), editorProps))))));
};
/*
 * react-beautiful-dnd overrides the cursor to grab, but there is a contenteditable div from
 * atlaskit/editor that has text selection instead of grabbing. So let's override the cursor here too.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51d5b53b8e55695b$var$DefaultValueStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f31jfw _19bv1jfw _otyrpxbi _1acl1kdv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7ovNu", function(module, exports) {

$parcel$export(module.exports, "AsyncEditor", () => $1982c5eca0821a13$export$f2d99141810bab01);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $jMLuu = parcelRequire("jMLuu");

var $lvsgf = parcelRequire("lvsgf");

var $kxZPA = parcelRequire("kxZPA");

var $bnK2X = parcelRequire("bnK2X");

var $jbnXj = parcelRequire("jbnXj");

var $hDdIK = parcelRequire("hDdIK");
const $1982c5eca0821a13$var$ERROR_ID = 'importEditor';
const $1982c5eca0821a13$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1982c5eca0821a13$var$Skeleton, {
        width: "44%",
        height: "42px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1982c5eca0821a13$var$Spacer, {
        height: "22px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1982c5eca0821a13$var$Skeleton, {
        width: "90%",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1982c5eca0821a13$var$Spacer, {
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1982c5eca0821a13$var$Skeleton, {
        width: "63%",
        height: "14px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1982c5eca0821a13$var$Spacer, {
        height: "24px"
    }));
const $1982c5eca0821a13$export$65db35c377fab04b = ()=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1982c5eca0821a13$var$errorWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error"
    }, intl.formatMessage((0, $hDdIK.default).editorFailedToLoad)));
};
const $1982c5eca0821a13$var$renderAsyncEditor = ({ EditorContext: EditorContext, WithEditorActions: WithEditorActions, Editor: Editor, props: props, scrollableElement: scrollableElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvsgf.Consumer), null, (onRecalculateAnimatorHeight)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbnXj.AsyncEditorView), {
            EditorContext: EditorContext,
            WithEditorActions: WithEditorActions,
            Editor: Editor,
            onRecalculateAnimatorHeight: onRecalculateAnimatorHeight,
            scrollableElement: scrollableElement,
            ...props
        }));

const $1982c5eca0821a13$var$importEditorCore = ()=>(0, $koFzm.famaCatchAndLogFetchError)((parcelRequire("l5g3R")), (0, $bnK2X.PACKAGE_NAME), (0, $gl0PU.toErrorId)($1982c5eca0821a13$var$ERROR_ID), (0, $gl0PU.toErrorMessage)('Failed to async load the Atlaskit editor for multiline configuration')); // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1982c5eca0821a13$var$LazyEditorRenderer = (0, $kxZPA.lazy)(()=>$1982c5eca0821a13$var$importEditorCore().then(({ EditorContext: EditorContext, WithEditorActions: WithEditorActions, Editor: Editor })=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMLuu.ScrollableParentConsumer), null, (scrollableParent)=>$1982c5eca0821a13$var$renderAsyncEditor({
                    EditorContext: // @ts-expect-error - TS2322 - Type 'typeof LegacyEditorContext' is not assignable to type 'ComponentType<{ children: ReactNode; }>'.
                    EditorContext,
                    WithEditorActions: WithEditorActions,
                    Editor: Editor,
                    props: props,
                    scrollableElement: scrollableParent.current
                }))), {});
const $1982c5eca0821a13$export$f2d99141810bab01 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $1982c5eca0821a13$var$ERROR_ID,
        packageName: (0, $bnK2X.PACKAGE_NAME),
        teamName: "jsd-shield",
        fallback: $1982c5eca0821a13$export$65db35c377fab04b
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-editor",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1982c5eca0821a13$export$7db30d367db7d20a, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1982c5eca0821a13$var$LazyEditorRenderer, props)));
const $1982c5eca0821a13$var$shimmer = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1982c5eca0821a13$var$Skeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _5sag9cwz _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhkm7j4 _1itkabhq _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1982c5eca0821a13$var$Spacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $1982c5eca0821a13$var$errorWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("jbnXj", function(module, exports) {

$parcel$export(module.exports, "AsyncEditorView", () => $be5e04d5dcf11bf7$export$74ce8bb86db204fe);

var $5uXOq = parcelRequire("5uXOq");

var $l1C1k = parcelRequire("l1C1k");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $6wesA = parcelRequire("6wesA");

var $bnK2X = parcelRequire("bnK2X");

var $hDdIK = parcelRequire("hDdIK");
const $be5e04d5dcf11bf7$export$fb8d7f40caaeea67 = ({ errorCount: errorCount, onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $be5e04d5dcf11bf7$var$errorWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        actions: errorCount <= 2 ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: "reload-editor-error-action",
                onClick: onRetry
            }, formatMessage((0, $hDdIK.default).editorContextErrorAction))
        ] : [],
        title: formatMessage((0, $hDdIK.default).editorContextErrorTitle)
    }, errorCount <= 2 ? formatMessage((0, $hDdIK.default).editorContextErrorMessageToReloadEditor) : formatMessage((0, $hDdIK.default).editorContextErrorMessageToRefreshPage)));
};
const $be5e04d5dcf11bf7$var$onDefaultValueChange = (actions, onUpdate)=>()=>{
        actions.getValue().then((value)=>{
            if (!value) return;
            const doc = (0, $l1C1k.traverse)(value, {
                mention: (node)=>{
                    // Omit accessLevel as documents from the API do not include this property, and we need dirty checks to be correct
                    // @ts-expect-error - TS2339 - Property 'accessLevel' does not exist on type '{ [name: string]: any; } | undefined'.
                    const { accessLevel: accessLevel, ...attrs } = node.attrs;
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    return {
                        ...node,
                        attrs: attrs
                    };
                }
            });
            if (onUpdate && doc) onUpdate(doc);
        });
    };
const $be5e04d5dcf11bf7$export$74ce8bb86db204fe = (props)=>{
    const { EditorContext: EditorContext, WithEditorActions: WithEditorActions } = props;
    const popupMountElement = (0, $5uXOq.useRef)(null);
    const [errorCount, setErrorCount] = (0, $5uXOq.useState)(0);
    const [resetCaughtError, setResetCaughtError] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        // Ensure the height animator has been recalculated so the async editor doesn't overflow the container
        props.onRecalculateAnimatorHeight();
        const { body: body } = document;
        if (body !== null) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            popupMountElement.current = document.createElement('div');
            popupMountElement.current.setAttribute('class', (0, $6wesA.IGNORE_CLICK_OUTSIDE_CLASS_NAME));
            body.appendChild(popupMountElement.current);
        }
        return function componentWillUnmount() {
            if (body !== null && popupMountElement.current != null) body.removeChild(popupMountElement.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderEditor = (actions)=>{
        const { onUpdate: onUpdate, Editor: Editor, scrollableElement: scrollableElement, onRecalculateAnimatorHeight: onRecalculateAnimatorHeight, ...editorProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Editor, {
            allowPanel: true,
            allowRule: true,
            appearance: "comment",
            ...editorProps,
            onChange: $be5e04d5dcf11bf7$var$onDefaultValueChange(actions, onUpdate),
            allowAnalyticsGASV3: true,
            ...scrollableElement ? {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                popupsMountPoint: popupMountElement.current || document.body || undefined,
                popupsScrollableElement: scrollableElement
            } : null,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true
            }
        });
    };
    const onError = ()=>{
        setErrorCount(errorCount + 1);
        setResetCaughtError(undefined);
    };
    const renderAsyncEditor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditorContext, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithEditorActions, {
            render: renderEditor
        }));
    const renderAsyncEditorWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "editorContext",
            packageName: (0, $bnK2X.PACKAGE_NAME),
            teamName: "jsd-shield",
            fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be5e04d5dcf11bf7$export$fb8d7f40caaeea67, {
                    errorCount: errorCount,
                    onRetry: ()=>setResetCaughtError(error)
                }),
            onError: onError,
            resetCaughtError: resetCaughtError
        }, renderAsyncEditor());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderAsyncEditorWithErrorBoundary());
};
const $be5e04d5dcf11bf7$var$errorWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("hDdIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d8684e22afbcd3f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0d8684e22afbcd3f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editorFailedToLoad: {
        "id": "project-settings-product-features-jsm-common.field-configuration.multiline-without-mentions.async-editor.editor-failed-to-load",
        "defaultMessage": "We couldn\u2019t load the editor. Save your changes, refresh, and try again."
    },
    editorContextErrorTitle: {
        "id": "project-settings-product-features-jsm-common.field-configuration.multiline-without-mentions.async-editor.editor-context-error-title",
        "defaultMessage": "We couldn't save your changes"
    },
    editorContextErrorMessageToRefreshPage: {
        "id": "project-settings-product-features-jsm-common.field-configuration.multiline-without-mentions.async-editor.editor-context-error-message-to-refresh-page",
        "defaultMessage": "Refresh the page and try again."
    },
    editorContextErrorMessageToReloadEditor: {
        "id": "project-settings-product-features-jsm-common.field-configuration.multiline-without-mentions.async-editor.editor-context-error-message-to-reload-editor",
        "defaultMessage": "Reload the editor and try again."
    },
    editorContextErrorAction: {
        "id": "project-settings-product-features-jsm-common.field-configuration.multiline-without-mentions.async-editor.editor-context-error-action",
        "defaultMessage": "Try again"
    }
});

});



parcelRegister("j2UsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aed1fcaf01e7610$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9aed1fcaf01e7610$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textDefaultValueLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.text-default-value-label",
        "defaultMessage": "Default text"
    },
    textDefaultDescriptionLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.text-default-description-label",
        "defaultMessage": "Default description"
    },
    environmentDefaultValueLabel: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.environment-default-value-label",
        "defaultMessage": "Default environment"
    },
    textDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.multiline.text-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default text"
    },
    descriptionDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.multiline.description-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default description"
    },
    environmentDefaultValueDisabledTooltip: {
        "id": "issue-type-page.field-associated.field-configuration.multiline.environment-default-value-disabled-tooltip",
        "defaultMessage": "You can\u2019t change this field\u2019s default environment"
    },
    defaultValueTooLongErrorDescription: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-description",
        "defaultMessage": "Your description is too long."
    },
    defaultValueTooLongErrorValue: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-value",
        "defaultMessage": "Your text is too long."
    }
});

});

parcelRegister("2SHDE", function(module, exports) {

$parcel$export(module.exports, "isAdfEmpty", () => $edfbc10861a42ce4$export$186b9eba0e17d2d1);

var $l1C1k = parcelRequire("l1C1k");
const $edfbc10861a42ce4$var$isEmptyParagraph = (node)=>Boolean(node.type === 'paragraph' && node.content && node.content.length === 0);
const $edfbc10861a42ce4$export$186b9eba0e17d2d1 = (adf)=>{
    if (adf.content == null) return true;
    const firstNode = adf.content[0];
    if (firstNode == null) return true;
    return adf.content.length === 1 && $edfbc10861a42ce4$var$isEmptyParagraph(firstNode);
};
const $edfbc10861a42ce4$export$c383e63d7f976624 = (adf)=>(0, $l1C1k.traverse)(adf, {
        mention: (node)=>{
            // Omit accessLevel as documents from the API do not include this property and we need dirty checks to be correct
            // @ts-expect-error - TS2339 - Property 'accessLevel' does not exist on type '{ [name: string]: any; } | undefined'.
            const { accessLevel: accessLevel, ...attrs } = node.attrs;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...node,
                attrs: attrs
            };
        }
    });

});



parcelRegister("ghck8", function(module, exports) {

$parcel$export(module.exports, "fieldAliasDescriptionMustBeShortEnough", () => $451af6b99a39e81b$export$1e74e92415a82c09);


var $dqelS = parcelRequire("dqelS");
const $451af6b99a39e81b$var$valid = [];
const $451af6b99a39e81b$var$FIELD_ALIAS_DESCRIPTION_MAX_LENGTH = 255;
const $451af6b99a39e81b$var$errorAliasDescriptionTooLong = [
    {
        position: (0, $d2e37636a1b0be7f$export$79e928bf2e38d2f4),
        messageDescriptor: (0, $dqelS.fieldValidationMessages).errorFieldDescriptionTooLong,
        values: {
            maxCharacters: $451af6b99a39e81b$var$FIELD_ALIAS_DESCRIPTION_MAX_LENGTH
        }
    }
];
const $451af6b99a39e81b$export$1e74e92415a82c09 = ({ field: field })=>{
    if (// @ts-expect-error - TS2339 - Property 'alternateDescription' does not exist on type 'Field | AssociatedField'.
    field.alternateDescription != null && // @ts-expect-error - TS2339 - Property 'alternateDescription' does not exist on type 'Field | AssociatedField'.
    field.alternateDescription.length > $451af6b99a39e81b$var$FIELD_ALIAS_DESCRIPTION_MAX_LENGTH) return $451af6b99a39e81b$var$errorAliasDescriptionTooLong;
    return $451af6b99a39e81b$var$valid;
};

});
parcelRegister("dqelS", function(module, exports) {

$parcel$export(module.exports, "fieldValidationMessages", () => $47b8385f224a571e$export$99eb7f1b9870c4fe);

var $7VHMR = parcelRequire("7VHMR");
const $47b8385f224a571e$export$99eb7f1b9870c4fe = (0, $7VHMR.defineMessages)({
    errorFieldDescriptionTooLong: {
        "id": "project-settings-product-features-jsm-tmp.common.utils.field-validator.error-field-description-too-long",
        "defaultMessage": "Description can't exceed {maxCharacters} characters"
    },
    errorKeyDuplicate: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.cascading-options.options-list.error-key-duplicate",
        "defaultMessage": "Already exists. Try something else."
    }
});

});


parcelRegister("7Ertg", function(module, exports) {

$parcel$export(module.exports, "doesJsmTmpSupportIssueTypeHierarchy", () => $daceef1789a76555$export$3bb177d721873985);
$parcel$export(module.exports, "PACKAGE_NAME", () => $daceef1789a76555$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "getRequestFieldCategoryId", () => $daceef1789a76555$export$bf7c2dcd120ea5fd);

var $in90R = parcelRequire("in90R");

var $3XO6n = parcelRequire("3XO6n");
const $daceef1789a76555$export$3bb177d721873985 = ()=>false;
const $daceef1789a76555$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectSettingsAppsIssueTypePageJsmTmp');
const $daceef1789a76555$export$bf7c2dcd120ea5fd = ()=>(0, $in90R.toFieldCategory)('request');

});

parcelRegister("b3HO0", function(module, exports) {

$parcel$export(module.exports, "fieldCategories", () => $f4e0c662868ff2bc$export$2a5221b3ba8fb353);
$parcel$export(module.exports, "addIssueTypeMessages", () => $f4e0c662868ff2bc$export$871b018529ef98e8);
$parcel$export(module.exports, "deleteFieldMessages", () => $f4e0c662868ff2bc$export$6ad141c20d48e8e9);
$parcel$export(module.exports, "fieldWarnings", () => $f4e0c662868ff2bc$export$64e0557338f5ac89);

var $7VHMR = parcelRequire("7VHMR");
const $f4e0c662868ff2bc$export$2a5221b3ba8fb353 = (0, $7VHMR.defineMessages)({
    alwaysShowTitleRequestForm: {
        "id": "project-settings.product-features.service-desk.always-show-title-request-form",
        "defaultMessage": "Customer request form"
    },
    descriptionTitle: {
        "id": "project-settings.product-features.service-desk.description-title",
        "defaultMessage": "Description fields"
    },
    primaryTitle: {
        "id": "project-settings.product-features.service-desk.primary-title",
        "defaultMessage": "Context fields"
    },
    hideWhenEmptyFields: {
        "id": "project-settings-apps.issue-type-page.fields.fields-editor.hide-when-empty-field",
        "defaultMessage": "Hide when empty fields"
    },
    whatIsThis: {
        "id": "project-settings.product-features.service-desk.what-is-this",
        "defaultMessage": "What\u2019s this?"
    },
    linkToDocumentationText: {
        "id": "project-settings.product-features.service-desk.link-to-documentation-text",
        "defaultMessage": "Learn more"
    },
    linkToInProductHelpText: {
        "id": "project-settings.product-features.service-desk.link-to-in-product-help-text",
        "defaultMessage": "Learn more about the issue view"
    },
    linkToInProductHelpTextIssueTermRefresh: {
        "id": "project-settings.product-features.service-desk.link-to-in-product-help-text-issue-term-refresh",
        "defaultMessage": "Read more about the work item view"
    },
    linkToInProductHelpTextPortal: {
        "id": "project-settings.product-features.service-desk.link-to-in-product-help-text-portal",
        "defaultMessage": "Learn more about the portal"
    },
    whatArePrimaryFieldsForInProductHelp: {
        "id": "project-settings.product-features.service-desk.what-are-primary-fields-for-in-product-help-with-forms-enabled-request-form",
        "defaultMessage": "Fields and forms added to the request form are filled out by customers when they raise a request from the portal.{br}{br}{learnMoreLink}."
    },
    whatAreDescriptionFieldsForInProductHelp: {
        "id": "project-settings.product-features.service-desk.what-are-description-fields-for-in-product-help",
        "defaultMessage": "These fields can help describe what needs to be done, or collect more information about issues.{br}{br}{learnMoreLink}."
    },
    whatAreDescriptionFieldsForInProductHelpIssueTermRefresh: {
        "id": "project-settings.product-features.service-desk.what-are-description-fields-for-in-product-help-issue-term-refresh",
        "defaultMessage": "These fields can help describe what needs to be done, or collect more information about work items.{br}{br}{learnMoreLink}."
    },
    whatAreSecondaryFieldsWithDividerForInProductHelp: {
        "id": "project-settings.product-features.service-desk.what-are-secondary-fields-with-divider-for-in-product-help",
        "defaultMessage": "These fields provide context, and help your team to group, filter, and report on issues.{br}{br}{learnMoreLink}."
    },
    whatAreSecondaryFieldsWithDividerForInProductHelpIssueTermRefresh: {
        "id": "project-settings.product-features.service-desk.what-are-secondary-fields-with-divider-for-in-product-help-issue-term-refresh",
        "defaultMessage": "These fields provide context, and help your team to group, filter, and report on work items.{br}{br}{learnMoreLink}."
    },
    primaryEmptyMessage: {
        "id": "project-settings.product-features.service-desk.primary-empty-message",
        "defaultMessage": "Drag fields here to add them to your \u201C{issueTypeName}\u201D request form in your portal. You can give them display names to change how they appear to your customers."
    },
    descriptionEmptyTitle: {
        "id": "project-settings.product-features.service-desk.description-empty-title",
        "defaultMessage": "Drag and drop paragraph text fields here"
    },
    secondaryEmptyTitle: {
        "id": "project-settings.product-features.service-desk.secondary-empty-title",
        "defaultMessage": "Add additional fields here"
    },
    secondaryEmptyMessage: {
        "id": "project-settings.product-features.service-desk.secondary-empty-message",
        "defaultMessage": "Drag fields here to add them to your internal \u201C{issueTypeName}\u201D requests\u2019 layout. These fields are only visible by internal users on your site."
    },
    emailFieldsTitle: {
        "id": "project-settings.product-features.service-desk.email-fields-title",
        "defaultMessage": "Email fields"
    },
    whatAreEmailFields: {
        "id": "project-settings.product-features.service-desk.what-are-email-fields",
        "defaultMessage": "These fields are generated automatically from incoming emails. They can't be edited or reordered."
    },
    showMoreDividerText: {
        "id": "project-settings-apps.issue-type-page.fields.fields-editor.show-more-divider-text",
        "defaultMessage": "Hide fields below"
    },
    hideFieldsBelowCategoryEmptyMessageWithDraggableDivider: {
        "id": "project-settings-apps.common.product-features.product-features.service-desk.hide-fields-below-category-empty-message-with-draggable-divider",
        "defaultMessage": "Drag fields here or drag the dotted line up to add fields to your \u201C{issueTypeName}\u201D issues\u2019 layout. When empty, these fields may appear under a \u201CShow more\u201D link or may be hidden."
    },
    hideFieldsBelowCategoryEmptyMessageWithDraggableDividerIssueTermRefresh: {
        "id": "project-settings-apps.common.product-features.product-features.service-desk.hide-fields-below-category-empty-message-with-draggable-divider-issue-term-refresh",
        "defaultMessage": "Drag fields here or drag the dotted line up to add fields to your \u201C{issueTypeName}\u201D work items\u2019 layout. When empty, these fields may appear under a \u201CShow more\u201D link or may be hidden."
    }
});
const $f4e0c662868ff2bc$export$871b018529ef98e8 = (0, $7VHMR.defineMessages)({
    screenReaderErrorPrefixForFieldErrorMessage: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.screenReaderErrorPrefixForFieldErrorMessage",
        "defaultMessage": "Error"
    },
    // project-settings-apps/add-issue-type/view/main-modal/content/name-input/view.js
    nameInputLabel: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.name-input.label",
        "defaultMessage": "Name"
    },
    nameInputPlaceholder: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.name-input.placeholder",
        "defaultMessage": "Enter new name"
    },
    nameTooShortError: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.name-input.too-short-error-name",
        "defaultMessage": "Add a name."
    },
    nameAlreadyExistsError: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.name-input.already-exists-error-name",
        "defaultMessage": "Already exists. Try a different name."
    },
    nameTooLongError: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.name-input.too-long-error",
        "defaultMessage": "Name can't exceed {characterLimit} characters"
    },
    // project-settings-apps/add-issue-type/view/main-modal/content/description-input/view.js
    descriptionInputLabel: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.description-input.label",
        "defaultMessage": "Portal description"
    },
    descriptionInputPlaceholder: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.description-input.placeholder",
        "defaultMessage": "Let customers know when to use this request type"
    },
    descriptionTooLongError: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.description-input.too-long-error",
        "defaultMessage": "Description can't exceed {characterLimit} characters"
    },
    // project-settings-apps/add-issue-type/view/main-modal/content/avatar-input/view.js
    avatarLabel: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.avatar-input.label",
        "defaultMessage": "Icon"
    },
    avatarIconName: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.avatar-input.icon-name",
        "defaultMessage": "Request type icon"
    },
    changeAvatarAction: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.avatar-input.change-action",
        "defaultMessage": "Change icon"
    },
    // project-settings-apps/add-issue-type/view/main-modal/footer/view.js
    createNewIssueTypeConfirmButton: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.template-footer.add",
        "defaultMessage": "Create"
    },
    createNewIssueTypeCancelButton: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.footer.cancel",
        "defaultMessage": "Cancel"
    },
    // project-settings-apps/add-issue-type/view/main-modal/template-content/view.js
    templatesHeader: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.template-content.suggested",
        "defaultMessage": "Suggested"
    },
    // project-settings-apps/add-issue-type/view/main-modal/template-footer/view.js
    addIssueTypeFromTemplateConfirmButton: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.footer.add",
        "defaultMessage": "Add"
    },
    addIssueTypeFromTemplateCancelButton: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.template-footer.cancel",
        "defaultMessage": "Cancel"
    },
    moveFromTemplateToCreateButton: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.template-footer.show-form",
        "defaultMessage": "Create request type"
    },
    // project-settings-apps/add-issue-type/view/main-modal/view.js
    modalDialogTitle: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.title",
        "defaultMessage": "Create request type"
    },
    modalDialogAddTitle: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.add-title",
        "defaultMessage": "Add request type"
    },
    // project-settings-apps/add-issue-type/flags/index.js
    addIssueTypeSuccessTitle: {
        "id": "jsd.project-settings.project-settings-spa.flags.add-issue-type-success-title-new",
        "defaultMessage": "Request type created"
    },
    addIssueTypeSuccessDescription: {
        "id": "jsd.project-settings.project-settings-spa.flags.add-issue-type-success-description-new",
        "defaultMessage": "\u201C{descriptionName}\u201D has been successfully created."
    },
    addIssueTypeFailureTitle: {
        "id": "jsd.project-settings.project-settings-spa.flags.add-issue-type-failure-title",
        "defaultMessage": "Couldn't add the request type"
    },
    addIssueTypeFailureDescription: {
        "id": "jsd.project-settings.project-settings-spa.flags.add-issue-type-failure-description",
        "defaultMessage": "Sorry, something went wrong and we couldn't add the request type. Try again."
    },
    // project-settings/project-settings-spa/view/nav-items/project-settings-navigation-items.js
    triggerButton: {
        "id": "jsd.project-setting-navigation.issueType.add-issue-type-trigger",
        "defaultMessage": "Add request type"
    }
});
const $f4e0c662868ff2bc$export$6ad141c20d48e8e9 = (0, $7VHMR.defineMessages)({
    buttonConfirm: {
        "id": "jsd.project-settings-apps.issue-type-page.delete-field-modal.button-confirm",
        "defaultMessage": "Delete"
    },
    buttonCancel: {
        "id": "jsd.project-settings-apps.issue-type-page.delete-field-modal.button-cancel",
        "defaultMessage": "Cancel"
    },
    modalHeader: {
        "id": "jsd.project-settings-apps.issue-type-page.delete-field-modal.modal-header",
        "defaultMessage": "Delete \u201C{fieldName}\u201D field"
    },
    issueDataWipeWarning: {
        "id": "jsd.project-settings-apps.issue-type-page.delete-field-modal.issue-data-wipe-warning",
        "defaultMessage": "Anything stored in this field on any request will be deleted."
    },
    eventualConsistencyWarning: {
        "id": "jsd.project-settings-apps.issue-type-page.delete-field-modal.eventual-consistency-warning",
        "defaultMessage": "Deleting will take some time to complete, and you may need to refresh the page to see the change."
    },
    noUndo: {
        "id": "jsd.project-settings-apps.issue-type-page.delete-field-modal.no-undo",
        "defaultMessage": "You can't undo this."
    },
    warningWhenOneIssueType: {
        "id": "jsd.project-settings-apps.issue-type-page.delete-field-modal.warning-when-one-issue-type",
        "defaultMessage": "Your \u201C{issueTypeIcon} {issueTypeName}\u201D request type uses this field."
    },
    warningWhenMultipleIssueTypes: {
        "id": "jsd.project-settings-apps.issue-type-page.delete-field-modal.warning-when-multiple-issue-types",
        "defaultMessage": "This field is used in these request types:"
    }
});
const $f4e0c662868ff2bc$export$64e0557338f5ac89 = (0, $7VHMR.defineMessages)({
    approversListInformation: {
        "id": "project-settings-apps.issue-type-page.field-associated.field-configuration.approvers-list.approvers-list-information",
        "defaultMessage": "People in this field will be asked to approve the request at the \"{approvalStatus}\" workflow status. You can remove this field by modifying the approval for \"{approvalStatus}\"."
    }
});

});

parcelRegister("EcXxh", function(module, exports) {

$parcel$export(module.exports, "fetchLayoutConfiguration", () => $0b7ea678a5cd8112$export$cdc3b62ee28e5139);

var $in90R = parcelRequire("in90R");

var $92ECu = parcelRequire("92ECu");

var $iBOrg = parcelRequire("iBOrg");

var $iwJFl = parcelRequire("iwJFl");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $7OARM = parcelRequire("7OARM");

var $3WKp7 = parcelRequire("3WKp7");

var $ovaMM = parcelRequire("ovaMM");

var $c2EaK = parcelRequire("c2EaK");

var $1thZT = parcelRequire("1thZT");

var $eZEPm = parcelRequire("eZEPm");

var $4SBL6 = parcelRequire("4SBL6");


var $2teXs = parcelRequire("2teXs");

var $6Tnl1 = parcelRequire("6Tnl1");

var $g5X3G = parcelRequire("g5X3G");


var $kDWdC = parcelRequire("kDWdC");

var $1n6rX = parcelRequire("1n6rX");

var $7Ertg = parcelRequire("7Ertg");
const $0b7ea678a5cd8112$var$LayoutConfigurationFragment = (0, $92ECu.gqlTagGira)`
${(0, $3WKp7.JiraIssueLayoutUsageInfoFragment)}
${(0, $3WKp7.JiraIssueLayoutItemContainerFragment)}
${(0, $3WKp7.AvailableLayoutItemGroupsFragments)}
${(0, $3WKp7.JiraIssueLayoutItemConfigurationFragment)}
fragment TMPJSMLayoutConfigurationFragment on Query {
  simplifiedProject(projectId: $projectId) {
    issueType(id: $extraDefinerId) {
      properties(keys: $requestOwnerPropertyKeys)
      issueRestriction {
        defaultRestrictions {
          restrictionValue
        }
      }
    }
  }
  projectConfiguration(projectId: $projectId) {
    ... on JiraProjectConfigurationResult {
      limitInfo {
        limitFieldsPerProject
        currentFieldsPerProject
        limitOptionsPerField
      }
    }
  }
  issueLayoutConfiguration(issueLayoutKey: {projectId: $projectId, extraDefinerId: $extraDefinerId}, type: ISSUE_VIEW) {
    __typename
    ... on JiraIssueLayoutConfigurationResult {
      issueLayoutResult {
        __typename
        id
        name
        usageInfo {
           ...JiraIssueLayoutUsageInfo
        }
        containers {
            ...JiraIssueLayoutItemContainerFragment
        }
      }
      metadata {
        __typename
        configuration {
            ...JiraIssueLayoutItemConfigurationFragment
        }
        availableFieldTypes {
          nodes {
            name
            key
            operations {
              editable
              canModifyRequired
              canModifyOptions
              canModifyDefaultValue
              canModifyPropertyConfiguration
              removable
              deletable
              canAssociateInSettings
              categoriesWhitelist
            }
          }
        }
        availableItems {
          restrictedFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          suggestedFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          systemAndAppFields(first: $availableItemsPageSize) {
            ...SystemAvailableLayoutItemsGroup
          }
          textFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          labelsFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          peopleFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          dateFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          selectFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          numberFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          otherFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
          advancedFields(first: $availableItemsPageSize) {
            ...CustomAvailableLayoutItemsGroup
          }
        }
      }
    }
  }
}
`;
const $0b7ea678a5cd8112$var$fetchIssueLayoutConfigurationInternal = (projectContext, extraDefinerId, availableItemsPageSize)=>{
    const client = (0, $iBOrg.getClient)((0, $g5X3G.toBaseUrl)('')); // in cloud, baseUrl is always empty string
    const { projectId: projectId } = projectContext;
    const query = `
            query SwiftJsmTmpInitial($projectId: Long!, $extraDefinerId: Long!, $fieldPropertyKeys: [String!]!, $availableItemsPageSize: Int!, $requestOwnerPropertyKeys: [String!] = []) {
                ...TMPJSMLayoutConfigurationFragment
            }
            ${$0b7ea678a5cd8112$var$LayoutConfigurationFragment}
    `;
    return client.query({
        query: query,
        variables: {
            projectId: projectId,
            extraDefinerId: extraDefinerId,
            fieldPropertyKeys: [
                (0, $23ebcbac5107706a$export$ffd77ce47de6d72c),
                (0, $23ebcbac5107706a$export$663476c4863d5014),
                'jsd.field.approval.config',
                'jsd.field.approval.all.configs'
            ],
            requestOwnerPropertyKeys: [
                (0, $23ebcbac5107706a$export$97806a3c861a8076)
            ],
            availableItemsPageSize: availableItemsPageSize
        }
    });
};
const $0b7ea678a5cd8112$var$responseTransformer = (extraDefinerId, response, defaultCategoryConfigurations, emailRequestTypeCategoryConfigurations)=>{
    if (response.errors && response.errors.length > 0) {
        if ((0, $6Tnl1.is404GraphqlResponse)(response.errors)) throw new (0, $4SBL6.ExcludeFromMonitoringError)('Failed to load initial data: 404');
        throw new Error(`Failed to load initial data. issue-type-page.services.fetch-data-service${JSON.stringify(response.errors)}`);
    }
    if (!response.data) throw new Error('Failed to load initial data. `response.data` is empty');
    const { issueLayoutConfiguration: issueLayoutConfiguration, simplifiedProject: simplifiedProject, projectConfiguration: projectConfiguration } = response.data;
    if (!simplifiedProject || !simplifiedProject.issueType || !issueLayoutConfiguration || issueLayoutConfiguration.__typename === 'QueryError' || !issueLayoutConfiguration.issueLayoutResult || issueLayoutConfiguration.issueLayoutResult.name === null || issueLayoutConfiguration.issueLayoutResult.name === undefined || !issueLayoutConfiguration.issueLayoutResult.containers || !issueLayoutConfiguration.issueLayoutResult.usageInfo || !issueLayoutConfiguration.issueLayoutResult.usageInfo.edges || // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"JiraIssueLayoutResult"' and '"QueryError"' have no overlap.
    issueLayoutConfiguration.issueLayoutResult.__typename === 'QueryError' || !issueLayoutConfiguration.metadata || // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"JiraIssueLayoutMetadata"' and '"QueryError"' have no overlap.
    issueLayoutConfiguration.metadata.__typename === 'QueryError' || !projectConfiguration || projectConfiguration.__typename === 'QueryError' || !projectConfiguration.limitInfo) throw new Error('Failed to load initial data. `issueLayoutConfiguration` has the wrong shape');
    const gqlIssueRestriction = simplifiedProject.issueType.issueRestriction;
    const properties = simplifiedProject.issueType.properties || undefined;
    const isEmailRequestType = properties && properties[0, $23ebcbac5107706a$export$97806a3c861a8076];
    const jsmTmpTransformers = {
        ...(0, $eZEPm.default),
        activeLayoutItem: isEmailRequestType ? (0, $kDWdC.jsmTmpTransformActiveLayoutItemForEmailRequest) : (0, $kDWdC.jsmTmpTransformActiveLayoutItem),
        category: (0, $1n6rX.jsmTmpTransformCategory)
    };
    let issueRestriction = null;
    if (gqlIssueRestriction && gqlIssueRestriction.defaultRestrictions) issueRestriction = {
        defaultRestrictions: gqlIssueRestriction.defaultRestrictions.map(({ restrictionValue: restrictionValue })=>({
                restrictionValue: restrictionValue
            }))
    };
    const { issueLayoutResult: { id: layoutId, name: screenName, usageInfo: { edges: layoutOwnersEdges }, containers: containers }, metadata: { configuration: { items: { nodes: layoutItemNodes } }, availableItems: availableItems, availableFieldTypes: availableFieldTypes } } = issueLayoutConfiguration;
    if (containers.length === 0) throw new Error(`Failed to load initial data. No containers for issueLayout ${extraDefinerId}`);
    const layoutOwnerEdge = layoutOwnersEdges.find(({ currentProject: currentProject })=>currentProject);
    if (!layoutOwnerEdge || !layoutOwnerEdge.node || !layoutOwnerEdge.node.layoutOwners) throw new Error(`Failed to load initial data. No layoutOwners for issueLayout ${extraDefinerId}`);
    const { node: { layoutOwners: layoutOwners } } = layoutOwnerEdge;
    const availableLayoutItemGroups = (0, $c2EaK.transformAvailableLayoutItemGroups)(availableItems || {});
    const { fieldsById: fieldsById, panelsById: panelsById } = (0, $ovaMM.createLayoutItemsIndex)(layoutItemNodes);
    const activeLayoutItems = jsmTmpTransformers.activeLayoutItems(containers, fieldsById, panelsById, jsmTmpTransformers);
    const fieldTypes = availableFieldTypes.nodes.map(({ name: name, key: key, operations: { __typename: __typename, categoriesWhitelist: categoriesWhitelist, ...restOperations } })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            name: name,
            key: (0, $2teXs.toFieldType)(key),
            operations: {
                ...restOperations,
                categoriesWhitelist: categoriesWhitelist.map((0, $in90R.toFieldCategory))
            }
        }));
    const { currentFieldsPerProject: currentFieldsPerProject, limitFieldsPerProject: limitFieldsPerProject, limitOptionsPerField: limitOptionsPerField } = projectConfiguration.limitInfo;
    const issueLayoutOwners = (0, $1thZT.transformLayoutOwners)(layoutOwners).map((owner)=>{
        if (owner.data.id === extraDefinerId && owner.type === (0, $231503f5cdbec9c4$export$3bfbaac56381682c)) return {
            ...owner,
            data: {
                ...owner.data,
                properties: {
                    ...owner.data.properties,
                    ...properties
                }
            }
        };
        return owner;
    });
    return {
        layoutId: layoutId ?? null,
        screenName: screenName,
        issueLayoutOwners: issueLayoutOwners,
        fieldTypes: fieldTypes,
        categoryConfigurations: isEmailRequestType ? emailRequestTypeCategoryConfigurations : defaultCategoryConfigurations,
        tabs: jsmTmpTransformers.tabs(containers, fieldsById, jsmTmpTransformers),
        activeLayoutItems: activeLayoutItems,
        availableLayoutItemGroups: availableLayoutItemGroups,
        // TODO: add non-configurable fields information
        nonConfigurableFields: [],
        issueRestriction: issueRestriction,
        // limits
        projectFieldCollection: {
            limitProjectScopedPerProject: null,
            limitFieldsPerProject: limitFieldsPerProject,
            currentFieldsPerProject: currentFieldsPerProject,
            nextFieldsPerProject: currentFieldsPerProject
        },
        fieldOptionCollection: {
            limitPerField: limitOptionsPerField
        },
        affectedProjects: [],
        limits: {
            optionsPerField: limitOptionsPerField
        },
        allowedActions: null,
        accessControl: null
    };
};
const $0b7ea678a5cd8112$export$cdc3b62ee28e5139 = (defaultCategoryConfigurations, emailRequestTypeCategoryConfigurations)=>async ({ projectContext: projectContext, extraDefinerId: extraDefinerId, availableItemsPageSize: availableItemsPageSize, cloudId: cloudId })=>{
        const [layoutConfiguration, proformaReqTypeConfig, explicitFieldAssociation] = await Promise.all([
            (0, $koFzm.famaCatchAndLogFetchError)($0b7ea678a5cd8112$var$fetchIssueLayoutConfigurationInternal(projectContext, extraDefinerId, availableItemsPageSize), (0, $7Ertg.PACKAGE_NAME), (0, $gl0PU.toErrorId)('fetchSwiftConfigurationData'), (0, $gl0PU.toErrorMessage)('Failed to fetch SWIFT configuration data for the issue layout')).then((response)=>$0b7ea678a5cd8112$var$responseTransformer(extraDefinerId, response, defaultCategoryConfigurations, emailRequestTypeCategoryConfigurations)),
            (0, $iwJFl.fetchProformaReqTypeConfig)({
                projectId: projectContext.projectId,
                requestTypeId: extraDefinerId,
                cloudId: cloudId
            }),
            (0, $7OARM.fetchExplicitFieldAssociation)(projectContext.projectId)
        ]);
        return {
            ...layoutConfiguration,
            ...proformaReqTypeConfig ? {
                proformaReqTypeConfig: proformaReqTypeConfig
            } : {},
            explicitFieldAssociation: explicitFieldAssociation
        };
    };

});
parcelRegister("7OARM", function(module, exports) {

$parcel$export(module.exports, "fetchExplicitFieldAssociation", () => $18a39d3457fe64e1$export$5db6b6bf212ad84e);

var $6s1PB = parcelRequire("6s1PB");
function $18a39d3457fe64e1$export$5db6b6bf212ad84e(projectId) {
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    if (!expConfig.get('isEnabled', false)) return Promise.resolve({
        enabled: false
    });
    return fetch(`/rest/internal/latest/efa/projects/${projectId}`).then((response)=>{
        if (!response.ok) throw new Error('Failed to load project toggle status');
        return response.json();
    }).then(({ explicitFieldAssociationEnabled: explicitFieldAssociationEnabled })=>({
            enabled: explicitFieldAssociationEnabled
        }));
}

});

parcelRegister("1thZT", function(module, exports) {

$parcel$export(module.exports, "transformLayoutOwners", () => $ebd56c00f035f7c7$export$3d70ee10212e7f1d);

const $ebd56c00f035f7c7$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
const $ebd56c00f035f7c7$export$9be9f574874c9a2f = 'jsm.issue.type.id';
const $ebd56c00f035f7c7$export$b320c6b352dcb101 = 'jsm.issue.type.name';
const $ebd56c00f035f7c7$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
const $ebd56c00f035f7c7$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
function $ebd56c00f035f7c7$var$issueTypeOwner({ id: id, name: name, description: description, avatarId: avatarId, iconUrl: iconUrl }) {
    return {
        type: (0, $231503f5cdbec9c4$export$48834e33dc47483),
        data: {
            // Ensure to update IssueTypeOwnerDataBean in Jira BE if new fields added as this is used by both load AND save flow.
            // Addition of new field here must be feature flagged otherwise it may cause an incident (e.g. HOT-110012).
            id: parseInt(id, 10),
            name: name,
            description: description || '',
            avatarId: avatarId ?? null,
            iconUrl: iconUrl ?? null
        }
    };
}
function $ebd56c00f035f7c7$var$requestTypeOwner({ id: id, externalUuid: externalUuid, name: name, description: description, avatarId: avatarId, iconUrl: iconUrl, instructions: instructions, restrictionStatus: restrictionStatus, properties: properties }) {
    return {
        type: (0, $231503f5cdbec9c4$export$3bfbaac56381682c),
        data: {
            // Ensure to update RequestTypeOwnerDataBean in Jira BE if new fields added as this is used by both load AND save flow.
            // Addition of new field here must be feature flagged otherwise it may cause an incident (e.g. HOT-110012).
            id: parseInt(id, 10),
            name: name,
            description: description || '',
            avatarId: avatarId ?? null,
            iconUrl: iconUrl ?? null,
            instructions: instructions || '',
            externalUuid: externalUuid,
            restrictionStatus: restrictionStatus,
            properties: {
                [$ebd56c00f035f7c7$export$aefba859678f04a]: properties?.[$ebd56c00f035f7c7$export$aefba859678f04a],
                [$ebd56c00f035f7c7$export$b320c6b352dcb101]: properties?.[$ebd56c00f035f7c7$export$b320c6b352dcb101],
                [$ebd56c00f035f7c7$export$97bca9c51480133e]: properties?.[$ebd56c00f035f7c7$export$97bca9c51480133e],
                [$ebd56c00f035f7c7$export$b540ee71bad36b8b]: properties?.[$ebd56c00f035f7c7$export$b540ee71bad36b8b],
                [$ebd56c00f035f7c7$export$9be9f574874c9a2f]: properties?.[$ebd56c00f035f7c7$export$9be9f574874c9a2f]
            }
        }
    };
}
const $ebd56c00f035f7c7$export$3d70ee10212e7f1d = (gqlLayoutOwners)=>{
    const result = [];
    for(let i = 0; i < gqlLayoutOwners.length; i += 1){
        const item = gqlLayoutOwners[i];
        if (item.__typename === 'JiraIssueLayoutIssueTypeOwner') result.push($ebd56c00f035f7c7$var$issueTypeOwner(item));
        if (item.__typename === 'JiraIssueLayoutRequestTypeOwner') result.push($ebd56c00f035f7c7$var$requestTypeOwner(item));
    }
    return result;
};

});

parcelRegister("6Tnl1", function(module, exports) {

$parcel$export(module.exports, "is404GraphqlResponse", () => $6aeeb740c372d766$export$ea8475cc3f927cd5);
function $6aeeb740c372d766$export$ea8475cc3f927cd5(errors) {
    return Array.isArray(errors) && errors.every((err)=>err != null && typeof err === 'object' && 'extensions' in err && typeof err.extensions === 'object' && err.extensions != null && 'statusCode' in err.extensions && err?.extensions?.statusCode === 404);
}

});

const $23ebcbac5107706a$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $23ebcbac5107706a$export$663476c4863d5014 = 'jsd.field.helpText';
const $23ebcbac5107706a$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $23ebcbac5107706a$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';

parcelRegister("kDWdC", function(module, exports) {

$parcel$export(module.exports, "jsmTmpTransformActiveLayoutItem", () => $9b593433f668dc5a$export$6ec6dd64b067454f);
$parcel$export(module.exports, "jsmTmpTransformActiveLayoutItemForEmailRequest", () => $9b593433f668dc5a$export$cb24e67135935952);

var $ebGjZ = parcelRequire("ebGjZ");

var $eZEPm = parcelRequire("eZEPm");

var $2teXs = parcelRequire("2teXs");

var $bnK2X = parcelRequire("bnK2X");

const $9b593433f668dc5a$var$overridesForEmailRequestType = {
    summary: {
        required: true,
        sortable: false
    },
    description: {
        required: false,
        sortable: false,
        operations: {
            removable: false,
            canModifyRequired: false
        }
    },
    attachment: {
        required: false,
        sortable: false,
        operations: {
            removable: false,
            canModifyRequired: false
        }
    }
};
const $9b593433f668dc5a$var$applyOverridesForEmailRequestType = (item)=>{
    if (item.layoutItemType !== (0, $2teXs.FIELD_LAYOUT_ITEM_TYPE)) return item;
    const overrides = $9b593433f668dc5a$var$overridesForEmailRequestType[item.data.key];
    if (!overrides) return item;
    return {
        ...item,
        data: {
            ...item.data,
            required: overrides.required,
            sortable: overrides.sortable,
            operations: {
                ...item.operations,
                ...overrides.operations
            }
        }
    };
};
const $9b593433f668dc5a$export$6ec6dd64b067454f = (field, containerType, transformers)=>{
    // first call the platform transformer
    const activeLayoutItem = (0, $eZEPm.default).activeLayoutItem(field, containerType, transformers);
    if (activeLayoutItem === null) return null;
    return {
        ...activeLayoutItem,
        data: {
            ...activeLayoutItem.data,
            ...activeLayoutItem.layoutItemType === (0, $2teXs.FIELD_LAYOUT_ITEM_TYPE) && field.__typename === 'JiraIssueLayoutFieldItemConfiguration' && field.properties && {
                // add the portal field name
                alternateName: (0, $ebGjZ.normalizeAlias)(field.properties[0, $23ebcbac5107706a$export$ffd77ce47de6d72c]),
                alternateDescription: (0, $ebGjZ.normalizeAlias)(field.properties[0, $23ebcbac5107706a$export$663476c4863d5014]),
                // The approval field configuration is currently saved in the fields properties,
                // For the purposes of this app, we want to read the approval config data via the fields configuration
                configuration: {
                    ...activeLayoutItem.data.configuration,
                    ...field.properties[0, $bnK2X.JSD_FIELD_APPROVAL_ALL_CONFIGS] ? {
                        [(0, $bnK2X.JSD_FIELD_APPROVAL_ALL_CONFIGS)]: field.properties[0, $bnK2X.JSD_FIELD_APPROVAL_ALL_CONFIGS]
                    } : {},
                    ...field.properties[0, $bnK2X.JSD_FIELD_APPROVAL_CONFIG] ? {
                        [(0, $bnK2X.JSD_FIELD_APPROVAL_CONFIG)]: field.properties[0, $bnK2X.JSD_FIELD_APPROVAL_CONFIG]
                    } : {}
                }
            }
        }
    };
};
const $9b593433f668dc5a$export$cb24e67135935952 = (field, containerType, transformers)=>{
    const item = $9b593433f668dc5a$export$6ec6dd64b067454f(field, containerType, transformers);
    if (!item) return item;
    return $9b593433f668dc5a$var$applyOverridesForEmailRequestType(item);
};

});
parcelRegister("ebGjZ", function(module, exports) {

$parcel$export(module.exports, "normalizeAlias", () => $d323b17d38c04b23$export$c6c6863447265be7);
// Emptystring is not valid alias for name or description.
const $d323b17d38c04b23$export$c6c6863447265be7 = (alternateNameOrDescription)=>{
    if (alternateNameOrDescription === '') return undefined;
    return alternateNameOrDescription;
};

});


parcelRegister("1n6rX", function(module, exports) {

$parcel$export(module.exports, "jsmTmpTransformCategory", () => $fd8e66ef85b9dc47$export$f576a75a73531ed8);

var $eZEPm = parcelRequire("eZEPm");

var $7Ertg = parcelRequire("7Ertg");
const $fd8e66ef85b9dc47$export$f576a75a73531ed8 = (containerType)=>{
    if (containerType === 'REQUEST_PORTAL') // `ISSUE_VIEW` layout returns request field container `REQUEST_PORTAL`
    // for `request` fields.
    // Transform to `request` so it matches
    return (0, $7Ertg.getRequestFieldCategoryId)();
    return (0, $eZEPm.default).category(containerType);
};

});


parcelRegister("l0vRU", function(module, exports) {

$parcel$export(module.exports, "saveChangesService", () => $8bc0767a47df00a4$export$fce2a7ee6855aaa6);
$parcel$export(module.exports, "saveChangesServiceWithProformaContext", () => $8bc0767a47df00a4$export$cb1dee848fa51852);

var $dGrdR = parcelRequire("dGrdR");

var $eusud = parcelRequire("eusud");

var $iwJFl = parcelRequire("iwJFl");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");

var $kqnEs = parcelRequire("kqnEs");

var $lQAYg = parcelRequire("lQAYg");

var $9SUwx = parcelRequire("9SUwx");

var $fuYee = parcelRequire("fuYee");

var $5irNm = parcelRequire("5irNm");

var $7Ertg = parcelRequire("7Ertg");

var $eGGJz = parcelRequire("eGGJz");
const $8bc0767a47df00a4$var$updateIssueTypeTimer = (0, $dGrdR.metrics).custom({
    key: 'project-settings.issue-type.jsw-tmp.update'
});
const $8bc0767a47df00a4$export$7c611e2970463da4 = (projectId, layoutId, extraDefinerId, { issueLayout: issueLayout, owners: owners })=>(0, $eusud.performPutRequest)(`/rest/internal/1.0/issueLayouts/${layoutId}`, {
        body: JSON.stringify({
            projectId: projectId,
            extraDefinerId: extraDefinerId,
            owners: owners,
            issueLayoutType: 'ISSUE_VIEW',
            issueLayoutConfig: issueLayout
        })
    });
const $8bc0767a47df00a4$export$fce2a7ee6855aaa6 = async ({ projectId: projectId, layoutId: layoutId, extraDefinerId: extraDefinerId, data: data })=>{
    const transformedData = (0, $eGGJz.transformRequest)(data);
    $8bc0767a47df00a4$var$updateIssueTypeTimer.start();
    try {
        const response = await $8bc0767a47df00a4$export$7c611e2970463da4(projectId, layoutId, extraDefinerId, transformedData);
        const result = {
            ...response
        };
        $8bc0767a47df00a4$var$updateIssueTypeTimer.stop();
        return (0, $9SUwx.transformUpdateLayoutResponse)(result);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $1RLjE.logError)((0, $7Ertg.PACKAGE_NAME), (0, $gl0PU.toErrorId)('updateIssueLayoutJsmTeamManaged'), (0, $gl0PU.toErrorMessage)(error.errors?.map((e)=>e.error)?.toString() || 'The request failed trying to update issue layout'), error);
        $8bc0767a47df00a4$var$updateIssueTypeTimer.stop();
        throw error;
    }
};
const $8bc0767a47df00a4$export$cb1dee848fa51852 = (store, createAnalyticsEvent)=>async ({ projectId: projectId, layoutId: layoutId, extraDefinerId: extraDefinerId, data: data })=>{
        const state = store.getState();
        const cloudId = (0, $lQAYg.getCloudId)(state);
        const transformedData = (0, $eGGJz.transformRequest)(data);
        $8bc0767a47df00a4$var$updateIssueTypeTimer.start();
        try {
            store.dispatch((0, $kqnEs.saveChangesStart)());
            const response = await $8bc0767a47df00a4$export$7c611e2970463da4(projectId, layoutId, extraDefinerId, transformedData);
            // Call remove and add in sequence so that ProformaForm is added
            // ONLY WHEN remove previous form succeed
            await (0, $5irNm.removeProformaReqTypeForm)((0, $lQAYg.proformaReqTypeFormRemovalRequest)(state), createAnalyticsEvent);
            await (0, $fuYee.addProformaReqTypeForm)((0, $lQAYg.proformaReqTypeFormAddRequest)(state), createAnalyticsEvent);
            const result = {
                ...response
            };
            $8bc0767a47df00a4$var$updateIssueTypeTimer.stop();
            // get the latest backend state
            await (0, $iwJFl.fetchProformaReqTypeConfig)({
                cloudId: cloudId,
                projectId: projectId,
                requestTypeId: extraDefinerId
            }).then((config)=>{
                if (config !== null) store.dispatch((0, $kqnEs.fetchProformaReqTypeConfigSuccess)(config));
                else store.dispatch((0, $kqnEs.removeProformaReqTypeFormSuccess)());
            });
            store.dispatch((0, $kqnEs.saveChangesSuccess)());
            return (0, $9SUwx.transformUpdateLayoutResponse)(result);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $1RLjE.logError)((0, $7Ertg.PACKAGE_NAME), (0, $gl0PU.toErrorId)('updateIssueLayoutJsmTeamManaged'), (0, $gl0PU.toErrorMessage)(error.errors?.map((e)=>e.error)?.toString() || 'The request failed trying to update issue layout'), error);
            $8bc0767a47df00a4$var$updateIssueTypeTimer.stop();
            throw error;
        }
    };

});
parcelRegister("9SUwx", function(module, exports) {

$parcel$export(module.exports, "transformUpdateLayoutResponse", () => $c47f0cb3a2731349$export$d70851665a236dd8);

var $fOGZN = parcelRequire("fOGZN");

var $ebGjZ = parcelRequire("ebGjZ");

var $dGEfc = parcelRequire("dGEfc");


var $bnK2X = parcelRequire("bnK2X");
const $c47f0cb3a2731349$var$toField = (restField)=>{
    const field = (0, $dGEfc.updateResponseItemTransformers).toField(restField);
    const { properties: properties } = restField.data;
    const configuration = {
        ...restField.data.configuration,
        inactiveFieldLozenge: undefined
    };
    let alternateDescription;
    let alternateName;
    if (properties) {
        alternateName = typeof properties[0, $bnK2X.JSD_FIELD_ALIAS] === 'string' ? (0, $ebGjZ.normalizeAlias)(properties[0, $bnK2X.JSD_FIELD_ALIAS]) : undefined;
        alternateDescription = typeof properties[0, $bnK2X.JSD_FIELD_HELPTEXT] === 'string' ? (0, $ebGjZ.normalizeAlias)(properties[0, $bnK2X.JSD_FIELD_HELPTEXT]) : undefined;
        if (properties[0, $bnK2X.JSD_FIELD_APPROVAL_CONFIG]) configuration[0, $bnK2X.JSD_FIELD_APPROVAL_CONFIG] = properties[0, $bnK2X.JSD_FIELD_APPROVAL_CONFIG];
        if (properties[0, $bnK2X.JSD_FIELD_APPROVAL_ALL_CONFIGS]) configuration[0, $bnK2X.JSD_FIELD_APPROVAL_ALL_CONFIGS] = properties[0, $bnK2X.JSD_FIELD_APPROVAL_ALL_CONFIGS];
    }
    return {
        ...field,
        data: {
            ...field.data,
            alternateName: alternateName,
            alternateDescription: alternateDescription,
            configuration: configuration
        }
    };
};
/**
 * 'Security Level' field is managed by Request Type Security dialog (@atlassian/jira-servicedesk-request-type-security) hence
 * when updating the issue layout we do not want it to show up on the page. All fields are returned when updating the issue layout.
 */ const $c47f0cb3a2731349$var$filterSecurityLevelField = (activeLayoutItems)=>{
    return activeLayoutItems.filter((activeLayoutItem)=>{
        switch(activeLayoutItem.type){
            case 0, $86d8ca14342a9842$export$d6f887e0c1be1b74:
                return activeLayoutItem.key !== (0, $fOGZN.SECURITY);
            default:
                return true;
        }
    });
};
const $c47f0cb3a2731349$export$d70851665a236dd8 = ({ extraDefinerId: extraDefinerId, issueLayoutConfig: issueLayoutConfig, issueLayoutType: issueLayoutType, owners: owners })=>({
        owners: owners,
        extraDefinerId: extraDefinerId,
        issueLayoutType: issueLayoutType,
        name: owners[0].data.name,
        description: owners[0].data.description,
        activeLayoutItems: (0, $dGEfc.updateResponseToActiveLayoutItems)($c47f0cb3a2731349$var$filterSecurityLevelField(issueLayoutConfig.items), {
            ...(0, $dGEfc.updateResponseItemTransformers),
            toField: $c47f0cb3a2731349$var$toField
        })
    });

});
parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $1df76d38eb6e3f90$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, $5fc53.SELECT_CF_TYPE);
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE),
    (0, $5fc53.ORGANIZATION_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});
parcelRegister("65mz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7178ba5d31d0f054$export$2e2bcd8739ae039);
const $7178ba5d31d0f054$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;

});


parcelRegister("dGEfc", function(module, exports) {

$parcel$export(module.exports, "updateResponseItemTransformers", () => $adace0fdf47b760e$export$e9fff9f150646818);
$parcel$export(module.exports, "updateResponseToActiveLayoutItems", () => $adace0fdf47b760e$export$e267a40690c33bfc);

var $4R6GH = parcelRequire("4R6GH");

var $2teXs = parcelRequire("2teXs");


var $l6Vth = parcelRequire("l6Vth");

var $aUDnU = parcelRequire("aUDnU");

var $4Y9LX = parcelRequire("4Y9LX");
const $adace0fdf47b760e$export$4e06114ad1feedd8 = ({ key: key, sectionType: sectionType, data: data })=>{
    const { operations: operations, options: options, type: type, custom: custom, global: global, required: required, provider: provider, properties: properties, defaultValue: defaultValue } = data;
    const normalizedOptions = (0, $4Y9LX.normalizeOptions)(type, options);
    const field = {
        key: key,
        externalUuid: data.externalUuid,
        name: data.name,
        description: data.description,
        category: (0, $l6Vth.transformCategory)(sectionType),
        type: type,
        custom: custom,
        global: global,
        required: required,
        operations: operations,
        provider: provider,
        ...(0, $4R6GH.fg)('forge_custom_fields_on_jsm_portal_create') ? {
            properties: properties
        } : {},
        options: normalizedOptions,
        defaultValue: (0, $aUDnU.normalizeDefaultValue)(type, defaultValue, normalizedOptions),
        configuration: data.configuration,
        // API doesn't return availability information on update
        // it will be alter reinjected in the SWIFT code
        availability: null
    };
    return {
        key: (0, $2teXs.toLayoutItemKey)((0, $2teXs.FIELD_LAYOUT_ITEM_TYPE), key),
        layoutItemType: (0, $2teXs.FIELD_LAYOUT_ITEM_TYPE),
        operations: operations,
        category: (0, $l6Vth.transformCategory)(sectionType),
        data: field
    };
};
const $adace0fdf47b760e$export$75be736ce6545903 = ({ key: key, sectionType: sectionType, data: data })=>{
    const operations = {
        editable: data.operations.editable,
        removable: data.operations.removable,
        categoriesWhitelist: data.operations.categoriesWhitelist,
        canAssociateInSettings: data.operations.canAssociateInSettings,
        deletable: data.operations.deletable
    };
    return {
        key: (0, $2teXs.toLayoutItemKey)((0, $2teXs.PANEL_LAYOUT_ITEM_TYPE), key),
        layoutItemType: (0, $2teXs.PANEL_LAYOUT_ITEM_TYPE),
        operations: operations,
        category: (0, $l6Vth.transformCategory)(sectionType),
        data: {
            key: key,
            name: data.name,
            operations: operations
        }
    };
};
const $adace0fdf47b760e$export$e9fff9f150646818 = {
    toField: $adace0fdf47b760e$export$4e06114ad1feedd8,
    toPanel: $adace0fdf47b760e$export$75be736ce6545903
};
const $adace0fdf47b760e$export$e267a40690c33bfc = (serverItems, itemTransformers)=>serverItems.reduce((accum, item)=>{
        switch(item.type){
            case 0, $86d8ca14342a9842$export$f1c9dd0f5207dd5e:
                {
                    if (item.items == null || item.items === undefined || item.items.length === 0) return accum;
                    const itemsWithSectionType = item.items.map((tabItem)=>tabItem.type === (0, $86d8ca14342a9842$export$d6f887e0c1be1b74) && Boolean(tabItem.data) ? tabItem : null).filter(Boolean).map(({ data: data, key: key, type: type })=>({
                            data: data,
                            key: key,
                            type: type,
                            sectionType: item.sectionType
                        }));
                    return accum.concat($adace0fdf47b760e$export$e267a40690c33bfc(itemsWithSectionType, itemTransformers));
                }
            case 0, $86d8ca14342a9842$export$d6f887e0c1be1b74:
                return accum.concat(itemTransformers.toField(item));
            case 0, $86d8ca14342a9842$export$867b449446b85962:
                return accum.concat(itemTransformers.toPanel(item));
            default:
                return accum;
        }
    }, []);

});
const $86d8ca14342a9842$export$d6f887e0c1be1b74 = 'FIELD';
const $86d8ca14342a9842$export$2b9b886dddb4ba32 = 'GROUP';
const $86d8ca14342a9842$export$867b449446b85962 = 'PANEL';
const $86d8ca14342a9842$export$f1c9dd0f5207dd5e = 'TAB';



parcelRegister("fuYee", function(module, exports) {

$parcel$export(module.exports, "addProformaReqTypeForm", () => $2eebc692572109b8$export$e6a6d4863dd4bc8c);

var $7LGo4 = parcelRequire("7LGo4");

var $bpfvR = parcelRequire("bpfvR");
const $2eebc692572109b8$export$e6a6d4863dd4bc8c = async (proformaReqTypeFormAddRequest, createAnalyticsEvent)=>{
    if (proformaReqTypeFormAddRequest) try {
        return await (0, $bpfvR.addProformaReqTypeForm)({
            ...proformaReqTypeFormAddRequest,
            createAnalyticsEvent: createAnalyticsEvent
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        throw new (0, $7LGo4.ProformaReqTypeAddError)(e.message, proformaReqTypeFormAddRequest.formName);
    }
    return undefined;
};

});
parcelRegister("7LGo4", function(module, exports) {

$parcel$export(module.exports, "ProformaReqTypeAddError", () => $963577d949df9eb9$export$7defb67eaa9a5c23);
class $963577d949df9eb9$export$7defb67eaa9a5c23 extends Error {
    constructor(message, formName){
        super(message), this.proformaReqTypeAddErrorTag = true;
        this.formName = formName;
    }
}

});

parcelRegister("bpfvR", function(module, exports) {

$parcel$export(module.exports, "addProformaReqTypeForm", () => $80b8870e27b1ad14$export$e6a6d4863dd4bc8c);

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

const $80b8870e27b1ad14$export$e6a6d4863dd4bc8c = async ({ cloudId: cloudId, projectId: projectId, requestTypeId: requestTypeId, formId: formId, createAnalyticsEvent: createAnalyticsEvent })=>{
    try {
        await (0, $eusud.performPostRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/3/project/${projectId}/requesttype/${requestTypeId}/form/${formId}/portal-association`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) (0, $jcw0u.default)({
            meta: {
                id: 'addProformaReqTypeForm',
                packageName: $26bfa12f59001b80$export$9345d7360ffe0722,
                teamName: $26bfa12f59001b80$export$9f98a8d796affec6
            },
            error: error,
            attributes: {
                formId: formId
            }
        });
        throw error;
    }
    createAnalyticsEvent && (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'proformaRTCFormAdd succeeded', {
        formId: formId,
        projectId: projectId,
        requestTypeId: requestTypeId
    });
    return requestTypeId;
};

});


parcelRegister("5irNm", function(module, exports) {

$parcel$export(module.exports, "removeProformaReqTypeForm", () => $bae9d5dd33a95cd7$export$31dbf24cf341a3cf);

var $f8D3e = parcelRequire("f8D3e");

var $hPE41 = parcelRequire("hPE41");
const $bae9d5dd33a95cd7$export$31dbf24cf341a3cf = async (proformaReqTypeFormRemovalRequest, createAnalyticsEvent)=>{
    if (proformaReqTypeFormRemovalRequest) try {
        const removedProformaFormReqTypeId = await (0, $hPE41.removeProformaReqTypeForm)({
            ...proformaReqTypeFormRemovalRequest,
            createAnalyticsEvent: createAnalyticsEvent
        });
        return removedProformaFormReqTypeId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        throw new (0, $f8D3e.ProformaReqTypeRemoveError)(e.message, proformaReqTypeFormRemovalRequest.formName);
    }
    return undefined;
};

});
parcelRegister("f8D3e", function(module, exports) {

$parcel$export(module.exports, "ProformaReqTypeRemoveError", () => $f35fa12a0c825ef6$export$fc6b7411f26764f4);
class $f35fa12a0c825ef6$export$fc6b7411f26764f4 extends Error {
    constructor(message, formName){
        super(message), this.proformaReqTypeRemoveErrorTag = true;
        this.formName = formName;
    }
}

});

parcelRegister("hPE41", function(module, exports) {

$parcel$export(module.exports, "removeProformaReqTypeForm", () => $6de56005ae282fca$export$31dbf24cf341a3cf);

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

const $6de56005ae282fca$export$31dbf24cf341a3cf = async ({ cloudId: cloudId, projectId: projectId, requestTypeId: requestTypeId, formId: formId, createAnalyticsEvent: createAnalyticsEvent })=>{
    try {
        await (0, $eusud.performDeleteRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/3/project/${projectId}/requesttype/${requestTypeId}/form/${formId}/portal-association`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) (0, $jcw0u.default)({
            meta: {
                id: 'removeProformaReqTypeForm',
                packageName: $26bfa12f59001b80$export$9345d7360ffe0722,
                teamName: $26bfa12f59001b80$export$9f98a8d796affec6
            },
            error: error,
            attributes: {
                formId: formId
            }
        });
        throw error;
    }
    createAnalyticsEvent && (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'proformaRTCFormRemove succeeded', {
        formId: formId,
        projectId: projectId,
        requestTypeId: requestTypeId
    });
    return requestTypeId;
};

});


parcelRegister("eGGJz", function(module, exports) {

$parcel$export(module.exports, "transformRequest", () => $434cac8b531bdcf9$export$b6b0907238057217);

var $2teXs = parcelRequire("2teXs");


var $8PlRD = parcelRequire("8PlRD");
const $434cac8b531bdcf9$var$NEW_FIELD_KEY_PREFIX = 'new_field_';
const $434cac8b531bdcf9$export$e86b221e36eb9b8a = (data)=>({
        items: data.layoutItems.map((layoutItem)=>{
            // Category should never be null for layout items but we'll add a check here to make flow happy.
            if (layoutItem.category === null) return null;
            switch(layoutItem.layoutItemType){
                case 0, $2teXs.FIELD_LAYOUT_ITEM_TYPE:
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    return {
                        type: (0, $86d8ca14342a9842$export$d6f887e0c1be1b74),
                        sectionType: layoutItem.category,
                        key: layoutItem.data.key.includes($434cac8b531bdcf9$var$NEW_FIELD_KEY_PREFIX) ? null : layoutItem.data.key,
                        data: (0, $8PlRD.cleanFieldForRequest)(layoutItem.data)
                    };
                case 0, $2teXs.PANEL_LAYOUT_ITEM_TYPE:
                    {
                        const panel = layoutItem.data;
                        return {
                            type: (0, $86d8ca14342a9842$export$867b449446b85962),
                            sectionType: layoutItem.category,
                            key: panel.key,
                            data: {
                                name: panel.name,
                                operations: panel.operations
                            }
                        };
                    }
                default:
                    // prettier-ignore
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    layoutItem;
                    return null;
            }
        }).filter(Boolean)
    });
const $434cac8b531bdcf9$export$b6b0907238057217 = (data)=>({
        owners: data.issueLayoutOwners,
        issueLayout: $434cac8b531bdcf9$export$e86b221e36eb9b8a(data)
    });

});
parcelRegister("8PlRD", function(module, exports) {

$parcel$export(module.exports, "cleanFieldForRequest", () => $45f5b8b0051ef2d8$export$ccb5415e2d4c5d7b);

const $45f5b8b0051ef2d8$var$removeEmptyOptions = (option)=>option && typeof option.value === 'string' && option.value !== '';
const $45f5b8b0051ef2d8$var$normalizeInactiveFieldLozenge = ({ inactiveFieldLozenge: inactiveFieldLozenge, ...restConfig })=>restConfig;
const $45f5b8b0051ef2d8$var$normalizeConfiguration = (configuration)=>{
    let config = configuration;
    if (config) {
        // Remove any inactive field lozenge data since it is localized message data that we shouldn't persist
        config = $45f5b8b0051ef2d8$var$normalizeInactiveFieldLozenge(config);
        return Object.keys(config).length === 0 ? undefined : config;
    }
    return undefined;
};
const $45f5b8b0051ef2d8$var$normalizeOptions = (options)=>Array.isArray(options) ? options.map(({ optimisticId: optimisticId, ...rest })=>rest).filter($45f5b8b0051ef2d8$var$removeEmptyOptions) : undefined;
const $45f5b8b0051ef2d8$var$normalizeDefaultValue = (defaultValue)=>Array.isArray(defaultValue) ? defaultValue.map(({ optimisticId: optimisticId, ...rest })=>rest) : defaultValue;
const $45f5b8b0051ef2d8$export$ccb5415e2d4c5d7b = (field)=>({
        externalUuid: field.externalUuid,
        name: field.name,
        description: field.description,
        type: field.type,
        custom: field.custom,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        global: field.global !== undefined ? field.global : undefined,
        required: field.required,
        operations: field.operations,
        provider: field.provider,
        options: $45f5b8b0051ef2d8$var$normalizeOptions(field.options),
        defaultValue: $45f5b8b0051ef2d8$var$normalizeDefaultValue(field.defaultValue),
        properties: {
            [(0, $23ebcbac5107706a$export$ffd77ce47de6d72c)]: field.alternateName || null,
            [(0, $23ebcbac5107706a$export$663476c4863d5014)]: field.alternateDescription || null
        },
        configuration: $45f5b8b0051ef2d8$var$normalizeConfiguration(field.configuration)
    });

});



parcelRegister("hwF9S", function(module, exports) {

$parcel$export(module.exports, "MainContent", () => $5e6a57cc7e6abec0$export$5c0547b091a4b556);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");


var $h5J4D = parcelRequire("h5J4D");

var $bg6Rm = parcelRequire("bg6Rm");


var $8k5eK = parcelRequire("8k5eK");

var $5uaGm = parcelRequire("5uaGm");


var $7Ertg = parcelRequire("7Ertg");

var $9Ekea = parcelRequire("9Ekea");
const $5e6a57cc7e6abec0$export$5c0547b091a4b556 = ({ issueTypeResetCount: issueTypeResetCount, activeFieldListRefElement: activeFieldListRefElement, activeFieldCategories: activeFieldCategories, children: children, fieldsDocumentationUrl: fieldsDocumentationUrl, issueLayoutOwners: issueLayoutOwners, extraDefinerId: extraDefinerId, onUpdateIssueLayoutOwner: onUpdateIssueLayoutOwner, onSetHasSeenEmptyStatePulse: onSetHasSeenEmptyStatePulse, projectKey: projectKey })=>{
    const issueType = issueLayoutOwners.find(({ data: { id: id } })=>id === extraDefinerId);
    if (!issueType || issueType.type !== (0, $231503f5cdbec9c4$export$3bfbaac56381682c)) throw new Error("Can't find current request type data");
    const { description: description, properties: properties } = issueType.data;
    const isEmailRequestType = properties && properties[0, $23ebcbac5107706a$export$97806a3c861a8076];
    const onDescriptionUpdate = (value)=>{
        onUpdateIssueLayoutOwner({
            ...issueType,
            data: {
                ...issueType.data,
                description: value
            }
        });
    };
    const validateDescription = (value)=>(0, $8k5eK.validateIssueTypeDescription)(value, (0, $9Ekea.validationMessages)).find(({ position: position })=>position === (0, $d2e37636a1b0be7f$export$b3eded1439af86ec));
    const onHelpTextUpdate = (value)=>{
        onUpdateIssueLayoutOwner({
            ...issueType,
            data: {
                ...issueType.data,
                instructions: value
            }
        });
    };
    const validateHelpText = (value)=>(0, $8k5eK.validateIssueTypeHelpText)(value, (0, $9Ekea.validationMessages)).find(({ position: position })=>position === (0, $d2e37636a1b0be7f$export$cb807c52d310479f));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isEmailRequestType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5J4D.DescriptionInlineInputTmp), {
        messages: (0, $9Ekea.descriptionInlineInputMessages),
        value: description,
        issueTypeResetCount: issueTypeResetCount,
        onChange: onDescriptionUpdate,
        onValidate: validateDescription
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5J4D.DescriptionInlineInputTmp), {
        value: issueType.data.instructions,
        messages: (0, $9Ekea.helpTextInlineInputMessages),
        issueTypeResetCount: issueTypeResetCount,
        onChange: onHelpTextUpdate,
        onValidate: validateHelpText
    })), activeFieldListRefElement, activeFieldCategories.map((category, index)=>{
        const showFormPanel = !isEmailRequestType && category.configuration.name === (0, $7Ertg.getRequestFieldCategoryId)();
        return(// The name is a unique identifier
        // eslint-disable-next-line react/jsx-key
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), (0, $4R6GH.fg)('concurrent-rendering-fix-unique-list-key') ? {
            key: category.configuration.name
        } : {}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bg6Rm.FieldCategory), {
            key: category.configuration.name,
            categoryIndex: index,
            category: category,
            fieldsDocumentationUrl: fieldsDocumentationUrl
        }, children({
            category: category
        })), showFormPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uaGm.FormPanelWithErrorBoundary), {
            category: category,
            projectKey: projectKey,
            onSetHasSeenEmptyStatePulse: onSetHasSeenEmptyStatePulse
        })));
    }));
};

});
parcelRegister("h5J4D", function(module, exports) {

$parcel$export(module.exports, "DescriptionInlineInputTmp", () => $b31e3b4917e39157$export$1d157746ade5cabf);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $bopR4 = parcelRequire("bopR4");

var $6LCpJ = parcelRequire("6LCpJ");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");
const $b31e3b4917e39157$export$1d157746ade5cabf = (props)=>{
    const { onValidate: onValidate, onChange: onChange, value: value, issueTypeResetCount: issueTypeResetCount, messages: messages } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const validateAndFormatMessage = (newValue)=>{
        const error = onValidate(newValue);
        return error ? formatMessage(error.messageDescriptor, error.values) : '';
    };
    const renderReadView = (0, $5uXOq.useCallback)(()=>// MC-961 Data attribute used for pollinator synthetic checks in
        // https://stash.atlassian.com/projects/JSRE/repos/pollinator-synthetic-checks
        // Checks: IssueTypesConfig
        value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b31e3b4917e39157$var$TextAreaReadWrapper, {
            "data-pollinator-issue-type-description-read": true,
            "aria-hidden": true
        }, value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b31e3b4917e39157$export$a29e888df6d078ac, {
            "data-pollinator-issue-type-description-read": true
        }, formatMessage(messages.descriptionPlaceholder)), [
        value,
        formatMessage,
        messages.descriptionPlaceholder
    ]);
    const renderEditView = (0, $5uXOq.useCallback)(({ errorMessage: errorMessage, onChange: editViewOnChange, ...fieldProps })=>// MC-961 Data attribute used for pollinator synthetic checks in
        // https://stash.atlassian.com/projects/JSRE/repos/pollinator-synthetic-checks
        // Checks: IssueTypesConfig
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            content: errorMessage,
            isOpen: fieldProps.isInvalid,
            placement: "right",
            messageId: "project-settings-apps-issue-type-page-product-features.common.ui.description-inline-input-tmp.inline-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-pollinator-issue-type-description-edit": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
            ...fieldProps,
            autoFocus: true,
            rows: 1,
            onChange: (e)=>editViewOnChange(e.target.value)
        }))), []);
    const editButtonLabel = value ? `${value}- ${formatMessage(messages.editDescriptionButtonLabel)}` : formatMessage(messages.editDescriptionButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b31e3b4917e39157$export$c1638c4c027acf2d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        key: issueTypeResetCount,
        readView: renderReadView,
        editView: renderEditView,
        label: messages.label ? formatMessage(messages.label) : undefined,
        editButtonLabel: editButtonLabel,
        defaultValue: value,
        onConfirm: onChange,
        readViewFitContainerWidth: true,
        validate: validateAndFormatMessage
    }));
};
const $b31e3b4917e39157$var$minRows = 1;
const $b31e3b4917e39157$var$textAreaLineHeightFactor = 2.5;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b31e3b4917e39157$var$TextAreaReadWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1af7edf-0"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $gwIPs.gridSize) * $b31e3b4917e39157$var$textAreaLineHeightFactor * $b31e3b4917e39157$var$minRows}px`,
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"}`,
    wordBreak: 'break-word'
});
const $b31e3b4917e39157$export$a29e888df6d078ac = /*#__PURE__*/ (0, $47bDC.default)($b31e3b4917e39157$var$TextAreaReadWrapper).withConfig({
    componentId: "sc-1af7edf-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, #172B4D)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b31e3b4917e39157$var$BlockWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1af7edf-2"
})({
    /* Ensure block elements in the header have correct vertical spacing */ marginBottom: "var(--ds-space-200, 16px)"
});
const $b31e3b4917e39157$export$c1638c4c027acf2d = /*#__PURE__*/ (0, $47bDC.default)($b31e3b4917e39157$var$BlockWrapper).withConfig({
    componentId: "sc-1af7edf-3"
})({
    /* Add negative horizontal margin equal to the input padding to ensure the input text is left aligned */ marginLeft: "var(--ds-space-negative-100, -8px)",
    marginRight: "var(--ds-space-negative-100, -8px)",
    /* Offset the above negative margin to re-align the input label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    label: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    /* Inline edit has a fixed margin top of 8px that we need to override */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        marginTop: 0
    }
});

});
parcelRegister("bopR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb3572edb783a8f$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $7O4UO = parcelRequire("7O4UO");

var $efXp3 = parcelRequire("efXp3");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");

var $1PDuf = parcelRequire("1PDuf");

var $pZGLJ = parcelRequire("pZGLJ");

var $6LLMl = parcelRequire("6LLMl");
const $9fb3572edb783a8f$var$fieldStyles = null;
const $9fb3572edb783a8f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $pZGLJ.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$9fb3572edb783a8f$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LLMl.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        if ((0, $VSDnB.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PDuf.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9fb3572edb783a8f$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;

});
parcelRegister("1PDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d92d54fb10d87e$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $lLLkM = parcelRequire("lLLkM");

var $bjGSs = parcelRequire("bjGSs");

var $hl2pN = parcelRequire("hl2pN");
const $55d92d54fb10d87e$var$buttonsContainerStyles = null;
const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = null;
const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hl2pN))), {
                            ...iconProps,
                            LEGACY_size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM)))
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;

});
parcelRegister("hl2pN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9db35ecad695c835ed46bfa4bbde0dff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9f6456416d52b22$var$_react = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c9f6456416d52b22$var$_checkMark = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("f22iM")));

var $c9f6456416d52b22$var$_check = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $c9f6456416d52b22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9f6456416d52b22$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $c9f6456416d52b22$var$_react.default.createElement($c9f6456416d52b22$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $c9f6456416d52b22$var$_check.default
    }, props));
$c9f6456416d52b22$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $c9f6456416d52b22$var$_default = module.exports.default = $c9f6456416d52b22$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});



parcelRegister("pZGLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5aa752dd00081f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d5aa752dd00081f6$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;

});

parcelRegister("6LLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba9adf9a6463766$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");
const $1ba9adf9a6463766$var$readViewContainerStyles = null;
const $1ba9adf9a6463766$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $1ba9adf9a6463766$var$readViewWrapperStyles = null;
const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = null;
const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                xcss: $1ba9adf9a6463766$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;

});


parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});


parcelRegister("bg6Rm", function(module, exports) {

$parcel$export(module.exports, "FieldCategory", () => $03ed8c4eb9cba1a9$export$e3354b4104a3f598);
$parcel$export(module.exports, "FieldCategoryRoundedColumn", () => $03ed8c4eb9cba1a9$export$4ba054c8cbd1a689);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $koVbs = parcelRequire("koVbs");

var $2tk6O = parcelRequire("2tk6O");

var $dnFZH = parcelRequire("dnFZH");

var $f7b9o = parcelRequire("f7b9o");

const $03ed8c4eb9cba1a9$export$e46faf8cc0689bc4 = ({ category: category, fieldsDocumentationUrl: fieldsDocumentationUrl, whatsThisLabelIdRef: whatsThisLabelIdRef })=>{
    const { whatIsThis: whatIsThis } = category.configuration;
    if (!whatIsThis) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7b9o.WhatIsThisWithInProductHelp), {
        whatsThisLabelIdRef: whatsThisLabelIdRef,
        buttonLabel: whatIsThis.buttonLabel,
        description: whatIsThis.content,
        linkToDocumentationText: whatIsThis.linkToDocumentationText,
        itemDocumentationUrl: fieldsDocumentationUrl,
        linkToInProductHelpArticleId: whatIsThis.linkToInProductHelpArticleId
    });
};
const $03ed8c4eb9cba1a9$export$e3354b4104a3f598 = ({ children: children, categoryIndex: categoryIndex, category: category, hasMarginTop: hasMarginTop = true, fieldsDocumentationUrl: fieldsDocumentationUrl })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const BeforeItems = category.configuration.renderBeforeItems;
    const id = `${category.configuration.name}-category-field-section-list`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ed8c4eb9cba1a9$var$RoundedColumnNew, {
        "aria-label": formatMessage(category.configuration.displayName),
        tabIndex: 0,
        id: id,
        removeSpaceAbove: !!category.configuration.dividerText
    }, category.configuration.dividerText && categoryIndex !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dnFZH.Divider), {
        name: category.configuration.name,
        dividerText: category.configuration.dividerText
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ed8c4eb9cba1a9$export$484c5779653232cc, {
        hasMarginTop: hasMarginTop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ed8c4eb9cba1a9$export$f99233281efd08a0, null, formatMessage(category.configuration.displayName)), $03ed8c4eb9cba1a9$export$e46faf8cc0689bc4({
        category: category,
        fieldsDocumentationUrl: fieldsDocumentationUrl,
        formatMessage: formatMessage,
        whatsThisLabelIdRef: id
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, BeforeItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BeforeItems, null) : null, children));
};
const $03ed8c4eb9cba1a9$var$RoundedColumnNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { removeSpaceAbove: removeSpaceAbove, enableFullSizeDropZone: enableFullSizeDropZone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_dvyroe": (0, $lD23V.default)(`${__cmplp.removeSpaceAbove ? "var(--ds-space-negative-250, -20px)" : "var(--ds-space-0, 0px)"} ${"var(--ds-space-negative-100, -8px)"} ${"var(--ds-space-200, 16px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _18s8y17o _ca0qze3t _u5f3u2gc _n3tdze3t _19bvu2gc",
            __cmplp.enableFullSizeDropZone ? "_4t3inau3" : "_4t3i1wug",
            __cmplp.enableFullSizeDropZone ? "_vchhusvi" : "_vchh18uv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03ed8c4eb9cba1a9$export$484c5779653232cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasMarginTop: hasMarginTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_mif3oh": (0, $lD23V.default)(`${__cmplp.hasMarginTop ? "var(--ds-space-150, 12px)" : "var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1yt41p6o _1e0c1txw _2lx2vrvc _1n261q9c _1bah1y6m _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $03ed8c4eb9cba1a9$export$4ba054c8cbd1a689 = /*#__PURE__*/ (0, $47bDC.default)((0, $2tk6O.Column)).withConfig({
    componentId: "sc-1s5dgra-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        borderRadius: "var(--ds-space-050, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: props.removeSpaceAbove ? "var(--ds-space-negative-250, -20px)" : "var(--ds-space-0, 0px)",
        marginBottom: "var(--ds-space-200, 16px)",
        /* According to the flexbox spec, flex items should not shrink below there min-content size. But Safari does not
        respect this behaviour when the item is display flex, hence flex-shrink: 0. */ flexShrink: 0
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ enableFullSizeDropZone: enableFullSizeDropZone })=>enableFullSizeDropZone ? /* height: 100 - 16px is to leave a gap at the bottom to be consistent with the sides */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        height: `calc(100% - ${"var(--ds-space-200, 16px)"})`,
        boxSizing: 'border-box'
    }) : ''); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03ed8c4eb9cba1a9$var$TitleBase = /*#__PURE__*/ (0, $47bDC.default).h2.withConfig({
    componentId: "sc-1s5dgra-1"
})({
    /* Use a line height which matches the board's column titles. */ // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-300, 24px)",
    /* Shrink when there is not enough space inline */ minWidth: "var(--ds-space-0, 0px)",
    flexShrink: 1,
    /* Hiding overflow to prevent scrollbars from showing up for Windows fonts (see MC-2533) */ overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $03ed8c4eb9cba1a9$export$f99233281efd08a0 = /*#__PURE__*/ (0, $47bDC.default)($03ed8c4eb9cba1a9$var$TitleBase).withConfig({
    componentId: "sc-1s5dgra-2"
})`font:${"var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};`; // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

});
parcelRegister("dnFZH", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $68e1c4d6bfb0ee85$export$2e0a83ec2e27ecbb);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $2Zxiy = parcelRequire("2Zxiy");

var $aWse0 = parcelRequire("aWse0");

var $4SBL6 = parcelRequire("4SBL6");
const $68e1c4d6bfb0ee85$var$getDividerDroppableId = (category)=>`${category}-active-category-droppable-id-divider`;
const $68e1c4d6bfb0ee85$export$2e0a83ec2e27ecbb = ({ name: name, dividerText: dividerText })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Droppable), {
        droppableId: $68e1c4d6bfb0ee85$var$getDividerDroppableId(name),
        isDropDisabled: true
    }, (dropProvided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: dropProvided.innerRef,
            ...dropProvided.droppableProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Draggable), {
            draggableId: name,
            index: 0
        }, (provided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68e1c4d6bfb0ee85$var$DividerContainer, {
                innerRef: provided.innerRef,
                ...provided.draggableProps,
                ...provided.dragHandleProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68e1c4d6bfb0ee85$var$DividerLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68e1c4d6bfb0ee85$var$DividerMessage, null, dividerText ? formatMessage(dividerText) : (0, $4SBL6.SHOW_NO_MESSAGE)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68e1c4d6bfb0ee85$var$DividerLine, null))), dropProvided.placeholder));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68e1c4d6bfb0ee85$var$DividerLine = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kj3gyl-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `2px dashed ${"var(--ds-border, #091E4224)"}`,
    flexGrow: 1,
    opacity: 0.6
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68e1c4d6bfb0ee85$var$DividerMessage = /*#__PURE__*/ (0, $47bDC.default).strong.withConfig({
    componentId: "kj3gyl-1"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text-subtlest, #626F86)"};margin-top:0;padding:${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"};opacity:0.8;`;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68e1c4d6bfb0ee85$var$DividerContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kj3gyl-2"
})`align-items:center;display:flex;flex-direction:row;flex-grow:1;justify-content:center;padding:${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"};&:hover,&:active{${$68e1c4d6bfb0ee85$var$DividerLine},${$68e1c4d6bfb0ee85$var$DividerMessage}{opacity:1;}}`;

});

parcelRegister("f7b9o", function(module, exports) {

$parcel$export(module.exports, "WhatIsThisWithInProductHelp", () => $7373ab5a365abd47$export$7b1647cb99ab2356);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $6tRzQ = parcelRequire("6tRzQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $jgJNO = parcelRequire("jgJNO");

var $gt8X2 = parcelRequire("gt8X2");
const $7373ab5a365abd47$export$7b1647cb99ab2356 = (props)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const buttonRef = (0, $5uXOq.useRef)(null);
    const buttonId = `${props.whatsThisLabelIdRef}-what-is-this-button`;
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        // we need to focus the button so that pressing ESC will close the popup
        if (buttonRef.current !== undefined && buttonRef.current !== null) buttonRef.current.focus();
        setIsOpen(!isOpen);
    }, [
        buttonRef,
        setIsOpen,
        isOpen
    ]);
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { itemDocumentationUrl: itemDocumentationUrl, linkToDocumentationText: linkToDocumentationText, linkToInProductHelpArticleId: linkToInProductHelpArticleId, description: description, buttonLabel: buttonLabel } = props;
    const isInValidLink = (url)=>url === undefined || url == null || url === '';
    const linkToItemDocumentation = (0, $5uXOq.useMemo)(()=>{
        if (isInValidLink(itemDocumentationUrl) || linkToDocumentationText === undefined) return null;
        const documentationLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: itemDocumentationUrl,
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage(linkToDocumentationText));
        if (linkToInProductHelpArticleId === undefined) return documentationLink;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gt8X2.IPHLink), {
            articleId: linkToInProductHelpArticleId,
            linkText: linkToDocumentationText,
            documentationUrl: itemDocumentationUrl
        });
    }, [
        itemDocumentationUrl,
        linkToDocumentationText,
        linkToInProductHelpArticleId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7373ab5a365abd47$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "right",
        messageId: "project-settings-apps-issue-type-page-product-features.common.ui.field-category.what-is-this-with-in-product-help.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $7373ab5a365abd47$var$contentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7373ab5a365abd47$var$WhatIsThisContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7373ab5a365abd47$var$CategoryInfoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...description,
                values: {
                    learnMoreLink: linkToItemDocumentation,
                    br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
                }
            })))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle",
                isSelected: isOpen,
                id: buttonId,
                onClick: onToggle,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: ""
                }),
                "aria-labelledby": `${buttonId} ${props.whatsThisLabelIdRef}`,
                "aria-label": formatMessage(buttonLabel),
                ...triggerProps
            })
    }));
};
// We want to allow translated messages to be broken up across multiple lines
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7373ab5a365abd47$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7373ab5a365abd47$var$CategoryInfoContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1mo5int-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 36.25}px`,
    '@media (max-width: 1120px)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${(0, $gwIPs.gridSize) * 31}px`
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7373ab5a365abd47$var$WhatIsThisContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f12aa",
            __cmplp.className
        ])
    });
});
const $7373ab5a365abd47$var$contentStyles = (0, $8CUq3.xcss)({
    padding: 'space.200'
});

});
parcelRegister("gt8X2", function(module, exports) {

$parcel$export(module.exports, "IPHLink", () => $a3cb948dcf7cd24f$export$8ca4cba792159c15);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $e4yMr = parcelRequire("e4yMr");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $a3cb948dcf7cd24f$export$8ca4cba792159c15 = (props)=>{
    const { articleId: articleId, linkText: linkText, analyticsOptions: analyticsOptions, documentationUrl: documentationUrl } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onOpenInProductHelpArticle = (0, $5Zxxp.useHelpPanelLink)();
    const handleClick = (clickType)=>(e)=>{
            const modifiersPressed = e && Boolean(e.shiftKey || e.metaKey || e.ctrlKey);
            const shouldOpenLinkInIph = // on primary button click
            clickType === 'primary' && // no modifier buttons have been pressed
            !modifiersPressed;
            // if documentationUrl is missing, fallback to IPH always
            if (shouldOpenLinkInIph || !documentationUrl) {
                onOpenInProductHelpArticle(articleId);
                // prevent the link from opening as usual
                e.preventDefault();
            }
            const actionSubjectId = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(linkText.defaultMessage);
            const analyticsAttributes = {
                clickType: clickType,
                actionSubjectId: actionSubjectId,
                articleId: articleId,
                modifiersPressed: modifiersPressed
            };
            if (analyticsOptions) {
                const event = createAnalyticsEvent(analyticsOptions.event);
                (0, $8zOmE.fireUIAnalytics)(event, analyticsOptions.actionSubjectId, {
                    ...analyticsAttributes,
                    actionSubjectId: actionSubjectId
                });
            } else {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'IPH link'
                });
                const uiAnalytics = 'helpLink clicked';
                (0, $8zOmE.fireUIAnalytics)(event, uiAnalytics, actionSubjectId, analyticsAttributes);
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: documentationUrl ?? '',
        target: "_blank",
        onContextMenu: handleClick('context'),
        onClick: handleClick('primary'),
        onAuxClick: handleClick('aux')
    }, formatMessage(linkText));
};

});
parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");

var $6s1PB = parcelRequire("6s1PB");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $6s1PB.expVal)('m1_features_page_experiment', 'cohort', 'not-enrolled') === 'variation' ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $6s1PB.expVal)('m1_features_page_experiment', 'cohort', 'not-enrolled') === 'variation' && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
const $b0d1b3c2fea05784$var$buttonWrapperSubtleStyles = null;

});
parcelRegister("6BNJk", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $20386d7da4313ff0$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $20386d7da4313ff0$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $20386d7da4313ff0$export$23aa6670f346c214);

var $gwIPs = parcelRequire("gwIPs");
const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
const $20386d7da4313ff0$export$23aa6670f346c214 = (0, $gwIPs.gridSize) * 46;

});

parcelRegister("kspz4", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $aee6103177ce0723$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $aee6103177ce0723$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $jgGDm = parcelRequire("jgGDm");
const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $3sQ5x.createHook)((0, $jgGDm.default));
const $aee6103177ce0723$export$c61f56f4797e22db = (0, $3sQ5x.createHook)((0, $jgGDm.default), {
    selector: null
});
const $aee6103177ce0723$export$513717a84f55db1a = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelSubscriber'
});
const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("jgGDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465615692863cce9$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $iXqE5 = parcelRequire("iXqE5");

var $958ua = parcelRequire("958ua");
let $465615692863cce9$var$iphStorage;
const $465615692863cce9$var$createStorage = ()=>{
    if ($465615692863cce9$var$iphStorage) return $465615692863cce9$var$iphStorage;
    $465615692863cce9$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
    return $465615692863cce9$var$iphStorage;
};
const $465615692863cce9$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $465615692863cce9$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $465615692863cce9$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'help-panel',
    initialState: $465615692863cce9$var$initialState,
    actions: $958ua
});

});
parcelRegister("958ua", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $177ac56c5a5bf49e$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $177ac56c5a5bf49e$export$cdabe01d01a8da1e);

var $eNf8a = parcelRequire("eNf8a");
const $177ac56c5a5bf49e$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $177ac56c5a5bf49e$var$iphStorage.set('history', []);
    };
const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("hsmeR", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $39a48ee662f10943$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $39a48ee662f10943$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $39a48ee662f10943$export$ebe5e907fb0bb63a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $byk51 = parcelRequire("byk51");

var $5e5zm = parcelRequire("5e5zm");
const $39a48ee662f10943$var$useActiveRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $byk51.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
    return rightSidebar;
};
const $39a48ee662f10943$var$useRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
    return rightSidebarState;
};
const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $5e5zm.useLayoutStoreActions)();
    return (0, $5uXOq.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});





parcelRegister("5uaGm", function(module, exports) {

$parcel$export(module.exports, "FormPanelWithErrorBoundary", () => $0bd0cfaf73b3858b$export$fa0e4e8ec9c3b8a1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $42CjB = parcelRequire("42CjB");

var $bU3PY = parcelRequire("bU3PY");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $7CP12 = parcelRequire("7CP12");

var $1FnF2 = parcelRequire("1FnF2");

var $jCesz = parcelRequire("jCesz");

var $4R6GH = parcelRequire("4R6GH");

var $6hGCq = parcelRequire("6hGCq");

var $5wvQR = parcelRequire("5wvQR");

var $9Yw1p = parcelRequire("9Yw1p");

var $1V7UD = parcelRequire("1V7UD");

var $kqnEs = parcelRequire("kqnEs");

var $lQAYg = parcelRequire("lQAYg");

var $7O80d = parcelRequire("7O80d");

var $91c3S = parcelRequire("91c3S");
// FormSecurityWarningIcon can be replaced with a platform component for consistency with warning
// icons used in the proforma-form-builder.
const $0bd0cfaf73b3858b$var$FormSecurityWarningIcon = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
    const oldIconLabel = (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage((0, $91c3S.messages).formSecurityWithIssueSecurityWarningLabelIssueTermRefresh) : formatMessage((0, $91c3S.messages).formSecurityWithIssueSecurityWarningLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: "bottom-end",
        messageId: "project-settings-product-features-jsm-common.ui.form-panel.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                padding: "space.200",
                xcss: $0bd0cfaf73b3858b$var$warningPopupContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $91c3S.messages).formSecurityWithIssueSecurityWarningDescriptionIssueTermRefresh : (0, $91c3S.messages).formSecurityWithIssueSecurityWarningDescription)),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                        ...iconProps,
                        color: isPopupOpen ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-warning, #E56910)"
                    }),
                isSelected: isPopupOpen,
                onClick: ()=>setIsPopupOpen(!isPopupOpen),
                label: (0, $4R6GH.fg)('granular_permissions_on_forms_ga') ? formatMessage((0, $91c3S.messages).formSecurityAndIssueSecurityWarningLabel) : oldIconLabel,
                appearance: "subtle",
                spacing: "compact"
            })
    });
};
const $0bd0cfaf73b3858b$var$ProformaFormHeaderOld = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bd0cfaf73b3858b$var$Line, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0bd0cfaf73b3858b$var$sectionSpacingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, formatMessage((0, $91c3S.messages).attachedFormLabel))));
};
const $0bd0cfaf73b3858b$var$ProformaFormHeader = ({ requestTypeId: requestTypeId, formRestrictionStatus: formRestrictionStatus })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [requestType] = (0, $6hGCq.useTicketTypeStore)(requestTypeId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bd0cfaf73b3858b$var$Line, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0bd0cfaf73b3858b$var$sectionSpacingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.025",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, formatMessage((0, $91c3S.messages).attachedFormLabel)), requestType?.issueSecurityStatus === 'ACTIVE' && formRestrictionStatus === (0, $5wvQR.FormRestrictionStatus).RESTRICTED && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bd0cfaf73b3858b$var$FormSecurityWarningIcon, null))));
};
const $0bd0cfaf73b3858b$export$55230923d5e81d01 = (props)=>{
    const { category: category, projectKey: projectKey, onSetHasSeenEmptyStatePulse: onSetHasSeenEmptyStatePulse, autoExpandFormCard: autoExpandFormCard = false } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { forms: forms, isLoading: isLoading, error: error } = (0, $7CP12.useProformaProjectFormsOnMount)();
    const shouldShowFormEmptyState = (0, $6s1PB.expValEquals)('rtc_form_empty_state_to_all_user', 'cohort', 'experiment') ? !isLoading && !error : forms.length > 0;
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $6s1PB.expVal)('rtc_form_empty_state_to_all_user', 'cohort', 'not-enrolled') !== 'not-enrolled') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'statsigExperiment exposed', 'rtc_form_empty_state_to_all_user');
    }, [
        createAnalyticsEvent
    ]);
    const [isNewTemplateFormCreated, setIsNewTemplateFormCreated] = (0, $5uXOq.useState)(false);
    const proformaStore = (0, $5uXOq.useContext)((0, $9Yw1p.ProformaStoreContext));
    const [proformaState, setProformaState] = (0, $5uXOq.useState)();
    const [proformaConfig, setProformaConfig] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = proformaStore ? proformaStore.subscribe(()=>{
            const state = proformaStore.getState();
            setProformaState(state);
            const config = (0, $lQAYg.getProformaRequestTypeFormCardConfig)(state);
            setProformaConfig(config);
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))); // for initial fetch - if the store's state is loaded after component mount, this will ensure it receives the current state on mount.
        if (proformaStore && !proformaState && !proformaConfig) {
            const state = proformaStore.getState();
            setProformaState(state);
            const config = (0, $lQAYg.getProformaRequestTypeFormCardConfig)(state);
            setProformaConfig(config);
        } // Clean up the subscription
        return ()=>{
            unsubscribe();
        };
    }, [
        proformaConfig,
        proformaState,
        proformaStore
    ]);
    const onRemoveFormExample = (requestTypeId)=>{
        proformaStore?.dispatch((0, $kqnEs.markProformaReqTypeFormForRemoval)(requestTypeId));
    };
    const onAddFormExample = async (optimisticForm)=>{
        if (proformaStore) (0, $1V7UD.setSelectedForm)(proformaStore, optimisticForm.value);
    };
    if (proformaState && (0, $lQAYg.isProformaReqTypeConfigLoading)(proformaState)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, proformaConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('granular_permissions_on_forms_m1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bd0cfaf73b3858b$var$ProformaFormHeader, {
        requestTypeId: proformaConfig.requestTypeId,
        formRestrictionStatus: proformaConfig.restrictionStatus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bd0cfaf73b3858b$var$ProformaFormHeaderOld, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O80d.FormCard), {
        config: proformaConfig,
        onRemoveFormFromReqType: onRemoveFormExample,
        category: category,
        projectKey: projectKey,
        autoExpand: autoExpandFormCard
    })), !proformaConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowFormEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bd0cfaf73b3858b$var$Line, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FnF2.AsyncFormEmptyState), {
        onTemplateFormCreated: ()=>{
            setIsNewTemplateFormCreated(true);
        },
        onAdd: onAddFormExample,
        onPulseShown: onSetHasSeenEmptyStatePulse,
        hasTemplateForms: isNewTemplateFormCreated || forms.length > 0
    })), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null), !!error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bd0cfaf73b3858b$var$Line, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jCesz.FormsNotLoadedError), null))));
};
const $0bd0cfaf73b3858b$export$fa0e4e8ec9c3b8a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsm-proforma-form-panel",
        packageName: "jiraProjectSettingsProductFeaturesJsmCommon",
        teamName: "jsm-request-intake",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bd0cfaf73b3858b$export$55230923d5e81d01, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bd0cfaf73b3858b$var$Line = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlzgxb",
            __cmplp.className
        ])
    });
});
const $0bd0cfaf73b3858b$var$sectionSpacingStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});
const $0bd0cfaf73b3858b$var$warningPopupContentStyles = (0, $8CUq3.xcss)({
    maxWidth: '200px'
});

});
parcelRegister("7CP12", function(module, exports) {

$parcel$export(module.exports, "useFetchProformaProjectForms", () => $806e73c654ecf72e$export$2f5ac38471dcb354);
$parcel$export(module.exports, "useProformaProjectFormsOnMount", () => $806e73c654ecf72e$export$25e9c54a22629d92);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $dAfqg = parcelRequire("dAfqg");

var $koeKL = parcelRequire("koeKL");

const $806e73c654ecf72e$export$2f5ac38471dcb354 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectId = data?.projectId ?? undefined;
    const cloudId = (0, $koeKL.useCloudId)();
    return (0, $5uXOq.useCallback)(()=>(0, $eusud.performGetRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/1/projects/${projectId}/forms`), [
        cloudId,
        projectId
    ]);
};
const $806e73c654ecf72e$export$25e9c54a22629d92 = ()=>{
    const [forms, setForms] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectId = data?.projectId ?? undefined;
    const fetchProformaProjectForms = $806e73c654ecf72e$export$2f5ac38471dcb354();
    const fetchForms = (0, $5uXOq.useCallback)(async ()=>{
        setError(null);
        setIsLoading(true);
        try {
            const projectForms = await fetchProformaProjectForms();
            setForms(projectForms);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (exception) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'getProformaReqTypeProjectForms',
                    packageName: $26bfa12f59001b80$export$9345d7360ffe0722,
                    teamName: $26bfa12f59001b80$export$9f98a8d796affec6
                },
                error: exception,
                attributes: {
                    projectId: projectId
                }
            });
            setError(exception);
        } finally{
            setIsLoading(false);
        }
    }, [
        projectId,
        fetchProformaProjectForms
    ]);
    // Fetch forms once on mount
    (0, $5uXOq.useEffect)(()=>{
        fetchForms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        forms: forms,
        isLoading: isLoading,
        error: error
    };
};

});

parcelRegister("1FnF2", function(module, exports) {

$parcel$export(module.exports, "AsyncFormEmptyState", () => $1b9ce593e1428dfa$export$f889f39eae8b8330);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b9ce593e1428dfa$var$FormEmptyState = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("jCesz"))).then((exportedModule)=>exportedModule.FormEmptyState), {
    moduleId: "./src/packages/proforma/request-type-config/src/ui/form-empty-state/index.tsx"
});
const $1b9ce593e1428dfa$export$f889f39eae8b8330 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "ProformaRTCFormEmptyStateWrapper",
        packageName: (0, $26bfa12f59001b80$export$9345d7360ffe0722),
        teamName: (0, $26bfa12f59001b80$export$9f98a8d796affec6)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        name: "form-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1b9ce593e1428dfa$var$FormEmptyState, props)));

});
parcelRegister("jCesz", function(module, exports) {

$parcel$export(module.exports, "FormsNotLoadedError", () => $12897861d70ab0e6$export$f34fd7c3da3b1714);
$parcel$export(module.exports, "FormEmptyState", () => $12897861d70ab0e6$export$2338b304e76d30d7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cC9Cp = parcelRequire("cC9Cp");

var $5bpEQ = parcelRequire("5bpEQ");

var $5QsHM = parcelRequire("5QsHM");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $6jvUj = parcelRequire("6jvUj");

var $av6gl = parcelRequire("av6gl");
var $2sdeO = parcelRequire("2sdeO");

var $aW3TH = parcelRequire("aW3TH");

var $bV8dQ = parcelRequire("bV8dQ");

var $4R6GH = parcelRequire("4R6GH");

var $5wvQR = parcelRequire("5wvQR");


var $7CP12 = parcelRequire("7CP12");


var $d8fKE = parcelRequire("d8fKE");

var $7N8g9 = parcelRequire("7N8g9");

var $4zqHM = parcelRequire("4zqHM");
const $12897861d70ab0e6$var$PROFORMA_RTC_EMPTY_STATE_CHANGEBOARDING_USER_PROPERTY_KEY = 'proforma-rtc-empty-state-changeboarding-seen-status';
const $12897861d70ab0e6$var$FormSelector = ({ onCancel: onCancel, onAdd: onAdd })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fetchProformaProjectForms = (0, $7CP12.useFetchProformaProjectForms)();
    const { locale: locale } = (0, $koVbs.default)();
    const environment = (0, $2tT7R.useEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { errorUtils: errorUtils } = (0, $5uXOq.useMemo)(()=>{
        const proformaEnvironment = (0, $cC9Cp.toProformaEnvironment)(environment);
        const { api: apiUrl, jira: jiraUrl } = (0, $5bpEQ.getUrls)(proformaEnvironment, cloudId);
        return (0, $6jvUj.createUtils2)(jiraUrl, apiUrl, proformaEnvironment, 'RtcFormEmptyState', ()=>()=>undefined, createAnalyticsEvent, locale);
    }, [
        cloudId,
        createAnalyticsEvent,
        environment,
        locale
    ]);
    const loadFormsApi = (0, $5uXOq.useMemo)(()=>({
            loadForms: async ()=>{
                const projectForms = await fetchProformaProjectForms();
                return {
                    recommended: [],
                    available: projectForms.map(({ id: id, name: name, restrictionStatus: restrictionStatus })=>({
                            label: name,
                            value: id,
                            ...(0, $4R6GH.fg)('granular_permissions_on_forms_m1') && {
                                restrictionStatus: restrictionStatus ?? (0, $5wvQR.FormRestrictionStatus).OPEN
                            }
                        }))
                };
            }
        }), [
        fetchProformaProjectForms
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2sdeO.AddFormStoreContainer), {
        api: loadFormsApi,
        errorUtils: errorUtils
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $av6gl.AddForm), {
        onCancel: onCancel,
        onAdd: onAdd
    }));
};
const $12897861d70ab0e6$export$f34fd7c3da3b1714 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$Margin, {
        "data-testid": "proforma-request-type-config.ui.form-empty-state.forms-not-loaded-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$ContentColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage((0, $7N8g9.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $7N8g9.default).formsNotLoadedError))))));
};
const $12897861d70ab0e6$var$FormEmptyStateInternal = ({ onAdd: onAdd, onPulseShown: onPulseShown, onTemplateFormCreated: onTemplateFormCreated, hasTemplateForms: hasTemplateForms })=>{
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: $12897861d70ab0e6$var$PROFORMA_RTC_EMPTY_STATE_CHANGEBOARDING_USER_PROPERTY_KEY,
        isSeenValue: true,
        packageName: $26bfa12f59001b80$export$9345d7360ffe0722,
        teamName: $26bfa12f59001b80$export$9f98a8d796affec6
    });
    const [canShowPulse, setCanShowPulse] = (0, $5uXOq.useState)(true);
    const shouldShowPulse = canShowPulse && !hasSeenSpotlight;
    const shouldShowSpotlight = !canShowPulse && !hasSeenSpotlight;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isSelectorDisplayed, setIsSelectorDisplayed] = (0, $5uXOq.useState)(false);
    const [isAttachFormDropdownOpen, setIsAttachFormDropdownOpen] = (0, $5uXOq.useState)(false);
    const { setIsTemplateLibraryOpen: setIsTemplateLibraryOpen } = (0, $aW3TH.useTemplateLibraryActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowPulse) onPulseShown();
    }, [
        onPulseShown,
        shouldShowPulse
    ]);
    const withSpotlight = (onAcknowledgeSpotlight)=>()=>{
            if (shouldShowPulse) {
                setCanShowPulse(false);
                return;
            }
            if (shouldShowSpotlight) markSpotlightAsSeen();
            onAcknowledgeSpotlight();
        };
    const onAddFormClick = withSpotlight(()=>{
        setIsSelectorDisplayed(true);
    });
    const openAttachFormDropdown = withSpotlight(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'attachFormDropdown');
        setIsAttachFormDropdownOpen(true);
    });
    const onAttachFormButtonClick = withSpotlight(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'attachFormButton');
        setIsTemplateLibraryOpen(true);
    });
    const onCreateFromTemplateDropdownItemClick = withSpotlight(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createFromTemplateDropdownItem');
        setIsTemplateLibraryOpen(true);
    });
    const onSelectFormDropdownItemClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'selectExistingFormDropdownItem');
        setIsSelectorDisplayed(true);
    };
    const onCancelAddForm = ()=>{
        setIsSelectorDisplayed(false);
    };
    const onAttachFormDropDownOpenChange = (openChangeArgs)=>{
        openChangeArgs.isOpen ? openAttachFormDropdown() : setIsAttachFormDropdownOpen(false);
    };
    const onAddSelectedForm = (form)=>{
        onAdd(form);
    };
    const onFormCreated = (createdForm)=>{
        setIsTemplateLibraryOpen(false);
        onTemplateFormCreated();
        onAdd({
            label: createdForm.formName,
            value: createdForm.formId
        });
    };
    (0, $5uXOq.useEffect)(()=>()=>markSpotlightAsSeen(), [
        markSpotlightAsSeen
    ]);
    let attachFormButton;
    let onAcknowledgeSpotlight;
    let instructionMsg;
    if ((0, $6s1PB.expValEquals)('rtc_form_empty_state_to_all_user', 'cohort', 'experiment')) {
        if (hasTemplateForms) {
            instructionMsg = formatMessage((0, $7N8g9.default).searchAndCreateFormDescription);
            onAcknowledgeSpotlight = openAttachFormDropdown;
            attachFormButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
                trigger: formatMessage((0, $7N8g9.default).attachFormButton),
                isOpen: isAttachFormDropdownOpen,
                onOpenChange: onAttachFormDropDownOpenChange
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                onClick: onSelectFormDropdownItemClick
            }, formatMessage((0, $7N8g9.default).selectExistingFormButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                onClick: onCreateFromTemplateDropdownItemClick
            }, formatMessage((0, $7N8g9.default).createFromTemplateButton))));
        } else {
            instructionMsg = formatMessage((0, $7N8g9.default).createFormDescription);
            onAcknowledgeSpotlight = onAttachFormButtonClick;
            attachFormButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                onClick: onAttachFormButtonClick
            }, formatMessage((0, $7N8g9.default).attachFormButton));
        }
    } else {
        instructionMsg = formatMessage((0, $7N8g9.default).subtitle);
        onAcknowledgeSpotlight = onAddFormClick;
        attachFormButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: onAddFormClick
        }, formatMessage((0, $7N8g9.default).addFormButton));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$Margin, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "proformaRtcFormEmptyState",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $e1c6b645992f9e3f$export$3c389bd4d38f57a0)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$Card, null, isSelectorDisplayed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bV8dQ.AnalyticsProvider), {
        channel: (0, $5bpEQ.ANALYTICS_CHANNEL)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$ContentColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage((0, $7N8g9.default).title)), (0, $6s1PB.expValEquals)('rtc_form_empty_state_to_all_user', 'cohort', 'experiment') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small"
    }, formatMessage((0, $7N8g9.default).subtitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $12897861d70ab0e6$var$formSelectorWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$FormSelector, {
        onCancel: onCancelAddForm,
        onAdd: onAddSelectedForm
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$EmptyStateRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$ContentColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage((0, $7N8g9.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small"
    }, instructionMsg)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$SpotlightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: shouldShowPulse
    }, attachFormButton))), (0, $6s1PB.expValEquals)('rtc_form_empty_state_to_all_user', 'cohort', 'experiment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zqHM.ProformaFormTemplateLibrary), {
        onFormCreated: onFormCreated
    }))), shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d8fKE.ChangeboardingSpotlight), {
        onAcknowledge: onAcknowledgeSpotlight
    }))));
};
const $12897861d70ab0e6$export$2338b304e76d30d7 = (props)=>(0, $6s1PB.expValEquals)('rtc_form_empty_state_to_all_user', 'cohort', 'experiment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aW3TH.TemplateLibraryContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$FormEmptyStateInternal, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12897861d70ab0e6$var$FormEmptyStateInternal, props); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12897861d70ab0e6$var$Margin = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _19pkutpp _otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12897861d70ab0e6$var$Card = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1bsb1osq _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _vchhusvi _16qs1uzo _bfhk1j9a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12897861d70ab0e6$var$EmptyStateRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12897861d70ab0e6$var$ContentColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12897861d70ab0e6$var$SpotlightWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswpfqs",
            __cmplp.className
        ])
    });
});
const $12897861d70ab0e6$var$formSelectorWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("cC9Cp", function(module, exports) {

$parcel$export(module.exports, "toProformaEnvironment", () => $498398f11ffa02f4$export$81a9ecf6b01a04d4);

var $fxMku = parcelRequire("fxMku");
const $498398f11ffa02f4$export$81a9ecf6b01a04d4 = (environment)=>{
    switch(environment){
        case 'dev':
            return (0, $fxMku.Environment).DEVELOPMENT;
        case 'staging':
            return (0, $fxMku.Environment).STAGING;
        case 'prod':
            return (0, $fxMku.Environment).PRODUCTION;
        case 'local':
        default:
            return (0, $fxMku.Environment).LOCAL;
    }
};

});
parcelRegister("fxMku", function(module, exports) {

$parcel$export(module.exports, "Environment", () => $b50f6d5564bbfb55$export$7dc6752a22ab011a);
let $b50f6d5564bbfb55$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["PRODUCTION"] = "prod";
    Environment["STAGING"] = "staging";
    Environment["DEVELOPMENT"] = "dev";
    Environment["LOCAL"] = "local";
    return Environment;
}({});

});


parcelRegister("5bpEQ", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $1cd284857d4cae3e$export$85183a312807388d);
$parcel$export(module.exports, "getUrls", () => $1cd284857d4cae3e$export$c69765bbdb1543ad);





const $1cd284857d4cae3e$export$85183a312807388d = 'productAnalytics';
const $1cd284857d4cae3e$export$c69765bbdb1543ad = (environment, cloudId)=>({
        api: `/gateway/api/proforma/cloudid/${cloudId}`,
        jira: '',
        templatesService: environment === 'prod' ? 'https://proforma-templates.services.atlassian.com' : 'https://proforma-templates.stg.services.atlassian.com',
        analyticsService: environment === 'prod' ? 'https://proforma-analytics.services.atlassian.com' : 'https://proforma-analytics.stg.services.atlassian.com'
    });

});

parcelRegister("6jvUj", function(module, exports) {

$parcel$export(module.exports, "createErrorUtils", () => $498d4489c00ccef2$export$7a2f0d878b08650d);
$parcel$export(module.exports, "createUtils", () => $498d4489c00ccef2$export$b6881d4b4863cacc);
$parcel$export(module.exports, "createUtils2", () => $498d4489c00ccef2$export$e4e37e88de17afb6);

var $a1RLT = parcelRequire("a1RLT");

var $j93Fo = parcelRequire("j93Fo");

var $gFGsm = parcelRequire("gFGsm");
function $498d4489c00ccef2$export$7a2f0d878b08650d(errorUtilsModuleName, environment, createAnalyticsEvent, showFlag = ()=>()=>{}) {
    return new (0, $gFGsm.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
}
function $498d4489c00ccef2$export$b6881d4b4863cacc(settings, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
    const errorUtils = new (0, $gFGsm.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, settings.environment);
    (0, $j93Fo.setNoticeLocale)(locale);
    const apiUtil = new (0, $a1RLT.ApiUtil)(settings.urls.jira, settings.urls.api, errorUtils, createAnalyticsEvent);
    return {
        apiUtil: apiUtil,
        errorUtils: errorUtils
    };
}
function $498d4489c00ccef2$export$e4e37e88de17afb6(jiraUrl, apiUrl, environment, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
    const errorUtils = new (0, $gFGsm.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
    (0, $j93Fo.setNoticeLocale)(locale);
    const apiUtil = new (0, $a1RLT.ApiUtil)(jiraUrl, apiUrl, errorUtils, createAnalyticsEvent);
    return {
        apiUtil: apiUtil,
        errorUtils: errorUtils
    };
}

});
parcelRegister("a1RLT", function(module, exports) {

$parcel$export(module.exports, "AcceptedResponseType", () => $74d3b548944c3270$export$9126c50ecfe2a46d);
$parcel$export(module.exports, "ApiUtil", () => $74d3b548944c3270$export$baa861b25a2283a4);

var $kCVub = parcelRequire("kCVub");

var $erWXD = parcelRequire("erWXD");

var $bRqoO = parcelRequire("bRqoO");

var $caW8j = parcelRequire("caW8j");
let $74d3b548944c3270$export$9126c50ecfe2a46d = /*#__PURE__*/ function(AcceptedResponseType) {
    AcceptedResponseType["Json"] = "json";
    AcceptedResponseType["Blob"] = "blob";
    return AcceptedResponseType;
}({});
class $74d3b548944c3270$export$baa861b25a2283a4 {
    constructor(jiraUrl, proformaUrl, errorUtils, createAnalyticsEvent){
        this.errorUtils = void 0;
        this.jiraUrl = void 0;
        this.proformaUrl = void 0;
        this.createAnalyticsEvent = void 0;
        this.jiraUrl = jiraUrl;
        this.proformaUrl = proformaUrl;
        this.errorUtils = errorUtils;
        this.createAnalyticsEvent = createAnalyticsEvent;
    }
    get(path, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'GET', path, responseType, requestName);
    }
    jiraGet(path, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'GET', path, responseType, requestName);
    }
    put(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'PUT', path, responseType, requestName, body);
    }
    jiraPut(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'PUT', path, responseType, requestName, body);
    }
    post(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'POST', path, responseType, requestName, body);
    }
    jiraPost(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'POST', path, responseType, requestName, body);
    }
    delete(path, body, requestName, responseType = 'none') {
        return this.fetchApi(true, 'DELETE', path, responseType, requestName, body);
    }
    /** Converts the `relativePath` into an absolute ProForma API URI. */ createApiUrl(relativePath) {
        return this.proformaUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
    /** Converts the `relativePath` into an absolute Jira URI. */ createJiraUrl(relativePath) {
        return this.jiraUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
    getAnalyticsSource() {
        try {
            var _analyticsData$payloa, _analyticsData$payloa2;
            const analyticsEvent = this.createAnalyticsEvent({});
            const analyticsData = (0, $kCVub.extractAWCDataFromEvent)(analyticsEvent);
            return (_analyticsData$payloa = analyticsData === null || analyticsData === void 0 ? void 0 : (_analyticsData$payloa2 = analyticsData.payload) === null || _analyticsData$payloa2 === void 0 ? void 0 : _analyticsData$payloa2.source) !== null && _analyticsData$payloa !== void 0 ? _analyticsData$payloa : 'unknown';
        } catch (e) {
            return 'unknown';
        }
    }
    fetchApi(proForma, method, path, responseType, requestName, body) {
        const analyticsSource = this.getAnalyticsSource();
        return fetch(proForma ? this.createApiUrl(path) : this.createJiraUrl(path), {
            method: method,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Experimental-Experience': analyticsSource,
                ...responseType === $74d3b548944c3270$export$9126c50ecfe2a46d.Json ? {
                    Accept: 'application/json'
                } : {}
            },
            ...body && {
                body: JSON.stringify(body)
            }
        }).catch((error)=>{
            const message = `No response from API: ${error.message || ''}`;
            const apiError = $74d3b548944c3270$var$toApiError(0, {
                error: message
            }, true, requestName);
            this.errorUtils.reportError(error, {
                actionSubject: (0, $erWXD.ActionSubject).PROFORMA_API,
                id: 'fetchApi',
                attributes: {
                    path: path,
                    method: method,
                    responseType: responseType,
                    requestName: requestName,
                    apiError: JSON.stringify(apiError),
                    isClientFetchError: true
                }
            });
            return Promise.reject(apiError);
        }).then((response)=>{
            let errorObj = new Error(response.statusText);
            if (!response.ok) {
                var _ref, _response$headers$get;
                const traceId = (_ref = (_response$headers$get = response.headers.get('x-trace-id')) !== null && _response$headers$get !== void 0 ? _response$headers$get : response.headers.get('atl-traceid')) !== null && _ref !== void 0 ? _ref : undefined;
                let apiErrorPromise;
                try {
                    // Try to parse response error details
                    const responseJsonApiError = responseType !== 'json' ? undefined : response.json().then((responseJson)=>$74d3b548944c3270$var$toApiError(response.status, responseJson, false, requestName, traceId)).catch((error)=>{
                        const message = `Failed to parse error response as JSON from API: ${error.message || ''}`;
                        errorObj = error;
                        return $74d3b548944c3270$var$toApiError(response.status, {
                            error: message
                        }, false, requestName, traceId);
                    });
                    if (response.status === 401) this.errorUtils.notifyUser((0, $bRqoO.NoticeType).ErrorApiUnauthorised);
                    if (response.status === 403) this.errorUtils.notifyUser((0, $bRqoO.NoticeType).ErrorApiMissingPermissions);
                    if (responseJsonApiError !== undefined) apiErrorPromise = responseJsonApiError.then((apiError)=>Promise.reject(apiError));
                    else // Create error object with error response body
                    apiErrorPromise = Promise.reject($74d3b548944c3270$var$toApiError(response.status, {
                        error: response.body || ''
                    }, false, requestName, traceId));
                } catch (error) {
                    const message = `Unexpected response from API: ${response.body || ''}`;
                    errorObj = error;
                    apiErrorPromise = Promise.reject($74d3b548944c3270$var$toApiError(response.status, {
                        error: message
                    }, false, requestName, traceId));
                }
                apiErrorPromise.catch((apiError)=>{
                    this.errorUtils.reportError(errorObj, {
                        actionSubject: (0, $erWXD.ActionSubject).PROFORMA_API,
                        id: 'fetchApi',
                        attributes: {
                            status: response.status,
                            statusGroup: `${Math.floor(response.status / 100)}xx`,
                            traceId: traceId,
                            path: path,
                            method: method,
                            responseType: responseType,
                            requestName: requestName,
                            apiError: JSON.stringify(apiError),
                            isClientFetchError: false
                        }
                    });
                });
                return apiErrorPromise;
            }
            if (response.status === 204) return '';
            switch(responseType){
                case 'json':
                    return response.json();
                case 'blob':
                    return response.blob();
                case 'text':
                    return response.text();
                case 'none':
                    return '';
                default:
                    return response;
            }
        });
    }
}
function $74d3b548944c3270$var$toApiError(status, responseJson, isClientFetchError, requestName, traceId) {
    if (Object.keys(responseJson).length === 0) return (0, $caW8j.constructApiError)(`Unexpected API reply (HTTP/${status})`, status, responseJson, requestName);
    const error = responseJson['error'] || `Unexpected API reply (HTTP/${status})`;
    const context = responseJson['context'];
    const contextId = responseJson['contextId'];
    const details = responseJson['details'];
    return (0, $caW8j.constructApiError)(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId);
}

});
parcelRegister("erWXD", function(module, exports) {

$parcel$export(module.exports, "ActionSubject", () => $a85152b408a7fe70$export$7f97440769de1377);
$parcel$export(module.exports, "Action", () => $a85152b408a7fe70$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "FormUpdateType", () => $a85152b408a7fe70$export$d7867a52899740a0);
/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */ // These are entities in ProForma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
let $a85152b408a7fe70$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    // Objects
    ActionSubject["FORM"] = "form";
    // An actual form on an issue.
    ActionSubject["FORM_FIELD"] = "formField";
    // A field in a form.
    ActionSubject["FORM_FIELD_CHOICES_DATA_CONNECTION"] = "formFieldChoicesDataConnection";
    // A data connection's choices in a form.
    ActionSubject["FORM_FIELD_CHOICES_JIRA_FIELD"] = "formFieldChoicesJiraField";
    // A Jira field's choices in a form.
    ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
    // Language dropdown of a form in form settings.
    ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
    // Lock and PDF of a form on submit toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
    // Submit and validate on create toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
    // Issue forms types dropdown in form settings, enabled through issue forms toggle.
    ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
    // Recommended forms types dropdown in form settings, enabled through recommended forms toggle.
    ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
    // Request create types dropdown in form settings, enabled through request create toggle ("Attach to request types").
    ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
    // Answer of a Question in a form.
    ActionSubject["TEMPLATE_FORM"] = "templateForm";
    // A form in a project created by form builder than can be then instantiated on an issue.
    ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
    // Predefined templates available in the form builder that can be inserted into a template form.
    ActionSubject["BUTTON"] = "button";
    ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
    ActionSubject["SELECT_ITEM"] = "selectItem";
    ActionSubject["FILTER"] = "filter";
    ActionSubject["LIST"] = "list";
    ActionSubject["PANEL"] = "panel";
    ActionSubject["SECTION"] = "section";
    ActionSubject["TABLE"] = "table";
    ActionSubject["MODAL"] = "modal";
    ActionSubject["PROFORMA_API"] = "proformaAPI";
    ActionSubject["PROFORMA_UI"] = "proformaUI";
    ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
    ActionSubject["ATTACHMENT"] = "proformaAttachment";
    ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
    ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
    ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
    ActionSubject["REQUEST_TYPE"] = "requestType";
    ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
    ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
    ActionSubject["FORM_PERMISSIONS"] = "proformaFormPermissions";
    // Processes
    ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
    ActionSubject["FORM_VALIDATION"] = "formValidation";
    ActionSubject["FORM_EDIT"] = "formEdit";
    ActionSubject["FORM_SAVE"] = "formSave";
    ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
    ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
    ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
    ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
    ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
    return ActionSubject;
}({});
let $a85152b408a7fe70$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    // Objects
    Action["ADDED"] = "added";
    // When an entity is added/inserted into another.
    Action["CLICKED"] = "clicked";
    Action["CREATED"] = "created";
    Action["DELETED"] = "deleted";
    Action["DOWNLOADED"] = "downloaded";
    Action["EXPORTED"] = "exported";
    Action["UPDATED"] = "updated";
    Action["VIEWED"] = "viewed";
    Action["SELECTED"] = "selected";
    Action["COPIED"] = "copied";
    // Processes
    Action["FAILED"] = "failed";
    Action["FINISHED"] = "finished";
    Action["STARTED"] = "started";
    Action["STOPPED"] = "stopped";
    return Action;
}({});
let $a85152b408a7fe70$export$d7867a52899740a0 = /*#__PURE__*/ function(FormUpdateType) {
    FormUpdateType["REOPEN"] = "REOPEN";
    FormUpdateType["SAVE"] = "SAVE";
    FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
    FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
    FormUpdateType["SUBMIT"] = "SUBMIT";
    FormUpdateType["CLOSE"] = "CLOSE"; // Similar to SUBMIT, used in "Close customer edits" option in form card meatball menu
    return FormUpdateType;
}({});

});

parcelRegister("bRqoO", function(module, exports) {

$parcel$export(module.exports, "NoticeType", () => $8a291f441fcc3884$export$3b5003ffe8119af2);
$parcel$export(module.exports, "Notices", () => $8a291f441fcc3884$export$ba15f0a357d713fd);

var $9svqU = parcelRequire("9svqU");

var $7fcWf = parcelRequire("7fcWf");
let $8a291f441fcc3884$export$3b5003ffe8119af2 = /*#__PURE__*/ function(NoticeType) {
    NoticeType["ConfirmDeleteForm"] = "ConfirmDeleteForm";
    NoticeType["ConfirmChangeFormToInternal"] = "ConfirmChangeFormToInternal";
    NoticeType["ConfirmChangeFormToExternal"] = "ConfirmChangeFormToExternal";
    NoticeType["ConfirmCancelEdit"] = "ConfirmCancelEdit";
    NoticeType["ConfirmSubmitForm"] = "ConfirmSubmitForm";
    NoticeType["ConfirmSubmitFormLock"] = "ConfirmSubmitFormLock";
    NoticeType["ConfirmReopenForm"] = "ConfirmReopenForm";
    NoticeType["ErrorApiUnauthorised"] = "ErrorApiUnauthorised";
    NoticeType["ErrorApiMissingPermissions"] = "ErrorApiMissingPermissions";
    NoticeType["ErrorApiAddConnectionFailed"] = "ErrorApiAddConnectionFailed";
    NoticeType["ErrorApiUpdateConnectionFailed"] = "ErrorApiUpdateConnectionFailed";
    NoticeType["ErrorApiSubmitFormFailed"] = "ErrorApiSubmitFormFailed";
    NoticeType["ErrorApiSaveFormFailed"] = "ErrorApiSaveFormFailed";
    NoticeType["ErrorApiSaveFormFailedOnConflict"] = "ErrorApiSaveFormFailedOnConflict";
    NoticeType["ErrorApiSaveFormInvalidAnswersFailed"] = "ErrorApiSaveFormInvalidAnswersFailed";
    NoticeType["ErrorApiSaveTemplateFormFailed"] = "ErrorApiSaveTemplateFormFailed";
    NoticeType["ErrorApiLoadTemplateFormFailed"] = "ErrorApiLoadTemplateFormFailed";
    NoticeType["ErrorApiLoadJiraFieldsFailed"] = "ErrorApiLoadJiraFieldsFailed";
    NoticeType["ErrorApiLoadDataConnectionsFailed"] = "ErrorApiLoadDataConnectionsFailed";
    NoticeType["ErrorApiLoadSettingsRefDataFailed"] = "ErrorApiLoadSettingsRefDataFailed";
    return NoticeType;
}({});
const $8a291f441fcc3884$export$ba15f0a357d713fd = {
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmDeleteForm]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).DeleteFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).DeleteFormMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Delete],
        isWarningNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormToInternal]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ChangeFormToInternalHeader],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ChangeFormToInternalMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).MakeInternal]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormToExternal]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ChangeFormToExternalHeader],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ChangeFormToExternalMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).MakeExternal]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmCancelEdit]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).CancelEditFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).CancelEditFormMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Confirm]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitForm]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).SubmitFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).SubmitFormMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Submit]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitFormLock]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).SubmitFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).SubmitFormLockMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Submit]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmReopenForm]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ReopenFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ReopenFormMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Reopen]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiUnauthorised]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).UnauthorisedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).UnauthorisedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiMissingPermissions]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).MissingPermissionsTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).MissingPermissionsMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiAddConnectionFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).AddConnectionFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).AddConnectionFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiUpdateConnectionFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).UpdateConnectionFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).UpdateConnectionFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSubmitFormFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SubmitFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SubmitFormFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormInvalidAnswersFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormInvalidAnswersMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormFailedOnConflict]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedOnConflictMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveTemplateFormFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveTemplateFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveTemplateFormFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadTemplateFormFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadTemplateFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadTemplateFormFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadJiraFieldsFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadJiraFieldsFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadJiraFieldsFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadDataConnectionsFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadDataConnectionsFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadDataConnectionsFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadSettingsRefDataFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadSettingsRefDataFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadSettingsRefDataFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    }
};

});
parcelRegister("9svqU", function(module, exports) {

$parcel$export(module.exports, "ApiErrorMessage", () => $6e2f1c86cfbb31d7$export$231e36d3eb058aab);
$parcel$export(module.exports, "IntlApiErrorMessages", () => $6e2f1c86cfbb31d7$export$4a210a14fc5cbd69);

var $7VHMR = parcelRequire("7VHMR");
let $6e2f1c86cfbb31d7$export$231e36d3eb058aab = /*#__PURE__*/ function(ApiErrorMessage) {
    ApiErrorMessage["UnauthorisedTitle"] = "UnauthorisedTitle";
    ApiErrorMessage["UnauthorisedMsg"] = "UnauthorisedMsg";
    ApiErrorMessage["MissingPermissionsTitle"] = "MissingPermissionsTitle";
    ApiErrorMessage["MissingPermissionsMsg"] = "MissingPermissionsMsg";
    ApiErrorMessage["AddConnectionFailedTitle"] = "AddConnectionFailedTitle";
    ApiErrorMessage["AddConnectionFailedMsg"] = "AddConnectionFailedMsg";
    ApiErrorMessage["UpdateConnectionFailedTitle"] = "UpdateConnectionFailedTitle";
    ApiErrorMessage["UpdateConnectionFailedMsg"] = "UpdateConnectionFailedMsg";
    ApiErrorMessage["SubmitFormFailedTitle"] = "SubmitFormFailedTitle";
    ApiErrorMessage["SubmitFormFailedMsg"] = "SubmitFormFailedMsg";
    ApiErrorMessage["SaveFormFailedTitle"] = "SaveFormFailedTitle";
    ApiErrorMessage["SaveFormFailedMsg"] = "SaveFormFailedMsg";
    ApiErrorMessage["SaveFormInvalidAnswersMsg"] = "SaveFormInvalidAnswersMsg";
    ApiErrorMessage["SaveFormFailedOnConflictMsg"] = "SaveFormFailedOnConflictMsg";
    ApiErrorMessage["SaveTemplateFormFailedTitle"] = "SaveTemplateFormFailedTitle";
    ApiErrorMessage["SaveTemplateFormFailedMsg"] = "SaveTemplateFormFailedMsg";
    ApiErrorMessage["LoadTemplateFormFailedTitle"] = "LoadTemplateFormFailedTitle";
    ApiErrorMessage["LoadTemplateFormFailedMsg"] = "LoadTemplateFormFailedMsg";
    ApiErrorMessage["LoadJiraFieldsFailedTitle"] = "LoadJiraFieldsFailedTitle";
    ApiErrorMessage["LoadJiraFieldsFailedMsg"] = "LoadJiraFieldsFailedMsg";
    ApiErrorMessage["LoadDataConnectionsFailedTitle"] = "LoadDataConnectionsFailedTitle";
    ApiErrorMessage["LoadDataConnectionsFailedMsg"] = "LoadDataConnectionsFailedMsg";
    ApiErrorMessage["LoadSettingsRefDataFailedTitle"] = "LoadSettingsRefDataFailedTitle";
    ApiErrorMessage["LoadSettingsRefDataFailedMsg"] = "LoadSettingsRefDataFailedMsg";
    return ApiErrorMessage;
}({});
const $6e2f1c86cfbb31d7$export$4a210a14fc5cbd69 = (0, $7VHMR.defineMessages)({
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UnauthorisedTitle]: {
        id: 'ui-notices.apiError.title.UnauthorisedTitle',
        defaultMessage: 'Error: User Unauthorised'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UnauthorisedMsg]: {
        id: 'ui-notices.apiError.msg.UnauthorisedMsg',
        defaultMessage: 'Try refreshing your page or logging into Jira again.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.MissingPermissionsTitle]: {
        id: 'ui-notices.apiError.title.MissingPermissionsTitle',
        defaultMessage: 'Error: User is not allowed this action'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.MissingPermissionsMsg]: {
        id: 'ui-notices.apiError.msg.MissingPermissionsMsg',
        defaultMessage: 'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.AddConnectionFailedTitle]: {
        id: 'ui-notices.apiError.title.AddConnectionFailedTitle',
        defaultMessage: 'Error: Adding data connection failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.AddConnectionFailedMsg]: {
        id: 'ui-notices.apiError.msg.AddConnectionFailedMsg',
        defaultMessage: 'A server error occurred while trying to add the data connection.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UpdateConnectionFailedTitle]: {
        id: 'ui-notices.apiError.title.UpdateConnectionFailedTitle',
        defaultMessage: 'Error: Updating data connection failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UpdateConnectionFailedMsg]: {
        id: 'ui-notices.apiError.msg.UpdateConnectionFailedMsg',
        defaultMessage: 'A server error occurred while trying to update the data connection.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SubmitFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SubmitFormFailedTitle',
        defaultMessage: 'Error: Submitting form failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SubmitFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SubmitFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to submit the form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SaveFormFailedTitle',
        defaultMessage: "We couldn\u2019t save your changes",
        description: 'The title on the error flag informing customers that their form failed to save.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to save the form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormInvalidAnswersMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg',
        defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
        description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedOnConflictMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg',
        defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
        description: "The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state doesn't allow the customer to do so."
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveTemplateFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SaveTemplateFormFailedTitle',
        defaultMessage: 'Error: Saving template form failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveTemplateFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SaveTemplateFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to save the template form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadTemplateFormFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadTemplateFormFailedTitle',
        defaultMessage: "We couldn\u2019t load your form"
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadTemplateFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadTemplateFormFailedMsg',
        defaultMessage: 'Refresh the page to try again'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadJiraFieldsFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadJiraFieldsFailedTitle',
        defaultMessage: 'Error: Loading Jira fields failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadJiraFieldsFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg',
        defaultMessage: 'A server error occurred while trying to load Jira fields on the template form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadDataConnectionsFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadDataConnectionsFailedTitle',
        defaultMessage: 'Error: Loading data connections failed.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadDataConnectionsFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg',
        defaultMessage: 'A server error occurred while trying to load data connections on the template form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadSettingsRefDataFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle',
        defaultMessage: 'Error: Loading form settings reference data failed.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadSettingsRefDataFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg',
        defaultMessage: "A server error occurred while trying to load the reference for the template form's settings."
    }
});

});

parcelRegister("7fcWf", function(module, exports) {

$parcel$export(module.exports, "NoticeMessage", () => $5463f86ac7c8d952$export$cd61f3d27ce0e442);
$parcel$export(module.exports, "IntlNoticeMessages", () => $5463f86ac7c8d952$export$5f3ce93e2cd01692);

var $7VHMR = parcelRequire("7VHMR");
let $5463f86ac7c8d952$export$cd61f3d27ce0e442 = /*#__PURE__*/ function(NoticeMessage) {
    NoticeMessage["Delete"] = "Delete";
    NoticeMessage["Discard"] = "Discard";
    NoticeMessage["Change"] = "Change";
    NoticeMessage["Confirm"] = "Confirm";
    NoticeMessage["Submit"] = "Submit";
    NoticeMessage["Reopen"] = "Reopen";
    NoticeMessage["Close"] = "Close";
    NoticeMessage["Cancel"] = "Cancel";
    NoticeMessage["UpgradeNow"] = "UpgradeNow";
    NoticeMessage["MakeInternal"] = "MakeInternal";
    NoticeMessage["MakeExternal"] = "MakeExternal";
    NoticeMessage["DeleteFormTitle"] = "DeleteFormTitle";
    NoticeMessage["DeleteFormMsg"] = "DeleteFormMsg";
    NoticeMessage["ChangeFormAvailabilityTitle"] = "ChangeFormAvailabilityTitle";
    NoticeMessage["ChangeFormToInternalHeader"] = "ChangeFormToInternalHeader";
    NoticeMessage["ChangeFormToInternalMsg"] = "ChangeFormToInternalMsg";
    NoticeMessage["ChangeFormToExternalHeader"] = "ChangeFormToExternalHeader";
    NoticeMessage["ChangeFormToExternalMsg"] = "ChangeFormToExternalMsg";
    NoticeMessage["CancelEditFormTitle"] = "CancelEditFormTitle";
    NoticeMessage["CancelEditFormMsg"] = "CancelEditFormMsg";
    NoticeMessage["SubmitFormTitle"] = "SubmitFormTitle";
    NoticeMessage["SubmitFormMsg"] = "SubmitFormMsg";
    NoticeMessage["SubmitFormLockMsg"] = "SubmitFormLockMsg";
    NoticeMessage["ReopenFormTitle"] = "ReopenFormTitle";
    NoticeMessage["ReopenFormMsg"] = "ReopenFormMsg";
    NoticeMessage["ErrorExplanations1"] = "ErrorExplanations1";
    NoticeMessage["ErrorExplanations2"] = "ErrorExplanations2";
    NoticeMessage["ErrorExplanations3"] = "ErrorExplanations3";
    NoticeMessage["ErrorExplanations4"] = "ErrorExplanations4";
    return NoticeMessage;
}({});
const $5463f86ac7c8d952$export$5f3ce93e2cd01692 = (0, $7VHMR.defineMessages)({
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Delete]: {
        id: 'ui-notices.confirmText.Delete',
        defaultMessage: 'Delete'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Discard]: {
        id: 'ui-notices.confirmText.Discard',
        defaultMessage: 'Discard'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Change]: {
        id: 'ui-notices.confirmText.Change',
        defaultMessage: 'Change'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Confirm]: {
        id: 'ui-notices.confirmText.Confirm',
        defaultMessage: 'Confirm'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Submit]: {
        id: 'ui-notices.confirmText.Submit',
        defaultMessage: 'Submit'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Reopen]: {
        id: 'ui-notices.confirmText.Reopen',
        defaultMessage: 'Reopen'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Close]: {
        id: 'ui-notices.confirmText.Close',
        defaultMessage: 'Close'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Cancel]: {
        id: 'ui-notices.confirmText.Cancel',
        defaultMessage: 'Cancel'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.UpgradeNow]: {
        id: 'ui-notices.confirmText.UpgradeNow',
        defaultMessage: 'Upgrade Now'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.MakeInternal]: {
        id: 'ui-notices.confirmText.MakeInternal',
        defaultMessage: 'Make internal'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.MakeExternal]: {
        id: 'ui-notices.confirmText.MakeExternal',
        defaultMessage: 'Make external'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.DeleteFormTitle]: {
        id: 'ui-notices.title.DeleteFormTitle',
        defaultMessage: 'Confirm Deleting Form'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.DeleteFormMsg]: {
        id: 'ui-notices.msg.DeleteFormMsg',
        defaultMessage: "Are you sure you want to delete the \u201C{formName}\u201D form? This cannot be undone."
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormAvailabilityTitle]: {
        id: 'ui-notices.title.ChangeFormAvailabilityTitle',
        defaultMessage: 'Confirm Changing Form Availability'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToInternalHeader]: {
        id: 'ui-notices.title.ChangeFormInternalHeader',
        defaultMessage: 'Make form internal only and hide from customer'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToInternalMsg]: {
        id: 'ui-notices.msg.ChangeFormInternalMsg',
        defaultMessage: 'Any forms made internal will only be seen by agents and hidden in the portal from customers.'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToExternalHeader]: {
        id: 'ui-notices.title.ChangeFormToExternalHeader',
        defaultMessage: 'Make form external and show to customer'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToExternalMsg]: {
        id: 'ui-notices.msg.ChangeFormToExternalMsg',
        defaultMessage: 'Customers will be able to view this form in the portal and it will no longer be internal only.'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.CancelEditFormTitle]: {
        id: 'ui-notices.title.CancelEditFormTitle',
        defaultMessage: 'Confirm Discarding Changes'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.CancelEditFormMsg]: {
        id: 'ui-notices.msg.CancelEditFormMsg',
        defaultMessage: 'There are changes to answers on the \u201C{formName}\u201D form that will be lost if you choose "Confirm". Are you sure you want to continue?'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormTitle]: {
        id: 'ui-notices.title.SubmitFormTitle',
        defaultMessage: 'Confirm Form Submission'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormMsg]: {
        id: 'ui-notices.msg.SubmitFormMsg',
        defaultMessage: 'Are you sure you want to submit this form ?'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormLockMsg]: {
        id: 'ui-notices.msg.SubmitFormLockMsg',
        defaultMessage: 'Are you sure you want to submit this form ? Once submitted no further changes can be made.'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ReopenFormTitle]: {
        id: 'ui-notices.title.ReopenFormTitle',
        defaultMessage: 'Confirm Reopening Form'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ReopenFormMsg]: {
        id: 'ui-notices.msg.ReopenFormMsg',
        defaultMessage: 'Are you sure you want to reopen the submitted form for editing?'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations1]: {
        id: 'ui-notices.msg.ErrorExplanations1',
        defaultMessage: 'Please refer to our'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations2]: {
        id: 'ui-notices.msg.ErrorExplanations2',
        defaultMessage: 'Error Explanations'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations3]: {
        id: 'ui-notices.msg.ErrorExplanations3',
        defaultMessage: 'page for more details or contact'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations4]: {
        id: 'ui-notices.msg.ErrorExplanations4',
        defaultMessage: 'ThinkTilt Support'
    }
});

});


parcelRegister("caW8j", function(module, exports) {

$parcel$export(module.exports, "constructApiError", () => $8dd38339de80c582$export$4fb8f0e1418096d0);
$parcel$export(module.exports, "isUnknownApiError", () => $8dd38339de80c582$export$a072859f46abbb91);
$parcel$export(module.exports, "getFormSaveErrors", () => $8dd38339de80c582$export$ed98b2247c52f4f6);
$parcel$export(module.exports, "getJiraErrorCollectionResponse", () => $8dd38339de80c582$export$e6390e344b33daed);

var $3KrJl = parcelRequire("3KrJl");

var $8w794 = parcelRequire("8w794");
function $8dd38339de80c582$export$4fb8f0e1418096d0(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId) {
    switch(error){
        case (0, $3KrJl.ApiErrorType).client:
            return {
                error: (0, $3KrJl.ApiErrorType).client,
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $3KrJl.ApiErrorType).clientWithDetails:
            return {
                error: (0, $3KrJl.ApiErrorType).clientWithDetails,
                context: (0, $8w794.ErrorContextOf)(context),
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $3KrJl.ApiErrorType).json:
            return {
                error: (0, $3KrJl.ApiErrorType).json,
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $3KrJl.ApiErrorType).jwt:
            return {
                error: (0, $3KrJl.ApiErrorType).jwt,
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        default:
            return {
                error: (0, $3KrJl.ApiErrorType).unknown,
                message: error,
                status: status,
                responseJson: responseJson,
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                requestName: requestName
            };
    }
}
const $8dd38339de80c582$export$a072859f46abbb91 = (apiError)=>apiError.error === (0, $3KrJl.ApiErrorType).unknown;
const $8dd38339de80c582$export$ed98b2247c52f4f6 = (apiError)=>{
    if ($8dd38339de80c582$export$a072859f46abbb91(apiError) && apiError.status === 400) return {
        generalErrors: [],
        errorsByQuestionId: {},
        ...apiError.responseJson
    };
    return undefined;
};
const $8dd38339de80c582$export$e6390e344b33daed = (apiError)=>{
    if ($8dd38339de80c582$export$a072859f46abbb91(apiError) && apiError.status >= 400 && apiError.status < 500) return {
        errorMessages: [],
        errors: {},
        ...apiError.responseJson
    };
    return undefined;
};

});
parcelRegister("3KrJl", function(module, exports) {

$parcel$export(module.exports, "ApiErrorType", () => $2bab2d9fb6f6d466$export$eb26b24d7b7bab09);
let $2bab2d9fb6f6d466$export$eb26b24d7b7bab09 = /*#__PURE__*/ function(ApiErrorType) {
    ApiErrorType["client"] = "client";
    ApiErrorType["clientWithDetails"] = "clientWithDetails";
    ApiErrorType["json"] = "json";
    ApiErrorType["jwt"] = "jwt";
    ApiErrorType["unknown"] = "unknown";
    ApiErrorType["timeout"] = "timeout";
    return ApiErrorType;
}({});

});

parcelRegister("8w794", function(module, exports) {

$parcel$export(module.exports, "ErrorContextOf", () => $6336dacbdad88890$export$2c172aed648e926c);
let $6336dacbdad88890$export$21818dff4f4f7174 = /*#__PURE__*/ function(ErrorContext) {
    ErrorContext["I18nAccessPathKey"] = "err.access.path";
    ErrorContext["I18nEntityConnectionKey"] = "err.entity.connection";
    ErrorContext["I18nEntityFormKey"] = "err.entity.form";
    ErrorContext["I18nEntityIssueKey"] = "err.entity.issue";
    ErrorContext["I18nEntityIssueCreateKey"] = "err.entity.issue.create";
    ErrorContext["I18nEntityPreferredFormKey"] = "err.entity.preferredform";
    ErrorContext["I18nEntityProjectKey"] = "err.entity.project";
    ErrorContext["I18nEntityRequestTypeKey"] = "err.entity.requesttype";
    ErrorContext["I18nEntityServiceDeskKey"] = "err.entity.servicedesk";
    ErrorContext["I18nJwtParseKey"] = "err.jwt.parse";
    ErrorContext["I18nJwtSignatureKey"] = "err.jwt.signed";
    ErrorContext["I18nJwtVerifyKey"] = "err.jwt.verify";
    ErrorContext["I18nInternalServerError"] = "err.server.internal";
    ErrorContext["I18nUnknownContextError"] = "err.context.unknown";
    return ErrorContext;
}({});
function $6336dacbdad88890$export$2c172aed648e926c(context) {
    switch(context){
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nAccessPathKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nAccessPathKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityConnectionKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityConnectionKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityFormKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityFormKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueCreateKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueCreateKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityPreferredFormKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityPreferredFormKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityProjectKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityProjectKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityRequestTypeKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityRequestTypeKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityServiceDeskKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityServiceDeskKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtParseKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtParseKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtSignatureKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtSignatureKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtVerifyKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtVerifyKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nInternalServerError:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nInternalServerError;
        default:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nUnknownContextError;
    }
}

});



parcelRegister("j93Fo", function(module, exports) {

$parcel$export(module.exports, "setNoticeLocale", () => $df01b3b500941fc5$export$caf904df61b5b10d);
$parcel$export(module.exports, "showNotice", () => $df01b3b500941fc5$export$b25305d7fdb340d7);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $24oqM = parcelRequire("24oqM");
let $df01b3b500941fc5$var$locale = 'en-US';
function $df01b3b500941fc5$export$caf904df61b5b10d(newLocale) {
    $df01b3b500941fc5$var$locale = newLocale;
}
function $df01b3b500941fc5$export$b25305d7fdb340d7(noticeType, intlValues, errorDetails) {
    return new Promise((resolve)=>{
        const dialogTargetNode = document.getElementById('pf-dialog-container');
        if (!dialogTargetNode) {
            // eslint-disable-next-line no-console
            console.error(`Could not show notice ${noticeType}. The target Node for the dialog is not available`);
            resolve(false);
        }
        const handleClose = (confirmed)=>{
            resolve(!!confirmed);
            $df01b3b500941fc5$var$closeNotice();
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $24oqM.Notice), {
            noticeType: noticeType,
            handleClose: handleClose,
            settings: {
                intlValues: intlValues,
                errorDetails: errorDetails,
                customLocale: $df01b3b500941fc5$var$locale
            }
        }), dialogTargetNode);
    });
}
function $df01b3b500941fc5$var$closeNotice() {
    const dialogTargetNode = document.getElementById('pf-dialog-container');
    if (!dialogTargetNode) {
        // eslint-disable-next-line no-console
        console.error(`Could not close notice. The target Node for the dialog is not available`);
        return false;
    }
    const closed = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unmountComponentAtNode(dialogTargetNode);
    if (!closed) // eslint-disable-next-line no-console
    console.error(`Could not close notice. There is no dialog to unmount`);
    return closed;
}

});
parcelRegister("24oqM", function(module, exports) {

$parcel$export(module.exports, "Notice", () => $181ee7fa9c781879$export$71802e30fd294f61);

var $5uXOq = parcelRequire("5uXOq");

var $dlLGv = parcelRequire("dlLGv");

var $fiX4W = parcelRequire("fiX4W");

var $8v3RR = parcelRequire("8v3RR");

var $bRqoO = parcelRequire("bRqoO");
const $181ee7fa9c781879$export$71802e30fd294f61 = ({ noticeType: noticeType, handleClose: handleClose, settings: { customLocale: customLocale = (0, $fiX4W.DEFAULT_LOCALE), intlValues: intlValues, errorDetails: errorDetails, overrideZIndex: overrideZIndex } })=>{
    const notice = (0, $bRqoO.Notices)[noticeType];
    if (!notice) {
        // eslint-disable-next-line no-console
        console.error(`Could not show notice, notice type ${noticeType} does not exist`);
        handleClose();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlLGv.PackageIntlProvider), {
        locale: customLocale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8v3RR.NoticeDialog), {
        title: notice.title,
        titleVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.titleVars,
        message: notice.message,
        messageVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.msgVars,
        confirmText: notice.confirmText,
        confirmLink: notice.confirmLink,
        handleClose: handleClose,
        isErrorNotice: notice.isErrorNotice,
        errorDetails: errorDetails,
        isWarningNotice: notice.isWarningNotice,
        overrideZIndex: overrideZIndex
    }));
};

});
parcelRegister("dlLGv", function(module, exports) {

$parcel$export(module.exports, "PackageIntlProvider", () => $9b8239ac40bcdc9c$export$dfce9acc1b75df7a);
$parcel$export(module.exports, "withPackageIntlProvider", () => $9b8239ac40bcdc9c$export$38662a78c6a3a7ce);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $i9OHB = parcelRequire("i9OHB");

var $ioVpW = parcelRequire("ioVpW");
const $9b8239ac40bcdc9c$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9OHB.ProformaIntlProvider), {
        locale: locale,
        messages: (0, $ioVpW.default)
    }, children);
const $9b8239ac40bcdc9c$export$38662a78c6a3a7ce = (WrappedComponent)=>(props)=>{
        const intl = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b8239ac40bcdc9c$export$dfce9acc1b75df7a, {
            locale: intl.locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
    };

});
parcelRegister("i9OHB", function(module, exports) {

$parcel$export(module.exports, "ProformaIntlProvider", () => $d38065afc4acf5f2$export$f345b4b8e42e419e);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $dS3PR = parcelRequire("dS3PR");

var $iyjlq = parcelRequire("iyjlq");
const $d38065afc4acf5f2$export$f345b4b8e42e419e = ({ children: children, locale: locale, messages: messages })=>{
    var _getCodesFromLocale;
    const { language: language, country: country } = (_getCodesFromLocale = (0, $iyjlq.getCodesFromLocale)(locale)) !== null && _getCodesFromLocale !== void 0 ? _getCodesFromLocale : {};
    const lazyMessages = (0, $iyjlq.useLazyMessages)(messages, language !== null && language !== void 0 ? language : (0, $iyjlq.DEFAULT_LOCALE), country);
    if (lazyMessages === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        messages: lazyMessages,
        locale: country && `${language}-${country}` || language || locale.replace('_', '-'),
        defaultLocale: (0, $iyjlq.DEFAULT_LOCALE),
        defaultRichTextElements: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                    weight: "bold"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                    as: "strong"
                }, chunks)
        }
    }, children);
};

});
parcelRegister("iyjlq", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $d81a686b660c1f7e$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getCodesFromLocale", () => $d81a686b660c1f7e$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyMessages", () => $d81a686b660c1f7e$export$7ddce3b5511cfaa8);

var $5uXOq = parcelRequire("5uXOq");
const $d81a686b660c1f7e$export$1af4c7e47ad72f44 = 'en';
const $d81a686b660c1f7e$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $d81a686b660c1f7e$export$4d25b49b6dc1b540 = (locale)=>{
    const match = $d81a686b660c1f7e$var$localeRegex.exec(locale);
    if (match) {
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country === null || country === void 0 ? void 0 : country.toUpperCase()
        };
    }
    // TODO: Use error service to log:
    // eslint-disable-next-line no-console
    console.error('Unable to determine language and country from invalid locale.');
    return undefined;
};
const $d81a686b660c1f7e$var$loadLazyMessages = async (lazyMessages, language, country)=>{
    var _await$default, _await, _ref;
    return (_await$default = (_await = await ((_ref = country && lazyMessages[`${language}_${country}`] || lazyMessages[language] || lazyMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
};
const $d81a686b660c1f7e$export$7ddce3b5511cfaa8 = (lazyMessages, language, country)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        $d81a686b660c1f7e$var$loadLazyMessages(lazyMessages, language, country).catch(()=>({})).then(setMessages);
    }, [
        country,
        language,
        lazyMessages,
        setMessages
    ]);
    return messages;
};

});


parcelRegister("ioVpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d65701c9e2552e18$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */ 
























const $d65701c9e2552e18$var$lazyMessages = {
    cs: ()=>(parcelRequire("hpylm")),
    da: ()=>(parcelRequire("bxes0")),
    de: ()=>(parcelRequire("62Ikn")),
    en: ()=>(parcelRequire("b940G")),
    en_GB: ()=>(parcelRequire("3MfRg")),
    en_ZZ: ()=>(parcelRequire("8GHTS")),
    es: ()=>(parcelRequire("iDINQ")),
    fi: ()=>(parcelRequire("avWuc")),
    fr: ()=>(parcelRequire("7mRR8")),
    hu: ()=>(parcelRequire("hhRcH")),
    it: ()=>(parcelRequire("6zd31")),
    ja: ()=>(parcelRequire("dWqMX")),
    ko: ()=>(parcelRequire("AYLPF")),
    nb: ()=>(parcelRequire("kuyLU")),
    nl: ()=>(parcelRequire("aJNtk")),
    pl: ()=>(parcelRequire("6NSn1")),
    pt_BR: ()=>(parcelRequire("9nKnc")),
    ru: ()=>(parcelRequire("a1Urr")),
    sv: ()=>(parcelRequire("3KPzJ")),
    th: ()=>(parcelRequire("bxanm")),
    tr: ()=>(parcelRequire("e7v7R")),
    uk: ()=>(parcelRequire("SCees")),
    vi: ()=>(parcelRequire("e68UC")),
    zh: ()=>(parcelRequire("1diT2")),
    zh_TW: ()=>(parcelRequire("eCwMW"))
};
var $d65701c9e2552e18$export$2e2bcd8739ae039 = $d65701c9e2552e18$var$lazyMessages;

});
parcelRegister("hpylm", function(module, exports) {

let $cacf695d6609942d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cacf695d6609942d$var$load("bOMSG").then(()=>parcelRequire('bSYnh'));

});

parcelRegister("bxes0", function(module, exports) {

let $865dfc5d95b6d240$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865dfc5d95b6d240$var$load("99s0m").then(()=>parcelRequire('fr8Uf'));

});

parcelRegister("62Ikn", function(module, exports) {

let $46655085ceabc6c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $46655085ceabc6c5$var$load("41WhO").then(()=>parcelRequire('6EC1L'));

});

parcelRegister("b940G", function(module, exports) {

let $81d3a54780c1512c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81d3a54780c1512c$var$load("iZTjR").then(()=>parcelRequire('iSOzX'));

});

parcelRegister("3MfRg", function(module, exports) {

let $2c0227debdd6f9d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2c0227debdd6f9d9$var$load("dzFRq").then(()=>parcelRequire('eBxLi'));

});

parcelRegister("8GHTS", function(module, exports) {

let $65344ca64273a036$var$load = (parcelRequire("28QjX"))(4);
module.exports = $65344ca64273a036$var$load("DijSr").then(()=>parcelRequire('8e7FB'));

});

parcelRegister("iDINQ", function(module, exports) {

let $d91e9f78456f87ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d91e9f78456f87ec$var$load("abWEg").then(()=>parcelRequire('bSBGI'));

});

parcelRegister("avWuc", function(module, exports) {

let $7a7a2ac1dfd6d20e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a7a2ac1dfd6d20e$var$load("6OcKU").then(()=>parcelRequire('jStmS'));

});

parcelRegister("7mRR8", function(module, exports) {

let $55d45d2a793960aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55d45d2a793960aa$var$load("ffJfg").then(()=>parcelRequire('lVomF'));

});

parcelRegister("hhRcH", function(module, exports) {

let $c95d4b5c58f8de0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c95d4b5c58f8de0c$var$load("3qpTf").then(()=>parcelRequire('gV19l'));

});

parcelRegister("6zd31", function(module, exports) {

let $4c8021fc781a1dce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c8021fc781a1dce$var$load("eK7PP").then(()=>parcelRequire('iRfhX'));

});

parcelRegister("dWqMX", function(module, exports) {

let $a26578cc82e9244d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a26578cc82e9244d$var$load("lt3Cs").then(()=>parcelRequire('kEMuB'));

});

parcelRegister("AYLPF", function(module, exports) {

let $06f280a925b1a0c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $06f280a925b1a0c0$var$load("dHRzd").then(()=>parcelRequire('lJY2E'));

});

parcelRegister("kuyLU", function(module, exports) {

let $eeb194e95369a68f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eeb194e95369a68f$var$load("hwtzD").then(()=>parcelRequire('icvbb'));

});

parcelRegister("aJNtk", function(module, exports) {

let $7d147b7cef45b1ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d147b7cef45b1ad$var$load("7KTDh").then(()=>parcelRequire('btUKW'));

});

parcelRegister("6NSn1", function(module, exports) {

let $4f417e81a6d8cf92$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f417e81a6d8cf92$var$load("ly7Tk").then(()=>parcelRequire('UaJXH'));

});

parcelRegister("9nKnc", function(module, exports) {

let $6d4a3bc61a0abadb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d4a3bc61a0abadb$var$load("5nTxr").then(()=>parcelRequire('dqi2n'));

});

parcelRegister("a1Urr", function(module, exports) {

let $74d5c7870b6e24d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $74d5c7870b6e24d0$var$load("cuJeo").then(()=>parcelRequire('deEZs'));

});

parcelRegister("3KPzJ", function(module, exports) {

let $2bbdacbfddda11a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bbdacbfddda11a1$var$load("7khh5").then(()=>parcelRequire('gtyia'));

});

parcelRegister("bxanm", function(module, exports) {

let $865ad335ab3b7d27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865ad335ab3b7d27$var$load("35Enp").then(()=>parcelRequire('cRlYl'));

});

parcelRegister("e7v7R", function(module, exports) {

let $a479dd13cfb78f86$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a479dd13cfb78f86$var$load("2yjYv").then(()=>parcelRequire('c7xZi'));

});

parcelRegister("SCees", function(module, exports) {

let $0a42b2a787c0725f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a42b2a787c0725f$var$load("3l58i").then(()=>parcelRequire('4rorX'));

});

parcelRegister("e68UC", function(module, exports) {

let $a43889fd69003bb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a43889fd69003bb6$var$load("4mWuc").then(()=>parcelRequire('1vLaj'));

});

parcelRegister("1diT2", function(module, exports) {

let $0e25a7d85e0988e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e25a7d85e0988e0$var$load("lG0k3").then(()=>parcelRequire('auLUs'));

});

parcelRegister("eCwMW", function(module, exports) {

let $aa4e0c675e7f1870$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa4e0c675e7f1870$var$load("jvhrA").then(()=>parcelRequire('3SBDK'));

});



parcelRegister("fiX4W", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $b2465d41ca8b525b$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "ProFormaIntlProvider", () => $b2465d41ca8b525b$export$23e25b3437f9c000);
$parcel$export(module.exports, "withProFormaIntlProvider", () => $b2465d41ca8b525b$export$a98a2d834cadecf0);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $dS3PR = parcelRequire("dS3PR");

var $ioVpW = parcelRequire("ioVpW");

var $hPkt9 = parcelRequire("hPkt9");
const $b2465d41ca8b525b$export$1af4c7e47ad72f44 = 'en-US';
const $b2465d41ca8b525b$export$23e25b3437f9c000 = ({ children: children, i18nMessages: i18nMessages, locale: locale })=>{
    var _ref, _ref2;
    // `commonCoreI18nMessages` is a temporary variable required only while we need to maintain
    // access to the 'proforma-common-core' translations for other packages. Once the translations
    // are properly per package, this can be removed.
    const commonCoreI18nMessages = (0, $hPkt9.useLazyI18nMessages)(locale, (0, $ioVpW.default));
    if (!commonCoreI18nMessages) return null;
    const { language: language, country: country } = (0, $hPkt9.getCodesFromLocale)(locale);
    const messages = (_ref = (_ref2 = country && i18nMessages[`${language}_${country}`]) !== null && _ref2 !== void 0 ? _ref2 : i18nMessages[language]) !== null && _ref !== void 0 ? _ref : i18nMessages.en;
    // `aggregateMessages` is a temporary variable required only while we need to maintain
    // access to the 'proforma-common-core' translations for other packages. Once the translations
    // are properly per package, this can be removed.
    const aggregateMessages = {
        ...commonCoreI18nMessages,
        ...messages
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        messages: aggregateMessages,
        locale: country ? `${language}-${country}` : language,
        defaultLocale: $b2465d41ca8b525b$export$1af4c7e47ad72f44,
        defaultRichTextElements: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                    weight: "bold"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                    as: "strong"
                }, chunks)
        }
    }, children);
};
const $b2465d41ca8b525b$export$a98a2d834cadecf0 = (i18nMessages, WrappedComponent)=>(props)=>{
        const intl = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b2465d41ca8b525b$export$23e25b3437f9c000, {
            i18nMessages: i18nMessages,
            locale: intl.locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
    };

});
parcelRegister("hPkt9", function(module, exports) {

$parcel$export(module.exports, "getCodesFromLocale", () => $cfa713d6b7186a1c$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyI18nMessages", () => $cfa713d6b7186a1c$export$30a7082641f381ea);

var $5uXOq = parcelRequire("5uXOq");

var $fiX4W = parcelRequire("fiX4W");
const $cfa713d6b7186a1c$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $cfa713d6b7186a1c$export$4d25b49b6dc1b540 = (locale)=>{
    let match = $cfa713d6b7186a1c$var$localeRegex.exec(locale);
    if (!match) {
        // eslint-disable-next-line no-console
        console.error('Unable to get language and country from invalid locale, falling back to default locale.');
        match = $cfa713d6b7186a1c$var$localeRegex.exec((0, $fiX4W.DEFAULT_LOCALE));
    }
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country === null || country === void 0 ? void 0 : country.toUpperCase()
    };
};
const $cfa713d6b7186a1c$var$loadLazyI18nMessages = async (locale, lazyI18nMessages)=>{
    var _await$default, _await, _ref;
    const { language: language, country: country } = $cfa713d6b7186a1c$export$4d25b49b6dc1b540(locale);
    return (_await$default = (_await = await ((_ref = country && lazyI18nMessages[`${language}_${country}`] || lazyI18nMessages[language] || lazyI18nMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
};
const $cfa713d6b7186a1c$export$30a7082641f381ea = (locale, lazyI18nMessages)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        $cfa713d6b7186a1c$var$loadLazyI18nMessages(locale, lazyI18nMessages).catch(()=>({})).then(setMessages);
    }, [
        locale,
        setMessages,
        lazyI18nMessages
    ]);
    return messages;
};

});


parcelRegister("8v3RR", function(module, exports) {

$parcel$export(module.exports, "NoticeDialog", () => $63043807ff653784$export$7ccde09c2c5f5940);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dS3PR = parcelRequire("dS3PR");

var $abT4b = parcelRequire("abT4b");

var $fsAfP = parcelRequire("fsAfP");

var $7fcWf = parcelRequire("7fcWf");
const $63043807ff653784$export$7ccde09c2c5f5940 = ({ title: title, titleVars: titleVars, message: message, messageVars: messageVars, confirmText: confirmText, confirmLink: confirmLink, handleClose: handleClose, isErrorNotice: isErrorNotice, errorDetails: errorDetails, isWarningNotice: isWarningNotice, overrideZIndex: overrideZIndex })=>{
    const appearance = isErrorNotice ? 'danger' : isWarningNotice ? 'warning' : undefined;
    const actions = [];
    if (isErrorNotice) ;
    else if (confirmLink) actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close]),
        onClick: ()=>handleClose(false),
        appearance: 'subtle'
    });
    else actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Cancel]),
        onClick: ()=>handleClose(false),
        appearance: 'subtle'
    });
    const primaryButtonAppearance = appearance || 'primary';
    if (confirmLink) actions.push({
        // @ts-ignore
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), confirmText),
        href: confirmLink,
        target: '_blank',
        rel: 'noopener noreferrer',
        appearance: primaryButtonAppearance
    });
    else actions.push({
        // @ts-ignore
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), confirmText),
        onClick: ()=>handleClose(true),
        appearance: primaryButtonAppearance
    });
    let onOpenCompleteF;
    if (overrideZIndex) onOpenCompleteF = (node, isAppearing)=>{
        overrideZIndex && node.parentElement ? node.parentElement.style.zIndex = '5000' : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onOpenComplete: onOpenCompleteF,
        onClose: ()=>handleClose(),
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: appearance
    }, /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, title, {
        values: titleVars
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, message, {
        values: messageVars
    }))), isErrorNotice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ErrorExplanations1]), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abT4b.PfLink), {
        href: "http://links.thinktilt.net/error-explanations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ErrorExplanations2])), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ErrorExplanations3]), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abT4b.PfLink), {
        href: "https://support.thinktilt.com/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ErrorExplanations4])), "."), !!errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fsAfP.ErrorSection), {
        errorDetails: errorDetails
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, actions.map(({ text: text, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), props, text))));
};

});
parcelRegister("abT4b", function(module, exports) {

$parcel$export(module.exports, "PfLink", () => $76b5a57dfb2cdc0a$export$9522c077a5f2be27);

var $5uXOq = parcelRequire("5uXOq");
const $76b5a57dfb2cdc0a$export$9522c077a5f2be27 = ({ href: href, onClick: onClick, id: id, popup: popup = true, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: href,
        id: id,
        rel: popup ? 'noreferrer noopener' : undefined,
        target: popup ? '_blank' : undefined,
        onClick: onClick
    }, children);
};

});

parcelRegister("fsAfP", function(module, exports) {

$parcel$export(module.exports, "ErrorSection", () => $b41597dfedacbba9$export$b0bceea2ea86179a);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $dS3PR = parcelRequire("dS3PR");


var $dTlW6 = parcelRequire("dTlW6");
const $b41597dfedacbba9$export$b0bceea2ea86179a = ({ errorDetails: errorDetails })=>{
    const [showErrorDetails, setShowErrorDetails] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b41597dfedacbba9$var$ErrorSectionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, "Show error details:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        isChecked: showErrorDetails,
        onChange: ()=>{
            setShowErrorDetails(!showErrorDetails);
        }
    })), showErrorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b41597dfedacbba9$var$ErrorDetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b41597dfedacbba9$var$ErrorSectionLabel = (0, $dAHxw.default).div({
    display: 'flex',
    marginTop: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> p': {
        marginTop: "var(--ds-space-025, 2px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b41597dfedacbba9$var$ErrorDetailsWrapper = (0, $dAHxw.default).div({
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("dAHxw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e506934574c3414$export$2e2bcd8739ae039);
parcelRequire("bS32t");
parcelRequire("5uXOq");
parcelRequire("bS0aY");

var $bWGt6 = parcelRequire("bWGt6");

parcelRequire("l9ACI");
parcelRequire("7PpcK");
parcelRequire("lDKn9");
var $9e506934574c3414$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $9e506934574c3414$var$newStyled = (0, $bWGt6.default).bind();
$9e506934574c3414$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $9e506934574c3414$var$newStyled[tagName] = $9e506934574c3414$var$newStyled(tagName);
});
var $9e506934574c3414$export$2e2bcd8739ae039 = $9e506934574c3414$var$newStyled;

});

parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});

parcelRegister("aFYTH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c13696afcc546e8bf0fe91a6c236c8d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));

var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c5cf8a572bea882$var$CrossIcon = (props)=>/*#__PURE__*/ $7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
    }, props));
$7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;

});

parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});






parcelRegister("gFGsm", function(module, exports) {

$parcel$export(module.exports, "LiveErrorUtils", () => $c23168a474488ad4$export$f2a509cffb92cb9c);
/* eslint-disable no-console */ 
var $5uXOq = parcelRequire("5uXOq");

var $31NxU = parcelRequire("31NxU");
var $3kk8J = parcelRequire("3kk8J");
var $8vvJk = parcelRequire("8vvJk");

var $ousew = parcelRequire("ousew");

var $dD7Zc = parcelRequire("dD7Zc");


var $h8yj2 = parcelRequire("h8yj2");

var $aIZdc = parcelRequire("aIZdc");

var $9e9ba = parcelRequire("9e9ba");

var $erWXD = parcelRequire("erWXD");

var $bRqoO = parcelRequire("bRqoO");

var $fxMku = parcelRequire("fxMku");
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $c23168a474488ad4$var$TAGS = [
    'module',
    'actionSubject',
    'url'
];
// From https://sentry.io/settings/atlassian-2y/projects/proforma/keys/
const $c23168a474488ad4$var$SENTRY_PUBLIC_KEY = 'c6ac6cc7ef554e3286ec09d412c9c1f4';
const $c23168a474488ad4$var$SENTRY_PROJECT_ID = '6388218';
const $c23168a474488ad4$var$SENTRY_COMMERCIAL_DSN = `https://${$c23168a474488ad4$var$SENTRY_PUBLIC_KEY}@o55978.ingest.sentry.io/${$c23168a474488ad4$var$SENTRY_PROJECT_ID}`;
const $c23168a474488ad4$var$SENTRY_FEDRAMP_DSN = `https://${$c23168a474488ad4$var$SENTRY_PUBLIC_KEY}@sentry.atlassian-us-gov-mod.com/${$c23168a474488ad4$var$SENTRY_PROJECT_ID}`;
const $c23168a474488ad4$var$PROFORMA_SENTRY_PROJECT_DSN = (0, $aIZdc.isFedRamp)() ? $c23168a474488ad4$var$SENTRY_FEDRAMP_DSN : $c23168a474488ad4$var$SENTRY_COMMERCIAL_DSN;
class $c23168a474488ad4$export$f2a509cffb92cb9c {
    constructor(moduleName, showFlag, createAnalyticsEvent, environment){
        this.moduleName = void 0;
        this.showFlag = void 0;
        this.createAnalyticsEvent = void 0;
        this.sentryHub = void 0;
        this.environment = void 0;
        this.moduleName = moduleName;
        this.showFlag = showFlag;
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.environment = environment;
        this.sentryHub = this.getSentryHub(environment);
    }
    reportError(error, options) {
        var _options$actionSubjec;
        const errorPrefix = `Proforma(${this.moduleName}): `;
        const severity = options !== null && options !== void 0 && options.severity ? options.severity : (0, $8vvJk.Severity).Error;
        // 1) Log error in console
        switch(severity){
            case (0, $8vvJk.Severity).Warning:
                console.warn(errorPrefix, error);
                break;
            case (0, $8vvJk.Severity).Info:
                console.info(errorPrefix, error);
                break;
            default:
                console.error(errorPrefix, error);
                break;
        }
        const actionSubject = (_options$actionSubjec = options === null || options === void 0 ? void 0 : options.actionSubject) !== null && _options$actionSubjec !== void 0 ? _options$actionSubjec : (0, $erWXD.ActionSubject).PROFORMA_UI;
        const attributes = (options === null || options === void 0 ? void 0 : options.attributes) && Object.fromEntries(Object.entries(options.attributes).map(([key, value])=>[
                key,
                typeof value === 'string' ? (0, $9e9ba.maskEmailIds)(value) : value
            ]));
        // Todo: add user agent, package version, url,
        const details = {
            actionSubject: actionSubject,
            errorId: options === null || options === void 0 ? void 0 : options.id,
            severity: severity,
            module: this.moduleName,
            errorMsg: error.message,
            errorInfo: options === null || options === void 0 ? void 0 : options.errorInfo,
            isClientFetchError: error.isClientFetchError,
            requestName: error.requestName,
            traceId: error.traceId,
            status: error.status,
            userAgent: this.getBrowserUserAgent(),
            url: this.getUrl(),
            ...attributes
        };
        // 2) Send error to Atlassian analytics pipeline (GasV3)
        (0, $h8yj2.fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, $erWXD.Action).FAILED}`, details);
        // 3) Send error to Sentry
        if (this.environment === (0, $fxMku.Environment).LOCAL || this.sentryHub === undefined) return;
        const sentryHub = this.sentryHub;
        sentryHub.withScope((scope)=>{
            scope.setLevel(severity);
            Object.keys(details).forEach((key)=>{
                const value = details[key];
                if (value) {
                    if ($c23168a474488ad4$var$TAGS.includes(key)) scope.setTag(key, value.toString());
                    else scope.setExtra(key, value);
                }
            });
            sentryHub.captureException(error);
        });
    }
    /**
   * @private
   * @deprecated notifyUser has been deprecated. Please use the `useFlags()` hook directly instead.
   */ notifyUser(errorNotice, customDescription) {
        const notice = (0, $bRqoO.Notices)[errorNotice];
        if (notice) {
            this.showFlag({
                appearance: 'error',
                isAutoDismiss: true,
                //TO DO - https://product-fabric.atlassian.net/browse/DSP-21423
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                    label: "",
                    LEGACY_secondaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
                    color: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), notice.title),
                description: customDescription ? customDescription : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), notice.message)
            });
            return Promise.resolve();
        } else {
            console.error(`Could not show error, notice type ${errorNotice} does not exist`);
            return Promise.reject();
        }
    }
    getSentryHub(environment) {
        try {
            const client = new (0, $31NxU.BrowserClient)({
                environment: environment,
                dsn: $c23168a474488ad4$var$PROFORMA_SENTRY_PROJECT_DSN
            });
            return new (0, $3kk8J.Hub)(client);
        } catch (error) {
            const actionSubject = 'getProformaSentryHub';
            const details = {
                actionSubject: actionSubject,
                severity: (0, $8vvJk.Severity).Error,
                module: this.moduleName,
                errorMsg: error.message,
                userAgent: this.getBrowserUserAgent(),
                url: this.getUrl()
            };
            (0, $h8yj2.fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, $erWXD.Action).FAILED}`, details);
        }
    }
    getBrowserUserAgent() {
        var _window$navigator$use, _window, _window$navigator;
        return (_window$navigator$use = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) !== null && _window$navigator$use !== void 0 ? _window$navigator$use : 'unknown';
    }
    getUrl() {
        var _window$document$loca, _window2, _window2$document, _window2$document$loc;
        return (_window$document$loca = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$document = _window2.document) === null || _window2$document === void 0 ? void 0 : (_window2$document$loc = _window2$document.location) === null || _window2$document$loc === void 0 ? void 0 : _window2$document$loc.host) !== null && _window$document$loca !== void 0 ? _window$document$loca : 'unknown';
    }
}

});
parcelRegister("31NxU", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $2347e5dedbca2ded$export$1df9218a526d318d);

var $3VFsf = parcelRequire("3VFsf");

var $fVKZK = parcelRequire("fVKZK");
var $9Up1Q = parcelRequire("9Up1Q");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $1jQdQ = parcelRequire("1jQdQ");

var $86ilb = parcelRequire("86ilb");

var $7n7dK = parcelRequire("7n7dK");

var $3Y2SJ = parcelRequire("3Y2SJ");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $2347e5dedbca2ded$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $9Up1Q.SDK_VERSION)
                }
            ],
            version: (0, $9Up1Q.SDK_VERSION)
        };
        _this = _super.call(this, (0, $1jQdQ.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $gI8Be.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $86ilb.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $7n7dK.injectReportDialog)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $3Y2SJ.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $fVKZK.BaseClient));

});
parcelRegister("fVKZK", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $b990a217eb724e06$export$4f22f74eddb7716a);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $3knVN = parcelRequire("3knVN");

var $bYhbK = parcelRequire("bYhbK");
var $b990a217eb724e06$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $b990a217eb724e06$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $gI8Be.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $gI8Be.checkOrSetAlreadyCaught)(exception)) {
            (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).log($b990a217eb724e06$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $gI8Be.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $gI8Be.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).log($b990a217eb724e06$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $bYhbK.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $3VFsf.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $gI8Be.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $gI8Be.uuid4)()),
            timestamp: event.timestamp || (0, $gI8Be.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $gfYRq.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $gI8Be.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $gI8Be.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, b), b.data && {
                    data: (0, $gI8Be.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $gI8Be.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $gI8Be.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $gI8Be.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $gI8Be.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $gI8Be.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $gI8Be.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $3VFsf.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $gI8Be.rejectedSyncPromise)(new (0, $gI8Be.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $gI8Be.rejectedSyncPromise)(new (0, $gI8Be.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $gI8Be.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $b990a217eb724e06$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $gI8Be.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $gI8Be.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $gI8Be.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $b990a217eb724e06$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $gI8Be.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $gI8Be.isPlainObject)(event) || event === null)) throw new (0, $gI8Be.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $gI8Be.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $gI8Be.isPlainObject)(rv) || rv === null)) throw new (0, $gI8Be.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("3xuhl", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("hZpZ3")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("fB1v8")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("fB1v8")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("ha3jm")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("ha3jm")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("f7sqx")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("eUO5L")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("iDqcL")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("okkfE")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("okkfE")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("okkfE")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("okkfE")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("okkfE")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("okkfE")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("okkfE")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("okkfE")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("okkfE")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("okkfE")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("aHQIJ")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("1vYJz")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("1vYJz")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("1vYJz")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("1vYJz")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("1vYJz")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("1vYJz")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("gBQwe")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("gBQwe")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("59M0S")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("59M0S")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("59M0S")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("59M0S")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("59M0S")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("59M0S")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("6dKoA")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("5L8AU")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("1M66C")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("1M66C")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("h2Oxu")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("keOcA")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("keOcA")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("keOcA")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("9BO8q")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("9BO8q")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("9BO8q")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("4mVTs")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("4mVTs")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("4mVTs")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("2cvr9")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("2cvr9")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("2cvr9")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("fLq1q")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("giEo2")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("giEo2")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("giEo2")).updateRateLimits);
parcelRequire("hZpZ3");
parcelRequire("fB1v8");
parcelRequire("ha3jm");

parcelRequire("f7sqx");
parcelRequire("eUO5L");
parcelRequire("iDqcL");
parcelRequire("okkfE");
parcelRequire("aHQIJ");

parcelRequire("1vYJz");

var $3kiq9 = parcelRequire("3kiq9");
parcelRequire("gBQwe");
parcelRequire("59M0S");

parcelRequire("6dKoA");
parcelRequire("5L8AU");
parcelRequire("1M66C");
parcelRequire("h2Oxu");
parcelRequire("keOcA");
parcelRequire("9BO8q");
parcelRequire("4mVTs");

var $gI8Be = parcelRequire("gI8Be");


parcelRequire("2cvr9");
parcelRequire("fLq1q");
parcelRequire("giEo2");
$parcel$exportWildcard(module.exports, $3kiq9);
$parcel$exportWildcard(module.exports, $gI8Be);

});

parcelRegister("3knVN", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $26c5cd9556cd8ba2$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $26c5cd9556cd8ba2$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("bYhbK", function(module, exports) {

$parcel$export(module.exports, "setupIntegrations", () => $8b72a18ea9aa7e3f$export$51abed9797baa598);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
var $3kk8J = parcelRequire("3kk8J");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $3knVN = parcelRequire("3knVN");
var $8b72a18ea9aa7e3f$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $8b72a18ea9aa7e3f$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $8b72a18ea9aa7e3f$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $3VFsf.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $3VFsf.__spread)($8b72a18ea9aa7e3f$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $3VFsf.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $8b72a18ea9aa7e3f$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $3VFsf.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $8b72a18ea9aa7e3f$export$e7390a03b70a6f2f(integration) {
    if ($8b72a18ea9aa7e3f$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $gfYRq.addGlobalEventProcessor), (0, $3kk8J.getCurrentHub));
    $8b72a18ea9aa7e3f$export$b14a8888f80a0b3e.push(integration.name);
    (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).log("Integration installed: " + integration.name);
}
function $8b72a18ea9aa7e3f$export$51abed9797baa598(options) {
    var integrations = {};
    $8b72a18ea9aa7e3f$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $8b72a18ea9aa7e3f$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $gI8Be.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("9Up1Q", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $736cc23961be74e3$export$31499a9cd224b78c);
var $736cc23961be74e3$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("1jQdQ", function(module, exports) {

$parcel$export(module.exports, "BrowserBackend", () => $0f601308e4e6ba6f$export$2526e21aec9d0ce7);

var $3VFsf = parcelRequire("3VFsf");

var $ccWrZ = parcelRequire("ccWrZ");
var $S4fte = parcelRequire("S4fte");

var $8vvJk = parcelRequire("8vvJk");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $c8Het = parcelRequire("c8Het");

var $bUa9S = parcelRequire("bUa9S");
var $huxes = parcelRequire("huxes");
var $5egvK = parcelRequire("5egvK");
var $2EUFJ = parcelRequire("2EUFJ");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $0f601308e4e6ba6f$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $c8Het.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $8vvJk.Severity).Info;
        return (0, $c8Het.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $S4fte.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $S4fte.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $gI8Be.supportsFetch)()) {
            var requestOptions = (0, $3VFsf.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $huxes.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $bUa9S.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $5egvK.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $2EUFJ.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $ccWrZ.BaseBackend));

});
parcelRegister("ccWrZ", function(module, exports) {

$parcel$export(module.exports, "BaseBackend", () => $8e33f21400272aa3$export$8f43a53a38d7e95f);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $S4fte = parcelRequire("S4fte");

var $3knVN = parcelRequire("3knVN");

var $bf08D = parcelRequire("bf08D");

var $aMFZ3 = parcelRequire("aMFZ3");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $8e33f21400272aa3$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $gI8Be.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $gI8Be.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $S4fte.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $bf08D.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $S4fte.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $3VFsf.__read)((0, $bf08D.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $3knVN.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $aMFZ3.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("S4fte", function(module, exports) {

$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $0a2856eddb28200f$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $0a2856eddb28200f$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $0a2856eddb28200f$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $0a2856eddb28200f$export$671c7ed8e40a7a57);
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");
var $0a2856eddb28200f$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $0a2856eddb28200f$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $gI8Be.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $0a2856eddb28200f$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $0a2856eddb28200f$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $0a2856eddb28200f$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $0a2856eddb28200f$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $0a2856eddb28200f$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $gI8Be.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $0a2856eddb28200f$var$_getIngestEndpoint(dsn, target) {
    return "" + $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0a2856eddb28200f$var$_encodedAuth(dsn) {
    return (0, $gI8Be.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $0a2856eddb28200f$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $0a2856eddb28200f$var$getStoreEndpoint(dsn) {
    return $0a2856eddb28200f$var$_getIngestEndpoint(dsn, 'store');
}
function $0a2856eddb28200f$export$c1677e22ac2217a5(dsn) {
    return $0a2856eddb28200f$var$getStoreEndpoint(dsn) + "?" + $0a2856eddb28200f$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $0a2856eddb28200f$var$_getEnvelopeEndpoint(dsn) {
    return $0a2856eddb28200f$var$_getIngestEndpoint(dsn, 'envelope');
}
function $0a2856eddb28200f$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $0a2856eddb28200f$var$_getEnvelopeEndpoint(dsn) + "?" + $0a2856eddb28200f$var$_encodedAuth(dsn);
}
function $0a2856eddb28200f$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $0a2856eddb28200f$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $0a2856eddb28200f$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $gI8Be.makeDsn)(dsnLike);
    var endpoint = $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $gI8Be.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("bf08D", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $82f133e7faf6394e$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $82f133e7faf6394e$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $82f133e7faf6394e$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $82f133e7faf6394e$export$2006389de558b996);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("3xuhl");
var $2cvr9 = parcelRequire("2cvr9");
var $gI8Be = parcelRequire("gI8Be");

var $S4fte = parcelRequire("S4fte");
/** Extract sdk info from from the API metadata */ function $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $3VFsf.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $3VFsf.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $82f133e7faf6394e$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $gI8Be.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $2cvr9.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $82f133e7faf6394e$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $3VFsf.__read)($82f133e7faf6394e$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $2cvr9.serializeEnvelope)(envelope),
        type: type,
        url: (0, $S4fte.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $82f133e7faf6394e$export$c31057337a18010f(event, api) {
    var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $gI8Be.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $2cvr9.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $82f133e7faf6394e$export$2006389de558b996(event, api) {
    var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $gI8Be.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $S4fte.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $S4fte.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $gI8Be.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $2cvr9.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $2cvr9.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("aMFZ3", function(module, exports) {

$parcel$export(module.exports, "NoopTransport", () => $7d9ef429c62e7388$export$6f2767450ea1346c);
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");
/** Noop transport */ var $7d9ef429c62e7388$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $gI8Be.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $gI8Be.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("c8Het", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $8d67c476e355940c$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $8d67c476e355940c$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $8d67c476e355940c$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $8d67c476e355940c$export$5425b53185d13d6c);

var $3VFsf = parcelRequire("3VFsf");

var $8vvJk = parcelRequire("8vvJk");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $6hYiK = parcelRequire("6hYiK");
function $8d67c476e355940c$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $8d67c476e355940c$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $8d67c476e355940c$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $8d67c476e355940c$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $gI8Be.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $gI8Be.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $gI8Be.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $8d67c476e355940c$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $8d67c476e355940c$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $8d67c476e355940c$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $8d67c476e355940c$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $8d67c476e355940c$var$getPopSize(ex);
    try {
        return (0, $gI8Be.createStackParser)((0, $6hYiK.opera10StackParser), (0, $6hYiK.opera11StackParser), (0, $6hYiK.chromeStackParser), (0, $6hYiK.winjsStackParser), (0, $6hYiK.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $8d67c476e355940c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $8d67c476e355940c$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($8d67c476e355940c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $8d67c476e355940c$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $8d67c476e355940c$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $8d67c476e355940c$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $gI8Be.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $8vvJk.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $gI8Be.resolvedSyncPromise)(event);
}
function $8d67c476e355940c$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $8vvJk.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $8d67c476e355940c$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $gI8Be.resolvedSyncPromise)(event);
}
function $8d67c476e355940c$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $gI8Be.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $8d67c476e355940c$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $gI8Be.isDOMError)(exception) || (0, $gI8Be.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $8d67c476e355940c$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $gI8Be.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $8d67c476e355940c$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $gI8Be.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $gI8Be.isError)(exception)) // we have a real Error object, do nothing
    return $8d67c476e355940c$export$73fbea5a0a5234af(exception);
    if ((0, $gI8Be.isPlainObject)(exception) || (0, $gI8Be.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $8d67c476e355940c$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $gI8Be.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $8d67c476e355940c$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $gI8Be.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $gI8Be.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $8d67c476e355940c$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $8d67c476e355940c$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("6hYiK", function(module, exports) {

$parcel$export(module.exports, "chromeStackParser", () => $49431b32a95d7ea3$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $49431b32a95d7ea3$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $49431b32a95d7ea3$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $49431b32a95d7ea3$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $49431b32a95d7ea3$export$989a1824b4734ce6);

var $3VFsf = parcelRequire("3VFsf");
// global reference to slice
var $49431b32a95d7ea3$var$UNKNOWN_FUNCTION = '?';
var $49431b32a95d7ea3$var$OPERA10_PRIORITY = 10;
var $49431b32a95d7ea3$var$OPERA11_PRIORITY = 20;
var $49431b32a95d7ea3$var$CHROME_PRIORITY = 30;
var $49431b32a95d7ea3$var$WINJS_PRIORITY = 40;
var $49431b32a95d7ea3$var$GECKO_PRIORITY = 50;
function $49431b32a95d7ea3$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $49431b32a95d7ea3$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $49431b32a95d7ea3$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $49431b32a95d7ea3$var$chrome = function(line) {
    var parts = $49431b32a95d7ea3$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $49431b32a95d7ea3$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $3VFsf.__read)($49431b32a95d7ea3$var$extractSafariExtensionDetails(parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $49431b32a95d7ea3$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $49431b32a95d7ea3$export$c693d9295441d8f9 = [
    $49431b32a95d7ea3$var$CHROME_PRIORITY,
    $49431b32a95d7ea3$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $49431b32a95d7ea3$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $49431b32a95d7ea3$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $49431b32a95d7ea3$var$gecko = function(line) {
    var _a;
    var parts = $49431b32a95d7ea3$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $49431b32a95d7ea3$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION;
        _a = (0, $3VFsf.__read)($49431b32a95d7ea3$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $49431b32a95d7ea3$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $49431b32a95d7ea3$export$c9ddf1e2b5d48bff = [
    $49431b32a95d7ea3$var$GECKO_PRIORITY,
    $49431b32a95d7ea3$var$gecko
];
var $49431b32a95d7ea3$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $49431b32a95d7ea3$var$winjs = function(line) {
    var parts = $49431b32a95d7ea3$var$winjsRegex.exec(line);
    return parts ? $49431b32a95d7ea3$var$createFrame(parts[2], parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $49431b32a95d7ea3$export$b6d155d85c1dcba5 = [
    $49431b32a95d7ea3$var$WINJS_PRIORITY,
    $49431b32a95d7ea3$var$winjs
];
var $49431b32a95d7ea3$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $49431b32a95d7ea3$var$opera10 = function(line) {
    var parts = $49431b32a95d7ea3$var$opera10Regex.exec(line);
    return parts ? $49431b32a95d7ea3$var$createFrame(parts[2], parts[3] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $49431b32a95d7ea3$export$966ec832d9699d6 = [
    $49431b32a95d7ea3$var$OPERA10_PRIORITY,
    $49431b32a95d7ea3$var$opera10
];
var $49431b32a95d7ea3$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $49431b32a95d7ea3$var$opera11 = function(line) {
    var parts = $49431b32a95d7ea3$var$opera11Regex.exec(line);
    return parts ? $49431b32a95d7ea3$var$createFrame(parts[5], parts[3] || parts[4] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $49431b32a95d7ea3$export$989a1824b4734ce6 = [
    $49431b32a95d7ea3$var$OPERA11_PRIORITY,
    $49431b32a95d7ea3$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $49431b32a95d7ea3$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $49431b32a95d7ea3$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("bUa9S", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", () => $8aaccde9cc8aea61$export$2bdee3f9b92f4e82);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $7xYoj = parcelRequire("7xYoj");

var $ad8JG = parcelRequire("ad8JG");
/** `fetch` based transport */ var $8aaccde9cc8aea61$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $ad8JG.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $gI8Be.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $gI8Be.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $gI8Be.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $7xYoj.BaseTransport));

});
parcelRegister("7xYoj", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $57ea75eadd985084$export$74b99d619e90f481);

var $3VFsf = parcelRequire("3VFsf");

var $bf08D = parcelRequire("bf08D");
var $S4fte = parcelRequire("S4fte");
parcelRequire("3xuhl");
var $fLq1q = parcelRequire("fLq1q");
var $giEo2 = parcelRequire("giEo2");
var $gI8Be = parcelRequire("gI8Be");
var $2cvr9 = parcelRequire("2cvr9");

var $86ilb = parcelRequire("86ilb");

var $ad8JG = parcelRequire("ad8JG");
function $57ea75eadd985084$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $57ea75eadd985084$var$global = (0, $gI8Be.getGlobalObject)();
/** Base Transport class implementation */ var $57ea75eadd985084$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $gI8Be.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $S4fte.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $S4fte.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $57ea75eadd985084$var$global.document) $57ea75eadd985084$var$global.document.addEventListener('visibilitychange', function() {
            if ($57ea75eadd985084$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $bf08D.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $bf08D.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $57ea75eadd985084$var$requestTypeToCategory(category) + ":" + reason;
        (0, $86ilb.IS_DEBUG_BUILD) && (0, $gI8Be.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $86ilb.IS_DEBUG_BUILD) && (0, $gI8Be.logger).log('No outcomes to flush');
            return;
        }
        (0, $86ilb.IS_DEBUG_BUILD) && (0, $gI8Be.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $S4fte.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $3VFsf.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $fLq1q.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $gI8Be.dsnToString)(this._api.dsn));
        try {
            (0, $ad8JG.sendReport)(url, (0, $2cvr9.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $86ilb.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $gI8Be.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $giEo2.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $86ilb.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $gI8Be.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $57ea75eadd985084$var$requestTypeToCategory(requestType);
        return new Date((0, $giEo2.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $57ea75eadd985084$var$requestTypeToCategory(requestType);
        return (0, $giEo2.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("86ilb", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $5e5d1c5a13c7017d$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $5e5d1c5a13c7017d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("ad8JG", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", () => $76f1e50a4e2b3aa8$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $76f1e50a4e2b3aa8$export$84bb63b2c17ec44d);
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $86ilb = parcelRequire("86ilb");
var $76f1e50a4e2b3aa8$var$global = (0, $gI8Be.getGlobalObject)();
var $76f1e50a4e2b3aa8$var$cachedFetchImpl;
function $76f1e50a4e2b3aa8$export$8be2119ce08e3379() {
    if ($76f1e50a4e2b3aa8$var$cachedFetchImpl) return $76f1e50a4e2b3aa8$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $gI8Be.isNativeFetch)($76f1e50a4e2b3aa8$var$global.fetch)) return $76f1e50a4e2b3aa8$var$cachedFetchImpl = $76f1e50a4e2b3aa8$var$global.fetch.bind($76f1e50a4e2b3aa8$var$global);
    var document = $76f1e50a4e2b3aa8$var$global.document;
    var fetchImpl = $76f1e50a4e2b3aa8$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $86ilb.IS_DEBUG_BUILD) && (0, $gI8Be.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $76f1e50a4e2b3aa8$var$cachedFetchImpl = fetchImpl.bind($76f1e50a4e2b3aa8$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $76f1e50a4e2b3aa8$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($76f1e50a4e2b3aa8$var$global && $76f1e50a4e2b3aa8$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $76f1e50a4e2b3aa8$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $76f1e50a4e2b3aa8$var$global.navigator.sendBeacon.bind($76f1e50a4e2b3aa8$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $gI8Be.supportsFetch)()) {
        var fetch_1 = $76f1e50a4e2b3aa8$export$8be2119ce08e3379();
        return (0, $gI8Be.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("huxes", function(module, exports) {

$parcel$export(module.exports, "makeNewFetchTransport", () => $cbbf04388348e7ab$export$1c57e6bfd09bad13);

var $3VFsf = parcelRequire("3VFsf");

var $6Vta0 = parcelRequire("6Vta0");

var $ad8JG = parcelRequire("ad8JG");
function $cbbf04388348e7ab$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $ad8JG.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $3VFsf.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $6Vta0.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("6Vta0", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $50aeaf944e235b68$export$d09f50d9ab7f7b69);
parcelRequire("3xuhl");
var $giEo2 = parcelRequire("giEo2");
var $gI8Be = parcelRequire("gI8Be");
var $2cvr9 = parcelRequire("2cvr9");
var $50aeaf944e235b68$export$d8a725a7dce95622 = 'error';
var $50aeaf944e235b68$export$99adc6fe67a3c63e = 'transaction';
var $50aeaf944e235b68$export$9d7ad34f132fe68f = 'attachment';
var $50aeaf944e235b68$export$42d9e7b5fc564c45 = 'session';
var $50aeaf944e235b68$export$e515cf6dfd2f98b8 = 30;
function $50aeaf944e235b68$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $gI8Be.makePromiseBuffer)(options.bufferSize || $50aeaf944e235b68$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $2cvr9.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $2cvr9.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $giEo2.isRateLimited)(rateLimits, category)) return (0, $gI8Be.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $gI8Be.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $giEo2.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $gI8Be.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $gI8Be.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $giEo2.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("5egvK", function(module, exports) {

$parcel$export(module.exports, "makeNewXHRTransport", () => $3ceb115445ff80d8$export$4c0ac1dd4bbf4921);

var $6Vta0 = parcelRequire("6Vta0");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $3ceb115445ff80d8$var$XHR_READYSTATE_DONE = 4;
function $3ceb115445ff80d8$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $gI8Be.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $3ceb115445ff80d8$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $6Vta0.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("2EUFJ", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", () => $1efb47151abb73ac$export$874a283af77e8e62);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $7xYoj = parcelRequire("7xYoj");
/** `XHR` based transport */ var $1efb47151abb73ac$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $gI8Be.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $gI8Be.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $7xYoj.BaseTransport));

});


parcelRegister("7n7dK", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreOnError", () => $55e0484034c91259$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $55e0484034c91259$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $55e0484034c91259$export$deb9aac8ea0b576c);

var $3VFsf = parcelRequire("3VFsf");

var $7zHWg = parcelRequire("7zHWg");
var $S4fte = parcelRequire("S4fte");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");

var $86ilb = parcelRequire("86ilb");
var $55e0484034c91259$var$global = (0, $gI8Be.getGlobalObject)();
var $55e0484034c91259$var$ignoreOnError = 0;
function $55e0484034c91259$export$b79738ab10c590b2() {
    return $55e0484034c91259$var$ignoreOnError > 0;
}
function $55e0484034c91259$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $55e0484034c91259$var$ignoreOnError += 1;
    setTimeout(function() {
        $55e0484034c91259$var$ignoreOnError -= 1;
    });
}
function $55e0484034c91259$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $gI8Be.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $55e0484034c91259$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $55e0484034c91259$export$1265a142ff5ba165();
            (0, $7zHWg.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $gI8Be.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $gI8Be.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $7zHWg.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $gI8Be.markFunctionWrapped)(sentryWrapped, fn);
    (0, $gI8Be.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $55e0484034c91259$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$55e0484034c91259$var$global.document) return;
    if (!options.eventId) {
        (0, $86ilb.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $86ilb.IS_DEBUG_BUILD) && (0, $gI8Be.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $55e0484034c91259$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $S4fte.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $55e0484034c91259$var$global.document.head || $55e0484034c91259$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("3Y2SJ", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $2e3935ee4e2a5168$export$2dc68d50d56fbbd);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");

var $8vvJk = parcelRequire("8vvJk");
parcelRequire("3xuhl");
var $gI8Be = parcelRequire("gI8Be");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $2e3935ee4e2a5168$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $3VFsf.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $gI8Be.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $gI8Be.addInstrumentationHandler)('console', $2e3935ee4e2a5168$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $gI8Be.addInstrumentationHandler)('dom', $2e3935ee4e2a5168$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $gI8Be.addInstrumentationHandler)('xhr', $2e3935ee4e2a5168$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $gI8Be.addInstrumentationHandler)('fetch', $2e3935ee4e2a5168$var$_fetchBreadcrumb);
        if (this._options.history) (0, $gI8Be.addInstrumentationHandler)('history', $2e3935ee4e2a5168$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2e3935ee4e2a5168$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $gI8Be.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $gI8Be.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2e3935ee4e2a5168$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $gI8Be.severityFromString)(handlerData.level),
        message: (0, $gI8Be.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $gI8Be.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $3kk8J.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2e3935ee4e2a5168$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2e3935ee4e2a5168$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $8vvJk.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2e3935ee4e2a5168$var$_historyBreadcrumb(handlerData) {
    var global = (0, $gI8Be.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $gI8Be.parseUrl)(global.location.href);
    var parsedFrom = (0, $gI8Be.parseUrl)(from);
    var parsedTo = (0, $gI8Be.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("9e9ba", function(module, exports) {

$parcel$export(module.exports, "maskEmailIds", () => $6b7c8aa13a9e7ef7$export$7a75efd77ad928b4);
const $6b7c8aa13a9e7ef7$var$EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
const $6b7c8aa13a9e7ef7$export$7a75efd77ad928b4 = (text)=>text.replace($6b7c8aa13a9e7ef7$var$EMAIL_REGEX, '***@***');

});



parcelRegister("av6gl", function(module, exports) {

$parcel$export(module.exports, "AddForm", () => $7a51a842404d7d1a$export$11223b1abaada9c7);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");


var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");


var $7K5PP = parcelRequire("7K5PP");

var $bv2Tr = parcelRequire("bv2Tr");

var $i9OHB = parcelRequire("i9OHB");

var $hTsMS = parcelRequire("hTsMS");

var $hnuQa = parcelRequire("hnuQa");

var $2sdeO = parcelRequire("2sdeO");

var $hAFzt = parcelRequire("hAFzt");

var $7J3wD = parcelRequire("7J3wD");

var $gATks = parcelRequire("gATks");
const $7a51a842404d7d1a$var$IconOption = ({ option: option, restrictionStatus: restrictionStatus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gATks.IconSelect), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnuQa.FormCardIcon), {
        restrictionStatus: restrictionStatus,
        isSelecting: true
    }), option);
const $7a51a842404d7d1a$var$AddFormBase = ({ onAdd: onAdd, onCancel: onCancel })=>{
    const intl = (0, $koVbs.default)();
    const { forms: forms, isLoading: isLoading, error: error } = (0, $2sdeO.useAddFormState)();
    const [selectedForm, setSelectedForm] = (0, $5uXOq.useState)(undefined);
    const handleOnAdd = ()=>{
        if (selectedForm) onAdd(selectedForm);
    };
    const buildSelectOptions = (availableForms)=>{
        if (availableForms.recommended.length > 0 && availableForms.available.length > 0) return [
            {
                label: intl.formatMessage((0, $7J3wD.messages).addFormSelectGroupRecommended),
                options: availableForms.recommended
            },
            {
                label: intl.formatMessage((0, $7J3wD.messages).addFormSelectGroupOther),
                options: availableForms.available
            }
        ];
        // flatten object values to 1D-Array
        return Object.values(availableForms).flat();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hAFzt.ErrorState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gATks.IssueFormSelectorStyles), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        id: "AddFormSelector",
        instanceId: "proforma-form-system.add-form.ui.issue-form-selector.add-form-select",
        tabSelectsValue: true,
        isLoading: isLoading,
        options: forms ? buildSelectOptions(forms) : [],
        defaultMenuIsOpen: true,
        label: intl.formatMessage((0, $7J3wD.messages).addFormSelectInputPlaceholder),
        placeholder: intl.formatMessage((0, $7J3wD.messages).addFormSelectInputPlaceholder),
        autoFocus: true,
        onChange: (_selectedForm)=>{
            if (_selectedForm && 'value' in _selectedForm) setSelectedForm(_selectedForm);
        },
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a51a842404d7d1a$var$IconOption, {
                option: option.label || intl.formatMessage((0, $7J3wD.messages).emptyFormName),
                restrictionStatus: option.restrictionStatus
            }),
        labelId: "react-select-proforma-form-system.add-form.ui.issue-form-selector.add-form-select-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gATks.ButtonRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: handleOnAdd,
        isDisabled: selectedForm === undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7J3wD.messages).addFormButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: ()=>{
            setSelectedForm(undefined);
            onCancel();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7J3wD.messages).cancelButton))))));
};
const $7a51a842404d7d1a$export$11223b1abaada9c7 = (props)=>{
    const { locale: locale } = (0, $koVbs.default)();
    const errorUtils = (0, $2sdeO.useAddFormErrorUtils)();
    if (!errorUtils) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9OHB.ProformaIntlProvider), {
        messages: (0, $hTsMS.default),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv2Tr.ErrorBoundary), {
        errorUtils: errorUtils,
        renderError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hAFzt.ErrorState), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a51a842404d7d1a$var$AddFormBase, props)));
};

});
parcelRegister("bv2Tr", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $85f4d5778164d0dc$export$e926676385687eaf);
/* eslint-disable react/destructuring-assignment */ 
var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $dS3PR = parcelRequire("dS3PR");

var $92Z2l = parcelRequire("92Z2l");

var $erWXD = parcelRequire("erWXD");
class $85f4d5778164d0dc$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            errorInfo: null,
            error: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo.componentStack
        });
        this.props.errorUtils.reportError(error, {
            actionSubject: (0, $erWXD.ActionSubject).PROFORMA_UI,
            id: 'errorBoundary',
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.hasError) {
            // Render error UI here
            const { renderError: renderError } = this.props;
            return renderError ? renderError({
                error: this.state.error
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f4d5778164d0dc$var$ErrorPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f4d5778164d0dc$var$ErrorPageSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
                appearance: "error",
                title: "Something went wrong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                as: "p"
            }, "Refresh the page and try again. ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), "If the error persists,", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: "https://support.thinktilt.com",
                target: "_blank",
                rel: "noopener noreferrer"
            }, "contact support"), "."))));
        }
        return this.props.children;
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85f4d5778164d0dc$var$ErrorPage = (0, $dAHxw.default).div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
const $85f4d5778164d0dc$var$ErrorPageSection = (0, $dAHxw.default).div({});

});

parcelRegister("hTsMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06de74d149dd62e$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */ 
























const $d06de74d149dd62e$var$lazyMessages = {
    cs: ()=>(parcelRequire("a0euB")),
    da: ()=>(parcelRequire("bvC3V")),
    de: ()=>(parcelRequire("fMnWv")),
    en: ()=>(parcelRequire("fiK4i")),
    en_GB: ()=>(parcelRequire("cScDM")),
    en_ZZ: ()=>(parcelRequire("7M3Pi")),
    es: ()=>(parcelRequire("g2uyY")),
    fi: ()=>(parcelRequire("cxakX")),
    fr: ()=>(parcelRequire("fLSq6")),
    hu: ()=>(parcelRequire("6kBGL")),
    it: ()=>(parcelRequire("lDcKQ")),
    ja: ()=>(parcelRequire("fqw2Z")),
    ko: ()=>(parcelRequire("jPARt")),
    nb: ()=>(parcelRequire("1MJVM")),
    nl: ()=>(parcelRequire("6ET94")),
    pl: ()=>(parcelRequire("8gvoL")),
    pt_BR: ()=>(parcelRequire("jasi2")),
    ru: ()=>(parcelRequire("gOrWq")),
    sv: ()=>(parcelRequire("cRWHc")),
    th: ()=>(parcelRequire("0lGVp")),
    tr: ()=>(parcelRequire("dt2DP")),
    uk: ()=>(parcelRequire("jL11Y")),
    vi: ()=>(parcelRequire("6tG1e")),
    zh: ()=>(parcelRequire("aoQaJ")),
    zh_TW: ()=>(parcelRequire("fDiqB"))
};
var $d06de74d149dd62e$export$2e2bcd8739ae039 = $d06de74d149dd62e$var$lazyMessages;

});
parcelRegister("a0euB", function(module, exports) {

let $748525653077b5a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $748525653077b5a7$var$load("8HX2i").then(()=>parcelRequire('2axnI'));

});

parcelRegister("bvC3V", function(module, exports) {

let $86101d5530bd19c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86101d5530bd19c0$var$load("b0nLq").then(()=>parcelRequire('e4hHg'));

});

parcelRegister("fMnWv", function(module, exports) {

let $b7cde93af6898da6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7cde93af6898da6$var$load("aXE5n").then(()=>parcelRequire('g2HH7'));

});

parcelRegister("fiK4i", function(module, exports) {

let $b23c45a5599a84ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b23c45a5599a84ad$var$load("lTxlH").then(()=>parcelRequire('fglIY'));

});

parcelRegister("cScDM", function(module, exports) {

let $95f4555ab185a506$var$load = (parcelRequire("28QjX"))(4);
module.exports = $95f4555ab185a506$var$load("kON2y").then(()=>parcelRequire('7aNOL'));

});

parcelRegister("7M3Pi", function(module, exports) {

let $5a8ffbf36772102d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a8ffbf36772102d$var$load("eYvdg").then(()=>parcelRequire('i2TKh'));

});

parcelRegister("g2uyY", function(module, exports) {

let $bad48a69d1fd3172$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bad48a69d1fd3172$var$load("1gXu0").then(()=>parcelRequire('bZAbe'));

});

parcelRegister("cxakX", function(module, exports) {

let $920095d05bb95f4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $920095d05bb95f4e$var$load("dLNBF").then(()=>parcelRequire('igpDq'));

});

parcelRegister("fLSq6", function(module, exports) {

let $b7b575752aef6734$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7b575752aef6734$var$load("8oIvg").then(()=>parcelRequire('7bVRR'));

});

parcelRegister("6kBGL", function(module, exports) {

let $49c1d88791eb94ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49c1d88791eb94ce$var$load("kRxHs").then(()=>parcelRequire('fWdTq'));

});

parcelRegister("lDcKQ", function(module, exports) {

let $fbf7224b4437f0cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fbf7224b4437f0cf$var$load("crpYp").then(()=>parcelRequire('frg6f'));

});

parcelRegister("fqw2Z", function(module, exports) {

let $b3b2249d210e907e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3b2249d210e907e$var$load("bLKJd").then(()=>parcelRequire('JNri8'));

});

parcelRegister("jPARt", function(module, exports) {

let $e6ff5fac5f5ab983$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6ff5fac5f5ab983$var$load("d47JO").then(()=>parcelRequire('6IPMP'));

});

parcelRegister("1MJVM", function(module, exports) {

let $14cde70c3f0cc42b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $14cde70c3f0cc42b$var$load("ftcUi").then(()=>parcelRequire('3HkCf'));

});

parcelRegister("6ET94", function(module, exports) {

let $4d914138aa6a8967$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d914138aa6a8967$var$load("5rLps").then(()=>parcelRequire('aWYNk'));

});

parcelRegister("8gvoL", function(module, exports) {

let $60482c6bb8f70cbd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60482c6bb8f70cbd$var$load("irfYs").then(()=>parcelRequire('3j2V3'));

});

parcelRegister("jasi2", function(module, exports) {

let $df44e549829e67a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $df44e549829e67a5$var$load("8hynA").then(()=>parcelRequire('8g2ln'));

});

parcelRegister("gOrWq", function(module, exports) {

let $c3d6fd6845f7f318$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3d6fd6845f7f318$var$load("56mbx").then(()=>parcelRequire('f9i5O'));

});

parcelRegister("cRWHc", function(module, exports) {

let $95e7f709589f9ad2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $95e7f709589f9ad2$var$load("1XRxm").then(()=>parcelRequire('ap02o'));

});

parcelRegister("0lGVp", function(module, exports) {

let $0010d3a66c8eb629$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0010d3a66c8eb629$var$load("YYSnT").then(()=>parcelRequire('lGvmY'));

});

parcelRegister("dt2DP", function(module, exports) {

let $9ce008550303bc4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ce008550303bc4c$var$load("ltbZw").then(()=>parcelRequire('3Rtcm'));

});

parcelRegister("jL11Y", function(module, exports) {

let $e62334d4e7e45d7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e62334d4e7e45d7a$var$load("kW8g5").then(()=>parcelRequire('heWlD'));

});

parcelRegister("6tG1e", function(module, exports) {

let $4b760b8ec39a39ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b760b8ec39a39ef$var$load("4cz5e").then(()=>parcelRequire('30zIL'));

});

parcelRegister("aoQaJ", function(module, exports) {

let $79249d8d2ac0502b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $79249d8d2ac0502b$var$load("7ehvN").then(()=>parcelRequire('iz96j'));

});

parcelRegister("fDiqB", function(module, exports) {

let $b618caf1c43aa11f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b618caf1c43aa11f$var$load("iEjIe").then(()=>parcelRequire('g1O7M'));

});


parcelRegister("hnuQa", function(module, exports) {

$parcel$export(module.exports, "FormCardIcon", () => $ca6c81ee2b600ce5$export$ee70f67f15460e27);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");


var $e4B5S = parcelRequire("e4B5S");

var $a8hd9 = parcelRequire("a8hd9");

var $2EYf6 = parcelRequire("2EYf6");

var $VSDnB = parcelRequire("VSDnB");


var $3bDjY = parcelRequire("3bDjY");

var $h8yj2 = parcelRequire("h8yj2");

var $5wvQR = parcelRequire("5wvQR");

var $erWXD = parcelRequire("erWXD");

var $k3kYV = parcelRequire("k3kYV");
const $ca6c81ee2b600ce5$export$ee70f67f15460e27 = ({ restrictionStatus: restrictionStatus, isSelecting: isSelecting })=>{
    const getFormLockedIcon = ()=>{
        const lockedIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a8hd9))), {
            color: isSelecting ? `var(--ds-icon-accent-red, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : `var(--ds-icon, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`,
            spacing: "none",
            label: ""
        });
        return !isSelecting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $k3kYV.messages).restrictedFormIconTooltip),
            onShow: (analyticsEvent)=>{
                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, (0, $erWXD.ActionSubject).FORM_PERMISSIONS);
            }
        }, lockedIcon) : lockedIcon;
    };
    return restrictionStatus === (0, $5wvQR.FormRestrictionStatus).RESTRICTED && (0, $VSDnB.fg)('granular_permissions_on_forms_m1') ? getFormLockedIcon() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e4B5S))), {
        LEGACY_fallbackIcon: (0, $2EYf6.default),
        color: "currentColor",
        label: ""
    });
};

});
parcelRegister("e4B5S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3ee36718444182a$var$_react = $a3ee36718444182a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a3ee36718444182a$var$_baseNew = $a3ee36718444182a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a3ee36718444182a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3ee36718444182a$var$FormIcon = (props)=>/*#__PURE__*/ $a3ee36718444182a$var$_react.default.createElement($a3ee36718444182a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$a3ee36718444182a$var$FormIcon.displayName = 'FormIcon';
var $a3ee36718444182a$var$_default = module.exports.default = $a3ee36718444182a$var$FormIcon;

});

parcelRegister("a8hd9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7d30dad6d1ac9ad16d909c6f786d22d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7608008571388d79$var$_react = $7608008571388d79$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7608008571388d79$var$_lockLocked = $7608008571388d79$var$_interopRequireDefault((parcelRequire("bwyQI")));

var $7608008571388d79$var$_lockFilled = $7608008571388d79$var$_interopRequireDefault((parcelRequire("gs7PQ")));
function $7608008571388d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7608008571388d79$var$LockLockedIcon = (props)=>/*#__PURE__*/ $7608008571388d79$var$_react.default.createElement($7608008571388d79$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $7608008571388d79$var$_lockFilled.default
    }, props));
$7608008571388d79$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $7608008571388d79$var$_default = module.exports.default = $7608008571388d79$var$LockLockedIcon;

});
parcelRegister("gs7PQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>/*#__PURE__*/ $bfa556ca72f8a34c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
    }));
$bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;

});


parcelRegister("2EYf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a0d99ab14252b55$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4a0d99ab14252b55$var$FormCardIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "18",
        viewBox: "0 0 14 18",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "currentColor",
                d: "M1.994 2v14h10V2h-10ZM0 1.791C0 .8028.897 0 2.006 0h9.988C13.102 0 14 .8082 14 1.791v14.418c0 .9891-.897 1.791-2.006 1.791H2.006c-.5295.0007-1.03778-.1873-1.41369-.5229C.21639 17.1415.00344 16.6855 0 16.209V1.791Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "currentColor",
                d: "M6.9013 11.1153h2.8718c.5287 0 .9572-.3997.9572-.8929 0-.4931-.4285-.8928-.9572-.8928H6.9013c-.5287 0-.9573.3997-.9573.8928 0 .4932.4286.8929.9573.8929ZM6.9013 8.2231h2.8718c.5287 0 .9572-.3997.9572-.8928 0-.49314-.4285-.89288-.9572-.89288H6.9013c-.5287 0-.9573.39974-.9573.89288 0 .4931.4286.8928.9573.8928ZM6.9013 5.40103h2.8718c.5287 0 .9572-.39975.9572-.89286s-.4285-.89286-.9572-.89286L6.9013 3.6153c-.5287 0-.9573.39976-.9573.89287 0 .49311.4286.89286.9573.89286ZM3.1488 5.32959h1.83796c0-.82142-.00001-1.22117 0-1.71429H3.1488v1.71429ZM3.22598 8.1517H5.0639V6.43742H3.22598V8.1517ZM3.22598 11.0439H5.0639V9.3296H3.22598v1.7143ZM4.18324 14H9.812c.5286 0 .9572-.3997.9572-.8929 0-.4931-.4286-.8928-.9572-.8928H4.18324c-.52868 0-.95726.3997-.95726.8928 0 .4932.42858.8929.95726.8929Z"
            })
        ]
    });
/**
 * __FormCardIcon__
 */ const $4a0d99ab14252b55$var$FormCardIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4a0d99ab14252b55$var$FormCardIconGlyph
    });
var $4a0d99ab14252b55$export$2e2bcd8739ae039 = $4a0d99ab14252b55$var$FormCardIcon;

});

parcelRegister("5wvQR", function(module, exports) {

$parcel$export(module.exports, "FormRestrictionStatus", () => $4058a5fc30fc445c$export$a22d71169ecf2be0);
$parcel$export(module.exports, "FormSupportedPrincipalType", () => $4058a5fc30fc445c$export$4bfccb8a14f3a257);
const $4058a5fc30fc445c$export$a22d71169ecf2be0 = {
    OPEN: 'open',
    RESTRICTED: 'restricted'
};
const $4058a5fc30fc445c$export$4bfccb8a14f3a257 = {
    USER: 'USER',
    USER_GROUP: 'USER_GROUP'
}; // TODO(amartinez): response API to be confirmed as a part of REQIN-1453.

});

parcelRegister("k3kYV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e9945cf8e4526c89$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e9945cf8e4526c89$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    restrictedFormIconTooltip: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header-new.form-card-icon.restricted-form-icon-tooltip',
        defaultMessage: 'Only specific people can view this form',
        description: 'Tooltip for the restricted form icon used in the form card header.'
    }
});

});


parcelRegister("2sdeO", function(module, exports) {

$parcel$export(module.exports, "useAddFormState", () => $1c9877100143736e$export$7fef181a170f4ae6);
$parcel$export(module.exports, "useAddFormErrorUtils", () => $1c9877100143736e$export$4b850b7ba9a639fb);
$parcel$export(module.exports, "AddFormStoreContainer", () => $1c9877100143736e$export$1e510900fbeff2e9);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $8pSia = parcelRequire("8pSia");

var $bNNwg = parcelRequire("bNNwg");
const $1c9877100143736e$var$AddFormStore = (0, $iXqE5.createStore)({
    initialState: {
        isLoading: false,
        forms: null,
        error: null
    },
    actions: $8pSia.actions,
    name: 'proforma-form-index-store'
});
const $1c9877100143736e$export$7fef181a170f4ae6 = (0, $3sQ5x.createStateHook)($1c9877100143736e$var$AddFormStore, {
    selector: (state)=>({
            isLoading: state.isLoading,
            forms: state.forms,
            error: state.error
        })
});
const $1c9877100143736e$export$880450b7fc383fe6 = (0, $3sQ5x.createActionsHook)($1c9877100143736e$var$AddFormStore);
const $1c9877100143736e$export$4b850b7ba9a639fb = (0, $3sQ5x.createStateHook)($1c9877100143736e$var$AddFormStore, {
    selector: (state)=>state.errorUtils
});
const $1c9877100143736e$export$1e510900fbeff2e9 = (0, $gg7kZ.createContainer)($1c9877100143736e$var$AddFormStore, {
    onInit: ()=>({ dispatch: dispatch, setState: setState }, { errorUtils: errorUtils })=>{
            setState({
                errorUtils: errorUtils
            });
            dispatch((0, $bNNwg.loadForms)());
        }
});

});
parcelRegister("8pSia", function(module, exports) {

$parcel$export(module.exports, "actions", () => $620ac5cc707c7823$export$e324594224ef24da);

var $bNNwg = parcelRequire("bNNwg");
const $620ac5cc707c7823$export$e324594224ef24da = {
    loadForms: $bNNwg.loadForms
};

});
parcelRegister("bNNwg", function(module, exports) {

$parcel$export(module.exports, "loadForms", () => $897aaed7a28a267e$export$ff4d94dd8c4ee66);
const $897aaed7a28a267e$export$ff4d94dd8c4ee66 = ()=>async ({ setState: setState }, { api: api, errorUtils: errorUtils })=>{
        setState({
            isLoading: true
        });
        try {
            const forms = await api.loadForms();
            setState({
                forms: forms,
                isLoading: false
            });
        } catch (error) {
            errorUtils.reportError(error, {
                id: 'loadForms'
            });
            setState({
                error: error,
                isLoading: false
            });
            throw error;
        }
    };

});



parcelRegister("hAFzt", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $cce60ba545dfe517$export$c1ed4f415b9e7023);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $92Z2l = parcelRequire("92Z2l");

var $7yg3D = parcelRequire("7yg3D");
const $cce60ba545dfe517$export$c1ed4f415b9e7023 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7yg3D.messages).errorMessage));

});
parcelRegister("7yg3D", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57f82a1cf3a7e657$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $57f82a1cf3a7e657$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorMessage: {
        id: 'proforma-form-system.add-form.ui.error-state.error-message',
        defaultMessage: "We\u2019re unable to load forms. Refresh this page and try again.",
        description: 'Text for the error state when there is an error in form preview.'
    }
});

});


parcelRegister("7J3wD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $59ff78766a3b0adc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $59ff78766a3b0adc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    emptyFormName: {
        id: 'proforma-form-system.add-form.ui.empty-form-name',
        defaultMessage: 'Untitled Form',
        description: 'A placeholder for a form with an empty name.'
    },
    addFormButton: {
        id: 'proforma-form-system.add-form.ui.add-form-button',
        defaultMessage: 'Add',
        description: 'Add form button text'
    },
    cancelButton: {
        id: 'proforma-form-system.add-form.ui.cancel-button',
        defaultMessage: 'Cancel',
        description: 'Form cancel button text'
    },
    addFormSelectInputPlaceholder: {
        id: 'proforma-form-system.add-form.ui.add-form-select-input-placeholder',
        defaultMessage: 'Select a form',
        description: 'Placeholder text for add form dropdown'
    },
    addFormSelectGroupRecommended: {
        id: 'proforma-form-system.add-form.ui.add-form-select-group-recommended',
        defaultMessage: 'Recommended',
        description: 'Option group text for recommended forms'
    },
    addFormSelectGroupOther: {
        id: 'proforma-form-system.add-form.ui.add-form-select-group-other',
        defaultMessage: 'Other Forms',
        description: 'Option group text for avaiable or other forms'
    }
});

});

parcelRegister("gATks", function(module, exports) {

$parcel$export(module.exports, "IssueFormSelectorStyles", () => $c14aed5547718d40$export$fbd06a3f6aaad3cd);
$parcel$export(module.exports, "ButtonRow", () => $c14aed5547718d40$export$564cbe3426fc093a);
$parcel$export(module.exports, "IconSelect", () => $c14aed5547718d40$export$249df474ea45aebc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");
const $c14aed5547718d40$export$fbd06a3f6aaad3cd = (0, $dAHxw.default).div({
    marginBottom: "var(--ds-space-100, 8px)"
});
const $c14aed5547718d40$export$564cbe3426fc093a = (0, $dAHxw.default).div({
    textAlign: 'right',
    margin: `${"var(--ds-space-100, 8px)"} 1px`
});
const $c14aed5547718d40$export$249df474ea45aebc = (0, $dAHxw.default).div({
    display: 'flex',
    gap: "var(--ds-space-075, 6px)",
    alignItems: 'center'
});

});


parcelRegister("aW3TH", function(module, exports) {

$parcel$export(module.exports, "TemplateLibraryContainer", () => $7f62581ee82d6ab6$export$b414c1ae30748492);
$parcel$export(module.exports, "useTemplateLibraryState", () => $7f62581ee82d6ab6$export$47840b12545bcb14);
$parcel$export(module.exports, "useTemplateLibraryActions", () => $7f62581ee82d6ab6$export$8bf462d2c8456f46);
$parcel$export(module.exports, "useTemplateForm", () => $7f62581ee82d6ab6$export$7646fd624e15efcf);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $7f62581ee82d6ab6$export$6114e3fefcbff062 = (isOpen)=>({ setState: setState })=>{
        setState({
            isTemplateLibraryOpen: isOpen
        });
    };
const $7f62581ee82d6ab6$export$b9839c0fc9ebf20a = (selectedTemplate)=>({ setState: setState })=>{
        setState({
            selectedTemplate: selectedTemplate
        });
    };
const $7f62581ee82d6ab6$export$7679083b8956d369 = (id, template)=>({ setState: setState, getState: getState })=>{
        const currentTemplates = getState().templates;
        if (!currentTemplates[id]) {
            currentTemplates[id] = {
                ...template
            };
            setState({
                templates: {
                    ...currentTemplates
                }
            });
        }
    };
const $7f62581ee82d6ab6$var$actions = {
    setIsTemplateLibraryOpen: $7f62581ee82d6ab6$export$6114e3fefcbff062,
    setSelectedTemplate: $7f62581ee82d6ab6$export$b9839c0fc9ebf20a,
    setTemplates: $7f62581ee82d6ab6$export$7679083b8956d369
};
const $7f62581ee82d6ab6$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isTemplateLibraryOpen: false,
        selectedTemplate: undefined,
        templates: {}
    },
    name: 'proforma-template-library-store',
    actions: $7f62581ee82d6ab6$var$actions
});
const $7f62581ee82d6ab6$export$b414c1ae30748492 = (0, $gg7kZ.createContainer)($7f62581ee82d6ab6$var$Store);
const $7f62581ee82d6ab6$export$47840b12545bcb14 = (0, $3sQ5x.createStateHook)($7f62581ee82d6ab6$var$Store);
const $7f62581ee82d6ab6$export$8bf462d2c8456f46 = (0, $3sQ5x.createActionsHook)($7f62581ee82d6ab6$var$Store);
const $7f62581ee82d6ab6$export$1a4139ca79fdfefc = (state, id)=>state.templates[id];
const $7f62581ee82d6ab6$export$7646fd624e15efcf = (0, $3sQ5x.createStateHook)($7f62581ee82d6ab6$var$Store, {
    selector: $7f62581ee82d6ab6$export$1a4139ca79fdfefc
});

});

parcelRegister("bV8dQ", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $8adb655be51f0bfa$export$1b581a2ec13e37f1);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

const $8adb655be51f0bfa$export$1b581a2ec13e37f1 = ({ children: children, channel: channel })=>{
    const sendEvent = (0, $5uXOq.useCallback)((event)=>{
        var _event$clone;
        // For backwards compatibility with analytics listeners in the product
        // which attempt to determine the actionSubject and attributes
        // from the context.
        const { actionSubject: actionSubject, attributes: attributes } = event.payload;
        const context = {};
        if (actionSubject) {
            context.component = actionSubject;
            context.componentName = actionSubject;
        }
        if (attributes) context.attributes = attributes;
        event.context.push(context);
        (_event$clone = event.clone()) === null || _event$clone === void 0 || _event$clone.fire(channel);
    }, [
        channel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        channel: (0, $6e65040b988c460f$export$2ceccf177fae277c),
        onEvent: sendEvent
    }, children);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';


const $e1c6b645992f9e3f$export$f83d7d78a84a242f = 'proformaRtcEmptyStateChangeboardingSpotlight';
const $e1c6b645992f9e3f$export$1222b4ae9a94b9ec = 'proforma-rtc-empty-state-changeboarding-spotlight';
const $e1c6b645992f9e3f$export$3c389bd4d38f57a0 = 'proforma-rtc-empty-state-changeboarding-spotlight-target';

parcelRegister("d8fKE", function(module, exports) {

$parcel$export(module.exports, "ChangeboardingSpotlight", () => $166a93e7b72fdce3$export$1cacf70a9ba01116);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $cgL5K = parcelRequire("cgL5K");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $8XcFP = parcelRequire("8XcFP");

var $ldR7O = parcelRequire("ldR7O");

var $ehdJY = parcelRequire("ehdJY");


var $iXiji = parcelRequire("iXiji");
const $166a93e7b72fdce3$export$1cacf70a9ba01116 = ({ onAcknowledge: onAcknowledge })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, (0, $6s1PB.expValEquals)('rtc_form_empty_state_to_all_user', 'cohort', 'experiment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $e1c6b645992f9e3f$export$f83d7d78a84a242f),
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        heading: formatMessage((0, $iXiji.default).title),
        target: (0, $e1c6b645992f9e3f$export$3c389bd4d38f57a0),
        actions: [
            {
                text: formatMessage((0, $iXiji.default).gotIt),
                onClick: onAcknowledge
            }
        ],
        dialogWidth: 336,
        key: (0, $e1c6b645992f9e3f$export$1222b4ae9a94b9ec),
        dialogPlacement: "top right",
        messageId: "proforma-request-type-config.ui.form-empty-state.changeboarding-spotlight.jira-spotlight",
        messageType: (0, $4R6GH.fg)('bug-fix-add-form-button-onboarding') ? 'transactional' : 'engagement'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $iXiji.default).message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldR7O.StyledSpotlight), {
        dialogWidth: 336,
        target: (0, $e1c6b645992f9e3f$export$3c389bd4d38f57a0),
        dialogPlacement: "top right",
        messageId: "proforma-request-type-config.ui.form-empty-state.changeboarding-spotlight.styled-spotlight",
        messageType: (0, $4R6GH.fg)('bug-fix-add-form-button-onboarding') ? 'transactional' : 'engagement'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XcFP.AnalyticsSpotlightCard), {
        sourceName: (0, $e1c6b645992f9e3f$export$f83d7d78a84a242f),
        spotlightId: (0, $e1c6b645992f9e3f$export$1222b4ae9a94b9ec),
        buttons: {
            primary: {
                text: formatMessage((0, $iXiji.default).gotIt),
                onClick: onAcknowledge
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $iXiji.default).text)))));
};

});
parcelRegister("8XcFP", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSpotlightCard", () => $9f17f3ea580eb49f$export$a11224e1cac19ef6);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $l8ruj = parcelRequire("l8ruj");

var $iI6zx = parcelRequire("iI6zx");
const $9f17f3ea580eb49f$export$a11224e1cac19ef6 = ({ sourceName: sourceName, spotlightId: spotlightId, buttons: buttons, ...props })=>{
    const { primary: primary, secondary: secondary, close: close } = buttons;
    const createAnalyticsButtonHandler = (handler, attributes)=>(event, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${sourceName}Button`, attributes);
            handler && handler(event, analyticsEvent);
        };
    // Add analytics to passed in button handlers
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const buttonsWithAnalytics = {};
    if (close) buttonsWithAnalytics.close = {
        ...close,
        onClick: createAnalyticsButtonHandler(close.onClick, {
            buttonType: 'close'
        })
    };
    if (primary) buttonsWithAnalytics.primary = {
        ...primary,
        onClick: createAnalyticsButtonHandler(primary.onClick, {
            buttonType: 'primary'
        })
    };
    if (secondary) buttonsWithAnalytics.secondary = {
        ...secondary,
        onClick: createAnalyticsButtonHandler(secondary.onClick, {
            buttonType: 'secondary'
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "analytics-spot-light-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        attributes: {
            spotlightId: spotlightId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iI6zx.ItsmSpotlightCard), {
        ...props,
        buttons: buttonsWithAnalytics
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        key: spotlightId
    })));
};

});
parcelRegister("iI6zx", function(module, exports) {

$parcel$export(module.exports, "ItsmSpotlightCard", () => $129f355b120b370f$export$8ee57a78413ee1d4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fr1K2 = parcelRequire("fr1K2");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $iSltJ = parcelRequire("iSltJ");

var $8RXs9 = parcelRequire("8RXs9");

var $kfhC9 = parcelRequire("kfhC9");

var $kFv58 = parcelRequire("kFv58");
const $129f355b120b370f$export$8ee57a78413ee1d4 = (0, $8RXs9.default)(({ heading: heading, steps: steps, buttons: buttons, children: children, intl: intl, infoBox: infoBox })=>{
    const hasFooter = buttons.primary || buttons.secondary || steps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$export$e0b309a29dbe6cbc, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$var$Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$export$1b51c6466e79404f, null, heading !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$export$284be1ee64a3465c, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$export$ba1d1c438cc57586, null, heading)), children), buttons.close && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "link",
        ...buttons.close
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
        label: intl.formatMessage((0, $kFv58.default).exitTourButtonLabel),
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "small",
        spacing: "none"
    }))), infoBox !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$export$aff4fc93593c3bcf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSltJ))), {
        spacing: "spacious",
        color: "var(--ds-icon-discovery, #8270DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$export$bd2d482767bd4d6, null, infoBox)), hasFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$export$a06f1c675e846f6f, null, steps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($129f355b120b370f$export$13807d9ee5a34a42, null, steps.current, "/", steps.count), buttons.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfhC9.PurpleButton), {
        appearance: "subtle-link",
        ...(0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(buttons.secondary, 'text')
    }, buttons.secondary && buttons.secondary.text), buttons.primary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfhC9.PurpleButton), {
        autoFocus: true,
        appearance: "primary",
        ...(0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(buttons.primary, 'text')
    }, buttons.primary && buttons.primary.text)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $129f355b120b370f$var$Body = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1i7v2smr _11sqpxbi _auo4pxbi _1k8bpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $129f355b120b370f$export$1b51c6466e79404f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $129f355b120b370f$export$bd2d482767bd4d6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _19pkidpf _2hwxidpf _otyridpf _18u0utpp _vwz41tcg _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $129f355b120b370f$export$e0b309a29dbe6cbc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _bfhkvuon _19pkmgjw _otyrmgjw _18u0c7mi _2hwxc7mi _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $129f355b120b370f$export$284be1ee64a3465c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
}); // Cannot use atlaskit/heading due to automatic color setting that breaks due to overriding Spotlight background color above.
const $129f355b120b370f$export$ba1d1c438cc57586 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $129f355b120b370f$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bahesu3 _19pkxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $129f355b120b370f$export$13807d9ee5a34a42 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _11c81o8v _syaz131l _ect41odn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $129f355b120b370f$export$aff4fc93593c3bcf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko14y2 _1e0c1txw _ca0qpxbi _u5f3v47k _n3tdpxbi _19bvutpp _bfhk1nvp _19pkxy5q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iSltJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70113934dd41ece58b869c894c478228>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbddee5646da8a29$var$_react = $dbddee5646da8a29$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dbddee5646da8a29$var$_lightbulb = $dbddee5646da8a29$var$_interopRequireDefault((parcelRequire("e78BF")));

var $dbddee5646da8a29$var$_objects = $dbddee5646da8a29$var$_interopRequireDefault((parcelRequire("6TTYU")));
function $dbddee5646da8a29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "EmojiObjectsIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbddee5646da8a29$var$LightbulbIcon = (props)=>/*#__PURE__*/ $dbddee5646da8a29$var$_react.default.createElement($dbddee5646da8a29$var$_lightbulb.default, Object.assign({
        LEGACY_fallbackIcon: $dbddee5646da8a29$var$_objects.default
    }, props));
$dbddee5646da8a29$var$LightbulbIcon.Name = 'LightbulbIconMigration';
var $dbddee5646da8a29$var$_default = module.exports.default = $dbddee5646da8a29$var$LightbulbIcon;

});
parcelRegister("6TTYU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50634de35803d733$var$_react = $50634de35803d733$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $50634de35803d733$var$_lightbulb = $50634de35803d733$var$_interopRequireDefault((parcelRequire("e78BF")));
function $50634de35803d733$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $50634de35803d733$var$EmojiObjectsIcon = (props)=>/*#__PURE__*/ $50634de35803d733$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611s.45.907 1 .907h4c.55 0 1-.408 1-.907s.32-1.224.71-1.611c0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m0 2a4.003 4.003 0 0 1 3.998 3.998c0 1.029-1.145 2.511-1.695 3.064-.507.501-.912 1.216-1.13 1.938h-2.346c-.217-.722-.622-1.435-1.125-1.934-.555-.557-1.7-2.039-1.7-3.068A4.003 4.003 0 0 1 11.998 6m2.965 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1z"/></svg>`
    }, props, {
        newIcon: $50634de35803d733$var$_lightbulb.default
    }));
$50634de35803d733$var$EmojiObjectsIcon.displayName = 'EmojiObjectsIcon';
var $50634de35803d733$var$_default = module.exports.default = $50634de35803d733$var$EmojiObjectsIcon;

});


parcelRegister("kfhC9", function(module, exports) {

$parcel$export(module.exports, "PurpleButton", () => $4bca6c6321cb996e$export$9e383db15189956f);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");
// It is a copy of the theme used in the AK's onboarding component!
// atlaskit/onboarding/theme
const $4bca6c6321cb996e$var$purpleButtonTheme = {
    primary: {
        background: {
            default: {
                light: "var(--ds-background-discovery-bold, #6E5DC6)",
                dark: "var(--ds-background-discovery-bold, #6E5DC6)"
            },
            hover: {
                light: "var(--ds-background-discovery-bold-hovered, #5E4DB2)",
                dark: "var(--ds-background-discovery-bold-hovered, #5E4DB2)"
            },
            active: {
                light: "var(--ds-background-discovery-bold-pressed, #352C63)",
                dark: "var(--ds-background-discovery-bold-pressed, #352C63)"
            },
            disabled: {
                light: "var(--ds-background-disabled, #091E4208)",
                dark: "var(--ds-background-disabled, #091E4208)"
            },
            selected: {
                light: "var(--ds-background-danger, #FFECEB)",
                dark: "var(--ds-background-danger, #FFECEB)"
            },
            focus: {
                light: "var(--ds-background-discovery-bold, #6E5DC6)",
                dark: "var(--ds-background-discovery-bold, #6E5DC6)"
            }
        },
        boxShadow: {
            focus: {
                light: `${"var(--ds-border-discovery, #8270DB)"}`,
                dark: `${"var(--ds-border-discovery, #8270DB)"}`
            }
        },
        color: {
            default: {
                light: "var(--ds-text-inverse, #FFFFFF)",
                dark: "var(--ds-text-inverse, #FFFFFF)"
            },
            hover: {
                light: "var(--ds-text-inverse, #FFFFFF)",
                dark: "var(--ds-text-inverse, #FFFFFF)"
            },
            active: {
                light: "var(--ds-text-inverse, #FFFFFF)",
                dark: "var(--ds-text-inverse, #FFFFFF)"
            },
            disabled: {
                light: "var(--ds-text-inverse, #FFFFFF)",
                dark: "var(--ds-text-inverse, #FFFFFF)"
            },
            selected: {
                light: "var(--ds-text-inverse, #FFFFFF)",
                dark: "var(--ds-text-inverse, #FFFFFF)"
            },
            focus: {
                light: "var(--ds-text-inverse, #FFFFFF)",
                dark: "var(--ds-text-inverse, #FFFFFF)"
            }
        },
        outline: {
            focus: {
                light: 'none',
                dark: 'none'
            }
        }
    },
    link: {
        color: {
            default: {
                light: "var(--ds-text-discovery, #5E4DB2)",
                dark: "var(--ds-text-discovery, #5E4DB2)"
            },
            hover: {
                light: "var(--ds-text-discovery, #5E4DB2)",
                dark: "var(--ds-text-discovery, #5E4DB2)"
            },
            active: {
                light: "var(--ds-text-discovery, #5E4DB2)",
                dark: "var(--ds-text-discovery, #5E4DB2)"
            },
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: {
                light: "var(--ds-text-discovery, #5E4DB2)",
                dark: "var(--ds-text-discovery, #5E4DB2)"
            },
            focus: {
                light: "var(--ds-text-discovery, #5E4DB2)",
                dark: "var(--ds-text-discovery, #5E4DB2)"
            }
        },
        boxShadow: {
            focus: {
                light: `${"var(--ds-border-discovery, #8270DB)"}`,
                dark: `${"var(--ds-border-discovery, #8270DB)"}`
            }
        },
        outline: {
            focus: {
                light: 'none',
                dark: 'none'
            }
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: {
                light: `underline ${"var(--ds-text-discovery, #5E4DB2)"}`,
                dark: `underline ${"var(--ds-text-discovery, #5E4DB2)"}`
            }
        },
        textDecorationLine: {
            active: {
                light: 'none',
                dark: 'none'
            }
        },
        boxShadow: {
            focus: {
                light: `${"var(--ds-border-discovery, #8270DB)"}`,
                dark: `${"var(--ds-border-discovery, #8270DB)"}`
            }
        },
        color: {
            default: {
                light: "var(--ds-text-subtle, #44546F)",
                dark: "var(--ds-text-subtle, #44546F)"
            },
            hover: {
                light: "var(--ds-text-subtlest, #626F86)",
                dark: "var(--ds-text-subtlest, #626F86)"
            },
            active: {
                light: "var(--ds-text-subtle, #44546F)",
                dark: "var(--ds-text-subtle, #44546F)"
            },
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: {
                light: "var(--ds-text-subtle, #44546F)",
                dark: "var(--ds-text-subtle, #44546F)"
            },
            focus: {
                light: "var(--ds-text-subtle, #44546F)",
                dark: "var(--ds-text-subtle, #44546F)"
            }
        }
    }
};
const $4bca6c6321cb996e$var$applyTheme = (customTheme)=>(currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
        const { appearance: appearance, state: state, mode: mode } = themeProps;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"" | Appearance' can't be used to index type '{ readonly primary: { readonly background: { readonly default: { readonly light: "#6554C0"; readonly dark: "#6554C0"; }; readonly hover: { readonly light: "#8777D9"; readonly dark: "#8777D9"; }; readonly active: { readonly light: "#403294"; readonly dark: "#403294"; }; readonly disabled: { ...; }; readonly selected:...'.
        const customThemeAppearance = customTheme[`${appearance || ''}`]; // Trying to find custom theme rules for the provided appearance.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let customStyles = {};
        if (customThemeAppearance) // Extracting rules for the provided state.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        customStyles = Object.keys(customThemeAppearance).reduce((acc, key)=>{
            const value = customThemeAppearance[key];
            // @ts-expect-error - Type 'undefined' cannot be used as an index type.
            if (value[state]) acc[key] = value[state][mode];
            return acc;
        }, {});
        // Returning a theme that is a combination of default values and the custom button theme rules.
        return {
            buttonStyles: {
                ...buttonStyles,
                ...customStyles
            },
            spinnerStyles: spinnerStyles
        };
    };
const $4bca6c6321cb996e$export$9e383db15189956f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        theme: $4bca6c6321cb996e$var$applyTheme($4bca6c6321cb996e$var$purpleButtonTheme),
        ...props
    });

});

parcelRegister("kFv58", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2329413f381fda$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d2329413f381fda$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    exitTourButtonLabel: {
        "id": "servicedesk-itsm-onboarding-common.common.itsm-spotlight-card.exit-tour-button-label",
        "defaultMessage": "Exit tour"
    }
});

});



parcelRegister("ldR7O", function(module, exports) {

$parcel$export(module.exports, "StyledSpotlight", () => $c7673819b2e5cefc$export$dd256ed70cc58059);

var $5uXOq = parcelRequire("5uXOq");

var $9fuVs = parcelRequire("9fuVs");

var $gwIPs = parcelRequire("gwIPs");

var $ehdJY = parcelRequire("ehdJY");
const $c7673819b2e5cefc$var$DIALOG_WIDTH = 41 * (0, $gwIPs.gridSize);
const $c7673819b2e5cefc$var$defaultProps = {
    targetBgColor: "var(--ds-surface, #FFFFFF)",
    targetRadius: (0, $gwIPs.borderRadius),
    dialogWidth: $c7673819b2e5cefc$var$DIALOG_WIDTH
};
const $c7673819b2e5cefc$var$spotlightWithDefaults = (defaults)=>(props)=>{
        const { children: children, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
            ...defaults,
            ...rest
        }, children));
    };
const $c7673819b2e5cefc$export$dd256ed70cc58059 = $c7673819b2e5cefc$var$spotlightWithDefaults($c7673819b2e5cefc$var$defaultProps);

});

parcelRegister("iXiji", function(module, exports) {

$parcel$export(module.exports, "default", () => $17de06ad1aecd570$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $17de06ad1aecd570$var$messages = (0, $7VHMR.defineMessages)({
    gotIt: {
        "id": "proforma-request-type-config.form-empty-state.changeboarding-spotlight.got-it",
        "defaultMessage": "Got it"
    },
    text: {
        "id": "proforma-request-type-config.form-empty-state.changeboarding-spotlight.text",
        "defaultMessage": "Easily add an existing form directly to your request type without leaving this page."
    },
    title: {
        "id": "proforma-request-type-config.form-empty-state.changeboarding-spotlight.title",
        "defaultMessage": "Add more customization to a request form"
    },
    message: {
        "id": "proforma-request-type-config.form-empty-state.changeboarding-spotlight.message",
        "defaultMessage": "Attach forms with advanced formatting including conditional sections, rich text, and form-only fields."
    }
});
var $17de06ad1aecd570$export$2e2bcd8739ae039 = $17de06ad1aecd570$var$messages;

});


parcelRegister("7N8g9", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a8a2890689b465$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $80a8a2890689b465$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "proforma-request-type-config.form-empty-state.title",
        "defaultMessage": "Forms"
    },
    subtitle: {
        "id": "proforma-request-type-config.form-empty-state.subtitle",
        "defaultMessage": "Search and select an existing form to add to this request type."
    },
    searchAndCreateFormDescription: {
        "id": "proforma-request-type-config.form-empty-state.search-and-create-form-description",
        "defaultMessage": "Attach an existing form to this request type, or create a new form using a template."
    },
    createFormDescription: {
        "id": "proforma-request-type-config.form-empty-state.create-form-description",
        "defaultMessage": "Search the form template library to create a form to attach to this request type."
    },
    addFormButton: {
        "id": "proforma-request-type-config.form-empty-state.add-form-button",
        "defaultMessage": "Add form"
    },
    formsNotLoadedError: {
        "id": "proforma-request-type-config.form-empty-state.forms-not-loaded-error",
        "defaultMessage": "We\u2019re unable to load existing forms. Refresh this page and try again."
    },
    attachFormButton: {
        "id": "proforma-request-type-config.form-empty-state.attach-form-button",
        "defaultMessage": "Attach form"
    },
    selectExistingFormButton: {
        "id": "proforma-request-type-config.form-empty-state.select-existing-form-button",
        "defaultMessage": "Select existing"
    },
    createFromTemplateButton: {
        "id": "proforma-request-type-config.form-empty-state.create-from-template-button",
        "defaultMessage": "Create from template"
    }
});
var $80a8a2890689b465$export$2e2bcd8739ae039 = $80a8a2890689b465$var$messages;

});

parcelRegister("4zqHM", function(module, exports) {

$parcel$export(module.exports, "ProformaFormTemplateLibrary", () => $7105ab53b1c656be$export$5f1662423f068740);

var $5uXOq = parcelRequire("5uXOq");

var $kIbMP = parcelRequire("kIbMP");

var $dKzS9 = parcelRequire("dKzS9");

var $dAfqg = parcelRequire("dAfqg");

var $fBiBu = parcelRequire("fBiBu");
const $7105ab53b1c656be$var$ProformaFormTemplateLibraryInternal = ({ projectId: projectId, onFormCreated: onFormCreated })=>{
    const { createForm: createForm } = (0, $fBiBu.useCreateProformaRequestTypeForm)(projectId);
    const handleTemplateSelected = (0, $5uXOq.useCallback)(async (templateId, template, templateGroup)=>{
        const formTemplateKey = (0, $dKzS9.generateFormTemplateKey)(templateGroup, template.design.settings.name);
        const createdFormResponse = await createForm({
            templateId: templateId,
            template: template,
            formTemplateKey: formTemplateKey
        });
        if (createdFormResponse !== undefined) onFormCreated({
            formId: createdFormResponse.form.id,
            formName: createdFormResponse.form.design.settings.name
        });
    }, [
        createForm,
        onFormCreated
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kIbMP.ProformaTemplateLibraryInDrawer), {
        onTemplateSelected: handleTemplateSelected,
        noBlankTemplate: true
    });
};
const $7105ab53b1c656be$export$5f1662423f068740 = ({ onFormCreated: onFormCreated })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectId = data?.projectId ?? undefined;
    return projectId !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7105ab53b1c656be$var$ProformaFormTemplateLibraryInternal, {
        projectId: projectId,
        onFormCreated: onFormCreated
    }) : null;
};

});
parcelRegister("kIbMP", function(module, exports) {

$parcel$export(module.exports, "ProformaTemplateLibraryInDrawer", () => $4719d7c7b70415ac$export$8c06e3ce3a085ee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $fWHJX = parcelRequire("fWHJX");
var $8ZrIP = parcelRequire("8ZrIP");
var $bnVag = parcelRequire("bnVag");
var $4Nfb9 = parcelRequire("4Nfb9");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $aW3TH = parcelRequire("aW3TH");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

var $dnjeJ = parcelRequire("dnjeJ");

var $6mTto = parcelRequire("6mTto");
const $4719d7c7b70415ac$var$styles = {
    drawerContent: "_19pkze3t"
}; // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences

const $4719d7c7b70415ac$var$LazyProformaTemplateLibrary = (0, $kxZPA.lazy)(()=>(parcelRequire("iRvzI")).then(({ ProformaTemplateLibraryWithAnalytics: ProformaTemplateLibraryWithAnalytics })=>ProformaTemplateLibraryWithAnalytics), {
    moduleId: "./src/packages/proforma/proforma-template-library/src/ui/main.tsx"
});
const $4719d7c7b70415ac$var$LazyProformaTemplateLibraryWithUFO = (props)=>{
    (0, $dnjeJ.useUFOComponentExperience)((0, $6mTto.proformaTemplateLibraryExperience));
    return /*#__PURE__*/ $5uXOq.createElement($4719d7c7b70415ac$var$LazyProformaTemplateLibrary, props);
};
const $4719d7c7b70415ac$export$8c06e3ce3a085ee = (props)=>{
    const { isTemplateLibraryOpen: isTemplateLibraryOpen } = (0, $aW3TH.useTemplateLibraryState)();
    const { setIsTemplateLibraryOpen: setIsTemplateLibraryOpen } = (0, $aW3TH.useTemplateLibraryActions)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $fWHJX.Drawer), {
        testId: "proforma-template-library.ui.proforma-template-library-drawer",
        isOpen: isTemplateLibraryOpen,
        onClose: ()=>setIsTemplateLibraryOpen(false),
        width: "full"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $4Nfb9.DrawerSidebar), null, /*#__PURE__*/ $5uXOq.createElement((0, $8ZrIP.DrawerCloseButton), null)), /*#__PURE__*/ $5uXOq.createElement((0, $bnVag.DrawerContent), {
        xcss: $4719d7c7b70415ac$var$styles.drawerContent
    }, /*#__PURE__*/ $5uXOq.createElement((0, $7hSN4.LazySuspense), {
        fallback: (0, $4R6GH.fg)('proforma_templates_fun_in_frontend') ? /*#__PURE__*/ $5uXOq.createElement((0, $eZJjh.default), {
            size: "large"
        }) : null
    }, /*#__PURE__*/ $5uXOq.createElement($4719d7c7b70415ac$var$LazyProformaTemplateLibraryWithUFO, props))));
};

});
parcelRegister("fWHJX", function(module, exports) {

$parcel$export(module.exports, "Drawer", () => $25b769189f345f23$export$4071300121a182f5);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $6QvkM = parcelRequire("6QvkM");

var $9MHPe = parcelRequire("9MHPe");
var $fxUuP = parcelRequire("fxUuP");

var $k8nZq = parcelRequire("k8nZq");

var $2BpNa = parcelRequire("2BpNa");

var $fPayJ = parcelRequire("fPayJ");
// escape close manager for layering
const $25b769189f345f23$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $5uXOq.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $fxUuP.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
};
const $25b769189f345f23$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $5uXOq.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $lv4Ny.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k8nZq.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BpNa.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPayJ.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9MHPe.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $2OMIu.jsx)($25b769189f345f23$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};

});
parcelRegister("2BpNa", function(module, exports) {

$parcel$export(module.exports, "default", () => $793a41736040e69c$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");
const $793a41736040e69c$var$styles = {
    blanket: "_kqswh2mm"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $793a41736040e69c$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4uxPN.default), {
            /*
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: "large",
            /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $793a41736040e69c$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j55bS.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
var $793a41736040e69c$export$2e2bcd8739ae039 = $793a41736040e69c$var$Blanket;

});

parcelRegister("fPayJ", function(module, exports) {

$parcel$export(module.exports, "DrawerPanel", () => $24e4f2a945e34300$export$96114a266f19b4d0);
/* drawer-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $35XSW = parcelRequire("35XSW");
var $8Sbj3 = parcelRequire("8Sbj3");

var $csKKl = parcelRequire("csKKl");

var $ebUJZ = parcelRequire("ebUJZ");
const $24e4f2a945e34300$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $24e4f2a945e34300$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect41gqc",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $24e4f2a945e34300$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
const $24e4f2a945e34300$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $5uXOq.useRef)(null);
    const onFinish = (0, $5uXOq.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)($24e4f2a945e34300$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ebUJZ.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $bwpsq.default)([
                            $24e4f2a945e34300$var$styles.root,
                            $24e4f2a945e34300$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $csKKl.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $csKKl.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};

});
parcelRegister("csKKl", function(module, exports) {

$parcel$export(module.exports, "OnCloseContext", () => $6adc395c21ff5b23$export$7376ab1fc7707bdd);
$parcel$export(module.exports, "useOnClose", () => $6adc395c21ff5b23$export$c2b12c82f332a6fb);
$parcel$export(module.exports, "EnsureIsInsideDrawerContext", () => $6adc395c21ff5b23$export$e3662b8677049786);
$parcel$export(module.exports, "useEnsureIsInsideDrawer", () => $6adc395c21ff5b23$export$780b9799f6bfecd8);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $6adc395c21ff5b23$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $6adc395c21ff5b23$export$c2b12c82f332a6fb = ()=>(0, $5uXOq.useContext)($6adc395c21ff5b23$export$7376ab1fc7707bdd);
const $6adc395c21ff5b23$export$e3662b8677049786 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $6adc395c21ff5b23$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $5uXOq.useContext)($6adc395c21ff5b23$export$e3662b8677049786);
    (0, $3joPi.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};

});

parcelRegister("ebUJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $547a2c060825940e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");
/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $547a2c060825940e$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ao4Ml.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
var $547a2c060825940e$export$2e2bcd8739ae039 = $547a2c060825940e$var$FocusLock;

});



parcelRegister("8ZrIP", function(module, exports) {

$parcel$export(module.exports, "DrawerCloseButton", () => $6e17165bd43ac8bd$export$d0c3a75c17ac0cab);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $bu8Mq = parcelRequire("bu8Mq");

var $csKKl = parcelRequire("csKKl");
const $6e17165bd43ac8bd$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $csKKl.useEnsureIsInsideDrawer)();
    const onClose = (0, $csKKl.useOnClose)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...iconProps,
                size: "large",
                LEGACY_size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($bu8Mq))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};

});
parcelRegister("bu8Mq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::707984c4bf43fbcb724a560e605082a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85c94e946798d101$var$_react = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $85c94e946798d101$var$_arrowLeft = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("ctqwA")));

var $85c94e946798d101$var$_arrowLeft2 = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("3gt3f")));
function $85c94e946798d101$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85c94e946798d101$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $85c94e946798d101$var$_react.default.createElement($85c94e946798d101$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $85c94e946798d101$var$_arrowLeft2.default
    }, props));
$85c94e946798d101$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $85c94e946798d101$var$_default = module.exports.default = $85c94e946798d101$var$ArrowLeftIcon;

});
parcelRegister("3gt3f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $260966be5d9bd0f6$var$_react = $260966be5d9bd0f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $260966be5d9bd0f6$var$_arrowLeft = $260966be5d9bd0f6$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $260966be5d9bd0f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $260966be5d9bd0f6$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $260966be5d9bd0f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $260966be5d9bd0f6$var$_arrowLeft.default
    }));
$260966be5d9bd0f6$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $260966be5d9bd0f6$var$_default = module.exports.default = $260966be5d9bd0f6$var$ArrowLeftIcon;

});



parcelRegister("bnVag", function(module, exports) {

$parcel$export(module.exports, "DrawerContent", () => $8dbafdf66b92f715$export$57ca055474bc0056);
/* drawer-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2alJM = parcelRequire("2alJM");

var $bWn3s = parcelRequire("bWn3s");

var $csKKl = parcelRequire("csKKl");

var $kOcHs = parcelRequire("kOcHs");
const $8dbafdf66b92f715$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $8dbafdf66b92f715$var$DrawerContentBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $8dbafdf66b92f715$var$styles.default,
            xcss
        ]),
        ref: (0, $bWn3s.mergeRefs)([
            ref,
            scrollableRef
        ]),
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $8dbafdf66b92f715$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $csKKl.useEnsureIsInsideDrawer)();
    (0, $kOcHs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8dbafdf66b92f715$var$DrawerContentBase, {
            scrollContentLabel: scrollContentLabel,
            xcss: xcss,
            children: children
        })
    });
};

});
parcelRegister("kOcHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b738857dbc61139$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $5b738857dbc61139$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $5b738857dbc61139$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setScrollTopOffset($5b738857dbc61139$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $5uXOq.useCallback)(()=>{
        if ($5b738857dbc61139$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("4Nfb9", function(module, exports) {

$parcel$export(module.exports, "DrawerSidebar", () => $d6603d78eb4fb8af$export$25c48648e7980210);
/* drawer-sidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $csKKl = parcelRequire("csKKl");
const $d6603d78eb4fb8af$var$styles = {
    default: "_4cvr1h6o _vchhusvi _syaz1gjq _1e0c1txw _1o9zidpf _2lx21bp4 _4t3i1kxc _n3tdpxbi _ca0q1ejb _1bsbxncg"
};
const $d6603d78eb4fb8af$export$25c48648e7980210 = ({ children: children, xcss: xcss })=>{
    (0, $csKKl.useEnsureIsInsideDrawer)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $d6603d78eb4fb8af$var$styles.default,
            xcss
        ]),
        "data-testid": "drawer-sidebar",
        children: children
    });
};

});

parcelRegister("6mTto", function(module, exports) {

$parcel$export(module.exports, "proformaTemplateLibraryExperience", () => $2bd834e24110f976$export$451a0e8b519ffce);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $2bd834e24110f976$export$451a0e8b519ffce = new (0, $duUGa.UFOExperience)('proforma.template-library', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("iRvzI", function(module, exports) {

let $dbb5ab5f4d7799b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dbb5ab5f4d7799b1$var$load("kWrFZ"),
    $dbb5ab5f4d7799b1$var$load("92sUi"),
    $dbb5ab5f4d7799b1$var$load("i5RRW"),
    $dbb5ab5f4d7799b1$var$load("h2MrD"),
    $dbb5ab5f4d7799b1$var$load("bYT2S"),
    $dbb5ab5f4d7799b1$var$load("hPzOn"),
    $dbb5ab5f4d7799b1$var$load("cM9em"),
    $dbb5ab5f4d7799b1$var$load("fr9NE"),
    $dbb5ab5f4d7799b1$var$load("8ubmg")
]).then(()=>parcelRequire('4KwNP'));

});


parcelRegister("dKzS9", function(module, exports) {

$parcel$export(module.exports, "generateFormTemplateKey", () => $9bab6b14e5323602$export$d56ade9f6d05d67a);
const $9bab6b14e5323602$export$d56ade9f6d05d67a = (formTemplateGroup, formTemplateName)=>{
    const processedGroup = formTemplateGroup?.trim().toLowerCase().replaceAll(' ', '-');
    const processedName = formTemplateName.trim().toLowerCase().replaceAll(' ', '-');
    return !processedGroup ? processedName : processedGroup?.concat('.', processedName);
};

});

parcelRegister("fBiBu", function(module, exports) {

$parcel$export(module.exports, "useCreateProformaRequestTypeForm", () => $ec944fa87d380601$export$33ad201c3f206dec);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dTob9 = parcelRequire("dTob9");

var $koeKL = parcelRequire("koeKL");
const $ec944fa87d380601$var$createForm = (cloudId, projectId, template)=>(0, $eusud.performPostRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/cloud/project/${projectId}/form`, {
        body: JSON.stringify(template)
    });
const $ec944fa87d380601$export$33ad201c3f206dec = (projectId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFormSelectFailFlag: showFormSelectFailFlag } = (0, $dTob9.useFormSelectedErrorFlag)();
    const request = (0, $5uXOq.useCallback)(async ({ templateId: templateId, template: template, formTemplateKey: formTemplateKey })=>{
        try {
            const createdFormResponse = await $ec944fa87d380601$var$createForm(cloudId, projectId, template);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'proformaRequestTypeForm created', {
                projectId: projectId,
                templateFormId: createdFormResponse.form.id,
                formTemplateId: templateId,
                formTemplateKey: formTemplateKey
            });
            return createdFormResponse;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'createProformaRequestTypeForm',
                    packageName: 'jiraProformaRequestTypeConfig',
                    teamName: 'jsm-request-intake'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    projectId: projectId
                }
            });
            showFormSelectFailFlag();
            throw error;
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        projectId,
        showFormSelectFailFlag
    ]);
    const { loading: loading, data: data, error: error, fetch: fetch } = (0, $ld2hZ.useService)(request, {
        loading: true
    });
    return {
        loading: loading,
        data: data,
        error: error,
        createForm: fetch
    };
};

});
parcelRegister("dTob9", function(module, exports) {

$parcel$export(module.exports, "useFormSelectedErrorFlag", () => $7c5d144ea28a8ffe$export$2fbea2fdae1f5e83);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $ARTjQ = parcelRequire("ARTjQ");
const $7c5d144ea28a8ffe$export$2fbea2fdae1f5e83 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showFormSelectFailFlag = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            id: 'proforma-template-library.ui.library.form-selected-error',
            type: 'error',
            title: formatMessage((0, $ARTjQ.messages).title),
            isAutoDismiss: true,
            messageId: 'proforma-template-library.common.utils.form-selected-failed-flag.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        formatMessage
    ]);
    return {
        showFormSelectFailFlag: showFormSelectFailFlag
    };
};

});
parcelRegister("ARTjQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5f207aabf3549d28$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5f207aabf3549d28$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "proforma-template-library.common.utils.form-selected-failed-flag.title",
        "defaultMessage": "We couldn't open this form template. Select template to try again."
    }
});

});






parcelRegister("6hGCq", function(module, exports) {

$parcel$export(module.exports, "useTicketTypeStore", () => $90d5b9ecb1740024$export$a501008e2b64a210);
$parcel$export(module.exports, "useChangeWorkflowStore", () => $90d5b9ecb1740024$export$9910495d5ea6a92e);
$parcel$export(module.exports, "useTicketTypesStore", () => $90d5b9ecb1740024$export$e810fd2f804c6d2b);
$parcel$export(module.exports, "useUnmappedRequestTypes", () => $90d5b9ecb1740024$export$9834b6e1be55ac4d);
$parcel$export(module.exports, "useCollatedUnmappedRequestTypes", () => $90d5b9ecb1740024$export$25a50275ed5de4ef);
$parcel$export(module.exports, "useCollatedTicketTypes", () => $90d5b9ecb1740024$export$3f19cfb6230f1193);
$parcel$export(module.exports, "useTicketTypePendingCreationStore", () => $90d5b9ecb1740024$export$d88ecde7cc4a8035);
$parcel$export(module.exports, "usePendingTicketTypeDeletionStore", () => $90d5b9ecb1740024$export$a852d545ead0356a);
$parcel$export(module.exports, "useAppPropsStore", () => $90d5b9ecb1740024$export$18a64e16ae0985fb);
$parcel$export(module.exports, "useTicketTypeStoreActions", () => $90d5b9ecb1740024$export$2cf4dc2ac2efcfc7);
$parcel$export(module.exports, "useProjectWorkflowScheme", () => $90d5b9ecb1740024$export$a48cc039330f473a);
$parcel$export(module.exports, "TicketTypeContainer", () => $90d5b9ecb1740024$export$59e15b1c7fc7f701);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $1VEGT = parcelRequire("1VEGT");

var $5N6Dq = parcelRequire("5N6Dq");

var $lsopK = parcelRequire("lsopK");

var $a3YF3 = parcelRequire("a3YF3");

var $bXg9w = parcelRequire("bXg9w");

var $5wJgc = parcelRequire("5wJgc");

var $hBu9K = parcelRequire("hBu9K");

var $kC55f = parcelRequire("kC55f");

var $dAKn3 = parcelRequire("dAKn3");

var $6dYoO = parcelRequire("6dYoO");

var $4PmdS = parcelRequire("4PmdS");

var $48vCH = parcelRequire("48vCH");

var $cL08L = parcelRequire("cL08L");

var $7VGl8 = parcelRequire("7VGl8");

var $l3fjA = parcelRequire("l3fjA");

var $69Q5q = parcelRequire("69Q5q");
const $90d5b9ecb1740024$var$actions = {
    setTicketTypes: $l3fjA.default,
    deleteTicketType: $5N6Dq.default,
    setRequestTypeGroups: $dAKn3.default,
    setRequestTypeIssueType: $6dYoO.default,
    setRequestTypesPractice: $48vCH.default,
    setTicketTypeIcon: $cL08L.default,
    setTicketTypeName: $7VGl8.default,
    createTicketType: $1VEGT.default,
    setChangeWorkflowToEdit: $a3YF3.default,
    resetChangeWorkflow: $lsopK.default,
    setRequestTypeFormData: $kC55f.default,
    setProjectWorkflowScheme: $5wJgc.default,
    setIssueTypeWorkflow: $bXg9w.default,
    setRequestTypeCategory: $hBu9K.default,
    setRequestTypeSecurity: $4PmdS.default
};
const $90d5b9ecb1740024$var$initialState = {
    ticketTypes: {},
    appProps: {
        projectKey: '',
        projectId: -1
    },
    pendingTicketTypeCreation: {
        error: null,
        data: null
    },
    pendingTicketTypeDeletion: {
        error: null,
        data: null
    },
    changeWorkflow: {
        isShowing: false,
        requestTypeId: null
    },
    requestTypeFormData: {
        data: null,
        error: null
    },
    projectWorkflowScheme: {
        loading: true,
        error: null,
        issueTypeIdToWorkflow: {},
        defaultWorkflow: null
    }
};
const $90d5b9ecb1740024$var$Store = (0, $iXqE5.createStore)({
    initialState: $90d5b9ecb1740024$var$initialState,
    actions: $90d5b9ecb1740024$var$actions,
    name: 'ticket-type-store'
});
const $90d5b9ecb1740024$export$a501008e2b64a210 = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.ticketTypeSelector)
});
const $90d5b9ecb1740024$export$9910495d5ea6a92e = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.changeWorkflowSelector)
});
const $90d5b9ecb1740024$export$e810fd2f804c6d2b = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.ticketTypesByPracticeSelector)
});
const $90d5b9ecb1740024$export$9834b6e1be55ac4d = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.unmappedRequestTypesSelector)
});
const $90d5b9ecb1740024$export$25a50275ed5de4ef = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.collatedUnmappedRequestTypesSelector)
});
const $90d5b9ecb1740024$export$3f19cfb6230f1193 = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.collatedTicketTypesSelector)
});
const $90d5b9ecb1740024$export$d88ecde7cc4a8035 = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.pendingTicketTypeCreationSelector)
});
const $90d5b9ecb1740024$export$b779a211eaf123f0 = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.ticketTypeSetNameErrorSelector)
});
const $90d5b9ecb1740024$export$9ea41e3772e76347 = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.ticketTypeSetIconErrorSelector)
});
const $90d5b9ecb1740024$export$a852d545ead0356a = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.pendingTicketTypeDeletionSelector)
});
const $90d5b9ecb1740024$export$18a64e16ae0985fb = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.appPropsSelector)
});
const $90d5b9ecb1740024$export$2cf4dc2ac2efcfc7 = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: null
});
const $90d5b9ecb1740024$export$c16240ba68e2d6ce = (0, $3sQ5x.createStateHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.requestTypeFormData)
});
const $90d5b9ecb1740024$export$a48cc039330f473a = (0, $3sQ5x.createHook)($90d5b9ecb1740024$var$Store, {
    selector: (0, $69Q5q.projectWorkflowSchemeSelector)
});
const $90d5b9ecb1740024$var$Container = (0, $gg7kZ.createContainer)($90d5b9ecb1740024$var$Store, {
    onInit: ()=>({ setState: setState }, { projectKey: projectKey, projectId: projectId })=>{
            setState({
                appProps: {
                    projectKey: projectKey,
                    projectId: projectId
                }
            });
        }
});
const $90d5b9ecb1740024$export$59e15b1c7fc7f701 = ({ children: children, projectKey: projectKey, projectId: projectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90d5b9ecb1740024$var$Container, {
        scope: projectKey,
        projectKey: projectKey,
        projectId: projectId
    }, children);

});
parcelRegister("1VEGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7edc67d7f1b917a8$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $llffo = parcelRequire("llffo");

var $3gSfv = parcelRequire("3gSfv");
const $7edc67d7f1b917a8$var$createTicketType = (newTicket, groupIds, suggestedName, suggestedDescription, isSuggestedByAI, analyticsEvent, onTicketCreated)=>async ({ getState: getState, setState: setState })=>{
        setState({
            pendingTicketTypeCreation: {
                error: null,
                data: newTicket
            }
        });
        const { appProps: { projectId: projectId } } = getState();
        try {
            const { issueType: issueType, iconUrl: url, iconId: iconId } = newTicket;
            if (issueType === null || url === null || iconId === null) throw new Error('Missing issuetype or icon data');
            const result = await (0, $llffo.createTicketTypeService)(newTicket, projectId, groupIds);
            const { name: name, id: id, externalId: externalId, icon: icon, iconUrl: iconUrl, description: description, usedByEmailSettings: usedByEmailSettings, helpText: helpText, groups: groups, issueType: { id: issueTypeId }, practices: practices, restrictionStatus: restrictionStatus, issueSecurityStatus: issueSecurityStatus } = result;
            const ticketTypeCreated = {
                name: name,
                id: id,
                iconUrl: iconUrl,
                iconId: icon,
                description: description,
                usedByEmailSettings: usedByEmailSettings,
                helpText: helpText,
                groups: groups,
                issueType: Number(issueTypeId),
                practices: practices.map((practice)=>practice.key),
                externalId: externalId,
                restrictionStatus: restrictionStatus,
                issueSecurityStatus: issueSecurityStatus
            };
            const { ticketTypes: ticketTypes } = getState();
            const ticketTypesData = {
                ...ticketTypes
            };
            ticketTypesData[id.toString()] = {
                currentState: ticketTypeCreated,
                updateState: {}
            };
            onTicketCreated(id);
            setState({
                pendingTicketTypeCreation: {
                    error: null,
                    data: null
                },
                ticketTypes: ticketTypesData
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'requestType created', {
                isDuplicate: false,
                isSuggestedByAI: isSuggestedByAI,
                nameSimilarityPercentage: isSuggestedByAI ? (0, $3gSfv.similarityPercentage)(name, suggestedName) : 0,
                descriptionSimilarityPercentage: isSuggestedByAI ? (0, $3gSfv.similarityPercentage)(description, suggestedDescription) : 0
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                pendingTicketTypeCreation: {
                    error: error,
                    data: newTicket
                }
            });
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'createTicketTypeService',
                    packageName: 'jiraServicedeskTicketTypesStore'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
var $7edc67d7f1b917a8$export$2e2bcd8739ae039 = $7edc67d7f1b917a8$var$createTicketType;

});
parcelRegister("llffo", function(module, exports) {

$parcel$export(module.exports, "createTicketTypeService", () => $601484c963a9ab4a$export$7bfc169d868b3c90);

var $eusud = parcelRequire("eusud");

const $601484c963a9ab4a$export$2c331abbe7735068 = (projectId)=>`/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/request-types`;
const $601484c963a9ab4a$export$7bfc169d868b3c90 = (newTicket, projectId, groupIds)=>{
    const { name: name, description: description, iconId: iconId, issueType: issueType, practices: practices } = newTicket;
    const url = $601484c963a9ab4a$export$2c331abbe7735068(projectId);
    let options = {
        body: JSON.stringify({
            description: description,
            icon: iconId,
            issueTypeId: issueType,
            name: name,
            groupIds: groupIds
        })
    };
    const hasPractice = practices && practices[0] && practices[0] !== (0, $5c15c74117e15b55$export$52bf3f16b7812704);
    if (hasPractice) options = {
        body: JSON.stringify({
            description: description,
            icon: iconId,
            issueTypeId: issueType,
            name: name,
            groupIds: groupIds,
            practice: practices[0]
        })
    };
    return (0, $eusud.performPostRequest)(url, options);
};

});
// BERRY-1358 prefer no_category from @atlassian/jira-servicedesk-work-category certainly?
const $5c15c74117e15b55$export$52bf3f16b7812704 = 'no-practice';


parcelRegister("3gSfv", function(module, exports) {

$parcel$export(module.exports, "similarityPercentage", () => $02d074ab1861fa0c$export$f48c7aa04e85aebc);

var $4PSWi = parcelRequire("4PSWi");
const $02d074ab1861fa0c$export$f48c7aa04e85aebc = (a, b)=>{
    const distance = (0, (/*@__PURE__*/$parcel$interopDefault($4PSWi))).get(a || '', b || '');
    const similarity = 1 - distance / Math.max(a?.length || 0, b?.length || 0) || 0;
    return similarity * 100;
};

});
parcelRegister("4PSWi", function(module, exports) {
(function() {
    'use strict';
    var collator;
    try {
        collator = typeof Intl !== "undefined" && typeof Intl.Collator !== "undefined" ? Intl.Collator("generic", {
            sensitivity: "base"
        }) : null;
    } catch (err) {
        console.log("Collator could not be initialized and wouldn't be used");
    }
    // arrays to re-use
    var prevRow = [], str2Char = [];
    /**
   * Based on the algorithm at http://en.wikipedia.org/wiki/Levenshtein_distance.
   */ var Levenshtein = {
        /**
     * Calculate levenshtein distance of the two strings.
     *
     * @param str1 String the first string.
     * @param str2 String the second string.
     * @param [options] Additional options.
     * @param [options.useCollator] Use `Intl.Collator` for locale-sensitive string comparison.
     * @return Integer the levenshtein distance (0 and above).
     */ get: function(str1, str2, options) {
            var useCollator = options && collator && options.useCollator;
            var str1Len = str1.length, str2Len = str2.length;
            // base cases
            if (str1Len === 0) return str2Len;
            if (str2Len === 0) return str1Len;
            // two rows
            var curCol, nextCol, i, j, tmp;
            // initialise previous row
            for(i = 0; i < str2Len; ++i){
                prevRow[i] = i;
                str2Char[i] = str2.charCodeAt(i);
            }
            prevRow[str2Len] = str2Len;
            var strCmp;
            if (useCollator) // calculate current row distance from previous row using collator
            for(i = 0; i < str1Len; ++i){
                nextCol = i + 1;
                for(j = 0; j < str2Len; ++j){
                    curCol = nextCol;
                    // substution
                    strCmp = 0 === collator.compare(str1.charAt(i), String.fromCharCode(str2Char[j]));
                    nextCol = prevRow[j] + (strCmp ? 0 : 1);
                    // insertion
                    tmp = curCol + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // deletion
                    tmp = prevRow[j + 1] + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // copy current col value into previous (in preparation for next iteration)
                    prevRow[j] = curCol;
                }
                // copy last col value into previous (in preparation for next iteration)
                prevRow[j] = nextCol;
            }
            else // calculate current row distance from previous row without collator
            for(i = 0; i < str1Len; ++i){
                nextCol = i + 1;
                for(j = 0; j < str2Len; ++j){
                    curCol = nextCol;
                    // substution
                    strCmp = str1.charCodeAt(i) === str2Char[j];
                    nextCol = prevRow[j] + (strCmp ? 0 : 1);
                    // insertion
                    tmp = curCol + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // deletion
                    tmp = prevRow[j + 1] + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // copy current col value into previous (in preparation for next iteration)
                    prevRow[j] = curCol;
                }
                // copy last col value into previous (in preparation for next iteration)
                prevRow[j] = nextCol;
            }
            return nextCol;
        }
    };
    // amd
    if (typeof define !== "undefined" && define !== null && define.amd) define(function() {
        return Levenshtein;
    });
    else if (module !== null && true && module.exports === exports) module.exports = Levenshtein;
    else if (typeof self !== "undefined" && typeof self.postMessage === 'function' && typeof self.importScripts === 'function') self.Levenshtein = Levenshtein;
    else if (typeof window !== "undefined" && window !== null) window.Levenshtein = Levenshtein;
})();

});



parcelRegister("5N6Dq", function(module, exports) {

$parcel$export(module.exports, "default", () => $072cb84e8820cada$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $aWzLq = parcelRequire("aWzLq");
const $072cb84e8820cada$var$deleteTicketType = (ticketTypeId, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { ticketTypes: ticketTypes, appProps: { projectId: projectId } } = getState();
        const id = `${ticketTypeId}`;
        if (ticketTypes[id] !== undefined) {
            const toBeDeletedTicketType = ticketTypes[id].currentState;
            setState({
                pendingTicketTypeDeletion: {
                    error: null,
                    data: id
                }
            });
            try {
                await (0, $aWzLq.deleteTicketTypeService)(toBeDeletedTicketType, projectId);
                const { ticketTypes: existingTicketTypes } = getState();
                const updatedTicketTypes = {
                    ...existingTicketTypes
                };
                delete updatedTicketTypes[id];
                setState({
                    ticketTypes: updatedTicketTypes,
                    pendingTicketTypeDeletion: {
                        error: null,
                        data: null
                    }
                });
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'requestType deleted');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    pendingTicketTypeDeletion: {
                        error: error,
                        data: id
                    }
                });
                (0, $jcw0u.default)({
                    event: analyticsEvent,
                    meta: {
                        id: 'deleteTicketTypeService',
                        packageName: 'jiraServicedeskTicketTypesStore'
                    },
                    error: error
                });
            }
        }
    };
var $072cb84e8820cada$export$2e2bcd8739ae039 = $072cb84e8820cada$var$deleteTicketType;

});
parcelRegister("aWzLq", function(module, exports) {

$parcel$export(module.exports, "deleteTicketTypeService", () => $7365946ef9d5f589$export$3c7b63f0bae07cb0);

var $a7EYT = parcelRequire("a7EYT");
const $7365946ef9d5f589$export$64b6f8b4f6a8e722 = (projectId, groups, id)=>{
    const groupId = groups.length > 0 ? groups[0].id : 'hidden';
    return `/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${groupId}/request-types/${id}`;
};
const $7365946ef9d5f589$export$3c7b63f0bae07cb0 = (ticketType, projectId)=>{
    const { groups: groups, id: id } = ticketType;
    const url = $7365946ef9d5f589$export$64b6f8b4f6a8e722(projectId, groups, id);
    return (0, $a7EYT.performDeleteRequest)(url);
};

});
parcelRegister("a7EYT", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $99def0fa5fc488a1$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $99def0fa5fc488a1$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $99def0fa5fc488a1$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $99def0fa5fc488a1$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $99def0fa5fc488a1$export$8ef51cba9d28f819);

var $gccSB = parcelRequire("gccSB");

var $cjFoH = parcelRequire("cjFoH");

var $5HnTq = parcelRequire("5HnTq");


var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY = 'validation.error';
class $99def0fa5fc488a1$export$fee0012ae6cb3438 extends (0, $jJZqs.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(response)) this.response = response;
    }
}
const $99def0fa5fc488a1$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $99def0fa5fc488a1$var$putOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PUT'
};
const $99def0fa5fc488a1$var$postOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'POST'
};
const $99def0fa5fc488a1$var$deleteOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'DELETE'
};
const $99def0fa5fc488a1$var$patchOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PATCH'
};
const $99def0fa5fc488a1$var$processResponse = async (response)=>{
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY) throw (0, $eusud.transformValidationErrorFromServer)(jsonResponse);
        const message = $99def0fa5fc488a1$var$transformMessageErrorsFromServer(errors);
        throw new $99def0fa5fc488a1$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $99def0fa5fc488a1$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$putOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$postOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$deleteOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$patchOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);

});



parcelRegister("lsopK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0725e64e0b31bc3$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a0725e64e0b31bc3$var$resetChangeWorkflow = ()=>({ setState: setState })=>{
        setState({
            changeWorkflow: {
                isShowing: false,
                requestTypeId: null
            }
        });
    };
var $a0725e64e0b31bc3$export$2e2bcd8739ae039 = $a0725e64e0b31bc3$var$resetChangeWorkflow;

});

parcelRegister("a3YF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbe4a4ffc2f687c3$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $dbe4a4ffc2f687c3$var$setChangeWorkflowToEdit = (requestTypeId)=>({ setState: setState })=>{
        setState({
            changeWorkflow: {
                isShowing: true,
                requestTypeId: requestTypeId
            }
        });
    };
var $dbe4a4ffc2f687c3$export$2e2bcd8739ae039 = $dbe4a4ffc2f687c3$var$setChangeWorkflowToEdit;

});

parcelRegister("bXg9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c60d50b4a59502$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $02c60d50b4a59502$var$setIssueTypeWorkflow = (issueTypeId, workflow)=>({ getState: getState, setState: setState })=>{
        const { projectWorkflowScheme: projectWorkflowScheme } = getState();
        const { issueTypeIdToWorkflow: issueTypeIdToWorkflow } = projectWorkflowScheme;
        setState({
            projectWorkflowScheme: {
                ...projectWorkflowScheme,
                issueTypeIdToWorkflow: {
                    ...issueTypeIdToWorkflow,
                    [issueTypeId]: workflow
                }
            }
        });
    };
var $02c60d50b4a59502$export$2e2bcd8739ae039 = $02c60d50b4a59502$var$setIssueTypeWorkflow;

});

parcelRegister("5wJgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f81d5513d22ef5d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $7f81d5513d22ef5d$var$setProjectWorkflowScheme = (value)=>({ setState: setState })=>{
        setState({
            projectWorkflowScheme: value
        });
    };
var $7f81d5513d22ef5d$export$2e2bcd8739ae039 = $7f81d5513d22ef5d$var$setProjectWorkflowScheme;

});

parcelRegister("hBu9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $1348e39be1da05cd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1348e39be1da05cd$var$setRequestTypeCategory = (requestTypeId, category)=>({ getState: getState, setState: setState })=>{
        const { ticketTypes: ticketTypes } = getState();
        const requestType = ticketTypes[String(requestTypeId)]?.currentState;
        const updatedRequestType = {
            ...requestType,
            category: category
        };
        setState({
            ticketTypes: {
                ...ticketTypes,
                [String(requestTypeId)]: {
                    currentState: updatedRequestType,
                    updateState: {}
                }
            }
        });
    };
var $1348e39be1da05cd$export$2e2bcd8739ae039 = $1348e39be1da05cd$var$setRequestTypeCategory;

});

parcelRegister("kC55f", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf44d0945c9053c8$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $bf44d0945c9053c8$var$setRequestTypeFormData = (requestTypeFormData)=>({ setState: setState })=>{
        setState({
            requestTypeFormData: requestTypeFormData
        });
    };
var $bf44d0945c9053c8$export$2e2bcd8739ae039 = $bf44d0945c9053c8$var$setRequestTypeFormData;

});

parcelRegister("dAKn3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0aee46ea007da44$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a0aee46ea007da44$var$setRequestTypeGroups = (id, groups)=>({ getState: getState, setState: setState })=>{
        const { ticketTypes: ticketTypes } = getState();
        const requestType = ticketTypes[String(id)].currentState;
        const updatedRequestType = {
            ...requestType,
            groups: groups
        };
        setState({
            ticketTypes: {
                ...ticketTypes,
                [String(id)]: {
                    currentState: updatedRequestType,
                    updateState: {}
                }
            }
        });
    };
var $a0aee46ea007da44$export$2e2bcd8739ae039 = $a0aee46ea007da44$var$setRequestTypeGroups;

});

parcelRegister("6dYoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $529bf1393a8b1ed9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $529bf1393a8b1ed9$var$setRequestTypeIssueType = (id, issueTypeId)=>({ getState: getState, setState: setState })=>{
        const { ticketTypes: ticketTypes } = getState();
        const requestType = ticketTypes[String(id)].currentState;
        const updatedRequestType = {
            ...requestType,
            issueType: issueTypeId
        };
        setState({
            ticketTypes: {
                ...ticketTypes,
                [String(id)]: {
                    currentState: updatedRequestType,
                    updateState: {}
                }
            }
        });
    };
var $529bf1393a8b1ed9$export$2e2bcd8739ae039 = $529bf1393a8b1ed9$var$setRequestTypeIssueType;

});

parcelRegister("4PmdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c4ee6c53fbe0e6a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0c4ee6c53fbe0e6a$var$setRequestTypeSecurity = (requestTypeId, requestTypeSecurityStatus, issueSecurityStatus)=>({ getState: getState, setState: setState })=>{
        const { ticketTypes: ticketTypes } = getState();
        const requestType = ticketTypes[String(requestTypeId)]?.currentState;
        const updatedRequestType = {
            ...requestType,
            ...requestTypeSecurityStatus && {
                restrictionStatus: requestTypeSecurityStatus
            },
            ...issueSecurityStatus && {
                issueSecurityStatus: issueSecurityStatus
            }
        };
        setState({
            ticketTypes: {
                ...ticketTypes,
                [String(requestTypeId)]: {
                    currentState: updatedRequestType,
                    updateState: {}
                }
            }
        });
    };
var $0c4ee6c53fbe0e6a$export$2e2bcd8739ae039 = $0c4ee6c53fbe0e6a$var$setRequestTypeSecurity;

});

parcelRegister("48vCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eebb2efb2847191$export$2e2bcd8739ae039);

var $oCMSG = parcelRequire("oCMSG");
const $6eebb2efb2847191$var$setRequestTypesPractice = (ids, practice)=>({ getState: getState, setState: setState })=>{
        const { ticketTypes: ticketTypes } = getState();
        const practices = practice === (0, $oCMSG.NO_PRACTICE) ? [] : [
            practice
        ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedRequestTypes = ids.reduce((acc, id)=>{
            const requestType = ticketTypes[String(id)].currentState;
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...acc,
                [String(id)]: {
                    currentState: {
                        ...requestType,
                        practices: practices
                    },
                    updateState: {}
                }
            };
        }, {});
        setState({
            ticketTypes: {
                ...ticketTypes,
                ...updatedRequestTypes
            }
        });
    };
var $6eebb2efb2847191$export$2e2bcd8739ae039 = $6eebb2efb2847191$var$setRequestTypesPractice;

});

parcelRegister("cL08L", function(module, exports) {

$parcel$export(module.exports, "default", () => $665df32d9f593ebc$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $dxUH3 = parcelRequire("dxUH3");
const $665df32d9f593ebc$var$setTicketTypeIcon = (ticketTypeId, icon, analyticsEvent)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const ticketTypeIdString = ticketTypeId.toString();
        let { ticketTypes: ticketTypes } = getState();
        const ticketType = ticketTypes[ticketTypeIdString].currentState;
        const { iconId: iconId, iconUrl: iconUrl } = icon;
        const newTicketType = {
            ...ticketType,
            iconId: iconId,
            iconUrl: iconUrl
        };
        const updatedTicketTypes = {
            ...ticketTypes,
            [ticketTypeIdString]: {
                currentState: ticketType,
                updateState: {
                    icon: {
                        data: icon,
                        error: null
                    }
                }
            }
        };
        setState({
            ticketTypes: updatedTicketTypes
        });
        try {
            await dispatch((0, $dxUH3.updateTicketType)(ticketTypeIdString, newTicketType));
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'requestType updated');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            ticketTypes = getState().ticketTypes;
            const updatedTicketType = {
                currentState: {
                    ...ticketTypes[ticketTypeIdString].currentState
                },
                updateState: {
                    icon: {
                        data: null,
                        error: error
                    }
                }
            };
            const newTicketTypes = {
                ...ticketTypes,
                [ticketTypeIdString]: updatedTicketType
            };
            setState({
                ticketTypes: newTicketTypes
            });
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'updateTicketTypeIcon',
                    packageName: 'jiraServicedeskTicketTypesStore'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
var $665df32d9f593ebc$export$2e2bcd8739ae039 = $665df32d9f593ebc$var$setTicketTypeIcon;

});
parcelRegister("dxUH3", function(module, exports) {

$parcel$export(module.exports, "updateTicketType", () => $33cda9f3ee93c657$export$48e0d8e15ef68cbb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ed2T3 = parcelRequire("ed2T3");
const $33cda9f3ee93c657$export$48e0d8e15ef68cbb = (ticketTypeId, ticketType)=>async ({ getState: getState, setState: setState })=>{
        const { appProps: { projectId: projectId } } = getState();
        await (0, $ed2T3.updateTicketTypeService)(ticketType, projectId);
        const { ticketTypes: currentTicketTypes } = getState();
        const updatedTicketTypes = {
            ...currentTicketTypes,
            [ticketTypeId]: {
                currentState: ticketType,
                updateState: {}
            }
        };
        setState({
            ticketTypes: updatedTicketTypes
        });
    };

});
parcelRegister("ed2T3", function(module, exports) {

$parcel$export(module.exports, "updateTicketTypeService", () => $c1babd1b2d6520b6$export$71b5156f84a9ffbd);

var $eusud = parcelRequire("eusud");
const $c1babd1b2d6520b6$export$a0549930d7e1578d = (projectId, groups, id)=>{
    const groupId = groups.length > 0 ? groups[0].id : 'hidden';
    return `/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${groupId}/request-types/${id}`;
};
const $c1babd1b2d6520b6$export$71b5156f84a9ffbd = (ticketType, projectId)=>{
    const { description: description, groups: groups, id: id, iconId: iconId, name: name } = ticketType;
    const url = $c1babd1b2d6520b6$export$a0549930d7e1578d(projectId, groups, id);
    return (0, $eusud.performPutRequest)(url, {
        body: JSON.stringify({
            description: description,
            groups: groups,
            icon: iconId,
            id: id,
            name: name
        })
    });
};

});



parcelRegister("7VGl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e16628d478ce34$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $dxUH3 = parcelRequire("dxUH3");
const $b9e16628d478ce34$var$setTicketTypeName = (ticketTypeId, name, analyticsEvent)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const ticketTypeIdString = ticketTypeId.toString();
        let { ticketTypes: ticketTypes } = getState();
        const ticketType = ticketTypes[ticketTypeIdString].currentState;
        const newTicketType = {
            ...ticketType,
            name: name
        };
        const updatedTicketTypes = {
            ...ticketTypes,
            [ticketTypeIdString]: {
                currentState: ticketType,
                updateState: {
                    name: {
                        data: name,
                        error: null
                    }
                }
            }
        };
        setState({
            ticketTypes: updatedTicketTypes
        });
        try {
            await dispatch((0, $dxUH3.updateTicketType)(ticketTypeIdString, newTicketType));
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'requestType updated');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            ticketTypes = getState().ticketTypes;
            const updatedTicketType = {
                currentState: {
                    ...ticketTypes[ticketTypeIdString].currentState
                },
                updateState: {
                    name: {
                        data: null,
                        error: error
                    }
                }
            };
            const newTicketTypes = {
                ...ticketTypes,
                [ticketTypeIdString]: updatedTicketType
            };
            setState({
                ticketTypes: newTicketTypes
            });
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'updateTicketTypeName',
                    packageName: 'jiraServicedeskTicketTypesStore'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
var $b9e16628d478ce34$export$2e2bcd8739ae039 = $b9e16628d478ce34$var$setTicketTypeName;

});

parcelRegister("l3fjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d194f4084b76a254$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d194f4084b76a254$var$setTicketTypes = (ticketTypes)=>({ getState: getState, setState: setState })=>{
        const { ticketTypes: currentTicketTypes } = getState();
        const data = {
            ...currentTicketTypes
        };
        ticketTypes.forEach((ticketType)=>{
            data[ticketType.id.toString()] = {
                currentState: ticketType,
                updateState: {}
            };
        });
        setState({
            ticketTypes: data
        });
    };
var $d194f4084b76a254$export$2e2bcd8739ae039 = $d194f4084b76a254$var$setTicketTypes;

});

parcelRegister("69Q5q", function(module, exports) {

$parcel$export(module.exports, "pendingTicketTypeCreationSelector", () => $055932ae76259d0c$export$af0edd6ce15da08b);
$parcel$export(module.exports, "pendingTicketTypeDeletionSelector", () => $055932ae76259d0c$export$73bef9483c5bce6a);
$parcel$export(module.exports, "unmappedRequestTypesSelector", () => $055932ae76259d0c$export$46d298277bff74ac);
$parcel$export(module.exports, "ticketTypesByPracticeSelector", () => $055932ae76259d0c$export$f2df6c3c4a6006d0);
$parcel$export(module.exports, "ticketTypeSelector", () => $055932ae76259d0c$export$e2b6b89f6e0120b8);
$parcel$export(module.exports, "changeWorkflowSelector", () => $055932ae76259d0c$export$c681186a150a88);
$parcel$export(module.exports, "ticketTypeSetNameErrorSelector", () => $055932ae76259d0c$export$698509c77bd3d539);
$parcel$export(module.exports, "ticketTypeSetIconErrorSelector", () => $055932ae76259d0c$export$6fc8b0d0303e66e1);
$parcel$export(module.exports, "collatedTicketTypesSelector", () => $055932ae76259d0c$export$e6e10ef23ff52618);
$parcel$export(module.exports, "collatedUnmappedRequestTypesSelector", () => $055932ae76259d0c$export$f6c9cd77c468818b);
$parcel$export(module.exports, "appPropsSelector", () => $055932ae76259d0c$export$35f6163c558b245e);
$parcel$export(module.exports, "requestTypeFormData", () => $055932ae76259d0c$export$435cf48eb8c4adf);
$parcel$export(module.exports, "projectWorkflowSchemeSelector", () => $055932ae76259d0c$export$db09b5ba0d747b5a);

var $dGvGJ = parcelRequire("dGvGJ");

var $k7bx6 = parcelRequire("k7bx6");

var $basmW = parcelRequire("basmW");

var $gccSB = parcelRequire("gccSB");

var $1AkQu = parcelRequire("1AkQu");

var $oCMSG = parcelRequire("oCMSG");

var $lXsrv = parcelRequire("lXsrv");
const $055932ae76259d0c$export$af0edd6ce15da08b = (state)=>state.pendingTicketTypeCreation;
const $055932ae76259d0c$export$73bef9483c5bce6a = (state)=>state.pendingTicketTypeDeletion;
const $055932ae76259d0c$var$ticketTypesSelector = (0, $dGvGJ.createSelector)((state)=>state.ticketTypes, (ticketTypesMap)=>{
    const keys = Object.keys(ticketTypesMap);
    if (keys.length === 0) return null;
    return keys.map((key)=>ticketTypesMap[key] && ticketTypesMap[key].currentState);
});
const $055932ae76259d0c$export$46d298277bff74ac = (0, $dGvGJ.createSelector)($055932ae76259d0c$var$ticketTypesSelector, (0, $lXsrv.filterUnmappedRequestType));
const $055932ae76259d0c$var$ticketTypeUpdateSelector = (0, $dGvGJ.createSelector)((state)=>state.ticketTypes, (state, ticketTypeId)=>ticketTypeId, (ticketTypesMap, ticketTypeId)=>{
    if (!ticketTypesMap || Object.keys(ticketTypesMap).length < 0) return null;
    const ticketType = ticketTypesMap[String(ticketTypeId)];
    return ticketType && ticketType.updateState;
});
const $055932ae76259d0c$export$f2df6c3c4a6006d0 = (0, $dGvGJ.createSelector)((state)=>$055932ae76259d0c$var$ticketTypesSelector(state), (state)=>$055932ae76259d0c$export$46d298277bff74ac(state), (state, practice)=>practice, (allTicketTypes, unmappedRequestTypes, practice)=>{
    if (practice == null || practice === (0, $oCMSG.NO_PRACTICE)) return unmappedRequestTypes;
    const filteredTicketTypes = allTicketTypes && allTicketTypes.filter(({ practices: practices })=>practices.includes(practice));
    return !filteredTicketTypes || filteredTicketTypes.length === 0 ? null : filteredTicketTypes;
});
const $055932ae76259d0c$export$e2b6b89f6e0120b8 = (0, $dGvGJ.createSelector)((state)=>$055932ae76259d0c$var$ticketTypesSelector(state), (state, ticketTypeId)=>ticketTypeId, (ticketTypes, ticketTypeId)=>{
    if (!ticketTypes) return null;
    return ticketTypes.find(({ id: id })=>id === ticketTypeId) || null;
});
const $055932ae76259d0c$export$c681186a150a88 = (0, $dGvGJ.createSelector)((state)=>state, (state)=>{
    if (state.changeWorkflow.requestTypeId !== null) return {
        isShowing: state.changeWorkflow.isShowing,
        requestType: $055932ae76259d0c$export$e2b6b89f6e0120b8(state, state.changeWorkflow.requestTypeId)
    };
    return {
        isShowing: state.changeWorkflow.isShowing,
        requestType: null
    };
});
const $055932ae76259d0c$export$698509c77bd3d539 = (0, $dGvGJ.createSelector)((state, ticketTypeId)=>$055932ae76259d0c$var$ticketTypeUpdateSelector(state, ticketTypeId), (updateState)=>{
    const namePendingState = updateState && updateState.name;
    if (namePendingState) return namePendingState.error;
    return null;
});
const $055932ae76259d0c$export$6fc8b0d0303e66e1 = (0, $dGvGJ.createSelector)((state, ticketTypeId)=>$055932ae76259d0c$var$ticketTypeUpdateSelector(state, ticketTypeId), (updateState)=>{
    const iconPendingState = updateState && updateState.icon;
    if (iconPendingState) return iconPendingState.error;
    return null;
});
const $055932ae76259d0c$export$277bc4015d5b9fce = (0, $dGvGJ.createSelector)((state, { practice: practice })=>$055932ae76259d0c$export$f2df6c3c4a6006d0(state, practice), (state, filterOptions)=>filterOptions, (ticketTypesByPractice, filterOptions)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(ticketTypesByPractice)) return null;
    const { issueTypes: issueTypes, groups: groups, text: text } = filterOptions;
    const { requestTypeCategories: requestTypeCategories } = filterOptions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        (0, (/*@__PURE__*/$parcel$interopDefault($k7bx6)))((0, $lXsrv.filterTicketTypesByIssueTypes))(issueTypes),
        (0, (/*@__PURE__*/$parcel$interopDefault($k7bx6)))((0, $lXsrv.filterTicketTypesByGroups))(groups),
        (0, (/*@__PURE__*/$parcel$interopDefault($k7bx6)))((0, $lXsrv.filterTicketTypesByText))(text),
        (0, (/*@__PURE__*/$parcel$interopDefault($k7bx6)))((0, $lXsrv.filterTicketTypesByCategory))(requestTypeCategories)
    ])(ticketTypesByPractice);
});
const $055932ae76259d0c$export$e6e10ef23ff52618 = (0, $dGvGJ.createSelector)((state, { filters: filters })=>filters ? $055932ae76259d0c$export$277bc4015d5b9fce(state, filters) : $055932ae76259d0c$var$ticketTypesSelector(state), (state, { sort: sort })=>sort, (filteredTicketTypes, sort)=>{
    if (filteredTicketTypes) return sort ? (0, (/*@__PURE__*/$parcel$interopDefault($1AkQu)))(filteredTicketTypes, sort.iteratees, sort.orders) : filteredTicketTypes;
    return null;
});
const $055932ae76259d0c$export$f6c9cd77c468818b = (0, $dGvGJ.createSelector)($055932ae76259d0c$export$e6e10ef23ff52618, (0, $lXsrv.filterUnmappedRequestType));
const $055932ae76259d0c$export$35f6163c558b245e = (state)=>state.appProps;
const $055932ae76259d0c$export$435cf48eb8c4adf = (state)=>state.requestTypeFormData.data;
const $055932ae76259d0c$export$db09b5ba0d747b5a = (state)=>state.projectWorkflowScheme;

});
parcelRegister("k7bx6", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");
/** Used to compose bitmasks for function metadata. */ var $ea4d6843cad6318b$var$WRAP_CURRY_RIGHT_FLAG = 16;
/**
 * This method is like `_.curry` except that arguments are applied to `func`
 * in the manner of `_.partialRight` instead of `_.partial`.
 *
 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curryRight(abc);
 *
 * curried(3)(2)(1);
 * // => [1, 2, 3]
 *
 * curried(2, 3)(1);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(3)(1, _)(2);
 * // => [1, 2, 3]
 */ function $ea4d6843cad6318b$var$curryRight(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $5oTQF(func, $ea4d6843cad6318b$var$WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $ea4d6843cad6318b$var$curryRight.placeholder;
    return result;
}
// Assign default placeholders.
$ea4d6843cad6318b$var$curryRight.placeholder = {};
module.exports = $ea4d6843cad6318b$var$curryRight;

});
parcelRegister("5oTQF", function(module, exports) {

var $g1o5k = parcelRequire("g1o5k");

var $1BSxH = parcelRequire("1BSxH");

var $gQoGK = parcelRequire("gQoGK");

var $2pq1V = parcelRequire("2pq1V");

var $cwXqG = parcelRequire("cwXqG");

var $dzqxs = parcelRequire("dzqxs");

var $c8pf3 = parcelRequire("c8pf3");

var $4EzKU = parcelRequire("4EzKU");

var $iKqmZ = parcelRequire("iKqmZ");

var $kPZpS = parcelRequire("kPZpS");
/** Error message constants. */ var $3eea84024a50d6cf$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $3eea84024a50d6cf$var$WRAP_BIND_FLAG = 1, $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG = 2, $3eea84024a50d6cf$var$WRAP_CURRY_FLAG = 8, $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG = 16, $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG = 32, $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3eea84024a50d6cf$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $3eea84024a50d6cf$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($3eea84024a50d6cf$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $3eea84024a50d6cf$var$nativeMax($kPZpS(ary), 0);
    arity = arity === undefined ? arity : $kPZpS(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $dzqxs(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $c8pf3(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3eea84024a50d6cf$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $3eea84024a50d6cf$var$WRAP_BIND_FLAG) var result = $1BSxH(func, bitmask, thisArg);
    else if (bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_FLAG || bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG) result = $gQoGK(func, bitmask, arity);
    else if ((bitmask == $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG || bitmask == ($3eea84024a50d6cf$var$WRAP_BIND_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $cwXqG(func, bitmask, thisArg, partials);
    else result = $2pq1V.apply(undefined, newData);
    var setter = data ? $g1o5k : $4EzKU;
    return $iKqmZ(setter(result, newData), func, bitmask);
}
module.exports = $3eea84024a50d6cf$var$createWrap;

});
parcelRegister("g1o5k", function(module, exports) {

var $etyzk = parcelRequire("etyzk");

var $hQCy5 = parcelRequire("hQCy5");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $ba9f6c1d52531584$var$baseSetData = !$hQCy5 ? $etyzk : function(func, data) {
    $hQCy5.set(func, data);
    return func;
};
module.exports = $ba9f6c1d52531584$var$baseSetData;

});

parcelRegister("1BSxH", function(module, exports) {

var $iJkMv = parcelRequire("iJkMv");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $12c38e2c5009183b$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $12c38e2c5009183b$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $12c38e2c5009183b$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
    function wrapper() {
        var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $12c38e2c5009183b$var$createBind;

});
parcelRegister("iJkMv", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $da2c8caf7ae3955a$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $ady43(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $k0qYG(result) ? result : thisBinding;
    };
}
module.exports = $da2c8caf7ae3955a$var$createCtor;

});


parcelRegister("gQoGK", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $iJkMv = parcelRequire("iJkMv");

var $2pq1V = parcelRequire("2pq1V");

var $6fuEo = parcelRequire("6fuEo");

var $8ZIC5 = parcelRequire("8ZIC5");

var $kBUUu = parcelRequire("kBUUu");

var $1V15E = parcelRequire("1V15E");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $c434a7442e0e841e$var$createCurry(func, bitmask, arity) {
    var Ctor = $iJkMv(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $8ZIC5(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBUUu(args, placeholder);
        length -= holders.length;
        if (length < arity) return $6fuEo(func, bitmask, $2pq1V, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        return $hlchF(fn, this, args);
    }
    return wrapper;
}
module.exports = $c434a7442e0e841e$var$createCurry;

});
parcelRegister("2pq1V", function(module, exports) {

var $k8MLc = parcelRequire("k8MLc");

var $eqXBf = parcelRequire("eqXBf");

var $khpbX = parcelRequire("khpbX");

var $iJkMv = parcelRequire("iJkMv");

var $6fuEo = parcelRequire("6fuEo");

var $8ZIC5 = parcelRequire("8ZIC5");

var $3Prcz = parcelRequire("3Prcz");

var $kBUUu = parcelRequire("kBUUu");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $1c121b92b9034c1f$var$WRAP_BIND_FLAG = 1, $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG = 2, $1c121b92b9034c1f$var$WRAP_CURRY_FLAG = 8, $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG = 16, $1c121b92b9034c1f$var$WRAP_ARY_FLAG = 128, $1c121b92b9034c1f$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1c121b92b9034c1f$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $1c121b92b9034c1f$var$WRAP_ARY_FLAG, isBind = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1c121b92b9034c1f$var$WRAP_CURRY_FLAG | $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1c121b92b9034c1f$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $iJkMv(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $8ZIC5(wrapper), holdersCount = $khpbX(args, placeholder);
        if (partials) args = $k8MLc(args, partials, holders, isCurried);
        if (partialsRight) args = $eqXBf(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBUUu(args, placeholder);
            return $6fuEo(func, bitmask, $1c121b92b9034c1f$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $3Prcz(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $1V15E && this instanceof wrapper) fn = Ctor || $iJkMv(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $1c121b92b9034c1f$var$createHybrid;

});
parcelRegister("k8MLc", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea9a60ca966f8da9$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $ea9a60ca966f8da9$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $ea9a60ca966f8da9$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $ea9a60ca966f8da9$var$composeArgs;

});

parcelRegister("eqXBf", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a821b9ab167c5b82$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $a821b9ab167c5b82$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $a821b9ab167c5b82$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $a821b9ab167c5b82$var$composeArgsRight;

});

parcelRegister("khpbX", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $ec38efbc1ab3f809$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $ec38efbc1ab3f809$var$countHolders;

});

parcelRegister("6fuEo", function(module, exports) {

var $2dCKt = parcelRequire("2dCKt");

var $4EzKU = parcelRequire("4EzKU");

var $iKqmZ = parcelRequire("iKqmZ");
/** Used to compose bitmasks for function metadata. */ var $48cbeb57943323d5$var$WRAP_BIND_FLAG = 1, $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG = 2, $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG = 4, $48cbeb57943323d5$var$WRAP_CURRY_FLAG = 8, $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG = 32, $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $48cbeb57943323d5$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $48cbeb57943323d5$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($48cbeb57943323d5$var$WRAP_BIND_FLAG | $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($2dCKt(func)) $4EzKU(result, newData);
    result.placeholder = placeholder;
    return $iKqmZ(result, func, bitmask);
}
module.exports = $48cbeb57943323d5$var$createRecurry;

});
parcelRegister("4EzKU", function(module, exports) {

var $g1o5k = parcelRequire("g1o5k");

var $eqv0t = parcelRequire("eqv0t");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $3636a22a88d50b78$var$setData = $eqv0t($g1o5k);
module.exports = $3636a22a88d50b78$var$setData;

});

parcelRegister("iKqmZ", function(module, exports) {

var $d25DY = parcelRequire("d25DY");

var $iPKwQ = parcelRequire("iPKwQ");

var $8pgNR = parcelRequire("8pgNR");

var $1ZcUe = parcelRequire("1ZcUe");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $da60fa5a8c702882$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $8pgNR(wrapper, $iPKwQ(source, $1ZcUe($d25DY(source), bitmask)));
}
module.exports = $da60fa5a8c702882$var$setWrapToString;

});
parcelRegister("d25DY", function(module, exports) {
/** Used to match wrap detail comments. */ var $97cfd7023a392295$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $97cfd7023a392295$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $97cfd7023a392295$var$getWrapDetails(source) {
    var match = source.match($97cfd7023a392295$var$reWrapDetails);
    return match ? match[1].split($97cfd7023a392295$var$reSplitDetails) : [];
}
module.exports = $97cfd7023a392295$var$getWrapDetails;

});

parcelRegister("iPKwQ", function(module, exports) {
/** Used to match wrap detail comments. */ var $db61150bcd231438$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $db61150bcd231438$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($db61150bcd231438$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $db61150bcd231438$var$insertWrapDetails;

});

parcelRegister("1ZcUe", function(module, exports) {

var $fmP8r = parcelRequire("fmP8r");

var $fUP98 = parcelRequire("fUP98");
/** Used to compose bitmasks for function metadata. */ var $17257fcfcc231370$var$WRAP_BIND_FLAG = 1, $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG = 2, $17257fcfcc231370$var$WRAP_CURRY_FLAG = 8, $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG = 16, $17257fcfcc231370$var$WRAP_PARTIAL_FLAG = 32, $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $17257fcfcc231370$var$WRAP_ARY_FLAG = 128, $17257fcfcc231370$var$WRAP_REARG_FLAG = 256, $17257fcfcc231370$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $17257fcfcc231370$var$wrapFlags = [
    [
        'ary',
        $17257fcfcc231370$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $17257fcfcc231370$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $17257fcfcc231370$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $17257fcfcc231370$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $17257fcfcc231370$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $17257fcfcc231370$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $17257fcfcc231370$var$updateWrapDetails(details, bitmask) {
    $fmP8r($17257fcfcc231370$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$fUP98(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $17257fcfcc231370$var$updateWrapDetails;

});



parcelRegister("8ZIC5", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $68c6a086039b9437$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $68c6a086039b9437$var$getHolder;

});

parcelRegister("3Prcz", function(module, exports) {

var $jHlUS = parcelRequire("jHlUS");

var $e8U1z = parcelRequire("e8U1z");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c9b3c36ffa24094$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $2c9b3c36ffa24094$var$reorder(array, indexes) {
    var arrLength = array.length, length = $2c9b3c36ffa24094$var$nativeMin(indexes.length, arrLength), oldArray = $jHlUS(array);
    while(length--){
        var index = indexes[length];
        array[length] = $e8U1z(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $2c9b3c36ffa24094$var$reorder;

});

parcelRegister("kBUUu", function(module, exports) {
/** Used as the internal argument placeholder. */ var $f0136883d4267917$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $f0136883d4267917$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $f0136883d4267917$var$PLACEHOLDER) {
            array[index] = $f0136883d4267917$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $f0136883d4267917$var$replaceHolders;

});



parcelRegister("cwXqG", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $iJkMv = parcelRequire("iJkMv");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $91f6929c17575724$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $91f6929c17575724$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $91f6929c17575724$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $hlchF(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $91f6929c17575724$var$createPartial;

});

parcelRegister("c8pf3", function(module, exports) {

var $k8MLc = parcelRequire("k8MLc");

var $eqXBf = parcelRequire("eqXBf");

var $kBUUu = parcelRequire("kBUUu");
/** Used as the internal argument placeholder. */ var $8d59cfe3586d6695$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $8d59cfe3586d6695$var$WRAP_BIND_FLAG = 1, $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG = 2, $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG = 4, $8d59cfe3586d6695$var$WRAP_CURRY_FLAG = 8, $8d59cfe3586d6695$var$WRAP_ARY_FLAG = 128, $8d59cfe3586d6695$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8d59cfe3586d6695$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $8d59cfe3586d6695$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($8d59cfe3586d6695$var$WRAP_BIND_FLAG | $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG | $8d59cfe3586d6695$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG || srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($8d59cfe3586d6695$var$WRAP_ARY_FLAG | $8d59cfe3586d6695$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG ? 0 : $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $k8MLc(partials, value, source[4]) : value;
        data[4] = partials ? $kBUUu(data[3], $8d59cfe3586d6695$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $eqXBf(partials, value, source[6]) : value;
        data[6] = partials ? $kBUUu(data[5], $8d59cfe3586d6695$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $8d59cfe3586d6695$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $8d59cfe3586d6695$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $8d59cfe3586d6695$var$mergeData;

});



parcelRegister("1AkQu", function(module, exports) {

var $kE90z = parcelRequire("kE90z");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $127952ba7d4c15a6$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$8LQ84(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$8LQ84(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $kE90z(collection, iteratees, orders);
}
module.exports = $127952ba7d4c15a6$var$orderBy;

});

parcelRegister("lXsrv", function(module, exports) {

$parcel$export(module.exports, "FILTER_BY_NO_GROUPS_GROUP_ID", () => $5f0f8cbebb505f4a$export$476dbeb3cc2e266a);
$parcel$export(module.exports, "filterTicketTypesByIssueTypes", () => $5f0f8cbebb505f4a$export$d2b6aa0e5d67e6de);
$parcel$export(module.exports, "filterTicketTypesByGroups", () => $5f0f8cbebb505f4a$export$858bdcc3661a249d);
$parcel$export(module.exports, "filterTicketTypesByCategory", () => $5f0f8cbebb505f4a$export$dc3111cd3fae2e3a);
$parcel$export(module.exports, "filterTicketTypesByText", () => $5f0f8cbebb505f4a$export$28fedc2bfea3ae43);
$parcel$export(module.exports, "filterUnmappedRequestType", () => $5f0f8cbebb505f4a$export$984372a700133d04);

var $4Xk2W = parcelRequire("4Xk2W");
const $5f0f8cbebb505f4a$export$476dbeb3cc2e266a = -1;
const $5f0f8cbebb505f4a$export$d2b6aa0e5d67e6de = (ticketTypes, issueTypes)=>{
    if (issueTypes.length === 0) return ticketTypes;
    const issueTypesSet = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issueTypes, 'id');
    return ticketTypes.filter((ticketType)=>issueTypesSet[ticketType.issueType]);
};
const $5f0f8cbebb505f4a$export$858bdcc3661a249d = (ticketTypes, groupsFilter)=>{
    if (groupsFilter.length === 0) return ticketTypes;
    const groupsSet = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(groupsFilter, 'id');
    return ticketTypes.filter((ticketType)=>{
        const { groups: groups } = ticketType;
        const isCheckForItemsWithNoGroups = Boolean(groupsSet[$5f0f8cbebb505f4a$export$476dbeb3cc2e266a]);
        if (isCheckForItemsWithNoGroups && groups.length === 0) return true;
        return groups.some((group)=>groupsSet[group.id]);
    });
};
const $5f0f8cbebb505f4a$export$dc3111cd3fae2e3a = (ticketTypes, categories)=>{
    if (categories.length === 0) return ticketTypes;
    const categorySet = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(categories, 'id');
    return ticketTypes.filter((ticketType)=>{
        const { category: category } = ticketType;
        if (!category) return false;
        return categorySet[category.id];
    });
};
const $5f0f8cbebb505f4a$export$28fedc2bfea3ae43 = (ticketTypes, text)=>{
    if (!text) return ticketTypes;
    const lowercaseText = text.trim().toLocaleLowerCase();
    return ticketTypes.filter(({ name: name, description: description })=>`${name} ${description}`.toLocaleLowerCase().includes(lowercaseText));
};
const $5f0f8cbebb505f4a$export$984372a700133d04 = (requestTypes)=>{
    if (!requestTypes) return [];
    return requestTypes.filter(({ practices: practices })=>practices.length === 0);
};

});



parcelRegister("1V7UD", function(module, exports) {

$parcel$export(module.exports, "setSelectedForm", () => $b9bf56c2b36d82c5$export$8f6273ea84daf7a0);

var $k54oX = parcelRequire("k54oX");

var $kqnEs = parcelRequire("kqnEs");

var $lQAYg = parcelRequire("lQAYg");
const $b9bf56c2b36d82c5$export$8f6273ea84daf7a0 = async (store, formId)=>{
    const state = store.getState();
    if ((0, $lQAYg.getProjectType)(state) !== 'service_desk') return;
    const projectId = (0, $lQAYg.getProjectId)(state);
    const cloudId = (0, $lQAYg.getCloudId)(state);
    const selectedForm = await (0, $k54oX.fetchProformaSelectedForm)({
        cloudId: cloudId,
        projectId: projectId,
        formId: formId
    });
    selectedForm && store.dispatch((0, $kqnEs.addProformaFormOptimistically)(selectedForm));
};

});
parcelRegister("k54oX", function(module, exports) {

$parcel$export(module.exports, "fetchProformaSelectedForm", () => $e808e60a1dac6ff6$export$e4e02ec802dde945);

var $4R6GH = parcelRequire("4R6GH");

var $kBqOV = parcelRequire("kBqOV");
const $e808e60a1dac6ff6$export$e4e02ec802dde945 = async ({ cloudId: cloudId, projectId: projectId, formId: formId })=>{
    try {
        const proformaFormDataResponse = await (0, $kBqOV.fetchProformaFormData)({
            cloudId: cloudId,
            projectId: projectId,
            formId: formId
        });
        if (proformaFormDataResponse === null) return null;
        const issueFormSettings = proformaFormDataResponse?.publish?.jira;
        return {
            formId: formId,
            formName: proformaFormDataResponse?.design.settings.name,
            linkedFields: $e808e60a1dac6ff6$var$getLinkedFields(proformaFormDataResponse),
            usedAsIssueForm: issueFormSettings?.newIssueRequestTypeIds && issueFormSettings?.newIssueRequestTypeIds.length > 0 || issueFormSettings?.newIssueIssueTypeIds && issueFormSettings?.newIssueIssueTypeIds.length > 0,
            restrictionStatus: (0, $4R6GH.fg)('granular_permissions_on_forms_m1') ? proformaFormDataResponse?.restrictionStatus : undefined
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $kBqOV.sendErrorAnalyticsEvent)(projectId, formId, error);
        return null;
    }
};
const $e808e60a1dac6ff6$var$getLinkedFields = (form)=>Object.values(form.design.questions).reduce((acc, question)=>{
        if (question.jiraField) acc[question.jiraField] = {
            key: question.jiraField,
            required: question.validation.rq
        };
        return acc;
    }, {});

});
parcelRegister("kBqOV", function(module, exports) {

$parcel$export(module.exports, "fetchProformaFormData", () => $71d6cf3d380c3fd7$export$7f78d3298806a680);
$parcel$export(module.exports, "sendErrorAnalyticsEvent", () => $71d6cf3d380c3fd7$export$c80735b6de2f9cb4);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $71d6cf3d380c3fd7$export$7f78d3298806a680 = async ({ cloudId: cloudId, projectId: projectId, formId: formId })=>(0, $eusud.performGetRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/2/projects/${projectId}/forms/${formId}`);
const $71d6cf3d380c3fd7$export$c80735b6de2f9cb4 = (projectId, formId, error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'fetchProformaReqTypeForm',
            packageName: $26bfa12f59001b80$export$9345d7360ffe0722,
            teamName: $26bfa12f59001b80$export$9f98a8d796affec6
        },
        error: error,
        attributes: {
            projectId: projectId,
            formId: formId
        }
    });
};

});



parcelRegister("7O80d", function(module, exports) {

$parcel$export(module.exports, "FormCard", () => $6f3918c6cf4237c3$export$11154b700737b45e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $5Fuj0 = parcelRequire("5Fuj0");

var $dD7Zc = parcelRequire("dD7Zc");

var $7paD5 = parcelRequire("7paD5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $3bDjY = parcelRequire("3bDjY");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dtkTM = parcelRequire("dtkTM");

var $f8MmL = parcelRequire("f8MmL");

var $2teXs = parcelRequire("2teXs");

var $11mCu = parcelRequire("11mCu");

var $jOXAB = parcelRequire("jOXAB");

var $hPw0Z = parcelRequire("hPw0Z");

var $947Yg = parcelRequire("947Yg");

var $lvsgf = parcelRequire("lvsgf");

var $5wvQR = parcelRequire("5wvQR");
var $6rybY = parcelRequire("6rybY");
var $kxjzW = parcelRequire("kxjzW");

var $koeKL = parcelRequire("koeKL");

var $bV8dQ = parcelRequire("bV8dQ");

var $5bpEQ = parcelRequire("5bpEQ");

var $9k3m4 = parcelRequire("9k3m4");

var $6JsCe = parcelRequire("6JsCe");

var $az6SI = parcelRequire("az6SI");
const $6f3918c6cf4237c3$var$scrollIntoView = (el)=>{
    if (!el || !el.scrollIntoView) return;
    try {
        // @ts-expect-error - TS2345 - Argument of type '{ block: "nearest"; behaviour: string; }' is not assignable to parameter of type 'boolean | ScrollIntoViewOptions | undefined'.
        el.scrollIntoView({
            block: 'nearest',
            behaviour: 'smooth'
        }); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        el.scrollIntoView();
    }
};
const $6f3918c6cf4237c3$export$7bb68811c2476537 = (props)=>{
    const { config: config, onRemoveFormClick: onRemoveFormClick, autoExpand: autoExpand = false, projectKey: projectKey } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const intl = (0, $koVbs.default)();
    const { formatList: formatList, formatMessage: formatMessage } = intl;
    const { openCardKeys: openCardKeys, cardToggled: cardToggled } = (0, $f8MmL.useSwiftLifecycle)();
    const isOpen = openCardKeys.includes('formcard');
    const onToggle = ()=>cardToggled('formcard');
    const onClick = (e)=>{
        e.stopPropagation();
        onToggle();
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        onToggle();
    };
    const previouslyOpen = (0, $5uXOq.useRef)(false);
    const elevationRef = (0, $5uXOq.useRef)(null);
    const handleElevationRefChanged = (0, $5uXOq.useCallback)((ref)=>{
        elevationRef.current = ref;
    }, [
        elevationRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (autoExpand) cardToggled('formcard');
    }, [
        autoExpand,
        cardToggled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && !previouslyOpen.current) $6f3918c6cf4237c3$var$scrollIntoView(elevationRef.current);
        previouslyOpen.current = isOpen;
    }, [
        isOpen,
        previouslyOpen,
        elevationRef
    ]);
    const { projectId: projectId, formName: formName, formId: formId, requestTypeId: requestTypeId, linkedFields: linkedFields, restrictionStatus: restrictionStatus } = config;
    const [showConfirmation, setShowConfirmation] = (0, $5uXOq.useState)(false);
    const onRemoveFormClickCallback = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    ()=>onRemoveFormClick(requestTypeId), [
        onRemoveFormClick,
        requestTypeId
    ]);
    const toggleConfirmation = ()=>{
        setShowConfirmation(!showConfirmation);
    };
    const mismatchedFields = (0, $5uXOq.useMemo)(()=>{
        if (props.category && linkedFields) {
            // Get required field on request type
            const requiredFieldsOnRequest = props.category.layoutItems.filter((item)=>item.layoutItemType === (0, $2teXs.FIELD_LAYOUT_ITEM_TYPE) && item.data.required) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            .map((item)=>item.data); // Get conditional fields from associated form
            const conditionalFieldsOnForm = Object.keys(linkedFields).filter((key)=>!!linkedFields && !!linkedFields[key].conditional); /**
                                                                                                                                   * Conditional fields mismatch are those that are required
                                                                                                                                   * in RTC configuration and conditional in associated form
                                                                                                                                   */ 
            const conditionalMismatchFields = requiredFieldsOnRequest.filter((requestField)=>conditionalFieldsOnForm.includes(requestField.key)); /**
                                                                                                                                             * Get non-required fields from associated form that are not conditional
                                                                                                                                             * and exclude summary field, as summary is excluded from required error
                                                                                                                                             */ 
            const nonRequiredFieldsOnForm = Object.keys(linkedFields).filter((key)=>key !== (0, $5fc53.SUMMARY_TYPE) && !!linkedFields && !linkedFields[key].required && !linkedFields[key].conditional); /**
                                                                                                                                                                                               * Required fields mismatch are those that are required
                                                                                                                                                                                               * in RTC configuration and not required in associated form.
                                                                                                                                                                                               * See previous comments for the full logic behind required mismatch
                                                                                                                                                                                               */ 
            const requiredMismatchFields = requiredFieldsOnRequest.filter((requestField)=>nonRequiredFieldsOnForm.includes(requestField.key));
            return {
                conditionalFields: conditionalMismatchFields,
                requiredFields: requiredMismatchFields,
                hasMismatch: conditionalMismatchFields.length > 0 || requiredMismatchFields.length > 0
            };
        }
        return {
            conditionalFields: [],
            requiredFields: [],
            hasMismatch: false
        };
    }, [
        linkedFields,
        props.category
    ]);
    const getMismatchFieldTooltipMessage = ()=>{
        if (mismatchedFields.conditionalFields.length > 0) {
            if (mismatchedFields.requiredFields.length > 0) return (0, $6JsCe.messages).conditionalAndRequiredFieldMismatchTooltipError;
            return (0, $6JsCe.messages).conditionalFieldMismatchTooltipError;
        }
        return (0, $6JsCe.messages).requiredFieldMismatchTooltipError;
    };
    const getMismatchFieldSectionMessage = ()=>{
        if (mismatchedFields.conditionalFields.length > 0) {
            if (mismatchedFields.requiredFields.length > 0) return (0, $6JsCe.messages).conditionalAndRequiredFieldMismatchSectionError;
            return (0, $6JsCe.messages).conditionalFieldMismatchSectionError;
        }
        return (0, $6JsCe.messages).requiredFieldMismatchSectionError;
    }; /**
      * Returns required mismatch fields if there is required and conditional mismatch, or
      * if there is only required fields mismatch. Otherwise returns conditional mismatch fields.
      * Function returns required mismatch fields if there is required and conditional mismatch
      * because in that case we display required mismatch field names only to the user. Otherwise we
      * display conditional mismatch field names.
      */ 
    const getMismatchFieldNames = ()=>(mismatchedFields.requiredFields.length > 0 ? mismatchedFields.requiredFields : mismatchedFields.conditionalFields).map((field)=>`\u{2018}${field.name}\u{2018}`);
    const formBuilderUrl = `/jira/servicedesk/projects/${projectKey}/settings/forms/form/${formId}/edit`; // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const onFieldToggleTransitionEnd = ()=>{};
    const stopPropagation = (e)=>e.stopPropagation();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f3918c6cf4237c3$var$Margin, {
        ref: handleElevationRefChanged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f3918c6cf4237c3$var$Expandable, {
        sortable: true,
        isExpandable: true,
        isHighlighted: false,
        isOpen: isOpen,
        deleteAnimation: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.Form), {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f3918c6cf4237c3$var$HeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f3918c6cf4237c3$var$HeaderColumn, {
        isFlex: true,
        onClick: onClick
    }, restrictionStatus && restrictionStatus === (0, $5wvQR.FormRestrictionStatus).RESTRICTED && (0, $4R6GH.fg)('granular_permissions_on_forms_m1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bV8dQ.AnalyticsProvider), {
        channel: (0, $5bpEQ.ANALYTICS_CHANNEL)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6rybY.FormSecurityConfigButton), {
        restrictionStatus: restrictionStatus ?? (0, $5wvQR.FormRestrictionStatus).OPEN,
        loadRestrictedPrincipals: ()=>(0, $kxjzW.loadRestrictedPrincipalsForTemplateForm)(cloudId, projectId, formId),
        saveRestrictedPrincipals: ()=>Promise.resolve(),
        isViewMode: true,
        appearance: "subtle",
        spacing: "compact",
        viewModeManageRestrictionUrl: (0, $4R6GH.fg)('granular_permissions_on_forms_ga') ? formBuilderUrl : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11mCu.FieldNameWrapper), {
        "data-testid": "project-settings-product-features-jsm-common.ui.form-panel.form-card.form-name"
    }, formName))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.IconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: (0, $9k3m4.default),
        label: formatMessage((0, $6JsCe.messages).formIconAriaLabel),
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11mCu.FieldNameWrapper), {
        "data-testid": "project-settings-product-features-jsm-common.ui.form-panel.form-card.form-name"
    }, formName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f3918c6cf4237c3$var$HeaderColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f3918c6cf4237c3$var$EditButtonWrapper, {
        appearance: "subtle",
        href: formBuilderUrl,
        target: "_blank",
        spacing: "compact",
        title: formatMessage((0, $6JsCe.messages).editDropdownItemLabel),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            label: formatMessage((0, $6JsCe.messages).opensInAnotherWindowAriaLabel),
            LEGACY_size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6JsCe.messages).editDropdownItemLabel)), onRemoveFormClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: toggleConfirmation,
        title: formatMessage((0, $6JsCe.messages).removeFormLabel),
        spacing: "none",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Fuj0))), {
            label: formatMessage((0, $6JsCe.messages).removeFormLabel),
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPw0Z.ChevronContainer), {
        isOpen: isOpen,
        onMouseDown: stopPropagation,
        onTransitionEnd: onFieldToggleTransitionEnd
    }, mismatchedFields.hasMismatch && !isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(getMismatchFieldTooltipMessage())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: onClick,
        "aria-label": formatMessage((0, $6JsCe.messages).fieldMismatchErrorIcon),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        })
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $947Yg.FieldChevron), {
        isOpen: isOpen,
        onClick: onClick,
        isExpandable: true,
        error: undefined
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jOXAB.HeightAnimator), {
        Animation: (0, $hPw0Z.FieldContentAnimation),
        isExpanded: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvsgf.Consumer), null, (onRecalculateAnimatorHeight)=>isOpen && formId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, mismatchedFields.hasMismatch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f3918c6cf4237c3$var$SectionMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...getMismatchFieldSectionMessage(),
            values: {
                // @ts-expect-error - Type '(content: string) => JSX.Element' is not assignable to type 'ReactNode'.
                b: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        weight: "bold"
                    }, content),
                fieldList: formatList(getMismatchFieldNames(), {
                    type: 'conjunction',
                    style: 'long'
                }),
                fieldListCount: getMismatchFieldNames().length
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $6f3918c6cf4237c3$var$formPreviewWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dtkTM.AsyncFormPreview), {
            formId: formId,
            onRecalculateParentHeight: onRecalculateAnimatorHeight
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $az6SI.RemoveFormConfirmationDialog), {
        isOpen: showConfirmation,
        onConfirm: onRemoveFormClickCallback,
        onCancel: toggleConfirmation
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $6f3918c6cf4237c3$export$11154b700737b45e = (props)=>{
    const formCardProps = {
        ...props,
        onRemoveFormClick: props.onRemoveFormFromReqType
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "proformaRtcFormCard",
        packageName: "jiraProjectSettingsProductFeaturesJsmCommon",
        teamName: "jsd-shield"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "proformaRtcFormCard",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f3918c6cf4237c3$export$7bb68811c2476537, formCardProps)));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f3918c6cf4237c3$var$HeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hPw0Z.FieldHeaderContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f3918c6cf4237c3$var$HeaderColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlex: isFlex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _2lx2vrvc _1bto1l2s _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.isFlex && "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f3918c6cf4237c3$var$Margin = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f3918c6cf4237c3$var$EditButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f3918c6cf4237c3$var$Expandable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hPw0Z.Elevation), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk1d5g",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f3918c6cf4237c3$var$SectionMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $6f3918c6cf4237c3$var$formPreviewWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.100'
});

});
parcelRegister("5Fuj0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bce2e8cefeb7a1e23af480e5534534d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42084a291eb7f82a$var$_react = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42084a291eb7f82a$var$_delete = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("4IrpZ")));

var $42084a291eb7f82a$var$_remove = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("f5BqX")));
function $42084a291eb7f82a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "EditorRemoveIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42084a291eb7f82a$var$DeleteIcon = (props)=>/*#__PURE__*/ $42084a291eb7f82a$var$_react.default.createElement($42084a291eb7f82a$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $42084a291eb7f82a$var$_remove.default
    }, props));
$42084a291eb7f82a$var$DeleteIcon.Name = 'DeleteIconMigration';
var $42084a291eb7f82a$var$_default = module.exports.default = $42084a291eb7f82a$var$DeleteIcon;

});
parcelRegister("4IrpZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36f08a2f957bd6ab$var$_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>/*#__PURE__*/ $36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;

});

parcelRegister("f5BqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afc45c3418436f46$var$_react = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $afc45c3418436f46$var$_delete = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("4IrpZ")));
function $afc45c3418436f46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $afc45c3418436f46$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $afc45c3418436f46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $afc45c3418436f46$var$_delete.default
    }));
$afc45c3418436f46$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $afc45c3418436f46$var$_default = module.exports.default = $afc45c3418436f46$var$EditorRemoveIcon;

});


parcelRegister("dtkTM", function(module, exports) {

$parcel$export(module.exports, "AsyncFormPreview", () => $3cf7e1d1137d9902$export$3ab7a1434debc7af);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3cf7e1d1137d9902$var$FormPreview = (0, $kxZPA.lazy)(()=>(parcelRequire("1mKaB")).then((exportedModule)=>exportedModule.FormPreview), {
    moduleId: "./src/packages/proforma/request-type-config/src/ui/form-preview/index.tsx"
});
const $3cf7e1d1137d9902$export$3ab7a1434debc7af = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "ProformaRTCPreviewWrapper",
        packageName: (0, $26bfa12f59001b80$export$9345d7360ffe0722),
        teamName: (0, $26bfa12f59001b80$export$9f98a8d796affec6)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        name: "form-preview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3cf7e1d1137d9902$var$FormPreview, props)));

});
parcelRegister("1mKaB", function(module, exports) {

let $0feba8ea9047cf3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0feba8ea9047cf3b$var$load("kWrFZ"),
    $0feba8ea9047cf3b$var$load("h2MrD"),
    $0feba8ea9047cf3b$var$load("bYT2S"),
    $0feba8ea9047cf3b$var$load("cM9em"),
    $0feba8ea9047cf3b$var$load("fr9NE"),
    $0feba8ea9047cf3b$var$load("kcSVE")
]).then(()=>parcelRequire('5uJ4p'));

});


parcelRegister("f8MmL", function(module, exports) {

$parcel$export(module.exports, "SwiftLifecycleProvider", () => $42b0a4d2955bb51a$export$d5727b8dd7c8e192);
$parcel$export(module.exports, "useSwiftLifecycle", () => $42b0a4d2955bb51a$export$23d7c5f55420ac55);

var $5uXOq = parcelRequire("5uXOq");
const $42b0a4d2955bb51a$var$initialState = {
    issueTypeResetCount: 0,
    openCardKeys: [],
    getConfirmedInputValue: ()=>'',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    inlineChange: ()=>()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    cardToggled: ()=>{},
    forceValidationFor: null,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setProductModalOpen: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    addLayoutItem: ()=>{}
};
const $42b0a4d2955bb51a$var$SwiftLifecycleContext = /*#__PURE__*/ (0, $5uXOq.createContext)($42b0a4d2955bb51a$var$initialState);
const $42b0a4d2955bb51a$export$d5727b8dd7c8e192 = $42b0a4d2955bb51a$var$SwiftLifecycleContext.Provider;
const $42b0a4d2955bb51a$export$23d7c5f55420ac55 = ()=>(0, $5uXOq.useContext)($42b0a4d2955bb51a$var$SwiftLifecycleContext);

});

parcelRegister("11mCu", function(module, exports) {

$parcel$export(module.exports, "Disabled", () => $aff826fef3de2e4d$export$9a986b15f53d6d10);
$parcel$export(module.exports, "FieldNameWrapper", () => $aff826fef3de2e4d$export$72c4330ec5b4ea77);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");
const $aff826fef3de2e4d$export$9a986b15f53d6d10 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1lh4 _tzy4105o _80om13gf",
            __cmplp.className
        ])
    });
});
const $aff826fef3de2e4d$export$72c4330ec5b4ea77 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1vjmi9t-0"
})({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '10em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});

parcelRegister("jOXAB", function(module, exports) {

$parcel$export(module.exports, "HeightAnimator", () => $ee76e3bb0e661443$export$f8ea76779a639cb2);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $lvsgf = parcelRequire("lvsgf");
class $ee76e3bb0e661443$export$f8ea76779a639cb2 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onTransitionEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidUpdate(prevProps) {
        this.onRecalculateAnimatorHeight();
        // Set isAnimating to true whenever isExpanded changes so we can hide overflow and ensure children are visible
        if (this.props.isExpanded !== prevProps.isExpanded) this.setState({
            isAnimating: true
        });
    }
    render() {
        const { children: children, isExpanded: isExpanded, Animation: Animation, onMouseDown: onMouseDown } = this.props;
        const { height: height, isAnimating: isAnimating } = this.state;
        // Render the children off-screen to calculate their size before animating.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Animation, {
            height: height,
            isExpanded: isExpanded,
            isAnimating: isAnimating,
            onMouseDown: onMouseDown,
            onTransitionEnd: this.onTransitionEnd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: this.onContainerUpdate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvsgf.Provider), {
            value: this.onRecalculateAnimatorHeight
        }, !isExpanded && !isAnimating ? null : children)));
    }
    constructor(...args){
        super(...args), this.state = {
            height: 0,
            isAnimating: false
        }, this.onRecalculateAnimatorHeight = ()=>{
            this.onContainerUpdate(this.containerEl);
        }, this.onContainerUpdate = (container)=>{
            if (!container) return;
            const height = container.clientHeight;
            this.containerEl = container;
            const { height: currentHeight } = this.state;
            if (currentHeight !== height) this.setState({
                height: height
            });
        }, this.onTransitionEnd = (e)=>{
            this.props.onTransitionEnd(e);
            // Set isAnimating to false whenever transition has completed so we can show overflow and hide children if collapsed.
            this.setState({
                isAnimating: false
            });
        }, this.containerEl = null;
    }
}

});

parcelRegister("947Yg", function(module, exports) {

$parcel$export(module.exports, "FieldChevron", () => $74581c61b057aaee$export$8b9aeb8185ff41c3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $h1toL = parcelRequire("h1toL");

var $7nnPp = parcelRequire("7nnPp");

var $3dGN0 = parcelRequire("3dGN0");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $2Q3ZZ = parcelRequire("2Q3ZZ");
const $74581c61b057aaee$var$getErrorMessage = (error, intl)=>intl.formatMessage(error.messageDescriptor, error.values);
const $74581c61b057aaee$export$8b9aeb8185ff41c3 = ({ isOpen: isOpen, isExpandable: isExpandable, onClick: onClick, appearance: appearance, error: error, testId: testId, name: name })=>{
    const intl = (0, $koVbs.default)();
    if (!isExpandable) return null;
    // toggleFieldButton descriptor will handle with/without name along with open/close
    const labelWithName = intl.formatMessage((0, $2Q3ZZ.messages).toggleFieldButton, {
        field: name || null,
        isOpen: isOpen
    });
    if (error != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: $74581c61b057aaee$var$getErrorMessage(error, intl)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($74581c61b057aaee$var$FixedChevron, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "danger",
        onClick: onClick,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))), {
            testId: testId ? `${testId}--error` : undefined,
            secondaryColor: "var(--ds-icon-danger, #C9372C)",
            primaryColor: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
            label: ""
        }),
        "aria-label": labelWithName
    })));
    return(/**
     * Note that data-test-cypress is being hardcoded for jira/src/packages/project-settings/issue-type-page/src/integration-tests/cy-integration.tsx
     * and is being defined by CY_FIELD_TYPE_TOGGLE_PANEL_BUTTON in jira/src/packages/project-settings/issue-type-page/src/integration-tests/page-object.tsx
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($74581c61b057aaee$var$RotatingChevron, {
        "data-test-cypress": "field-type-toggle-panel-button",
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: appearance || 'subtle-link',
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h1toL))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)",
            label: ""
        }),
        "aria-label": labelWithName
    })));
};
const $74581c61b057aaee$var$elementSize = "var(--ds-space-300, 24px)";
const $74581c61b057aaee$var$animationParams = '250ms cubic-bezier(0.15, 1, 0.3, 1)'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74581c61b057aaee$var$RotatingChevron = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641sqz _4t3i1ejb _1bsb1ejb",
            __cmplp.isOpen ? "_t9ec14w8" : "_t9ecglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74581c61b057aaee$var$FixedChevron = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ejb _1bsb1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});

parcelRegister("2Q3ZZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1625842da0d2246$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f1625842da0d2246$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fieldNamePlaceholder: {
        "id": "project-settings-apps.issue-type-page.fields.field.field-name-placeholder",
        "defaultMessage": "Enter field name"
    },
    cannotRenameField: {
        "id": "project-settings-apps.issue-type-page.field.cannot-rename-field",
        "defaultMessage": "You can't rename this field"
    },
    defaultValueShow: {
        "id": "project-settings-apps.issue-type-page.field.default-value-show",
        "defaultMessage": "Set default value"
    },
    defaultValueClearMenu: {
        "id": "project-settings-apps.issue-type-page.field.default-value-clear-menu",
        "defaultMessage": "Clear default value"
    },
    renameAliasedField: {
        "id": "project-settings-apps.issue-type-page.field.rename-aliased-field",
        "defaultMessage": "Rename field"
    },
    removeField: {
        "id": "project-settings-apps.issue-type-page.field.remove-field",
        "defaultMessage": "Remove"
    },
    cannotRemoveFieldTooltip: {
        "id": "project-settings-apps.issue-type-page.field.cannot-remove-field-tooltip",
        "defaultMessage": "{productOrPluginThatCreatedThisField} created this field. You can\u2019t remove it."
    },
    cannotRenameOrReorderFieldTooltip: {
        "id": "project-settings-apps.issue-type-page.field.cannot-rename-or-reorder-field-tooltip",
        "defaultMessage": "{productOrPluginThatCreatedThisField} created this field. You can\u2019t rename or reorder it."
    },
    cannotEditOrReorderFieldTooltip: {
        "id": "project-settings-apps.issue-type-page.field.cannot-edit-or-reorder-field-tooltip",
        "defaultMessage": "{productOrPluginThatCreatedThisField} created this field. You can\u2019t edit or reorder it."
    },
    cannotEditFieldTooltip: {
        "id": "project-settings-apps.issue-type-page.field.cannot-edit-field-tooltip",
        "defaultMessage": "{productOrPluginThatCreatedThisField} created this field. You can\u2019t edit it."
    },
    expandFieldButton: {
        "id": "project-settings-apps.issue-type-page.field-associated.expand-field-button",
        "defaultMessage": "Open field configuration"
    },
    collapseFieldButton: {
        "id": "project-settings-apps.issue-type-page.field-associated.collapse-field-button",
        "defaultMessage": "Close field configuration"
    },
    toggleFieldButton: {
        "id": "project-settings-apps.issue-type-page.field-associated.toggle-field-button",
        "defaultMessage": "{field, select, \n            null {}\n            other {{field} - }\n        }{isOpen, select, \n            true {Close}\n            false {Open}\n            other {}\n        } field configuration"
    }
});

});


parcelRegister("6rybY", function(module, exports) {

$parcel$export(module.exports, "FormSecurityConfigButton", () => $4b0fc986cb28c0fa$export$97e5cabf93dc60c0);

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $koVbs = parcelRequire("koVbs");


var $42CjB = parcelRequire("42CjB");

var $bKCvK = parcelRequire("bKCvK");

var $a8hd9 = parcelRequire("a8hd9");

var $lu848 = parcelRequire("lu848");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");


var $3bDjY = parcelRequire("3bDjY");

var $jkADf = parcelRequire("jkADf");
var $h8yj2 = parcelRequire("h8yj2");

var $erWXD = parcelRequire("erWXD");

var $i9OHB = parcelRequire("i9OHB");

var $5wvQR = parcelRequire("5wvQR");

var $3rxRm = parcelRequire("3rxRm");

var $4Q73X = parcelRequire("4Q73X");

var $9XJJv = parcelRequire("9XJJv");
var $kjDXQ = parcelRequire("kjDXQ");

var $jcGgi = parcelRequire("jcGgi");

var $5vTut = parcelRequire("5vTut");
const $4b0fc986cb28c0fa$export$97e5cabf93dc60c0 = (props)=>{
    const { locale: locale } = (0, $koVbs.default)();
    const { loadRestrictedPrincipals: loadRestrictedPrincipals, saveRestrictedPrincipals: saveRestrictedPrincipals } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4cXA.ErrorBoundary), {
        fallbackRender: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9OHB.ProformaIntlProvider), {
        messages: (0, $4Q73X.default),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCvK.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rxRm.FormPermissionsContainer), {
        loadRestrictedPrincipals: loadRestrictedPrincipals,
        saveRestrictedPrincipals: saveRestrictedPrincipals
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b0fc986cb28c0fa$var$ConfigButton, props)))));
};
const $4b0fc986cb28c0fa$var$ConfigButton = ({ restrictionStatus: restrictionStatus, appearance: appearance, spacing: spacing, isViewMode: isViewMode, getWarningMessage: getWarningMessage, viewModeManageRestrictionUrl: viewModeManageRestrictionUrl, showOnboarding: showOnboarding, acknowledgeOnboarding: acknowledgeOnboarding, getWarningMessageConfig: getWarningMessageConfig })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isRestricted = restrictionStatus === (0, $5wvQR.FormRestrictionStatus).RESTRICTED;
    const [isConfigModalOpen, setIsConfigModalOpen] = (0, $5uXOq.useState)(false);
    const openConfigModal = (event, analyticsEvent)=>{
        event.stopPropagation();
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, (0, $erWXD.ActionSubject).FORM_PERMISSIONS);
        setIsConfigModalOpen(true);
    };
    const getTooltipMessage = ()=>{
        if (!isRestricted) return (0, $jcGgi.messages).openTooltip;
        return isViewMode ? (0, $jcGgi.messages).restrictedViewModeTooltip : (0, $jcGgi.messages).restrictedTooltip;
    };
    const labelForEditMode = formatMessage(isRestricted ? (0, $jcGgi.messages).restrictedLabel : (0, $jcGgi.messages).openLabel);
    const labelForViewMode = formatMessage((0, $jcGgi.messages).viewModeButtonLabel);
    const buttonLabel = isViewMode ? labelForViewMode : labelForEditMode;
    const onProceedOnboarding = (event, analyticsEvent)=>{
        if (acknowledgeOnboarding) acknowledgeOnboarding();
        openConfigModal(event, analyticsEvent);
    };
    const onDismissOnboarding = ()=>{
        if (acknowledgeOnboarding) acknowledgeOnboarding();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jkADf.ContextWrapper), {
        attributes: {
            restrictionStatus: restrictionStatus
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        onClick: (e)=>e.stopPropagation()
    }, isViewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjDXQ.ViewConfigModal), {
        isOpen: isConfigModalOpen,
        onClose: ()=>setIsConfigModalOpen(false),
        getWarningMessage: (0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes') ? undefined : getWarningMessage,
        viewModeManageRestrictionUrl: viewModeManageRestrictionUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9XJJv.ConfigModal), {
        isOpen: isConfigModalOpen,
        onClose: ()=>setIsConfigModalOpen(false),
        getWarningMessage: (0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes') ? undefined : getWarningMessage,
        getWarningMessageConfig: getWarningMessageConfig
    })), (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(getTooltipMessage())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5vTut.PulseSpotlightOnboarding), {
        showOnboarding: !!showOnboarding,
        onDismiss: onDismissOnboarding,
        onProceed: onProceedOnboarding
    }, (onClickWithOnboarding)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            appearance: appearance,
            spacing: spacing,
            onClick: onClickWithOnboarding(openConfigModal),
            testId: "proforma-form-security.ui.config-button",
            icon: isRestricted ? $4b0fc986cb28c0fa$var$RedLockFilledIcon : (0, (/*@__PURE__*/$parcel$interopDefault($lu848))),
            label: buttonLabel
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(getTooltipMessage())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: appearance,
        spacing: spacing,
        onClick: openConfigModal,
        testId: "proforma-form-security.ui.config-button",
        icon: isRestricted ? $4b0fc986cb28c0fa$var$RedLockFilledIcon : (0, (/*@__PURE__*/$parcel$interopDefault($lu848))),
        label: formatMessage(isRestricted ? (0, $jcGgi.messages).restricted : (0, $jcGgi.messages).open)
    })));
};
const $4b0fc986cb28c0fa$var$RedLockFilledIcon = (props)=>{
    const { label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a8hd9))), {
        color: `var(--ds-icon-accent-red, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        LEGACY_size: "medium",
        label: label
    });
};

});
parcelRegister("lu848", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8de16db866164b3bef52d579e79a51f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa42a7fa1c2bee95$var$_react = $fa42a7fa1c2bee95$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fa42a7fa1c2bee95$var$_lockUnlocked = $fa42a7fa1c2bee95$var$_interopRequireDefault((parcelRequire("jHgVl")));

var $fa42a7fa1c2bee95$var$_unlock = $fa42a7fa1c2bee95$var$_interopRequireDefault((parcelRequire("9vD9G")));
function $fa42a7fa1c2bee95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockUnlockedIcon.
 * This component is LockUnlockedIcon, with `UNSAFE_fallbackIcon` set to "UnlockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa42a7fa1c2bee95$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $fa42a7fa1c2bee95$var$_react.default.createElement($fa42a7fa1c2bee95$var$_lockUnlocked.default, Object.assign({
        LEGACY_fallbackIcon: $fa42a7fa1c2bee95$var$_unlock.default
    }, props));
$fa42a7fa1c2bee95$var$LockUnlockedIcon.Name = 'LockUnlockedIconMigration';
var $fa42a7fa1c2bee95$var$_default = module.exports.default = $fa42a7fa1c2bee95$var$LockUnlockedIcon;

});
parcelRegister("9vD9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ec561afe9929007$var$_react = $6ec561afe9929007$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6ec561afe9929007$var$_lockUnlocked = $6ec561afe9929007$var$_interopRequireDefault((parcelRequire("jHgVl")));
function $6ec561afe9929007$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ec561afe9929007$var$UnlockIcon = (props)=>/*#__PURE__*/ $6ec561afe9929007$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 11.009C5 9.899 5.897 9 7.006 9h9.988A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991zM7 11v8h10v-8z"/><circle cx="12" cy="15" r="2"/><path d="M8 6.251v-.249A4.004 4.004 0 0 1 12 2a4 4 0 0 1 4 4.002V6.5h-2v-.498A2 2 0 0 0 12 4c-1.102 0-2 .898-2 2.002V11H8zm6 .249h2a1 1 0 0 1-2 0"/></g></svg>`
    }, props, {
        newIcon: $6ec561afe9929007$var$_lockUnlocked.default
    }));
$6ec561afe9929007$var$UnlockIcon.displayName = 'UnlockIcon';
var $6ec561afe9929007$var$_default = module.exports.default = $6ec561afe9929007$var$UnlockIcon;

});


parcelRegister("jkADf", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $e64f0f96877c6709$export$34282a1f95511a11);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");

var $daJ0i = parcelRequire("daJ0i");
const $e64f0f96877c6709$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $e64f0f96877c6709$export$34282a1f95511a11 = (props)=>{
    const data = $e64f0f96877c6709$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: props.children
        })
    });
};

});

parcelRegister("3rxRm", function(module, exports) {

$parcel$export(module.exports, "FormPermissionsContainer", () => $281e2886c4d613a0$export$798b4c4f5c3f8133);
$parcel$export(module.exports, "useFormPermissions", () => $281e2886c4d613a0$export$a50e2e1fdebefcbc);
$parcel$export(module.exports, "useFormPermissionsActions", () => $281e2886c4d613a0$export$c2702ee1ac4b2b58);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $foFHU = parcelRequire("foFHU");
const $281e2886c4d613a0$var$initialState = {
    principals: [],
    // Callbacks modified by container init hydration.
    loadRestrictedPrincipals: ()=>Promise.resolve({
            principals: []
        }),
    saveRestrictedPrincipals: ()=>Promise.resolve()
};
// Explicitly set actions to export for the store.
const $281e2886c4d613a0$var$actions = {
    setPrincipals: $foFHU.setPrincipals,
    addPrincipals: $foFHU.addPrincipals,
    removePrincipal: $foFHU.removePrincipal
};
const $281e2886c4d613a0$var$FormPermissionsStore = (0, $iXqE5.createStore)({
    name: 'form-permissions-store',
    initialState: $281e2886c4d613a0$var$initialState,
    actions: $281e2886c4d613a0$var$actions
});
const $281e2886c4d613a0$export$798b4c4f5c3f8133 = (0, $gg7kZ.createContainer)($281e2886c4d613a0$var$FormPermissionsStore, {
    onInit: ()=>({ setState: setState }, { loadRestrictedPrincipals: loadRestrictedPrincipals, saveRestrictedPrincipals: saveRestrictedPrincipals })=>setState({
                ...$281e2886c4d613a0$var$initialState,
                loadRestrictedPrincipals: loadRestrictedPrincipals,
                saveRestrictedPrincipals: saveRestrictedPrincipals
            })
});
const $281e2886c4d613a0$export$a50e2e1fdebefcbc = (0, $3sQ5x.createHook)($281e2886c4d613a0$var$FormPermissionsStore);
const $281e2886c4d613a0$export$c2702ee1ac4b2b58 = (0, $3sQ5x.createActionsHook)($281e2886c4d613a0$var$FormPermissionsStore);
const $281e2886c4d613a0$export$942f593fbf213ce0 = (0, $3sQ5x.createStateHook)($281e2886c4d613a0$var$FormPermissionsStore);

});
parcelRegister("foFHU", function(module, exports) {

$parcel$export(module.exports, "setPrincipals", () => $b3597315b88f51cd$export$8cd5486c66a94482);
$parcel$export(module.exports, "addPrincipals", () => $b3597315b88f51cd$export$fedd78a135546bef);
$parcel$export(module.exports, "removePrincipal", () => $b3597315b88f51cd$export$93482a3be7b7c9de);
const $b3597315b88f51cd$export$8cd5486c66a94482 = (principals)=>({ setState: setState })=>setState({
            principals: principals
        });
const $b3597315b88f51cd$export$fedd78a135546bef = (newPrincipals)=>({ setState: setState, getState: getState })=>setState({
            principals: [
                ...newPrincipals,
                ...getState().principals
            ]
        });
const $b3597315b88f51cd$export$93482a3be7b7c9de = (ari)=>({ setState: setState, getState: getState })=>setState({
            principals: getState().principals.filter((p)=>!p.ari.equals(ari))
        });

});


parcelRegister("4Q73X", function(module, exports) {

$parcel$export(module.exports, "default", () => $38617f4e051444cf$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */ 


const $38617f4e051444cf$var$lazyMessages = {
    en: ()=>(parcelRequire("Ww81t")),
    en_GB: ()=>(parcelRequire("iCn6y")),
    en_ZZ: ()=>(parcelRequire("6z9Tc"))
};
var $38617f4e051444cf$export$2e2bcd8739ae039 = $38617f4e051444cf$var$lazyMessages;

});
parcelRegister("Ww81t", function(module, exports) {

let $0afe56ecd276b9f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0afe56ecd276b9f4$var$load("lgTZ6").then(()=>parcelRequire('1UJIs'));

});

parcelRegister("iCn6y", function(module, exports) {

let $d8ddb2b498c24d31$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d8ddb2b498c24d31$var$load("drAEf").then(()=>parcelRequire('cco96'));

});

parcelRegister("6z9Tc", function(module, exports) {

let $4c7daecb6cf87fa7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c7daecb6cf87fa7$var$load("hfSoG").then(()=>parcelRequire('aWD22'));

});


parcelRegister("9XJJv", function(module, exports) {

$parcel$export(module.exports, "ConfigModal", () => $740d195d63eb87cb$export$f23b3af3ccf0ba37);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");


var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $bKCvK = parcelRequire("bKCvK");

var $84THj = parcelRequire("84THj");

var $dD7Zc = parcelRequire("dD7Zc");

var $c2i4s = parcelRequire("c2i4s");

var $e4yMr = parcelRequire("e4yMr");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $92Z2l = parcelRequire("92Z2l");


var $h8yj2 = parcelRequire("h8yj2");

var $erWXD = parcelRequire("erWXD");

var $7Q9gS = parcelRequire("7Q9gS");

var $iy987 = parcelRequire("iy987");

var $JZbeA = parcelRequire("JZbeA");

var $3rxRm = parcelRequire("3rxRm");

var $bvVfo = parcelRequire("bvVfo");

var $4kmIs = parcelRequire("4kmIs");

var $6npk1 = parcelRequire("6npk1");

var $40qJP = parcelRequire("40qJP");
const $740d195d63eb87cb$export$f23b3af3ccf0ba37 = ({ isOpen: isOpen, onClose: onClose, getWarningMessage: getWarningMessage, getWarningMessageConfig: getWarningMessageConfig })=>{
    const [{ principals: principals, loadRestrictedPrincipals: loadFn, saveRestrictedPrincipals: saveFn }, { setPrincipals: setPrincipals }] = (0, $3rxRm.useFormPermissions)();
    const { removePrincipal: removePrincipal } = (0, $3rxRm.useFormPermissionsActions)();
    const { loading: loadingLoad, error: errorLoad, loadRestrictedPrincipals: loadRestrictedPrincipals } = (0, $bvVfo.useLoadRestrictedPrincipals)(loadFn);
    const { loading: loadingSave, saveRestrictedPrincipals: saveRestrictedPrincipals } = (0, $4kmIs.useSaveRestrictedPrincipals)(saveFn);
    const { showFlag: showFlag } = (0, $bKCvK.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [warningMessage, setWarningMessage] = (0, $5uXOq.useState)();
    const [isLoadingWarningMessage, setIsLoadingWarningMessage] = (0, $5uXOq.useState)(false);
    const [hasAttachmentInForm, setHasAttachmentInForm] = (0, $5uXOq.useState)();
    const [hasLinkedJiraFieldInForm, setHasLinkedJiraFieldInForm] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && !(0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes')) loadRestrictedPrincipals().then((data)=>{
            var _data$principals;
            setPrincipals((_data$principals = data === null || data === void 0 ? void 0 : data.principals) !== null && _data$principals !== void 0 ? _data$principals : []);
            (0, $h8yj2.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $erWXD.ActionSubject).MODAL,
                action: data ? (0, $erWXD.Action).VIEWED : (0, $erWXD.Action).FAILED
            }), (0, $erWXD.ActionSubject).FORM_PERMISSIONS, {
                isViewMode: false
            });
        });
    }, [
        createAnalyticsEvent,
        isOpen,
        loadRestrictedPrincipals,
        setPrincipals
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const fetchWarningMessage = async ()=>{
            if (isOpen && getWarningMessage) {
                setIsLoadingWarningMessage(true);
                const message = await getWarningMessage();
                setWarningMessage(message);
            }
            setIsLoadingWarningMessage(false);
        };
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $VSDnB.fg)('granular_permissions_on_forms_ga') && !(0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes')) fetchWarningMessage();
    }, [
        isOpen,
        getWarningMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const fetchWarningMessage = async ()=>{
            if (getWarningMessageConfig) {
                setIsLoadingWarningMessage(true);
                const { hasAttachment: hasAttachment, hasLinkedJiraField: hasLinkedJiraField } = await getWarningMessageConfig();
                setHasAttachmentInForm(hasAttachment);
                setHasLinkedJiraFieldInForm(hasLinkedJiraField);
                let message;
                if (hasLinkedJiraField && hasAttachment) message = (0, $VSDnB.fg)('itsm-issue-renaming') ? formatMessage((0, $6npk1.messages).formSecurityCombinedWarningDescriptionIssueTermRefresh) : formatMessage((0, $6npk1.messages).formSecurityCombinedWarningDescription);
                else if (hasLinkedJiraField) message = (0, $VSDnB.fg)('itsm-issue-renaming') ? formatMessage((0, $6npk1.messages).formSecurityJiraLinkedFieldWarningDescriptionIssueTermRefresh) : formatMessage((0, $6npk1.messages).formSecurityJiraLinkedFieldWarningDescription);
                else if (hasAttachment) message = (0, $VSDnB.fg)('itsm-issue-renaming') ? formatMessage((0, $6npk1.messages).formSecurityAttachmentsWarningDescriptionIssueTermRefresh) : formatMessage((0, $6npk1.messages).formSecurityAttachmentsWarningDescription);
                setWarningMessage(message);
                setIsLoadingWarningMessage(false);
                return {
                    hasLinkedJiraField: hasLinkedJiraField,
                    hasAttachment: hasAttachment
                };
            }
        };
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $VSDnB.fg)('granular_permissions_on_forms_ga') && (0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes') && isOpen) Promise.all([
            loadRestrictedPrincipals(),
            fetchWarningMessage()
        ]).then((data)=>{
            var _data$0$principals, _data$, _data$2, _data$3;
            setPrincipals((_data$0$principals = (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.principals) !== null && _data$0$principals !== void 0 ? _data$0$principals : []);
            (0, $h8yj2.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $erWXD.ActionSubject).MODAL,
                action: data ? (0, $erWXD.Action).VIEWED : (0, $erWXD.Action).FAILED
            }), (0, $erWXD.ActionSubject).FORM_PERMISSIONS, {
                isViewMode: false,
                hasAttachment: (_data$2 = data[1]) === null || _data$2 === void 0 ? void 0 : _data$2.hasAttachment,
                hasLinkedJiraField: (_data$3 = data[1]) === null || _data$3 === void 0 ? void 0 : _data$3.hasLinkedJiraField
            });
        });
    }, [
        isOpen,
        getWarningMessageConfig,
        formatMessage,
        loadRestrictedPrincipals,
        setPrincipals,
        createAnalyticsEvent
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((result)=>result === 'success' ? (0, $h8yj2.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM_PERMISSIONS} ${(0, $erWXD.Action).UPDATED}`, (0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes') ? {
            hasAttachment: hasAttachmentInForm,
            hasLinkedJiraField: hasLinkedJiraFieldInForm
        } : {}) : (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM_PERMISSIONS} ${(0, $erWXD.Action).FAILED}`, (0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes') ? {
            hasAttachment: hasAttachmentInForm,
            hasLinkedJiraField: hasLinkedJiraFieldInForm
        } : {}), [
        createAnalyticsEvent,
        hasAttachmentInForm,
        hasLinkedJiraFieldInForm
    ]);
    const apply = (0, $5uXOq.useCallback)(async ()=>{
        const savedPrincipals = await saveRestrictedPrincipals(principals);
        if (savedPrincipals) {
            fireAnalytics('success');
            showFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6npk1.messages).restrictionsApplySuccessTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6npk1.messages).restrictionsApplySuccessDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
                    spacing: "spacious",
                    label: "",
                    color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
                })
            });
            onClose();
        } else {
            fireAnalytics('fail');
            showFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6npk1.messages).restrictionsApplyFailureTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6npk1.messages).restrictionsApplyFailureDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                    spacing: "spacious",
                    label: "",
                    color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
                })
            });
        }
    }, [
        saveRestrictedPrincipals,
        principals,
        showFlag,
        onClose,
        fireAnalytics
    ]);
    const modalHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6npk1.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj))),
        label: formatMessage((0, $6npk1.messages).restrictionsModalCloseIconLabel),
        onClick: onClose
    }));
    const modalBodyDescription = loadingLoad ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iy987.LoadingModalBodyDescription), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6npk1.messages).description, {
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: (0, $7Q9gS.FORM_RESTRICTION_URL),
                    target: "_blank"
                }, chunks)
        }
    }));
    const modalBodyWarning = (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? warningMessage && loadingLoad ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: "",
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, warningMessage)) : loadingLoad || !getWarningMessage || !getWarningMessage() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: "",
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, getWarningMessage()));
    const getModalBodyContent = ()=>{
        if ((0, $VSDnB.fg)('granular_permissions_on_forms_ga')) {
            if (loadingLoad || isLoadingWarningMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iy987.LoadingModalBodyContent), {
                isEdit: true
            });
        } else if (loadingLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iy987.LoadingModalBodyContent), {
            isEdit: true
        });
        if (errorLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            spacing: "spacious",
            label: "load-error",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6npk1.messages).restrictionsLoadFailureDescription));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $40qJP.PrincipalPicker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $JZbeA.PrincipalList), {
            principals: principals,
            removePrincipal: removePrincipal
        }));
    };
    const modalFooter = loadingLoad ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6npk1.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        isLoading: loadingSave,
        onClick: errorLoad ? onClose : apply,
        "aria-label": (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? formatMessage((0, $6npk1.messages).applyButtonLabel) : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6npk1.messages).applyButton)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: onClose,
        height: 500
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, modalHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, modalBodyDescription), (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? modalBodyWarning && warningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, modalBodyWarning) : modalBodyWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, modalBodyWarning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, getModalBodyContent()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, modalFooter)));
};

});
parcelRegister("7Q9gS", function(module, exports) {

$parcel$export(module.exports, "everyoneElseAri", () => $5b5494ccb4f045f3$export$3ba7316a3095d72e);
$parcel$export(module.exports, "FORM_RESTRICTION_URL", () => $5b5494ccb4f045f3$export$5433776cac94f4b5);
$parcel$export(module.exports, "BUTTON_SPOTLIGHT_TARGET_NAME", () => $5b5494ccb4f045f3$export$857959a003c929e9);

var $guy0h = parcelRequire("guy0h");
const $5b5494ccb4f045f3$export$3ba7316a3095d72e = (0, $guy0h.IdentityGroupAri).create({
    groupId: 'everyoneelse'
});
const $5b5494ccb4f045f3$export$5433776cac94f4b5 = 'https://support.atlassian.com/jira-service-management-cloud/docs/restrict-who-can-view-forms/';
const $5b5494ccb4f045f3$export$857959a003c929e9 = 'proforma-form-security-button-spotlight-target';

});
parcelRegister("guy0h", function(module, exports) {

$parcel$export(module.exports, "IdentityGroupAri", () => $c019d318335b1dcb$export$a0ec2d0676c0549c);

var $iyUs3 = parcelRequire("iyUs3");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/identity/group/manifest.ts
var $c019d318335b1dcb$var$identityGroupAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $iyUs3.IdentityGroupAriResourceOwner),
    resourceType: (0, $iyUs3.IdentityGroupAriResourceType),
    resourceIdSlug: "{groupId}",
    resourceIdSegmentFormats: {
        groupId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/identity/group/index.ts
var $c019d318335b1dcb$export$a0ec2d0676c0549c = class _IdentityGroupAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._groupId = opts.resourceIdSegmentValues.groupId;
    }
    get groupId() {
        return this._groupId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c019d318335b1dcb$var$identityGroupAriStaticOpts.qualifier,
            platformQualifier: $c019d318335b1dcb$var$identityGroupAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c019d318335b1dcb$var$identityGroupAriStaticOpts.resourceOwner,
            resourceType: $c019d318335b1dcb$var$identityGroupAriStaticOpts.resourceType,
            resourceId: `${opts.groupId}`,
            resourceIdSegmentValues: {
                groupId: opts.groupId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $c019d318335b1dcb$var$identityGroupAriStaticOpts);
        return new _IdentityGroupAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $c019d318335b1dcb$var$identityGroupAriStaticOpts);
        return new _IdentityGroupAri(opts);
    }
    getVariables() {
        return {
            groupId: this.groupId
        };
    }
};

});
parcelRegister("iyUs3", function(module, exports) {

$parcel$export(module.exports, "IdentityGroupAriResourceOwner", () => $d8373112590c3b25$export$37767420f897daca);
$parcel$export(module.exports, "IdentityGroupAriResourceType", () => $d8373112590c3b25$export$34f7ba4c01550cbf);
// src/identity/group/types.ts
var $d8373112590c3b25$export$37767420f897daca = "identity", $d8373112590c3b25$export$34f7ba4c01550cbf = "group";

});



parcelRegister("iy987", function(module, exports) {

$parcel$export(module.exports, "LoadingModalBodyDescription", () => $d8127bf814e62d6f$export$c6bb5b73bb8c2d08);
$parcel$export(module.exports, "LoadingModalBodyContent", () => $d8127bf814e62d6f$export$e0ee96e589925465);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");
const $d8127bf814e62d6f$export$c6bb5b73bb8c2d08 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "95%",
        height: "16px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "95%",
        height: "16px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "35%",
        height: "16px",
        isShimmering: true
    }));
const $d8127bf814e62d6f$export$e0ee96e589925465 = ({ isEdit: isEdit })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d8127bf814e62d6f$var$skeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, isEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "100%",
        height: "40px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "50%",
        height: "25px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "20%",
        height: "25px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "50%",
        height: "25px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "20%",
        height: "25px",
        isShimmering: true
    }))));
const $d8127bf814e62d6f$var$skeletonWrapperStyles = (0, $8CUq3.xcss)({
    width: '95%'
});

});

parcelRegister("JZbeA", function(module, exports) {

$parcel$export(module.exports, "PrincipalList", () => $08a3a932565d99da$export$5decdd2f69541323);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $414Wj = parcelRequire("414Wj");

var $7Q9gS = parcelRequire("7Q9gS");

var $5wvQR = parcelRequire("5wvQR");

var $4q1Ox = parcelRequire("4q1Ox");

var $33NsD = parcelRequire("33NsD");
const $08a3a932565d99da$export$5decdd2f69541323 = ({ principals: principals, isViewMode: isViewMode, removePrincipal: removePrincipal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (principals.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.050",
        testId: "proforma-form-security.ui.config-button.config-modal.form-permissions-config.principal-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33NsD.PrincipalItem), {
        key: (0, $7Q9gS.everyoneElseAri).toString(),
        principal: {
            ari: (0, $7Q9gS.everyoneElseAri),
            type: (0, $5wvQR.FormSupportedPrincipalType).USER_GROUP,
            name: formatMessage((0, $4q1Ox.messages).everyoneElse)
        },
        isDisabled: true,
        isViewMode: isViewMode,
        removePrincipal: removePrincipal
    }), principals.map((principal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33NsD.PrincipalItem), {
            key: principal.ari.toString(),
            principal: principal,
            canAccess: true,
            isViewMode: isViewMode,
            removePrincipal: removePrincipal
        })));
};

});
parcelRegister("4q1Ox", function(module, exports) {

$parcel$export(module.exports, "messages", () => $337aff6316ee650d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $337aff6316ee650d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    everyoneElse: {
        id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-list.everyone-else',
        defaultMessage: 'Everyone else',
        description: 'Displayed when viewing the form permission list to show the permission on everyone else.'
    }
});

});

parcelRegister("33NsD", function(module, exports) {

$parcel$export(module.exports, "PrincipalItem", () => $23a804cbc0d16a37$export$a040ad5a2a093986);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $ujWmd = parcelRequire("ujWmd");

var $7sUFC = parcelRequire("7sUFC");

var $fVnbM = parcelRequire("fVnbM");

var $4hqZ5 = parcelRequire("4hqZ5");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");


var $3bDjY = parcelRequire("3bDjY");

var $5wvQR = parcelRequire("5wvQR");

var $gLBDQ = parcelRequire("gLBDQ");
const $23a804cbc0d16a37$export$a040ad5a2a093986 = ({ principal: principal, canAccess: canAccess, isDisabled: isDisabled, isViewMode: isViewMode, removePrincipal: removePrincipal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const principalRef = (0, $5uXOq.useRef)(null);
    const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sUFC.default), {
        avatar: principal.type === (0, $5wvQR.FormSupportedPrincipalType).USER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            size: "medium",
            name: principal.name,
            src: principal.avatar
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $23a804cbc0d16a37$var$peopleIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        })),
        primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: principal.name,
            ignoreTooltipPointerEvents: true,
            isScreenReaderAnnouncementDisabled: true,
            canAppear: ()=>{
                const principalElement = principalRef.current;
                return principalElement !== null && principalElement.scrollWidth > principalElement.clientWidth;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $23a804cbc0d16a37$var$truncationStyles,
            ref: principalRef,
            testId: "proforma-form-security.common.ui.principal-list.principal-item"
        }, principal.name))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $23a804cbc0d16a37$var$avatarStyles
    }, avatar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $23a804cbc0d16a37$var$permissionsStyles
    }, canAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gLBDQ.messages).hasAccess) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gLBDQ.messages).noAccess)), !isViewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $23a804cbc0d16a37$var$removeButtonStyles
    }, !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: ()=>removePrincipal(principal.ari),
        "aria-label": (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? formatMessage((0, $gLBDQ.messages).removeLabel, {
            principalName: principal.name
        }) : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gLBDQ.messages).remove))));
};
const $23a804cbc0d16a37$var$avatarStyles = (0, $8CUq3.xcss)({
    width: '65%',
    margin: 'auto'
});
const $23a804cbc0d16a37$var$peopleIconStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'border.radius.circle',
    margin: 'space.025',
    padding: 'space.050'
});
const $23a804cbc0d16a37$var$permissionsStyles = (0, $8CUq3.xcss)({
    width: '23%',
    margin: 'auto'
});
const $23a804cbc0d16a37$var$removeButtonStyles = (0, $8CUq3.xcss)({
    width: '12%',
    margin: 'auto'
});
const $23a804cbc0d16a37$var$truncationStyles = (0, $8CUq3.xcss)({
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("gLBDQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c34e3bf83b9e0231$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $c34e3bf83b9e0231$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    hasAccess: {
        id: 'proforma-form-security.common.ui.principal-list.principal-item.has-access',
        defaultMessage: 'Has access',
        description: 'Text in the form permission list indicating the user/group can access the submitted form.'
    },
    noAccess: {
        id: 'proforma-form-security.common.ui.principal-list.principal-item.no-access',
        defaultMessage: 'No access',
        description: 'Text in the form permission list indicating the user/group cannot access the submitted form.'
    },
    remove: {
        id: 'proforma-form-security.common.ui.principal-list.principal-item.remove',
        defaultMessage: 'Remove',
        description: 'Text for the button in the form permission list allowing the user to remove the user/group.'
    },
    removeLabel: {
        id: 'proforma-form-security.common.ui.principal-list.principal-item.remove-label',
        defaultMessage: 'Remove form access for {principalName}',
        description: 'Label for the button in the form permission list allowing the user to remove the user/group.'
    }
});

});



parcelRegister("bvVfo", function(module, exports) {

$parcel$export(module.exports, "useLoadRestrictedPrincipals", () => $861eff18460c785b$export$7111b41d9d8021d4);

var $1QaPL = parcelRequire("1QaPL");
const $861eff18460c785b$export$7111b41d9d8021d4 = (loadFn)=>{
    const service = (0, $1QaPL.useService)(loadFn);
    return {
        ...service,
        loadRestrictedPrincipals: service.fetch
    };
};

});
parcelRegister("1QaPL", function(module, exports) {

$parcel$export(module.exports, "useService", () => $15730d24c4ef62d3$export$6de4685a6c88b4e9);

var $5uXOq = parcelRequire("5uXOq");
const $15730d24c4ef62d3$export$6de4685a6c88b4e9 = (request)=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: false,
        data: undefined,
        error: undefined
    });
    const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};

});


parcelRegister("4kmIs", function(module, exports) {

$parcel$export(module.exports, "useSaveRestrictedPrincipals", () => $326aa69ce0e7c6ad$export$c1a749ade60270d6);

var $5uXOq = parcelRequire("5uXOq");

var $1QaPL = parcelRequire("1QaPL");
const $326aa69ce0e7c6ad$export$c1a749ade60270d6 = (saveFn)=>{
    const request = (0, $5uXOq.useCallback)(async (principals)=>{
        await saveFn(principals);
        // We return the principals on success so we can distinguish between success/failure
        // scenarios directly from when we call it, without waiting for a re-render and
        // depending on `error` that useService returns.
        return principals;
    }, [
        saveFn
    ]);
    const service = (0, $1QaPL.useService)(request);
    return {
        ...service,
        saveRestrictedPrincipals: service.fetch
    };
};

});

parcelRegister("6npk1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4a488877159f6ad3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4a488877159f6ad3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.title',
        defaultMessage: 'Restrict who can view this form',
        description: 'Title for the form permission configuration modal.'
    },
    description: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.description',
        defaultMessage: 'Control who can view this form once submitted by giving access to specific people. Any changes made to restrictions will only apply to newly submitted forms. <link>Read more about restricting forms</link>',
        description: 'Description for the form permission configuration modal.'
    },
    cancelButton: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.cancel-button',
        defaultMessage: 'Cancel',
        description: 'Cancel button for the form permission configuration modal'
    },
    applyButton: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.apply-button',
        defaultMessage: 'Apply',
        description: 'Apply button for the form permission configuration modal'
    },
    applyButtonLabel: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.apply-button-label',
        defaultMessage: 'Apply restrictions',
        description: 'Label for Apply button for the form permission configuration modal'
    },
    restrictionsLoadFailureDescription: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-load-failure-description',
        defaultMessage: "We couldn\u2019t load restrictions on this page. Refresh the page and try again.",
        description: 'Message shown to the user when loading the restricted principals failed'
    },
    restrictionsApplySuccessTitle: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-apply-success-title',
        defaultMessage: 'Restrictions updated',
        description: 'Message shown to the user when they successfully update the restrictions when saving the form permissions'
    },
    restrictionsApplySuccessDescription: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-apply-success-description',
        defaultMessage: 'It may take a few moments for these changes to apply.',
        description: 'Description of the flag to show to the user when they successfully apply the restrictions when saving the form permissions.'
    },
    restrictionsApplyFailureTitle: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-apply-failure-title',
        defaultMessage: "We couldn\u2019t update restrictions",
        description: 'Message shown to the user when they failed to update the restrictions when saving the form permissions'
    },
    restrictionsApplyFailureDescription: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-apply-failure-description',
        defaultMessage: 'Refresh the page and try again.',
        description: 'Description of the flag to show to the user when they failed to apply the restrictions when saving the form permissions.'
    },
    restrictionsModalCloseIconLabel: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-modal-close-icon-label',
        defaultMessage: 'Close modal',
        description: 'Label for the close icon within the form permissions edit modal.'
    },
    formSecurityJiraLinkedFieldWarningDescription: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-jira-linked-field-warning-description',
        defaultMessage: "Restrictions set on this form won\u2019t apply to linked Jira fields. Anyone with access to the issue may still be able to see these fields.",
        description: 'The warning description displayed in the form security modal when there exists a jira linked field question and the form is restricted.'
    },
    formSecurityJiraLinkedFieldWarningDescriptionIssueTermRefresh: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-jira-linked-field-warning-description-issue-term-refresh',
        defaultMessage: "Restrictions set on this form won\u2019t apply to linked Jira fields. Anyone with access to the work item may still be able to see these fields.",
        description: 'The warning description displayed in the form security modal when there exists a jira linked field question and the form is restricted.'
    },
    formSecurityAttachmentsWarningDescription: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-attachments-warning-description',
        defaultMessage: "Restrictions set on this form won\u2019t apply to attachments. Anyone with access to the issue will be able to see attachments.",
        description: 'The warning description displayed in the form security modal when there exists an attachment question and the form is restricted.'
    },
    formSecurityAttachmentsWarningDescriptionIssueTermRefresh: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-attachments-warning-description-issue-term-refresh',
        defaultMessage: "Restrictions set on this form won\u2019t apply to attachments. Anyone with access to the work item will be able to see attachments.",
        description: 'The warning description displayed in the form security modal when there exists an attachment question and the form is restricted.'
    },
    formSecurityCombinedWarningDescription: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-combined-warning-description',
        defaultMessage: "Restrictions set on this form won\u2019t apply to linked Jira fields or attachments. Anyone with access to the issue will be able to see them.",
        description: 'The warning description displayed in the form security modal when there exists an attachment question and the form is restricted.'
    },
    formSecurityCombinedWarningDescriptionIssueTermRefresh: {
        id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-combined-warning-description-issue-term-refresh',
        defaultMessage: "Restrictions set on this form won\u2019t apply to linked Jira fields or attachments. Anyone with access to the work item will be able to see them.",
        description: 'The warning description displayed in the form security modal when there exists an attachment question and the form is restricted.'
    }
});

});

parcelRegister("40qJP", function(module, exports) {

$parcel$export(module.exports, "PrincipalPicker", () => $2eabe7287a1578a0$export$2c31df01ac3aac3c);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $2x3Cb = parcelRequire("2x3Cb");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $k5uoT = parcelRequire("k5uoT");

var $cr0SA = parcelRequire("cr0SA");

var $1Jl81 = parcelRequire("1Jl81");

var $5wvQR = parcelRequire("5wvQR");

var $3rxRm = parcelRequire("3rxRm");

var $l7W9Q = parcelRequire("l7W9Q");

var $bChnZ = parcelRequire("bChnZ");
const $2eabe7287a1578a0$export$2c31df01ac3aac3c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
    const [{ principals: principals }, { addPrincipals: addPrincipals }] = (0, $3rxRm.useFormPermissions)();
    const { data: data, loading: loading, error: error, searchUsersAndGroups: searchUsersAndGroups } = (0, $l7W9Q.useSearchUsersAndGroups)();
    const options = (data || []).filter((searchedPrincipal)=>!principals.some((selectedPrincipal)=>$2eabe7287a1578a0$var$convertOptionToPrincipal(searchedPrincipal).ari.equals(selectedPrincipal.ari)));
    const onQueryChange = (0, $5uXOq.useCallback)((nextQuery)=>{
        if (nextQuery) searchUsersAndGroups(nextQuery);
    }, [
        searchUsersAndGroups
    ]);
    const debouncedOnQueryChange = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onQueryChange, 500), [
        onQueryChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "react-select-form-security-principal-picker-input"
    }, formatMessage((0, $bChnZ.messages).userPickerInputLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2eabe7287a1578a0$var$pickerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        isMulti: true,
        appearance: "compact",
        width: "100%",
        ariaLabel: (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? formatMessage((0, $bChnZ.messages).userPickerInputLabel) : formatMessage((0, $bChnZ.messages).ariaLabel),
        fieldId: "form-security-principal-picker",
        options: options,
        onChange: (newSelectedPrincipals)=>{
            if (Array.isArray(newSelectedPrincipals)) setSelectedOptions(newSelectedPrincipals);
        },
        onInputChange: debouncedOnQueryChange,
        isLoading: loading,
        value: selectedOptions,
        placeholder: "",
        addMoreMessage: "",
        noOptionsMessage: error ? formatMessage((0, $bChnZ.messages).error) : null,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $k5uoT.layers).modal()
                })
        },
        menuPortalTarget: document.body
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2eabe7287a1578a0$var$addButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        shouldFitContainer: true,
        isDisabled: selectedOptions.length === 0,
        onClick: ()=>{
            addPrincipals(selectedOptions.map($2eabe7287a1578a0$var$convertOptionToPrincipal));
            setSelectedOptions([]);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bChnZ.messages).add)))));
};
const $2eabe7287a1578a0$var$convertOptionToPrincipal = ({ id: id, type: type, name: name, avatarUrl: avatarUrl })=>({
        ari: (0, $1Jl81.AnyAri).parse(id),
        type: type === 'group' ? (0, $5wvQR.FormSupportedPrincipalType).USER_GROUP : (0, $5wvQR.FormSupportedPrincipalType).USER,
        name: name,
        avatar: avatarUrl
    });
const $2eabe7287a1578a0$var$pickerStyles = (0, $8CUq3.xcss)({
    width: '90%'
});
const $2eabe7287a1578a0$var$addButtonStyles = (0, $8CUq3.xcss)({
    width: '10%'
});

});
parcelRegister("l7W9Q", function(module, exports) {

$parcel$export(module.exports, "useSearchUsersAndGroups", () => $f6175d57c778e736$export$3b70bb77cd073d2e);

var $5uXOq = parcelRequire("5uXOq");

var $guy0h = parcelRequire("guy0h");
var $k9L5z = parcelRequire("k9L5z");

var $1QaPL = parcelRequire("1QaPL");

var $kUMCJ = parcelRequire("kUMCJ");
const $f6175d57c778e736$var$PRINCIPAL_PICKER_LIMIT = 50;
const $f6175d57c778e736$export$3b70bb77cd073d2e = ()=>{
    var _data$users$users$fil, _data$groups$groups$m;
    const request = (0, $5uXOq.useCallback)(async (query)=>{
        const queryParams = new URLSearchParams({
            query: query,
            maxResults: $f6175d57c778e736$var$PRINCIPAL_PICKER_LIMIT.toString(),
            showAvatar: 'true',
            avatarSize: 'medium',
            caseInsensitive: 'true'
        });
        const response = await fetch(`/rest/api/3/groupuserpicker?${queryParams.toString()}`, {
            credentials: 'same-origin'
        });
        if (response.ok) return response.json();
        throw new Error(`Unexpected response from ${response.url} ${response.status} ${response.statusText}`);
    }, []);
    const { data: data, loading: loading, error: error, fetch: searchUsersAndGroups } = (0, $1QaPL.useService)(request);
    const userOptions = (_data$users$users$fil = data === null || data === void 0 ? void 0 : data.users.users.filter(({ accountType: accountType })=>accountType !== (0, $kUMCJ.UserAccountType).CUSTOMER) // Customer account not supported yet.
    .map((user)=>({
            id: (0, $k9L5z.IdentityUserAri).create({
                userId: user.accountId
            }).toString(),
            name: user.displayName,
            type: 'user',
            avatarUrl: user.avatarUrl
        }))) !== null && _data$users$users$fil !== void 0 ? _data$users$users$fil : [];
    const groupOptions = (_data$groups$groups$m = data === null || data === void 0 ? void 0 : data.groups.groups.map((group)=>({
            id: (0, $guy0h.IdentityGroupAri).create({
                groupId: group.groupId
            }).toString(),
            name: group.name,
            type: 'group'
        }))) !== null && _data$groups$groups$m !== void 0 ? _data$groups$groups$m : [];
    const options = userOptions.concat(groupOptions).sort((a, b)=>a.name.localeCompare(b.name));
    return {
        data: options,
        loading: loading,
        error: error,
        searchUsersAndGroups: searchUsersAndGroups
    };
};

});
parcelRegister("kUMCJ", function(module, exports) {

$parcel$export(module.exports, "UserAccountType", () => $f39ec14414c17029$export$325c64f5c67460ad);
const $f39ec14414c17029$export$325c64f5c67460ad = {
    APP: 'app',
    ATLASSIAN: 'atlassian',
    CUSTOMER: 'customer'
};

});


parcelRegister("bChnZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8750bacc69b0c11c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8750bacc69b0c11c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    userPickerInputLabel: {
        id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-picker.user-picker-input-label',
        defaultMessage: 'Search user name or group',
        description: 'Label for the user picker in the form permission configuration modal.'
    },
    add: {
        id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-picker.add',
        defaultMessage: 'Add',
        description: 'Add button text for the form permission configuration modal to add a principal.'
    },
    error: {
        id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-picker.error',
        defaultMessage: 'Error loading users and groups',
        description: 'Error message displayed in the picker when we failed to load the users and groups.'
    },
    ariaLabel: {
        id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-picker.aria-label',
        defaultMessage: 'User and group picker',
        description: 'Aria label for the user and group picker in the form permission configuration modal.'
    }
});

});



parcelRegister("kjDXQ", function(module, exports) {

$parcel$export(module.exports, "ViewConfigModal", () => $eca49511af4b1470$export$d87dd5ea334589ba);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");


var $2NMNM = parcelRequire("2NMNM");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");

var $84THj = parcelRequire("84THj");

var $dD7Zc = parcelRequire("dD7Zc");

var $kHhcd = parcelRequire("kHhcd");

var $e4yMr = parcelRequire("e4yMr");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $92Z2l = parcelRequire("92Z2l");


var $h8yj2 = parcelRequire("h8yj2");

var $erWXD = parcelRequire("erWXD");

var $7Q9gS = parcelRequire("7Q9gS");

var $iy987 = parcelRequire("iy987");

var $JZbeA = parcelRequire("JZbeA");

var $3rxRm = parcelRequire("3rxRm");

var $bvVfo = parcelRequire("bvVfo");

var $hyMPp = parcelRequire("hyMPp");
const $eca49511af4b1470$export$d87dd5ea334589ba = ({ isOpen: isOpen, onClose: onClose, getWarningMessage: getWarningMessage, viewModeManageRestrictionUrl: viewModeManageRestrictionUrl })=>{
    const [{ principals: principals, loadRestrictedPrincipals: loadFn }, { setPrincipals: setPrincipals }] = (0, $3rxRm.useFormPermissions)();
    const { loading: loading, error: error, loadRestrictedPrincipals: loadRestrictedPrincipals } = (0, $bvVfo.useLoadRestrictedPrincipals)(loadFn);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [warningMessage, setWarningMessage] = (0, $5uXOq.useState)();
    const [isLoadingWarningMessage, setIsLoadingWarningMessage] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) loadRestrictedPrincipals().then((data)=>{
            var _data$principals;
            setPrincipals((_data$principals = data === null || data === void 0 ? void 0 : data.principals) !== null && _data$principals !== void 0 ? _data$principals : []);
            (0, $h8yj2.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $erWXD.ActionSubject).MODAL,
                action: data ? (0, $erWXD.Action).VIEWED : (0, $erWXD.Action).FAILED
            }), (0, $erWXD.ActionSubject).FORM_PERMISSIONS, {
                isViewMode: true
            });
        });
    }, [
        createAnalyticsEvent,
        isOpen,
        loadRestrictedPrincipals,
        setPrincipals
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const fetchWarningMessage = async ()=>{
            if (isOpen && getWarningMessage) {
                setIsLoadingWarningMessage(true);
                const message = await getWarningMessage();
                setWarningMessage(message);
            }
            setIsLoadingWarningMessage(false);
        };
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $VSDnB.fg)('granular_permissions_on_forms_ga') && !(0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes')) fetchWarningMessage();
    }, [
        isOpen,
        getWarningMessage
    ]);
    const modalHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hyMPp.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj))),
        label: formatMessage((0, $hyMPp.messages).restrictionsModalCloseIconLabel),
        onClick: onClose
    }));
    const modalBodyDescription = loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iy987.LoadingModalBodyDescription), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $hyMPp.messages).description, {
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: (0, $7Q9gS.FORM_RESTRICTION_URL),
                    target: "_blank"
                }, chunks)
        }
    }));
    const modalBodyWarning = (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? warningMessage && loading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: "",
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, warningMessage)) : loading || !getWarningMessage || !getWarningMessage() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: "",
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, getWarningMessage()));
    const getModalBodyContent = ()=>{
        if ((0, $VSDnB.fg)('granular_permissions_on_forms_ga')) {
            if (loading || isLoadingWarningMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iy987.LoadingModalBodyContent), null);
        } else if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iy987.LoadingModalBodyContent), null);
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            spacing: "spacious",
            label: "load-error",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hyMPp.messages).restrictionsLoadFailureDescription));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $JZbeA.PrincipalList), {
            principals: principals,
            isViewMode: true,
            removePrincipal: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        });
    };
    const modalFooter = viewModeManageRestrictionUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        href: viewModeManageRestrictionUrl,
        target: "_blank",
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($kHhcd))),
        "aria-label": (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? formatMessage((0, $hyMPp.messages).manageButtonLabel) : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hyMPp.messages).manageButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: onClose,
        "aria-label": (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? formatMessage((0, $hyMPp.messages).closeButtonLabel) : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hyMPp.messages).closeButton))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hyMPp.messages).closeButton));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: onClose,
        height: 500
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, modalHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, modalBodyDescription), (0, $VSDnB.fg)('granular_permissions_on_forms_ga') ? modalBodyWarning && warningMessage && !(0, $VSDnB.fg)('proforma_granular_permissions_analytic_attributes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, modalBodyWarning) : modalBodyWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, modalBodyWarning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, getModalBodyContent()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, loading ? null : modalFooter)));
};

});
parcelRegister("kHhcd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1959b1db9d7d7f74dcc029cd008a599f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f115298c6cca5e13$var$_react = $f115298c6cca5e13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f115298c6cca5e13$var$_baseNew = $f115298c6cca5e13$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f115298c6cca5e13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for links that open up a new tab as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f115298c6cca5e13$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $f115298c6cca5e13$var$_react.default.createElement($f115298c6cca5e13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.688 2.5a.19.19 0 0 0-.188.188v6.624c0 .104.084.188.188.188h6.624a.19.19 0 0 0 .188-.187V8.5H11v.813C11 10.244 10.245 11 9.313 11H2.686A1.687 1.687 0 0 1 1 9.313V2.686C1 1.757 1.756 1 2.688 1H3.5v1.5zM5.75 1h4.5a.75.75 0 0 1 .75.75v4.5H9.5V3.56L5.53 7.53 4.47 6.47 8.44 2.5H5.75z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$f115298c6cca5e13$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $f115298c6cca5e13$var$_default = module.exports.default = $f115298c6cca5e13$var$LinkExternalIcon;

});

parcelRegister("hyMPp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cc8b7ce7e8a9765f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $cc8b7ce7e8a9765f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'proforma-form-security.config-button.config-modal.view-modal.title',
        defaultMessage: 'Who can view this form',
        description: 'Title for the form permission configuration modal in view only mode.'
    },
    description: {
        id: 'proforma-form-security.config-button.config-modal.view-modal.description',
        defaultMessage: 'Only specific people can view this form once submitted. <link>Read more about restricting forms</link>',
        description: 'Description for the form permission configuration modal in view only mode.'
    },
    manageButton: {
        id: 'proforma-form-security.config-button.config-modal.view-modal.manageButton',
        defaultMessage: 'Manage',
        description: 'Manage button for the form permission configuration modal in view only mode.'
    },
    manageButtonLabel: {
        id: 'proforma-form-security.config-button.config-modal.view-modal.manageButtonLabel',
        defaultMessage: 'Manage form restrictions',
        description: 'Label for Manage button for the form permission configuration modal in view only mode.'
    },
    closeButton: {
        id: 'proforma-form-security.config-button.config-modal.view-modal.cancelButton',
        defaultMessage: 'Close',
        description: 'Close button for the form permission configuration modal in view only mode.'
    },
    closeButtonLabel: {
        id: 'proforma-form-security.config-button.config-modal.view-modal.cancelButtonLabel',
        defaultMessage: 'Close modal',
        description: 'Label for Close button for the form permission configuration modal in view only mode.'
    },
    restrictionsLoadFailureDescription: {
        id: 'proforma-form-security.config-button.config-modal.view-modal.restrictionsLoadFailureDescription',
        defaultMessage: "We couldn\u2019t load restrictions on this page. Refresh the page and try again.",
        description: 'Message shown to the user when loading the restricted principals failed'
    },
    restrictionsModalCloseIconLabel: {
        id: 'proforma-form-security.config-button.config-modal.view-modal.restrictions-modal-close-icon-label',
        defaultMessage: 'Close modal',
        description: 'Label for the close icon within the form permissions view modal.'
    }
});

});


parcelRegister("jcGgi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dfafeb9f2ecec7cf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $dfafeb9f2ecec7cf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    restrictedTooltip: {
        id: 'proforma-form-security.config-button.restricted-tooltip',
        defaultMessage: 'Only specific people can view this form',
        description: 'Text for the form permission button tooltip to show it is restricted.'
    },
    restrictedViewModeTooltip: {
        id: 'proforma-form-security.config-button.restricted-view-mode-tooltip',
        defaultMessage: 'View restrictions',
        description: 'Text for the view-mode form permission button tooltip to show it is restricted.'
    },
    openTooltip: {
        id: 'proforma-form-security.config-button.open-tooltip',
        defaultMessage: 'Anyone can view this form',
        description: 'Text for the form permission button tooltip to show it is open.'
    },
    restricted: {
        id: 'proforma-form-security.config-button.restricted',
        defaultMessage: 'Restrictions apply on submitted forms',
        description: 'Label attribute for the form permission button to show it is restricted.'
    },
    open: {
        id: 'proforma-form-security.config-button.open',
        defaultMessage: 'No restrictions apply on submitted forms',
        description: 'Label attribute for the form permission button to show it is open.'
    },
    restrictedLabel: {
        id: 'proforma-form-security.config-button.restricted-label',
        defaultMessage: 'Manage restrictions, restrictions applied',
        description: 'Label attribute for the form permission button to show it is restricted.'
    },
    openLabel: {
        id: 'proforma-form-security.config-button.restricted-label',
        defaultMessage: 'Manage restrictions, no restrictions applied',
        description: 'Label attribute for the form permission button to show it is open.'
    },
    viewModeButtonLabel: {
        id: 'proforma-form-security.config-button.view-mode-button-label',
        defaultMessage: 'View form restrictions',
        description: 'Label attribute for the form permission button to view form restrictions.'
    }
});

});

parcelRegister("5vTut", function(module, exports) {

$parcel$export(module.exports, "PulseSpotlightOnboarding", () => $403ae43f39349d6b$export$6e9467aee5245535);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");


var $e4yMr = parcelRequire("e4yMr");

var $7gs1W = parcelRequire("7gs1W");
var $imZsD = parcelRequire("imZsD");
var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $7Q9gS = parcelRequire("7Q9gS");

var $2YYw1 = parcelRequire("2YYw1");

var $ctMTT = parcelRequire("ctMTT");
const $403ae43f39349d6b$export$6e9467aee5245535 = ({ showOnboarding: showOnboarding, children: children, onDismiss: onDismiss, onProceed: onProceed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [onboardingStep, setOnboardingStep] = (0, $5uXOq.useState)('none');
    const showPulse = onboardingStep === 'pulse';
    const showSpotlight = onboardingStep === 'spotlight';
    (0, $5uXOq.useEffect)(()=>{
        if (showOnboarding) setOnboardingStep('pulse');
        else setOnboardingStep('none');
    }, [
        showOnboarding
    ]);
    const onClickWithOnboarding = (onClick)=>(event, analyticsEvent)=>{
            event.stopPropagation();
            switch(onboardingStep){
                case 'pulse':
                    setOnboardingStep('spotlight');
                    return;
                case 'none':
                    return onClick(event, analyticsEvent);
                case 'spotlight':
                default:
            }
        };
    const handleProceed = (event, analyticsEvent)=>{
        setOnboardingStep('none');
        onProceed(event, analyticsEvent);
    };
    const handleDismiss = ()=>{
        setOnboardingStep('none');
        onDismiss();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $7Q9gS.BUTTON_SPOTLIGHT_TARGET_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: showPulse
    }, children(onClickWithOnboarding))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, showSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7gs1W.default), {
        target: (0, $7Q9gS.BUTTON_SPOTLIGHT_TARGET_NAME),
        key: (0, $7Q9gS.BUTTON_SPOTLIGHT_TARGET_NAME),
        heading: formatMessage((0, $ctMTT.messages).spotlightHeading),
        actions: [
            {
                text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ctMTT.messages).spotlightPrimaryButton),
                onClick: handleProceed
            },
            {
                text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ctMTT.messages).spotlightSecondaryButton),
                onClick: handleDismiss,
                appearance: 'subtle'
            }
        ],
        targetRadius: 3,
        targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
        dialogWidth: 280,
        dialogPlacement: "bottom left",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2YYw1)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $ctMTT.messages).spotlightContent, {
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    appearance: "inverse",
                    href: (0, $7Q9gS.FORM_RESTRICTION_URL),
                    target: "_blank"
                }, chunks)
        }
    })))));
};

});
parcelRegister("2YYw1", function(module, exports) {
module.exports = new URL("form-permission-onboarding.ff1f6e21.svg", import.meta.url).toString();

});

parcelRegister("ctMTT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $915e2017a94cd40f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $915e2017a94cd40f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    spotlightHeading: {
        id: 'proforma-form-security.config-button.onboarding.spotlight-heading',
        defaultMessage: 'Restrict who can view this form',
        description: 'Heading for content in onboarding sportlight for form security config button.'
    },
    spotlightContent: {
        id: 'proforma-form-security.config-button.onboarding.spotlight-content',
        defaultMessage: 'Control who can view this form once submitted by giving access to specific people. <link>Read more about restricting forms</link>',
        description: 'Content for content in onboarding sportlight for form security config button.'
    },
    spotlightPrimaryButton: {
        id: 'proforma-form-security.config-button.onboarding.spotlight-primary-button',
        defaultMessage: 'Try it out',
        description: 'Text for primary button in onboarding sportlight for form security config button.'
    },
    spotlightSecondaryButton: {
        id: 'proforma-form-security.config-button.onboarding.spotlight-secondary-button',
        defaultMessage: 'Dismiss',
        description: 'Text for secondary button in onboarding sportlight for form security config button.'
    }
});

});



parcelRegister("kxjzW", function(module, exports) {

$parcel$export(module.exports, "saveRestrictedPrincipalsForTemplateForm", () => $ef3613a539de0fa9$export$29bab78c7af6515d);
$parcel$export(module.exports, "loadRestrictedPrincipalsForTemplateForm", () => $ef3613a539de0fa9$export$94a42509057aab46);

var $1Jl81 = parcelRequire("1Jl81");
var $guy0h = parcelRequire("guy0h");
var $k9L5z = parcelRequire("k9L5z");

var $5wvQR = parcelRequire("5wvQR");

var $66UG2 = parcelRequire("66UG2");
const $ef3613a539de0fa9$export$29bab78c7af6515d = (cloudId, projectId, templateFormLegacyId, principals)=>$ef3613a539de0fa9$var$doFetch($ef3613a539de0fa9$var$proformaFormRestrictionsURLPath(cloudId, projectId, templateFormLegacyId), 'POST', (0, $66UG2.AcceptedResponseType).None, principals.map((principal)=>principal.ari.toString())).then(()=>principals.length > 0 ? (0, $5wvQR.FormRestrictionStatus).RESTRICTED : (0, $5wvQR.FormRestrictionStatus).OPEN);
const $ef3613a539de0fa9$export$94a42509057aab46 = (cloudId, projectId, templateFormLegacyId)=>$ef3613a539de0fa9$var$doFetch($ef3613a539de0fa9$var$proformaFormRestrictionsURLPath(cloudId, projectId, templateFormLegacyId), 'GET', (0, $66UG2.AcceptedResponseType).Json).then((principals)=>({
            principals: principals.map($ef3613a539de0fa9$var$toFormSupportedPrincipal)
        }));
const $ef3613a539de0fa9$var$toFormSupportedPrincipal = (p)=>{
    const identityResourceType = (0, $1Jl81.AnyAri).parse(p.principalId).resourceType;
    switch(identityResourceType){
        case 'user':
            return {
                ari: (0, $k9L5z.IdentityUserAri).parse(p.principalId),
                type: (0, $5wvQR.FormSupportedPrincipalType).USER,
                name: p.name,
                avatar: p.avatarUrl
            };
        case 'group':
            return {
                ari: (0, $guy0h.IdentityGroupAri).parse(p.principalId),
                type: (0, $5wvQR.FormSupportedPrincipalType).USER_GROUP,
                name: p.name,
                avatar: p.avatarUrl
            };
        default:
            throw new Error(`unsupported principal type ${identityResourceType}`);
    }
};
/** Formats a url path for the form restrictions endpoint on Proforma */ const $ef3613a539de0fa9$var$proformaFormRestrictionsURLPath = (cloudId, projectId, templateFormLegacyId)=>`/gateway/api/proforma/cloudid/${cloudId}/api/frontend/jira/project/${projectId}/form/${templateFormLegacyId}/restrictions`;
/** Wrapper around fetch with a minimal API specific for form restriction requests */ const $ef3613a539de0fa9$var$doFetch = (url, method, acceptedResponseType, body)=>fetch(url, {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        method: method,
        ...body && {
            body: JSON.stringify(body)
        }
    }).then((response)=>{
        if (!response.ok) throw new Error(`Unexpected response from ${response.url} ${response.status} ${response.statusText}`);
        switch(acceptedResponseType){
            case (0, $66UG2.AcceptedResponseType).Json:
                return response.json();
            case (0, $66UG2.AcceptedResponseType).None:
                return undefined;
            default:
                throw new Error(`Unexpected accepted response type ${acceptedResponseType}`);
        }
    });

});
parcelRegister("66UG2", function(module, exports) {

$parcel$export(module.exports, "AcceptedResponseType", () => $472f447cba27e932$export$9126c50ecfe2a46d);
const $472f447cba27e932$export$9126c50ecfe2a46d = {
    Json: 'json',
    None: 'none'
};

});


parcelRegister("9k3m4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d605c97d2edb45e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $3d605c97d2edb45e$var$FormIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "18",
        viewBox: "0 -2 14 22"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M1.994 2v14h10V2h-10ZM0 1.791C0 .8028.897 0 2.006 0h9.988C13.102 0 14 .8082 14 1.791v14.418c0 .9891-.897 1.791-2.006 1.791H2.006c-.5295.0007-1.03778-.1873-1.41369-.5229C.21639 17.1415.00344 16.6855 0 16.209V1.791Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M6.9013 11.1153h2.8718c.5287 0 .9572-.3997.9572-.8929 0-.4931-.4285-.8928-.9572-.8928H6.9013c-.5287 0-.9573.3997-.9573.8928 0 .4932.4286.8929.9573.8929ZM6.9013 8.2231h2.8718c.5287 0 .9572-.3997.9572-.8928 0-.49314-.4285-.89288-.9572-.89288H6.9013c-.5287 0-.9573.39974-.9573.89288 0 .4931.4286.8928.9573.8928ZM6.9013 5.40103h2.8718c.5287 0 .9572-.39975.9572-.89286s-.4285-.89286-.9572-.89286L6.9013 3.6153c-.5287 0-.9573.39976-.9573.89287 0 .49311.4286.89286.9573.89286ZM3.1488 5.32959h1.83796c0-.82142-.00001-1.22117 0-1.71429H3.1488v1.71429ZM3.22598 8.1517H5.0639V6.43742H3.22598V8.1517ZM3.22598 11.0439H5.0639V9.3296H3.22598v1.7143ZM4.18324 14H9.812c.5286 0 .9572-.3997.9572-.8929 0-.4931-.4286-.8928-.9572-.8928H4.18324c-.52868 0-.95726.3997-.95726.8928 0 .4932.42858.8929.95726.8929Z"
    }));
var $3d605c97d2edb45e$export$2e2bcd8739ae039 = $3d605c97d2edb45e$var$FormIcon;

});

parcelRegister("6JsCe", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b2555c7fcc70d3bc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b2555c7fcc70d3bc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    emptyStateText: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.empty-state-text",
        "defaultMessage": "Add forms for customers to fill out when raising a request."
    },
    formsFieldName: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.forms-field-name",
        "defaultMessage": "Forms"
    },
    formIconAriaLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.form-icon-aria-label",
        "defaultMessage": "Form"
    },
    learnMoreLink: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.learn-more-link",
        "defaultMessage": "Learn more about forms."
    },
    linkedFieldError: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.linked-field-error",
        "defaultMessage": "Linked field error."
    },
    fixInFormBuilderLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.fix-in-form-builder-label",
        "defaultMessage": "Fix in form builder"
    },
    editDropdownItemLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.meatball.edit-dropdown-item-label",
        "defaultMessage": "Edit"
    },
    opensInAnotherWindowAriaLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.meatball.opens-in-another-window-aria-label",
        "defaultMessage": "Opens in another window"
    },
    removeFormLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.meatball.remove-dropdown-item-label",
        "defaultMessage": "Remove"
    },
    fixInFormBuilderLabelNew: {
        "id": "project-settings-product-features-jsm-common.form-card.fix-in-form-builder-label-new",
        "defaultMessage": "Check linked field configuration"
    },
    conditionalFieldMismatchTooltipError: {
        "id": "project-settings-product-features-jsm-common.form-card.conditional-field-mismatch-tooltip-error",
        "defaultMessage": "Remove required fields from sections"
    },
    requiredFieldMismatchTooltipError: {
        "id": "project-settings-product-features-jsm-common.form-card.required-field-mismatch-tooltip-error",
        "defaultMessage": "Mark linked fields as required"
    },
    conditionalAndRequiredFieldMismatchTooltipError: {
        "id": "project-settings-product-features-jsm-common.form-card.conditional-and-required-field-mismatch-tooltip-error",
        "defaultMessage": "Mark linked fields as required and remove from sections"
    },
    conditionalFieldMismatchSectionError: {
        "id": "project-settings-product-features-jsm-common.form-card.conditional-field-mismatch-section-error",
        "defaultMessage": "Select <b>Edit</b> to remove the form {fieldListCount, plural, one {field linked to the required Jira field} other {fields linked to the required Jira fields}} {fieldList} from any conditional sections."
    },
    requiredFieldMismatchSectionError: {
        "id": "project-settings-product-features-jsm-common.form-card.required-field-mismatch-section-error",
        "defaultMessage": "Select <b>Edit</b> to mark the form {fieldListCount, plural, one {field as required to match its linked Jira field} other {fields as required to match its linked Jira fields}} {fieldList}."
    },
    conditionalAndRequiredFieldMismatchSectionError: {
        "id": "project-settings-product-features-jsm-common.form-card.conditional-and-required-field-mismatch-section-error",
        "defaultMessage": "Select <b>Edit</b> to mark the form {fieldListCount, plural, one {field} other {fields}} linked to {fieldList} as required, and remove any required linked form fields from conditional sections."
    },
    fieldMismatchErrorIcon: {
        "id": "project-settings.issue-type-page-product-features-jsm-common.ui.form-panel.form-card.field-mismatch-error-icon",
        "defaultMessage": "Field mismatch error icon."
    }
});

});

parcelRegister("az6SI", function(module, exports) {

$parcel$export(module.exports, "RemoveFormConfirmationDialog", () => $c02ad994989205ad$export$56d3f4bcfcd1887f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $bU3PY = parcelRequire("bU3PY");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $i8Qvm = parcelRequire("i8Qvm");

var $7NYq5 = parcelRequire("7NYq5");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $cESzO = parcelRequire("cESzO");
const $c02ad994989205ad$export$56d3f4bcfcd1887f = ({ isOpen: isOpen, onConfirm: onConfirm, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "project-settings-product-features-jsm-common.ui.form-panel.form-card.remove-form-confirmation.modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c02ad994989205ad$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        color: "var(--ds-icon-warning, #E56910)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c02ad994989205ad$var$WarningText, null, formatMessage((0, $cESzO.messages).title)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage((0, $cESzO.messages).descriptionIssueTermRefresh) : formatMessage((0, $cESzO.messages).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onCancel,
        autoFocus: false,
        "aria-label": formatMessage((0, $cESzO.messages).cancelButton)
    }, formatMessage((0, $cESzO.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "warning",
        onClick: onConfirm,
        autoFocus: false,
        "aria-label": formatMessage((0, $cESzO.messages).removeButton)
    }, formatMessage((0, $cESzO.messages).removeButton)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c02ad994989205ad$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c02ad994989205ad$var$WarningText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cESzO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5b9faa9109f55aef$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5b9faa9109f55aef$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "project-settings-product-features-jsm-common.form-card.remove-form-confirmation.title",
        "defaultMessage": "Remove form from this request type"
    },
    description: {
        "id": "project-settings-product-features-jsm-common.form-card.remove-form-confirmation.description",
        "defaultMessage": "Existing issues created using this request type won't be affected by this change."
    },
    descriptionIssueTermRefresh: {
        "id": "project-settings-product-features-jsm-common.form-card.remove-form-confirmation.description-issue-term-refresh",
        "defaultMessage": "Existing work items created using this request type won't be affected by this change."
    },
    cancelButton: {
        "id": "project-settings-product-features-jsm-common.form-card.remove-form-confirmation.cancel-button",
        "defaultMessage": "Cancel"
    },
    removeButton: {
        "id": "project-settings-product-features-jsm-common.form-card.remove-form-confirmation.remove-button",
        "defaultMessage": "Remove"
    }
});

});



parcelRegister("91c3S", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e10d98bf1a78a4f4$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e10d98bf1a78a4f4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    attachedFormLabel: {
        "id": "project-settings-product-features-jsm-common.form-panel.attached-form-label",
        "defaultMessage": "Attached form"
    },
    formSecurityWithIssueSecurityWarningDescription: {
        "id": "project-settings-product-features-jsm-common.form-panel.form-security-with-issue-security-warning-description",
        "defaultMessage": "Restrictions on this form conflict with the issue security level set on this request type. Only those with access to both will be able to view this form."
    },
    formSecurityWithIssueSecurityWarningDescriptionIssueTermRefresh: {
        "id": "project-settings-product-features-jsm-common.form-panel.form-security-with-issue-security-warning-description-issue-term-refresh",
        "defaultMessage": "Restrictions on this form conflict with the work item security level set on this request type. Only those with access to both will be able to view this form."
    },
    formSecurityWithIssueSecurityWarningLabel: {
        "id": "project-settings-product-features-jsm-common.form-panel.form-security-with-issue-security-warning-label",
        "defaultMessage": "Select to view form security with issue security warning message"
    },
    formSecurityWithIssueSecurityWarningLabelIssueTermRefresh: {
        "id": "project-settings-product-features-jsm-common.form-panel.form-security-with-issue-security-warning-label-issue-term-refresh",
        "defaultMessage": "Select to view form security with work item security warning message"
    },
    formSecurityAndIssueSecurityWarningLabel: {
        "id": "project-settings-product-features-jsm-common.form-panel.form-security-and-issue-security-warning-label",
        "defaultMessage": "View attached form warning message"
    }
});

});


parcelRegister("9Ekea", function(module, exports) {

$parcel$export(module.exports, "validationMessages", () => $94b1c41c58ee3852$export$2497dec627a30444);
$parcel$export(module.exports, "descriptionInlineInputMessages", () => $94b1c41c58ee3852$export$c6bd25009c72ff5);
$parcel$export(module.exports, "helpTextInlineInputMessages", () => $94b1c41c58ee3852$export$3b894744b266d320);

var $7VHMR = parcelRequire("7VHMR");
const $94b1c41c58ee3852$export$2497dec627a30444 = (0, $7VHMR.defineMessages)({
    errorMessageIssueTypeDescriptionTooLong: {
        "id": "project-settings-product-features-jsm-cmp.utils.validation.error-message-issue-type-description-too-long",
        "defaultMessage": "Description should be {maximumDescriptionLength, plural, one {# character} other {# characters}} or less"
    },
    errorMessageInvalidDefaultValue: {
        "id": "project-settings-product-features-jsm-cmp.utils.validation.error-message-invalid-default-value",
        "defaultMessage": "Enter a valid preset value."
    },
    errorMessageIssueTypeHelpTextTooLong: {
        "id": "project-settings-product-features-jsm-cmp.utils.validation.error-message-issue-type-help-text-too-long",
        "defaultMessage": "Help text can\u2019t exceed {maximumHelpTextLength, plural, one {# character} other {# characters}}"
    },
    errorMessageIssueTypeNameTooLong: {
        "id": "project-settings-product-features-jsm-cmp.utils.validation.error-message-issue-type-name-too-long",
        "defaultMessage": "Request type name can\u2019t exceed {maximumNameLength, plural, one {# character} other {# characters}}"
    },
    errorMessageEmptyIssueTypeName: {
        "id": "ticket-type-fields.layout.header.inline-edit.warning",
        "defaultMessage": "You must specify a ticket type name"
    }
});
const $94b1c41c58ee3852$export$c6bd25009c72ff5 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "jsd.project-settings-apps.add-issue-type.main-modal.content.description-input.label",
        "defaultMessage": "Portal description"
    },
    editDescriptionButtonLabel: {
        "id": "jsd.project-settings-apps.issue-type-page.main-header.description-inline-input.edit-description-button-label",
        "defaultMessage": "Edit description"
    },
    descriptionPlaceholder: {
        "id": "jsd.project-settings-apps.issue-type-page.main-header.description-inline-input.placeholder",
        "defaultMessage": "Let people know when to use this request type"
    }
});
const $94b1c41c58ee3852$export$3b894744b266d320 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "project-settings-apps.issue-type-page.main-content-jsm.help-text-label",
        "defaultMessage": "Portal instructions"
    },
    editDescriptionButtonLabel: {
        "id": "project-settings-apps.issue-type-page.main-header.help-text-inline-input.edit-button-label",
        "defaultMessage": "Edit portal instructions"
    },
    descriptionPlaceholder: {
        "id": "project-settings-apps.issue-type-page.main-content-jsm.help-text-placeholder",
        "defaultMessage": "Enter text to help your customers complete this form correctly."
    }
});

});


parcelRegister("fyLyr", function(module, exports) {

$parcel$export(module.exports, "MainHeader", () => $eb9ff85a0e4569d9$export$5f0b2c5569a35f91);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $1W8JP = parcelRequire("1W8JP");

var $cgvPO = parcelRequire("cgvPO");

var $dVb03 = parcelRequire("dVb03");


var $JZXck = parcelRequire("JZXck");
const $eb9ff85a0e4569d9$export$5f0b2c5569a35f91 = (props)=>{
    const { extraDefinerId: extraDefinerId, issueLayoutOwners: issueLayoutOwners, project: project } = props;
    const issueType = issueLayoutOwners.find(({ data: { id: id } })=>id === extraDefinerId);
    if (!issueType || issueType.type !== (0, $231503f5cdbec9c4$export$3bfbaac56381682c)) throw new Error("Can't find current request type data");
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { properties: properties } = issueType.data;
    const isEmailRequestType = properties && properties[0, $23ebcbac5107706a$export$97806a3c861a8076];
    const requestTypeSecurityConfigButton = issueType.data.externalUuid && issueType.data.restrictionStatus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVb03.ConfigButton), {
        ...(0, $4R6GH.fg)('concurrent-rendering-fix-unique-list-key') ? {
            key: `RequestTypeSecurityConfigButton-${project.projectId}`
        } : {},
        projectId: project.projectId,
        projectKey: project.projectKey,
        requestType: {
            externalId: issueType.data.externalUuid,
            restrictionStatus: issueType.data.restrictionStatus,
            issueSecurityStatus: 'INACTIVE',
            usedByEmailSettings: !!isEmailRequestType
        },
        features: [
            'REQUEST_TYPE_PERMISSIONS'
        ],
        showText: true,
        skipOnboarding: true
    }) : null;
    const headerMessages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $JZXck.default),
            ...(0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $JZXck.messagesIssueTermRefresh) : {},
            editNameButtonLabel: (0, $cgvPO.editIssueTypeMessages).editNameButtonLabel,
            editNameInputLabel: (0, $cgvPO.editIssueTypeMessages).editNameInputLabel
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1W8JP.MainHeaderTmp), {
        ...props,
        issueType: issueType,
        messages: headerMessages,
        extraActions: [
            requestTypeSecurityConfigButton,
            ...props.extraActions ?? []
        ]
    }), isEmailRequestType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eb9ff85a0e4569d9$export$b9b108b497733374, null, formatMessage((0, $JZXck.default).emailRequestTypeDescription)) : null);
};
const $eb9ff85a0e4569d9$export$b9b108b497733374 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1W8JP", function(module, exports) {

$parcel$export(module.exports, "MainHeaderTmp", () => $3e8a474ed81bbf1e$export$3e46d3c3faacdc27);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $ldJSL = parcelRequire("ldJSL");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $4R6GH = parcelRequire("4R6GH");

var $g7vpP = parcelRequire("g7vpP");

var $2Cxf6 = parcelRequire("2Cxf6");

var $jkLES = parcelRequire("jkLES");

var $6wesA = parcelRequire("6wesA");
const $3e8a474ed81bbf1e$export$3e46d3c3faacdc27 = (props)=>{
    const { issueType: issueType, extraActions: extraActions, onUpdateIssueLayoutOwner: onUpdateIssueLayoutOwner, issueTypeResetCount: issueTypeResetCount, IssueTypeRestriction: IssueTypeRestriction, EditWorkflowButton: EditWorkflowButton, isIssueRestrictionEnabled: isIssueRestrictionEnabled, shouldShowWorkflowEditor: shouldShowWorkflowEditor, project: project, messages: messages } = props;
    const { properties: properties } = issueType.data;
    const isEmailRequestType = properties && properties[0, $6wesA.JSD_IS_EMAIL_REQUEST_TYPE];
    const [isAvatarModalOpen, setIsAvatarModalOpen] = (0, $5uXOq.useState)(false);
    const { name: name, iconUrl: iconUrl, avatarId: avatarId, id: issueTypeId } = issueType.data;
    // remove this line while cleaning jsdcloud_13712_update_tmp_email_request_type
    const canNameBeEdited = true;
    const openAvatarModal = ()=>setIsAvatarModalOpen(true);
    const closeAvatarModal = ()=>setIsAvatarModalOpen(false);
    const onAvatarSelected = (avatar)=>{
        onUpdateIssueLayoutOwner({
            ...issueType,
            data: {
                ...issueType.data,
                avatarId: String(avatar.id),
                iconUrl: avatar.uri
            }
        });
        setIsAvatarModalOpen(false);
    };
    const onNameChange = (newName)=>{
        onUpdateIssueLayoutOwner({
            ...issueType,
            data: {
                ...issueType.data,
                name: newName
            }
        });
    };
    const allActions = [];
    if (shouldShowWorkflowEditor) allActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditWorkflowButton, {
        key: "edit-workflow",
        issueTypeId: issueTypeId
    }));
    if (isIssueRestrictionEnabled) allActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueTypeRestriction, {
        key: "restriction",
        issueTypeName: name
    }));
    if (extraActions) allActions.push(...extraActions);
    const nameInlineInputMessages = (0, $5uXOq.useMemo)(()=>({
            editNameButtonLabel: messages.editNameButtonLabel,
            editNameInputLabel: (0, $4R6GH.fg)('jsm_rtc_document_title_a11y') ? messages.editNameInputLabel : undefined
        }), [
        messages.editNameButtonLabel,
        messages.editNameInputLabel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e8a474ed81bbf1e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Cxf6.AvatarIcon), {
        onEdit: openAvatarModal,
        avatarUri: iconUrl || '',
        label: name,
        messages: messages
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g7vpP.default), {
        isOpen: isAvatarModalOpen,
        onAvatarSelected: onAvatarSelected,
        onDismiss: closeAvatarModal,
        selectedAvatar: {
            id: Number(avatarId ?? 0),
            uri: iconUrl || ''
        },
        projectId: project.projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e8a474ed81bbf1e$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        disableTitleStyles: true,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $3e8a474ed81bbf1e$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, allActions))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jkLES.NameInlineInput), {
        issueTypeId: issueTypeId,
        projectId: project.projectId,
        canBeEdited: (0, $4R6GH.fg)('jsdcloud_13712_update_tmp_email_request_type') ? !isEmailRequestType : canNameBeEdited,
        issueTypeResetCount: issueTypeResetCount,
        value: name,
        validationMessages: messages,
        onChange: onNameChange,
        messages: nameInlineInputMessages
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e8a474ed81bbf1e$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e8a474ed81bbf1e$var$Header = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "a8fkl6-0"
})({
    flexGrow: 1,
    width: 0,
    /* The AK PageHeader component has built in margins that don't match our desired layout for the SWIFT page so let's override it. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> div': {
        margin: 0
    }
});
const $3e8a474ed81bbf1e$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $0c196d37a4e8266c$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $0c196d37a4e8266c$var$truncateStyles = null;
const $0c196d37a4e8266c$var$outerStyles = null;
const $0c196d37a4e8266c$var$titleStyles = null;
const $0c196d37a4e8266c$var$titleWrapperStyles = null;
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = null;
const $0c196d37a4e8266c$var$titleContainerStyles = null;
const $0c196d37a4e8266c$var$actionStyles = null;
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = null;
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $0c196d37a4e8266c$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("g7vpP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef5c60321b578945$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $9pe79 = parcelRequire("9pe79");

var $97Kan = parcelRequire("97Kan");

var $6caEX = parcelRequire("6caEX");

var $iLwXE = parcelRequire("iLwXE");

var $jbVoj = parcelRequire("jbVoj");

var $iwpO5 = parcelRequire("iwpO5");

var $2vIDJ = parcelRequire("2vIDJ");

var $bG15C = parcelRequire("bG15C");

var $6fqr6 = parcelRequire("6fqr6");
class $ef5c60321b578945$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.store = (0, $2vIDJ.default)((0, $jbVoj.rootOperation), props);
        this.store.dispatch((0, $iwpO5.fetchAvatars)());
    }
    componentDidUpdate(prevProps) {
        const avatars = (0, $bG15C.getAvatars)(this.store.getState());
        if ((0, $9pe79.default)(prevProps, this.props)) return;
        this.store.dispatch((0, $iwpO5.initializeAppProps)(this.props));
        if (!prevProps.isOpen && this.props.isOpen) this.store.dispatch((0, $iwpO5.fetchAvatars)());
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(avatars) && !this.props.selectedAvatar) this.props.onAvatarSelected(avatars[0]);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            id: (0, $iLwXE.APP_ID),
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $6caEX.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6fqr6.default), null)));
    }
}

});
parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("6caEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9fef1bc384f8bb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9e9qZ = parcelRequire("9e9qZ");

var $iwpO5 = parcelRequire("iwpO5");
const $2a9fef1bc384f8bb$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $iwpO5.SAVE_AVATAR_IMAGE_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9e9qZ.AvatarUploadFailedFlag), props);
        case 0, $iwpO5.SHOW_FETCH_AVATARS_ERROR_FLAG:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9e9qZ.AvatarFetchFailedFlag), props);
        default:
            return undefined;
    }
};
var $2a9fef1bc384f8bb$export$2e2bcd8739ae039 = $2a9fef1bc384f8bb$var$flagsMapper;

});
parcelRegister("9e9qZ", function(module, exports) {

$parcel$export(module.exports, "AvatarFetchFailedFlag", () => $87d1a79eb7bc8205$export$24383bcfe1266398);
$parcel$export(module.exports, "AvatarUploadFailedFlag", () => $87d1a79eb7bc8205$export$78f1f1e4e17c00d5);

var $5uXOq = parcelRequire("5uXOq");

var $fG9jT = parcelRequire("fG9jT");

var $az4zD = parcelRequire("az4zD");

var $9OY2o = parcelRequire("9OY2o");
const $87d1a79eb7bc8205$export$24383bcfe1266398 = (0, $az4zD.injectIntlV2)(// @ts-expect-error - Property 'formatMessage' does not exist on type 'IntlShapeV2 | IntlShape | undefined'.
({ intl: { formatMessage: formatMessage }, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fG9jT.default), {
        ...props,
        flagType: "error",
        title: formatMessage((0, $9OY2o.messages).fetchFailedFlagTitle, {}),
        description: formatMessage((0, $9OY2o.messages).fetchFailedFlagDescription, {}),
        messageId: `project-settings-apps-common.avatar-service.common-flag.fetchFailedFlag.${props.id}`,
        messageType: "transactional"
    }));
const $87d1a79eb7bc8205$export$78f1f1e4e17c00d5 = (0, $az4zD.injectIntlV2)(// @ts-expect-error - Property 'formatMessage' does not exist on type 'IntlShapeV2 | IntlShape | undefined'.
({ intl: { formatMessage: formatMessage }, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fG9jT.default), {
        ...props,
        flagType: "error",
        title: formatMessage((0, $9OY2o.messages).uploadFailedFlagTitle, {}),
        description: formatMessage((0, $9OY2o.messages).uploadFailedFlagDescription, {}),
        messageId: `project-settings-apps-common.avatar-service.common-flag.uploadFailedFlag.${props.id}`,
        messageType: "transactional"
    }));

});
parcelRegister("fG9jT", function(module, exports) {

$parcel$export(module.exports, "default", () => $874cfd4b776497f7$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$874cfd4b776497f7$export$2e2bcd8739ae039 = (0, $3KRpp.CommonFlag);

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("iYvi5")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("iYvi5")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $kxZPA.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("ktXXH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $kxZPA.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("ktXXH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("iYvi5", function(module, exports) {

let $dd061a425b165709$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dd061a425b165709$var$load("hPzOn"),
    $dd061a425b165709$var$load("h2MrD"),
    $dd061a425b165709$var$load("bYT2S"),
    $dd061a425b165709$var$load("cM9em"),
    $dd061a425b165709$var$load("fr9NE"),
    $dd061a425b165709$var$load("4yB9l")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("ktXXH", function(module, exports) {

let $ee95073ee99eb1d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee95073ee99eb1d5$var$load("Fkef4").then(()=>parcelRequire('5pz6a'));

});



parcelRegister("9OY2o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b01eb3f8f95dd543$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b01eb3f8f95dd543$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fetchFailedFlagTitle: {
        "id": "project-settings-apps.common.avatar-service.fetch-failed-flag-title",
        "defaultMessage": "We couldn't find our default icons"
    },
    fetchFailedFlagDescription: {
        "id": "project-settings-apps.common.avatar-service.fetch-failed-flag-description",
        "defaultMessage": "Upload your own image, or refresh the page to retry loading our default images."
    },
    uploadFailedFlagTitle: {
        "id": "project-settings-apps.common.avatar-service.upload-failed-flag-title",
        "defaultMessage": "We couldn't upload your image"
    },
    uploadFailedFlagDescription: {
        "id": "project-settings-apps.common.avatar-service.upload-failed-flag-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});

});


parcelRegister("iwpO5", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $06591b015645e084$export$84856e4ae7cd7538);
$parcel$export(module.exports, "initializeAppProps", () => $06591b015645e084$export$5f0e35553cecddfe);
$parcel$export(module.exports, "FETCH_AVATARS", () => $06591b015645e084$export$595c2c75812f5d47);
$parcel$export(module.exports, "fetchAvatars", () => $06591b015645e084$export$20d96f412158cf04);
$parcel$export(module.exports, "FETCH_AVATARS_SUCCESS", () => $06591b015645e084$export$5bce4d84a470b13d);
$parcel$export(module.exports, "fetchAvatarsSuccess", () => $06591b015645e084$export$ccaff80f22f50293);
$parcel$export(module.exports, "FETCH_AVATARS_FAILURE", () => $06591b015645e084$export$a5ad4645724f5a87);
$parcel$export(module.exports, "fetchAvatarsFailure", () => $06591b015645e084$export$71d62a5c95f19547);
$parcel$export(module.exports, "SHOW_FETCH_AVATARS_ERROR_FLAG", () => $06591b015645e084$export$92629bc2b05ddfbd);
$parcel$export(module.exports, "showFetchAvatarsErrorFlag", () => $06591b015645e084$export$7fb6e6df703949f8);
$parcel$export(module.exports, "SAVE_AVATAR_IMAGE_SUCCESS", () => $06591b015645e084$export$96168300178a8488);
$parcel$export(module.exports, "saveAvatarImageSuccess", () => $06591b015645e084$export$23afef434894c06a);
$parcel$export(module.exports, "SAVE_AVATAR_IMAGE_FAILURE", () => $06591b015645e084$export$b0f5550291672758);
$parcel$export(module.exports, "saveAvatarImageFailure", () => $06591b015645e084$export$ed10bed01c62b585);
$parcel$export(module.exports, "SAVE_AVATAR_IMAGE", () => $06591b015645e084$export$3ad2448711d78c79);
$parcel$export(module.exports, "saveAvatarImage", () => $06591b015645e084$export$72e5e12345b3aff9);
const $06591b015645e084$export$84856e4ae7cd7538 = 'state.INITIALIZE_APP_PROPS';
const $06591b015645e084$export$5f0e35553cecddfe = (payload)=>({
        type: $06591b015645e084$export$84856e4ae7cd7538,
        payload: payload
    });
const $06591b015645e084$export$595c2c75812f5d47 = 'state.FETCH_AVATARS';
const $06591b015645e084$export$20d96f412158cf04 = ()=>({
        type: $06591b015645e084$export$595c2c75812f5d47
    });
const $06591b015645e084$export$5bce4d84a470b13d = 'state.FETCH_AVATARS_SUCCESS';
const $06591b015645e084$export$ccaff80f22f50293 = (payload)=>({
        type: $06591b015645e084$export$5bce4d84a470b13d,
        payload: payload
    });
const $06591b015645e084$export$a5ad4645724f5a87 = 'state.FETCH_AVATARS_FAILURE';
const $06591b015645e084$export$71d62a5c95f19547 = ()=>({
        type: $06591b015645e084$export$a5ad4645724f5a87
    });
const $06591b015645e084$export$92629bc2b05ddfbd = 'state.SHOW_FETCH_AVATARS_ERROR_FLAG';
const $06591b015645e084$export$7fb6e6df703949f8 = ()=>({
        type: $06591b015645e084$export$92629bc2b05ddfbd
    });
const $06591b015645e084$export$96168300178a8488 = 'state.SAVE_AVATAR_IMAGE_SUCCESS';
const $06591b015645e084$export$23afef434894c06a = (avatar)=>({
        type: $06591b015645e084$export$96168300178a8488,
        payload: {
            avatar: avatar
        }
    });
const $06591b015645e084$export$b0f5550291672758 = 'state.SAVE_AVATAR_IMAGE_FAILURE';
const $06591b015645e084$export$ed10bed01c62b585 = ()=>({
        type: $06591b015645e084$export$b0f5550291672758
    });
const $06591b015645e084$export$3ad2448711d78c79 = 'state.SAVE_AVATAR_IMAGE';
const $06591b015645e084$export$72e5e12345b3aff9 = (image, properties)=>({
        type: $06591b015645e084$export$3ad2448711d78c79,
        payload: {
            image: image,
            properties: properties
        }
    });

});


parcelRegister("iLwXE", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $467ea37b7a225cb9$export$d76071d5de2774fc);
$parcel$export(module.exports, "PACKAGE_NAME", () => $467ea37b7a225cb9$export$b8b9d90f9e5bd72b);

var $3XO6n = parcelRequire("3XO6n");
const $467ea37b7a225cb9$export$d76071d5de2774fc = 'project-settings-apps.avatar-modal';
const $467ea37b7a225cb9$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectSettingsAppsAvatarModal');

});

parcelRegister("jbVoj", function(module, exports) {

$parcel$export(module.exports, "rootOperation", () => $b19883fd22d471d5$export$8109dbf3bda166a6);

var $e1AU2 = parcelRequire("e1AU2");

var $3yPsZ = parcelRequire("3yPsZ");

var $iLwXE = parcelRequire("iLwXE");

var $1lZ0R = parcelRequire("1lZ0R");

var $1pgqH = parcelRequire("1pgqH");
const $b19883fd22d471d5$var$epic = (0, $e1AU2.combineEpics)((0, $1lZ0R.default), (0, $1pgqH.default));
const $b19883fd22d471d5$export$8109dbf3bda166a6 = (0, $3yPsZ.default)({
    packageName: (0, $iLwXE.PACKAGE_NAME),
    id: 'epic',
    epic: $b19883fd22d471d5$var$epic,
    sendToPrivacyUnsafeSplunk: true
});

});
parcelRegister("3yPsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9850a56ee2372bab$export$2e2bcd8739ae039);
parcelRequire("c66Ur");

var $jcw0u = parcelRequire("jcw0u");
var /**
 * Catches errors within the epic middleware and makes them available to monitoring.
 *
 * As opposed to epic-wrapper, this function uses fireErrorAnalytics to make data also available in SignalFx.
 *
 * Takes an optional observable as a parameter that can be returned when an error is encountered.
 * This could be used to show an error flag, for example, but will replace attempting to continue
 * the current observable stream.
 *
 * Example usage, which could be applied to the root epic:
 *
 * famaErrorHandlerEpicMiddleware({
 *   packageName: 'yourPackageName',
 *   id: 'yourErrorId',
 *   epic: combineEpics(epicOne, epicTwo),
 * );
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$9850a56ee2372bab$export$2e2bcd8739ae039 = ({ attributes: attributes, epic: epic, errorObservable: errorObservable, id: id, packageName: packageName, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, teamName: teamName })=>(action$, store, deps)=>epic(action$, store, deps).catch((error, stream)=>{
            const defaultAttributes = {
                message: 'Unhandled error in epic'
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: id,
                    packageName: packageName,
                    teamName: teamName
                },
                attributes: {
                    ...defaultAttributes,
                    ...attributes
                },
                sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
            });
            return errorObservable || stream;
        });

});

parcelRegister("1lZ0R", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a75d4675dd0da0$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $iwpO5 = parcelRequire("iwpO5");

var $bG15C = parcelRequire("bG15C");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47a75d4675dd0da0$export$2e2bcd8739ae039 = (action$, store, deps)=>// @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<FetchAvatarsSuccessAction | FetchAvatarsFailureAction>' but required in type 'ActionsObservable<Action>'.
    action$.ofType((0, $iwpO5.FETCH_AVATARS)).switchMap(()=>{
        const state = store.getState();
        const projectId = (0, $bG15C.getProjectId)(state);
        return (0, $kVLXA.Observable).fromPromise(deps.avatarService.get(projectId)).map((0, $iwpO5.fetchAvatarsSuccess)).catch(()=>(0, $kVLXA.Observable).of((0, $iwpO5.fetchAvatarsFailure)()));
    });

});
parcelRegister("bG15C", function(module, exports) {

$parcel$export(module.exports, "getProjectId", () => $3864ac0259cf878b$export$89040d072f281f85);
$parcel$export(module.exports, "getIsOpen", () => $3864ac0259cf878b$export$22a0749f4a6b2d26);
$parcel$export(module.exports, "getSelectedAvatar", () => $3864ac0259cf878b$export$4616025ba0db1dfa);
$parcel$export(module.exports, "getOnAvatarSelected", () => $3864ac0259cf878b$export$4cb1a74f14b1f7e7);
$parcel$export(module.exports, "getOnDismiss", () => $3864ac0259cf878b$export$eb8a6013fba2b81f);
$parcel$export(module.exports, "getAvatars", () => $3864ac0259cf878b$export$d7a0d0325afdce8d);
$parcel$export(module.exports, "getIsSaving", () => $3864ac0259cf878b$export$88b3f624eba99c6);
$parcel$export(module.exports, "getFetchError", () => $3864ac0259cf878b$export$4c9b7f00cee73151);

var $aZsz6 = parcelRequire("aZsz6");
const $3864ac0259cf878b$export$89040d072f281f85 = (state)=>state.appProps.projectId;
const $3864ac0259cf878b$export$22a0749f4a6b2d26 = (state)=>state.appProps.isOpen;
const $3864ac0259cf878b$export$4616025ba0db1dfa = (state)=>{
    const avatar = state.appProps.selectedAvatar;
    if (avatar) return {
        ...avatar,
        uri: (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(avatar.uri).href
    };
    return avatar;
};
const $3864ac0259cf878b$export$4cb1a74f14b1f7e7 = (state)=>state.appProps.onAvatarSelected;
const $3864ac0259cf878b$export$eb8a6013fba2b81f = (state)=>state.appProps.onDismiss;
const $3864ac0259cf878b$export$d7a0d0325afdce8d = (state)=>state.avatars;
const $3864ac0259cf878b$export$9552b8fa6cd3a4c2 = (state)=>state.isFetching;
const $3864ac0259cf878b$export$88b3f624eba99c6 = (state)=>state.isSaving;
const $3864ac0259cf878b$export$4c9b7f00cee73151 = (state)=>state.fetchError;

});


parcelRegister("1pgqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9120816c3d90c713$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $iwpO5 = parcelRequire("iwpO5");

var $bG15C = parcelRequire("bG15C");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9120816c3d90c713$export$2e2bcd8739ae039 = (action$, store, deps)=>// @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<SaveAvatarImageSuccessAction | SaveAvatarImageFailureAction>' but required in type 'ActionsObservable<Action>'.
    action$.ofType((0, $iwpO5.SAVE_AVATAR_IMAGE)).switchMap((action)=>{
        const state = store.getState();
        const projectId = (0, $bG15C.getProjectId)(state);
        const onAvatarSelected = (0, $bG15C.getOnAvatarSelected)(state);
        const { image: image, properties: properties } = action.payload;
        return (0, $kVLXA.Observable).fromPromise(deps.avatarService.save(projectId, image, properties)).map((avatar)=>{
            onAvatarSelected(avatar);
            return (0, $iwpO5.saveAvatarImageSuccess)(avatar);
        }).catch(()=>(0, $kVLXA.Observable).of((0, $iwpO5.saveAvatarImageFailure)()));
    });

});


parcelRegister("2vIDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec99ce639379a1b2$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $8SjvH = parcelRequire("8SjvH");

var $99qrY = parcelRequire("99qrY");

var $iLwXE = parcelRequire("iLwXE");

var $ki6NX = parcelRequire("ki6NX");
const $ec99ce639379a1b2$var$errorMiddleware = (0, $8SjvH.default)({
    packageName: (0, $iLwXE.PACKAGE_NAME),
    id: 'redux',
    sendToPrivacyUnsafeSplunk: true
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ec99ce639379a1b2$export$2e2bcd8739ae039 = (rootEpic, appProps)=>(0, $F2Mxm.default)({
        appName: 'project-settings/issue-type-avatar-modal',
        rootReducer: $ki6NX.default,
        rootEpic: rootEpic,
        rootEpicDependencies: {
            avatarService: $99qrY.default
        },
        initialState: {
            ...(0, $ki6NX.defaultState),
            appProps: appProps
        },
        middlewares: [
            $ec99ce639379a1b2$var$errorMiddleware
        ]
    });

});
parcelRegister("8SjvH", function(module, exports) {

$parcel$export(module.exports, "default", () => $108f3174c451b399$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * As opposed to redux-middleware, this function uses fireErrorAnalytics to make data also available in SignalFx.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 *
 * e.g. [middlewareOne, errorHandling({ packageName: 'yourPackageName', id: 'yourErrorId' })]
 */ const $108f3174c451b399$var$errorHandling = ({ attributes: attributes, errorActionCreator: errorActionCreator, id: id, onError: onError, packageName: packageName, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, teamName: teamName })=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const defaultAttributes = {
                        message: `Unhandled error for Redux action: '${action.type}'`
                    };
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: id,
                            packageName: packageName,
                            teamName: teamName
                        },
                        attributes: {
                            ...defaultAttributes,
                            ...attributes
                        },
                        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
                    });
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $108f3174c451b399$export$2e2bcd8739ae039 = $108f3174c451b399$var$errorHandling;

});

parcelRegister("99qrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f46cf2e371b55b74$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $7xX3j = parcelRequire("7xX3j");

var $3XO6n = parcelRequire("3XO6n");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $1RLjE = parcelRequire("1RLjE");

var $4cS2K = parcelRequire("4cS2K");

var $7W7NV = parcelRequire("7W7NV");
const $f46cf2e371b55b74$export$3988ae62b71be9a3 = (projectId)=>{
    const storedAvatars = (0, $7W7NV.default).get(projectId);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(storedAvatars)) return Promise.resolve(storedAvatars);
    const getAvatarsPromise = (0, $koFzm.famaCatchAndLogFetchError)((0, $7xX3j.get)(projectId), (0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('getIssueTypeAvatars'), (0, $gl0PU.toErrorMessage)('Failed to fetch issue type avatars for a project'));
    return getAvatarsPromise.then((rawAvatars)=>{
        try {
            const avatars = (0, $4cS2K.default)(rawAvatars);
            (0, $7W7NV.default).init(projectId, avatars);
            return avatars;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('processIssueTypeAvatars'), (0, $gl0PU.toErrorMessage)('Failed to normalize issue type avatars or initialize avatar storage'), error);
            throw error;
        }
    });
};
const $f46cf2e371b55b74$var$save = (projectId, image, properties)=>{
    const saveAvatarPromise = (0, $koFzm.famaCatchAndLogFetchError)((0, $7xX3j.save)(projectId, image, properties), (0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('uploadIssueTypeAvatar'), (0, $gl0PU.toErrorMessage)('Failed to upload an issue type avatar for a project'));
    return saveAvatarPromise.then((result)=>{
        try {
            const normalizedAvatar = (0, $4cS2K.normaliseSavedAvatar)(result);
            (0, $7W7NV.default).update(projectId, normalizedAvatar);
            return normalizedAvatar;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('processUploadedIssueTypeAvatar'), (0, $gl0PU.toErrorMessage)('Failed to normalize an uploaded issue type avatar or update avatar storage'), error);
            throw error;
        }
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f46cf2e371b55b74$export$2e2bcd8739ae039 = {
    get: $f46cf2e371b55b74$export$3988ae62b71be9a3,
    save: $f46cf2e371b55b74$var$save
};

});
parcelRegister("7xX3j", function(module, exports) {

$parcel$export(module.exports, "get", () => $93860938096034dd$export$3988ae62b71be9a3);
$parcel$export(module.exports, "save", () => $93860938096034dd$export$a1544dad697b423d);

var $7f4tk = parcelRequire("7f4tk");

var $eusud = parcelRequire("eusud");

var $4tcSU = parcelRequire("4tcSU");
const $93860938096034dd$export$a5b7a8c3b1c6e775 = (projectId)=>`/rest/api/2/universal_avatar/type/issuetype/owner/project:${projectId}`;
const $93860938096034dd$export$390adb1b87b11212 = (context, croppingProperties)=>`${$93860938096034dd$export$a5b7a8c3b1c6e775(context.projectId)}?atl_token=${(0, $4tcSU.default)() || ''}` + `&x=${Math.floor(croppingProperties.x)}` + `&y=${Math.floor(croppingProperties.y)}` + `&size=${Math.floor(croppingProperties.size)}`;
const $93860938096034dd$export$3988ae62b71be9a3 = (projectId)=>(0, $7f4tk.default)($93860938096034dd$export$a5b7a8c3b1c6e775(projectId));
const $93860938096034dd$export$a1544dad697b423d = (projectId, image, properties)=>{
    const url = $93860938096034dd$export$390adb1b87b11212({
        projectId: projectId
    }, properties);
    return (0, $eusud.performPostRequest)(url, {
        body: image,
        headers: {
            'Content-Type': image.type
        }
    });
};

});

parcelRegister("4cS2K", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a2a115a4d046ac6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getProjectAvatarUrl", () => $9a2a115a4d046ac6$export$65a50dd1fe88e116);
$parcel$export(module.exports, "normaliseSavedAvatar", () => $9a2a115a4d046ac6$export$b11f6166803b3fff);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9a2a115a4d046ac6$export$2e2bcd8739ae039 = (rawAvatars)=>rawAvatars.system.concat(rawAvatars.custom).map((raw)=>({
            id: Number(raw.id),
            uri: raw.urls['48x48'],
            fileName: raw.fileName
        }));
const $9a2a115a4d046ac6$export$65a50dd1fe88e116 = (avatarId)=>`/secure/viewavatar?avatarId=${avatarId}&avatarType=issuetype`;
const $9a2a115a4d046ac6$export$b11f6166803b3fff = (avatar)=>({
        id: parseInt(avatar.id, 10),
        uri: $9a2a115a4d046ac6$export$65a50dd1fe88e116(parseInt(avatar.id, 10)),
        fileName: avatar.fileName
    });

});

parcelRegister("7W7NV", function(module, exports) {

$parcel$export(module.exports, "default", () => $67667b6b8cc6fa67$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $3XO6n = parcelRequire("3XO6n");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");
const $67667b6b8cc6fa67$var$AVATARS_ISSUE_TYPE_PREFIX = 'AVATARS_ISSUE_TYPE';
const $67667b6b8cc6fa67$var$storage = (0, $eNf8a.createSessionStorageProvider)('avatar-modal');
const $67667b6b8cc6fa67$var$buildStorageKey = (projectId)=>`${$67667b6b8cc6fa67$var$AVATARS_ISSUE_TYPE_PREFIX}_${String(projectId)}`;
const $67667b6b8cc6fa67$var$init = (projectId, avatars)=>{
    $67667b6b8cc6fa67$var$storage.set($67667b6b8cc6fa67$var$buildStorageKey(projectId), JSON.stringify(avatars));
};
const $67667b6b8cc6fa67$var$get = (projectId)=>{
    const serializedAvatars = $67667b6b8cc6fa67$var$storage.get($67667b6b8cc6fa67$var$buildStorageKey(projectId));
    if (!serializedAvatars) return [];
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return JSON.parse(serializedAvatars);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('avatarStorage'), (0, $gl0PU.toErrorMessage)('Saved issue type avatars are corrupted in session storage'), error);
        return [];
    }
};
const $67667b6b8cc6fa67$var$update = (projectId, avatar)=>{
    const avatars = $67667b6b8cc6fa67$var$get(projectId);
    if (!avatars) $67667b6b8cc6fa67$var$init(projectId, [
        avatar
    ]);
    else $67667b6b8cc6fa67$var$storage.set($67667b6b8cc6fa67$var$buildStorageKey(projectId), JSON.stringify([
        ...avatars,
        avatar
    ]));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67667b6b8cc6fa67$export$2e2bcd8739ae039 = {
    init: $67667b6b8cc6fa67$var$init,
    get: $67667b6b8cc6fa67$var$get,
    update: $67667b6b8cc6fa67$var$update
};

});


parcelRegister("ki6NX", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $74ce55d0a9eefc78$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $74ce55d0a9eefc78$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $iwpO5 = parcelRequire("iwpO5");
const $74ce55d0a9eefc78$export$49d5fc8cba920a0 = {
    appProps: {
        projectId: 0,
        isOpen: false,
        selectedAvatar: undefined,
        onAvatarSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    isFetching: false,
    isSaving: false,
    fetchError: false,
    avatars: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74ce55d0a9eefc78$export$2e2bcd8739ae039 = (state = $74ce55d0a9eefc78$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $iwpO5.INITIALIZE_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $iwpO5.FETCH_AVATARS:
            return {
                ...state,
                isFetching: true,
                fetchError: false,
                avatars: $74ce55d0a9eefc78$export$49d5fc8cba920a0.avatars
            };
        case 0, $iwpO5.FETCH_AVATARS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                fetchError: false,
                avatars: action.payload
            };
        case 0, $iwpO5.FETCH_AVATARS_FAILURE:
            return {
                ...state,
                isFetching: false,
                fetchError: true
            };
        case 0, $iwpO5.SAVE_AVATAR_IMAGE:
            return {
                ...state,
                isSaving: true
            };
        case 0, $iwpO5.SAVE_AVATAR_IMAGE_SUCCESS:
            return {
                ...state,
                isSaving: false,
                avatars: [
                    ...state.avatars,
                    action.payload.avatar
                ]
            };
        case 0, $iwpO5.SAVE_AVATAR_IMAGE_FAILURE:
            return {
                ...state,
                isSaving: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("6fqr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef42c5d55c2d234$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $bC2fB = parcelRequire("bC2fB");

var $iwpO5 = parcelRequire("iwpO5");

var $bG15C = parcelRequire("bG15C");

var $2b0eQ = parcelRequire("2b0eQ");
const $6ef42c5d55c2d234$var$getSelectedAvatarSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((0, $bG15C.getSelectedAvatar), (res)=>res);
const $6ef42c5d55c2d234$var$mapStateToPropsFactory = ()=>{
    const getSelectedAvatarSelectorInstance = $6ef42c5d55c2d234$var$getSelectedAvatarSelectorMemoized();
    return (state)=>({
            onAvatarSelected: (0, $bG15C.getOnAvatarSelected)(state),
            onDismiss: (0, $bG15C.getOnDismiss)(state),
            avatars: (0, $bG15C.getAvatars)(state),
            selectedAvatar: getSelectedAvatarSelectorInstance(state),
            isOpen: (0, $bG15C.getIsOpen)(state),
            isSaving: (0, $bG15C.getIsSaving)(state),
            fetchError: (0, $bG15C.getFetchError)(state)
        });
};
const $6ef42c5d55c2d234$var$mapDispatchToProps = {
    onSaveImage: (0, $iwpO5.saveAvatarImage),
    onShowFetchAvatarsErrorFlag: (0, $iwpO5.showFetchAvatarsErrorFlag)
};
const $6ef42c5d55c2d234$var$Connected = (0, $bC2fB.connect)($6ef42c5d55c2d234$var$mapStateToPropsFactory, $6ef42c5d55c2d234$var$mapDispatchToProps)((0, $2b0eQ.AvatarModal));
var $6ef42c5d55c2d234$export$2e2bcd8739ae039 = $6ef42c5d55c2d234$var$Connected;

});
parcelRegister("2b0eQ", function(module, exports) {

$parcel$export(module.exports, "AvatarModal", () => $09fe42707e8572ee$export$1a3213ef0157af9e);

var $5uXOq = parcelRequire("5uXOq");

var $5PyON = parcelRequire("5PyON");

var $01Rn4 = parcelRequire("01Rn4");

var $koVbs = parcelRequire("koVbs");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");

var $iLwXE = parcelRequire("iLwXE");

var $eHxL6 = parcelRequire("eHxL6");

var $cnyuV = parcelRequire("cnyuV");
const $09fe42707e8572ee$export$1a3213ef0157af9e = (props)=>{
    const getAvatarForSelectedAvatar = (selectedAvatar)=>props.avatars.find((avatar)=>selectedAvatar && selectedAvatar.dataURI === avatar.uri);
    const onAvatarPicked = (avatar)=>{
        const newAvatar = getAvatarForSelectedAvatar(avatar);
        if (newAvatar === null || newAvatar === undefined) // This is a bug between the integration of Media Avatar Picker Dialog and the Project Details Avatar
        (0, $1RLjE.logError)((0, $iLwXE.PACKAGE_NAME), (0, $gl0PU.toErrorId)('pickAvatar'), (0, $gl0PU.toErrorMessage)('Attempted to save a predefined avatar but could not find it'));
        else props.onAvatarSelected(newAvatar);
    };
    const { selectedAvatar: selectedAvatar, avatars: avatars, onSaveImage: onSaveImage, isSaving: isSaving, isOpen: isOpen, onDismiss: onDismiss, fetchError: fetchError, onShowFetchAvatarsErrorFlag: onShowFetchAvatarsErrorFlag } = props;
    const intl = (0, $koVbs.default)();
    const { formatMessage: formatMessage } = intl;
    if (!isOpen) return null;
    let mediaPickerAvatars = [];
    if (avatars) mediaPickerAvatars = avatars.map((avatar)=>({
            dataURI: avatar.uri,
            name: (0, $eHxL6.getAccessibleAvatarName)(avatar)(intl)
        }));
    const selectedMediaPickerAvatar = mediaPickerAvatars.find((avatar)=>selectedAvatar && selectedAvatar.uri === avatar.dataURI);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5PyON.default), {
        title: formatMessage((0, $cnyuV.default).modalTitle),
        primaryButtonText: formatMessage((0, $cnyuV.default).selectAvatar),
        predefinedAvatarsText: formatMessage((0, $cnyuV.default).defaultListTitle),
        defaultSelectedAvatar: selectedMediaPickerAvatar,
        avatars: mediaPickerAvatars,
        onCancel: onDismiss,
        onImagePicked: onSaveImage,
        onAvatarPicked: onAvatarPicked,
        isLoading: isSaving
    }), fetchError === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: onShowFetchAvatarsErrorFlag
    }));
};

});
parcelRegister("5PyON", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed57d39cb94df9e1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hPQcr = parcelRequire("hPQcr");

const $ed57d39cb94df9e1$var$AvatarPickerDialogErrorBoundary = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("kRd9o")));
function $ed57d39cb94df9e1$export$2e2bcd8739ae039(props) {
    const SuspenseFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: props.placeholder || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hPQcr.CustomSpinner), {})
        }), [
        props.placeholder
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)(SuspenseFallback, {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($ed57d39cb94df9e1$var$AvatarPickerDialogErrorBoundary, {
            ...props
        })
    });
}

});
parcelRegister("hPQcr", function(module, exports) {

$parcel$export(module.exports, "CustomSpinner", () => $e0d81fb21c43c9e9$export$93fefdb47d45b5cd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2XI9f = parcelRequire("2XI9f");
const $e0d81fb21c43c9e9$export$93fefdb47d45b5cd = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2XI9f.default), {
        blankedColor: `${"var(--ds-blanket, rgba(255, 255, 255, 0.53))"}`,
        invertSpinnerColor: false
    });
};

});
parcelRegister("2XI9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f5f68a4750c9801$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eSLIv = parcelRequire("eSLIv");

var $fPycj = parcelRequire("fPycj");

var $VSDnB = parcelRequire("VSDnB");
const $1f5f68a4750c9801$var$ModalSpinner = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPycj.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eSLIv.default), {
        ...props
    });
var $1f5f68a4750c9801$export$2e2bcd8739ae039 = $1f5f68a4750c9801$var$ModalSpinner;

});
parcelRegister("eSLIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b357977404ea7fb7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $k5uoT = parcelRequire("k5uoT");

var $eZJjh = parcelRequire("eZJjh");

var $bWGt6 = parcelRequire("bWGt6");
function $b357977404ea7fb7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b357977404ea7fb7$var$overlayZindex = (0, $k5uoT.layers).modal() + 10;
const $b357977404ea7fb7$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $b357977404ea7fb7$var$overlayZindex
});
$b357977404ea7fb7$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $b357977404ea7fb7$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$b357977404ea7fb7$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $b357977404ea7fb7$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $b357977404ea7fb7$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b357977404ea7fb7$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $b357977404ea7fb7$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($b357977404ea7fb7$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: "large",
                appearance: invertSpinnerColor || $b357977404ea7fb7$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("fPycj", function(module, exports) {

$parcel$export(module.exports, "default", () => $be399455922a702c$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $be399455922a702c$var$blanketStyles = null;
const $be399455922a702c$var$spinnerStyles = null;
const $be399455922a702c$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $be399455922a702c$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $be399455922a702c$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: "large",
                appearance: invertSpinnerColor || $be399455922a702c$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("kRd9o", function(module, exports) {

let $f2f2f55153eb85b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f2f2f55153eb85b5$var$load("cM9em"),
    $f2f2f55153eb85b5$var$load("fr9NE"),
    $f2f2f55153eb85b5$var$load("h2MrD"),
    $f2f2f55153eb85b5$var$load("bYT2S"),
    $f2f2f55153eb85b5$var$load("hPzOn"),
    $f2f2f55153eb85b5$var$load("lTdBU")
]).then(()=>parcelRequire('jyHO8'));

});


parcelRegister("eHxL6", function(module, exports) {

$parcel$export(module.exports, "getAccessibleAvatarName", () => $c9500a50e8c9502d$export$b7a0be78db7aa598);

var $gDRYC = parcelRequire("gDRYC");
/**
 * This isn't the greatest of maps. It doesn't guarantee to actually describe all the avatars.
 * It's just the best effort to describe some of the default system avatars.
 * Trouble is that our backend doesn't return any names or alts or anything; all we have are filenames which mostly don't make much sense.
 *
 * See https://hello.atlassian.net/wiki/spaces/~hbegg/pages/1898366234/Updating+Jira+s+project+icons+to+make+them+more+accessible
 *
 * @returns MessageDescriptor if there's an appropriate one; null if the filename is not recognized. If null then use some generic fallback.
 */ const $c9500a50e8c9502d$var$filenameToMessageDescriptor = (filename)=>{
    switch(filename){
        // First known issue type avatars
        case 'development_task.svg':
            return (0, $gDRYC.messages).developmentTask;
        case 'feedback.svg':
            return (0, $gDRYC.messages).feedback;
        case 'request_access.svg':
            return (0, $gDRYC.messages).requestAccess;
        case 'genericissue.svg':
            return (0, $gDRYC.messages).genericIssue;
        case 'bug.svg':
            return (0, $gDRYC.messages).bug;
        case 'defect.svg':
            return (0, $gDRYC.messages).defect;
        case 'documentation.svg':
            return (0, $gDRYC.messages).documentation;
        case 'epic.svg':
            return (0, $gDRYC.messages).epic;
        case 'exclamation.svg':
            return (0, $gDRYC.messages).exclamation;
        case 'design_task.svg':
            return (0, $gDRYC.messages).designTask;
        case 'improvement.svg':
            return (0, $gDRYC.messages).improvement;
        case 'newfeature.svg':
            return (0, $gDRYC.messages).newFeature;
        case 'remove_feature.svg':
            return (0, $gDRYC.messages).removeFeature;
        case 'requirement.svg':
            return (0, $gDRYC.messages).requirement;
        case 'sales.svg':
            return (0, $gDRYC.messages).sales;
        case 'story.svg':
            return (0, $gDRYC.messages).story;
        case 'subtask.svg':
            return (0, $gDRYC.messages).subtask;
        case 'task.svg':
            return (0, $gDRYC.messages).task;
        case 'question.svg':
            return (0, $gDRYC.messages).question;
        case 'incident.svg':
            return (0, $gDRYC.messages).incident;
        case 'notes.svg':
            return (0, $gDRYC.messages).notes;
        case 'envelope.svg':
            return (0, $gDRYC.messages).envelope;
        case 'issue-type_person.svg':
            return (0, $gDRYC.messages).issueTypePerson;
        case 'issue-type_document.svg':
            return (0, $gDRYC.messages).issueTypeDocument;
        case 'issue-type_order.svg':
            return (0, $gDRYC.messages).issueTypeOrder;
        case 'issue-type_property.svg':
            return (0, $gDRYC.messages).issueTypeProperty;
        case 'issue-type_lead.svg':
            return (0, $gDRYC.messages).issueTypeLead;
        case 'issue-type_claim.svg':
            return (0, $gDRYC.messages).issueTypeClaim;
        // Now project avatars
        case 'project_avatar_alien.svg':
            return (0, $gDRYC.messages).projectAvatarAlien;
        case 'project_avatar_parrot.svg':
            return (0, $gDRYC.messages).projectAvatarParrot;
        case 'project_avatar_cloud.svg':
            return (0, $gDRYC.messages).projectAvatarCloud;
        case 'project_avatar_disc.svg':
            return (0, $gDRYC.messages).projectAvatarDisc;
        case 'project_avatar_code.svg':
            return (0, $gDRYC.messages).projectAvatarCode;
        case 'project_avatar_coffee.svg':
            return (0, $gDRYC.messages).projectAvatarCoffee;
        case 'project_avatar_design.svg':
            return (0, $gDRYC.messages).projectAvatarDesign;
        case 'project_avatar_drill.svg':
            return (0, $gDRYC.messages).projectAvatarDrill;
        case 'project_avatar_food.svg':
            return (0, $gDRYC.messages).projectAvatarFood;
        case 'project_avatar_koala.svg':
            return (0, $gDRYC.messages).projectAvatarKoala;
        case 'project_avatar_mobile.svg':
            return (0, $gDRYC.messages).projectAvatarMobile;
        case 'project_avatar_money.svg':
            return (0, $gDRYC.messages).projectAvatarMoney;
        case 'project_avatar_website.svg':
            return (0, $gDRYC.messages).projectAvatarWebsite;
        case 'project_avatar_nature.svg':
            return (0, $gDRYC.messages).projectAvatarNature;
        case 'project_avatar_notes.svg':
            return (0, $gDRYC.messages).projectAvatarNotes;
        case 'project_avatar_plane.svg':
            return (0, $gDRYC.messages).projectAvatarPlane;
        case 'project_avatar_power.svg':
            return (0, $gDRYC.messages).projectAvatarPower;
        case 'project_avatar_flag.svg':
            return (0, $gDRYC.messages).projectAvatarFlag;
        case 'project_avatar_refresh.svg':
            return (0, $gDRYC.messages).projectAvatarRefresh;
        case 'project_avatar_rocket.svg':
            return (0, $gDRYC.messages).projectAvatarRocket;
        case 'project_avatar_science.svg':
            return (0, $gDRYC.messages).projectAvatarScience;
        case 'project_avatar_settings.svg':
            return (0, $gDRYC.messages).projectAvatarSettings;
        case 'project_avatar_spanner.svg':
            return (0, $gDRYC.messages).projectAvatarSpanner;
        case 'project_avatar_storm.svg':
            return (0, $gDRYC.messages).projectAvatarStorm;
        case 'project_avatar_support.svg':
            return (0, $gDRYC.messages).projectAvatarSupport;
        case 'project_avatar_yeti.svg':
            return (0, $gDRYC.messages).projectAvatarYeti;
        default:
            return null;
    }
};
const $c9500a50e8c9502d$export$b7a0be78db7aa598 = (avatar)=>{
    // avatars without filename have alt based on ID
    if (avatar.fileName) {
        const messageDescriptor = $c9500a50e8c9502d$var$filenameToMessageDescriptor(avatar.fileName);
        if (messageDescriptor) return (intl)=>intl.formatMessage(messageDescriptor);
    }
    // Custom avatars have no alt because customers do not provide any when uploading images
    return ()=>'';
};

});
parcelRegister("gDRYC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ba71fbcf79a3a6ec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ba71fbcf79a3a6ec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    developmentTask: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.development-task",
        "defaultMessage": "Angled brackets"
    },
    feedback: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.feedback",
        "defaultMessage": "Light bulb"
    },
    requestAccess: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.request-access",
        "defaultMessage": "Lock"
    },
    genericIssue: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.generic-issue",
        "defaultMessage": "Ring"
    },
    bug: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.bug",
        "defaultMessage": "Dot"
    },
    defect: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.defect",
        "defaultMessage": "Graph"
    },
    documentation: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.documentation",
        "defaultMessage": "Document"
    },
    epic: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.epic",
        "defaultMessage": "Bolt"
    },
    exclamation: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.exclamation",
        "defaultMessage": "Exclamation mark"
    },
    designTask: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.design-task",
        "defaultMessage": "Heart"
    },
    improvement: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.improvement",
        "defaultMessage": "Up arrow"
    },
    newFeature: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.new-feature",
        "defaultMessage": "Plus sign"
    },
    removeFeature: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.remove-feature",
        "defaultMessage": "Minus sign"
    },
    requirement: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.requirement",
        "defaultMessage": "Tick"
    },
    sales: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.sales",
        "defaultMessage": "Dollar sign"
    },
    story: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.story",
        "defaultMessage": "Bookmark"
    },
    subtask: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.subtask",
        "defaultMessage": "Squares"
    },
    task: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.task",
        "defaultMessage": "Checkmark"
    },
    question: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.question",
        "defaultMessage": "Question mark"
    },
    incident: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.incident",
        "defaultMessage": "Filled triangle with a circle between"
    },
    notes: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.notes",
        "defaultMessage": "Notebook with pencil"
    },
    envelope: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.envelope",
        "defaultMessage": "Envelope"
    },
    issueTypePerson: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-person",
        "defaultMessage": "Person"
    },
    issueTypeDocument: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-document",
        "defaultMessage": "Page with earmark"
    },
    issueTypeOrder: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-order",
        "defaultMessage": "Dollar sign"
    },
    issueTypeProperty: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-property",
        "defaultMessage": "Diamond"
    },
    issueTypeLead: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-lead",
        "defaultMessage": "Plus sign"
    },
    issueTypeClaim: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-claim",
        "defaultMessage": "Plus sign with shield"
    },
    projectAvatarAlien: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-alien",
        "defaultMessage": "One-eyed alien in spaceship"
    },
    projectAvatarParrot: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-parrot",
        "defaultMessage": "Smiling bird with yellow beak"
    },
    projectAvatarCloud: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-cloud",
        "defaultMessage": "Happy cloud"
    },
    projectAvatarDisc: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-disc",
        "defaultMessage": "Vinyl record"
    },
    projectAvatarCode: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-code",
        "defaultMessage": "Computer browser"
    },
    projectAvatarCoffee: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-coffee",
        "defaultMessage": "Coffee cup"
    },
    projectAvatarDesign: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-design",
        "defaultMessage": "Painting of landscape resting on easel"
    },
    projectAvatarDrill: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-drill",
        "defaultMessage": "Yellow electric drill"
    },
    projectAvatarFood: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-food",
        "defaultMessage": "Hot dog with mustard"
    },
    projectAvatarKoala: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-koala",
        "defaultMessage": "Smiling koala eating leaf"
    },
    projectAvatarMobile: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-mobile",
        "defaultMessage": "Smartphone with smiley face"
    },
    projectAvatarMoney: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-money",
        "defaultMessage": "Wallet with money sticking out"
    },
    projectAvatarWebsite: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-website",
        "defaultMessage": "Computer browser with cursor in centre"
    },
    projectAvatarNature: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-nature",
        "defaultMessage": "Snow-capped mountains with sun behind"
    },
    projectAvatarNotes: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-notes",
        "defaultMessage": "Notebook with pencil"
    },
    projectAvatarPlane: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-plane",
        "defaultMessage": "Airplane flying skyward"
    },
    projectAvatarPower: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-power",
        "defaultMessage": "Purple and orange battery with plus symbol"
    },
    projectAvatarFlag: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-flag",
        "defaultMessage": "Red flag on pole"
    },
    projectAvatarRefresh: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-refresh",
        "defaultMessage": "Two circular arrows representing refresh icon"
    },
    projectAvatarRocket: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-rocket",
        "defaultMessage": "Rocket flying through space"
    },
    projectAvatarScience: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-science",
        "defaultMessage": "Science bottle full of bubbling red liquid"
    },
    projectAvatarSettings: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-settings",
        "defaultMessage": "Settings control panel with vertical sliders"
    },
    projectAvatarSpanner: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-spanner",
        "defaultMessage": "Silver wrench"
    },
    projectAvatarStorm: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-storm",
        "defaultMessage": "Storm cloud with rain and lightning"
    },
    projectAvatarSupport: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-support",
        "defaultMessage": "Red and white life buoy on blue background"
    },
    projectAvatarYeti: {
        "id": "project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-yeti",
        "defaultMessage": "Frowning abominable snowman"
    }
});

});


parcelRegister("cnyuV", function(module, exports) {

$parcel$export(module.exports, "default", () => $031b5f71c6746784$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $031b5f71c6746784$var$messages = (0, $7VHMR.defineMessages)({
    modalTitle: {
        "id": "project-settings-apps.avatar-modal.modal-title",
        "defaultMessage": "Choose an icon"
    },
    selectAvatar: {
        "id": "project-settings-apps.avatar-modal.select-avatar",
        "defaultMessage": "Select"
    },
    defaultListTitle: {
        "id": "project-settings-apps.avatar-modal.default-list-title",
        "defaultMessage": "Default icons"
    }
});
var $031b5f71c6746784$export$2e2bcd8739ae039 = $031b5f71c6746784$var$messages;

});




parcelRegister("2Cxf6", function(module, exports) {

$parcel$export(module.exports, "AvatarIcon", () => $227e4365e35a104c$export$b1f22795a41806ac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");
const $227e4365e35a104c$export$b1f22795a41806ac = ({ onEdit: onEdit, messages: messages, avatarUri: avatarUri, label: label, tooltipDelay: tooltipDelay })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($227e4365e35a104c$var$EditableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(messages.avatarAccessibleAlt),
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: avatarUri,
        name: formatMessage(messages.avatarAlt),
        label: formatMessage(messages.avatarAriaLabel, {
            issueType: label
        }),
        appearance: "square",
        size: "small",
        onClick: onEdit
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $227e4365e35a104c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _19pku2gc _18u01i6y",
            __cmplp.className
        ])
    });
});
const $227e4365e35a104c$var$EditableWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $227e4365e35a104c$var$Wrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _we3n18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jkLES", function(module, exports) {

$parcel$export(module.exports, "NameInlineInput", () => $97b8c1c07bf44cb0$export$5fc7acc0d33a0401);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $cb25w = parcelRequire("cb25w");

var $bopR4 = parcelRequire("bopR4");

var $kY99m = parcelRequire("kY99m");

var $4R6GH = parcelRequire("4R6GH");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $fF59k = parcelRequire("fF59k");

var $8k5eK = parcelRequire("8k5eK");
const $97b8c1c07bf44cb0$var$CY_KEY = 'data-test-cypress';
const $97b8c1c07bf44cb0$var$CY_ISSUE_TYPE_NAME = 'project-settings-apps.issue-type-page.main-header.name-inline-input';
const $97b8c1c07bf44cb0$var$CY_ISSUE_TYPE_NAME_PROPS = {
    [$97b8c1c07bf44cb0$var$CY_KEY]: $97b8c1c07bf44cb0$var$CY_ISSUE_TYPE_NAME
};
const $97b8c1c07bf44cb0$export$5fc7acc0d33a0401 = (props)=>{
    const { canBeEdited: canBeEdited, onChange: onChange, value: value, issueTypeResetCount: issueTypeResetCount, issueTypeId: issueTypeId, projectId: projectId, validationMessages: validationMessages = {}, onValidateIssueTypeName: onValidateIssueTypeName = (0, $8k5eK.validateIssueTypeName), existingNames: existingNames = null, messages: messages } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [issueTypesPromise, setIssueTypesPromise] = (0, $5uXOq.useState)(null);
    const getAllIssueTypes = ()=>{
        if (!issueTypesPromise) {
            const newPromise = (0, $fF59k.fetchIssueTypeNames)(projectId).catch(()=>{
                // we shouldn't keep failed promise
                setIssueTypesPromise(null);
                return [];
            });
            setIssueTypesPromise(newPromise);
            return newPromise;
        }
        return issueTypesPromise;
    };
    (0, $5uXOq.useEffect)(()=>{
        // we should re-load issue type names when user switches to another project
        setIssueTypesPromise(null);
    }, [
        projectId
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const validateAndFormatMessage = async (newValue)=>{
        let existingIssueTypeNames = existingNames;
        if (!existingIssueTypeNames) {
            const issueTypes = await getAllIssueTypes();
            existingIssueTypeNames = issueTypes.filter(({ id: id })=>id !== issueTypeId).map(({ name: name })=>name);
        }
        const errors = onValidateIssueTypeName(newValue, existingIssueTypeNames, validationMessages);
        if (errors.length > 0) return formatMessage(errors[0].messageDescriptor, errors[0].values);
        return '';
    };
    const sendAnalytics = (event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'textField clicked', 'issueLayoutTitle');
    };
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97b8c1c07bf44cb0$var$ReadWrapper, null, value), [
        value
    ]);
    const renderEditView = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'errorMessage' implicitly has an 'any' type.
    ({ errorMessage: errorMessage, ...fieldProps })=>{
        const editNameInputLabelMessage = messages.editNameInputLabel;
        const editInputLabel = (0, $4R6GH.fg)('jsm_rtc_document_title_a11y') ? editNameInputLabelMessage && formatMessage(editNameInputLabelMessage) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            content: errorMessage,
            isOpen: fieldProps.isInvalid,
            placement: "right",
            messageId: "project-settings-apps-issue-type-page-product-features.common.ui.name-inline-input.inline-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97b8c1c07bf44cb0$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            ...fieldProps,
            "aria-label": editInputLabel,
            autoFocus: true
        })));
    }, [
        messages.editNameInputLabel,
        formatMessage
    ]);
    const editButtonLabel = value ? `${value} - ${formatMessage(messages.editNameButtonLabel)}` : formatMessage(messages.editNameButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97b8c1c07bf44cb0$var$IssueTypeHeaderAlignmentWrapperWithAnalytics, {
        onClick: sendAnalytics,
        ...$97b8c1c07bf44cb0$var$CY_ISSUE_TYPE_NAME_PROPS
    }, canBeEdited ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        key: issueTypeResetCount,
        readView: renderReadView,
        // @ts-expect-error - TS2322 - Type '({ errorMessage, ...fieldProps }: { [x: string]: any; errorMessage: any; }) => Element' is not assignable to type '(fieldProps: ExtendedFieldProps<string>, ref: RefObject<any>) => ReactNode'.
        editView: renderEditView,
        editButtonLabel: editButtonLabel,
        defaultValue: value,
        onConfirm: onChange,
        readViewFitContainerWidth: true,
        validate: validateAndFormatMessage
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97b8c1c07bf44cb0$export$f202aa44f50dc35, null, value));
};
// This is a magic number that is calculated based on:
// - 300px (default navigation sidebar width)
// - 360px - fields sidebar width
// - 592px min content width from the spec - https://hello.atlassian.net/wiki/spaces/JPLAT/pages/509111195/Field+Responsiveness
// using this media query is not perfect (because navigation sidebar can have custom width or they may be extra
// help sidebar on the right side), but it should work well in most cases and it also allows us to avoid
// using JS to check current width of content area
const $97b8c1c07bf44cb0$var$getMaxWidth = ()=>1252;
// Override the default AK Textfield theme to ensure typography styles match the parent. We also make minor
// adjustments to the input spacing to match design specs. https://hello.atlassian.net/wiki/spaces/JPLAT/pages/190076898/Issue+types+spec+-+Edit+issue+type
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97b8c1c07bf44cb0$var$TextFieldWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-19rdww-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'input[data-ds--text-field--input]': {
        font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        margin: `${"var(--ds-space-negative-025, -2px)"} 0`
    }
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97b8c1c07bf44cb0$var$IssueTypeHeaderAlignmentWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-19rdww-1"
})({
    /* Inline edit has a fixed margin top of 8px that we need to override */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        marginTop: 0
    }
});
// This wrapper is here to avoid content jumps upon triggering inline-edit
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97b8c1c07bf44cb0$var$ReadWrapper = /*#__PURE__*/ (0, $47bDC.default).h1.withConfig({
    componentId: "sc-19rdww-2"
})`font:${"var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};overflow-wrap:break-word;margin-top:0;padding:${"var(--ds-space-075, 6px)"};@media screen and (max-width:${$97b8c1c07bf44cb0$var$getMaxWidth()}px){text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}`;
const $97b8c1c07bf44cb0$export$f202aa44f50dc35 = /*#__PURE__*/ (0, $47bDC.default)($97b8c1c07bf44cb0$var$ReadWrapper).withConfig({
    componentId: "sc-19rdww-3"
})({
    /* Add padding to the non-editable wrapper matching the padding of the inline edit component to make sure they're aligned. */ padding: "var(--ds-space-100, 8px)"
});
const $97b8c1c07bf44cb0$var$IssueTypeHeaderAlignmentWrapperWithAnalytics = (0, $cb25w.default)({
    onClick: {
        action: 'clicked'
    }
})($97b8c1c07bf44cb0$var$IssueTypeHeaderAlignmentWrapper);

});
parcelRegister("fF59k", function(module, exports) {

$parcel$export(module.exports, "fetchIssueTypeNames", () => $439343c77acb3aed$export$7263e1c0c262ca17);

var $92ECu = parcelRequire("92ECu");

var $iBOrg = parcelRequire("iBOrg");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $g5X3G = parcelRequire("g5X3G");

var $6wesA = parcelRequire("6wesA");
const $439343c77acb3aed$var$issueTypeNamesQuery = (0, $92ECu.gqlTagGira)`
query IssueTypeNames($projectId: Long!) {
  simplifiedProject(projectId: $projectId) {
    issueTypes {
      id
      name
    }
  }
}
`;
const $439343c77acb3aed$export$7263e1c0c262ca17 = (projectId)=>{
    const client = (0, $iBOrg.getClient)((0, $g5X3G.toBaseUrl)('')); // in cloud, baseUrl is always empty string
    return (0, $koFzm.famaCatchAndLogFetchError)(client.query({
        query: $439343c77acb3aed$var$issueTypeNamesQuery,
        variables: {
            projectId: projectId
        }
    }), (0, $6wesA.PACKAGE_NAME), (0, $gl0PU.toErrorId)('fetchEverything'), (0, $gl0PU.toErrorMessage)('Failed to fetch data for every issue type on the issue type page')).then(({ data: data })=>{
        if (!data || !data.simplifiedProject || !data.simplifiedProject.issueTypes) throw new Error('Failed to fetch issue type names');
        return data.simplifiedProject.issueTypes.filter(Boolean);
    });
};

});



parcelRegister("dVb03", function(module, exports) {

$parcel$export(module.exports, "ConfigButton", () => $9de93a56a754a1e4$export$2a11314f6699854b);

var $5uXOq = parcelRequire("5uXOq");

var $fqbGj = parcelRequire("fqbGj");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $a8hd9 = parcelRequire("a8hd9");

var $lu848 = parcelRequire("lu848");

var $dD7Zc = parcelRequire("dD7Zc");

var $f5TWP = parcelRequire("f5TWP");

var $3bDjY = parcelRequire("3bDjY");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $5QsHM = parcelRequire("5QsHM");

var $ajlSd = parcelRequire("ajlSd");

var $hjSul = parcelRequire("hjSul");


var $6cNFG = parcelRequire("6cNFG");

var $17PZH = parcelRequire("17PZH");

var $4nsum = parcelRequire("4nsum");

var $8vxsE = parcelRequire("8vxsE");
const $9de93a56a754a1e4$var$RedLockFilledIcon = (props)=>{
    const { label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a8hd9))), {
        color: "var(--ds-icon-accent-red, #C9372C)",
        LEGACY_size: "medium",
        label: label,
        testId: "servicedesk-request-type-security.ui.config-button.lock-icon"
    });
};
const $9de93a56a754a1e4$var$UnlockIcon = (props)=>{
    const { label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lu848))), {
        color: "var(--ds-text, #172B4D)",
        LEGACY_size: "medium",
        label: label,
        testId: "servicedesk-request-type-security.ui.config-button.unlock-icon"
    });
};
const $9de93a56a754a1e4$var$RedErrorIcon = (props)=>{
    const { label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_size: "small",
        label: label,
        testId: "servicedesk-request-type-security.ui.config-button.error-icon"
    });
};
const $9de93a56a754a1e4$var$ConfigButtonBase = ({ projectId: projectId, projectKey: projectKey, requestType: requestType, appearance: appearance, skipOnboarding: skipOnboarding, features: features, showText: showText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isConfigModalOpen, setIsConfigModalOpen] = (0, $5uXOq.useState)(false);
    const [restrictionStatus, setRestrictionStatus] = (0, $5uXOq.useState)(requestType.restrictionStatus);
    const [issueSecurityStatus, setIssueSecurityStatus] = (0, $5uXOq.useState)(requestType.issueSecurityStatus);
    const [{ isSeen: hasSeenOldOnboarding }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: (0, $63ddb234502a404c$export$fec73f364bbbf0e),
        isSeenValue: true,
        packageName: $63ddb234502a404c$export$9345d7360ffe0722,
        teamName: $63ddb234502a404c$export$9f98a8d796affec6,
        skipOnboarding: skipOnboarding
    });
    const [{ isSeen: hasSeenOnboarding }, { markAsSeen: markOnboardingAsSeen }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: (0, $63ddb234502a404c$export$54d48d4a689f727e),
        isSeenValue: true,
        packageName: $63ddb234502a404c$export$9345d7360ffe0722,
        teamName: $63ddb234502a404c$export$9f98a8d796affec6,
        skipOnboarding: skipOnboarding
    });
    const [{ isSeen: hasSeenIssueSecurityChangeboarding }, { markAsSeen: markIssueSecurityChangeboardingAsSeen }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: (0, $63ddb234502a404c$export$d9e71669643d0e1e),
        isSeenValue: true,
        packageName: $63ddb234502a404c$export$9345d7360ffe0722,
        teamName: $63ddb234502a404c$export$9f98a8d796affec6,
        skipOnboarding: skipOnboarding
    });
    const issueSecurityChangeboardingActive = !hasSeenIssueSecurityChangeboarding && requestType.issueSecurityStatus !== 'INACTIVE';
    const [defaultFeature, setDefaultFeature] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (!hasSeenOnboarding && hasSeenOldOnboarding || issueSecurityChangeboardingActive) setDefaultFeature('ISSUE_SECURITY');
    }, [
        hasSeenOldOnboarding,
        hasSeenOnboarding,
        issueSecurityChangeboardingActive
    ]);
    const openConfigModal = (_, analyticsEvent)=>{
        if (!skipOnboarding) {
            if (issueSecurityChangeboardingActive) markIssueSecurityChangeboardingAsSeen();
            markOnboardingAsSeen();
        }
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'requestTypeRestriction');
        setIsConfigModalOpen(true);
    };
    const close = (0, $5uXOq.useCallback)((newRestrictionStatus, newIssueSecurityStatus)=>{
        if (newRestrictionStatus) setRestrictionStatus(newRestrictionStatus);
        if (newIssueSecurityStatus) {
            if (newIssueSecurityStatus === 'ACTIVE') markIssueSecurityChangeboardingAsSeen();
            setIssueSecurityStatus(newIssueSecurityStatus);
        }
        if (requestType.onSecurityStatusChange && (0, $4R6GH.fg)('granular_permissions_on_forms_m1')) requestType.onSecurityStatusChange(newRestrictionStatus, newIssueSecurityStatus);
        setIsConfigModalOpen(false);
        setDefaultFeature(undefined);
    }, [
        markIssueSecurityChangeboardingAsSeen,
        requestType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setRestrictionStatus(requestType.restrictionStatus);
    }, [
        requestType.restrictionStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setIssueSecurityStatus(requestType.issueSecurityStatus);
    }, [
        requestType.issueSecurityStatus
    ]);
    const hasNoRestrictions = restrictionStatus === 'OPEN' && issueSecurityStatus === 'INACTIVE';
    const renderNudge = ()=>{
        const headingMessage = (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage(issueSecurityChangeboardingActive ? (0, $8vxsE.default).changeboardingNudgeHeadingIssueTermRefresh : (0, $8vxsE.default).onboardingNudgeHeading) : formatMessage(issueSecurityChangeboardingActive ? (0, $8vxsE.default).changeboardingNudgeHeading : (0, $8vxsE.default).onboardingNudgeHeading);
        const contentMessageTermRefresh = issueSecurityChangeboardingActive ? (0, $8vxsE.default).changeboardingNudgeContentIssueTermRefresh : (0, $8vxsE.default).onboardingNudgeContentIssueTermRefresh;
        const contentMessage = issueSecurityChangeboardingActive ? (0, $8vxsE.default).changeboardingNudgeContent : (0, $8vxsE.default).onboardingNudgeContent;
        return (0, $ajlSd.createOnboardingSpotlight)({
            actions: [
                {
                    onClick: ()=>{
                        if (issueSecurityChangeboardingActive) markIssueSecurityChangeboardingAsSeen();
                        markOnboardingAsSeen();
                    },
                    content: formatMessage((0, $8vxsE.default).onboardingNudgeDismissButton),
                    appearance: 'subtle'
                },
                {
                    onClick: openConfigModal,
                    content: formatMessage((0, $8vxsE.default).onboardingNudgeShowMeButton),
                    appearance: 'primary'
                }
            ],
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17PZH.ConfigModalIllustration), {
                alt: headingMessage
            }),
            headingMessage: headingMessage,
            contentMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $4R6GH.fg)('itsm-issue-renaming') ? contentMessageTermRefresh : contentMessage,
                values: {
                    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, chunks),
                    link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
                            href: "https://support.atlassian.com/jira-service-management-cloud/docs/create-security-levels-for-issues",
                            target: "_blank"
                        }, chunks)
                }
            })
        });
    };
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqbGj.NudgeSpotlight), {
        hidden: hasSeenOnboarding && !issueSecurityChangeboardingActive,
        setHidden: ()=>{
        /* state handled externally */ },
        spotlightCard: renderNudge(),
        position: "bottom-end",
        showSpotlightCardOnFirstRender: false,
        nudgeTestId: "servicedesk-request-type-security.onboarding.nudge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage(hasNoRestrictions ? (0, $8vxsE.default).openTooltipV2IssueTermRefresh : (0, $8vxsE.default).restrictedTooltipV2IssueTermRefresh) : formatMessage(hasNoRestrictions ? (0, $8vxsE.default).openTooltipV2 : (0, $8vxsE.default).restrictedTooltipV2)
    }, showText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: appearance,
        onClick: openConfigModal,
        testId: "servicedesk-request-type-security.ui.config-button",
        iconBefore: hasNoRestrictions ? $9de93a56a754a1e4$var$UnlockIcon : $9de93a56a754a1e4$var$RedLockFilledIcon,
        iconAfter: (0, $6cNFG.isMisconfigured)(issueSecurityStatus) ? $9de93a56a754a1e4$var$RedErrorIcon : undefined,
        "aria-label": formatMessage(hasNoRestrictions ? (0, $8vxsE.default).openV2 : (0, $8vxsE.default).restrictedV2)
    }, formatMessage((0, $8vxsE.default).restrictions)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: appearance,
        onClick: openConfigModal,
        testId: "servicedesk-request-type-security.ui.config-button",
        icon: hasNoRestrictions ? $9de93a56a754a1e4$var$UnlockIcon : $9de93a56a754a1e4$var$RedLockFilledIcon,
        label: formatMessage(hasNoRestrictions ? (0, $8vxsE.default).openV2 : (0, $8vxsE.default).restrictedV2)
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            projectId: projectId,
            requestTypeExternalId: requestType.externalId,
            restrictionStatus: restrictionStatus,
            issueSecurityStatus: issueSecurityStatus,
            supportRequestTypePermission: features.includes('REQUEST_TYPE_PERMISSIONS'),
            supportIssueSecurity: features.includes('ISSUE_SECURITY')
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4nsum.ConfigModal), {
        isOpen: isConfigModalOpen,
        onClose: close,
        projectId: projectId,
        projectKey: projectKey,
        requestTypeExternalId: requestType.externalId,
        isEmailRequestType: requestType.usedByEmailSettings,
        features: features,
        defaultFeature: defaultFeature
    }), button);
};
const $9de93a56a754a1e4$export$2a11314f6699854b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "configButton",
        packageName: (0, $63ddb234502a404c$export$9345d7360ffe0722),
        teamName: (0, $63ddb234502a404c$export$9f98a8d796affec6),
        sendToPrivacyUnsafeSplunk: true,
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9de93a56a754a1e4$var$ConfigButtonBase, props));

});
const $63ddb234502a404c$export$9345d7360ffe0722 = 'jiraServicedeskRequestTypeSecurity';
const $63ddb234502a404c$export$9f98a8d796affec6 = 'jsm-request-intake';
const $63ddb234502a404c$export$fec73f364bbbf0e = 'request-type-security-onboarding-seen-status';
const $63ddb234502a404c$export$54d48d4a689f727e = 'request-type-security-onboarding-v2-seen-status';
const $63ddb234502a404c$export$d9e71669643d0e1e = 'request-type-issue-security-changeboarding-seen-status';

parcelRegister("6cNFG", function(module, exports) {

$parcel$export(module.exports, "isDefaultNotAllowed", () => $58b5f694fc3e2188$export$c47ed26c3141be7);
$parcel$export(module.exports, "isMisconfigured", () => $58b5f694fc3e2188$export$404a908c1503e077);
$parcel$export(module.exports, "isMisconfiguredMissingLevel", () => $58b5f694fc3e2188$export$6d22cae281419382);
$parcel$export(module.exports, "isMissingValueForRequiredField", () => $58b5f694fc3e2188$export$f02b85140a4cc18e);
$parcel$export(module.exports, "isMissingValueForSelectOption", () => $58b5f694fc3e2188$export$4256838a58ab5a3f);
const $58b5f694fc3e2188$export$c47ed26c3141be7 = ({ isRequired: isRequired, defaultSecurityLevelId: defaultSecurityLevelId })=>isRequired || !defaultSecurityLevelId;
const $58b5f694fc3e2188$export$404a908c1503e077 = (issueSecurityStatus)=>issueSecurityStatus === 'MISCONFIGURED_REQUIRED_FIELD' || issueSecurityStatus === 'MISCONFIGURED_MISSING_LEVEL';
const $58b5f694fc3e2188$export$6d22cae281419382 = ({ selectedSecurityLevelId: selectedSecurityLevelId, securityLevels: securityLevels })=>!!selectedSecurityLevelId && !securityLevels.some(({ id: id })=>id === selectedSecurityLevelId);
const $58b5f694fc3e2188$export$f02b85140a4cc18e = ({ isRequired: isRequired, selectedSecurityLevelId: selectedSecurityLevelId })=>isRequired && !selectedSecurityLevelId;
const $58b5f694fc3e2188$export$4256838a58ab5a3f = ({ securityLevelOption: securityLevelOption, defaultSecurityLevelId: defaultSecurityLevelId, selectedSecurityLevelId: selectedSecurityLevelId })=>securityLevelOption === 'SELECT' && !!defaultSecurityLevelId && !selectedSecurityLevelId;

});

parcelRegister("17PZH", function(module, exports) {

$parcel$export(module.exports, "ConfigModalIllustration", () => $5a1722a3f309c640$export$9401620da939331e);

var $5uXOq = parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");

var $4CvEa = parcelRequire("4CvEa");
const $5a1722a3f309c640$export$9401620da939331e = ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4CvEa))),
        alt: alt
    });

});
parcelRegister("4CvEa", function(module, exports) {
module.exports = new URL("config-modal-illustration.34ff6920.svg", import.meta.url).toString();

});


parcelRegister("4nsum", function(module, exports) {

$parcel$export(module.exports, "ConfigModal", () => $4b21675cf9b73b07$export$f23b3af3ccf0ba37);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $dD7Zc = parcelRequire("dD7Zc");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $1DVhQ = parcelRequire("1DVhQ");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");
var $8TQB5 = parcelRequire("8TQB5");

var $fZneA = parcelRequire("fZneA");

var $pa9q9 = parcelRequire("pa9q9");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $7NYq5 = parcelRequire("7NYq5");

var $5oFIy = parcelRequire("5oFIy");

var $4R6GH = parcelRequire("4R6GH");

var $hGJN6 = parcelRequire("hGJN6");

var $6cNFG = parcelRequire("6cNFG");

var $idb8o = parcelRequire("idb8o");

var $jR1eB = parcelRequire("jR1eB");

var $cWZ9d = parcelRequire("cWZ9d");
const $4b21675cf9b73b07$export$f23b3af3ccf0ba37 = ({ isOpen: isOpen, onClose: onClose, projectId: projectId, projectKey: projectKey, requestTypeExternalId: requestTypeExternalId, isEmailRequestType: isEmailRequestType, features: features, defaultFeature: defaultFeature })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { principals: principals, prependPrincipals: prependPrincipals, removePrincipal: removePrincipal, issueSecurityState: issueSecurityState, makeIssueSecuritySelection: makeIssueSecuritySelection, configurationFetch: configurationFetch, configurationLoading: configurationLoading, configurationErrors: configurationErrors, applyConfiguration: applyConfiguration, applyConfigurationLoading: applyConfigurationLoading } = (0, $hGJN6.useCombinedRequestTypeSecurity)(projectId, requestTypeExternalId, features);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) configurationFetch();
    }, [
        configurationFetch,
        isOpen
    ]);
    const apply = async ()=>{
        const result = await applyConfiguration();
        if (result.isSuccess) {
            showFlag({
                type: 'success',
                title: formatMessage((0, $jR1eB.default).restrictionsApplySuccessTitle),
                description: formatMessage((0, $jR1eB.default).restrictionsApplySuccessDescription),
                messageId: 'servicedesk-request-type-security.ui.config-button.config-modal.show-flag.success.modal.show-flag.success',
                messageType: 'transactional'
            });
            onClose(result.newRestrictionStatus, result.newIssueSecurityStatus);
        } else if (result.errorType === 'PRINCIPAL-OVER-LIMITS') showFlag({
            type: 'error',
            title: formatMessage((0, $jR1eB.default).restrictionsApplyLimitedTitle),
            description: formatMessage((0, $jR1eB.default).restrictionsApplyLimitedDescription),
            messageId: `servicedesk-request-type-security.ui.config-button.config-modal.modal.showFlag.error.${result.errorType}`,
            messageType: 'transactional'
        });
        else if (result.errorType === 'MISCONFIGURATION') showFlag({
            type: 'error',
            title: formatMessage((0, $jR1eB.default).restrictionsApplyFailureTitle),
            description: formatMessage((0, $jR1eB.default).restrictionsApplyMisconfigurationDescription),
            messageId: `servicedesk-request-type-security.ui.config-button.config-modal.modal.showFlag.error.${result.errorType}`,
            messageType: 'transactional'
        });
        else showFlag({
            type: 'error',
            title: formatMessage((0, $jR1eB.default).restrictionsApplyFailureTitle),
            description: formatMessage((0, $jR1eB.default).restrictionsApplyFailureDescription),
            messageId: `servicedesk-request-type-security.ui.config-button.config-modal.modal.showFlag.error.${result.errorType}`,
            messageType: 'transactional'
        });
    };
    const cancel = ()=>onClose();
    const modalHeader = configurationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "50%",
        height: "25px",
        isShimmering: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jR1eB.default).title));
    const firstError = configurationErrors[0];
    const modalBody = ()=>{
        if (firstError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
            actionSubject: "requestTypeSecurityModal",
            action: "failed",
            attributes: {
                error: firstError.toString(),
                errorStack: firstError.stack,
                isClientFetchError: (0, $fZneA.isClientFetchError)(firstError)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            title: formatMessage((0, $jR1eB.default).loadErrorTitle),
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: ()=>configurationFetch(),
            appearance: "link",
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jR1eB.default).reloadButton))))));
        if (configurationLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.500"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "95%",
            height: "25px",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "95%",
            height: "25px",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "70%",
            height: "25px",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "40%",
            height: "25px",
            isShimmering: true
        }));
        const featureTabComponents = features.map((feature)=>{
            if (feature === 'REQUEST_TYPE_PERMISSIONS') return {
                title: formatMessage((0, $jR1eB.default).whoCanRaiseRequestsTabTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWZ9d.RequestTypePermissionsConfig), {
                    principals: principals,
                    prependPrincipals: prependPrincipals,
                    removePrincipal: removePrincipal,
                    isEmailRequestType: isEmailRequestType
                }),
                error: false
            };
            if (feature === 'ISSUE_SECURITY' && issueSecurityState) return {
                title: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $jR1eB.default).whoCanViewIssuesTabTitleIssueTermRefresh : (0, $jR1eB.default).whoCanViewIssuesTabTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $idb8o.IssueSecurityConfig), {
                    projectKey: projectKey,
                    issueSecurityState: issueSecurityState,
                    makeSelection: makeIssueSecuritySelection
                }),
                error: (0, $6cNFG.isMisconfigured)(issueSecurityState.issueSecurityStatus)
            };
            return null;
        }).filter(Boolean);
        let content;
        if (featureTabComponents.length === 0) throw Error('Invalid features. There must be at least 1 feature.');
        else if (featureTabComponents.length === 1) content = featureTabComponents[0].body;
        else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
            id: "request-type-security-config-modal",
            defaultSelected: defaultFeature ? features.indexOf(defaultFeature) : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, featureTabComponents.map(({ title: title, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), {
                key: title
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                space: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4b21675cf9b73b07$var$tabTextStyles
            }, title), error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }) : null)))), featureTabComponents.map(({ title: title, body: body })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TQB5.default), {
                key: `${title}-body`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4b21675cf9b73b07$var$tabPanelStyles
            }, body))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            actionSubject: "modal",
            action: "viewed",
            actionSubjectId: "requestTypeSecurity"
        }), content);
    };
    const modalFooter = configurationLoading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: cancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jR1eB.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: "primary",
        onClick: apply,
        isLoading: applyConfigurationLoading,
        isDisabled: !!firstError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jR1eB.default).applyButton)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        onClose: cancel,
        height: 570,
        messageId: "servicedesk-request-type-security.ui.config-button.config-modal.modal.config-modal-new",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, modalHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, modalBody()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, modalFooter)));
};
const $4b21675cf9b73b07$var$tabPanelStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
const $4b21675cf9b73b07$var$tabTextStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025'
});

});
parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("jxIT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a23bdf24c904bdb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $dS3PR = parcelRequire("dS3PR");

var $eQ4wW = parcelRequire("eQ4wW");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $5a23bdf24c904bdb$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eQ4wW.useTab)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                weight: "medium",
                color: "inherit",
                maxLines: 1,
                children: children
            })
        })
    });
});
var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");
const $e15f9538b451f314$var$baseStyles = null;
const $e15f9538b451f314$var$tabListStyles = null;
const $e15f9538b451f314$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});

parcelRegister("8TQB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca06f45af60382a8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $eQ4wW = parcelRequire("eQ4wW");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $ca06f45af60382a8$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $eQ4wW.useTabPanel)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            role: role,
            id: id,
            hidden: hidden,
            "aria-labelledby": ariaLabelledBy,
            tabIndex: tabIndex,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: children
            })
        })
    });
};
var $ca06f45af60382a8$export$2e2bcd8739ae039 = $ca06f45af60382a8$var$TabPanel;

});

parcelRegister("hGJN6", function(module, exports) {

$parcel$export(module.exports, "useCombinedRequestTypeSecurity", () => $31acbb56ee12017f$export$97dc626057512ed8);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $2p5FC = parcelRequire("2p5FC");

var $6cNFG = parcelRequire("6cNFG");

var $l9Gan = parcelRequire("l9Gan");

const $31acbb56ee12017f$var$PRINCIPALS_LIMIT = 50;
const $31acbb56ee12017f$export$49cd5306c50f84bd = (newRestrictionStatus, newIssueSecurityStatus)=>({
        isSuccess: true,
        newRestrictionStatus: newRestrictionStatus,
        newIssueSecurityStatus: newIssueSecurityStatus
    });
const $31acbb56ee12017f$export$c28ff3dd4e9c5af8 = (errorType, error)=>({
        isSuccess: false,
        errorType: errorType,
        error: error
    });
const $31acbb56ee12017f$export$97dc626057512ed8 = (projectId, requestTypeExternalId, features)=>{
    const supportRequestTypePermission = features.includes('REQUEST_TYPE_PERMISSIONS');
    const supportIssueSecurity = features.includes('ISSUE_SECURITY');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { principals: principals, prependPrincipals: prependPrincipals, removePrincipal: removePrincipal, requestTypePermissionLoading: requestTypePermissionLoading, requestTypePermissionError: requestTypePermissionError, requestTypePermissionFetch: requestTypePermissionFetch, applyRequestTypePermission: applyRequestTypePermission, applyRequestTypePermissionLoading: applyRequestTypePermissionLoading } = (0, $l9Gan.useRequestTypePermissions)(projectId, requestTypeExternalId);
    const { issueSecurityState: issueSecurityState, makeSelection: makeIssueSecuritySelection, issueSecurityConfigLoading: issueSecurityConfigLoading, issueSecurityConfigError: issueSecurityConfigError, issueSecurityConfigFetch: issueSecurityConfigFetch, applyIssueSecurity: applyIssueSecurity, applyIssueSecurityLoading: applyIssueSecurityLoading, showError: showError } = (0, $2p5FC.useIssueSecurity)(projectId, requestTypeExternalId);
    const configurationFetch = (0, $5uXOq.useMemo)(()=>{
        return async ()=>{
            supportRequestTypePermission && requestTypePermissionFetch();
            supportIssueSecurity && issueSecurityConfigFetch();
        };
    }, [
        issueSecurityConfigFetch,
        requestTypePermissionFetch,
        supportIssueSecurity,
        supportRequestTypePermission
    ]);
    const configurationLoading = supportRequestTypePermission && requestTypePermissionLoading || supportIssueSecurity && issueSecurityConfigLoading;
    const configurationErrors = [
        ...supportRequestTypePermission && requestTypePermissionError ? [
            requestTypePermissionError
        ] : [],
        ...supportIssueSecurity && issueSecurityConfigError ? [
            issueSecurityConfigError
        ] : []
    ];
    const fireAnalytics = (result, error)=>{
        const attributes = {
            error: error?.toString()
        };
        return result === 'succeed' ? (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'combinedRequestTypeSecurity updated', attributes) : (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'combinedRequestTypeSecurity updateFailed', attributes);
    };
    const applyConfiguration = async ()=>{
        if (supportRequestTypePermission && principals.length > $31acbb56ee12017f$var$PRINCIPALS_LIMIT) return $31acbb56ee12017f$export$c28ff3dd4e9c5af8((0, $762384ddf50fefa1$export$23c34ca691d1d6d4));
        if (supportIssueSecurity && issueSecurityState && ((0, $6cNFG.isMisconfiguredMissingLevel)(issueSecurityState) || (0, $6cNFG.isMissingValueForRequiredField)(issueSecurityState) || (0, $6cNFG.isMissingValueForSelectOption)(issueSecurityState))) {
            showError();
            return $31acbb56ee12017f$export$c28ff3dd4e9c5af8((0, $762384ddf50fefa1$export$9443c33870106e2));
        }
        try {
            const [newRestrictionStatus, newIssueSecurityStatus] = await Promise.all([
                supportRequestTypePermission ? applyRequestTypePermission() : Promise.resolve(undefined),
                supportIssueSecurity ? applyIssueSecurity() : Promise.resolve(undefined)
            ]);
            fireAnalytics('succeed');
            return $31acbb56ee12017f$export$49cd5306c50f84bd(newRestrictionStatus, newIssueSecurityStatus);
        } catch (e) {
            fireAnalytics('fail', e);
            return $31acbb56ee12017f$export$c28ff3dd4e9c5af8((0, $762384ddf50fefa1$export$78244dbb77cfa6b6), e);
        }
    };
    const applyConfigurationLoading = (supportRequestTypePermission ? applyRequestTypePermissionLoading : false) || (supportIssueSecurity ? applyIssueSecurityLoading : false);
    return {
        principals: principals,
        prependPrincipals: prependPrincipals,
        removePrincipal: removePrincipal,
        issueSecurityState: issueSecurityState,
        makeIssueSecuritySelection: makeIssueSecuritySelection,
        configurationFetch: configurationFetch,
        configurationLoading: configurationLoading,
        configurationErrors: configurationErrors,
        applyConfiguration: applyConfiguration,
        applyConfigurationLoading: applyConfigurationLoading
    };
};

});
parcelRegister("2p5FC", function(module, exports) {

$parcel$export(module.exports, "useIssueSecurity", () => $094002469ce9a313$export$25194f121e90c8ae);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $34Ybh = parcelRequire("34Ybh");

var $THFJS = parcelRequire("THFJS");

var $ifhQL = parcelRequire("ifhQL");

var $6cNFG = parcelRequire("6cNFG");
const $094002469ce9a313$export$25194f121e90c8ae = (projectId, requestTypeExternalId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: issueSecurityConfigData, loading: issueSecurityConfigLoading, error: issueSecurityConfigError, fetch: issueSecurityConfigFetch } = (0, $THFJS.useLoadIssueSecurity)(projectId, requestTypeExternalId);
    const [uiSecurityLevelOption, setSecurityLevelOption] = (0, $5uXOq.useState)('DEFAULT');
    const [uiSelectedSecurityLevelId, setSelectedSecurityLevelId] = (0, $5uXOq.useState)();
    const [uiShowError, setShowError] = (0, $5uXOq.useState)(false);
    const { loading: saveLoading, fetch: saveFetch } = (0, $ifhQL.useSaveIssueSecurity)(projectId, requestTypeExternalId);
    const { loading: deleteLoading, fetch: deleteFetch } = (0, $34Ybh.useDeleteIssueSecurity)(projectId, requestTypeExternalId);
    const showError = ()=>setShowError(true);
    const makeSelection = (0, $5uXOq.useCallback)((securityLevelOption, selectedSecurityLevelId)=>{
        setSecurityLevelOption(securityLevelOption);
        setSelectedSecurityLevelId(securityLevelOption === 'SELECT' ? selectedSecurityLevelId : undefined);
        setShowError(false);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (issueSecurityConfigData) {
            const securityLevelOption = issueSecurityConfigData.selectedSecurityLevelId || (0, $6cNFG.isDefaultNotAllowed)(issueSecurityConfigData) ? 'SELECT' : 'DEFAULT';
            makeSelection(securityLevelOption, issueSecurityConfigData.selectedSecurityLevelId);
            const isError = (0, $6cNFG.isMisconfiguredMissingLevel)(issueSecurityConfigData) || (0, $6cNFG.isMissingValueForRequiredField)(issueSecurityConfigData);
            setShowError(isError);
        }
    }, [
        issueSecurityConfigData,
        makeSelection
    ]);
    const fireAnalytics = (result)=>{
        const attributes = {
            hasDefaultSecurityLevel: !!issueSecurityState?.defaultSecurityLevelId,
            selectedSecurityLevelId: issueSecurityState?.selectedSecurityLevelId,
            defaultSecurityLevelId: issueSecurityState?.defaultSecurityLevelId,
            issueSecurityLevelsCount: issueSecurityState?.securityLevels.length,
            issueSecurityUpdateType: uiSelectedSecurityLevelId ? 'save' : 'delete'
        };
        return result === 'succeed' ? (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'requestTypeIssueSecurity updated', attributes) : (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'requestTypeIssueSecurity updateFailed', attributes);
    };
    /**
	 * If response was successful, we expect null to be returned as the body is empty.
	 * Otherwise, we expect undefined or something else in the error case, which we convert to an exception.
	 */ const applyIssueSecurity = async ()=>{
        if (!issueSecurityConfigData) {
            fireAnalytics('fail');
            throw Error('Issue security does not exist.');
        }
        if (uiSelectedSecurityLevelId === issueSecurityConfigData?.selectedSecurityLevelId) return issueSecurityConfigData?.issueSecurityStatus;
        if (uiSelectedSecurityLevelId === undefined) {
            const result = await deleteFetch();
            if (result !== null) {
                fireAnalytics('fail');
                throw Error('Failed to delete issue security');
            }
            fireAnalytics('succeed');
            return issueSecurityConfigData?.defaultSecurityLevelId ? 'ACTIVE' : 'INACTIVE';
        }
        const result = await saveFetch({
            issueSecurityLevelId: uiSelectedSecurityLevelId
        });
        if (result !== null) {
            fireAnalytics('fail');
            throw Error('Failed to save issue security');
        }
        fireAnalytics('succeed');
        return 'ACTIVE';
    };
    const issueSecurityState = issueSecurityConfigData && {
        selectedSecurityLevelId: uiSelectedSecurityLevelId,
        defaultSecurityLevelId: issueSecurityConfigData.defaultSecurityLevelId,
        securityLevels: issueSecurityConfigData.securityLevels,
        issueSecurityStatus: issueSecurityConfigData.issueSecurityStatus,
        isRequired: issueSecurityConfigData.isRequired,
        securityLevelOption: uiSecurityLevelOption,
        showError: uiShowError
    };
    return {
        issueSecurityState: issueSecurityState,
        issueSecurityConfigLoading: issueSecurityConfigLoading,
        issueSecurityConfigError: issueSecurityConfigError,
        issueSecurityConfigFetch: issueSecurityConfigFetch,
        applyIssueSecurity: applyIssueSecurity,
        applyIssueSecurityLoading: saveLoading || deleteLoading,
        makeSelection: makeSelection,
        showError: showError
    };
};

});
parcelRegister("34Ybh", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssueSecurity", () => $8b494777468e0c05$export$80cd6ce4e368434e);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $a7EYT = parcelRequire("a7EYT");
const $8b494777468e0c05$export$80cd6ce4e368434e = (projectId, requestTypeExternalId)=>{
    const request = (0, $5uXOq.useCallback)(()=>(0, $a7EYT.performDeleteRequest)(`/rest/servicedesk/1/project/${projectId}/request-type/${requestTypeExternalId}/issue-security`), [
        projectId,
        requestTypeExternalId
    ]);
    // Response body is empty so we don't need to return data.
    const { data: data, ...rest } = (0, $ld2hZ.useService)(request);
    return rest;
};

});

parcelRegister("THFJS", function(module, exports) {

$parcel$export(module.exports, "useLoadIssueSecurity", () => $bea91a38aecce5dc$export$ed564570e2f9ac8a);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $a7EYT = parcelRequire("a7EYT");
const $bea91a38aecce5dc$export$ed564570e2f9ac8a = (projectId, requestTypeExternalId)=>{
    const request = (0, $5uXOq.useCallback)(()=>(0, $a7EYT.performGetRequest)(`/rest/servicedesk/1/project/${projectId}/request-type/${requestTypeExternalId}/issue-security`), [
        projectId,
        requestTypeExternalId
    ]);
    return (0, $ld2hZ.useService)(request);
};

});

parcelRegister("ifhQL", function(module, exports) {

$parcel$export(module.exports, "useSaveIssueSecurity", () => $3bdf35eea4e77cd2$export$153f7fbc3fed8bac);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $a7EYT = parcelRequire("a7EYT");
const $3bdf35eea4e77cd2$export$153f7fbc3fed8bac = (projectId, requestTypeExternalId)=>{
    const request = (0, $5uXOq.useCallback)((body)=>(0, $a7EYT.performPutRequest)(`/rest/servicedesk/1/project/${projectId}/request-type/${requestTypeExternalId}/issue-security`, {
            body: JSON.stringify(body)
        }), [
        projectId,
        requestTypeExternalId
    ]);
    // Response body is empty so we don't need to return data.
    const { data: data, ...rest } = (0, $ld2hZ.useService)(request);
    return rest;
};

});


parcelRegister("l9Gan", function(module, exports) {

$parcel$export(module.exports, "useRequestTypePermissions", () => $6db17a1bd257ebcc$export$e1e0f9023898c318);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $kaSqp = parcelRequire("kaSqp");

var $fc9If = parcelRequire("fc9If");

var $5Ccmm = parcelRequire("5Ccmm");
const $6db17a1bd257ebcc$export$e1e0f9023898c318 = (projectId, requestTypeExternalId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: configurationData, loading: configurationLoading, error: configurationError, fetch: configurationFetch } = (0, $fc9If.useLoadRequestTypeRestriction)(projectId, requestTypeExternalId);
    const { loading: saveLoading, fetch: saveFetch } = (0, $5Ccmm.useSaveRequestTypeRestriction)(projectId, requestTypeExternalId);
    const { loading: deleteLoading, fetch: deleteFetch } = (0, $kaSqp.useDeleteRequestTypeRestriction)(projectId, requestTypeExternalId);
    const [principals, setPrincipals] = (0, $5uXOq.useState)([]);
    (0, $5uXOq.useEffect)(()=>{
        if (configurationData) setPrincipals(configurationData.principals);
    }, [
        configurationData
    ]);
    const prependPrincipals = (newPrincipals)=>{
        setPrincipals((existingPrincipals)=>[
                ...newPrincipals,
                ...existingPrincipals
            ]);
    };
    const removePrincipal = (id)=>{
        setPrincipals(principals.filter((principal)=>principal.id !== id));
    };
    const fireAnalytics = (result)=>{
        const oldPrincipals = configurationData ? configurationData.principals : [];
        const attributes = {
            restrictionAction: principals.length === 0 ? 'OPEN' : 'RESTRICTED',
            restrictionPrincipalsCount: principals.length,
            restrictionIndividualsCount: principals.filter((p)=>p.type === 'USER').length,
            restrictionPrincipalsAdded: principals.filter((newP)=>!oldPrincipals.some((oldP)=>oldP.id === newP.id)).length,
            restrictionPrincipalsRemoved: oldPrincipals.filter((oldP)=>!principals.some((newP)=>newP.id === oldP.id)).length,
            restrictionGroupsCount: principals.filter((p)=>p.type === 'USER_GROUP').length,
            restrictionCustomerOrganizationsCount: principals.filter((p)=>p.type === 'CUSTOMER_ORGANIZATION').length
        };
        return result === 'succeed' ? (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'requestTypePermissions updated', attributes) : (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'requestTypePermissions updateFailed', attributes);
    };
    /**
	 * If response was successful, we expect null to be returned as the body is empty.
	 * Otherwise, we expect undefined or something else in the error case, which we convert to an exception.
	 */ const applyConfiguration = async ()=>{
        if (principals.length === 0) {
            const result = await deleteFetch();
            if (result !== null) {
                fireAnalytics('fail');
                throw Error('Failed to delete configuration');
            }
            fireAnalytics('succeed');
            return 'OPEN';
        }
        const result = await saveFetch({
            principals: principals.map(({ id: id })=>id)
        });
        if (result !== null) {
            fireAnalytics('fail');
            throw Error('Failed to save configuration');
        }
        fireAnalytics('succeed');
        return 'RESTRICTED';
    };
    return {
        principals: principals,
        prependPrincipals: prependPrincipals,
        removePrincipal: removePrincipal,
        requestTypePermissionLoading: configurationLoading,
        requestTypePermissionError: configurationError,
        requestTypePermissionFetch: configurationFetch,
        applyRequestTypePermission: applyConfiguration,
        applyRequestTypePermissionLoading: saveLoading || deleteLoading
    };
};

});
parcelRegister("kaSqp", function(module, exports) {

$parcel$export(module.exports, "useDeleteRequestTypeRestriction", () => $e157c9f4db99bba9$export$85b8d04e3d6c4036);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $a7EYT = parcelRequire("a7EYT");
const $e157c9f4db99bba9$export$85b8d04e3d6c4036 = (projectId, requestTypeExternalId)=>{
    const request = (0, $5uXOq.useCallback)(()=>(0, $a7EYT.performDeleteRequest)(`/rest/servicedesk/1/project/${projectId}/request-type/${requestTypeExternalId}/permissions`), [
        projectId,
        requestTypeExternalId
    ]);
    // Response body is empty so we don't need to return data.
    const { data: data, ...rest } = (0, $ld2hZ.useService)(request);
    return rest;
};

});

parcelRegister("fc9If", function(module, exports) {

$parcel$export(module.exports, "useLoadRequestTypeRestriction", () => $6b71e838fd54d9d7$export$f751da834738f6b3);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $a7EYT = parcelRequire("a7EYT");
const $6b71e838fd54d9d7$export$f751da834738f6b3 = (projectId, requestTypeExternalId)=>{
    const request = (0, $5uXOq.useCallback)(()=>(0, $a7EYT.performGetRequest)(`/rest/servicedesk/1/project/${projectId}/request-type/${requestTypeExternalId}/permissions`), [
        projectId,
        requestTypeExternalId
    ]);
    return (0, $ld2hZ.useService)(request);
};

});

parcelRegister("5Ccmm", function(module, exports) {

$parcel$export(module.exports, "useSaveRequestTypeRestriction", () => $331e1f9c962cadfc$export$ef6c64a0b6b306a8);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $a7EYT = parcelRequire("a7EYT");
const $331e1f9c962cadfc$export$ef6c64a0b6b306a8 = (projectId, requestTypeExternalId)=>{
    const request = (0, $5uXOq.useCallback)((body)=>(0, $a7EYT.performPutRequest)(`/rest/servicedesk/1/project/${projectId}/request-type/${requestTypeExternalId}/permissions`, {
            body: JSON.stringify(body)
        }), [
        projectId,
        requestTypeExternalId
    ]);
    // Response body is empty so we don't need to return data.
    const { data: data, ...rest } = (0, $ld2hZ.useService)(request);
    return rest;
};

});


const $762384ddf50fefa1$export$9443c33870106e2 = 'MISCONFIGURATION';
const $762384ddf50fefa1$export$23c34ca691d1d6d4 = 'PRINCIPAL-OVER-LIMITS';
const $762384ddf50fefa1$export$78244dbb77cfa6b6 = 'UNKNOWN';


parcelRegister("idb8o", function(module, exports) {

$parcel$export(module.exports, "IssueSecurityConfig", () => $5ef68080e142d940$export$566336bc0de1e02b);

var $5uXOq = parcelRequire("5uXOq");

var $2x3Cb = parcelRequire("2x3Cb");

var $dD7Zc = parcelRequire("dD7Zc");

var $7paD5 = parcelRequire("7paD5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $jouoW = parcelRequire("jouoW");

var $7K5PP = parcelRequire("7K5PP");

var $e4yMr = parcelRequire("e4yMr");

var $41j30 = parcelRequire("41j30");

var $gwIPs = parcelRequire("gwIPs");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");

var $4R6GH = parcelRequire("4R6GH");

var $6cNFG = parcelRequire("6cNFG");


var $3drba = parcelRequire("3drba");

var $8Zbxn = parcelRequire("8Zbxn");

var $ixbwN = parcelRequire("ixbwN");

var $1tNUs = parcelRequire("1tNUs");
const $5ef68080e142d940$export$566336bc0de1e02b = ({ projectKey: projectKey, issueSecurityState: issueSecurityState, makeSelection: makeSelection })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { selectedSecurityLevelId: selectedSecurityLevelId, defaultSecurityLevelId: defaultSecurityLevelId, securityLevels: securityLevels, isRequired: isRequired, securityLevelOption: securityLevelOption, showError: showError } = issueSecurityState;
    const securityLevelOptions = securityLevels.map((level)=>({
            value: level.id,
            label: level.name,
            isDefault: level.id === defaultSecurityLevelId,
            isMember: level.isMember,
            description: level.description
        }));
    const securityLevelGroupedOptions = [
        {
            label: formatMessage((0, $8Zbxn.default).memberOfSecurityLevel),
            options: securityLevelOptions.filter(({ isMember: isMember })=>isMember)
        },
        {
            label: formatMessage((0, $8Zbxn.default).notMemberOfSecurityLevel),
            options: securityLevelOptions.filter(({ isMember: isMember })=>!isMember)
        }
    ];
    const defaultSecurityLevel = securityLevelOptions.find((level)=>level.value === defaultSecurityLevelId);
    const misconfiguredMissingLevel = showError && (0, $6cNFG.isMisconfiguredMissingLevel)(issueSecurityState);
    const misconfiguredRequired = showError && ((0, $6cNFG.isMissingValueForRequiredField)(issueSecurityState) || (0, $6cNFG.isMissingValueForSelectOption)(issueSecurityState));
    const [defaultSecurityLevelRadioPopupOpen, setDefaultSecurityLevelRadioPopupOpen] = (0, $5uXOq.useState)(false);
    const manageSecurityLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ef68080e142d940$var$LinkDocumentation, {
        projectKey: projectKey,
        issueSecurityState: issueSecurityState,
        message: (0, $8Zbxn.default).manageSecurityLevelsLink
    });
    const onRadioChange = (option)=>{
        if ((0, $6cNFG.isDefaultNotAllowed)(issueSecurityState) && option === 'DEFAULT') setDefaultSecurityLevelRadioPopupOpen(true);
        else makeSelection(option, selectedSecurityLevelId);
    };
    const securityLevelOptionDisplay = ()=>{
        if (securityLevelOption === 'SELECT' || !defaultSecurityLevel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
            htmlFor: "select-security-level"
        }, formatMessage((0, $8Zbxn.default).selectLabel)), isRequired || defaultSecurityLevel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.danger"
        }, "*") : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            classNamePrefix: "issue-security-picker",
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal + 1
                    })
            },
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: document.body,
            isClearable: !isRequired && !defaultSecurityLevel,
            menuPlacement: "auto",
            options: securityLevelGroupedOptions,
            components: {
                Option: (0, $ixbwN.SelectOption),
                SingleValue: (0, $1tNUs.SelectSingleValue)
            },
            onChange: (newValue)=>makeSelection('SELECT', newValue ? newValue.value : undefined),
            label: formatMessage((0, $8Zbxn.default).selectLabel),
            placeholder: formatMessage((0, $8Zbxn.default).placeholder),
            value: securityLevelOptions.find((level)=>level.value === selectedSecurityLevelId),
            isInvalid: misconfiguredMissingLevel || misconfiguredRequired
        }), misconfiguredMissingLevel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ef68080e142d940$var$ErrorMessage, {
            message: formatMessage((0, $8Zbxn.default).missingLevelError)
        }), misconfiguredRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ef68080e142d940$var$ErrorMessage, {
            message: formatMessage((0, $8Zbxn.default).requiredError)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
            htmlFor: "default-security-level"
        }, formatMessage((0, $8Zbxn.default).selectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixbwN.SelectOptionStandalone), {
            label: defaultSecurityLevel.label,
            description: defaultSecurityLevel.description
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "tab",
        action: "viewed",
        actionSubjectId: "requestTypeIssueSecurity",
        attributes: $5ef68080e142d940$var$getAnalyticsAttributes(issueSecurityState)
    }), securityLevels.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $8Zbxn.default).descriptionIssueTermRefresh : (0, $8Zbxn.default).description,
        values: {
            link: (chunks)=>(0, $4R6GH.fg)('jsm_request_intake_enghealth_due_in_feb') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: (0, $fb67798be3405463$export$76f159d3921266c2),
                    target: "_blank",
                    appearance: "default"
                }, chunks) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
                    href: (0, $fb67798be3405463$export$76f159d3921266c2),
                    target: "_blank"
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                xcss: $5ef68080e142d940$var$popupContentStyles
            }, isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $8Zbxn.default).isRequiredPopup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $8Zbxn.default).noDefaultSecurityLevelPopupIssueTermRefresh : (0, $8Zbxn.default).noDefaultSecurityLevelPopup), manageSecurityLink)),
        zIndex: (0, $gwIPs.layers).modal + 1,
        placement: "bottom-start",
        messageId: "servicedesk-request-type-security.ui.config-button.config-modal.issue-security-config.popup",
        messageType: "transactional",
        isOpen: defaultSecurityLevelRadioPopupOpen,
        onClose: ()=>setDefaultSecurityLevelRadioPopupOpen(false),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
                ...triggerProps,
                "aria-expanded": undefined,
                isChecked: securityLevelOption === 'DEFAULT',
                label: formatMessage((0, $8Zbxn.default).alwaysUseProjectDefaultSecurityLevel),
                onClick: ()=>onRadioChange('DEFAULT')
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
        isChecked: securityLevelOption === 'SELECT',
        label: formatMessage((0, $8Zbxn.default).selectSecurityLevel),
        onClick: ()=>onRadioChange('SELECT')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, securityLevelOptionDisplay(), manageSecurityLink))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3drba.ConfigEmptyState), {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ef68080e142d940$var$LinkDocumentation, {
            projectKey: projectKey,
            issueSecurityState: issueSecurityState,
            message: (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $8Zbxn.default).goToIssueSecurityLinkIssueTermRefresh : (0, $8Zbxn.default).goToIssueSecurityLink
        })
    }));
};
const $5ef68080e142d940$var$ErrorMessage = ({ message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        testId: "servicedesk-request-type-security.ui.config-button.config-modal.issue-security-config.misconfiguration-error-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        LEGACY_size: "small",
        label: message,
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.danger"
    }, message));
const $5ef68080e142d940$var$LinkDocumentation = ({ projectKey: projectKey, issueSecurityState: issueSecurityState, message: message })=>(0, $4R6GH.fg)('jsm_request_intake_enghealth_due_in_feb') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: `/plugins/servlet/project-config/${projectKey}/issuesecurity`,
        target: "_blank",
        onClick: (_, event)=>(0, $8zOmE.fireUIAnalytics)(event, 'manageIssueSecurityLink', $5ef68080e142d940$var$getAnalyticsAttributes(issueSecurityState))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), message)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: `/plugins/servlet/project-config/${projectKey}/issuesecurity`,
        target: "_blank",
        onClick: (_, event)=>(0, $8zOmE.fireUIAnalytics)(event, 'manageIssueSecurityLink', $5ef68080e142d940$var$getAnalyticsAttributes(issueSecurityState))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
        LEGACY_size: "small",
        label: ""
    })));
const $5ef68080e142d940$var$getAnalyticsAttributes = (issueSecurityState)=>({
        hasDefaultSecurityLevel: !!issueSecurityState.defaultSecurityLevelId,
        selectedSecurityLevelId: issueSecurityState.selectedSecurityLevelId,
        defaultSecurityLevelId: issueSecurityState.defaultSecurityLevelId,
        issueSecurityLevelsCount: issueSecurityState.securityLevels.length
    });
const $5ef68080e142d940$var$popupContentStyles = (0, $8CUq3.xcss)({
    maxWidth: '14rem',
    padding: 'space.200'
});

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    (0, $VSDnB.fg)('platform-icon-control-migration') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});

parcelRegister("41j30", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2f3c33a6194375$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $hjSul = parcelRequire("hjSul");
function $7c2f3c33a6194375$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), rest, children);
}
var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})($7c2f3c33a6194375$var$Link);

});

const $fb67798be3405463$export$76f159d3921266c2 = 'https://support.atlassian.com/jira-service-management-cloud/docs/create-security-levels-for-issues';

parcelRegister("3drba", function(module, exports) {

$parcel$export(module.exports, "ConfigEmptyState", () => $c4203f7871a03063$export$fc2ff0683de3a7b3);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");

var $ousew = parcelRequire("ousew");

var $itmJb = parcelRequire("itmJb");

var $hjSul = parcelRequire("hjSul");

var $4R6GH = parcelRequire("4R6GH");

var $cbxbZ = parcelRequire("cbxbZ");


var $cpybo = parcelRequire("cpybo");
const $c4203f7871a03063$export$fc2ff0683de3a7b3 = ({ link: link })=>{
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbxbZ.GenericEmptyState), {
        header: (0, $4R6GH.fg)('itsm-issue-renaming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), isJiraAdmin ? (0, $cpybo.default).headerIssueTermRefresh : (0, $cpybo.default).headerNotJiraAdminIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), isJiraAdmin ? (0, $cpybo.default).header : (0, $cpybo.default).headerNotJiraAdmin),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $cpybo.default).descriptionIssueTermRefresh : (0, $cpybo.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            href: (0, $fb67798be3405463$export$76f159d3921266c2),
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $cpybo.default).readMoreAboutIssueSecurityIssueTermRefresh : (0, $cpybo.default).readMoreAboutIssueSecurity))),
        link: link
    });
};

});
parcelRegister("cbxbZ", function(module, exports) {

$parcel$export(module.exports, "GenericEmptyState", () => $002af824a9f6e7a6$export$132fde68b328fb32);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $1YCbo = parcelRequire("1YCbo");

var $koVbs = parcelRequire("koVbs");

var $fQtY1 = parcelRequire("fQtY1");
const $002af824a9f6e7a6$export$132fde68b328fb32 = ({ header: header, description: description, link: link })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $002af824a9f6e7a6$var$stackStyle,
        space: "space.200",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $002af824a9f6e7a6$var$imageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YCbo.default), {
        alt: formatMessage((0, $fQtY1.default).securityPermissionsImageAlt)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        align: "center"
    }, description), link));
};
const $002af824a9f6e7a6$var$imageStyle = (0, $8CUq3.xcss)({
    height: '160px',
    width: '160px'
});
const $002af824a9f6e7a6$var$stackStyle = (0, $8CUq3.xcss)({
    width: '85%'
});

});
parcelRegister("1YCbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $fffaf24e2243c7b7$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $ah2T9 = parcelRequire("ah2T9");

var $pE73f = parcelRequire("pE73f");
const $fffaf24e2243c7b7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($pE73f)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ah2T9))
});
var $fffaf24e2243c7b7$export$2e2bcd8739ae039 = $fffaf24e2243c7b7$var$Illustration;
// for advanced use only
const $fffaf24e2243c7b7$export$a179c88182cb9d56 = [
    0,
    0,
    275,
    275
];

});
parcelRegister("ah2T9", function(module, exports) {
module.exports = new URL("security-permissions-darkmode.3c5db0bb.svg", import.meta.url).toString();

});

parcelRegister("pE73f", function(module, exports) {
module.exports = new URL("security-permissions.ebb7eed7.svg", import.meta.url).toString();

});


parcelRegister("fQtY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $94280c131a2607bb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $94280c131a2607bb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    securityPermissionsImageAlt: {
        "id": "servicedesk-request-type-security.common.generic-empty-state.security-permissions-image-alt",
        "defaultMessage": "Illustration of a lock"
    }
});

});


parcelRegister("cpybo", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee202fc7952905c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fee202fc7952905c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.header",
        "defaultMessage": "Looks like you don\u2019t have issue security configured"
    },
    headerIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.header-issue-term-refresh",
        "defaultMessage": "Looks like you don\u2019t have work item security configured"
    },
    headerNotJiraAdmin: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.header-not-jira-admin",
        "defaultMessage": "Contact your admin to set up issue security"
    },
    headerNotJiraAdminIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.header-not-jira-admin-issue-term-refresh",
        "defaultMessage": "Contact your admin to set up work item security"
    },
    description: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.description",
        "defaultMessage": "Control who has the ability to view certain issues by assigning specific people and groups to security levels."
    },
    descriptionIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.description-issue-term-refresh",
        "defaultMessage": "Control who has the ability to view certain work items by assigning specific people and groups to security levels."
    },
    readMoreAboutIssueSecurity: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.read-more-about-issue-security",
        "defaultMessage": "Read more about issue security"
    },
    readMoreAboutIssueSecurityIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.read-more-about-issue-security-issue-term-refresh",
        "defaultMessage": "Read more about work item security"
    }
});

});


parcelRegister("8Zbxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9b8563da4f18e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ad9b8563da4f18e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.description",
        "defaultMessage": "Set an issue security level to control who can view issues created with this request type. <link>Read more about issue security</link>"
    },
    descriptionIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.description-issue-term-refresh",
        "defaultMessage": "Set a work item security level to control who can view work items created with this request type. <link>Read more about work item security</link>"
    },
    manageSecurityLevelsLink: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.manage-security-levels-link",
        "defaultMessage": "Manage security levels"
    },
    goToIssueSecurityLink: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.go-to-issue-security-link",
        "defaultMessage": "Go to issue security"
    },
    goToIssueSecurityLinkIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.go-to-issue-security-link-issue-term-refresh",
        "defaultMessage": "Go to work item security"
    },
    missingLevelError: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.missing-level-error",
        "defaultMessage": "Security level is no longer available"
    },
    requiredError: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.required-error",
        "defaultMessage": "Select a security level"
    },
    placeholder: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.placeholder",
        "defaultMessage": "Select level"
    },
    selectLabel: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.select-label",
        "defaultMessage": "Security level"
    },
    memberOfSecurityLevel: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.member-of-security-level",
        "defaultMessage": "Member"
    },
    notMemberOfSecurityLevel: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.not-member-of-security-level",
        "defaultMessage": "Not a member"
    },
    alwaysUseProjectDefaultSecurityLevel: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.always-use-project-default-security-level",
        "defaultMessage": "Always use default security level"
    },
    selectSecurityLevel: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.select-security-level",
        "defaultMessage": "Use security level other than default"
    },
    noDefaultSecurityLevelPopup: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.no-default-security-level-popup",
        "defaultMessage": "This project is using an issue security scheme that doesn\u2019t have a default set."
    },
    noDefaultSecurityLevelPopupIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.no-default-security-level-popup-issue-term-refresh",
        "defaultMessage": "This project is using a work item security scheme that doesn\u2019t have a default set."
    },
    isRequiredPopup: {
        "id": "servicedesk-request-type-security.config-button.config-modal.issue-security-config.is-required-popup",
        "defaultMessage": "When the security level field is required, this option isn\u2019t available as a level must be manually selected."
    }
});

});

parcelRegister("ixbwN", function(module, exports) {

$parcel$export(module.exports, "SelectOption", () => $390618f8afed5645$export$11a8a1ea41bf55d8);
$parcel$export(module.exports, "SelectOptionStandalone", () => $390618f8afed5645$export$2cab796c716aa170);

var $5uXOq = parcelRequire("5uXOq");

var $a8hd9 = parcelRequire("a8hd9");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $bChGW = parcelRequire("bChGW");
const $390618f8afed5645$export$11a8a1ea41bf55d8 = (props)=>{
    const { label: label, description: description } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390618f8afed5645$export$2cab796c716aa170, {
        label: label,
        description: description
    }));
};
const $390618f8afed5645$export$2cab796c716aa170 = ({ label: label, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a8hd9))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtlest"
    }, description)));

});

parcelRegister("1tNUs", function(module, exports) {

$parcel$export(module.exports, "SelectSingleValue", () => $084b89d63c8db2ad$export$b9e728ff91937168);

var $5uXOq = parcelRequire("5uXOq");

var $a8hd9 = parcelRequire("a8hd9");

var $f5TWP = parcelRequire("f5TWP");

var $bChGW = parcelRequire("bChGW");
const $084b89d63c8db2ad$export$b9e728ff91937168 = (props)=>{
    const { label: label } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a8hd9))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    }), label));
};

});


parcelRegister("jR1eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f13b1569bcfe5e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $27f13b1569bcfe5e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk-request-type-security.config-button.config-modal.title",
        "defaultMessage": "Restrict this request type"
    },
    whoCanRaiseRequestsTabTitle: {
        "id": "servicedesk-request-type-security.config-button.config-modal.who-can-raise-requests-tab-title",
        "defaultMessage": "Who can raise requests"
    },
    whoCanViewIssuesTabTitle: {
        "id": "servicedesk-request-type-security.config-button.config-modal.who-can-view-issues-tab-title",
        "defaultMessage": "Who can view issues"
    },
    whoCanViewIssuesTabTitleIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.config-modal.who-can-view-issues-tab-title-issue-term-refresh",
        "defaultMessage": "Who can view work items"
    },
    cancelButton: {
        "id": "servicedesk-request-type-security.config-button.config-modal.cancel-button",
        "defaultMessage": "Cancel"
    },
    applyButton: {
        "id": "servicedesk-request-type-security.config-button.config-modal.apply-button",
        "defaultMessage": "Apply"
    },
    reloadButton: {
        "id": "servicedesk-request-type-security.config-button.config-modal.reload-button",
        "defaultMessage": "Try again"
    },
    loadErrorTitle: {
        "id": "servicedesk-request-type-security.config-button.config-modal.load-error-title",
        "defaultMessage": "We couldn\u2019t load restrictions on this page"
    },
    restrictionsApplySuccessTitle: {
        "id": "servicedesk-request-type-security.config-button.config-modal.restrictions-apply-success-title",
        "defaultMessage": "Restrictions updated"
    },
    restrictionsApplySuccessDescription: {
        "id": "servicedesk-request-type-security.config-button.config-modal.restrictions-apply-success-description",
        "defaultMessage": "It may take a few moments for these changes to apply."
    },
    restrictionsApplyFailureTitle: {
        "id": "servicedesk-request-type-security.config-button.config-modal.restrictions-apply-failure-title",
        "defaultMessage": "We couldn\u2019t update restrictions"
    },
    restrictionsApplyFailureDescription: {
        "id": "servicedesk-request-type-security.config-button.config-modal.restrictions-apply-failure-description",
        "defaultMessage": "Select Apply to try again."
    },
    restrictionsApplyLimitedTitle: {
        "id": "servicedesk-request-type-security.config-button.config-modal.restrictions-apply-limited-title",
        "defaultMessage": "We\u2019re unable to add users or groups"
    },
    restrictionsApplyLimitedDescription: {
        "id": "servicedesk-request-type-security.config-button.config-modal.restrictions-apply-limited-description",
        "defaultMessage": "No more than 50 users or groups can have access to this request type. Remove some users or groups, and try again."
    },
    restrictionsApplyMisconfigurationDescription: {
        "id": "servicedesk-request-type-security.config-button.config-modal.restrictions-apply-misconfiguration-description",
        "defaultMessage": "Resolve the misconfiguration and try again."
    }
});

});

parcelRegister("cWZ9d", function(module, exports) {

$parcel$export(module.exports, "RequestTypePermissionsConfig", () => $dbe19969a1fe2cb1$export$69e2d6c6b8cc6eba);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $hjSul = parcelRequire("hjSul");

var $fGdSe = parcelRequire("fGdSe");

var $1vtYJ = parcelRequire("1vtYJ");

var $fIeax = parcelRequire("fIeax");

var $lQMe0 = parcelRequire("lQMe0");
const $dbe19969a1fe2cb1$var$LinkDocumentation = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/add-or-remove-restrictions-on-request-types/",
        target: "_blank"
    }, children);
const $dbe19969a1fe2cb1$export$69e2d6c6b8cc6eba = ({ principals: principals, prependPrincipals: prependPrincipals, removePrincipal: removePrincipal, isEmailRequestType: isEmailRequestType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "tab",
        action: "viewed",
        actionSubjectId: "requestTypePermission"
    }), isEmailRequestType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fGdSe.ConfigEmptyState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $1vtYJ.default).descriptionV2, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: $dbe19969a1fe2cb1$var$LinkDocumentation
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQMe0.PrincipalPicker), {
        alreadySelectedPrincipals: principals,
        addPrincipals: prependPrincipals
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIeax.PrincipalList), {
        principals: principals,
        removePrincipal: removePrincipal
    })))));
};

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("fGdSe", function(module, exports) {

$parcel$export(module.exports, "ConfigEmptyState", () => $c2053cfb8c460bc2$export$fc2ff0683de3a7b3);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cbxbZ = parcelRequire("cbxbZ");

var $k02d5 = parcelRequire("k02d5");
const $c2053cfb8c460bc2$export$fc2ff0683de3a7b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbxbZ.GenericEmptyState), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $k02d5.default).header),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $k02d5.default).description)
    });

});
parcelRegister("k02d5", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc4c9605de4cac48$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dc4c9605de4cac48$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.empty-state.header",
        "defaultMessage": "Unable to restrict who can raise requests via email"
    },
    description: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.empty-state.description",
        "defaultMessage": "Any request types used by email channel can\u2019t be restricted in order for anonymous users to still send requests via email."
    }
});

});


parcelRegister("1vtYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc5e0afc18da21d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ecc5e0afc18da21d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    descriptionV2: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.description-v-2",
        "defaultMessage": "Give access to specific people to control who can raise this request. Restricted request types can be raised in all channels except email, chat, widget, and the virtual service agent. {linkStart}Read more about restricting request types{linkEnd}"
    }
});

});

parcelRegister("fIeax", function(module, exports) {

$parcel$export(module.exports, "PrincipalList", () => $30103448548a800e$export$5decdd2f69541323);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");

var $koVbs = parcelRequire("koVbs");

var $3OXSV = parcelRequire("3OXSV");

var $jITHI = parcelRequire("jITHI");
const $30103448548a800e$export$5decdd2f69541323 = ({ principals: principals, removePrincipal: removePrincipal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (principals.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050",
        testId: "servicedesk-request-type-security.ui.config-button.config-modal.request-type-permissions-config.principal-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jITHI.PrincipalItem), {
        key: "everyone-else",
        principal: {
            id: 'everyone-else',
            type: 'USER_GROUP',
            name: formatMessage((0, $3OXSV.default).everyoneElse)
        },
        isGreyedOut: true
    }), principals.map((principal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jITHI.PrincipalItem), {
            key: principal.id,
            principal: principal,
            canAccess: true,
            removePrincipal: ()=>removePrincipal(principal.id)
        })));
};

});
parcelRegister("3OXSV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4711ee1ae248d52a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4711ee1ae248d52a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    everyoneElse: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.everyone-else",
        "defaultMessage": "Everyone else"
    }
});

});

parcelRegister("jITHI", function(module, exports) {

$parcel$export(module.exports, "PrincipalItem", () => $26d25d7d43cb21c0$export$a040ad5a2a093986);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $7sUFC = parcelRequire("7sUFC");

var $fVnbM = parcelRequire("fVnbM");

var $4hqZ5 = parcelRequire("4hqZ5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");

var $3tqnF = parcelRequire("3tqnF");
const $26d25d7d43cb21c0$export$a040ad5a2a093986 = ({ principal: principal, canAccess: canAccess, isGreyedOut: isGreyedOut, removePrincipal: removePrincipal })=>{
    const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sUFC.default), {
        avatar: principal.type === 'USER' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            size: "medium",
            name: principal.name,
            src: principal.avatar,
            isDisabled: isGreyedOut
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: [
                $26d25d7d43cb21c0$var$peopleIconStyles,
                isGreyedOut && $26d25d7d43cb21c0$var$greyedOutPeopleIconStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon, #44546F)"
        })),
        primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span",
            xcss: isGreyedOut && $26d25d7d43cb21c0$var$greyedOutTextStyles
        }, principal.name),
        secondaryText: isGreyedOut ? undefined : $26d25d7d43cb21c0$var$getByline(principal.type)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $26d25d7d43cb21c0$var$avatarStyles
    }, avatar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $26d25d7d43cb21c0$var$permissionsStyles,
            isGreyedOut && $26d25d7d43cb21c0$var$greyedOutTextStyles
        ]
    }, canAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3tqnF.default).hasAccess) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3tqnF.default).noAccess)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $26d25d7d43cb21c0$var$removeButtonStyles,
            isGreyedOut && $26d25d7d43cb21c0$var$greyedOutTextStyles
        ]
    }, removePrincipal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: ()=>removePrincipal()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3tqnF.default).remove))));
};
const $26d25d7d43cb21c0$var$getByline = (principalType)=>{
    switch(principalType){
        case 'USER_GROUP':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3tqnF.default).group);
        case 'CUSTOMER_ORGANIZATION':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3tqnF.default).customerOrganization);
        default:
            return null;
    }
};
const $26d25d7d43cb21c0$var$avatarStyles = (0, $8CUq3.xcss)({
    width: '65%',
    margin: 'auto'
});
const $26d25d7d43cb21c0$var$peopleIconStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'border.radius.circle',
    margin: 'space.025',
    padding: 'space.050'
});
const $26d25d7d43cb21c0$var$greyedOutPeopleIconStyles = (0, $8CUq3.xcss)({
    opacity: 'opacity.disabled'
});
const $26d25d7d43cb21c0$var$permissionsStyles = (0, $8CUq3.xcss)({
    width: '23%',
    margin: 'auto'
});
const $26d25d7d43cb21c0$var$removeButtonStyles = (0, $8CUq3.xcss)({
    width: '12%',
    margin: 'auto'
});
const $26d25d7d43cb21c0$var$greyedOutTextStyles = (0, $8CUq3.xcss)({
    color: 'color.text.disabled'
});

});
parcelRegister("3tqnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1185835eb3c990b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d1185835eb3c990b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hasAccess: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.has-access",
        "defaultMessage": "Has access"
    },
    noAccess: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.no-access",
        "defaultMessage": "No access"
    },
    remove: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.remove",
        "defaultMessage": "Remove"
    },
    customerOrganization: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.customer-organization",
        "defaultMessage": "Customer organization"
    },
    group: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.group",
        "defaultMessage": "Group"
    }
});

});



parcelRegister("lQMe0", function(module, exports) {

$parcel$export(module.exports, "PrincipalPicker", () => $db7aaf288c354661$export$2c31df01ac3aac3c);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $cr0SA = parcelRequire("cr0SA");

var $gwIPs = parcelRequire("gwIPs");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3J1QC = parcelRequire("3J1QC");


var $k3ttl = parcelRequire("k3ttl");
const $db7aaf288c354661$export$2c31df01ac3aac3c = ({ alreadySelectedPrincipals: alreadySelectedPrincipals, addPrincipals: addPrincipals })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [query, setQuery] = (0, $5uXOq.useState)('');
    const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $3J1QC.useSearchPrincipals)();
    const options = (data || []).filter((searchedPrincipal)=>!alreadySelectedPrincipals.some((selectedPrincipal)=>$db7aaf288c354661$var$convertOptionToPrincipal(searchedPrincipal).id === selectedPrincipal.id));
    (0, $5uXOq.useEffect)(()=>{
        if (query) fetch(query);
    }, [
        fetch,
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $db7aaf288c354661$var$pickerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        isMulti: true,
        appearance: "compact",
        width: "100%",
        ariaLabel: formatMessage((0, $k3ttl.default).ariaLabel),
        fieldId: "request-type-security-principal-picker",
        options: options,
        onChange: (newSelectedPrincipals)=>{
            if (Array.isArray(newSelectedPrincipals)) setSelectedOptions(newSelectedPrincipals);
        },
        value: selectedOptions,
        placeholder: formatMessage((0, $k3ttl.default).placeholderV2),
        onInputChange: (queryStr)=>setQuery(queryStr || ''),
        isLoading: loading,
        addMoreMessage: "",
        noOptionsMessage: error ? formatMessage((0, $k3ttl.default).errorV2) : null,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).modal + 1
                })
        },
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: document.body
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $db7aaf288c354661$var$addButtonStyles,
        onClick: ()=>{
            addPrincipals(selectedOptions.map($db7aaf288c354661$var$convertOptionToPrincipal));
            setSelectedOptions([]);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        shouldFitContainer: true,
        isDisabled: selectedOptions.length === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $k3ttl.default).add))));
};
const $db7aaf288c354661$var$convertOptionToPrincipal = ({ id: id, name: name, avatarUrl: avatarUrl })=>{
    let requestTypeSupportedPrincipalType = 'USER';
    if (id.startsWith((0, $f1a84375911a138e$export$40c50816b3ba92e3))) requestTypeSupportedPrincipalType = 'CUSTOMER_ORGANIZATION';
    else if (id.startsWith((0, $f1a84375911a138e$export$49f6ff7f13a0fefa))) requestTypeSupportedPrincipalType = 'USER_GROUP';
    return {
        id: id,
        type: requestTypeSupportedPrincipalType,
        name: name,
        avatar: avatarUrl
    };
};
const $db7aaf288c354661$var$pickerStyles = (0, $8CUq3.xcss)({
    width: '90%'
});
const $db7aaf288c354661$var$addButtonStyles = (0, $8CUq3.xcss)({
    width: '10%'
});

});
parcelRegister("3J1QC", function(module, exports) {

$parcel$export(module.exports, "useSearchPrincipals", () => $a551362ad48bca9d$export$d8e12cd6fa9cb29b);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $koVbs = parcelRequire("koVbs");

var $jDrwg = parcelRequire("jDrwg");

var $a7EYT = parcelRequire("a7EYT");

var $9disN = parcelRequire("9disN");

const $a551362ad48bca9d$var$DEBOUNCE_DELAY_MS = 300;
const $a551362ad48bca9d$export$d8e12cd6fa9cb29b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const usersAndGroupsRequest = (0, $5uXOq.useCallback)((query)=>(0, $a7EYT.performGetRequest)(`/rest/api/3/groupuserpicker?query=${encodeURIComponent(query)}&maxResults=50&showAvatar=true&avatarSize=medium&caseInsensitive=true`), []);
    const customerOrganizationsRequest = (0, $5uXOq.useCallback)((query)=>(0, $a7EYT.performGetRequest)(`/rest/servicedesk/1/organisations/search?query=${encodeURIComponent(query)}`), []);
    const { data: usersAndGroupsData, fetch: fetchUsersAndGroups, loading: usersAndGroupsLoading, error: usersAndGroupsError } = (0, $ld2hZ.useService)(usersAndGroupsRequest);
    const { data: customerOrganizationsData, fetch: fetchCustomerOrganizations, loading: customerOrganizationsLoading, error: customerOrganizationsError } = (0, $ld2hZ.useService)(customerOrganizationsRequest);
    const [debouncedFetch] = (0, $jDrwg.default)((query)=>Promise.all([
            fetchUsersAndGroups(query),
            fetchCustomerOrganizations(query)
        ]), $a551362ad48bca9d$var$DEBOUNCE_DELAY_MS);
    const userOptions = usersAndGroupsData?.users.users.map((user)=>({
            id: `${0, $f1a84375911a138e$export$470b0d72e4fdc43a}/${user.accountId}`,
            name: user.displayName,
            type: 'user',
            avatarUrl: user.avatarUrl
        })) ?? [];
    const groupOptions = usersAndGroupsData?.groups.groups.map((group)=>({
            id: `${0, $f1a84375911a138e$export$49f6ff7f13a0fefa}/${group.groupId}`,
            name: group.name,
            type: 'group',
            byline: formatMessage((0, $9disN.default).group)
        })) ?? [];
    const customerOrganizationOptions = customerOrganizationsData?.map((customerOrganization)=>({
            id: `${0, $f1a84375911a138e$export$40c50816b3ba92e3}/${customerOrganization.externalId}`,
            name: customerOrganization.name,
            type: 'group',
            byline: formatMessage((0, $9disN.default).customerOrganization)
        })) ?? [];
    const options = userOptions.concat(groupOptions).concat(customerOrganizationOptions).sort((a, b)=>a.name.localeCompare(b.name));
    const loading = usersAndGroupsLoading || customerOrganizationsLoading;
    const error = usersAndGroupsError || customerOrganizationsError;
    const data = loading || error ? [] : options;
    return {
        data: data,
        fetch: debouncedFetch,
        loading: loading,
        error: error
    };
};

});
parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("9disN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0565292c8cf11b9b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0565292c8cf11b9b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customerOrganization: {
        "id": "servicedesk-request-type-security.services.search-principals.customer-organization",
        "defaultMessage": "Customer organization"
    },
    group: {
        "id": "servicedesk-request-type-security.services.search-principals.group",
        "defaultMessage": "Group"
    }
});

});

const $f1a84375911a138e$export$470b0d72e4fdc43a = 'ari:cloud:identity::user';
const $f1a84375911a138e$export$49f6ff7f13a0fefa = 'ari:cloud:identity::group';
const $f1a84375911a138e$export$40c50816b3ba92e3 = 'ari:cloud:identity::customer-organization';


parcelRegister("k3ttl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddeab130c9ceb6b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ddeab130c9ceb6b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholderV2: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-picker.placeholder-v-2",
        "defaultMessage": "Search user name, group or customer organization"
    },
    add: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-picker.add",
        "defaultMessage": "Add"
    },
    errorV2: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-picker.error-v-2",
        "defaultMessage": "Error loading users, groups and customer organizations"
    },
    ariaLabel: {
        "id": "servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-picker.aria-label",
        "defaultMessage": "User and group picker"
    }
});

});




parcelRegister("8vxsE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcc76c398a89f3ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dcc76c398a89f3ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    restricted: {
        "id": "servicedesk-request-type-security.config-button.restricted",
        "defaultMessage": "Restrictions apply on this request type"
    },
    restrictedV2: {
        "id": "servicedesk-request-type-security.config-button.restricted-v-2",
        "defaultMessage": "Manage restrictions, restrictions applied"
    },
    restrictedTooltip: {
        "id": "servicedesk-request-type-security.config-button.restricted-tooltip",
        "defaultMessage": "Only specific people can raise this request"
    },
    restrictedTooltipV2: {
        "id": "servicedesk-request-type-security.config-button.restricted-tooltip-v-2",
        "defaultMessage": "Only specific people can raise or view this issue"
    },
    restrictedTooltipV2IssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.restricted-tooltip-v-2-issue-term-refresh",
        "defaultMessage": "Only specific people can raise or view this work item"
    },
    restrictions: {
        "id": "servicedesk-request-type-security.config-button.restrictions",
        "defaultMessage": "Restrictions"
    },
    open: {
        "id": "servicedesk-request-type-security.config-button.open",
        "defaultMessage": "No restrictions on this request type"
    },
    openV2: {
        "id": "servicedesk-request-type-security.config-button.open-v-2",
        "defaultMessage": "Manage restrictions, no restrictions applied"
    },
    openTooltip: {
        "id": "servicedesk-request-type-security.config-button.open-tooltip",
        "defaultMessage": "Anyone can raise this request"
    },
    openTooltipV2: {
        "id": "servicedesk-request-type-security.config-button.open-tooltip-v-2",
        "defaultMessage": "Anyone can raise or view this issue"
    },
    openTooltipV2IssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.open-tooltip-v-2-issue-term-refresh",
        "defaultMessage": "Anyone can raise or view this work item"
    },
    emailChannelWarningPopup: {
        "id": "servicedesk-request-type-security.config-button.email-channel-warning-popup",
        "defaultMessage": "Unable to restrict request type as it\u2019s used by email channel."
    },
    onboardingSpotlightHeading: {
        "id": "servicedesk-request-type-security.config-button.onboarding-spotlight-heading",
        "defaultMessage": "Manage restrictions on this request type"
    },
    onboardingSpotlightContent: {
        "id": "servicedesk-request-type-security.config-button.onboarding-spotlight-content",
        "defaultMessage": "Control who can raise requests by giving access to only specific people."
    },
    onboardingSpotlightConfirmButton: {
        "id": "servicedesk-request-type-security.config-button.onboarding-spotlight-confirm-button",
        "defaultMessage": "OK"
    },
    onboardingNudgeHeading: {
        "id": "servicedesk-request-type-security.config-button.onboarding-nudge-heading",
        "defaultMessage": "Manage restrictions on this request type all in one place"
    },
    onboardingNudgeContent: {
        "id": "servicedesk-request-type-security.config-button.onboarding-nudge-content",
        "defaultMessage": "Choose who has access to raise this request and view issues created with this request type for complete control."
    },
    onboardingNudgeContentIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.onboarding-nudge-content-issue-term-refresh",
        "defaultMessage": "Choose who has access to raise this request and view work items created with this request type for complete control."
    },
    changeboardingNudgeHeading: {
        "id": "servicedesk-request-type-security.config-button.changeboarding-nudge-heading",
        "defaultMessage": "A new way to manage issue security on request types"
    },
    changeboardingNudgeHeadingIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.changeboarding-nudge-heading-issue-term-refresh",
        "defaultMessage": "A new way to manage work item security on request types"
    },
    changeboardingNudgeContent: {
        "id": "servicedesk-request-type-security.config-button.changeboarding-nudge-content",
        "defaultMessage": "No longer do you need to add the <b>Security level</b> field to request types, now <link>control who can both view issues and raise requests</link> in one place. Plus, have better visibility of how your issue security scheme\u2019s default level applies."
    },
    changeboardingNudgeContentIssueTermRefresh: {
        "id": "servicedesk-request-type-security.config-button.changeboarding-nudge-content-issue-term-refresh",
        "defaultMessage": "No longer do you need to add the <b>Security level</b> field to request types, now <link>control who can both view work items and raise requests</link> in one place. Plus, have better visibility of how your work item security scheme\u2019s default level applies."
    },
    onboardingNudgeDismissButton: {
        "id": "servicedesk-request-type-security.config-button.onboarding-nudge-dismiss-button",
        "defaultMessage": "Dismiss"
    },
    onboardingNudgeShowMeButton: {
        "id": "servicedesk-request-type-security.config-button.onboarding-nudge-show-me-button",
        "defaultMessage": "Show me"
    }
});

});


parcelRegister("JZXck", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed24aee3f7f5ba3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messagesIssueTermRefresh", () => $6ed24aee3f7f5ba3$export$f587f79e19cb8c9);

var $7VHMR = parcelRequire("7VHMR");
var $6ed24aee3f7f5ba3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    avatarAlt: {
        "id": "project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-alt",
        "defaultMessage": "Issue type icon"
    },
    avatarAccessibleAlt: {
        "id": "project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-accessible-alt",
        "defaultMessage": "Change issue type icon"
    },
    avatarAriaLabel: {
        "id": "project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-aria-label",
        "defaultMessage": "Change issue type icon - {issueType}"
    },
    editAvatar: {
        "id": "project-settings-apps.issue-type-page.main-header.avatar-icon.edit-avatar",
        "defaultMessage": "Edit issue type icon"
    },
    errorMessageIssueTypeNameTooShort: {
        "id": "project-settings-apps.issue-type-page.main-header.name-inline-input.too-short-error-name",
        "defaultMessage": "Add a name."
    },
    errorMessageIssueTypeNameAlreadyExists: {
        "id": "project-settings-apps.issue-type-page.main-header.name-inline-input.already-exists-error-name",
        "defaultMessage": "Already exists. Try a different name."
    },
    errorMessageIssueTypeNameTooLong: {
        "id": "project-settings-apps.issue-type-page.main-header.name-inline-input.too-long-error-name",
        "defaultMessage": "Name can't exceed {maximumNameLength} characters"
    },
    errorMessageIssueTypeHelpTextTooLong: {
        "id": "project-settings-apps.issue-type-page.main-header.help-text-inline-input.too-long-error-name",
        "defaultMessage": "Help text can't exceed {maximumHelpTextLength} characters"
    },
    errorMessageIssueTypeDescriptionTooLong: {
        "id": "project-settings-apps.issue-type-page.main-header.description-inline-input.too-long-error-name",
        "defaultMessage": "Description can't exceed {maximumDescriptionLength} characters"
    },
    emailRequestTypeDescription: {
        "id": "project-settings-apps.issue-type-page.main-header.email-request-type-description.description-jsm",
        "defaultMessage": "Request received from your email support channel."
    }
});
const $6ed24aee3f7f5ba3$export$f587f79e19cb8c9 = (0, $7VHMR.defineMessages)({
    avatarAlt: {
        "id": "project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-alt-issue-term-refresh",
        "defaultMessage": "Work type icon"
    },
    avatarAccessibleAlt: {
        "id": "project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-accessible-alt-issue-term-refresh",
        "defaultMessage": "Change work type icon"
    },
    avatarAriaLabel: {
        "id": "project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-aria-label-issue-term-refresh",
        "defaultMessage": "Change work type icon - {issueType}"
    },
    editAvatar: {
        "id": "project-settings-apps.issue-type-page.main-header.avatar-icon.edit-avatar-issue-term-refresh",
        "defaultMessage": "Edit work type icon"
    }
});

});


parcelRegister("bDbDt", function(module, exports) {

$parcel$export(module.exports, "HiddenInContextWarning", () => $9e097666db40b434$export$daccef6658d7f810);

var $5uXOq = parcelRequire("5uXOq");

var $92Z2l = parcelRequire("92Z2l");

var $gt8X2 = parcelRequire("gt8X2");

var $lN1S8 = parcelRequire("lN1S8");

var $4R6GH = parcelRequire("4R6GH");

var $eGY06 = parcelRequire("eGY06");
const $9e097666db40b434$export$ddfe3e20c145601 = 'NO_CONTEXT';
const $9e097666db40b434$var$PRODUCT_HELP_ARTICLE_ID = '6I42ggwGORmP84atFaD3hS';
const $9e097666db40b434$var$PRODUCT_HELP_LINK = 'https://support.atlassian.com/jira-cloud-administration/docs/configure-a-custom-field/#Troubleshoot-issue-configuration-and-context';
const $9e097666db40b434$export$daccef6658d7f810 = ({ context: context, customFieldId: customFieldId, intl: intl })=>{
    const link = context === $9e097666db40b434$export$ddfe3e20c145601 ? `/secure/admin/ConfigureCustomField!default.jspa?customFieldId=${customFieldId}` : `/secure/admin/ManageConfigurationScheme!default.jspa?customFieldId=${customFieldId}&fieldConfigSchemeId=${context.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, intl.formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $eGY06.messages).contextNotAppliedIssueTermRefresh : (0, $eGY06.messages).contextNotApplied, {
        a: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
                href: link
            }, message),
        link: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gt8X2.IPHLink), {
                articleId: $9e097666db40b434$var$PRODUCT_HELP_ARTICLE_ID,
                documentationUrl: $9e097666db40b434$var$PRODUCT_HELP_LINK,
                linkText: {
                    // Text that we get is already translated at this point and we're interested in the pure string only, so we only add this random id to comply with the API
                    // and to make sure no real translation will be put under this fake key
                    id: 'c29tZSBoYXNoIGZvciByZWFjdC1pbnRsIGtleQ1==.no-translate',
                    defaultMessage: message[0]
                }
            })
    }));
};

});
parcelRegister("eGY06", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7bf48cbdcf8ca5e1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7bf48cbdcf8ca5e1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    contextNotApplied: {
        "id": "project-settings-product-features-jsm-tmp.restricted-field-warnings.context-not-applied",
        "defaultMessage": "You can't see this field in the issue view as the context is not applied to this project. <a>Add or edit context</a> to add a global context for this field. <link>Learn about the global context and your project</link>"
    },
    contextNotAppliedIssueTermRefresh: {
        "id": "project-settings-product-features-jsm-tmp.restricted-field-warnings.context-not-applied-issue-term-refresh",
        "defaultMessage": "You can't see this field in the work item view as the context is not applied to this project. <a>Add or edit context</a> to add a global context for this field. <link>Read about the global context and your project</link>"
    }
});

});


parcelRegister("if5xq", function(module, exports) {

$parcel$export(module.exports, "JsmTmpSidebar", () => $10631fb1f753d7bf$export$69fa0eb01d4a9131);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6wesA = parcelRequire("6wesA");

var $f0bqs = parcelRequire("f0bqs");

var $iuXsH = parcelRequire("iuXsH");

var $4Po1l = parcelRequire("4Po1l");

var $cnxA1 = parcelRequire("cnxA1");

var $5c9VP = parcelRequire("5c9VP");

var $47FNU = parcelRequire("47FNU");

var $8riZJ = parcelRequire("8riZJ");

var $6HQIb = parcelRequire("6HQIb");

var $d5sKj = parcelRequire("d5sKj");

var $hKL69 = parcelRequire("hKL69");

var $1tHhD = parcelRequire("1tHhD");

var $2tk6O = parcelRequire("2tk6O");

var $1Sxkt = parcelRequire("1Sxkt");

var $d5Xd9 = parcelRequire("d5Xd9");

var $6Ae0x = parcelRequire("6Ae0x");

var $bMszT = parcelRequire("bMszT");

var $2d6uN = parcelRequire("2d6uN");
const $10631fb1f753d7bf$var$FieldGroup = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5c9VP.FieldGroup), {
        ...props,
        messages: (0, $6Ae0x.fieldGroupMessages)
    });
const $10631fb1f753d7bf$var$JsmTmpSidebarNew = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getDropAnimationWidth: getDropAnimationWidth, itemGroups: itemGroups, filter: filter, totalAvailableItemsCount: totalAvailableItemsCount, onFilterChange: onFilterChange, onCreateField: onCreateField, isMouseDragging: isMouseDragging, onLoadMore: onLoadMore, asyncState: asyncState, availableFieldTypes: availableFieldTypes, DroppableLayoutItemList: DroppableLayoutItemList, PanelComponent: PanelComponent, FieldComponent: FieldComponent, project: project, tenant: tenant, isDropDisabled: isDropDisabled, droppableListIdPrefix: droppableListIdPrefix, getIndexAfterUnsortableFields: getIndexAfterUnsortableFields, FieldTypeList: FieldTypeList, issueLayoutOwners: issueLayoutOwners, isFieldsLimitReached: isFieldsLimitReached, fieldLimitPerProject: fieldLimitPerProject, explicitFieldAssociation: explicitFieldAssociation } = props;
    const isJiraAdmin = (0, $1Sxkt.isGlobalAdmin)(tenant);
    const uiGroups = (0, $1tHhD.useAvailableLayoutItemGroups)(filter, itemGroups); // there is always a single Issue type being an owner of the current layout
    const issueType = issueLayoutOwners[0].data;
    const fieldTypes = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d5Xd9.FieldTypes), {
        FieldTypeList: FieldTypeList,
        isFieldsLimitReached: isFieldsLimitReached,
        fieldLimitPerProject: fieldLimitPerProject,
        availableFieldTypes: availableFieldTypes,
        isMouseDragging: isMouseDragging,
        onFieldTypeClicked: onCreateField,
        getDropAnimationWidth: getDropAnimationWidth,
        issueTypeName: issueType.name
    });
    const create = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$createSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.SidebarDividingLine), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.PaddedColumnSection), null, fieldTypes));
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.PaddedColumnSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$titleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $6Ae0x.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0bqs.WhatIsThis), {
        content: formatMessage((0, $6Ae0x.default).whatIsThisContent),
        buttonText: formatMessage((0, $6Ae0x.default).moreInformationAboutTheFieldsButtonText)
    }))));
    const isEmpty = !totalAvailableItemsCount && !uiGroups.length;
    const isFiltered = !!filter.name;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    const filterNode = explicitFieldAssociation.enabled && expConfig.get('isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47FNU.FilterEfa), {
        onChange: onFilterChange,
        filter: filter,
        totalAvailableItemsCount: totalAvailableItemsCount,
        asyncState: asyncState
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8riZJ.Filter), {
        onChange: onFilterChange,
        filter: filter,
        totalAvailableItemsCount: totalAvailableItemsCount,
        asyncState: asyncState
    });
    if (asyncState === (0, $6wesA.LOADING)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$scrollableSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$noVerticalPaddingColumnStyles
    }, filterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6HQIb.LoadingState), null))), create, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2d6uN.SidebarFooter), {
        isGlobalAdmin: isJiraAdmin,
        isEfaEnabled: explicitFieldAssociation.enabled,
        project: project
    }));
    if (asyncState === (0, $6wesA.FAILURE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$scrollableSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$noVerticalPaddingColumnStyles
    }, filterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnxA1.ErrorState), null))), create, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2d6uN.SidebarFooter), {
        isGlobalAdmin: isJiraAdmin,
        isEfaEnabled: explicitFieldAssociation.enabled,
        project: project
    }));
    if (isEmpty && !isFiltered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$scrollableSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.PaddedColumnSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Po1l.EmptyState), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage((0, $6Ae0x.default).emptyStateTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage((0, $6Ae0x.default).emptyStateMessageIssueTermRefresh) : formatMessage((0, $6Ae0x.default).emptyStateMessage)))))), create, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2d6uN.SidebarFooter), {
        isGlobalAdmin: isJiraAdmin,
        isEfaEnabled: explicitFieldAssociation.enabled,
        project: project
    }));
    if (isEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$scrollableSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$noVerticalPaddingColumnStyles
    }, filterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d5sKj.NotFoundState), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, expConfig.get('isEnabled', false) && formatMessage((0, $6Ae0x.default).notFoundStateTitleWithProjectName, {
        projectName: project.projectName
    }), !expConfig.get('isEnabled', false) && formatMessage((0, $6Ae0x.default).notFoundStateTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, expConfig.get('isEnabled', false) && formatMessage((0, $6Ae0x.default).notFoundStateMessageWithFieldsPage), !expConfig.get('isEnabled', false) && formatMessage((0, $6Ae0x.default).notFoundStateMessage))))), create, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2d6uN.SidebarFooter), {
        isGlobalAdmin: isJiraAdmin,
        isEfaEnabled: explicitFieldAssociation.enabled,
        project: project
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$scrollableSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $10631fb1f753d7bf$var$noVerticalPaddingColumnStyles
    }, filterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10631fb1f753d7bf$var$PaddedAvailableItems, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuXsH.AvailableItemsList), {
        filter: filter,
        tenant: tenant,
        isDropDisabled: isDropDisabled,
        isRestrictedFieldsGroupVisible: true,
        getIndexAfterUnsortableFields: getIndexAfterUnsortableFields,
        droppableListIdPrefix: droppableListIdPrefix,
        getDropAnimationWidth: getDropAnimationWidth,
        project: project,
        FieldComponent: FieldComponent,
        FieldGroupComponent: $10631fb1f753d7bf$var$FieldGroup,
        PanelComponent: PanelComponent,
        DroppableLayoutItemList: DroppableLayoutItemList,
        RestrictedFieldGroupComponent: (0, $bMszT.RestrictedFieldGroup),
        onLoadMore: onLoadMore,
        uiGroups: uiGroups
    })))), create, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2d6uN.SidebarFooter), {
        isGlobalAdmin: isJiraAdmin,
        isEfaEnabled: explicitFieldAssociation.enabled,
        project: project
    }));
});
const $10631fb1f753d7bf$var$JsmTmpSidebarOld = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getDropAnimationWidth: getDropAnimationWidth, itemGroups: itemGroups, filter: filter, totalAvailableItemsCount: totalAvailableItemsCount, onFilterChange: onFilterChange, onCreateField: onCreateField, isMouseDragging: isMouseDragging, onLoadMore: onLoadMore, asyncState: asyncState, availableFieldTypes: availableFieldTypes, DroppableLayoutItemList: DroppableLayoutItemList, PanelComponent: PanelComponent, FieldComponent: FieldComponent, project: project, tenant: tenant, isDropDisabled: isDropDisabled, droppableListIdPrefix: droppableListIdPrefix, getIndexAfterUnsortableFields: getIndexAfterUnsortableFields, FieldTypeList: FieldTypeList, issueLayoutOwners: issueLayoutOwners, isFieldsLimitReached: isFieldsLimitReached, fieldLimitPerProject: fieldLimitPerProject, explicitFieldAssociation: explicitFieldAssociation } = props;
    const uiGroups = (0, $1tHhD.useAvailableLayoutItemGroups)(filter, itemGroups); // there is always a single Issue type being an owner of the current layout
    const issueType = issueLayoutOwners[0].data;
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.PaddedColumnSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10631fb1f753d7bf$var$TitleWrapperOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $6Ae0x.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0bqs.WhatIsThis), {
        content: formatMessage((0, $6Ae0x.default).whatIsThisContent),
        buttonText: formatMessage((0, $6Ae0x.default).moreInformationAboutTheFieldsButtonText)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d5Xd9.FieldTypes), {
        FieldTypeList: FieldTypeList,
        isFieldsLimitReached: isFieldsLimitReached,
        fieldLimitPerProject: fieldLimitPerProject,
        availableFieldTypes: availableFieldTypes,
        isMouseDragging: isMouseDragging,
        onFieldTypeClicked: onCreateField,
        getDropAnimationWidth: getDropAnimationWidth,
        issueTypeName: issueType.name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.SidebarDividingLine), null));
    const isEmpty = !totalAvailableItemsCount && !uiGroups.length;
    const isFiltered = !!filter.name;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    const filterNode = explicitFieldAssociation.enabled && expConfig.get('isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47FNU.FilterEfa), {
        onChange: onFilterChange,
        filter: filter,
        totalAvailableItemsCount: totalAvailableItemsCount,
        asyncState: asyncState
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8riZJ.Filter), {
        onChange: onFilterChange,
        filter: filter,
        totalAvailableItemsCount: totalAvailableItemsCount,
        asyncState: asyncState
    });
    if (asyncState === (0, $6wesA.LOADING)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10631fb1f753d7bf$var$PaddedColumnNoDividingLine, null, filterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6HQIb.LoadingState), null));
    if (asyncState === (0, $6wesA.FAILURE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10631fb1f753d7bf$var$PaddedColumnNoDividingLine, null, filterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnxA1.ErrorState), null));
    if (isEmpty && !isFiltered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.PaddedColumnSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Po1l.EmptyState), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage((0, $6Ae0x.default).emptyStateTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage((0, $6Ae0x.default).emptyStateMessageIssueTermRefresh) : formatMessage((0, $6Ae0x.default).emptyStateMessage)))));
    if (isEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10631fb1f753d7bf$var$PaddedColumnNoDividingLine, null, filterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d5sKj.NotFoundState), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage((0, $6Ae0x.default).notFoundStateTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, formatMessage((0, $6Ae0x.default).notFoundStateMessage))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10631fb1f753d7bf$var$PaddedColumnNoDividingLine, null, filterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10631fb1f753d7bf$var$PaddedAvailableItems, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuXsH.AvailableItemsList), {
        filter: filter,
        tenant: tenant,
        isDropDisabled: isDropDisabled,
        isRestrictedFieldsGroupVisible: true,
        getIndexAfterUnsortableFields: getIndexAfterUnsortableFields,
        droppableListIdPrefix: droppableListIdPrefix,
        getDropAnimationWidth: getDropAnimationWidth,
        project: project,
        FieldComponent: FieldComponent,
        FieldGroupComponent: $10631fb1f753d7bf$var$FieldGroup,
        PanelComponent: PanelComponent,
        DroppableLayoutItemList: DroppableLayoutItemList,
        RestrictedFieldGroupComponent: (0, $bMszT.RestrictedFieldGroup),
        onLoadMore: onLoadMore,
        uiGroups: uiGroups
    })));
});
const $10631fb1f753d7bf$export$69fa0eb01d4a9131 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expValEquals)('tmp_issue_type_edit_changes_reducing_duplicate_cfs', 'cohort', 'experiment'), $10631fb1f753d7bf$var$JsmTmpSidebarNew, $10631fb1f753d7bf$var$JsmTmpSidebarOld);
const $10631fb1f753d7bf$var$createSectionStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200'
});
const $10631fb1f753d7bf$var$titleWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 'space.250',
    gap: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10631fb1f753d7bf$var$TitleWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0qv47k _n3tdu2gc",
            __cmplp.className
        ])
    });
});
const $10631fb1f753d7bf$var$PaddedColumnNoDividingLine = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2tk6O.Column), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qutpp _u5f3pxbi _n3tdidpf _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $10631fb1f753d7bf$var$PaddedAvailableItems = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2tk6O.Column), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $10631fb1f753d7bf$var$noVerticalPaddingColumnStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    display: 'flex',
    flexDirection: 'column'
});
const $10631fb1f753d7bf$var$scrollableSectionStyles = (0, $8CUq3.xcss)({
    overflow: 'auto',
    overflowWrap: 'break-word',
    flexGrow: 1,
    position: 'relative'
});

});
parcelRegister("f0bqs", function(module, exports) {

$parcel$export(module.exports, "WhatIsThis", () => $b2fe194075ef7338$export$347a58a7ea5d76ad);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $6tRzQ = parcelRequire("6tRzQ");

var $i0vxP = parcelRequire("i0vxP");

var $eHJxW = parcelRequire("eHJxW");
const $b2fe194075ef7338$export$347a58a7ea5d76ad = (props)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        // we need to focus the button so that pressing ESC will close the popup
        if (buttonRef.current !== undefined && buttonRef.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        buttonRef.current.focus();
        setIsOpen(!isOpen);
    }, [
        buttonRef,
        setIsOpen,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b2fe194075ef7338$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        onClose: onClose,
        content: props.content,
        isOpen: isOpen,
        placement: "right",
        onContentBlur: onClose,
        messageId: "project-settings-apps-issue-type-page-product-features.common.ui.field-category.what-is-this.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        isSelected: isOpen,
        onClick: onToggle,
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'Ref<HTMLElement> | undefined'.
        ref: buttonRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }),
        "aria-label": props.buttonText
    }))));
};
// We want to allow translated messages to be broken up across multiple lines
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b2fe194075ef7338$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i0vxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e488d7f69150a6e1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");
class $e488d7f69150a6e1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args), this.setRef = (ref)=>{
            this.ref = ref;
        }, this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});


parcelRegister("iuXsH", function(module, exports) {

$parcel$export(module.exports, "AvailableItemsList", () => $248d8183ec8687b0$export$371861d9726eaffb);

var $5uXOq = parcelRequire("5uXOq");

var $8QDwl = parcelRequire("8QDwl");

var $6wesA = parcelRequire("6wesA");

var $1tHhD = parcelRequire("1tHhD");
const $248d8183ec8687b0$export$371861d9726eaffb = (props)=>{
    const { isRestrictedFieldsGroupVisible: isRestrictedFieldsGroupVisible, droppableListIdPrefix: droppableListIdPrefix, isDropDisabled: isDropDisabled, getDropAnimationWidth: getDropAnimationWidth, DroppableLayoutItemList: DroppableLayoutItemList, PanelComponent: PanelComponent, FieldComponent: FieldComponent, FieldGroupComponent: FieldGroupComponent, RestrictedFieldGroupComponent: RestrictedFieldGroupComponent, project: project, getIndexAfterUnsortableFields: getIndexAfterUnsortableFields, filter: filter, onLoadMore: onLoadMore, uiGroups: uiGroups, tenant: tenant } = props;
    const highlightRegExp = (0, $5uXOq.useMemo)(()=>{
        if (!filter || !filter.name) return null;
        // Huh?
        const escaped = (0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(filter.name.replace(/\s{2,}/gi, ' '));
        return new RegExp(escaped, 'ig');
    }, [
        filter
    ]);
    const onRenderItem = (0, $1tHhD.useOnRenderLayoutItem)({
        FieldComponent: FieldComponent,
        PanelComponent: PanelComponent,
        project: project,
        getIndexAfterUnsortableFields: getIndexAfterUnsortableFields,
        highlightRegExp: highlightRegExp
    });
    const maxPageSize = 30;
    const groups = uiGroups.map(({ name: name, groupId: groupId, items: items, totalCount: totalCount, endCursor: endCursor, hasNextPage: hasNextPage })=>{
        const remainingItems = totalCount - items.length;
        // +2 here to avoid situations when the last page will only have 1 field
        const pageSize = remainingItems < maxPageSize + 2 ? remainingItems : maxPageSize;
        return groupId === (0, $6wesA.RESTRICTED_GROUP) ? isRestrictedFieldsGroupVisible && // @ts-expect-error property `messages` is required for all groups even though it is only used in the suggested group
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RestrictedFieldGroupComponent, {
            totalCount: totalCount,
            key: name,
            groupId: groupId,
            items: items,
            pageSize: pageSize,
            hasNextPage: hasNextPage,
            droppableListIdPrefix: droppableListIdPrefix,
            isDropDisabled: isDropDisabled,
            endCursor: endCursor,
            onLoadMore: onLoadMore,
            onRenderItem: onRenderItem,
            getDropAnimationWidth: getDropAnimationWidth,
            DroppableLayoutItemList: DroppableLayoutItemList,
            tenant: tenant
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldGroupComponent, {
            totalCount: totalCount,
            key: name,
            title: name,
            groupId: groupId,
            items: items,
            pageSize: pageSize,
            hasNextPage: hasNextPage,
            droppableListIdPrefix: droppableListIdPrefix,
            isDropDisabled: isDropDisabled,
            endCursor: endCursor,
            onLoadMore: onLoadMore,
            onRenderItem: onRenderItem,
            getDropAnimationWidth: getDropAnimationWidth,
            DroppableLayoutItemList: DroppableLayoutItemList
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, groups);
};

});
parcelRegister("8QDwl", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $6711d60dd8e02df4$var$escapeRegExp(string) {
    string = $jJVtR(string);
    return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
}
module.exports = $6711d60dd8e02df4$var$escapeRegExp;

});

parcelRegister("1tHhD", function(module, exports) {

$parcel$export(module.exports, "getItemWidth", () => $65f5fcaa35379c4a$export$61ce3db45e2dfb09);
$parcel$export(module.exports, "endSearchInteraction", () => $65f5fcaa35379c4a$export$dfdc2ab49f6fb02b);
$parcel$export(module.exports, "useAvailableLayoutItemGroups", () => $65f5fcaa35379c4a$export$6124559b96444468);
$parcel$export(module.exports, "getFieldsFilterDisabledReason", () => $65f5fcaa35379c4a$export$94a83ef5a352cb3d);
$parcel$export(module.exports, "useOnRenderLayoutItem", () => $65f5fcaa35379c4a$export$c2494e5babfbe95a);

var $5uXOq = parcelRequire("5uXOq");

var $5LFTH = parcelRequire("5LFTH");

var $7qDUb = parcelRequire("7qDUb");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6wesA = parcelRequire("6wesA");

var $2teXs = parcelRequire("2teXs");

var $7vmkt = parcelRequire("7vmkt");
const $65f5fcaa35379c4a$export$61ce3db45e2dfb09 = (style)=>{
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    if (style != null && typeof style.width === 'number') // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return style.width;
    return 0, $6wesA.DO_NOT_ANIMATE_WIDTH;
};
const $65f5fcaa35379c4a$export$dfdc2ab49f6fb02b = ()=>{};
const $65f5fcaa35379c4a$export$6124559b96444468 = (filter, itemGroups, returnAllGroups = false)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useMemo)(()=>{
        const uiGroups = itemGroups.map(({ groupId: groupId, ...rest })=>({
                ...rest,
                groupId: groupId,
                name: formatMessage((0, $7vmkt.default)[groupId])
            }));
        const [suggestedGroup] = (0, (/*@__PURE__*/$parcel$interopDefault($5LFTH)))(uiGroups, ({ groupId: groupId })=>groupId === (0, $6wesA.SUGGESTED_GROUP));
        const [restrictedGroup] = (0, (/*@__PURE__*/$parcel$interopDefault($5LFTH)))(uiGroups, ({ groupId: groupId })=>groupId === (0, $6wesA.RESTRICTED_GROUP));
        if (!returnAllGroups && !filter.name && suggestedGroup && (suggestedGroup.items.length > 0 || suggestedGroup.hasNextPage)) // if there is no filter, and we have some suggested fields
        // then we only return suggested fields and ignore all the other groups
        return [
            suggestedGroup
        ];
        // Sort the rest of the groups by name
        const sortedGroups = (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(uiGroups, ({ name: name })=>name);
        if (suggestedGroup) sortedGroups.unshift(suggestedGroup);
        if (restrictedGroup) sortedGroups.unshift(restrictedGroup);
        return sortedGroups.filter((group)=>group.items.length > 0 || group.hasNextPage);
    }, [
        itemGroups,
        filter,
        formatMessage,
        returnAllGroups
    ]);
};
const $65f5fcaa35379c4a$export$94a83ef5a352cb3d = (isGlobalAdmin, accessControl)=>{
    if (isGlobalAdmin || !accessControl || accessControl.userHasEditLayoutPermission && accessControl.isScreenIsolated) return undefined;
    const screenNotIsolatedMessageValue = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7vmkt.default).screenNotIsolatedMessageIssueTermRefresh : (0, $7vmkt.default).screenNotIsolatedMessage;
    const userDoesntHaveEditLayoutPermissionMessageValue = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7vmkt.default).userDoesntHaveEditLayoutPermissionMessageIssueTermRefresh : (0, $7vmkt.default).userDoesntHaveEditLayoutPermissionMessage;
    return accessControl.userHasEditLayoutPermission ? screenNotIsolatedMessageValue : userDoesntHaveEditLayoutPermissionMessageValue;
};
const $65f5fcaa35379c4a$export$c2494e5babfbe95a = ({ FieldComponent: FieldComponent, PanelComponent: PanelComponent, project: project, getIndexAfterUnsortableFields: getIndexAfterUnsortableFields, highlightRegExp: highlightRegExp })=>(0, $5uXOq.useCallback)((layoutItem, isDragging, scaleX, transition)=>{
        switch(layoutItem.layoutItemType){
            case 0, $2teXs.FIELD_LAYOUT_ITEM_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldComponent, {
                    highlightPattern: highlightRegExp,
                    isDragging: isDragging,
                    layoutItem: layoutItem,
                    scaleX: scaleX,
                    transition: transition,
                    getIndexAfterUnsortableFields: getIndexAfterUnsortableFields
                });
            case 0, $2teXs.PANEL_LAYOUT_ITEM_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PanelComponent, {
                    isDragging: isDragging,
                    layoutItem: layoutItem,
                    project: project,
                    isDescriptionVisible: false,
                    getIndexAfterUnsortableFields: getIndexAfterUnsortableFields
                });
            default:
                // prettier-ignore
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                layoutItem;
                return null;
        }
    }, // False positive saying FieldComponent and PanelComponent are unnecessary. https://github.com/facebook/react/issues/18051
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        FieldComponent,
        PanelComponent,
        getIndexAfterUnsortableFields,
        highlightRegExp
    ]);

});
parcelRegister("5LFTH", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $4r9Kx = parcelRequire("4r9Kx");
/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */ function $4331d77c9f973c3d$var$remove(array, predicate) {
    var result = [];
    if (!(array && array.length)) return result;
    var index = -1, indexes = [], length = array.length;
    predicate = $bxDef(predicate, 3);
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
        }
    }
    $4r9Kx(array, indexes);
    return result;
}
module.exports = $4331d77c9f973c3d$var$remove;

});
parcelRegister("4r9Kx", function(module, exports) {

var $ftdKz = parcelRequire("ftdKz");

var $e8U1z = parcelRequire("e8U1z");
/** Used for built-in method references. */ var $33b13f16cd434021$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $33b13f16cd434021$var$splice = $33b13f16cd434021$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */ function $33b13f16cd434021$var$basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while(length--){
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
            var previous = index;
            if ($e8U1z(index)) $33b13f16cd434021$var$splice.call(array, index, 1);
            else $ftdKz(array, index);
        }
    }
    return array;
}
module.exports = $33b13f16cd434021$var$basePullAt;

});


parcelRegister("7vmkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $de58287e1596f411$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $de58287e1596f411$var$messages = (0, $7VHMR.defineMessages)({
    whatIsThisContent: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.what-is-this-content",
        "defaultMessage": "Fields capture and display the information people need to carry out a project's work."
    },
    loadMoreButtonText: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.load-more-button-text",
        "defaultMessage": "Show next {count, plural, one {# field} other {# fields}}"
    },
    moreInformationAboutTheFieldsButtonText: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.more-information-about-the-fields-button-text",
        "defaultMessage": "More information about the fields"
    },
    suggestedGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.suggested-group",
        "defaultMessage": "Suggested fields"
    },
    assetsGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.assets-group",
        "defaultMessage": "Asset fields"
    },
    datesGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.dates-group",
        "defaultMessage": "Date and time fields"
    },
    labelsGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.labels-group",
        "defaultMessage": "Label fields"
    },
    numberGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.number-group",
        "defaultMessage": "Number fields"
    },
    peopleGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.people-group",
        "defaultMessage": "People and groups fields"
    },
    selectGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.select-group",
        "defaultMessage": "Select fields"
    },
    systemGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.system-group",
        "defaultMessage": "System fields"
    },
    textGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.text-group",
        "defaultMessage": "Text fields"
    },
    versionGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.version-group",
        "defaultMessage": "Version fields"
    },
    otherGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.other-group",
        "defaultMessage": "Other fields"
    },
    advancedGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.advanced-group",
        "defaultMessage": "Advanced fields"
    },
    restrictedGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.restricted-group",
        "defaultMessage": "Restricted fields"
    },
    aiSuggestedGroup: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.ai-suggested-group",
        "defaultMessage": "AI suggested fields"
    },
    suggestedGroupButtonText: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.suggested-group-button-text",
        "defaultMessage": "What are suggested fields?"
    },
    moreInformationAboutTheSuggestedFieldsButtonText: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.more-information-about-the-suggested-fields-button-text",
        "defaultMessage": "More information about the suggested fields"
    },
    userDoesntHaveEditLayoutPermissionMessage: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.user-doesnt-have-edit-layout-permission-message",
        "defaultMessage": "You need the \u2018Manage Issue Layouts\u2019 permission to add fields to an issue layout - contact your Jira Admin."
    },
    screenNotIsolatedMessage: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.screen-not-isolated-message",
        "defaultMessage": "The screen supporting this issue layout is shared by multiple projects, so only Jira Admins can add fields."
    },
    userDoesntHaveEditLayoutPermissionMessageIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.user-doesnt-have-edit-layout-permission-message-issue-term-refresh",
        "defaultMessage": "You need the \u2018Manage work item layouts\u2019 permission to add fields to a work item - contact your Jira Admin."
    },
    screenNotIsolatedMessageIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.screen-not-isolated-message-issue-term-refresh",
        "defaultMessage": "The screen supporting the layout of this work item is shared by multiple projects, so only Jira Admins can add fields."
    },
    emptyStateAltText: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.empty-state-alt-text",
        "defaultMessage": "This sidebar supports drag-and-drop fields."
    }
});
var $de58287e1596f411$export$2e2bcd8739ae039 = $de58287e1596f411$var$messages;

});



parcelRegister("4Po1l", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $be39e07f07c4e432$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $7vmkt = parcelRequire("7vmkt");

var $9CpnO = parcelRequire("9CpnO");
const $be39e07f07c4e432$var$EmptyStateNew = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be39e07f07c4e432$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be39e07f07c4e432$var$EmptyStateIcon, {
        alt: formatMessage((0, $7vmkt.default).emptyStateAltText),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9CpnO)))
    }), children);
};
const $be39e07f07c4e432$export$fddf379e22a74b00 = $be39e07f07c4e432$var$EmptyStateNew;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $be39e07f07c4e432$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bahfbqo _d58v1h6o",
            __cmplp.className
        ])
    });
});
const $be39e07f07c4e432$var$EmptyStateIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i146b _19pk1jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9CpnO", function(module, exports) {
module.exports = new URL("drag-and-drop-fields.ec193bdc.svg", import.meta.url).toString();

});


parcelRegister("cnxA1", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $2dba9003247fe9ed$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $hKL69 = parcelRequire("hKL69");

var $f1YXf = parcelRequire("f1YXf");

var $1Cagy = parcelRequire("1Cagy");
const $2dba9003247fe9ed$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.GrowingScrollableSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2dba9003247fe9ed$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2dba9003247fe9ed$var$ErrorStateIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f1YXf))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.StateText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("strong", null, formatMessage((0, $1Cagy.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), formatMessage((0, $1Cagy.default).message))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $2dba9003247fe9ed$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bahfbqo _d58v1h6o",
            __cmplp.className
        ])
    });
});
const $2dba9003247fe9ed$var$ErrorStateIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i146b _19pk1jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hKL69", function(module, exports) {

$parcel$export(module.exports, "PaddedSection", () => $309565519129b938$export$e2dbd7a9454dbf49);
$parcel$export(module.exports, "GrowingScrollableSection", () => $309565519129b938$export$e54b5b6fabb7bc08);
$parcel$export(module.exports, "PaddedColumnSection", () => $309565519129b938$export$c1d85af4d3094ecc);
$parcel$export(module.exports, "TitleWrapper", () => $309565519129b938$export$585a3b23e887288b);
$parcel$export(module.exports, "SidebarDescription", () => $309565519129b938$export$72520ef1652cfab3);
$parcel$export(module.exports, "SidebarDividingLine", () => $309565519129b938$export$e8f698a2cdc4f9b6);
$parcel$export(module.exports, "NoStyle", () => $309565519129b938$export$b26f334142381436);
$parcel$export(module.exports, "PaginationButtonsContainer", () => $309565519129b938$export$58cb4b0787b25613);
$parcel$export(module.exports, "FieldCategoryTitle", () => $309565519129b938$export$2847f19d8996527d);
$parcel$export(module.exports, "FieldCategoryWrapper", () => $309565519129b938$export$47fe97dcf374bdf8);
$parcel$export(module.exports, "StateText", () => $309565519129b938$export$2c7a587db7134b92);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $2tk6O = parcelRequire("2tk6O");
const $309565519129b938$export$e2dbd7a9454dbf49 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$e54b5b6fabb7bc08 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $309565519129b938$export$e2dbd7a9454dbf49, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _16jlkb7n _kqswh2mm _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$c1d85af4d3094ecc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2tk6O.Column), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$585a3b23e887288b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _19pkxy5q _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0qidpf _u5f3pxbi _n3tdidpf _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$72520ef1652cfab3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _19pkpxbi _y3gn1e5h _syaz1fxt _ca0qidpf _u5f3pxbi _n3tdidpf _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$d327f17106f5276b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$f0d8d8388ae63c2e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz131l _19pku2gc",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$e8f698a2cdc4f9b6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zludwz _19pkidpf _2hwxpxbi _otyridpf _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $309565519129b938$var$NoStyleComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$b26f334142381436 = ({ innerRef: innerRef, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309565519129b938$var$NoStyleComponent, {
        ...rest,
        ref: innerRef
    });
const $309565519129b938$export$58cb4b0787b25613 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvresu3 _1bahesu3",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$2847f19d8996527d = /*#__PURE__*/ (0, $47bDC.default).label.withConfig({
    componentId: "sc-1kcgcoe-0"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text-subtle, #44546F)"};display:block;margin-bottom:${"var(--ds-space-150, 12px)"};margin-top:${"var(--ds-space-150, 12px)"};`;
const $309565519129b938$export$47fe97dcf374bdf8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $309565519129b938$export$2c7a587db7134b92 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _19pkpxbi _y3gn1e5h _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("f1YXf", function(module, exports) {
module.exports = new URL("error.43445e70.svg", import.meta.url).toString();

});

parcelRegister("1Cagy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8c2433e1df8c4a9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $f8c2433e1df8c4a9$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.error-state.title",
        "defaultMessage": "We couldn\u2019t load the fields"
    },
    message: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.error-state.message",
        "defaultMessage": "Clear the search and try again."
    }
});
var $f8c2433e1df8c4a9$export$2e2bcd8739ae039 = $f8c2433e1df8c4a9$var$messages;

});


parcelRegister("5c9VP", function(module, exports) {

$parcel$export(module.exports, "FieldGroup", () => $e9d49ef26a543fbd$export$f0fe469072bc6950);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $aWse0 = parcelRequire("aWse0");

var $2NMNM = parcelRequire("2NMNM");

var $6wesA = parcelRequire("6wesA");

var $7vmkt = parcelRequire("7vmkt");

var $hKL69 = parcelRequire("hKL69");

var $1tHhD = parcelRequire("1tHhD");

var $0Qv8s = parcelRequire("0Qv8s");
const $e9d49ef26a543fbd$var$TriggerLoadNextPage = ({ groupId: groupId, endCursor: endCursor, pageSize: pageSize, onLoadMore: onLoadMore })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'load more',
            actionSubject: 'availableItemsGroup'
        });
        onLoadMore(groupId, endCursor, pageSize, analyticsEvent);
    }, [
        groupId,
        endCursor,
        pageSize,
        onLoadMore,
        createAnalyticsEvent
    ]);
    return null;
};
const $e9d49ef26a543fbd$export$f0fe469072bc6950 = ({ title: title, groupId: groupId, items: items, pageSize: pageSize, hasNextPage: hasNextPage, droppableListIdPrefix: droppableListIdPrefix, isDropDisabled: isDropDisabled, endCursor: endCursor, onLoadMore: onLoadMore, onRenderItem: onRenderItem, getDropAnimationWidth: getDropAnimationWidth, DroppableLayoutItemList: // TODO: It does not seem to be any variations of this component, refactor to use import instead of prop
DroppableLayoutItemList, messages: injectedMessages })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const onLoadMoreClick = (_, analyticsEvent)=>{
        if (endCursor !== null) onLoadMore(groupId, endCursor, pageSize, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.FieldCategoryWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.FieldCategoryTitle), null, title), groupId === (0, $6wesA.SUGGESTED_GROUP) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0Qv8s.WhatIsThis), {
        content: formatMessage(injectedMessages.suggestedGroupContent),
        buttonText: formatMessage((0, $7vmkt.default).moreInformationAboutTheSuggestedFieldsButtonText),
        componentId: "suggested-fields-section"
    })), hasNextPage && endCursor !== null && items.length < 2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9d49ef26a543fbd$var$TriggerLoadNextPage, {
        groupId: groupId,
        endCursor: endCursor,
        pageSize: pageSize,
        onLoadMore: onLoadMore
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DroppableLayoutItemList, {
        id: `${droppableListIdPrefix}${title}`,
        items: items,
        isDropDisabled: isDropDisabled,
        isDragDisabled: false,
        renderItem: onRenderItem,
        ListStyle: (0, $hKL69.NoStyle),
        getDropAnimationWidth: getDropAnimationWidth,
        getItemWidth: (0, $1tHhD.getItemWidth),
        dropHighlight: false,
        onRender: (0, $1tHhD.endSearchInteraction),
        minimumItemCount: 0
    }), hasNextPage && endCursor !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.PaginationButtonsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onLoadMoreClick
    }, formatMessage((0, $7vmkt.default).loadMoreButtonText, {
        count: pageSize
    }))) : null);
};

});
parcelRegister("0Qv8s", function(module, exports) {

$parcel$export(module.exports, "WhatIsThis", () => $41dd6799078c7aa9$export$347a58a7ea5d76ad);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $6tRzQ = parcelRequire("6tRzQ");

var $i0vxP = parcelRequire("i0vxP");

var $eHJxW = parcelRequire("eHJxW");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $41dd6799078c7aa9$export$347a58a7ea5d76ad = ({ buttonText: buttonText, content: content, componentId: componentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const sendAnalytics = (0, $5uXOq.useCallback)((nextIsOpen)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), `whatIsThisPopup ${nextIsOpen ? 'opened' : 'closed'}`, {
            componentId: componentId
        });
    }, [
        createAnalyticsEvent,
        componentId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        sendAnalytics(false);
        setIsOpen(false);
    }, [
        sendAnalytics,
        setIsOpen
    ]);
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        // we need to focus the button so that pressing ESC will close the popup
        if (buttonRef.current !== undefined && buttonRef.current !== null) buttonRef.current.focus();
        const nextIsOpen = !isOpen;
        sendAnalytics(nextIsOpen);
        setIsOpen(nextIsOpen);
    }, [
        buttonRef,
        sendAnalytics,
        setIsOpen,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($41dd6799078c7aa9$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        onClose: onClose,
        content: content,
        isOpen: isOpen,
        placement: "right",
        onContentBlur: onClose,
        messageId: "project-settings-apps-issue-type-page-product-features.common.ui.sidebar.what-is-this.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        isSelected: isOpen,
        onClick: onToggle,
        ref: buttonRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }),
        label: buttonText,
        "aria-label": buttonText
    }))));
};
// We want to allow translated messages to be broken up across multiple lines
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $41dd6799078c7aa9$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});


parcelRegister("47FNU", function(module, exports) {

$parcel$export(module.exports, "FilterEfa", () => $6ceb19c24b13cda4$export$af17f07cc1a05bbe);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");

var $3bDjY = parcelRequire("3bDjY");

var $fraBZ = parcelRequire("fraBZ");

var $gzH4T = parcelRequire("gzH4T");

var $koVbs = parcelRequire("koVbs");

var $2xSAL = parcelRequire("2xSAL");

var $6wesA = parcelRequire("6wesA");

var $i8Swm = parcelRequire("i8Swm");
const $6ceb19c24b13cda4$export$af17f07cc1a05bbe = ({ onChange: onChange, asyncState: asyncState, filter: filter, totalAvailableItemsCount: totalAvailableItemsCount, disabledReason: disabledReason })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onSearchFieldChange = (searchTerm, analyticsEvent)=>onChange({
            name: searchTerm
        }, analyticsEvent);
    const message = filter.name ? (0, $i8Swm.messages).matchingItemsCount : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small"
    }, formatMessage((0, $i8Swm.messages).filterLabel)), disabledReason === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        key: "filter",
        value: filter.name,
        onChange: onSearchFieldChange,
        isAutocompleteDisabled: true,
        placeholder: formatMessage((0, $i8Swm.messages).filterPlaceholder),
        shouldFitContainerWidth: true,
        // placeholder for SearchField is hidden by default, so we have to override it
        placeholderAlwaysVisible: true
    }), asyncState === (0, $6wesA.LOADING) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null) : message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage(message, {
        count: totalAvailableItemsCount
    })), message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: formatMessage(message, {
            count: totalAvailableItemsCount
        }),
        shouldAnnounce: asyncState !== (0, $6wesA.LOADING)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(disabledReason)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        key: "filter",
        value: filter.name,
        onChange: onSearchFieldChange,
        isAutocompleteDisabled: true,
        placeholder: formatMessage((0, $i8Swm.messages).filterPlaceholder),
        shouldFitContainerWidth: true,
        // placeholder for SearchField is hidden by default, so we have to override it
        placeholderAlwaysVisible: true,
        isDisabled: true
    })));
};

});
parcelRegister("fraBZ", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $f73a83ae5cba96ea$export$a43c8a2f4981e0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dqoiX = parcelRequire("dqoiX");
const $f73a83ae5cba96ea$var$NON_BREAKING_SPACE = '\u00A0';
const $f73a83ae5cba96ea$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $5uXOq.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $5uXOq.useRef)('');
    const setAlternatePolite = (0, $5uXOq.useRef)(false);
    const addSuffix = (0, $5uXOq.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $5uXOq.useState)('');
    const [newMessage, setNewMessage] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dqoiX.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ $5uXOq.createElement((0, $dqoiX.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});
const $f73a83ae5cba96ea$var$positionRelative = null;

});

parcelRegister("gzH4T", function(module, exports) {

$parcel$export(module.exports, "Fill", () => $86943b3dfe04c963$export$ffffe40bfa0649a3);
/* fill.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");
const $86943b3dfe04c963$export$ffffe40bfa0649a3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1e0c1o8l _aetryzv1",
            __cmplp.className
        ])
    });
});
var $86943b3dfe04c963$export$2e2bcd8739ae039 = $86943b3dfe04c963$export$ffffe40bfa0649a3;

});
parcelRegister("1wbtX", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "SkeletonCompiled", () => $39c21c8edc6f2616$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $39c21c8edc6f2616$export$e477bb7d17087f28);
$parcel$export(module.exports, "Skeleton", () => $39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $39c21c8edc6f2616$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $47bDC.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
const $39c21c8edc6f2616$export$1d2144641222f3bd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
        animationTimingFunction: 'linear',
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        backgroundImage: `linear-gradient( to right, ${"var(--ds-skeleton, #091E420F)"} 10%, ${"var(--ds-skeleton-subtle, #091E4208)"} 30%, ${"var(--ds-skeleton, #091E420F)"} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $39c21c8edc6f2616$export$b1deee0d21f1be36 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $39c21c8edc6f2616$export$dc84d515085190e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$dc84d515085190e, $39c21c8edc6f2616$export$1d2144641222f3bd);
const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$e477bb7d17087f28, $39c21c8edc6f2616$export$b1deee0d21f1be36);

});


parcelRegister("2xSAL", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $f115db1c327fbbaa$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");

var $2NMNM = parcelRequire("2NMNM");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cBssJ = parcelRequire("cBssJ");

var $hJBhl = parcelRequire("hJBhl");

var $5yLnO = parcelRequire("5yLnO");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInput = (0, $5uXOq.useRef)(null);
    const previousValueRef = (0, $5uXOq.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $f115db1c327fbbaa$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJBhl.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? {
            reducedHeight: reducedHeight
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
$f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $f115db1c327fbbaa$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
$f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f115db1c327fbbaa$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $f115db1c327fbbaa$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $lD23V.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $lD23V.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $lD23V.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cBssJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08273d4fc2a6d6da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("hJBhl", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $99940a7c159b00c0$export$84038b503874befa);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");
const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $99940a7c159b00c0$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ)))
    }));
const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $h9kUS.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("5yLnO", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $71cc18983db63a0d$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $71cc18983db63a0d$export$8a82bff895521bd9);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $26g7Y = parcelRequire("26g7Y");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");
const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStyles,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStylesBefore,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
const $71cc18983db63a0d$var$wrapperStyles = (0, $8CUq3.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $71cc18983db63a0d$var$spacingStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $71cc18983db63a0d$var$wrapperStylesBefore = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $71cc18983db63a0d$var$spacingStylesBefore = (0, $8CUq3.xcss)({
    marginLeft: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});


parcelRegister("i8Swm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7adadb5ed435bbbb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7adadb5ed435bbbb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    filterPlaceholder: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.filter.filter-placeholder",
        "defaultMessage": "Type to search"
    },
    filterLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.filter.filter-label",
        "defaultMessage": "Search fields in this project"
    },
    matchingItemsCount: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.filter.matching-items-count",
        "defaultMessage": "{count, plural, one {# result matches} other {# results match}} your search"
    }
});

});


parcelRegister("8riZJ", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $93d2cabaec6634aa$export$ec91da630f36d5ea);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $fraBZ = parcelRequire("fraBZ");

var $gzH4T = parcelRequire("gzH4T");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2xSAL = parcelRequire("2xSAL");

var $6wesA = parcelRequire("6wesA");

var $5gW5v = parcelRequire("5gW5v");
const $93d2cabaec6634aa$export$ec91da630f36d5ea = ({ onChange: onChange, asyncState: asyncState, filter: filter, totalAvailableItemsCount: totalAvailableItemsCount, disabledReason: disabledReason })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onSearchFieldChange = (searchTerm, analyticsEvent)=>onChange({
            name: searchTerm
        }, analyticsEvent);
    const totalCountMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $5gW5v.default).totalCountIssueTermRefresh : (0, $5gW5v.default).totalCount;
    const message = filter.name ? (0, $5gW5v.default).matchingItemsCount : totalCountMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93d2cabaec6634aa$var$SearchFieldWrapper, null, (0, $6s1PB.expValEquals)('tmp_issue_type_edit_changes_reducing_duplicate_cfs', 'cohort', 'experiment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $93d2cabaec6634aa$var$searchFieldLabelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: "filter"
    }, formatMessage((0, $5gW5v.default).filterLabel))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93d2cabaec6634aa$var$SearchFieldLabelOld, null, formatMessage((0, $5gW5v.default).filterLabel)), disabledReason === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        key: "filter",
        value: filter.name,
        onChange: onSearchFieldChange,
        isAutocompleteDisabled: true,
        placeholder: formatMessage((0, $5gW5v.default).filterPlaceholder),
        shouldFitContainerWidth: true // placeholder for SearchField is hidden by default, so we have to override it
        ,
        placeholderAlwaysVisible: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93d2cabaec6634aa$var$TotalCountWrapper, null, asyncState === (0, $6wesA.LOADING) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93d2cabaec6634aa$var$TotalCount, null, formatMessage(message, {
        count: totalAvailableItemsCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: formatMessage(message, {
            count: totalAvailableItemsCount
        }),
        shouldAnnounce: asyncState !== (0, $6wesA.LOADING)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(disabledReason)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        key: "filter",
        value: filter.name,
        onChange: onSearchFieldChange,
        isAutocompleteDisabled: true,
        placeholder: formatMessage((0, $5gW5v.default).filterPlaceholder),
        shouldFitContainerWidth: true // placeholder for SearchField is hidden by default, so we have to override it
        ,
        placeholderAlwaysVisible: true,
        isDisabled: true
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93d2cabaec6634aa$var$SearchFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrutpp _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $93d2cabaec6634aa$var$searchFieldLabelStyles = (0, $8CUq3.xcss)({
    font: 'font.heading.xxsmall',
    color: 'color.text.subtle',
    paddingBottom: 'space.025',
    paddingTop: 'space.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93d2cabaec6634aa$var$SearchFieldLabelOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93d2cabaec6634aa$var$TotalCount = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _y3gn1e5h _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93d2cabaec6634aa$var$TotalCountWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1b66 _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5gW5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $72737c03af7c2f68$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $72737c03af7c2f68$var$messages = (0, $7VHMR.defineMessages)({
    filterPlaceholder: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.filter.filter-placeholder",
        "defaultMessage": "Type to search all fields"
    },
    filterLabel: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.filter.filter-label",
        "defaultMessage": "Search all fields"
    },
    totalCount: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.filter.total-count",
        "defaultMessage": "Reuse {count, plural, one {# field} other {# fields}} from other issue types and projects"
    },
    matchingItemsCount: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.filter.matching-items-count",
        "defaultMessage": "{count, plural, one {# result} other {# results}} match your search"
    },
    totalCountIssueTermRefresh: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.filter.total-count-issue-term-refresh",
        "defaultMessage": "Reuse {count, plural, one {# field} other {# fields}} from other work types and projects"
    }
});
var $72737c03af7c2f68$export$2e2bcd8739ae039 = $72737c03af7c2f68$var$messages;

});


parcelRegister("6HQIb", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $5f986d7578102ece$export$62aa48085237e36f);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $gzH4T = parcelRequire("gzH4T");

var $1wbtX = parcelRequire("1wbtX");

var $hKL69 = parcelRequire("hKL69");
const $5f986d7578102ece$export$62aa48085237e36f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.GrowingScrollableSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.FieldCategoryTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f986d7578102ece$var$Field, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f986d7578102ece$var$Field, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f986d7578102ece$var$Field, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f986d7578102ece$var$Field, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f986d7578102ece$var$Field, null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f986d7578102ece$var$Field = /*#__PURE__*/ (0, $47bDC.default)((0, $1wbtX.Skeleton)).withConfig({
    componentId: "sc-1os3ipi-0"
})({
    width: '100%',
    height: '42px',
    marginBottom: "var(--ds-space-050, 4px)"
});

});

parcelRegister("d5sKj", function(module, exports) {

$parcel$export(module.exports, "NotFoundState", () => $465abdf1e2556c6a$export$383d78f578494ab6);

var $5uXOq = parcelRequire("5uXOq");

var $hKL69 = parcelRequire("hKL69");
const $465abdf1e2556c6a$export$383d78f578494ab6 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.GrowingScrollableSection), null, children);

});

parcelRegister("1Sxkt", function(module, exports) {

$parcel$export(module.exports, "isGlobalAdmin", () => $aff18c01c0e82c70$export$6b0a59ae858cb499);
const $aff18c01c0e82c70$export$6b0a59ae858cb499 = (tenantContext)=>tenantContext.isAdmin;

});

parcelRegister("d5Xd9", function(module, exports) {

$parcel$export(module.exports, "FieldTypes", () => $2b91c54d067d1003$export$6c2fadcd8bf80d96);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $6wesA = parcelRequire("6wesA");

var $4VVNr = parcelRequire("4VVNr");

var $4R6GH = parcelRequire("4R6GH");

var $gSOBs = parcelRequire("gSOBs");
const $2b91c54d067d1003$export$6c2fadcd8bf80d96 = ({ FieldTypeList: FieldTypeList, isFieldsLimitReached: isFieldsLimitReached, availableFieldTypes: availableFieldTypes, fieldLimitPerProject: fieldLimitPerProject, isMouseDragging: isMouseDragging, onFieldTypeClicked: onFieldTypeClicked, getDropAnimationWidth: getDropAnimationWidth })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4VVNr.ExpandableSection), {
        initialOpen: !(0, $6s1PB.expValEquals)('tmp_issue_type_edit_changes_reducing_duplicate_cfs', 'cohort', 'experiment'),
        variant: (0, $6s1PB.expValEquals)('tmp_issue_type_edit_changes_reducing_duplicate_cfs', 'cohort', 'experiment') ? 'regular' : 'large',
        label: formatMessage((0, $gSOBs.default).title),
        description: (0, $4R6GH.fg)('itsm-issue-renaming') ? formatMessage((0, $gSOBs.default).descriptionIssueTermRefresh) : formatMessage((0, $gSOBs.default).description)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldTypeList, {
        isDisabled: isFieldsLimitReached,
        messageTooltipWhenDisabled: formatMessage((0, $gSOBs.default).fieldCreationLimitReached, {
            fieldLimit: fieldLimitPerProject
        }),
        id: (0, $6wesA.FIELD_TYPE_LIST),
        items: availableFieldTypes,
        areItemsClickable: !isMouseDragging,
        onFieldTypeClicked: onFieldTypeClicked,
        getDropAnimationWidth: getDropAnimationWidth
    }));
};

});
parcelRegister("4VVNr", function(module, exports) {

$parcel$export(module.exports, "ExpandableSection", () => $b4a645265151830c$export$e86ef41bc845761);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $hWZau = parcelRequire("hWZau");

var $6s76W = parcelRequire("6s76W");
const $b4a645265151830c$export$e86ef41bc845761 = ({ children: children, label: label, description: description, initialOpen: initialOpen, variant: variant = 'regular' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4a645265151830c$var$ExpandableSectionContainer, {
        open: initialOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4a645265151830c$var$Trigger, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4a645265151830c$var$TriggerText, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4a645265151830c$var$TriggerIconContainer, null, variant === 'regular' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-text, #172B4D)"
    }), variant === 'large' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6s76W))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-text, #172B4D)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4a645265151830c$var$HiddenContentContainer, {
        hasDescription: Boolean(description)
    }, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4a645265151830c$var$Description, null, description), children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4a645265151830c$var$TriggerIconContainer = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1nc8442-0"
})({
    display: 'inline-flex',
    transition: 'transform 250ms cubic-bezier(0.15, 1, 0.3, 1)'
});
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4a645265151830c$var$ExpandableSectionContainer = /*#__PURE__*/ (0, $47bDC.default).details.withConfig({
    componentId: "sc-1nc8442-1"
})`&[open]{${$b4a645265151830c$var$TriggerIconContainer}{transform:rotate(90deg);}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4a645265151830c$var$Trigger = /*#__PURE__*/ (0, $47bDC.default).summary.withConfig({
    componentId: "sc-1nc8442-2"
})({
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    /** Copied from Button component version ^16.3.5 */ transition: '0.1s ease-out 0s',
    transitionProperty: 'background-color, margin-left, padding-left',
    '&:hover': {
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
        borderRadius: '3px',
        marginLeft: "var(--ds-space-negative-075, -6px)",
        paddingLeft: "var(--ds-space-075, 6px)"
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4a645265151830c$var$TriggerText = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1nc8442-3"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text-subtle, #44546F)"};margin-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4a645265151830c$var$Description = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "sc-1nc8442-4"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text-subtle, #44546F)"};margin-top:0;margin-bottom:${"var(--ds-space-200, 16px)"};`;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4a645265151830c$var$HiddenContentContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1nc8442-5"
})`${({ hasDescription: hasDescription })=>!hasDescription && (0, $47bDC.css)({
        marginTop: "var(--ds-space-050, 4px)"
    })}`;

});
parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});


parcelRegister("gSOBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f860213e891f23$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a6f860213e891f23$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "project-settings-apps.issue-type-page.fields.fields-toolbar.create-field-title",
        "defaultMessage": "Create a field"
    },
    description: {
        "id": "project-settings-apps.issue-type-page.fields.fields-toolbar.create-field-description",
        "defaultMessage": "Drag a field type to one of the sections on the left to create a custom field for this issue type."
    },
    descriptionIssueTermRefresh: {
        "id": "project-settings-apps.issue-type-page.fields.fields-toolbar.create-field-description-issue-term-refresh",
        "defaultMessage": "Drag a field type to one of the sections on the left to create a custom field for this work type."
    },
    fieldCreationLimitReached: {
        "id": "project-settings-apps.issue-type-page.fields.fields-toolbar.field-creation-limit-reached",
        "defaultMessage": "You can\u2019t create more than {fieldLimit} fields in this project. You can reuse previously created fields."
    }
});
var $a6f860213e891f23$export$2e2bcd8739ae039 = $a6f860213e891f23$var$messages;

});


parcelRegister("6Ae0x", function(module, exports) {

$parcel$export(module.exports, "fieldGroupMessages", () => $7cfa9ae0aad48949$export$64501e2a2c71147a);
$parcel$export(module.exports, "default", () => $7cfa9ae0aad48949$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7cfa9ae0aad48949$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.title",
        "defaultMessage": "Fields"
    },
    whatIsThisContent: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.what-is-this-content",
        "defaultMessage": "Fields capture and display the information people need to carry out a project's work"
    },
    moreInformationAboutTheFieldsButtonText: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.more-information-about-the-fields-button-text",
        "defaultMessage": "More information about the fields"
    },
    emptyStateTitle: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.empty-state-title",
        "defaultMessage": "Drag fields here to remove them"
    },
    emptyStateMessage: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.empty-state-message",
        "defaultMessage": "Fields in this area aren\u2019t shown in the issue view for this request type. You can drag the fields back to the left to show them."
    },
    emptyStateMessageIssueTermRefresh: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.empty-state-message-issue-term-refresh",
        "defaultMessage": "Fields in this area aren\u2019t shown in the work item view for this request type. You can drag the fields back to the left to show them."
    },
    notFoundStateTitle: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.not-found-state-title",
        "defaultMessage": "We couldn\u2019t find what you\u2019re looking for."
    },
    notFoundStateTitleWithProjectName: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.not-found-state-title-with-project-name",
        "defaultMessage": "No fields found in \"{projectName}\" match that search"
    },
    notFoundStateMessage: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.not-found-state-message",
        "defaultMessage": "Try searching for something else or create a new field."
    },
    notFoundStateMessageWithFieldsPage: {
        "id": "project-settings-product-features-jsw-tmp.sidebar.not-found-state-message-with-fields-page",
        "defaultMessage": "Add fields to your project on the fields page to use it here."
    }
});
const $7cfa9ae0aad48949$export$64501e2a2c71147a = (0, $7VHMR.defineMessages)({
    suggestedGroupContent: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.suggested-group-content",
        "defaultMessage": "These fields were recently created, or are currently used in this project."
    }
});
var $7cfa9ae0aad48949$export$2e2bcd8739ae039 = $7cfa9ae0aad48949$var$messages;

});

parcelRegister("bMszT", function(module, exports) {

$parcel$export(module.exports, "RestrictedFieldGroup", () => $60baca34f1e8f43d$export$4d0d4147c805f711);

var $5uXOq = parcelRequire("5uXOq");

var $58he2 = parcelRequire("58he2");

var $g1Czu = parcelRequire("g1Czu");
const $60baca34f1e8f43d$export$4d0d4147c805f711 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58he2.RestrictedFieldGroup), {
        ...props,
        restrictedFieldGroupMessages: (0, $g1Czu.messages)
    });

});
parcelRegister("58he2", function(module, exports) {

$parcel$export(module.exports, "RestrictedFieldGroup", () => $b94e045bc029eeec$export$4d0d4147c805f711);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $16T6Y = parcelRequire("16T6Y");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1Sxkt = parcelRequire("1Sxkt");

var $gt8X2 = parcelRequire("gt8X2");

var $4VVNr = parcelRequire("4VVNr");

var $5c9VP = parcelRequire("5c9VP");

var $hKL69 = parcelRequire("hKL69");
const $b94e045bc029eeec$var$PRODUCT_HELP_ARTICLE_ID = '6I42ggwGORmP84atFaD3hS';
const $b94e045bc029eeec$var$PRODUCT_HELP_LINK = 'https://support.atlassian.com/jira-cloud-administration/docs/configure-a-custom-field/#Troubleshoot-issue-configuration-and-context';
const $b94e045bc029eeec$export$4d0d4147c805f711 = ({ restrictedFieldGroupMessages: restrictedFieldGroupMessages, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const restrictedFieldSectionLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b94e045bc029eeec$var$RestrictedFieldSectionLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? restrictedFieldGroupMessages.labelIssueTermRefresh : restrictedFieldGroupMessages.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, props.totalCount));
    const restrictedFieldDescription = ()=>{
        const descriptionGlobalAdminMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? restrictedFieldGroupMessages.descriptionGlobalAdminIssueTermRefresh : restrictedFieldGroupMessages.descriptionGlobalAdmin;
        const descriptionNonGlobalAdminMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? restrictedFieldGroupMessages.descriptionNonGlobalAdminIssueTermRefresh : restrictedFieldGroupMessages.descriptionNonGlobalAdmin;
        return (0, $1Sxkt.isGlobalAdmin)(props.tenant) ? descriptionGlobalAdminMessage : descriptionNonGlobalAdminMessage;
    }; // @ts-expect-error - TS2769 - No overload matches this call.
    const restrictedFieldSectionDescription = formatMessage(restrictedFieldDescription(), {
        link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gt8X2.IPHLink), {
                articleId: $b94e045bc029eeec$var$PRODUCT_HELP_ARTICLE_ID,
                documentationUrl: $b94e045bc029eeec$var$PRODUCT_HELP_LINK,
                linkText: {
                    // Text that we get is already translated at this point and we're interested in the pure string only, so we only add this random id to comply with the API
                    // and to make sure no real translation will be put under this fake key
                    id: 'c29tZSBoYXNoIGZvciByZWFjdC1pbnRsIGtleQ==.no-translate',
                    defaultMessage: text[0]
                }
            })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b94e045bc029eeec$var$restrictedFieldGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4VVNr.ExpandableSection), {
        label: restrictedFieldSectionLabel,
        description: restrictedFieldSectionDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5c9VP.FieldGroup), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b94e045bc029eeec$var$DividingLineContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.SidebarDividingLine), null))));
};
const $b94e045bc029eeec$var$restrictedFieldGroupContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050',
    marginBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b94e045bc029eeec$var$RestrictedFieldSectionLabelContainer = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "cj72lp-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '> *:first-child': {
        marginRight: "var(--ds-space-100, 8px)"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b94e045bc029eeec$var$DividingLineContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81y3u",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g1Czu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eeffecd39a8cc9ca$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $eeffecd39a8cc9ca$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.label",
        "defaultMessage": "Fields unavailable in the issue view"
    },
    labelIssueTermRefresh: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.label-issue-term-refresh",
        "defaultMessage": "Fields unavailable in the work item view"
    },
    descriptionGlobalAdmin: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.description-global-admin",
        "defaultMessage": "These fields will not be available in the issue view even if you drag them to the issue layout as the fields don\u2019t have a global context. <link>See why fields aren\u2019t visible in the issue view.</link>"
    },
    descriptionGlobalAdminIssueTermRefresh: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.description-global-admin-issue-term-refresh",
        "defaultMessage": "These fields will not be available in the work item view even if you drag them to the work item layout as the fields don\u2019t have a global context. <link>See why fields aren\u2019t visible in the work item view.</link>"
    },
    descriptionNonGlobalAdmin: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.description-non-global-admin",
        "defaultMessage": "These fields will not be available in the issue view even if you drag them to the issue layout as the fields don\u2019t have a global context. <link>Reach out to your Jira admin.</link>"
    },
    descriptionNonGlobalAdminIssueTermRefresh: {
        "id": "project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.description-non-global-admin-issue-term-refresh",
        "defaultMessage": "These fields will not be available in the work item view even if you drag them to the work item layout as the fields don\u2019t have a global context. <link>Reach out to your Jira admin.</link>"
    }
});

});


parcelRegister("2d6uN", function(module, exports) {

$parcel$export(module.exports, "SidebarFooter", () => $acd6d929c044f7f1$export$dce6987161f0823a);

var $5uXOq = parcelRequire("5uXOq");

var $j6d2H = parcelRequire("j6d2H");

var $hKL69 = parcelRequire("hKL69");

var $2tk6O = parcelRequire("2tk6O");

var $6s1PB = parcelRequire("6s1PB");
const $acd6d929c044f7f1$export$dce6987161f0823a = ({ isGlobalAdmin: isGlobalAdmin, isEfaEnabled: isEfaEnabled, project: project })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    const isEfaFooterEnabled = isEfaEnabled && project?.simplified && expConfig.get('isEnabled', false);
    if (!isGlobalAdmin && !isEfaFooterEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tk6O.Column), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.SidebarDividingLine), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6d2H.SidebarFindFieldHelpLink), {
        isEfaEnabled: isEfaEnabled,
        isGlobalAdmin: isGlobalAdmin,
        project: project
    }));
};

});
parcelRegister("j6d2H", function(module, exports) {

$parcel$export(module.exports, "SidebarFindFieldHelpLink", () => $ed4d2e84c8644d1a$export$8d4f906c86371b76);

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $dpnNB = parcelRequire("dpnNB");

var $1W5F5 = parcelRequire("1W5F5");
const $ed4d2e84c8644d1a$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};
const $ed4d2e84c8644d1a$export$8d4f906c86371b76 = (0, $7XYc4.componentWithCondition)($ed4d2e84c8644d1a$var$isEfaExperimentExposed, (0, $dpnNB.SidebarFindFieldHelpLinkWithEfaEnabled), (0, $1W5F5.SidebarFindFieldHelpLinkToGlobalSettings));

});
parcelRegister("dpnNB", function(module, exports) {

$parcel$export(module.exports, "SidebarFindFieldHelpLinkWithEfaEnabled", () => $60660de71ec05635$export$1fb03565204990d6);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $lN1S8 = parcelRequire("lN1S8");

var $2uIDL = parcelRequire("2uIDL");
const $60660de71ec05635$var$Wrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        alignInline: "start"
    }, children));
const $60660de71ec05635$var$LinkToGlobalSettings = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60660de71ec05635$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $2uIDL.messages).helpMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
        href: (0, $4R6GH.fg)('centralized-fields-page-m1') ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa'
    }, formatMessage((0, $2uIDL.messages).helpLink)));
};
const $60660de71ec05635$var$ContactAdminLink = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60660de71ec05635$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $2uIDL.messages).helpMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
        href: "/secure/ContactAdministrators!default.jspa"
    }, formatMessage((0, $2uIDL.messages).contactAdminLink)));
};
const $60660de71ec05635$var$FieldsPageLink = ({ project: project })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60660de71ec05635$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $2uIDL.messages).findGlobalField)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
        href: `/jira/software/projects/${project.projectKey}/settings/fields`
    }, formatMessage((0, $2uIDL.messages).helpLinkToFieldsPage)));
};
const $60660de71ec05635$export$1fb03565204990d6 = ({ project: project, isEfaEnabled: isEfaEnabled, isGlobalAdmin: isGlobalAdmin })=>{
    // We're making assumption here that every simplified project supports EFA. I'm afraid that might bite us later, perhaps this should be a ProjectFeature instead?
    if (isEfaEnabled && project?.simplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60660de71ec05635$var$FieldsPageLink, {
        project: project
    });
    if (isGlobalAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60660de71ec05635$var$LinkToGlobalSettings, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60660de71ec05635$var$ContactAdminLink, null);
};

});
parcelRegister("2uIDL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e85ef1dad3e168d0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e85ef1dad3e168d0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    helpMessage: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.help-message",
        "defaultMessage": "Can\u2019t find a field?"
    },
    findGlobalField: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.find-global-field",
        "defaultMessage": "Need to add a global field?"
    },
    helpLink: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.help-link",
        "defaultMessage": "Go to custom fields"
    },
    helpLinkToFieldsPage: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.help-link-to-fields-page",
        "defaultMessage": "Go to the Fields page"
    },
    contactAdminLink: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.contact-admin-link",
        "defaultMessage": "Contact your Jira admin"
    }
});

});


parcelRegister("1W5F5", function(module, exports) {

$parcel$export(module.exports, "SidebarFindFieldHelpLinkToGlobalSettings", () => $11117ac91f5c981e$export$cbf4b47b396ca13a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $lN1S8 = parcelRequire("lN1S8");

var $hKL69 = parcelRequire("hKL69");

var $dgqc9 = parcelRequire("dgqc9");
const $11117ac91f5c981e$export$cbf4b47b396ca13a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Show appropriate messages for site + Jira admins. See https://hello.atlassian.net/wiki/spaces/JPCE/pages/1234159989/FE+How+do+I+tell+which+admin+am+I#Tenant-context
    const isGlobalAdmin = (0, $itmJb.useIsAdmin)();
    const customFieldsLink = (0, $4R6GH.fg)('centralized-fields-page-m1') ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa';
    const buttonLink = isGlobalAdmin ? customFieldsLink : '/secure/ContactAdministrators!default.jspa';
    const buttonLinkDescriptor = isGlobalAdmin ? (0, $dgqc9.default).helpLink : (0, $dgqc9.default).contactAdminLink;
    const buttonClickedEventName = isGlobalAdmin ? 'goToCustomFields' : 'contactYourJiraAdmin';
    const buttonOnClick = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, buttonClickedEventName, {
            isAuxClick: false
        });
    };
    const buttonOnAuxClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', buttonClickedEventName, {
            isAuxClick: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKL69.PaddedSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11117ac91f5c981e$var$TextWithSpacing, null, formatMessage((0, $dgqc9.default).helpMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lN1S8.NewTabLink), {
        href: buttonLink,
        onClick: buttonOnClick,
        onAuxClick: buttonOnAuxClick
    }, formatMessage(buttonLinkDescriptor)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11117ac91f5c981e$var$TextWithSpacing = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dgqc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9176c8d13da36cf7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $9176c8d13da36cf7$var$messages = (0, $7VHMR.defineMessages)({
    helpMessage: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.help-message",
        "defaultMessage": "Can\u2019t find a field?"
    },
    helpLink: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.help-link",
        "defaultMessage": "Go to custom fields"
    },
    contactAdminLink: {
        "id": "project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.contact-admin-link",
        "defaultMessage": "Contact your Jira admin"
    }
});
var $9176c8d13da36cf7$export$2e2bcd8739ae039 = $9176c8d13da36cf7$var$messages;

});





parcelRegister("gurvk", function(module, exports) {

$parcel$export(module.exports, "ViewButtonWrapper", () => $7db9117d20cf6701$export$b471d248f3620f23);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $1GGwS = parcelRequire("1GGwS");

var $ggICg = parcelRequire("ggICg");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $9ut4M = parcelRequire("9ut4M");

var $cgvPO = parcelRequire("cgvPO");

var $gGU25 = parcelRequire("gGU25");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7Ertg = parcelRequire("7Ertg");
const $7db9117d20cf6701$var$ViewButton = ({ rootContainerId: rootContainerId, projectId: projectId, didUserChangeAnything: didUserChangeAnything })=>{
    const intl = (0, $koVbs.default)();
    const sendAnalytics = (event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'textField clicked', 'viewIssueLayout');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ut4M.default), {
        projectId: projectId
    }, ({ servicedeskPortalId: servicedeskPortalId })=>// @ts-expect-error - TS2322 - Type 'false | Element' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
        servicedeskPortalId !== undefined && // eslint-disable-next-line jira/ff/no-preconditioning
        ((0, $4R6GH.fg)('viewed_portal_event_check_for_cortops') && (0, $6s1PB.expValEquals)('_connecting_request_types_on_portal', 'cohort', 'variation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
            isDisabled: didUserChangeAnything,
            onClick: sendAnalytics,
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))),
            href: `/servicedesk/customer/portal/${servicedeskPortalId}/create/${rootContainerId}`,
            target: "_blank",
            testId: "project-settings-product-features-jsm-tmp.ui.view-button.portal-id-cortops"
        }, intl.formatMessage((0, $cgvPO.viewButton).viewInPortal)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            isDisabled: didUserChangeAnything,
            onClick: sendAnalytics,
            href: `/servicedesk/customer/portal/${servicedeskPortalId}/create/${rootContainerId}`,
            target: "_blank",
            testId: "project-settings-product-features-jsm-tmp.ui.view-button.portal-id"
        }, intl.formatMessage((0, $cgvPO.viewButton).view))));
};
const $7db9117d20cf6701$var$ViewButtonActual = (props)=>{
    const intl = (0, $koVbs.default)();
    const { rootContainerId: requestTypeId, projectKey: projectKey, didUserChangeAnything: didUserChangeAnything } = props;
    const sendAnalytics = (event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'textField clicked', 'viewIssueLayout');
    };
    const { portalId: portalId, portalUrl: portalUrl } = (0, $gGU25.usePortalId)({
        projectKey: projectKey,
        requestTypeId: requestTypeId
    });
    const showButton = portalId && portalUrl;
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('viewed_portal_event_check_for_cortops') && (0, $6s1PB.expValEquals)('_connecting_request_types_on_portal', 'cohort', 'variation')) return showButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        isDisabled: didUserChangeAnything,
        onClick: sendAnalytics,
        href: `${portalUrl}/create/${requestTypeId}`,
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))),
        target: "_blank",
        testId: "project-settings-product-features-jsm-tmp.ui.view-button.portal-url-cortops"
    }, intl.formatMessage((0, $cgvPO.viewButton).viewInPortal)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7db9117d20cf6701$var$ViewButton, props);
    return showButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        isDisabled: didUserChangeAnything,
        onClick: sendAnalytics,
        href: `${portalUrl}/create/${requestTypeId}`,
        target: "_blank",
        testId: "project-settings-product-features-jsm-tmp.ui.view-button.portal-url"
    }, intl.formatMessage((0, $cgvPO.viewButton).view)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7db9117d20cf6701$var$ViewButton, props);
};
const $7db9117d20cf6701$export$b471d248f3620f23 = (props)=>{
    const intl = (0, $koVbs.default)();
    const { projectKey: projectKey, didUserChangeAnything: didUserChangeAnything, tooltipDelay: tooltipDelay } = props;
    if (projectKey === undefined || projectKey === '') {
        (0, $jcw0u.default)({
            meta: {
                id: 'jsmViewButton.projectKeyReadError.tmp',
                packageName: (0, $7Ertg.PACKAGE_NAME),
                teamName: 'jsd-shield'
            }
        });
        return didUserChangeAnything ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: intl.formatMessage((0, $cgvPO.viewButton).viewDisabledTooltip),
            position: "mouse",
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7db9117d20cf6701$var$ViewButton, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7db9117d20cf6701$var$ViewButton, props);
    }
    return didUserChangeAnything ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: intl.formatMessage((0, $cgvPO.viewButton).viewDisabledTooltip),
        position: "mouse",
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7db9117d20cf6701$var$ViewButtonActual, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7db9117d20cf6701$var$ViewButtonActual, props);
};

});
parcelRegister("9ut4M", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ea9e8c9aeb0071$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $T8nWD = parcelRequire("T8nWD");

var $e6TwI = parcelRequire("e6TwI");

var $bbjDy = parcelRequire("bbjDy");
// eslint-disable-next-line jira/react/no-class-components
class $20ea9e8c9aeb0071$var$ServicedeskPortalIdProvider extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.store = (0, $e6TwI.default)((0, $T8nWD.default));
    }
    render() {
        const { children: children, projectId: projectId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            id: (0, $e6TwI.APP_ID),
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbjDy.default), {
            projectId: projectId
        }, children));
    }
}
var $20ea9e8c9aeb0071$export$2e2bcd8739ae039 = $20ea9e8c9aeb0071$var$ServicedeskPortalIdProvider;

});
parcelRegister("T8nWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c20748bd730b5b3$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $jcw0u = parcelRequire("jcw0u");

var $8Mn9t = parcelRequire("8Mn9t");

var $l5jTG = parcelRequire("l5jTG");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9c20748bd730b5b3$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $l5jTG.FETCH_SERVICEDESK_PORTAL)).switchMap(({ payload: { projectId: projectId } })=>(0, $kVLXA.Observable).fromPromise((0, $8Mn9t.default)(projectId)).map((res)=>{
            const { id: portalId } = res;
            return (0, $l5jTG.fetchServicedeskPortalSuccessAction)(portalId);
        }).catch((error)=>{
            (0, $jcw0u.trackFetchErrors)({
                error: error,
                id: 'fetchServicedeskPortal',
                packageName: 'jiraProjectSettingsAppsServicedeskPortalProvider',
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $kVLXA.Observable).empty();
        }));

});
parcelRegister("8Mn9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae0ff2f3b90488c6$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
const $ae0ff2f3b90488c6$var$fetchServiceDeskPortal = (projectId)=>{
    const url = `/rest/servicedeskapi/servicedesk/projectId:${projectId}`;
    return (0, $7f4tk.default)(url);
};
var $ae0ff2f3b90488c6$export$2e2bcd8739ae039 = $ae0ff2f3b90488c6$var$fetchServiceDeskPortal;

});

parcelRegister("l5jTG", function(module, exports) {

$parcel$export(module.exports, "FETCH_SERVICEDESK_PORTAL", () => $d117cddc8e13402c$export$c2a80656cb7b997b);
$parcel$export(module.exports, "FETCH_SERVICEDESK_PORTAL_SUCCESS", () => $d117cddc8e13402c$export$812e5094eb3b94ff);
$parcel$export(module.exports, "fetchServicedeskPortalAction", () => $d117cddc8e13402c$export$3e724d7d52cea367);
$parcel$export(module.exports, "fetchServicedeskPortalSuccessAction", () => $d117cddc8e13402c$export$2f86735c5c4b9e09);
const $d117cddc8e13402c$export$c2a80656cb7b997b = 'state.FETCH_SERVICEDESK_PORTAL';
const $d117cddc8e13402c$export$812e5094eb3b94ff = 'state.FETCH_SERVICEDESK_PORTAL_SUCCESS';
const $d117cddc8e13402c$export$3e724d7d52cea367 = (projectId)=>({
        type: $d117cddc8e13402c$export$c2a80656cb7b997b,
        payload: {
            projectId: projectId
        }
    });
const $d117cddc8e13402c$export$2f86735c5c4b9e09 = (portalId)=>({
        type: $d117cddc8e13402c$export$812e5094eb3b94ff,
        payload: {
            portalId: portalId
        }
    });

});


parcelRegister("e6TwI", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $ef728e75fe8990d3$export$d76071d5de2774fc);
$parcel$export(module.exports, "default", () => $ef728e75fe8990d3$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $g3qyq = parcelRequire("g3qyq");

var $8Mn9t = parcelRequire("8Mn9t");

var $cXZRJ = parcelRequire("cXZRJ");
const $ef728e75fe8990d3$export$d76071d5de2774fc = 'project-settings-apps.servicedesk-portal-link';
const $ef728e75fe8990d3$var$rootEpicDependencies = {
    fetchServicedeskPortal: $8Mn9t.default
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ef728e75fe8990d3$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'project-settings/servicedesk-portal-link',
        rootReducer: // @ts-expect-error - TS2322 - Type '(state: State | undefined, action: FetchServicedeskPortalSuccessAction) => State' is not assignable to type 'Reducer<State>'.
        $cXZRJ.default,
        rootEpic: rootEpic,
        rootEpicDependencies: $ef728e75fe8990d3$var$rootEpicDependencies,
        initialState: (0, $cXZRJ.defaultState),
        middlewares: [
            (0, $g3qyq.default)($ef728e75fe8990d3$export$d76071d5de2774fc)
        ]
    });

});
parcelRegister("g3qyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c091411acc86b19$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $aMh57 = parcelRequire("aMh57");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $4c091411acc86b19$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $2YZCu.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $aMh57.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $4c091411acc86b19$export$2e2bcd8739ae039 = $4c091411acc86b19$var$errorHandling;

});

parcelRegister("cXZRJ", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $e17bac951ee68c6c$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $e17bac951ee68c6c$export$2e2bcd8739ae039);

var $l5jTG = parcelRequire("l5jTG");
const $e17bac951ee68c6c$export$49d5fc8cba920a0 = {
    portalId: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e17bac951ee68c6c$export$2e2bcd8739ae039 = (state = $e17bac951ee68c6c$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $l5jTG.FETCH_SERVICEDESK_PORTAL_SUCCESS:
            return {
                portalId: action.payload.portalId
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});


parcelRegister("bbjDy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5b13b2ae0ff2bc$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $l5jTG = parcelRequire("l5jTG");

var $eSN3j = parcelRequire("eSN3j");

var $hI2Vo = parcelRequire("hI2Vo");
const $ad5b13b2ae0ff2bc$var$mapStateToProps = (state)=>({
        portalId: (0, $eSN3j.getServicedeskPortalId)(state)
    });
const $ad5b13b2ae0ff2bc$var$mapDispatchToProps = {
    onFetchServicedeskPortal: (0, $l5jTG.fetchServicedeskPortalAction)
};
var $ad5b13b2ae0ff2bc$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(// @ts-expect-error - TS2769 - Type 'unknown' is not assignable to type 'State'.
$ad5b13b2ae0ff2bc$var$mapStateToProps, $ad5b13b2ae0ff2bc$var$mapDispatchToProps)((0, $hI2Vo.default));

});
parcelRegister("eSN3j", function(module, exports) {

$parcel$export(module.exports, "getServicedeskPortalId", () => $1853c04a8106593d$export$dfb212197c431a7e);
const $1853c04a8106593d$export$dfb212197c431a7e = (state)=>state.portalId;

});

parcelRegister("hI2Vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8673d1d7bc5b762c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line jira/react/no-class-components
class $8673d1d7bc5b762c$var$ServicedeskPortalProvider extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { projectId: projectId, onFetchServicedeskPortal: onFetchServicedeskPortal } = this.props;
        onFetchServicedeskPortal(projectId);
    }
    componentDidUpdate(prevProps) {
        const { projectId: projectId, onFetchServicedeskPortal: onFetchServicedeskPortal } = this.props;
        if (prevProps.projectId !== projectId) onFetchServicedeskPortal(projectId);
    }
    render() {
        const { portalId: portalId, children: children } = this.props;
        return children({
            servicedeskPortalId: portalId
        });
    }
}
var $8673d1d7bc5b762c$export$2e2bcd8739ae039 = $8673d1d7bc5b762c$var$ServicedeskPortalProvider;

});



parcelRegister("gGU25", function(module, exports) {

$parcel$export(module.exports, "usePortalId", () => $1fee2f938df37c94$export$27bb594bbc4fe7c3);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $3XO6n = parcelRequire("3XO6n");
const $1fee2f938df37c94$var$PACKAGE_NAME = (0, $3XO6n.toPackageName)('jiraServiceDeskPortalHook');
const $1fee2f938df37c94$export$94df0e59ebebf4a7 = (projectKey, requestTypeId)=>`/secure/EditRequestType!editRequestTypeJson.jspa?projectKey=${projectKey}&rtId=${requestTypeId}`;
const $1fee2f938df37c94$export$27bb594bbc4fe7c3 = ({ projectKey: projectKey, requestTypeId: requestTypeId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [requestType, setRequestType] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const url = $1fee2f938df37c94$export$94df0e59ebebf4a7(projectKey, requestTypeId);
    (0, $5uXOq.useEffect)(()=>{
        setRequestType(null);
        setError(null);
        setIsLoading(true);
        (0, $7f4tk.default)(url).then((data)=>{
            setIsLoading(false);
            setRequestType(data.requestType);
            setError(null);
        }).catch((caughtError)=>{
            setIsLoading(false);
            setRequestType(null);
            setError(caughtError);
            (0, $jcw0u.default)({
                error: caughtError,
                meta: {
                    id: 'jsmPreviewButton.portalIdFetchError',
                    packageName: $1fee2f938df37c94$var$PACKAGE_NAME,
                    teamName: 'jsd-shield'
                }
            });
        });
    }, [
        setIsLoading,
        setError,
        setRequestType,
        url
    ]);
    return {
        isLoading: isLoading,
        portalId: requestType?.portalId,
        portalUrl: requestType?.portalUrl,
        error: error
    };
};

});



parcelRegister("iaiNb", function(module, exports) {

$parcel$export(module.exports, "IssueTypesNavigationItemsFetcher", () => $a0748c2f0e6a5f88$export$3ac3b55f0d9fd42);
$parcel$export(module.exports, "RedirectToDefaultIssueType", () => $a0748c2f0e6a5f88$export$a33b5bafcd725c68);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $02Psx = parcelRequire("02Psx");

var $6wesA = parcelRequire("6wesA");

var $7tQej = parcelRequire("7tQej");

var $kIafm = parcelRequire("kIafm");

var $8WWxc = parcelRequire("8WWxc");
const $a0748c2f0e6a5f88$export$3ac3b55f0d9fd42 = ({ projectId: projectId, productFeatures: productFeatures })=>{
    const actions = (0, $kIafm.useIssueTypesNavigationItemsActions)();
    const [{ asyncState: asyncState, projectId: currentProjectId }] = (0, $kIafm.useIssueTypesNavigationItems)();
    const intl = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (asyncState === (0, $6wesA.INIT) || projectId !== currentProjectId) actions.load(projectId, productFeatures, intl);
    }, [
        asyncState,
        actions,
        projectId,
        currentProjectId,
        productFeatures,
        intl
    ]);
    return null;
};
const $a0748c2f0e6a5f88$var$getBlankAndGeneralExpCohort = ()=>{
    // Don't expose this experiment here because this is just a util. Seeing the template is handled elsewhere.
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsm_remove_blank_and_general_template_demarcation');
    return expConfig.get('cohort', 'not-enrolled');
};
const $a0748c2f0e6a5f88$export$a33b5bafcd725c68 = ({ extraDefinerId: extraDefinerId, project: project })=>{
    const [{ asyncState: asyncState, baseLevel: baseLevel, topLevel: topLevel, bottomLevel: bottomLevel }] = (0, $kIafm.useIssueTypesNavigationItems)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    (0, $5uXOq.useEffect)(()=>{
        if (asyncState === (0, $6wesA.FAILURE)) showFlag({
            type: 'error',
            title: (0, $8WWxc.default).errorTitle,
            description: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8WWxc.default).errorDescriptionIssueTermRefresh : (0, $8WWxc.default).errorDescription,
            messageId: 'spa-apps-project-settings-issue-type.team-managed.navigation.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        asyncState,
        showFlag
    ]);
    if (asyncState === (0, $6wesA.FAILURE)) return null;
    const isKnownIssueType = [
        ...topLevel,
        ...baseLevel,
        ...bottomLevel
    ].some(({ id: id })=>id === extraDefinerId);
    if (asyncState !== (0, $6wesA.SUCCESS) || isKnownIssueType) return null;
    let defaultIssueTypeId = '';
    if ($a0748c2f0e6a5f88$var$getBlankAndGeneralExpCohort() === 'variation') {
        defaultIssueTypeId = baseLevel[0] ? String(baseLevel[0].id) : '';
        if (!defaultIssueTypeId) defaultIssueTypeId = topLevel[0] ? String(topLevel[0].id) : ''; // Fallback if no base level issue type but top level exists
    } else defaultIssueTypeId = baseLevel[0] ? String(baseLevel[0].id) : '';
    if (!defaultIssueTypeId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        push: false,
        to: (0, $02Psx.getNextgenSettingsIssueTypesUrl)(project.projectType, project.projectKey, defaultIssueTypeId)
    });
};

});
parcelRegister("kIafm", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesNavigationItems", () => $117ff49c1fb0e68b$export$8facf5695da03580);
$parcel$export(module.exports, "useIssueTypesNavigationItemsActions", () => $117ff49c1fb0e68b$export$502d4d04702890ce);

var $6wesA = parcelRequire("6wesA");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $4R6GH = parcelRequire("4R6GH");

var $kXBJP = parcelRequire("kXBJP");

var $bI4Ju = parcelRequire("bI4Ju");
const $117ff49c1fb0e68b$export$d4c72bab9d6cc13a = {
    projectId: null,
    asyncState: (0, $6wesA.INIT),
    data: {
        limitPerProject: null,
        issueTypes: []
    },
    addIssueTypeTooltipMessage: ''
};
const $117ff49c1fb0e68b$var$load = (projectId, productFeatures, intl)=>async ({ setState: setState, getState: getState })=>{
        try {
            const currentState = getState();
            if (currentState.asyncState === (0, $6wesA.LOADING) && projectId === currentState.projectId) return;
            setState({
                ...projectId === currentState.projectId ? currentState : $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
                projectId: projectId,
                asyncState: (0, $6wesA.LOADING)
            });
            const result = await (0, $kXBJP.queryIssueTypesNavigationItems)(projectId, productFeatures);
            if (getState().projectId !== projectId) return;
            const { limitPerProject: limitPerProject, data: data } = result.data.simplifiedProject.issueTypeCollection;
            setState({
                projectId: projectId,
                asyncState: (0, $6wesA.SUCCESS),
                data: {
                    limitPerProject: limitPerProject,
                    issueTypes: data
                },
                addIssueTypeTooltipMessage: productFeatures.navigationMessages.addIssueTypeDisabledTooltipIssueTermRefresh && (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltipIssueTermRefresh, {
                    limit: limitPerProject
                }) : intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltip, {
                    limit: limitPerProject
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                asyncState: (0, $6wesA.FAILURE)
            });
        }
    };
const $117ff49c1fb0e68b$var$remove = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $6wesA.SUCCESS)) return;
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: state.data.issueTypes.filter(({ id: id })=>id !== issueTypeId)
            }
        });
    };
const $117ff49c1fb0e68b$var$update = (layoutOwners)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $6wesA.SUCCESS)) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newDataById = {};
        for(let i = 0; i < layoutOwners.length; i += 1){
            const { data: data } = layoutOwners[i];
            newDataById[data.id] = {
                name: data.name,
                avatarId: data.avatarId,
                icon: data.iconUrl
            };
        }
        const issueTypes = state.data.issueTypes.map((issueType)=>{
            if (!newDataById[issueType.id]) return issueType;
            const { name: name, avatarId: avatarId } = newDataById[issueType.id];
            return {
                ...issueType,
                name: name,
                avatarId: avatarId || issueType.avatarId
            };
        });
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: issueTypes
            }
        });
    };
const $117ff49c1fb0e68b$export$e324594224ef24da = {
    load: $117ff49c1fb0e68b$var$load,
    remove: $117ff49c1fb0e68b$var$remove,
    update: $117ff49c1fb0e68b$var$update
};
const $117ff49c1fb0e68b$export$94d3eea6047656ad = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
    const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
    const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, $bI4Ju.getIssueTypeNavigationItemsLevels)(issueTypes);
    const isIssueTypeLimitReached = (0, $bI4Ju.getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
    const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
    return {
        asyncState: asyncState,
        projectId: projectId,
        isAddIssueTypeDisabled: asyncState !== (0, $6wesA.SUCCESS) || isIssueTypeLimitReached,
        addIssueTypeTooltip: addIssueTypeTooltip,
        topLevel: topLevel,
        baseLevel: baseLevel,
        bottomLevel: bottomLevel
    };
};
// Made it const for visibility. Apparently, store name must be unique or it breaks the library
const $117ff49c1fb0e68b$var$STORE_NAME = 'issue-type-page-navigation-items-new';
const $117ff49c1fb0e68b$var$Store = (0, $iXqE5.createStore)({
    name: $117ff49c1fb0e68b$var$STORE_NAME,
    initialState: $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
    actions: $117ff49c1fb0e68b$export$e324594224ef24da
});
const $117ff49c1fb0e68b$export$8facf5695da03580 = (0, $3sQ5x.createHook)($117ff49c1fb0e68b$var$Store, {
    selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
});
// @ts-expect-error - TS2322 - Type 'HookActionsFunction<BoundActions<State, { readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>...' is not assignable to type 'HookActionsFunction<{ readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>; readonly remove: (...'.
const $117ff49c1fb0e68b$export$502d4d04702890ce = (0, $3sQ5x.createActionsHook)($117ff49c1fb0e68b$var$Store);
const $117ff49c1fb0e68b$export$313f907c8e339d1b = (0, $51nlc.createSubscriber)($117ff49c1fb0e68b$var$Store, {
    selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
});

});
parcelRegister("kXBJP", function(module, exports) {

$parcel$export(module.exports, "queryIssueTypesNavigationItems", () => $e8107a8cce63320f$export$d7f9b965a8cdf6ce);

var $7f4tk = parcelRequire("7f4tk");

var $1JUEq = parcelRequire("1JUEq");
const $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery = (projectId)=>`query IssueTypesNavigationItems {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
            }
        }
    }
  }`;
const $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery = (projectId, keys)=>`query IssueTypesNavigationItemsWithProperties {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
                properties(keys: ${JSON.stringify(keys)})
            }
        }
    }
  }`;
const $e8107a8cce63320f$export$d7f9b965a8cdf6ce = (projectId, productFeatures)=>{
    const propertyKeys = (0, $1JUEq.getAllPropertiesKeys)(productFeatures);
    const query = propertyKeys.length ? $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery(projectId, propertyKeys) : $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery(projectId);
    return (0, $7f4tk.default)('/rest/gira/latest/?issue-type-page-navigation', {
        method: 'POST',
        body: JSON.stringify({
            query: query
        })
    });
};

});
parcelRegister("1JUEq", function(module, exports) {

$parcel$export(module.exports, "getAllPropertiesKeys", () => $fec81b5fddfaba4b$export$481a21941383de83);

const $fec81b5fddfaba4b$export$481a21941383de83 = (features)=>{
    const { issueTypeHelpText: issueTypeHelpText } = features;
    const allPropertiesKeys = [
        (0, $052efe0fea3c4d67$export$97806a3c861a8076),
        (0, $052efe0fea3c4d67$export$5a53542e76b69730)
    ];
    return issueTypeHelpText ? allPropertiesKeys : [];
};

});
const $052efe0fea3c4d67$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $052efe0fea3c4d67$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';
const $052efe0fea3c4d67$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $052efe0fea3c4d67$export$663476c4863d5014 = 'jsd.field.helpText';
const $052efe0fea3c4d67$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $052efe0fea3c4d67$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';



parcelRegister("bI4Ju", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeNavigationItemsLevels", () => $a611b4a47ee97f87$export$fcf99cb11372431f);
$parcel$export(module.exports, "getIsIssueTypeLimitReached", () => $a611b4a47ee97f87$export$f9ef03d331bca3e6);

var $g4tDr = parcelRequire("g4tDr");

var $4cS2K = parcelRequire("4cS2K");
const $a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
const $a611b4a47ee97f87$export$fcf99cb11372431f = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
        const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
        const issueTypeNavigationItem = {
            id: id,
            name: name,
            avatarId: avatarId,
            operations: operations,
            icon: (0, $4cS2K.getProjectAvatarUrl)(avatarId)
        };
        if ((0, $g4tDr.isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
        else if ((0, $g4tDr.isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
        else if ((0, $g4tDr.isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
        return acc;
    }, {
        topLevel: [],
        baseLevel: [],
        bottomLevel: []
    });
const $a611b4a47ee97f87$export$f9ef03d331bca3e6 = (limitPerProject, numberOfIssueTypes)=>limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;

});
parcelRegister("g4tDr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $03dd5f7faa501890$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $03dd5f7faa501890$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $03dd5f7faa501890$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $03dd5f7faa501890$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $03dd5f7faa501890$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $03dd5f7faa501890$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $03dd5f7faa501890$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $03dd5f7faa501890$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $03dd5f7faa501890$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $03dd5f7faa501890$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $03dd5f7faa501890$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $03dd5f7faa501890$export$638ac52227e67c8);
const $03dd5f7faa501890$export$2294cfc7730248df = 4;
const $03dd5f7faa501890$export$961a1d6da881600c = 3;
const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
const $03dd5f7faa501890$export$9ad20e435294162a = 1;
const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
};
const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
};
const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
};
const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};
const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};

});



parcelRegister("8WWxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e370c0fc193b8a71$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $e370c0fc193b8a71$var$messages = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "spa-apps.project-settings.issue-type.team-managed.navigation.error-title",
        "defaultMessage": "Something went wrong."
    },
    errorDescription: {
        "id": "spa-apps.project-settings.issue-type.team-managed.navigation.error-description",
        "defaultMessage": "We couldn't load this issue type's details. Refresh and try again."
    },
    errorDescriptionIssueTermRefresh: {
        "id": "spa-apps.project-settings.issue-type.team-managed.navigation.error-description-issue-term-refresh",
        "defaultMessage": "We couldn't load this work type's details. Refresh and try again."
    }
});
var $e370c0fc193b8a71$export$2e2bcd8739ae039 = $e370c0fc193b8a71$var$messages;

});


parcelRegister("hHWvI", function(module, exports) {

$parcel$export(module.exports, "filterServiceDeskConnectApps", () => $1852de4546de7b5f$export$487aff301160057a);

var $4R6GH = parcelRequire("4R6GH");

var $lNhbS = parcelRequire("lNhbS");
const $1852de4546de7b5f$var$excludedConnectAddonKeys = [
    (0, $lNhbS.JIRA_AUTOMATION_ADDON_KEY),
    (0, $lNhbS.JIRA_FEDRAMP_MODERATE_AUTOMATION_ADDON_KEY)
];
const $1852de4546de7b5f$var$excludedConnectAddonKeysLegacy = [
    (0, $lNhbS.JIRA_AUTOMATION_ADDON_KEY)
];
const $1852de4546de7b5f$export$487aff301160057a = (connectAppsData)=>{
    const keysToExclude = (0, $4R6GH.fg)('wolf-86_exclude_legacy_automation_navigation_fedm') ? $1852de4546de7b5f$var$excludedConnectAddonKeys : $1852de4546de7b5f$var$excludedConnectAddonKeysLegacy;
    return connectAppsData && connectAppsData.filter(({ connectIframeProps: connectIframeProps })=>// connectIframeProps should never be falsey, however we don't want exclusion by default
        !keysToExclude.includes(connectIframeProps ? connectIframeProps.addon_key : ''));
};

});

parcelRegister("hRqBV", function(module, exports) {

$parcel$export(module.exports, "AccessMenu", () => $0da192f9312f6dfb$export$ad4989badaf2c553);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $02Psx = parcelRequire("02Psx");

var $9OXo1 = parcelRequire("9OXo1");

var $lNhbS = parcelRequire("lNhbS");

var $dzkBf = parcelRequire("dzkBf");
const $0da192f9312f6dfb$export$ad4989badaf2c553 = ({ projectKey: projectKey, features: features })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const { hasServiceDeskAccess: hasJSD } = appPermissions;
    if (features == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'access'
        },
        selectedOn: [
            'project-settings-servicedesk-access'
        ],
        href: `${baseSettingsUrl}/access`,
        shifter: {
            groupTitle: formatMessage((0, $dzkBf.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        }
    }, formatMessage((0, $dzkBf.default).access)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'customer-permissions'
        },
        href: `${baseSettingsUrl}/customer-permissions`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $dzkBf.default).customerPermissions)));
};

});
parcelRegister("dzkBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $64d840a93280ed5a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $64d840a93280ed5a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    access: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.access.access",
        "defaultMessage": "People and access"
    },
    title: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.access.title",
        "defaultMessage": "Project settings"
    },
    customerPermissions: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.access.customer-permissions",
        "defaultMessage": "Customer permissions"
    }
});

});


parcelRegister("98hQ0", function(module, exports) {

$parcel$export(module.exports, "Channels", () => $0a1cec0f99497e3a$export$e9b470e80c258c34);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $aIZdc = parcelRequire("aIZdc");

var $2vSU6 = parcelRequire("2vSU6");

var $7CMCs = parcelRequire("7CMCs");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $02Psx = parcelRequire("02Psx");

var $9OXo1 = parcelRequire("9OXo1");

var $lNhbS = parcelRequire("lNhbS");

var $fVpM0 = parcelRequire("fVpM0");

var $cfK1T = parcelRequire("cfK1T");

var $dHXIb = parcelRequire("dHXIb");
const $0a1cec0f99497e3a$export$e9b470e80c258c34 = ({ projectKey: projectKey, features: features })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const { hasServiceDeskAccess: hasJSD } = appPermissions;
    const BackMenuItem = {
        href: baseSettingsUrl,
        title: formatMessage((0, $dHXIb.default).goToSettings)
    };
    if (features == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'portal-settings'
        },
        href: `${baseSettingsUrl}/channels/portal-settings`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $dHXIb.default).portalSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'email'
        },
        href: `${baseSettingsUrl}/email`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $dHXIb.default).email)), features?.hasChat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'chat-settings'
        },
        href: `${baseSettingsUrl}/chat`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $dHXIb.default).chat))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'widget-settings'
        },
        href: `${baseSettingsUrl}/widget`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $dHXIb.default).widget)), hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'knowledgeBase'
        },
        selectedOn: [
            'project-settings-servicedesk-kb'
        ],
        href: `${baseSettingsUrl}/confluence-kb`,
        shifter: {
            groupTitle: formatMessage((0, $dHXIb.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        }
    }, formatMessage((0, $dHXIb.default).knowledgeBase)), !(0, $aIZdc.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "virtualAgent",
        packageName: "jiraNavigationAppsSidebarServicedesk",
        teamName: "navigation",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfK1T.VirtualAgentMenuItem), {
                projectKey: projectKey
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVpM0.VirtualAgent), {
        projectKey: projectKey,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        shifter: {
            groupTitle: formatMessage((0, $dHXIb.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'external-links'
        },
        selectedOn: [
            'project-settings-servicedesk-external-links'
        ],
        href: `${baseSettingsUrl}/external-links`
    }, formatMessage((0, $dHXIb.default).externalLinks)));
};

});
parcelRegister("dHXIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfd2afd9b17acf1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bbfd2afd9b17acf1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addIssueType: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.add-issue-type",
        "defaultMessage": "Add request type"
    },
    projectSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.project-settings",
        "defaultMessage": "Project settings"
    },
    details: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.details",
        "defaultMessage": "Details"
    },
    itsmFeatures: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.itsm-features",
        "defaultMessage": "Features"
    },
    customerPermissions: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    customerNotifications: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    notificationEmail: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.notification-email",
        "defaultMessage": "Notification email"
    },
    internalNotifications: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    widget: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.widget",
        "defaultMessage": "Widget"
    },
    portalSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.portal-settings",
        "defaultMessage": "Portal"
    },
    email: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.email",
        "defaultMessage": "Email"
    },
    access: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.access",
        "defaultMessage": "Internal access"
    },
    notifications: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.notifications",
        "defaultMessage": "Notifications"
    },
    itemBack: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.item-back",
        "defaultMessage": "Back to project"
    },
    goToSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.go-to-settings",
        "defaultMessage": "Back to settings"
    },
    title: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.title",
        "defaultMessage": "Project settings"
    },
    fieldsNonFinal: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.fields-non-final",
        "defaultMessage": "Fields"
    },
    issueTypes: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types",
        "defaultMessage": "Request types"
    },
    incidentManagement: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.incident-management",
        "defaultMessage": "Incident management"
    },
    channels: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.channels",
        "defaultMessage": "Channels"
    },
    languageSupport: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.language-support",
        "defaultMessage": "Language support"
    },
    knowledgeBase: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.knowledge-base",
        "defaultMessage": "Knowledge base"
    },
    automation: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.automation",
        "defaultMessage": "Automation"
    },
    playbooks: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.playbooks",
        "defaultMessage": "Playbooks"
    },
    slaSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.sla-settings",
        "defaultMessage": "SLAs"
    },
    customerSatisfaction: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.customer-satisfaction",
        "defaultMessage": "Customer satisfaction"
    },
    ejectToClassic: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.eject-to-classic",
        "defaultMessage": "Advanced"
    },
    chat: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.chat",
        "defaultMessage": "Chat"
    },
    forms: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.forms",
        "defaultMessage": "Forms"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.new-lozenge",
        "defaultMessage": "New"
    },
    externalLinks: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.external-links",
        "defaultMessage": "External resources"
    },
    dataClassificationsNonFinal: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.data-classifications-non-final",
        "defaultMessage": "Data classifications"
    },
    accessGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.access-group",
        "defaultMessage": "Access"
    },
    requestsManagementGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.requests-management-group",
        "defaultMessage": "Request management"
    },
    channelsGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.channels-group",
        "defaultMessage": "Channels & self service"
    },
    notificationsGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.notifications-group",
        "defaultMessage": "Notifications"
    },
    integrationsGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.integrations-group",
        "defaultMessage": "Apps"
    },
    journeysNonFinal: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.journeys-non-final",
        "defaultMessage": "Journeys"
    }
});

});


parcelRegister("l5jSb", function(module, exports) {

$parcel$export(module.exports, "EcosystemAppsMenu", () => $835e7f5386efb00f$export$e583660e6ee09caf);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $1rTGO = parcelRequire("1rTGO");

var $aHv3X = parcelRequire("aHv3X");

var $k2DRb = parcelRequire("k2DRb");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $4OCke = parcelRequire("4OCke");

var $k51JQ = parcelRequire("k51JQ");

var $02Psx = parcelRequire("02Psx");

var $4R6GH = parcelRequire("4R6GH");

var $5ckiS = parcelRequire("5ckiS");
const $835e7f5386efb00f$export$c62cfdba33f43c7e = ({ baseSettingsUrl: baseSettingsUrl = '', apps: apps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const forgeApps = (0, $5uXOq.useMemo)(()=>apps.forge || [], [
        apps.forge
    ]);
    const connectApps = (0, $5uXOq.useMemo)(()=>apps.connect || [], [
        apps.connect
    ]);
    const sortedApps = (0, $5uXOq.useMemo)(()=>[
            ...forgeApps.map((app)=>({
                    type: 'forge',
                    name: app.name,
                    app: app
                })),
            ...connectApps.map((app)=>({
                    type: 'connect',
                    name: app.title,
                    app: app
                }))
        ].sort((a, b)=>a.name.localeCompare(b.name)), [
        connectApps,
        forgeApps
    ]);
    if (apps.forge == null || apps.connect == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $4R6GH.fg)('efa-149-deprecating-app-fields') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'app-fields'
        },
        href: `${baseSettingsUrl}/apps/app-fields`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $5ckiS.messages).appFields)), sortedApps.map(({ type: type, app: app })=>{
        if (type === 'forge') {
            // @ts-expect-error - TS2322 - Type 'App | App' is not assignable to type 'ForgeProjectSettingsItem'.
            const item = app;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
                key: app.id,
                ...item,
                showIcon: false,
                nestedMenuActive: false
            });
        }
        // @ts-expect-error - TS2322 - Type 'App | App' is not assignable to type 'App'.
        const connectApp = app;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'connect-app'
            },
            key: connectApp.id,
            href: `${baseSettingsUrl}/apps/${connectApp.id}`,
            selectedOn: (0, $4OCke.matchUrlPathname)()
        }, connectApp.title);
    }), forgeApps.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
        }
    }) : null);
};
const $835e7f5386efb00f$export$e583660e6ee09caf = (props)=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const projectKey = project && project.key || ''; // flow
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aHv3X.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($835e7f5386efb00f$export$c62cfdba33f43c7e, {
        baseSettingsUrl: baseSettingsUrl,
        ...props
    }));
};

});
parcelRegister("aHv3X", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $de4af379e202f62d$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $de4af379e202f62d$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $de4af379e202f62d$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $de4af379e202f62d$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("5ckiS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bd9dc53a59281ef6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bd9dc53a59281ef6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    apps: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.ecosystem-apps.apps",
        "defaultMessage": "Apps"
    },
    appFields: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.ecosystem-apps.app-fields",
        "defaultMessage": "App fields"
    }
});

});


parcelRegister("8uoEG", function(module, exports) {

$parcel$export(module.exports, "Language", () => $2290a13c5769b300$export$ce4fe1c9e6520c1a);

var $5uXOq = parcelRequire("5uXOq");

var $5on2Q = parcelRequire("5on2Q");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $iwDvi = parcelRequire("iwDvi");

var $3OGaE = parcelRequire("3OGaE");

var $lpwtK = parcelRequire("lpwtK");

var $kZj7F = parcelRequire("kZj7F");

var $2NMNM = parcelRequire("2NMNM");

var $02Psx = parcelRequire("02Psx");

var $1e8Ij = parcelRequire("1e8Ij");

var $eSH1I = parcelRequire("eSH1I");

var $dHXIb = parcelRequire("dHXIb");
const $2290a13c5769b300$export$ce4fe1c9e6520c1a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const [enabledLanguages, { fetchLanguages: fetchLanguages }] = (0, $1e8Ij.useEnabledLanguages)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ data: translations }] = (0, $eSH1I.useTranslationSummaries)();
    (0, $5uXOq.useEffect)(()=>{
        if (project) {
            const analyticsEvent = createAnalyticsEvent({});
            fetchLanguages(project.id, analyticsEvent);
        }
    }, [
        createAnalyticsEvent,
        fetchLanguages,
        project
    ]);
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), project.key);
    const BackMenuItem = {
        href: `${baseSettingsUrl}/language`,
        title: formatMessage((0, $dHXIb.default).itemBack)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $dHXIb.default).languageSupport)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, enabledLanguages?.filter((language)=>language.state !== 'unused').map((language)=>{
        const summary = translations?.languageTranslationSummaries?.find((v)=>v.key === language.key);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
            analytics: {
                itemId: language.key
            },
            iconAfter: summary?.flaggedSections ? // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5on2Q))), {
                primaryColor: "var(--ds-icon-warning, #E56910)",
                label: ""
            }) : null,
            id: language.key,
            key: language.key,
            title: language.label,
            href: `${baseSettingsUrl}/language/${language.key}`,
            overrides: {
                BackMenuItem: BackMenuItem
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwDvi.SidebarTranslations), null));
    })));
};

});

parcelRegister("dVJa0", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $be684c3360131654$export$36ba2f559d49a8f6);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $02Psx = parcelRequire("02Psx");

var $dHXIb = parcelRequire("dHXIb");
const $be684c3360131654$export$36ba2f559d49a8f6 = ({ projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey);
    if (projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'internal-notifications'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseSettingsUrl}/internal-notifications`
    }, formatMessage((0, $dHXIb.default).internalNotifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        href: `${baseSettingsUrl}/customer-notifications`,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)()
    }, formatMessage((0, $dHXIb.default).customerNotifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'notification-email'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseSettingsUrl}/notification-email`
    }, formatMessage((0, $dHXIb.default).notificationEmail)));
};

});

parcelRegister("j6F3H", function(module, exports) {

$parcel$export(module.exports, "RequestsManagementMenu", () => $a825aff7ce671652$export$30079c5ff257de7f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $xc3fY = parcelRequire("xc3fY");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $6jY6G = parcelRequire("6jY6G");

var $02Psx = parcelRequire("02Psx");

var $9OXo1 = parcelRequire("9OXo1");

var $6s1PB = parcelRequire("6s1PB");

var $y8WG5 = parcelRequire("y8WG5");

var $lNhbS = parcelRequire("lNhbS");

var $9AiBW = parcelRequire("9AiBW");

var $dHXIb = parcelRequire("dHXIb");

var $a4ZZB = parcelRequire("a4ZZB");
const $a825aff7ce671652$var$requestTypesGroupWrapperStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.150'
});
const $a825aff7ce671652$var$requestTypesWrapperStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.300'
});
const $a825aff7ce671652$export$30079c5ff257de7f = ({ projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const { hasServiceDeskAccess: hasJSD } = appPermissions;
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: settingFeatures } = (0, $y8WG5.useTMPSettingFeatures)();
    const calculateRequestTypesActive = ({ path: path })=>/jira\/servicedesk\/projects\/.+\/settings\/issuetypes\/.+/.test(path);
    const [requestTypesActive] = (0, $5uXOq.useState)(calculateRequestTypesActive(route));
    if (settingFeatures == null || projectKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a825aff7ce671652$var$requestTypesGroupWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'request-types-group'
        },
        menuItemLabel: formatMessage((0, $a4ZZB.default).requestTypesGroup),
        forceExpand: requestTypesActive,
        submenuId: "request-types-group-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a825aff7ce671652$var$requestTypesWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AiBW.IssueTypes), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        selectedOn: [
            'project-settings-servicedesk-proforma-project-forms'
        ],
        href: `${baseSettingsUrl}/forms`
    }, formatMessage((0, $a4ZZB.default).forms)), hasJSD && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'sla'
        },
        selectedOn: [
            'servicedesk-sla-settings'
        ],
        href: `${baseSettingsUrl}/sla`,
        shifter: {
            groupTitle: formatMessage((0, $a4ZZB.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        }
    }, formatMessage((0, $a4ZZB.default).slaSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'feedback-settings'
        },
        selectedOn: [
            'project-settings-servicedesk-feedback'
        ],
        href: `${baseSettingsUrl}/feedback-settings`,
        shifter: {
            groupTitle: formatMessage((0, $a4ZZB.default).title),
            context: projectKey,
            weight: (0, $lNhbS.PROJECT_SETTINGS_SHIFTER_WEIGHT)
        }
    }, formatMessage((0, $a4ZZB.default).customerSatisfaction)), settingFeatures?.hasFields && expConfig.get('isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'fields'
        },
        selectedOn: [
            'project-settings-servicedesk-fields'
        ],
        href: `${baseSettingsUrl}/fields`
    }, formatMessage((0, $dHXIb.default).fieldsNonFinal))));
};

});
parcelRegister("9AiBW", function(module, exports) {

$parcel$export(module.exports, "IssueTypes", () => $596855b393852c8f$export$15fef796fc6acc30);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $2vSU6 = parcelRequire("2vSU6");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $lGo7j = parcelRequire("lGo7j");

var $4OCke = parcelRequire("4OCke");

var $02Psx = parcelRequire("02Psx");

var $kIafm = parcelRequire("kIafm");

var $iYXmi = parcelRequire("iYXmi");
const $596855b393852c8f$export$15fef796fc6acc30 = ()=>{
    const [issueTypesData] = (0, $kIafm.useIssueTypesNavigationItems)();
    const navigationItems = [
        ...issueTypesData.baseLevel,
        ...issueTypesData.bottomLevel,
        ...issueTypesData.topLevel
    ];
    const { data: project } = (0, $lpwtK.useProject)();
    const { isAddIssueTypeDisabled: isAddIssueTypeDisabled } = issueTypesData;
    if (!project || !navigationItems.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), null);
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), project.key);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, navigationItems.map((issueType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            key: String(issueType.id),
            analytics: {
                itemId: String(issueType.id)
            },
            selectedOn: (0, $4OCke.matchUrlPathname)(),
            href: `${baseSettingsUrl}/issuetypes/${issueType.id}`
        }, issueType.name)), issueTypesData.addIssueTypeTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueTypesData.addIssueTypeTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYXmi.AddRequestTypeDropdown), {
        isDisabled: isAddIssueTypeDisabled,
        projectId: project.id
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYXmi.AddRequestTypeDropdown), {
        isDisabled: isAddIssueTypeDisabled,
        projectId: project.id
    }));
};
const $596855b393852c8f$export$b723082bae55645b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkfg4m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iYXmi", function(module, exports) {

$parcel$export(module.exports, "AddRequestTypeDropdown", () => $7ade1f04ff4e2311$export$6725af24e8e595ac);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $99M5v = parcelRequire("99M5v");

var $3u0c5 = parcelRequire("3u0c5");

var $kMSay = parcelRequire("kMSay");

var $aXhsp = parcelRequire("aXhsp");

var $AeWM3 = parcelRequire("AeWM3");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jcw0u = parcelRequire("jcw0u");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $fkAkD = parcelRequire("fkAkD");

var $hiHwF = parcelRequire("hiHwF");

var $kIafm = parcelRequire("kIafm");

var $9OXo1 = parcelRequire("9OXo1");

var $3vhCv = parcelRequire("3vhCv");

var $kSmsQ = parcelRequire("kSmsQ");

var $fmWKv = parcelRequire("fmWKv");
const $7ade1f04ff4e2311$var$fireFetchError = (error)=>{
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'fetchFieldLimitsForAddRequestTypeDropdown',
            packageName: 'jiraNavigationAppsSidebarServicedesk',
            teamName: 'navigation'
        }
    });
};
const $7ade1f04ff4e2311$var$entryPointParams = {};
const $7ade1f04ff4e2311$export$6725af24e8e595ac = ({ isDisabled: isDisabled, projectId: projectId })=>{
    const intl = (0, $koVbs.default)();
    const [isRequestTypeBuilderOpen, setIsRequestTypeBuilderOpen] = (0, $5uXOq.useState)(false);
    const [isCreateBlank, setIsCreateBlank] = (0, $5uXOq.useState)(false);
    const navActions = (0, $kIafm.useIssueTypesNavigationItemsActions)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $hiHwF.asyncRequestTypeBuilderDrawerEntryPoint), $7ade1f04ff4e2311$var$entryPointParams);
    const requestTypeBuilderTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const client = (0, $AeWM3.getClient)('', (0, $aXhsp.default), tenantContext.xsrfToken ?? '');
    const { data: data } = (0, $5tTFS.useQuery)((0, $3vhCv.FIELDS_LIMIT_QUERY), {
        client: client,
        variables: {
            projectId: projectId
        },
        fetchPolicy: 'network-only',
        // need to ensure we don't get a cached result otherwise we might not get the latest limit info
        onCompleted: (fetchData)=>{
            if (fetchData?.projectConfiguration?.__typename === 'JiraProjectConfigurationResult') (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'addRequestTypeDropdowwn.FIELDS_LIMIT_QUERY success');
            else $7ade1f04ff4e2311$var$fireFetchError(new Error('QueryError'));
        },
        onError: $7ade1f04ff4e2311$var$fireFetchError
    });
    const hasReachedFieldLimit = (0, $5uXOq.useMemo)(()=>(0, $fmWKv.transformGiraReponseToHasReachedFieldLimits)(data), [
        data
    ]);
    const startTracingRequestTypeBuilder = (0, $kMSay.default)('jsm-view-tmp-request-type-builder');
    const startTracingBlankRequestTypeBuilder = (0, $kMSay.default)('jsm-view-tmp-blank-request-type-builder');
    const handleCreateCustom = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled) {
            setIsCreateBlank(true);
            startTracingBlankRequestTypeBuilder();
            setIsRequestTypeBuilderOpen(true);
        }
    }, [
        isDisabled,
        startTracingBlankRequestTypeBuilder
    ]);
    const handleCreateWithTemplate = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled) {
            setIsCreateBlank(false);
            startTracingRequestTypeBuilder();
            setIsRequestTypeBuilderOpen(true);
        }
    }, [
        isDisabled,
        startTracingRequestTypeBuilder
    ]);
    const handleCloseBuilder = (0, $5uXOq.useCallback)(()=>{
        setIsRequestTypeBuilderOpen(false);
    }, []);
    const handleCompleted = (0, $5uXOq.useCallback)(()=>{
        navActions.load(projectId, (0, $fkAkD.getServiceDeskFeatures)(), intl);
    }, [
        projectId,
        intl,
        navActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
                ...triggerProps,
                isDisabled: isDisabled,
                analytics: {
                    itemId: 'add-issue-type'
                },
                ref: (0, $7mPT9.default)(triggerRef, requestTypeBuilderTrigger),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                    spacing: "spacious",
                    label: ""
                })
            }, intl.formatMessage((0, $kSmsQ.messages).addRequestType))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmWKv.ConditionalTooltip), {
        shouldShowTooltip: hasReachedFieldLimit,
        tooltipContent: intl.formatMessage((0, $kSmsQ.messages).maxFieldsLimitReachedTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleCreateWithTemplate,
        isDisabled: hasReachedFieldLimit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $kSmsQ.messages).createFromTemplate,
        values: {
            // This is valid and is clear from the docs https://formatjs.io/docs/react-intl/components/#rich-text-formatting
            // @ts-expect-error Type '(text: string) => JSX.Element' is not assignable to type 'ReactNode'.
            lozenge: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                    appearance: "new"
                }, text)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleCreateCustom
    }, intl.formatMessage((0, $kSmsQ.messages).createCustom)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "bundle-async-request-type-builder-entry-point",
        packageName: "jira-servicedesk-request-type-builder",
        teamName: "jsm-getting-started",
        errorFallback: "flag",
        runtimeProps: {
            isOpen: isRequestTypeBuilderOpen,
            onClose: handleCloseBuilder,
            onCompleted: handleCompleted,
            isCreateBlank: isCreateBlank
        }
    }));
};

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});
parcelRegister("1DiV8", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $13081c324be1f9ab$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $13081c324be1f9ab$export$f5708dca728d7177);

var $3VFsf = parcelRequire("3VFsf");

var $6cAn5 = parcelRequire("6cAn5");
var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $13081c324be1f9ab$var$_a;
var $13081c324be1f9ab$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $13081c324be1f9ab$var$genericMessage;
        $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
}
function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
    invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
})($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;

});


parcelRegister("e3a3O", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $02a3c2aebc919401$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $02a3c2aebc919401$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $02a3c2aebc919401$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $02a3c2aebc919401$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $02a3c2aebc919401$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $ebaCz = parcelRequire("ebaCz");

var $1DiV8 = parcelRequire("1DiV8");

var $12QNw = parcelRequire("12QNw");
var $02a3c2aebc919401$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $02a3c2aebc919401$var$Observable = function(_super) {
    (0, $3VFsf.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $ebaCz.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $aS6b9.default));
function $02a3c2aebc919401$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
    var message = '';
    if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
    (0, $3VFsf.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $02a3c2aebc919401$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
    (0, $3VFsf.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jojW6.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            stale: false
        }));
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), variables);
        if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jojW6.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jojW6.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($02a3c2aebc919401$var$Observable);
function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $02a3c2aebc919401$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $02a3c2aebc919401$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
            if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
        else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $02a3c2aebc919401$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jojW6.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jojW6.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jojW6.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jojW6.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $1DiV8.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3VFsf.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $12QNw.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $12QNw.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jojW6.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3VFsf.__generator)(this, function(_b) {
                mainDefinition = (0, $jojW6.getMainDefinition)(document);
                fragments = (0, $jojW6.getFragmentDefinitions)(document);
                fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3VFsf.__generator)(this, function(_a) {
                            if (!(0, $jojW6.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jojW6.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $1DiV8.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jojW6.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jojW6.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jojW6.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $02a3c2aebc919401$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $02a3c2aebc919401$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
        this.queryStore = new $02a3c2aebc919401$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jojW6.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $02a3c2aebc919401$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $1DiV8.invariant)(mutation, 9);
                        (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jojW6.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jojW6.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jojW6.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jojW6.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jojW6.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jojW6.getDefaultValues)((0, $jojW6.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3VFsf.__assign)({}, options);
        return new $02a3c2aebc919401$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $1DiV8.invariant)(options.query, 12);
        (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
        (0, $1DiV8.invariant)(!options.returnPartialData, 14);
        (0, $1DiV8.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jojW6.graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $02a3c2aebc919401$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $1DiV8.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jojW6.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation));
        } else {
            observable = $02a3c2aebc919401$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $1DiV8.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $02a3c2aebc919401$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jojW6.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jojW6.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jojW6.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jojW6.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jojW6.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jojW6.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jojW6.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $02a3c2aebc919401$var$version = "2.6.10";
var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $clSzL.ApolloLink).empty();
        if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $02a3c2aebc919401$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $02a3c2aebc919401$var$version;
        this.localState = new $02a3c2aebc919401$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $02a3c2aebc919401$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.query), options);
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $clSzL.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;

});
parcelRegister("jojW6", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $e1dfb923a27ca793$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e1dfb923a27ca793$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e1dfb923a27ca793$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e1dfb923a27ca793$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e1dfb923a27ca793$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e1dfb923a27ca793$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e1dfb923a27ca793$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e1dfb923a27ca793$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e1dfb923a27ca793$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e1dfb923a27ca793$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e1dfb923a27ca793$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e1dfb923a27ca793$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e1dfb923a27ca793$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e1dfb923a27ca793$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e1dfb923a27ca793$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e1dfb923a27ca793$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e1dfb923a27ca793$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e1dfb923a27ca793$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e1dfb923a27ca793$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e1dfb923a27ca793$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e1dfb923a27ca793$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e1dfb923a27ca793$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e1dfb923a27ca793$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e1dfb923a27ca793$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e1dfb923a27ca793$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e1dfb923a27ca793$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e1dfb923a27ca793$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e1dfb923a27ca793$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e1dfb923a27ca793$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e1dfb923a27ca793$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e1dfb923a27ca793$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e1dfb923a27ca793$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e1dfb923a27ca793$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e1dfb923a27ca793$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e1dfb923a27ca793$export$160070228be94b08);

var $12QNw = parcelRequire("12QNw");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $fkrBp = parcelRequire("fkrBp");

var $bqMzA = parcelRequire("bqMzA");

var $6cAn5 = parcelRequire("6cAn5");
function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e1dfb923a27ca793$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e1dfb923a27ca793$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e1dfb923a27ca793$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e1dfb923a27ca793$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e1dfb923a27ca793$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e1dfb923a27ca793$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e1dfb923a27ca793$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e1dfb923a27ca793$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e1dfb923a27ca793$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $1DiV8.InvariantError)(17);
}
function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fkrBp)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3VFsf.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
    throw new (0, $1DiV8.InvariantError)(18);
}
function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $12QNw.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
    return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
    return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'client'
    ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $1DiV8.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, document), {
        definitions: (0, $3VFsf.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $1DiV8.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
    (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
        return definition;
    });
    (0, $1DiV8.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
    var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
    (0, $1DiV8.invariant)(def, 5);
    return def;
}
function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
    (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
    (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
    (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $1DiV8.InvariantError)(10);
}
function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, $3VFsf.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
    return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
    return (0, $12QNw.visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    selections: (0, $3VFsf.__spreadArrays)(selections, [
                        $e1dfb923a27ca793$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e1dfb923a27ca793$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e1dfb923a27ca793$export$74985f3324559867(doc) {
    return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        $e1dfb923a27ca793$var$connectionRemoveConfig
    ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
}
function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
    var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $12QNw.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $12QNw.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
    return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
}
function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
    switch($e1dfb923a27ca793$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
    if (typeof $6cAn5 !== 'undefined' && "production") return "production";
    return 'development';
}
function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
    return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
}
function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
}
function $e1dfb923a27ca793$export$df77466336fe5355() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
}
function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
}
function $e1dfb923a27ca793$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e1dfb923a27ca793$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
    if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
    }
    return obj;
}
var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e1dfb923a27ca793$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e1dfb923a27ca793$export$160070228be94b08(sources);
}
function $e1dfb923a27ca793$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e1dfb923a27ca793$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
    if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3VFsf.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e1dfb923a27ca793$var$haveWarned = Object.create({});
function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
        if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("fkrBp", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("bqMzA", function(module, exports) {

$parcel$export(module.exports, "equal", () => $8527cd05038b1b96$export$411ce8e5a71e3069);
var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
var $8527cd05038b1b96$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
    try {
        return $8527cd05038b1b96$var$check(a, b);
    } finally{
        $8527cd05038b1b96$var$previousComparisons.clear();
    }
}
function $8527cd05038b1b96$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $8527cd05038b1b96$var$toString.call(a);
    var bTag = $8527cd05038b1b96$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $8527cd05038b1b96$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;

});


parcelRegister("clSzL", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("aS6b9")).default);

var $aS6b9 = parcelRequire("aS6b9");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3VFsf.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $aS6b9.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $aS6b9.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jojW6.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3VFsf.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3VFsf.__assign)({}, context, next(context));
        else context = (0, $3VFsf.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3VFsf.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $aS6b9.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $aS6b9.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $aS6b9.default).of() : rightLink.request(operation) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $aS6b9.default).of() : rightLink.request(operation, forward) || (0, $aS6b9.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $1DiV8.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $aS6b9.default).of();
}

});
parcelRegister("aS6b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea3bd7f736c1eb4$export$2e2bcd8739ae039);

var $4osjv = parcelRequire("4osjv");
var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($4osjv)));
var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;

});
parcelRegister("4osjv", function(module, exports) {

module.exports = (parcelRequire("k0hXK")).Observable;

});
parcelRegister("k0hXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e901bdc1c9a5edd7$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species'); // === Abstract Operations ===
function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e901bdc1c9a5edd7$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
}
function $e901bdc1c9a5edd7$var$isObservable(x) {
    return x instanceof $e901bdc1c9a5edd7$var$Observable; // SPEC: Brand check
}
function $e901bdc1c9a5edd7$var$hostReportError(e) {
    if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e901bdc1c9a5edd7$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    });
}
function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
}
function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e901bdc1c9a5edd7$var$enqueue(function() {
            return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
        });
        return;
    }
    $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
}
var $e901bdc1c9a5edd7$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e901bdc1c9a5edd7$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e901bdc1c9a5edd7$var$closeSubscription(this);
                    $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e901bdc1c9a5edd7$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e901bdc1c9a5edd7$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e901bdc1c9a5edd7$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                    method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
        hostReportError: $e901bdc1c9a5edd7$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $2YZCu = parcelRequire("2YZCu");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $aS6b9.default)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $aS6b9.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $aS6b9.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $aS6b9.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $aS6b9.default).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $aS6b9.default).of({
                data: {}
            });
            return new (0, $aS6b9.default)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});

parcelRegister("7mPT9", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $d1da29f25d5b5e0a$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $d1da29f25d5b5e0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
    return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("hiHwF", function(module, exports) {

$parcel$export(module.exports, "asyncRequestTypeBuilderDrawerEntryPoint", () => $2b94c4d81ea0fef5$export$fbc3775a3f93e83);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $2b94c4d81ea0fef5$export$fbc3775a3f93e83 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7HNCX")), {
        moduleId: "18fc6798"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7HNCX", function(module, exports) {

let $59c30b87aa67fe6d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $59c30b87aa67fe6d$var$load("92sUi"),
    $59c30b87aa67fe6d$var$load("i5RRW"),
    $59c30b87aa67fe6d$var$load("hPzOn"),
    $59c30b87aa67fe6d$var$load("cM9em"),
    $59c30b87aa67fe6d$var$load("fr9NE"),
    $59c30b87aa67fe6d$var$load("jdCM1")
]).then(()=>parcelRequire('5X8rZ'));

});


parcelRegister("3vhCv", function(module, exports) {

$parcel$export(module.exports, "FIELDS_LIMIT_QUERY", () => $c58b3dc0118914b8$export$2884d50ec2224a66);

var $5cllN = parcelRequire("5cllN");
const $c58b3dc0118914b8$export$2884d50ec2224a66 = (0, $5cllN.default)`
    query addRequestTypeDropdownQuery($projectId: Long!) {
        projectConfiguration(projectId: $projectId) {
            ... on JiraProjectConfigurationResult {
                limitInfo {
                    limitFieldsPerProject
                    currentFieldsPerProject
                }
            }
        }
    }
`;

});

parcelRegister("kSmsQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1cdeab39cad66376$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1cdeab39cad66376$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    addRequestType: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types.add-request-type-dropdown.add-request-type",
        "defaultMessage": "Add request type"
    },
    createFromTemplate: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types.add-request-type-dropdown.create-from-template",
        "defaultMessage": "Create from template"
    },
    createCustom: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types.add-request-type-dropdown.create-custom",
        "defaultMessage": "Create blank"
    },
    maxFieldsLimitReachedTooltip: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types.add-request-type-dropdown.max-fields-limit-reached-tooltip",
        "defaultMessage": "You've reached the field limit for this project. Select 'Create blank' to reuse existing fields."
    }
});

});

parcelRegister("fmWKv", function(module, exports) {

$parcel$export(module.exports, "transformGiraReponseToHasReachedFieldLimits", () => $3bee68c83a070a17$export$ab3be55c7f3a4aca);
$parcel$export(module.exports, "ConditionalTooltip", () => $3bee68c83a070a17$export$d8abb7a1cfbd4b6b);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $jldZL = parcelRequire("jldZL");
const $3bee68c83a070a17$export$ab3be55c7f3a4aca = (data)=>{
    if (data?.projectConfiguration?.__typename === 'JiraProjectConfigurationResult') {
        const fieldsLimit = data?.projectConfiguration.limitInfo?.limitFieldsPerProject;
        const currentFieldsCount = data?.projectConfiguration.limitInfo?.currentFieldsPerProject;
        return typeof fieldsLimit === 'number' && typeof currentFieldsCount === 'number' && currentFieldsCount >= fieldsLimit;
    }
    return false;
};
const $3bee68c83a070a17$export$d8abb7a1cfbd4b6b = ({ shouldShowTooltip: shouldShowTooltip, children: children, tooltipContent: tooltipContent })=>{
    if (shouldShowTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, tooltipContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        position: "right"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});



parcelRegister("a4ZZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe976e6caa7b4a1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6fe976e6caa7b4a1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forms: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.forms",
        "defaultMessage": "Forms"
    },
    title: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.title",
        "defaultMessage": "Project settings"
    },
    slaSettings: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.sla-settings",
        "defaultMessage": "SLAs"
    },
    customerSatisfaction: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.customer-satisfaction",
        "defaultMessage": "Customer satisfaction"
    },
    requestTypesGroup: {
        "id": "spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.request-types-group",
        "defaultMessage": "Request types"
    }
});

});



parcelRegister("fN4XF", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumTenant", () => $11ce00fcf419be21$export$37b11e717072c329);

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $11ce00fcf419be21$export$11b7a32564b1225a = (editions)=>Object.values(editions).some((edition)=>edition === (0, $ldyPw.PREMIUM_EDITION));
const $11ce00fcf419be21$export$37b11e717072c329 = ()=>{
    const editions = (0, $k9JTq.useAppEditions)();
    return $11ce00fcf419be21$export$11b7a32564b1225a(editions);
};

});

parcelRegister("2EZB0", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $eb9e9308ddea5703$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $koVbs = parcelRequire("koVbs");

var $fMdqG = parcelRequire("fMdqG");

var $auDmG = parcelRequire("auDmG");

var $fxFUw = parcelRequire("fxFUw");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $cZpsT = parcelRequire("cZpsT");

var $hjSul = parcelRequire("hjSul");

var $lNhbS = parcelRequire("lNhbS");

var $a88Sz = parcelRequire("a88Sz");

var $hT8S3 = parcelRequire("hT8S3");
const $eb9e9308ddea5703$export$a06f1c675e846f6f = ({ isSimplified: isSimplified })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const cloudId = (0, $koeKL.useCloudId)();
    const showDescription = !isAnonymous && isSimplified;
    const title = (0, $hT8S3.messages).titleTeamManaged;
    const feedbackDialogAttributes = (0, $5uXOq.useMemo)(()=>{
        const additionalFields = [
            {
                id: (0, $7iULw.EntryKeys).IS_ADMIN,
                value: String(isAdmin)
            },
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            },
            {
                id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: String(isSimplified)
            }
        ];
        return {
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: 'jira-servicedesk-next-gen-sidebar-nav',
            feedbackContext: additionalFields,
            additionalFields: additionalFields
        };
    }, [
        isAdmin,
        cloudId,
        isSimplified
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxFUw.ProjectFooter), {
        description: showDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMdqG.FeedbackButton), {
            feedbackDialogAttributes: feedbackDialogAttributes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $auDmG.HelpPanelButton), {
            articleId: "322DvJroFxRchFjLrpSETA",
            "aria-label": formatMessage((0, $a88Sz.messages).learnMoreAriaLabel),
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
                href: (0, $lNhbS.NG_COMMUNITY_LINK),
                target: "_blank",
                "aria-label": formatMessage((0, $a88Sz.messages).learnMoreAriaLabel)
            }, formatMessage((0, $a88Sz.messages).learnMore))
        }, formatMessage((0, $a88Sz.messages).learnMore)))
    }, isSimplified ? formatMessage(title) : formatMessage((0, $hT8S3.messages).companyManagedTitle));
};

});
parcelRegister("fMdqG", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $8f7ce8dd50553c0e$export$116fedbe5e2e2bd8);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9heAh = parcelRequire("9heAh");
const $8f7ce8dd50553c0e$export$116fedbe5e2e2bd8 = ({ feedbackDialogAttributes: feedbackDialogAttributes })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'sidebar', {
            itemId: 'feedback-footer'
        });
        openFeedbackCollector({
            ...feedbackDialogAttributes
        });
    }, [
        createAnalyticsEvent,
        feedbackDialogAttributes,
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onClick,
        spacing: "none"
    }, formatMessage((0, $9heAh.messages).feedback));
};

});
parcelRegister("9heAh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $71971bdb009a20d6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $71971bdb009a20d6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    feedback: {
        "id": "spa-apps-sidebar-common.feedback-button.feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("auDmG", function(module, exports) {

$parcel$export(module.exports, "HelpPanelButton", () => $c4b9c1de653fb6b2$export$4b6bbd2e0136b372);

var $5uXOq = parcelRequire("5uXOq");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $c4b9c1de653fb6b2$export$4b6bbd2e0136b372 = ({ HelpButtonLink: HelpButtonLink = (0, $5Zxxp.default), articleId: articleId, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useCallback: useCallback = (0, $5uXOq.useCallback), ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const onClick = useCallback(()=>fireUIAnalytics(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'sidebar', {
            helpArticleId: articleId,
            itemId: 'learnMore'
        }), [
        articleId,
        createAnalyticsEvent,
        fireUIAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HelpButtonLink, {
        articleId: articleId,
        type: "HELP_ARTICLE",
        appearance: "subtle-link",
        spacing: "none",
        onClick: onClick,
        ...rest
    });
};

});

parcelRegister("fxFUw", function(module, exports) {

$parcel$export(module.exports, "ProjectFooter", () => $60f5e4c9257f773e$export$84c2ab70be8ad47b);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jASxh = parcelRequire("jASxh");

var $fpoBX = parcelRequire("fpoBX");
const $60f5e4c9257f773e$var$bgColorCssVar = '--project-footer-bg-color';
const $60f5e4c9257f773e$var$textColorCssVar = '--project-footer-text-color';
const $60f5e4c9257f773e$var$customFooterStyles = null;
const $60f5e4c9257f773e$var$bgColorThemeStyles = null;
const $60f5e4c9257f773e$var$colorThemeStyles = null;
const $60f5e4c9257f773e$export$88140d3970f0ce84 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1dltidpf _w8sqidpf _fjwridpf _1yxxidpf _tkqh1ule _1g6a1h6o _dqi54jg8 _1lfu4jg8 _1bnm1gjq _1t3912x7 _qz5b12x7 _xd2912x7 _2i0812x7 _2pzv1o8l _1w711gjq",
            item?.background?.default && "_16hg1p3a",
            item?.color?.default && "_1w90enff _i9a1enff _1cmdenff",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$60f5e4c9257f773e$var$bgColorCssVar]: item?.background?.default,
            [$60f5e4c9257f773e$var$textColorCssVar]: item?.color?.default
        }
    });
};
const $60f5e4c9257f773e$export$84c2ab70be8ad47b = ({ Footer: Footer = (0, $jASxh.default), children: children, description: description })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        component: $60f5e4c9257f773e$export$88140d3970f0ce84,
        // @ts-expect-error - TS2769 - No overload matches this call.
        description: description,
        testId: "navigation-apps-sidebar-common.ui.project-footer.test-footer"
    }, children);
};

});
parcelRegister("jASxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43d894138745be37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $juVrZ = parcelRequire("juVrZ");

var $jSfqD = parcelRequire("jSfqD");

var $6cAn5 = parcelRequire("6cAn5");
const $43d894138745be37$var$styles = {
    iconContainer: "_1e0c1o8l _1bsb1k8s _4t3i1k8s",
    oldFooter: "_vrjtdcr7 _16vx1h6o _1cg71wug _if291ule _14741h6o _oiqe1tcg _1kba1h6o _w1ap1osq _1mt2ze3t _159iu2gc _76zj1o8l _13e21h6o _14bw1o8l _eq7s12x7 _1jkv12x7 _1rla12x7 _z2a212x7 _11kj1w7a _jl2n73ad _1et61w7a _1v6jjjyb"
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $43d894138745be37$var$OldFooter = (props)=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ iconBefore: iconBefore, onClick: onClick, description: description, children: children, testId: testId })=>({
            iconBefore: iconBefore,
            onClick: onClick,
            description: description,
            children: children,
            testId: testId
        }))(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ...safeProps,
        component: props.component || (0, $juVrZ.Container),
        className: (0, $bwpsq.default)([
            $43d894138745be37$var$styles.oldFooter
        ])
    });
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $43d894138745be37$var$Footer = ({ description: description, children: children, iconBefore: iconBefore, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        padding: "space.100",
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
            space: "space.100",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $43d894138745be37$var$styles.iconContainer,
                    children: iconBefore
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.075",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            size: "UNSAFE_small",
                            align: "center",
                            color: "inherit",
                            children: children
                        }),
                        description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            size: "UNSAFE_small",
                            as: "p",
                            align: "center",
                            color: "color.text.subtlest",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $43d894138745be37$var$FooterFacade = ({ useDeprecatedApi: useDeprecatedApi = true, description: description, iconBefore: iconBefore, testId: testId, children: children, component: component, onClick: onClick })=>{
    if (!useDeprecatedApi) return /*#__PURE__*/ (0, $2OMIu.jsx)($43d894138745be37$var$Footer, {
        iconBefore: iconBefore,
        description: description,
        testId: testId,
        children: children
    });
    typeof $6cAn5;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($43d894138745be37$var$OldFooter, {
        onClick: onClick,
        component: component,
        iconBefore: iconBefore,
        description: description,
        testId: testId,
        children: children
    });
};
var $43d894138745be37$export$2e2bcd8739ae039 = $43d894138745be37$var$FooterFacade;

});
parcelRegister("juVrZ", function(module, exports) {

$parcel$export(module.exports, "Container", () => $c46eefd51badc16b$export$42a852a2b6b56249);
$parcel$export(module.exports, "default", () => $c46eefd51badc16b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jSfqD = parcelRequire("jSfqD");
const $c46eefd51badc16b$var$styles = {
    header: "_vrjt140y _1cmd10s3 _1cg71wug _11kj1w7a _jl2n73ad _1et61w7a _1v6j10s3"
};
const $c46eefd51badc16b$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps,
        children: children
    }));
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c46eefd51badc16b$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ...props,
        ref: ref,
        component: props.component || $c46eefd51badc16b$export$42a852a2b6b56249,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: {
            Title: {
                // eslint-disable-next-line @atlaskit/design-system/use-heading
                render: (_, { children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
                        ...props,
                        children: children
                    })
            }
        },
        className: (0, $bwpsq.default)([
            $c46eefd51badc16b$var$styles.header
        ])
    });
});
var $c46eefd51badc16b$export$2e2bcd8739ae039 = $c46eefd51badc16b$var$Header;

});



parcelRegister("hT8S3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e0c3bed14d928b9d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e0c3bed14d928b9d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    companyManagedTitle: {
        "id": "spa-apps-sidebar-servicedesk.menu.footer.company-managed-title",
        "defaultMessage": "You're in a company-managed project"
    },
    // Rebrand
    titleTeamManaged: {
        "id": "spa-apps-sidebar-servicedesk.menu.footer.title-team-managed",
        "defaultMessage": "You're in a team-managed project"
    }
});

});






//# sourceMappingURL=async-sidebar-servicedesk.6a6f1e7a.js.map
